import * as i0 from '@angular/core';
import { InjectionToken, PLATFORM_ID, Injectable, Inject, Pipe, NgModule, Optional, SkipSelf, Component, Input as Input$1, ViewChild, EventEmitter, Output, Directive, isDevMode, SecurityContext, ChangeDetectionStrategy, HostListener, HostBinding, ContentChildren, forwardRef, ElementRef, ViewChildren, ViewEncapsulation, ContentChild, Attribute } from '@angular/core';
import * as i1$1 from '@angular/common';
import { isPlatformBrowser, CommonModule, DOCUMENT } from '@angular/common';
import { tap, catchError, finalize, share, take, map, takeUntil, debounceTime } from 'rxjs/operators';
import { of, throwError, Subject, fromEvent, BehaviorSubject, merge as merge$1, timer, takeUntil as takeUntil$1, debounceTime as debounceTime$1, Subscription } from 'rxjs';
import * as i1 from '@angular/common/http';
import { HttpClient, provideHttpClient, withInterceptorsFromDi, HttpHeaders } from '@angular/common/http';
import * as i2 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i1$2 from '@angular/platform-browser';
import * as i1$3 from '@angular/cdk/a11y';
import { A11yModule, ActiveDescendantKeyManager } from '@angular/cdk/a11y';
import * as i1$4 from '@angular/cdk/overlay';
import { OverlayConfig, ConnectionPositionPair, OverlayModule } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import * as lazySizes from 'lazysizes';
import * as i1$5 from '@angular/animations';
import { trigger, state, style, transition, animate } from '@angular/animations';
import * as i4 from '@angular/forms';
import { FormsModule, NG_VALUE_ACCESSOR, NgControl, NG_VALIDATORS, Validators, ReactiveFormsModule } from '@angular/forms';
import * as i2$1 from '@angular/cdk/layout';
import { emailMask, createNumberMask } from 'text-mask-addons';
import { DOWN_ARROW, ENTER, SPACE, ESCAPE, END, HOME } from '@angular/cdk/keycodes';
import { __decorate, __metadata } from 'tslib';

const WINDOW = new InjectionToken('WindowToken');
/* Define abstract class for obtaining reference to the global window object. */
class WindowRef {
    get nativeWindow() {
        throw new Error('Not implemented.');
    }
}
/* Define class that implements the abstract class and returns the native window object. */
class BrowserWindowRef extends WindowRef {
    constructor(platformId) {
        super();
        this.platformId = platformId;
    }
    get nativeWindow() {
        if (isPlatformBrowser(this.platformId)) {
            return window;
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: BrowserWindowRef, deps: [{ token: PLATFORM_ID }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: BrowserWindowRef }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: BrowserWindowRef, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: Object, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }] });
/* Create an factory function that returns the native window object. */
function windowFactory(browserWindowRef, platformId) {
    if (isPlatformBrowser(platformId)) {
        return browserWindowRef.nativeWindow;
    }
    return new Object();
}
const browserWindowProvider = {
    provide: WindowRef,
    useClass: BrowserWindowRef
};
/* Create an injectable provider that uses the windowFactory function for returning the native window object. */
const windowProvider = {
    provide: WINDOW,
    useFactory: windowFactory,
    deps: [WindowRef, PLATFORM_ID]
};
/* Create an array of providers. */
const WINDOW_PROVIDER = [
    browserWindowProvider,
    windowProvider
];

class SiteCatService {
    constructor(windowRef) {
        this.windowRef = windowRef;
    }
    setCitiData(value) {
        if (!this.windowRef)
            return;
        if (typeof this.windowRef.s === 'undefined') {
            this.windowRef.citiData.defaultPageView = true;
        }
        this.windowRef.citiData = Object.assign(this.windowRef.citiData, value);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: SiteCatService, deps: [{ token: WINDOW }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: SiteCatService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: SiteCatService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }] });

class StripHtmlPipe {
    transform(message) {
        return !message ? '' : message
            .replace(/<(?:.|\n)*?>/gm, '')
            .replace(/&amp|;/g, '&')
            .replace(/&lt|;/g, '<')
            .replace(/&gt|;/g, '>');
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: StripHtmlPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    /** @nocollapse */ static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: StripHtmlPipe, isStandalone: false, name: "stripHtml" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: StripHtmlPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'stripHtml',
                    standalone: false
                }]
        }] });

class StripHtml {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: StripHtml, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: StripHtml, declarations: [StripHtmlPipe], imports: [CommonModule], exports: [StripHtmlPipe] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: StripHtml, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: StripHtml, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [StripHtmlPipe],
                    exports: [StripHtmlPipe]
                }]
        }] });

class OrderBy {
    constructor() {
        this.value = [];
    }
    static _orderByComparator(a, b) {
        if (a === null || typeof a === 'undefined') {
            a = 0;
        }
        if (b === null || typeof b === 'undefined') {
            b = 0;
        }
        if ((isNaN(parseFloat(a)) || !isFinite(a)) || (isNaN(parseFloat(b)) || !isFinite(b))) {
            // Isn't a number so lowercase the string to properly compare
            if (a.toLowerCase() < b.toLowerCase()) {
                return -1;
            }
            if (a.toLowerCase() > b.toLowerCase()) {
                return 1;
            }
        }
        else {
            // Parse strings as numbers to compare properly
            if (parseFloat(a) < parseFloat(b)) {
                return -1;
            }
            if (parseFloat(a) > parseFloat(b)) {
                return 1;
            }
        }
        return 0; // equal each other
    }
    transform(input, config = '+') {
        // make a copy of the input's reference
        this.value = [...input];
        // var value = this.value;
        if (!Array.isArray(this.value)) {
            return this.value;
        }
        if (!Array.isArray(config) || (Array.isArray(config) && config.length === 1)) {
            const propertyToCheck = !Array.isArray(config) ? config : config[0];
            const desc = propertyToCheck.substr(0, 1) === '-';
            // Basic array
            if (!propertyToCheck || propertyToCheck === '-' || propertyToCheck === '+') {
                return !desc ? this.value.sort() : this.value.sort().reverse();
            }
            else {
                const property = propertyToCheck.substr(0, 1) === '+' || propertyToCheck.substr(0, 1) === '-'
                    ? propertyToCheck.substr(1)
                    : propertyToCheck;
                this.value.sort(function (a, b) {
                    return !desc
                        ? OrderBy._orderByComparator(a[property], b[property])
                        : -OrderBy._orderByComparator(a[property], b[property]);
                });
                return this.value;
            }
        }
        else {
            // Loop over property of the array in order and sort
            this.value.sort(function (a, b) {
                for (let i = 0; i < config.length; i++) {
                    const desc = config[i].substr(0, 1) === '-';
                    const property = config[i].substr(0, 1) === '+' || config[i].substr(0, 1) === '-'
                        ? config[i].substr(1)
                        : config[i];
                    const comparison = !desc
                        ? OrderBy._orderByComparator(a[property], b[property])
                        : -OrderBy._orderByComparator(a[property], b[property]);
                    // Don't return 0 yet in case of needing to sort by next property
                    if (comparison !== 0) {
                        return comparison;
                    }
                }
                return 0; // equal each other
            });
            return this.value;
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: OrderBy, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    /** @nocollapse */ static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: OrderBy, isStandalone: false, name: "orderBy", pure: false }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: OrderBy, decorators: [{
            type: Pipe,
            args: [{ name: 'orderBy', standalone: false, pure: false }]
        }] });

class CitiOrderBy {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CitiOrderBy, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: CitiOrderBy, declarations: [OrderBy], imports: [CommonModule], exports: [OrderBy] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CitiOrderBy, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CitiOrderBy, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [OrderBy],
                    exports: [OrderBy]
                }]
        }] });

class SmartSearchPipe {
    transform(value, args) {
        return null;
    }
    smartSearchAlgorithm(options, input) {
        let result = [];
        if (options.length <= 1)
            return options;
        const sourceUpperNoSpace = input.toUpperCase().split(' ').join('');
        // use levenshtein distance to figure out if the results are still relevant to what the user is inputing
        const noOps = options.filter(option => {
            const targetUpperNoSpace = option.label.toUpperCase().split(' ').join('');
            const levDist = this.levenshteinDistance(sourceUpperNoSpace, targetUpperNoSpace);
            return levDist <= targetUpperNoSpace.length; // filter results that do not require the user to delete every character and retype the word to correct them
        }).length === 0;
        if (noOps)
            return [];
        result = this.pruneSort(options, input);
        const labelInputMatchOption = result.find(option => option.label.toUpperCase().split(' ').join('') === input.toUpperCase().split(' ').join(''));
        const patternsFound = this.searchPatterns(result, input);
        if (labelInputMatchOption != null && result.length > 1 && patternsFound.length === 1) { // the input matches the result perfectly without any other matching patterns return nothing else
            return [labelInputMatchOption];
        }
        const valueInputMatchOption = result.find(option => option.value.toUpperCase().split(' ').join('') === input.toUpperCase().split(' ').join(''));
        if (valueInputMatchOption != null && result.length > 1) { // place resutls that match the value at the top
            const replacerIndex = result.indexOf(valueInputMatchOption);
            result = this.setOptionToBeFirstIn(result, replacerIndex);
        }
        return result;
    }
    setOptionToBeFirstIn(listOfOps, replacerIndex) {
        const replacer = listOfOps.splice(replacerIndex, 1);
        listOfOps.reverse();
        listOfOps.push(replacer.pop());
        listOfOps.reverse();
        return listOfOps;
    }
    searchPatterns(options, input) {
        const sourceUpperNoSpace = input.toUpperCase().split(' ').join('');
        const filteredList = options
            .filter(option => option.label.toUpperCase().split(' ').join('').includes(sourceUpperNoSpace) || option.value.toUpperCase().split(' ').join('').includes(sourceUpperNoSpace));
        return filteredList;
    }
    // for any questions refer to Haron at ha54701
    /**
     * Takes an input search string and any list of string options of type Option
     * Looks at every option and gives a score for each option based off the following scoring chart
     * Chart: +4 for having same first letter as input
     *        +1 for having following letters same and in the correct index as input
     *        -1 for having option string longer than input string to eliminate bias for long words
     *        +2 for having letters in the input string within the option string
     *
     * sort the scores and find the avg and standard deviation then return the extremas
     *
     * @param unsortedOptionsList
     * @param input
     *
     * @returns Option[]
     */
    pruneSort(unsortedOptionsList, input) {
        const scoreOptionsObj = {};
        const vowels = ['a', 'e', 'i', 'o', 'u'];
        unsortedOptionsList.forEach(option => {
            const sourceUpperNoSpace = input.toUpperCase().split(' ').join('');
            const searchTarget = option.label.toUpperCase().split(' ').join('');
            let score = 0;
            if (sourceUpperNoSpace.split('')[0] === searchTarget.split('')[0])
                score = 3; // preference to having the first letter
            if (sourceUpperNoSpace.length < searchTarget.length)
                score -= 1; // eliminate bias for long words that may contain common letters in input
            // preference for having matching letters in correct positions
            if (sourceUpperNoSpace.length <= searchTarget.length) { // search positions for the smaller length string
                sourceUpperNoSpace.split('').forEach((sI, i) => {
                    if (searchTarget[i] !== null) {
                        if (sI === searchTarget[i]) {
                            if (!vowels.includes(sI))
                                score++;
                        }
                    }
                    //preference for having letters included in the search string
                    if (searchTarget.split('').includes(sI) && !vowels.includes(sI))
                        score += 2;
                });
            }
            else {
                searchTarget.split('').forEach((sT, i) => {
                    if (sourceUpperNoSpace[i] !== null) {
                        if (sT === sourceUpperNoSpace[i]) {
                            if (!vowels.includes(sT))
                                score++;
                        }
                    }
                    //preference for having letters included in the search string
                    if (sourceUpperNoSpace.split('').includes(sT) && !vowels.includes(sT))
                        score += 2;
                });
            }
            const scoreExists = scoreOptionsObj[score] != null;
            if (scoreExists) {
                scoreOptionsObj[score].push(option);
            }
            else {
                scoreOptionsObj[score] = [option];
            }
        });
        const sortedOptionsList = [];
        const scores = Object.keys(scoreOptionsObj)
            .map(score => parseInt(score, 10))
            .sort(function (a, b) { return a - b; }).reverse();
        if (scores.length > 1) {
            const avgScore = this.average(scores);
            const stdDev = this.standardDeviation(scores, avgScore);
            scores.forEach(score => {
                const options = scoreOptionsObj[score];
                if (score >= avgScore + stdDev)
                    sortedOptionsList.push(...options);
            });
        }
        let optionsList = [];
        if (sortedOptionsList.length === 0) { // the results are all within the same standard deviation
            optionsList = this.searchPatterns(unsortedOptionsList, input);
            return optionsList;
        }
        return sortedOptionsList;
    }
    standardDeviation(data, avgScore) {
        const squareDiffs = data.map((value) => {
            const diff = value - avgScore;
            const sqr = diff ** 2;
            return sqr;
        });
        const sumSquareDiff = squareDiffs.reduce((total, num) => total + num);
        return Math.sqrt(sumSquareDiff / data.length);
    }
    average(data) {
        return data.reduce((total, num) => total + num) / data.length;
    }
    values(object) {
        return Object.keys(object).map(key => object[key]);
    }
    // https://en.wikipedia.org/wiki/Levenshtein_distance
    levenshteinDistance(searchSource, searchTarget) {
        const searchSourceLen = searchSource.length;
        const searchTargetLen = searchTarget.length;
        // Create empty edit distance matrix for all possible modifications of
        // substrings of searchSource to substrings of searchTarget.
        const distanceMatrix = Array(searchTargetLen + 1).fill(null).map(() => Array(searchSourceLen + 1).fill(null));
        const firstRow = distanceMatrix[0];
        firstRow.forEach((col, i) => {
            firstRow[i] = i; // fill the first row with 0 - searchSourceLen
        });
        distanceMatrix.forEach((row, j) => {
            row[0] = j; // fill the first column with 0 - searchTargetLen
        });
        // check the cost of each character within both strings
        for (let j = 1; j <= searchTargetLen; j++) {
            for (let i = 1; i <= searchSourceLen; i++) {
                const substitutionCost = (searchSource[i - 1] === searchTarget[j - 1]) ? 0 : 1;
                distanceMatrix[j][i] = Math.min(distanceMatrix[j - 1][i] + 1, //cost for deletion
                distanceMatrix[j][i - 1] + 1, // cost for insertion
                distanceMatrix[j - 1][i - 1] + substitutionCost // cost for substitution
                );
            }
        }
        return distanceMatrix[searchTargetLen][searchSourceLen]; // the levenshtein distance between searchSource and searchTarget
    }
    flatMap(array, mapFunc) {
        //this function will be used to put all option group options in one array
        return array.reduce((cumulus, next) => [...mapFunc(next), ...cumulus], []);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: SmartSearchPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    /** @nocollapse */ static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: SmartSearchPipe, isStandalone: false, name: "smartSearch" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: SmartSearchPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'smartSearch',
                    standalone: false
                }]
        }] });

class SmartSearchOrdinaryPipe extends SmartSearchPipe {
    constructor() {
        super();
    }
    transform(options, input) {
        let result = [];
        if (!input)
            return options;
        result = this.smartSearchAlgorithm(options, input);
        return result;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: SmartSearchOrdinaryPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    /** @nocollapse */ static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: SmartSearchOrdinaryPipe, isStandalone: false, name: "smartSearchOrdinary" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: SmartSearchOrdinaryPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'smartSearchOrdinary',
                    standalone: false
                }]
        }], ctorParameters: () => [] });

class SmartSearchGroupPipe extends SmartSearchPipe {
    constructor() {
        super();
    }
    transform(groups, input) {
        let result = [];
        if (!input)
            return groups;
        result = this.smartSearchGroupsAlgorithm(groups, input);
        if (result.length > 0) {
            return result;
        }
        result = this.searchGroupPatterns(groups, input);
        return result;
    }
    smartSearchGroupsAlgorithm(groups, input) {
        const groupTitleSearch = groups.find(group => group.groupName.toUpperCase() === input.toUpperCase());
        if (groupTitleSearch != null)
            return [groupTitleSearch];
        const optionsArray = this.flatMap(groups, (group) => group.options);
        const resultOptions = this.smartSearchAlgorithm(optionsArray, input);
        if (resultOptions.length === 0)
            return [];
        let result = [];
        result = groups.filter(group => group.options.filter(option => resultOptions.includes(option)).length > 0)
            .map(group => ({
            groupName: group.groupName,
            options: resultOptions.filter(option => group.options.includes(option))
        }));
        if (result.length === 1)
            return result;
        const topGroupIndex = result.indexOf(result.find(group => group.options.includes(resultOptions[0])));
        if (topGroupIndex !== 0)
            [result[0], result[topGroupIndex]] = [result[topGroupIndex], result[0]];
        return result;
    }
    searchGroupPatterns(groups, input) {
        const result = [];
        const topResults = [];
        groups.forEach(group => {
            let groupOptions = group.options;
            groupOptions = super.searchPatterns(groupOptions, input);
            if (groupOptions.length > 0) {
                const filteredGroup = {
                    groupName: group.groupName,
                    options: groupOptions
                };
                topResults.push(groupOptions[0]);
                result.push(filteredGroup);
            }
        });
        // prune the top result groups so that they show up first
        const sortedTopResults = super.pruneSort(topResults, input);
        topResults.forEach((option, index) => {
            const replacerIndex = sortedTopResults.indexOf(option);
            // if we haven't observed this index yet swap it with its correct position
            if (index > replacerIndex)
                [result[index], result[replacerIndex]] = [result[replacerIndex], result[index]];
        });
        return result;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: SmartSearchGroupPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    /** @nocollapse */ static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: SmartSearchGroupPipe, isStandalone: false, name: "smartSearchGroup" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: SmartSearchGroupPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'smartSearchGroup',
                    standalone: false
                }]
        }], ctorParameters: () => [] });

class SmartSearchModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: SmartSearchModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: SmartSearchModule, declarations: [SmartSearchPipe, SmartSearchOrdinaryPipe, SmartSearchGroupPipe], imports: [CommonModule], exports: [SmartSearchOrdinaryPipe, SmartSearchGroupPipe] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: SmartSearchModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: SmartSearchModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [SmartSearchPipe, SmartSearchOrdinaryPipe, SmartSearchGroupPipe],
                    exports: [SmartSearchOrdinaryPipe, SmartSearchGroupPipe]
                }]
        }] });

const SERVER_URL = new InjectionToken('SERVER_URL');
class Icon2RegistryService {
    constructor(http, platformId, serverUrl) {
        this.http = http;
        this.platformId = platformId;
        this.serverUrl = serverUrl;
        this.cachedIconByUrl = new Map();
        this.iconsFetchingByUrl = new Map();
    }
    /** Add a SVG to the registry by passing a name and the SVG data. */
    addSvgByData(data, name) {
        if (!this.cachedIconByUrl.has(name)) {
            this.cachedIconByUrl.set(name, data);
        }
    }
    /** Add a SVG to the registry by passing a name and the SVG source url. */
    addSvgByUrl(url, name = url) {
        if (!this.cachedIconByUrl.has(name)) {
            const data = this._fetchSvgFromUrl(url);
            this.iconsFetchingByUrl.set(name, data);
        }
    }
    /** Load a SVG to the registry from a URL. */
    loadSvg(name) {
        const svgByName = this.getSvgByName(name);
        if (svgByName)
            return svgByName;
        const shade = name.includes('b1') ? 'b1' : 'white';
        const filePath = `./commonui-assets/svgs/icons/${shade}/${name}.svg`;
        const svgData = this._fetchSvgFromUrl(filePath, name);
        return svgData;
    }
    /** Get loaded SVG from registry by name. */
    getSvgByName(name) {
        if (this.cachedIconByUrl.has(name)) {
            return of(this.cachedIconByUrl.get(name));
        }
        else if (this.iconsFetchingByUrl.has(name)) {
            return this.iconsFetchingByUrl.get(name);
        }
    }
    /** Remove a SVG from the registry by URL (or name). */
    unloadSvg(name) {
        return this.cachedIconByUrl.delete(name);
    }
    /**fetch SVG data from given URL */
    _fetchSvgFromUrl(url, name = url) {
        if (!url)
            throw Error('URL is empty or undefined');
        const fetchingInProgress = this.iconsFetchingByUrl.get(url);
        if (fetchingInProgress)
            return fetchingInProgress;
        const svgRequest = this.http.get(url, { responseType: 'text' }).pipe(tap(req => this.cachedIconByUrl.set(name, req)), catchError(err => {
            return throwError(err);
        }), finalize(() => this.iconsFetchingByUrl.delete(name)), share());
        this.iconsFetchingByUrl.set(name, svgRequest);
        return svgRequest;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Icon2RegistryService, deps: [{ token: i1.HttpClient }, { token: PLATFORM_ID }, { token: SERVER_URL, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Icon2RegistryService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Icon2RegistryService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: Object, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [SERVER_URL]
                }] }] });
function ICON2_REGISTRY_PROVIDER_FACTORY(parentRegistry, httpClient, platformId, serverUrl) {
    return parentRegistry || new Icon2RegistryService(httpClient, platformId, serverUrl);
}
const ICON2_REGISTRY_PROVIDER = {
    provide: Icon2RegistryService,
    deps: [[new Optional(), new SkipSelf(), Icon2RegistryService], HttpClient, [PLATFORM_ID],
        [new Optional(), SERVER_URL]
    ],
    useFactory: ICON2_REGISTRY_PROVIDER_FACTORY
};

class Icon2Component {
    set shade(style) {
        this._shade = style === 'dark' ? 'b1' : style === 'light' ? 'white' : style;
    }
    /**
     * SVG Icons are name in this manner: 000-name-shade(-circle)
     *000: 3 digits code for 'icon', 2 digits code for 'sfi'
     *name: name of the icon
     *shade: 'b1' for dark, 'white' for light
     *(-circle): include -circle in file name if includeCircle is true
     */
    set name(name) {
        this._name = name;
        this.type = name.split('-')[0].length === 2 ? 'sfi' : 'icon';
    }
    constructor(iconRegistry, cdr) {
        this.iconRegistry = iconRegistry;
        this.cdr = cdr;
        this.role = 'img';
        this.idStr = '';
        this.ariaHidden = false;
        this.size = 'medium';
        this.isHoverSfi = false;
        this.includeCircle = false;
        this.type = 'sfi';
        this.tabIndex = null;
        this._shade = '';
    }
    ngOnInit() {
        this.init();
    }
    ngOnDestroy() {
        this.destroy();
    }
    ngOnChanges() {
        if (this._svgElement)
            this.destroy();
        this.init();
    }
    get circleString() {
        return (this.type === 'sfi' && this.isHoverSfi) || this.includeCircle
            ? '-circle'
            : '';
    }
    get svgName() {
        const shade = this._shade ? `-${this._shade}` : '';
        return `${this._name}${shade}${this.circleString}`;
    }
    get smallFormatIconName() {
        const alt = this.isHoverSfi ? '-hover' : this.circleString;
        return `${this._shade}-${this._name}${alt}`;
    }
    destroy() {
        this.svgDivElementRef.nativeElement.innerHTML = '';
        this._svgElement = undefined;
        if (this._iconSubscription)
            this._iconSubscription.unsubscribe();
    }
    init() {
        this.type === 'sfi' ? this.getSmallFormatIconClass() : this.getSVGIcon();
    }
    getSVGIcon() {
        this.iconClass = `${this.size}${this.circleString}`;
        this._iconSubscription = this.iconRegistry
            .loadSvg(this.svgName)
            .subscribe(data => this.initSvg(data));
    }
    getSmallFormatIconClass() {
        this.iconClass = `sfi ${this.smallFormatIconName} ${this.size}${this.circleString}`;
    }
    initSvg(data) {
        if (!data)
            return;
        setTimeout(() => {
            const divElem = this.svgDivElementRef.nativeElement;
            divElem.innerHTML = data;
            this._svgElement = divElem.firstChild;
            this.cdr.markForCheck();
        }, 0);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Icon2Component, deps: [{ token: Icon2RegistryService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: Icon2Component, isStandalone: false, selector: "citi-icon2", inputs: { role: "role", idStr: "idStr", ariaLabel: "ariaLabel", ariaHidden: "ariaHidden", size: "size", isHoverSfi: "isHoverSfi", includeCircle: "includeCircle", type: "type", svgStyle: "svgStyle", tabIndex: "tabIndex", shade: "shade", name: "name" }, viewQueries: [{ propertyName: "svgDivElementRef", first: true, predicate: ["svgContainer"], descendants: true }], usesOnChanges: true, ngImport: i0, template: `
    <div
      #svgContainer
      [attr.tabindex]="tabIndex"
      [ngStyle]="type === 'glyph' ? '' : svgStyle"
      [ngClass]="[iconClass]"
      [attr.id]="idStr"
      [attr.role]="role"
      [attr.aria-label]="ariaLabel"
      [attr.aria-hidden]="ariaHidden ? true : null"
    ></div>
  `, isInline: true, styles: [":host{line-height:0}:host div{display:inline-block;line-height:0px}.small{width:12px;height:12px}.medium{width:14px;height:14px}.large{width:16px;height:16px}.small-circle{width:18px;height:18px}.medium-circle{width:20px;height:20px}.large-circle{width:22px;height:22px}.sfi{background-repeat:no-repeat}.sfi.small{width:12px;height:12px;margin:3px}.sfi.medium{width:14px;height:14px;margin:3px}.sfi.large{width:16px;height:16px;margin:4px}.sfi.small-circle{width:18px;height:18px;margin:5px}.sfi.medium-circle{width:20px;height:20px;margin:5px}.sfi.large-circle{width:22px;height:22px;margin:5px}.sfi.white-01-up{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 7.99'%3E%3Ctitle%3E01-up-b1%3C/title%3E%3Cpath d='M18,15.45a1,1,0,0,1-.73-.32L12,9.47,6.73,15.13a1,1,0,0,1-1.46-1.36l5.32-5.72a2,2,0,0,1,2.82,0l5.32,5.72A1,1,0,0,1,18,15.45Z' transform='translate(-5 -7.46)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-01-up-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E01-up-b1-alt%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3Cpath d='M13.41,8.05a2,2,0,0,0-2.82,0L5.27,13.77a1,1,0,0,0,1.46,1.36L12,9.47l5.27,5.66a1,1,0,1,0,1.46-1.36Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-01-up-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E01-up-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm6.68,14.18a1,1,0,0,1-1.41,0L12,9.47,6.73,15.13a1,1,0,0,1-1.46-1.36l5.32-5.72a2,2,0,0,1,2.82,0l5.32,5.72A1,1,0,0,1,18.68,15.18Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-02-down{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 8.02'%3E%3Ctitle%3E02-down-b1%3C/title%3E%3Cpath d='M12,16.52a1.94,1.94,0,0,1-1.41-.62L5.27,10.18A1,1,0,0,1,6.73,8.82L12,14.48l5.27-5.66a1,1,0,1,1,1.46,1.36L13.41,15.9A1.94,1.94,0,0,1,12,16.52Z' transform='translate(-5 -8.5)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-02-down-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E02-down-b1-alt%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3Cpath d='M17.27,8.82,12,14.48,6.73,8.82a1,1,0,0,0-1.46,1.36l5.32,5.72a1.91,1.91,0,0,0,2.82,0l5.32-5.72a1,1,0,1,0-1.46-1.36Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-02-down-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E02-down-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm6.73,9.18L13.41,15.9a1.91,1.91,0,0,1-2.82,0L5.27,10.18A1,1,0,0,1,6.73,8.82L12,14.48l5.27-5.66a1,1,0,1,1,1.46,1.36Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-03-left{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8.02 14'%3E%3Cpath d='M14.45,19a1,1,0,0,1-.68-.27L8.05,13.41A2,2,0,0,1,7.43,12a2,2,0,0,1,.62-1.42l5.72-5.32a1,1,0,0,1,1.36,1.47L9.47,12l5.66,5.26a1,1,0,0,1,0,1.42A1,1,0,0,1,14.45,19Z' transform='translate(-7.43 -5)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-03-left-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E03-left-b1-alt%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3Cpath d='M15.18,5.32a1,1,0,0,0-1.41-.06L8.05,10.58A2,2,0,0,0,7.43,12a2,2,0,0,0,.62,1.41l5.72,5.32a1,1,0,0,0,1.36-1.47L9.47,12l5.66-5.27A1,1,0,0,0,15.18,5.32Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-03-left-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E03-left-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm3.13,16.26a1,1,0,0,1,0,1.42,1,1,0,0,1-1.41.05L8.05,13.41A2,2,0,0,1,7.43,12a2,2,0,0,1,.62-1.42l5.72-5.32a1,1,0,0,1,1.36,1.47L9.47,12Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-04-right{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8.02 14'%3E%3Ctitle%3E04-right-b1%3C/title%3E%3Cpath d='M10,19a1,1,0,0,1-.73-.32,1,1,0,0,1,.05-1.42L15,12,9.32,6.73a1,1,0,0,1,1.36-1.47l5.72,5.32A2,2,0,0,1,17,12a2,2,0,0,1-.62,1.41l-5.72,5.32A1,1,0,0,1,10,19Z' transform='translate(-9 -5)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-04-right-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E04-right-b1-alt%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3Cpath d='M10.68,5.26A1,1,0,0,0,9.32,6.73L15,12,9.32,17.26a1,1,0,0,0-.05,1.42,1,1,0,0,0,1.41.05l5.72-5.32A2,2,0,0,0,17,12a2,2,0,0,0-.62-1.42Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-04-right-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E04-right-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm4.4,12.41-5.72,5.32a1,1,0,0,1-1.36-1.47L15,12,9.32,6.73a1,1,0,0,1,1.36-1.47l5.72,5.32A2,2,0,0,1,17,12,2,2,0,0,1,16.4,13.41Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-05-check{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 9.99'%3E%3Ctitle%3E05-check-b1%3C/title%3E%3Cpath d='M9.54,17a1.51,1.51,0,0,1-1-.42L5.3,13.48A1,1,0,0,1,6.7,12L9.54,14.8,17.3,7.28a1,1,0,1,1,1.4,1.43l-8.1,7.86A1.53,1.53,0,0,1,9.54,17Z' transform='translate(-5 -7)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-05-check-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E05-check-b1-alt%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3Cpath d='M17.3,7.28,9.54,14.8,6.7,12a1,1,0,0,0-1.4,1.44l3.19,3.09a1.51,1.51,0,0,0,1,.42,1.53,1.53,0,0,0,1.06-.42l8.1-7.86a1,1,0,1,0-1.4-1.43Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-05-check-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E05-check-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm6.7,7.71-8.1,7.86A1.53,1.53,0,0,1,9.54,17a1.51,1.51,0,0,1-1-.42L5.3,13.48A1,1,0,0,1,6.7,12L9.54,14.8,17.3,7.28a1,1,0,1,1,1.4,1.43Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-06-close{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 11'%3E%3Ctitle%3E06-close-b1%3C/title%3E%3Cpath d='M13.41,12l3.8-3.79a1,1,0,1,0-1.42-1.42L12,10.59,8.21,6.79A1,1,0,1,0,6.79,8.21L10.59,12l-3.8,3.79a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L12,13.41l3.79,3.8a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z' transform='translate(-6.5 -6.5)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-06-close-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E06-close-b1-alt%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3Cpath d='M17.21,6.79a1,1,0,0,0-1.42,0L12,10.59,8.21,6.79A1,1,0,1,0,6.79,8.21L10.59,12l-3.8,3.79a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L12,13.41l3.79,3.8a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L13.41,12l3.8-3.79A1,1,0,0,0,17.21,6.79Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-06-close-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E06-close-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm5.21,14.79a1,1,0,0,1,0,1.42,1,1,0,0,1-1.42,0L12,13.41l-3.79,3.8a1,1,0,0,1-1.42,0,1,1,0,0,1,0-1.42L10.59,12,6.79,8.21A1,1,0,1,1,8.21,6.79L12,10.59l3.79-3.8a1,1,0,1,1,1.42,1.42L13.41,12Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-07-equal{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 7'%3E%3Ctitle%3E07-equal-b1%3C/title%3E%3Cpath d='M18,10.5H6a1,1,0,0,1,0-2H18a1,1,0,0,1,0,2Z' transform='translate(-5 -8.5)' style='fill:%23fff'/%3E%3Cpath d='M18,15.5H6a1,1,0,0,1,0-2H18a1,1,0,0,1,0,2Z' transform='translate(-5 -8.5)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-07-equal-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E07-equal-b1-alt%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3Cpath d='M18,8.5H6a1,1,0,0,0,0,2H18a1,1,0,0,0,0-2Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3Cpath d='M18,13.5H6a1,1,0,0,0,0,2H18a1,1,0,0,0,0-2Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-07-equal-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E07-equal-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm6,14.5H6a1,1,0,0,1,0-2H18a1,1,0,0,1,0,2Zm0-5H6a1,1,0,0,1,0-2H18a1,1,0,0,1,0,2Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-08-plus{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 14'%3E%3Ctitle%3E08-plus-b1%3C/title%3E%3Cpath d='M18,11H13V6a1,1,0,0,0-2,0v5H6a1,1,0,0,0,0,2h5v5a1,1,0,0,0,2,0V13h5a1,1,0,0,0,0-2Z' transform='translate(-5 -5)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-08-plus-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E09-minus-b1-alt%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3Cpath d='M18,11H6a1,1,0,0,0,0,2H18a1,1,0,0,0,0-2Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-08-plus-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E09-minus-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm6,12H6a1,1,0,0,1,0-2H18a1,1,0,0,1,0,2Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-09-minus{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 2'%3E%3Ctitle%3E09-minus-b1%3C/title%3E%3Cpath d='M18,13H6a1,1,0,0,1,0-2H18a1,1,0,0,1,0,2Z' transform='translate(-5 -11)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-09-minus-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E09-minus-b1-alt%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3Cpath d='M18,11H6a1,1,0,0,0,0,2H18a1,1,0,0,0,0-2Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-09-minus-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E09-minus-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm6,12H6a1,1,0,0,1,0-2H18a1,1,0,0,1,0,2Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-10-navigation{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 10'%3E%3Ctitle%3E10-navigation-b1%3C/title%3E%3Cpath d='M6,9H18a1,1,0,0,0,0-2H6A1,1,0,0,0,6,9Z' transform='translate(-5 -7)' style='fill:%23fff'/%3E%3Cpath d='M18,11H6a1,1,0,0,0,0,2H18a1,1,0,0,0,0-2Z' transform='translate(-5 -7)' style='fill:%23fff'/%3E%3Cpath d='M18,15H6a1,1,0,0,0,0,2H18a1,1,0,0,0,0-2Z' transform='translate(-5 -7)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-10-navigation-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E10-navigation-b1-alt%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3Cpath d='M18,7H6A1,1,0,0,0,6,9H18a1,1,0,0,0,0-2Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3Cpath d='M18,11H6a1,1,0,0,0,0,2H18a1,1,0,0,0,0-2Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3Cpath d='M18,15H6a1,1,0,0,0,0,2H18a1,1,0,0,0,0-2Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-10-navigation-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E10-navigation-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm6,16H6a1,1,0,0,1,0-2H18a1,1,0,0,1,0,2Zm0-4H6a1,1,0,0,1,0-2H18a1,1,0,0,1,0,2Zm0-4H6A1,1,0,0,1,6,7H18a1,1,0,0,1,0,2Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-11-favorite{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 14'%3E%3Ctitle%3E11-favorite-b1%3C/title%3E%3Cpath d='M12,7.33l.71,2.26L13,10.64h3.31l-1.85,1.43-.81.63.3,1L14.63,16l-1.7-1.3L12,14l-.91.69L9.4,16l.69-2.28.29-1-.82-.63L7.71,10.64h3.07l.35-1L12,7.33M12,4.5a.88.88,0,0,0-.83.58L9.72,9.14H5.88a.91.91,0,0,0-.7.34.88.88,0,0,0,.16,1.23l3.31,2.55L7.41,17.37a.87.87,0,0,0,.15.78.86.86,0,0,0,.7.35.89.89,0,0,0,.53-.18L12,15.86l3.23,2.45a.87.87,0,0,0,.53.18,1.15,1.15,0,0,0,.26,0,.88.88,0,0,0,.58-1.1l-1.24-4.11,3.28-2.54A.85.85,0,0,0,19,10a.87.87,0,0,0-.88-.88h-4l-1.27-4a.9.9,0,0,0-.55-.56.93.93,0,0,0-.29,0Z' transform='translate(-5 -4.5)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-11-favorite-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E11-favorite-b1-alt%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3Cpath d='M18.12,9.14h-4l-1.27-4a.9.9,0,0,0-.55-.56.93.93,0,0,0-.29,0,.88.88,0,0,0-.83.58L9.72,9.14H5.88a.91.91,0,0,0-.7.34.88.88,0,0,0,.16,1.23l3.31,2.55L7.41,17.37a.87.87,0,0,0,.15.78.86.86,0,0,0,.7.35.89.89,0,0,0,.53-.18L12,15.86l3.23,2.45a.87.87,0,0,0,.53.18,1.15,1.15,0,0,0,.26,0,.88.88,0,0,0,.58-1.1l-1.24-4.11,3.28-2.54A.85.85,0,0,0,19,10,.87.87,0,0,0,18.12,9.14Zm-3.66,2.93-.81.63.3,1L14.63,16l-1.7-1.3L12,14l-.91.69L9.4,16l.69-2.28.29-1-.82-.63L7.71,10.64h3.07l.35-1L12,7.33l.71,2.26L13,10.64h3.31Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-11-favorite-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E11-favorite-b1-hover%3C/title%3E%3Cpolygon points='12 9.64 11.66 8.59 10.95 6.33 10.13 8.64 9.78 9.64 8.72 9.64 6.71 9.64 8.56 11.07 9.38 11.7 9.09 12.69 8.4 14.97 10.11 13.66 11.02 12.97 11.93 13.66 13.63 14.96 12.95 12.69 12.65 11.7 13.46 11.07 15.31 9.64 13.1 9.64 12 9.64' style='fill:%23fff'/%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm6.66,9.71-3.28,2.54,1.24,4.11a.88.88,0,0,1-.58,1.1,1.15,1.15,0,0,1-.26,0,.87.87,0,0,1-.53-.18L12,15.86,8.79,18.32a.89.89,0,0,1-.53.18.86.86,0,0,1-.7-.35.87.87,0,0,1-.15-.78l1.24-4.11L5.34,10.71a.88.88,0,0,1-.16-1.23.91.91,0,0,1,.7-.34H9.72l1.44-4.06A.88.88,0,0,1,12,4.5a.93.93,0,0,1,.29,0,.9.9,0,0,1,.55.56l1.27,4h4A.87.87,0,0,1,19,10,.85.85,0,0,1,18.66,10.71Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-12-info{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E12-info-b1%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23fff;fill-rule:evenodd'/%3E%3Cpath d='M12,9a1,1,0,0,0-1,1v8a1,1,0,0,0,2,0V10A1,1,0,0,0,12,9Z' transform='translate(-1 -1)' style='fill:%23fff;fill-rule:evenodd'/%3E%3Ccircle cx='11' cy='5' r='1' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-12-info-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath d='M12 1C5.925 1 1 5.926 1 12c0 6.075 4.925 11 11 11s11-4.925 11-11c0-6.074-4.925-11-11-11m0 1c5.514 0 10 4.486 10 10 0 5.515-4.486 10-10 10S2 17.515 2 12C2 6.485 6.486 2 12 2m0 17.149a1 1 0 0 1-1-1v-8a1 1 0 1 1 2 0v8a1 1 0 0 1-1 1m1-13a1 1 0 1 1-2 0 1 1 0 0 1 2 0' id='a'/%3E%3C/defs%3E%3Cg transform='translate(.2 .2)' fill='none' fill-rule='evenodd'%3E%3Cmask id='b' fill='%23fff'%3E%3Cuse xlink:href='%23a'/%3E%3C/mask%3E%3Cuse fill='%23000' xlink:href='%23a'/%3E%3Cg mask='url(%23b)' fill='%23FFF'%3E%3Cpath d='M0 0h24v24H0z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A\")}.sfi.white-12-info-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath d='M12 1C5.925 1 1 5.926 1 12c0 6.075 4.925 11 11 11s11-4.925 11-11c0-6.074-4.925-11-11-11m0 18.149a1 1 0 0 1-1-1v-8a1 1 0 1 1 2 0v8a1 1 0 0 1-1 1m1-13a1 1 0 1 1-2 0 1 1 0 0 1 2 0' id='a'/%3E%3C/defs%3E%3Cg transform='translate(.2 .2)' fill='none' fill-rule='evenodd'%3E%3Cmask id='b' fill='%23fff'%3E%3Cuse xlink:href='%23a'/%3E%3C/mask%3E%3Cuse fill='%23000' xlink:href='%23a'/%3E%3Cg mask='url(%23b)' fill='%23FFF'%3E%3Cpath d='M0 0h24v24H0z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A\")}.sfi.white-13-help{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath d='M12 1C5.925 1 1 5.926 1 12c0 6.075 4.925 11 11 11s11-4.925 11-11c0-6.074-4.925-11-11-11m0 1c5.514 0 10 4.486 10 10 0 5.515-4.486 10-10 10S2 17.515 2 12C2 6.485 6.486 2 12 2m1 16.155a1 1 0 1 1-2 0 1 1 0 0 1 2 0M12.053 7.15c.344 0 .67.04.944.082.61.094 1.036.593 1.036 1.215 0 .457-.223.739-.417.934l-1.336 1.276a3.97 3.97 0 0 0-1.268 2.919v.572c0 .554.45 1.005 1.003 1.005.553 0 1.002-.451 1.002-1.005v-.572c0-.361.05-.892.49-1.348l1.66-1.547c.56-.593.872-1.387.872-2.234 0-1.598-1.113-2.934-2.646-3.177-.696-.155-1.901-.15-2.533.01a3.112 3.112 0 0 0-1.865 1.092 4.701 4.701 0 0 0-.117.167c-.154.212-.223.397-.223.588 0 .552.45 1.002 1.003 1.002.317 0 .495-.086.68-.33.052-.07.336-.427.892-.56.258-.06.534-.09.823-.09' id='a'/%3E%3C/defs%3E%3Cg transform='translate(.2 .2)' fill='none' fill-rule='evenodd'%3E%3Cmask id='b' fill='%23fff'%3E%3Cuse xlink:href='%23a'/%3E%3C/mask%3E%3Cuse fill='%23000' xlink:href='%23a'/%3E%3Cg mask='url(%23b)' fill='%23FFF'%3E%3Cpath d='M0 0h24v24H0z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A\")}.sfi.white-13-help-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E12-info-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm1,17a1,1,0,0,1-2,0V10a1,1,0,0,1,2,0ZM12,7a1,1,0,1,1,1-1A1,1,0,0,1,12,7Z' transform='translate(-1 -1)' style='fill:%23fff;fill-rule:evenodd'/%3E%3C/svg%3E\")}.sfi.white-14-warning{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath d='M12.001 1c-.511 0-1.003.3-1.245.816L1.144 20.882a1.535 1.535 0 0 0-.144.651C1 22.343 1.621 23 2.388 23h19.224c.213 0 .424-.052.616-.152.686-.36.967-1.24.627-1.966L13.244 1.816a1.432 1.432 0 0 0-.629-.664A1.321 1.321 0 0 0 12.001 1m0 1a.32.32 0 0 1 .151.039c.078.04.144.112.199.228l9.599 19.039c.112.239.025.546-.186.656a.33.33 0 0 1-.152.038H2.388c-.21 0-.388-.214-.388-.467 0-.079.017-.157.037-.201L11.662 2.24c.083-.177.23-.24.339-.24M12 15.996a1 1 0 0 1-1-1v-7a1 1 0 1 1 2 0v7a1 1 0 0 1-1 1m-1 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0' id='a'/%3E%3C/defs%3E%3Cg transform='translate(.2 .2)' fill='none' fill-rule='evenodd'%3E%3Cmask id='b' fill='%23fff'%3E%3Cuse xlink:href='%23a'/%3E%3C/mask%3E%3Cuse fill='%23000' xlink:href='%23a'/%3E%3Cg mask='url(%23b)' fill='%23FFF'%3E%3Cpath d='M0 0h24v24H0z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A\")}.sfi.white-14-warning-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath d='M12.001 1c-.511 0-1.003.3-1.245.816L1.144 20.882a1.535 1.535 0 0 0-.144.651C1 22.343 1.621 23 2.388 23h19.224c.213 0 .424-.052.616-.152.686-.36.967-1.24.627-1.966L13.244 1.816a1.432 1.432 0 0 0-.629-.664A1.321 1.321 0 0 0 12.001 1M12 15.996a1 1 0 0 1-1-1v-7a1 1 0 1 1 2 0v7a1 1 0 0 1-1 1m-1 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0' id='a'/%3E%3C/defs%3E%3Cg transform='translate(.2 .2)' fill='none' fill-rule='evenodd'%3E%3Cmask id='b' fill='%23fff'%3E%3Cuse xlink:href='%23a'/%3E%3C/mask%3E%3Cuse fill='%23000' xlink:href='%23a'/%3E%3Cg mask='url(%23b)' fill='%23FFF'%3E%3Cpath d='M0 0h24v24H0z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A\")}.sfi.b1-01-up{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 7.99'%3E%3Ctitle%3E01-up-b1%3C/title%3E%3Cpath d='M18,15.45a1,1,0,0,1-.73-.32L12,9.47,6.73,15.13a1,1,0,0,1-1.46-1.36l5.32-5.72a2,2,0,0,1,2.82,0l5.32,5.72A1,1,0,0,1,18,15.45Z' transform='translate(-5 -7.46)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-01-up-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E01-up-b1-alt%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3Cpath d='M13.41,8.05a2,2,0,0,0-2.82,0L5.27,13.77a1,1,0,0,0,1.46,1.36L12,9.47l5.27,5.66a1,1,0,1,0,1.46-1.36Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-01-up-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E01-up-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm6.68,14.18a1,1,0,0,1-1.41,0L12,9.47,6.73,15.13a1,1,0,0,1-1.46-1.36l5.32-5.72a2,2,0,0,1,2.82,0l5.32,5.72A1,1,0,0,1,18.68,15.18Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-02-down{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 8.02'%3E%3Ctitle%3E02-down-b1%3C/title%3E%3Cpath d='M12,16.52a1.94,1.94,0,0,1-1.41-.62L5.27,10.18A1,1,0,0,1,6.73,8.82L12,14.48l5.27-5.66a1,1,0,1,1,1.46,1.36L13.41,15.9A1.94,1.94,0,0,1,12,16.52Z' transform='translate(-5 -8.5)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-02-down-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E02-down-b1-alt%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3Cpath d='M17.27,8.82,12,14.48,6.73,8.82a1,1,0,0,0-1.46,1.36l5.32,5.72a1.91,1.91,0,0,0,2.82,0l5.32-5.72a1,1,0,1,0-1.46-1.36Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-02-down-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E02-down-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm6.73,9.18L13.41,15.9a1.91,1.91,0,0,1-2.82,0L5.27,10.18A1,1,0,0,1,6.73,8.82L12,14.48l5.27-5.66a1,1,0,1,1,1.46,1.36Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-03-left{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8.02 14'%3E%3Cpath d='M14.45,19a1,1,0,0,1-.68-.27L8.05,13.41A2,2,0,0,1,7.43,12a2,2,0,0,1,.62-1.42l5.72-5.32a1,1,0,0,1,1.36,1.47L9.47,12l5.66,5.26a1,1,0,0,1,0,1.42A1,1,0,0,1,14.45,19Z' transform='translate(-7.43 -5)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-03-left-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E03-left-b1-alt%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3Cpath d='M15.18,5.32a1,1,0,0,0-1.41-.06L8.05,10.58A2,2,0,0,0,7.43,12a2,2,0,0,0,.62,1.41l5.72,5.32a1,1,0,0,0,1.36-1.47L9.47,12l5.66-5.27A1,1,0,0,0,15.18,5.32Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-03-left-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E03-left-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm3.13,16.26a1,1,0,0,1,0,1.42,1,1,0,0,1-1.41.05L8.05,13.41A2,2,0,0,1,7.43,12a2,2,0,0,1,.62-1.42l5.72-5.32a1,1,0,0,1,1.36,1.47L9.47,12Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-04-right{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8.02 14'%3E%3Ctitle%3E04-right-b1%3C/title%3E%3Cpath d='M10,19a1,1,0,0,1-.73-.32,1,1,0,0,1,.05-1.42L15,12,9.32,6.73a1,1,0,0,1,1.36-1.47l5.72,5.32A2,2,0,0,1,17,12a2,2,0,0,1-.62,1.41l-5.72,5.32A1,1,0,0,1,10,19Z' transform='translate(-9 -5)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-04-right-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E04-right-b1-alt%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3Cpath d='M10.68,5.26A1,1,0,0,0,9.32,6.73L15,12,9.32,17.26a1,1,0,0,0-.05,1.42,1,1,0,0,0,1.41.05l5.72-5.32A2,2,0,0,0,17,12a2,2,0,0,0-.62-1.42Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-04-right-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E04-right-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm4.4,12.41-5.72,5.32a1,1,0,0,1-1.36-1.47L15,12,9.32,6.73a1,1,0,0,1,1.36-1.47l5.72,5.32A2,2,0,0,1,17,12,2,2,0,0,1,16.4,13.41Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-05-check{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 9.99'%3E%3Ctitle%3E05-check-b1%3C/title%3E%3Cpath d='M9.54,17a1.51,1.51,0,0,1-1-.42L5.3,13.48A1,1,0,0,1,6.7,12L9.54,14.8,17.3,7.28a1,1,0,1,1,1.4,1.43l-8.1,7.86A1.53,1.53,0,0,1,9.54,17Z' transform='translate(-5 -7)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-05-check-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E05-check-b1-alt%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3Cpath d='M17.3,7.28,9.54,14.8,6.7,12a1,1,0,0,0-1.4,1.44l3.19,3.09a1.51,1.51,0,0,0,1,.42,1.53,1.53,0,0,0,1.06-.42l8.1-7.86a1,1,0,1,0-1.4-1.43Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-05-check-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E05-check-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm6.7,7.71-8.1,7.86A1.53,1.53,0,0,1,9.54,17a1.51,1.51,0,0,1-1-.42L5.3,13.48A1,1,0,0,1,6.7,12L9.54,14.8,17.3,7.28a1,1,0,1,1,1.4,1.43Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-06-close{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 11'%3E%3Ctitle%3E06-close-b1%3C/title%3E%3Cpath d='M13.41,12l3.8-3.79a1,1,0,1,0-1.42-1.42L12,10.59,8.21,6.79A1,1,0,1,0,6.79,8.21L10.59,12l-3.8,3.79a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L12,13.41l3.79,3.8a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z' transform='translate(-6.5 -6.5)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-06-close-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E06-close-b1-alt%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3Cpath d='M17.21,6.79a1,1,0,0,0-1.42,0L12,10.59,8.21,6.79A1,1,0,1,0,6.79,8.21L10.59,12l-3.8,3.79a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L12,13.41l3.79,3.8a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L13.41,12l3.8-3.79A1,1,0,0,0,17.21,6.79Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-06-close-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E06-close-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm5.21,14.79a1,1,0,0,1,0,1.42,1,1,0,0,1-1.42,0L12,13.41l-3.79,3.8a1,1,0,0,1-1.42,0,1,1,0,0,1,0-1.42L10.59,12,6.79,8.21A1,1,0,1,1,8.21,6.79L12,10.59l3.79-3.8a1,1,0,1,1,1.42,1.42L13.41,12Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-07-equal{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 7'%3E%3Ctitle%3E07-equal-b1%3C/title%3E%3Cpath d='M18,10.5H6a1,1,0,0,1,0-2H18a1,1,0,0,1,0,2Z' transform='translate(-5 -8.5)' style='fill:%23002a54'/%3E%3Cpath d='M18,15.5H6a1,1,0,0,1,0-2H18a1,1,0,0,1,0,2Z' transform='translate(-5 -8.5)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-07-equal-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E07-equal-b1-alt%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3Cpath d='M18,8.5H6a1,1,0,0,0,0,2H18a1,1,0,0,0,0-2Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3Cpath d='M18,13.5H6a1,1,0,0,0,0,2H18a1,1,0,0,0,0-2Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-07-equal-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E07-equal-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm6,14.5H6a1,1,0,0,1,0-2H18a1,1,0,0,1,0,2Zm0-5H6a1,1,0,0,1,0-2H18a1,1,0,0,1,0,2Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-08-plus{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 14'%3E%3Ctitle%3E08-plus-b1%3C/title%3E%3Cpath d='M18,11H13V6a1,1,0,0,0-2,0v5H6a1,1,0,0,0,0,2h5v5a1,1,0,0,0,2,0V13h5a1,1,0,0,0,0-2Z' transform='translate(-5 -5)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-08-plus-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E09-minus-b1-alt%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3Cpath d='M18,11H6a1,1,0,0,0,0,2H18a1,1,0,0,0,0-2Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-08-plus-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E08-plus-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm6,12H13v5a1,1,0,0,1-2,0V13H6a1,1,0,0,1,0-2h5V6a1,1,0,0,1,2,0v5h5a1,1,0,0,1,0,2Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-09-minus{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 2'%3E%3Ctitle%3E09-minus-b1%3C/title%3E%3Cpath d='M18,13H6a1,1,0,0,1,0-2H18a1,1,0,0,1,0,2Z' transform='translate(-5 -11)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-09-minus-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' x='0' y='0' viewBox='0 0 24 24' xml:space='preserve'%3E%3Cstyle%3E .st0%7Bfill:%23002a54%7D %3C/style%3E%3Cpath class='st0' d='M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm0 21C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10z'/%3E%3Cpath class='st0' d='M18 11H6a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2z'/%3E%3C/svg%3E%0A\")}.sfi.b1-09-minus-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E09-minus-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm6,12H6a1,1,0,0,1,0-2H18a1,1,0,0,1,0,2Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-10-navigation{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 10'%3E%3Ctitle%3E10-navigation-b1%3C/title%3E%3Cpath d='M6,9H18a1,1,0,0,0,0-2H6A1,1,0,0,0,6,9Z' transform='translate(-5 -7)' style='fill:%23002a54'/%3E%3Cpath d='M18,11H6a1,1,0,0,0,0,2H18a1,1,0,0,0,0-2Z' transform='translate(-5 -7)' style='fill:%23002a54'/%3E%3Cpath d='M18,15H6a1,1,0,0,0,0,2H18a1,1,0,0,0,0-2Z' transform='translate(-5 -7)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-10-navigation-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E10-navigation-b1-alt%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3Cpath d='M18,7H6A1,1,0,0,0,6,9H18a1,1,0,0,0,0-2Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3Cpath d='M18,11H6a1,1,0,0,0,0,2H18a1,1,0,0,0,0-2Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3Cpath d='M18,15H6a1,1,0,0,0,0,2H18a1,1,0,0,0,0-2Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-10-navigation-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E10-navigation-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm6,16H6a1,1,0,0,1,0-2H18a1,1,0,0,1,0,2Zm0-4H6a1,1,0,0,1,0-2H18a1,1,0,0,1,0,2Zm0-4H6A1,1,0,0,1,6,7H18a1,1,0,0,1,0,2Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-11-favorite{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 14'%3E%3Ctitle%3E11-favorite-b1%3C/title%3E%3Cpath d='M12,7.33l.71,2.26L13,10.64h3.31l-1.85,1.43-.81.63.3,1L14.63,16l-1.7-1.3L12,14l-.91.69L9.4,16l.69-2.28.29-1-.82-.63L7.71,10.64h3.07l.35-1L12,7.33M12,4.5a.88.88,0,0,0-.83.58L9.72,9.14H5.88a.91.91,0,0,0-.7.34.88.88,0,0,0,.16,1.23l3.31,2.55L7.41,17.37a.87.87,0,0,0,.15.78.86.86,0,0,0,.7.35.89.89,0,0,0,.53-.18L12,15.86l3.23,2.45a.87.87,0,0,0,.53.18,1.15,1.15,0,0,0,.26,0,.88.88,0,0,0,.58-1.1l-1.24-4.11,3.28-2.54A.85.85,0,0,0,19,10a.87.87,0,0,0-.88-.88h-4l-1.27-4a.9.9,0,0,0-.55-.56.93.93,0,0,0-.29,0Z' transform='translate(-5 -4.5)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-11-favorite-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E11-favorite-b1-alt%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3Cpath d='M18.12,9.14h-4l-1.27-4a.9.9,0,0,0-.55-.56.93.93,0,0,0-.29,0,.88.88,0,0,0-.83.58L9.72,9.14H5.88a.91.91,0,0,0-.7.34.88.88,0,0,0,.16,1.23l3.31,2.55L7.41,17.37a.87.87,0,0,0,.15.78.86.86,0,0,0,.7.35.89.89,0,0,0,.53-.18L12,15.86l3.23,2.45a.87.87,0,0,0,.53.18,1.15,1.15,0,0,0,.26,0,.88.88,0,0,0,.58-1.1l-1.24-4.11,3.28-2.54A.85.85,0,0,0,19,10,.87.87,0,0,0,18.12,9.14Zm-3.66,2.93-.81.63.3,1L14.63,16l-1.7-1.3L12,14l-.91.69L9.4,16l.69-2.28.29-1-.82-.63L7.71,10.64h3.07l.35-1L12,7.33l.71,2.26L13,10.64h3.31Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-11-favorite-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E11-favorite-b1-hover%3C/title%3E%3Cpolygon points='12 9.64 11.66 8.59 10.95 6.33 10.13 8.64 9.78 9.64 8.72 9.64 6.71 9.64 8.56 11.07 9.38 11.7 9.09 12.69 8.4 14.97 10.11 13.66 11.02 12.97 11.93 13.66 13.63 14.96 12.95 12.69 12.65 11.7 13.46 11.07 15.31 9.64 13.1 9.64 12 9.64' style='fill:%23002a54'/%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm6.66,9.71-3.28,2.54,1.24,4.11a.88.88,0,0,1-.58,1.1,1.15,1.15,0,0,1-.26,0,.87.87,0,0,1-.53-.18L12,15.86,8.79,18.32a.89.89,0,0,1-.53.18.86.86,0,0,1-.7-.35.87.87,0,0,1-.15-.78l1.24-4.11L5.34,10.71a.88.88,0,0,1-.16-1.23.91.91,0,0,1,.7-.34H9.72l1.44-4.06A.88.88,0,0,1,12,4.5a.93.93,0,0,1,.29,0,.9.9,0,0,1,.55.56l1.27,4h4A.87.87,0,0,1,19,10,.85.85,0,0,1,18.66,10.71Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-12-info{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E12-info-b1%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23002a54;fill-rule:evenodd'/%3E%3Cpath d='M12,9a1,1,0,0,0-1,1v8a1,1,0,0,0,2,0V10A1,1,0,0,0,12,9Z' transform='translate(-1 -1)' style='fill:%23002a54;fill-rule:evenodd'/%3E%3Ccircle cx='11' cy='5' r='1' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-12-info-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' x='0' y='0' viewBox='0 0 24 24' xml:space='preserve'%3E%3Cstyle%3E .st0%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23002a54%7D %3C/style%3E%3Cpath class='st0' d='M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm0 21C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10z'/%3E%3Cpath class='st0' d='M12 8.996a1 1 0 0 0-1 1v8a1 1 0 1 0 2 0v-8a1 1 0 0 0-1-1z'/%3E%3Ccircle class='st0' cx='12' cy='5.997' r='1'/%3E%3C/svg%3E%0A\")}.sfi.b1-12-info-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E12-info-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm1,17a1,1,0,0,1-2,0V10a1,1,0,0,1,2,0ZM12,7a1,1,0,1,1,1-1A1,1,0,0,1,12,7Z' transform='translate(-1 -1)' style='fill:%23002a54;fill-rule:evenodd'/%3E%3C/svg%3E\")}.sfi.b1-13-help{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' x='0' y='0' viewBox='0 0 24 24' xml:space='preserve'%3E%3Cstyle%3E .st0%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23002a54%7D %3C/style%3E%3Cpath class='st0' d='M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm0 21C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10z'/%3E%3Cpath class='st0' d='M13.393 5.118c-.697-.156-1.9-.15-2.534.01A3.108 3.108 0 0 0 8.995 6.22a7.317 7.317 0 0 0-.118.167c-.153.212-.223.398-.223.588 0 .553.45 1.003 1.004 1.003.317 0 .495-.087.68-.33.052-.07.336-.428.891-.56.259-.06.535-.09.824-.09.344 0 .67.042.944.083.61.093 1.036.592 1.036 1.214 0 .457-.223.74-.417.935l-1.337 1.275a3.973 3.973 0 0 0-1.267 2.92v.571c0 .554.45 1.005 1.003 1.005s1.002-.451 1.002-1.005v-.572c0-.36.05-.891.49-1.347l1.661-1.547a3.24 3.24 0 0 0 .871-2.235c0-1.597-1.113-2.933-2.646-3.176z'/%3E%3Ccircle class='st0' cx='12' cy='18.002' r='1'/%3E%3C/svg%3E%0A\")}.sfi.b1-13-help-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm0 18.002a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm3.168-8.473l-1.66 1.547c-.44.456-.49.987-.49 1.347v.572c0 .554-.45 1.005-1.003 1.005s-1.003-.451-1.003-1.005v-.572c0-1.113.45-2.15 1.267-2.919l1.337-1.275c.194-.195.417-.478.417-.935 0-.622-.426-1.12-1.036-1.214a6.37 6.37 0 0 0-.944-.082c-.289 0-.565.029-.823.088-.556.133-.84.49-.891.56-.186.244-.364.331-.681.331-.553 0-1.004-.45-1.004-1.003 0-.19.07-.376.223-.588.017-.024.097-.14.118-.167a3.108 3.108 0 0 1 1.864-1.09c.633-.162 1.837-.167 2.534-.011 1.533.243 2.646 1.579 2.646 3.176a3.24 3.24 0 0 1-.871 2.235z' fill='%23002a54'/%3E%3C/svg%3E%0A\")}.sfi.b1-14-warning{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' x='0' y='0' viewBox='0 0 24 24' xml:space='preserve'%3E%3Cstyle%3E .st1%7Bfill:%23002a54%7D %3C/style%3E%3Ccircle cx='12' cy='18.997' r='1' fill-rule='evenodd' clip-rule='evenodd' fill='%23002a54'/%3E%3Cpath class='st1' d='M12 6.996a1 1 0 0 0-1 1v7a1 1 0 1 0 2 0v-7a1 1 0 0 0-1-1z'/%3E%3Cpath class='st1' d='M22.856 20.882L13.244 1.817a1.43 1.43 0 0 0-.629-.664A1.321 1.321 0 0 0 12.001 1c-.511 0-1.003.3-1.245.817L1.144 20.882a1.536 1.536 0 0 0-.144.65C1 22.344 1.621 23 2.388 23h19.224c.213 0 .424-.052.615-.152.687-.36.969-1.24.629-1.966zm-1.092 1.08a.325.325 0 0 1-.152.038H2.388c-.21 0-.388-.214-.388-.467 0-.08.017-.158.037-.2L11.662 2.24c.083-.178.23-.241.339-.241.051 0 .102.013.15.039.08.04.145.112.2.228l9.599 19.04c.112.238.025.544-.186.655z'/%3E%3C/svg%3E%0A\")}.sfi.b1-14-warning-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M22.856 20.882L13.244 1.817a1.43 1.43 0 0 0-.629-.664A1.321 1.321 0 0 0 12.001 1c-.511 0-1.003.3-1.245.817L1.144 20.882a1.536 1.536 0 0 0-.144.65C1 22.344 1.621 23 2.388 23h19.224c.213 0 .424-.052.615-.152.687-.36.969-1.24.629-1.966zM12 19.997a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm1-5a1 1 0 1 1-2 0v-7a1 1 0 1 1 2 0v7z' fill='%23002a54'/%3E%3C/svg%3E%0A\")}.sfi.b2-01-up{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 7.99'%3E%3Ctitle%3E01-up-white%3C/title%3E%3Cpath d='M26,24a1,1,0,0,1-.73-.32L20,18l-5.27,5.67a1,1,0,1,1-1.46-1.37l5.32-5.71a2,2,0,0,1,2.82,0l5.32,5.71A1,1,0,0,1,26,24' transform='translate(-13 -16)' style='fill:%23056DAE;fill-rule:evenodd'/%3E%3C/svg%3E\")}.sfi.b2-02-down{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 8.02'%3E%3Ctitle%3E02-down-white%3C/title%3E%3Cpath d='M20,24a1.94,1.94,0,0,1-1.41-.62l-5.32-5.72a1,1,0,0,1,1.46-1.36L20,22l5.27-5.66a1,1,0,0,1,1.46,1.36l-5.32,5.72A1.94,1.94,0,0,1,20,24' transform='translate(-13 -15.99)' style='fill:%23056DAE;fill-rule:evenodd'/%3E%3C/svg%3E\")}.sfi.b2-03-left{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8.02 14'%3E%3Ctitle%3E03-left-white%3C/title%3E%3Cpath d='M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27' transform='translate(-15.99 -13)' style='fill:%23056DAE;fill-rule:evenodd'/%3E%3C/svg%3E\")}.sfi.b2-04-right{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8.02 14'%3E%3Ctitle%3E04-right-white%3C/title%3E%3Cpath d='M17,27a1,1,0,0,1-.68-1.73L22,20l-5.66-5.27a1,1,0,0,1,1.36-1.46l5.72,5.32a1.91,1.91,0,0,1,0,2.82l-5.72,5.32A1,1,0,0,1,17,27' transform='translate(-15.99 -13)' style='fill:%23056DAE;fill-rule:evenodd'/%3E%3C/svg%3E\")}.sfi.g1-06-close{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 11'%3E%3Ctitle%3E06-close-white%3C/title%3E%3Cpath d='M21.41,20l3.8-3.79a1,1,0,0,0-1.42-1.42L20,18.59l-3.79-3.8a1,1,0,0,0-1.42,1.42L18.59,20l-3.8,3.79a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L20,21.41l3.79,3.8a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z' transform='translate(-14.5 -14.5)' style='fill:%23666;fill-rule:evenodd'/%3E%3C/svg%3E\")}.sfi.g1-06-close:hover,.sfi.g1-06-close:focus{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E06-close-white-hover%3C/title%3E%3Cpath d='M21.41,20.15l3.8-3.79a1,1,0,0,0,0-1.41,1,1,0,0,0-1.42,0L20,18.74,16.21,15a1,1,0,0,0-1.42,0,1,1,0,0,0,0,1.41l3.8,3.79L14.79,24a1,1,0,0,0,0,1.41,1,1,0,0,0,1.42,0L20,21.57l3.79,3.79a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.41ZM20,9A11,11,0,1,0,31,20,11,11,0,0,0,20,9' transform='translate(-9 -9)' style='fill:%23666;fill-rule:evenodd'/%3E%3C/svg%3E\")}.sfi.g1-02-down{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 8.02'%3E%3Ctitle%3E02-down-white%3C/title%3E%3Cpath d='M20,24a1.94,1.94,0,0,1-1.41-.62l-5.32-5.72a1,1,0,0,1,1.46-1.36L20,22l5.27-5.66a1,1,0,0,1,1.46,1.36l-5.32,5.72A1.94,1.94,0,0,1,20,24' transform='translate(-13 -15.99)' style='fill:%23666;fill-rule:evenodd'/%3E%3C/svg%3E\")}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Icon2Component, decorators: [{
            type: Component,
            args: [{ selector: 'citi-icon2', standalone: false, template: `
    <div
      #svgContainer
      [attr.tabindex]="tabIndex"
      [ngStyle]="type === 'glyph' ? '' : svgStyle"
      [ngClass]="[iconClass]"
      [attr.id]="idStr"
      [attr.role]="role"
      [attr.aria-label]="ariaLabel"
      [attr.aria-hidden]="ariaHidden ? true : null"
    ></div>
  `, styles: [":host{line-height:0}:host div{display:inline-block;line-height:0px}.small{width:12px;height:12px}.medium{width:14px;height:14px}.large{width:16px;height:16px}.small-circle{width:18px;height:18px}.medium-circle{width:20px;height:20px}.large-circle{width:22px;height:22px}.sfi{background-repeat:no-repeat}.sfi.small{width:12px;height:12px;margin:3px}.sfi.medium{width:14px;height:14px;margin:3px}.sfi.large{width:16px;height:16px;margin:4px}.sfi.small-circle{width:18px;height:18px;margin:5px}.sfi.medium-circle{width:20px;height:20px;margin:5px}.sfi.large-circle{width:22px;height:22px;margin:5px}.sfi.white-01-up{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 7.99'%3E%3Ctitle%3E01-up-b1%3C/title%3E%3Cpath d='M18,15.45a1,1,0,0,1-.73-.32L12,9.47,6.73,15.13a1,1,0,0,1-1.46-1.36l5.32-5.72a2,2,0,0,1,2.82,0l5.32,5.72A1,1,0,0,1,18,15.45Z' transform='translate(-5 -7.46)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-01-up-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E01-up-b1-alt%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3Cpath d='M13.41,8.05a2,2,0,0,0-2.82,0L5.27,13.77a1,1,0,0,0,1.46,1.36L12,9.47l5.27,5.66a1,1,0,1,0,1.46-1.36Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-01-up-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E01-up-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm6.68,14.18a1,1,0,0,1-1.41,0L12,9.47,6.73,15.13a1,1,0,0,1-1.46-1.36l5.32-5.72a2,2,0,0,1,2.82,0l5.32,5.72A1,1,0,0,1,18.68,15.18Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-02-down{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 8.02'%3E%3Ctitle%3E02-down-b1%3C/title%3E%3Cpath d='M12,16.52a1.94,1.94,0,0,1-1.41-.62L5.27,10.18A1,1,0,0,1,6.73,8.82L12,14.48l5.27-5.66a1,1,0,1,1,1.46,1.36L13.41,15.9A1.94,1.94,0,0,1,12,16.52Z' transform='translate(-5 -8.5)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-02-down-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E02-down-b1-alt%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3Cpath d='M17.27,8.82,12,14.48,6.73,8.82a1,1,0,0,0-1.46,1.36l5.32,5.72a1.91,1.91,0,0,0,2.82,0l5.32-5.72a1,1,0,1,0-1.46-1.36Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-02-down-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E02-down-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm6.73,9.18L13.41,15.9a1.91,1.91,0,0,1-2.82,0L5.27,10.18A1,1,0,0,1,6.73,8.82L12,14.48l5.27-5.66a1,1,0,1,1,1.46,1.36Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-03-left{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8.02 14'%3E%3Cpath d='M14.45,19a1,1,0,0,1-.68-.27L8.05,13.41A2,2,0,0,1,7.43,12a2,2,0,0,1,.62-1.42l5.72-5.32a1,1,0,0,1,1.36,1.47L9.47,12l5.66,5.26a1,1,0,0,1,0,1.42A1,1,0,0,1,14.45,19Z' transform='translate(-7.43 -5)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-03-left-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E03-left-b1-alt%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3Cpath d='M15.18,5.32a1,1,0,0,0-1.41-.06L8.05,10.58A2,2,0,0,0,7.43,12a2,2,0,0,0,.62,1.41l5.72,5.32a1,1,0,0,0,1.36-1.47L9.47,12l5.66-5.27A1,1,0,0,0,15.18,5.32Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-03-left-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E03-left-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm3.13,16.26a1,1,0,0,1,0,1.42,1,1,0,0,1-1.41.05L8.05,13.41A2,2,0,0,1,7.43,12a2,2,0,0,1,.62-1.42l5.72-5.32a1,1,0,0,1,1.36,1.47L9.47,12Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-04-right{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8.02 14'%3E%3Ctitle%3E04-right-b1%3C/title%3E%3Cpath d='M10,19a1,1,0,0,1-.73-.32,1,1,0,0,1,.05-1.42L15,12,9.32,6.73a1,1,0,0,1,1.36-1.47l5.72,5.32A2,2,0,0,1,17,12a2,2,0,0,1-.62,1.41l-5.72,5.32A1,1,0,0,1,10,19Z' transform='translate(-9 -5)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-04-right-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E04-right-b1-alt%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3Cpath d='M10.68,5.26A1,1,0,0,0,9.32,6.73L15,12,9.32,17.26a1,1,0,0,0-.05,1.42,1,1,0,0,0,1.41.05l5.72-5.32A2,2,0,0,0,17,12a2,2,0,0,0-.62-1.42Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-04-right-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E04-right-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm4.4,12.41-5.72,5.32a1,1,0,0,1-1.36-1.47L15,12,9.32,6.73a1,1,0,0,1,1.36-1.47l5.72,5.32A2,2,0,0,1,17,12,2,2,0,0,1,16.4,13.41Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-05-check{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 9.99'%3E%3Ctitle%3E05-check-b1%3C/title%3E%3Cpath d='M9.54,17a1.51,1.51,0,0,1-1-.42L5.3,13.48A1,1,0,0,1,6.7,12L9.54,14.8,17.3,7.28a1,1,0,1,1,1.4,1.43l-8.1,7.86A1.53,1.53,0,0,1,9.54,17Z' transform='translate(-5 -7)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-05-check-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E05-check-b1-alt%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3Cpath d='M17.3,7.28,9.54,14.8,6.7,12a1,1,0,0,0-1.4,1.44l3.19,3.09a1.51,1.51,0,0,0,1,.42,1.53,1.53,0,0,0,1.06-.42l8.1-7.86a1,1,0,1,0-1.4-1.43Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-05-check-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E05-check-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm6.7,7.71-8.1,7.86A1.53,1.53,0,0,1,9.54,17a1.51,1.51,0,0,1-1-.42L5.3,13.48A1,1,0,0,1,6.7,12L9.54,14.8,17.3,7.28a1,1,0,1,1,1.4,1.43Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-06-close{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 11'%3E%3Ctitle%3E06-close-b1%3C/title%3E%3Cpath d='M13.41,12l3.8-3.79a1,1,0,1,0-1.42-1.42L12,10.59,8.21,6.79A1,1,0,1,0,6.79,8.21L10.59,12l-3.8,3.79a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L12,13.41l3.79,3.8a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z' transform='translate(-6.5 -6.5)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-06-close-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E06-close-b1-alt%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3Cpath d='M17.21,6.79a1,1,0,0,0-1.42,0L12,10.59,8.21,6.79A1,1,0,1,0,6.79,8.21L10.59,12l-3.8,3.79a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L12,13.41l3.79,3.8a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L13.41,12l3.8-3.79A1,1,0,0,0,17.21,6.79Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-06-close-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E06-close-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm5.21,14.79a1,1,0,0,1,0,1.42,1,1,0,0,1-1.42,0L12,13.41l-3.79,3.8a1,1,0,0,1-1.42,0,1,1,0,0,1,0-1.42L10.59,12,6.79,8.21A1,1,0,1,1,8.21,6.79L12,10.59l3.79-3.8a1,1,0,1,1,1.42,1.42L13.41,12Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-07-equal{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 7'%3E%3Ctitle%3E07-equal-b1%3C/title%3E%3Cpath d='M18,10.5H6a1,1,0,0,1,0-2H18a1,1,0,0,1,0,2Z' transform='translate(-5 -8.5)' style='fill:%23fff'/%3E%3Cpath d='M18,15.5H6a1,1,0,0,1,0-2H18a1,1,0,0,1,0,2Z' transform='translate(-5 -8.5)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-07-equal-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E07-equal-b1-alt%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3Cpath d='M18,8.5H6a1,1,0,0,0,0,2H18a1,1,0,0,0,0-2Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3Cpath d='M18,13.5H6a1,1,0,0,0,0,2H18a1,1,0,0,0,0-2Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-07-equal-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E07-equal-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm6,14.5H6a1,1,0,0,1,0-2H18a1,1,0,0,1,0,2Zm0-5H6a1,1,0,0,1,0-2H18a1,1,0,0,1,0,2Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-08-plus{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 14'%3E%3Ctitle%3E08-plus-b1%3C/title%3E%3Cpath d='M18,11H13V6a1,1,0,0,0-2,0v5H6a1,1,0,0,0,0,2h5v5a1,1,0,0,0,2,0V13h5a1,1,0,0,0,0-2Z' transform='translate(-5 -5)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-08-plus-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E09-minus-b1-alt%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3Cpath d='M18,11H6a1,1,0,0,0,0,2H18a1,1,0,0,0,0-2Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-08-plus-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E09-minus-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm6,12H6a1,1,0,0,1,0-2H18a1,1,0,0,1,0,2Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-09-minus{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 2'%3E%3Ctitle%3E09-minus-b1%3C/title%3E%3Cpath d='M18,13H6a1,1,0,0,1,0-2H18a1,1,0,0,1,0,2Z' transform='translate(-5 -11)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-09-minus-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E09-minus-b1-alt%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3Cpath d='M18,11H6a1,1,0,0,0,0,2H18a1,1,0,0,0,0-2Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-09-minus-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E09-minus-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm6,12H6a1,1,0,0,1,0-2H18a1,1,0,0,1,0,2Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-10-navigation{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 10'%3E%3Ctitle%3E10-navigation-b1%3C/title%3E%3Cpath d='M6,9H18a1,1,0,0,0,0-2H6A1,1,0,0,0,6,9Z' transform='translate(-5 -7)' style='fill:%23fff'/%3E%3Cpath d='M18,11H6a1,1,0,0,0,0,2H18a1,1,0,0,0,0-2Z' transform='translate(-5 -7)' style='fill:%23fff'/%3E%3Cpath d='M18,15H6a1,1,0,0,0,0,2H18a1,1,0,0,0,0-2Z' transform='translate(-5 -7)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-10-navigation-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E10-navigation-b1-alt%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3Cpath d='M18,7H6A1,1,0,0,0,6,9H18a1,1,0,0,0,0-2Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3Cpath d='M18,11H6a1,1,0,0,0,0,2H18a1,1,0,0,0,0-2Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3Cpath d='M18,15H6a1,1,0,0,0,0,2H18a1,1,0,0,0,0-2Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-10-navigation-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E10-navigation-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm6,16H6a1,1,0,0,1,0-2H18a1,1,0,0,1,0,2Zm0-4H6a1,1,0,0,1,0-2H18a1,1,0,0,1,0,2Zm0-4H6A1,1,0,0,1,6,7H18a1,1,0,0,1,0,2Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-11-favorite{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 14'%3E%3Ctitle%3E11-favorite-b1%3C/title%3E%3Cpath d='M12,7.33l.71,2.26L13,10.64h3.31l-1.85,1.43-.81.63.3,1L14.63,16l-1.7-1.3L12,14l-.91.69L9.4,16l.69-2.28.29-1-.82-.63L7.71,10.64h3.07l.35-1L12,7.33M12,4.5a.88.88,0,0,0-.83.58L9.72,9.14H5.88a.91.91,0,0,0-.7.34.88.88,0,0,0,.16,1.23l3.31,2.55L7.41,17.37a.87.87,0,0,0,.15.78.86.86,0,0,0,.7.35.89.89,0,0,0,.53-.18L12,15.86l3.23,2.45a.87.87,0,0,0,.53.18,1.15,1.15,0,0,0,.26,0,.88.88,0,0,0,.58-1.1l-1.24-4.11,3.28-2.54A.85.85,0,0,0,19,10a.87.87,0,0,0-.88-.88h-4l-1.27-4a.9.9,0,0,0-.55-.56.93.93,0,0,0-.29,0Z' transform='translate(-5 -4.5)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-11-favorite-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E11-favorite-b1-alt%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3Cpath d='M18.12,9.14h-4l-1.27-4a.9.9,0,0,0-.55-.56.93.93,0,0,0-.29,0,.88.88,0,0,0-.83.58L9.72,9.14H5.88a.91.91,0,0,0-.7.34.88.88,0,0,0,.16,1.23l3.31,2.55L7.41,17.37a.87.87,0,0,0,.15.78.86.86,0,0,0,.7.35.89.89,0,0,0,.53-.18L12,15.86l3.23,2.45a.87.87,0,0,0,.53.18,1.15,1.15,0,0,0,.26,0,.88.88,0,0,0,.58-1.1l-1.24-4.11,3.28-2.54A.85.85,0,0,0,19,10,.87.87,0,0,0,18.12,9.14Zm-3.66,2.93-.81.63.3,1L14.63,16l-1.7-1.3L12,14l-.91.69L9.4,16l.69-2.28.29-1-.82-.63L7.71,10.64h3.07l.35-1L12,7.33l.71,2.26L13,10.64h3.31Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-11-favorite-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E11-favorite-b1-hover%3C/title%3E%3Cpolygon points='12 9.64 11.66 8.59 10.95 6.33 10.13 8.64 9.78 9.64 8.72 9.64 6.71 9.64 8.56 11.07 9.38 11.7 9.09 12.69 8.4 14.97 10.11 13.66 11.02 12.97 11.93 13.66 13.63 14.96 12.95 12.69 12.65 11.7 13.46 11.07 15.31 9.64 13.1 9.64 12 9.64' style='fill:%23fff'/%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm6.66,9.71-3.28,2.54,1.24,4.11a.88.88,0,0,1-.58,1.1,1.15,1.15,0,0,1-.26,0,.87.87,0,0,1-.53-.18L12,15.86,8.79,18.32a.89.89,0,0,1-.53.18.86.86,0,0,1-.7-.35.87.87,0,0,1-.15-.78l1.24-4.11L5.34,10.71a.88.88,0,0,1-.16-1.23.91.91,0,0,1,.7-.34H9.72l1.44-4.06A.88.88,0,0,1,12,4.5a.93.93,0,0,1,.29,0,.9.9,0,0,1,.55.56l1.27,4h4A.87.87,0,0,1,19,10,.85.85,0,0,1,18.66,10.71Z' transform='translate(-1 -1)' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-12-info{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E12-info-b1%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23fff;fill-rule:evenodd'/%3E%3Cpath d='M12,9a1,1,0,0,0-1,1v8a1,1,0,0,0,2,0V10A1,1,0,0,0,12,9Z' transform='translate(-1 -1)' style='fill:%23fff;fill-rule:evenodd'/%3E%3Ccircle cx='11' cy='5' r='1' style='fill:%23fff'/%3E%3C/svg%3E\")}.sfi.white-12-info-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath d='M12 1C5.925 1 1 5.926 1 12c0 6.075 4.925 11 11 11s11-4.925 11-11c0-6.074-4.925-11-11-11m0 1c5.514 0 10 4.486 10 10 0 5.515-4.486 10-10 10S2 17.515 2 12C2 6.485 6.486 2 12 2m0 17.149a1 1 0 0 1-1-1v-8a1 1 0 1 1 2 0v8a1 1 0 0 1-1 1m1-13a1 1 0 1 1-2 0 1 1 0 0 1 2 0' id='a'/%3E%3C/defs%3E%3Cg transform='translate(.2 .2)' fill='none' fill-rule='evenodd'%3E%3Cmask id='b' fill='%23fff'%3E%3Cuse xlink:href='%23a'/%3E%3C/mask%3E%3Cuse fill='%23000' xlink:href='%23a'/%3E%3Cg mask='url(%23b)' fill='%23FFF'%3E%3Cpath d='M0 0h24v24H0z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A\")}.sfi.white-12-info-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath d='M12 1C5.925 1 1 5.926 1 12c0 6.075 4.925 11 11 11s11-4.925 11-11c0-6.074-4.925-11-11-11m0 18.149a1 1 0 0 1-1-1v-8a1 1 0 1 1 2 0v8a1 1 0 0 1-1 1m1-13a1 1 0 1 1-2 0 1 1 0 0 1 2 0' id='a'/%3E%3C/defs%3E%3Cg transform='translate(.2 .2)' fill='none' fill-rule='evenodd'%3E%3Cmask id='b' fill='%23fff'%3E%3Cuse xlink:href='%23a'/%3E%3C/mask%3E%3Cuse fill='%23000' xlink:href='%23a'/%3E%3Cg mask='url(%23b)' fill='%23FFF'%3E%3Cpath d='M0 0h24v24H0z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A\")}.sfi.white-13-help{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath d='M12 1C5.925 1 1 5.926 1 12c0 6.075 4.925 11 11 11s11-4.925 11-11c0-6.074-4.925-11-11-11m0 1c5.514 0 10 4.486 10 10 0 5.515-4.486 10-10 10S2 17.515 2 12C2 6.485 6.486 2 12 2m1 16.155a1 1 0 1 1-2 0 1 1 0 0 1 2 0M12.053 7.15c.344 0 .67.04.944.082.61.094 1.036.593 1.036 1.215 0 .457-.223.739-.417.934l-1.336 1.276a3.97 3.97 0 0 0-1.268 2.919v.572c0 .554.45 1.005 1.003 1.005.553 0 1.002-.451 1.002-1.005v-.572c0-.361.05-.892.49-1.348l1.66-1.547c.56-.593.872-1.387.872-2.234 0-1.598-1.113-2.934-2.646-3.177-.696-.155-1.901-.15-2.533.01a3.112 3.112 0 0 0-1.865 1.092 4.701 4.701 0 0 0-.117.167c-.154.212-.223.397-.223.588 0 .552.45 1.002 1.003 1.002.317 0 .495-.086.68-.33.052-.07.336-.427.892-.56.258-.06.534-.09.823-.09' id='a'/%3E%3C/defs%3E%3Cg transform='translate(.2 .2)' fill='none' fill-rule='evenodd'%3E%3Cmask id='b' fill='%23fff'%3E%3Cuse xlink:href='%23a'/%3E%3C/mask%3E%3Cuse fill='%23000' xlink:href='%23a'/%3E%3Cg mask='url(%23b)' fill='%23FFF'%3E%3Cpath d='M0 0h24v24H0z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A\")}.sfi.white-13-help-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E12-info-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm1,17a1,1,0,0,1-2,0V10a1,1,0,0,1,2,0ZM12,7a1,1,0,1,1,1-1A1,1,0,0,1,12,7Z' transform='translate(-1 -1)' style='fill:%23fff;fill-rule:evenodd'/%3E%3C/svg%3E\")}.sfi.white-14-warning{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath d='M12.001 1c-.511 0-1.003.3-1.245.816L1.144 20.882a1.535 1.535 0 0 0-.144.651C1 22.343 1.621 23 2.388 23h19.224c.213 0 .424-.052.616-.152.686-.36.967-1.24.627-1.966L13.244 1.816a1.432 1.432 0 0 0-.629-.664A1.321 1.321 0 0 0 12.001 1m0 1a.32.32 0 0 1 .151.039c.078.04.144.112.199.228l9.599 19.039c.112.239.025.546-.186.656a.33.33 0 0 1-.152.038H2.388c-.21 0-.388-.214-.388-.467 0-.079.017-.157.037-.201L11.662 2.24c.083-.177.23-.24.339-.24M12 15.996a1 1 0 0 1-1-1v-7a1 1 0 1 1 2 0v7a1 1 0 0 1-1 1m-1 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0' id='a'/%3E%3C/defs%3E%3Cg transform='translate(.2 .2)' fill='none' fill-rule='evenodd'%3E%3Cmask id='b' fill='%23fff'%3E%3Cuse xlink:href='%23a'/%3E%3C/mask%3E%3Cuse fill='%23000' xlink:href='%23a'/%3E%3Cg mask='url(%23b)' fill='%23FFF'%3E%3Cpath d='M0 0h24v24H0z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A\")}.sfi.white-14-warning-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath d='M12.001 1c-.511 0-1.003.3-1.245.816L1.144 20.882a1.535 1.535 0 0 0-.144.651C1 22.343 1.621 23 2.388 23h19.224c.213 0 .424-.052.616-.152.686-.36.967-1.24.627-1.966L13.244 1.816a1.432 1.432 0 0 0-.629-.664A1.321 1.321 0 0 0 12.001 1M12 15.996a1 1 0 0 1-1-1v-7a1 1 0 1 1 2 0v7a1 1 0 0 1-1 1m-1 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0' id='a'/%3E%3C/defs%3E%3Cg transform='translate(.2 .2)' fill='none' fill-rule='evenodd'%3E%3Cmask id='b' fill='%23fff'%3E%3Cuse xlink:href='%23a'/%3E%3C/mask%3E%3Cuse fill='%23000' xlink:href='%23a'/%3E%3Cg mask='url(%23b)' fill='%23FFF'%3E%3Cpath d='M0 0h24v24H0z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A\")}.sfi.b1-01-up{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 7.99'%3E%3Ctitle%3E01-up-b1%3C/title%3E%3Cpath d='M18,15.45a1,1,0,0,1-.73-.32L12,9.47,6.73,15.13a1,1,0,0,1-1.46-1.36l5.32-5.72a2,2,0,0,1,2.82,0l5.32,5.72A1,1,0,0,1,18,15.45Z' transform='translate(-5 -7.46)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-01-up-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E01-up-b1-alt%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3Cpath d='M13.41,8.05a2,2,0,0,0-2.82,0L5.27,13.77a1,1,0,0,0,1.46,1.36L12,9.47l5.27,5.66a1,1,0,1,0,1.46-1.36Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-01-up-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E01-up-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm6.68,14.18a1,1,0,0,1-1.41,0L12,9.47,6.73,15.13a1,1,0,0,1-1.46-1.36l5.32-5.72a2,2,0,0,1,2.82,0l5.32,5.72A1,1,0,0,1,18.68,15.18Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-02-down{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 8.02'%3E%3Ctitle%3E02-down-b1%3C/title%3E%3Cpath d='M12,16.52a1.94,1.94,0,0,1-1.41-.62L5.27,10.18A1,1,0,0,1,6.73,8.82L12,14.48l5.27-5.66a1,1,0,1,1,1.46,1.36L13.41,15.9A1.94,1.94,0,0,1,12,16.52Z' transform='translate(-5 -8.5)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-02-down-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E02-down-b1-alt%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3Cpath d='M17.27,8.82,12,14.48,6.73,8.82a1,1,0,0,0-1.46,1.36l5.32,5.72a1.91,1.91,0,0,0,2.82,0l5.32-5.72a1,1,0,1,0-1.46-1.36Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-02-down-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E02-down-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm6.73,9.18L13.41,15.9a1.91,1.91,0,0,1-2.82,0L5.27,10.18A1,1,0,0,1,6.73,8.82L12,14.48l5.27-5.66a1,1,0,1,1,1.46,1.36Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-03-left{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8.02 14'%3E%3Cpath d='M14.45,19a1,1,0,0,1-.68-.27L8.05,13.41A2,2,0,0,1,7.43,12a2,2,0,0,1,.62-1.42l5.72-5.32a1,1,0,0,1,1.36,1.47L9.47,12l5.66,5.26a1,1,0,0,1,0,1.42A1,1,0,0,1,14.45,19Z' transform='translate(-7.43 -5)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-03-left-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E03-left-b1-alt%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3Cpath d='M15.18,5.32a1,1,0,0,0-1.41-.06L8.05,10.58A2,2,0,0,0,7.43,12a2,2,0,0,0,.62,1.41l5.72,5.32a1,1,0,0,0,1.36-1.47L9.47,12l5.66-5.27A1,1,0,0,0,15.18,5.32Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-03-left-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E03-left-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm3.13,16.26a1,1,0,0,1,0,1.42,1,1,0,0,1-1.41.05L8.05,13.41A2,2,0,0,1,7.43,12a2,2,0,0,1,.62-1.42l5.72-5.32a1,1,0,0,1,1.36,1.47L9.47,12Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-04-right{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8.02 14'%3E%3Ctitle%3E04-right-b1%3C/title%3E%3Cpath d='M10,19a1,1,0,0,1-.73-.32,1,1,0,0,1,.05-1.42L15,12,9.32,6.73a1,1,0,0,1,1.36-1.47l5.72,5.32A2,2,0,0,1,17,12a2,2,0,0,1-.62,1.41l-5.72,5.32A1,1,0,0,1,10,19Z' transform='translate(-9 -5)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-04-right-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E04-right-b1-alt%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3Cpath d='M10.68,5.26A1,1,0,0,0,9.32,6.73L15,12,9.32,17.26a1,1,0,0,0-.05,1.42,1,1,0,0,0,1.41.05l5.72-5.32A2,2,0,0,0,17,12a2,2,0,0,0-.62-1.42Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-04-right-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E04-right-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm4.4,12.41-5.72,5.32a1,1,0,0,1-1.36-1.47L15,12,9.32,6.73a1,1,0,0,1,1.36-1.47l5.72,5.32A2,2,0,0,1,17,12,2,2,0,0,1,16.4,13.41Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-05-check{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 9.99'%3E%3Ctitle%3E05-check-b1%3C/title%3E%3Cpath d='M9.54,17a1.51,1.51,0,0,1-1-.42L5.3,13.48A1,1,0,0,1,6.7,12L9.54,14.8,17.3,7.28a1,1,0,1,1,1.4,1.43l-8.1,7.86A1.53,1.53,0,0,1,9.54,17Z' transform='translate(-5 -7)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-05-check-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E05-check-b1-alt%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3Cpath d='M17.3,7.28,9.54,14.8,6.7,12a1,1,0,0,0-1.4,1.44l3.19,3.09a1.51,1.51,0,0,0,1,.42,1.53,1.53,0,0,0,1.06-.42l8.1-7.86a1,1,0,1,0-1.4-1.43Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-05-check-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E05-check-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm6.7,7.71-8.1,7.86A1.53,1.53,0,0,1,9.54,17a1.51,1.51,0,0,1-1-.42L5.3,13.48A1,1,0,0,1,6.7,12L9.54,14.8,17.3,7.28a1,1,0,1,1,1.4,1.43Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-06-close{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 11'%3E%3Ctitle%3E06-close-b1%3C/title%3E%3Cpath d='M13.41,12l3.8-3.79a1,1,0,1,0-1.42-1.42L12,10.59,8.21,6.79A1,1,0,1,0,6.79,8.21L10.59,12l-3.8,3.79a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L12,13.41l3.79,3.8a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z' transform='translate(-6.5 -6.5)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-06-close-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E06-close-b1-alt%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3Cpath d='M17.21,6.79a1,1,0,0,0-1.42,0L12,10.59,8.21,6.79A1,1,0,1,0,6.79,8.21L10.59,12l-3.8,3.79a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L12,13.41l3.79,3.8a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L13.41,12l3.8-3.79A1,1,0,0,0,17.21,6.79Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-06-close-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E06-close-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm5.21,14.79a1,1,0,0,1,0,1.42,1,1,0,0,1-1.42,0L12,13.41l-3.79,3.8a1,1,0,0,1-1.42,0,1,1,0,0,1,0-1.42L10.59,12,6.79,8.21A1,1,0,1,1,8.21,6.79L12,10.59l3.79-3.8a1,1,0,1,1,1.42,1.42L13.41,12Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-07-equal{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 7'%3E%3Ctitle%3E07-equal-b1%3C/title%3E%3Cpath d='M18,10.5H6a1,1,0,0,1,0-2H18a1,1,0,0,1,0,2Z' transform='translate(-5 -8.5)' style='fill:%23002a54'/%3E%3Cpath d='M18,15.5H6a1,1,0,0,1,0-2H18a1,1,0,0,1,0,2Z' transform='translate(-5 -8.5)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-07-equal-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E07-equal-b1-alt%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3Cpath d='M18,8.5H6a1,1,0,0,0,0,2H18a1,1,0,0,0,0-2Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3Cpath d='M18,13.5H6a1,1,0,0,0,0,2H18a1,1,0,0,0,0-2Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-07-equal-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E07-equal-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm6,14.5H6a1,1,0,0,1,0-2H18a1,1,0,0,1,0,2Zm0-5H6a1,1,0,0,1,0-2H18a1,1,0,0,1,0,2Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-08-plus{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 14'%3E%3Ctitle%3E08-plus-b1%3C/title%3E%3Cpath d='M18,11H13V6a1,1,0,0,0-2,0v5H6a1,1,0,0,0,0,2h5v5a1,1,0,0,0,2,0V13h5a1,1,0,0,0,0-2Z' transform='translate(-5 -5)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-08-plus-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E09-minus-b1-alt%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3Cpath d='M18,11H6a1,1,0,0,0,0,2H18a1,1,0,0,0,0-2Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-08-plus-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E08-plus-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm6,12H13v5a1,1,0,0,1-2,0V13H6a1,1,0,0,1,0-2h5V6a1,1,0,0,1,2,0v5h5a1,1,0,0,1,0,2Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-09-minus{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 2'%3E%3Ctitle%3E09-minus-b1%3C/title%3E%3Cpath d='M18,13H6a1,1,0,0,1,0-2H18a1,1,0,0,1,0,2Z' transform='translate(-5 -11)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-09-minus-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' x='0' y='0' viewBox='0 0 24 24' xml:space='preserve'%3E%3Cstyle%3E .st0%7Bfill:%23002a54%7D %3C/style%3E%3Cpath class='st0' d='M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm0 21C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10z'/%3E%3Cpath class='st0' d='M18 11H6a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2z'/%3E%3C/svg%3E%0A\")}.sfi.b1-09-minus-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E09-minus-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm6,12H6a1,1,0,0,1,0-2H18a1,1,0,0,1,0,2Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-10-navigation{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 10'%3E%3Ctitle%3E10-navigation-b1%3C/title%3E%3Cpath d='M6,9H18a1,1,0,0,0,0-2H6A1,1,0,0,0,6,9Z' transform='translate(-5 -7)' style='fill:%23002a54'/%3E%3Cpath d='M18,11H6a1,1,0,0,0,0,2H18a1,1,0,0,0,0-2Z' transform='translate(-5 -7)' style='fill:%23002a54'/%3E%3Cpath d='M18,15H6a1,1,0,0,0,0,2H18a1,1,0,0,0,0-2Z' transform='translate(-5 -7)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-10-navigation-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E10-navigation-b1-alt%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3Cpath d='M18,7H6A1,1,0,0,0,6,9H18a1,1,0,0,0,0-2Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3Cpath d='M18,11H6a1,1,0,0,0,0,2H18a1,1,0,0,0,0-2Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3Cpath d='M18,15H6a1,1,0,0,0,0,2H18a1,1,0,0,0,0-2Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-10-navigation-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E10-navigation-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm6,16H6a1,1,0,0,1,0-2H18a1,1,0,0,1,0,2Zm0-4H6a1,1,0,0,1,0-2H18a1,1,0,0,1,0,2Zm0-4H6A1,1,0,0,1,6,7H18a1,1,0,0,1,0,2Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-11-favorite{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 14'%3E%3Ctitle%3E11-favorite-b1%3C/title%3E%3Cpath d='M12,7.33l.71,2.26L13,10.64h3.31l-1.85,1.43-.81.63.3,1L14.63,16l-1.7-1.3L12,14l-.91.69L9.4,16l.69-2.28.29-1-.82-.63L7.71,10.64h3.07l.35-1L12,7.33M12,4.5a.88.88,0,0,0-.83.58L9.72,9.14H5.88a.91.91,0,0,0-.7.34.88.88,0,0,0,.16,1.23l3.31,2.55L7.41,17.37a.87.87,0,0,0,.15.78.86.86,0,0,0,.7.35.89.89,0,0,0,.53-.18L12,15.86l3.23,2.45a.87.87,0,0,0,.53.18,1.15,1.15,0,0,0,.26,0,.88.88,0,0,0,.58-1.1l-1.24-4.11,3.28-2.54A.85.85,0,0,0,19,10a.87.87,0,0,0-.88-.88h-4l-1.27-4a.9.9,0,0,0-.55-.56.93.93,0,0,0-.29,0Z' transform='translate(-5 -4.5)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-11-favorite-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E11-favorite-b1-alt%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3Cpath d='M18.12,9.14h-4l-1.27-4a.9.9,0,0,0-.55-.56.93.93,0,0,0-.29,0,.88.88,0,0,0-.83.58L9.72,9.14H5.88a.91.91,0,0,0-.7.34.88.88,0,0,0,.16,1.23l3.31,2.55L7.41,17.37a.87.87,0,0,0,.15.78.86.86,0,0,0,.7.35.89.89,0,0,0,.53-.18L12,15.86l3.23,2.45a.87.87,0,0,0,.53.18,1.15,1.15,0,0,0,.26,0,.88.88,0,0,0,.58-1.1l-1.24-4.11,3.28-2.54A.85.85,0,0,0,19,10,.87.87,0,0,0,18.12,9.14Zm-3.66,2.93-.81.63.3,1L14.63,16l-1.7-1.3L12,14l-.91.69L9.4,16l.69-2.28.29-1-.82-.63L7.71,10.64h3.07l.35-1L12,7.33l.71,2.26L13,10.64h3.31Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-11-favorite-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E11-favorite-b1-hover%3C/title%3E%3Cpolygon points='12 9.64 11.66 8.59 10.95 6.33 10.13 8.64 9.78 9.64 8.72 9.64 6.71 9.64 8.56 11.07 9.38 11.7 9.09 12.69 8.4 14.97 10.11 13.66 11.02 12.97 11.93 13.66 13.63 14.96 12.95 12.69 12.65 11.7 13.46 11.07 15.31 9.64 13.1 9.64 12 9.64' style='fill:%23002a54'/%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm6.66,9.71-3.28,2.54,1.24,4.11a.88.88,0,0,1-.58,1.1,1.15,1.15,0,0,1-.26,0,.87.87,0,0,1-.53-.18L12,15.86,8.79,18.32a.89.89,0,0,1-.53.18.86.86,0,0,1-.7-.35.87.87,0,0,1-.15-.78l1.24-4.11L5.34,10.71a.88.88,0,0,1-.16-1.23.91.91,0,0,1,.7-.34H9.72l1.44-4.06A.88.88,0,0,1,12,4.5a.93.93,0,0,1,.29,0,.9.9,0,0,1,.55.56l1.27,4h4A.87.87,0,0,1,19,10,.85.85,0,0,1,18.66,10.71Z' transform='translate(-1 -1)' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-12-info{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E12-info-b1%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,21A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z' transform='translate(-1 -1)' style='fill:%23002a54;fill-rule:evenodd'/%3E%3Cpath d='M12,9a1,1,0,0,0-1,1v8a1,1,0,0,0,2,0V10A1,1,0,0,0,12,9Z' transform='translate(-1 -1)' style='fill:%23002a54;fill-rule:evenodd'/%3E%3Ccircle cx='11' cy='5' r='1' style='fill:%23002a54'/%3E%3C/svg%3E\")}.sfi.b1-12-info-circle{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' x='0' y='0' viewBox='0 0 24 24' xml:space='preserve'%3E%3Cstyle%3E .st0%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23002a54%7D %3C/style%3E%3Cpath class='st0' d='M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm0 21C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10z'/%3E%3Cpath class='st0' d='M12 8.996a1 1 0 0 0-1 1v8a1 1 0 1 0 2 0v-8a1 1 0 0 0-1-1z'/%3E%3Ccircle class='st0' cx='12' cy='5.997' r='1'/%3E%3C/svg%3E%0A\")}.sfi.b1-12-info-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E12-info-b1-hover%3C/title%3E%3Cpath d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm1,17a1,1,0,0,1-2,0V10a1,1,0,0,1,2,0ZM12,7a1,1,0,1,1,1-1A1,1,0,0,1,12,7Z' transform='translate(-1 -1)' style='fill:%23002a54;fill-rule:evenodd'/%3E%3C/svg%3E\")}.sfi.b1-13-help{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' x='0' y='0' viewBox='0 0 24 24' xml:space='preserve'%3E%3Cstyle%3E .st0%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23002a54%7D %3C/style%3E%3Cpath class='st0' d='M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm0 21C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10z'/%3E%3Cpath class='st0' d='M13.393 5.118c-.697-.156-1.9-.15-2.534.01A3.108 3.108 0 0 0 8.995 6.22a7.317 7.317 0 0 0-.118.167c-.153.212-.223.398-.223.588 0 .553.45 1.003 1.004 1.003.317 0 .495-.087.68-.33.052-.07.336-.428.891-.56.259-.06.535-.09.824-.09.344 0 .67.042.944.083.61.093 1.036.592 1.036 1.214 0 .457-.223.74-.417.935l-1.337 1.275a3.973 3.973 0 0 0-1.267 2.92v.571c0 .554.45 1.005 1.003 1.005s1.002-.451 1.002-1.005v-.572c0-.36.05-.891.49-1.347l1.661-1.547a3.24 3.24 0 0 0 .871-2.235c0-1.597-1.113-2.933-2.646-3.176z'/%3E%3Ccircle class='st0' cx='12' cy='18.002' r='1'/%3E%3C/svg%3E%0A\")}.sfi.b1-13-help-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm0 18.002a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm3.168-8.473l-1.66 1.547c-.44.456-.49.987-.49 1.347v.572c0 .554-.45 1.005-1.003 1.005s-1.003-.451-1.003-1.005v-.572c0-1.113.45-2.15 1.267-2.919l1.337-1.275c.194-.195.417-.478.417-.935 0-.622-.426-1.12-1.036-1.214a6.37 6.37 0 0 0-.944-.082c-.289 0-.565.029-.823.088-.556.133-.84.49-.891.56-.186.244-.364.331-.681.331-.553 0-1.004-.45-1.004-1.003 0-.19.07-.376.223-.588.017-.024.097-.14.118-.167a3.108 3.108 0 0 1 1.864-1.09c.633-.162 1.837-.167 2.534-.011 1.533.243 2.646 1.579 2.646 3.176a3.24 3.24 0 0 1-.871 2.235z' fill='%23002a54'/%3E%3C/svg%3E%0A\")}.sfi.b1-14-warning{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' x='0' y='0' viewBox='0 0 24 24' xml:space='preserve'%3E%3Cstyle%3E .st1%7Bfill:%23002a54%7D %3C/style%3E%3Ccircle cx='12' cy='18.997' r='1' fill-rule='evenodd' clip-rule='evenodd' fill='%23002a54'/%3E%3Cpath class='st1' d='M12 6.996a1 1 0 0 0-1 1v7a1 1 0 1 0 2 0v-7a1 1 0 0 0-1-1z'/%3E%3Cpath class='st1' d='M22.856 20.882L13.244 1.817a1.43 1.43 0 0 0-.629-.664A1.321 1.321 0 0 0 12.001 1c-.511 0-1.003.3-1.245.817L1.144 20.882a1.536 1.536 0 0 0-.144.65C1 22.344 1.621 23 2.388 23h19.224c.213 0 .424-.052.615-.152.687-.36.969-1.24.629-1.966zm-1.092 1.08a.325.325 0 0 1-.152.038H2.388c-.21 0-.388-.214-.388-.467 0-.08.017-.158.037-.2L11.662 2.24c.083-.178.23-.241.339-.241.051 0 .102.013.15.039.08.04.145.112.2.228l9.599 19.04c.112.238.025.544-.186.655z'/%3E%3C/svg%3E%0A\")}.sfi.b1-14-warning-hover{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M22.856 20.882L13.244 1.817a1.43 1.43 0 0 0-.629-.664A1.321 1.321 0 0 0 12.001 1c-.511 0-1.003.3-1.245.817L1.144 20.882a1.536 1.536 0 0 0-.144.65C1 22.344 1.621 23 2.388 23h19.224c.213 0 .424-.052.615-.152.687-.36.969-1.24.629-1.966zM12 19.997a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm1-5a1 1 0 1 1-2 0v-7a1 1 0 1 1 2 0v7z' fill='%23002a54'/%3E%3C/svg%3E%0A\")}.sfi.b2-01-up{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 7.99'%3E%3Ctitle%3E01-up-white%3C/title%3E%3Cpath d='M26,24a1,1,0,0,1-.73-.32L20,18l-5.27,5.67a1,1,0,1,1-1.46-1.37l5.32-5.71a2,2,0,0,1,2.82,0l5.32,5.71A1,1,0,0,1,26,24' transform='translate(-13 -16)' style='fill:%23056DAE;fill-rule:evenodd'/%3E%3C/svg%3E\")}.sfi.b2-02-down{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 8.02'%3E%3Ctitle%3E02-down-white%3C/title%3E%3Cpath d='M20,24a1.94,1.94,0,0,1-1.41-.62l-5.32-5.72a1,1,0,0,1,1.46-1.36L20,22l5.27-5.66a1,1,0,0,1,1.46,1.36l-5.32,5.72A1.94,1.94,0,0,1,20,24' transform='translate(-13 -15.99)' style='fill:%23056DAE;fill-rule:evenodd'/%3E%3C/svg%3E\")}.sfi.b2-03-left{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8.02 14'%3E%3Ctitle%3E03-left-white%3C/title%3E%3Cpath d='M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27' transform='translate(-15.99 -13)' style='fill:%23056DAE;fill-rule:evenodd'/%3E%3C/svg%3E\")}.sfi.b2-04-right{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8.02 14'%3E%3Ctitle%3E04-right-white%3C/title%3E%3Cpath d='M17,27a1,1,0,0,1-.68-1.73L22,20l-5.66-5.27a1,1,0,0,1,1.36-1.46l5.72,5.32a1.91,1.91,0,0,1,0,2.82l-5.72,5.32A1,1,0,0,1,17,27' transform='translate(-15.99 -13)' style='fill:%23056DAE;fill-rule:evenodd'/%3E%3C/svg%3E\")}.sfi.g1-06-close{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 11'%3E%3Ctitle%3E06-close-white%3C/title%3E%3Cpath d='M21.41,20l3.8-3.79a1,1,0,0,0-1.42-1.42L20,18.59l-3.79-3.8a1,1,0,0,0-1.42,1.42L18.59,20l-3.8,3.79a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L20,21.41l3.79,3.8a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z' transform='translate(-14.5 -14.5)' style='fill:%23666;fill-rule:evenodd'/%3E%3C/svg%3E\")}.sfi.g1-06-close:hover,.sfi.g1-06-close:focus{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E06-close-white-hover%3C/title%3E%3Cpath d='M21.41,20.15l3.8-3.79a1,1,0,0,0,0-1.41,1,1,0,0,0-1.42,0L20,18.74,16.21,15a1,1,0,0,0-1.42,0,1,1,0,0,0,0,1.41l3.8,3.79L14.79,24a1,1,0,0,0,0,1.41,1,1,0,0,0,1.42,0L20,21.57l3.79,3.79a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.41ZM20,9A11,11,0,1,0,31,20,11,11,0,0,0,20,9' transform='translate(-9 -9)' style='fill:%23666;fill-rule:evenodd'/%3E%3C/svg%3E\")}.sfi.g1-02-down{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 8.02'%3E%3Ctitle%3E02-down-white%3C/title%3E%3Cpath d='M20,24a1.94,1.94,0,0,1-1.41-.62l-5.32-5.72a1,1,0,0,1,1.46-1.36L20,22l5.27-5.66a1,1,0,0,1,1.46,1.36l-5.32,5.72A1.94,1.94,0,0,1,20,24' transform='translate(-13 -15.99)' style='fill:%23666;fill-rule:evenodd'/%3E%3C/svg%3E\")}\n"] }]
        }], ctorParameters: () => [{ type: Icon2RegistryService }, { type: i0.ChangeDetectorRef }], propDecorators: { role: [{
                type: Input$1
            }], idStr: [{
                type: Input$1
            }], ariaLabel: [{
                type: Input$1
            }], ariaHidden: [{
                type: Input$1
            }], size: [{
                type: Input$1
            }], isHoverSfi: [{
                type: Input$1
            }], includeCircle: [{
                type: Input$1
            }], type: [{
                type: Input$1
            }], svgStyle: [{
                type: Input$1
            }], tabIndex: [{
                type: Input$1
            }], shade: [{
                type: Input$1
            }], name: [{
                type: Input$1
            }], svgDivElementRef: [{
                type: ViewChild,
                args: ['svgContainer']
            }] } });

class Icon2WrapperComponent {
    constructor() {
        this.flexDirection = 'row';
        this.flexWrap = 'wrap';
        this.padding = '0px';
        this.alignment = 'center';
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Icon2WrapperComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: Icon2WrapperComponent, isStandalone: false, selector: "citi-icon2-wrapper, [citi-icon2-wrapper]", inputs: { flexDirection: "flexDirection", flexWrap: "flexWrap", padding: "padding", alignment: "alignment" }, host: { classAttribute: "citi-icon2-wrapper" }, ngImport: i0, template: `
      <div class="flex-wrapper wrapper-text"
        [ngStyle]="{
          'flex-direction': flexDirection,
          'padding': padding,
          'align-items': alignment,
          'flex-wrap': flexWrap
        }">
          <ng-content></ng-content>
      </div>
    `, isInline: true, styles: [".flex-wrapper{display:inline-flex;position:relative}.wrapper-text{font-size:16px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Icon2WrapperComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-icon2-wrapper, [citi-icon2-wrapper]', standalone: false, host: { class: 'citi-icon2-wrapper' }, template: `
      <div class="flex-wrapper wrapper-text"
        [ngStyle]="{
          'flex-direction': flexDirection,
          'padding': padding,
          'align-items': alignment,
          'flex-wrap': flexWrap
        }">
          <ng-content></ng-content>
      </div>
    `, styles: [".flex-wrapper{display:inline-flex;position:relative}.wrapper-text{font-size:16px}\n"] }]
        }], propDecorators: { flexDirection: [{
                type: Input$1
            }], flexWrap: [{
                type: Input$1
            }], padding: [{
                type: Input$1
            }], alignment: [{
                type: Input$1
            }] } });

const COMPONENTS$19 = [
    Icon2Component,
    Icon2WrapperComponent
];
const MODULES$1e = [
    CommonModule,
];
class Icons2 {
    static forRoot() {
        return {
            ngModule: Icons2,
            providers: [ICON2_REGISTRY_PROVIDER, provideHttpClient(withInterceptorsFromDi())]
        };
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Icons2, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: Icons2, declarations: [Icon2Component,
            Icon2WrapperComponent], imports: [CommonModule], exports: [Icon2Component,
            Icon2WrapperComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Icons2, providers: [provideHttpClient(withInterceptorsFromDi())], imports: [MODULES$1e] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Icons2, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$1e],
                    declarations: [...COMPONENTS$19],
                    exports: [...COMPONENTS$19],
                    providers: [provideHttpClient(withInterceptorsFromDi())]
                }]
        }] });

const LIVE_ANNOUNCER_ELEMENT_TOKEN = new InjectionToken('liveAnnouncerElement');
class CitiLiveAnnouncer {
    constructor(elementToken, _document) {
        this._document = _document;
        this.multiAnnounceMessage = '';
        // We inject the live element as `any` because the constructor signature cannot reference
        // browser globals (HTMLElement) on non-browser environments, since having a class decorator
        // causes TypeScript to preserve the constructor signature types.
        this._liveElement = elementToken || this._createLiveElement();
    }
    /**
     * Announces a message to screenreaders.
     * @param message Message to be announced to the screenreader
     * @param politeness The politeness of the announcer element
     * @returns Promise that will be resolved when the message is added to the DOM.
     */
    announce(message, politeness = 'polite', preventClear = false) {
        if (!message)
            return Promise.resolve();
        this._liveElement.textContent = '';
        this._liveElement.setAttribute('aria-live', politeness);
        // This 100ms timeout is necessary for some browser + screen-reader combinations:
        // - Both JAWS and NVDA over IE11 will not announce anything without a non-zero timeout.
        // - With Chrome and IE11 with NVDA or JAWS, a repeated (identical) message won't be read a
        //   second time without clearing and then using a non-zero delay.
        // (using JAWS 17 at time of this writing).
        return new Promise(resolve => {
            setTimeout(() => {
                this._liveElement.textContent = this.cleanHTML(message);
                resolve();
                if (!preventClear)
                    setTimeout(() => this.clear(), 10000);
            }, 100);
        });
    }
    // this is a less comprehensive solution, but may allow for multipilt
    multiAnnounce(msg) {
        if (!msg)
            return;
        this.multiAnnounceMessage += ` ${this.cleanHTML(msg)}`;
        this._liveElement.textContent = this.multiAnnounceMessage;
        setTimeout(() => this.multiAnnounceMessage = '', 0);
    }
    cleanHTML(message) {
        return message
            .replace(/<(?:.|\n)*?>/gm, '')
            .replace(/&amp;/g, '&')
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>');
    }
    /**
     * Clears the current text from the announcer element. Can be used to prevent
     * screen readers from reading the text out again while the user is going
     * through the page landmarks.
     */
    clear() {
        if (this._liveElement) {
            this._liveElement.textContent = '';
        }
    }
    ngOnDestroy() {
        if (this._liveElement && this._liveElement.parentNode) {
            this._liveElement.parentNode.removeChild(this._liveElement);
        }
    }
    _createLiveElement() {
        const liveEl = this._document.createElement('div');
        liveEl.classList.add('sr-only', 'ddl-live-announcer-element');
        liveEl.setAttribute('aria-atomic', 'true');
        liveEl.setAttribute('aria-live', 'polite');
        this._document.body.appendChild(liveEl);
        return liveEl;
    }
    changePageTitleAndSetFocus(title, refocusBody = true, announce = false) {
        // Set the new title if there is one
        if (typeof title === 'string' && title.length) {
            const titleTag = document.getElementsByTagName('title')[0];
            titleTag.innerHTML = title;
            if (announce)
                this.announce(title);
        }
        // Add tabindex and aria-live to body tag, and then set focus on the body tag\
        if (refocusBody) {
            const bodyTag = document.getElementsByTagName('body')[0];
            bodyTag.tabIndex = -1;
            bodyTag.setAttribute('aria-live', 'assertive');
            bodyTag.focus();
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CitiLiveAnnouncer, deps: [{ token: LIVE_ANNOUNCER_ELEMENT_TOKEN, optional: true }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CitiLiveAnnouncer, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CitiLiveAnnouncer, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [LIVE_ANNOUNCER_ELEMENT_TOKEN]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }] });
/** @docs-private */
function LIVE_ANNOUNCER_PROVIDER_FACTORY(parentDispatcher, liveElement, _document) {
    return parentDispatcher || new CitiLiveAnnouncer(liveElement, _document);
}
/** @docs-private */
const LIVE_ANNOUNCER_PROVIDER = {
    // If there is already a LiveAnnouncer available, use that. Otherwise, provide a new one.
    provide: CitiLiveAnnouncer,
    deps: [
        [new Optional(), new SkipSelf(), CitiLiveAnnouncer],
        [new Optional(), new Inject(LIVE_ANNOUNCER_ELEMENT_TOKEN)],
        DOCUMENT,
    ],
    useFactory: LIVE_ANNOUNCER_PROVIDER_FACTORY
};

function getFocableAbleElements(root) {
    return root.querySelectorAll(`
    a[href]:not([tabindex='-1']),
    area[href]:not([tabindex='-1']),
    input:not([disabled]):not([tabindex='-1']),
    select:not([disabled]):not([tabindex='-1']),
    textarea:not([disabled]):not([tabindex='-1']),
    button:not([disabled]):not([tabindex='-1']),
    iframe:not([tabindex='-1']),
    [tabindex]:not([tabindex='-1']),
    [contentEditable=true]:not([tabindex='-1']
  `);
}

const BANNER_ALERT_ICON2_MEDIUM_STYLES = {
    'width.px': '30',
    'height.px': '30',
    'margin-right.px': '2'
};
const BANNER_ALERT_ICON2_SMALL_STYLES = {
    'width.px': '20',
    'height.px': '20',
    'margin.px': '6'
};
/**
 * @Component: Banner Alert
 * @Section: uicomponent
 * @description This is the Banner Alert component and is used to display different types of Banner Alert
 * from Bootstrap.
 */
class BannerAlertComponent {
    constructor(elRef, announcer) {
        this.elRef = elRef;
        this.announcer = announcer;
        this.open = true;
        /**
         * @property bannerType
         * @description This property helps to define the type of alert to be displayed
         * @return string (page | module) default page
         */
        this.bannerType = 'page';
        /**
         * @property hasCloseButton
         * @description This property helps to show/hide the close icon.
         * @return string
         */
        this.hasCloseButton = true;
        this.bold = true;
        /**
         * @Event: closeButtonClick
         * @description Emitted when close icon is clicked
         * @return Object
         */
        this.closeButtonClick = new EventEmitter();
    }
    generateCssClassString() {
        switch (this.alertType) {
            case 'success':
                this.alertTypeClass = 'ct-banner-green-alert';
                break;
            case 'critical':
                this.alertTypeClass = 'ct-banner-red-alert';
                break;
            case 'marketing':
                this.alertTypeClass = 'ct-banner-blue-alert';
                break;
            case 'technical':
                this.alertTypeClass = 'ct-banner-gray-alert';
                break;
            default:
                this.alertTypeClass = 'ct-banner-gray-alert';
        }
    }
    ngOnInit() {
        this.generateCssClassString();
    }
    /** close alert on click X icon **/
    closeAlert() {
        setTimeout(() => {
            this.announcer.announce(this.alertType + ' banner is closed');
            setTimeout(() => {
                this.open = false;
                // Emit the change to the close
                this.closeButtonClick.emit();
                const focusableElements = Array.from(getFocableAbleElements(document));
                if (focusableElements)
                    focusableElements.forEach((el, index) => {
                        if (el == this.close.nativeElement)
                            focusableElements[index + 1].focus();
                    });
            }, 200);
        }, 300);
    }
    button2GetAriaLabel() {
        return `${this.alertType} Alert Close`;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: BannerAlertComponent, deps: [{ token: i0.ElementRef }, { token: CitiLiveAnnouncer }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: BannerAlertComponent, isStandalone: false, selector: "citi-banner-alert", inputs: { alertType: "alertType", bannerType: "bannerType", idStr: "idStr", hasCloseButton: "hasCloseButton", alertMessage: "alertMessage", bold: "bold" }, outputs: { closeButtonClick: "closeButtonClick" }, viewQueries: [{ propertyName: "wrapper", first: true, predicate: ["alertWrapper"], descendants: true }, { propertyName: "close", first: true, predicate: ["close"], descendants: true }], ngImport: i0, template: `
    <div
      #alertWrapper
      class="ct-cbolui-page-banner {{ open ? 'alertOpen' : 'alertClose' }}"
      *ngIf="bannerType == 'page'"
    >
      <div
        class="ct-banner-alert-box"
        [ngClass]="alertTypeClass"
        [attr.id]="idStr"
      >
        <div class="row">
          <div class="col-xs-10">
            <strong class="ct-banner_alert_font">
              <ng-content select="[alertContent]"></ng-content>
            </strong>
          </div>
          <div class="col-xs-2">
            <button
              #close
              *ngIf="hasCloseButton"
              type="button"
              class="close"
              [attr.aria-label]="button2GetAriaLabel()"
              (click)="closeAlert()"
            ></button>
          </div>
        </div>
      </div>
    </div>
    <div
      #alertWrapper
      class="ct-cbolui-module-banner {{ open ? 'alertOpen' : 'alertClose' }}"
      *ngIf="bannerType == 'module'"
    >
      <div
        class="ct-module-alert-box"
        [ngClass]="alertTypeClass"
        [attr.id]="idStr"
      >
        <div class="row">
          <div class="col-xs-10">
            <strong class="ct-banner_alert_font">
              <ng-content select="[alertmoduleContent]"></ng-content>
            </strong>
          </div>
          <div class="col-xs-2">
            <button
              #close
              *ngIf="hasCloseButton"
              type="button"
              class="close"
              [attr.aria-label]="button2GetAriaLabel()"
              (click)="closeAlert()"
            ></button>
          </div>
        </div>
      </div>
    </div>
  `, isInline: true, styles: [".alertOpen{display:block}.alertClose{display:none}.ct-banner_alert_font{font-family:sans-serif}.ct-cbolui-page-banner ::ng-deep .cbolui-icon-text,.ct-cbolui-module-banner ::ng-deep .cbolui-icon-text{width:calc(100% - 30px)}.ct-cbolui-page-banner .ct-banner-alert-box{padding:20px 20px 20px 30px;margin:20px 0}.ct-cbolui-module-banner .ct-module-alert-box{padding:10px 20px 10px 30px;margin:20px 0}.ct-banner-red-alert{border-left:4px solid #d60000}.ct-banner-blue-alert{border-left:4px solid #056dae}.ct-banner-green-alert{border-left:4px solid #006e0a}.ct-banner-gray-alert{border-left:4px solid #666666}::ng-deep .theme-light .ct-cbolui-page-banner .ct-banner-alert-box{background-color:#eee}::ng-deep .theme-gray .ct-cbolui-page-banner .ct-banner-alert-box{background-color:#fff}.ct-cbolui-page-banner .ct-banner-alert-box ::ng-deep .message-text{padding-right:40px}.ct-banner-alert-box ::ng-deep .cbolui-icon-wrapper,.ct-module-alert-box ::ng-deep .cbolui-icon-wrapper{display:flex;padding:0;margin-bottom:0;border:1px solid transparent;border-radius:0}::ng-deep .theme-gray .ct-module-alert-box{border-right:1px solid #fff;border-top:1px solid #fff;border-bottom:1px solid #fff}::ng-deep .theme-light .ct-module-alert-box{border-right:1px solid #eee;border-top:1px solid #eee;border-bottom:1px solid #eee}.close.close{height:12px;width:12px;margin-top:5px;margin-right:4px;float:right;background-position-x:0px;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 11'%3E%3Ctitle%3E06-close-white%3C/title%3E%3Cpath d='M21.41,20l3.8-3.79a1,1,0,0,0-1.42-1.42L20,18.59l-3.79-3.8a1,1,0,0,0-1.42,1.42L18.59,20l-3.8,3.79a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L20,21.41l3.79,3.8a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z' transform='translate(-14.5 -14.5)' style='fill:%23666;fill-rule:evenodd'/%3E%3C/svg%3E\")}.close.close:hover,.close.close:focus{margin-top:0;margin-right:0;height:20px;width:20px;background-position:unset;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E06-close-white-hover%3C/title%3E%3Cpath d='M21.41,20.15l3.8-3.79a1,1,0,0,0,0-1.41,1,1,0,0,0-1.42,0L20,18.74,16.21,15a1,1,0,0,0-1.42,0,1,1,0,0,0,0,1.41l3.8,3.79L14.79,24a1,1,0,0,0,0,1.41,1,1,0,0,0,1.42,0L20,21.57l3.79,3.79a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.41ZM20,9A11,11,0,1,0,31,20,11,11,0,0,0,20,9' transform='translate(-9 -9)' style='fill:%23666;fill-rule:evenodd'/%3E%3C/svg%3E\")}:host ::ng-deep citi-icon2.success path{fill:#015a09}:host ::ng-deep citi-icon2.critical g{fill:#b50404;width:34px;height:34px}:host ::ng-deep citi-icon2.marketing path{fill:#004e7f}:host ::ng-deep citi-icon2.technical g{fill:#2a2a2a;width:34px;height:34px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: BannerAlertComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-banner-alert', standalone: false, template: `
    <div
      #alertWrapper
      class="ct-cbolui-page-banner {{ open ? 'alertOpen' : 'alertClose' }}"
      *ngIf="bannerType == 'page'"
    >
      <div
        class="ct-banner-alert-box"
        [ngClass]="alertTypeClass"
        [attr.id]="idStr"
      >
        <div class="row">
          <div class="col-xs-10">
            <strong class="ct-banner_alert_font">
              <ng-content select="[alertContent]"></ng-content>
            </strong>
          </div>
          <div class="col-xs-2">
            <button
              #close
              *ngIf="hasCloseButton"
              type="button"
              class="close"
              [attr.aria-label]="button2GetAriaLabel()"
              (click)="closeAlert()"
            ></button>
          </div>
        </div>
      </div>
    </div>
    <div
      #alertWrapper
      class="ct-cbolui-module-banner {{ open ? 'alertOpen' : 'alertClose' }}"
      *ngIf="bannerType == 'module'"
    >
      <div
        class="ct-module-alert-box"
        [ngClass]="alertTypeClass"
        [attr.id]="idStr"
      >
        <div class="row">
          <div class="col-xs-10">
            <strong class="ct-banner_alert_font">
              <ng-content select="[alertmoduleContent]"></ng-content>
            </strong>
          </div>
          <div class="col-xs-2">
            <button
              #close
              *ngIf="hasCloseButton"
              type="button"
              class="close"
              [attr.aria-label]="button2GetAriaLabel()"
              (click)="closeAlert()"
            ></button>
          </div>
        </div>
      </div>
    </div>
  `, styles: [".alertOpen{display:block}.alertClose{display:none}.ct-banner_alert_font{font-family:sans-serif}.ct-cbolui-page-banner ::ng-deep .cbolui-icon-text,.ct-cbolui-module-banner ::ng-deep .cbolui-icon-text{width:calc(100% - 30px)}.ct-cbolui-page-banner .ct-banner-alert-box{padding:20px 20px 20px 30px;margin:20px 0}.ct-cbolui-module-banner .ct-module-alert-box{padding:10px 20px 10px 30px;margin:20px 0}.ct-banner-red-alert{border-left:4px solid #d60000}.ct-banner-blue-alert{border-left:4px solid #056dae}.ct-banner-green-alert{border-left:4px solid #006e0a}.ct-banner-gray-alert{border-left:4px solid #666666}::ng-deep .theme-light .ct-cbolui-page-banner .ct-banner-alert-box{background-color:#eee}::ng-deep .theme-gray .ct-cbolui-page-banner .ct-banner-alert-box{background-color:#fff}.ct-cbolui-page-banner .ct-banner-alert-box ::ng-deep .message-text{padding-right:40px}.ct-banner-alert-box ::ng-deep .cbolui-icon-wrapper,.ct-module-alert-box ::ng-deep .cbolui-icon-wrapper{display:flex;padding:0;margin-bottom:0;border:1px solid transparent;border-radius:0}::ng-deep .theme-gray .ct-module-alert-box{border-right:1px solid #fff;border-top:1px solid #fff;border-bottom:1px solid #fff}::ng-deep .theme-light .ct-module-alert-box{border-right:1px solid #eee;border-top:1px solid #eee;border-bottom:1px solid #eee}.close.close{height:12px;width:12px;margin-top:5px;margin-right:4px;float:right;background-position-x:0px;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 11'%3E%3Ctitle%3E06-close-white%3C/title%3E%3Cpath d='M21.41,20l3.8-3.79a1,1,0,0,0-1.42-1.42L20,18.59l-3.79-3.8a1,1,0,0,0-1.42,1.42L18.59,20l-3.8,3.79a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L20,21.41l3.79,3.8a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z' transform='translate(-14.5 -14.5)' style='fill:%23666;fill-rule:evenodd'/%3E%3C/svg%3E\")}.close.close:hover,.close.close:focus{margin-top:0;margin-right:0;height:20px;width:20px;background-position:unset;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E06-close-white-hover%3C/title%3E%3Cpath d='M21.41,20.15l3.8-3.79a1,1,0,0,0,0-1.41,1,1,0,0,0-1.42,0L20,18.74,16.21,15a1,1,0,0,0-1.42,0,1,1,0,0,0,0,1.41l3.8,3.79L14.79,24a1,1,0,0,0,0,1.41,1,1,0,0,0,1.42,0L20,21.57l3.79,3.79a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.41ZM20,9A11,11,0,1,0,31,20,11,11,0,0,0,20,9' transform='translate(-9 -9)' style='fill:%23666;fill-rule:evenodd'/%3E%3C/svg%3E\")}:host ::ng-deep citi-icon2.success path{fill:#015a09}:host ::ng-deep citi-icon2.critical g{fill:#b50404;width:34px;height:34px}:host ::ng-deep citi-icon2.marketing path{fill:#004e7f}:host ::ng-deep citi-icon2.technical g{fill:#2a2a2a;width:34px;height:34px}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: CitiLiveAnnouncer }], propDecorators: { wrapper: [{
                type: ViewChild,
                args: ['alertWrapper']
            }], close: [{
                type: ViewChild,
                args: ['close']
            }], alertType: [{
                type: Input$1
            }], bannerType: [{
                type: Input$1
            }], idStr: [{
                type: Input$1
            }], hasCloseButton: [{
                type: Input$1
            }], alertMessage: [{
                type: Input$1
            }], bold: [{
                type: Input$1
            }], closeButtonClick: [{
                type: Output
            }] } });

const MODULES$1d = [
    CommonModule,
    RouterModule,
    Icons2
];
class BannerAlert {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: BannerAlert, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: BannerAlert, declarations: [BannerAlertComponent], imports: [CommonModule,
            RouterModule,
            Icons2], exports: [BannerAlertComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: BannerAlert, imports: [MODULES$1d] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: BannerAlert, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$1d],
                    declarations: [BannerAlertComponent],
                    exports: [BannerAlertComponent]
                }]
        }] });

class ContentHtmlDirective {
    constructor(_el) {
        this._el = _el;
    }
    ngOnInit() {
        if (this.html) {
            this._el.nativeElement.innerHTML = this.html;
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ContentHtmlDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.5", type: ContentHtmlDirective, isStandalone: false, selector: "[contentHtml]", inputs: { html: ["contentHtml", "html"] }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ContentHtmlDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[contentHtml]',
                    standalone: false
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { html: [{
                type: Input$1,
                args: ['contentHtml']
            }] } });

/**
 * @Component: Row
 * @Section: GridLayouts
 * @description This is the column component and is used to leverage the grid
 * from Bootstrap.
*/
class RowComponent {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: RowComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: RowComponent, isStandalone: false, selector: "citi-row, [citi-row]", inputs: { classes: "classes", htmlContent: "htmlContent" }, ngImport: i0, template: `
    <div class="row {{classes}}" [contentHtml]="htmlContent">
        <ng-content></ng-content>
    </div>`, isInline: true, dependencies: [{ kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: RowComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'citi-row, [citi-row]',
                    standalone: false,
                    template: `
    <div class="row {{classes}}" [contentHtml]="htmlContent">
        <ng-content></ng-content>
    </div>`
                }]
        }], propDecorators: { classes: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }] } });

/**
 * @Component: Column
 * @Section: GridLayouts
 * @description This is the column component and is used to leverage the grid
 * from Bootstrap.
*/
class ColumnComponent {
    constructor() {
        this.columnClasses = [];
    }
    /**
     * @property xs
     * @description This defines the grid behavior for the xs grid resolution
     * @return number (1-12)
    */
    set xs(xs) {
        this.resetSizeInput('col-xs-', xs);
    }
    /**
     * @property sm
     * @description This defines the grid behavior for the sm grid resolution
     * @return number (1-12)
    */
    set sm(sm) {
        this.resetSizeInput('col-sm-', sm);
    }
    /**
     * @property md
     * @description This defines the grid behavior for the md grid resolution
     * @return number (1-12)
    */
    set md(md) {
        this.resetSizeInput('col-md-', md);
    }
    /**
     * @property lg
     * @description This defines the grid behavior for the lg grid resolution
     * @return number (1-12)
    */
    set lg(lg) {
        this.resetSizeInput('col-lg-', lg);
    }
    /**
     * @property pullRight
     * @description This will force the column to float right
     * @Type: boolean
    */
    set pullRight(pullRight) {
        pullRight ? this.resetClass('pull-right', 'pull-right') : this.resetClass('pull-right', '');
    }
    /**
     * @property pullLeft
     * @description This will force the column to float left
     * @Type: boolean
    */
    set pullLeft(pullLeft) {
        pullLeft ? this.resetClass('pull-left', 'pull-left') : this.resetClass('pull-left', '');
    }
    /**
     * @property offXs
     * @description This defines the offset behavior for the xs grid resolution
     * @return number (1-12)
    */
    set offXs(offXs) {
        this.resetSizeInput('col-xs-offset-', offXs);
    }
    /**
     * @property offSm
     * @description This defines the offset behavior for the sm grid resolution
     * @return number (1-12)
    */
    set offSm(offSm) {
        this.resetSizeInput('col-sm-offset-', offSm);
    }
    /**
     * @property offMd
     * @description This defines the offset behavior for the md grid resolution
     * @return number (1-12)
    */
    set offMd(offMd) {
        this.resetSizeInput('col-md-offset-', offMd);
    }
    /**
     * @property offLg
     * @description This defines the offset behavior for the lg grid resolution
     * @return number (1-12)
    */
    set offLg(offLg) {
        this.resetSizeInput('col-lg-offset-', offLg);
    }
    ngOnInit() {
        if (this.classes) {
            this.columnClasses.push(this.classes);
        }
    }
    resetSizeInput(sizeSearch, newSize) {
        this.resetClass(sizeSearch, newSize ? sizeSearch + newSize : '');
    }
    resetClass(searchStr, newClass) {
        for (let i = this.columnClasses.length - 1; i >= 0; i--) {
            if (this.columnClasses[i].indexOf(searchStr) !== -1) {
                // Keeps offset class from being removed when not intended.
                if (!(searchStr.indexOf('offset') === -1 && this.columnClasses[i].indexOf('offset') !== -1)) {
                    this.columnClasses.splice(i, 1);
                }
            }
        }
        this.columnClasses.push(newClass);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ColumnComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: ColumnComponent, isStandalone: false, selector: "citi-column, [citi-column]", inputs: { xs: "xs", sm: "sm", md: "md", lg: "lg", pullRight: "pullRight", pullLeft: "pullLeft", offXs: "offXs", offSm: "offSm", offMd: "offMd", offLg: "offLg", classes: "classes", htmlContent: "htmlContent" }, ngImport: i0, template: `
    <div [ngClass]="columnClasses" [contentHtml]="htmlContent">
        <ng-content></ng-content>
    </div>`, isInline: true, dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ColumnComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'citi-column, [citi-column]',
                    standalone: false,
                    template: `
    <div [ngClass]="columnClasses" [contentHtml]="htmlContent">
        <ng-content></ng-content>
    </div>`
                }]
        }], propDecorators: { xs: [{
                type: Input$1
            }], sm: [{
                type: Input$1
            }], md: [{
                type: Input$1
            }], lg: [{
                type: Input$1
            }], pullRight: [{
                type: Input$1
            }], pullLeft: [{
                type: Input$1
            }], offXs: [{
                type: Input$1
            }], offSm: [{
                type: Input$1
            }], offMd: [{
                type: Input$1
            }], offLg: [{
                type: Input$1
            }], classes: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }] } });

const SectionColorErrorMessage = 'CITI-SECTION: A valid color string was not provided to the sectionColor input.';
const ContentColorErrorMessage = 'CITI-SECTION: A valid color string was not provided to the contentColor input.';
const white = '#FFFFFF';
const black = '#333333';
const colorRegex = /^#([\dA-Fa-f]{6}|[\dA-Fa-f]{3})/;
;
;
function isValidString(string) {
    // Return if the type of the value provided is a string and its length is greater than 0 (has at least 1 character)
    return typeof string === 'string' && string.length > 0;
}
function isValidColor(color) {
    return isValidString(color) && color.match(colorRegex) !== null;
}
function getColorFromString(color, colors) {
    // If the string is a hex value return the string as the proper color
    if (color.match(colorRegex))
        return color;
    // If the string is a color name return the hex value of the named color from the colors object
    if (Object.keys(colors).map((key, value) => key).indexOf(color) !== -1)
        return colors[color];
    // Return undefined (fail) if neither of the above are true
    return undefined;
}
/**
 * @Component: Section
 * @Section: GridLayouts
 * @description This is the section component and is used to leverage the full-page theme
*/
class SectionComponent {
    constructor() {
        // List of colors by name that include a background color and font color
        this.colors = {
            'CitiBlue': { backgroundColor: '#056DAE', fontColor: white },
            'DarkBlue': { backgroundColor: '#002A54', fontColor: white },
            'NearBlack': { backgroundColor: '#333333', fontColor: white },
            'LightGray': { backgroundColor: '#EEEEEE', fontColor: black },
            'White': { backgroundColor: '#FFFFFF', fontColor: black },
            'DarkGray': { backgroundColor: '#666666', fontColor: white },
            'Seafoam': { backgroundColor: '#00B0B9', fontColor: black },
            'Teal': { backgroundColor: '#007377', fontColor: white },
            'Navy': { backgroundColor: '#002D72', fontColor: white },
            'Magenta': { backgroundColor: '#C6007E', fontColor: white },
            'DarkMagenta': { backgroundColor: '#890C58', fontColor: white },
            'BrightBlue': { backgroundColor: '#00BDF2', fontColor: black },
            'Citigold1': { backgroundColor: '#B5995C', fontColor: black },
            'Citigold2': { backgroundColor: '#8E6F32', fontColor: white },
            'Citigold3': { backgroundColor: '#745B2D', fontColor: white },
            'CitiPriority1': { backgroundColor: '#0E2A48', fontColor: white },
            'CitiPriority2': { backgroundColor: '#091022', fontColor: white },
            'Green': { backgroundColor: '#006E0A', fontColor: white },
            'Red': { backgroundColor: '#D60000', fontColor: white }
        };
    }
    // #endregion
    // #region -------------- Methods ------------- //
    setColorOrError(color, backgroundProperty, fontProperty, error) {
        // If we got all three values
        if (isValidString(color) && isValidString(backgroundProperty) && isValidString(fontProperty) && isValidString(error)) {
            // Get the color hex value using the string provided
            const colors = getColorFromString(color, this.colors);
            // If we got a valid color object
            if (typeof colors === 'object' && isValidColor(colors.backgroundColor) && isValidColor(colors.fontColor)) {
                // Set it on the section/content
                this[backgroundProperty] = colors.backgroundColor;
                // Set it on the font
                this[fontProperty] = colors.fontColor;
            }
            else if (isValidColor(colors)) {
                // Set the background color
                this[backgroundProperty] = colors;
            }
            else if (isDevMode) {
                // Otherwise error out
                console.error(error, this);
            }
        }
        else if (isDevMode) {
            // Otherwise error out
            console.error(error, this);
        }
    }
    // #endregion
    // #region ---------- Inputs/Outputs ---------- //
    /**
     * @property sectionColor
     * @description Sets the full-page color.  The full-page color spans the width of the entire page.
     * @return string: CamelCasedCitiColorName or #XXX or #XXXXXX
     * Colors names available at https://ddl-style-guide.cfapps-gt1-dev.nam.nsroot.net/color.html
     */
    set sectionColor(color) {
        // Set the color
        this.setColorOrError(color, '_sectionColor', '_fontColor', SectionColorErrorMessage);
    }
    /**
     * @property contentColor
     * @description Sets the content-area color. The content-area color spans the width of the content only.
     * @return string: CamelCasedCitiColorName or #XXX or #XXXXXX
     */
    set contentColor(color) {
        // Set the color
        this.setColorOrError(color, '_contentColor', '_fontColor', ContentColorErrorMessage);
    }
    ;
    /**
     * @property fontColor
     * @description Sets the font color for the section.
     * Font colors are set automatically when using a citi color name.
     * If setting font color manually ensure that sufficient contrast exists between background color and font color
     * A tool for checking this is available at https://webaim.org/resources/contrastchecker/
     * @return string: #XXX or #XXXXXX
     */
    set fontColor(color) {
        // Set the color
        if (isValidColor(color))
            this._fontColor = color;
    }
    ;
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: SectionComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: SectionComponent, isStandalone: false, selector: "citi-section", inputs: { sectionColor: "sectionColor", contentColor: "contentColor", fontColor: "fontColor" }, ngImport: i0, template: `
        <div class="section-wrapper" [ngStyle]="{ 'background-color': _sectionColor}">
            <div class="section-content-wrapper" [ngStyle]="{ 'background-color': _contentColor, 'color': _fontColor }">
                <ng-content></ng-content>
            </div>
        </div>
    `, isInline: true, styles: [".section-wrapper .section-content-wrapper{max-width:1440px;margin:0 auto;padding:0 20px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: SectionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-section', standalone: false, template: `
        <div class="section-wrapper" [ngStyle]="{ 'background-color': _sectionColor}">
            <div class="section-content-wrapper" [ngStyle]="{ 'background-color': _contentColor, 'color': _fontColor }">
                <ng-content></ng-content>
            </div>
        </div>
    `, styles: [".section-wrapper .section-content-wrapper{max-width:1440px;margin:0 auto;padding:0 20px}\n"] }]
        }], propDecorators: { sectionColor: [{
                type: Input$1
            }], contentColor: [{
                type: Input$1
            }], fontColor: [{
                type: Input$1
            }] } });

class ContentHtml {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ContentHtml, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: ContentHtml, declarations: [ContentHtmlDirective], imports: [CommonModule], exports: [ContentHtmlDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ContentHtml, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ContentHtml, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [ContentHtmlDirective],
                    exports: [ContentHtmlDirective]
                }]
        }] });

const COMPONENTS$18 = [
    ColumnComponent,
    RowComponent,
    SectionComponent,
];
const MODULES$1c = [
    CommonModule,
    ContentHtml
];
class Grid {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Grid, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: Grid, declarations: [ColumnComponent,
            RowComponent,
            SectionComponent], imports: [CommonModule,
            ContentHtml], exports: [ColumnComponent,
            RowComponent,
            SectionComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Grid, imports: [MODULES$1c] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Grid, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$1c],
                    declarations: [...COMPONENTS$18],
                    exports: [...COMPONENTS$18]
                }]
        }] });

function addJfpToken(href) {
    // If the target is set to _blank
    if (!href.match('JFP_TOKEN')) {
        // Check if there is a JFP Token in session storage
        // The casting is to avoid any compilcation error because of strict type checking of Typescript
        const jfpToken = sessionStorage.sessionJFP_TOKEN;
        if (jfpToken) {
            // Append the correct prefix
            href += href.match(/\?/g) ? '&' : '?';
            // Append the JFP_TOKEN
            href += 'JFP_TOKEN=' + jfpToken;
        }
    }
    return href;
}

const boolCheck = (val) => {
    if (val === 'true' || val === 'false' || val === true || val === false)
        return true;
    else
        return false;
};
const CTA_CLASSES = {
    primary: 'btn btn-primary',
    secondary: 'btn btn-link chevron-link secondary',
    tertiary: 'btn btn-link',
    icon: 'btn-link btn-icon',
    arrowRight: 'arrow-btn next',
    arrowLeft: 'arrow-btn prev',
    large: 'large',
    small: 'small',
    bold: 'bold',
    disabled: 'disabled',
    noMargin: 'noMargin',
    leftArrow: 'left link',
    btn_white: 'btn btn-primary btn_white',
    btn_white_on_blue: 'btn btn-primary btn_white_on_blue',
    'btn-white-disabled': 'btn btn-primary btn-white-disabled disabled',
    'btn-dark-disabled': 'btn btn-primary btn-dark-disabled disabled',
    'btn-blue-arrow-right': 'btn btn-primary arrow-btn next',
    'btn-blue-arrow-left': 'btn btn-primary arrow-btn prev',
    'btn-white-arrow-right': 'btn btn-primary btn_white_arrow_right arrow-btn next',
    'btn-white-arrow-left': 'btn btn-primary btn_white_arrow_left arrow-btn prev',
    'btn-dark-arrow-right': 'btn btn-primary btn_dark_arrow_right arrow-btn next',
    'btn-dark-arrow-left': 'btn btn-primary btn_dark_arrow_left arrow-btn prev',
    'btn-blue-hover-arrow-right': 'btn btn-primary btn_blue_hover_arrow_right arrow-btn next',
    'btn-blue-hover-arrow-left': 'btn btn-primary btn_blue_hover_arrow_left arrow-btn prev',
    btn_white_priority_arrow_right: 'btn btn-primary btn_white_priority_arrow_right arrow-btn next',
    btn_white_priority_arrow_left: 'btn btn-primary btn_white_priority_arrow_left arrow-btn prev',
    btn_dark_priority: 'btn btn-primary btn_dark_priority',
    btn_light_priority: 'btn btn-primary btn_light_priority',
    btn_gold: 'btn btn-primary btn_gold',
    gold_arrow_right: 'btn btn-primary btn_gold gold_arrow_right arrow-btn next',
    gold_arrow_left: 'btn btn-primary btn_gold gold_arrow_left arrow-btn prev',
    btn_gold_dark: 'btn btn-primary dark btn_gold',
    gold_dark_arrow_right: 'btn btn-primary dark btn_gold gold_arrow_right arrow-btn next',
    gold_dark_arrow_left: 'btn btn-primary dark btn_gold gold_arrow_left arrow-btn prev'
};
/**
 * @Component: Click to Action
 * @Section: ButtonsLinksLists
 * @description This component generates citi related click to actions like links, buttons, and their
 * various states.
 */
class CTAComponent {
    /**
     * @property bold
     * @description Makes the CTA bold.
     * @Type: Empty Attribute
     */
    set bold(bold) {
        if (bold !== false)
            this._bold = 'bold';
    }
    /**
     * @property noMargin
     * @description Supplies the aria-labeledby value
     * @return string
     */
    set noMargin(notMargin) {
        if (typeof notMargin !== 'undefined' && notMargin !== false) {
            this._noMargin = 'noMargin';
        }
    }
    /**
     * @property tabIndex
     * @description Supplies the tabindex value
     * @return string
     */
    set tabIndex(tabindex) {
        if (typeof tabindex !== 'undefined') {
            this._tabIndex = tabindex;
        }
    }
    /**
     * @property ariaDescribedBy
     * @description Supplies the aria-describedby value
     * @return string
     */
    set ariaDescription(description) {
        if (typeof description !== 'undefined') {
            this._ariaDescription = description;
        }
    }
    /**
     * @property ariaLabeledBy
     * @description Supplies the aria-labeledby value
     * @return string
     */
    set ariaLabeledBy(labeledBy) {
        if (typeof labeledBy !== 'undefined') {
            this._ariaLabeledBy = labeledBy;
        }
    }
    /**
     * @property ariaHasPopup
     * @description Supplies the value for the aria-haspopup attribute
     * @return string
     */
    set ariaHasPopup(hasPopup) {
        if (typeof hasPopup !== 'undefined') {
            this._ariaHasPopup = hasPopup;
        }
    }
    /**
     * @property ariaRole
     * @description Supplies the value for the role attribute
     * @return string
     */
    set ariaRole(role) {
        if (typeof role !== 'undefined') {
            this._role = role;
        }
    }
    /**
     * @property ariaLabel
     * @description Supplies the aria-label value
     * @return string
     */
    set ariaLabel(label) {
        if (typeof label !== 'undefined') {
            this._ariaLabel = label;
        }
    }
    /**
     * @property ariaControls
     * @description Supplies the aria-controls value
     * @return string
     */
    set ariaControls(controls) {
        if (typeof controls !== 'undefined') {
            this._ariaControls = controls;
        }
    }
    /**
     * @property ariaExpanded
     * @description Supplies the aria-controls value
     * @return string
     */
    set ariaExpanded(expanded) {
        if (typeof expanded !== 'undefined') {
            this._ariaExpanded = expanded;
        }
    }
    /**
     * @property dataTarget
     * @description Sets value to the data-target attribute for a button
     * @return string
     */
    set dataTarget(value) {
        this._dataTarget = value;
    }
    /**
     * @property addJFPToken
     * @description Whether the JFP Token should be appended regardless of what the target attribute is set to.
     * NOTE: This is only to be used in cases where the target attribute would otherwise prevent the JFP token from being appended.
     * @Type: boolean
     */
    set addJFPToken(add) {
        this._addJFPToken = add;
        this.href = this._href;
    }
    /**
     * @property doNotAddJFPToken
     * @description Overrides the addition of adding the JFP token (could not use the addJFPToken attribute since it defaults to false already)
     */
    set doNotAddJFPToken(doNotAdd) {
        this._doNotAddJFPToken = doNotAdd;
        this.href = this._href;
    }
    /**
     * @property buttonType
     * @description This is the type property for the button
     * @return string
     */
    set buttonType(type) {
        if (typeof type !== 'undefined') {
            this._buttonType = type;
        }
    }
    /**
     * @property target
     * @description The value of the target attribute for the CTA.
     * @return string
     */
    set target(target) {
        if (typeof target !== 'undefined') {
            this._guid = this.guid();
            this._target = target;
            if (target === '_blank' && !this._ariaDescription) {
                this._ariaDescription = 'Opens in new window';
            }
            this.href = this._href;
        }
    }
    /**
     * @property href
     * @description The value of the href attribute for the CTA.
     * @return string
     */
    set href(href) {
        if (typeof href === 'string' && href.length) {
            if ((this._target !== '_blank' || this._addJFPToken) &&
                !href.match('JFP_TOKEN') &&
                !this._doNotAddJFPToken) {
                if (isPlatformBrowser(this.platformId))
                    href = addJfpToken(href);
            }
            this._href = this._domSanitizer.sanitize(SecurityContext.URL, href);
        }
    }
    /**
     * @property value
     * @description The text value of the CTA.
     * @return string
     */
    set value(value) {
        if (typeof value !== 'undefined') {
            this._guid = this.guid();
            this._value = value;
        }
    }
    /**
     * @property disabled
     * @description Shows the disabled state of the CTA
     * @Type: boolean
     * @twoway true
     */
    set disabled(value) {
        if (typeof value !== 'undefined') {
            // Prevent error when trying to JSON.parse empty string
            if (value === '')
                value = 'false';
            if (boolCheck(value)) {
                this._isDisabled = JSON.parse(value);
                this._guid = this.guid();
                JSON.parse(value) === true
                    ? (this._disabled = 'disabled')
                    : (this._disabled = '');
                setTimeout(() => {
                    this.disabledChange.emit(value);
                }, 0);
            }
        }
    }
    /**
     * @property type
     * @description Determines the type of CTA to be displayed.  Valid options include
     * primary, secondary, tertiary, or icon.
     * @return string
     */
    set type(type) {
        if (typeof type !== 'undefined') {
            this._guid = this.guid();
            const typeKeys = Object.keys(this.buttonClasses);
            if (!typeKeys.includes(type)) {
                console.error('Valid button types are ', ...typeKeys);
            }
            else {
                for (const k of typeKeys) {
                    if (type === k) {
                        this._type = this.buttonClasses[k];
                        break;
                    }
                }
            }
        }
    }
    /**
     * @property size
     * @description Determines the size of CTA to be displayed.  Valid options include
     * large and small.  Can only be applied to primary buttons.
     * @return string
     */
    set size(size) {
        if (typeof size !== 'undefined') {
            this._guid = this.guid();
            const typeKeys = Object.keys(this.buttonClasses);
            if (typeKeys.includes('primary')) {
                if (!this._arrow || (this._arrow && size !== 'small')) {
                    this._size = size;
                }
            }
            else {
                console.error('Button sizes cannot be applied to tertiary or secondary buttons.');
            }
        }
    }
    /**
     * @property arrow
     * @description Determines whether the CTA should have an arrow or not.  Valid options
     * include left or right. Arrows can only be given to primary buttons and buttons that are not small.
     * @return string
     */
    set arrow(arrow) {
        if (typeof arrow !== 'undefined') {
            this._hasArrow = true;
            this._guid = this.guid();
            if (!this._type.match('secondary') || !this._type.match('tertiary')) {
                if (this._size !== 'small') {
                    if (arrow === 'left') {
                        this._arrow = this.buttonClasses.arrowLeft;
                    }
                    else if (arrow === 'right') {
                        this._arrow = this.buttonClasses.arrowRight;
                    }
                }
                else {
                    if (isDevMode) {
                        console.warn('Arrows cannot be added to a small size button');
                    }
                }
            }
            else {
                if (isDevMode) {
                    console.warn('Arrows can only be added to primary buttons');
                }
            }
        }
    }
    /**
     * @property leftArrow
     * @description Determines whether the Secondary CTA should have a left arrow or not.  Valid options
     * include left.
     * @return string
     */
    set leftArrow(leftArrow) {
        if (typeof leftArrow !== 'undefined') {
            this._guid = this.guid();
            if (this._type.match('chevron-link')) {
                if (leftArrow === 'left') {
                    this._leftArrow = this.buttonClasses.leftArrow;
                }
            }
            else {
                if (isDevMode) {
                    console.warn('leftArrow cannot be added to a primary button');
                }
            }
        }
    }
    // #endregion
    // #region // ----------------------- Methods ----------------------- //
    constructor(platformId, cdr, _domSanitizer) {
        this.platformId = platformId;
        this.cdr = cdr;
        this._domSanitizer = _domSanitizer;
        // #region // ----------------------- Properties ----------------------- //
        /**
         * @description CTASettings to hold the settings for the CTA
         */
        this._arrow = '';
        this._bold = '';
        this._button = '';
        this._buttonType = 'button';
        this._disabled = '';
        this._href = null;
        this._size = '';
        this._target = '_self';
        this._type = 'btn btn-primary';
        this._value = '';
        this._dataTarget = null;
        this._addJFPToken = false;
        this._doNotAddJFPToken = false;
        this._noMargin = '';
        this._leftArrow = '';
        /**
         * @property buttonClasses
         * @description Classes for buttons
         */
        this.buttonClasses = CTA_CLASSES;
        // #endregion
        // #region // ----------------------- Input/Output ----------------------- //
        /**
         * @property textAlign
         * @description Gives ability to align the text. By default is center.
         * @return string
         */
        this.textAlign = 'center';
        /**
         * @Event: ctaClick
         * @description CTA click event for detecting 'disabled' state
         */
        this.ctaClick = new EventEmitter();
        /**
         * @Event: disabledChange
         * @description Disabled property is changed
         */
        this.disabledChange = new EventEmitter();
        /**
         * @Event: ctaFocus
         * @description CTA is focused
         */
        this.ctaFocus = new EventEmitter();
        /**
         * @Event: ctaBlur
         * @description CTA is blurred
         */
        this.ctaBlur = new EventEmitter();
        this.idStr = this.guid();
    }
    onFocus(event) {
        // Sets the focus to the inner button which is the real element need to be focus
        this.button.nativeElement.focus();
    }
    onButtonFocus(event) {
        this.ctaFocus.emit(event);
    }
    onButtonBlur(event) {
        this.ctaBlur.emit(event);
    }
    guid() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return (s4() +
            s4() +
            '-' +
            s4() +
            '-' +
            s4() +
            '-' +
            s4() +
            '-' +
            s4() +
            s4() +
            s4());
    }
    onCTAClick() {
        if (this._disabled !== 'disabled') {
            this.ctaClick.emit();
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CTAComponent, deps: [{ token: PLATFORM_ID }, { token: i0.ChangeDetectorRef }, { token: i1$2.DomSanitizer }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: CTAComponent, isStandalone: false, selector: "citi-cta", inputs: { textAlign: "textAlign", bold: "bold", noMargin: "noMargin", tabIndex: "tabIndex", ariaDescription: "ariaDescription", ariaLabeledBy: "ariaLabeledBy", ariaHasPopup: "ariaHasPopup", ariaRole: "ariaRole", ariaLabel: "ariaLabel", ariaControls: "ariaControls", ariaExpanded: "ariaExpanded", router: "router", queryParams: "queryParams", idStr: "idStr", dataTarget: "dataTarget", addJFPToken: "addJFPToken", doNotAddJFPToken: "doNotAddJFPToken", buttonType: "buttonType", target: "target", href: "href", value: "value", disabled: "disabled", type: "type", size: "size", arrow: "arrow", leftArrow: "leftArrow" }, outputs: { ctaClick: "ctaClick", disabledChange: "disabledChange", ctaFocus: "ctaFocus", ctaBlur: "ctaBlur" }, host: { listeners: { "focus": "onFocus($event)" } }, viewQueries: [{ propertyName: "button", first: true, predicate: ["button"], descendants: true }], ngImport: i0, template: `
    <button
      #button
      *ngIf="!_href && !router"
      [type]="_buttonType"
      [attr.id]="idStr"
      [attr.tabindex]="_tabIndex ? _tabIndex : null"
      [attr.disabled]="_disabled === 'disabled' ? true : null"
      [attr.aria-haspopup]="_ariaHasPopup ? _ariaHasPopup : null"
      [attr.aria-controls]="_ariaControls ? _ariaControls : null"
      [attr.aria-expanded]="_ariaExpanded"
      [attr.role]="_role ? _role : null"
      [attr.aria-label]="_ariaLabel ? _ariaLabel : null"
      [attr.aria-labelledby]="_ariaLabeledBy ? _ariaLabeledBy : null"
      [attr.aria-describedby]="
        _ariaDescription ? _guid + '_ariadescription' : null
      "
      [ngClass]="[
        _button,
        _type,
        _disabled,
        _arrow,
        _leftArrow,
        _size,
        _bold,
        _noMargin
      ]"
      [attr.data-target]="_dataTarget"
      [innerHtml]="_value"
      (click)="onCTAClick()"
      [style.text-align]="textAlign"
      (focus)="onButtonFocus($event)"
      (blur)="onButtonBlur($event)"
    ></button>
    <a
      #button
      *ngIf="_href"
      [attr.target]="_target"
      [attr.id]="idStr"
      [attr.tabindex]="_tabIndex ? _tabIndex : null "
      [attr.disabled]="_disabled === 'disabled' ? true : null"
      [attr.aria-disabled]="_disabled === 'disabled' ? true : null"
      [attr.href]="_href ? _href : null"
      [attr.role]="_role ? _role : null"
      [attr.aria-label]="_ariaLabel ? _ariaLabel : null"
      [attr.aria-labelledby]="_ariaLabeledBy ? _ariaLabeledBy : null"
      [attr.aria-describedby]="
        _ariaDescription ? _guid + '_ariadescription' : null
      "
      [ngClass]="[
        _button,
        _type,
        _disabled,
        _leftArrow,
        _bold,
        _noMargin
      ]"
      class="cta-link"
      [innerHtml]="_value"
      [attr.data-target]="_dataTarget"
      (click)="onCTAClick()"
      (focus)="onButtonFocus($event)"
      (blur)="onButtonBlur($event)"
    >
    </a>
    <a
      #button
      *ngIf="router"
      [routerLink]="router"
      [queryParams]="queryParams"
      [attr.id]="idStr"
      [attr.tabindex]="_tabIndex ? _tabIndex : null"
      [attr.disabled]="_disabled === 'disabled' ? true : null"
      [attr.aria-label]="_ariaLabel ? _ariaLabel : null"
      [attr.aria-labelledby]="_ariaLabeledBy ? _ariaLabeledBy : null"
      [attr.aria-describedby]="
        _ariaDescription ? _guid + '_ariadescription' : null
      "
      [innerHtml]="_value"
      [attr.data-target]="_dataTarget"
      [ngClass]="[
        _button,
        _type,
        _disabled,
        _leftArrow,
        _bold,
        _noMargin
      ]"
      class="cta-link-router"
      (focus)="onButtonFocus($event)"
      (blur)="onButtonBlur($event)"
    ></a>

    <span
      *ngIf="_ariaDescription"
      [id]="_guid + '_ariadescription'"
      class="sr-only"
      aria-hidden="true"
      [innerHtml]="_ariaDescription"
    ></span>
  `, isInline: true, styles: ["@charset \"UTF-8\";.btn_white,.btn-primary.btn_white{background-color:#fff;color:#056dae;border-color:#fff}.btn_white:hover,.btn_white:focus,.btn-primary.btn_white:hover,.btn-primary.btn_white:focus{background-color:#056dae;color:#fff;border-color:#056dae}.btn_white_on_blue,.btn-primary.btn_white_on_blue{background-color:#fff;color:#056dae;border-color:#fff}.btn_white_on_blue:hover,.btn_white_on_blue:focus,.btn-primary.btn_white_on_blue:hover,.btn-primary.btn_white_on_blue:focus{background-color:#002a54;color:#fff;border-color:#002a54}.btn_dark_priority{background-color:#0e2a48;color:#fff;border-color:#0e2a48}.btn_dark_priority:hover,.btn_dark_priority:focus{background-color:#091022;color:#fff;border-color:#091022}.btn-primary.btn_dark_priority:active{background-color:#091022;color:#fff;border-color:#091022}.btn_light_priority,.btn-primary.btn_light_priority{background-color:#fff;color:#000;border-color:#fff}.btn_light_priority:hover,.btn_light_priority:focus,.btn-primary.btn_light_priority:hover,.btn-primary.btn_light_priority:focus{background-color:#65778a;color:#fff;border-color:#65778a}.btn.btn-white-disabled{border-color:#fff;color:#fff;background-color:transparent;opacity:1}.btn.btn-white-disabled:hover{border-color:#fff;color:#fff}.btn.btn-dark-disabled{border-color:#666;opacity:.5;color:#666;background-color:transparent}.btn.btn-dark-disabled:hover{border-color:#666;color:#666}.btn_dark_arrow_right{background-color:#0e2a48;color:#fff;border-color:#0e2a48}.btn_dark_arrow_right:hover,.btn_dark_arrow_right:focus{background-color:#091022;border-color:#091022}.btn_dark_arrow_right[disabled],.btn_dark_arrow_right.disabled{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E04-glyph-right-white%3C/title%3E%3Cpath d=%27M17,27a1,1,0,0,1-.68-1.73L22,20l-5.66-5.27a1,1,0,0,1,1.36-1.46l5.72,5.32a1.91,1.91,0,0,1,0,2.82l-5.72,5.32A1,1,0,0,1,17,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:rgba(0, 0, 0, 0.5);fill-rule:evenodd%27/%3E%3C/svg%3E\")}.btn-primary.btn_dark_arrow_right:active{background-color:#091022;color:#fff;border-color:#091022}.btn_dark_arrow_left{background-color:#0e2a48;color:#fff;border-color:#0e2a48;background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23ffffff;fill-rule:evenodd%27/%3E%3C/svg%3E\")}.btn_dark_arrow_left:hover,.btn_dark_arrow_left:focus{background-color:#091022;color:#fff;border-color:#091022;background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23ffffff;fill-rule:evenodd%27/%3E%3C/svg%3E\")}.btn_dark_arrow_left[disabled],.btn_dark_arrow_left.disabled{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:rgba(0, 0, 0, 0.5);fill-rule:evenodd%27/%3E%3C/svg%3E\")}.btn-primary.btn_dark_arrow_left:active{background-color:#091022;color:#fff;border-color:#091022}.btn_white_arrow_left{background-color:#fff;color:#056dae;border-color:#fff;background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23056dae;fill-rule:evenodd%27/%3E%3C/svg%3E\")!important}.btn_white_arrow_left:hover,.btn_white_arrow_left:focus{background-color:#056dae;color:#fff;border-color:#056dae;background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23ffffff;fill-rule:evenodd%27/%3E%3C/svg%3E\")!important}.btn_white_arrow_right{background-color:#fff;color:#056dae;border-color:#fff;background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E04-glyph-right-white%3C/title%3E%3Cpath d=%27M17,27a1,1,0,0,1-.68-1.73L22,20l-5.66-5.27a1,1,0,0,1,1.36-1.46l5.72,5.32a1.91,1.91,0,0,1,0,2.82l-5.72,5.32A1,1,0,0,1,17,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23056dae;fill-rule:evenodd%27/%3E%3C/svg%3E\")!important}.btn_white_arrow_right:hover,.btn_white_arrow_right:focus{background-color:#056dae;color:#fff;border-color:#056dae;background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E04-glyph-right-white%3C/title%3E%3Cpath d=%27M17,27a1,1,0,0,1-.68-1.73L22,20l-5.66-5.27a1,1,0,0,1,1.36-1.46l5.72,5.32a1.91,1.91,0,0,1,0,2.82l-5.72,5.32A1,1,0,0,1,17,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23ffffff;fill-rule:evenodd%27/%3E%3C/svg%3E\")!important}.btn_blue_hover_arrow_left{background-color:#fff;color:#056dae;border-color:#fff;background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23056dae;fill-rule:evenodd%27/%3E%3C/svg%3E\")!important}.btn_blue_hover_arrow_left:hover,.btn_blue_hover_arrow_left:focus{background-color:#65778a;color:#fff;border-color:#65778a;background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23ffffff;fill-rule:evenodd%27/%3E%3C/svg%3E\")!important}.btn_blue_hover_arrow_right{background-color:#fff;color:#056dae;border-color:#fff;background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E04-glyph-right-white%3C/title%3E%3Cpath d=%27M17,27a1,1,0,0,1-.68-1.73L22,20l-5.66-5.27a1,1,0,0,1,1.36-1.46l5.72,5.32a1.91,1.91,0,0,1,0,2.82l-5.72,5.32A1,1,0,0,1,17,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23056dae;fill-rule:evenodd%27/%3E%3C/svg%3E\")!important}.btn_blue_hover_arrow_right:hover,.btn_blue_hover_arrow_right:focus{background-color:#65778a;color:#fff;border-color:#65778a;background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E04-glyph-right-white%3C/title%3E%3Cpath d=%27M17,27a1,1,0,0,1-.68-1.73L22,20l-5.66-5.27a1,1,0,0,1,1.36-1.46l5.72,5.32a1.91,1.91,0,0,1,0,2.82l-5.72,5.32A1,1,0,0,1,17,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23ffffff;fill-rule:evenodd%27/%3E%3C/svg%3E\")!important}.btn_white_priority_arrow_left{background-color:#fff;color:#0e2a48;border-color:#fff;background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%230e2a48;fill-rule:evenodd%27/%3E%3C/svg%3E\")!important}.btn_white_priority_arrow_left:hover,.btn_white_priority_arrow_left:focus{background-color:#65778a;color:#fff;border-color:#65778a;background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23ffffff;fill-rule:evenodd%27/%3E%3C/svg%3E\")!important}.btn_white_priority_arrow_right{background-color:#fff!important;color:#0e2a48!important;border-color:#fff!important;background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E04-glyph-right-white%3C/title%3E%3Cpath d=%27M17,27a1,1,0,0,1-.68-1.73L22,20l-5.66-5.27a1,1,0,0,1,1.36-1.46l5.72,5.32a1.91,1.91,0,0,1,0,2.82l-5.72,5.32A1,1,0,0,1,17,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%230e2a48;fill-rule:evenodd%27/%3E%3C/svg%3E\")!important}.btn_white_priority_arrow_right:hover,.btn_white_priority_arrow_right:focus{background-color:#65778a!important;color:#fff!important;border-color:#65778a!important;background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E04-glyph-right-white%3C/title%3E%3Cpath d=%27M17,27a1,1,0,0,1-.68-1.73L22,20l-5.66-5.27a1,1,0,0,1,1.36-1.46l5.72,5.32a1.91,1.91,0,0,1,0,2.82l-5.72,5.32A1,1,0,0,1,17,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23ffffff;fill-rule:evenodd%27/%3E%3C/svg%3E\")!important}.btn_gold{background-color:#8e6f32;color:#fff;border-color:#8e6f32}.btn_gold:hover,.btn_gold:focus{background-color:#745b2d;color:#fff;border-color:#745b2d}.btn_gold[disabled],.btn_gold[disabled]:hover,.btn_gold[disabled]:focus,.btn_gold.disabled,.btn_gold.disabled:hover,.btn_gold.disabled:focus{color:#00000080;border-color:#00000080}.btn-primary.btn_gold:active{background-color:#745b2d;color:#fff;border-color:#745b2d}.gold_arrow_right{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E04-glyph-right-white%3C/title%3E%3Cpath d=%27M17,27a1,1,0,0,1-.68-1.73L22,20l-5.66-5.27a1,1,0,0,1,1.36-1.46l5.72,5.32a1.91,1.91,0,0,1,0,2.82l-5.72,5.32A1,1,0,0,1,17,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23ffffff;fill-rule:evenodd%27/%3E%3C/svg%3E\")}.gold_arrow_right:hover,.gold_arrow_right:focus{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E04-glyph-right-white%3C/title%3E%3Cpath d=%27M17,27a1,1,0,0,1-.68-1.73L22,20l-5.66-5.27a1,1,0,0,1,1.36-1.46l5.72,5.32a1.91,1.91,0,0,1,0,2.82l-5.72,5.32A1,1,0,0,1,17,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23ffffff;fill-rule:evenodd%27/%3E%3C/svg%3E\")}.gold_arrow_right[disabled],.gold_arrow_right.disabled{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E04-glyph-right-white%3C/title%3E%3Cpath d=%27M17,27a1,1,0,0,1-.68-1.73L22,20l-5.66-5.27a1,1,0,0,1,1.36-1.46l5.72,5.32a1.91,1.91,0,0,1,0,2.82l-5.72,5.32A1,1,0,0,1,17,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:rgba(0, 0, 0, 0.5);fill-rule:evenodd%27/%3E%3C/svg%3E\")}.btn-primary.gold_arrow_right:active{background-color:#745b2d;color:#fff;border-color:#745b2d}.gold_arrow_left{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23ffffff;fill-rule:evenodd%27/%3E%3C/svg%3E\")}.gold_arrow_left:hover,.gold_arrow_left:focus{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23ffffff;fill-rule:evenodd%27/%3E%3C/svg%3E\")}.gold_arrow_left[disabled],.gold_arrow_left.disabled{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:rgba(0, 0, 0, 0.5);fill-rule:evenodd%27/%3E%3C/svg%3E\")}.btn-primary.gold_arrow_left:active{background-color:#745b2d;color:#fff;border-color:#745b2d}:host-context(.theme-dark,.cta-bg-dark) .btn_gold,.dark.btn_gold{background-color:#fff;color:#8e6f32;border-color:#fff}:host-context(.theme-dark,.cta-bg-dark) .btn_gold:hover,.dark.btn_gold:hover,:host-context(.theme-dark,.cta-bg-dark) .btn_gold:focus,.dark.btn_gold:focus{background-color:#8e6f32;color:#fff;border-color:#8e6f32}:host-context(.theme-dark,.cta-bg-dark) [disabled].btn_gold,[disabled].dark.btn_gold,:host-context(.theme-dark,.cta-bg-dark) .disabled.btn_gold,.disabled.dark.btn_gold{background-color:transparent;color:#fff;border-color:#fff}:host-context(.theme-dark,.cta-bg-dark) .gold_arrow_right,.dark.gold_arrow_right{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E04-glyph-right-white%3C/title%3E%3Cpath d=%27M17,27a1,1,0,0,1-.68-1.73L22,20l-5.66-5.27a1,1,0,0,1,1.36-1.46l5.72,5.32a1.91,1.91,0,0,1,0,2.82l-5.72,5.32A1,1,0,0,1,17,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%238e6f32;fill-rule:evenodd%27/%3E%3C/svg%3E\")}:host-context(.theme-dark,.cta-bg-dark) .gold_arrow_right:hover,.dark.gold_arrow_right:hover,:host-context(.theme-dark,.cta-bg-dark) .gold_arrow_right:focus,.dark.gold_arrow_right:focus{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E04-glyph-right-white%3C/title%3E%3Cpath d=%27M17,27a1,1,0,0,1-.68-1.73L22,20l-5.66-5.27a1,1,0,0,1,1.36-1.46l5.72,5.32a1.91,1.91,0,0,1,0,2.82l-5.72,5.32A1,1,0,0,1,17,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23ffffff;fill-rule:evenodd%27/%3E%3C/svg%3E\")}:host-context(.theme-dark,.cta-bg-dark) [disabled].gold_arrow_right,[disabled].dark.gold_arrow_right,:host-context(.theme-dark,.cta-bg-dark) .disabled.gold_arrow_right,.disabled.dark.gold_arrow_right{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E04-glyph-right-white%3C/title%3E%3Cpath d=%27M17,27a1,1,0,0,1-.68-1.73L22,20l-5.66-5.27a1,1,0,0,1,1.36-1.46l5.72,5.32a1.91,1.91,0,0,1,0,2.82l-5.72,5.32A1,1,0,0,1,17,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23ffffff;fill-rule:evenodd%27/%3E%3C/svg%3E\")}:host-context(.theme-dark,.cta-bg-dark) .gold_arrow_left,.dark.gold_arrow_left{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%238e6f32;fill-rule:evenodd%27/%3E%3C/svg%3E\")}:host-context(.theme-dark,.cta-bg-dark) .gold_arrow_left:hover,.dark.gold_arrow_left:hover,:host-context(.theme-dark,.cta-bg-dark) .gold_arrow_left:focus,.dark.gold_arrow_left:focus{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23ffffff;fill-rule:evenodd%27/%3E%3C/svg%3E\")}:host-context(.theme-dark,.cta-bg-dark) [disabled].gold_arrow_left,[disabled].dark.gold_arrow_left,:host-context(.theme-dark,.cta-bg-dark) .disabled.gold_arrow_left,.disabled.dark.gold_arrow_left{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23ffffff;fill-rule:evenodd%27/%3E%3C/svg%3E\")}.btn-primary.arrow-btn.next[disabled],.btn-primary.arrow-btn.next.disabled{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E04-glyph-right-white%3C/title%3E%3Cpath d=%27M17,27a1,1,0,0,1-.68-1.73L22,20l-5.66-5.27a1,1,0,0,1,1.36-1.46l5.72,5.32a1.91,1.91,0,0,1,0,2.82l-5.72,5.32A1,1,0,0,1,17,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:rgba(0, 0, 0, 0.5);fill-rule:evenodd%27/%3E%3C/svg%3E\")}.btn-primary.arrow-btn.prev[disabled],.btn-primary.arrow-btn.prev.disabled{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:rgba(0, 0, 0, 0.5);fill-rule:evenodd%27/%3E%3C/svg%3E\")}.secondary{text-decoration:none;white-space:normal}a.secondary.cta-link,a.cta-link-router{text-decoration:underline}a.cta-link-router.btn-primary{text-decoration:none}.btn-link.btn-icon:before{content:\"\";left:-20px;top:4px;height:12px;width:12px;background-repeat:no-repeat;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 14'%3E%3Cpath d='M26,19H21V14a1,1,0,0,0-2,0v5H14a1,1,0,0,0,0,2h5v5a1,1,0,0,0,2,0V21h5a1,1,0,0,0,0-2' transform='translate(-13 -13)' style='fill:%23056DAE;fill-rule:evenodd'/%3E%3C/svg%3E\")}.btn-link.btn-icon:hover,.btn-link.btn-icon:focus{text-decoration:underline}.btn-link.btn-icon:hover:before,.btn-link.btn-icon:focus:before{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 14'%3E%3Cpath d='M26,19H21V14a1,1,0,0,0-2,0v5H14a1,1,0,0,0,0,2h5v5a1,1,0,0,0,2,0V21h5a1,1,0,0,0,0-2' transform='translate(-13 -13)' style='fill:%23002a54;fill-rule:evenodd'/%3E%3C/svg%3E\")}.btn-link.btn-icon[disabled],.btn-link.btn-icon.disabled{color:#00000080;cursor:default;opacity:.65}.btn-link.btn-icon[disabled]:before,.btn-link.btn-icon.disabled:before{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 14 14%27%3E%3Cpath d=%27M26,19H21V14a1,1,0,0,0-2,0v5H14a1,1,0,0,0,0,2h5v5a1,1,0,0,0,2,0V21h5a1,1,0,0,0,0-2%27 transform=%27translate(-13 -13)%27 style=%27fill:rgba(0, 0, 0, 0.5);fill-rule:evenodd%27/%3E%3C/svg%3E\")}.btn-link.btn-icon[disabled]:hover,.btn-link.btn-icon[disabled]:focus,.btn-link.btn-icon.disabled:hover,.btn-link.btn-icon.disabled:focus{text-decoration:none}a.btn-icon.cta-link,a.cta-link-router.btn-link.btn-icon{text-decoration:underline}:host-context(.theme-dark) .secondary:hover,:host-context(.theme-dark) .secondary:focus{text-decoration:underline}.noMargin{margin:0}.chevron-link.chevron-link,.chevron-link.chevron-link:hover,.chevron-link.chevron-link:focus,.chevron-link.chevron-link.bold,.chevron-link.chevron-link.bold:hover,.chevron-link.chevron-link.bold:focus{background-image:none;margin-right:0}.chevron-link.chevron-link:after{content:\"\\a0\";background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E04-glyph-right-white%3C/title%3E%3Cpath d=%27M17,27a1,1,0,0,1-.68-1.73L22,20l-5.66-5.27a1,1,0,0,1,1.36-1.46l5.72,5.32a1.91,1.91,0,0,1,0,2.82l-5.72,5.32A1,1,0,0,1,17,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23056dae;fill-rule:evenodd%27/%3E%3C/svg%3E\");background-repeat:no-repeat;background-color:transparent;background-position:top 50% right 0;display:inline-block;margin-left:6px}.chevron-link.chevron-link:hover:after,.chevron-link.chevron-link:focus:after{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E04-glyph-right-white%3C/title%3E%3Cpath d=%27M17,27a1,1,0,0,1-.68-1.73L22,20l-5.66-5.27a1,1,0,0,1,1.36-1.46l5.72,5.32a1.91,1.91,0,0,1,0,2.82l-5.72,5.32A1,1,0,0,1,17,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23002a54;fill-rule:evenodd%27/%3E%3C/svg%3E\")}.chevron-link.chevron-link.bold:after{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%276.25px%27 height=%2711.25px%27 viewBox=%270 0 5 9%27%3E%3Cg transform=%27translate(-1274.000000, -1120.000000)%27 fill=%27%23056dae%27 %3E%3Cpath d=%27M1278.93387,1124.67494 L1278.93387,1123.48506 L1274.744,1120.08 L1274.744,1122.26987 L1277.11109,1124.09266 L1274.744,1125.90278 L1274.744,1128.08 L1278.93387,1124.67494 Z%27 /%3E%3C/g%3E%3C/svg%3E\")}.chevron-link.chevron-link.bold:hover:after,.chevron-link.chevron-link.bold:focus:after{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%276.25px%27 height=%2711.25px%27 viewBox=%270 0 5 9%27%3E%3Cg transform=%27translate(-1274.000000, -1120.000000)%27 fill=%27%23002a54%27 %3E%3Cpath d=%27M1278.93387,1124.67494 L1278.93387,1123.48506 L1274.744,1120.08 L1274.744,1122.26987 L1277.11109,1124.09266 L1274.744,1125.90278 L1274.744,1128.08 L1278.93387,1124.67494 Z%27 /%3E%3C/g%3E%3C/svg%3E\")}.chevron-link.chevron-link.disabled:after{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E04-glyph-right-white%3C/title%3E%3Cpath d=%27M17,27a1,1,0,0,1-.68-1.73L22,20l-5.66-5.27a1,1,0,0,1,1.36-1.46l5.72,5.32a1.91,1.91,0,0,1,0,2.82l-5.72,5.32A1,1,0,0,1,17,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:rgba(0, 0, 0, 0.5);fill-rule:evenodd%27/%3E%3C/svg%3E\")}.chevron-link.chevron-link.disabled:hover:after,.chevron-link.chevron-link.disabled:focus:after{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E04-glyph-right-white%3C/title%3E%3Cpath d=%27M17,27a1,1,0,0,1-.68-1.73L22,20l-5.66-5.27a1,1,0,0,1,1.36-1.46l5.72,5.32a1.91,1.91,0,0,1,0,2.82l-5.72,5.32A1,1,0,0,1,17,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:rgba(0, 0, 0, 0.5);fill-rule:evenodd%27/%3E%3C/svg%3E\")}.chevron-link.chevron-link.disabled.bold:after{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%276.25px%27 height=%2711.25px%27 viewBox=%270 0 5 9%27%3E%3Cg transform=%27translate(-1274.000000, -1120.000000)%27 fill=%27rgba(0, 0, 0, 0.5)%27 %3E%3Cpath d=%27M1278.93387,1124.67494 L1278.93387,1123.48506 L1274.744,1120.08 L1274.744,1122.26987 L1277.11109,1124.09266 L1274.744,1125.90278 L1274.744,1128.08 L1278.93387,1124.67494 Z%27 /%3E%3C/g%3E%3C/svg%3E\")}.chevron-link.chevron-link.disabled.bold:hover:after,.chevron-link.chevron-link.disabled.bold:focus:after{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%276.25px%27 height=%2711.25px%27 viewBox=%270 0 5 9%27%3E%3Cg transform=%27translate(-1274.000000, -1120.000000)%27 fill=%27rgba(0, 0, 0, 0.5)%27 %3E%3Cpath d=%27M1278.93387,1124.67494 L1278.93387,1123.48506 L1274.744,1120.08 L1274.744,1122.26987 L1277.11109,1124.09266 L1274.744,1125.90278 L1274.744,1128.08 L1278.93387,1124.67494 Z%27 /%3E%3C/g%3E%3C/svg%3E\")}.chevron-link.chevron-link.left:after{display:none}.chevron-link.chevron-link.left:before{content:\"\\a0\";background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23056dae;fill-rule:evenodd%27/%3E%3C/svg%3E\");background-repeat:no-repeat;background-color:transparent;background-position:top 50% left 0;display:inline-block;margin-right:6px}.chevron-link.chevron-link.left:hover:before,.chevron-link.chevron-link.left:focus:before{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23002a54;fill-rule:evenodd%27/%3E%3C/svg%3E\")}.chevron-link.chevron-link.left.bold:before{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23056dae;fill-rule:evenodd%27/%3E%3C/svg%3E\")}.chevron-link.chevron-link.left.bold:hover:before,.chevron-link.chevron-link.left.bold:focus:before{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23002a54;fill-rule:evenodd%27/%3E%3C/svg%3E\")}.chevron-link.chevron-link.left.disabled:before{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:rgba(0, 0, 0, 0.5);fill-rule:evenodd%27/%3E%3C/svg%3E\")}.chevron-link.chevron-link.left.disabled:hover:before,.chevron-link.chevron-link.left.disabled:focus:before{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:rgba(0, 0, 0, 0.5);fill-rule:evenodd%27/%3E%3C/svg%3E\")}:host-context(.theme-dark) .chevron-link,:host-context(.theme-dark) .chevron-link:hover,:host-context(.theme-dark) .chevron-link:focus,:host-context(.theme-dark) .chevron-link.bold,:host-context(.theme-dark) .chevron-link.bold:hover,:host-context(.theme-dark) .chevron-link.bold:focus{background-image:none;margin-right:0}:host-context(.theme-dark) .chevron-link:after{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E04-glyph-right-white%3C/title%3E%3Cpath d=%27M17,27a1,1,0,0,1-.68-1.73L22,20l-5.66-5.27a1,1,0,0,1,1.36-1.46l5.72,5.32a1.91,1.91,0,0,1,0,2.82l-5.72,5.32A1,1,0,0,1,17,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23ffffff;fill-rule:evenodd%27/%3E%3C/svg%3E\")}:host-context(.theme-dark) .chevron-link.bold:after{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%276.25px%27 height=%2711.25px%27 viewBox=%270 0 5 9%27%3E%3Cg transform=%27translate(-1274.000000, -1120.000000)%27 fill=%27%23ffffff%27 %3E%3Cpath d=%27M1278.93387,1124.67494 L1278.93387,1123.48506 L1274.744,1120.08 L1274.744,1122.26987 L1277.11109,1124.09266 L1274.744,1125.90278 L1274.744,1128.08 L1278.93387,1124.67494 Z%27 /%3E%3C/g%3E%3C/svg%3E\")}:host-context(.theme-dark) .chevron-link.left:before{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23ffffff;fill-rule:evenodd%27/%3E%3C/svg%3E\")}:host-context(.theme-dark) .chevron-link.left.bold:before{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23ffffff;fill-rule:evenodd%27/%3E%3C/svg%3E\")}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "info", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CTAComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-cta', standalone: false, template: `
    <button
      #button
      *ngIf="!_href && !router"
      [type]="_buttonType"
      [attr.id]="idStr"
      [attr.tabindex]="_tabIndex ? _tabIndex : null"
      [attr.disabled]="_disabled === 'disabled' ? true : null"
      [attr.aria-haspopup]="_ariaHasPopup ? _ariaHasPopup : null"
      [attr.aria-controls]="_ariaControls ? _ariaControls : null"
      [attr.aria-expanded]="_ariaExpanded"
      [attr.role]="_role ? _role : null"
      [attr.aria-label]="_ariaLabel ? _ariaLabel : null"
      [attr.aria-labelledby]="_ariaLabeledBy ? _ariaLabeledBy : null"
      [attr.aria-describedby]="
        _ariaDescription ? _guid + '_ariadescription' : null
      "
      [ngClass]="[
        _button,
        _type,
        _disabled,
        _arrow,
        _leftArrow,
        _size,
        _bold,
        _noMargin
      ]"
      [attr.data-target]="_dataTarget"
      [innerHtml]="_value"
      (click)="onCTAClick()"
      [style.text-align]="textAlign"
      (focus)="onButtonFocus($event)"
      (blur)="onButtonBlur($event)"
    ></button>
    <a
      #button
      *ngIf="_href"
      [attr.target]="_target"
      [attr.id]="idStr"
      [attr.tabindex]="_tabIndex ? _tabIndex : null "
      [attr.disabled]="_disabled === 'disabled' ? true : null"
      [attr.aria-disabled]="_disabled === 'disabled' ? true : null"
      [attr.href]="_href ? _href : null"
      [attr.role]="_role ? _role : null"
      [attr.aria-label]="_ariaLabel ? _ariaLabel : null"
      [attr.aria-labelledby]="_ariaLabeledBy ? _ariaLabeledBy : null"
      [attr.aria-describedby]="
        _ariaDescription ? _guid + '_ariadescription' : null
      "
      [ngClass]="[
        _button,
        _type,
        _disabled,
        _leftArrow,
        _bold,
        _noMargin
      ]"
      class="cta-link"
      [innerHtml]="_value"
      [attr.data-target]="_dataTarget"
      (click)="onCTAClick()"
      (focus)="onButtonFocus($event)"
      (blur)="onButtonBlur($event)"
    >
    </a>
    <a
      #button
      *ngIf="router"
      [routerLink]="router"
      [queryParams]="queryParams"
      [attr.id]="idStr"
      [attr.tabindex]="_tabIndex ? _tabIndex : null"
      [attr.disabled]="_disabled === 'disabled' ? true : null"
      [attr.aria-label]="_ariaLabel ? _ariaLabel : null"
      [attr.aria-labelledby]="_ariaLabeledBy ? _ariaLabeledBy : null"
      [attr.aria-describedby]="
        _ariaDescription ? _guid + '_ariadescription' : null
      "
      [innerHtml]="_value"
      [attr.data-target]="_dataTarget"
      [ngClass]="[
        _button,
        _type,
        _disabled,
        _leftArrow,
        _bold,
        _noMargin
      ]"
      class="cta-link-router"
      (focus)="onButtonFocus($event)"
      (blur)="onButtonBlur($event)"
    ></a>

    <span
      *ngIf="_ariaDescription"
      [id]="_guid + '_ariadescription'"
      class="sr-only"
      aria-hidden="true"
      [innerHtml]="_ariaDescription"
    ></span>
  `, changeDetection: ChangeDetectionStrategy.OnPush, styles: ["@charset \"UTF-8\";.btn_white,.btn-primary.btn_white{background-color:#fff;color:#056dae;border-color:#fff}.btn_white:hover,.btn_white:focus,.btn-primary.btn_white:hover,.btn-primary.btn_white:focus{background-color:#056dae;color:#fff;border-color:#056dae}.btn_white_on_blue,.btn-primary.btn_white_on_blue{background-color:#fff;color:#056dae;border-color:#fff}.btn_white_on_blue:hover,.btn_white_on_blue:focus,.btn-primary.btn_white_on_blue:hover,.btn-primary.btn_white_on_blue:focus{background-color:#002a54;color:#fff;border-color:#002a54}.btn_dark_priority{background-color:#0e2a48;color:#fff;border-color:#0e2a48}.btn_dark_priority:hover,.btn_dark_priority:focus{background-color:#091022;color:#fff;border-color:#091022}.btn-primary.btn_dark_priority:active{background-color:#091022;color:#fff;border-color:#091022}.btn_light_priority,.btn-primary.btn_light_priority{background-color:#fff;color:#000;border-color:#fff}.btn_light_priority:hover,.btn_light_priority:focus,.btn-primary.btn_light_priority:hover,.btn-primary.btn_light_priority:focus{background-color:#65778a;color:#fff;border-color:#65778a}.btn.btn-white-disabled{border-color:#fff;color:#fff;background-color:transparent;opacity:1}.btn.btn-white-disabled:hover{border-color:#fff;color:#fff}.btn.btn-dark-disabled{border-color:#666;opacity:.5;color:#666;background-color:transparent}.btn.btn-dark-disabled:hover{border-color:#666;color:#666}.btn_dark_arrow_right{background-color:#0e2a48;color:#fff;border-color:#0e2a48}.btn_dark_arrow_right:hover,.btn_dark_arrow_right:focus{background-color:#091022;border-color:#091022}.btn_dark_arrow_right[disabled],.btn_dark_arrow_right.disabled{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E04-glyph-right-white%3C/title%3E%3Cpath d=%27M17,27a1,1,0,0,1-.68-1.73L22,20l-5.66-5.27a1,1,0,0,1,1.36-1.46l5.72,5.32a1.91,1.91,0,0,1,0,2.82l-5.72,5.32A1,1,0,0,1,17,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:rgba(0, 0, 0, 0.5);fill-rule:evenodd%27/%3E%3C/svg%3E\")}.btn-primary.btn_dark_arrow_right:active{background-color:#091022;color:#fff;border-color:#091022}.btn_dark_arrow_left{background-color:#0e2a48;color:#fff;border-color:#0e2a48;background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23ffffff;fill-rule:evenodd%27/%3E%3C/svg%3E\")}.btn_dark_arrow_left:hover,.btn_dark_arrow_left:focus{background-color:#091022;color:#fff;border-color:#091022;background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23ffffff;fill-rule:evenodd%27/%3E%3C/svg%3E\")}.btn_dark_arrow_left[disabled],.btn_dark_arrow_left.disabled{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:rgba(0, 0, 0, 0.5);fill-rule:evenodd%27/%3E%3C/svg%3E\")}.btn-primary.btn_dark_arrow_left:active{background-color:#091022;color:#fff;border-color:#091022}.btn_white_arrow_left{background-color:#fff;color:#056dae;border-color:#fff;background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23056dae;fill-rule:evenodd%27/%3E%3C/svg%3E\")!important}.btn_white_arrow_left:hover,.btn_white_arrow_left:focus{background-color:#056dae;color:#fff;border-color:#056dae;background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23ffffff;fill-rule:evenodd%27/%3E%3C/svg%3E\")!important}.btn_white_arrow_right{background-color:#fff;color:#056dae;border-color:#fff;background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E04-glyph-right-white%3C/title%3E%3Cpath d=%27M17,27a1,1,0,0,1-.68-1.73L22,20l-5.66-5.27a1,1,0,0,1,1.36-1.46l5.72,5.32a1.91,1.91,0,0,1,0,2.82l-5.72,5.32A1,1,0,0,1,17,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23056dae;fill-rule:evenodd%27/%3E%3C/svg%3E\")!important}.btn_white_arrow_right:hover,.btn_white_arrow_right:focus{background-color:#056dae;color:#fff;border-color:#056dae;background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E04-glyph-right-white%3C/title%3E%3Cpath d=%27M17,27a1,1,0,0,1-.68-1.73L22,20l-5.66-5.27a1,1,0,0,1,1.36-1.46l5.72,5.32a1.91,1.91,0,0,1,0,2.82l-5.72,5.32A1,1,0,0,1,17,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23ffffff;fill-rule:evenodd%27/%3E%3C/svg%3E\")!important}.btn_blue_hover_arrow_left{background-color:#fff;color:#056dae;border-color:#fff;background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23056dae;fill-rule:evenodd%27/%3E%3C/svg%3E\")!important}.btn_blue_hover_arrow_left:hover,.btn_blue_hover_arrow_left:focus{background-color:#65778a;color:#fff;border-color:#65778a;background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23ffffff;fill-rule:evenodd%27/%3E%3C/svg%3E\")!important}.btn_blue_hover_arrow_right{background-color:#fff;color:#056dae;border-color:#fff;background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E04-glyph-right-white%3C/title%3E%3Cpath d=%27M17,27a1,1,0,0,1-.68-1.73L22,20l-5.66-5.27a1,1,0,0,1,1.36-1.46l5.72,5.32a1.91,1.91,0,0,1,0,2.82l-5.72,5.32A1,1,0,0,1,17,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23056dae;fill-rule:evenodd%27/%3E%3C/svg%3E\")!important}.btn_blue_hover_arrow_right:hover,.btn_blue_hover_arrow_right:focus{background-color:#65778a;color:#fff;border-color:#65778a;background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E04-glyph-right-white%3C/title%3E%3Cpath d=%27M17,27a1,1,0,0,1-.68-1.73L22,20l-5.66-5.27a1,1,0,0,1,1.36-1.46l5.72,5.32a1.91,1.91,0,0,1,0,2.82l-5.72,5.32A1,1,0,0,1,17,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23ffffff;fill-rule:evenodd%27/%3E%3C/svg%3E\")!important}.btn_white_priority_arrow_left{background-color:#fff;color:#0e2a48;border-color:#fff;background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%230e2a48;fill-rule:evenodd%27/%3E%3C/svg%3E\")!important}.btn_white_priority_arrow_left:hover,.btn_white_priority_arrow_left:focus{background-color:#65778a;color:#fff;border-color:#65778a;background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23ffffff;fill-rule:evenodd%27/%3E%3C/svg%3E\")!important}.btn_white_priority_arrow_right{background-color:#fff!important;color:#0e2a48!important;border-color:#fff!important;background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E04-glyph-right-white%3C/title%3E%3Cpath d=%27M17,27a1,1,0,0,1-.68-1.73L22,20l-5.66-5.27a1,1,0,0,1,1.36-1.46l5.72,5.32a1.91,1.91,0,0,1,0,2.82l-5.72,5.32A1,1,0,0,1,17,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%230e2a48;fill-rule:evenodd%27/%3E%3C/svg%3E\")!important}.btn_white_priority_arrow_right:hover,.btn_white_priority_arrow_right:focus{background-color:#65778a!important;color:#fff!important;border-color:#65778a!important;background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E04-glyph-right-white%3C/title%3E%3Cpath d=%27M17,27a1,1,0,0,1-.68-1.73L22,20l-5.66-5.27a1,1,0,0,1,1.36-1.46l5.72,5.32a1.91,1.91,0,0,1,0,2.82l-5.72,5.32A1,1,0,0,1,17,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23ffffff;fill-rule:evenodd%27/%3E%3C/svg%3E\")!important}.btn_gold{background-color:#8e6f32;color:#fff;border-color:#8e6f32}.btn_gold:hover,.btn_gold:focus{background-color:#745b2d;color:#fff;border-color:#745b2d}.btn_gold[disabled],.btn_gold[disabled]:hover,.btn_gold[disabled]:focus,.btn_gold.disabled,.btn_gold.disabled:hover,.btn_gold.disabled:focus{color:#00000080;border-color:#00000080}.btn-primary.btn_gold:active{background-color:#745b2d;color:#fff;border-color:#745b2d}.gold_arrow_right{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E04-glyph-right-white%3C/title%3E%3Cpath d=%27M17,27a1,1,0,0,1-.68-1.73L22,20l-5.66-5.27a1,1,0,0,1,1.36-1.46l5.72,5.32a1.91,1.91,0,0,1,0,2.82l-5.72,5.32A1,1,0,0,1,17,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23ffffff;fill-rule:evenodd%27/%3E%3C/svg%3E\")}.gold_arrow_right:hover,.gold_arrow_right:focus{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E04-glyph-right-white%3C/title%3E%3Cpath d=%27M17,27a1,1,0,0,1-.68-1.73L22,20l-5.66-5.27a1,1,0,0,1,1.36-1.46l5.72,5.32a1.91,1.91,0,0,1,0,2.82l-5.72,5.32A1,1,0,0,1,17,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23ffffff;fill-rule:evenodd%27/%3E%3C/svg%3E\")}.gold_arrow_right[disabled],.gold_arrow_right.disabled{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E04-glyph-right-white%3C/title%3E%3Cpath d=%27M17,27a1,1,0,0,1-.68-1.73L22,20l-5.66-5.27a1,1,0,0,1,1.36-1.46l5.72,5.32a1.91,1.91,0,0,1,0,2.82l-5.72,5.32A1,1,0,0,1,17,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:rgba(0, 0, 0, 0.5);fill-rule:evenodd%27/%3E%3C/svg%3E\")}.btn-primary.gold_arrow_right:active{background-color:#745b2d;color:#fff;border-color:#745b2d}.gold_arrow_left{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23ffffff;fill-rule:evenodd%27/%3E%3C/svg%3E\")}.gold_arrow_left:hover,.gold_arrow_left:focus{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23ffffff;fill-rule:evenodd%27/%3E%3C/svg%3E\")}.gold_arrow_left[disabled],.gold_arrow_left.disabled{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:rgba(0, 0, 0, 0.5);fill-rule:evenodd%27/%3E%3C/svg%3E\")}.btn-primary.gold_arrow_left:active{background-color:#745b2d;color:#fff;border-color:#745b2d}:host-context(.theme-dark,.cta-bg-dark) .btn_gold,.dark.btn_gold{background-color:#fff;color:#8e6f32;border-color:#fff}:host-context(.theme-dark,.cta-bg-dark) .btn_gold:hover,.dark.btn_gold:hover,:host-context(.theme-dark,.cta-bg-dark) .btn_gold:focus,.dark.btn_gold:focus{background-color:#8e6f32;color:#fff;border-color:#8e6f32}:host-context(.theme-dark,.cta-bg-dark) [disabled].btn_gold,[disabled].dark.btn_gold,:host-context(.theme-dark,.cta-bg-dark) .disabled.btn_gold,.disabled.dark.btn_gold{background-color:transparent;color:#fff;border-color:#fff}:host-context(.theme-dark,.cta-bg-dark) .gold_arrow_right,.dark.gold_arrow_right{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E04-glyph-right-white%3C/title%3E%3Cpath d=%27M17,27a1,1,0,0,1-.68-1.73L22,20l-5.66-5.27a1,1,0,0,1,1.36-1.46l5.72,5.32a1.91,1.91,0,0,1,0,2.82l-5.72,5.32A1,1,0,0,1,17,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%238e6f32;fill-rule:evenodd%27/%3E%3C/svg%3E\")}:host-context(.theme-dark,.cta-bg-dark) .gold_arrow_right:hover,.dark.gold_arrow_right:hover,:host-context(.theme-dark,.cta-bg-dark) .gold_arrow_right:focus,.dark.gold_arrow_right:focus{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E04-glyph-right-white%3C/title%3E%3Cpath d=%27M17,27a1,1,0,0,1-.68-1.73L22,20l-5.66-5.27a1,1,0,0,1,1.36-1.46l5.72,5.32a1.91,1.91,0,0,1,0,2.82l-5.72,5.32A1,1,0,0,1,17,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23ffffff;fill-rule:evenodd%27/%3E%3C/svg%3E\")}:host-context(.theme-dark,.cta-bg-dark) [disabled].gold_arrow_right,[disabled].dark.gold_arrow_right,:host-context(.theme-dark,.cta-bg-dark) .disabled.gold_arrow_right,.disabled.dark.gold_arrow_right{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E04-glyph-right-white%3C/title%3E%3Cpath d=%27M17,27a1,1,0,0,1-.68-1.73L22,20l-5.66-5.27a1,1,0,0,1,1.36-1.46l5.72,5.32a1.91,1.91,0,0,1,0,2.82l-5.72,5.32A1,1,0,0,1,17,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23ffffff;fill-rule:evenodd%27/%3E%3C/svg%3E\")}:host-context(.theme-dark,.cta-bg-dark) .gold_arrow_left,.dark.gold_arrow_left{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%238e6f32;fill-rule:evenodd%27/%3E%3C/svg%3E\")}:host-context(.theme-dark,.cta-bg-dark) .gold_arrow_left:hover,.dark.gold_arrow_left:hover,:host-context(.theme-dark,.cta-bg-dark) .gold_arrow_left:focus,.dark.gold_arrow_left:focus{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23ffffff;fill-rule:evenodd%27/%3E%3C/svg%3E\")}:host-context(.theme-dark,.cta-bg-dark) [disabled].gold_arrow_left,[disabled].dark.gold_arrow_left,:host-context(.theme-dark,.cta-bg-dark) .disabled.gold_arrow_left,.disabled.dark.gold_arrow_left{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23ffffff;fill-rule:evenodd%27/%3E%3C/svg%3E\")}.btn-primary.arrow-btn.next[disabled],.btn-primary.arrow-btn.next.disabled{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E04-glyph-right-white%3C/title%3E%3Cpath d=%27M17,27a1,1,0,0,1-.68-1.73L22,20l-5.66-5.27a1,1,0,0,1,1.36-1.46l5.72,5.32a1.91,1.91,0,0,1,0,2.82l-5.72,5.32A1,1,0,0,1,17,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:rgba(0, 0, 0, 0.5);fill-rule:evenodd%27/%3E%3C/svg%3E\")}.btn-primary.arrow-btn.prev[disabled],.btn-primary.arrow-btn.prev.disabled{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:rgba(0, 0, 0, 0.5);fill-rule:evenodd%27/%3E%3C/svg%3E\")}.secondary{text-decoration:none;white-space:normal}a.secondary.cta-link,a.cta-link-router{text-decoration:underline}a.cta-link-router.btn-primary{text-decoration:none}.btn-link.btn-icon:before{content:\"\";left:-20px;top:4px;height:12px;width:12px;background-repeat:no-repeat;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 14'%3E%3Cpath d='M26,19H21V14a1,1,0,0,0-2,0v5H14a1,1,0,0,0,0,2h5v5a1,1,0,0,0,2,0V21h5a1,1,0,0,0,0-2' transform='translate(-13 -13)' style='fill:%23056DAE;fill-rule:evenodd'/%3E%3C/svg%3E\")}.btn-link.btn-icon:hover,.btn-link.btn-icon:focus{text-decoration:underline}.btn-link.btn-icon:hover:before,.btn-link.btn-icon:focus:before{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 14'%3E%3Cpath d='M26,19H21V14a1,1,0,0,0-2,0v5H14a1,1,0,0,0,0,2h5v5a1,1,0,0,0,2,0V21h5a1,1,0,0,0,0-2' transform='translate(-13 -13)' style='fill:%23002a54;fill-rule:evenodd'/%3E%3C/svg%3E\")}.btn-link.btn-icon[disabled],.btn-link.btn-icon.disabled{color:#00000080;cursor:default;opacity:.65}.btn-link.btn-icon[disabled]:before,.btn-link.btn-icon.disabled:before{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 14 14%27%3E%3Cpath d=%27M26,19H21V14a1,1,0,0,0-2,0v5H14a1,1,0,0,0,0,2h5v5a1,1,0,0,0,2,0V21h5a1,1,0,0,0,0-2%27 transform=%27translate(-13 -13)%27 style=%27fill:rgba(0, 0, 0, 0.5);fill-rule:evenodd%27/%3E%3C/svg%3E\")}.btn-link.btn-icon[disabled]:hover,.btn-link.btn-icon[disabled]:focus,.btn-link.btn-icon.disabled:hover,.btn-link.btn-icon.disabled:focus{text-decoration:none}a.btn-icon.cta-link,a.cta-link-router.btn-link.btn-icon{text-decoration:underline}:host-context(.theme-dark) .secondary:hover,:host-context(.theme-dark) .secondary:focus{text-decoration:underline}.noMargin{margin:0}.chevron-link.chevron-link,.chevron-link.chevron-link:hover,.chevron-link.chevron-link:focus,.chevron-link.chevron-link.bold,.chevron-link.chevron-link.bold:hover,.chevron-link.chevron-link.bold:focus{background-image:none;margin-right:0}.chevron-link.chevron-link:after{content:\"\\a0\";background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E04-glyph-right-white%3C/title%3E%3Cpath d=%27M17,27a1,1,0,0,1-.68-1.73L22,20l-5.66-5.27a1,1,0,0,1,1.36-1.46l5.72,5.32a1.91,1.91,0,0,1,0,2.82l-5.72,5.32A1,1,0,0,1,17,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23056dae;fill-rule:evenodd%27/%3E%3C/svg%3E\");background-repeat:no-repeat;background-color:transparent;background-position:top 50% right 0;display:inline-block;margin-left:6px}.chevron-link.chevron-link:hover:after,.chevron-link.chevron-link:focus:after{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E04-glyph-right-white%3C/title%3E%3Cpath d=%27M17,27a1,1,0,0,1-.68-1.73L22,20l-5.66-5.27a1,1,0,0,1,1.36-1.46l5.72,5.32a1.91,1.91,0,0,1,0,2.82l-5.72,5.32A1,1,0,0,1,17,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23002a54;fill-rule:evenodd%27/%3E%3C/svg%3E\")}.chevron-link.chevron-link.bold:after{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%276.25px%27 height=%2711.25px%27 viewBox=%270 0 5 9%27%3E%3Cg transform=%27translate(-1274.000000, -1120.000000)%27 fill=%27%23056dae%27 %3E%3Cpath d=%27M1278.93387,1124.67494 L1278.93387,1123.48506 L1274.744,1120.08 L1274.744,1122.26987 L1277.11109,1124.09266 L1274.744,1125.90278 L1274.744,1128.08 L1278.93387,1124.67494 Z%27 /%3E%3C/g%3E%3C/svg%3E\")}.chevron-link.chevron-link.bold:hover:after,.chevron-link.chevron-link.bold:focus:after{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%276.25px%27 height=%2711.25px%27 viewBox=%270 0 5 9%27%3E%3Cg transform=%27translate(-1274.000000, -1120.000000)%27 fill=%27%23002a54%27 %3E%3Cpath d=%27M1278.93387,1124.67494 L1278.93387,1123.48506 L1274.744,1120.08 L1274.744,1122.26987 L1277.11109,1124.09266 L1274.744,1125.90278 L1274.744,1128.08 L1278.93387,1124.67494 Z%27 /%3E%3C/g%3E%3C/svg%3E\")}.chevron-link.chevron-link.disabled:after{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E04-glyph-right-white%3C/title%3E%3Cpath d=%27M17,27a1,1,0,0,1-.68-1.73L22,20l-5.66-5.27a1,1,0,0,1,1.36-1.46l5.72,5.32a1.91,1.91,0,0,1,0,2.82l-5.72,5.32A1,1,0,0,1,17,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:rgba(0, 0, 0, 0.5);fill-rule:evenodd%27/%3E%3C/svg%3E\")}.chevron-link.chevron-link.disabled:hover:after,.chevron-link.chevron-link.disabled:focus:after{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E04-glyph-right-white%3C/title%3E%3Cpath d=%27M17,27a1,1,0,0,1-.68-1.73L22,20l-5.66-5.27a1,1,0,0,1,1.36-1.46l5.72,5.32a1.91,1.91,0,0,1,0,2.82l-5.72,5.32A1,1,0,0,1,17,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:rgba(0, 0, 0, 0.5);fill-rule:evenodd%27/%3E%3C/svg%3E\")}.chevron-link.chevron-link.disabled.bold:after{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%276.25px%27 height=%2711.25px%27 viewBox=%270 0 5 9%27%3E%3Cg transform=%27translate(-1274.000000, -1120.000000)%27 fill=%27rgba(0, 0, 0, 0.5)%27 %3E%3Cpath d=%27M1278.93387,1124.67494 L1278.93387,1123.48506 L1274.744,1120.08 L1274.744,1122.26987 L1277.11109,1124.09266 L1274.744,1125.90278 L1274.744,1128.08 L1278.93387,1124.67494 Z%27 /%3E%3C/g%3E%3C/svg%3E\")}.chevron-link.chevron-link.disabled.bold:hover:after,.chevron-link.chevron-link.disabled.bold:focus:after{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%276.25px%27 height=%2711.25px%27 viewBox=%270 0 5 9%27%3E%3Cg transform=%27translate(-1274.000000, -1120.000000)%27 fill=%27rgba(0, 0, 0, 0.5)%27 %3E%3Cpath d=%27M1278.93387,1124.67494 L1278.93387,1123.48506 L1274.744,1120.08 L1274.744,1122.26987 L1277.11109,1124.09266 L1274.744,1125.90278 L1274.744,1128.08 L1278.93387,1124.67494 Z%27 /%3E%3C/g%3E%3C/svg%3E\")}.chevron-link.chevron-link.left:after{display:none}.chevron-link.chevron-link.left:before{content:\"\\a0\";background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23056dae;fill-rule:evenodd%27/%3E%3C/svg%3E\");background-repeat:no-repeat;background-color:transparent;background-position:top 50% left 0;display:inline-block;margin-right:6px}.chevron-link.chevron-link.left:hover:before,.chevron-link.chevron-link.left:focus:before{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23002a54;fill-rule:evenodd%27/%3E%3C/svg%3E\")}.chevron-link.chevron-link.left.bold:before{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23056dae;fill-rule:evenodd%27/%3E%3C/svg%3E\")}.chevron-link.chevron-link.left.bold:hover:before,.chevron-link.chevron-link.left.bold:focus:before{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23002a54;fill-rule:evenodd%27/%3E%3C/svg%3E\")}.chevron-link.chevron-link.left.disabled:before{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:rgba(0, 0, 0, 0.5);fill-rule:evenodd%27/%3E%3C/svg%3E\")}.chevron-link.chevron-link.left.disabled:hover:before,.chevron-link.chevron-link.left.disabled:focus:before{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:rgba(0, 0, 0, 0.5);fill-rule:evenodd%27/%3E%3C/svg%3E\")}:host-context(.theme-dark) .chevron-link,:host-context(.theme-dark) .chevron-link:hover,:host-context(.theme-dark) .chevron-link:focus,:host-context(.theme-dark) .chevron-link.bold,:host-context(.theme-dark) .chevron-link.bold:hover,:host-context(.theme-dark) .chevron-link.bold:focus{background-image:none;margin-right:0}:host-context(.theme-dark) .chevron-link:after{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E04-glyph-right-white%3C/title%3E%3Cpath d=%27M17,27a1,1,0,0,1-.68-1.73L22,20l-5.66-5.27a1,1,0,0,1,1.36-1.46l5.72,5.32a1.91,1.91,0,0,1,0,2.82l-5.72,5.32A1,1,0,0,1,17,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23ffffff;fill-rule:evenodd%27/%3E%3C/svg%3E\")}:host-context(.theme-dark) .chevron-link.bold:after{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%276.25px%27 height=%2711.25px%27 viewBox=%270 0 5 9%27%3E%3Cg transform=%27translate(-1274.000000, -1120.000000)%27 fill=%27%23ffffff%27 %3E%3Cpath d=%27M1278.93387,1124.67494 L1278.93387,1123.48506 L1274.744,1120.08 L1274.744,1122.26987 L1277.11109,1124.09266 L1274.744,1125.90278 L1274.744,1128.08 L1278.93387,1124.67494 Z%27 /%3E%3C/g%3E%3C/svg%3E\")}:host-context(.theme-dark) .chevron-link.left:before{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23ffffff;fill-rule:evenodd%27/%3E%3C/svg%3E\")}:host-context(.theme-dark) .chevron-link.left.bold:before{background-image:url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8.02 14%27%3E%3Ctitle%3E03-glyph-left-white%3C/title%3E%3Cpath d=%27M23,27a1,1,0,0,1-.68-.27l-5.72-5.32a1.91,1.91,0,0,1,0-2.82l5.72-5.32a1,1,0,1,1,1.36,1.46L18,20l5.66,5.27a1,1,0,0,1,0,1.41A1,1,0,0,1,23,27%27 transform=%27translate(-15.99 -13)%27 style=%27fill:%23ffffff;fill-rule:evenodd%27/%3E%3C/svg%3E\")}\n"] }]
        }], ctorParameters: () => [{ type: Object, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: i0.ChangeDetectorRef }, { type: i1$2.DomSanitizer }], propDecorators: { button: [{
                type: ViewChild,
                args: ['button']
            }], textAlign: [{
                type: Input$1
            }], bold: [{
                type: Input$1
            }], noMargin: [{
                type: Input$1
            }], tabIndex: [{
                type: Input$1
            }], ariaDescription: [{
                type: Input$1
            }], ariaLabeledBy: [{
                type: Input$1
            }], ariaHasPopup: [{
                type: Input$1
            }], ariaRole: [{
                type: Input$1
            }], ariaLabel: [{
                type: Input$1
            }], ariaControls: [{
                type: Input$1
            }], ariaExpanded: [{
                type: Input$1
            }], router: [{
                type: Input$1
            }], queryParams: [{
                type: Input$1
            }], idStr: [{
                type: Input$1
            }], dataTarget: [{
                type: Input$1
            }], addJFPToken: [{
                type: Input$1
            }], doNotAddJFPToken: [{
                type: Input$1
            }], buttonType: [{
                type: Input$1
            }], target: [{
                type: Input$1
            }], href: [{
                type: Input$1
            }], value: [{
                type: Input$1
            }], disabled: [{
                type: Input$1
            }], type: [{
                type: Input$1
            }], size: [{
                type: Input$1
            }], arrow: [{
                type: Input$1
            }], leftArrow: [{
                type: Input$1
            }], ctaClick: [{
                type: Output
            }], disabledChange: [{
                type: Output
            }], ctaFocus: [{
                type: Output
            }], ctaBlur: [{
                type: Output
            }], onFocus: [{
                type: HostListener,
                args: ['focus', ['$event']]
            }] } });

const COMPONENTS$17 = [CTAComponent];
const MODULES$1b = [CommonModule, RouterModule];
class CTA {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CTA, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: CTA, declarations: [CTAComponent], imports: [CommonModule, RouterModule], exports: [CTAComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CTA, imports: [MODULES$1b] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CTA, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$1b],
                    declarations: [...COMPONENTS$17],
                    exports: [...COMPONENTS$17]
                }]
        }] });

/**
 * Converts boolean string to boolean for @Input()
 * @type decorator
 */
function Boolish(target, property) {
    let val;
    return {
        set: (value) => {
            if (typeof value == 'boolean')
                val = value;
            else if (typeof value == 'string' && value !== '')
                val = (value == 'false') ? false : true;
            else if (typeof value == 'number')
                val = !!value;
            else
                val = target[property];
        },
        get: () => val,
        enumerable: true,
        configurable: true
    };
}
;

function androidPlatformCheck(platform) {
    if ((platform === 'Linux armv8l') ||
        (platform === 'Linux armv7l') ||
        (platform === 'Android') ||
        (platform.toLowerCase().trim() === 'linuxarmv7l') ||
        (platform.toLowerCase().trim() === 'linuxarmv8l') ||
        (platform.toLowerCase().trim() === 'android')) {
        return true;
    }
    return false;
}

function hasClass$1(el, className) {
    if (el.classList) {
        return el.classList.contains(className);
    }
    else {
        return !!el.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'));
    }
}

function addClass$1(el, className) {
    if (el.classList) {
        el.classList.add(className);
    }
    else if (!hasClass$1(el, className)) {
        el.className += ' ' + className;
    }
}

function addStyle(el, styleMap) {
    for (const style in styleMap) {
        if (style) {
            el.style[style] = styleMap[style];
        }
    }
}

function coerceBool(val) {
    if (typeof val === 'boolean')
        return val;
    else if (!val || val == 'false')
        return false;
    else if (val == 'true')
        return true;
    else
        console.error(`Expected a boolean but received ${val}`);
}

function changePageTitleAndSetFocus(title) {
    // Get the body tag
    const bodyTag = document.getElementsByTagName('body')[0];
    // Get the title tag
    const titleTag = document.getElementsByTagName('title')[0];
    // Set the new title if there is one
    if (typeof title === 'string' && title.length) {
        titleTag.innerHTML = title;
    }
    // Add tabindex and aria-live to body tag, and then set focus on the body tag
    bodyTag.tabIndex = -1;
    bodyTag.setAttribute('aria-live', 'assertive');
    bodyTag.focus();
}

/**
 * @name executeOnStable
 * @description Waits until the microtask queue is empty and then executes code. Less hacky than setTimout and doesn't force another digest
 * @param NgZone ngZone the local NgZone context
 * @param Function func The code to execute
 * @example
 * executeOnStable(this.ngZone, () => this.input.nativeElement.focus())
 */
function executeOnStable(ngZone, func) {
    ngZone.runOutsideAngular(() => {
        ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => func());
    });
}

function closestByClass(el, clazz) {
    while (!el.classList.contains(clazz)) {
        el = el.parentNode;
        if (!el) {
            return null;
        }
    }
    return el;
}

function decodeString(string) {
    const el = document.createElement('textarea');
    el.innerHTML = string;
    return el.value;
}

function findUpTag(el, tag) {
    while (el.parentNode) {
        el = el.parentNode;
        if (el.tagName === tag)
            return el;
    }
    return null;
}

/**
 * This method is like `findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Number} Returns the index of the found element, else `-1`.
 * @example
 *
 * const users = [
  *   { 'user': 'barney',  'active': true },
  *   { 'user': 'pebbles', 'active': true }
  *   { 'user': 'fred',    'active': false },
  *   { 'user': 'pebbles', 'active': false }
  * ]
  *
  * findLastIndex(users, ({ user }) => user == 'pebbles')  => 3
  */
function findLastIndex(array, predicate) {
    const length = array == null ? 0 : array.length;
    if (!length)
        return -1;
    return baseFindIndex(array, predicate, length - 1, true);
}
function baseFindIndex(array, predicate, fromIndex = 0, fromRight = false) {
    const { length } = array;
    let index = fromIndex + (fromRight ? 1 : -1);
    while ((fromRight ? index-- : ++index < length)) {
        if (predicate(array[index], index, array))
            return index;
    }
    return -1;
}

/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @param Array|Object array The array to iterate over.
 * @param Function iteratee The function invoked per iteration.
 * @returns Array Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
  *   return [n, n]
  * }
  *
  * flatMap([1, 2], duplicate)
  * // => [1, 1, 2, 2]
  */
function flatMap$1(array, iteratee) {
    return array.reduce((cumulus, next) => [...iteratee(next), ...cumulus], []);
}

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`.
 *
 * @param {Array} array The collection to iterate over.
 * @param {Function} key The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * groupBy([{fname: 'Michael', lname: 'Jordan'}, {fname: 'Michael', lname: 'Jackson'}, {fname: 'Pee Wee', lname: 'Herman'}], 'fname')
 * // => {
 *         'Michael': [{fname: 'Michael', lname: 'Jordan'}, {fname: 'Michael', lname: 'Jackson'}],
 *         'Pee Wee': [{fname: 'Pee Wee', lname: 'Herman'}] }
 */
function groupBy(array, key) {
    return array.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
}
;

/**
 * adds a character to a string at a specifed index
 *
 * @param String string The string to which a character should be added
 * @param String char The character to be added
 * @param Index index The index of the character to remove
 * @returns String Returns the string with the index removed.
 * @example
 *
 * const thur = 'Thursday'
 *
 * removeCharAt(2)
 * // => Thrsday
 */
function insertCharAt(string = '', char, index) {
    return string.substring(0, index) + char + string.substring(index);
}

/**
 * Determines if the given value is an array type
 *
 * @param Any any value to test
 * @returns Boolean Returns true if value is an array type
 * @example
 *
 * const arrayValue = ['1', '2']
 *
 * isArray(arrayValue)
 * // => true
 */
function isArray(value) {
    return typeof value !== 'undefined' && value.constructor === Array;
}

/**
 * Determines if value can be coersed to be a boolean
 *
 * @param Any value the value to test
 * @returns Boolean Returns true if the value is boolish
 * @example
 *
 * isBoolish(true);     // true
 * isBoolish('false');  // true
 * isBoolish('hello');  // false
 * isBoolish(0);        // false
 */
function isBoolish(value) {
    return typeof value === 'boolean' || value === 'true' || value === 'false';
}

/**
 * Determines if a value is defined for all types
 *
 * @param Array|Object array The array to iterate over.
 * @param Function iteratee The function invoked per iteration.
 * @returns Array Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
  *   return [n, n]
  * }
  *
  * flatMap([1, 2], duplicate)
  * // => [1, 1, 2, 2]
  */
function isDefined(value) {
    return !!value
        && value !== 'null'
        && value !== 'undefined'
        && value.toString().length > 0;
}

/**
 * Determines if an object has any members
 *
 * @param Array|Object array The array to iterate over.
 * @returns Boolean Returns true if an object has properties
 * @example
 *
 * isEmptyObject({}); // true
 * isEmptyObject({foo:'bar'});  // false
 */
function isEmptyObject(obj) {
    for (const prop in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, prop))
            return false;
    }
    return true;
}

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @param Array|Object collection The collection to iterate over.
 * @param Function iteratee The iteratee to transform keys.
 * @returns Object Returns the composed aggregate object.
 * @example
 *
 * const array = [
  *   { 'dir': 'left', 'code': 97 },
  *   { 'dir': 'right', 'code': 100 }
  * ]
  *
  * keyBy(array, ({ code }) => String.fromCharCode(code))
  * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
  */
function keyBy(array, key) {
    const collection = {};
    array.forEach(item => {
        collection[item[key]] = item;
    });
    return collection;
}

/**
 * @name merge
 * @description
 * @param
 * @param
 * @example
 * // Merge the modifier with the branding data
 * brandingData = merge(brandingData, modifierOnError);
 *
 */
function merge(source, modifier) {
    // For each property in the modifier
    for (let property in modifier) {
        // Try to set the property of the existing object if it already exists
        try {
            // If the source property is another object
            if (modifier[property].constructor == Object) {
                // Recursively run merge on that object as well
                source[property] = this.merge(source[property], modifier[property]);
            }
            else {
                // Otherwise simply update the property with the new value
                source[property] = modifier[property];
            }
            // Catch when the property is not already set on the source object
        }
        catch (e) {
            // And set the property on the source object
            source[property] = modifier[property];
        }
    }
    // Return the resulting object
    return source;
}

/**
 * @name mergeObjects
 * @description
 * @param
 * @param
 * @example
 *
 */
function mergeObjects(obj1, obj2) {
    const keys = Object.keys(obj2);
    for (let j = 0; j < keys.length; j += 1) {
        obj1[keys[j]] = obj2[keys[j]];
    }
    return obj1;
}

function removeClass(el, className) {
    if (el.classList) {
        el.classList.remove(className);
    }
    else if (hasClass$1(el, className)) {
        const reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
        el.className = el.className.replace(reg, ' ');
    }
}

/**
 * removes a character from a string at a specifed index
 *
 * @param String string The string from which to remove a character
 * @param Number index The index of the character to remove
 * @returns String Returns the string with the index removed.
 * @example
 *
 * const thur = 'Thursday'
 *
 * removeCharAt(2)
 * // => Thrsday
 */
function removeCharAt(string, index) {
    return string.substring(0, index) + string.substring(index + 1);
}

/**
 * reverses the order of the characters in a string
 *
 * @param Array string The string to reverse.
 * @returns Number Returns the reversed string.
 * @example
 *
 * const thur = 'Thursday'
 *
 * reverseString(thur)
 * // => yadsruht
 */
function reverseString(string) {
    return string.split('').reverse().join('');
}

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @param object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
  *   this.a = 1
  *   this.b = 2
  * }
  *
  * Foo.prototype.c = 3
  *
  * values(new Foo)
  * // => [1, 2] (iteration order is not guaranteed)
  *
  * values('hi')
  * // => ['h', 'i']
  */
function values(obj) {
    const result = [];
    for (const item in obj) {
        if (obj[item])
            result.push(obj[item]);
    }
    return result;
}

/**
 * Gets an array of predecessor elements until you reach a specific element
 * @param node pass in the node to find its predecessors
 * @param [selector] limits the array of predecessors to the closest element matching the selector
 * @returns array of predecessor elements of the provided node, until it reaches the element matching the selector
 */
function getElementParentsUntil(node, selector) {
    const parentElements = [];
    let parent = node.parentElement;
    while (parent) {
        if (selector &&
            parent?.closest &&
            parent?.closest(selector) === parent) {
            break;
        }
        if (parent.nodeType === 1) {
            parentElements.unshift(parent);
        }
        parent = parent.parentElement;
    }
    return parentElements;
}
/**
 * Gets an array of all predecessor elements
 * @param node pass in the node to find its predecessors
 * @returns array of predecessor elements of the provided node
 */
function getElementParents(node) {
    return getElementParentsUntil(node);
}

/**
 * Gets element children
 * @param parentNode pass in the node to get it's children
 * @param [skipChildNodes] the child node (or array of node children) you want to skip (optional)
 * @returns an array of the child elements of the supplied node
 */
function getElementChildren(parentNode, skipChildNodes) {
    const returnChildren = [];
    if (!parentNode) {
        return returnChildren;
    }
    let child = parentNode.firstChild;
    while (child) {
        const isSkipped = Array.isArray(skipChildNodes)
            ? skipChildNodes.includes(child)
            : skipChildNodes === child;
        // check for Element type and if skipped
        if (child.nodeType === 1 && !isSkipped) {
            returnChildren.push(child);
        }
        child = child.nextSibling;
    }
    return returnChildren;
}

/**
 * Gets element siblings
 * @param node pass in the node to find it's siblings
 * @returns an array of the sibling elements
 */
function getElementSiblings(node) {
    return getElementChildren(node.parentNode, [node]);
}

class DdlAriaHideOuterDomDirective {
    // #endregion
    // #region ========== Constructor / Lifecycle Hooks ========== //
    constructor(el, _renderer) {
        this.el = el;
        this._renderer = _renderer;
        // #region ========== Properties ========== //
        this._parentalSiblings = [];
        /**
         * Array of CSS selectors that should be excluded from having aria-hidden applied
         * @default '.cdk-live-announcer-element' live announcer should not be hidden from screen readers
         */
        this.outerDomExceptions = ['.cdk-live-announcer-element', '.ddl-live-announcer-element'];
    }
    ngOnChanges(simpleChanges) {
        for (const propName in simpleChanges) {
            if (simpleChanges.hasOwnProperty(propName)) {
                const change = simpleChanges[propName];
                if (propName === 'isOuterDomAriaHidden' && !change.isFirstChange()) {
                    if (this.isOuterDomAriaHidden) {
                        this._ariaHideParentalSiblings();
                    }
                    else {
                        this._ariaRestoreParentalSiblings();
                    }
                }
            }
        }
    }
    ngAfterViewInit() {
        if (this.isOuterDomAriaHidden) {
            this._ariaHideParentalSiblings();
        }
    }
    ngOnDestroy() {
        this._ariaRestoreParentalSiblings();
    }
    // #endregion
    // #region ========== Public Methods ========== //
    show() {
        this._ariaRestoreParentalSiblings();
    }
    hide() {
        this._ariaHideParentalSiblings();
    }
    // #endregion
    // #region ========== Private Methods ========== //
    _ariaHideParentalSiblings() {
        // This method should not be run again when _parentalSiblings array is not empty.
        // However, in case it is, we need to clear it first before running again.
        if (this._parentalSiblings.length) {
            this._ariaRestoreParentalSiblings();
        }
        getElementSiblings(this.el.nativeElement).forEach(sibling => {
            if (!this._isElementExcluded(sibling)) {
                this._applyAriaHidden(sibling);
            }
        });
        getElementParentsUntil(this.el.nativeElement, 'body').forEach(parent => {
            getElementSiblings(parent).forEach(sibling => {
                if (!this._isElementExcluded(sibling)) {
                    this._applyAriaHidden(sibling);
                }
            });
        });
    }
    _applyAriaHidden(el) {
        const currentAriaHiddenAttribute = el.getAttribute('aria-hidden');
        // first store element's attribute value for aria-hidden
        this._parentalSiblings.push({
            element: el,
            attributeName: 'aria-hidden',
            previousAttributeValue: currentAriaHiddenAttribute
        });
        // now set aria-hidden to false
        this._renderer.setAttribute(el, 'aria-hidden', 'true');
    }
    _ariaRestoreParentalSiblings() {
        this._parentalSiblings.forEach(parentSibling => {
            if (parentSibling.previousAttributeValue) {
                this._renderer.setAttribute(parentSibling.element, parentSibling.attributeName, parentSibling.previousAttributeValue);
            }
            else {
                this._renderer.removeAttribute(parentSibling.element, parentSibling.attributeName);
            }
        });
        // after resetting values, clear array
        this._parentalSiblings.length = 0;
    }
    _isElementExcluded(el) {
        return el.matches(this.outerDomExceptions.join(','));
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: DdlAriaHideOuterDomDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.5", type: DdlAriaHideOuterDomDirective, isStandalone: false, selector: "[ddlAriaHideOuterDom]", inputs: { isOuterDomAriaHidden: "isOuterDomAriaHidden", outerDomExceptions: "outerDomExceptions" }, exportAs: ["ddlAriaHideOuterDom"], usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: DdlAriaHideOuterDomDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[ddlAriaHideOuterDom]',
                    standalone: false,
                    exportAs: 'ddlAriaHideOuterDom'
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.Renderer2 }], propDecorators: { isOuterDomAriaHidden: [{
                type: Input$1
            }], outerDomExceptions: [{
                type: Input$1
            }] } });

/**
* @Component: JAMP
* @description This component generates a JAMP (Just A Moment Please) element that can be shown during loading
*/
class JampComponent {
    set useGif(value) {
        this._useGif = value;
        this.loadingClass = this._useGif ? '' : 'loading';
    }
    ;
    get useGif() { return this._useGif; }
    ;
    set visible(show) {
        this._visible = coerceBool(show);
        if (!!this._visible !== !this.isHidden) {
            if (this._visible) {
                this.show();
            }
            else {
                this.hide();
            }
        }
    }
    get visible() { return this._visible; }
    ;
    /**
    * @property pagelevel
    * @description Whether JAMP fills the entire window instead of just its immediate container
    * @Type: boolean
    */
    set pagelevel(value) {
        this.isPageLevel = value;
    }
    ;
    get pagelevel() { return this.isPageLevel; }
    ;
    /**
    * @property additionalCssClasses
    * @description Adds the given string as additional classes to the class attribute of the jamp. This will replaces
    * any CSS classes not in DDL standard with the string provided in the parameter.
    * @return string
    * @twoway false
    */
    set additionalCssClasses(value) {
        this._additionalCssClasses = value;
        this.updateCssClasses();
    }
    get additionalCssClasses() {
        return this._additionalCssClasses;
    }
    // #endregion
    // #region ========== Constructor / LifeCycle Hooks ========== //
    constructor(announcer, _doc, _renderer) {
        this.announcer = announcer;
        this._doc = _doc;
        this._renderer = _renderer;
        // #region ========== Properties ========== //
        this.jampCssClass = '';
        this.loadingClass = '';
        this._additionalCssClasses = '';
        // #endregion
        // #region ========== HostBinding ========== //
        // Set classes on host <citi-jamp> tag
        this.isHidden = true;
        this.isPageLevel = false;
        this._document = this._doc;
    }
    ngOnInit() {
        // if both are set to true on init, then this makes sure it shows up correctly
        if (this.pagelevel && this.visible) {
            this.isHidden = true;
            this.show();
        }
        this.updateCssClasses();
    }
    ngOnDestroy() {
        this._setBodyAttributes(false);
    }
    // #endregion
    // #region ========== Methods ========== //
    updateCssClasses() {
        const classSet = this._additionalCssClasses.split(' ');
        classSet.push('jamp-css');
        if (this.isCenterAligned)
            classSet.push('jamp-center-css');
        this.jampCssClass = classSet.join(' ');
    }
    /**
    * @name show
    * @description Makes the JAMP visible.
    * @return Void
    */
    show() {
        if (this.isHidden) {
            this.isHidden = false;
            if (this.isPageLevel) {
                this._previousFocusedElement = this._document.activeElement;
                this._isPageLevelJampVisible = true;
                this._setBodyAttributes(this._isPageLevelJampVisible);
                setTimeout(() => {
                    this.jampPageLevelContent?.nativeElement?.focus();
                    this._isDomAriaHidden = true;
                }, 100);
            }
            else {
                this.announcer.announce(this.waitMessage, 200);
            }
        }
    }
    /**
    * @name show
    * @description Makes the JAMP hidden.
    * @return Void
    */
    hide() {
        if (!this.isHidden) {
            this.announcer.announce(this.readyMessage, 200);
            this.isHidden = true;
            this._isDomAriaHidden = false;
            if (this.isPageLevel) {
                this._setBodyAttributes(!this.isHidden);
                setTimeout(() => {
                    this._previousFocusedElement?.focus();
                    this._isPageLevelJampVisible = false;
                }, 10);
            }
        }
    }
    _setBodyAttributes(isJampVisible) {
        if (isJampVisible && this.isPageLevel) {
            this._renderer.addClass(this._document.body, 'ddl-jamp-open');
        }
        else {
            this._renderer.removeClass(this._document.body, 'ddl-jamp-open');
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: JampComponent, deps: [{ token: i1$3.LiveAnnouncer }, { token: DOCUMENT }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: JampComponent, isStandalone: false, selector: "citi-jamp", inputs: { useGif: "useGif", visible: "visible", pagelevel: "pagelevel", htmlContent: "htmlContent", additionalCssClasses: "additionalCssClasses", waitMessage: "waitMessage", readyMessage: "readyMessage", isCenterAligned: "isCenterAligned" }, host: { properties: { "class.hidden": "this.isHidden", "class.jamp-page-level": "this.isPageLevel" } }, viewQueries: [{ propertyName: "jampPageLevelContent", first: true, predicate: ["jampPageLevelContent"], descendants: true }], ngImport: i0, template: `
    <div class="fillHeight" *ngIf="!isPageLevel; else pageLevelJamp">
      <div class="alignmentEl fillHeight" [ngClass]="(isCenterAligned ? 'position-initial' : '')">
        <div class="jamp {{jampCssClass}}">
          <div class="img {{loadingClass}}" role="img" [attr.aria-label]="waitMessage"></div>
          <div class="message" [contentHtml]="htmlContent">
            <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
          </div>
        </div>
      </div>
    </div>
    <ng-template #pageLevelJamp>
      <div class="fillHeight" *ngIf="_isPageLevelJampVisible" ddlAriaHideOuterDom [isOuterDomAriaHidden]="_isDomAriaHidden">
        <div class="alignmentEl fillHeight" [ngClass]="(isCenterAligned ? 'position-initial' : '')" cdkTrapFocus>
          <div #jampPageLevelContent class="jamp {{jampCssClass}}" tabindex="0" role="dialog">
            <div class="img {{loadingClass}}" role="img" [attr.aria-label]="waitMessage"></div>
            <div class="message" [contentHtml]="htmlContent">
              <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template #contentTemplate><ng-content></ng-content></ng-template>
    `, isInline: true, styles: [".jamp.white .message{color:#fff}.jamp .img{background-position:0 0;background-repeat:no-repeat;background-size:contain;padding-top:5px;margin-right:3px;width:30px;height:30px;display:inline-block}.jamp .message{position:relative;top:-9px}.jamp.jamp-css .loading{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3C%21--%20Generator%3A%20Adobe%20Illustrator%2019.1.0%2C%20SVG%20Export%20Plug-In%20.%20SVG%20Version%3A%206.00%20Build%200%29%20%20--%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2030%2030%22%20style%3D%22enable-background%3Anew%200%200%2030%2030%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text/css%22%3E%0A%09.Drop_x0020_Shadow%7Bfill%3Anone%3B%7D%0A%09.Round_x0020_Corners_x0020_2_x0020_pt%7Bfill%3A%23FFFFFF%3Bstroke%3A%23000000%3Bstroke-miterlimit%3A10%3B%7D%0A%09.Live_x0020_Reflect_x0020_X%7Bfill%3Anone%3B%7D%0A%09.Bevel_x0020_Soft%7Bfill%3Aurl%28%23SVGID_1_%29%3B%7D%0A%09.Dusk%7Bfill%3A%23FFFFFF%3B%7D%0A%09.Foliage_GS%7Bfill%3A%23FFDD00%3B%7D%0A%09.Pompadour_GS%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3Bfill%3A%2344ADE2%3B%7D%0A%09.st0%7Bfill%3Anone%3B%7D%0A%09.st1%7Bfill%3A%23056EAE%3B%7D%0A%3C/style%3E%0A%3ClinearGradient%20id%3D%22SVGID_1_%22%20gradientUnits%3D%22userSpaceOnUse%22%20x1%3D%220%22%20y1%3D%220%22%20x2%3D%220.7071%22%20y2%3D%220.7071%22%3E%0A%09%3Cstop%20%20offset%3D%220%22%20style%3D%22stop-color%3A%23DEDFE3%22/%3E%0A%09%3Cstop%20%20offset%3D%220.1738%22%20style%3D%22stop-color%3A%23D8D9DD%22/%3E%0A%09%3Cstop%20%20offset%3D%220.352%22%20style%3D%22stop-color%3A%23C9CACD%22/%3E%0A%09%3Cstop%20%20offset%3D%220.5323%22%20style%3D%22stop-color%3A%23B4B5B8%22/%3E%0A%09%3Cstop%20%20offset%3D%220.7139%22%20style%3D%22stop-color%3A%23989A9C%22/%3E%0A%09%3Cstop%20%20offset%3D%220.8949%22%20style%3D%22stop-color%3A%23797C7E%22/%3E%0A%09%3Cstop%20%20offset%3D%221%22%20style%3D%22stop-color%3A%23656B6C%22/%3E%0A%3C/linearGradient%3E%0A%3Cg%3E%0A%09%3Crect%20x%3D%220%22%20class%3D%22st0%22%20width%3D%2230%22%20height%3D%2230%22/%3E%0A%09%3Cpath%20class%3D%22st1%22%20d%3D%22M2.2%2C17.5C2.1%2C16.7%2C2%2C15.8%2C2%2C15C2%2C7.8%2C7.8%2C2%2C15%2C2s13%2C5.8%2C13%2C13c0%2C0.8-0.1%2C1.7-0.2%2C2.5h2%0A%09%09c0.1-0.8%2C0.2-1.6%2C0.2-2.5c0-8.3-6.7-15-15-15S0%2C6.7%2C0%2C15c0%2C0.8%2C0.1%2C1.7%2C0.2%2C2.5H2.2z%22/%3E%0A%3C/g%3E%0A%3C/svg%3E%0A);background-repeat:no-repeat;animation:spin 1.16s infinite linear}.jamp.jamp-css.white .loading{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3C%21--%20Generator%3A%20Adobe%20Illustrator%2019.2.1%2C%20SVG%20Export%20Plug-In%20.%20SVG%20Version%3A%206.00%20Build%200%29%20%20--%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2030%2030%22%20style%3D%22enable-background%3Anew%200%200%2030%2030%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text/css%22%3E%0A%09.st0%7Bfill%3Anone%3B%7D%0A%09.st1%7Bfill%3A%23FFFFFF%3B%7D%0A%3C/style%3E%0A%3Cg%3E%0A%09%3Crect%20class%3D%22st0%22%20width%3D%2230%22%20height%3D%2230%22/%3E%0A%09%3Cpath%20class%3D%22st1%22%20d%3D%22M2.2%2C17.5C2.1%2C16.7%2C2%2C15.8%2C2%2C15C2%2C7.8%2C7.8%2C2%2C15%2C2s13%2C5.8%2C13%2C13c0%2C0.8-0.1%2C1.7-0.2%2C2.5h2%0A%09%09c0.1-0.8%2C0.2-1.6%2C0.2-2.5c0-8.3-6.7-15-15-15S0%2C6.7%2C0%2C15c0%2C0.8%2C0.1%2C1.7%2C0.2%2C2.5H2.2z%22/%3E%0A%3C/g%3E%0A%3C/svg%3E%0A);background-repeat:no-repeat}@keyframes spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}:host.jamp-page-level{background:#ffffffe6;position:fixed;z-index:100;inset:0}:host.jamp-page-level .row{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}:host.jamp-page-level .jamp:focus-visible{outline:none}.jamp-center-css{width:calc(100% - 60px);max-height:calc(100% - 60px);position:absolute!important;top:50%!important;left:50%!important;transform:translate(-50%,-50%)}.jamp{position:relative!important;top:50%!important;left:0%!important;text-align:center!important;transform:translateY(-50%)!important;margin:0}.fillHeight{min-height:100%;height:100%}.position-initial{position:initial}.citi-modal :host .jamp{margin:30px 0 10px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }, { kind: "directive", type: i1$3.CdkTrapFocus, selector: "[cdkTrapFocus]", inputs: ["cdkTrapFocus", "cdkTrapFocusAutoCapture"], exportAs: ["cdkTrapFocus"] }, { kind: "directive", type: DdlAriaHideOuterDomDirective, selector: "[ddlAriaHideOuterDom]", inputs: ["isOuterDomAriaHidden", "outerDomExceptions"], exportAs: ["ddlAriaHideOuterDom"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: JampComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-jamp', standalone: false, template: `
    <div class="fillHeight" *ngIf="!isPageLevel; else pageLevelJamp">
      <div class="alignmentEl fillHeight" [ngClass]="(isCenterAligned ? 'position-initial' : '')">
        <div class="jamp {{jampCssClass}}">
          <div class="img {{loadingClass}}" role="img" [attr.aria-label]="waitMessage"></div>
          <div class="message" [contentHtml]="htmlContent">
            <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
          </div>
        </div>
      </div>
    </div>
    <ng-template #pageLevelJamp>
      <div class="fillHeight" *ngIf="_isPageLevelJampVisible" ddlAriaHideOuterDom [isOuterDomAriaHidden]="_isDomAriaHidden">
        <div class="alignmentEl fillHeight" [ngClass]="(isCenterAligned ? 'position-initial' : '')" cdkTrapFocus>
          <div #jampPageLevelContent class="jamp {{jampCssClass}}" tabindex="0" role="dialog">
            <div class="img {{loadingClass}}" role="img" [attr.aria-label]="waitMessage"></div>
            <div class="message" [contentHtml]="htmlContent">
              <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template #contentTemplate><ng-content></ng-content></ng-template>
    `, styles: [".jamp.white .message{color:#fff}.jamp .img{background-position:0 0;background-repeat:no-repeat;background-size:contain;padding-top:5px;margin-right:3px;width:30px;height:30px;display:inline-block}.jamp .message{position:relative;top:-9px}.jamp.jamp-css .loading{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3C%21--%20Generator%3A%20Adobe%20Illustrator%2019.1.0%2C%20SVG%20Export%20Plug-In%20.%20SVG%20Version%3A%206.00%20Build%200%29%20%20--%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2030%2030%22%20style%3D%22enable-background%3Anew%200%200%2030%2030%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text/css%22%3E%0A%09.Drop_x0020_Shadow%7Bfill%3Anone%3B%7D%0A%09.Round_x0020_Corners_x0020_2_x0020_pt%7Bfill%3A%23FFFFFF%3Bstroke%3A%23000000%3Bstroke-miterlimit%3A10%3B%7D%0A%09.Live_x0020_Reflect_x0020_X%7Bfill%3Anone%3B%7D%0A%09.Bevel_x0020_Soft%7Bfill%3Aurl%28%23SVGID_1_%29%3B%7D%0A%09.Dusk%7Bfill%3A%23FFFFFF%3B%7D%0A%09.Foliage_GS%7Bfill%3A%23FFDD00%3B%7D%0A%09.Pompadour_GS%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3Bfill%3A%2344ADE2%3B%7D%0A%09.st0%7Bfill%3Anone%3B%7D%0A%09.st1%7Bfill%3A%23056EAE%3B%7D%0A%3C/style%3E%0A%3ClinearGradient%20id%3D%22SVGID_1_%22%20gradientUnits%3D%22userSpaceOnUse%22%20x1%3D%220%22%20y1%3D%220%22%20x2%3D%220.7071%22%20y2%3D%220.7071%22%3E%0A%09%3Cstop%20%20offset%3D%220%22%20style%3D%22stop-color%3A%23DEDFE3%22/%3E%0A%09%3Cstop%20%20offset%3D%220.1738%22%20style%3D%22stop-color%3A%23D8D9DD%22/%3E%0A%09%3Cstop%20%20offset%3D%220.352%22%20style%3D%22stop-color%3A%23C9CACD%22/%3E%0A%09%3Cstop%20%20offset%3D%220.5323%22%20style%3D%22stop-color%3A%23B4B5B8%22/%3E%0A%09%3Cstop%20%20offset%3D%220.7139%22%20style%3D%22stop-color%3A%23989A9C%22/%3E%0A%09%3Cstop%20%20offset%3D%220.8949%22%20style%3D%22stop-color%3A%23797C7E%22/%3E%0A%09%3Cstop%20%20offset%3D%221%22%20style%3D%22stop-color%3A%23656B6C%22/%3E%0A%3C/linearGradient%3E%0A%3Cg%3E%0A%09%3Crect%20x%3D%220%22%20class%3D%22st0%22%20width%3D%2230%22%20height%3D%2230%22/%3E%0A%09%3Cpath%20class%3D%22st1%22%20d%3D%22M2.2%2C17.5C2.1%2C16.7%2C2%2C15.8%2C2%2C15C2%2C7.8%2C7.8%2C2%2C15%2C2s13%2C5.8%2C13%2C13c0%2C0.8-0.1%2C1.7-0.2%2C2.5h2%0A%09%09c0.1-0.8%2C0.2-1.6%2C0.2-2.5c0-8.3-6.7-15-15-15S0%2C6.7%2C0%2C15c0%2C0.8%2C0.1%2C1.7%2C0.2%2C2.5H2.2z%22/%3E%0A%3C/g%3E%0A%3C/svg%3E%0A);background-repeat:no-repeat;animation:spin 1.16s infinite linear}.jamp.jamp-css.white .loading{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3C%21--%20Generator%3A%20Adobe%20Illustrator%2019.2.1%2C%20SVG%20Export%20Plug-In%20.%20SVG%20Version%3A%206.00%20Build%200%29%20%20--%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2030%2030%22%20style%3D%22enable-background%3Anew%200%200%2030%2030%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text/css%22%3E%0A%09.st0%7Bfill%3Anone%3B%7D%0A%09.st1%7Bfill%3A%23FFFFFF%3B%7D%0A%3C/style%3E%0A%3Cg%3E%0A%09%3Crect%20class%3D%22st0%22%20width%3D%2230%22%20height%3D%2230%22/%3E%0A%09%3Cpath%20class%3D%22st1%22%20d%3D%22M2.2%2C17.5C2.1%2C16.7%2C2%2C15.8%2C2%2C15C2%2C7.8%2C7.8%2C2%2C15%2C2s13%2C5.8%2C13%2C13c0%2C0.8-0.1%2C1.7-0.2%2C2.5h2%0A%09%09c0.1-0.8%2C0.2-1.6%2C0.2-2.5c0-8.3-6.7-15-15-15S0%2C6.7%2C0%2C15c0%2C0.8%2C0.1%2C1.7%2C0.2%2C2.5H2.2z%22/%3E%0A%3C/g%3E%0A%3C/svg%3E%0A);background-repeat:no-repeat}@keyframes spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}:host.jamp-page-level{background:#ffffffe6;position:fixed;z-index:100;inset:0}:host.jamp-page-level .row{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}:host.jamp-page-level .jamp:focus-visible{outline:none}.jamp-center-css{width:calc(100% - 60px);max-height:calc(100% - 60px);position:absolute!important;top:50%!important;left:50%!important;transform:translate(-50%,-50%)}.jamp{position:relative!important;top:50%!important;left:0%!important;text-align:center!important;transform:translateY(-50%)!important;margin:0}.fillHeight{min-height:100%;height:100%}.position-initial{position:initial}.citi-modal :host .jamp{margin:30px 0 10px}\n"] }]
        }], ctorParameters: () => [{ type: i1$3.LiveAnnouncer }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i0.Renderer2 }], propDecorators: { isHidden: [{
                type: HostBinding,
                args: ['class.hidden']
            }], isPageLevel: [{
                type: HostBinding,
                args: ['class.jamp-page-level']
            }], jampPageLevelContent: [{
                type: ViewChild,
                args: ['jampPageLevelContent']
            }], useGif: [{
                type: Input$1
            }], visible: [{
                type: Input$1
            }], pagelevel: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }], additionalCssClasses: [{
                type: Input$1
            }], waitMessage: [{
                type: Input$1
            }], readyMessage: [{
                type: Input$1
            }], isCenterAligned: [{
                type: Input$1
            }] } });

class DdlAriaHideOuterDomModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: DdlAriaHideOuterDomModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: DdlAriaHideOuterDomModule, declarations: [DdlAriaHideOuterDomDirective], imports: [CommonModule], exports: [DdlAriaHideOuterDomDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: DdlAriaHideOuterDomModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: DdlAriaHideOuterDomModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DdlAriaHideOuterDomDirective],
                    imports: [CommonModule],
                    exports: [DdlAriaHideOuterDomDirective]
                }]
        }] });

const COMPONENTS$16 = [
    JampComponent
];
const MODULES$1a = [
    CommonModule,
    ContentHtml,
    A11yModule,
    DdlAriaHideOuterDomModule
];
class JAMP {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: JAMP, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: JAMP, declarations: [JampComponent], imports: [CommonModule,
            ContentHtml,
            A11yModule,
            DdlAriaHideOuterDomModule], exports: [JampComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: JAMP, imports: [MODULES$1a] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: JAMP, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$1a],
                    declarations: [...COMPONENTS$16],
                    exports: [JampComponent]
                }]
        }] });

/**
 * @Component: Checkmark List
 * @Section: ButtonsLinksLists
 * @description This component generates a checkmark list.
 */
class CheckmarkListComponent {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CheckmarkListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: CheckmarkListComponent, isStandalone: false, selector: "citi-checkmark-list", inputs: { htmlContent: "htmlContent" }, ngImport: i0, template: `
    <div class="b-copy-modules">
        <ul class="list-check-mark" [contentHtml]="htmlContent">
            <ng-content></ng-content>
        </ul>
    </div>
    `, isInline: true, styles: [".list-check-mark ::ng-deep li::marker{color:transparent}.list-check-mark ::ng-deep li{position:relative}.list-check-mark ::ng-deep li:before{content:\"\";background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 9.99'%3E%3Ctitle%3E05-glyph-check-white%3C/title%3E%3Cpath d='M17.54,25a1.48,1.48,0,0,1-1.05-.43L13.3,21.49a1,1,0,1,1,1.4-1.44l2.84,2.76,7.76-7.52a1,1,0,1,1,1.4,1.43l-8.1,7.85a1.52,1.52,0,0,1-1.06.43' transform='translate(-13 -15)' style='fill:%23006E0A;fill-rule:evenodd'/%3E%3C/svg%3E\");left:-18px;position:absolute!important;top:9px}\n"], dependencies: [{ kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CheckmarkListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-checkmark-list', standalone: false, template: `
    <div class="b-copy-modules">
        <ul class="list-check-mark" [contentHtml]="htmlContent">
            <ng-content></ng-content>
        </ul>
    </div>
    `, styles: [".list-check-mark ::ng-deep li::marker{color:transparent}.list-check-mark ::ng-deep li{position:relative}.list-check-mark ::ng-deep li:before{content:\"\";background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 9.99'%3E%3Ctitle%3E05-glyph-check-white%3C/title%3E%3Cpath d='M17.54,25a1.48,1.48,0,0,1-1.05-.43L13.3,21.49a1,1,0,1,1,1.4-1.44l2.84,2.76,7.76-7.52a1,1,0,1,1,1.4,1.43l-8.1,7.85a1.52,1.52,0,0,1-1.06.43' transform='translate(-13 -15)' style='fill:%23006E0A;fill-rule:evenodd'/%3E%3C/svg%3E\");left:-18px;position:absolute!important;top:9px}\n"] }]
        }], propDecorators: { htmlContent: [{
                type: Input$1
            }] } });

// This Component
const MODULES$19 = [
    CommonModule,
    ContentHtml
];
class CheckmarkList {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CheckmarkList, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: CheckmarkList, declarations: [CheckmarkListComponent], imports: [CommonModule,
            ContentHtml], exports: [CheckmarkListComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CheckmarkList, imports: [MODULES$19] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CheckmarkList, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$19],
                    declarations: [CheckmarkListComponent],
                    exports: [CheckmarkListComponent]
                }]
        }] });

/**
 * @Component: List Item
 * @Section: ButtonsLinksLists
 * @description This component generates a list item.
 */
class ListItemComponent {
    // TODO: Needs to be deprecated
    get doesHostElementHasLiTag() {
        return this.hostEl.nativeElement.tagName === 'LI';
    }
    // TODO: Needs to be deprecated
    setContentToHost() {
        this.hostEl.nativeElement.innerHTML = this.liContentEl.nativeElement.innerHTML;
        if (this.htmlContent !== null) {
            this.hostEl.nativeElement.innerHTML = this.htmlContent;
        }
    }
    constructor(hostEl) {
        this.hostEl = hostEl;
        /**
         * @property htmlContent
         * @description Adds the given string as the content and supports simple HTML.
         * Do not pass anything within the component tags using ng-content. Do not use citi-* components in the String.
         * This works with expressions for asynchronously loaded content that will get picked up by the
         * Angular 2 change detection.
         * @return string
         * @twoway false
         */
        this.htmlContent = null;
    }
    ngAfterViewInit() {
        // If the host element is a 'li', moves the content to the host not the 'li' inside
        if (this.doesHostElementHasLiTag) {
            this.setContentToHost();
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ListItemComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: ListItemComponent, isStandalone: false, selector: "citi-list-item, [citi-list-item]", inputs: { htmlContent: "htmlContent" }, viewQueries: [{ propertyName: "liContentEl", first: true, predicate: ["liContent"], descendants: true }], ngImport: i0, template: `
    <li role="listitem" [class.hidden]="doesHostElementHasLiTag" [contentHtml]="htmlContent" #liContent>
      <ng-content></ng-content>
    </li>


    `, isInline: true, dependencies: [{ kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ListItemComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'citi-list-item, [citi-list-item]',
                    standalone: false,
                    template: `
    <li role="listitem" [class.hidden]="doesHostElementHasLiTag" [contentHtml]="htmlContent" #liContent>
      <ng-content></ng-content>
    </li>


    `
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { htmlContent: [{
                type: Input$1
            }], liContentEl: [{
                type: ViewChild,
                args: ['liContent']
            }] } });

const MODULES$18 = [
    CommonModule,
    ContentHtml
];
class ListItem {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ListItem, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: ListItem, declarations: [ListItemComponent], imports: [CommonModule,
            ContentHtml], exports: [ListItemComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ListItem, imports: [MODULES$18] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ListItem, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$18],
                    declarations: [ListItemComponent],
                    exports: [ListItemComponent]
                }]
        }] });

/**
 * @Component: Ordered List
 * @Section: ButtonsLinksLists
 * @description This component generates an ordered list.
 */
class OrderedListComponent {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: OrderedListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: OrderedListComponent, isStandalone: false, selector: "citi-ordered-list", inputs: { htmlContent: "htmlContent" }, ngImport: i0, template: `
    <ol [contentHtml]="htmlContent">
        <ng-content></ng-content>
    </ol>
`, isInline: true, styles: ["ol>::ng-deep li:before{position:relative;left:-11px}\n"], dependencies: [{ kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: OrderedListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-ordered-list', standalone: false, template: `
    <ol [contentHtml]="htmlContent">
        <ng-content></ng-content>
    </ol>
`, styles: ["ol>::ng-deep li:before{position:relative;left:-11px}\n"] }]
        }], propDecorators: { htmlContent: [{
                type: Input$1
            }] } });

const COMPONENTS$15 = [
    OrderedListComponent
];
const MODULES$17 = [
    CommonModule,
    ContentHtml,
    ListItem
];
class OrderedList {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: OrderedList, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: OrderedList, declarations: [OrderedListComponent], imports: [CommonModule,
            ContentHtml,
            ListItem], exports: [OrderedListComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: OrderedList, imports: [MODULES$17] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: OrderedList, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$17],
                    declarations: [...COMPONENTS$15],
                    exports: [OrderedListComponent]
                }]
        }] });

/**
 * @Component: Unordered List
 * @Section: ButtonsLinksLists
 * @description This component generates an unordered list.
 */
class UnorderedListComponent {
    constructor() {
        /**
        * @property isCTAList
        * @description This will render the CTA list
        * @Type: boolean
        */
        this.isCTAList = false;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: UnorderedListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: UnorderedListComponent, isStandalone: false, selector: "citi-unordered-list", inputs: { isCTAList: "isCTAList", htmlContent: "htmlContent" }, ngImport: i0, template: `
        <div class="b-copy-modules" >
            <ul role="list" [contentHtml]="htmlContent" class="{{isCTAList ? 'list-cta' : ''}}">
                <ng-content></ng-content>
            </ul>
        </div>
    `, isInline: true, styles: [".list-cta{font-weight:700}.list-cta ::ng-deep li{position:relative;color:#056dae}.list-cta ::ng-deep li a,.list-cta ::ng-deep li a:focus,.list-cta ::ng-deep li a:hover{background-position:top 55% right 0;background-repeat:no-repeat;padding-right:12px}\n"], dependencies: [{ kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: UnorderedListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-unordered-list', standalone: false, template: `
        <div class="b-copy-modules" >
            <ul role="list" [contentHtml]="htmlContent" class="{{isCTAList ? 'list-cta' : ''}}">
                <ng-content></ng-content>
            </ul>
        </div>
    `, styles: [".list-cta{font-weight:700}.list-cta ::ng-deep li{position:relative;color:#056dae}.list-cta ::ng-deep li a,.list-cta ::ng-deep li a:focus,.list-cta ::ng-deep li a:hover{background-position:top 55% right 0;background-repeat:no-repeat;padding-right:12px}\n"] }]
        }], propDecorators: { isCTAList: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }] } });

const MODULES$16 = [
    CommonModule,
    ContentHtml,
    ListItem
];
class UnorderedList {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: UnorderedList, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: UnorderedList, declarations: [UnorderedListComponent], imports: [CommonModule,
            ContentHtml,
            ListItem], exports: [UnorderedListComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: UnorderedList, imports: [MODULES$16] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: UnorderedList, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$16],
                    declarations: [UnorderedListComponent],
                    exports: [UnorderedListComponent]
                }]
        }] });

/**
 * @Component: X-Mark List
 * @Section: ButtonsLinksLists
 * @description This component generates an x-mark list.
 */
class XmarkListComponent {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: XmarkListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: XmarkListComponent, isStandalone: false, selector: "citi-xmark-list", inputs: { htmlContent: "htmlContent" }, ngImport: i0, template: `
        <div class="b-copy-modules">
            <ul class="list-x-mark" [contentHtml]="htmlContent">
                <ng-content></ng-content>
            </ul>
        </div>
    `, isInline: true, styles: [".list-x-mark ::ng-deep li::marker{color:transparent}.list-x-mark::ng-deep li{position:relative}.list-x-mark::ng-deep li:before{content:\"\";background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 11'%3E%3Ctitle%3E06-glyph-close-white%3C/title%3E%3Cpath d='M21.41,20l3.8-3.79a1,1,0,0,0-1.42-1.42L20,18.59l-3.79-3.8a1,1,0,0,0-1.42,1.42L18.59,20l-3.8,3.79a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L20,21.41l3.79,3.8a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z' transform='translate(-14.5 -14.5)' style='fill:%23D60000;fill-rule:evenodd'/%3E%3C/svg%3E\");left:-18px;position:absolute!important;width:.625rem;height:.625rem;top:6px}\n"], dependencies: [{ kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: XmarkListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-xmark-list', standalone: false, template: `
        <div class="b-copy-modules">
            <ul class="list-x-mark" [contentHtml]="htmlContent">
                <ng-content></ng-content>
            </ul>
        </div>
    `, styles: [".list-x-mark ::ng-deep li::marker{color:transparent}.list-x-mark::ng-deep li{position:relative}.list-x-mark::ng-deep li:before{content:\"\";background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 11'%3E%3Ctitle%3E06-glyph-close-white%3C/title%3E%3Cpath d='M21.41,20l3.8-3.79a1,1,0,0,0-1.42-1.42L20,18.59l-3.79-3.8a1,1,0,0,0-1.42,1.42L18.59,20l-3.8,3.79a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L20,21.41l3.79,3.8a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z' transform='translate(-14.5 -14.5)' style='fill:%23D60000;fill-rule:evenodd'/%3E%3C/svg%3E\");left:-18px;position:absolute!important;width:.625rem;height:.625rem;top:6px}\n"] }]
        }], propDecorators: { htmlContent: [{
                type: Input$1
            }] } });

const MODULES$15 = [
    CommonModule,
    ContentHtml,
    ListItem
];
class XmarkList {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: XmarkList, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: XmarkList, declarations: [XmarkListComponent], imports: [CommonModule,
            ContentHtml,
            ListItem], exports: [XmarkListComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: XmarkList, imports: [MODULES$15] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: XmarkList, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$15],
                    declarations: [XmarkListComponent],
                    exports: [XmarkListComponent]
                }]
        }] });

const NAVIGATOR = new InjectionToken('NavigatorToken');
function navigatorFactory(platformId) {
    return isPlatformBrowser(platformId) ? navigator : null;
}
const NAVIGATOR_PROVIDER = {
    provide: NAVIGATOR,
    useFactory: navigatorFactory,
    deps: [PLATFORM_ID]
};

class TextHeaderComponent {
    /**
     * What level the header should be.
     * This should be heirarchical to other headers in the document starting at h2.
     */
    set level(level) {
        const newLevel = (typeof level === 'string') ? +level : level;
        if (!newLevel || isNaN(+newLevel) || newLevel < 1 || newLevel > 6) {
            if (isDevMode)
                console.warn('TEXT_HEADER: The value passed to level should be a number between 1 and 6');
        }
        else
            this._headerLevel = newLevel;
    }
    get level() {
        return this._headerLevel;
    }
    /**
     * number corresponding to the level of header whose style you want to use. Not heirarchical.
     */
    set style(level) {
        const newLevel = (typeof level === 'string') ? +level : level;
        if (!newLevel || isNaN(+newLevel) || newLevel < 1 || newLevel > 6) {
            if (isDevMode)
                console.warn('TEXT_HEADER: The value passed to style should be a number between 1 and 6 and correspond to the header level whose style you want to use.');
            this._styleLevel = null;
        }
        else
            this._styleLevel = newLevel;
    }
    get style() {
        return this._styleLevel;
    }
    /**
     * If the header should be bold.
     */
    set bold(isBold) {
        this._isBold = isBold;
    }
    get bold() {
        return this._isBold;
    }
    set class(_class) {
        this._classString = _class;
    }
    get class() {
        return this._classString;
    }
    // #endregion
    // #region =========== Constructor / Life-cycle Hooks ========== //
    constructor() {
        // #endregion
        // #region =========== @Input ========== //
        /**
         * Sets aria-level value. This can be used to overwrite the automatic level calculation
         * of the user agent
         * @deprecated
         */
        this.ariaLevel = null;
        this.htmlContent = '';
    }
    ngAfterViewInit() {
        setTimeout(() => {
            if (this.html)
                this.htmlContent = this.html;
        }, 0);
    }
    ngOnChanges(changes) {
        for (const propName in changes) {
            switch (propName) {
                case 'htmlContent':
                    // When using htmlContent on outerHTML, it will not update correctly on
                    // subsequent changes, unless removed and re-added to DOM
                    this._hideHtmlContent = true;
                    setTimeout(() => {
                        this._hideHtmlContent = false;
                    }, 0);
                    break;
            }
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TextHeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: TextHeaderComponent, isStandalone: false, selector: "citi-text-header", inputs: { ariaLevel: "ariaLevel", level: "level", style: "style", bold: "bold", class: "class", html: "html", ariaRole: "ariaRole", htmlContent: "htmlContent" }, usesOnChanges: true, ngImport: i0, template: `
    <ng-template #contentTemplate>
      <ng-container *ngIf="htmlContent; else projectedContent">
        <div [outerHTML]="htmlContent"></div>
      </ng-container>
      <ng-template #projectedContent>
        <ng-content></ng-content>
      </ng-template>
    </ng-template>

    <ng-container *ngIf="!_hideHtmlContent">
      <h1 *ngIf="level == 1"
        [ngClass]="[style ? 'header-level-' + style : '', bold ? 'bold' : '', class ? class : '']"
        [attr.role]="(ariaRole? ariaRole : null)"
        [attr.aria-level]="(ariaLevel? ariaLevel : null)"
      ><ng-container *ngTemplateOutlet="contentTemplate"></ng-container></h1>
      <h2 *ngIf="level == 2"
        [ngClass]="[style ? 'header-level-' + style : '', bold ? 'bold' : '', class ? class : '']"
        [attr.role]="(ariaRole? ariaRole : null)"
        [attr.aria-level]="(ariaLevel? ariaLevel : null)"
      ><ng-container *ngTemplateOutlet="contentTemplate"></ng-container></h2>
      <h3 *ngIf="level == 3"
        [ngClass]="[style ? 'header-level-' + style : '', bold ? 'bold' : '', class ? class : '']"
        [attr.role]="(ariaRole? ariaRole : null)"
        [attr.aria-level]="(ariaLevel? ariaLevel : null)"
      ><ng-container *ngTemplateOutlet="contentTemplate"></ng-container></h3>
      <h4 *ngIf="level == 4"
        [ngClass]="[style ? 'header-level-' + style : '', bold ? 'bold' : '', class ? class : '']"
        [attr.role]="(ariaRole? ariaRole : null)"
        [attr.aria-level]="(ariaLevel? ariaLevel : null)"
      ><ng-container *ngTemplateOutlet="contentTemplate"></ng-container></h4>
      <h5 *ngIf="level == 5"
        [ngClass]="[style ? 'header-level-' + style : '', bold ? 'bold' : '', class ? class : '']"
        [attr.role]="(ariaRole? ariaRole : null)"
        [attr.aria-level]="(ariaLevel? ariaLevel : null)"
      ><ng-container *ngTemplateOutlet="contentTemplate"></ng-container></h5>
      <h6 *ngIf="level == 6"
        [ngClass]="[style ? 'header-level-' + style : '', bold ? 'bold' : '', class ? class : '']"
        [attr.role]="(ariaRole? ariaRole : null)"
        [attr.aria-level]="(ariaLevel? ariaLevel : null)"
      ><ng-container *ngTemplateOutlet="contentTemplate"></ng-container></h6>
    </ng-container>
  `, isInline: true, styles: [".header-level-1,.header-level-2,.header-level-3,.header-level-4,.header-level-5,.header-level-6{margin-bottom:20px;line-height:normal}.header-level-1{font-size:4.25rem;line-height:4.75rem;text-transform:none;letter-spacing:initial}.header-level-2{font-size:2.625rem;line-height:3.125rem;text-transform:none;letter-spacing:initial}.header-level-3{font-size:1.625rem;line-height:2rem;text-transform:none;letter-spacing:initial}.header-level-4{font-size:1.313rem;line-height:1.688rem;text-transform:none;letter-spacing:initial}.header-level-5{font-size:1rem;letter-spacing:2px;line-height:1.4rem;text-transform:uppercase}.header-level-6{font-size:.75rem;letter-spacing:2px;line-height:1.125rem;text-transform:uppercase}.bold{font-family:Interstate_Bold,sans-serif}.html-content-hidden{position:absolute;width:1px;height:1px;opacity:.1;overflow:hidden;pointer-events:none}@media (max-width: 991px){.header-level-1{font-size:2.625rem!important}.header-level-2{font-size:1.625rem!important}.header-level-3{font-size:1.313rem!important}.header-level-4{font-size:1rem!important}.header-level-5{font-size:1rem!important;text-transform:uppercase;letter-spacing:2px}.header-level-6{font-size:.75rem!important;text-transform:uppercase;letter-spacing:2px}}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TextHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-text-header', standalone: false, template: `
    <ng-template #contentTemplate>
      <ng-container *ngIf="htmlContent; else projectedContent">
        <div [outerHTML]="htmlContent"></div>
      </ng-container>
      <ng-template #projectedContent>
        <ng-content></ng-content>
      </ng-template>
    </ng-template>

    <ng-container *ngIf="!_hideHtmlContent">
      <h1 *ngIf="level == 1"
        [ngClass]="[style ? 'header-level-' + style : '', bold ? 'bold' : '', class ? class : '']"
        [attr.role]="(ariaRole? ariaRole : null)"
        [attr.aria-level]="(ariaLevel? ariaLevel : null)"
      ><ng-container *ngTemplateOutlet="contentTemplate"></ng-container></h1>
      <h2 *ngIf="level == 2"
        [ngClass]="[style ? 'header-level-' + style : '', bold ? 'bold' : '', class ? class : '']"
        [attr.role]="(ariaRole? ariaRole : null)"
        [attr.aria-level]="(ariaLevel? ariaLevel : null)"
      ><ng-container *ngTemplateOutlet="contentTemplate"></ng-container></h2>
      <h3 *ngIf="level == 3"
        [ngClass]="[style ? 'header-level-' + style : '', bold ? 'bold' : '', class ? class : '']"
        [attr.role]="(ariaRole? ariaRole : null)"
        [attr.aria-level]="(ariaLevel? ariaLevel : null)"
      ><ng-container *ngTemplateOutlet="contentTemplate"></ng-container></h3>
      <h4 *ngIf="level == 4"
        [ngClass]="[style ? 'header-level-' + style : '', bold ? 'bold' : '', class ? class : '']"
        [attr.role]="(ariaRole? ariaRole : null)"
        [attr.aria-level]="(ariaLevel? ariaLevel : null)"
      ><ng-container *ngTemplateOutlet="contentTemplate"></ng-container></h4>
      <h5 *ngIf="level == 5"
        [ngClass]="[style ? 'header-level-' + style : '', bold ? 'bold' : '', class ? class : '']"
        [attr.role]="(ariaRole? ariaRole : null)"
        [attr.aria-level]="(ariaLevel? ariaLevel : null)"
      ><ng-container *ngTemplateOutlet="contentTemplate"></ng-container></h5>
      <h6 *ngIf="level == 6"
        [ngClass]="[style ? 'header-level-' + style : '', bold ? 'bold' : '', class ? class : '']"
        [attr.role]="(ariaRole? ariaRole : null)"
        [attr.aria-level]="(ariaLevel? ariaLevel : null)"
      ><ng-container *ngTemplateOutlet="contentTemplate"></ng-container></h6>
    </ng-container>
  `, styles: [".header-level-1,.header-level-2,.header-level-3,.header-level-4,.header-level-5,.header-level-6{margin-bottom:20px;line-height:normal}.header-level-1{font-size:4.25rem;line-height:4.75rem;text-transform:none;letter-spacing:initial}.header-level-2{font-size:2.625rem;line-height:3.125rem;text-transform:none;letter-spacing:initial}.header-level-3{font-size:1.625rem;line-height:2rem;text-transform:none;letter-spacing:initial}.header-level-4{font-size:1.313rem;line-height:1.688rem;text-transform:none;letter-spacing:initial}.header-level-5{font-size:1rem;letter-spacing:2px;line-height:1.4rem;text-transform:uppercase}.header-level-6{font-size:.75rem;letter-spacing:2px;line-height:1.125rem;text-transform:uppercase}.bold{font-family:Interstate_Bold,sans-serif}.html-content-hidden{position:absolute;width:1px;height:1px;opacity:.1;overflow:hidden;pointer-events:none}@media (max-width: 991px){.header-level-1{font-size:2.625rem!important}.header-level-2{font-size:1.625rem!important}.header-level-3{font-size:1.313rem!important}.header-level-4{font-size:1rem!important}.header-level-5{font-size:1rem!important;text-transform:uppercase;letter-spacing:2px}.header-level-6{font-size:.75rem!important;text-transform:uppercase;letter-spacing:2px}}\n"] }]
        }], ctorParameters: () => [], propDecorators: { ariaLevel: [{
                type: Input$1
            }], level: [{
                type: Input$1
            }], style: [{
                type: Input$1
            }], bold: [{
                type: Input$1
            }], class: [{
                type: Input$1
            }], html: [{
                type: Input$1
            }], ariaRole: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }] } });

let nextId$9 = 0;
/**
 * @Component: Modal
 * @description This component generates a modal
 */
class ModalComponent {
    get ariaTitle() {
        return this.title ? this.title.replace(/<\/?[^>]+(>|$)/g, '') : '';
    }
    /**
     * @property idStr
     * @description Sets the id attribute of the modal
     * @return string
     */
    get idStr() {
        return this._id || this._uid;
    }
    set idStr(value) {
        this._id = value || this._uid;
    }
    /**
     * @property show
     * @description Whether the modal should be open or not
     * @twoway true
     * @Type: boolean
     */
    set show(show) {
        // Only run if changing.
        // You don't need to run code to show if already shown & vise versa
        // Also, keeps showChange emit from causing this to run twice
        if (this.show !== show) {
            this._show = show;
            // Should not run until after AfterViewInit.
            // Keeps from running on the first ngOnChanges
            if (this.isDoneWithViewInit) {
                if (this._show) {
                    this.showModal();
                }
                else {
                    this.hideModal();
                }
            }
        }
    }
    get show() {
        return this._show;
    }
    /**
     * @property closeButtonIdStr
     * @description Sets the id attribute of the modal close button
     * @return string
     */
    set closeButtonIdStr(idStr) {
        if (typeof idStr !== 'undefined') {
            this._closeButtonIdStr = idStr;
        }
    }
    get closeButtonIdStr() {
        return this._closeButtonIdStr;
    }
    // #endregion
    // #region // -------------- Constructor -------------- //
    constructor(renderer, _ngZone, cdr, announcer, _document, _navigator, _window) {
        this.renderer = renderer;
        this._ngZone = _ngZone;
        this.cdr = cdr;
        this.announcer = announcer;
        this._document = _document;
        this._window = _window;
        /**
         * @property ariaRole
         * @description the ariaRole to define a role for the modal
         * @return string
         */
        this.ariaRole = 'dialog';
        this._uid = `citi-modal-${nextId$9++}`;
        /**
         * @property primaryButtonTarget
         * @description The target for the primary button
         * @return string
         */
        this.primaryButtonTarget = null;
        /**
         * @property closeOnBgClick
         * @description whather or not close on bg click
         * @Type: boolean
         */
        this.closeOnBgClick = false;
        // #endregion
        // #region // -------------- @Output -------------- //
        /**
         * @Event: primaryButtonClick
         * @description This event that is fired when the primary button of the modal changes.
         * Can be bound to with (primaryButtonClick)='myFunction($event)'
         * @return Object
         */
        this.primaryButtonClick = new EventEmitter();
        /**
         * @Event: secondaryButtonClick
         * @description This event that is fired when the secondary button of the modal changes.
         * Can be bound to with (secondaryButtonClick)='myFunction($event)'
         * @return Object
         */
        this.secondaryButtonClick = new EventEmitter();
        /**
         * @Event: closeButtonClick
         * @description This event that is fired when the close button of the modal changes.
         * Can be bound to with (closeButtonClick)='myFunction($event)'
         * @return Object
         */
        this.closeButtonClick = new EventEmitter();
        /**
         * @Event: showChange
         * @description This event that is fired when the modal is hidden/displayed.
         * Can be bound to with (showChange)='myFunction($event)'.
         * Value 'true' in the parameter means the modal is displayed
         * Value 'false' in the parameter means the modal is hidden
         * @return boolean
         */
        this.showChange = new EventEmitter();
        /**
         * @Event: onHide
         * @description This event that is fired when the modal is hidden
         * @return Object
         */
        this.onHide = new EventEmitter();
        // This line has to be in the constructor.
        this.bodyEl = this._document.getElementsByTagName('body')[0];
        this.doc = this._document.documentElement;
        this.initialPosition = 0;
        this.isIOS =
            _navigator &&
                !!_navigator.platform &&
                /iPad|iPhone|iPod/.test(_navigator.platform);
        this._closeButtonIdStr = `modalCloseButton-${nextId$9++}`;
    }
    // #endregion
    // #region // -------------- Lifecycle Hooks -------------- //
    ngAfterViewInit() {
        this.isDoneWithViewInit = true;
        // If modal is set to show initially, then this will show the modal once the view is ready
        if (this.show) {
            this.showModal();
        }
    }
    ngOnDestroy() {
        // Make sure to remove classes/styles from body element
        this.toggleBodyScrollable(false);
        this.IOSFixBodyToScrollPos(false);
    }
    // #endregion
    // #region // -------------- HostListener -------------- //
    onEscape(event) {
        if (this.show && event.key === 'Escape') {
            if ((event.target.classList[0] === 'dropdown' || event.target.classList[0] === 'citi-tooltip-close' || event.target.classList[0] === 'tooltip-trigger') &&
                event.defaultPrevented === true) {
                this.show = true;
            }
            else {
                this.show = false;
            }
        }
    }
    // #endregion
    // #region // -------------- Methods -------------- //
    onClick(event) {
        //if we click outside close the modal
        if (this.isInClassActive === true &&
            !this.modal.nativeElement.contains(event.target) &&
            this.closeOnBgClick) {
            this.closeButtonClicked(event);
        }
    }
    // Function to open/close modal
    toggleModal(show) {
        if (typeof show !== 'boolean')
            this.show = !this.show;
        else
            this.show = show;
    }
    /** This function is being called from close button in Modal, which will fire toggle modal event and also
      close button event.
    */
    closeButtonClicked(e) {
        this.show = false;
        this.closeButtonClick.emit(e);
    }
    /** This function is being called on keyup event from close button in Modal, which will set role attribute to none when ctrl is pressed.
     */
    onKeyUpCloseButton(e) {
        if (e.keyCode == 17)
            this.ariaRole = 'none';
    }
    /** This function is being called from primary button in Modal, fires the event to to eventEmitter object,
      and passing parameter 'e' for the use on consuming side
    */
    primaryButtonClicked(e) {
        this.primaryButtonClick.emit(e);
    }
    /** This function is being called from secondary button in Modal, which will fire toggle
     modal event and also end user session event.
    */
    secondaryButtonClicked(e) {
        this.show = false;
        this.secondaryButtonClick.emit(e);
    }
    closeAndNavigate() {
        this.show = false;
    }
    executeOnStable(func) {
        this._ngZone.runOutsideAngular(() => {
            this._ngZone.onStable
                .asObservable()
                .pipe(take(1))
                .subscribe(() => func());
        });
    }
    showModal() {
        // We have to add the modal-open class to the body tag when the modal is open
        this.toggleBodyScrollable(true);
        this.isDisplayBlock = true;
        this.startShowTransition();
        this.showChange.emit(true);
        setTimeout(() => {
            this.openButton = this.getOpenerElement();
            this.finishShowTransition();
            // added because there are use-cases where change detection is not triggered
            this.cdr.markForCheck();
        }, 0);
    }
    hideModal() {
        this.IOSFixBodyToScrollPos(false);
        this.startHideTransition();
        this.showChange.emit(false);
        this.isDisplayBlock = false;
        // Focus the button that originally opened the modal
        setTimeout(() => {
            if (this.openButton) {
                this.openButton.focus();
            }
        }, 150);
        // Wait for the modal to fade out
        // The delay should match the CSS transition speed
        setTimeout(() => {
            // We have to remove the modal-open class when the modal is closed
            this.toggleBodyScrollable(false);
            this.finishHideTransition();
            // Emits event when a modal is hidden
            this.onHide.emit();
            // added because there are use-cases where change detection is not triggered
            this.cdr.markForCheck();
        }, 150);
    }
    startShowTransition() {
        // IOS Scroll fix
        this.IOSFixBodyToScrollPos(true);
        //expression has changed issue fixed by addign setTimeout
        setTimeout(() => {
            this.isDisplayBlock = true;
        });
    }
    finishShowTransition() {
        // Fade/transition in from top
        this.isInClassActive = true;
        // Scroll to top of modal
        this.modalBody.nativeElement.scrollTop = 0;
        this.modal.nativeElement.scrollTop = 0;
        // Focus modal container
        this.modal.nativeElement.focus();
        // Update to focus on the modal header (CUC-6346)
        if (!this.disableCloseButton)
            this.closeButton.nativeElement.focus();
        else if (this.title)
            this.modalHeader.nativeElement.focus();
        else if (this.modalHeaderAlt)
            this.modalHeaderAlt.nativeElement.focus();
        else
            this.content.nativeElement.focus();
    }
    startHideTransition() {
        this.isInClassActive = false;
    }
    finishHideTransition() {
        this.isDisplayBlock = false;
    }
    toggleBodyScrollable(isScrollable = true) {
        if (isScrollable) {
            // We have to add the 'modal-open' class to disable the scrolling capability for the body element
            this.renderer.addClass(this.bodyEl, 'modal-open');
            this.renderer.setStyle(this.bodyEl, 'padding-right', '17px');
        }
        else {
            // We have to remove the 'modal-open' class to reactivate the scrolling capability for the body element
            this.renderer.removeClass(this.bodyEl, 'modal-open');
            this.renderer.removeStyle(this.bodyEl, 'padding-right');
        }
    }
    IOSFixBodyToScrollPos(modalOpen = false) {
        if (this.isIOS) {
            if (modalOpen) {
                this.initialPosition =
                    ((this._window && this._window.pageYOffset) || this.doc.scrollTop) -
                        (this.doc.clientTop || 0);
                this.renderer.setStyle(this.bodyEl, 'overflow', 'hidden');
                this.renderer.setStyle(this.bodyEl, 'position', 'fixed');
                this.renderer.setStyle(this.bodyEl, 'width', '100%');
                this.renderer.setStyle(this.bodyEl, 'top', `-${this.initialPosition}px`);
            }
            else {
                this.initialPosition = this.initialPosition || 0;
                this.renderer.removeStyle(this.bodyEl, 'overflow');
                this.renderer.removeStyle(this.bodyEl, 'position');
                this.renderer.removeStyle(this.bodyEl, 'width');
                this.renderer.removeStyle(this.bodyEl, 'top');
                if (this._window)
                    this._window.scrollTo(0, this.initialPosition);
            }
        }
    }
    // Create a reference to the button that opened the modal
    getOpenerElement() {
        let openerElement;
        if (this.openerSelector)
            openerElement = (this._document.querySelector(this.openerSelector));
        else
            openerElement = (this._document.querySelector('[data-target="#' + this.idStr + '"]'));
        return openerElement ? openerElement : null;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ModalComponent, deps: [{ token: i0.Renderer2 }, { token: i0.NgZone }, { token: i0.ChangeDetectorRef }, { token: CitiLiveAnnouncer }, { token: DOCUMENT }, { token: NAVIGATOR }, { token: WINDOW }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: ModalComponent, isStandalone: false, selector: "citi-modal", inputs: { scrollable: "scrollable", htmlContent: "htmlContent", ariaRole: "ariaRole", footerContent: "footerContent", idStr: "idStr", title: "title", primaryButtonUrl: "primaryButtonUrl", primaryButtonTarget: "primaryButtonTarget", primaryButtonText: "primaryButtonText", showCancelButton: "showCancelButton", footerProjection: "footerProjection", disablePrimaryButton: "disablePrimaryButton", disableCloseButton: "disableCloseButton", closeOnBgClick: "closeOnBgClick", cancelButtonText: "cancelButtonText", openerSelector: "openerSelector", show: "show", closeButtonIdStr: "closeButtonIdStr" }, outputs: { primaryButtonClick: "primaryButtonClick", secondaryButtonClick: "secondaryButtonClick", closeButtonClick: "closeButtonClick", showChange: "showChange", onHide: "onHide" }, host: { listeners: { "window:keydown": "onEscape($event)", "window:touchstart": "onClick($event)", "window:click": "onClick($event)" } }, viewQueries: [{ propertyName: "modalHeader", first: true, predicate: ["modalHeader"], descendants: true }, { propertyName: "modalHeaderAlt", first: true, predicate: ["modalHeaderAlt"], descendants: true }, { propertyName: "modal", first: true, predicate: ["modal"], descendants: true }, { propertyName: "modalBg", first: true, predicate: ["modalBg"], descendants: true }, { propertyName: "modalBody", first: true, predicate: ["modalBody"], descendants: true }, { propertyName: "closeButton", first: true, predicate: ["closeButton"], descendants: true }, { propertyName: "primaryButton", first: true, predicate: ["primaryButton"], descendants: true }, { propertyName: "secondaryButton", first: true, predicate: ["secondaryButton"], descendants: true }, { propertyName: "wrapDiv", first: true, predicate: ["wrapDiv"], descendants: true }, { propertyName: "content", first: true, predicate: ["content"], descendants: true }], ngImport: i0, template: `
    <div ddlAriaHideOuterDom [isOuterDomAriaHidden]="isDisplayBlock">
      <div
        #wrapDiv
        tabindex="-1"
        class="modal citi-modal fade"
        [class.scrollable]="scrollable"
        [class.in]="isInClassActive"
        [style.display]="isDisplayBlock ? 'block' : 'none'"
        [attr.id]="idStr"
      >
        <div #modal class="modal-dialog">
          <div class="modal-content" tabindex="-1" [attr.role]="ariaRole" cdkTrapFocus>
            <div class="modal-header"></div>
            <div>
              <button
                #closeButton
                *ngIf="!disableCloseButton"
                type="button"
                class="close-button"
                aria-label="Close modal"
                (click)="closeButtonClicked($event)"
                (keyup)="onKeyUpCloseButton($event)"
              >
                <span class="sr-only">Close</span>
              </button>
              <div
                #modalBody
                class="modal-body"
                [attr.tabindex]="scrollable ? 0 : null"
              >
                <div
                  #modalHeader
                  class="border-outline"
                  tabindex="-1"
                  *ngIf="title; else altHeader"
                >
                  <citi-text-header
                    level="2"
                    [style]="2"
                    [htmlContent]="title"
                  ></citi-text-header>
                </div>
                <ng-template #altHeader>
                  <div class="header" #modalHeaderAlt tabindex="-1">
                    <ng-content select="[title]"></ng-content>
                  </div>
                </ng-template>
                <div
                  class="modal-body-content"
                  [contentHtml]="htmlContent"
                  #content
                  tabindex="-1"
                >
                  <ng-content></ng-content>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <div class="text-right" *ngIf="!footerProjection">
                <div
                  *ngIf="
                    (showCancelButton && cancelButtonText) || primaryButtonText
                  "
                  class="citi-modal-controls"
                  [hidden]="!primaryButtonText && !showCancelButton"
                >
                  <citi-cta
                    [tabIndex]="disablePrimaryButton ? -1 : 0"
                    #primaryButton
                    *ngIf="primaryButtonText"
                    [ariaRole]="!primaryButtonUrl ? 'button' : null"
                    class="modal-primary-btn btnclassTest"
                    [target]="primaryButtonTarget"
                    [href]="primaryButtonUrl ? !disablePrimaryButton ? primaryButtonUrl : 'javascript:;' : null"
                    [value]="primaryButtonText"
                    [disabled]="disablePrimaryButton"
                    (ctaClick)="primaryButtonClicked($event)"
                  >
                  </citi-cta>
                  <span aria-hidden="false" class="sr-only"></span>
                  <citi-cta
                    #secondaryButton
                    *ngIf="showCancelButton && cancelButtonText"
                    class="modal-secondary-btn marginBetweenBtns"
                    ariaRole="button"
                    type="tertiary"
                    [value]="cancelButtonText"
                    (ctaClick)="secondaryButtonClicked($event)"
                  >
                  </citi-cta>
                </div>
              </div>
              <div *ngIf="footerProjection" class="footer-projection">
                <div [contentHtml]="footerContent">
                  <ng-content select="[footerContent]"></ng-content>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        #modalBg
        class="modal-backdrop citi-modal-backdrop fade"
        [class.in]="isInClassActive"
        [style.display]="isDisplayBlock ? 'block' : 'none'"
      ></div>
    </div>
  `, isInline: true, styles: ["a,abbr,acronym,address,applet,article,aside,audio,b,big,blockquote,body,canvas,caption,center,cite,code,dd,del,details,dfn,div,dl,dt,em,embed,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,html,i,iframe,img,ins,kbd,label,legend,li,mark,menu,nav,object,ol,output,p,pre,q,ruby,s,samp,section,small,span,strike,strong,sub,summary,sup,table,tbody,td,tfoot,th,thead,time,tr,tt,u,ul,var,video{margin:0;padding:0;border:0;font:inherit;vertical-align:baseline}article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section{display:block}body{line-height:1}ol,ul{list-style:none}blockquote,q{quotes:none}blockquote:after,blockquote:before,q:after,q:before{content:\"\";content:none}table{border-collapse:collapse;border-spacing:0}.citi-modal-backdrop{z-index:9999}.border-outline{outline:none}.citi-modal{z-index:10000}.citi-modal .modal-dialog{width:55%;max-width:1200px}@media (max-width: 480px){.citi-modal .modal-dialog{width:100%;max-height:100%;overflow:auto}}@media (min-width: 480px){.citi-modal .modal-dialog{width:100%}.citi-modal .modal-dialog .modal-footer citi-cta{display:inline-block}}@media (min-width: 768px){.citi-modal .modal-dialog{width:65%}}@media (min-width: 1200px){.citi-modal .modal-dialog{width:60%}}@media (min-width: 1440px){.citi-modal .modal-dialog{width:55%}}.citi-modal.scrollable .modal-body{max-height:360px;overflow-x:hidden;overflow-y:auto}@media (max-width: 480px){.citi-modal .modal-footer ::ng-deep .btn{width:100%}}@media (min-width: 480px){.citi-modal .modal-footer ::ng-deep .btn{width:auto}}.citi-modal .modal-secondary-btn ::ng-deep .btn-link{text-decoration:none}.citi-modal .footer-projection ::ng-deep .secondary.chevron-link.chevron-link:after{background-image:none}.citi-modal button.close-button{position:absolute;top:30px;right:35px;padding:0;border:0;width:15px;height:15px;margin-top:4px;margin-right:4px;background-repeat:no-repeat;background-color:transparent;-webkit-appearance:none;opacity:1;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 11'%3E%3Ctitle%3E06-close-white%3C/title%3E%3Cpath d='M21.41,20l3.8-3.79a1,1,0,0,0-1.42-1.42L20,18.59l-3.79-3.8a1,1,0,0,0-1.42,1.42L18.59,20l-3.8,3.79a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L20,21.41l3.79,3.8a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z' transform='translate(-14.5 -14.5)' style='fill:%23666;fill-rule:evenodd'/%3E%3C/svg%3E\")}.citi-modal button.close-button:focus,.citi-modal button.close-button:hover{opacity:1;margin-top:0;margin-right:0;height:25px;width:25px;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E06-close-white-hover%3C/title%3E%3Cpath d='M21.41,20.15l3.8-3.79a1,1,0,0,0,0-1.41,1,1,0,0,0-1.42,0L20,18.74,16.21,15a1,1,0,0,0-1.42,0,1,1,0,0,0,0,1.41l3.8,3.79L14.79,24a1,1,0,0,0,0,1.41,1,1,0,0,0,1.42,0L20,21.57l3.79,3.79a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.41ZM20,9A11,11,0,1,0,31,20,11,11,0,0,0,20,9' transform='translate(-9 -9)' style='fill:%23666;fill-rule:evenodd'/%3E%3C/svg%3E\")}.citi-modal button.close-button :focus-visible{outline:none}.modal.in{overflow-x:hidden;overflow-y:auto}.botPadding{padding-bottom:20px!important}.marginBetweenBtns{margin-left:20px}@media (max-width: 480px){.marginBetweenBtns{margin-left:0}}.header{display:block;box-sizing:border-box;margin-top:0;margin-bottom:20px;font-family:Interstate_Light,sans-serif;font-size:42px;font-weight:200;line-height:3.125rem;text-align:left;letter-spacing:normal}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: TextHeaderComponent, selector: "citi-text-header", inputs: ["ariaLevel", "level", "style", "bold", "class", "html", "ariaRole", "htmlContent"] }, { kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }, { kind: "component", type: CTAComponent, selector: "citi-cta", inputs: ["textAlign", "bold", "noMargin", "tabIndex", "ariaDescription", "ariaLabeledBy", "ariaHasPopup", "ariaRole", "ariaLabel", "ariaControls", "ariaExpanded", "router", "queryParams", "idStr", "dataTarget", "addJFPToken", "doNotAddJFPToken", "buttonType", "target", "href", "value", "disabled", "type", "size", "arrow", "leftArrow"], outputs: ["ctaClick", "disabledChange", "ctaFocus", "ctaBlur"] }, { kind: "directive", type: i1$3.CdkTrapFocus, selector: "[cdkTrapFocus]", inputs: ["cdkTrapFocus", "cdkTrapFocusAutoCapture"], exportAs: ["cdkTrapFocus"] }, { kind: "directive", type: DdlAriaHideOuterDomDirective, selector: "[ddlAriaHideOuterDom]", inputs: ["isOuterDomAriaHidden", "outerDomExceptions"], exportAs: ["ddlAriaHideOuterDom"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-modal', standalone: false, template: `
    <div ddlAriaHideOuterDom [isOuterDomAriaHidden]="isDisplayBlock">
      <div
        #wrapDiv
        tabindex="-1"
        class="modal citi-modal fade"
        [class.scrollable]="scrollable"
        [class.in]="isInClassActive"
        [style.display]="isDisplayBlock ? 'block' : 'none'"
        [attr.id]="idStr"
      >
        <div #modal class="modal-dialog">
          <div class="modal-content" tabindex="-1" [attr.role]="ariaRole" cdkTrapFocus>
            <div class="modal-header"></div>
            <div>
              <button
                #closeButton
                *ngIf="!disableCloseButton"
                type="button"
                class="close-button"
                aria-label="Close modal"
                (click)="closeButtonClicked($event)"
                (keyup)="onKeyUpCloseButton($event)"
              >
                <span class="sr-only">Close</span>
              </button>
              <div
                #modalBody
                class="modal-body"
                [attr.tabindex]="scrollable ? 0 : null"
              >
                <div
                  #modalHeader
                  class="border-outline"
                  tabindex="-1"
                  *ngIf="title; else altHeader"
                >
                  <citi-text-header
                    level="2"
                    [style]="2"
                    [htmlContent]="title"
                  ></citi-text-header>
                </div>
                <ng-template #altHeader>
                  <div class="header" #modalHeaderAlt tabindex="-1">
                    <ng-content select="[title]"></ng-content>
                  </div>
                </ng-template>
                <div
                  class="modal-body-content"
                  [contentHtml]="htmlContent"
                  #content
                  tabindex="-1"
                >
                  <ng-content></ng-content>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <div class="text-right" *ngIf="!footerProjection">
                <div
                  *ngIf="
                    (showCancelButton && cancelButtonText) || primaryButtonText
                  "
                  class="citi-modal-controls"
                  [hidden]="!primaryButtonText && !showCancelButton"
                >
                  <citi-cta
                    [tabIndex]="disablePrimaryButton ? -1 : 0"
                    #primaryButton
                    *ngIf="primaryButtonText"
                    [ariaRole]="!primaryButtonUrl ? 'button' : null"
                    class="modal-primary-btn btnclassTest"
                    [target]="primaryButtonTarget"
                    [href]="primaryButtonUrl ? !disablePrimaryButton ? primaryButtonUrl : 'javascript:;' : null"
                    [value]="primaryButtonText"
                    [disabled]="disablePrimaryButton"
                    (ctaClick)="primaryButtonClicked($event)"
                  >
                  </citi-cta>
                  <span aria-hidden="false" class="sr-only"></span>
                  <citi-cta
                    #secondaryButton
                    *ngIf="showCancelButton && cancelButtonText"
                    class="modal-secondary-btn marginBetweenBtns"
                    ariaRole="button"
                    type="tertiary"
                    [value]="cancelButtonText"
                    (ctaClick)="secondaryButtonClicked($event)"
                  >
                  </citi-cta>
                </div>
              </div>
              <div *ngIf="footerProjection" class="footer-projection">
                <div [contentHtml]="footerContent">
                  <ng-content select="[footerContent]"></ng-content>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        #modalBg
        class="modal-backdrop citi-modal-backdrop fade"
        [class.in]="isInClassActive"
        [style.display]="isDisplayBlock ? 'block' : 'none'"
      ></div>
    </div>
  `, styles: ["a,abbr,acronym,address,applet,article,aside,audio,b,big,blockquote,body,canvas,caption,center,cite,code,dd,del,details,dfn,div,dl,dt,em,embed,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,html,i,iframe,img,ins,kbd,label,legend,li,mark,menu,nav,object,ol,output,p,pre,q,ruby,s,samp,section,small,span,strike,strong,sub,summary,sup,table,tbody,td,tfoot,th,thead,time,tr,tt,u,ul,var,video{margin:0;padding:0;border:0;font:inherit;vertical-align:baseline}article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section{display:block}body{line-height:1}ol,ul{list-style:none}blockquote,q{quotes:none}blockquote:after,blockquote:before,q:after,q:before{content:\"\";content:none}table{border-collapse:collapse;border-spacing:0}.citi-modal-backdrop{z-index:9999}.border-outline{outline:none}.citi-modal{z-index:10000}.citi-modal .modal-dialog{width:55%;max-width:1200px}@media (max-width: 480px){.citi-modal .modal-dialog{width:100%;max-height:100%;overflow:auto}}@media (min-width: 480px){.citi-modal .modal-dialog{width:100%}.citi-modal .modal-dialog .modal-footer citi-cta{display:inline-block}}@media (min-width: 768px){.citi-modal .modal-dialog{width:65%}}@media (min-width: 1200px){.citi-modal .modal-dialog{width:60%}}@media (min-width: 1440px){.citi-modal .modal-dialog{width:55%}}.citi-modal.scrollable .modal-body{max-height:360px;overflow-x:hidden;overflow-y:auto}@media (max-width: 480px){.citi-modal .modal-footer ::ng-deep .btn{width:100%}}@media (min-width: 480px){.citi-modal .modal-footer ::ng-deep .btn{width:auto}}.citi-modal .modal-secondary-btn ::ng-deep .btn-link{text-decoration:none}.citi-modal .footer-projection ::ng-deep .secondary.chevron-link.chevron-link:after{background-image:none}.citi-modal button.close-button{position:absolute;top:30px;right:35px;padding:0;border:0;width:15px;height:15px;margin-top:4px;margin-right:4px;background-repeat:no-repeat;background-color:transparent;-webkit-appearance:none;opacity:1;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 11'%3E%3Ctitle%3E06-close-white%3C/title%3E%3Cpath d='M21.41,20l3.8-3.79a1,1,0,0,0-1.42-1.42L20,18.59l-3.79-3.8a1,1,0,0,0-1.42,1.42L18.59,20l-3.8,3.79a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L20,21.41l3.79,3.8a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z' transform='translate(-14.5 -14.5)' style='fill:%23666;fill-rule:evenodd'/%3E%3C/svg%3E\")}.citi-modal button.close-button:focus,.citi-modal button.close-button:hover{opacity:1;margin-top:0;margin-right:0;height:25px;width:25px;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E06-close-white-hover%3C/title%3E%3Cpath d='M21.41,20.15l3.8-3.79a1,1,0,0,0,0-1.41,1,1,0,0,0-1.42,0L20,18.74,16.21,15a1,1,0,0,0-1.42,0,1,1,0,0,0,0,1.41l3.8,3.79L14.79,24a1,1,0,0,0,0,1.41,1,1,0,0,0,1.42,0L20,21.57l3.79,3.79a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.41ZM20,9A11,11,0,1,0,31,20,11,11,0,0,0,20,9' transform='translate(-9 -9)' style='fill:%23666;fill-rule:evenodd'/%3E%3C/svg%3E\")}.citi-modal button.close-button :focus-visible{outline:none}.modal.in{overflow-x:hidden;overflow-y:auto}.botPadding{padding-bottom:20px!important}.marginBetweenBtns{margin-left:20px}@media (max-width: 480px){.marginBetweenBtns{margin-left:0}}.header{display:block;box-sizing:border-box;margin-top:0;margin-bottom:20px;font-family:Interstate_Light,sans-serif;font-size:42px;font-weight:200;line-height:3.125rem;text-align:left;letter-spacing:normal}\n"] }]
        }], ctorParameters: () => [{ type: i0.Renderer2 }, { type: i0.NgZone }, { type: i0.ChangeDetectorRef }, { type: CitiLiveAnnouncer }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [NAVIGATOR]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }], propDecorators: { modalHeader: [{
                type: ViewChild,
                args: ['modalHeader']
            }], modalHeaderAlt: [{
                type: ViewChild,
                args: ['modalHeaderAlt']
            }], modal: [{
                type: ViewChild,
                args: ['modal']
            }], modalBg: [{
                type: ViewChild,
                args: ['modalBg']
            }], modalBody: [{
                type: ViewChild,
                args: ['modalBody']
            }], closeButton: [{
                type: ViewChild,
                args: ['closeButton']
            }], primaryButton: [{
                type: ViewChild,
                args: ['primaryButton']
            }], secondaryButton: [{
                type: ViewChild,
                args: ['secondaryButton']
            }], wrapDiv: [{
                type: ViewChild,
                args: ['wrapDiv']
            }], content: [{
                type: ViewChild,
                args: ['content']
            }], scrollable: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }], ariaRole: [{
                type: Input$1
            }], footerContent: [{
                type: Input$1
            }], idStr: [{
                type: Input$1
            }], title: [{
                type: Input$1
            }], primaryButtonUrl: [{
                type: Input$1
            }], primaryButtonTarget: [{
                type: Input$1
            }], primaryButtonText: [{
                type: Input$1
            }], showCancelButton: [{
                type: Input$1
            }], footerProjection: [{
                type: Input$1
            }], disablePrimaryButton: [{
                type: Input$1
            }], disableCloseButton: [{
                type: Input$1
            }], closeOnBgClick: [{
                type: Input$1
            }], cancelButtonText: [{
                type: Input$1
            }], openerSelector: [{
                type: Input$1
            }], show: [{
                type: Input$1
            }], closeButtonIdStr: [{
                type: Input$1
            }], primaryButtonClick: [{
                type: Output
            }], secondaryButtonClick: [{
                type: Output
            }], closeButtonClick: [{
                type: Output
            }], showChange: [{
                type: Output
            }], onHide: [{
                type: Output
            }], onEscape: [{
                type: HostListener,
                args: ['window:keydown', ['$event']]
            }], onClick: [{
                type: HostListener,
                args: ['window:touchstart', ['$event']]
            }, {
                type: HostListener,
                args: ['window:click', ['$event']]
            }] } });

const MODULES$14 = [
    CommonModule,
    ContentHtml
];
class TextHeader {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TextHeader, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: TextHeader, declarations: [TextHeaderComponent], imports: [CommonModule,
            ContentHtml], exports: [TextHeaderComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TextHeader, imports: [MODULES$14] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TextHeader, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$14],
                    declarations: [TextHeaderComponent],
                    exports: [TextHeaderComponent]
                }]
        }] });

const COMPONENTS$14 = [ModalComponent];
const MODULES$13 = [
    CommonModule,
    TextHeader,
    ContentHtml,
    CTA,
    Icons2,
    A11yModule,
    DdlAriaHideOuterDomModule,
];
class Modal {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Modal, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: Modal, declarations: [ModalComponent], imports: [CommonModule,
            TextHeader,
            ContentHtml,
            CTA,
            Icons2,
            A11yModule,
            DdlAriaHideOuterDomModule], exports: [ModalComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Modal, providers: [WINDOW_PROVIDER, NAVIGATOR_PROVIDER], imports: [MODULES$13] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Modal, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$13],
                    declarations: [...COMPONENTS$14],
                    providers: [WINDOW_PROVIDER, NAVIGATOR_PROVIDER],
                    exports: [...COMPONENTS$14]
                }]
        }] });

/*tslint:disable:forin*/
class ContentDirective {
    // receives the content object
    set contentObj(object) {
        if (!!this.mapping)
            object = this.reMap(object);
        // assign the values to the component
        for (const prop in object) {
            this.host[prop] = object[prop];
        }
    }
    // map the content property names to the component property names
    reMap(object) {
        const newObject = {};
        if (!!this.mapping)
            for (const prop in object) {
                newObject[this.mapping[prop]] = object[prop];
            }
        return newObject;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ContentDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.5", type: ContentDirective, isStandalone: false, selector: "[contentObj]", inputs: { host: "host", mapping: "mapping", contentObj: "contentObj" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ContentDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[contentObj]',
                    standalone: false
                }]
        }], propDecorators: { host: [{
                type: Input$1
            }], mapping: [{
                type: Input$1
            }], contentObj: [{
                type: Input$1
            }] } });

class ContentObj {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ContentObj, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: ContentObj, declarations: [ContentDirective], imports: [CommonModule], exports: [ContentDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ContentObj, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ContentObj, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [ContentDirective],
                    exports: [ContentDirective]
                }]
        }] });

class IsFocusedDirective {
    constructor(_el) {
        this._el = _el;
    }
    set isFocused(isFocused) {
        // At the time, I work on this. The ES6 lambda function does not properly set the context (this) to the
        // the directive object. As a result, I fall back using vanilla javascript 'bind' method.
        // This can be change in the future if the context is set properly.
        setTimeout(function () {
            if (isFocused) {
                this._el.nativeElement.focus();
            }
        }.bind(this), 0);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: IsFocusedDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.5", type: IsFocusedDirective, isStandalone: false, selector: "[isFocused]", inputs: { isFocused: "isFocused" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: IsFocusedDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[isFocused]',
                    standalone: false,
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { isFocused: [{
                type: Input$1
            }] } });

class IsFocused {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: IsFocused, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: IsFocused, declarations: [IsFocusedDirective], imports: [CommonModule], exports: [IsFocusedDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: IsFocused, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: IsFocused, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [IsFocusedDirective],
                    exports: [IsFocusedDirective]
                }]
        }] });

const DEFAULT_CONFIG$1 = {
    hasBackdrop: false,
    maxHeight: 40 * 6,
    panelClass: 'overlay-panel',
};
class OverlayPanelDirective {
    constructor(host, vcr, overlay, viewContainerRef, announcer) {
        this.host = host;
        this.vcr = vcr;
        this.overlay = overlay;
        this.viewContainerRef = viewContainerRef;
        this.announcer = announcer;
        this.alive = true;
        this.showing = false;
        this.role = 'application';
    }
    getOverlayConfig(config) {
        const scrollStrategy = this.getOverlayScroll();
        const positionStrategy = this.getOverlayPosition();
        const overlayConfig = new OverlayConfig({
            width: this.origin.offsetWidth,
            backdropClass: config.backdropClass,
            positionStrategy: this.positionStrategy || this.getOverlayPosition(),
            scrollStrategy: this.scrollStrategy || this.getOverlayScroll(),
            maxHeight: config.maxHeight,
            panelClass: config.panelClass,
            hasBackdrop: config.hasBackdrop
        });
        return overlayConfig;
    }
    openDropdown(config = {}) {
        this.showing = true;
        this.syncWidth();
        const dialogConfig = { ...DEFAULT_CONFIG$1, ...config };
        this.overlayRef = this.createOverlay(dialogConfig);
        this.overlayRef.backdropClick().subscribe(() => this.close());
        const template = new TemplatePortal(this.templateRef, this.vcr);
        this.overlayRef.attach(template);
    }
    createOverlay(config) {
        const overlayConfig = this.getOverlayConfig(config);
        return this.overlay.create(overlayConfig);
    }
    getOverlayPosition() {
        const positions = [
            new ConnectionPositionPair({ originX: 'start', originY: 'bottom' }, { overlayX: 'start', overlayY: 'top' }),
            new ConnectionPositionPair({ originX: 'end', originY: 'top' }, { overlayX: 'end', overlayY: 'bottom' })
        ];
        return this.overlay
            .position()
            .flexibleConnectedTo(this.origin)
            .withPositions(positions)
            .withFlexibleDimensions(false)
            .withPush(false);
    }
    getOverlayScroll() {
        return this.overlay.scrollStrategies.reposition();
    }
    onWinResize() {
        this.syncWidth();
    }
    syncWidth() {
        if (!this.overlayRef) {
            return;
        }
        const refRect = this.origin.getBoundingClientRect();
        this.overlayRef.updateSize({ width: refRect.width });
    }
    ngOnDestroy() {
        this.alive = false;
    }
    close() {
        this.overlayRef.detach();
        this.overlayRef.dispose();
        this.overlayRef = null;
        this.showing = false;
        this.announcer.announce('Collapsed');
    }
    get origin() {
        return this.host.nativeElement;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: OverlayPanelDirective, deps: [{ token: i0.ElementRef }, { token: i0.ViewContainerRef }, { token: i1$4.Overlay }, { token: i0.ViewContainerRef }, { token: CitiLiveAnnouncer }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.5", type: OverlayPanelDirective, isStandalone: false, selector: "[citiOverlayPanel]", inputs: { templateRef: "templateRef", positionStrategy: "positionStrategy", scrollStrategy: "scrollStrategy" }, host: { listeners: { "window:resize": "onWinResize()", "window:keydown.escape": "close()" }, properties: { "attr.role": "this.role" } }, exportAs: ["citiOverlayPanel"], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: OverlayPanelDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[citiOverlayPanel]',
                    standalone: false,
                    exportAs: 'citiOverlayPanel'
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.ViewContainerRef }, { type: i1$4.Overlay }, { type: i0.ViewContainerRef }, { type: CitiLiveAnnouncer }], propDecorators: { templateRef: [{
                type: Input$1
            }], positionStrategy: [{
                type: Input$1
            }], scrollStrategy: [{
                type: Input$1
            }], role: [{
                type: HostBinding,
                args: ['attr.role']
            }], onWinResize: [{
                type: HostListener,
                args: ['window:resize']
            }], close: [{
                type: HostListener,
                args: ['window:keydown.escape']
            }] } });

class DdlFocusTrap {
    constructor(focusTrapFactory, elementRef, _document) {
        this.focusTrapFactory = focusTrapFactory;
        this.elementRef = elementRef;
        this._document = _document;
        this.saveFocusedElement();
    }
    ngOnInit() {
        this.focusTrap = this.focusTrapFactory.create(this.elementRef.nativeElement);
        this.focusTrap.focusInitialElementWhenReady();
    }
    ngOnDestroy() {
        this.destroy();
    }
    destroy() {
        this.focusTrap.destroy();
        this.restoreFocus();
    }
    restoreFocus() {
        this.previouslyFocusedElement.focus();
    }
    saveFocusedElement() {
        this.previouslyFocusedElement = this._document.activeElement;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: DdlFocusTrap, deps: [{ token: i1$3.FocusTrapFactory }, { token: i0.ElementRef }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.5", type: DdlFocusTrap, isStandalone: false, selector: "[ddlFocusTrap]", exportAs: ["ddlFocusTrap"], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: DdlFocusTrap, decorators: [{
            type: Directive,
            args: [{
                    selector: '[ddlFocusTrap]',
                    standalone: false,
                    exportAs: 'ddlFocusTrap'
                }]
        }], ctorParameters: () => [{ type: i1$3.FocusTrapFactory }, { type: i0.ElementRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }] });

const COMPONENTS$13 = [OverlayPanelDirective, DdlFocusTrap];
const MODULES$12 = [CommonModule];
class OverlayPanel {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: OverlayPanel, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: OverlayPanel, declarations: [OverlayPanelDirective, DdlFocusTrap], imports: [CommonModule, OverlayModule], exports: [OverlayPanelDirective, DdlFocusTrap, OverlayModule] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: OverlayPanel, imports: [MODULES$12, OverlayModule, OverlayModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: OverlayPanel, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$12, OverlayModule],
                    declarations: [...COMPONENTS$13],
                    exports: [...COMPONENTS$13, OverlayModule]
                }]
        }] });

class LazyLoadImageDirective {
    constructor(el, renderer) {
        this.el = el;
        this.renderer = renderer;
        this.tempImage = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///////ywAAAAAAQABAAACAkQBADs=';
    }
    ngOnInit() {
        this.initLazyLoading();
        this.setAttributes();
    }
    initLazyLoading() {
        if (lazySizes) {
            lazySizes.init();
        }
    }
    setAttributes() {
        this.renderer.addClass(this.el.nativeElement, 'lazyload');
        if (this.el.nativeElement.localName === 'img') {
            this.setImgSrc();
        }
        else {
            this.setElementBackgroundImage();
        }
    }
    setImgSrc() {
        this.renderer.setAttribute(this.el.nativeElement, 'data-src', this.imgSrc);
        this.renderer.setAttribute(this.el.nativeElement, 'src', this.tempImage);
    }
    setElementBackgroundImage() {
        this.renderer.setAttribute(this.el.nativeElement, 'data-bg', this.imgSrc);
        this.renderer.setStyle(this.el.nativeElement, 'background-image', `url(${this.tempImage})`);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: LazyLoadImageDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.5", type: LazyLoadImageDirective, isStandalone: false, selector: "[lazyloadUrl]", inputs: { imgSrc: ["lazyloadUrl", "imgSrc"] }, exportAs: ["lazyloadUrl"], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: LazyLoadImageDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[lazyloadUrl]',
                    standalone: false,
                    exportAs: 'lazyloadUrl',
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.Renderer2 }], propDecorators: { imgSrc: [{
                type: Input$1,
                args: ['lazyloadUrl']
            }] } });

class LazyLoadImage {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: LazyLoadImage, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: LazyLoadImage, declarations: [LazyLoadImageDirective], imports: [CommonModule], exports: [LazyLoadImageDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: LazyLoadImage, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: LazyLoadImage, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [LazyLoadImageDirective],
                    exports: [LazyLoadImageDirective],
                }]
        }] });

let nextTooltipIndex$1 = 0;
class TooltipPopupComponent {
    // #endregion
    // #region ------------- INPUT / OUTPUT --------------//
    /**
     * @property show
     * @description Whether or not the tooltip should be shown
     * @Type: boolean
     * @twoway true
     */
    set show(show) {
        // If we got a boolean and showChange isn't running
        if (typeof show === 'boolean' && !this.showChangeRunning) {
            // If show is true and is not equal to the current show
            if (show && show !== this.open) {
                // Let the tooltip know it is being programmtically opened via [(show)]
                this.tooltipShownProgrammatically = this.tooltipOpenedProgrammatically = true;
                this.openTooltip();
            }
            else if (!show && show !== this.open)
                this.closeTooltip();
        }
    }
    // #endregion
    // #region ----------------- HostListener ------------- ///
    onDocumentClick(event) {
        // Get the target based on click or touch
        const target = event.type === 'click' ? event.target : event.touches[0].target;
        const clickedInside = this.el.nativeElement.contains(target);
        // Emit from emitter to let parent know something clicked outside the given element
        // (any emitted value will work here, true since semantically it is 'true' that someone clicked outside)
        if (!clickedInside)
            this.clickOutside.emit(true);
    }
    // Listen for keyup events
    onDocumentKeyUp(event) {
        this.handleKeyUp(event);
    }
    // Listen for the button to blur (this part enables psuedo tooltip reading for vision-impaired users)
    onButtonBlur(event) {
    }
    // #endregion
    // #region ----------------- Constructor / Lifecycle Hooks ------------- ///
    constructor(el, announcer) {
        this.el = el;
        this.announcer = announcer;
        // #region /// ----------------- Properties ------------------ ///
        // Whether the tooltip is open or not (opening animation)
        this.open = false;
        // Whether the tooltip is closed or not (should be display:none)
        this.closed = true;
        // What the described by should be set to
        this.describedBy = null;
        // The length of the animation when opening/closing the tooltip
        this.animationTimeout = 175;
        // Whether or not the outline should show for keyboard users. Removed on click of the button.
        this.showOutline = true;
        // Whether the show state of the tooltip is changing
        this.showChangeRunning = false;
        // Set to true when the tooltip is set to show programmatically
        this.tooltipShownProgrammatically = false;
        // Set to true when the tooltip is opened programmatically
        this.tooltipOpenedProgrammatically = false;
        // Sets tooltip to different theme
        this.themeClass = null;
        //sets to false when close button is clicked so that tooltip contents won't be read again
        this.announceTooltip = true;
        this.showChange = new EventEmitter();
        this.tooltipIdChange = new EventEmitter();
        /**
         * @property size
         * @description The size of the tooltip.
         * Valid values are small and large.
         * Default value is small.
         * @return string
         * @twoway false
         */
        this.size = 'small';
        /**
         * @property buttonLabel
         * @description Applies an aria-label attribute to the tooltip trigger button
         * @return string
         * @twoway false
         */
        this.buttonLabel = 'tooltip';
        /**
         * @property hasCloseButton
         * @description Whether or not the tooltip should contain a close button
         * @Type: boolean
         * @twoway false
         */
        this.hasCloseButton = true;
        /**
         * @property position
         * @description Where the tooltip should be positioned.
         * Falls back to "auto" positioning if tooltip would extend past the limits of the screen.
         * Valid values: left, right, bottom, top, auto.
         * @return string
         * @twoway false
         */
        this.position = 'bottom';
        /**
         * @property secondaryPosition
         * @description Where the tooltip should be positioned secondarily
         * Valid values: center, left, right
         * @return string
         * @twoway false
         */
        this.secondaryPosition = 'center';
        /**
         * Don't announce the contents of the tooltip when user focuses on tooltip icon
         */
        this.isContentAlerted = true;
        /**
         * @property clickOutside
         * @description emits when a click event occurs outside of the tooltip elements
         * @Type: EventEmitter<any>
         * @twoway false
         */
        this.clickOutside = new EventEmitter();
        /**
         * @property clickClose
         * @description emits only when the close button is clicked
         * @Type: EventEmitter<any>
         * @twoway false
         */
        this.clickClose = new EventEmitter();
    }
    ;
    ngOnInit() {
        this.setTooltipId(this.tooltipId);
        this.addClickOutsideListener();
        this.themeChange();
    }
    //#endregion
    // #region ----------------- Methods ------------- ///
    openTooltip() {
        if (!this.open) {
            // Let the component know that the tooltip is changing its show state
            this.showChangeRunning = true;
            // Cancel the closed timeout
            clearTimeout(this.closedTimeout);
            // Set the tooltip to not closed
            this.closed = false;
            // Makes sure theme is current
            this.themeChange();
            // Wait for the display: none property to be removed from the DOM element so the animation will work correctly
            setTimeout(() => {
                // Open the tooltip
                this.open = true;
                // Emit the change
                this.showChange.emit(true);
                setTimeout(() => {
                    if (this.tooltipTitle) {
                        if (this.tooltipOpenedProgrammatically)
                            this.announcer.announce(this.tooltipTitle + ' ' + this.tooltipBody);
                    }
                    else {
                        if (this.tooltipOpenedProgrammatically)
                            this.announcer.announce(this.tooltipBody);
                    }
                    // Let the tooltip know we are no longer showing programmatically
                    this.tooltipShownProgrammatically = false;
                    // Let the component know that the tooltip is no longer changing its show state
                    this.showChangeRunning = false;
                }, 225);
            }, 0);
        }
        return true;
    }
    closeTooltip(announceCollapsed) {
        if (announceCollapsed && (navigator.userAgent.match(/iPhone|iPad|iPod/i)))
            this.announcer.announce(this.buttonLabel + ' collapsed.', 'assertive');
        if ((navigator.userAgent.match(/Android/i)))
            this.announcer.announce(this.buttonLabel + ' collapsed.', 'assertive');
        if (this.open && !this.tooltipShownProgrammatically) {
            // Let the component know that the tooltip is changing its show state
            this.showChangeRunning = true;
            // Close the tooltip
            this.open = false;
            // If the tooltip was not opened programmatically shift the focus back to the trigger
            if (!this.tooltipOpenedProgrammatically) {
                // commented line: 195 since tooltip body is being read twice on blur of the button.(Issue tracker#1063)
                this.announceTooltip = false;
                this.trigger.nativeElement.focus();
            }
            // Set the tooltipOpenedProgrammatically flag back to false
            this.tooltipOpenedProgrammatically = false;
            // Wait for the close animation to finish
            this.closedTimeout = setTimeout(() => {
                // Set the tooltip to closed
                this.closed = true;
                // Emit the change
                this.showChange.emit(false);
                // Let the component know that the tooltip is no longer changing its show state
                setTimeout(() => this.showChangeRunning = false, 225);
            }, this.animationTimeout);
        }
        return false;
    }
    toggleTooltip(announceCollapsed) {
        // If the tooltip is open, close it
        if (this.open)
            this.closeTooltip(announceCollapsed);
        // Otherwise open it
        else {
            //tslint:disable:whitespace
            if (navigator.userAgent.match(/Android/i)) {
                if (!!this.tooltipTitle && !!this.tooltipBody) {
                    this.announcer
                        .announce('expanded. ' + this.tooltipTitle.replace(/<(?:.|\n)*?>/gm, '') + '. ' + this.tooltipBody.replace(/<(?:.|\n)*?>/gm, ''), 'assertive');
                }
                else if (!!this.tooltipTitle) {
                    this.announcer.announce('expanded. ' + this.tooltipTitle.replace(/<(?:.|\n)*?>/gm, ''), 'assertive');
                }
                else if (!!this.tooltipBody)
                    this.announcer.announce('expanded. ' + this.tooltipBody.replace(/<(?:.|\n)*?>/gm, ''), 'assertive');
            }
            this.openTooltip();
        }
        // Return whether or not the tooltip's final state will be opened or closed
        return !this.open;
    }
    // Sets the unique ID for this tooltip- GET WITH NATE ABOUT HOW TO AVOID ERROR WITHOUT USING SET TIMEOUT TO FORCE CODE INTO NEW LIFECYCLE
    setTooltipId(tooltipId) {
        // If a tooltip id has not been defined
        if (!this.tooltipId) {
            // Generate and set the unique ID
            this.tooltipId = 'citi-tooltip-' + nextTooltipIndex$1++;
            // We need to wait for the initial lifecycle to end before setting the new value
            setTimeout(() => {
                // Emit the new ID in case the parent component wants to use it
                this.tooltipIdChange.emit(this.tooltipId);
            }, 0);
        }
        return this.tooltipId;
    }
    // Adds the listener for when the tooltip is clicked outside of in order to close the tooltip
    addClickOutsideListener() {
        // Listen for a click outside of the tooltip
        this.clickOutside.subscribe(clickedOutside => {
            // don't cast focus to the trigger if closed from click outside
            this.tooltipOpenedProgrammatically = true;
            if (!this.closed)
                this.closeTooltip();
        });
        return this.clickOutside;
    }
    // Handles all key presses on the host
    handleKeyUp(event) {
        // Get the key pressed
        const keyCode = event.keyCode;
        // Switch on key code
        switch (keyCode) {
            // Esc key
            case 27:
                this.closeTooltip();
                break;
            // Tab key
            // case 9:
            //     // If the active element is the host element and the tooltip is not open, set the tooltip to be read by the screen reader (typical tooltip functionality)
            //     this.describedBy = (document.activeElement === this.trigger.nativeElement && !this.open)
            //         ? this.tooltipId + '-content'
            //         : this.describedBy = null;
            //     break;
            // Space bar
            case 32:
                // If the active element is the host element or the close button make sure the outline shows
                if (document.activeElement === this.trigger.nativeElement || document.activeElement === this.closeButton.nativeElement)
                    this.showOutline = true;
        }
    }
    onBlur() {
        if (!this.announceTooltip && !this.open)
            this.announceTooltip = true;
        if (!this.announceTooltip && this.open)
            this.announceTooltip = false;
    }
    onFocus() {
        setTimeout(() => {
            if (this.announceTooltip && this.isContentAlerted) {
                if (!!this.tooltipTitle && !!this.tooltipBody) {
                    this.announcer.announce(this.stripHTML(`${this.tooltipTitle} ${this.tooltipBody}`), 'assertive');
                }
                else if (!!this.tooltipTitle) {
                    this.announcer.announce(this.stripHTML(this.tooltipTitle), 'assertive');
                }
                else if (!!this.tooltipBody)
                    this.announcer.announce(this.stripHTML(this.tooltipBody), 'assertive');
            }
            else
                this.announcer.announce('');
        }, 0);
    }
    stripHTML(str) {
        return str.replace(/<(?:.|\n)*?>/gm, '');
    }
    onCloseClick(event, announceCollapsed) {
        this.onToggleClick(event, announceCollapsed);
        this.announcer.announce("collapsed", 'assertive');
        this.clickClose.emit();
        // this.closeTooltip(announceCollapsed);
    }
    onToggleClick(event, announceCollapsed) {
        // Bypass the flag that skips focusing back on the tooltip trigger since we used the tooltip trigger to close the tooltip
        if (this.tooltipOpenedProgrammatically)
            this.tooltipOpenedProgrammatically = false;
        this.toggleTooltip(announceCollapsed);
    }
    themeChange() {
        this.themeClass = Boolean(this.theme) ? `tooltip-theme-${this.theme}` : '';
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TooltipPopupComponent, deps: [{ token: i0.ElementRef }, { token: CitiLiveAnnouncer }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: TooltipPopupComponent, isStandalone: false, selector: "[citi-tooltip]", inputs: { show: "show", tooltipId: "tooltipId", tooltipBody: "tooltipBody", tooltipTitle: "tooltipTitle", size: "size", buttonLabel: "buttonLabel", hasCloseButton: "hasCloseButton", theme: "theme", position: "position", secondaryPosition: "secondaryPosition", isContentAlerted: "isContentAlerted" }, outputs: { showChange: "showChange", tooltipIdChange: "tooltipIdChange", clickOutside: "clickOutside", clickClose: "clickClose" }, host: { listeners: { "document:click": "onDocumentClick($event)", "document:touchstart": "onDocumentClick($event)", "document:keyup": "onDocumentKeyUp($event)", "blur": "onButtonBlur($event)" } }, viewQueries: [{ propertyName: "trigger", first: true, predicate: ["trigger"], descendants: true }, { propertyName: "tooltip", first: true, predicate: ["tooltip"], descendants: true }, { propertyName: "closeButton", first: true, predicate: ["closeButton"], descendants: true }], ngImport: i0, template: `
    <div #wrapper class="tooltip-wrapper" [ngClass]="themeClass">

    <button #trigger type="button" class="trigger" (blur)="onBlur()" (focus)="onFocus()" [attr.id]="tooltipId + '-button'"
        [attr.aria-label]="buttonLabel" [attr.aria-controls]="tooltipId" [attr.aria-expanded]="open"
        (click)="onToggleClick($event, false)"></button>

    <span class="tooltip-pointer {{position}}" [ngClass]="{'closed': closed, 'open': open}"></span>

    <div #tooltip [attr.id]="tooltipId" role="tooltip" class="tool-tip {{position}}" [ngClass]="{'closed': closed, 'open': open}"
        [attr.aria-labelledby]="buttonId" [attr.aria-hidden]="!open">

        <div class="wrapper" [ngClass]="['position-' + position, 'offset-' + secondaryPosition, size]">

            <div class="content-wrapper">

                <div class="content {{size}}" [attr.id]="tooltipId + '-content'">

                    <p *ngIf="tooltipTitle" class="tooltip-title" [innerHtml]="tooltipTitle"></p>

                    <div *ngIf="tooltipBody" [attr.id]="tooltipId + '-body'" class="tooltip-body"
                        [attr.tabindex]="(!open ? -1 : null)" [innerHtml]="tooltipBody"></div>

                    <div *ngIf="!tooltipBody" [attr.id]="tooltipId + '-body'" class="tooltip-body"
                        [attr.tabindex]="(!open ? -1 : null)">

                        <ng-content></ng-content>

                    </div>

                </div>

                <div #closeButton class= "close-button">
                    <citi-icon2 *ngIf= "hasCloseButton"
                        [idStr]="tooltipId + '-close-btn'"
                        [ariaLabel]= "'close ' + buttonLabel"
                        [tabIndex]= "!open ? null: 0"
                        [attr.aria-hidden]= "!open"
                        [attr.aria-controls]= "tooltipId"
                        name= "06-close"
                        shade= "g1"
                        size= "small"
                        (keyup.enter)= "onCloseClick($event, true)"
                        (click)= "onCloseClick($event, true)">
                    </citi-icon2>
                </div>
            </div>
        </div>
    </div>
</div>

  `, isInline: true, styles: [":host{padding:0;position:relative;display:inline-block;outline-offset:1px}:host>.tooltip-wrapper{width:100%;height:100%;position:absolute;z-index:999}:host>.tooltip-wrapper>.trigger{width:100%;height:100%;border-color:transparent;background-color:transparent;color:transparent}:host>.tooltip-wrapper>.trigger:focus{outline-width:2px;outline-style:solid;outline-color:Highlight}@media (-webkit-min-device-pixel-ratio: 0){:host>.tooltip-wrapper>.trigger:focus{outline-color:-webkit-focus-ring-color;outline-style:auto}}:host>.tooltip-wrapper>.tooltip-pointer{display:block;overflow:hidden;position:absolute;z-index:99999;opacity:0;transition:all 175ms ease}:host>.tooltip-wrapper>.tooltip-pointer.open{opacity:1;transition:all 175ms ease}:host>.tooltip-wrapper>.tooltip-pointer.closed{display:none}:host>.tooltip-wrapper>.tooltip-pointer:after{content:\"\";background:#eee;box-shadow:0 1px 4px #0000003d;display:block;width:15px;height:15px;position:relative;left:5px;top:4px}:host>.tooltip-wrapper>.tooltip-pointer.top{width:24px;height:11px;top:auto;bottom:calc(100% + 4px);left:calc(50% - 12px)}:host>.tooltip-wrapper>.tooltip-pointer.top:after{top:-8px;transform:rotate(45deg)}:host>.tooltip-wrapper>.tooltip-pointer.right{width:11px;height:24px;left:calc(100% + 4px);top:calc(50% - 12px)}:host>.tooltip-wrapper>.tooltip-pointer.right:after{transform:rotate(-45deg)}:host>.tooltip-wrapper>.tooltip-pointer.bottom{width:24px;height:11px;top:calc(100% + 4px);left:calc(50% - 12px)}:host>.tooltip-wrapper>.tooltip-pointer.bottom:after{transform:rotate(45deg)}:host>.tooltip-wrapper>.tooltip-pointer.left{width:11px;height:24px;left:auto;right:calc(100% + 4px);top:calc(50% - 12px)}:host>.tooltip-wrapper>.tooltip-pointer.left:after{left:-8px;transform:rotate(45deg)}:host>.tooltip-wrapper>.tool-tip{text-indent:0;text-align:left;top:0;left:initial;line-height:1.5;position:absolute;width:100%;height:100%;cursor:auto;opacity:0;pointer-events:none;transition:all 175ms ease}:host>.tooltip-wrapper>.tool-tip.open{opacity:1;transition:all 175ms ease}:host>.tooltip-wrapper>.tool-tip.closed{display:none}:host>.tooltip-wrapper>.tool-tip>.wrapper{position:absolute;z-index:1000;pointer-events:auto;background-color:#eee;padding:20px;box-shadow:0 1px 4px #0000003d;width:320px}:host>.tooltip-wrapper>.tool-tip>.wrapper.position-top{bottom:calc(100% + 15px)}:host>.tooltip-wrapper>.tool-tip>.wrapper.position-top.offset-center{left:-160px}:host>.tooltip-wrapper>.tool-tip>.wrapper.position-top.offset-right{left:-15px}:host>.tooltip-wrapper>.tool-tip>.wrapper.position-top.offset-left{left:calc(100% - 305px)}:host>.tooltip-wrapper>.tool-tip>.wrapper.position-right{left:calc(100% + 15px);top:-15px}:host>.tooltip-wrapper>.tool-tip>.wrapper.position-bottom{top:calc(100% + 15px)}:host>.tooltip-wrapper>.tool-tip>.wrapper.position-bottom.offset-center{left:-160px}:host>.tooltip-wrapper>.tool-tip>.wrapper.position-bottom.offset-right{left:-15px}:host>.tooltip-wrapper>.tool-tip>.wrapper.position-bottom.offset-left{left:calc(100% - 305px)}:host>.tooltip-wrapper>.tool-tip>.wrapper.position-left{right:calc(100% + 15px);top:-15px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large{width:460px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-top.offset-center{left:-230px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-top.offset-right{left:-15px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-top.offset-left{left:calc(100% - 445px)}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-bottom.offset-center{left:-230px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-bottom.offset-right{left:-15px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-bottom.offset-left{left:calc(100% - 445px)}@media all and (max-width: 720px){:host>.tooltip-wrapper>.tool-tip>.wrapper.large{width:320px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-top.offset-center{left:-160px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-top.offset-right{left:-15px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-top.offset-left{left:calc(100% - 305px)}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-bottom.offset-center{left:-160px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-bottom.offset-right{left:-15px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-bottom.offset-left{left:calc(100% - 305px)}}:host>.tooltip-wrapper>.tool-tip>.wrapper>.content-wrapper{display:flex;width:100%}:host>.tooltip-wrapper>.tool-tip>.wrapper>.content-wrapper>.content{flex:1 1 auto;width:90%}:host>.tooltip-wrapper>.tool-tip>.wrapper>.content-wrapper>.content>.tooltip-title{font-family:Interstate_Bold,sans-serif;line-height:1;font-size:12px!important}:host>.tooltip-wrapper>.tool-tip>.wrapper>.content-wrapper>.content>.tooltip-body{font-size:12px!important}:host>.tooltip-wrapper>.tool-tip>.wrapper>.content-wrapper>.content>.tooltip-body ::ng-deep *{font-size:12px!important}:host>.tooltip-wrapper>.tool-tip>.wrapper>.content-wrapper>.content.large>.tooltip-title{font-size:1.625rem!important;font-family:Interstate_Light}:host>.tooltip-wrapper>.tool-tip>.wrapper>.content-wrapper>.content.large>.tooltip-body{font-size:1em!important}:host>.tooltip-wrapper>.tool-tip>.wrapper>.content-wrapper>.close-button{width:10%;text-align:right}:host>.tooltip-wrapper.tooltip-theme-dark>.tooltip-pointer:after{background-color:#fff}:host>.tooltip-wrapper.tooltip-theme-dark>.tool-tip>.wrapper{background-color:#fff}::ng-deep #tooltipCloseIcon.sfi.small{margin-top:4px;margin-right:4px}::ng-deep #tooltipCloseIcon.sfi.small:focus,::ng-deep #tooltipCloseIcon.sfi.small:hover{margin-top:0;margin-right:0;height:20px;width:20px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: Icon2Component, selector: "citi-icon2", inputs: ["role", "idStr", "ariaLabel", "ariaHidden", "size", "isHoverSfi", "includeCircle", "type", "svgStyle", "tabIndex", "shade", "name"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TooltipPopupComponent, decorators: [{
            type: Component,
            args: [{ selector: '[citi-tooltip]', standalone: false, template: `
    <div #wrapper class="tooltip-wrapper" [ngClass]="themeClass">

    <button #trigger type="button" class="trigger" (blur)="onBlur()" (focus)="onFocus()" [attr.id]="tooltipId + '-button'"
        [attr.aria-label]="buttonLabel" [attr.aria-controls]="tooltipId" [attr.aria-expanded]="open"
        (click)="onToggleClick($event, false)"></button>

    <span class="tooltip-pointer {{position}}" [ngClass]="{'closed': closed, 'open': open}"></span>

    <div #tooltip [attr.id]="tooltipId" role="tooltip" class="tool-tip {{position}}" [ngClass]="{'closed': closed, 'open': open}"
        [attr.aria-labelledby]="buttonId" [attr.aria-hidden]="!open">

        <div class="wrapper" [ngClass]="['position-' + position, 'offset-' + secondaryPosition, size]">

            <div class="content-wrapper">

                <div class="content {{size}}" [attr.id]="tooltipId + '-content'">

                    <p *ngIf="tooltipTitle" class="tooltip-title" [innerHtml]="tooltipTitle"></p>

                    <div *ngIf="tooltipBody" [attr.id]="tooltipId + '-body'" class="tooltip-body"
                        [attr.tabindex]="(!open ? -1 : null)" [innerHtml]="tooltipBody"></div>

                    <div *ngIf="!tooltipBody" [attr.id]="tooltipId + '-body'" class="tooltip-body"
                        [attr.tabindex]="(!open ? -1 : null)">

                        <ng-content></ng-content>

                    </div>

                </div>

                <div #closeButton class= "close-button">
                    <citi-icon2 *ngIf= "hasCloseButton"
                        [idStr]="tooltipId + '-close-btn'"
                        [ariaLabel]= "'close ' + buttonLabel"
                        [tabIndex]= "!open ? null: 0"
                        [attr.aria-hidden]= "!open"
                        [attr.aria-controls]= "tooltipId"
                        name= "06-close"
                        shade= "g1"
                        size= "small"
                        (keyup.enter)= "onCloseClick($event, true)"
                        (click)= "onCloseClick($event, true)">
                    </citi-icon2>
                </div>
            </div>
        </div>
    </div>
</div>

  `, styles: [":host{padding:0;position:relative;display:inline-block;outline-offset:1px}:host>.tooltip-wrapper{width:100%;height:100%;position:absolute;z-index:999}:host>.tooltip-wrapper>.trigger{width:100%;height:100%;border-color:transparent;background-color:transparent;color:transparent}:host>.tooltip-wrapper>.trigger:focus{outline-width:2px;outline-style:solid;outline-color:Highlight}@media (-webkit-min-device-pixel-ratio: 0){:host>.tooltip-wrapper>.trigger:focus{outline-color:-webkit-focus-ring-color;outline-style:auto}}:host>.tooltip-wrapper>.tooltip-pointer{display:block;overflow:hidden;position:absolute;z-index:99999;opacity:0;transition:all 175ms ease}:host>.tooltip-wrapper>.tooltip-pointer.open{opacity:1;transition:all 175ms ease}:host>.tooltip-wrapper>.tooltip-pointer.closed{display:none}:host>.tooltip-wrapper>.tooltip-pointer:after{content:\"\";background:#eee;box-shadow:0 1px 4px #0000003d;display:block;width:15px;height:15px;position:relative;left:5px;top:4px}:host>.tooltip-wrapper>.tooltip-pointer.top{width:24px;height:11px;top:auto;bottom:calc(100% + 4px);left:calc(50% - 12px)}:host>.tooltip-wrapper>.tooltip-pointer.top:after{top:-8px;transform:rotate(45deg)}:host>.tooltip-wrapper>.tooltip-pointer.right{width:11px;height:24px;left:calc(100% + 4px);top:calc(50% - 12px)}:host>.tooltip-wrapper>.tooltip-pointer.right:after{transform:rotate(-45deg)}:host>.tooltip-wrapper>.tooltip-pointer.bottom{width:24px;height:11px;top:calc(100% + 4px);left:calc(50% - 12px)}:host>.tooltip-wrapper>.tooltip-pointer.bottom:after{transform:rotate(45deg)}:host>.tooltip-wrapper>.tooltip-pointer.left{width:11px;height:24px;left:auto;right:calc(100% + 4px);top:calc(50% - 12px)}:host>.tooltip-wrapper>.tooltip-pointer.left:after{left:-8px;transform:rotate(45deg)}:host>.tooltip-wrapper>.tool-tip{text-indent:0;text-align:left;top:0;left:initial;line-height:1.5;position:absolute;width:100%;height:100%;cursor:auto;opacity:0;pointer-events:none;transition:all 175ms ease}:host>.tooltip-wrapper>.tool-tip.open{opacity:1;transition:all 175ms ease}:host>.tooltip-wrapper>.tool-tip.closed{display:none}:host>.tooltip-wrapper>.tool-tip>.wrapper{position:absolute;z-index:1000;pointer-events:auto;background-color:#eee;padding:20px;box-shadow:0 1px 4px #0000003d;width:320px}:host>.tooltip-wrapper>.tool-tip>.wrapper.position-top{bottom:calc(100% + 15px)}:host>.tooltip-wrapper>.tool-tip>.wrapper.position-top.offset-center{left:-160px}:host>.tooltip-wrapper>.tool-tip>.wrapper.position-top.offset-right{left:-15px}:host>.tooltip-wrapper>.tool-tip>.wrapper.position-top.offset-left{left:calc(100% - 305px)}:host>.tooltip-wrapper>.tool-tip>.wrapper.position-right{left:calc(100% + 15px);top:-15px}:host>.tooltip-wrapper>.tool-tip>.wrapper.position-bottom{top:calc(100% + 15px)}:host>.tooltip-wrapper>.tool-tip>.wrapper.position-bottom.offset-center{left:-160px}:host>.tooltip-wrapper>.tool-tip>.wrapper.position-bottom.offset-right{left:-15px}:host>.tooltip-wrapper>.tool-tip>.wrapper.position-bottom.offset-left{left:calc(100% - 305px)}:host>.tooltip-wrapper>.tool-tip>.wrapper.position-left{right:calc(100% + 15px);top:-15px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large{width:460px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-top.offset-center{left:-230px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-top.offset-right{left:-15px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-top.offset-left{left:calc(100% - 445px)}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-bottom.offset-center{left:-230px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-bottom.offset-right{left:-15px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-bottom.offset-left{left:calc(100% - 445px)}@media all and (max-width: 720px){:host>.tooltip-wrapper>.tool-tip>.wrapper.large{width:320px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-top.offset-center{left:-160px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-top.offset-right{left:-15px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-top.offset-left{left:calc(100% - 305px)}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-bottom.offset-center{left:-160px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-bottom.offset-right{left:-15px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-bottom.offset-left{left:calc(100% - 305px)}}:host>.tooltip-wrapper>.tool-tip>.wrapper>.content-wrapper{display:flex;width:100%}:host>.tooltip-wrapper>.tool-tip>.wrapper>.content-wrapper>.content{flex:1 1 auto;width:90%}:host>.tooltip-wrapper>.tool-tip>.wrapper>.content-wrapper>.content>.tooltip-title{font-family:Interstate_Bold,sans-serif;line-height:1;font-size:12px!important}:host>.tooltip-wrapper>.tool-tip>.wrapper>.content-wrapper>.content>.tooltip-body{font-size:12px!important}:host>.tooltip-wrapper>.tool-tip>.wrapper>.content-wrapper>.content>.tooltip-body ::ng-deep *{font-size:12px!important}:host>.tooltip-wrapper>.tool-tip>.wrapper>.content-wrapper>.content.large>.tooltip-title{font-size:1.625rem!important;font-family:Interstate_Light}:host>.tooltip-wrapper>.tool-tip>.wrapper>.content-wrapper>.content.large>.tooltip-body{font-size:1em!important}:host>.tooltip-wrapper>.tool-tip>.wrapper>.content-wrapper>.close-button{width:10%;text-align:right}:host>.tooltip-wrapper.tooltip-theme-dark>.tooltip-pointer:after{background-color:#fff}:host>.tooltip-wrapper.tooltip-theme-dark>.tool-tip>.wrapper{background-color:#fff}::ng-deep #tooltipCloseIcon.sfi.small{margin-top:4px;margin-right:4px}::ng-deep #tooltipCloseIcon.sfi.small:focus,::ng-deep #tooltipCloseIcon.sfi.small:hover{margin-top:0;margin-right:0;height:20px;width:20px}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: CitiLiveAnnouncer }], propDecorators: { show: [{
                type: Input$1
            }], showChange: [{
                type: Output
            }], tooltipId: [{
                type: Input$1
            }], tooltipIdChange: [{
                type: Output
            }], tooltipBody: [{
                type: Input$1
            }], tooltipTitle: [{
                type: Input$1
            }], size: [{
                type: Input$1
            }], buttonLabel: [{
                type: Input$1
            }], hasCloseButton: [{
                type: Input$1
            }], theme: [{
                type: Input$1
            }], position: [{
                type: Input$1
            }], secondaryPosition: [{
                type: Input$1
            }], isContentAlerted: [{
                type: Input$1
            }], clickOutside: [{
                type: Output
            }], clickClose: [{
                type: Output
            }], trigger: [{
                type: ViewChild,
                args: ['trigger']
            }], tooltip: [{
                type: ViewChild,
                args: ['tooltip']
            }], closeButton: [{
                type: ViewChild,
                args: ['closeButton']
            }], onDocumentClick: [{
                type: HostListener,
                args: ['document:click', ['$event']]
            }, {
                type: HostListener,
                args: ['document:touchstart', ['$event']]
            }], onDocumentKeyUp: [{
                type: HostListener,
                args: ['document:keyup', ['$event']]
            }], onButtonBlur: [{
                type: HostListener,
                args: ['blur', ['$event']]
            }] } });

class TooltipComponent {
    constructor() {
        /**
         * @property clickClose
         * @description emits only when the close button is clicked
         * @Type: Emitter
         * @twoway false
         */
        this.clickClose = new EventEmitter();
        this.tooltipIdChange = new EventEmitter();
        /**
         * @property size
         * @description The size of the tooltip.
         * Valid values are small and large.
         * Default value is small.
         * @return string
         * @twoway false
         */
        this.size = 'small';
        /**
         * @property buttonLabel
         * @description Applies an aria-label attribute to the tooltip trigger button
         * @return string
         * @twoway false
         */
        this.buttonLabel = 'tooltip';
        /**
         * @property hasCloseButton
         * @description Whether or not the tooltip should contain a close button
         * @Type: boolean
         * @twoway false
         */
        this.hasCloseButton = true;
        /**
         * @property position
         * @description Where the tooltip should be positioned.
         * Falls back to "auto" positioning if tooltip would extend past the limits of the screen.
         * Valid values: left, right, bottom, top, auto.
         * @return string
         * @twoway false
         */
        this.position = 'bottom';
        /**
         * @property secondaryPosition
         * @description Where the tooltip should be positioned secondarily
         * Valid values: center, left, right
         * @return string
         * @twoway false
         */
        this.secondaryPosition = 'center';
        /**
         * Don't announce the contents of the tooltip when user focuses on tooltip icon
         */
        this.isContentAlerted = true;
        this.showChange = new EventEmitter();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TooltipComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: TooltipComponent, isStandalone: false, selector: "citi-tooltip:not(.1Q21)", inputs: { tooltipId: "tooltipId", tooltipBody: "tooltipBody", tooltipTitle: "tooltipTitle", size: "size", buttonLabel: "buttonLabel", hasCloseButton: "hasCloseButton", theme: "theme", position: "position", secondaryPosition: "secondaryPosition", isContentAlerted: "isContentAlerted", show: "show" }, outputs: { clickClose: "clickClose", tooltipIdChange: "tooltipIdChange", showChange: "showChange" }, viewQueries: [{ propertyName: "target", first: true, predicate: ["tooltipTarget"], descendants: true }], ngImport: i0, template: `
    <div
        #tooltipTarget
        citi-tooltip
        class="trigger"
        [(tooltipId)]="tooltipId"
        (tooltipIdChange)="tooltipIdChange.emit($event)"
        [tooltipBody]="tooltipBody"
        [tooltipTitle]="tooltipTitle"
        [(show)]="show"
        (showChange)="showChange.emit($event)"
        (clickClose)="clickClose.emit()"
        [position]="position"
        [size]="size"
        [buttonLabel]="buttonLabel"
        [hasCloseButton]="hasCloseButton"
        [secondaryPosition]="secondaryPosition"
        [theme]="theme"
        [isContentAlerted]="isContentAlerted"
    >
        <ng-content></ng-content>
    </div>
    `, isInline: true, styles: [".trigger{position:relative;top:5px;border:none;-webkit-appearance:none;background-color:transparent;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E13-glyph-help-white%3C/title%3E%3Cpath d='M20.05,15.15a6.62,6.62,0,0,1,.95.08,1.21,1.21,0,0,1,1,1.22,1.27,1.27,0,0,1-.41.93l-1.34,1.28A4,4,0,0,0,19,21.58v.57a1,1,0,0,0,2,0v-.57a1.84,1.84,0,0,1,.49-1.35l1.66-1.55A3.23,3.23,0,0,0,24,16.45a3.17,3.17,0,0,0-2.65-3.18,6.93,6.93,0,0,0-2.53,0A3.15,3.15,0,0,0,17,14.37a1.63,1.63,0,0,0-.11.17,1,1,0,0,0-.23.59,1,1,0,0,0,1,1,.76.76,0,0,0,.68-.33,1.54,1.54,0,0,1,.89-.56,3.62,3.62,0,0,1,.82-.09m.95,11a1,1,0,1,1-1-1,1,1,0,0,1,1,1M20,10A10,10,0,1,1,10,20,10,10,0,0,1,20,10m0-1A11,11,0,1,0,31,20,11,11,0,0,0,20,9' transform='translate(-9 -9)' style='fill:%23666;fill-rule:evenodd'/%3E%3C/svg%3E\");width:20px;height:20px}.trigger:hover,.trigger:focus{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E13-glyph-help-white-hover%3C/title%3E%3Cpath d='M20.05,15.15a6.62,6.62,0,0,1,.95.08,1.21,1.21,0,0,1,1,1.22,1.27,1.27,0,0,1-.41.93l-1.34,1.28A4,4,0,0,0,19,21.58v.57a1,1,0,0,0,2,0v-.57a1.84,1.84,0,0,1,.49-1.35l1.66-1.55A3.23,3.23,0,0,0,24,16.45a3.17,3.17,0,0,0-2.65-3.18,6.93,6.93,0,0,0-2.53,0A3.15,3.15,0,0,0,17,14.37a1.63,1.63,0,0,0-.11.17,1,1,0,0,0-.23.59,1,1,0,0,0,1,1,.76.76,0,0,0,.68-.33,1.54,1.54,0,0,1,.89-.56,3.62,3.62,0,0,1,.82-.09m.95,11a1,1,0,1,1-1-1,1,1,0,0,1,1,1M20,9A11,11,0,1,0,31,20,11,11,0,0,0,20,9' transform='translate(-9 -9)' style='fill:%23666;fill-rule:evenodd'/%3E%3C/svg%3E\")}.trigger i{margin:0;position:static}.trigger:active *{position:relative;top:0;left:0;right:initial;bottom:initial}\n"], dependencies: [{ kind: "component", type: TooltipPopupComponent, selector: "[citi-tooltip]", inputs: ["show", "tooltipId", "tooltipBody", "tooltipTitle", "size", "buttonLabel", "hasCloseButton", "theme", "position", "secondaryPosition", "isContentAlerted"], outputs: ["showChange", "tooltipIdChange", "clickOutside", "clickClose"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TooltipComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-tooltip:not(.1Q21)', standalone: false, template: `
    <div
        #tooltipTarget
        citi-tooltip
        class="trigger"
        [(tooltipId)]="tooltipId"
        (tooltipIdChange)="tooltipIdChange.emit($event)"
        [tooltipBody]="tooltipBody"
        [tooltipTitle]="tooltipTitle"
        [(show)]="show"
        (showChange)="showChange.emit($event)"
        (clickClose)="clickClose.emit()"
        [position]="position"
        [size]="size"
        [buttonLabel]="buttonLabel"
        [hasCloseButton]="hasCloseButton"
        [secondaryPosition]="secondaryPosition"
        [theme]="theme"
        [isContentAlerted]="isContentAlerted"
    >
        <ng-content></ng-content>
    </div>
    `, styles: [".trigger{position:relative;top:5px;border:none;-webkit-appearance:none;background-color:transparent;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E13-glyph-help-white%3C/title%3E%3Cpath d='M20.05,15.15a6.62,6.62,0,0,1,.95.08,1.21,1.21,0,0,1,1,1.22,1.27,1.27,0,0,1-.41.93l-1.34,1.28A4,4,0,0,0,19,21.58v.57a1,1,0,0,0,2,0v-.57a1.84,1.84,0,0,1,.49-1.35l1.66-1.55A3.23,3.23,0,0,0,24,16.45a3.17,3.17,0,0,0-2.65-3.18,6.93,6.93,0,0,0-2.53,0A3.15,3.15,0,0,0,17,14.37a1.63,1.63,0,0,0-.11.17,1,1,0,0,0-.23.59,1,1,0,0,0,1,1,.76.76,0,0,0,.68-.33,1.54,1.54,0,0,1,.89-.56,3.62,3.62,0,0,1,.82-.09m.95,11a1,1,0,1,1-1-1,1,1,0,0,1,1,1M20,10A10,10,0,1,1,10,20,10,10,0,0,1,20,10m0-1A11,11,0,1,0,31,20,11,11,0,0,0,20,9' transform='translate(-9 -9)' style='fill:%23666;fill-rule:evenodd'/%3E%3C/svg%3E\");width:20px;height:20px}.trigger:hover,.trigger:focus{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E13-glyph-help-white-hover%3C/title%3E%3Cpath d='M20.05,15.15a6.62,6.62,0,0,1,.95.08,1.21,1.21,0,0,1,1,1.22,1.27,1.27,0,0,1-.41.93l-1.34,1.28A4,4,0,0,0,19,21.58v.57a1,1,0,0,0,2,0v-.57a1.84,1.84,0,0,1,.49-1.35l1.66-1.55A3.23,3.23,0,0,0,24,16.45a3.17,3.17,0,0,0-2.65-3.18,6.93,6.93,0,0,0-2.53,0A3.15,3.15,0,0,0,17,14.37a1.63,1.63,0,0,0-.11.17,1,1,0,0,0-.23.59,1,1,0,0,0,1,1,.76.76,0,0,0,.68-.33,1.54,1.54,0,0,1,.89-.56,3.62,3.62,0,0,1,.82-.09m.95,11a1,1,0,1,1-1-1,1,1,0,0,1,1,1M20,9A11,11,0,1,0,31,20,11,11,0,0,0,20,9' transform='translate(-9 -9)' style='fill:%23666;fill-rule:evenodd'/%3E%3C/svg%3E\")}.trigger i{margin:0;position:static}.trigger:active *{position:relative;top:0;left:0;right:initial;bottom:initial}\n"] }]
        }], propDecorators: { clickClose: [{
                type: Output
            }], tooltipId: [{
                type: Input$1
            }], tooltipIdChange: [{
                type: Output
            }], tooltipBody: [{
                type: Input$1
            }], tooltipTitle: [{
                type: Input$1
            }], size: [{
                type: Input$1
            }], buttonLabel: [{
                type: Input$1
            }], hasCloseButton: [{
                type: Input$1
            }], theme: [{
                type: Input$1
            }], position: [{
                type: Input$1
            }], secondaryPosition: [{
                type: Input$1
            }], isContentAlerted: [{
                type: Input$1
            }], target: [{
                type: ViewChild,
                args: ['tooltipTarget']
            }], show: [{
                type: Input$1
            }], showChange: [{
                type: Output
            }] } });

let nextTooltipIndex = 0;
class TooltipPopupComponent1Q21 {
    // #endregion
    // #region ------------- INPUT / OUTPUT --------------//
    /**
     * @property show
     * @description Whether or not the tooltip should be shown
     * @Type: boolean
     * @twoway true
     */
    set show(show) {
        // If we got a boolean and showChange isn't running
        if (typeof show === 'boolean' && !this.showChangeRunning) {
            // If show is true and is not equal to the current show
            if (show && show !== this.open) {
                // Let the tooltip know it is being programmtically opened via [(show)]
                this.tooltipShownProgrammatically = this.tooltipOpenedProgrammatically = true;
                this.openTooltip();
            }
            else if (!show && show !== this.open)
                this.closeTooltip();
        }
    }
    // #endregion
    // #region ----------------- HostListener ------------- ///
    onDocumentClick(event) {
        // Get the target based on click or touch
        const target = event.type === 'click' ? event.target : event.touches[0].target;
        const clickedInside = this.el.nativeElement.contains(target);
        // Emit from emitter to let parent know something clicked outside the given element
        // (any emitted value will work here, true since semantically it is 'true' that someone clicked outside)
        if (!clickedInside)
            this.clickOutside.emit(true);
    }
    // Listen for keyup events
    onDocumentKeyUp(event) {
        this.handleKeyUp(event);
    }
    // Listen for the button to blur (this part enables psuedo tooltip reading for vision-impaired users)
    onButtonBlur(event) { }
    // #endregion
    // #region ----------------- Constructor / Lifecycle Hooks ------------- ///
    constructor(el, liveAnnouncer) {
        this.el = el;
        this.liveAnnouncer = liveAnnouncer;
        // #region /// ----------------- Properties ------------------ ///
        // Whether the tooltip is open or not (opening animation)
        this.open = false;
        // Whether the tooltip is closed or not (should be display:none)
        this.closed = true;
        // What the described by should be set to
        this.describedBy = null;
        // The length of the animation when opening/closing the tooltip
        this.animationTimeout = 175;
        // Whether or not the outline should show for keyboard users. Removed on click of the button.
        this.showOutline = true;
        // Whether the show state of the tooltip is changing
        this.showChangeRunning = false;
        // Set to true when the tooltip is set to show programmatically
        this.tooltipShownProgrammatically = false;
        // Set to true when the tooltip is opened programmatically
        this.tooltipOpenedProgrammatically = false;
        // Sets tooltip to different theme
        this.themeClass = null;
        this._isExpanded = false;
        this.showChange = new EventEmitter();
        this.tooltipIdChange = new EventEmitter();
        /**
         * @property size
         * @description The size of the tooltip.
         * Valid values are small and large.
         * Default value is small.
         * @return string
         * @twoway false
         */
        this.size = 'small';
        /**
         * @property buttonLabel
         * @description Applies an aria-label attribute to the tooltip trigger button
         * @return string
         * @twoway false
         */
        this.buttonLabel = 'tooltip';
        /**
        * @property closeButtonLabel
        * @description Applies an aria-label attribute to the tooltip trigger button
        * @return string
        * @twoway false
        */
        this.closeButtonLabel = 'tooltip close';
        /**
         * @property hasCloseButton
         * @description Whether or not the tooltip should contain a close button
         * @Type: boolean
         * @twoway false
         */
        this.hasCloseButton = true;
        /**
         * @property position
         * @description Where the tooltip should be positioned.
         * Falls back to "auto" positioning if tooltip would extend past the limits of the screen.
         * Valid values: left, right, bottom, top, auto.
         * @return string
         * @twoway false
         */
        this.position = 'bottom';
        /**
         * @property secondaryPosition
         * @description Where the tooltip should be positioned secondarily
         * Valid values: center, left, right
         * @return string
         * @twoway false
         */
        this.secondaryPosition = 'center';
        /**
         * Don't announce the contents of the tooltip when user focuses on tooltip icon
         */
        this.isContentAlerted = true;
        this.closeOnBgClick = true;
        /**
         * @property clickOutside
         * @description emits when a click event occurs outside of the tooltip elements
         * @Type: EventEmitter<any>
         * @twoway false
         */
        this.clickOutside = new EventEmitter();
        /**
         * @property clickClose
         * @description emits only when the close button is clicked
         * @Type: EventEmitter<any>
         * @twoway false
         */
        this.clickClose = new EventEmitter();
    }
    ngOnInit() {
        this.setTooltipId(this.tooltipId);
        this.addClickOutsideListener();
        this.themeChange();
    }
    //#endregion
    // #region ----------------- Methods ------------- ///
    openTooltip() {
        if (!this.open) {
            // Let the component know that the tooltip is changing its show state
            this.showChangeRunning = true;
            this._isExpanded = true;
            // Cancel the closed timeout
            clearTimeout(this.closedTimeout);
            // Set the tooltip to not closed
            this.closed = false;
            // Makes sure theme is current
            this.themeChange();
            // Wait for the display: none property to be removed from the DOM element so the animation will work correctly
            setTimeout(() => {
                // Open the tooltip
                this.open = true;
                // Emit the change
                this.showChange.emit(true);
                // Let the tooltip know we are no longer showing programmatically
                this.tooltipShownProgrammatically = false;
                // Let the component know that the tooltip is no longer changing its show state
                this.showChangeRunning = false;
                // Let the displayBlock is of the ariahidden
                this._isDisplayBlock = true;
                setTimeout(() => {
                    this.tooltipContent.nativeElement.focus();
                }, 1000);
            }, 10);
        }
        return true;
    }
    closeTooltip(announceCollapsed) {
        if (this.open && !this.tooltipShownProgrammatically) {
            // Let the component know that the tooltip is changing its show state
            this.showChangeRunning = true;
            // Close the tooltip
            this.open = false;
            this._isExpanded = false;
            setTimeout(() => {
                this.trigger.nativeElement.focus();
            }, 150);
            // Set the tooltipOpenedProgrammatically flag back to false
            this.tooltipOpenedProgrammatically = false;
            // Wait for the close animation to finish
            this.closedTimeout = setTimeout(() => {
                // Set the tooltip to closed
                this.closed = true;
                // Emit the change
                this.showChange.emit(false);
                // Let the component know that the tooltip is no longer changing its show state
                setTimeout(() => {
                    this.showChangeRunning = false;
                    // Let the displayBlock is of the ariahidden
                    this._isDisplayBlock = false;
                }, 225);
            }, this.animationTimeout);
        }
        return false;
    }
    closeTooltipOnFocus(announceCollapsed) {
        if (this.open && !this.tooltipShownProgrammatically) {
            // Let the component know that the tooltip is changing its show state
            this.showChangeRunning = true;
            // Close the tooltip
            this.open = false;
            this._isExpanded = false;
            setTimeout(() => {
                this.trigger.nativeElement.focus();
            }, 0);
            this.liveAnnouncer.announce(this.buttonLabel + ' collapsed', 'assertive');
            // Set the tooltipOpenedProgrammatically flag back to false
            this.tooltipOpenedProgrammatically = false;
            // Wait for the close animation to finish
            this.closedTimeout = setTimeout(() => {
                // Set the tooltip to closed
                this.closed = true;
                // Emit the change
                this.showChange.emit(false);
                // Let the component know that the tooltip is no longer changing its show state
                setTimeout(() => {
                    this.showChangeRunning = false;
                    // Let the displayBlock is of the ariahidden
                    this._isDisplayBlock = false;
                }, 100);
            }, this.animationTimeout);
        }
        return false;
    }
    toggleTooltip(announceCollapsed) {
        // If the tooltip is open, close it
        if (this.open)
            this.closeTooltip(announceCollapsed);
        // Otherwise open it
        else {
            this.openTooltip();
        }
        // Return whether or not the tooltip's final state will be opened or closed
        return !this.open;
    }
    // Sets the unique ID for this tooltip- GET WITH NATE ABOUT HOW TO AVOID ERROR WITHOUT USING SET TIMEOUT TO FORCE CODE INTO NEW LIFECYCLE
    setTooltipId(tooltipId) {
        // If a tooltip id has not been defined
        if (!this.tooltipId) {
            // Generate and set the unique ID
            this.tooltipId = 'citi-tooltip-' + nextTooltipIndex++;
            // We need to wait for the initial lifecycle to end before setting the new value
            setTimeout(() => {
                // Emit the new ID in case the parent component wants to use it
                this.tooltipIdChange.emit(this.tooltipId);
            }, 0);
        }
        return this.tooltipId;
    }
    // Adds the listener for when the tooltip is clicked outside of in order to close the tooltip
    addClickOutsideListener() {
        // Listen for a click outside of the tooltip
        this.clickOutside.subscribe(clickedOutside => {
            // don't cast focus to the trigger if closed from click outside
            this.tooltipOpenedProgrammatically = true;
            if (!this.closed && this.closeOnBgClick)
                this.closeTooltip();
        });
        return this.clickOutside;
    }
    // Handles all key presses on the host
    handleKeyUp(event) {
        // Get the key pressed
        const keyCode = event.keyCode;
        // Switch on key code
        switch (keyCode) {
            // Esc key
            case 27:
                this.closeTooltip();
                break;
            // Space bar
            case 32:
                // If the active element is the host element or the close button make sure the outline shows
                if (document.activeElement === this.trigger.nativeElement ||
                    document.activeElement === this.closeButton.nativeElement)
                    this.showOutline = true;
        }
    }
    onBlur() { }
    onFocus() { }
    stripHTML(str) {
        return str.replace(/<(?:.|\n)*?>/gm, '');
    }
    onSpaceKey(event, announceCollapsed) {
        if (event.key === 'Space') {
            event.preventDefault();
            this.closeTooltip(false);
            this.clickClose.emit();
        }
    }
    onCloseClick(event, announceCollapsed) {
        event.preventDefault();
        this.closeTooltip(false);
        this.clickClose.emit();
    }
    onFocusClose(event, announceCollapsed) {
        event.preventDefault();
        this.closeTooltipOnFocus(false);
        this.clickClose.emit();
    }
    onEscKeyDown(event, announceCollapsed) {
        if (this.open) {
            event.preventDefault();
            this.liveAnnouncer.announce('collapsed', 'assertive');
            this.onToggleClick(event, announceCollapsed);
            this.clickClose.emit();
        }
    }
    onCloseEscKeyDown(event, announceCollapsed) {
        if (this.open) {
            event.preventDefault();
            this.liveAnnouncer.announce(this.buttonLabel + ' collapsed', 'assertive');
            this.closeTooltip(false);
            this.clickClose.emit();
        }
    }
    onToggleClick(event, announceCollapsed) {
        // Bypass the flag that skips focusing back on the tooltip trigger since we used the tooltip trigger to close the tooltip
        if (this.tooltipOpenedProgrammatically)
            this.tooltipOpenedProgrammatically = false;
        this.toggleTooltip(announceCollapsed);
    }
    themeChange() {
        this.themeClass = Boolean(this.theme) ? `tooltip-theme-${this.theme}` : '';
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TooltipPopupComponent1Q21, deps: [{ token: i0.ElementRef }, { token: i1$3.LiveAnnouncer }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: TooltipPopupComponent1Q21, isStandalone: false, selector: "[citi-tooltip.1Q21]", inputs: { show: "show", tooltipId: "tooltipId", tooltipBody: "tooltipBody", tooltipTitle: "tooltipTitle", titleHeadingLevel: "titleHeadingLevel", size: "size", buttonLabel: "buttonLabel", closeButtonLabel: "closeButtonLabel", hasCloseButton: "hasCloseButton", theme: "theme", position: "position", secondaryPosition: "secondaryPosition", isContentAlerted: "isContentAlerted", closeOnBgClick: "closeOnBgClick" }, outputs: { showChange: "showChange", tooltipIdChange: "tooltipIdChange", clickOutside: "clickOutside", clickClose: "clickClose" }, host: { listeners: { "document:click": "onDocumentClick($event)", "document:touchstart": "onDocumentClick($event)", "document:keyup": "onDocumentKeyUp($event)", "blur": "onButtonBlur($event)" } }, viewQueries: [{ propertyName: "trigger", first: true, predicate: ["trigger"], descendants: true }, { propertyName: "tooltip", first: true, predicate: ["tooltip"], descendants: true }, { propertyName: "closeButton", first: true, predicate: ["closeButton"], descendants: true }, { propertyName: "tooltipContent", first: true, predicate: ["tooltipContent"], descendants: true }], ngImport: i0, template: `
    <div #wrapper class="tooltip-wrapper" [ngClass]="themeClass">
      <button
        #trigger
        type="button"
        class="tooltip-trigger trigger"
        (blur)="onBlur()"
        (focus)="onFocus()"
        [attr.id]="tooltipId + '-button'"
        [attr.aria-label]="buttonLabel"
        [attr.aria-controls]="tooltipId"
        [attr.aria-expanded]="_isExpanded"
        (click)="onToggleClick($event, false)"
        (keydown.escape)="onEscKeyDown($event, true)"
      ></button>

      <span
        aria-hidden="true"
        class="tooltip-pointer {{ position }}"
        [ngClass]="{ closed: closed, open: open }"
      ></span>

      <div
        #tooltip
        [attr.id]="tooltipId"
        role="tooltip"
        class="tool-tip {{ position }}"
        [ngClass]="{ closed: closed, open: open }"
        [attr.aria-labelledby]="buttonId"
        [attr.aria-hidden]="!open"
      >
        <div
          class="wrapper"
          [ngClass]="[
            'position-' + position,
            'offset-' + secondaryPosition,
            size
          ]"
        >
          <div *ngIf="hasCloseButton">
            <div class="content-wrapper" #tooltipContent>
              <div
                class="content {{ size }}"
                [attr.id]="tooltipId + '-content'"
              >
                <p
                  *ngIf="tooltipTitle && titleHeadingLevel; else hasCloseTitleH2"
                  class="tooltip-title"
                  role="heading"
                  [attr.aria-level]="titleHeadingLevel"
                  [innerHtml]="tooltipTitle"
                ></p>
                <ng-template #hasCloseTitleH2>
                  <h2
                    *ngIf="tooltipTitle"
                    class="tooltip-title"
                    [innerHtml]="tooltipTitle"
                  ></h2>
                </ng-template>

                <div
                  *ngIf="tooltipBody"
                  [attr.id]="tooltipId + '-body'"
                  class="tooltip-body"
                  [innerHtml]="tooltipBody"
                ></div>

                <div
                  *ngIf="!tooltipBody"
                  [attr.id]="tooltipId + '-body'"
                  class="tooltip-body"
                >
                  <ng-content></ng-content>
                </div>
              </div>

              <div class="close-button">
                <button
                  #closeButton
                  *ngIf="hasCloseButton"
                  type="button"
                  role="button"
                  class="citi-tooltip-close close-button"
                  [attr.aria-label]="closeButtonLabel"
                  (click)="onCloseClick($event, true)"
                  (focusout)="onFocusClose($event, true)"
                  (keyup.enter)="onCloseClick($event, true)"
                  (keyup.space)="onSpaceKey($event, true)"
                  (keydown.escape)="onCloseEscKeyDown($event, true)"
                >
                  <span class="sr-only">Close</span>
                </button>
              </div>
            </div>
          </div>

          <div *ngIf="!hasCloseButton">
            <div class="content-wrapper" #tooltipContent>
              <div
                class="content {{ size }}"
                [attr.id]="tooltipId + '-content'"
              >
                <p
                  *ngIf="tooltipTitle && titleHeadingLevel; else noCloseTitleH2"
                  class="tooltip-title"
                  role="heading"
                  [attr.aria-level]="titleHeadingLevel"
                  [innerHtml]="tooltipTitle"
                ></p>
                <ng-template #noCloseTitleH2>
                  <h2
                    *ngIf="tooltipTitle"
                    class="tooltip-title"
                    [innerHtml]="tooltipTitle"
                  ></h2>
                </ng-template>

                <div
                  *ngIf="tooltipBody"
                  [attr.id]="tooltipId + '-body'"
                  class="tooltip-body"
                  [innerHtml]="tooltipBody"
                ></div>

                <div
                  *ngIf="!tooltipBody"
                  [attr.id]="tooltipId + '-body'"
                  class="tooltip-body"
                >
                  <ng-content></ng-content>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `, isInline: true, styles: [":host{padding:0;position:relative;display:inline-block;outline-offset:1px}:host>.tooltip-wrapper{width:100%;height:100%;position:absolute;z-index:999}:host>.tooltip-wrapper>.trigger{width:100%;height:100%;border-color:transparent;background-color:transparent;color:transparent}:host>.tooltip-wrapper>.trigger:focus{outline-width:2px;outline-style:solid;outline-color:Highlight}@media (-webkit-min-device-pixel-ratio: 0){:host>.tooltip-wrapper>.trigger:focus{outline-color:-webkit-focus-ring-color;outline-style:auto}}:host>.tooltip-wrapper>.tooltip-pointer{display:block;overflow:hidden;position:absolute;z-index:99999;opacity:0;transition:all 175ms ease}:host>.tooltip-wrapper>.tooltip-pointer.open{opacity:1;transition:all 175ms ease}:host>.tooltip-wrapper>.tooltip-pointer.closed{display:none}:host>.tooltip-wrapper>.tooltip-pointer:after{content:\"\";background:#eee;box-shadow:0 1px 4px #0000003d;display:block;width:15px;height:15px;position:relative;left:5px;top:4px}:host>.tooltip-wrapper>.tooltip-pointer.top{width:24px;height:11px;top:auto;bottom:calc(100% + 4px);left:calc(50% - 12px)}:host>.tooltip-wrapper>.tooltip-pointer.top:after{top:-8px;transform:rotate(45deg)}:host>.tooltip-wrapper>.tooltip-pointer.right{width:11px;height:24px;left:calc(100% + 4px);top:calc(50% - 12px)}:host>.tooltip-wrapper>.tooltip-pointer.right:after{transform:rotate(-45deg)}:host>.tooltip-wrapper>.tooltip-pointer.bottom{width:24px;height:11px;top:calc(100% + 4px);left:calc(50% - 12px)}:host>.tooltip-wrapper>.tooltip-pointer.bottom:after{transform:rotate(45deg)}:host>.tooltip-wrapper>.tooltip-pointer.left{width:11px;height:24px;left:auto;right:calc(100% + 4px);top:calc(50% - 12px)}:host>.tooltip-wrapper>.tooltip-pointer.left:after{left:-8px;transform:rotate(45deg)}:host>.tooltip-wrapper>.tool-tip{text-indent:0;text-align:left;top:0;left:initial;line-height:1.5;position:absolute;width:100%;height:100%;cursor:auto;opacity:0;pointer-events:none;transition:all 175ms ease}:host>.tooltip-wrapper>.tool-tip.open{opacity:1;transition:all 175ms ease}:host>.tooltip-wrapper>.tool-tip.closed{display:none}:host>.tooltip-wrapper>.tool-tip>.wrapper{position:absolute;z-index:1000;pointer-events:auto;background-color:#eee;padding:20px;box-shadow:0 1px 4px #0000003d;width:320px}:host>.tooltip-wrapper>.tool-tip>.wrapper.position-top{bottom:calc(100% + 15px)}:host>.tooltip-wrapper>.tool-tip>.wrapper.position-top.offset-center{left:-160px}:host>.tooltip-wrapper>.tool-tip>.wrapper.position-top.offset-right{left:-15px}:host>.tooltip-wrapper>.tool-tip>.wrapper.position-top.offset-left{left:calc(100% - 305px)}:host>.tooltip-wrapper>.tool-tip>.wrapper.position-right{left:calc(100% + 15px);top:-15px}:host>.tooltip-wrapper>.tool-tip>.wrapper.position-bottom{top:calc(100% + 15px)}:host>.tooltip-wrapper>.tool-tip>.wrapper.position-bottom.offset-center{left:-160px}:host>.tooltip-wrapper>.tool-tip>.wrapper.position-bottom.offset-right{left:-15px}:host>.tooltip-wrapper>.tool-tip>.wrapper.position-bottom.offset-left{left:calc(100% - 305px)}:host>.tooltip-wrapper>.tool-tip>.wrapper.position-left{right:calc(100% + 15px);top:-15px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large{width:460px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-top.offset-center{left:-230px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-top.offset-right{left:-15px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-top.offset-left{left:calc(100% - 445px)}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-bottom.offset-center{left:-230px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-bottom.offset-right{left:-15px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-bottom.offset-left{left:calc(100% - 445px)}@media all and (max-width: 720px){:host>.tooltip-wrapper>.tool-tip>.wrapper.large{width:320px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-top.offset-center{left:-160px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-top.offset-right{left:-15px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-top.offset-left{left:calc(100% - 305px)}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-bottom.offset-center{left:-160px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-bottom.offset-right{left:-15px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-bottom.offset-left{left:calc(100% - 305px)}}:host>.tooltip-wrapper>.tool-tip>.wrapper .content-wrapper{display:flex;width:100%}:host>.tooltip-wrapper>.tool-tip>.wrapper .content-wrapper>.content{flex:1 1 auto;width:90%}:host>.tooltip-wrapper>.tool-tip>.wrapper .content-wrapper>.content>.tooltip-title{font-family:Interstate_Bold,sans-serif;line-height:1;font-size:12px!important;margin-bottom:12px}:host>.tooltip-wrapper>.tool-tip>.wrapper .content-wrapper>.content>.tooltip-body{font-size:12px!important;font-family:Interstate_Light,sans-serif;font-weight:400}:host>.tooltip-wrapper>.tool-tip>.wrapper .content-wrapper>.content>.tooltip-body ::ng-deep *{font-size:12px!important}:host>.tooltip-wrapper>.tool-tip>.wrapper .content-wrapper>.content.large>.tooltip-title{font-size:1.625rem!important;font-family:Interstate_Light}:host>.tooltip-wrapper>.tool-tip>.wrapper .content-wrapper>.content.large>.tooltip-body{font-size:1em!important}:host>.tooltip-wrapper>.tool-tip>.wrapper .content-wrapper>.close-button{width:10%;text-align:right}:host>.tooltip-wrapper.tooltip-theme-dark>.tooltip-pointer:after{background-color:#fff}:host>.tooltip-wrapper.tooltip-theme-dark>.tool-tip>.wrapper{background-color:#fff}button.close-button{position:absolute;top:10px;right:12px;padding:0;border:0;width:12px;height:12px;margin-top:4px;margin-right:4px;background-repeat:no-repeat;background-color:transparent;-webkit-appearance:none;opacity:1;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 11'%3E%3Ctitle%3E06-close-white%3C/title%3E%3Cpath d='M21.41,20l3.8-3.79a1,1,0,0,0-1.42-1.42L20,18.59l-3.79-3.8a1,1,0,0,0-1.42,1.42L18.59,20l-3.8,3.79a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L20,21.41l3.79,3.8a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z' transform='translate(-14.5 -14.5)' style='fill:%23666;fill-rule:evenodd'/%3E%3C/svg%3E\")}button.close-button:focus,button.close-button:hover{opacity:1;height:12px;width:12px;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E06-close-white-hover%3C/title%3E%3Cpath d='M21.41,20.15l3.8-3.79a1,1,0,0,0,0-1.41,1,1,0,0,0-1.42,0L20,18.74,16.21,15a1,1,0,0,0-1.42,0,1,1,0,0,0,0,1.41l3.8,3.79L14.79,24a1,1,0,0,0,0,1.41,1,1,0,0,0,1.42,0L20,21.57l3.79,3.79a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.41ZM20,9A11,11,0,1,0,31,20,11,11,0,0,0,20,9' transform='translate(-9 -9)' style='fill:%23666;fill-rule:evenodd'/%3E%3C/svg%3E\")}button.close-button :focus-visible{outline:none}::ng-deep #tooltipCloseIcon.sfi.small{margin-top:4px;margin-right:4px}::ng-deep #tooltipCloseIcon.sfi.small:focus,::ng-deep #tooltipCloseIcon.sfi.small:hover{margin-top:0;margin-right:0;height:20px;width:20px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TooltipPopupComponent1Q21, decorators: [{
            type: Component,
            args: [{ selector: '[citi-tooltip.1Q21]', standalone: false, template: `
    <div #wrapper class="tooltip-wrapper" [ngClass]="themeClass">
      <button
        #trigger
        type="button"
        class="tooltip-trigger trigger"
        (blur)="onBlur()"
        (focus)="onFocus()"
        [attr.id]="tooltipId + '-button'"
        [attr.aria-label]="buttonLabel"
        [attr.aria-controls]="tooltipId"
        [attr.aria-expanded]="_isExpanded"
        (click)="onToggleClick($event, false)"
        (keydown.escape)="onEscKeyDown($event, true)"
      ></button>

      <span
        aria-hidden="true"
        class="tooltip-pointer {{ position }}"
        [ngClass]="{ closed: closed, open: open }"
      ></span>

      <div
        #tooltip
        [attr.id]="tooltipId"
        role="tooltip"
        class="tool-tip {{ position }}"
        [ngClass]="{ closed: closed, open: open }"
        [attr.aria-labelledby]="buttonId"
        [attr.aria-hidden]="!open"
      >
        <div
          class="wrapper"
          [ngClass]="[
            'position-' + position,
            'offset-' + secondaryPosition,
            size
          ]"
        >
          <div *ngIf="hasCloseButton">
            <div class="content-wrapper" #tooltipContent>
              <div
                class="content {{ size }}"
                [attr.id]="tooltipId + '-content'"
              >
                <p
                  *ngIf="tooltipTitle && titleHeadingLevel; else hasCloseTitleH2"
                  class="tooltip-title"
                  role="heading"
                  [attr.aria-level]="titleHeadingLevel"
                  [innerHtml]="tooltipTitle"
                ></p>
                <ng-template #hasCloseTitleH2>
                  <h2
                    *ngIf="tooltipTitle"
                    class="tooltip-title"
                    [innerHtml]="tooltipTitle"
                  ></h2>
                </ng-template>

                <div
                  *ngIf="tooltipBody"
                  [attr.id]="tooltipId + '-body'"
                  class="tooltip-body"
                  [innerHtml]="tooltipBody"
                ></div>

                <div
                  *ngIf="!tooltipBody"
                  [attr.id]="tooltipId + '-body'"
                  class="tooltip-body"
                >
                  <ng-content></ng-content>
                </div>
              </div>

              <div class="close-button">
                <button
                  #closeButton
                  *ngIf="hasCloseButton"
                  type="button"
                  role="button"
                  class="citi-tooltip-close close-button"
                  [attr.aria-label]="closeButtonLabel"
                  (click)="onCloseClick($event, true)"
                  (focusout)="onFocusClose($event, true)"
                  (keyup.enter)="onCloseClick($event, true)"
                  (keyup.space)="onSpaceKey($event, true)"
                  (keydown.escape)="onCloseEscKeyDown($event, true)"
                >
                  <span class="sr-only">Close</span>
                </button>
              </div>
            </div>
          </div>

          <div *ngIf="!hasCloseButton">
            <div class="content-wrapper" #tooltipContent>
              <div
                class="content {{ size }}"
                [attr.id]="tooltipId + '-content'"
              >
                <p
                  *ngIf="tooltipTitle && titleHeadingLevel; else noCloseTitleH2"
                  class="tooltip-title"
                  role="heading"
                  [attr.aria-level]="titleHeadingLevel"
                  [innerHtml]="tooltipTitle"
                ></p>
                <ng-template #noCloseTitleH2>
                  <h2
                    *ngIf="tooltipTitle"
                    class="tooltip-title"
                    [innerHtml]="tooltipTitle"
                  ></h2>
                </ng-template>

                <div
                  *ngIf="tooltipBody"
                  [attr.id]="tooltipId + '-body'"
                  class="tooltip-body"
                  [innerHtml]="tooltipBody"
                ></div>

                <div
                  *ngIf="!tooltipBody"
                  [attr.id]="tooltipId + '-body'"
                  class="tooltip-body"
                >
                  <ng-content></ng-content>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `, styles: [":host{padding:0;position:relative;display:inline-block;outline-offset:1px}:host>.tooltip-wrapper{width:100%;height:100%;position:absolute;z-index:999}:host>.tooltip-wrapper>.trigger{width:100%;height:100%;border-color:transparent;background-color:transparent;color:transparent}:host>.tooltip-wrapper>.trigger:focus{outline-width:2px;outline-style:solid;outline-color:Highlight}@media (-webkit-min-device-pixel-ratio: 0){:host>.tooltip-wrapper>.trigger:focus{outline-color:-webkit-focus-ring-color;outline-style:auto}}:host>.tooltip-wrapper>.tooltip-pointer{display:block;overflow:hidden;position:absolute;z-index:99999;opacity:0;transition:all 175ms ease}:host>.tooltip-wrapper>.tooltip-pointer.open{opacity:1;transition:all 175ms ease}:host>.tooltip-wrapper>.tooltip-pointer.closed{display:none}:host>.tooltip-wrapper>.tooltip-pointer:after{content:\"\";background:#eee;box-shadow:0 1px 4px #0000003d;display:block;width:15px;height:15px;position:relative;left:5px;top:4px}:host>.tooltip-wrapper>.tooltip-pointer.top{width:24px;height:11px;top:auto;bottom:calc(100% + 4px);left:calc(50% - 12px)}:host>.tooltip-wrapper>.tooltip-pointer.top:after{top:-8px;transform:rotate(45deg)}:host>.tooltip-wrapper>.tooltip-pointer.right{width:11px;height:24px;left:calc(100% + 4px);top:calc(50% - 12px)}:host>.tooltip-wrapper>.tooltip-pointer.right:after{transform:rotate(-45deg)}:host>.tooltip-wrapper>.tooltip-pointer.bottom{width:24px;height:11px;top:calc(100% + 4px);left:calc(50% - 12px)}:host>.tooltip-wrapper>.tooltip-pointer.bottom:after{transform:rotate(45deg)}:host>.tooltip-wrapper>.tooltip-pointer.left{width:11px;height:24px;left:auto;right:calc(100% + 4px);top:calc(50% - 12px)}:host>.tooltip-wrapper>.tooltip-pointer.left:after{left:-8px;transform:rotate(45deg)}:host>.tooltip-wrapper>.tool-tip{text-indent:0;text-align:left;top:0;left:initial;line-height:1.5;position:absolute;width:100%;height:100%;cursor:auto;opacity:0;pointer-events:none;transition:all 175ms ease}:host>.tooltip-wrapper>.tool-tip.open{opacity:1;transition:all 175ms ease}:host>.tooltip-wrapper>.tool-tip.closed{display:none}:host>.tooltip-wrapper>.tool-tip>.wrapper{position:absolute;z-index:1000;pointer-events:auto;background-color:#eee;padding:20px;box-shadow:0 1px 4px #0000003d;width:320px}:host>.tooltip-wrapper>.tool-tip>.wrapper.position-top{bottom:calc(100% + 15px)}:host>.tooltip-wrapper>.tool-tip>.wrapper.position-top.offset-center{left:-160px}:host>.tooltip-wrapper>.tool-tip>.wrapper.position-top.offset-right{left:-15px}:host>.tooltip-wrapper>.tool-tip>.wrapper.position-top.offset-left{left:calc(100% - 305px)}:host>.tooltip-wrapper>.tool-tip>.wrapper.position-right{left:calc(100% + 15px);top:-15px}:host>.tooltip-wrapper>.tool-tip>.wrapper.position-bottom{top:calc(100% + 15px)}:host>.tooltip-wrapper>.tool-tip>.wrapper.position-bottom.offset-center{left:-160px}:host>.tooltip-wrapper>.tool-tip>.wrapper.position-bottom.offset-right{left:-15px}:host>.tooltip-wrapper>.tool-tip>.wrapper.position-bottom.offset-left{left:calc(100% - 305px)}:host>.tooltip-wrapper>.tool-tip>.wrapper.position-left{right:calc(100% + 15px);top:-15px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large{width:460px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-top.offset-center{left:-230px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-top.offset-right{left:-15px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-top.offset-left{left:calc(100% - 445px)}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-bottom.offset-center{left:-230px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-bottom.offset-right{left:-15px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-bottom.offset-left{left:calc(100% - 445px)}@media all and (max-width: 720px){:host>.tooltip-wrapper>.tool-tip>.wrapper.large{width:320px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-top.offset-center{left:-160px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-top.offset-right{left:-15px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-top.offset-left{left:calc(100% - 305px)}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-bottom.offset-center{left:-160px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-bottom.offset-right{left:-15px}:host>.tooltip-wrapper>.tool-tip>.wrapper.large.position-bottom.offset-left{left:calc(100% - 305px)}}:host>.tooltip-wrapper>.tool-tip>.wrapper .content-wrapper{display:flex;width:100%}:host>.tooltip-wrapper>.tool-tip>.wrapper .content-wrapper>.content{flex:1 1 auto;width:90%}:host>.tooltip-wrapper>.tool-tip>.wrapper .content-wrapper>.content>.tooltip-title{font-family:Interstate_Bold,sans-serif;line-height:1;font-size:12px!important;margin-bottom:12px}:host>.tooltip-wrapper>.tool-tip>.wrapper .content-wrapper>.content>.tooltip-body{font-size:12px!important;font-family:Interstate_Light,sans-serif;font-weight:400}:host>.tooltip-wrapper>.tool-tip>.wrapper .content-wrapper>.content>.tooltip-body ::ng-deep *{font-size:12px!important}:host>.tooltip-wrapper>.tool-tip>.wrapper .content-wrapper>.content.large>.tooltip-title{font-size:1.625rem!important;font-family:Interstate_Light}:host>.tooltip-wrapper>.tool-tip>.wrapper .content-wrapper>.content.large>.tooltip-body{font-size:1em!important}:host>.tooltip-wrapper>.tool-tip>.wrapper .content-wrapper>.close-button{width:10%;text-align:right}:host>.tooltip-wrapper.tooltip-theme-dark>.tooltip-pointer:after{background-color:#fff}:host>.tooltip-wrapper.tooltip-theme-dark>.tool-tip>.wrapper{background-color:#fff}button.close-button{position:absolute;top:10px;right:12px;padding:0;border:0;width:12px;height:12px;margin-top:4px;margin-right:4px;background-repeat:no-repeat;background-color:transparent;-webkit-appearance:none;opacity:1;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 11'%3E%3Ctitle%3E06-close-white%3C/title%3E%3Cpath d='M21.41,20l3.8-3.79a1,1,0,0,0-1.42-1.42L20,18.59l-3.79-3.8a1,1,0,0,0-1.42,1.42L18.59,20l-3.8,3.79a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L20,21.41l3.79,3.8a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z' transform='translate(-14.5 -14.5)' style='fill:%23666;fill-rule:evenodd'/%3E%3C/svg%3E\")}button.close-button:focus,button.close-button:hover{opacity:1;height:12px;width:12px;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E06-close-white-hover%3C/title%3E%3Cpath d='M21.41,20.15l3.8-3.79a1,1,0,0,0,0-1.41,1,1,0,0,0-1.42,0L20,18.74,16.21,15a1,1,0,0,0-1.42,0,1,1,0,0,0,0,1.41l3.8,3.79L14.79,24a1,1,0,0,0,0,1.41,1,1,0,0,0,1.42,0L20,21.57l3.79,3.79a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.41ZM20,9A11,11,0,1,0,31,20,11,11,0,0,0,20,9' transform='translate(-9 -9)' style='fill:%23666;fill-rule:evenodd'/%3E%3C/svg%3E\")}button.close-button :focus-visible{outline:none}::ng-deep #tooltipCloseIcon.sfi.small{margin-top:4px;margin-right:4px}::ng-deep #tooltipCloseIcon.sfi.small:focus,::ng-deep #tooltipCloseIcon.sfi.small:hover{margin-top:0;margin-right:0;height:20px;width:20px}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i1$3.LiveAnnouncer }], propDecorators: { show: [{
                type: Input$1
            }], showChange: [{
                type: Output
            }], tooltipId: [{
                type: Input$1
            }], tooltipIdChange: [{
                type: Output
            }], tooltipBody: [{
                type: Input$1
            }], tooltipTitle: [{
                type: Input$1
            }], titleHeadingLevel: [{
                type: Input$1
            }], size: [{
                type: Input$1
            }], buttonLabel: [{
                type: Input$1
            }], closeButtonLabel: [{
                type: Input$1
            }], hasCloseButton: [{
                type: Input$1
            }], theme: [{
                type: Input$1
            }], position: [{
                type: Input$1
            }], secondaryPosition: [{
                type: Input$1
            }], isContentAlerted: [{
                type: Input$1
            }], closeOnBgClick: [{
                type: Input$1
            }], clickOutside: [{
                type: Output
            }], clickClose: [{
                type: Output
            }], trigger: [{
                type: ViewChild,
                args: ['trigger']
            }], tooltip: [{
                type: ViewChild,
                args: ['tooltip']
            }], closeButton: [{
                type: ViewChild,
                args: ['closeButton']
            }], tooltipContent: [{
                type: ViewChild,
                args: ['tooltipContent']
            }], onDocumentClick: [{
                type: HostListener,
                args: ['document:click', ['$event']]
            }, {
                type: HostListener,
                args: ['document:touchstart', ['$event']]
            }], onDocumentKeyUp: [{
                type: HostListener,
                args: ['document:keyup', ['$event']]
            }], onButtonBlur: [{
                type: HostListener,
                args: ['blur', ['$event']]
            }] } });

class TooltipComponent1Q21 {
    constructor() {
        /**
         * @property clickClose
         * @description emits only when the close button is clicked
         * @Type: Emitter
         * @twoway false
         */
        this.clickClose = new EventEmitter();
        this.tooltipIdChange = new EventEmitter();
        /**
         * @property size
         * @description The size of the tooltip.
         * Valid values are small and large.
         * Default value is small.
         * @return string
         * @twoway false
         */
        this.size = 'small';
        /**
         * @property buttonLabel
         * @description Applies an aria-label attribute to the tooltip trigger button
         * @return string
         * @twoway false
         */
        this.buttonLabel = 'tooltip';
        /**
      * @property closeButtonLabel
      * @description Applies an aria-label attribute to the tooltip trigger button
      * @return string
      * @twoway false
      */
        this.closeButtonLabel = 'tooltip close';
        /**
         * @property hasCloseButton
         * @description Whether or not the tooltip should contain a close button
         * @Type: boolean
         * @twoway false
         */
        this.hasCloseButton = true;
        /**
         * @property position
         * @description Where the tooltip should be positioned.
         * Falls back to "auto" positioning if tooltip would extend past the limits of the screen.
         * Valid values: left, right, bottom, top, auto.
         * @return string
         * @twoway false
         */
        this.position = 'bottom';
        /**
         * @property secondaryPosition
         * @description Where the tooltip should be positioned secondarily
         * Valid values: center, left, right
         * @return string
         * @twoway false
         */
        this.secondaryPosition = 'center';
        /**
         * Don't announce the contents of the tooltip when user focuses on tooltip icon
         */
        this.isContentAlerted = true;
        this.closeOnBgClick = true;
        this.showChange = new EventEmitter();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TooltipComponent1Q21, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: TooltipComponent1Q21, isStandalone: false, selector: "citi-tooltip.1Q21", inputs: { tooltipId: "tooltipId", tooltipBody: "tooltipBody", tooltipTitle: "tooltipTitle", titleHeadingLevel: "titleHeadingLevel", size: "size", buttonLabel: "buttonLabel", closeButtonLabel: "closeButtonLabel", hasCloseButton: "hasCloseButton", theme: "theme", position: "position", secondaryPosition: "secondaryPosition", isContentAlerted: "isContentAlerted", closeOnBgClick: "closeOnBgClick", show: "show" }, outputs: { clickClose: "clickClose", tooltipIdChange: "tooltipIdChange", showChange: "showChange" }, viewQueries: [{ propertyName: "target", first: true, predicate: ["tooltipTarget"], descendants: true }], ngImport: i0, template: `
    <div
      #tooltipTarget
      citi-tooltip.1Q21
      class="trigger"
      [(tooltipId)]="tooltipId"
      (tooltipIdChange)="tooltipIdChange.emit($event)"
      [tooltipBody]="tooltipBody"
      [tooltipTitle]="tooltipTitle"
      [(show)]="show"
      (showChange)="showChange.emit($event)"
      (clickClose)="clickClose.emit()"
      [position]="position"
      [size]="size"
      [buttonLabel]="buttonLabel"
      [closeButtonLabel]="closeButtonLabel"
      [closeOnBgClick]="closeOnBgClick"
      [hasCloseButton]="hasCloseButton"
      [secondaryPosition]="secondaryPosition"
      [theme]="theme"
      [isContentAlerted]="isContentAlerted"
      [titleHeadingLevel]="titleHeadingLevel"
    >
      <ng-content></ng-content>
    </div>
  `, isInline: true, styles: [".trigger{position:relative;top:5px;border:none;-webkit-appearance:none;background-color:transparent;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E13-glyph-help-white%3C/title%3E%3Cpath d='M20.05,15.15a6.62,6.62,0,0,1,.95.08,1.21,1.21,0,0,1,1,1.22,1.27,1.27,0,0,1-.41.93l-1.34,1.28A4,4,0,0,0,19,21.58v.57a1,1,0,0,0,2,0v-.57a1.84,1.84,0,0,1,.49-1.35l1.66-1.55A3.23,3.23,0,0,0,24,16.45a3.17,3.17,0,0,0-2.65-3.18,6.93,6.93,0,0,0-2.53,0A3.15,3.15,0,0,0,17,14.37a1.63,1.63,0,0,0-.11.17,1,1,0,0,0-.23.59,1,1,0,0,0,1,1,.76.76,0,0,0,.68-.33,1.54,1.54,0,0,1,.89-.56,3.62,3.62,0,0,1,.82-.09m.95,11a1,1,0,1,1-1-1,1,1,0,0,1,1,1M20,10A10,10,0,1,1,10,20,10,10,0,0,1,20,10m0-1A11,11,0,1,0,31,20,11,11,0,0,0,20,9' transform='translate(-9 -9)' style='fill:%23666;fill-rule:evenodd'/%3E%3C/svg%3E\");width:20px;height:20px}.trigger:hover,.trigger:focus{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E13-glyph-help-white-hover%3C/title%3E%3Cpath d='M20.05,15.15a6.62,6.62,0,0,1,.95.08,1.21,1.21,0,0,1,1,1.22,1.27,1.27,0,0,1-.41.93l-1.34,1.28A4,4,0,0,0,19,21.58v.57a1,1,0,0,0,2,0v-.57a1.84,1.84,0,0,1,.49-1.35l1.66-1.55A3.23,3.23,0,0,0,24,16.45a3.17,3.17,0,0,0-2.65-3.18,6.93,6.93,0,0,0-2.53,0A3.15,3.15,0,0,0,17,14.37a1.63,1.63,0,0,0-.11.17,1,1,0,0,0-.23.59,1,1,0,0,0,1,1,.76.76,0,0,0,.68-.33,1.54,1.54,0,0,1,.89-.56,3.62,3.62,0,0,1,.82-.09m.95,11a1,1,0,1,1-1-1,1,1,0,0,1,1,1M20,9A11,11,0,1,0,31,20,11,11,0,0,0,20,9' transform='translate(-9 -9)' style='fill:%23666;fill-rule:evenodd'/%3E%3C/svg%3E\")}.trigger i{margin:0;position:static}.trigger:active *{position:relative;top:0;left:0;right:initial;bottom:initial}\n"], dependencies: [{ kind: "component", type: TooltipPopupComponent1Q21, selector: "[citi-tooltip.1Q21]", inputs: ["show", "tooltipId", "tooltipBody", "tooltipTitle", "titleHeadingLevel", "size", "buttonLabel", "closeButtonLabel", "hasCloseButton", "theme", "position", "secondaryPosition", "isContentAlerted", "closeOnBgClick"], outputs: ["showChange", "tooltipIdChange", "clickOutside", "clickClose"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TooltipComponent1Q21, decorators: [{
            type: Component,
            args: [{ selector: 'citi-tooltip.1Q21', standalone: false, template: `
    <div
      #tooltipTarget
      citi-tooltip.1Q21
      class="trigger"
      [(tooltipId)]="tooltipId"
      (tooltipIdChange)="tooltipIdChange.emit($event)"
      [tooltipBody]="tooltipBody"
      [tooltipTitle]="tooltipTitle"
      [(show)]="show"
      (showChange)="showChange.emit($event)"
      (clickClose)="clickClose.emit()"
      [position]="position"
      [size]="size"
      [buttonLabel]="buttonLabel"
      [closeButtonLabel]="closeButtonLabel"
      [closeOnBgClick]="closeOnBgClick"
      [hasCloseButton]="hasCloseButton"
      [secondaryPosition]="secondaryPosition"
      [theme]="theme"
      [isContentAlerted]="isContentAlerted"
      [titleHeadingLevel]="titleHeadingLevel"
    >
      <ng-content></ng-content>
    </div>
  `, styles: [".trigger{position:relative;top:5px;border:none;-webkit-appearance:none;background-color:transparent;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E13-glyph-help-white%3C/title%3E%3Cpath d='M20.05,15.15a6.62,6.62,0,0,1,.95.08,1.21,1.21,0,0,1,1,1.22,1.27,1.27,0,0,1-.41.93l-1.34,1.28A4,4,0,0,0,19,21.58v.57a1,1,0,0,0,2,0v-.57a1.84,1.84,0,0,1,.49-1.35l1.66-1.55A3.23,3.23,0,0,0,24,16.45a3.17,3.17,0,0,0-2.65-3.18,6.93,6.93,0,0,0-2.53,0A3.15,3.15,0,0,0,17,14.37a1.63,1.63,0,0,0-.11.17,1,1,0,0,0-.23.59,1,1,0,0,0,1,1,.76.76,0,0,0,.68-.33,1.54,1.54,0,0,1,.89-.56,3.62,3.62,0,0,1,.82-.09m.95,11a1,1,0,1,1-1-1,1,1,0,0,1,1,1M20,10A10,10,0,1,1,10,20,10,10,0,0,1,20,10m0-1A11,11,0,1,0,31,20,11,11,0,0,0,20,9' transform='translate(-9 -9)' style='fill:%23666;fill-rule:evenodd'/%3E%3C/svg%3E\");width:20px;height:20px}.trigger:hover,.trigger:focus{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'%3E%3Ctitle%3E13-glyph-help-white-hover%3C/title%3E%3Cpath d='M20.05,15.15a6.62,6.62,0,0,1,.95.08,1.21,1.21,0,0,1,1,1.22,1.27,1.27,0,0,1-.41.93l-1.34,1.28A4,4,0,0,0,19,21.58v.57a1,1,0,0,0,2,0v-.57a1.84,1.84,0,0,1,.49-1.35l1.66-1.55A3.23,3.23,0,0,0,24,16.45a3.17,3.17,0,0,0-2.65-3.18,6.93,6.93,0,0,0-2.53,0A3.15,3.15,0,0,0,17,14.37a1.63,1.63,0,0,0-.11.17,1,1,0,0,0-.23.59,1,1,0,0,0,1,1,.76.76,0,0,0,.68-.33,1.54,1.54,0,0,1,.89-.56,3.62,3.62,0,0,1,.82-.09m.95,11a1,1,0,1,1-1-1,1,1,0,0,1,1,1M20,9A11,11,0,1,0,31,20,11,11,0,0,0,20,9' transform='translate(-9 -9)' style='fill:%23666;fill-rule:evenodd'/%3E%3C/svg%3E\")}.trigger i{margin:0;position:static}.trigger:active *{position:relative;top:0;left:0;right:initial;bottom:initial}\n"] }]
        }], propDecorators: { clickClose: [{
                type: Output
            }], tooltipId: [{
                type: Input$1
            }], tooltipIdChange: [{
                type: Output
            }], tooltipBody: [{
                type: Input$1
            }], tooltipTitle: [{
                type: Input$1
            }], titleHeadingLevel: [{
                type: Input$1
            }], size: [{
                type: Input$1
            }], buttonLabel: [{
                type: Input$1
            }], closeButtonLabel: [{
                type: Input$1
            }], hasCloseButton: [{
                type: Input$1
            }], theme: [{
                type: Input$1
            }], position: [{
                type: Input$1
            }], secondaryPosition: [{
                type: Input$1
            }], isContentAlerted: [{
                type: Input$1
            }], closeOnBgClick: [{
                type: Input$1
            }], target: [{
                type: ViewChild,
                args: ['tooltipTarget']
            }], show: [{
                type: Input$1
            }], showChange: [{
                type: Output
            }] } });

const COMPONENTS$12 = [
    TooltipComponent1Q21,
    TooltipPopupComponent1Q21,
];
const MODULES$11 = [
    CommonModule,
    Icons2,
    A11yModule,
    DdlAriaHideOuterDomModule,
];
class CitiTooltip1Q21 {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CitiTooltip1Q21, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: CitiTooltip1Q21, declarations: [TooltipComponent1Q21,
            TooltipPopupComponent1Q21], imports: [CommonModule,
            Icons2,
            A11yModule,
            DdlAriaHideOuterDomModule], exports: [TooltipComponent1Q21,
            TooltipPopupComponent1Q21] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CitiTooltip1Q21, imports: [MODULES$11] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CitiTooltip1Q21, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$11],
                    declarations: [...COMPONENTS$12],
                    exports: [...COMPONENTS$12]
                }]
        }] });

const COMPONENTS$11 = [
    TooltipComponent,
    TooltipPopupComponent,
];
const MODULES$10 = [
    CommonModule,
    Icons2,
    CitiTooltip1Q21,
];
class CitiTooltip {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CitiTooltip, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: CitiTooltip, declarations: [TooltipComponent,
            TooltipPopupComponent], imports: [CommonModule,
            Icons2,
            CitiTooltip1Q21], exports: [TooltipComponent,
            TooltipPopupComponent, CitiTooltip1Q21] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CitiTooltip, imports: [MODULES$10, CitiTooltip1Q21] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CitiTooltip, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$10],
                    declarations: [...COMPONENTS$11],
                    exports: [...COMPONENTS$11, CitiTooltip1Q21]
                }]
        }] });

class ValidationService {
    constructor() {
        this.errors = [];
        this.inputs = [];
        this.hasErrors = function () {
            return this.errors && this.errors.length ? true : false;
        };
        this.addError = function (error) {
            if (this.errors.indexOf(error) === -1) {
                this.errors.push(error);
                this.errorAdded.emit(error);
            }
        };
        this.removeError = function (error) {
            let index = this.errors.indexOf(error);
            if (index !== -1) {
                this.errors.splice(index, 1);
                this.errorRemoved.emit(error);
            }
        };
        this.addInput = function (input) {
            this.inputs.push(input);
        };
        this.errorAdded = new EventEmitter();
        this.errorRemoved = new EventEmitter();
        this.validateNow = new EventEmitter();
    }
    ;
    validate() {
        this.validateNow.emit();
    }
    ;
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ValidationService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ValidationService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ValidationService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class CSSLoaderService {
    constructor() {
        this.cssUrls = new Array();
    }
    /* Remove CSS from the css array and call DOM removal function */
    removeCSS(url) {
        /* Remove from the DOM */
        let head = document.getElementsByTagName('head')[0];
        let links = head.getElementsByTagName('link');
        for (let i = 0; i < links.length; i++) {
            let node = links[i];
            /* Add in url that needs to be added if it does not exist */
            if (node.href.indexOf(url) > -1) {
                head.removeChild(node);
                break;
            }
        }
        /* Remove from the css arrays */
        /* Iterate over css array to see if url has been loaded */
        for (let x = 0; x < this.cssUrls.length; x++) {
            if (this.cssUrls[x] === url) {
                this.cssUrls.splice(x, 1);
                break;
            }
        }
    }
    /* Add a CSS to the css array and add to the DOM */
    addCSS(url) {
        // Create link
        let link = document.createElement('link');
        link.rel = 'stylesheet';
        link.type = 'text/css';
        let head = document.getElementsByTagName('head')[0];
        let links = head.getElementsByTagName('link');
        // Check if the same style sheet has been loaded already.
        let isLoaded = false;
        for (let i = 0; i < links.length; i++) {
            let node = links[i];
            /* Add in url that needs to be added if it does not exist */
            if (node.href.indexOf(url) > -1) {
                isLoaded = true;
            }
        }
        /* If this is not loaded add it to the head */
        if (!isLoaded) {
            link.href = url;
            /* Append to the end of the current state of the head node */
            head.appendChild(link);
            this.cssUrls.push(url);
        }
    }
    getCSSList() {
        return this.cssUrls;
    }
    isLoaded(url) {
        /* Flag to track if url has been found */
        let isLoaded = false;
        /* Iterate over css array to see if url has been loaded */
        for (let x = 0; x < this.cssUrls.length; x++) {
            if (this.cssUrls[x] === url) {
                isLoaded = true;
            }
        }
        /* Return result */
        return isLoaded;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CSSLoaderService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CSSLoaderService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CSSLoaderService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [] });

class JSLoaderService {
    constructor() {
    }
    /* Dynamically load a JS file by creating a HTML element and appending it after the body */
    loadJS(url) {
        let node = document.createElement('script');
        node.src = url;
        node.type = 'text/javascript';
        node.async = true;
        node.charset = 'utf-8';
        document.getElementsByTagName('body')[0].appendChild(node);
    }
    /* Dynamically load a JS file and add a callback for after it is loaded */
    loadJSCallback(url, callback) {
        // Create the script tag and add it to the document
        const slib = document.createElement('script');
        slib.type = 'text/javascript';
        slib.async = true;
        slib.src = url;
        let cdone = false;
        const head = document.getElementsByTagName('head')[0];
        slib.onload = slib.onreadystatechange = function () {
            if (!cdone && (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete')) {
                cdone = true;
                if (callback) {
                    callback();
                }
                // Handle memory leak in IE
                slib.onload = slib.onreadystatechange = null;
                if (head && slib.parentNode) {
                    head.removeChild(slib);
                }
            }
        };
        if (callback) {
            slib.onload = callback;
        }
        const s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(slib, s);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: JSLoaderService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: JSLoaderService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: JSLoaderService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [] });

const LOCATION = new InjectionToken('LocationToken');
function locationFactory(platformId) {
    return isPlatformBrowser(platformId) ? location : null;
}
const LOCATION_PROVIDER = {
    provide: LOCATION,
    useFactory: locationFactory,
    deps: [PLATFORM_ID]
};

class TaggingDataLayerService {
    // #region // ========== Properties ========== //
    get _hasTagMethod() {
        return !!(this._window && this._window.taggingDataLayer);
    }
    // #endregion
    // #region // ========== Constructor ========== //
    constructor(_window) {
        this._window = _window;
    }
    // #endregion
    // #region // ========== Methods ========== //
    /**
     * Update events data
     */
    updateEventData(eventData, eventDataFromApp) {
        if (this._hasTagMethod) {
            if (eventDataFromApp) {
                this._window.taggingDataLayer.updateEventData(eventData, eventDataFromApp);
            }
            else {
                this._window.taggingDataLayer.updateEventData(eventData);
            }
        }
    }
    /**
    * Set application data
    */
    applicationData(applicationContent, appSpecificData) {
        if (this._hasTagMethod) {
            if (appSpecificData) {
                this._window.taggingDataLayer.applicationData(applicationContent, appSpecificData);
            }
            else {
                this._window.taggingDataLayer.applicationData(applicationContent);
            }
        }
    }
    /**
    * Tagging Transformation static data from cms promise
    */
    makeCMSCallPromise(customerId) {
        if (this._hasTagMethod) {
            this._window.taggingDataLayer.makeCMSCallPromise(customerId);
        }
    }
    /**
     * Add new specific data to data layer
     */
    addAppData(parentObject, appSpecificData) {
        if (this._hasTagMethod) {
            this._window.taggingDataLayer.addAppData(parentObject, appSpecificData);
        }
    }
    /**
    * Process CMS data
    */
    processCmsData(response, customerId) {
        if (this._hasTagMethod) {
            this._window.taggingDataLayer.processCmsData(response, customerId);
        }
    }
    /**
     * Get CCID if the user is logged in
     */
    getCCIDFromCCSID(ccsid, cb) {
        if (this._hasTagMethod) {
            this._window.taggingDataLayer.getCCIDFromCCSID(ccsid, cb);
        }
    }
    /**
     * Logging tagging errors
     */
    logTaggingError() {
        if (this._hasTagMethod) {
            this._window.taggingDataLayer.logTaggingError();
        }
    }
    getEnvironmentDetails(browserUrl) {
        if (browserUrl) {
            return this._window && this._window.taggingDataLayer && this._window.taggingDataLayer.getEnvironmentDetails(browserUrl);
        }
        return this._window && this._window.taggingDataLayer && this._window.taggingDataLayer.getEnvironmentDetails();
    }
    getErrorFormat() {
        return this._window && this._window.taggingDataLayer && this._window.taggingDataLayer.getErrorFormat();
    }
    setErrorLogs(errorLogs) {
        if (this._hasTagMethod) {
            this._window.taggingDataLayer.setErrorLogs(errorLogs);
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TaggingDataLayerService, deps: [{ token: WINDOW }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TaggingDataLayerService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TaggingDataLayerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }] });

const BACKSPACE = 8;
const KEY_TAB = 9;
const KEY_ENTER = 13;
const KEY_SHIFT = 16;
const KEY_ESC = 27;
const KEY_SPACEBAR = 32;
const KEY_PAGE_UP = 33;
const KEY_PAGE_DOWN = 34;
const KEY_END = 35;
const KEY_HOME = 36;
const KEY_ARROW_LEFT = 37;
const KEY_ARROW_UP = 38;
const KEY_ARROW_RIGHT = 39;
const KEY_ARROW_DOWN = 40;
const DELETE = 46;
const KEY_0 = 48;
const KEY_1 = 49;
const KEY_2 = 50;
const KEY_3 = 51;
const KEY_4 = 52;
const KEY_5 = 53;
const KEY_6 = 54;
const KEY_7 = 55;
const KEY_8 = 56;
const KEY_9 = 57;
const KEY_NUMPAD_0 = 96;
const KEY_NUMPAD_1 = 97;
const KEY_NUMPAD_2 = 98;
const KEY_NUMPAD_3 = 99;
const KEY_NUMPAD_4 = 100;
const KEY_NUMPAD_5 = 101;
const KEY_NUMPAD_6 = 102;
const KEY_NUMPAD_7 = 103;
const KEY_NUMPAD_8 = 104;
const KEY_NUMPAD_9 = 105;
const PERIOD = 190;

/**
 * @Component: Accordion Section
 * @description This component generates an accordion section
 */
class AccordionSectionComponent {
    set isOpen(isOpen) {
        this.isExpanded = this._isOpen = isOpen;
    }
    get isOpen() {
        return this._isOpen;
    }
    constructor() {
        this.isFocused = false;
        // #endregion
        // #region // ---------- Input/Output ---------- //
        /**
         * @property isCustomSectionHeaderRequired
         * @description Allows overriding the section title
         * Default behavior is false - which means input 'sectionTitle' will be displayed
         * @twoway false
         */
        this.isCustomSectionHeaderRequired = false;
        this.disabled = false;
        this.idStr = null;
        /**
         * @property isOpen
         * @description Checks if the current accordion section is openend/expanded
         * @twoway false
         */
        this._isOpen = false;
        /**
         * @property sectionClicked
         * @description emits when the section button is clicked
         * @twoway false
         */
        this.sectionClicked = new EventEmitter();
        this.accordionHeaderFocusCall = new EventEmitter();
        this.cssClassParent = false;
        this.cssClassLevel1 = false;
        this.attributeRole = 'menuitem';
        this.isExpanded = false;
    }
    // #region // ---------- Methods ---------- //
    focusButton() {
        this.button.nativeElement.focus();
    }
    selectSection(index) {
        this.sectionClicked.emit(index);
    }
    setHeaderFocus(index) {
        this.accordionHeaderFocusCall.emit(index);
    }
    stopBubble(event) {
        event.preventDefault();
        event.stopPropagation();
    }
    arrowNavigate(index) {
        if (this.multi) {
            if (index == this.sectionsLength) {
                this.setHeaderFocus(0);
            }
            else if (index < 0) {
                this.setHeaderFocus(this.sectionsLength - 1);
            }
            else {
                this.setHeaderFocus(index);
            }
        }
        else {
            if (index == this.sectionsLength) {
                this.selectSection(0);
            }
            else if (index < 0) {
                this.selectSection(this.sectionsLength - 1);
            }
            else {
                this.selectSection(index);
            }
        }
    }
    handleKeyPress(event) {
        if (event.key !== "Tab")
            this.stopBubble(event);
        let previousTabIdx = this.sectionIndex - 1;
        let nextTabIdx = this.sectionIndex + 1;
        switch (event.key) {
            case "Home":
                this.setHeaderFocus(0);
                break;
            case "End":
                this.setHeaderFocus(this.sectionsLength - 1);
                break;
            case "ArrowUp":
                window.scrollBy(0, -50);
                break;
            case "ArrowDown":
                window.scrollBy(0, 50);
                break;
            case "ArrowLeft":
                this.arrowNavigate(previousTabIdx);
                break;
            case "ArrowRight":
                this.arrowNavigate(nextTabIdx);
                break;
            case " ":
            case "Enter":
                this.selectSection(this.sectionIndex);
                break;
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: AccordionSectionComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: AccordionSectionComponent, isStandalone: false, selector: "li[citi-accordion-section]", inputs: { isCustomSectionHeaderRequired: "isCustomSectionHeaderRequired", disabled: "disabled", idStr: "idStr", sectionTitle: "sectionTitle", summary: "summary", htmlContent: "htmlContent", isOpen: "isOpen" }, outputs: { sectionClicked: "sectionClicked", accordionHeaderFocusCall: "accordionHeaderFocusCall" }, host: { properties: { "class.disabled": "disabled", "class.parent": "this.cssClassParent", "class.level1": "this.cssClassLevel1", "attr.role": "this.attributeRole", "class.is-expanded": "this.isExpanded" }, classAttribute: "citi-accordion-section" }, viewQueries: [{ propertyName: "button", first: true, predicate: ["button"], descendants: true }], ngImport: i0, template: `
    <button
      #button
      [attr.id]="idStr + '-button'"
      [attr.aria-controls]="idStr"
      [attr.aria-expanded]="_isOpen ? true : false"
      [attr.aria-disabled]="disabled ? true : null"
      [attr.disabled]="disabled ? true : null"
      class="category accordionControlButton"
      (click)="sectionClicked.emit(sectionIndex)"
      (keydown)="handleKeyPress($event)"
      type="button"
      [ngClass]="{
        'btn disabled': disabled,
        'accordion-header-focused': isFocused
      }"

    >
      <citi-icon2
        [ngClass]="{ 'is-expanded': isExpanded }"
        name="02-down"
        [shade]="disabled ? 'g1' : 'b2'"
        ariaLabel="Icon"
        ariaHidden="true"
      >
      </citi-icon2>
      <!--if overwrite flag is off (default behavior), show the section title -->
      <div *ngIf="!isCustomSectionHeaderRequired">
        <span
          [attr.id]="idStr + '-label'"
          *ngIf="sectionTitle"
          class="category-title hold-still"
          [innerHtml]="sectionTitle"
        ></span>
      </div>
      <div *ngIf="isCustomSectionHeaderRequired">
        <!--if overwrite flag is on, display the ngcontent passed into the component-->
        <ng-content select="[sectionHeader]"></ng-content>
      </div>
    </button>

    <!-- expandable area-->
    <div class="accordionSubMenu" [attr.id]="idStr">
      <div class="row">
        <div class="col-xs-12" [contentHtml]="htmlContent">
          <ng-content></ng-content>
        </div>
      </div>
    </div>

    <ng-content select="[footer]"></ng-content>
  `, isInline: true, styles: [".accordionControlButton{background:none;border:none;padding:0;text-align:left;width:100%}.accordionControlButton:hover{cursor:pointer}.accordionControlButton .hold-still{position:relative}.overflowChange{overflow:visible!important}.disabled{pointer-events:none;opacity:.9}citi-icon2.is-expanded ::ng-deep .sfi.b2-02-down{transform:rotate(180deg)}citi-icon2 ::ng-deep .sfi.b2-02-down{display:inline-block;position:absolute;transition:transform .4s ease-in-out;transform:rotate(0);transform-origin:50%}citi-icon2 ::ng-deep .sfi.g1-02-down{display:inline-block;position:absolute;transition:transform .4s ease-in-out;transform:rotate(0);transform-origin:50%}citi-icon2 ::ng-deep .sfi.medium{left:22px;height:8px;top:21px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }, { kind: "component", type: Icon2Component, selector: "citi-icon2", inputs: ["role", "idStr", "ariaLabel", "ariaHidden", "size", "isHoverSfi", "includeCircle", "type", "svgStyle", "tabIndex", "shade", "name"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: AccordionSectionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'li[citi-accordion-section]', standalone: false, host: { class: 'citi-accordion-section', '[class.disabled]': 'disabled' }, template: `
    <button
      #button
      [attr.id]="idStr + '-button'"
      [attr.aria-controls]="idStr"
      [attr.aria-expanded]="_isOpen ? true : false"
      [attr.aria-disabled]="disabled ? true : null"
      [attr.disabled]="disabled ? true : null"
      class="category accordionControlButton"
      (click)="sectionClicked.emit(sectionIndex)"
      (keydown)="handleKeyPress($event)"
      type="button"
      [ngClass]="{
        'btn disabled': disabled,
        'accordion-header-focused': isFocused
      }"

    >
      <citi-icon2
        [ngClass]="{ 'is-expanded': isExpanded }"
        name="02-down"
        [shade]="disabled ? 'g1' : 'b2'"
        ariaLabel="Icon"
        ariaHidden="true"
      >
      </citi-icon2>
      <!--if overwrite flag is off (default behavior), show the section title -->
      <div *ngIf="!isCustomSectionHeaderRequired">
        <span
          [attr.id]="idStr + '-label'"
          *ngIf="sectionTitle"
          class="category-title hold-still"
          [innerHtml]="sectionTitle"
        ></span>
      </div>
      <div *ngIf="isCustomSectionHeaderRequired">
        <!--if overwrite flag is on, display the ngcontent passed into the component-->
        <ng-content select="[sectionHeader]"></ng-content>
      </div>
    </button>

    <!-- expandable area-->
    <div class="accordionSubMenu" [attr.id]="idStr">
      <div class="row">
        <div class="col-xs-12" [contentHtml]="htmlContent">
          <ng-content></ng-content>
        </div>
      </div>
    </div>

    <ng-content select="[footer]"></ng-content>
  `, styles: [".accordionControlButton{background:none;border:none;padding:0;text-align:left;width:100%}.accordionControlButton:hover{cursor:pointer}.accordionControlButton .hold-still{position:relative}.overflowChange{overflow:visible!important}.disabled{pointer-events:none;opacity:.9}citi-icon2.is-expanded ::ng-deep .sfi.b2-02-down{transform:rotate(180deg)}citi-icon2 ::ng-deep .sfi.b2-02-down{display:inline-block;position:absolute;transition:transform .4s ease-in-out;transform:rotate(0);transform-origin:50%}citi-icon2 ::ng-deep .sfi.g1-02-down{display:inline-block;position:absolute;transition:transform .4s ease-in-out;transform:rotate(0);transform-origin:50%}citi-icon2 ::ng-deep .sfi.medium{left:22px;height:8px;top:21px}\n"] }]
        }], ctorParameters: () => [], propDecorators: { isCustomSectionHeaderRequired: [{
                type: Input$1
            }], disabled: [{
                type: Input$1
            }], idStr: [{
                type: Input$1
            }], sectionTitle: [{
                type: Input$1
            }], summary: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }], isOpen: [{
                type: Input$1
            }], sectionClicked: [{
                type: Output
            }], accordionHeaderFocusCall: [{
                type: Output
            }], button: [{
                type: ViewChild,
                args: ['button']
            }], cssClassParent: [{
                type: HostBinding,
                args: ['class.parent']
            }], cssClassLevel1: [{
                type: HostBinding,
                args: ['class.level1']
            }], attributeRole: [{
                type: HostBinding,
                args: ['attr.role']
            }], isExpanded: [{
                type: HostBinding,
                args: ['class.is-expanded']
            }] } });

/**
 * @Component: Accordion
 * @description This component generates the wrapper, title, and expand/collapse
 * button for accordions. Sections for the accordion are a separate component.
 */
class AccordionComponent {
    get noSectionsOpen() {
        return this.sections.find(section => section.isOpen) === undefined;
    }
    onKeyPressHome(event) {
        event.preventDefault();
        this.sections.first.focusButton();
    }
    onKeyPressEnd(event) {
        event.preventDefault();
        this.sections.last.focusButton();
    }
    // #endregion
    // #region // ---------- LIFECYCLE ---------- //
    constructor(el, announcer) {
        this.el = el;
        this.announcer = announcer;
        // #region // ---------- Properties ---------- //
        this.allSectionsOpen = true;
        this.allSectionsDisabled = false;
        this.someSectionsDisabled = false;
        this.focusedHeader = 0;
        /**
         * @property hideToggle
         * @description hide/show expand and collapse link
         */
        this.hideToggle = true;
        /**
         * @property multi
         * @description whether mulitple section are permitted to be open at the same time
         */
        this.multi = true;
        /**
         * @property someSectionsDisabledText
         * @description Screen reader text announcement when some sections disabled
         */
        this.someSectionsDisabledText = 'Some sections not available';
        this.collapseAllButtonText = 'Collapse All Sections';
        this.expandAllButtonText = 'Expand All Sections';
        this.allPanelsClosedText = 'All accordion panels collapsed';
        /**
         * @property expandAllButtonText
         * @description Button text displayed when all items are collapsed
         * @return string
         */
        this.closeOthersText = 'Other Sections Closed';
        this.allSectionsToggled = new EventEmitter();
    }
    ngAfterContentInit() {
        this.checkAllSections();
        this.sections.forEach((section, index) => {
            section.sectionIndex = index;
            section.sectionsLength = this.sections.length;
            section.multi = this.multi;
            section.accordionHeaderFocusCall.subscribe(idx => {
                this.setHeaderFocus(idx);
            });
        });
        this.listenForClicks();
        if (this.sections.toArray().every(section => section.disabled))
            this.allSectionsDisabled = true;
        if (this.sections.some(section => section.disabled))
            this.someSectionsDisabled = true;
    }
    // #endregion
    // #region // ------------ Methods ------------ //
    listenForClicks() {
        this.sections.forEach(section => {
            section.sectionClicked.subscribe(index => {
                if (!this.multi)
                    this.setAllSection(index);
                this.handleSectionToggle(index);
                this.checkAllSections();
            });
        });
    }
    handleSectionToggle(index) {
        const targetSection = this.sections.find(section => section.sectionIndex === index);
        targetSection.isOpen = !targetSection.isOpen;
        this.setHeaderFocus(index);
    }
    checkAllSections() {
        this.allSectionsOpen = this.noSectionsOpen
            ? false
            : !this.sections.some(section => !section.isOpen);
    }
    setAllSection(excludeIndex) {
        this.sections.forEach(section => {
            if (section.sectionIndex !== excludeIndex && section.isOpen) {
                section.isOpen = false;
                if (!this.multi) {
                    if (this.allSectionsOpen) {
                        setTimeout(() => this.announcer.announce(this.allPanelsClosedText), 104);
                    }
                    else {
                        if (!section.sectionTitle) {
                            let sectionNumber = section.sectionIndex + 1;
                            setTimeout(() => this.announcer.announce('Accordion panel ' + sectionNumber + ' collapsed'), 104);
                        }
                        else {
                            setTimeout(() => this.announcer.announce(section.sectionTitle + ' panel collapsed'), 104);
                        }
                    }
                }
            }
        });
    }
    /**
     * @Method: toggleAllSections
     * @description Opens/closes all sections
     * @return Void
     */
    toggleAllSections(event) {
        if (event)
            event.preventDefault();
        if (!this.allSectionsDisabled) {
            this.allSectionsOpen = !this.allSectionsOpen;
            this.sections.forEach(section => {
                if (!section.disabled) {
                    section.isOpen = this.allSectionsOpen;
                }
            });
        }
        if (this.someSectionsDisabled)
            setTimeout(() => this.announcer.announce(this.someSectionsDisabledText), 104);
        this.allSectionsToggled.emit();
    }
    section(index) {
        return this.sections.find((section, i) => i === index);
    }
    clearFocus() {
        this.sections.forEach(tab => (tab.isFocused = false));
    }
    focusActiveSection() {
        setTimeout(() => this.el.nativeElement.querySelector('.accordion-header-focused').focus(), 100);
    }
    setHeaderFocus(index) {
        this.clearFocus();
        this.section(index).isFocused = true;
        this.focusActiveSection();
        this.focusedHeader = index;
    }
    // #endregion
    set childIds(value) {
        if (isDevMode)
            console.warn('"childIds" is a depreacted attribute on the accordion component and will be retired in Janurary. Please remove this attribute.');
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: AccordionComponent, deps: [{ token: i0.ElementRef }, { token: i1$3.LiveAnnouncer }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: AccordionComponent, isStandalone: false, selector: "citi-accordion:not(.2Q23)", inputs: { accordionTitle: "accordionTitle", sectionMainTitle: "sectionMainTitle", hideToggle: "hideToggle", multi: "multi", theme: "theme", someSectionsDisabledText: "someSectionsDisabledText", collapseAllButtonText: "collapseAllButtonText", expandAllButtonText: "expandAllButtonText", allPanelsClosedText: "allPanelsClosedText", expandAllAriaLabelText: "expandAllAriaLabelText", collapseAllAriaLabelText: "collapseAllAriaLabelText", closeOthersText: "closeOthersText", isRightAlignedArrow: "isRightAlignedArrow", childIds: "childIds" }, outputs: { allSectionsToggled: "allSectionsToggled" }, host: { listeners: { "keydown.home": "onKeyPressHome($event)", "keydown.end": "onKeyPressEnd($event)" } }, queries: [{ propertyName: "sections", predicate: i0.forwardRef(() => AccordionSectionComponent) }], ngImport: i0, template: `
    <div [attr.class]="theme === 'dark' ? 'accordion-module' : null">
      <h3 *ngIf="sectionMainTitle" [innerHtml]="sectionMainTitle"></h3>
      <div
        class="accordion menu form linear"
        [ngClass]="{ 'cbolui-right-arrow': isRightAlignedArrow }"
      >
        <div class="row title" *ngIf="!hideToggle">
          <div class="hidden-xs hidden-sm col-xs-12 text-right">
            <button
              [attr.aria-expanded]="allSectionsOpen"
              (click)="toggleAllSections($event)"
              class="desktop toggle-accordion btn btn-link"
              [ngClass]="{'disabled': this.allSectionsDisabled}"
              [attr.aria-disabled]="this.allSectionsDisabled ? true : null"
              [attr.aria-label]="allSectionsOpen && collapseAllAriaLabelText ? collapseAllAriaLabelText
                                : !allSectionsOpen && expandAllAriaLabelText ? expandAllAriaLabelText
                                : null"
              [attr.disabled]="this.allSectionsDisabled ? true : null"
            >
              {{
                allSectionsOpen ? collapseAllButtonText : expandAllButtonText
              }}
            </button>
          </div>

          <div class="hidden-lg hidden-md col-xs-12">
            <button
              [attr.aria-expanded]="allSectionsOpen"
              (click)="toggleAllSections($event)"
              class="mobile toggle-accordion btn btn-link"
              [ngClass]="{'disabled': this.allSectionsDisabled}"
              [attr.aria-disabled]="this.allSectionsDisabled ? true : null"
              [attr.aria-label]="allSectionsOpen && collapseAllAriaLabelText ? collapseAllAriaLabelText
                                : !allSectionsOpen && expandAllAriaLabelText ? expandAllAriaLabelText
                                : null"
              [attr.disabled]="this.allSectionsDisabled ? true : null"
            >
              {{
                allSectionsOpen ? collapseAllButtonText : expandAllButtonText
              }}
            </button>
          </div>
        </div>

        <div class="title"
          *ngIf="accordionTitle"
          [innerHtml]="accordionTitle"
        ></div>
        <ul
          class="mainnav {{ !theme || theme !== 'dark' ? 'theme-light' : null }}"
          role="menu"
        >
          <ng-content></ng-content>
        </ul>
      </div>
    </div>
  `, isInline: true, styles: ["fieldset.dark{margin-bottom:0}[disabled].toggle-accordion:hover{text-decoration:underline}ul.mainnav ::ng-deep li.citi-accordion-section.disabled:hover{background-color:#eee!important}ul.mainnav.theme-light ::ng-deep li.citi-accordion-section.disabled:hover{background-color:#fff!important}.hidden{display:none}.accordion-module fieldset{width:100%;position:relative}:host-context(.theme-light .copy-Accordion) .accordion ul.mainnav ::ng-deep li.parent,:host-context(.theme-light .copy-Accordion) .accordion ul.mainnav ::ng-deep>li{background-color:#eee}:host-context(.theme-light .copy-Accordion) .accordion ul.mainnav ::ng-deep li.is-expanded,:host-context(.theme-light .copy-Accordion) .accordion-module ul.mainnav ::ng-deep li.is-expanded ::ng-deep .accordionSubMenu,:host-context(.theme-light .copy-Accordion) .accordion-module ul.mainnav ::ng-deep li.is-expanded ::ng-deep .category,:host-context(.theme-light .copy-Accordion) .accordion-module ul.mainnav ::ng-deep li:hover{background-color:#fff!important}.accordion-module div.accordion ul.mainnav ::ng-deep>[role=listitem] li.parent{list-style:none}.accordion-module div.accordion ul.mainnav ::ng-deep>[role=listitem]>li.parent>div.accordionSubMenu,.accordion-module div.accordion ul.mainnav ::ng-deep>[role=listitem]>li.parent>div.accordionSubMenu.content-summary{padding:0 20px 0 60px}.accordion-module div.accordion>div.title:nth-child(2) ul.mainnav ::ng-deep li button.category{display:block}.accordion.menu.cbolui-right-arrow ul.mainnav ::ng-deep li.parent .svg-arrow,.accordion.menu.cbolui-right-arrow ul.mainnav ::ng-deep>li .svg-arrow,.accordion.menu.cbolui-right-arrow ul.mainnav ::ng-deep li.parent.is-expanded>.category .svg-arrow,.accordion.menu.cbolui-right-arrow ul.mainnav ::ng-deep>li.is-expanded>.category .svg-arrow{position:relative;float:right;top:8px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: AccordionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-accordion:not(.2Q23)', standalone: false, template: `
    <div [attr.class]="theme === 'dark' ? 'accordion-module' : null">
      <h3 *ngIf="sectionMainTitle" [innerHtml]="sectionMainTitle"></h3>
      <div
        class="accordion menu form linear"
        [ngClass]="{ 'cbolui-right-arrow': isRightAlignedArrow }"
      >
        <div class="row title" *ngIf="!hideToggle">
          <div class="hidden-xs hidden-sm col-xs-12 text-right">
            <button
              [attr.aria-expanded]="allSectionsOpen"
              (click)="toggleAllSections($event)"
              class="desktop toggle-accordion btn btn-link"
              [ngClass]="{'disabled': this.allSectionsDisabled}"
              [attr.aria-disabled]="this.allSectionsDisabled ? true : null"
              [attr.aria-label]="allSectionsOpen && collapseAllAriaLabelText ? collapseAllAriaLabelText
                                : !allSectionsOpen && expandAllAriaLabelText ? expandAllAriaLabelText
                                : null"
              [attr.disabled]="this.allSectionsDisabled ? true : null"
            >
              {{
                allSectionsOpen ? collapseAllButtonText : expandAllButtonText
              }}
            </button>
          </div>

          <div class="hidden-lg hidden-md col-xs-12">
            <button
              [attr.aria-expanded]="allSectionsOpen"
              (click)="toggleAllSections($event)"
              class="mobile toggle-accordion btn btn-link"
              [ngClass]="{'disabled': this.allSectionsDisabled}"
              [attr.aria-disabled]="this.allSectionsDisabled ? true : null"
              [attr.aria-label]="allSectionsOpen && collapseAllAriaLabelText ? collapseAllAriaLabelText
                                : !allSectionsOpen && expandAllAriaLabelText ? expandAllAriaLabelText
                                : null"
              [attr.disabled]="this.allSectionsDisabled ? true : null"
            >
              {{
                allSectionsOpen ? collapseAllButtonText : expandAllButtonText
              }}
            </button>
          </div>
        </div>

        <div class="title"
          *ngIf="accordionTitle"
          [innerHtml]="accordionTitle"
        ></div>
        <ul
          class="mainnav {{ !theme || theme !== 'dark' ? 'theme-light' : null }}"
          role="menu"
        >
          <ng-content></ng-content>
        </ul>
      </div>
    </div>
  `, styles: ["fieldset.dark{margin-bottom:0}[disabled].toggle-accordion:hover{text-decoration:underline}ul.mainnav ::ng-deep li.citi-accordion-section.disabled:hover{background-color:#eee!important}ul.mainnav.theme-light ::ng-deep li.citi-accordion-section.disabled:hover{background-color:#fff!important}.hidden{display:none}.accordion-module fieldset{width:100%;position:relative}:host-context(.theme-light .copy-Accordion) .accordion ul.mainnav ::ng-deep li.parent,:host-context(.theme-light .copy-Accordion) .accordion ul.mainnav ::ng-deep>li{background-color:#eee}:host-context(.theme-light .copy-Accordion) .accordion ul.mainnav ::ng-deep li.is-expanded,:host-context(.theme-light .copy-Accordion) .accordion-module ul.mainnav ::ng-deep li.is-expanded ::ng-deep .accordionSubMenu,:host-context(.theme-light .copy-Accordion) .accordion-module ul.mainnav ::ng-deep li.is-expanded ::ng-deep .category,:host-context(.theme-light .copy-Accordion) .accordion-module ul.mainnav ::ng-deep li:hover{background-color:#fff!important}.accordion-module div.accordion ul.mainnav ::ng-deep>[role=listitem] li.parent{list-style:none}.accordion-module div.accordion ul.mainnav ::ng-deep>[role=listitem]>li.parent>div.accordionSubMenu,.accordion-module div.accordion ul.mainnav ::ng-deep>[role=listitem]>li.parent>div.accordionSubMenu.content-summary{padding:0 20px 0 60px}.accordion-module div.accordion>div.title:nth-child(2) ul.mainnav ::ng-deep li button.category{display:block}.accordion.menu.cbolui-right-arrow ul.mainnav ::ng-deep li.parent .svg-arrow,.accordion.menu.cbolui-right-arrow ul.mainnav ::ng-deep>li .svg-arrow,.accordion.menu.cbolui-right-arrow ul.mainnav ::ng-deep li.parent.is-expanded>.category .svg-arrow,.accordion.menu.cbolui-right-arrow ul.mainnav ::ng-deep>li.is-expanded>.category .svg-arrow{position:relative;float:right;top:8px}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i1$3.LiveAnnouncer }], propDecorators: { accordionTitle: [{
                type: Input$1
            }], sectionMainTitle: [{
                type: Input$1
            }], hideToggle: [{
                type: Input$1
            }], multi: [{
                type: Input$1
            }], theme: [{
                type: Input$1
            }], someSectionsDisabledText: [{
                type: Input$1
            }], collapseAllButtonText: [{
                type: Input$1
            }], expandAllButtonText: [{
                type: Input$1
            }], allPanelsClosedText: [{
                type: Input$1
            }], expandAllAriaLabelText: [{
                type: Input$1
            }], collapseAllAriaLabelText: [{
                type: Input$1
            }], closeOthersText: [{
                type: Input$1
            }], isRightAlignedArrow: [{
                type: Input$1
            }], allSectionsToggled: [{
                type: Output
            }], sections: [{
                type: ContentChildren,
                args: [forwardRef(() => AccordionSectionComponent)]
            }], onKeyPressHome: [{
                type: HostListener,
                args: ['keydown.home', ['$event']]
            }], onKeyPressEnd: [{
                type: HostListener,
                args: ['keydown.end', ['$event']]
            }], childIds: [{
                type: Input$1
            }] } });

/**
 * @Component: Accordion Section
 * @description This component generates an accordion section
 */
class AccordionSectionComponent2Q23 {
    set isOpen(isOpen) {
        this.isExpanded = this._isOpen = isOpen;
    }
    get isOpen() {
        return this._isOpen;
    }
    constructor() {
        this.isFocused = false;
        // #endregion
        // #region // ---------- Input/Output ---------- //
        this.panelHeaderLevel = 5;
        /**
         * @property isCustomSectionHeaderRequired
         * @description Allows overriding the section title
         * Default behavior is false - which means input 'sectionTitle' will be displayed
         * @twoway false
         */
        this.isCustomSectionHeaderRequired = false;
        this.disabled = false;
        this.idStr = null;
        this._isOpen = false;
        this.sectionClicked = new EventEmitter();
        this.accordionHeaderFocusCall = new EventEmitter();
        this.cssClassParent = false;
        this.cssClassLevel1 = false;
        this.isExpanded = false;
    }
    // #region // ---------- Methods ---------- //
    focusButton() {
        this.button.nativeElement.focus();
    }
    selectSection(index) {
        this.sectionClicked.emit(index);
    }
    setHeaderFocus(index) {
        this.accordionHeaderFocusCall.emit(index);
    }
    stopBubble(event) {
        event.preventDefault();
        event.stopPropagation();
    }
    arrowNavigate(index) {
        if (this.multi) {
            if (index == this.sectionsLength) {
                this.setHeaderFocus(0);
            }
            else if (index < 0) {
                this.setHeaderFocus(this.sectionsLength - 1);
            }
            else {
                this.setHeaderFocus(index);
            }
        }
        else {
            if (index == this.sectionsLength) {
                this.selectSection(0);
            }
            else if (index < 0) {
                this.selectSection(this.sectionsLength - 1);
            }
            else {
                this.selectSection(index);
            }
        }
    }
    handleKeyPress(event) {
        if (event.key !== "Tab")
            this.stopBubble(event);
        let previousTabIdx = this.sectionIndex - 1;
        let nextTabIdx = this.sectionIndex + 1;
        switch (event.key) {
            case "Home":
                this.setHeaderFocus(0);
                break;
            case "End":
                this.setHeaderFocus(this.sectionsLength - 1);
                break;
            case "ArrowUp":
                window.scrollBy(0, -50);
                break;
            case "ArrowDown":
                window.scrollBy(0, 50);
                break;
            case "ArrowLeft":
                this.arrowNavigate(previousTabIdx);
                break;
            case "ArrowRight":
                this.arrowNavigate(nextTabIdx);
                break;
            case " ":
            case "Enter":
                this.selectSection(this.sectionIndex);
                break;
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: AccordionSectionComponent2Q23, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: AccordionSectionComponent2Q23, isStandalone: false, selector: "citi-accordion-section.2Q23", inputs: { panelHeaderLevel: "panelHeaderLevel", isCustomSectionHeaderRequired: "isCustomSectionHeaderRequired", disabled: "disabled", idStr: "idStr", sectionTitle: "sectionTitle", htmlContent: "htmlContent", summary: "summary", isOpen: "isOpen" }, outputs: { sectionClicked: "sectionClicked", accordionHeaderFocusCall: "accordionHeaderFocusCall" }, host: { properties: { "class.disabled": "disabled", "class.parent": "this.cssClassParent", "class.level1": "this.cssClassLevel1", "attr.role": "this.attributeRole", "class.is-expanded": "this.isExpanded" }, classAttribute: "citi-accordion-section" }, viewQueries: [{ propertyName: "button", first: true, predicate: ["button"], descendants: true }], ngImport: i0, template: `
    <div class="accordion-section {{theme == 'dark' ? 'dark' : null}}">
      <div role="heading" [attr.aria-level]="panelHeaderLevel">
        <button
          #button
          [attr.id]="idStr + '-button'"
          [attr.aria-controls]="idStr"
          [attr.aria-expanded]="_isOpen ? true : false"
          [attr.aria-disabled]="disabled ? true : null"
          [attr.disabled]="disabled ? true : null"
          class="accordion-trigger"
          (click)="sectionClicked.emit(sectionIndex)"
          (keydown)="handleKeyPress($event)"
          type="button"
          [ngClass]="{
            'btn disabled': disabled,
            'is-expanded': isExpanded,
            'accordion-header-focused': isFocused
          }"
        >
          <citi-icon2
            [ngClass]="{ 'is-expanded': isExpanded }"
            name="02-down"
            [shade]="disabled ? 'g1' : 'b2'"
            ariaLabel="Icon"
            ariaHidden="true"
          >
          </citi-icon2>
          <!--if overwrite flag is off (default behavior), show the section title -->
          <div
            [attr.id]="idStr + '-label'"
            *ngIf="!isCustomSectionHeaderRequired && sectionTitle"
            class="category-title"
            [innerHtml]="sectionTitle"
          ></div>
          <div *ngIf="isCustomSectionHeaderRequired" class="category-title">
            <!--if overwrite flag is on, display the ngcontent passed into the component-->
            <ng-content select="[sectionHeader]"></ng-content>
          </div>
        </button>
      </div>
      <!-- expandable area-->
      <div
        class="accordion-panel"
        [attr.id]="idStr"
        [ngClass]="{ 'active': isExpanded }"
        [contentHtml]="htmlContent">
        <ng-content></ng-content>
      </div>
      <ng-content select="[footer]"></ng-content>
    </div>
  `, isInline: true, styles: [".overflowChange{overflow:visible!important}citi-icon2.is-expanded ::ng-deep .sfi.b2-02-down{transform:rotate(180deg)}citi-icon2 ::ng-deep .sfi.b2-02-down{display:inline-block;position:absolute;transition:transform .4s ease-in-out;transform:rotate(0);transform-origin:50%}citi-icon2 ::ng-deep .sfi.g1-02-down{display:inline-block;position:absolute;transition:transform .4s ease-in-out;transform:rotate(0);transform-origin:50%}citi-icon2 ::ng-deep .sfi.medium{left:22px;height:8px;top:21px}.accordion-section{background-color:#fff;border-top:1px solid #999}.accordion-trigger{background:none;border:none;color:#333;display:block;font-family:Interstate_Light,sans-serif;line-height:22px;font-size:1rem;padding:17px 20px 17px 60px;position:relative;text-align:left;width:100%}.accordion-trigger.is-expanded{background-color:#eee;color:#056dae}.accordion-trigger:hover{background-color:#eee;cursor:pointer}.accordion-trigger:hover .category-title{color:#002a54;text-decoration:underline}.accordion-trigger.disabled{cursor:default}.accordion-panel{color:#333;display:none;margin:auto;max-height:0;padding-left:25px;padding-right:10px;padding-bottom:10px;transition:max-height .4s ease-out,background-color .5s ease-in-out,visibility 1ms ease .501s;visibility:hidden;width:100%}.accordion-panel.active{background-color:#eee;color:#333;display:block;max-height:300em;transition:max-height 6s ease-out 2ms,background-color .5s ease-in-out 2ms,visibility 1ms ease;visibility:visible}.accordion-section.dark .accordion-trigger{background-color:#eee}.accordion-section.dark .accordion-trigger:hover,.accordion-section.dark .accordion-trigger.is-expanded,.accordion-section.dark .accordion-panel.active{background-color:#fff}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }, { kind: "component", type: Icon2Component, selector: "citi-icon2", inputs: ["role", "idStr", "ariaLabel", "ariaHidden", "size", "isHoverSfi", "includeCircle", "type", "svgStyle", "tabIndex", "shade", "name"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: AccordionSectionComponent2Q23, decorators: [{
            type: Component,
            args: [{ selector: 'citi-accordion-section.2Q23', host: { class: 'citi-accordion-section', '[class.disabled]': 'disabled' }, template: `
    <div class="accordion-section {{theme == 'dark' ? 'dark' : null}}">
      <div role="heading" [attr.aria-level]="panelHeaderLevel">
        <button
          #button
          [attr.id]="idStr + '-button'"
          [attr.aria-controls]="idStr"
          [attr.aria-expanded]="_isOpen ? true : false"
          [attr.aria-disabled]="disabled ? true : null"
          [attr.disabled]="disabled ? true : null"
          class="accordion-trigger"
          (click)="sectionClicked.emit(sectionIndex)"
          (keydown)="handleKeyPress($event)"
          type="button"
          [ngClass]="{
            'btn disabled': disabled,
            'is-expanded': isExpanded,
            'accordion-header-focused': isFocused
          }"
        >
          <citi-icon2
            [ngClass]="{ 'is-expanded': isExpanded }"
            name="02-down"
            [shade]="disabled ? 'g1' : 'b2'"
            ariaLabel="Icon"
            ariaHidden="true"
          >
          </citi-icon2>
          <!--if overwrite flag is off (default behavior), show the section title -->
          <div
            [attr.id]="idStr + '-label'"
            *ngIf="!isCustomSectionHeaderRequired && sectionTitle"
            class="category-title"
            [innerHtml]="sectionTitle"
          ></div>
          <div *ngIf="isCustomSectionHeaderRequired" class="category-title">
            <!--if overwrite flag is on, display the ngcontent passed into the component-->
            <ng-content select="[sectionHeader]"></ng-content>
          </div>
        </button>
      </div>
      <!-- expandable area-->
      <div
        class="accordion-panel"
        [attr.id]="idStr"
        [ngClass]="{ 'active': isExpanded }"
        [contentHtml]="htmlContent">
        <ng-content></ng-content>
      </div>
      <ng-content select="[footer]"></ng-content>
    </div>
  `, standalone: false, styles: [".overflowChange{overflow:visible!important}citi-icon2.is-expanded ::ng-deep .sfi.b2-02-down{transform:rotate(180deg)}citi-icon2 ::ng-deep .sfi.b2-02-down{display:inline-block;position:absolute;transition:transform .4s ease-in-out;transform:rotate(0);transform-origin:50%}citi-icon2 ::ng-deep .sfi.g1-02-down{display:inline-block;position:absolute;transition:transform .4s ease-in-out;transform:rotate(0);transform-origin:50%}citi-icon2 ::ng-deep .sfi.medium{left:22px;height:8px;top:21px}.accordion-section{background-color:#fff;border-top:1px solid #999}.accordion-trigger{background:none;border:none;color:#333;display:block;font-family:Interstate_Light,sans-serif;line-height:22px;font-size:1rem;padding:17px 20px 17px 60px;position:relative;text-align:left;width:100%}.accordion-trigger.is-expanded{background-color:#eee;color:#056dae}.accordion-trigger:hover{background-color:#eee;cursor:pointer}.accordion-trigger:hover .category-title{color:#002a54;text-decoration:underline}.accordion-trigger.disabled{cursor:default}.accordion-panel{color:#333;display:none;margin:auto;max-height:0;padding-left:25px;padding-right:10px;padding-bottom:10px;transition:max-height .4s ease-out,background-color .5s ease-in-out,visibility 1ms ease .501s;visibility:hidden;width:100%}.accordion-panel.active{background-color:#eee;color:#333;display:block;max-height:300em;transition:max-height 6s ease-out 2ms,background-color .5s ease-in-out 2ms,visibility 1ms ease;visibility:visible}.accordion-section.dark .accordion-trigger{background-color:#eee}.accordion-section.dark .accordion-trigger:hover,.accordion-section.dark .accordion-trigger.is-expanded,.accordion-section.dark .accordion-panel.active{background-color:#fff}\n"] }]
        }], ctorParameters: () => [], propDecorators: { panelHeaderLevel: [{
                type: Input$1
            }], isCustomSectionHeaderRequired: [{
                type: Input$1
            }], disabled: [{
                type: Input$1
            }], idStr: [{
                type: Input$1
            }], sectionTitle: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }], summary: [{
                type: Input$1
            }], isOpen: [{
                type: Input$1
            }], sectionClicked: [{
                type: Output
            }], accordionHeaderFocusCall: [{
                type: Output
            }], button: [{
                type: ViewChild,
                args: ['button']
            }], cssClassParent: [{
                type: HostBinding,
                args: ['class.parent']
            }], cssClassLevel1: [{
                type: HostBinding,
                args: ['class.level1']
            }], attributeRole: [{
                type: HostBinding,
                args: ['attr.role']
            }], isExpanded: [{
                type: HostBinding,
                args: ['class.is-expanded']
            }] } });

/**
 * @Component: Accordion
 * @description This component generates the wrapper, title, and expand/collapse
 * button for accordions. Sections for the accordion are a separate component.
 */
class AccordionComponent2Q23 {
    get noSectionsOpen() {
        return this.sections.find(section => section.isOpen) === undefined;
    }
    onKeyPressHome(event) {
        event.preventDefault();
        this.sections.first.focusButton();
    }
    onKeyPressEnd(event) {
        event.preventDefault();
        this.sections.last.focusButton();
    }
    // #endregion
    // #region // ---------- LIFECYCLE ---------- //
    constructor(el, announcer) {
        this.el = el;
        this.announcer = announcer;
        // #region // ---------- Properties ---------- //
        this.allSectionsOpen = true;
        this.allSectionsDisabled = false;
        this.someSectionsDisabled = false;
        this.focusedHeader = 0;
        this.mainTitleHeaderLevel = 3;
        this.titleHeaderLevel = 4;
        /**
         * @property hideToggle
         * @description hide/show expand and collapse link
         */
        this.hideToggle = true;
        /**
         * @property multi
         * @description whether mulitple section are permitted to be open at the same time
         */
        this.multi = true;
        /**
         * @property someSectionsDisabledText
         * @description Screen reader text announcement when some sections disabled
         */
        this.someSectionsDisabledText = 'Some sections not available';
        this.collapseAllButtonText = 'Collapse All Sections';
        this.expandAllButtonText = 'Expand All Sections';
        this.allPanelsClosedText = 'All accordion panels collapsed';
        this.closeOthersText = 'Other Sections Closed';
        this.allSectionsToggled = new EventEmitter();
    }
    ngAfterContentInit() {
        this.checkAllSections();
        this.sections.forEach((section, index) => {
            section.sectionIndex = index;
            section.sectionsLength = this.sections.length;
            section.multi = this.multi;
            section.theme = this.theme;
            section.accordionHeaderFocusCall.subscribe(idx => {
                this.setHeaderFocus(idx);
            });
        });
        this.listenForClicks();
        if (this.sections.toArray().every(section => section.disabled))
            this.allSectionsDisabled = true;
        if (this.sections.some(section => section.disabled))
            this.someSectionsDisabled = true;
    }
    // #endregion
    // #region // ------------ Methods ------------ //
    listenForClicks() {
        this.sections.forEach(section => {
            section.sectionClicked.subscribe(index => {
                if (!this.multi)
                    this.setAllSection(index);
                this.handleSectionToggle(index);
                this.checkAllSections();
            });
        });
    }
    handleSectionToggle(index) {
        const targetSection = this.sections.find(section => section.sectionIndex === index);
        targetSection.isOpen = !targetSection.isOpen;
        this.setHeaderFocus(index);
    }
    checkAllSections() {
        this.allSectionsOpen = this.noSectionsOpen
            ? false
            : !this.sections.some(section => !section.isOpen);
    }
    setAllSection(excludeIndex) {
        this.sections.forEach(section => {
            if (section.sectionIndex !== excludeIndex && section.isOpen) {
                section.isOpen = false;
                if (!this.multi) {
                    if (this.allSectionsOpen) {
                        setTimeout(() => this.announcer.announce(this.allPanelsClosedText), 104);
                    }
                    else {
                        if (!section.sectionTitle) {
                            let sectionNumber = section.sectionIndex + 1;
                            setTimeout(() => this.announcer.announce('Accordion panel ' + sectionNumber + ' collapsed'), 104);
                        }
                        else {
                            setTimeout(() => this.announcer.announce(section.sectionTitle + ' panel collapsed'), 104);
                        }
                    }
                }
            }
        });
    }
    /**
     * @Method: toggleAllSections
     * @description Opens/closes all sections
     * @return Void
     */
    toggleAllSections(event) {
        if (event)
            event.preventDefault();
        if (!this.allSectionsDisabled) {
            this.allSectionsOpen = !this.allSectionsOpen;
            this.sections.forEach(section => {
                if (!section.disabled) {
                    section.isOpen = this.allSectionsOpen;
                }
            });
        }
        if (this.someSectionsDisabled)
            setTimeout(() => this.announcer.announce(this.someSectionsDisabledText), 104);
        this.allSectionsToggled.emit();
    }
    section(index) {
        return this.sections.find((section, i) => i === index);
    }
    clearFocus() {
        this.sections.forEach(tab => (tab.isFocused = false));
    }
    focusActiveSection() {
        setTimeout(() => this.el.nativeElement.querySelector('.accordion-header-focused').focus(), 100);
    }
    setHeaderFocus(index) {
        this.clearFocus();
        this.section(index).isFocused = true;
        this.focusActiveSection();
        this.focusedHeader = index;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: AccordionComponent2Q23, deps: [{ token: i0.ElementRef }, { token: i1$3.LiveAnnouncer }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: AccordionComponent2Q23, isStandalone: false, selector: "citi-accordion.2Q23", inputs: { sectionMainTitle: "sectionMainTitle", mainTitleHeaderLevel: "mainTitleHeaderLevel", accordionTitle: "accordionTitle", titleHeaderLevel: "titleHeaderLevel", hideToggle: "hideToggle", multi: "multi", theme: "theme", someSectionsDisabledText: "someSectionsDisabledText", collapseAllButtonText: "collapseAllButtonText", expandAllButtonText: "expandAllButtonText", allPanelsClosedText: "allPanelsClosedText", closeOthersText: "closeOthersText", expandAllAriaLabelText: "expandAllAriaLabelText", collapseAllAriaLabelText: "collapseAllAriaLabelText", isRightAlignedArrow: "isRightAlignedArrow" }, outputs: { allSectionsToggled: "allSectionsToggled" }, host: { listeners: { "keydown.home": "onKeyPressHome($event)", "keydown.end": "onKeyPressEnd($event)" } }, queries: [{ propertyName: "sections", predicate: i0.forwardRef(() => AccordionSectionComponent2Q23) }], ngImport: i0, template: `
    <div [attr.class]="theme === 'dark' ? 'accordion-module' : null">
      <citi-text-header
        *ngIf="sectionMainTitle"
        [level]="mainTitleHeaderLevel"
        [htmlContent]="sectionMainTitle">
      </citi-text-header>
      <div
        class="accordion menu form linear"
        [ngClass]="{ 'cbolui-right-arrow': isRightAlignedArrow }"
      >
        <div class="row title" *ngIf="!hideToggle">
          <div class="hidden-xs hidden-sm col-xs-12 text-right">
            <button
              type="button"
              [attr.aria-expanded]="allSectionsOpen"
              (click)="toggleAllSections($event)"
              class="desktop toggle-accordion btn btn-link"
              [ngClass]="{'disabled': this.allSectionsDisabled}"
              [attr.aria-disabled]="this.allSectionsDisabled ? true : null"
              [attr.disabled]="this.allSectionsDisabled ? true : null"
              [attr.aria-label]="allSectionsOpen && collapseAllAriaLabelText ? collapseAllAriaLabelText
                                : !allSectionsOpen && expandAllAriaLabelText ? expandAllAriaLabelText
                                : null"
            >
              {{
                allSectionsOpen ? collapseAllButtonText : expandAllButtonText
              }}
            </button>
          </div>
          <div class="hidden-lg hidden-md col-xs-12">
            <button
              type="button"
              [attr.aria-expanded]="allSectionsOpen"
              (click)="toggleAllSections($event)"
              class="mobile toggle-accordion btn btn-link"
              [ngClass]="{'disabled': this.allSectionsDisabled}"
              [attr.aria-disabled]="this.allSectionsDisabled ? true : null"
              [attr.disabled]="this.allSectionsDisabled ? true : null"
              [attr.aria-label]="allSectionsOpen && collapseAllAriaLabelText ? collapseAllAriaLabelText
                                : !allSectionsOpen && expandAllAriaLabelText ? expandAllAriaLabelText
                                : null"
            >
              {{
                allSectionsOpen ? collapseAllButtonText : expandAllButtonText
              }}
            </button>
          </div>
        </div>
        <citi-text-header
          *ngIf="accordionTitle"
          [level]="titleHeaderLevel"
          [htmlContent]="accordionTitle">
        </citi-text-header>
        <div
          class="mainnav {{
            !theme || theme !== 'dark' ? 'theme-light' : null
          }}"
        >
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  `, isInline: true, styles: [".hide-toggle-button{display:none}[disabled].toggle-accordion:hover{text-decoration:underline}::ng-deep .citi-accordion-section.disabled:hover{background-color:#eee!important}.theme-light ::ng-deep .citi-accordion-section.disabled:hover{background-color:#fff!important}.hidden{display:none}.accordion-module fieldset{width:100%;position:relative}.accordion{margin:0}.accordion .mainnav{border-bottom:1px solid #999;margin:15px 0;width:100%}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: TextHeaderComponent, selector: "citi-text-header", inputs: ["ariaLevel", "level", "style", "bold", "class", "html", "ariaRole", "htmlContent"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: AccordionComponent2Q23, decorators: [{
            type: Component,
            args: [{ selector: 'citi-accordion.2Q23', standalone: false, template: `
    <div [attr.class]="theme === 'dark' ? 'accordion-module' : null">
      <citi-text-header
        *ngIf="sectionMainTitle"
        [level]="mainTitleHeaderLevel"
        [htmlContent]="sectionMainTitle">
      </citi-text-header>
      <div
        class="accordion menu form linear"
        [ngClass]="{ 'cbolui-right-arrow': isRightAlignedArrow }"
      >
        <div class="row title" *ngIf="!hideToggle">
          <div class="hidden-xs hidden-sm col-xs-12 text-right">
            <button
              type="button"
              [attr.aria-expanded]="allSectionsOpen"
              (click)="toggleAllSections($event)"
              class="desktop toggle-accordion btn btn-link"
              [ngClass]="{'disabled': this.allSectionsDisabled}"
              [attr.aria-disabled]="this.allSectionsDisabled ? true : null"
              [attr.disabled]="this.allSectionsDisabled ? true : null"
              [attr.aria-label]="allSectionsOpen && collapseAllAriaLabelText ? collapseAllAriaLabelText
                                : !allSectionsOpen && expandAllAriaLabelText ? expandAllAriaLabelText
                                : null"
            >
              {{
                allSectionsOpen ? collapseAllButtonText : expandAllButtonText
              }}
            </button>
          </div>
          <div class="hidden-lg hidden-md col-xs-12">
            <button
              type="button"
              [attr.aria-expanded]="allSectionsOpen"
              (click)="toggleAllSections($event)"
              class="mobile toggle-accordion btn btn-link"
              [ngClass]="{'disabled': this.allSectionsDisabled}"
              [attr.aria-disabled]="this.allSectionsDisabled ? true : null"
              [attr.disabled]="this.allSectionsDisabled ? true : null"
              [attr.aria-label]="allSectionsOpen && collapseAllAriaLabelText ? collapseAllAriaLabelText
                                : !allSectionsOpen && expandAllAriaLabelText ? expandAllAriaLabelText
                                : null"
            >
              {{
                allSectionsOpen ? collapseAllButtonText : expandAllButtonText
              }}
            </button>
          </div>
        </div>
        <citi-text-header
          *ngIf="accordionTitle"
          [level]="titleHeaderLevel"
          [htmlContent]="accordionTitle">
        </citi-text-header>
        <div
          class="mainnav {{
            !theme || theme !== 'dark' ? 'theme-light' : null
          }}"
        >
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  `, styles: [".hide-toggle-button{display:none}[disabled].toggle-accordion:hover{text-decoration:underline}::ng-deep .citi-accordion-section.disabled:hover{background-color:#eee!important}.theme-light ::ng-deep .citi-accordion-section.disabled:hover{background-color:#fff!important}.hidden{display:none}.accordion-module fieldset{width:100%;position:relative}.accordion{margin:0}.accordion .mainnav{border-bottom:1px solid #999;margin:15px 0;width:100%}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i1$3.LiveAnnouncer }], propDecorators: { sectionMainTitle: [{
                type: Input$1
            }], mainTitleHeaderLevel: [{
                type: Input$1
            }], accordionTitle: [{
                type: Input$1
            }], titleHeaderLevel: [{
                type: Input$1
            }], hideToggle: [{
                type: Input$1
            }], multi: [{
                type: Input$1
            }], theme: [{
                type: Input$1
            }], someSectionsDisabledText: [{
                type: Input$1
            }], collapseAllButtonText: [{
                type: Input$1
            }], expandAllButtonText: [{
                type: Input$1
            }], allPanelsClosedText: [{
                type: Input$1
            }], closeOthersText: [{
                type: Input$1
            }], expandAllAriaLabelText: [{
                type: Input$1
            }], collapseAllAriaLabelText: [{
                type: Input$1
            }], isRightAlignedArrow: [{
                type: Input$1
            }], allSectionsToggled: [{
                type: Output
            }], sections: [{
                type: ContentChildren,
                args: [forwardRef(() => AccordionSectionComponent2Q23)]
            }], onKeyPressHome: [{
                type: HostListener,
                args: ['keydown.home', ['$event']]
            }], onKeyPressEnd: [{
                type: HostListener,
                args: ['keydown.end', ['$event']]
            }] } });

const COMPONENTS$10 = [
    AccordionComponent2Q23,
    AccordionSectionComponent2Q23
];
const MODULES$$ = [CommonModule, ContentHtml, Icons2, TextHeader];
class Accordion2Q23 {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Accordion2Q23, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: Accordion2Q23, declarations: [AccordionComponent2Q23,
            AccordionSectionComponent2Q23], imports: [CommonModule, ContentHtml, Icons2, TextHeader], exports: [AccordionComponent2Q23,
            AccordionSectionComponent2Q23] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Accordion2Q23, imports: [MODULES$$] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Accordion2Q23, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$$],
                    declarations: [...COMPONENTS$10],
                    exports: [...COMPONENTS$10]
                }]
        }] });

const COMPONENTS$$ = [
    AccordionComponent,
    AccordionSectionComponent
];
const MODULES$_ = [CommonModule, ContentHtml, Icons2, Accordion2Q23];
class Accordion {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Accordion, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: Accordion, declarations: [AccordionComponent,
            AccordionSectionComponent], imports: [CommonModule, ContentHtml, Icons2, Accordion2Q23], exports: [AccordionComponent,
            AccordionSectionComponent, Accordion2Q23] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Accordion, imports: [MODULES$_, Accordion2Q23] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Accordion, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$_],
                    declarations: [...COMPONENTS$$],
                    exports: [...COMPONENTS$$, Accordion2Q23]
                }]
        }] });

class CarouselItemDirective {
    constructor(tpl) {
        this.tpl = tpl;
        this.isActiveSlide = false;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CarouselItemDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.5", type: CarouselItemDirective, isStandalone: false, selector: "[carousel-slide]", inputs: { slideAnnounce: ["carousel-slide", "slideAnnounce"], slideAriaLabel: ["carousel-slideSlideAriaLabel", "slideAriaLabel"], dotAriaLabel: ["carousel-slideDotAriaLabel", "dotAriaLabel"] }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CarouselItemDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[carousel-slide]',
                    standalone: false
                }]
        }], ctorParameters: () => [{ type: i0.TemplateRef }], propDecorators: { slideAnnounce: [{
                type: Input$1,
                args: ['carousel-slide']
            }], slideAriaLabel: [{
                type: Input$1,
                args: ['carousel-slideSlideAriaLabel']
            }], dotAriaLabel: [{
                type: Input$1,
                args: ['carousel-slideDotAriaLabel']
            }] } });

var Animation;
(function (Animation) {
    Animation["Fade"] = "fade";
    Animation["Slide"] = "slide";
})(Animation || (Animation = {}));
var Transition;
(function (Transition) {
    Transition[Transition["Next"] = 0] = "Next";
    Transition[Transition["Prev"] = 1] = "Prev";
})(Transition || (Transition = {}));
const TRANSITION_TIME = 1000;
class Carousel3Component {
    /**
     * This defines the custom string that will be announced via live announcer when the carousel transitions to a new slide
     * @deprecated
     */
    set announceSlideChange(message) {
        if (this._announceSlideChange === message)
            return;
        this._announceSlideChange = message;
        // this.announceSlide(message);
    }
    /**
     * This defines the index of the active slide that the carousel should display initially
     */
    set activeSlide(activeSlide) {
        if (this._activeSlide === activeSlide)
            return;
        this._activeSlide = activeSlide;
        if (this.carouselSlides && this.carouselSlides.length) {
            // prevents setting before init
            this.deactiveCurentSlide();
            this.activeNewSlide(activeSlide);
        }
    }
    get activeSlides() {
        return this._activeSlides;
    }
    set activeSlides(activeSlides) {
        if (this._activeSlides === activeSlides)
            return;
        this._activeSlides = activeSlides;
    }
    constructor(cd, differs, announcer) {
        this.cd = cd;
        this.differs = differs;
        this.announcer = announcer;
        this.showPause = false;
        this.isActiveSlide = false;
        //detects if mouse in on the slide or not
        this.isMouseEnter = false;
        this.hasFocus = false;
        this.animationComplete = true;
        // private carouselSlideRefArray: ElementRef[] = [];
        this.carouselSlideContentArray = [];
        // _slideAnnounce: string;
        /**
         * id for the carousel
         */
        this.idStr = 'carousel';
        /**
         * show/hide NEXT/PREV button
         */
        this.isNavigation = false;
        /**
         * show/hide controls
         */
        this.isControls = false;
        /**
         * set the auto rotation time
         */
        this.autoPlayDuration = 0;
        /**
         * This defines the custom value for the aria-label attribute of the Carousel section tag
         */
        this.ariaLabel = 'Carousel slide';
        /**
         * This defines the custom value for the aria-label attribute of the previous slide button
         */
        this.prevAriaLabel = 'Previous Slide';
        /**
         * This defines the custom value for the aria-label attribute of the next slide button
         */
        this.nextAriaLabel = 'Next Slide';
        /**
         * This defines the custom value for the aria-label attribute of the play button
         */
        this.playAriaLabel = 'Auto-rotating carousel button. Paused. Press enter to play.';
        /**
         * This defines the custom value for the aria-label attribute of the pause button
         */
        this.pauseAriaLabel = 'Auto-rotating carousel button. Playing. Press enter to pause.';
        /**
         * This defines the custom value for the aria-label attribute of the pause button
         */
        this.dotsAriaLabel = 'Slides';
        /**
         * This defines the custom message to announce when pause button is clicked
         * @deprecated
         */
        this.announceAfterPauseClicked = 'Click to play';
        /**
         * This defines the custom message to announce when play button is clicked
         * @deprecated
         */
        this.announceAfterPlayClicked = 'Click to pause';
        this._activeSlide = 0;
        this.activeSlideChange = new EventEmitter();
        cd.detach();
        setInterval(() => {
            this.cd.detectChanges();
        }, 1000);
    }
    ngAfterContentInit() {
        if (this.carouselSlides) {
            this.activeSlides = this.getPreviousCurrentNextIndexes(0);
            this.differ = this.differs.find(this.activeSlides).create();
            if (this.carouselSlides.length > 1 && this.autoPlayDuration > 0) {
                this.startTimer();
            }
        }
        setTimeout(() => {
            this.carouselSlideContentArray = this.carouselSlides.toArray();
            this.currentSlide = this.carouselSlideContentArray[this._activeSlide];
            if (this.currentSlide) {
                this.currentSlide.isActiveSlide = true;
            }
        }, 1);
    }
    ngOnDestroy() {
        this.cd.detach();
        this.stopTimer();
    }
    select(index) {
        // prevent user from clicking too fast
        if (!this.animationComplete)
            return;
        else
            setTimeout(() => (this.animationComplete = true), TRANSITION_TIME);
        this.animationComplete = false;
        this.activeSlides = this.getPreviousCurrentNextIndexes(index);
        const currentSlideDir = this.carouselSlides.find((c, i) => i === index);
        if (!this.showPause && currentSlideDir?.slideAriaLabel) {
            this.announcer.announce(currentSlideDir?.slideAriaLabel, 200);
        }
        this.activeSlideChange.emit(index);
        if (this.differ.diff(this.activeSlides)) {
            this.cd.detectChanges();
        }
    }
    preventDefault(e) {
        e.preventDefault();
    }
    getPreviousCurrentNextIndexes(index) {
        const slideLength = this.carouselSlides?.length;
        return {
            previous: (index === 0 ? slideLength - 1 : index - 1) % slideLength,
            current: index % slideLength,
            next: (index === slideLength - 1 ? 0 : index + 1) % slideLength
        };
    }
    getAnimationSlideState(index) {
        return index === this.activeSlides.current
            ? 'current'
            : index === this.activeSlides.next
                ? 'next'
                : index === this.activeSlides.previous
                    ? 'previous'
                    : 'none';
    }
    startTimer() {
        this.showPause = false;
        this.cd.detectChanges();
        // If current interval exists we need to clear it before creating new interval
        if (this.currentInterval) {
            clearInterval(this.currentInterval);
        }
        if (this.autoPlayDuration > 0) {
            this.currentInterval = setInterval(() => this.select(this.activeSlides.next), this.autoPlayDuration);
        }
    }
    stopTimer() {
        this.showPause = true;
        this.cd.detectChanges();
        if (this.currentInterval) {
            clearInterval(this.currentInterval);
        }
    }
    activeNewSlide(index) {
        this._activeSlide = index;
        this.activeSlideChange.emit(index);
        if (this.carouselSlideContentArray.length) {
            this.currentSlide = this.carouselSlideContentArray[index];
            this.currentSlide.isActiveSlide = true;
        }
    }
    changeDot(index, isPrevious) {
        if (this.animationComplete) {
            let upOrDown = isPrevious ? -1 : 1;
            upOrDown = upOrDown === -1 ? this.carouselSlides.length - 1 : upOrDown;
            let newDotIndex = (index + upOrDown) % this.carouselSlides.length;
            this.select(newDotIndex);
            this.dots.get(newDotIndex).nativeElement.focus();
        }
    }
    // togglePlayPause method gets called when play or pause button is clicked
    togglePlayPause(event) {
        this.showPause = !this.showPause;
        if (this.showPause)
            this.pauseClicked();
        else
            this.playClicked();
    }
    //onMouseEnterSlide method gets called when user takes a mouse pointer to the slide panel. Slide stops with this action
    onMouseEnterSlide() {
        this.isMouseEnter = true;
        this.stopTimer();
    }
    //onMouseLeaveSlide method gets called when user movers away a mouse pointer from the slide panel. Slide starts with this action
    onMouseLeaveSlide() {
        this.isMouseEnter = false;
        this.startTimer();
    }
    //pauseClicked method gets called when pause button is clicked
    pauseClicked() {
        this.stopTimer();
    }
    //playClicked method gets called when play button is clicked
    playClicked() {
        this.startTimer();
    }
    deactiveCurentSlide() {
        if (this.currentSlide) {
            this.currentSlide.isActiveSlide = false;
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Carousel3Component, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.KeyValueDiffers }, { token: i1$3.LiveAnnouncer }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: Carousel3Component, isStandalone: false, selector: "citi-carousel3", inputs: { idStr: "idStr", slides: "slides", isNavigation: "isNavigation", isControls: "isControls", autoPlayDuration: "autoPlayDuration", ariaLabel: "ariaLabel", prevAriaLabel: "prevAriaLabel", nextAriaLabel: "nextAriaLabel", playAriaLabel: "playAriaLabel", pauseAriaLabel: "pauseAriaLabel", dotsAriaLabel: "dotsAriaLabel", announceAfterPauseClicked: "announceAfterPauseClicked", announceAfterPlayClicked: "announceAfterPlayClicked", announceSlideChange: "announceSlideChange", activeSlide: "activeSlide", tabIndex: "tabIndex", slideTemplateRef: "slideTemplateRef", thumbnailTemplateRef: "thumbnailTemplateRef" }, outputs: { activeSlideChange: "activeSlideChange" }, host: { classAttribute: "citi-carousel3" }, queries: [{ propertyName: "carouselSlides", predicate: CarouselItemDirective }], viewQueries: [{ propertyName: "carouselSlideRefs", predicate: ["slide"], descendants: true, read: ElementRef }, { propertyName: "dots", predicate: ["dot"], descendants: true }], ngImport: i0, template: `
    <div
      class="carousel"
      [attr.id]="idStr"
      [attr.aria-label]="ariaLabel"
      role="region"
      aria-roledescription="carousel"
    >

      <!----- slides ------>
      <div
        #carousel
        [attr.id]="idStr + '-items'"
        class="slides"
        [attr.aria-live]="showPause? 'polite' : 'off'"
        (focusin)="stopTimer()"
        (focusout)="startTimer()"
        (mouseenter)="onMouseEnterSlide()"
        (mouseleave)="onMouseLeaveSlide()"
      >
        <!----- slide ----->
        <div
          #slide
          *ngFor="let carouselSlide of carouselSlides; index as i"
          class="slide"
          [id]="idStr + '-slide-' + (i + 1)"
          [class.is-active]="i === activeSlides?.current"
          [@slideState]="getAnimationSlideState(i)"
          [@displayState]="getAnimationSlideState(i)"
          role="tabpanel"
          aria-roledescription="slide"
          [attr.aria-label]="carouselSlide?.slideAriaLabel"
        >
          <ng-container [ngTemplateOutlet]="carouselSlide.tpl"></ng-container>
        </div>
      </div>

      <div
        class="static-content"
      >
        <ng-content select="[staticContent]"></ng-content>
      </div>

      <!-- previous/ Carousel left arrow svg -->
      <button
        #next
        type="button"
        class="next"
        (focus)="stopTimer()"
        (blur)="startTimer()"
        (click)="select(activeSlides.previous)"
        *ngIf="carouselSlides?.length > 1 && isNavigation"
        [attr.aria-label]="prevAriaLabel"
        [attr.aria-controls]="idStr + '-items'"
        (mouseenter)="stopTimer()"
        (mouseleave)="startTimer()"
        (keydown.enter)="[select(activeSlides.previous), preventDefault($event)]"
        (keydown.space)="[select(activeSlides.previous), preventDefault($event)]"
      >
        <img
          alt="previous"
          src="commonui-assets/svgs/carousel3-svg/left-arrow.svg"
        />
      </button>

      <!-- next/ Carousel right arrow svg -->
      <button
        *ngIf="carouselSlides?.length > 1 && isNavigation"
        class="prev"
        type="button"
        [attr.aria-label]="nextAriaLabel"
        [attr.aria-controls]="idStr + '-items'"
        (click)="select(activeSlides.next)"
        (focus)="stopTimer()"
        (mouseenter)="stopTimer()"
        (mouseleave)="startTimer()"
        (keydown.enter)="[select(activeSlides.next), preventDefault($event)]"
        (keydown.space)="[select(activeSlides.next), preventDefault($event)]"
      >
        <img
          alt="next"
          class="chevron-right"
          src="commonui-assets/svgs/carousel3-svg/right-arrow.svg"
        />
      </button>

      <!--- play/pause & indicators --->
      <div class="indicators" *ngIf="carouselSlides?.length > 1">
        <!----- pause-button ----->
        <button
          *ngIf="isControls && autoPlayDuration > 0"
          class="play"
          type="button"
          [attr.aria-label]="showPause ? playAriaLabel : pauseAriaLabel"
          (click)="togglePlayPause($event)"
          (keydown.enter)="[togglePlayPause($event), preventDefault($event)]"
          (keydown.space)="[togglePlayPause($event), preventDefault($event)]"
        >
          <img
            alt="play"
            src="{{
              showPause
                ? 'commonui-assets/svgs/carousel3-svg/pause-button.svg'
                : 'commonui-assets/svgs/carousel3-svg/play-button.svg'
            }}"
          />
        </button>

        <!--- PREV/Chevron Left svg --->
        <button
        type="button"
          class="chevron-prev"
          *ngIf="isNavigation"
          [attr.aria-label]="prevAriaLabel"
          [attr.aria-controls]="idStr + '-items'"
          (click)="[select(activeSlides.previous), stopTimer()]"
          (keydown.enter)="[stopTimer(), select(activeSlides.previous), preventDefault($event)]"
          (keydown.space)="[stopTimer(), select(activeSlides.previous), preventDefault($event)]"
        >
          <img
            alt="previous"
            src="commonui-assets/svgs/carousel3-svg/chevron-left.svg"
          />
        </button>

        <!----- INDICATOR ----->
        <div
          *ngIf="isControls"
          role="tablist"
          [attr.aria-label]="dotsAriaLabel"
        >
          <button
            #dot
            type="button"
            *ngFor="let carouselSlide of carouselSlides; index as i"
            role="tab"
            class="indicator"
            [class.is-active]="i === activeSlides.current"
            [attr.tabindex]="i === activeSlides.current ? null : -1"
            [id]="idStr + '-dot-' + (i + 1)"
            [attr.aria-controls]="idStr + '-slide-' + (i + 1)"
            [attr.aria-label]="carouselSlide?.dotAriaLabel"
            [attr.aria-selected]="i === activeSlides.current"
            (click)="select(i)"
            (keydown.enter)="[stopTimer(), select(i), preventDefault($event)]"
            (keydown.space)="[stopTimer(), select(i), preventDefault($event)]"
            (keydown.arrowRight)="[stopTimer(), changeDot(i)]"
            (keydown.arrowLeft)="[stopTimer(), changeDot(i, true)]"
          ></button>
        </div>

        <!--- NEXT/Chevron Right svg --->
        <button
          type="button"
          class="chevron-next"
          *ngIf="isNavigation"
          [attr.aria-label]="nextAriaLabel"
          [attr.aria-controls]="idStr + '-items'"
          (click)="[select(activeSlides.next), stopTimer()]"
          (keydown.enter)="[stopTimer(), select(activeSlides.next), preventDefault($event)]"
          (keydown.space)="[stopTimer(), select(activeSlides.next), preventDefault($event)]"
        >
          <img
            alt="next"
            src="commonui-assets/svgs/carousel3-svg/chevron-right.svg"
          />
        </button>
      </div>
      <!-- <div *ngIf="!showPause" aria-live="polite">{{_slideAnnounce}}</div> -->
    </div>
  `, isInline: true, styles: [":host{display:block}.carousel{width:100%;height:100%;min-height:600px;display:flex;flex-direction:column;flex-wrap:nowrap}.sr-only{position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden}.static-content{position:absolute;display:block;z-index:1;width:100%}.slides{position:relative;flex-grow:1;overflow:hidden}.slide{position:absolute;top:0;left:0;width:100%}.prev,.next{display:flex;z-index:1;position:absolute;top:37%;cursor:pointer;border:none;background:none;padding:0}.prev{right:0;margin-right:20px}.next{margin-left:20px}.indicators{list-style:none;display:flex;justify-content:center;align-items:center;padding-top:24px;padding-bottom:44px}.play,.pause{display:flex;border:none;background:none;padding:0;margin-right:25px}.play img,.pause img{width:24px}.indicator{background-color:#d8d8d8;border-radius:47px;width:12px;height:12px;margin-left:25px;border:none;padding:0}.indicator:first-child{margin-left:0}.indicator.is-active{border-color:#002a54;background-color:#002a54;opacity:2}.indicator:focus-visible{outline-offset:2px}.chevron-prev,.chevron-next{display:none;border:none;background:none;padding:0}.chevron-next{margin-left:25px}.chevron-prev{margin-right:25px}@media (max-width: 768px){.prev,.next{display:none}.chevron-prev,.chevron-next{display:block}.indicators{padding-bottom:24px;padding-top:14px}.indicator{margin-top:3px}}@media all and (-ms-high-contrast: none),(-ms-high-contrast: active){.slides{position:static;flex-grow:1;overflow:hidden}.indicators{position:absolute;bottom:0;left:46%}}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }], animations: [
            trigger('slideState', [
                state('current', style({
                    transform: 'translateX(0%)',
                    zIndex: 1
                })),
                state('next', style({
                    transform: 'translateX(100%)',
                    zIndex: 1
                })),
                state('previous', style({
                    transform: 'translateX(-100%)',
                    zIndex: 1
                })),
                transition('current => previous', animate(`${TRANSITION_TIME}ms ease-out`)),
                transition('next => current', animate(`${TRANSITION_TIME}ms ease-out`)),
                transition('current => next', animate(`${TRANSITION_TIME}ms ease-out`)),
                transition('previous => current', animate(`${TRANSITION_TIME}ms ease-out`))
            ]),
            trigger('displayState', [
                state('current', style({})),
                state('next', style({ display: 'none' })),
                state('previous', style({ display: 'none' })),
                state('none', style({ display: 'none' })),
                transition('current => previous', animate(`${TRANSITION_TIME}ms ease-out`)),
                transition('current => next', animate(`${TRANSITION_TIME}ms ease-out`)),
            ])
        ], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Carousel3Component, decorators: [{
            type: Component,
            args: [{ selector: 'citi-carousel3', standalone: false, host: {
                        class: 'citi-carousel3'
                    }, template: `
    <div
      class="carousel"
      [attr.id]="idStr"
      [attr.aria-label]="ariaLabel"
      role="region"
      aria-roledescription="carousel"
    >

      <!----- slides ------>
      <div
        #carousel
        [attr.id]="idStr + '-items'"
        class="slides"
        [attr.aria-live]="showPause? 'polite' : 'off'"
        (focusin)="stopTimer()"
        (focusout)="startTimer()"
        (mouseenter)="onMouseEnterSlide()"
        (mouseleave)="onMouseLeaveSlide()"
      >
        <!----- slide ----->
        <div
          #slide
          *ngFor="let carouselSlide of carouselSlides; index as i"
          class="slide"
          [id]="idStr + '-slide-' + (i + 1)"
          [class.is-active]="i === activeSlides?.current"
          [@slideState]="getAnimationSlideState(i)"
          [@displayState]="getAnimationSlideState(i)"
          role="tabpanel"
          aria-roledescription="slide"
          [attr.aria-label]="carouselSlide?.slideAriaLabel"
        >
          <ng-container [ngTemplateOutlet]="carouselSlide.tpl"></ng-container>
        </div>
      </div>

      <div
        class="static-content"
      >
        <ng-content select="[staticContent]"></ng-content>
      </div>

      <!-- previous/ Carousel left arrow svg -->
      <button
        #next
        type="button"
        class="next"
        (focus)="stopTimer()"
        (blur)="startTimer()"
        (click)="select(activeSlides.previous)"
        *ngIf="carouselSlides?.length > 1 && isNavigation"
        [attr.aria-label]="prevAriaLabel"
        [attr.aria-controls]="idStr + '-items'"
        (mouseenter)="stopTimer()"
        (mouseleave)="startTimer()"
        (keydown.enter)="[select(activeSlides.previous), preventDefault($event)]"
        (keydown.space)="[select(activeSlides.previous), preventDefault($event)]"
      >
        <img
          alt="previous"
          src="commonui-assets/svgs/carousel3-svg/left-arrow.svg"
        />
      </button>

      <!-- next/ Carousel right arrow svg -->
      <button
        *ngIf="carouselSlides?.length > 1 && isNavigation"
        class="prev"
        type="button"
        [attr.aria-label]="nextAriaLabel"
        [attr.aria-controls]="idStr + '-items'"
        (click)="select(activeSlides.next)"
        (focus)="stopTimer()"
        (mouseenter)="stopTimer()"
        (mouseleave)="startTimer()"
        (keydown.enter)="[select(activeSlides.next), preventDefault($event)]"
        (keydown.space)="[select(activeSlides.next), preventDefault($event)]"
      >
        <img
          alt="next"
          class="chevron-right"
          src="commonui-assets/svgs/carousel3-svg/right-arrow.svg"
        />
      </button>

      <!--- play/pause & indicators --->
      <div class="indicators" *ngIf="carouselSlides?.length > 1">
        <!----- pause-button ----->
        <button
          *ngIf="isControls && autoPlayDuration > 0"
          class="play"
          type="button"
          [attr.aria-label]="showPause ? playAriaLabel : pauseAriaLabel"
          (click)="togglePlayPause($event)"
          (keydown.enter)="[togglePlayPause($event), preventDefault($event)]"
          (keydown.space)="[togglePlayPause($event), preventDefault($event)]"
        >
          <img
            alt="play"
            src="{{
              showPause
                ? 'commonui-assets/svgs/carousel3-svg/pause-button.svg'
                : 'commonui-assets/svgs/carousel3-svg/play-button.svg'
            }}"
          />
        </button>

        <!--- PREV/Chevron Left svg --->
        <button
        type="button"
          class="chevron-prev"
          *ngIf="isNavigation"
          [attr.aria-label]="prevAriaLabel"
          [attr.aria-controls]="idStr + '-items'"
          (click)="[select(activeSlides.previous), stopTimer()]"
          (keydown.enter)="[stopTimer(), select(activeSlides.previous), preventDefault($event)]"
          (keydown.space)="[stopTimer(), select(activeSlides.previous), preventDefault($event)]"
        >
          <img
            alt="previous"
            src="commonui-assets/svgs/carousel3-svg/chevron-left.svg"
          />
        </button>

        <!----- INDICATOR ----->
        <div
          *ngIf="isControls"
          role="tablist"
          [attr.aria-label]="dotsAriaLabel"
        >
          <button
            #dot
            type="button"
            *ngFor="let carouselSlide of carouselSlides; index as i"
            role="tab"
            class="indicator"
            [class.is-active]="i === activeSlides.current"
            [attr.tabindex]="i === activeSlides.current ? null : -1"
            [id]="idStr + '-dot-' + (i + 1)"
            [attr.aria-controls]="idStr + '-slide-' + (i + 1)"
            [attr.aria-label]="carouselSlide?.dotAriaLabel"
            [attr.aria-selected]="i === activeSlides.current"
            (click)="select(i)"
            (keydown.enter)="[stopTimer(), select(i), preventDefault($event)]"
            (keydown.space)="[stopTimer(), select(i), preventDefault($event)]"
            (keydown.arrowRight)="[stopTimer(), changeDot(i)]"
            (keydown.arrowLeft)="[stopTimer(), changeDot(i, true)]"
          ></button>
        </div>

        <!--- NEXT/Chevron Right svg --->
        <button
          type="button"
          class="chevron-next"
          *ngIf="isNavigation"
          [attr.aria-label]="nextAriaLabel"
          [attr.aria-controls]="idStr + '-items'"
          (click)="[select(activeSlides.next), stopTimer()]"
          (keydown.enter)="[stopTimer(), select(activeSlides.next), preventDefault($event)]"
          (keydown.space)="[stopTimer(), select(activeSlides.next), preventDefault($event)]"
        >
          <img
            alt="next"
            src="commonui-assets/svgs/carousel3-svg/chevron-right.svg"
          />
        </button>
      </div>
      <!-- <div *ngIf="!showPause" aria-live="polite">{{_slideAnnounce}}</div> -->
    </div>
  `, changeDetection: ChangeDetectionStrategy.OnPush, animations: [
                        trigger('slideState', [
                            state('current', style({
                                transform: 'translateX(0%)',
                                zIndex: 1
                            })),
                            state('next', style({
                                transform: 'translateX(100%)',
                                zIndex: 1
                            })),
                            state('previous', style({
                                transform: 'translateX(-100%)',
                                zIndex: 1
                            })),
                            transition('current => previous', animate(`${TRANSITION_TIME}ms ease-out`)),
                            transition('next => current', animate(`${TRANSITION_TIME}ms ease-out`)),
                            transition('current => next', animate(`${TRANSITION_TIME}ms ease-out`)),
                            transition('previous => current', animate(`${TRANSITION_TIME}ms ease-out`))
                        ]),
                        trigger('displayState', [
                            state('current', style({})),
                            state('next', style({ display: 'none' })),
                            state('previous', style({ display: 'none' })),
                            state('none', style({ display: 'none' })),
                            transition('current => previous', animate(`${TRANSITION_TIME}ms ease-out`)),
                            transition('current => next', animate(`${TRANSITION_TIME}ms ease-out`)),
                        ])
                    ], styles: [":host{display:block}.carousel{width:100%;height:100%;min-height:600px;display:flex;flex-direction:column;flex-wrap:nowrap}.sr-only{position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden}.static-content{position:absolute;display:block;z-index:1;width:100%}.slides{position:relative;flex-grow:1;overflow:hidden}.slide{position:absolute;top:0;left:0;width:100%}.prev,.next{display:flex;z-index:1;position:absolute;top:37%;cursor:pointer;border:none;background:none;padding:0}.prev{right:0;margin-right:20px}.next{margin-left:20px}.indicators{list-style:none;display:flex;justify-content:center;align-items:center;padding-top:24px;padding-bottom:44px}.play,.pause{display:flex;border:none;background:none;padding:0;margin-right:25px}.play img,.pause img{width:24px}.indicator{background-color:#d8d8d8;border-radius:47px;width:12px;height:12px;margin-left:25px;border:none;padding:0}.indicator:first-child{margin-left:0}.indicator.is-active{border-color:#002a54;background-color:#002a54;opacity:2}.indicator:focus-visible{outline-offset:2px}.chevron-prev,.chevron-next{display:none;border:none;background:none;padding:0}.chevron-next{margin-left:25px}.chevron-prev{margin-right:25px}@media (max-width: 768px){.prev,.next{display:none}.chevron-prev,.chevron-next{display:block}.indicators{padding-bottom:24px;padding-top:14px}.indicator{margin-top:3px}}@media all and (-ms-high-contrast: none),(-ms-high-contrast: active){.slides{position:static;flex-grow:1;overflow:hidden}.indicators{position:absolute;bottom:0;left:46%}}\n"] }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }, { type: i0.KeyValueDiffers }, { type: i1$3.LiveAnnouncer }], propDecorators: { idStr: [{
                type: Input$1
            }], slides: [{
                type: Input$1
            }], isNavigation: [{
                type: Input$1
            }], isControls: [{
                type: Input$1
            }], autoPlayDuration: [{
                type: Input$1
            }], ariaLabel: [{
                type: Input$1
            }], prevAriaLabel: [{
                type: Input$1
            }], nextAriaLabel: [{
                type: Input$1
            }], playAriaLabel: [{
                type: Input$1
            }], pauseAriaLabel: [{
                type: Input$1
            }], dotsAriaLabel: [{
                type: Input$1
            }], announceAfterPauseClicked: [{
                type: Input$1
            }], announceAfterPlayClicked: [{
                type: Input$1
            }], announceSlideChange: [{
                type: Input$1
            }], activeSlide: [{
                type: Input$1
            }], tabIndex: [{
                type: Input$1
            }], slideTemplateRef: [{
                type: Input$1
            }], thumbnailTemplateRef: [{
                type: Input$1
            }], activeSlideChange: [{
                type: Output
            }], carouselSlideRefs: [{
                type: ViewChildren,
                args: ['slide', { read: ElementRef }]
            }], dots: [{
                type: ViewChildren,
                args: ['dot']
            }], carouselSlides: [{
                type: ContentChildren,
                args: [CarouselItemDirective]
            }] } });

const COMPONENTS$_ = [
    Carousel3Component,
    CarouselItemDirective,
];
const MODULES$Z = [CommonModule];
class Carousel3 {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Carousel3, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: Carousel3, declarations: [Carousel3Component,
            CarouselItemDirective], imports: [CommonModule], exports: [Carousel3Component,
            CarouselItemDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Carousel3, imports: [MODULES$Z] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Carousel3, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$Z],
                    declarations: [...COMPONENTS$_],
                    exports: [...COMPONENTS$_]
                }]
        }] });

/**
 * @Component: Disclaimer
 * @Section: Forms
 * @description This is the disclaimer component and is used to create reusable disclaimer
 * from Bootstrap.
*/
class DisclaimerComponent {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: DisclaimerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: DisclaimerComponent, isStandalone: false, selector: "citi-forms-disclaimer", inputs: { idStr: "idStr", htmlContent: "htmlContent" }, host: { classAttribute: "citi-forms-disclaimer" }, ngImport: i0, template: `
    <div [attr.id]="idStr" class="cbolui-disclaimer">
      <p>
        <small [contentHtml]="htmlContent">
          <ng-content></ng-content>
        </small>
      </p>
    </div>`, isInline: true, dependencies: [{ kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: DisclaimerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'citi-forms-disclaimer',
                    standalone: false,
                    template: `
    <div [attr.id]="idStr" class="cbolui-disclaimer">
      <p>
        <small [contentHtml]="htmlContent">
          <ng-content></ng-content>
        </small>
      </p>
    </div>`,
                    host: { class: 'citi-forms-disclaimer' }
                }]
        }], propDecorators: { idStr: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }] } });

const COMPONENTS$Z = [
    DisclaimerComponent
];
const MODULES$Y = [
    CommonModule,
    ContentHtml
];
class FormsDisclaimer {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: FormsDisclaimer, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: FormsDisclaimer, declarations: [DisclaimerComponent], imports: [CommonModule,
            ContentHtml], exports: [DisclaimerComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: FormsDisclaimer, imports: [MODULES$Y] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: FormsDisclaimer, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$Y],
                    declarations: [...COMPONENTS$Z],
                    exports: [...COMPONENTS$Z]
                }]
        }] });

/**
 * @Component: Tab-group
 * @description A wrapper for displaying individual tab panels
 */
let nextUniqueId$c = 0;
class TabGroup2Component {
    get idStr() { return this._id; }
    set idStr(value) { this._id = value || this._uid; }
    addTab(tab) {
        if (this.tabContent) {
            if (this.tabContent.nativeElement.children.length == 0)
                this.tabs = [];
        }
        this.tabs.push(tab);
        return this.tabs.length;
    }
    countTabs() {
        return this.tabs.length;
    }
    constructor(el, liveAnnouncer, navigatorRef) {
        this.el = el;
        this.liveAnnouncer = liveAnnouncer;
        this._uid = `citi-tab2-${nextUniqueId$c++}`;
        /**
         * @Event: tabChanged
         * @description This event that is fired when a tab activates; returns the index of the active tab (first tab is 1)
         * @return Number
         */
        this.tabChanged = new EventEmitter();
        /**
         * @property isThemeLight
         * @description Light theme default toggle
         * @return string
         */
        this.isThemeLight = true;
        this.tabs = [];
        this.tabsFocused = false;
        this.shiftOn = false;
        this._navigator = navigatorRef;
        // iOS device Detection
        this.iOS = this._navigator && (!!this._navigator.platform && /iPad|iPhone|iPod/.test(this._navigator.platform));
    }
    ngOnInit() {
        this.idStr = this.idStr;
        this.defaultTab = this.activeTab ? Number.parseInt(this.activeTab, 10) : 1;
        this.selectTab(this.tabs[this.defaultTab - 1], null);
    }
    selectTab(tab, event) {
        if (event) {
            event.preventDefault();
        }
        // Update tab select tag with new tab index
        if (this.tabSelect) {
            this.tabSelect.nativeElement.value = tab.tabIndex;
        }
        if (this.tabs.length > 0) {
            this.tabs.forEach((tab) => {
                tab.isExpanded = false;
                tab.tabIndexAttr = -1;
                tab.tabFocusTrigger.emit(false);
            });
            tab.isExpanded = true;
            tab.tabIndexAttr = 0;
            tab.tabFocusTrigger.emit(true);
            // TalkBack and VoiceOver announce
            if (this.iOS || (this._navigator && androidPlatformCheck(this._navigator.platform))) {
                this.liveAnnouncer.announce(tab.tabTitle + ' ' + 'selected expanded' + ' ' + tab.tabIndex + ' of ' + this.tabs.length);
            }
            // Event emitter
            this.tabChanged.emit(tab.tabIndex);
        }
    }
    // Dropdown select tag (change) method for mobile version D1.95 Action Module
    setSelectedTab() {
        if (this.tabs.length > 0) {
            let selectedTab;
            for (let tab of this.tabs) {
                // If TabComponent index matches select tag index
                if (this.tabSelect
                    && (Number(this.tabSelect.nativeElement.value) === tab.tabIndex)) {
                    selectedTab = tab;
                }
                // Look through each TabComponent and hide them all
                tab.isExpanded = false;
                tab.tabIndexAttr = -1;
                tab.tabFocusTrigger.emit(false);
            }
            ;
            // Update new TabComponent to currently viewed
            selectedTab.isExpanded = true;
            selectedTab.tabIndexAttr = 0;
            selectedTab.tabFocusTrigger.emit(true);
            // Event emitter
            this.tabChanged.emit(selectedTab.tabIndex);
        }
    }
    getExpanded(tab) {
        let width = window.innerWidth;
        if (width <= 768) {
            return tab.isExpanded;
        }
        else {
            return null;
        }
    }
    tablistFocus(event, tab) {
        this.tabsFocused = true;
    }
    tabToContent() {
        this.tabsFocused = false;
        this.tabContent.nativeElement.focus();
    }
    stopBubble(event) {
        event.preventDefault();
        event.stopPropagation();
    }
    // Manual tab activation
    setTabFocus(tab, event) {
        // if (event) {
        //   event.preventDefault();
        // }
        if (this.tabs.length > 0) {
            this.tabs.forEach((tab) => {
                tab.tabIndexAttr = -1;
                tab.tabFocusTrigger.emit(false);
            });
            tab.tabIndexAttr = 0;
            tab.tabFocusTrigger.emit(true);
            if ((!this.iOS)
                && (!androidPlatformCheck(this._navigator.platform))
                && (!tab.isExpanded)) {
                this.liveAnnouncer.announce('Use enter to expand.');
            }
        }
    }
    nextTabFocus(focusedTab) {
        if (this.tabs.length > 0) {
            for (const tab of this.tabs) {
                if (focusedTab
                    && ((focusedTab.tabIndex + 1) === tab.tabIndex)) {
                    this.setTabFocus(tab, null);
                }
            }
            ;
        }
    }
    prevTabFocus(focusedTab) {
        if (this.tabs.length > 0) {
            for (const tab of this.tabs) {
                if (focusedTab
                    && ((focusedTab.tabIndex - 1) === tab.tabIndex)) {
                    this.setTabFocus(tab, null);
                }
            }
            ;
        }
    }
    onTabKeyDown(event, tab) {
        const keycode = event.which;
        if ([KEY_HOME, KEY_END].includes(keycode))
            this.stopBubble(event);
        switch (keycode) {
            case KEY_HOME:
                this.selectTab(this.tabs[0], null);
                break;
            case KEY_END:
                this.selectTab(this.tabs[this.tabs.length - 1], null);
                break;
            case KEY_ARROW_LEFT:
                this.prevTabFocus(tab);
                break;
            case KEY_ARROW_RIGHT:
                this.nextTabFocus(tab);
                break;
            case KEY_SPACEBAR:
            case KEY_ENTER:
                this.selectTab(tab, null);
                break;
        }
    }
    ngAfterViewInit() {
        // Attaches the trigger button to the tab pages
        if (this.tabs.length > 0) {
            const triggerButtons = this.el.nativeElement.querySelectorAll('ul.accordion-control > li');
            this.tabs.forEach((tab, index) => {
                tab.triggerButton = triggerButtons[index];
                tab.tabFocusTrigger.subscribe(function (isActivated) {
                    if (isActivated) {
                        this.triggerButton.focus();
                    }
                }.bind(tab));
            });
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TabGroup2Component, deps: [{ token: i0.ElementRef }, { token: CitiLiveAnnouncer }, { token: NAVIGATOR }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: TabGroup2Component, isStandalone: false, selector: "citi-tab-group2", inputs: { idStr: "idStr", activeTab: "activeTab", htmlContent: "htmlContent", alternateStyle: "alternateStyle", tabSelectLabel: "tabSelectLabel", isThemeLight: "isThemeLight" }, outputs: { tabChanged: "tabChanged" }, viewQueries: [{ propertyName: "tabContent", first: true, predicate: ["tabContent"], descendants: true }, { propertyName: "tabSelect", first: true, predicate: ["tabSelect"], descendants: true }], ngImport: i0, template: `
  <div class="{{ alternateStyle }} {{isThemeLight ? 'theme-light' : '' }}" [attr.id]="idStr">
    <ul [attr.id]="'tgul-' + idStr" class="nav nav-tabs nav-justified hidden-xs accordion-control" role="tablist">
      <li
        *ngFor="let tab of tabs; let idx = index"
        [class]="(tab.twoLine ? 'two-line' : '') + (tab.isExpanded ? ' active' : '') + (tab.lastTab ? ' last' : '')"
        (click)="selectTab(tab, $event)"
        [tabindex]="(tab.isExpanded ? 0 : -1)"
        role="tab"
        (keydown)="onTabKeyDown($event, tab)"
        [attr.title]="tab.tabTitle"
        [attr.id]="idStr + 'Header-' + idx + '-tab'"
        [attr.aria-selected]="tab.isExpanded.toString()"
        [attr.aria-expanded]="tab.isExpanded.toString()">
        <span class="tab-label">
          <span class="tab-label-content">{{tab.tabTitle}}</span>
          <br *ngIf="tab.twoLine">
          <span [innerHtml]="tab.tabTitleSecond" *ngIf="tab.twoLine"></span>
        </span>
      </li>
    </ul>
    <div class="mobile-select-wrapper hidden-sm hidden-md hidden-lg" *ngIf="alternateStyle">
      <div class="row">
        <div class="form-group col-md-4 col-sm-6">
          <label for="action-module-mobile-select" class="select-box-label" [innerHTML]="tabSelectLabel"></label>
          <select id="action-module-mobile-select" [(ngModel)]="defaultTab" class="form-control action-module-mobile-select" #tabSelect (change)="setSelectedTab()">
            <option *ngFor="let tab of tabs; let idx = index" [value]="tab.tabIndex" [innerHTML]="tab.tabTitle"></option>
          </select>
        </div>
      </div>
    </div>
    <div class="tab-content-wrapper" #tabContent [contentHtml]="htmlContent">
      <ng-content></ng-content>
    </div>
  </div>
  `, isInline: true, styles: [":host .nav-tabs a:focus{outline:1px dotted #212121;outline:5px auto -webkit-focus-ring-color}.accordion.tabbed-look{margin-top:.1px}.nav-tabs{width:100%}.nav-tabs.nav-tabs-fullspan{max-width:75%}.nav-tabs.nav-tabs-fullspan.nav-justified>li{width:auto}.nav-tabs.nav-tabs-fullspan>li{min-width:100px}.nav-tabs>li{box-sizing:border-box;padding-right:10px;margin-bottom:0;text-align:center}.nav-tabs>li.last{padding-right:0}.nav-tabs>li .tab-label{color:#056dae;background-color:#fff;display:block;padding:0 20px;cursor:pointer;outline:none;width:100%;height:50px;margin:0;font-family:Interstate_Light,sans-serif,Arial,sans-serif;font-size:16px;font-size:1rem;line-height:normal;text-align:center;border:none;box-sizing:border-box}.nav-tabs>li .tab-label:hover,.nav-tabs>li .tab-label:focus{background-color:#fff}.nav-tabs>li .tab-label .tab-label-content{top:17px;position:relative}.nav-tabs>li.two-line>span .tab-label-content{top:6px}.nav-tabs>li.active .tab-label{background-color:#fff;color:#333;border:none}.nav-tabs>li.active .tab-label:hover,.nav-tabs>li.active .tab-label:focus{color:#333;background-color:#fff;text-decoration:none}.nav-tabs.nav-justified{height:50px}.nav-tabs.nav-justified .active .tab-label{border:none}.nav-tabs.nav-justified .active .tab-label:focus,.nav-tabs.nav-justified .active .tab-label:hover{border:none}.nav-tabs.nav-justified>li{margin-bottom:0}.nav-tabs.nav-justified>li .tab-label{margin-bottom:0;border-radius:0;border-bottom:1px solid #056DAE}.nav-tabs.nav-justified>li .tab-label:hover,.nav-tabs.nav-justified>li .tab-label:focus{border-width:3px}@media (max-width: 768px){.nav-tabs.nav-justified{height:auto}.nav-tabs.nav-justified>li{margin-bottom:0}.nav-tabs.nav-justified>li .tab-label{margin-bottom:0}}.theme-light .nav-tabs>li .tab-label,.theme-light .nav-tabs>li .tab-label:focus,.theme-light .nav-tabs>li .tab-label:hover{background:#eee}.theme-light .nav-tabs>li.active .tab-label,.theme-light .nav-tabs>li.active .tab-label:focus,.theme-light .nav-tabs>li.active .tab-label:hover{background:#eee}.theme-light.nav-justified .nav-tabs>li .tab-label,.theme-light.nav-justified .nav-tabs>li .tab-label:focus,.theme-light.nav-justified .nav-tabs>li .tab-label:hover{background:#eee}.theme-light .tab-content-wrapper{background:#eee}.tab-content-wrapper{padding:40px;background:#fff;border:none;margin-top:0}@media (max-width: 768px){.tab-content-wrapper{padding:0;margin-top:25px}}@media (max-width: 480px){.tab-content-wrapper{padding:.1px}}.tab-pane>section:first-child,.tab-pane>article:first-child,.tab-pane>div:first-child{margin-top:0}.mobile-select-wrapper{background:#eee}.action-d1-95-tab-group{margin-top:-20px}.action-d1-95-tab-group .nav-tabs>li{padding-right:0}.action-d1-95-tab-group .tab-content-wrapper{background:#eee}.action-d1-95-tab-group .nav-tabs.nav-justified>li>.tab-label{border-bottom:1px solid rgba(0,0,0,.25)}.action-d1-95-tab-group .nav-tabs.nav-justified>.active>.tab-label{border-bottom:5px solid #056DAE;color:#056dae}.action-d1-95-tab-group .form-group .form-control.action-module-mobile-select{background-color:#fff}@media (min-width: 768px){.action-d1-95-tab-group .nav-tabs>li>.tab-label{padding:.1px 5px}}@media (max-width: 480px){.action-d1-95-tab-group{margin-top:0}.action-d1-95-tab-group .tab-content-wrapper{border-top:none;margin-top:0}}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i4.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i4.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i4.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { kind: "directive", type: i4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i4.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TabGroup2Component, decorators: [{
            type: Component,
            args: [{ selector: 'citi-tab-group2', standalone: false, template: `
  <div class="{{ alternateStyle }} {{isThemeLight ? 'theme-light' : '' }}" [attr.id]="idStr">
    <ul [attr.id]="'tgul-' + idStr" class="nav nav-tabs nav-justified hidden-xs accordion-control" role="tablist">
      <li
        *ngFor="let tab of tabs; let idx = index"
        [class]="(tab.twoLine ? 'two-line' : '') + (tab.isExpanded ? ' active' : '') + (tab.lastTab ? ' last' : '')"
        (click)="selectTab(tab, $event)"
        [tabindex]="(tab.isExpanded ? 0 : -1)"
        role="tab"
        (keydown)="onTabKeyDown($event, tab)"
        [attr.title]="tab.tabTitle"
        [attr.id]="idStr + 'Header-' + idx + '-tab'"
        [attr.aria-selected]="tab.isExpanded.toString()"
        [attr.aria-expanded]="tab.isExpanded.toString()">
        <span class="tab-label">
          <span class="tab-label-content">{{tab.tabTitle}}</span>
          <br *ngIf="tab.twoLine">
          <span [innerHtml]="tab.tabTitleSecond" *ngIf="tab.twoLine"></span>
        </span>
      </li>
    </ul>
    <div class="mobile-select-wrapper hidden-sm hidden-md hidden-lg" *ngIf="alternateStyle">
      <div class="row">
        <div class="form-group col-md-4 col-sm-6">
          <label for="action-module-mobile-select" class="select-box-label" [innerHTML]="tabSelectLabel"></label>
          <select id="action-module-mobile-select" [(ngModel)]="defaultTab" class="form-control action-module-mobile-select" #tabSelect (change)="setSelectedTab()">
            <option *ngFor="let tab of tabs; let idx = index" [value]="tab.tabIndex" [innerHTML]="tab.tabTitle"></option>
          </select>
        </div>
      </div>
    </div>
    <div class="tab-content-wrapper" #tabContent [contentHtml]="htmlContent">
      <ng-content></ng-content>
    </div>
  </div>
  `, styles: [":host .nav-tabs a:focus{outline:1px dotted #212121;outline:5px auto -webkit-focus-ring-color}.accordion.tabbed-look{margin-top:.1px}.nav-tabs{width:100%}.nav-tabs.nav-tabs-fullspan{max-width:75%}.nav-tabs.nav-tabs-fullspan.nav-justified>li{width:auto}.nav-tabs.nav-tabs-fullspan>li{min-width:100px}.nav-tabs>li{box-sizing:border-box;padding-right:10px;margin-bottom:0;text-align:center}.nav-tabs>li.last{padding-right:0}.nav-tabs>li .tab-label{color:#056dae;background-color:#fff;display:block;padding:0 20px;cursor:pointer;outline:none;width:100%;height:50px;margin:0;font-family:Interstate_Light,sans-serif,Arial,sans-serif;font-size:16px;font-size:1rem;line-height:normal;text-align:center;border:none;box-sizing:border-box}.nav-tabs>li .tab-label:hover,.nav-tabs>li .tab-label:focus{background-color:#fff}.nav-tabs>li .tab-label .tab-label-content{top:17px;position:relative}.nav-tabs>li.two-line>span .tab-label-content{top:6px}.nav-tabs>li.active .tab-label{background-color:#fff;color:#333;border:none}.nav-tabs>li.active .tab-label:hover,.nav-tabs>li.active .tab-label:focus{color:#333;background-color:#fff;text-decoration:none}.nav-tabs.nav-justified{height:50px}.nav-tabs.nav-justified .active .tab-label{border:none}.nav-tabs.nav-justified .active .tab-label:focus,.nav-tabs.nav-justified .active .tab-label:hover{border:none}.nav-tabs.nav-justified>li{margin-bottom:0}.nav-tabs.nav-justified>li .tab-label{margin-bottom:0;border-radius:0;border-bottom:1px solid #056DAE}.nav-tabs.nav-justified>li .tab-label:hover,.nav-tabs.nav-justified>li .tab-label:focus{border-width:3px}@media (max-width: 768px){.nav-tabs.nav-justified{height:auto}.nav-tabs.nav-justified>li{margin-bottom:0}.nav-tabs.nav-justified>li .tab-label{margin-bottom:0}}.theme-light .nav-tabs>li .tab-label,.theme-light .nav-tabs>li .tab-label:focus,.theme-light .nav-tabs>li .tab-label:hover{background:#eee}.theme-light .nav-tabs>li.active .tab-label,.theme-light .nav-tabs>li.active .tab-label:focus,.theme-light .nav-tabs>li.active .tab-label:hover{background:#eee}.theme-light.nav-justified .nav-tabs>li .tab-label,.theme-light.nav-justified .nav-tabs>li .tab-label:focus,.theme-light.nav-justified .nav-tabs>li .tab-label:hover{background:#eee}.theme-light .tab-content-wrapper{background:#eee}.tab-content-wrapper{padding:40px;background:#fff;border:none;margin-top:0}@media (max-width: 768px){.tab-content-wrapper{padding:0;margin-top:25px}}@media (max-width: 480px){.tab-content-wrapper{padding:.1px}}.tab-pane>section:first-child,.tab-pane>article:first-child,.tab-pane>div:first-child{margin-top:0}.mobile-select-wrapper{background:#eee}.action-d1-95-tab-group{margin-top:-20px}.action-d1-95-tab-group .nav-tabs>li{padding-right:0}.action-d1-95-tab-group .tab-content-wrapper{background:#eee}.action-d1-95-tab-group .nav-tabs.nav-justified>li>.tab-label{border-bottom:1px solid rgba(0,0,0,.25)}.action-d1-95-tab-group .nav-tabs.nav-justified>.active>.tab-label{border-bottom:5px solid #056DAE;color:#056dae}.action-d1-95-tab-group .form-group .form-control.action-module-mobile-select{background-color:#fff}@media (min-width: 768px){.action-d1-95-tab-group .nav-tabs>li>.tab-label{padding:.1px 5px}}@media (max-width: 480px){.action-d1-95-tab-group{margin-top:0}.action-d1-95-tab-group .tab-content-wrapper{border-top:none;margin-top:0}}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: CitiLiveAnnouncer }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [NAVIGATOR]
                }] }], propDecorators: { idStr: [{
                type: Input$1
            }], activeTab: [{
                type: Input$1
            }], tabChanged: [{
                type: Output
            }], htmlContent: [{
                type: Input$1
            }], alternateStyle: [{
                type: Input$1
            }], tabSelectLabel: [{
                type: Input$1
            }], isThemeLight: [{
                type: Input$1
            }], tabContent: [{
                type: ViewChild,
                args: ['tabContent']
            }], tabSelect: [{
                type: ViewChild,
                args: ['tabSelect']
            }] } });

class Tab2Component {
    constructor(parent, el) {
        this.parent = parent;
        this.el = el;
        /**
         * @property titleSecond
         * @description Text shown as the second line of tab title
         * @return string
         */
        this.tabTitleSecond = '';
        // Set classes on host <citi-tab> tag
        this.classTabPane = false;
        this.classLevel1 = false;
        this.classParent = false;
        // @HostBinding('class.is-expanded') isExpanded = false;
        this.isExpanded = false;
        this.twoLine = false;
        this.tabFocusTrigger = new EventEmitter();
        this.triggerButton = null;
        // TODO: refector to use ContentChildren in the parent
        this.tabgroup = parent;
        this.tabIndex = this.tabgroup.addTab(this);
        this.tabIndexAttr = -1;
        this.zeroIndex = this.tabIndex - 1;
    }
    hasSecondLineTitle() {
        return typeof this.tabTitleSecond !== 'undefined' && this.tabTitleSecond != null && this.tabTitleSecond !== '';
    }
    get tabgroupId() {
        return `${this.tabgroup._id}-panel-${this.zeroIndex}`;
    }
    ngOnInit() {
        this.twoLine = this.hasSecondLineTitle();
        let totalTabs = this.tabgroup.countTabs();
        this.lastTab = this.tabIndex === totalTabs;
        this.isExpanded = this.tabIndex === this.tabgroup.defaultTab;
    }
    selectTab(event) {
        this.tabgroup.selectTab(this, event);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Tab2Component, deps: [{ token: TabGroup2Component }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: Tab2Component, isStandalone: false, selector: "citi-tab2", inputs: { tabTitle: ["title", "tabTitle"], tabTitleSecond: ["titleSecond", "tabTitleSecond"], htmlContent: "htmlContent" }, host: { properties: { "class.tab-pane": "this.classTabPane", "class.level1": "this.classLevel1", "class.parent": "this.classParent" } }, ngImport: i0, template: `
  <span
    [tabindex]="(isExpanded ? 0 : -1)"
    role="tab"
    class="category hidden-sm hidden-md hidden-lg {{isExpanded ? 'is-expanded' : '' }} {{tabgroup.isThemeLight ? 'theme-light' : '' }}"
    (click)="selectTab($event)"
    *ngIf="!tabgroup.alternateStyle"
    [attr.id]="tabgroup.idStr + 'Header-' + zeroIndex"
    [attr.aria-controls]="tabgroupId"
    data-title="Select to show/hide"
    [attr.aria-expanded]="isExpanded"
    [attr.aria-selected]="isExpanded">
    <svg class="svg-arrow"></svg>
    <span class="category-title" [innerHtml]="tabTitle"></span>
  </span>
  <div
    role="tabpanel"
    class="tab-pane {{isExpanded ? 'is-expanded' : '' }} {{tabgroup.isThemeLight ? 'theme-light' : '' }}"
    [attr.aria-labelledby]="tabgroup.idStr + 'Header-' + zeroIndex + '-tab'"
    [attr.id]="tabgroupId"
    [contentHtml]="htmlContent"
    [attr.aria-hidden]="!isExpanded"
    [ngClass]="(tabgroup.alternateStyle ? 'padding-none border-none mt-20-mobile' : '')">
    <ng-content></ng-content>
  </div>
  `, isInline: true, styles: [".tab-pane{border:none;padding:0;display:none;overflow:hidden;width:100%;visibility:hidden;margin:auto;max-height:0;transition:none}.tab-pane.is-expanded{background:#fff;display:block;max-height:300em;visibility:visible;transition:max-height 6s ease-out 2ms,background-color .5s ease-in-out 2ms,visibility 1ms ease;z-index:1}.tab-pane.is-expanded.theme-light{background:#eee}@media (max-width: 768px){.tab-pane:hover{border-top:1px solid #999999}}@media (max-width: 480px){.tab-pane{padding:0 20px 24px 70px}.tab-pane.mt-20-mobile{margin-top:20px!important}}.category{background-color:#eee;color:#333;cursor:pointer;display:block;font-family:Interstate_Light,sans-serif;font-size:16px;font-size:1rem;line-height:22px;padding:19px 20px;transition:background-color .5s ease-in-out}.category.is-expanded{background-color:#fff;color:#056dae}.category.theme-light{background-color:#fff}.category.theme-light.is-expanded{color:#056dae;background-color:#eee}.category .category-title{margin-left:19px}.category.is-expanded .svg-arrow{left:38px;transform:rotate(180deg)}@media (max-width: 480px){.category{border-top:1px solid #999999}}.svg-arrow{height:9px;width:16px;left:38px;transition:transform .4s ease-in-out;transform:rotate(0);transform-origin:50%;background-image:url(data:image/svg+xml;charset=utf-8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+DQo8c3ZnIHdpZHRoPSIxNXB4IiBoZWlnaHQ9IjhweCIgdmlld0JveD0iMCAwIDE1IDgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeG1sbnM6c2tldGNoPSJodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2gvbnMiPg0KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggMy40LjEgKDE1NjgxKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4NCiAgICA8dGl0bGU+Q2hldnJvbjwvdGl0bGU+DQogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+DQogICAgPGRlZnM+PC9kZWZzPg0KICAgIDxnIGlkPSJUb29sa2l0IiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBza2V0Y2g6dHlwZT0iTVNQYWdlIj4NCiAgICAgICAgPGcgaWQ9IkRyb3Bkb3ducyIgc2tldGNoOnR5cGU9Ik1TQXJ0Ym9hcmRHcm91cCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTg3OC4wMDAwMDAsIC0xMjIuMDAwMDAwKSIgZmlsbD0iIzA1NkRBRSI+DQogICAgICAgICAgICA8ZyBpZD0iRHJvcGRvd24tR3JleSIgc2tldGNoOnR5cGU9Ik1TTGF5ZXJHcm91cCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTcwLjAwMDAwMCwgMTAxLjAwMDAwMCkiPg0KICAgICAgICAgICAgICAgIDxnIGlkPSJEcm9wZG93bi1EZWZhdWx0IiBza2V0Y2g6dHlwZT0iTVNTaGFwZUdyb3VwIj4NCiAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTMxMiwzMiBMMzEyLDI5LjY5MTcwNDggTDMxNi45ODk2ODksMjUuMDI0NjU5MSBMMzEyLDIwLjM1Nzc1NTYgTDMxMiwxOCBMMzE4LjQ2MTUzOCwyNC4xNTU1NDg2IEwzMTguNDYxNTM4LDI1Ljg0NDMwOTMgTDMxMiwzMiIgaWQ9IkNoZXZyb24iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMxNS4yMzA3NjksIDI1LjAwMDAwMCkgcm90YXRlKC0yNzAuMDAwMDAwKSB0cmFuc2xhdGUoLTMxNS4yMzA3NjksIC0yNS4wMDAwMDApICI+PC9wYXRoPg0KICAgICAgICAgICAgICAgIDwvZz4NCiAgICAgICAgICAgIDwvZz4NCiAgICAgICAgPC9nPg0KICAgIDwvZz4NCjwvc3ZnPg==);background-repeat:no-repeat}@media (max-width: 768px){.border-none{border:none!important}.padding-none{padding:0!important}}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Tab2Component, decorators: [{
            type: Component,
            args: [{ selector: 'citi-tab2', standalone: false, template: `
  <span
    [tabindex]="(isExpanded ? 0 : -1)"
    role="tab"
    class="category hidden-sm hidden-md hidden-lg {{isExpanded ? 'is-expanded' : '' }} {{tabgroup.isThemeLight ? 'theme-light' : '' }}"
    (click)="selectTab($event)"
    *ngIf="!tabgroup.alternateStyle"
    [attr.id]="tabgroup.idStr + 'Header-' + zeroIndex"
    [attr.aria-controls]="tabgroupId"
    data-title="Select to show/hide"
    [attr.aria-expanded]="isExpanded"
    [attr.aria-selected]="isExpanded">
    <svg class="svg-arrow"></svg>
    <span class="category-title" [innerHtml]="tabTitle"></span>
  </span>
  <div
    role="tabpanel"
    class="tab-pane {{isExpanded ? 'is-expanded' : '' }} {{tabgroup.isThemeLight ? 'theme-light' : '' }}"
    [attr.aria-labelledby]="tabgroup.idStr + 'Header-' + zeroIndex + '-tab'"
    [attr.id]="tabgroupId"
    [contentHtml]="htmlContent"
    [attr.aria-hidden]="!isExpanded"
    [ngClass]="(tabgroup.alternateStyle ? 'padding-none border-none mt-20-mobile' : '')">
    <ng-content></ng-content>
  </div>
  `, styles: [".tab-pane{border:none;padding:0;display:none;overflow:hidden;width:100%;visibility:hidden;margin:auto;max-height:0;transition:none}.tab-pane.is-expanded{background:#fff;display:block;max-height:300em;visibility:visible;transition:max-height 6s ease-out 2ms,background-color .5s ease-in-out 2ms,visibility 1ms ease;z-index:1}.tab-pane.is-expanded.theme-light{background:#eee}@media (max-width: 768px){.tab-pane:hover{border-top:1px solid #999999}}@media (max-width: 480px){.tab-pane{padding:0 20px 24px 70px}.tab-pane.mt-20-mobile{margin-top:20px!important}}.category{background-color:#eee;color:#333;cursor:pointer;display:block;font-family:Interstate_Light,sans-serif;font-size:16px;font-size:1rem;line-height:22px;padding:19px 20px;transition:background-color .5s ease-in-out}.category.is-expanded{background-color:#fff;color:#056dae}.category.theme-light{background-color:#fff}.category.theme-light.is-expanded{color:#056dae;background-color:#eee}.category .category-title{margin-left:19px}.category.is-expanded .svg-arrow{left:38px;transform:rotate(180deg)}@media (max-width: 480px){.category{border-top:1px solid #999999}}.svg-arrow{height:9px;width:16px;left:38px;transition:transform .4s ease-in-out;transform:rotate(0);transform-origin:50%;background-image:url(data:image/svg+xml;charset=utf-8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+DQo8c3ZnIHdpZHRoPSIxNXB4IiBoZWlnaHQ9IjhweCIgdmlld0JveD0iMCAwIDE1IDgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeG1sbnM6c2tldGNoPSJodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2gvbnMiPg0KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggMy40LjEgKDE1NjgxKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4NCiAgICA8dGl0bGU+Q2hldnJvbjwvdGl0bGU+DQogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+DQogICAgPGRlZnM+PC9kZWZzPg0KICAgIDxnIGlkPSJUb29sa2l0IiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBza2V0Y2g6dHlwZT0iTVNQYWdlIj4NCiAgICAgICAgPGcgaWQ9IkRyb3Bkb3ducyIgc2tldGNoOnR5cGU9Ik1TQXJ0Ym9hcmRHcm91cCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTg3OC4wMDAwMDAsIC0xMjIuMDAwMDAwKSIgZmlsbD0iIzA1NkRBRSI+DQogICAgICAgICAgICA8ZyBpZD0iRHJvcGRvd24tR3JleSIgc2tldGNoOnR5cGU9Ik1TTGF5ZXJHcm91cCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTcwLjAwMDAwMCwgMTAxLjAwMDAwMCkiPg0KICAgICAgICAgICAgICAgIDxnIGlkPSJEcm9wZG93bi1EZWZhdWx0IiBza2V0Y2g6dHlwZT0iTVNTaGFwZUdyb3VwIj4NCiAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTMxMiwzMiBMMzEyLDI5LjY5MTcwNDggTDMxNi45ODk2ODksMjUuMDI0NjU5MSBMMzEyLDIwLjM1Nzc1NTYgTDMxMiwxOCBMMzE4LjQ2MTUzOCwyNC4xNTU1NDg2IEwzMTguNDYxNTM4LDI1Ljg0NDMwOTMgTDMxMiwzMiIgaWQ9IkNoZXZyb24iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMxNS4yMzA3NjksIDI1LjAwMDAwMCkgcm90YXRlKC0yNzAuMDAwMDAwKSB0cmFuc2xhdGUoLTMxNS4yMzA3NjksIC0yNS4wMDAwMDApICI+PC9wYXRoPg0KICAgICAgICAgICAgICAgIDwvZz4NCiAgICAgICAgICAgIDwvZz4NCiAgICAgICAgPC9nPg0KICAgIDwvZz4NCjwvc3ZnPg==);background-repeat:no-repeat}@media (max-width: 768px){.border-none{border:none!important}.padding-none{padding:0!important}}\n"] }]
        }], ctorParameters: () => [{ type: TabGroup2Component }, { type: i0.ElementRef }], propDecorators: { tabTitle: [{
                type: Input$1,
                args: ['title']
            }], tabTitleSecond: [{
                type: Input$1,
                args: ['titleSecond']
            }], htmlContent: [{
                type: Input$1
            }], classTabPane: [{
                type: HostBinding,
                args: ['class.tab-pane']
            }], classLevel1: [{
                type: HostBinding,
                args: ['class.level1']
            }], classParent: [{
                type: HostBinding,
                args: ['class.parent']
            }] } });

const COMPONENTS$Y = [
    TabGroup2Component,
    Tab2Component
];
const MODULES$X = [
    CommonModule,
    FormsModule,
    ContentHtml
];
class TabGroup2 {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TabGroup2, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: TabGroup2, declarations: [TabGroup2Component,
            Tab2Component], imports: [CommonModule,
            FormsModule,
            ContentHtml], exports: [TabGroup2Component,
            Tab2Component] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TabGroup2, imports: [MODULES$X] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TabGroup2, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$X],
                    declarations: [...COMPONENTS$Y],
                    exports: [...COMPONENTS$Y]
                }]
        }] });

class CarouselSlideDirective {
    constructor(tpl) {
        this.tpl = tpl;
        this.isActiveSlide = false;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CarouselSlideDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.5", type: CarouselSlideDirective, isStandalone: false, selector: "[carousel-slide]", inputs: { slideAnnounce: ["carouselSlide", "slideAnnounce"] }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CarouselSlideDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[carousel-slide]',
                    standalone: false
                }]
        }], ctorParameters: () => [{ type: i0.TemplateRef }], propDecorators: { slideAnnounce: [{
                type: Input$1,
                args: ['carouselSlide']
            }] } });

class Carousel2Component {
    set activeSlide(activeSlide) {
        if (this._activeSlide === activeSlide)
            return;
        this._activeSlide = activeSlide;
        if (this.carouselSlides && this.carouselSlides.length) { // prevents setting before init
            this.deactiveCurentSlide();
            this.activeNewSlide(activeSlide);
        }
    }
    /**
     * @property announceSlideChange
     * @description This defines the custom string that will be announced via live announcer when the carousel transitions to a new slide
     * @return string
     * @default
    */
    set announceSlideChange(message) {
        if (this._announceSlideChange === message)
            return;
        this._announceSlideChange = message;
        this.announceSlide(message);
    }
    get slidesHaveRendered() {
        return !this.carouselSlideRefs.first || this.carouselSlideRefs.first.nativeElement.clientHeight === 0;
    }
    get isLast() {
        return this._activeSlide + 1 === this.carouselSlides.length;
    }
    get isFirst() {
        return this._activeSlide === 0;
    }
    constructor(builder, ngZone, announcer) {
        this.builder = builder;
        this.ngZone = ngZone;
        this.announcer = announcer;
        this.hasFocus = false;
        this.carouselSlideContentArray = [];
        this.carouselSlideRefArray = [];
        /**
        * @property idStr
        * @description id for the carousel
        * @return string
        */
        this.idStr = 'carousel';
        /**
         * @property activeSlide
         * @description This defines the index of the active slide that the carousel should display initially
         * @return number
         * @default 0
        */
        this._activeSlide = 0;
        this.activeSlideChange = new EventEmitter();
        /**
         * @property ariaLabel
         * @description This defines the custom value for the aria-label attribute of the Carousel section tag
         * @return string
         * @default
        */
        this.ariaLabel = 'Carousel';
        /**
         * @property ariaLive
         * @description This defines the custom value for the aria-live attribute
         * @return string
         * @default
        */
        this.ariaLive = 'assertive';
        /**
         * @property prevAriaLabel
         * @description This defines the custom value for the aria-label attribute of the previous slide button
         * @return string
         * @default
        */
        this.prevAriaLabel = 'Previous Slide';
        /**
         * @property nextAriaLabel
         * @description This defines the custom value for the aria-label attribute of the next slide button
         * @return string
         * @default
        */
        this.nextAriaLabel = 'Next Slide';
        if (isDevMode()) {
            console.error('%cThe Common UI DDL Carousel2 <citi-carousel2> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    ngAfterContentInit() {
        setTimeout(() => {
            this.carouselSlideContentArray = this.carouselSlides.toArray();
            this.currentSlide = this.carouselSlideContentArray[this._activeSlide];
            this.currentSlide.isActiveSlide = true;
        }, 1);
    }
    ngAfterViewInit() {
        this.carouselSlideRefArray = this.carouselSlideRefs.toArray();
        this.carouselSlideRefArray.forEach(slide => slide.nativeElement.style.display = 'none');
        this.carouselSlideRefArray[this._activeSlide].nativeElement.style.display = 'inherit';
    }
    handleFocus() {
        this.hasFocus = true;
        this.announceSlide(this._announceSlideChange);
    }
    handleBlur() {
        this.hasFocus = false;
    }
    deactiveCurentSlide() {
        this.currentSlide.isActiveSlide = false;
    }
    activeNewSlide(index) {
        this._activeSlide = index;
        this.activeSlideChange.emit(index);
        if (this.carouselSlideContentArray.length) {
            this.currentSlide = this.carouselSlideContentArray[index];
            this.currentSlide.isActiveSlide = true;
        }
    }
    next() {
        this.deactiveCurentSlide();
        this.isLast
            ? this.activeNewSlide(0)
            : this.activeNewSlide(++this._activeSlide % this.carouselSlides.length);
    }
    prev() {
        this.deactiveCurentSlide();
        this.isFirst
            ? this.activeNewSlide(this.carouselSlides.length - 1)
            : this.activeNewSlide((--this._activeSlide + this.carouselSlides.length) % this.carouselSlides.length);
    }
    announceSlide(message) {
        this.announcer.announce(`Now Displaying slide ${this._activeSlide + 1} out of ${this.carouselSlideContentArray.length}. ${message}`);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Carousel2Component, deps: [{ token: i1$5.AnimationBuilder }, { token: i0.NgZone }, { token: CitiLiveAnnouncer }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: Carousel2Component, isStandalone: false, selector: "citi-carousel2", inputs: { idStr: "idStr", activeSlide: "activeSlide", announceSlideChange: "announceSlideChange", ariaLabel: "ariaLabel", ariaLive: "ariaLive", prevAriaLabel: "prevAriaLabel", nextAriaLabel: "nextAriaLabel" }, outputs: { activeSlideChange: "activeSlideChange" }, host: { classAttribute: "citi-carousel2" }, queries: [{ propertyName: "carouselSlides", predicate: CarouselSlideDirective }], viewQueries: [{ propertyName: "carousel", first: true, predicate: ["carousel"], descendants: true }, { propertyName: "carouselSlideRefs", predicate: ["slide"], descendants: true, read: ElementRef }], ngImport: i0, template: `
  <section [attr.id]="idStr" class="carousel" [attr.aria-label]="ariaLabel">
    <div class="carousel-inner" #carousel (focus)="handleFocus()" (blur)="handleBlur()" tabindex="0">
      <!-- .item -->
      <div [attr.id]="idStr + '-items'" class="carousel-items" [attr.aria-live]="ariaLive">
        <div *ngFor="let carouselSlide of carouselSlides; let i = index;"
          role="group"
          [@visibilityChanged]= "carouselSlide.isActiveSlide"
          [class.active]="carouselSlide.isActiveSlide"
          class="carousel-item"
          #slide>
          <!-- content -->
          <ng-container [ngTemplateOutlet]="carouselSlide.tpl"></ng-container>
        </div>
      </div>
    </div>
    <!-- .next, .prev -->
    <a
      role="button"
      tabindex="0"
      [attr.id]="idStr + 'PreviousBtn'"
      class="prev"
      (click)="prev()"
      (keydown.enter)="prev()"
      [attr.aria-label]="prevAriaLabel"
      [attr.aria-controls]="idStr + '-items'">
      <span [attr.id]="idStr + 'GlyphiconLeft'" class="glyphicon glyphicon-menu-left"></span>
    </a>
    <a
      role="button"
      tabindex="0"
      [attr.id]="idStr + 'NextBtn'"
      class="next"
      (click)="next()"
      (keydown.enter)="next()"
      [attr.aria-label]="nextAriaLabel"
      [attr.aria-controls]="idStr + '-items'">
      <span [attr.id]="idStr + 'GlyphiconRight'" class="glyphicon glyphicon-menu-right"></span>
    </a>
    <!-- .indicators -->
    <div class="carousel-indicators" [hidden]="carouselSlides.length <= 1">
      <a
        *ngFor="let carouselSlide of carouselSlides; let idx = index"
        role="button"
        tabindex="0"
        [attr.id]="idStr + 'Dot' + (idx + 1)"
        class="slide-indicator"
        [class.active]="carouselSlide.isActiveSlide"
        (click)="activeSlide = idx"
        (keydown.enter)="activeSlide = idx"
        [attr.aria-controls]="idStr + '-items'"
        [attr.aria-label]="'carousel slide dot ' + (idx + 1) + ' of ' + carouselSlides.length">
      </a>
    </div>
  </section>
  `, isInline: true, styles: [":host{display:block}.carousel .carosuel-inner{overflow:hidden;position:relative;width:100%}.carosuel-item{display:none;position:relative}.carosuel .carosuel-item.active{display:block}.prev,.next{cursor:pointer;position:absolute;top:42%;width:40px;height:80px;color:#fff;font-weight:700;font-size:28px;border-radius:0 50px 50px 0;-webkit-user-select:none;user-select:none;background-color:#002a54}.prev:hover,.next:hover{transition:.4s ease;opacity:.4;color:#fff}.prev:focus,.next:focus{color:#fff}.next{right:0;border-radius:50px 0 0 50px}.glyphicon-menu-left,.glyphicon-menu-right{display:inline-block;font-size:30px;height:30px;margin-top:20px;position:absolute;width:30px}.glyphicon-menu-left{margin-right:5px}.glyphicon-menu-right{margin-left:5px}.carousel-indicators{position:absolute;bottom:0!important}.carousel-indicators .slide-indicator{display:inline-block;width:12px;height:12px;margin:8px!important;text-indent:-999px;border:1px solid #086DAD!important;border-radius:47px;cursor:auto}.slide-indicator.active,.slide-indicator:hover{width:13px;height:13px;background-color:#086dad!important;transition:.4s ease}@media (max-width: 600px){.prev,.next{height:65px;width:30px;top:75px}.glyphicon-menu-left,.glyphicon-menu-right{height:20px;width:20px;font-size:20px}.glyphicon-menu-left{margin-left:5px;margin-right:0}.carousel-indicators .slide-indicator{height:10px;width:10px}}@media (max-width: 350px){.prev,.next{height:50px;width:25px;top:75px}.glyphicon-menu-left,.glyphicon-menu-right{margin-left:2px;margin-top:13px}}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }], animations: [
            trigger('visibilityChanged', [
                state('1', style({ opacity: 1, display: 'inherit' })),
                state('0', style({ opacity: 0, display: 'none' })),
                // transition('0=>1', [
                //   animate('550ms ease'),
                // ]),
                // transition('1=>0', [
                //   animate('150ms ease'),
                // ]),
            ])
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Carousel2Component, decorators: [{
            type: Component,
            args: [{ selector: 'citi-carousel2', standalone: false, host: { class: 'citi-carousel2' }, template: `
  <section [attr.id]="idStr" class="carousel" [attr.aria-label]="ariaLabel">
    <div class="carousel-inner" #carousel (focus)="handleFocus()" (blur)="handleBlur()" tabindex="0">
      <!-- .item -->
      <div [attr.id]="idStr + '-items'" class="carousel-items" [attr.aria-live]="ariaLive">
        <div *ngFor="let carouselSlide of carouselSlides; let i = index;"
          role="group"
          [@visibilityChanged]= "carouselSlide.isActiveSlide"
          [class.active]="carouselSlide.isActiveSlide"
          class="carousel-item"
          #slide>
          <!-- content -->
          <ng-container [ngTemplateOutlet]="carouselSlide.tpl"></ng-container>
        </div>
      </div>
    </div>
    <!-- .next, .prev -->
    <a
      role="button"
      tabindex="0"
      [attr.id]="idStr + 'PreviousBtn'"
      class="prev"
      (click)="prev()"
      (keydown.enter)="prev()"
      [attr.aria-label]="prevAriaLabel"
      [attr.aria-controls]="idStr + '-items'">
      <span [attr.id]="idStr + 'GlyphiconLeft'" class="glyphicon glyphicon-menu-left"></span>
    </a>
    <a
      role="button"
      tabindex="0"
      [attr.id]="idStr + 'NextBtn'"
      class="next"
      (click)="next()"
      (keydown.enter)="next()"
      [attr.aria-label]="nextAriaLabel"
      [attr.aria-controls]="idStr + '-items'">
      <span [attr.id]="idStr + 'GlyphiconRight'" class="glyphicon glyphicon-menu-right"></span>
    </a>
    <!-- .indicators -->
    <div class="carousel-indicators" [hidden]="carouselSlides.length <= 1">
      <a
        *ngFor="let carouselSlide of carouselSlides; let idx = index"
        role="button"
        tabindex="0"
        [attr.id]="idStr + 'Dot' + (idx + 1)"
        class="slide-indicator"
        [class.active]="carouselSlide.isActiveSlide"
        (click)="activeSlide = idx"
        (keydown.enter)="activeSlide = idx"
        [attr.aria-controls]="idStr + '-items'"
        [attr.aria-label]="'carousel slide dot ' + (idx + 1) + ' of ' + carouselSlides.length">
      </a>
    </div>
  </section>
  `, animations: [
                        trigger('visibilityChanged', [
                            state('1', style({ opacity: 1, display: 'inherit' })),
                            state('0', style({ opacity: 0, display: 'none' })),
                            // transition('0=>1', [
                            //   animate('550ms ease'),
                            // ]),
                            // transition('1=>0', [
                            //   animate('150ms ease'),
                            // ]),
                        ])
                    ], styles: [":host{display:block}.carousel .carosuel-inner{overflow:hidden;position:relative;width:100%}.carosuel-item{display:none;position:relative}.carosuel .carosuel-item.active{display:block}.prev,.next{cursor:pointer;position:absolute;top:42%;width:40px;height:80px;color:#fff;font-weight:700;font-size:28px;border-radius:0 50px 50px 0;-webkit-user-select:none;user-select:none;background-color:#002a54}.prev:hover,.next:hover{transition:.4s ease;opacity:.4;color:#fff}.prev:focus,.next:focus{color:#fff}.next{right:0;border-radius:50px 0 0 50px}.glyphicon-menu-left,.glyphicon-menu-right{display:inline-block;font-size:30px;height:30px;margin-top:20px;position:absolute;width:30px}.glyphicon-menu-left{margin-right:5px}.glyphicon-menu-right{margin-left:5px}.carousel-indicators{position:absolute;bottom:0!important}.carousel-indicators .slide-indicator{display:inline-block;width:12px;height:12px;margin:8px!important;text-indent:-999px;border:1px solid #086DAD!important;border-radius:47px;cursor:auto}.slide-indicator.active,.slide-indicator:hover{width:13px;height:13px;background-color:#086dad!important;transition:.4s ease}@media (max-width: 600px){.prev,.next{height:65px;width:30px;top:75px}.glyphicon-menu-left,.glyphicon-menu-right{height:20px;width:20px;font-size:20px}.glyphicon-menu-left{margin-left:5px;margin-right:0}.carousel-indicators .slide-indicator{height:10px;width:10px}}@media (max-width: 350px){.prev,.next{height:50px;width:25px;top:75px}.glyphicon-menu-left,.glyphicon-menu-right{margin-left:2px;margin-top:13px}}\n"] }]
        }], ctorParameters: () => [{ type: i1$5.AnimationBuilder }, { type: i0.NgZone }, { type: CitiLiveAnnouncer }], propDecorators: { idStr: [{
                type: Input$1
            }], activeSlide: [{
                type: Input$1
            }], activeSlideChange: [{
                type: Output
            }], announceSlideChange: [{
                type: Input$1
            }], ariaLabel: [{
                type: Input$1
            }], ariaLive: [{
                type: Input$1
            }], prevAriaLabel: [{
                type: Input$1
            }], nextAriaLabel: [{
                type: Input$1
            }], carousel: [{
                type: ViewChild,
                args: ['carousel']
            }], carouselSlideRefs: [{
                type: ViewChildren,
                args: ['slide', { read: ElementRef }]
            }], carouselSlides: [{
                type: ContentChildren,
                args: [CarouselSlideDirective]
            }] } });

const COMPONENTS$X = [
    Carousel2Component,
    CarouselSlideDirective,
];
class Carousel2 {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Carousel2, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: Carousel2, declarations: [Carousel2Component,
            CarouselSlideDirective], imports: [CommonModule], exports: [Carousel2Component,
            CarouselSlideDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Carousel2, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Carousel2, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [...COMPONENTS$X],
                    exports: [...COMPONENTS$X]
                }]
        }] });

/**
 * @Component: Errors
 * @Section: Forms
 * @description This is the errors component and is used to display different types of error
 * from Bootstrap.
*/
class ErrorsComponent {
    /**
     * @property enableAlertBackground
     * @description Enables/disables the grey background
     * @return string
     */
    set enableAlertBackground(value) {
        this._enableAlertBackground = value;
        this.generateCssClassString();
    }
    constructor() {
        this._enableAlertBackground = false;
        /**
          * @property iconText
          * @description This property helps to define the type of error icon to be announced with screen reader
          * @return string (default mesasges for icons: critical alert icon, alert box, notice alert icon)
         */
        this.iconText = '';
        /**
          * @property errorType
          * @description This property helps to define the type of error to be displayed
          * @return string (criticalAlert, alertBox, noticeAlert)
         */
        this.errorType = 'alertBox';
        /**
          * @property errorMessage
          * @description This property helps to define the errorMessage of the error section
          * @return string
         */
        this.errorMessage = '';
        /**
          * @property normalMessage
          * @description This property helps to define the normalMessage (displays with normal text)
          * of the error section other than error message
          * @return string
         */
        this.normalMessage = '';
        if (isDevMode()) {
            console.error('%cThe Common UI DDL FormErrors <citi-errors> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    // 'critical alert icon' | 'alert box' | 'notice alert icon'
    generateCssClassString() {
        switch (this.errorType) {
            case 'criticalAlert':
                this.alertTypeClass = 'alert critical';
                this.iconText = 'critical alert icon';
                break;
            case 'alertBox':
                this.alertTypeClass = 'alert-box';
                this.iconText = 'alert box';
                break;
            case 'noticeAlert':
                this.alertTypeClass = 'alert';
                this.iconText = 'notice alert icon';
                break;
            default:
                this.alertTypeClass = 'alert-box';
                this.iconText = 'alert box';
        }
        // If the alert type is not alert box but consumers still to want grey background,
        // adds the CSS class for the grey background
        if (this._enableAlertBackground && this.alertTypeClass !== 'alert-box') {
            this.alertTypeClass += ' theme-gray';
        }
    }
    ngOnInit() {
        this.generateCssClassString();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ErrorsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: ErrorsComponent, isStandalone: false, selector: "citi-errors", inputs: { iconText: "iconText", errorType: "errorType", idStr: "idStr", errorMessage: "errorMessage", normalMessage: "normalMessage", enableAlertBackground: "enableAlertBackground" }, host: { classAttribute: "citi-errors" }, ngImport: i0, template: `
    <div [ngClass]="alertTypeClass" [attr.id]="idStr" role="alert">
      <div class="message">
          <span class="sr-only" [innerHtml]="iconText"></span>
          <div *ngIf="errorType !== 'criticalAlert'" [innerHtml]="errorMessage"></div>
          <div *ngIf="errorType == 'criticalAlert'">
              <span class="strong" [innerHtml]="errorMessage"></span>
              <span [innerHtml]="normalMessage"></span>
          </div>
      </div>
    </div>
  `, isInline: true, styles: [":host{display:block}.alert .message{margin-left:28px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ErrorsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-errors', standalone: false, template: `
    <div [ngClass]="alertTypeClass" [attr.id]="idStr" role="alert">
      <div class="message">
          <span class="sr-only" [innerHtml]="iconText"></span>
          <div *ngIf="errorType !== 'criticalAlert'" [innerHtml]="errorMessage"></div>
          <div *ngIf="errorType == 'criticalAlert'">
              <span class="strong" [innerHtml]="errorMessage"></span>
              <span [innerHtml]="normalMessage"></span>
          </div>
      </div>
    </div>
  `, host: { class: 'citi-errors' }, styles: [":host{display:block}.alert .message{margin-left:28px}\n"] }]
        }], ctorParameters: () => [], propDecorators: { iconText: [{
                type: Input$1
            }], errorType: [{
                type: Input$1
            }], idStr: [{
                type: Input$1
            }], errorMessage: [{
                type: Input$1
            }], normalMessage: [{
                type: Input$1
            }], enableAlertBackground: [{
                type: Input$1
            }] } });

class FormErrors {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: FormErrors, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: FormErrors, declarations: [ErrorsComponent], imports: [CommonModule], exports: [ErrorsComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: FormErrors, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: FormErrors, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [ErrorsComponent],
                    exports: [ErrorsComponent]
                }]
        }] });

class ImageComponent {
    set type(type) {
        this._type = type;
    }
    get type() {
        return this._type;
    }
    set quote(value) {
        this._quote = (value === 'true' || value === true);
    }
    ;
    get quote() {
        return this._quote;
    }
    constructor() {
        this._imageLeftClass = 'pull-out-quote pull-quote-content-p-1';
        this._imageRightClass = 'pull-out-quote pull-quote-content-p-2';
        this._imageCenterClass = 'pull-out-quote-3 pull-out-quote-p-3';
        this.imageClass = this._imageLeftClass;
        /**
         * @property imageUrl
         * @description URL to the image
         * @return string
         * @twoway false
         */
        this.imageUrl = 'images/pull-out-quote-v2.png';
        /**
         * @property quoteText
         * @description Sets the text for quote section of an image
         * @return string
         * @twoway true
         */
        this.quoteText = 'Quote text';
        /**
         * @property type
         * @description Type of image element. Default value is 'left'. Valid values include 'left', 'right', and 'center'.
         * @return string
         * @twoway false
         */
        this._type = 'left';
        /**
         * @property quote
         * @description Shows/hides the quote section
         * @twoway false
         */
        this._quote = true;
        if (isDevMode()) {
            console.error('%cThe Common UI DDL Image <citi-image> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    ngOnInit() {
        switch (this._type) {
            case 'left':
                this.imageClass = this._imageLeftClass;
                break;
            case 'right':
                this.imageClass = this._imageRightClass;
                break;
            case 'center':
                this.imageClass = this._imageCenterClass;
                break;
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ImageComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: ImageComponent, isStandalone: false, selector: "citi-image", inputs: { altText: "altText", imageUrl: "imageUrl", dataTarget: "dataTarget", quoteText: "quoteText", type: "type", quote: "quote" }, ngImport: i0, template: `
    <section class="f-1-photo">
      <span class="sr-only" *ngIf="altText">graphic</span>
      <div [ngClass]="imageClass">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12">
              <blockquote *ngIf="quote" class="pull-quote-content">
                <p class="pull-quote-copy" [innerHtml]="quoteText"></p>
              </blockquote>
              <div class="pull-quote-banner">
                <img [attr.src]="imageUrl" [attr.data-target]="dataTarget" [attr.alt]="altText" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ImageComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'citi-image',
                    standalone: false,
                    template: `
    <section class="f-1-photo">
      <span class="sr-only" *ngIf="altText">graphic</span>
      <div [ngClass]="imageClass">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12">
              <blockquote *ngIf="quote" class="pull-quote-content">
                <p class="pull-quote-copy" [innerHtml]="quoteText"></p>
              </blockquote>
              <div class="pull-quote-banner">
                <img [attr.src]="imageUrl" [attr.data-target]="dataTarget" [attr.alt]="altText" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  `,
                }]
        }], ctorParameters: () => [], propDecorators: { altText: [{
                type: Input$1
            }], imageUrl: [{
                type: Input$1
            }], dataTarget: [{
                type: Input$1
            }], quoteText: [{
                type: Input$1
            }], type: [{
                type: Input$1
            }], quote: [{
                type: Input$1
            }] } });

class Image {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Image, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: Image, declarations: [ImageComponent], imports: [CommonModule], exports: [ImageComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Image, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Image, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [ImageComponent],
                    exports: [ImageComponent]
                }]
        }] });

class MapMarkerDataService {
    set resultCount(count) {
        this._resultCount = count;
    }
    set radius(radius) {
        this._radius = radius;
    }
    set bodyProperties(props) {
        this._bodyProperties = props;
    }
    set clientId(clientId) {
        this._clientId = clientId;
    }
    set endpointUrl(url) {
        this._endpointUrl = url;
    }
    // Constructor
    constructor(http, locationRef) {
        this.http = http;
        // Variables
        this.data = null;
        this.observable = null;
        this._resultCount = 50;
        this._radius = 50;
        this._bodyProperties = {};
        this.isPCFEnv =
            locationRef &&
                location.hostname.includes('cfapps-gt1-dev.nam.nsroot.net');
    }
    // Returns data
    getData(latlng) {
        // If we got a latlng with both a lat and lng
        if (typeof latlng !== 'undefined' && latlng.lat && latlng.lng) {
            if (this.isPCFEnv) {
                const result = JSON.parse(localStorage.getItem('mockMarkers'))
                    .filter(obj => Math.abs(obj.inputLocation.coordinates[0] - latlng.lng) < 0.05 &&
                    Math.abs(obj.inputLocation.coordinates[1] - latlng.lat) < 0.05)
                    .map(element => {
                    element.features = element.features
                        .slice(0, this._resultCount)
                        .filter(subel => subel.properties.distance < this._radius);
                    return element;
                });
                // console.log('getData with isPCFEnv true:', result && result[0] && result[0].features.map(ftr => {
                //     const ap = ftr.properties.additionalProperties;
                //     return { ADA: ap.ADA, type: ap.type };
                // }));
                console.log('result[0].features.length', result[0].features.length);
                return of(result[0]);
            }
            if (typeof this._clientId === 'string' &&
                this._clientId.length &&
                typeof this._endpointUrl === 'string' &&
                this._endpointUrl.length) {
                // Cancel the current HTTP Request
                if (this.observable && this.observable.unsubscribe) {
                    this.observable.unsubscribe();
                }
                // Get the nearest 50 locations within 50 miles
                let body = {
                    type: 'branchesAndATMs',
                    inputLocation: [latlng.lng, latlng.lat],
                    resultCount: this._resultCount,
                    distanceUnit: 'MILE',
                    findWithinRadius: this._radius
                };
                // if provided, then add the properties object
                if (!isEmptyObject(this._bodyProperties))
                    body = Object.assign(body, { properties: this._bodyProperties });
                const options = {
                    headers: new HttpHeaders({
                        Accept: 'application/json',
                        'Content-Type': 'application/json; charset=utf-8',
                        countryCode: 'US',
                        businessCode: 'GCB',
                        channelID: 'INTERNET',
                        scope: 'VISITOR',
                        'Accept-Language': 'en-US',
                        client_id: this._clientId
                    })
                };
                // Make our http call
                this.observable = this.http.post(this._endpointUrl, body, options).pipe(
                // Catch the successful call
                map(response => {
                    // Clear the observable
                    this.observable = null;
                    // Otherwise set the data
                    this.data = response;
                    // And return the response
                    return this.data;
                }), 
                // Catch any errors and do nothing
                catchError((error) => {
                    return throwError(error);
                }), 
                // Share the observable with subscribers
                share());
            }
            // Return the observable to be subscribed to
            return this.observable;
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: MapMarkerDataService, deps: [{ token: i1.HttpClient }, { token: LOCATION }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: MapMarkerDataService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: MapMarkerDataService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: Object, decorators: [{
                    type: Inject,
                    args: [LOCATION]
                }] }] });

/**
 * @Component: Map
 * @Section: Miscellaneous
 * @description Generates an interactive map to display locations of branches/atms
 */
class MapComponent {
    /**
     * @property bounds
     * @description The current bounds of the map (google maps LatLngBounds object)
     * @twoway true
     */
    set bounds(bounds) {
        // Make sure the bounds we got is not the current bounds of the map
        if (typeof this.map !== 'undefined' &&
            typeof bounds !== 'undefined' &&
            this.map.getBounds() !== bounds) {
            // Fit the map to the new bounds
            setTimeout(() => {
                this.map.fitBounds(bounds);
            }, 0);
        }
    }
    /**
     * Sets the active marker
     * @Type: Marker
     * @twoway true
     * param: {any} marker - the marker that is to be active
     */
    set activeMarker(marker) {
        // If there was a marker passed, the map is available, and the map data has been set
        if (marker && this.map && this.map.data) {
            // Get the marker from the data layer
            const newMarker = this.map.data.getFeatureById(marker.id);
            // If we found a matching marker in the data layer
            if (newMarker) {
                // Style the marker to be active
                this.makeMarkerActive(newMarker);
            }
        }
    }
    /**
     * lat/long of the center of the map being displayed
     * @Type: object {lat: "N", lng: "N"}
     * @twoway true
     * param: {{lat: number, lng: number}} position - the lat/lng values for map center
     */
    set mapCenter(position) {
        let updateMapCenter = true;
        // Set the map to display markers if this is not an initial map position
        if (typeof google !== 'undefined' || this.map) {
            this.displayMarkers = true;
        }
        // If we already have a map
        if (this.map) {
            // Get the current LatLng object
            const latlng = this.map.getCenter();
            // Create an object for the current map center
            const currentMapCenter = { lat: latlng.lat(), lng: latlng.lng() };
            // Check the new position against the old position, and if they are they same
            if (typeof position !== 'undefined' &&
                position.lat &&
                position.lng &&
                position.lat === currentMapCenter.lat &&
                position.lng === currentMapCenter.lng) {
                // Cet the map center not to update
                updateMapCenter = false;
            }
        }
        // If a position was provided
        if (typeof position !== 'undefined' &&
            position.lat &&
            position.lng &&
            position.lat &&
            updateMapCenter) {
            setTimeout(() => {
                // Set the current map service center to the provided position
                this.center = position;
                // Set thet map center using the provided position
                this.setMapCenter(position);
            }, 0);
        }
    }
    /**
     * @property zoomLevel
     * @description Current zoom level of the map. Accepts values between 0 (shows the entire earth) and up 21
     * @Type: array
     * @twoway true
     */
    set zoomLevel(level) {
        this.zoom = level;
        if (this.map &&
            typeof level !== 'undefined' &&
            level !== this.map.getZoom()) {
            // Update the zoom level of the map
            setTimeout(() => {
                this.map.setZoom(level);
            }, 0);
        }
    }
    /**
     * @property filters
     * @description Filters to be applied to the marker results.
     * Takes an array with JSON objects with two properties, key and value.
     * Key is the property to be matched against (branch, atm, etc).
     * Value is the value the property should match (true, false, branch manager, etc).
     * Example: [{key: "branch", value: "true"}]
     * @Type: array
     * @twoway false
     */
    set filters(filters) {
        // If we caught an array with at least one filter
        if (filters && typeof filters === 'object') {
            // Set the new filters to the map component
            this.currentMarkerFilters = filters;
        }
        else {
            this.currentMarkerFilters = null;
        }
    }
    /**
     * @property resultCount
     * @description configures the body object passed to the markerservice to request a specific number of markers
     * @return number
     * @twoway false
     */
    set resultCount(count) {
        this.markerService.resultCount = count;
    }
    /**
     * @property radius
     * @description configures the body object passed to the markerservice to limit results to a specifc radius
     * @return number
     * @twoway false
     */
    set radius(radius) {
        this.markerService.radius = radius;
    }
    /**
     * @property bodyProperties
     * @description configures the body object passed to the markerservice will send {"properties": OBJ} where OBJ is an object passed to the map component
     * @Type: object
     * @twoway false
     */
    set bodyProperties(props) {
        this.markerService.bodyProperties = props;
    }
    /**
     * @property typeFilters
     * @description Filters to be applied to the marker results for type. Allows for "or" matching instead of "and" matching.
     * Example: Marker represents an ATM OR MoneyPassATM.
     * Filters example: Marker represents an ATM AND a MoneyPassATM
     * Takes an array with JSON objects with two properties, key and value.
     * Key is the property to be matched against (branch, atm, etc).
     * Value is the value the property should match (true, false, branch manager, etc).
     * Example: [{key: "branch", value: "true"}]
     * @Type: array
     * @twoway false
     */
    set typeFilters(filters) {
        // If we caught an array with at least one filter
        if (filters && typeof filters === 'object') {
            // Set the new filters to the map component
            this.currentMarkerTypeFilters = filters;
        }
        else {
            this.currentMarkerTypeFilters = null;
        }
    }
    set clientId(clientId) {
        this.markerService.clientId = clientId;
    }
    set endpointUrl(url) {
        this.markerService.endpointUrl = url;
    }
    /**
     * @property customFilter
     * @description Pass in a custom function that returns a boolean value
     */
    // @Input() customFilter: (marker: any, index?: number, array?: any[]) => boolean;
    set customFilter(customFilter) {
        if (customFilter && typeof customFilter === 'function') {
            this._customFilter = customFilter;
        }
        else {
            this._customFilter = null;
        }
    }
    get customFilter() {
        return this._customFilter;
    }
    // #endregion
    // #region // ----------------------- Constructor / Lifecycle Hooks ----------------------- //
    constructor(markerService, zone, platformId) {
        this.markerService = markerService;
        this.zone = zone;
        // Added this flag to not relead the markers just because of window resize
        this.centeredDueToResize = false;
        // Whether or not the map should attempt to retrieve markers
        this.displayMarkers = false;
        // Location marker (stored to remove when reloaded)
        this.locationMarker = null;
        // #endregion
        // #region // ----------------------- Input / Output ----------------------- //
        /**
         * @property loading
         * @description Whether the map is loading or not
         * @twoway output only
         */
        this.loading = new EventEmitter();
        this.boundsChange = new EventEmitter();
        /**
         * @property atmMarkerLabel
         * @description Label text for the atm marker
         * @return string
         * @twoway false
         */
        this.atmMarkerLabel = 'ATM';
        /**
         * @property branchMarkerLabel
         * @description Label text for the branch marker
         * @return string
         * @twoway false
         */
        this.branchMarkerLabel = 'Branch';
        /**
         * @property moneypassMarkerLabel
         * @description Label text for the MoneyPass ATM marker
         * @return string
         * @twoway false
         */
        this.moneypassMarkerLabel = 'MoneyPass ATM';
        /**
         * @property displayedMarkers
         * @description A list of markers current displayed on the map.
         * @Type: array<Markers>
         * @twoway output only
         */
        this.displayedMarkers = new EventEmitter();
        /**
         * Fired whenever the currently active marker is changed. Returns a marker GeoJSON feature object
         * @Type: Marker
         * @twoway true
         */
        this.activeMarkerChange = new EventEmitter();
        this.mapCenterChange = new EventEmitter();
        this.zoomLevelChange = new EventEmitter();
        /**
         * @property updateMapOnMove
         * @description Whether the map should update the markers when the map is moved
         * @Type: boolean
         * @twoway false
         */
        this.updateMapOnMove = true;
        /**
         * @property loadLocation
         * @description Whether the map should find the user position on load, defaults to false
         * @Type: boolean
         * @twoway false
         */
        this.loadLocation = false;
        /**
         * @property onUserLocation
         * @description Outputs when the users location is obtained from the browser
         * @Type: LatLng
         * @twoway output only
         */
        this.onUserLocation = new EventEmitter();
        // Adds the user location marker
        this.addUserLocationMarker = (userLocation) => {
            // Set the users location to the component
            this.userLocation = userLocation;
            // Add the marker to the map
            this.locationMarker = this.map.data.addGeoJson({
                type: 'Feature',
                geometry: {
                    type: 'point',
                    coordinates: [userLocation.lng, userLocation.lat]
                },
                id: 'userLocation',
                properties: {
                    type: 'USERLOCATION'
                }
            });
            // Set the map to display markers
            this.displayMarkers = true;
            // Get the markers for the map if we don't already have some
            if (!this.markers)
                this.getMarkers();
        };
        // Callback for the call to the browser to request the users estimated lat/lng
        this.getUserLocationCallback = function (position) {
            // Catches a Geoposition object:
            // Get the latlng from the position object
            const latlng = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
            };
            // Set the map center to that location
            this.setMapCenter(new google.maps.LatLng(latlng));
            this.addUserLocationMarker(latlng);
            // Emit that the map component got the users location
            this.onUserLocation.emit(latlng);
        };
        if (isDevMode()) {
            console.error('%cThe Common UI DDL CitiMap <citi-map> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
        this.isBrowser = isPlatformBrowser(platformId);
        this.displayMarkers =
            false ||
                (this.isBrowser &&
                    location.hostname.includes('cfapps-gt1-dev.nam.nsroot.net'));
    }
    // On Init
    ngAfterViewInit() {
        // Set the key for the Google Maps API
        // If we got a valid API key
        if (this.isBrowser &&
            typeof this.apiKey === 'string' &&
            this.apiKey.length) {
            // Listen for the callback event for Google Maps JS APi on the window and call waitForBranding when it is ready
            window.googleMapsReady = () => this.initMap();
            // Create the script tag and add it to the document
            const gmap = document.createElement('script');
            gmap.type = 'text/javascript';
            gmap.async = true;
            gmap.src =
                'https://maps.googleapis.com/maps/api/js?callback=googleMapsReady&libraries=places&key=' +
                    this.apiKey;
            const s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(gmap, s);
        }
    }
    ngOnChanges(changes) {
        if (this.map &&
            this.map.data &&
            (changes.filters || changes.typeFilters || changes.customFilter)) {
            // Update the markers after any changes to the filters
            this.addMarkers(this.markers);
        }
    }
    ngOnDestroy() {
        // Remove script tag to avoid Google Maps API multiple times error
        if (this.isBrowser && window.google) {
            window.google = undefined;
            const scripts = document.querySelectorAll("script[src*='maps.googleapis.com']");
            Array.from(scripts).forEach(script => script.parentNode.removeChild(script));
        }
    }
    // #endregion
    // #region // ----------------------- Methods ----------------------- //
    // Intializes the map
    initMap() {
        // Let other components know the javascript for maps has been loading
        // Create event
        const evt = document.createEvent('HTMLEvents');
        // Initialize the event
        evt.initEvent('googleApiLoaded', true, false);
        // Fire the event
        window.dispatchEvent(evt);
        // Default icon label origin (position)
        const labelOrigin = new google.maps.Point(31, 17);
        // Active icon label origin (position)
        const activeLabelOrigin = new google.maps.Point(46, 27);
        // Define Google Maps Icon Class Objects for Map Icons
        this.icons = {
            // Branch icon
            branch: {
                url: 'assets/Branch_Default.png',
                labelOrigin: labelOrigin,
                scaledSize: new google.maps.Size(35, 31)
            },
            // Active branch icon
            branchActive: {
                url: 'assets/Branch_Active.png',
                labelOrigin: activeLabelOrigin,
                scaledSize: new google.maps.Size(58, 53)
            },
            // ATM icon
            atm: {
                url: 'assets/ATM_Default.png',
                labelOrigin: labelOrigin,
                scaledSize: new google.maps.Size(35, 31)
            },
            // Active ATM icon
            atmActive: {
                url: 'assets/ATM_Active.png',
                labelOrigin: activeLabelOrigin,
                scaledSize: new google.maps.Size(58, 53)
            },
            // MoneyPass icon
            moneypass: {
                url: 'assets/MoneyPass_ATM_Default.png',
                labelOrigin: labelOrigin,
                scaledSize: new google.maps.Size(35, 31)
            },
            // Active MoneyPass icon
            moneypassActive: {
                url: 'assets/MoneyPass_ATM_Active.png',
                labelOrigin: activeLabelOrigin,
                scaledSize: new google.maps.Size(58, 53)
            },
            // User location icon
            userlocation: {
                url: 'assets/Location_Marker.png',
                scaledSize: new google.maps.Size(35, 35)
            }
        };
        // Request location from the browser. Arrow function used to maintain scope.
        navigator.geolocation.getCurrentPosition(position => {
            if (this.loadLocation) {
                this.getUserLocationCallback(position);
            }
            else {
                this.onUserLocation.emit({
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                });
            }
        });
        // Set the map to a new google map
        this.map = new google.maps.Map(this.mapEl.nativeElement, {
            // Default zoom level
            zoom: this.zoom || 6,
            center: this.center || { lat: 22.896998, lng: -96.949422 },
            zoomControlOptions: {
                position: google.maps.ControlPosition.RIGHT_TOP
            },
            streetViewControlOptions: {
                position: google.maps.ControlPosition.RIGHT_TOP
            },
            fullscreenControl: false
        });
        // Create location icon
        const controlDiv = document.createElement('div');
        const firstChild = document.createElement('button');
        firstChild.type = 'button';
        firstChild.style.backgroundColor = '#fff';
        firstChild.style.border = 'none';
        firstChild.style.outline = 'none';
        firstChild.style.width = '28px';
        firstChild.style.height = '28px';
        firstChild.style.borderRadius = '2px';
        firstChild.style.boxShadow = '0 1px 4px rgba(0,0,0,0.3)';
        firstChild.style.cursor = 'pointer';
        firstChild.style.marginRight = '10px';
        firstChild.style.marginTop = '10px';
        firstChild.style.padding = '0px';
        firstChild.title = 'Your Location';
        controlDiv.appendChild(firstChild);
        const secondChild = document.createElement('div');
        secondChild.style.margin = '5px';
        secondChild.style.width = '18px';
        secondChild.style.height = '18px';
        secondChild.style.backgroundImage =
            'url(https://maps.gstatic.com/tactile/mylocation/mylocation-sprite-1x.png)';
        secondChild.style.backgroundSize = '180px 18px';
        secondChild.style.backgroundPosition = '0px 0px';
        secondChild.style.backgroundRepeat = 'no-repeat';
        secondChild.id = 'you_location_img';
        firstChild.appendChild(secondChild);
        google.maps.event.addListener(this.map, 'dragend', function () {
            document.getElementById('you_location_img').style.backgroundPosition =
                '0px 0px';
        });
        firstChild.addEventListener('click', () => {
            let imgX = '0';
            const animationInterval = setInterval(function () {
                if (imgX === '-18')
                    imgX = '0';
                else
                    imgX = '-18';
                document.getElementById('you_location_img').style.backgroundPosition =
                    imgX + 'px 0px';
            }, 500);
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(position => {
                    this.getUserLocationCallback(position);
                    clearInterval(animationInterval);
                    document.getElementById('you_location_img').style.backgroundPosition =
                        '-144px 0px';
                });
            }
            else {
                clearInterval(animationInterval);
                document.getElementById('you_location_img').style.backgroundPosition =
                    '0px 0px';
            }
        });
        // Add the location icon
        this.map.controls[google.maps.ControlPosition.TOP_RIGHT].push(controlDiv);
        /* After the map has been created set the tabindex to -1 in order to not allow users to tab to the map
            Accessibility should be implemented by the results finder portion of the map and not the map component itself */
        google.maps.event.addListenerOnce(this.map, 'tilesloaded', () => {
            const iframeElement = this.mapEl.nativeElement.querySelector('iframe');
            if (iframeElement) {
                iframeElement.setAttribute('tabindex', '-1');
            }
        });
        // Set the styles for the marker icons
        this.setStyles();
        // Set the initial map state
        this.update();
        // Listen for the map center to change
        this.map.addListener('center_changed', () => {
            /* Added this flag to not relead the markers just because of window resize */
            if (!this.centeredDueToResize) {
                // Set the markers to display
                this.displayMarkers = true;
                // If the map should update when the center is changed
                if (this.updateMapOnMove) {
                    // Update the map status
                    this.update();
                }
            }
            else {
                /* Still update the markers for the map but do not get new markers */
                this.addMarkers(this.markers);
            }
        });
        // Listen for clicks on the markers
        this.map.data.addListener('click', event => {
            // Get the marker
            const marker = event.feature;
            this.makeMarkerActive(marker);
            // Emit this as the currently active marker
            this.activeMarker = marker;
            this.activeMarkerChange.emit(marker);
        });
        // Listen for the map zoom level to change
        this.map.addListener('zoom_changed', () => {
            // Update map status
            this.update();
        });
        /* Store initial width */
        this.width = window.innerWidth;
        // Add a listener to reset the map when the window is resized
        google.maps.event.addDomListener(window, 'resize', event => {
            /* Only fire this event if the width is changed because this always will fire on scroll of phones */
            if (this.width !== window.innerWidth) {
                /* Added this flag to not relead the markers just because of window resize */
                this.centeredDueToResize = true;
                const center = this.map.getCenter();
                google.maps.event.trigger(this.map, 'resize');
                this.map.setCenter(center);
                this.centeredDueToResize = false;
                /* Update width */
                this.width = window.innerWidth;
            }
        });
    }
    // Updates the maps status via the outputs
    update() {
        this.zone.run(() => {
            if (this.map) {
                // Get the map center
                const latlng = this.map.getCenter();
                // Get the map bounds
                const bounds = this.map.getBounds();
                // Emit the zoom level
                this.zoomLevelChange.emit(this.map.getZoom());
                // Emit the change to the map center
                this.mapCenterChange.emit({ lat: latlng.lat(), lng: latlng.lng() });
                // Emit the change to the map bounds
                this.boundsChange.emit(bounds);
                // Get the markers
                this.getMarkers();
            }
        });
    }
    // Gets new markers from the marker service
    getMarkers() {
        // Clear the current marker timeout
        clearTimeout(this.markerTimeout);
        // If the map is set to display markers
        if (this.displayMarkers) {
            // If there is not a zoom marker limit or the maps current zoom level is above the zoom marker limit
            if (!this.zoomMarkerLimit || this.map.getZoom() >= this.zoomMarkerLimit) {
                // Clear the current marker timeout
                clearTimeout(this.markerTimeout);
                // Get the map coordinates
                const latlng = this.map.getCenter();
                // Get the marker data from the marker data service
                this.markerTimeout = setTimeout(() => {
                    // Emit that the markers are loading
                    this.loading.emit(true);
                    // Get the markers from the marker service
                    this.markerService
                        .getData({ lat: latlng.lat(), lng: latlng.lng() })
                        .subscribe(markers => {
                        // Add the markers to the map
                        this.addMarkers(markers);
                    });
                }, 250);
            }
            else if (this.zoomMarkerLimit &&
                this.map &&
                this.map.getZoom() < this.zoomMarkerLimit) {
                // Remove all the markers if we are outside the marker zoom limit
                this.map.data.forEach(marker => {
                    this.map.data.remove(marker);
                });
            }
        }
    }
    // Adds markers to the map using any supplied filters and type filters
    addMarkers(markers) {
        if (this.displayMarkers &&
            (!this.zoomMarkerLimit || this.map.getZoom() >= this.zoomMarkerLimit)) {
            // Save a reference to the array of markers
            this.markers = markers;
            // Get the map bounds
            const bounds = this.map.getBounds();
            // Create array to hold visible markers
            let visibleMarkers = [];
            // Remove all of the markers from the map
            this.map.data.forEach(feature => {
                this.map.data.remove(feature);
            });
            // Check if we have filters or type filters
            const hasFilters = !!this.currentMarkerFilters &&
                typeof this.currentMarkerFilters === 'object' &&
                this.currentMarkerFilters.length;
            const hasTypeFilters = !!this.currentMarkerTypeFilters &&
                typeof this.currentMarkerTypeFilters === 'object' &&
                this.currentMarkerTypeFilters.length;
            const hasCustomFilter = !!this.customFilter && typeof this.customFilter === 'function';
            // If there is a map and it has a data layer and we have markers and filters
            if (typeof this.markers !== 'undefined' &&
                typeof this.markers.features !== 'undefined' &&
                this.markers.features.length &&
                typeof this.map !== 'undefined' &&
                this.map.data &&
                (hasFilters || hasTypeFilters || hasCustomFilter)) {
                // console.group('filters');
                // console.log('hasFilters', hasFilters);
                // console.log('hasTypeFilters', hasTypeFilters);
                // console.log('hasCustomFilter', hasCustomFilter);
                // console.groupEnd();
                let filteredMarkers = [...this.markers.features];
                // Apply custom filter
                if (hasCustomFilter) {
                    filteredMarkers = filteredMarkers.filter(this.customFilter);
                }
                // Loop over each marker
                for (let markerIndex1 = 0, markersLength1 = filteredMarkers.length; markerIndex1 < markersLength1; markerIndex1++) {
                    // Get the marker
                    const marker1 = filteredMarkers[markerIndex1];
                    // If the marker has passed all filters.  Will be set to false by any filter that does not pass.
                    let markerPassesFilters = true;
                    // If the marker has passed all type filters.  Will be set to true by any filter that passes.
                    let markerPassesTypeFilters = false;
                    // How many filters have passed checks
                    // let numFilterPasses: number = 0;
                    // If we have type filters (this is OR filtering)
                    // console.log('filter:', hasFilters, 'typeFilter:', hasTypeFilters, 'currentMarkerTypeFilters:', this.currentMarkerTypeFilters);
                    if (hasTypeFilters) {
                        // Loop over each filter
                        for (let typeFilterIndex = 0, typeFiltersLength = this.currentMarkerTypeFilters.length; typeFilterIndex < typeFiltersLength; typeFilterIndex++) {
                            // Get the filter
                            const filter2 = this.currentMarkerTypeFilters[typeFilterIndex];
                            // If the map doesn't already have this marker
                            if (typeof this.map.data.getFeatureById(marker1.id) === 'undefined') {
                                // If the filter has a key and value and we got a marker
                                if (typeof marker1 !== 'undefined' &&
                                    typeof filter2.key !== 'undefined' &&
                                    typeof filter2.value !== 'undefined') {
                                    // Match the filter against the marker
                                    if (typeof marker1.properties.additionalProperties[filter2.key] !== 'undefined' &&
                                        marker1.properties.additionalProperties[filter2.key] ===
                                            filter2.value) {
                                        // Set the marker to not match the filters
                                        markerPassesTypeFilters = true;
                                        // Exit the loop
                                        typeFilterIndex = typeFiltersLength;
                                    }
                                }
                            }
                        }
                    }
                    // If we have filters (this is AND filtering)
                    if (hasFilters) {
                        // Loop over each filter
                        for (let filterIndex = 0, filtersLength = this.currentMarkerFilters.length; filterIndex < filtersLength; filterIndex++) {
                            // Get the filter
                            const filter1 = this.currentMarkerFilters[filterIndex];
                            // If the map doesn't already have this marker
                            if (typeof this.map.data.getFeatureById(marker1.id) === 'undefined') {
                                // If the filter has a key and value and we got a marker
                                if (typeof marker1 !== 'undefined' &&
                                    typeof filter1.key !== 'undefined' &&
                                    typeof filter1.value !== 'undefined') {
                                    // Match the filter against the marker
                                    if (typeof marker1.properties.additionalProperties[filter1.key] === 'undefined' ||
                                        marker1.properties.additionalProperties[filter1.key] !==
                                            filter1.value) {
                                        // Set the marker to not match the filters
                                        markerPassesFilters = false;
                                        // Exit the loop
                                        filterIndex = filtersLength;
                                    }
                                }
                            }
                        }
                    }
                    // If the marker passed all the filters
                    if ((!hasFilters || (hasFilters && markerPassesFilters)) &&
                        (!hasTypeFilters || (hasTypeFilters && markerPassesTypeFilters))) {
                        // Add it if it passes the filter
                        this.map.data.addGeoJson(marker1);
                        // Get the marker bounds in a google latlng object
                        const markerBounds1 = new google.maps.LatLng(marker1.geometry.coordinates[1], marker1.geometry.coordinates[0]);
                        // If the marker is inside the bounds of the map
                        if (bounds.contains(markerBounds1)) {
                            // Push the marker to the visible markers array
                            visibleMarkers.push(marker1);
                        }
                    }
                }
            }
            else {
                // Otherwise provide all markers to the map
                this.map.data.addGeoJson(this.markers);
                // Loop over all the markers
                for (let markerIndex2 = 0, markersLength2 = this.markers.features.length; markerIndex2 < markersLength2; markerIndex2++) {
                    // get a reference to the marker
                    const marker2 = this.markers.features[markerIndex2];
                    // Get the marker bounds in a google latlng object
                    const markerBounds2 = new google.maps.LatLng(marker2.geometry.coordinates[1], marker2.geometry.coordinates[0]);
                    // If the marker is inside the bounds of the map
                    if (bounds.contains(markerBounds2)) {
                        // Push the marker to the visible markers array
                        visibleMarkers.push(marker2);
                    }
                }
            }
            // console.log('addMarkers markers', this.markers);
            // console.log('addMarkers visibleMarkers', visibleMarkers);
            // if (this.customFilter && visibleMarkers && visibleMarkers.length) {
            //     visibleMarkers = visibleMarkers.filter(this.customFilter);
            // }
            // Add the marker for the users location if we have one
            if (this.userLocation)
                this.addUserLocationMarker(this.userLocation);
            // Emit the new visible markers
            this.displayedMarkers.emit(visibleMarkers);
            // Let the app know we are no longer loading
            this.loading.emit(false);
        }
    }
    // Sets the styles for the map icons
    setStyles() {
        // Set the styles for the markers
        this.map.data.setStyle(marker => {
            const markerType = marker.getProperty('type');
            // Return the correct icon for each marker type
            if (markerType === 'private bank') {
                // Return the active branch icon for private banks (no private bank markers)
                return {
                    icon: !!this.iconBranch ? this.iconBranch : this.icons.branch,
                    label: {
                        fontSize: '12px',
                        fontFamily: 'Interstate_Bold',
                        text: this.branchMarkerLabel
                    }
                };
            }
            else if (markerType === 'branch') {
                // Return the active branch icon
                return {
                    icon: !!this.iconBranch ? this.iconBranch : this.icons.branch,
                    label: {
                        fontSize: '12px',
                        fontFamily: 'Interstate_Bold',
                        text: this.branchMarkerLabel
                    }
                };
            }
            else if (markerType === 'atm') {
                // Return the ATM icon if this is a ATM marker
                return {
                    icon: !!this.iconAtm ? this.iconAtm : this.icons.atm,
                    label: {
                        fontSize: '12px',
                        fontFamily: 'Interstate_Bold',
                        text: this.atmMarkerLabel
                    }
                };
            }
            else if (markerType === 'moneypassatm') {
                // Return the MoneyPass icon if this is a MoneyPass marker
                // Update: asked to use the standard atm markers & labels for moneypass atms
                return {
                    icon: !!this.iconAtm ? this.iconAtm : this.icons.atm,
                    label: {
                        fontSize: '12px',
                        fontFamily: 'Interstate_Bold',
                        text: this.atmMarkerLabel
                    }
                };
            }
            else if (markerType === 'USERLOCATION') {
                // Return the user location icon if this is a user location marker
                return {
                    icon: !!this.iconUserLocation
                        ? this.iconUserLocation
                        : this.icons.userlocation,
                    zIndex: -1,
                    clickable: false
                };
            }
        });
    }
    // Resets the styling for the map icons
    resetStyles() {
        // Rever the map data layer styles
        this.map.data.revertStyle();
    }
    // Makes a marker active
    makeMarkerActive(marker) {
        // Reset all the styles
        this.resetStyles();
        const markerType = marker.getProperty('type');
        // Return the correct icon for this marker to be active
        if (markerType === 'private bank') {
            // Return the active branch icon for private banks
            this.map.data.overrideStyle(marker, {
                icon: !!this.iconBranchActive
                    ? this.iconBranchActive
                    : this.icons.branchActive
            });
        }
        else if (markerType === 'branch') {
            // Return the branch icon if this is a branch marker
            this.map.data.overrideStyle(marker, {
                icon: !!this.iconBranchActive
                    ? this.iconBranchActive
                    : this.icons.branchActive
            });
        }
        else if (markerType === 'atm') {
            // Return the ATM icon if this is a ATM marker
            this.map.data.overrideStyle(marker, {
                icon: !!this.iconAtmActive ? this.iconAtmActive : this.icons.atmActive
            });
        }
        else if (markerType === 'moneypassatm') {
            // Return the MoneyPass icon if this is a MoneyPass marker
            // Update: asked to use the standard atm markers & labels for moneypass atms
            this.map.data.overrideStyle(marker, {
                icon: !!this.iconAtmActive ? this.iconAtmActive : this.icons.atmActive
            });
        }
    }
    // Sets the center of the map
    setMapCenter(latlng) {
        // If we have a valid map and a latlng is defined
        if (this.map && latlng) {
            // Get the center of the map
            const center = this.map.getCenter();
            // If the center of the map is not already at the location requested
            if (latlng.lat !== center.lat() && latlng.lng !== center.lng()) {
                // Set the center of the map using latlng
                this.map.setCenter(latlng);
            }
        }
    }
    // Returns the lattitude and logitude of the center of the map in an object
    getMapCenter() {
        // Get the center of the map
        const center = this.map.getCenter;
        // Return an object with the lattitude and logitude
        return { lat: center.lat(), lng: center.lng() };
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: MapComponent, deps: [{ token: MapMarkerDataService }, { token: i0.NgZone }, { token: PLATFORM_ID }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: MapComponent, isStandalone: false, selector: "citi-map", inputs: { bounds: "bounds", locationServiceUrl: "locationServiceUrl", atmMarkerLabel: "atmMarkerLabel", apiKey: "apiKey", branchMarkerLabel: "branchMarkerLabel", moneypassMarkerLabel: "moneypassMarkerLabel", activeMarker: "activeMarker", mapCenter: "mapCenter", zoomLevel: "zoomLevel", filters: "filters", resultCount: "resultCount", radius: "radius", bodyProperties: "bodyProperties", typeFilters: "typeFilters", updateMapOnMove: "updateMapOnMove", loadLocation: "loadLocation", zoomMarkerLimit: "zoomMarkerLimit", clientId: "clientId", endpointUrl: "endpointUrl", customFilter: "customFilter", iconBranch: "iconBranch", iconBranchActive: "iconBranchActive", iconAtm: "iconAtm", iconAtmActive: "iconAtmActive", iconUserLocation: "iconUserLocation" }, outputs: { loading: "loading", boundsChange: "boundsChange", displayedMarkers: "displayedMarkers", activeMarkerChange: "activeMarkerChange", mapCenterChange: "mapCenterChange", zoomLevelChange: "zoomLevelChange", onUserLocation: "onUserLocation" }, viewQueries: [{ propertyName: "mapEl", first: true, predicate: ["map"], descendants: true }], usesOnChanges: true, ngImport: i0, template: '<div #map class="map-canvas"></div>', isInline: true, styles: [".map-canvas{width:100%;height:100%;min-height:400px}div[style^=\"height: 100px; margin-top: -50px; margin-left: -50%; display: table; border-spacing: 0\"]{margin-left:0!important}\n"], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: MapComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-map', standalone: false, template: '<div #map class="map-canvas"></div>', encapsulation: ViewEncapsulation.None, styles: [".map-canvas{width:100%;height:100%;min-height:400px}div[style^=\"height: 100px; margin-top: -50px; margin-left: -50%; display: table; border-spacing: 0\"]{margin-left:0!important}\n"] }]
        }], ctorParameters: () => [{ type: MapMarkerDataService }, { type: i0.NgZone }, { type: Object, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }], propDecorators: { mapEl: [{
                type: ViewChild,
                args: ['map']
            }], loading: [{
                type: Output
            }], bounds: [{
                type: Input$1
            }], boundsChange: [{
                type: Output
            }], locationServiceUrl: [{
                type: Input$1
            }], atmMarkerLabel: [{
                type: Input$1
            }], apiKey: [{
                type: Input$1
            }], branchMarkerLabel: [{
                type: Input$1
            }], moneypassMarkerLabel: [{
                type: Input$1
            }], displayedMarkers: [{
                type: Output
            }], activeMarker: [{
                type: Input$1
            }], activeMarkerChange: [{
                type: Output
            }], mapCenter: [{
                type: Input$1
            }], mapCenterChange: [{
                type: Output
            }], zoomLevel: [{
                type: Input$1
            }], zoomLevelChange: [{
                type: Output
            }], filters: [{
                type: Input$1
            }], resultCount: [{
                type: Input$1
            }], radius: [{
                type: Input$1
            }], bodyProperties: [{
                type: Input$1
            }], typeFilters: [{
                type: Input$1
            }], updateMapOnMove: [{
                type: Input$1
            }], loadLocation: [{
                type: Input$1
            }], zoomMarkerLimit: [{
                type: Input$1
            }], onUserLocation: [{
                type: Output
            }], clientId: [{
                type: Input$1
            }], endpointUrl: [{
                type: Input$1
            }], customFilter: [{
                type: Input$1
            }], iconBranch: [{
                type: Input$1
            }], iconBranchActive: [{
                type: Input$1
            }], iconAtm: [{
                type: Input$1
            }], iconAtmActive: [{
                type: Input$1
            }], iconUserLocation: [{
                type: Input$1
            }] } });

class CitiMap {
    static forRoot() {
        return {
            ngModule: CitiMap,
            providers: [LOCATION_PROVIDER, provideHttpClient(withInterceptorsFromDi())]
        };
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CitiMap, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: CitiMap, declarations: [MapComponent], exports: [MapComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CitiMap }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CitiMap, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [MapComponent],
                    exports: [MapComponent]
                }]
        }] });

class BreadcrumbComponent {
    constructor() {
        /**
         * @property links
         * @description List of links for the breadcrumb
         * @Type: Array
         */
        this.links = [];
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: BreadcrumbComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: BreadcrumbComponent, isStandalone: false, selector: "citi-breadcrumb", inputs: { currentText: "currentText", links: "links" }, ngImport: i0, template: `
  <nav aria-label="Breadcrumb">
    <ol class="breadcrumb">
      <li *ngFor="let link of links; index as i">
        <a *ngIf="!link.routerLink" href="{{link.href}}" [innerHtml]="link.text"></a>
        <a *ngIf="link.routerLink" [routerLink]="link.routerLink" [innerHtml]="link.text" [attr.aria-current]="!currentText && links.length - 1 === i ? 'page' : null"></a>
      </li>
      <li *ngIf="currentText"><span aria-current="page" [innerHtml]="currentText"></span></li>
    </ol>
  </nav>
  `, isInline: true, styles: [".breadcrumb{padding:8px 15px;margin-bottom:24px;list-style:none;border-radius:6px;background-color:transparent}.breadcrumb li{display:inline-block;font-size:14px}ol.breadcrumb{margin:0 0 25px;padding:8px 15px}ol.breadcrumb>li:before{padding:0 5px;position:static!important;content:\"\";counter-increment:initial}.breadcrumb>li+li:before{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8.02 14'%3E%3Ctitle%3E04-glyph-right-white%3C/title%3E%3Cpath d='M17,27a1,1,0,0,1-.68-1.73L22,20l-5.66-5.27a1,1,0,0,1,1.36-1.46l5.72,5.32a1.91,1.91,0,0,1,0,2.82l-5.72,5.32A1,1,0,0,1,17,27' transform='translate(-15.99 -13)' style='fill:%23666;fill-rule:evenodd'/%3E%3C/svg%3E\");content:\"\";margin:0 10px;height:10px;width:8px;display:inline-block;background-repeat:no-repeat}.active{color:#ccc}a,a:hover,a:focus{text-decoration:underline}a[aria-current=page]{color:#333}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "info", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: BreadcrumbComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-breadcrumb', standalone: false, template: `
  <nav aria-label="Breadcrumb">
    <ol class="breadcrumb">
      <li *ngFor="let link of links; index as i">
        <a *ngIf="!link.routerLink" href="{{link.href}}" [innerHtml]="link.text"></a>
        <a *ngIf="link.routerLink" [routerLink]="link.routerLink" [innerHtml]="link.text" [attr.aria-current]="!currentText && links.length - 1 === i ? 'page' : null"></a>
      </li>
      <li *ngIf="currentText"><span aria-current="page" [innerHtml]="currentText"></span></li>
    </ol>
  </nav>
  `, changeDetection: ChangeDetectionStrategy.OnPush, styles: [".breadcrumb{padding:8px 15px;margin-bottom:24px;list-style:none;border-radius:6px;background-color:transparent}.breadcrumb li{display:inline-block;font-size:14px}ol.breadcrumb{margin:0 0 25px;padding:8px 15px}ol.breadcrumb>li:before{padding:0 5px;position:static!important;content:\"\";counter-increment:initial}.breadcrumb>li+li:before{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8.02 14'%3E%3Ctitle%3E04-glyph-right-white%3C/title%3E%3Cpath d='M17,27a1,1,0,0,1-.68-1.73L22,20l-5.66-5.27a1,1,0,0,1,1.36-1.46l5.72,5.32a1.91,1.91,0,0,1,0,2.82l-5.72,5.32A1,1,0,0,1,17,27' transform='translate(-15.99 -13)' style='fill:%23666;fill-rule:evenodd'/%3E%3C/svg%3E\");content:\"\";margin:0 10px;height:10px;width:8px;display:inline-block;background-repeat:no-repeat}.active{color:#ccc}a,a:hover,a:focus{text-decoration:underline}a[aria-current=page]{color:#333}\n"] }]
        }], propDecorators: { currentText: [{
                type: Input$1
            }], links: [{
                type: Input$1
            }] } });

const MODULES$W = [
    CommonModule,
    FormsModule,
    RouterModule
];
class Breadcrumb {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Breadcrumb, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: Breadcrumb, declarations: [BreadcrumbComponent], imports: [CommonModule,
            FormsModule,
            RouterModule], exports: [BreadcrumbComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Breadcrumb, imports: [MODULES$W] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Breadcrumb, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$W],
                    declarations: [BreadcrumbComponent],
                    exports: [BreadcrumbComponent]
                }]
        }] });

let nextUniqueId$b = 0;
/**
 * @Component: Pagination
 * @description Automated generation of consecutive numbers to
 * identify the sequential order of pages
 */
class PaginationItem {
    constructor(number, isActive, isEllipsis, ellipsisPosition, hideEllipsis, id, ariaLabel) {
        this.ellipsisPosition = 'alter-front | alter-back | default';
        this.number = number;
        this.isActive = isActive;
        this.isEllipsis = isEllipsis;
        this.ellipsisPosition = ellipsisPosition;
        this.hideEllipsis = hideEllipsis;
        this.id = id;
        this.ariaLabel = ariaLabel;
    }
}
class Ellipses {
    constructor(front, back) {
        this.front = front;
        this.back = back;
    }
}
class PaginationComponent {
    get activePageID() {
        return this._id;
    }
    set activePageID(value) {
        this._id = value || this._uid;
    }
    constructor(_announcer, el, _ngZone, _navigator) {
        this._announcer = _announcer;
        this.el = el;
        this._ngZone = _ngZone;
        this._navigator = _navigator;
        this.visibleEllipsis = new PaginationItem(null, null, true, 'default', false, null, null);
        this.hiddenEllipsis = new PaginationItem(null, null, true, 'default', true, null, null);
        this.mobileFrontHiddenEllipsis = new PaginationItem(null, null, true, 'alter-front', true, null, null);
        this.mobileEndHiddenEllipsis = new PaginationItem(null, null, true, 'alter-back', true, null, null);
        this.pages = [];
        this.disablePrevButton = false;
        this.disableNextButton = false;
        this._isNavButtonClicked = false;
        this.class = 'citi-pagination';
        /**
         * @property ariaLabelPrefix
         * @description Pagination label prefix string for screen reader
         * @return string
         */
        this.ariaLabelPrefix = 'Page';
        /**
         * @property prevAriaLabel
         * @description Previous button label string for screen reader
         * @return string
         */
        this.prevAriaLabel = 'Previous';
        /**
         * @property nextAriaLabel
         * @description Next button label string for screen reader
         * @return string
         */
        this.nextAriaLabel = 'Next';
        this._uid = `citi-pagination-${nextUniqueId$b++}`;
        /**
         * @name activePageNumberChange
         * @description Emitted when a page in the pagination is active
         * @return Object
         * @Type: EventEmitter<number>
         */
        this.activePageNumberChange = new EventEmitter();
        /**
         * @property showNavigationButtons
         * @description Option to show previous/next button when page is less than 10
         * @Type: boolean
         */
        this.showNavigationButtons = false;
    }
    ngOnInit() {
        this.activePageID = this.activePageID;
    }
    ngOnChanges() {
        this.generatePages();
    }
    generatePages() {
        if (this.pageCount <= 0) {
            return new Error('Pagination configuration not accounted for.');
        }
        this.pages = this.sequentialPages;
        this.disablePrevButton = this.activePageNumber === 1;
        this.disableNextButton = this.activePageNumber === +this.pageCount;
        const ellipses = this.paginationEllipses;
        this.pages = [
            this.firstPageItem,
            ellipses.front,
            ...this.internalPagesItem(this.pages),
            ellipses.back,
            this.lastPageItem
        ].filter(page => page != null);
    }
    get sequentialPages() {
        return Array.apply(null, { length: this.pageCount }).map((val, index) => new PaginationItem(index + 1, // (display) number
        this.activePageNumber === index + 1, // isActive
        false, // isEllipsis
        'default', // ellipsisPosition
        false, // hideEllipsis
        `page-${index + 1}`, // id
        `${this.pageAriaLabel(this.activePageNumber === index + 1)} ${index +
            1} of ${this.pageCount}` // ariaLabel
        ));
    }
    get isButtonDisabledAndClicked() {
        return (this._isNavButtonClicked &&
            (this.activePageNumber === 1 || this.activePageNumber === +this.pageCount));
    }
    pageAriaLabel(isActive) {
        return isActive ? `current ${this.ariaLabelPrefix}` : this.ariaLabelPrefix;
    }
    hideNavButtons() {
        return this.pageCount < 10 && !this.showNavigationButtons;
    }
    get firstPageItem() {
        return this.pages[0];
    }
    get lastPageItem() {
        return this.pageCount > 1 ? this.pages[this.pageCount - 1] : null;
    }
    internalPagesItem(totalPages) {
        const internalPageItems = totalPages.slice(1, -1);
        console.log(internalPageItems);
        if (totalPages.length < 8)
            return internalPageItems;
        else if (this.activePageNumber <= 5)
            return internalPageItems.filter(page => page.number <= 5);
        else if (this.isCurrentLocationGreaterThanPage5 &&
            this.isCurrentLocationLessThan5PagesAway)
            return internalPageItems.splice(-4);
        else if (this.isCurrentLocationGreaterThanPage5)
            return internalPageItems.filter(page => page.number >= this.activePageNumber - 1 &&
                page.number <= this.activePageNumber + 1);
        else
            throw new Error('Pagination configuration not accounted for.');
    }
    get paginationEllipses() {
        if (this.pageCount < 8)
            return new Ellipses(this.mobileFrontHiddenEllipsis, this.mobileEndHiddenEllipsis);
        else if (this.activePageNumber <= 5)
            return new Ellipses(this.hiddenEllipsis, this.visibleEllipsis);
        else if (this.isCurrentLocationGreaterThanPage5 &&
            this.isCurrentLocationLessThan5PagesAway)
            return new Ellipses(this.visibleEllipsis, this.hiddenEllipsis);
        else if (this.isCurrentLocationGreaterThanPage5)
            return new Ellipses(this.visibleEllipsis, this.visibleEllipsis);
        else
            throw new Error('Pagination configuration not accounted for.');
    }
    get isCurrentLocationGreaterThanPage5() {
        return this.activePageNumber > 5;
    }
    get isCurrentLocationLessThan5PagesAway() {
        return this.pageCount - this.activePageNumber < 5;
    }
    get isCurrentLocationLessThan3PagesAway() {
        return this.pageCount - this.activePageNumber < 3;
    }
    get isCurrentLocationGreaterThanPage3() {
        return this.activePageNumber > 3;
    }
    arrowClick(index) {
        const currentPage = this.activePageNumber + index;
        let announceString;
        if (currentPage === 1) {
            announceString = `current ${this.ariaLabelPrefix} is ${currentPage} of ${this.pageCount} first page`;
        }
        else if (currentPage === this.pageCount) {
            announceString = `current ${this.ariaLabelPrefix} is ${currentPage} of ${this.pageCount} last page`;
        }
        else {
            announceString = `current ${this.ariaLabelPrefix} is ${currentPage} of ${this.pageCount}`;
        }
        if (currentPage < 1) {
            this._announcer.announce(`${this.prevAriaLabel} button unavailable`);
            return;
        }
        else if (currentPage > this.pageCount) {
            this._announcer.announce(`${this.nextAriaLabel} button unavailable`);
            return;
        }
        else {
            this._announcer.announce(announceString);
            this.setActivePage(currentPage, true);
            return;
        }
    }
    arrowFocus(index, pageLabel) {
        const currentPage = this.activePageNumber + index;
        if (currentPage >= 1 && currentPage <= this.pageCount) {
            setTimeout(() => {
                this._announcer.announce(pageLabel);
            }, 100);
        }
    }
    pageClick(currentPage) {
        this.setActivePage(currentPage);
        this.reCastFocus();
    }
    setActivePage(currentPage, isNavButtonClicked = false) {
        this.activePageNumber = currentPage;
        this.activePageNumberChange.emit(this.activePageNumber);
        this._isNavButtonClicked = isNavButtonClicked;
        if ((!this.isAndroidDevice && !this.isiOSDevice) ||
            this._isNavButtonClicked) {
            //prevent iOSDevice and Android device from announcing page twices
            this.announceNewCurrent();
        }
    }
    announceNewCurrent() {
        setTimeout(() => {
            this._announcer.announce(`current ${this.ariaLabelPrefix} is ${this.activePageNumber} of ${this.pageCount}`);
        }, 100);
    }
    /**
     * In Mobile, pagination only shows the first 3 pages or the last 3 pages (1,2,3...10 or 1...8,9,10)
     * If current page greater than 3 and less than the last 3 pages then pagination only shows the (1...5..10)
     * If there are more than 6 pages, show ellipses
     */
    hidePageInMobile(page) {
        if (this.pageCount <= 6)
            return false;
        return !this.visiblePages(page) && this.shouldHidePage(page);
    }
    displayHiddenEllipsis() {
        return (this.isCurrentLocationGreaterThanPage5 &&
            !this.isCurrentLocationLessThan5PagesAway);
    }
    visiblePages(page) {
        return (page === this.activePageNumber || page === 1 || page === +this.pageCount);
    }
    shouldHidePage(page) {
        return ((this.isCurrentLocationGreaterThanPage3 || page > 3) &&
            (!this.isCurrentLocationLessThan3PagesAway || this.pageCount - page >= 3));
    }
    hideNavButtonsMobile() {
        return this.pageCount < 7 && !this.showNavigationButtons;
    }
    hideEllipsis(isHiddenEllipsis, ellipsisPosition) {
        return this.pageCount < 10 && this.pageCount > 6
            ? this.hideEllipsIfUnder10Pages(isHiddenEllipsis, ellipsisPosition)
            : isHiddenEllipsis && !this.displayHiddenEllipsis();
    }
    hideEllipsIfUnder10Pages(isHiddenEllipsis, ellipsisPosition) {
        return (this.isCurrentLocationLessThan3PagesAway &&
            ellipsisPosition === 'alter-front') ||
            (!this.isCurrentLocationGreaterThanPage3 &&
                ellipsisPosition === 'alter-back')
            ? false
            : isHiddenEllipsis && !this.displayHiddenEllipsis();
    }
    get isAndroidDevice() {
        if (!this._navigator || !this._navigator.userAgent)
            return false;
        else
            return /(android)/i.test(this._navigator.userAgent);
    }
    get isiOSDevice() {
        if (!this._navigator || !this._navigator.userAgent)
            return false;
        else
            return (!!this._navigator.platform &&
                /(iPad|iPhone|iPod)/i.test(this._navigator.userAgent));
    }
    reCastFocus() {
        executeOnStable(this._ngZone, () => this.el.nativeElement.querySelector('.active').focus());
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: PaginationComponent, deps: [{ token: CitiLiveAnnouncer }, { token: i0.ElementRef }, { token: i0.NgZone }, { token: NAVIGATOR }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: PaginationComponent, isStandalone: false, selector: "citi-pagination", inputs: { ariaLabelPrefix: "ariaLabelPrefix", prevAriaLabel: "prevAriaLabel", nextAriaLabel: "nextAriaLabel", activePageNumber: "activePageNumber", activePageID: "activePageID", showNavigationButtons: "showNavigationButtons", pageCount: "pageCount" }, outputs: { activePageNumberChange: "activePageNumberChange" }, host: { properties: { "class": "this.class" } }, usesOnChanges: true, ngImport: i0, template: `
    <nav aria-label="Pagination">
      <ul class="pagination">
        <li>
          <!-- Previous Button-->
          <button
            [attr.aria-label]="!disablePrevButton ? prevAriaLabel: prevAriaLabel + ' ' + 'button unavailable'"
            [attr.id]="_id + '-prev-button'"
            [attr.tabIndex]="!disablePrevButton ?0 : -1"
            [ngClass]="{
              previousButtonIcon: true,
              disabled: disablePrevButton,
              'hidden-lg': hideNavButtons(),
              'hidden-xs': hideNavButtonsMobile()
            }"
            (click)="arrowClick(-1)"
            (focus) = "arrowFocus(1)"
            >
            <citi-icon2
              name="255-chevron-left"
              [svgStyle]="{ 'width.px': 30, 'height.px': 30 }"
              [includeCircle]="true"
              shade="dark"
              ariaLabel="icon"
            >
            </citi-icon2>
          </button>
        </li>

        <ng-container *ngFor="let page of pages">
          <!-- Both Ellipses -->
          <li
            class="page-ellipsis"
            *ngIf="page.isEllipsis"
            [ngClass]="{
              'hidden-lg': page.hideEllipsis,
              'hidden-xs': hideEllipsis(
                page.hideEllipsis,
                page.ellipsisPosition
              )
            }"
          >
            &#8230;
          </li>

          <!-- All Page Items-->
          <li
            class="page-item"
            *ngIf="page.number"
            (click)="pageClick(page.number)"
          >
            <a
              href="javascript:;"
              [attr.aria-label]="(page.number) === 1? page.ariaLabel + ' first page' : (page.number) === pageCount? page.ariaLabel + ' last page' : page.ariaLabel"
              [attr.id]="page.isActive ? _id : null"
              [ngClass]="{
                active: page.isActive,
                'hidden-xs': hideEllipsis(
                page.hideEllipsis,
                page.ellipsisPosition
              )
              }"
            >
              {{ page.number | number: '2.0' }}
            </a>
          </li>
        </ng-container>

        <!-- Next Button-->
        <li>
          <button
            [attr.aria-label]="!disableNextButton ? nextAriaLabel: nextAriaLabel + ' ' + 'button unavailable'"
            [attr.id]="_id + '-next-button'"
            [attr.tabIndex]="!disableNextButton ?0 : -1"
            [ngClass]="{
              nextButtonIcon: true,
              disabled: disableNextButton,
              'hidden-lg': hideNavButtons(),
              'hidden-xs': hideNavButtonsMobile()
            }"
            (click)="arrowClick(1)"
            (focus) = "arrowFocus(1)"
          >
            <citi-icon2
              name="257-chevron-right"
              [svgStyle]="{ 'width.px': 30, 'height.px': 30 }"
              [includeCircle]="true"
              shade="dark"
              ariaLabel="icon"
            >
            </citi-icon2>
          </button>
        </li>
      </ul>
    </nav>
  `, isInline: true, styles: [":host{display:block}.previousButtonIcon ::ng-deep circle,.nextButtonIcon ::ng-deep circle{fill:#056dae!important}.previousButtonIcon ::ng-deep circle:hover,.previousButtonIcon ::ng-deep circle:focus,.nextButtonIcon ::ng-deep circle:hover,.nextButtonIcon ::ng-deep circle:focus{fill:#002a54!important}.previousButtonIcon.disabled ::ng-deep circle,.nextButtonIcon.disabled ::ng-deep circle{fill:#767676!important}.previousButtonIcon,.nextButtonIcon{border:none;margin:0;padding:0;height:30px;background-color:unset}.pagination{display:inline-block;padding-left:0;margin:24px 0;border-radius:6px}.pagination>li{display:inline}.pagination>li>a{min-height:30px;min-width:38px;position:relative;float:left;text-decoration:none;color:#056dae;margin-left:-1px;font-family:Interstate_Light,sans-serif}.pagination>li>a:focus,.pagination>li>a:hover{color:#002a54}.pagination>li>a.active{font-family:Interstate_Bold,sans-serif;color:#000;cursor:default;pointer-events:none}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: Icon2Component, selector: "citi-icon2", inputs: ["role", "idStr", "ariaLabel", "ariaHidden", "size", "isHoverSfi", "includeCircle", "type", "svgStyle", "tabIndex", "shade", "name"] }, { kind: "pipe", type: i1$1.DecimalPipe, name: "number" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: PaginationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-pagination', standalone: false, template: `
    <nav aria-label="Pagination">
      <ul class="pagination">
        <li>
          <!-- Previous Button-->
          <button
            [attr.aria-label]="!disablePrevButton ? prevAriaLabel: prevAriaLabel + ' ' + 'button unavailable'"
            [attr.id]="_id + '-prev-button'"
            [attr.tabIndex]="!disablePrevButton ?0 : -1"
            [ngClass]="{
              previousButtonIcon: true,
              disabled: disablePrevButton,
              'hidden-lg': hideNavButtons(),
              'hidden-xs': hideNavButtonsMobile()
            }"
            (click)="arrowClick(-1)"
            (focus) = "arrowFocus(1)"
            >
            <citi-icon2
              name="255-chevron-left"
              [svgStyle]="{ 'width.px': 30, 'height.px': 30 }"
              [includeCircle]="true"
              shade="dark"
              ariaLabel="icon"
            >
            </citi-icon2>
          </button>
        </li>

        <ng-container *ngFor="let page of pages">
          <!-- Both Ellipses -->
          <li
            class="page-ellipsis"
            *ngIf="page.isEllipsis"
            [ngClass]="{
              'hidden-lg': page.hideEllipsis,
              'hidden-xs': hideEllipsis(
                page.hideEllipsis,
                page.ellipsisPosition
              )
            }"
          >
            &#8230;
          </li>

          <!-- All Page Items-->
          <li
            class="page-item"
            *ngIf="page.number"
            (click)="pageClick(page.number)"
          >
            <a
              href="javascript:;"
              [attr.aria-label]="(page.number) === 1? page.ariaLabel + ' first page' : (page.number) === pageCount? page.ariaLabel + ' last page' : page.ariaLabel"
              [attr.id]="page.isActive ? _id : null"
              [ngClass]="{
                active: page.isActive,
                'hidden-xs': hideEllipsis(
                page.hideEllipsis,
                page.ellipsisPosition
              )
              }"
            >
              {{ page.number | number: '2.0' }}
            </a>
          </li>
        </ng-container>

        <!-- Next Button-->
        <li>
          <button
            [attr.aria-label]="!disableNextButton ? nextAriaLabel: nextAriaLabel + ' ' + 'button unavailable'"
            [attr.id]="_id + '-next-button'"
            [attr.tabIndex]="!disableNextButton ?0 : -1"
            [ngClass]="{
              nextButtonIcon: true,
              disabled: disableNextButton,
              'hidden-lg': hideNavButtons(),
              'hidden-xs': hideNavButtonsMobile()
            }"
            (click)="arrowClick(1)"
            (focus) = "arrowFocus(1)"
          >
            <citi-icon2
              name="257-chevron-right"
              [svgStyle]="{ 'width.px': 30, 'height.px': 30 }"
              [includeCircle]="true"
              shade="dark"
              ariaLabel="icon"
            >
            </citi-icon2>
          </button>
        </li>
      </ul>
    </nav>
  `, changeDetection: ChangeDetectionStrategy.OnPush, styles: [":host{display:block}.previousButtonIcon ::ng-deep circle,.nextButtonIcon ::ng-deep circle{fill:#056dae!important}.previousButtonIcon ::ng-deep circle:hover,.previousButtonIcon ::ng-deep circle:focus,.nextButtonIcon ::ng-deep circle:hover,.nextButtonIcon ::ng-deep circle:focus{fill:#002a54!important}.previousButtonIcon.disabled ::ng-deep circle,.nextButtonIcon.disabled ::ng-deep circle{fill:#767676!important}.previousButtonIcon,.nextButtonIcon{border:none;margin:0;padding:0;height:30px;background-color:unset}.pagination{display:inline-block;padding-left:0;margin:24px 0;border-radius:6px}.pagination>li{display:inline}.pagination>li>a{min-height:30px;min-width:38px;position:relative;float:left;text-decoration:none;color:#056dae;margin-left:-1px;font-family:Interstate_Light,sans-serif}.pagination>li>a:focus,.pagination>li>a:hover{color:#002a54}.pagination>li>a.active{font-family:Interstate_Bold,sans-serif;color:#000;cursor:default;pointer-events:none}\n"] }]
        }], ctorParameters: () => [{ type: CitiLiveAnnouncer }, { type: i0.ElementRef }, { type: i0.NgZone }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [NAVIGATOR]
                }] }], propDecorators: { class: [{
                type: HostBinding,
                args: ['class']
            }], ariaLabelPrefix: [{
                type: Input$1
            }], prevAriaLabel: [{
                type: Input$1
            }], nextAriaLabel: [{
                type: Input$1
            }], activePageNumber: [{
                type: Input$1
            }], activePageID: [{
                type: Input$1
            }], activePageNumberChange: [{
                type: Output
            }], showNavigationButtons: [{
                type: Input$1
            }], pageCount: [{
                type: Input$1
            }] } });

const COMPONENTS$W = [PaginationComponent];
class Pagination {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Pagination, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: Pagination, declarations: [PaginationComponent], imports: [CommonModule, Icons2], exports: [PaginationComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Pagination, providers: [NAVIGATOR_PROVIDER], imports: [CommonModule, Icons2] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Pagination, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, Icons2],
                    providers: [NAVIGATOR_PROVIDER],
                    declarations: [...COMPONENTS$W],
                    exports: [...COMPONENTS$W]
                }]
        }] });

class ProgressBar2Component {
    constructor(liveAnnouncer) {
        this.liveAnnouncer = liveAnnouncer;
        this.ariaLabel = '';
        this.currentStep = 1;
        this.currentStepChange = new EventEmitter();
        this.totalSteps = 2;
        this.stepText = 'Step';
        this.ofText = 'of';
        this.nextText = 'Next';
        this.optionalText = '';
        this.nextStepNum = true;
    }
    ngOnInit() {
        this.updateStep();
    }
    ngOnChanges() {
        this.updateStep();
    }
    announce() {
        this.liveAnnouncer.announce(this.ariaLabel);
    }
    previous() {
        this.setCurrentStep(this.currentStep - 1);
    }
    next() {
        this.setCurrentStep(this.currentStep + 1);
    }
    setCurrentStep(stepNumber) {
        this.currentStep = stepNumber;
        this.updateStep();
    }
    currentStepLimit(stepNumber) {
        return stepNumber <= 1 ? 1 : (stepNumber >= this.totalSteps ? this.totalSteps : stepNumber);
    }
    updateStep() {
        // Make sure totalSteps is valid
        this.totalSteps = this.totalSteps < 2 ? 2 : this.totalSteps;
        // Make sure currentStep is valid
        this.currentStep = this.currentStepLimit(this.currentStep);
        // Sets nextStep. Needs to be null if on last step.
        this.nextStep = this.currentStep >= this.totalSteps ? null : this.currentStep + 1;
        // Sets percent of progress bar
        this.stepPercent = Math.round((this.currentStep / this.totalSteps) * 100);
        // Sets aria text to be read (strips out HTML tags for screen readers)
        this.ariaLabel = `${this.stepText} ${this.currentStep} ${this.ofText} ${this.totalSteps}`;
        this.ariaLabel += this.optionalText ? `. ${this.optionalText.replace(/<\/?[^>]+(>|$)/g, '')}` : '';
        // Emit Change
        this.currentStepChange.emit(this.currentStep);
        this.announce();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ProgressBar2Component, deps: [{ token: CitiLiveAnnouncer }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: ProgressBar2Component, isStandalone: false, selector: "citi-progress-bar2", inputs: { currentStep: "currentStep", totalSteps: "totalSteps", stepText: "stepText", ofText: "ofText", nextText: "nextText", optionalText: "optionalText", nextStepNum: "nextStepNum" }, outputs: { currentStepChange: "currentStepChange" }, usesOnChanges: true, ngImport: i0, template: `
		<div><ng-content select="[staticContent]"></ng-content></div>
		<div class="text-flex" *ngIf="nextStepNum">
			<div class="step-title">{{stepText}} {{currentStep}} {{ofText}} {{totalSteps}}</div>
			<div class="step-optional" [innerHTML]="optionalText"></div>
			<div class="step-next" *ngIf="nextStep">{{nextText}}: [{{stepText}} {{nextStep}}]</div>
		</div>
		<div class="progress">
			<!-- was previously role="progressbar" but instructed by Deque to make role="presentation" -->
			<div class="progress-bar"
			aria-hidden="true"
			role="presentation"
			[attr.aria-valuemin]="1"
			[attr.aria-valuemax]="totalSteps"
			[attr.aria-valuenow]="currentStep"
			[style.width.%]="stepPercent">
				<span class="sr-only">{{ariaLabel}}</span>
			</div>
		</div>
	`, isInline: true, styles: [".progress{overflow:hidden;height:10px;margin-bottom:21px;background-color:#ccc;border-radius:0}.progress-bar{float:left;width:0%;height:100%;font-size:.75rem;line-height:21px;color:#fff;text-align:center;background-color:#056dae}.progress{box-shadow:none}.progress-bar{transition:none}.text-flex{display:flex;line-height:1.85rem;flex-wrap:wrap}.step-title{font-size:1.25rem}.step-optional{font-style:italic;margin-left:20px}.step-next{margin-left:auto}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ProgressBar2Component, decorators: [{
            type: Component,
            args: [{ selector: 'citi-progress-bar2', standalone: false, template: `
		<div><ng-content select="[staticContent]"></ng-content></div>
		<div class="text-flex" *ngIf="nextStepNum">
			<div class="step-title">{{stepText}} {{currentStep}} {{ofText}} {{totalSteps}}</div>
			<div class="step-optional" [innerHTML]="optionalText"></div>
			<div class="step-next" *ngIf="nextStep">{{nextText}}: [{{stepText}} {{nextStep}}]</div>
		</div>
		<div class="progress">
			<!-- was previously role="progressbar" but instructed by Deque to make role="presentation" -->
			<div class="progress-bar"
			aria-hidden="true"
			role="presentation"
			[attr.aria-valuemin]="1"
			[attr.aria-valuemax]="totalSteps"
			[attr.aria-valuenow]="currentStep"
			[style.width.%]="stepPercent">
				<span class="sr-only">{{ariaLabel}}</span>
			</div>
		</div>
	`, styles: [".progress{overflow:hidden;height:10px;margin-bottom:21px;background-color:#ccc;border-radius:0}.progress-bar{float:left;width:0%;height:100%;font-size:.75rem;line-height:21px;color:#fff;text-align:center;background-color:#056dae}.progress{box-shadow:none}.progress-bar{transition:none}.text-flex{display:flex;line-height:1.85rem;flex-wrap:wrap}.step-title{font-size:1.25rem}.step-optional{font-style:italic;margin-left:20px}.step-next{margin-left:auto}\n"] }]
        }], ctorParameters: () => [{ type: CitiLiveAnnouncer }], propDecorators: { currentStep: [{
                type: Input$1
            }], currentStepChange: [{
                type: Output
            }], totalSteps: [{
                type: Input$1
            }], stepText: [{
                type: Input$1
            }], ofText: [{
                type: Input$1
            }], nextText: [{
                type: Input$1
            }], optionalText: [{
                type: Input$1
            }], nextStepNum: [{
                type: Input$1
            }] } });

const COMPONENTS$V = [ProgressBar2Component];
class ProgressBar2 {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ProgressBar2, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: ProgressBar2, declarations: [ProgressBar2Component], imports: [CommonModule], exports: [ProgressBar2Component] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ProgressBar2, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ProgressBar2, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [...COMPONENTS$V],
                    exports: [...COMPONENTS$V]
                }]
        }] });

class ButtonBarComponent {
    constructor() {
        this.leftHidden = true;
        this.rightHidden = true;
        /**
         * @property horizontalRule
         * @description Adds horizontal-rule class
         * @Type: boolean
         */
        this.horizontalRule = false;
        /**
         * @property links
         * @description List of links for the button bar
         * @Type: Array
         */
        this.links = [];
        if (isDevMode()) {
            console.error('%cThe Common UI DDL ButtonBar <citi-button-bar> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    ngOnInit() {
        if (this.links.length > 6) {
            this.links.splice(6, this.links.length);
        }
    }
    /**
     * @name isFullyScrolled
     * @description Checks if div is scrolled completely in mobile view
     * @return Boolean
     */
    isFullyScrolled() {
        return this.scroller.nativeElement.scrollLeft + this.scroller.nativeElement.offsetWidth >= this.scroller.nativeElement.scrollWidth;
    }
    /**
     * @name isNotScrolled
     * @description Checks if div is not scrolled in mobile view
     * @return Boolean
     */
    isNotScrolled() {
        return this.scroller.nativeElement.scrollLeft == 0;
    }
    /**
     * @name checkScroll
     * @description Checks if div is not scrolled in mobile view
     * @return Boolean
     */
    checkScroll() {
        this.leftHidden = this.isNotScrolled();
        this.rightHidden = this.isFullyScrolled();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ButtonBarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: ButtonBarComponent, isStandalone: false, selector: "citi-button-bar", inputs: { horizontalRule: "horizontalRule", links: "links" }, viewQueries: [{ propertyName: "scroller", first: true, predicate: ["scroller"], descendants: true }], ngImport: i0, template: `


        <div id="scroller"
          class="btn-group flexible line-delinated"
          [ngClass]="{'horizontal-rule' : horizontalRule==true}"
          role="group"
          (scroll)="checkScroll()">

          <span *ngFor="let link of links">
            <a class="btn btn-link" *ngIf="!link.routerLink" href="{{link.href}}" [innerHtml]="link.text"></a>
            <a class="btn btn-link" *ngIf="link.routerLink" routerLink="{{link.routerLink}}" [innerHtml]="link.text"></a>
          </span>

        </div>

        <div class="mobile-scroller">

          <div class="paddle left-paddle" [ngClass]="{'hidden' : leftHidden==true }">
            <span><span class="arrow"><</span></span>
              <span class="fader"></span>
          </div>

          <div class="paddle right-paddle" [ngClass]="{'hidden' : rightHidden==false }">
            <span><span class="arrow">></span></span>
            <span class="fader"> </span>
          </div>

        </div>


  `, isInline: true, dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "info", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ButtonBarComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'citi-button-bar',
                    standalone: false,
                    template: `


        <div id="scroller"
          class="btn-group flexible line-delinated"
          [ngClass]="{'horizontal-rule' : horizontalRule==true}"
          role="group"
          (scroll)="checkScroll()">

          <span *ngFor="let link of links">
            <a class="btn btn-link" *ngIf="!link.routerLink" href="{{link.href}}" [innerHtml]="link.text"></a>
            <a class="btn btn-link" *ngIf="link.routerLink" routerLink="{{link.routerLink}}" [innerHtml]="link.text"></a>
          </span>

        </div>

        <div class="mobile-scroller">

          <div class="paddle left-paddle" [ngClass]="{'hidden' : leftHidden==true }">
            <span><span class="arrow"><</span></span>
              <span class="fader"></span>
          </div>

          <div class="paddle right-paddle" [ngClass]="{'hidden' : rightHidden==false }">
            <span><span class="arrow">></span></span>
            <span class="fader"> </span>
          </div>

        </div>


  `,
                    changeDetection: ChangeDetectionStrategy.OnPush
                }]
        }], ctorParameters: () => [], propDecorators: { scroller: [{
                type: ViewChild,
                args: ['scroller']
            }], horizontalRule: [{
                type: Input$1
            }], links: [{
                type: Input$1
            }] } });

const MODULES$V = [
    CommonModule,
    FormsModule,
    RouterModule
];
class ButtonBar {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ButtonBar, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: ButtonBar, declarations: [ButtonBarComponent], imports: [CommonModule,
            FormsModule,
            RouterModule], exports: [ButtonBarComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ButtonBar, imports: [MODULES$V] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ButtonBar, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$V],
                    declarations: [ButtonBarComponent],
                    exports: [ButtonBarComponent]
                }]
        }] });

let nextId$8 = 0;
/**
 * @Component: Nav Tab
 * @Section: Navigation
 * @description This is the nav tab component and is used to create tab in the nav group
 * from Bootstrap.
*/
class NavTab2Component {
    /**
     * @property isActive
     * @description Sets current tab as active or inactive
     * @returns boolean
     */
    set isActive(isActive) {
        this.isNavTabActive = isActive;
        this.cdr.markForCheck();
    }
    get isActive() {
        return this.isNavTabActive;
    }
    constructor(cdr) {
        this.cdr = cdr;
        this.isNavTabActive = false;
        this.isFocused = false;
        this.groupHostId = '';
        if (isDevMode()) {
            console.error('%cThe Common UI DDL InPageNavigation2 <citi-nav-tab2> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
        this.hostId = `nav-tab-${nextId$8++}`;
        this.keyboardFocused = false;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: NavTab2Component, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: NavTab2Component, isStandalone: false, selector: "citi-nav-tab2, [citi-nav-tab2]", inputs: { label: "label", isActive: "isActive" }, host: { properties: { "class.nav-tab-panel-active": "this.isNavTabActive", "attr.id": "this.hostId" }, classAttribute: "citi-nav-tab2" }, ngImport: i0, template: `
  <div
    role="tabpanel"
    [attr.id]="hostId + '-tabpanel'"
    [attr.aria-labelledby]="groupHostId + '-' + hostId"
    [ngClass]="{'nav-tab-panel-active': isNavTabActive }"
    class="nav-tab-panel">
    <ng-content></ng-content>
  </div>
  `, isInline: true, styles: [":host .nav-tab-panel{display:none;position:relative;visibility:hidden;z-index:2}:host .nav-tab-panel.nav-tab-panel-active{display:block;visibility:visible}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: NavTab2Component, decorators: [{
            type: Component,
            args: [{ selector: 'citi-nav-tab2, [citi-nav-tab2]', standalone: false, template: `
  <div
    role="tabpanel"
    [attr.id]="hostId + '-tabpanel'"
    [attr.aria-labelledby]="groupHostId + '-' + hostId"
    [ngClass]="{'nav-tab-panel-active': isNavTabActive }"
    class="nav-tab-panel">
    <ng-content></ng-content>
  </div>
  `, changeDetection: ChangeDetectionStrategy.OnPush, host: {
                        'class': 'citi-nav-tab2'
                    }, styles: [":host .nav-tab-panel{display:none;position:relative;visibility:hidden;z-index:2}:host .nav-tab-panel.nav-tab-panel-active{display:block;visibility:visible}\n"] }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }], propDecorators: { isNavTabActive: [{
                type: HostBinding,
                args: ['class.nav-tab-panel-active']
            }], hostId: [{
                type: HostBinding,
                args: ['attr.id']
            }], label: [{
                type: Input$1
            }], isActive: [{
                type: Input$1
            }] } });

class OptionsComponent {
    set value(value) {
        if (typeof value === 'number')
            value = value.toString();
        this._value = value;
    }
    get value() {
        return this._value;
    }
    // #endregion
    // #region // ----------------------- Constructor / Lifecycle Hooks ----------------------- //
    constructor() {
        // #region // ----------------------- Properties ----------------------- //
        //displayed will be used for filtering
        this.displayed = true;
        //whether or not the option is a group child
        this.optionGroupChild = false;
        //used to reset highlight styles
        this.resetOption = false;
        // #endregion
        // #region // ----------------------- @Input ----------------------- //
        this.isSelected = false;
        this.disabled = false;
        // #endregion
        // #region // ----------------------- @Output ----------------------- //
        // NOTE: the followwing @Outputs are subscribed to in the dropdown2 component
        this.ddResetStyles = new EventEmitter();
        this.ddClose = new EventEmitter();
        this.ddDisplayText = new EventEmitter();
        this.ddValueName = new EventEmitter();
        this.ddValue = new EventEmitter();
        this.ddHasOptionSelected = new EventEmitter();
        this.ddAnnounce = new EventEmitter();
    }
    ngAfterViewInit() {
        setTimeout(() => {
            if (this.value === this.initDropdownValue)
                this.alreadySelected();
            if (this.isSelected)
                this.setValue();
        }, 0);
    }
    // #endregion
    // #region // ----------------------- Methods ----------------------- //
    resetStyles() {
        /*on hover, we want to get rid of the background on the selected option...
          so we will call a method in dropdown to search for the selected option and
          set that option's resetOption property to true*/
        this.ddResetStyles.emit(this.optionGroupChild);
    }
    setValueOnClick(event) {
        if (this.disabled)
            return;
        this.setValue();
        this.ddClose.emit(event);
    }
    setValueSilent(postAnnounceValue) {
        this.optionGroupChild
            ? this.announceValueWithGroup(postAnnounceValue)
            : this.announceValue(postAnnounceValue);
    }
    alreadySelected() {
        this.isSelected = true;
        this.ddDisplayText.emit(this.label);
    }
    setValue(postAnnounceValue) {
        if (this.disabled)
            return;
        this.ddHasOptionSelected.emit(true);
        this.ddValueName.emit(this.label);
        this.ddDisplayText.emit(this.label);
        this.ddValue.emit(this.value);
        this.setValueSilent(postAnnounceValue);
    }
    announceValue(postAnnounceValue) {
        let announceStr = `${this.valueText.nativeElement.innerHTML}`;
        announceStr += !!postAnnounceValue ? `. ${postAnnounceValue}` : '';
        this.ddAnnounce.emit(announceStr);
    }
    announceValueWithGroup(postAnnounceValue) {
        let announceStr = `${this.optionGroupName} grouping ${this.valueText.nativeElement.innerHTML}`;
        announceStr += !!postAnnounceValue ? `. ${postAnnounceValue}` : '';
        this.ddAnnounce.emit(announceStr);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: OptionsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: OptionsComponent, isStandalone: false, selector: "citi-options2", inputs: { isSelected: "isSelected", value: "value", label: "label", disabled: "disabled" }, outputs: { ddResetStyles: "ddResetStyles", ddClose: "ddClose", ddDisplayText: "ddDisplayText", ddValueName: "ddValueName", ddValue: "ddValue", ddHasOptionSelected: "ddHasOptionSelected", ddAnnounce: "ddAnnounce" }, host: { classAttribute: "citi-options2" }, viewQueries: [{ propertyName: "optionEl", first: true, predicate: ["optionEl"], descendants: true, static: true }, { propertyName: "valueText", first: true, predicate: ["valueText"], descendants: true, static: true }], ngImport: i0, template: `
    <div
      class="dd2-option"
      #optionEl
      role="option"
      (click)="setValueOnClick($event)"
      (mouseenter)="resetStyles()"
      [ngClass]="{
        selectedOption: isSelected && !resetOption,
        disabled: disabled,
        displayNone: !displayed
      }"
    >
      <span
        #valueText
        class="dd2-option-text"
        [ngClass]="{ optionGroupOption: optionGroupChild }"
        [innerHTML]="label"
      >
      </span>
    </div>
  `, isInline: true, styles: [".selectedOption{color:#056dae;text-decoration:underline}div{cursor:pointer;color:#333;font-size:16px;line-height:24px 1.5;padding:10px 20px;z-index:999}div:hover{color:#056dae;text-decoration:underline}.disabled{cursor:default;color:#666}.disabled:hover{color:#666;text-decoration:none}.displayNone{display:none}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: OptionsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-options2', standalone: false, template: `
    <div
      class="dd2-option"
      #optionEl
      role="option"
      (click)="setValueOnClick($event)"
      (mouseenter)="resetStyles()"
      [ngClass]="{
        selectedOption: isSelected && !resetOption,
        disabled: disabled,
        displayNone: !displayed
      }"
    >
      <span
        #valueText
        class="dd2-option-text"
        [ngClass]="{ optionGroupOption: optionGroupChild }"
        [innerHTML]="label"
      >
      </span>
    </div>
  `, host: { class: 'citi-options2' }, styles: [".selectedOption{color:#056dae;text-decoration:underline}div{cursor:pointer;color:#333;font-size:16px;line-height:24px 1.5;padding:10px 20px;z-index:999}div:hover{color:#056dae;text-decoration:underline}.disabled{cursor:default;color:#666}.disabled:hover{color:#666;text-decoration:none}.displayNone{display:none}\n"] }]
        }], ctorParameters: () => [], propDecorators: { optionEl: [{
                type: ViewChild,
                args: ['optionEl', { static: true }]
            }], valueText: [{
                type: ViewChild,
                args: ['valueText', { static: true }]
            }], isSelected: [{
                type: Input$1
            }], value: [{
                type: Input$1
            }], label: [{
                type: Input$1
            }], disabled: [{
                type: Input$1
            }], ddResetStyles: [{
                type: Output
            }], ddClose: [{
                type: Output
            }], ddDisplayText: [{
                type: Output
            }], ddValueName: [{
                type: Output
            }], ddValue: [{
                type: Output
            }], ddHasOptionSelected: [{
                type: Output
            }], ddAnnounce: [{
                type: Output
            }] } });

class OptionsGroupComponent {
    constructor() {
        this.isDisplayed = true;
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.options.forEach(option => {
                option.optionGroupChild = true;
                option.optionGroupName = this.groupName;
            });
        });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: OptionsGroupComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: OptionsGroupComponent, isStandalone: false, selector: "citi-options-group2", inputs: { groupName: "groupName" }, host: { classAttribute: "citi-options-group2" }, queries: [{ propertyName: "options", predicate: OptionsComponent }], ngImport: i0, template: `
    <div role="group" [ngClass]="{ displayNone: !isDisplayed }">
      <div class="optionsGroupText" [innerHTML]="groupName"></div>
      <div><ng-content></ng-content></div>
    </div>
  `, isInline: true, styles: [".optionsGroupText{font-weight:700;padding:10px 20px}.displayNone{display:none}:host ::ng-deep .dd2-option-text{margin-left:20px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: OptionsGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-options-group2', standalone: false, template: `
    <div role="group" [ngClass]="{ displayNone: !isDisplayed }">
      <div class="optionsGroupText" [innerHTML]="groupName"></div>
      <div><ng-content></ng-content></div>
    </div>
  `, host: { class: 'citi-options-group2' }, styles: [".optionsGroupText{font-weight:700;padding:10px 20px}.displayNone{display:none}:host ::ng-deep .dd2-option-text{margin-left:20px}\n"] }]
        }], ctorParameters: () => [], propDecorators: { options: [{
                type: ContentChildren,
                args: [OptionsComponent]
            }], groupName: [{
                type: Input$1
            }] } });

class MaskingPipe {
    transform(value) {
        if (!value)
            return value;
        return value.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0) + 'x'.repeat(txt.length - 2) + txt.charAt(txt.length - 1);
        });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: MaskingPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    /** @nocollapse */ static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: MaskingPipe, isStandalone: false, name: "masking" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: MaskingPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'masking', standalone: false }]
        }] });

class CustomPipe {
    constructor(injector) {
        this.injector = injector;
    }
    transform(value, pipeToken) {
        if (!pipeToken) {
            return value;
        }
        else {
            let pipe = this.injector.get(pipeToken);
            return pipe.transform(value);
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CustomPipe, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Pipe }); }
    /** @nocollapse */ static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: CustomPipe, isStandalone: false, name: "customPipe" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CustomPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'customPipe', standalone: false }]
        }], ctorParameters: () => [{ type: i0.Injector }] });

const DD2_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    // tslint:disable-next-line: no-use-before-declare
    useExisting: forwardRef(() => Dropdown2Component),
    multi: true
};
let nextUniqueId$a = 0;
/* AfterContentChecked, */
class Dropdown2Component {
    /**
     * This defines the id of the input.
     */
    get idStr() {
        return this._id;
    }
    set idStr(value) {
        this._id = value || this._uid;
    }
    /**
     * label id
     */
    // TODO: Using this could cause invalid HTML. Look into usage of labelId.
    set labelId(id) {
        this._labelId = id;
    }
    get labelId() {
        return this._labelId || this._uLabelId;
    }
    /**
     * size for the dropdown (fullwidth, large, medium, small, xsmall)
     */
    set size(size) {
        if (size === 'large') {
            this.hostRowClass = true;
            this.sizeClasses = 'col-md-8';
        }
        else if (size === 'medium') {
            this.hostRowClass = true;
            this.sizeClasses = 'col-md-6 col-sm-9';
        }
        else if (size === 'small') {
            this.hostRowClass = true;
            this.sizeClasses = 'col-md-4 col-sm-6';
        }
        else if (size === 'xsmall') {
            this.hostRowClass = true;
            this.sizeClasses = 'col-md-2 col-sm-3 col-xs-6';
        }
        else {
            this.hostRowClass = false;
            this.sizeClasses = '';
        }
        this._size = size;
    }
    get size() {
        return this._size;
    }
    set error(isErrored) {
        if (isErrored === this._error)
            return;
        if (isErrored)
            this.errorMessage = this.customErrorMessage;
        this._error = isErrored;
    }
    get error() {
        return this._error;
    }
    get value() {
        return this._value;
    }
    set value(newVal) {
        if (typeof newVal === 'number')
            newVal = newVal.toString();
        if (newVal !== this._value) {
            this.selectOption(newVal);
            this._value = newVal;
        }
    }
    /**
     * AriaLabelledby of scrollable menu
     * @Two-way: true
     */
    set getScrollableMenuAriaLabelledby(labeledbyId) {
        this._getScrollableMenuAriaLabelledby = labeledbyId;
    }
    get getScrollableMenuAriaLabelledby() {
        if (!this._getScrollableMenuAriaLabelledby && this.labelId) {
            this._getScrollableMenuAriaLabelledby = this.labelId;
        }
        return this._getScrollableMenuAriaLabelledby;
    }
    // #endregion
    // #region // ----------------------- Getter Properties ----------------------- //
    get labelOpacity() {
        return this.visibleLabel
            ? 1
            : !!this.placeholder && (this._value || this.showOptionsBox)
                ? 1
                : 0;
    }
    get currentText() {
        return this.dropdownValueText.nativeElement.innerHTML;
    }
    get isAndroid() {
        return /(android)/i.test(navigator.userAgent);
    }
    get isIOS() {
        return /iPhone|iPad|iPod/i.test(navigator.userAgent);
    }
    get isFirefox() {
        return /(firefox)/i.test(navigator.userAgent);
    }
    get isSafari() {
        return /(safari)/i.test(navigator.userAgent);
    }
    // #endregion
    // #region // ----------------------- Constructor / Lifecycle Hooks ----------------------- //
    constructor(validationService, announcer, _ngZone) {
        this.validationService = validationService;
        this.announcer = announcer;
        this._ngZone = _ngZone;
        this.unsub$ = new Subject();
        // #region // ----------------------- Properties ----------------------- //
        // whether the options box is displayed or not
        this.showOptionsBox = false;
        // whether or not we have a selected option
        this.hasOptionSelected = false;
        // error message to be displayed when there is an error
        this.errorMessage = 'Error';
        // need this to stop value from being set in writeValue
        this.allowSetValueInWriteValue = true;
        // sets to true if scrollable option box should scroll to top when selecting with arrow keys
        this.scrollTop = false;
        // set to true if scrollable options box should scroll to bottom when selecting with arrow keys
        this.scrollBottom = false;
        /* SEARCHING PROPERTIES */
        // whether or not the input search box has focus
        this.inputHasFocus = false;
        // array which will be used for predictive searching
        this.filteredList = [];
        // string used to store the values entered for searching without input box
        this.searchingInput = '';
        // whether or not there are any options displayed when searching with input box
        this.noOps = false;
        // placeholder for predictive search box
        this.searchBoxPlaceholder = 'Begin typing to filter options...';
        // whether the dropdown is being validated via form container submit
        this.errorFromSubmitCheck = false;
        this.sizeClasses = '';
        // search value
        this.searchValue = '';
        this.subscriptionArray = [];
        // #endregion
        // #region // -------------- HostBinding / Children -------------- //
        this.hostRowClass = false;
        /**
         * masking for selected drropdown
         */
        this.mask = false;
        /**
         * placeholder text for dropdown
         */
        this.placeholder = '';
        /**
         * label text to be displayed above dropdown
         */
        this.label = '';
        this._uid = `citi-dropdown2-${nextUniqueId$a++}`;
        this._uLabelId = `${this._uid}-label`;
        /**
         * name associated with the hidden input which will binf to the <form>
         */
        this.name = 'dropdown';
        this._size = '';
        /**
         * custom error message to be displayed when there is an error
         */
        this.customErrorMessage = 'Error';
        /**
         * This defines the error state on the input
         */
        this._error = false;
        /**
         * Text to be displayed when the input is required and no value was entered
         */
        this.requiredError = 'This field is required';
        /*
         * whether or not the predictive search box will be present
         */
        this.predictiveSearch = false;
        /**
         * The dropdown is not clickable
         */
        this.isDisabled = false;
        /**
         * optional 'dark' or 'light' theme for manually setting dropdown background color
         */
        this.dropdownTheme = 'dark';
        /**
         * This defines visableLabel for label.
         */
        this.visibleLabel = false;
        /* OUTPUTS */
        /**
         * The event is emitted when the error status changed
         * The event is returned.
         */
        this.errorChange = new EventEmitter();
        /**
         * The event is emitted when the value is changed
         * The event is returned.
         */
        this.valueChange = new EventEmitter();
        /**
         * Emits the value typed in the search box
         */
        this.searchValueChange = new EventEmitter();
        this.displayedValueChange = new EventEmitter();
        // #region // ----------------------- Form Binding Methods ----------------------- //
        // All methods below are required for the Value Control Accessor interface to work with [(ngModel)]
        this.onChange = (value) => { };
        this.onTouched = () => { };
        if (isDevMode()) {
            console.error('%cThe Common UI DDL Dropdown2 <citi-dropdown2> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    ngOnInit() {
        // ensures that an id is assigned
        this.idStr = this.idStr;
        if (!!this.placeholder)
            this.displayedText = this.placeholder;
        this.validationService.validateNow
            .pipe(takeUntil(this.unsub$))
            .subscribe(() => {
            this.errorFromSubmitCheck = true;
            this.validate();
        });
        this.valueChange.pipe(takeUntil(this.unsub$)).subscribe(() => {
            this.displayedText = this.valueName || this.placeholder;
        });
        /*   fromEvent(this.selectEl.nativeElement, 'touchstart')
            .pipe(takeUntil(this.unsub$))
            .subscribe((touchEvent: Event) => {
              if (this.isAndroid && !this.showOptionsBox && !this.predictiveSearch) {
                this.announcer.announce(
                  `expanded.\n ${this.required ? 'required.\n' : ''} ${
                    this.currentText
                  }`
                );
              }
            });
    
          if (!this.predictiveSearch) {
            fromEvent(this.selectEl.nativeElement, 'keypress')
              .pipe(takeUntil(this.unsub$))
              .subscribe((e: KeyboardEvent) => {
                this.searchWithoutInputBox(e);
              });
    
            // clear our string we are using to search with after not typing for 1 second
            fromEvent(this.selectEl.nativeElement, 'keypress')
              .pipe(
                debounceTime(1000),
                takeUntil(this.unsub$)
              )
              .subscribe((e: KeyboardEvent) => (this.searchingInput = ''));
          }
       */
        // Tell the valdation service that an option was added
        this.validationService.addInput(this);
    }
    ngAfterViewInit() {
        // queries that are available after ngafterviewinit lifecycle
        fromEvent(this.selectEl.nativeElement, 'touchstart')
            .pipe(takeUntil(this.unsub$))
            .subscribe((touchEvent) => {
            if (this.isAndroid && !this.showOptionsBox && !this.predictiveSearch) {
                this.announcer.announce(`expanded.\n ${this.required ? 'required.\n' : ''} ${this.currentText}`);
            }
        });
        if (!this.predictiveSearch) {
            fromEvent(this.selectEl.nativeElement, 'keypress')
                .pipe(takeUntil(this.unsub$))
                .subscribe((e) => {
                this.searchWithoutInputBox(e);
            });
            // clear our string we are using to search with after not typing for 1 second
            fromEvent(this.selectEl.nativeElement, 'keypress')
                .pipe(debounceTime(1000), takeUntil(this.unsub$))
                .subscribe((e) => (this.searchingInput = ''));
        }
    }
    ngAfterContentInit() {
        this.handleOptionSubscriptions();
    }
    ngOnDestroy() {
        this.validationService.removeError(this);
        this.unsub$.next();
        this.unsub$.complete();
    }
    // #endregion
    // #region // ----------------------- Methods ----------------------- //
    handleOptionSubscriptions() {
        // Since the list of options may have change we need to
        // remove previous subscriptions then reset the array
        this.subscriptionArray.forEach(sub => {
            sub.unsubscribe();
        });
        this.subscriptionArray.length = 0;
        // set up new subscriptions
        if (this.options && this.options.length) {
            this.options.forEach(opt => {
                opt.initDropdownValue = this.value;
                const subResetStyles = opt.ddResetStyles
                    .pipe(takeUntil(this.unsub$))
                    .subscribe(groupChild => this.resetStyles(groupChild));
                const subClose = opt.ddClose
                    .pipe(takeUntil(this.unsub$))
                    .subscribe(kbEvent => this.close(kbEvent));
                const subDisplayText = opt.ddDisplayText
                    .pipe(takeUntil(this.unsub$))
                    .subscribe(text => (this.displayedText = text));
                const subValueName = opt.ddValueName
                    .pipe(takeUntil(this.unsub$))
                    .subscribe(name => (this.valueName = name));
                const subValue = opt.ddValue
                    .pipe(takeUntil(this.unsub$))
                    .subscribe(val => {
                    this.value = val;
                    this.displayedValueChange.emit(val);
                });
                const subHasOptionSelected = opt.ddHasOptionSelected
                    .pipe(takeUntil(this.unsub$))
                    .subscribe(bol => {
                    if (this.hasOptionSelected !== bol) {
                        this.hasOptionSelected = bol;
                    }
                });
                const subAnnounce = opt.ddAnnounce
                    .pipe(takeUntil(this.unsub$), debounceTime(400))
                    .subscribe(announceText => {
                    this.announcer.announce(announceText);
                });
                // Array of Subscriptions for this option
                const optSubs = [
                    subResetStyles,
                    subClose,
                    subDisplayText,
                    subValueName,
                    subValue,
                    subHasOptionSelected,
                    subAnnounce
                ];
                this.subscriptionArray.push(...optSubs);
            });
        }
    }
    getAriaLabelledBy() {
        if (!!this.ariaLabelledById)
            return this.ariaLabelledById;
        else if (!!this.labelId)
            return this.labelId;
        else
            return null;
    }
    sortOptions(optionGroupOptions) {
        this.setOrderOptionNum();
        return sort(optionGroupOptions);
    }
    setOrderOptionNum() {
        if (this.hasGroups) {
            const optionGroups = this.optionsGroups.toArray();
            let i = 0;
            optionGroups.forEach(optionGroup => {
                optionGroup.options.forEach(option => {
                    option.optionOrderNum = i;
                    i++;
                });
            });
        }
    }
    selectOption(value) {
        const opt = this.findOption(this.hasGroups, value);
        if (opt) {
            this.optionSelected(opt);
            this.hasOptionSelected = true;
        }
    }
    executeOnStable(func) {
        this._ngZone.runOutsideAngular(() => {
            this._ngZone.onStable
                .asObservable()
                .pipe(take(1))
                .subscribe(() => func());
        });
    }
    search(event) {
        // when there is a keyboard event inside the input box, this method will be fired to search through the options
        // if the key pressed is not another key we are listening for, then store the number of chars in the input value
        if ([
            'ArrowDown',
            'ArrowUp',
            'PageDown',
            'PageUp',
            'End',
            'Home',
            'Enter',
            ' '
        ].includes(event.key))
            return;
        const charNum = this.searchValue.length;
        this.searchValueChange.emit(this.searchValue);
        // allow time for search value to update list of options
        setTimeout(() => {
            // get array of all option components
            const optionArray = this.hasGroups
                ? this.sortOptions(flatMap(this.optionsGroups.toArray(), (group) => group.options.toArray()))
                : this.options.toArray();
            // gets options that can be selected
            this.filteredList = optionArray.filter(opt => !opt.disabled);
            const fListLength = this.filteredList.length;
            // shows 'no matching options' message
            this.noOps = fListLength === 0;
            // wait for filteredList to be updated
            setTimeout(() => {
                // resets the option subscriptions
                this.handleOptionSubscriptions();
                // hide disabled options when searching. otherwise, show all options
                if (charNum === 0) {
                    // show all groups
                    if (this.hasGroups) {
                        this.optionsGroups.forEach(og => {
                            og.isDisplayed = true;
                        });
                    }
                    // show all options
                    this.setOptionsDisplayAll(optionArray, true);
                }
                else {
                    // hide disabled options
                    this.setOptionsDisplayAll(optionArray.filter(opt => opt.disabled), false);
                    // hide groups with no available options
                    if (this.hasGroups) {
                        this.optionsGroups.forEach(og => {
                            const firstFoundAvailableOption = og.options.find(opt => !opt.disabled);
                            if (!firstFoundAvailableOption) {
                                og.isDisplayed = false;
                            }
                        });
                    }
                }
                const postSetValueAnnounce = this.hasSearchValue
                    ? `${fListLength} matching option${fListLength > 1 ? 's' : ''}`
                    : `${fListLength} total options`;
                // select first value out of the results given
                if (fListLength >= 1 && this.hasSearchValue)
                    this.filteredList[0].setValue(postSetValueAnnounce);
            }, 0);
        }, 0);
    }
    searchWithoutInputBox(event) {
        /*method that triggers when keyup event on dropdown button is fired. This will search through options and set the value for the indicated option
         *replication of native select tag functionality
         */
        if (this.isDisabled)
            return;
        this.handleOptionSubscriptions();
        // make sure the user entered a char a-z or A-Z
        if ((event.charCode >= 97 && event.charCode <= 122) ||
            (event.charCode <= 90 && event.charCode >= 65)) {
            this.searchingInput += String.fromCharCode(event.charCode).toUpperCase();
            const charNum = this.searchingInput.length;
            let currentSelection;
            // get the current selection
            if (this.optionsGroups.length === 0)
                currentSelection = this.options
                    .toArray()
                    .find(option => option.isSelected);
            if (this.optionsGroups.length > 1)
                currentSelection = flatMap(this.optionsGroups.toArray(), (group) => group.options.toArray()).find(option => option.isSelected);
            // if there is something selected we will use a switch based on if we have option groups and if our string is 1 or more chars
            if (currentSelection) {
                // we do not have option groups and there is only 1 character in our string
                if (this.optionsGroups.length === 0 && charNum === 1) {
                    // find the first value in the options array that matches the entered character
                    const match2 = this.options
                        .toArray()
                        .find(option => option.label.substr(0, 1).toUpperCase() === this.searchingInput);
                    // if we have a match, set the value
                    if (match2)
                        match2.setValue();
                }
                // we do not have option groups and we have more than 1 character in our string
                else if (this.optionsGroups.length === 0 && charNum > 1) {
                    const allEqual = allCharsEqual(this.searchingInput);
                    // if all the characters are the same, we will make an array of all options that begin with the character in the string
                    if (allEqual) {
                        // all options that begin with the entered character
                        const allMatchingOptions = this.options
                            .toArray()
                            .filter(option => option.label.substr(0, 1).toUpperCase() ===
                            this.searchingInput[0]);
                        // if there are options that begin with the entered character, we can get a reference to the index of the current selection and then next index
                        if (allMatchingOptions.length > 0) {
                            const currentIndex = allMatchingOptions.indexOf(currentSelection);
                            const nextIndex1 = currentIndex + 1;
                            // if the next index is out of bounds, set the value of the first option in the matching array
                            if (nextIndex1 >= allMatchingOptions.length) {
                                allMatchingOptions[0].setValue();
                                // if the index is in bounds, set the value of the index
                            }
                            else
                                allMatchingOptions[nextIndex1].setValue();
                        }
                    }
                    // if not all the characters in the string are equal, we will see if the string matches any of the options substrings
                    if (!allEqual) {
                        const matchingOption1 = this.options
                            .toArray()
                            .find(option => option.label.substr(0, charNum).toUpperCase() ===
                            this.searchingInput);
                        if (matchingOption1)
                            matchingOption1.setValue();
                    }
                }
                else if (this.hasGroups && charNum === 1) {
                    const optionsGroupsOptions = flatMap(this.optionsGroups.toArray(), (group) => group.options.toArray());
                    const matchingOptionGroupOptions1 = optionsGroupsOptions.filter(option => option.label.substr(0, 1).toUpperCase() === this.searchingInput);
                    // if there are options that match, find the option with the lowest order number since flatmap put the option in reverse order
                    if (matchingOptionGroupOptions1.length > 0) {
                        this.setOrderOptionNum();
                        const firstOption = findFirstOption(matchingOptionGroupOptions1);
                        // set the value of the first option
                        firstOption.setValue();
                    }
                }
                // if there are option groups and there is more than 1 character in the string
                else if (this.hasGroups && charNum > 1) {
                    const allLettersEqual = allCharsEqual(this.searchingInput);
                    const optionGroupOptions = flatMap(this.optionsGroups.toArray(), (group) => group.options.toArray());
                    // if all chars in the string are the same, get all options that match the letter that was entered
                    if (allLettersEqual) {
                        const allMatchingOptionGroupOptions = optionGroupOptions.filter(option => option.label.substr(0, 1).toUpperCase() ===
                            this.searchingInput[0]);
                        // if we have matching options, sort the option to be in the order they appear in the dropdown
                        if (allMatchingOptionGroupOptions.length > 0) {
                            const sortedOptionsArray = this.sortOptions(allMatchingOptionGroupOptions);
                            const currentIndex = sortedOptionsArray.indexOf(currentSelection);
                            const nextIndex2 = currentIndex + 1;
                            // if the next index is out of bounds, set it to the first value
                            if (nextIndex2 >= sortedOptionsArray.length) {
                                sortedOptionsArray[0].setValue();
                                // if the next index is in bounds of the array, set the next value
                            }
                            else
                                sortedOptionsArray[nextIndex2].setValue();
                        }
                    }
                    // if not all chars in the string are the same, find a matching option
                    if (!allLettersEqual) {
                        const matchingOption2 = optionGroupOptions.find(option => option.label.substr(0, charNum).toUpperCase() ===
                            this.searchingInput);
                        if (matchingOption2)
                            matchingOption2.setValue();
                    }
                }
            }
            // if there is not a selection yet, we will use a switch with a case for no option groups and a case with option groups
            if (!currentSelection) {
                // if we have no option groups, see if there is a match to the value entered
                if (this.optionsGroups.length === 0) {
                    const match1 = this.options
                        .toArray()
                        .find(option => option.label.substr(0, 1).toUpperCase() === this.searchingInput);
                    // if there is a match, set the value
                    if (match1)
                        match1.setValue();
                }
                // if we have option groups, put all options from each group in an array and filter out all options that match the first letter entered
                else if (this.hasGroups) {
                    const optionsGroupsOptions = flatMap(this.optionsGroups.toArray(), (group) => group.options.toArray());
                    const matchingOptionGroupOptions2 = optionsGroupsOptions.filter(option => option.label.substr(0, 1).toUpperCase() === this.searchingInput);
                    // if there are options that match, find the option with the lowest order number since flatmap put the option in reverse order
                    if (matchingOptionGroupOptions2.length > 0) {
                        this.setOrderOptionNum();
                        const firstOption = findFirstOption(matchingOptionGroupOptions2);
                        // set the value of the first option
                        firstOption.setValue();
                    }
                }
            }
        }
    }
    _setNextPrevWithPS(optionList, isPrev, isPageDownUp) {
        // check to see if we have a selected item in our options array
        const selectedFilteredOption = optionList.find(option => option.isSelected === true);
        const fll = optionList.length;
        const boundaryIndex = isPrev ? 0 : fll - 1;
        const oppositeBoundaryIndex = isPrev ? fll - 1 : 0;
        const moveNumber = isPageDownUp ? 6 : 1;
        // if we do not have a selected item, let's set the first option (but not on arrow/page up)
        if (!selectedFilteredOption) {
            optionList[oppositeBoundaryIndex].setValue();
        }
        // if there is a selected option, let's get the current index
        if (selectedFilteredOption) {
            const selectedIndex = optionList.indexOf(selectedFilteredOption);
            const nextIndex = isPrev
                ? selectedIndex - moveNumber
                : selectedIndex + moveNumber;
            const isWithinBounds = nextIndex >= 0 && nextIndex < fll;
            // check to make sure the index is in bounds of the array, and then find the option with the next index to be set
            if (isWithinBounds) {
                optionList[nextIndex].setValue();
            }
            // if the next index is not in bounds of the array, set it back to first/last option
            else {
                // if currently at boundary, go to opposite boundry
                if (selectedIndex === boundaryIndex) {
                    if (isPrev) {
                        this.scrollBottom = true;
                    }
                    else {
                        this.scrollTop = true;
                    }
                    optionList[oppositeBoundaryIndex].setValue();
                }
                // if not yet at boundary, but nextIndex is outside bounds, go to boundry
                else {
                    optionList[boundaryIndex].setValue();
                }
            }
        }
    }
    _setNextPrev(e, isPrev, isPageDownUp) {
        if (this.isDisabled)
            return;
        e.preventDefault();
        this.handleOptionSubscriptions();
        // we are not using filteredList
        if (this.filteredList.length === 0) {
            // make an array of all options
            const optionList = this.hasGroups
                ? this.sortOptions(this.flattenedOptions).filter(opt => !opt.disabled)
                : this.options.toArray().filter(opt => !opt.disabled);
            this._setNextPrevWithPS(optionList, isPrev, isPageDownUp);
        }
        // we are using filteredList
        else if (this.filteredList.length > 0) {
            if (this.hasGroups) {
                // sort the filtered list to be in order
                this.filteredList = this.sortOptions(this.filteredList);
            }
            this._setNextPrevWithPS(this.filteredList, isPrev, isPageDownUp);
        }
    }
    get flattenedOptions() {
        return flatMap(this.optionsGroups.toArray(), (group) => group.options.toArray());
    }
    setNextValue(e) {
        // sets next value in dropdown if down/right arrow is pressed
        this._setNextPrev(e);
    }
    setPreviousValue(e) {
        // sets previous value in dropdown if up/left arrow is pressed
        this._setNextPrev(e, true);
    }
    // page down
    goPagedownOnPagedown(e) {
        this._setNextPrev(e, false, true);
    }
    // page down ends
    // page up keyboard event
    goPageupOnPageup(e) {
        this._setNextPrev(e, true, true);
    }
    // page up ends
    _goEndHome(event, isPrev) {
        event.preventDefault();
        event.stopPropagation();
        const fll = this.filteredList.length;
        if (this.isDisabled)
            return;
        this.handleOptionSubscriptions();
        // we are not using filteredList
        if (fll === 0) {
            // make an array of all options in each group
            const optionList = this.hasGroups
                ? this.sortOptions(this.flattenedOptions).filter(opt => !opt.disabled)
                : this.options.toArray().filter(opt => !opt.disabled);
            // if none can be selected
            if (!optionList.find(opt => !opt.disabled))
                return;
            if (isPrev) {
                this.scrollTop = true;
                optionList[0].setValue();
            }
            else {
                this.scrollBottom = true;
                optionList[optionList.length - 1].setValue();
            }
        }
        // we are using filteredList
        else if (fll > 0) {
            if (this.hasGroups) {
                this.filteredList = this.sortOptions(this.filteredList);
            }
            // find the selected option in the filtered list
            const selectedFilteredOption = this.filteredList.find(option => option.isSelected === true);
            // if we have a selected option, get the current index and the next index
            if (selectedFilteredOption) {
                if (isPrev) {
                    this.scrollTop = true;
                    this.filteredList[0].setValue();
                }
                else {
                    this.scrollBottom = true;
                    this.filteredList[fll - 1].setValue();
                }
            }
        }
    }
    // go end on keyboard end
    goEndOnEnd(event) {
        this._goEndHome(event);
    }
    // go end ends
    // go home on keyboard home
    goHomeOnHome(event) {
        this._goEndHome(event, true);
    }
    // go home ends
    get hasGroups() {
        return !!this.optionsGroups && this.optionsGroups.length > 0;
    }
    get hasSearchValue() {
        return !!this.searchValue;
    }
    findOption(hasGroups, value) {
        if (hasGroups) {
            return flatMap(this.optionsGroups, (group) => group.options.toArray()).find(option => value === option.value);
        }
        else if (this.options) {
            return this.options.find(option => value === option.value);
        }
        else {
            return null;
        }
    }
    setOptionsDisplayAll(optionsArray, isDisplayed) {
        optionsArray.forEach(option => (option.displayed = isDisplayed));
    }
    handleOptionSelectForScrollable(optionComp) {
        // this will check to see if the selected option is out of view while the options box is scrollable and scroll up or down accordingly
        const optionsArray = this.options.toArray().filter(opt => !opt.disabled);
        if (this.scrollTop === true) {
            this.scrollableBox.nativeElement.scrollTop = 0;
            this.scrollTop = false;
            return;
        }
        if (this.scrollBottom === true) {
            this.scrollableBox.nativeElement.scrollTop =
                (optionsArray.length - 1) * 44;
            this.scrollBottom = false;
            return;
        }
        const optionsBoxPos = this.scrollableBox.nativeElement.getBoundingClientRect();
        const optionPos = optionComp.optionEl.nativeElement.getBoundingClientRect();
        const relativePosTop = optionPos.top - optionsBoxPos.top;
        const relativePosBottom = optionPos.bottom - optionsBoxPos.bottom;
        const offsetB = Math.ceil(relativePosBottom / 44) * 44;
        const offsetT = Math.ceil(relativePosBottom / 44) * 44;
        if (relativePosBottom >= 0)
            this.scrollableBox.nativeElement.scrollTop += offsetB; //44;
        if (relativePosTop <= 0)
            this.scrollableBox.nativeElement.scrollTop += offsetT; //-44;
    }
    resetStyles(groupChild) {
        /*if the option is a child of a group, we need to find the selected option in the group and set the resetOption property
          to true so that the selection styles will be removed on hover */
        if (groupChild) {
            const options = this.flattenedOptions;
            const optionGroupOption = options.find(option => option.isSelected);
            if (optionGroupOption)
                optionGroupOption.resetOption = true;
            // otherwise, we have a regular option -> so find the selected one and set restOption to true
        }
        else {
            const selectedOption = this.options.find(option => option.isSelected);
            if (selectedOption)
                selectedOption.resetOption = true;
        }
    }
    onClick(event) {
        // if we click outside the dropdown/options box, close the dropdown
        if (this.showOptionsBox === true &&
            !this.selectEl.nativeElement.contains(event.target) &&
            !this.optionsBox.nativeElement.contains(event.target)) {
            this.clickOutsideClose();
        }
    }
    close(event) {
        // when the dropdown is open, if the user presses tab or shift+tab, close the dropdown
        if (this.showOptionsBox) {
            event.preventDefault();
            this.valueChange.emit(this.value);
            this.showOptionsBox = false;
            if (this.predictiveSearch)
                this.inputHasFocus = false;
            if (this.isIOS || this.isAndroid || this.predictiveSearch) {
                this.announcer.announce('collapsed.');
            }
            setTimeout(() => this.selectEl.nativeElement.focus(), 200);
        }
    }
    clickOutsideClose() {
        if (this.showOptionsBox)
            this.valueChange.emit(this.value);
        this.showOptionsBox = false;
        this.validate();
    }
    onInputFocus() {
        this.inputHasFocus = true;
        if (this.isAndroid && this.showOptionsBox)
            this.announcer.announce(`expanded.\n ${this.required ? 'required ' : ''} ${this.currentText}`);
        else if (this.isIOS)
            this.announcer.announce(this.searchBoxPlaceholder);
    }
    onDropdownFocus() {
        setTimeout(() => {
            if (!this.showOptionsBox &&
                this.hasOptionSelected &&
                (this.isIOS || this.isAndroid)) {
                this.announcer.announce('collapsed. ' +
                    this.dropdownValueText.nativeElement.innerHTML +
                    ' selected');
            }
            else if (this.hasOptionSelected) {
                this.announcer.announce(this.dropdownValueText.nativeElement.innerHTML + ' selected');
            }
            else if (!!this.placeholder && !(this.isIOS || this.isAndroid))
                this.announcer.announce(this.placeholder);
        }, 100);
    }
    onBlur() {
        if (this.predictiveSearch && !this.inputHasFocus && !this.showOptionsBox)
            this.validate();
        if (!this.predictiveSearch && !this.showOptionsBox)
            this.validate();
    }
    open(event) {
        event.preventDefault();
        if (!this.showOptionsBox) {
            this.toggleDropdown();
        }
    }
    validate() {
        // check if dropdown is a required field/ if there is an option selected
        if (this.required &&
            (this.value === '' || this.value === 'null' || this.value === 'undefined')) {
            this.toggleErrorState(true, 'requiredError');
            this.errorFromSubmitCheck
                ? this.announcer.multiAnnounce(`${this.label} alert ${this.errorMessage}`)
                : this.announcer.announce(`${this.label} alert ${this.errorMessage}`);
            this.errorFromSubmitCheck = false;
        }
    }
    // Clears an error state on the input. Takes a type of error
    toggleErrorState(isErrored, errorType) {
        // Clear the error state
        this._error = isErrored;
        if (errorType === 'requiredError')
            this.errorMessage = this.requiredError;
        if (errorType === 'customError')
            this.errorMessage = this.customErrorMessage;
        // Emit the change to the error
        this.errorChange.emit(isErrored);
        // Add Rmove the error to the validation service
        this._error
            ? this.validationService.addError(this)
            : this.validationService.removeError(this);
    }
    closeOnEnter(event) {
        if (this.isDisabled)
            return;
        event.preventDefault();
        event.stopPropagation();
        if (this.showOptionsBox) {
            this.valueChange.emit(this.value);
        }
        else {
            this.handleOptionSubscriptions();
        }
        if (!this.showOptionsBox &&
            this.hasOptionSelected &&
            !this.predictiveSearch) {
            this.showOptionsBox = true;
            this.handleAnnouncementsOnOpen();
            setTimeout(() => {
                this.handleOptionSelectForScrollable(this.hasGroups
                    ? this.flattenedOptions.find(option => option.isSelected)
                    : this.options.find(option => option.isSelected));
            });
        }
        else if (!this.showOptionsBox &&
            !this.hasOptionSelected &&
            !this.predictiveSearch) {
            this.showOptionsBox = true;
            this.handleAnnouncementsOnOpen();
        }
        else {
            this.toggleDropdown();
        }
    }
    closeOnly(event) {
        // only close DD, will not emit value
        if (this.showOptionsBox) {
            this.showOptionsBox = false;
            if (this.predictiveSearch)
                this.inputHasFocus = false;
            setTimeout(() => this.selectEl.nativeElement.focus(), 100);
        }
    }
    toggleDropdownOnClick(event) {
        if (this.isDisabled)
            return;
        // redo option subsriptions when opened
        if (!this.showOptionsBox)
            this.handleOptionSubscriptions();
        if (this.showOptionsBox) {
            this.close(event);
        }
        else if (!this.showOptionsBox &&
            this.hasOptionSelected &&
            !this.predictiveSearch) {
            this.showOptionsBox = true;
            this.handleAnnouncementsOnOpen();
            setTimeout(() => {
                this.handleOptionSelectForScrollable(this.hasGroups
                    ? this.flattenedOptions.find(option => option.isSelected)
                    : this.options.find(option => option.isSelected));
            });
        }
        else if (!this.showOptionsBox &&
            !this.hasOptionSelected &&
            !this.predictiveSearch) {
            this.showOptionsBox = true;
            this.handleAnnouncementsOnOpen();
        }
        else {
            this.toggleDropdown();
        }
    }
    toggleDropdown() {
        // toggle dropdown modal content
        if (this.isDisabled)
            return;
        this.showOptionsBox = !this.showOptionsBox;
        setTimeout(_ => this.selectEl.nativeElement.focus(), 100);
        if (!this.predictiveSearch)
            this.onDropdownFocus();
        if (this.showOptionsBox) {
            setTimeout(() => {
                // if the options box is open, announce the total number of options
                this.handleAnnouncementsOnOpen();
                // wait till dropdown is open and then check if options box is off the screen
                isInViewPort(this.optionsBox);
            }, 0);
        }
        else if (this.predictiveSearch)
            this.inputHasFocus = false;
        if (this.predictiveSearch && this.showOptionsBox) {
            this.searchValue = '';
            this.searchValueChange.emit(this.searchValue);
            setTimeout(() => {
                this.handleDropdownOpenWithPS();
                this.handleOptionSubscriptions();
            }, 0);
        }
        /*if we open the dropdown and take the background away from the selected option on hover, and we also do not
          select a new option, we want to make sure the selected option has the blue background still, so let's set it back*/
        // we have option groups
        if (this.hasGroups) {
            const options = this.flattenedOptions;
            const optionGroupOption = options.find(option => option.isSelected && option.resetOption);
            if (optionGroupOption)
                optionGroupOption.resetOption = false;
            // otherwise -> we do not have any option groups
        }
        else {
            const selectedOption = this.options.find(option => option.isSelected && option.resetOption);
            if (selectedOption) {
                selectedOption.resetOption = false;
            }
        }
        this.setOptionsDisplay();
    }
    handleAnnouncementsOnOpen() {
        if (this.optionsGroups.length === 0) {
            this.isAndroid || this.isIOS
                ? this.announcer.announce('expanded. ' +
                    this.options.length +
                    ' total options. \nDouble tap to select an option')
                : this.announcer.announce(this.options.length + ' total options');
        }
        else {
            const totalOptions = flatMap(this.optionsGroups.toArray(), (group) => group.options.toArray());
            this.isAndroid || this.isIOS
                ? this.announcer.announce('expanded. ' +
                    totalOptions.length +
                    ' total options. \nDouble tap to select an option')
                : this.announcer.announce(totalOptions.length + ' total options.');
        }
    }
    handleDropdownOpenWithPS() {
        if (this.isAndroid || this.isIOS)
            this.announcer.announce('expanded');
        if (this.optionsGroups.length === 0) {
            // reassign the filtered list to the options in our dropdown so they will be displayed when we open it again
            this.filteredList = this.options.toArray();
        }
        else {
            // set all options to be displayed when dropdown is opened
            this.filteredList = flatMap(this.optionsGroups.toArray(), (group) => group.options.toArray());
            this.optionsGroups.forEach(group => (group.isDisplayed = true));
        }
        const disabledOps = this.filteredList.filter(option => option.disabled);
        if (disabledOps.length > 0)
            this.setOptionsDisplayAll(disabledOps, true);
        this.filteredList = this.filteredList.filter(option => !option.disabled);
        // set noOps back to false since we want the options box to display
        this.noOps = false;
        // set all options to be displayed when we open the dropdown
        this.setOptionsDisplayAll(this.filteredList, true);
        setTimeout(() => {
            // Focus on input unless on mobile Safari. Safari on iOS does not allow focus() after timeout
            if (!(this.isIOS && this.isSafari)) {
                this.input.nativeElement.focus();
            }
            if (this.isAndroid && this.isFirefox) {
                // Firefox on Android does not work with KeyboardEvent, using InputEvent instead
                fromEvent(this.input.nativeElement, 'input')
                    .pipe(takeUntil(this.unsub$))
                    .subscribe((ie) => {
                    // create empty keyboard event to pass to search
                    const ke = new KeyboardEvent('keyup', {});
                    this.search(ke);
                });
            }
            else {
                // searching with input box observable - dynamic searching/filtering on keyup
                fromEvent(this.input.nativeElement, 'keyup')
                    .pipe(takeUntil(this.unsub$))
                    .subscribe((e) => {
                    this.search(e);
                });
            }
        }, 100);
    }
    optionSelected(optionComp) {
        // if there are option groups -> set all options within the groups to false if any are true
        if (this.hasGroups) {
            const options = this.flattenedOptions;
            const optionGroupOption = options.find(option => option.isSelected);
            // set resetOption back to false so it can be highlighted on hover again
            if (optionGroupOption)
                optionGroupOption.isSelected = optionGroupOption.resetOption = false;
            // otherwise -> we do not have any option groups, so just set the options in the dropdown to false if they are true
        }
        else {
            const selectedOption = this.options.find(option => option.isSelected);
            // set resetOption back to false so it can be highlighted on hover again
            if (selectedOption)
                selectedOption.isSelected = selectedOption.resetOption = false;
        }
        optionComp.isSelected = true;
        this.valueName = optionComp.label;
        if (this._error)
            this.toggleErrorState(false);
        optionComp.resetOption = false;
        this.allowSetValueInWriteValue = false;
        this.writeValue(optionComp.value);
        if (this.showOptionsBox)
            this.handleOptionSelectForScrollable(optionComp);
        this.allowSetValueInWriteValue = true;
    }
    setOptionsDisplay() {
        if (this.predictiveSearch) {
            const selectedOption = this.options
                .toArray()
                .find(option => option.isSelected);
            if (selectedOption)
                this.setOptionsDisplayAll(this.options.toArray(), true);
        }
    }
    reset() {
        this.toggleErrorState(false);
        this.displayedText = this.placeholder;
        const selection = this.options.find(option => option.isSelected);
        if (selection)
            selection.isSelected = false;
        this.value = '';
        this.hasOptionSelected = false;
        this.valueName = '';
    }
    // Allows Angular to update the model.
    // Update the model and changes needed for the view here.
    writeValue(value) {
        if (this.value === value)
            return;
        if (this.allowSetValueInWriteValue) {
            setTimeout(() => {
                const opt = this.findOption(this.hasGroups, value);
                this.handleOptionSubscriptions();
                if (!!opt)
                    opt.setValue();
                this._value = value;
            }, 0);
        }
        //      !!!!    WARNING: DO NOT REMOVE    !!!!
        // this is actually necessary for ngModel to update
        this.onChange(value);
        // only change the displayed text when dropdown is open and using the arrow keys to navigate through it
        if (this.showOptionsBox) {
            this.displayedText = this.valueName; //this.value;
            return;
        }
        // infom the consumer
        this.valueChange.emit(value);
    }
    // Allows Angular to register a function to call when the model changes.
    // Save the function as a property to call later here.
    registerOnChange(fn) {
        this.onChange = fn;
    }
    // Allows Angular to register a function to call when the input has been touched.
    // Save the function as a property to call later here.
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    // Allows Angular to disable the input.
    setDisabledState(isDisabled) {
        this.isDisabled = isDisabled;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Dropdown2Component, deps: [{ token: ValidationService }, { token: CitiLiveAnnouncer }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: Dropdown2Component, isStandalone: false, selector: "citi-dropdown2", inputs: { CustomMasking: "CustomMasking", mask: "mask", placeholder: "placeholder", label: "label", idStr: "idStr", labelId: "labelId", ariaLabelledById: "ariaLabelledById", name: "name", size: "size", customErrorMessage: "customErrorMessage", error: "error", requiredError: "requiredError", required: "required", predictiveSearch: "predictiveSearch", isDisabled: "isDisabled", dropdownTheme: "dropdownTheme", additionalClasses: "additionalClasses", visibleLabel: "visibleLabel", value: "value", getScrollableMenuAriaLabelledby: "getScrollableMenuAriaLabelledby" }, outputs: { errorChange: "errorChange", valueChange: "valueChange", searchValueChange: "searchValueChange", displayedValueChange: "displayedValueChange" }, host: { listeners: { "window:touchstart": "onClick($event)", "window:click": "onClick($event)" }, properties: { "class.row": "this.hostRowClass" } }, providers: [DD2_VALUE_ACCESSOR], queries: [{ propertyName: "options", predicate: OptionsComponent, descendants: true }, { propertyName: "optionsGroups", predicate: OptionsGroupComponent }], viewQueries: [{ propertyName: "selectEl", first: true, predicate: ["selectEl"], descendants: true }, { propertyName: "dropdownValueText", first: true, predicate: ["dropdownValueText"], descendants: true, static: true }, { propertyName: "input", first: true, predicate: ["input"], descendants: true }, { propertyName: "optionsBox", first: true, predicate: ["optionsBox"], descendants: true }, { propertyName: "scrollableBox", first: true, predicate: ["scrollableBox"], descendants: true }], ngImport: i0, template: `
    <div [ngClass]="sizeClasses">
      <div class="dropdown2-wrapper">
        <label
          *ngIf="!ariaLabelledById"
          [ngClass]="{ disabledLabel: isDisabled }"
          [ngStyle]="{ opacity: labelOpacity }"
          class="dropdownLabel"
          [for]="idStr"
          [id]="labelId"
          [innerHtml]="label"
        ></label>

        <!-- Hidden Input for native <form> -->
        <input
          class="hidden-input"
          type="text"
          [attr.disabled]="isDisabled ? 'disabled' : null"
          [attr.name]="idStr + 'HiddenInput'"
          [(ngModel)]="value"
        />
        <!-- dropdown button -->
        <div
          [attr.aria-controls]="idStr + '-listbox'"
          #selectEl
          role="combobox"
          [attr.aria-labelledby]="getAriaLabelledBy()"
          [attr.aria-required]="required"
          [attr.aria-expanded]="showOptionsBox"
          [attr.aria-owns]="showOptionsBox ? idStr + '-listbox' : null"
          [attr.disabled]="isDisabled ? 'disabled' : null"
          [attr.aria-disabled]="isDisabled ? 'true' : null"
          aria-haspopup="listbox"
          [ngClass]="{
            open: predictiveSearch && showOptionsBox,
            disabledOptionSelect: isDisabled,
            errorState: error,
            dark: dropdownTheme === 'dark',
            light: dropdownTheme === 'light',
            valueColor: displayedText === value,
            placeholderColor: displayedText === placeholder
          }"
          [id]="idStr"
          [attr.tabIndex]="!isDisabled ? '0' : '-1'"
          class="dropdown {{ additionalClasses }}"
          (click)="toggleDropdownOnClick($event)"
          (keyup.enter)="closeOnEnter($event)"
          (keydown.ArrowDown)="setNextValue($event)"
          (keydown.alt.ArrowDown)="closeOnEnter($event)"
          (keydown.ArrowUp)="setPreviousValue($event)"
          (keydown.escape)="close($event)"
          (keydown.space)="closeOnEnter($event)"
          (keydown.home)="goHomeOnHome($event)"
          (keydown.end)="goEndOnEnd($event)"
          (keydown.pageup)="goPageupOnPageup($event)"
          (keydown.pagedown)="goPagedownOnPagedown($event)"
          (focus)="onDropdownFocus()"
          (blur)="onBlur()"
          (keydown.tab)="close($event)"
          (keydown.shift.tab)="close($event)"
        >
          <!-- current selected option text - placeholder before an option is selected/ value after option is selected -->
          <div
            #dropdownValueText
            aria-hidden="true"
            role="textbox"
            class="dropdownText"
            [innerHTML]="
              mask
                ? !!CustomMasking
                  ? (displayedText | customPipe: CustomMasking)
                  : (displayedText | masking)
                : displayedText
            "
          ></div>

          <!-- arrow on dropdown button -->
          <citi-icon2
            class="arrowIcon"
            name="02-down"
            [shade]="isDisabled ? 'g1' : 'b2'"
            ariaLabel="down arrow icon"
            ariaLabel="icon"
          >
          </citi-icon2>
        </div>

        <!-- the options box -->
        <div
          #optionsBox
          *ngIf="showOptionsBox"
          class="options"
          [ngClass]="[dropdownTheme]"
        >
          <!-- input box that is present if predictive search is on -->
          <div
            *ngIf="predictiveSearch && showOptionsBox"
            class="searchBoxWrapper"
          >
            <input
              #input
              [(ngModel)]="searchValue"
              role="textbox"
              class="searchBox"
              type="text"
              [id]="idStr + '-searchbox'"
              [placeholder]="searchBoxPlaceholder"
              (focus)="onInputFocus()"
              (keyup.enter)="closeOnEnter($event)"
              (blur)="inputHasFocus = false"
              (keydown.tab)="close($event)"
              (keydown.ArrowDown)="setNextValue($event)"
              (keydown.shift.tab)="close($event)"
              (keydown.ArrowUp)="setPreviousValue($event)"
              (keydown.home)="goHomeOnHome($event)"
              (keydown.end)="goEndOnEnd($event)"
              (keydown.pageup)="goPageupOnPageup($event)"
              (keydown.pagedown)="goPagedownOnPagedown($event)"
              (keydown.escape)="close($event)"
            />
          </div>

          <!--message that will display if the input field does not match any options-->
          <div *ngIf="noOps" class="noOpsLeft" role="alert">
            No matching options
          </div>

          <!--options content-->
          <div
            #scrollableBox
            role="listbox"
            [id]="idStr + '-listbox'"
            class="scrollable-menu"
            [attr.aria-labelledby]="getScrollableMenuAriaLabelledby"
          >
            <ng-content></ng-content>
          </div>
        </div>

        <!-- error message -->
        <span *ngIf="_error && !showOptionsBox" class="dropdownErrorMessage">{{
          errorMessage
        }}</span>
      </div>
    </div>
  `, isInline: true, styles: [":host{display:block}.dropdown2-wrapper{position:relative;margin-bottom:20px;margin-left:-5px;margin-right:-5px}.scrollable-menu>::ng-deep citi-options2:first-child .dd2-option,.scrollable-menu>::ng-deep citi-options-group2:first-child .optionsGroupText{padding-top:20px}.scrollable-menu>::ng-deep citi-options2:last-child .dd2-option{padding-bottom:20px}.scrollable-menu>::ng-deep citi-options-group2:last-child citi-options2:last-child .dd2-option{padding-bottom:20px}.dropdown{box-sizing:border-box;padding:12px 20px;cursor:pointer;height:50px;border-radius:6px;box-shadow:none;transition:border-color ease-in-out 225ms;font-size:16px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;color:#6b6b6b}.dropdown:focus{border:1px solid #056DAE;outline:0}.dropdownLabel{font-size:.75rem;color:#666;width:100%;pointer-events:none;transition:opacity .3s ease-in-out,visibility 1ms ease 301ms}.hidden-input{visibility:hidden;height:0;width:0;position:absolute}.light{background-color:#fff;border:1px solid #eee}.dark{background-color:#eee;border:1px solid #fff}.options{width:100%;box-sizing:border-box;border-radius:6px;position:absolute;box-shadow:1px 1px 2px #0000003d;z-index:999}.arrowIcon{margin-top:17px;height:20px;position:absolute;right:25px;top:0;display:inline-block;pointer-events:none}.fullwidth{width:100%}.large{width:768px}.med{width:571px}.small{width:374px}.xsmall{width:172px}.dropdownText{position:absolute;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;padding-right:40px;width:85%}.valueColor{color:#333}.placeholderColor{color:#666}[role=combobox]{margin-top:3px}.open{border:1px solid #056DAE}.errorState{border:1px solid #D60000}.errorState:focus{border:2px solid #D60000}.dropdownErrorMessage{color:#d60000;font-weight:700;line-height:1rem;font-size:12px;font-size:.75rem;font-family:interstate_Bold,sans-serif}.searchBoxWrapper{padding-top:20px;padding-left:20px;padding-right:20px}.searchBox{background-color:#fff;padding-left:20px;padding-top:5px;padding-bottom:5px;border-radius:6px;border:1px solid #056DAE;width:100%}.searchBox:focus{outline:0}input::placeholder{color:#000;opacity:1}.scrollable-menu{max-height:50vh;overflow:auto}.noOpsLeft{padding:20px}@media (max-width: 991px){.large,.med,.small{width:100%}}.disabledOptionSelect{color:#333;font-size:16px;font-family:Interstate-Light;line-height:1.5;border:1px solid #666;background-color:transparent}.disabledOptionSelect:focus{border:1px solid #666}.disabledLabel{color:#333;font-size:12px;line-height:1.5;font-family:Interstate-Light}.disabledArrowIcon{fill:#666}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: i4.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i4.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: Icon2Component, selector: "citi-icon2", inputs: ["role", "idStr", "ariaLabel", "ariaHidden", "size", "isHoverSfi", "includeCircle", "type", "svgStyle", "tabIndex", "shade", "name"] }, { kind: "pipe", type: MaskingPipe, name: "masking" }, { kind: "pipe", type: CustomPipe, name: "customPipe" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Dropdown2Component, decorators: [{
            type: Component,
            args: [{ selector: 'citi-dropdown2', standalone: false, template: `
    <div [ngClass]="sizeClasses">
      <div class="dropdown2-wrapper">
        <label
          *ngIf="!ariaLabelledById"
          [ngClass]="{ disabledLabel: isDisabled }"
          [ngStyle]="{ opacity: labelOpacity }"
          class="dropdownLabel"
          [for]="idStr"
          [id]="labelId"
          [innerHtml]="label"
        ></label>

        <!-- Hidden Input for native <form> -->
        <input
          class="hidden-input"
          type="text"
          [attr.disabled]="isDisabled ? 'disabled' : null"
          [attr.name]="idStr + 'HiddenInput'"
          [(ngModel)]="value"
        />
        <!-- dropdown button -->
        <div
          [attr.aria-controls]="idStr + '-listbox'"
          #selectEl
          role="combobox"
          [attr.aria-labelledby]="getAriaLabelledBy()"
          [attr.aria-required]="required"
          [attr.aria-expanded]="showOptionsBox"
          [attr.aria-owns]="showOptionsBox ? idStr + '-listbox' : null"
          [attr.disabled]="isDisabled ? 'disabled' : null"
          [attr.aria-disabled]="isDisabled ? 'true' : null"
          aria-haspopup="listbox"
          [ngClass]="{
            open: predictiveSearch && showOptionsBox,
            disabledOptionSelect: isDisabled,
            errorState: error,
            dark: dropdownTheme === 'dark',
            light: dropdownTheme === 'light',
            valueColor: displayedText === value,
            placeholderColor: displayedText === placeholder
          }"
          [id]="idStr"
          [attr.tabIndex]="!isDisabled ? '0' : '-1'"
          class="dropdown {{ additionalClasses }}"
          (click)="toggleDropdownOnClick($event)"
          (keyup.enter)="closeOnEnter($event)"
          (keydown.ArrowDown)="setNextValue($event)"
          (keydown.alt.ArrowDown)="closeOnEnter($event)"
          (keydown.ArrowUp)="setPreviousValue($event)"
          (keydown.escape)="close($event)"
          (keydown.space)="closeOnEnter($event)"
          (keydown.home)="goHomeOnHome($event)"
          (keydown.end)="goEndOnEnd($event)"
          (keydown.pageup)="goPageupOnPageup($event)"
          (keydown.pagedown)="goPagedownOnPagedown($event)"
          (focus)="onDropdownFocus()"
          (blur)="onBlur()"
          (keydown.tab)="close($event)"
          (keydown.shift.tab)="close($event)"
        >
          <!-- current selected option text - placeholder before an option is selected/ value after option is selected -->
          <div
            #dropdownValueText
            aria-hidden="true"
            role="textbox"
            class="dropdownText"
            [innerHTML]="
              mask
                ? !!CustomMasking
                  ? (displayedText | customPipe: CustomMasking)
                  : (displayedText | masking)
                : displayedText
            "
          ></div>

          <!-- arrow on dropdown button -->
          <citi-icon2
            class="arrowIcon"
            name="02-down"
            [shade]="isDisabled ? 'g1' : 'b2'"
            ariaLabel="down arrow icon"
            ariaLabel="icon"
          >
          </citi-icon2>
        </div>

        <!-- the options box -->
        <div
          #optionsBox
          *ngIf="showOptionsBox"
          class="options"
          [ngClass]="[dropdownTheme]"
        >
          <!-- input box that is present if predictive search is on -->
          <div
            *ngIf="predictiveSearch && showOptionsBox"
            class="searchBoxWrapper"
          >
            <input
              #input
              [(ngModel)]="searchValue"
              role="textbox"
              class="searchBox"
              type="text"
              [id]="idStr + '-searchbox'"
              [placeholder]="searchBoxPlaceholder"
              (focus)="onInputFocus()"
              (keyup.enter)="closeOnEnter($event)"
              (blur)="inputHasFocus = false"
              (keydown.tab)="close($event)"
              (keydown.ArrowDown)="setNextValue($event)"
              (keydown.shift.tab)="close($event)"
              (keydown.ArrowUp)="setPreviousValue($event)"
              (keydown.home)="goHomeOnHome($event)"
              (keydown.end)="goEndOnEnd($event)"
              (keydown.pageup)="goPageupOnPageup($event)"
              (keydown.pagedown)="goPagedownOnPagedown($event)"
              (keydown.escape)="close($event)"
            />
          </div>

          <!--message that will display if the input field does not match any options-->
          <div *ngIf="noOps" class="noOpsLeft" role="alert">
            No matching options
          </div>

          <!--options content-->
          <div
            #scrollableBox
            role="listbox"
            [id]="idStr + '-listbox'"
            class="scrollable-menu"
            [attr.aria-labelledby]="getScrollableMenuAriaLabelledby"
          >
            <ng-content></ng-content>
          </div>
        </div>

        <!-- error message -->
        <span *ngIf="_error && !showOptionsBox" class="dropdownErrorMessage">{{
          errorMessage
        }}</span>
      </div>
    </div>
  `, providers: [DD2_VALUE_ACCESSOR], styles: [":host{display:block}.dropdown2-wrapper{position:relative;margin-bottom:20px;margin-left:-5px;margin-right:-5px}.scrollable-menu>::ng-deep citi-options2:first-child .dd2-option,.scrollable-menu>::ng-deep citi-options-group2:first-child .optionsGroupText{padding-top:20px}.scrollable-menu>::ng-deep citi-options2:last-child .dd2-option{padding-bottom:20px}.scrollable-menu>::ng-deep citi-options-group2:last-child citi-options2:last-child .dd2-option{padding-bottom:20px}.dropdown{box-sizing:border-box;padding:12px 20px;cursor:pointer;height:50px;border-radius:6px;box-shadow:none;transition:border-color ease-in-out 225ms;font-size:16px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;color:#6b6b6b}.dropdown:focus{border:1px solid #056DAE;outline:0}.dropdownLabel{font-size:.75rem;color:#666;width:100%;pointer-events:none;transition:opacity .3s ease-in-out,visibility 1ms ease 301ms}.hidden-input{visibility:hidden;height:0;width:0;position:absolute}.light{background-color:#fff;border:1px solid #eee}.dark{background-color:#eee;border:1px solid #fff}.options{width:100%;box-sizing:border-box;border-radius:6px;position:absolute;box-shadow:1px 1px 2px #0000003d;z-index:999}.arrowIcon{margin-top:17px;height:20px;position:absolute;right:25px;top:0;display:inline-block;pointer-events:none}.fullwidth{width:100%}.large{width:768px}.med{width:571px}.small{width:374px}.xsmall{width:172px}.dropdownText{position:absolute;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;padding-right:40px;width:85%}.valueColor{color:#333}.placeholderColor{color:#666}[role=combobox]{margin-top:3px}.open{border:1px solid #056DAE}.errorState{border:1px solid #D60000}.errorState:focus{border:2px solid #D60000}.dropdownErrorMessage{color:#d60000;font-weight:700;line-height:1rem;font-size:12px;font-size:.75rem;font-family:interstate_Bold,sans-serif}.searchBoxWrapper{padding-top:20px;padding-left:20px;padding-right:20px}.searchBox{background-color:#fff;padding-left:20px;padding-top:5px;padding-bottom:5px;border-radius:6px;border:1px solid #056DAE;width:100%}.searchBox:focus{outline:0}input::placeholder{color:#000;opacity:1}.scrollable-menu{max-height:50vh;overflow:auto}.noOpsLeft{padding:20px}@media (max-width: 991px){.large,.med,.small{width:100%}}.disabledOptionSelect{color:#333;font-size:16px;font-family:Interstate-Light;line-height:1.5;border:1px solid #666;background-color:transparent}.disabledOptionSelect:focus{border:1px solid #666}.disabledLabel{color:#333;font-size:12px;line-height:1.5;font-family:Interstate-Light}.disabledArrowIcon{fill:#666}\n"] }]
        }], ctorParameters: () => [{ type: ValidationService }, { type: CitiLiveAnnouncer }, { type: i0.NgZone }], propDecorators: { hostRowClass: [{
                type: HostBinding,
                args: ['class.row']
            }], options: [{
                type: ContentChildren,
                args: [OptionsComponent, { descendants: true }]
            }], optionsGroups: [{
                type: ContentChildren,
                args: [OptionsGroupComponent]
            }], selectEl: [{
                type: ViewChild,
                args: ['selectEl', { static: false }]
            }], dropdownValueText: [{
                type: ViewChild,
                args: ['dropdownValueText', { static: true }]
            }], input: [{
                type: ViewChild,
                args: ['input', { static: false }]
            }], optionsBox: [{
                type: ViewChild,
                args: ['optionsBox', { static: false }]
            }], scrollableBox: [{
                type: ViewChild,
                args: ['scrollableBox', { static: false }]
            }], CustomMasking: [{
                type: Input$1
            }], mask: [{
                type: Input$1
            }], placeholder: [{
                type: Input$1
            }], label: [{
                type: Input$1
            }], idStr: [{
                type: Input$1
            }], labelId: [{
                type: Input$1
            }], ariaLabelledById: [{
                type: Input$1
            }], name: [{
                type: Input$1
            }], size: [{
                type: Input$1
            }], customErrorMessage: [{
                type: Input$1
            }], error: [{
                type: Input$1
            }], requiredError: [{
                type: Input$1
            }], required: [{
                type: Input$1
            }], predictiveSearch: [{
                type: Input$1
            }], isDisabled: [{
                type: Input$1
            }], dropdownTheme: [{
                type: Input$1
            }], additionalClasses: [{
                type: Input$1
            }], visibleLabel: [{
                type: Input$1
            }], errorChange: [{
                type: Output
            }], valueChange: [{
                type: Output
            }], value: [{
                type: Input$1,
                args: ['value']
            }], getScrollableMenuAriaLabelledby: [{
                type: Input$1
            }], searchValueChange: [{
                type: Output
            }], displayedValueChange: [{
                type: Output
            }], onClick: [{
                type: HostListener,
                args: ['window:touchstart', ['$event']]
            }, {
                type: HostListener,
                args: ['window:click', ['$event']]
            }] } });
// #region // ----------------------- Functions ----------------------- //
function flatMap(array, mapFunc) {
    // this function will be used to put all option group options in one array
    return array.reduce((cumulus, next) => [...mapFunc(next), ...cumulus], []);
}
function allCharsEqual(stringToCompare) {
    // we will use this when searching when predictive search is off - returns true if all characters in a string are the same
    return stringToCompare.split('').every(char => char === stringToCompare[0]);
}
function findFirstOption(optionGroupOptions) {
    // this will find the first option when there are option groups. We will use this to put the options array in order
    let lowestOrderNum = optionGroupOptions[0];
    optionGroupOptions.forEach(option => {
        if (option.optionOrderNum < lowestOrderNum.optionOrderNum)
            lowestOrderNum = option;
    });
    return lowestOrderNum;
}
function sort(optionGroupOptions) {
    // this will sort the options when there are option groups (flat map does not put the options in the correct order)
    const newArray = [];
    let index = 0;
    // this.setOrderOptionNum();
    while (optionGroupOptions.length > 0) {
        const nextOption = findFirstOption(optionGroupOptions);
        optionGroupOptions.splice(optionGroupOptions.indexOf(nextOption), 1);
        newArray[index] = nextOption;
        index++;
    }
    return newArray;
}
function isInViewPort(selectEl) {
    const rect = selectEl.nativeElement.getBoundingClientRect();
    const html = document.documentElement;
    if (!(rect.bottom <= (window.innerHeight || html.clientHeight))) {
        const adjustment = rect.bottom - window.innerHeight;
        window.scrollBy(0, adjustment + 15);
    }
}

let nextId$7 = 0;
/**
 * @Component: Nav Group
 * @Section: Navigation
 * @description This is in page navigation component to create
 * from Bootstrap.
*/
class NavGroup2Component {
    set activeTab(index) {
        if (Number(index) === this.activeTab)
            return;
        this._activeTab = Number(index);
        if (this.tabs && this.tabs.length)
            this.selectTab(this._activeTab);
    }
    get activeTab() {
        return this._activeTab;
    }
    // #endregion
    // #region ---------- Life Cycle ----------- //
    constructor(el, liveAnnouncer, cdr, navigatorRef) {
        this.el = el;
        this.liveAnnouncer = liveAnnouncer;
        this.cdr = cdr;
        // #endregion
        // #region -------- Inputs/Outputs ---------- //
        /**
         * @property activeTab
         * @description This defines the active tab of in page navigation
         * @return number
        */
        this._activeTab = 0;
        /**
         * @property focusedTab
         * @description This defines the focused tab of in page navigation
         * @return number
        */
        this.focusedTab = 0;
        /**
         * @Event: activeTabChanged
         * @description This event that is fired when a tab activates; returns the index of the active tab (first tab is 1)
         * @return Number
         */
        this.activeTabChange = new EventEmitter();
        if (isDevMode()) {
            console.error('%cThe Common UI DDL InPageNavigation2 <citi-nav-group2> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
        this._navigator = navigatorRef;
        this.hostId = `nav-tab-group-${nextId$7++}`;
        this.iOS = this._navigator &&
            (!!this._navigator.platform
                && /iPad|iPhone|iPod/.test(this._navigator.platform));
    }
    ngAfterContentInit() {
        this.tabs.forEach(tab => tab.groupHostId = this.hostId);
        this.setInitial(this.activeTab);
    }
    // #endregion
    // #region ------------ Methods ------------- //
    setInitial(index) {
        this.focusedTab = index;
        const tab = this.tab(index);
        tab.isFocused = tab.isActive = true;
        this.cdr.detectChanges();
    }
    unSelectAll() {
        this.tabs.forEach(tab => this.setActiveTab(tab, false));
    }
    tab(index) {
        return this.tabs.find((tab, i) => i === index);
    }
    setActiveTab(tab, bool = true) {
        tab.isActive = tab.isFocused = tab.keyboardFocused = bool;
    }
    focusActive() {
        setTimeout(() => {
            this.tabSelect
                ? this.tabSelect.nativeElement.focus()
                : this.el.nativeElement.querySelector('.tab-focused').focus();
            this.cdr.detectChanges();
        }, 100);
    }
    currentTab() {
        return this.tabs.find(tab => tab.isActive);
    }
    selectTab(index) {
        this.unSelectAll();
        this.setActiveTab(this.tab(index));
        this.focusActive();
        this._activeTab = this.focusedTab = index;
        this.activeTabChange.emit(index);
        // TalkBack and VoiceOver announce
        if (this.iOS || (this._navigator && androidPlatformCheck(this._navigator.platform)))
            setTimeout(() => this.liveAnnouncer.announce(`${this.tab(index).label} selected ${Number(index) + 1} of ${this.tabs.length}`), 100);
    }
    clearFocus() {
        this.tabs.forEach(tab => tab.isFocused = tab.keyboardFocused = false);
    }
    removeKeyboardFocus() {
        this.tabs.forEach(tab => tab.keyboardFocused = false);
        this.tabs.forEach(tab => tab.isFocused = false);
        this.focusedTab = this.activeTab;
    }
    moveFocus(dir) {
        this.setTabFocus((this.focusedTab + this.tabs.length + dir) % this.tabs.length);
    }
    setTabFocus(index) {
        this.clearFocus();
        this.tab(index).isFocused = true;
        this.focusActive();
        this.focusedTab = index;
        if ((!this.iOS)
            && (!androidPlatformCheck(navigator.platform))
            && (!this.tab(index).isActive)) {
            this.liveAnnouncer.announce('Use enter to select tab.');
        }
    }
    stopBubble(event) {
        event.preventDefault();
        event.stopPropagation();
    }
    handleKeyPress(event) {
        if (event.which !== KEY_TAB)
            this.stopBubble(event);
        switch (event.which) {
            case KEY_HOME:
                this.setTabFocus(0);
                break;
            case KEY_END:
                this.setTabFocus(this.tabs.length - 1);
                break;
            case KEY_ARROW_LEFT:
            case KEY_ARROW_UP:
                this.moveFocus(-1);
                break;
            case KEY_ARROW_RIGHT:
            case KEY_ARROW_DOWN:
                this.moveFocus(1);
                break;
            case KEY_SPACEBAR:
            case KEY_ENTER:
                this.selectTab(this.focusedTab);
                break;
            case KEY_TAB: this.removeKeyboardFocus();
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: NavGroup2Component, deps: [{ token: i0.ElementRef }, { token: CitiLiveAnnouncer }, { token: i0.ChangeDetectorRef }, { token: NAVIGATOR }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: NavGroup2Component, isStandalone: false, selector: "citi-nav-group2", inputs: { activeTab: "activeTab", focusedTab: "focusedTab" }, outputs: { activeTabChange: "activeTabChange" }, host: { properties: { "attr.id": "this.hostId" }, classAttribute: "citi-nav-group2" }, queries: [{ propertyName: "tabs", predicate: NavTab2Component }], viewQueries: [{ propertyName: "tabContent", first: true, predicate: ["tabContent"], descendants: true }, { propertyName: "tabSelect", first: true, predicate: ["tabSelect"], descendants: true }], ngImport: i0, template: `
    <div [class]="'nav-tab-list tabs-'+tabs.length" role="tablist">
      <button
        *ngFor="let tab of tabs.toArray(); let idx = index"
        role="tab"
        type="button"
        class="nav-tab-label"
        [ngClass]="{
          'nav-tab-label-active'  : tab.isActive,
          'tab-focused'           : tab.isFocused,
          'tab-keyboard-focused'  : tab.keyboardFocused,
          'hidden-xs'             : tabs.length > 2
        }"
        [attr.id]="hostId + '-' + tab.hostId"
        [attr.aria-selected]="tab.isActive"
        [attr.aria-controls]="tab.hostId"
        [attr.tabindex]="(tab.isActive ? 0 : -1)"
        (click)="selectTab(idx)"
        (keydown)="handleKeyPress($event)">

        <span class="nav-tab-label-content" [innerHtml]="tab.label"></span>

      </button>
    </div>

    <div [ngClass]="{'hidden-sm hidden-md hidden-lg': tabs.length >= 2 }">
      <div class="row">
        <div class="col-md-4 col-sm-6">
          <citi-dropdown2
            [(value)]="activeTab">

            <citi-options2 *ngFor="let tab of tabs.toArray(); let idx = index"
              [value]="idx.toString()"
              [label]="tab.label"
            ></citi-options2>

          </citi-dropdown2>

          <!-- <select #tabSelect
            id="action-module-mobile-select"
            class="form-control action-module-mobile-select"
            [(ngModel)]="activeTab">

            <option *ngFor="let tab of tabs.toArray(); let idx = index"
              [value]="idx"
              [innerHTML]="tab.label"
            ></option>

          </select> -->

        </div>
      </div>
    </div>
    <div class="tab-content noPadding" #tabContent>
      <ng-content></ng-content>
    </div>
  `, isInline: true, styles: [":host .tab-content{background-color:transparent;padding:0}.nav-tab-list .nav-tab-label{background-color:#eee;border-left:none;border-bottom:5px solid #fff;border-top:5px solid #fff;border-right:none;height:70px;line-height:24px;min-height:70px;padding:10px;position:relative;width:50%}.nav-tab-list .nav-tab-label.nav-tab-label-active{background-color:#fff!important;border-top-color:transparent;border-bottom:5px solid #056DAE;box-shadow:0 0 5px 1px #33333340}.nav-tab-list .nav-tab-label.nav-tab-label-active .nav-tab-label-content{color:#333;background-color:transparent}.nav-tab-list .nav-tab-label .nav-tab-label-content{color:#056dae;background-color:transparent}.nav-tab-list .nav-tab-label .nav-tab-label-content:hover{color:#333}@media (min-width: 992px){.nav-tab-list .nav-tab-label{font-size:21px;line-height:27px;min-height:90px;height:90px}}@media (max-width: 768px){.nav-tab-list .nav-tab-label{height:auto}}.nav-tab-list .nav-tab-label:not(:first-child):before{content:\"\";background-color:#767676;height:calc(100% - 20px);left:0;position:absolute;top:10%;width:1px;z-index:3}.nav-tab-list .nav-tab-label.nav-tab-label-active+button:before,.nav-tab-list .nav-tab-label.nav-tab-label-active:before{background-color:transparent}.nav-tab-list.tabs-3 .nav-tab-label{width:33.33%}.nav-tab-list.tabs-4 .nav-tab-label{width:25%}.nav-tab-list.tabs-5 .nav-tab-label{width:20%}.tab-focused{outline:#7AACFE solid 2px!important;outline:auto 5px -webkit-focus-ring-color!important;z-index:2}.noPadding{padding:0}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: Dropdown2Component, selector: "citi-dropdown2", inputs: ["CustomMasking", "mask", "placeholder", "label", "idStr", "labelId", "ariaLabelledById", "name", "size", "customErrorMessage", "error", "requiredError", "required", "predictiveSearch", "isDisabled", "dropdownTheme", "additionalClasses", "visibleLabel", "value", "getScrollableMenuAriaLabelledby"], outputs: ["errorChange", "valueChange", "searchValueChange", "displayedValueChange"] }, { kind: "component", type: OptionsComponent, selector: "citi-options2", inputs: ["isSelected", "value", "label", "disabled"], outputs: ["ddResetStyles", "ddClose", "ddDisplayText", "ddValueName", "ddValue", "ddHasOptionSelected", "ddAnnounce"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: NavGroup2Component, decorators: [{
            type: Component,
            args: [{ selector: 'citi-nav-group2', standalone: false, template: `
    <div [class]="'nav-tab-list tabs-'+tabs.length" role="tablist">
      <button
        *ngFor="let tab of tabs.toArray(); let idx = index"
        role="tab"
        type="button"
        class="nav-tab-label"
        [ngClass]="{
          'nav-tab-label-active'  : tab.isActive,
          'tab-focused'           : tab.isFocused,
          'tab-keyboard-focused'  : tab.keyboardFocused,
          'hidden-xs'             : tabs.length > 2
        }"
        [attr.id]="hostId + '-' + tab.hostId"
        [attr.aria-selected]="tab.isActive"
        [attr.aria-controls]="tab.hostId"
        [attr.tabindex]="(tab.isActive ? 0 : -1)"
        (click)="selectTab(idx)"
        (keydown)="handleKeyPress($event)">

        <span class="nav-tab-label-content" [innerHtml]="tab.label"></span>

      </button>
    </div>

    <div [ngClass]="{'hidden-sm hidden-md hidden-lg': tabs.length >= 2 }">
      <div class="row">
        <div class="col-md-4 col-sm-6">
          <citi-dropdown2
            [(value)]="activeTab">

            <citi-options2 *ngFor="let tab of tabs.toArray(); let idx = index"
              [value]="idx.toString()"
              [label]="tab.label"
            ></citi-options2>

          </citi-dropdown2>

          <!-- <select #tabSelect
            id="action-module-mobile-select"
            class="form-control action-module-mobile-select"
            [(ngModel)]="activeTab">

            <option *ngFor="let tab of tabs.toArray(); let idx = index"
              [value]="idx"
              [innerHTML]="tab.label"
            ></option>

          </select> -->

        </div>
      </div>
    </div>
    <div class="tab-content noPadding" #tabContent>
      <ng-content></ng-content>
    </div>
  `, changeDetection: ChangeDetectionStrategy.OnPush, host: {
                        class: 'citi-nav-group2'
                    }, styles: [":host .tab-content{background-color:transparent;padding:0}.nav-tab-list .nav-tab-label{background-color:#eee;border-left:none;border-bottom:5px solid #fff;border-top:5px solid #fff;border-right:none;height:70px;line-height:24px;min-height:70px;padding:10px;position:relative;width:50%}.nav-tab-list .nav-tab-label.nav-tab-label-active{background-color:#fff!important;border-top-color:transparent;border-bottom:5px solid #056DAE;box-shadow:0 0 5px 1px #33333340}.nav-tab-list .nav-tab-label.nav-tab-label-active .nav-tab-label-content{color:#333;background-color:transparent}.nav-tab-list .nav-tab-label .nav-tab-label-content{color:#056dae;background-color:transparent}.nav-tab-list .nav-tab-label .nav-tab-label-content:hover{color:#333}@media (min-width: 992px){.nav-tab-list .nav-tab-label{font-size:21px;line-height:27px;min-height:90px;height:90px}}@media (max-width: 768px){.nav-tab-list .nav-tab-label{height:auto}}.nav-tab-list .nav-tab-label:not(:first-child):before{content:\"\";background-color:#767676;height:calc(100% - 20px);left:0;position:absolute;top:10%;width:1px;z-index:3}.nav-tab-list .nav-tab-label.nav-tab-label-active+button:before,.nav-tab-list .nav-tab-label.nav-tab-label-active:before{background-color:transparent}.nav-tab-list.tabs-3 .nav-tab-label{width:33.33%}.nav-tab-list.tabs-4 .nav-tab-label{width:25%}.nav-tab-list.tabs-5 .nav-tab-label{width:20%}.tab-focused{outline:#7AACFE solid 2px!important;outline:auto 5px -webkit-focus-ring-color!important;z-index:2}.noPadding{padding:0}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: CitiLiveAnnouncer }, { type: i0.ChangeDetectorRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [NAVIGATOR]
                }] }], propDecorators: { tabContent: [{
                type: ViewChild,
                args: ['tabContent']
            }], tabSelect: [{
                type: ViewChild,
                args: ['tabSelect']
            }], tabs: [{
                type: ContentChildren,
                args: [NavTab2Component]
            }], hostId: [{
                type: HostBinding,
                args: ['attr.id']
            }], activeTab: [{
                type: Input$1
            }], focusedTab: [{
                type: Input$1
            }], activeTabChange: [{
                type: Output
            }] } });

// Component Dependencies
const COMPONENTS$U = [
    Dropdown2Component,
    OptionsComponent,
    OptionsGroupComponent,
    MaskingPipe,
    CustomPipe
];
const MODULES$U = [CommonModule, FormsModule, Icons2];
// tslint:disable-next-line: class-name
class Dropdown2 {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Dropdown2, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: Dropdown2, declarations: [Dropdown2Component,
            OptionsComponent,
            OptionsGroupComponent,
            MaskingPipe,
            CustomPipe], imports: [CommonModule, FormsModule, Icons2], exports: [Dropdown2Component,
            OptionsComponent,
            OptionsGroupComponent,
            MaskingPipe,
            CustomPipe] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Dropdown2, imports: [MODULES$U] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Dropdown2, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$U],
                    declarations: [...COMPONENTS$U],
                    exports: [...COMPONENTS$U]
                }]
        }] });

const COMPONENTS$T = [
    NavGroup2Component,
    NavTab2Component
];
const MODULES$T = [
    CommonModule,
    FormsModule,
    Dropdown2
];
class InPageNavigation2 {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: InPageNavigation2, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: InPageNavigation2, declarations: [NavGroup2Component,
            NavTab2Component], imports: [CommonModule,
            FormsModule,
            Dropdown2], exports: [NavGroup2Component,
            NavTab2Component] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: InPageNavigation2, providers: [NAVIGATOR_PROVIDER], imports: [MODULES$T] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: InPageNavigation2, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$T],
                    declarations: [...COMPONENTS$T],
                    providers: [NAVIGATOR_PROVIDER],
                    exports: [...COMPONENTS$T]
                }]
        }] });

class RadialProgressBarComponent {
    // #region ========== Properties ========== //
    get _largestStrokeWidth() {
        return this.progressStrokeWidth > this.baseStrokeWidth ? this.progressStrokeWidth : this.baseStrokeWidth;
    }
    get radius() {
        const _radius = (this.diameter - this._largestStrokeWidth) / 2;
        return _radius;
    }
    get circumference() {
        const _circumference = 2 * Math.PI * this.radius;
        return _circumference;
    }
    get arcLength() {
        const _arcLength = this.circumference * this.percent * 0.01;
        return _arcLength;
    }
    get checkPath() {
        const d = this.diameter;
        const x1 = d * 0.27777;
        const y1 = d * 0.54795;
        const x2 = d * 0.40277;
        const y2 = d * 0.65753;
        const x3 = d * 0.75;
        const y3 = d * 0.34247;
        return `M${x1} ${y1} L${x2} ${y2} L${x3} ${y3}`;
    }
    get checkWidth() {
        return this.diameter * 0.1;
    }
    set percent(pcnt) {
        // Limit the percent between 0 and 100
        if (pcnt > 100) {
            console.warn('percent should not be above 100... setting to 100');
            this._percent = 100;
        }
        else if (pcnt < 0) {
            console.warn('percent should not be less than 0... setting to 0');
            this._percent = 0;
        }
        else {
            this._percent = pcnt;
        }
    }
    get percent() {
        return this._percent;
    }
    set announceText(announceTxt) {
        this._announceText = announceTxt;
        this.announce(announceTxt);
    }
    get announceText() {
        return this._announceText;
    }
    // #endregion
    // #region ========== Constructor / Lifecycle Hooks ========== //
    constructor(announcer) {
        this.announcer = announcer;
        // #endregion
        // #region ========== @Inputs ========== //
        this._percent = 50;
        this.diameter = 100;
        this.progressStrokeWidth = 8;
        this.baseStrokeWidth = 1;
        this.stepText = '-';
        if (isDevMode()) {
            console.error('%cThe Common UI DDL RadialProgressBar <citi-radial-progress-bar> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    // #endregion
    // #region ========== Methods ========== //
    announce(txt) {
        this.announcer.announce(txt);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: RadialProgressBarComponent, deps: [{ token: CitiLiveAnnouncer }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: RadialProgressBarComponent, isStandalone: false, selector: "citi-radial-progress-bar", inputs: { percent: "percent", diameter: "diameter", progressStrokeWidth: "progressStrokeWidth", baseStrokeWidth: "baseStrokeWidth", stepText: "stepText", announceText: "announceText" }, host: { classAttribute: "citi-radial-progress-bar" }, ngImport: i0, template: `
    <svg [attr.viewBox]="'0 0 ' + diameter + ' ' + diameter" [style.width.px]="diameter" [style.height.px]="diameter">
      <circle cx="50%" cy="50%" class="rpb-back" [class.rpb-back-done]="percent === 100" [attr.r]="radius" [style.stroke-width.px]="baseStrokeWidth" />
      <circle *ngIf="percent !== 0" cx="50%" cy="50%" class="rpb-arc" [class.rpb-arc-done]="percent === 100" [attr.r]="radius"
        [style.stroke-width.px]="progressStrokeWidth" [style.stroke-dasharray]="arcLength + ' ' + circumference" [style.stroke-dashoffset]="arcLength" />
      <text *ngIf="percent !== 100" class="rpb-text" x="50%" y="50%" dominant-baseline="middle" text-anchor="middle">
        {{stepText}}
      </text>
      <path *ngIf="percent === 100" class="rpb-done-check" [attr.d]="checkPath" [style.stroke-width.px]="checkWidth" />
    </svg>
    <div class="rpb-content">
      <ng-content></ng-content>
    </div>
  `, isInline: true, styles: [":host{display:inline-block;text-align:center}.rpb-back{stroke:#ccc;fill:transparent;transition:all .4s ease-out}.rpb-back-done{fill:#008a24;stroke:#008a24;stroke-dasharray:initial}.rpb-arc{stroke:#056dae;fill:transparent;stroke-linecap:round;transform-origin:50% 50%;transform:rotate(-90deg);animation:rpb-animate-arc .4s ease-out forwards;transition:all .4s ease-out}.rpb-arc-done{fill:#008a24;stroke:#008a24;stroke-dasharray:initial}@keyframes rpb-animate-arc{to{stroke-dashoffset:0}}.rpb-done-check{fill:none;stroke:#fff}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: RadialProgressBarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-radial-progress-bar', standalone: false, template: `
    <svg [attr.viewBox]="'0 0 ' + diameter + ' ' + diameter" [style.width.px]="diameter" [style.height.px]="diameter">
      <circle cx="50%" cy="50%" class="rpb-back" [class.rpb-back-done]="percent === 100" [attr.r]="radius" [style.stroke-width.px]="baseStrokeWidth" />
      <circle *ngIf="percent !== 0" cx="50%" cy="50%" class="rpb-arc" [class.rpb-arc-done]="percent === 100" [attr.r]="radius"
        [style.stroke-width.px]="progressStrokeWidth" [style.stroke-dasharray]="arcLength + ' ' + circumference" [style.stroke-dashoffset]="arcLength" />
      <text *ngIf="percent !== 100" class="rpb-text" x="50%" y="50%" dominant-baseline="middle" text-anchor="middle">
        {{stepText}}
      </text>
      <path *ngIf="percent === 100" class="rpb-done-check" [attr.d]="checkPath" [style.stroke-width.px]="checkWidth" />
    </svg>
    <div class="rpb-content">
      <ng-content></ng-content>
    </div>
  `, changeDetection: ChangeDetectionStrategy.OnPush, host: {
                        class: 'citi-radial-progress-bar'
                    }, styles: [":host{display:inline-block;text-align:center}.rpb-back{stroke:#ccc;fill:transparent;transition:all .4s ease-out}.rpb-back-done{fill:#008a24;stroke:#008a24;stroke-dasharray:initial}.rpb-arc{stroke:#056dae;fill:transparent;stroke-linecap:round;transform-origin:50% 50%;transform:rotate(-90deg);animation:rpb-animate-arc .4s ease-out forwards;transition:all .4s ease-out}.rpb-arc-done{fill:#008a24;stroke:#008a24;stroke-dasharray:initial}@keyframes rpb-animate-arc{to{stroke-dashoffset:0}}.rpb-done-check{fill:none;stroke:#fff}\n"] }]
        }], ctorParameters: () => [{ type: CitiLiveAnnouncer }], propDecorators: { percent: [{
                type: Input$1
            }], diameter: [{
                type: Input$1
            }], progressStrokeWidth: [{
                type: Input$1
            }], baseStrokeWidth: [{
                type: Input$1
            }], stepText: [{
                type: Input$1
            }], announceText: [{
                type: Input$1
            }] } });

const COMPONENTS$S = [RadialProgressBarComponent];
class RadialProgressBar {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: RadialProgressBar, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: RadialProgressBar, declarations: [RadialProgressBarComponent], imports: [CommonModule], exports: [RadialProgressBarComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: RadialProgressBar, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: RadialProgressBar, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [...COMPONENTS$S],
                    exports: [...COMPONENTS$S]
                }]
        }] });

const SlideInOutAnimation = [
    trigger('slideDrawer', [
        state('left', style({
            transform: 'translateX(-29%)'
        })),
        state('right', style({
            transform: 'translateX(0)'
        })),
        transition('* => *', animate(200))
    ])
];

class DrawerComponent {
    open() {
        this.direction = 'left';
        this.openDrawer = true;
        if (!this.turnOffAnnouncement)
            this.liveAnnouncer.announce(this.drawerOpenedAnnouncement);
    }
    close() {
        if (this.openDrawer)
            this.direction = 'right';
        if (!this.turnOffAnnouncement)
            this.liveAnnouncer.announce(this.drawerClosedAnnouncement);
        return true;
    }
    toggle() {
        this.direction == 'left' ? this.close() : this.open();
    }
    checkIfOpen() {
        if (this.direction == 'left')
            return true;
        else
            return false;
    }
    constructor(liveAnnouncer, mediaMatcher) {
        this.liveAnnouncer = liveAnnouncer;
        this.mediaMatcher = mediaMatcher;
        /**
         * @property: openDrawer
         * @description sets openDrawer to true if the drawer is open, else sets to false.
         * @type: boolean
         */
        this.openDrawer = false;
        /**
         * @property: direction
         * @description sets the animation direction for the drawer. Valid directions are left or right.
         * @type: string
         */
        this.direction = 'right';
        /**
         * @property: contentPanelOpenPercent
         * @description determines how much of the percentage of content drawer to open.
         * @type: number
         */
        this.contentPanelOpenPercent = 60;
        /**
         * @property: actionPanelOpenPercent
         * @description determines how much of the percentage of action drawer to open.
         * @type: number
         */
        this.actionPanelOpenPercent = 40;
        /**
         * @property: drawerOpenedAnnouncement
         * @description determines the message to read when drawer is opened.
         * @type: string
         */
        this.drawerOpenedAnnouncement = 'Drawer Opened';
        /**
         * @property: drawerClosedAnnouncement
         * @description  determines the message to read when drawer is closed.
         * @type: string
         */
        this.drawerClosedAnnouncement = 'Drawer Closed';
        /**
         * @property: turn off announcement
         * @description  determines the message to read when drawer is closed.
         * @type: string
         */
        this.turnOffAnnouncement = false;
        this.drawerClick = new EventEmitter();
        if (isDevMode()) {
            console.error('%cThe Common UI DDL Drawer <citi-drawer> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    ngOnInit() {
        this.matcher = this.mediaMatcher.matchMedia('(max-width: 767px)');
        if (this.matcher.matches) {
            this.contentPanelOpenPercent = 40;
            this.actionPanelOpenPercent = 60;
        }
    }
    onDrawerClick(event) {
        event.preventDefault();
        this.drawerClick.emit(event);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: DrawerComponent, deps: [{ token: i1$3.LiveAnnouncer }, { token: i2$1.MediaMatcher }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: DrawerComponent, isStandalone: false, selector: "citi-drawer", inputs: { contentPanelStyle: "contentPanelStyle", actionPanelStyle: "actionPanelStyle", actionPanelBgColor: "actionPanelBgColor", contentPanelBgColor: "contentPanelBgColor", openDrawer: "openDrawer", direction: "direction", contentPanelOpenPercent: "contentPanelOpenPercent", actionPanelOpenPercent: "actionPanelOpenPercent", drawerOpenedAnnouncement: "drawerOpenedAnnouncement", drawerClosedAnnouncement: "drawerClosedAnnouncement", turnOffAnnouncement: "turnOffAnnouncement" }, outputs: { drawerClick: "drawerClick" }, viewQueries: [{ propertyName: "contentPanelWrap", first: true, predicate: ["contentPanelWrap"], descendants: true }, { propertyName: "actionPanelWrap", first: true, predicate: ["actionPanelWrap"], descendants: true }], ngImport: i0, template: `
    <div [@slideDrawer]="direction" class="ddl-drawer-wrapper">
      <div
        #contentPanelWrap
        class="contentPanel"
        [ngStyle]="contentPanelStyle"
        [style.background-color]="contentPanelBgColor"
        [style.width]="checkIfOpen() ? contentPanelOpenPercent + '%' : '71%'"
        (click)="onDrawerClick($event)"
        tabindex="0"
      >
        <ng-content select="[contentPanel]"></ng-content>
      </div>

      <div
        #actionPanelWrap
        class="actionPanel"
        [ngStyle]="actionPanelStyle"
        [style.background-color]="actionPanelBgColor"
        [style.width]="checkIfOpen() ? actionPanelOpenPercent + '%' : ''"
        [attr.aria-hidden]="checkIfOpen() === true ? false : true"
      >
        <ng-content select="[actionPanel]"></ng-content>
      </div>
    </div>
  `, isInline: true, styles: [":host{font-family:Interstate_Light,sans-serif;font-size:15px;padding:5px 0}:host .ddl-drawer-wrapper{display:flex;width:145%}:host .ddl-drawer-wrapper .contentPanel{padding:6px;background-color:#fff}:host .ddl-drawer-wrapper .contentPanel:hover{background-color:#f4f4f4}:host .ddl-drawer-wrapper .actionPanel{background-color:#ebebeb}@media only screen and (max-width: 767px){:host .cds-drawer-wrapper{width:159%}}\n"], dependencies: [{ kind: "directive", type: i1$1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }], animations: [SlideInOutAnimation] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: DrawerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-drawer', standalone: false, animations: [SlideInOutAnimation], template: `
    <div [@slideDrawer]="direction" class="ddl-drawer-wrapper">
      <div
        #contentPanelWrap
        class="contentPanel"
        [ngStyle]="contentPanelStyle"
        [style.background-color]="contentPanelBgColor"
        [style.width]="checkIfOpen() ? contentPanelOpenPercent + '%' : '71%'"
        (click)="onDrawerClick($event)"
        tabindex="0"
      >
        <ng-content select="[contentPanel]"></ng-content>
      </div>

      <div
        #actionPanelWrap
        class="actionPanel"
        [ngStyle]="actionPanelStyle"
        [style.background-color]="actionPanelBgColor"
        [style.width]="checkIfOpen() ? actionPanelOpenPercent + '%' : ''"
        [attr.aria-hidden]="checkIfOpen() === true ? false : true"
      >
        <ng-content select="[actionPanel]"></ng-content>
      </div>
    </div>
  `, styles: [":host{font-family:Interstate_Light,sans-serif;font-size:15px;padding:5px 0}:host .ddl-drawer-wrapper{display:flex;width:145%}:host .ddl-drawer-wrapper .contentPanel{padding:6px;background-color:#fff}:host .ddl-drawer-wrapper .contentPanel:hover{background-color:#f4f4f4}:host .ddl-drawer-wrapper .actionPanel{background-color:#ebebeb}@media only screen and (max-width: 767px){:host .cds-drawer-wrapper{width:159%}}\n"] }]
        }], ctorParameters: () => [{ type: i1$3.LiveAnnouncer }, { type: i2$1.MediaMatcher }], propDecorators: { contentPanelWrap: [{
                type: ViewChild,
                args: ['contentPanelWrap']
            }], actionPanelWrap: [{
                type: ViewChild,
                args: ['actionPanelWrap']
            }], contentPanelStyle: [{
                type: Input$1
            }], actionPanelStyle: [{
                type: Input$1
            }], actionPanelBgColor: [{
                type: Input$1
            }], contentPanelBgColor: [{
                type: Input$1
            }], openDrawer: [{
                type: Input$1
            }], direction: [{
                type: Input$1
            }], contentPanelOpenPercent: [{
                type: Input$1
            }], actionPanelOpenPercent: [{
                type: Input$1
            }], drawerOpenedAnnouncement: [{
                type: Input$1
            }], drawerClosedAnnouncement: [{
                type: Input$1
            }], turnOffAnnouncement: [{
                type: Input$1
            }], drawerClick: [{
                type: Output
            }] } });

class Drawer {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Drawer, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: Drawer, declarations: [DrawerComponent], imports: [CommonModule], exports: [DrawerComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Drawer, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Drawer, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DrawerComponent],
                    imports: [CommonModule],
                    exports: [DrawerComponent]
                }]
        }] });

class AlertComponent {
    /**
     * @property type
     * @description Sets the different types of alert. Acceptable values include 'alert', 'critical', and 'alertBox'.
     * @return string
     */
    set type(type) {
        this.alertType = type;
    }
    /**
     * @property enableAlertBackground
     * @description Enables/disables the grey background
     * @return string
     */
    set enableAlertBackground(value) {
        this._enableAlertBackground = value;
        this.generateCssClassString();
    }
    /**
     * @property isPageLevelAlert
     * @description Is this alert is a page level alert
     * @return string
     */
    set isPageLevelAlert(value) {
        this._isPageLevelAlert = value;
        this.generateCssClassString();
    }
    /**
     * @property disabledBorder
     * @description Disables/enables red left border in an alert box
     * @return string
     */
    set disabledBorder(value) {
        this._disabledBorder = value;
        this.generateCssClassString();
    }
    get disabledBorder() {
        return this._disabledBorder;
    }
    constructor() {
        this.alertClass = 'ct-alert';
        this.criticalClass = 'ct-critical';
        this.alertBoxClass = 'ct-alert-box';
        this._enableAlertBackground = false;
        this._isPageLevelAlert = false;
        this.alertType = 'alert';
        this._disabledBorder = false;
        /**
         * @property notice
         * @description The label 'Alert' notice span is included if this is set to true
         * @Type: boolean
         */
        this.notice = false;
        /**
         * @property noticeText
         * @description Text to display as a message
         * @return string
         */
        this.alertText = 'Alert!';
    }
    generateCssClassString() {
        let componentArray = [];
        let notAlertBoxType = this.alertType !== 'alertBox' && this.alertType !== 'alertBoxSuccess'
            && this.alertType !== 'alertBoxCritical';
        let isAlertBoxType = !notAlertBoxType;
        let isAlertBoxWithIcon = this.alertType === 'alertBoxSuccess' || this.alertType === 'alertBoxCritical';
        if (isAlertBoxType) {
            componentArray.push(this.alertBoxClass);
            // Disables the grey background if required
            if (this._disabledBorder) {
                componentArray.push('ct-no-left-border');
            }
        }
        else {
            componentArray.push(this.alertClass);
        }
        if (isAlertBoxWithIcon) {
            componentArray.push('ct-alert-box-icon');
        }
        if (this._isPageLevelAlert) {
            componentArray.push('ct-alert');
            componentArray.push('ct-page-level-alert');
        }
        else {
            switch (this.alertType) {
                case 'critical':
                    componentArray.push(this.criticalClass);
                    break;
                case 'alertBoxSuccess':
                    componentArray.push('ct-alert-box-success');
                    break;
                case 'alertBoxCritical':
                    componentArray.push('ct-alert-box-critical');
                    break;
            }
            // If the alert type is not alert box but consumers still to want grey background,
            // adds the CSS class for the grey background
            if (notAlertBoxType && this._enableAlertBackground) {
                componentArray.push('ct-theme-gray');
            }
        }
        this.cssClass = componentArray.join(' ');
    }
    ngOnInit() {
        this.generateCssClassString();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: AlertComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: AlertComponent, isStandalone: false, selector: "citi-alert", inputs: { criticalAlertSRText: "criticalAlertSRText", alertSRText: "alertSRText", type: "type", enableAlertBackground: "enableAlertBackground", isPageLevelAlert: "isPageLevelAlert", notice: "notice", noticeText: "noticeText", alertText: "alertText", disabledBorder: "disabledBorder" }, ngImport: i0, template: `
  <div *ngIf="_isPageLevelAlert" [ngClass]="cssClass" [ngStyle]="{display: 'block'}">
    <div class="ct-message">
      <span *ngIf="notice" class="ct-strong">
        <span *ngIf="criticalAlertSRText" class="ct-sr-only">{{criticalAlertSRText}}</span>
        <span [innerHtml]="noticeText"></span>
      </span>
      <span [innerHtml]="alertText"></span>
    </div>
  </div>
  <div *ngIf="!_isPageLevelAlert" [ngClass]="cssClass">
    <span *ngIf="!notice && alertSRText" class="ct-sr-only">{{alertSRText}}</span>
    <div class="ct-message">
      <span *ngIf="notice" class="ct-strong">
        <span *ngIf="criticalAlertSRText" class="ct-sr-only">{{criticalAlertSRText}}</span>
        <span [innerHtml]="noticeText"></span>
      </span>
      <span [innerHtml]="alertText"></span>
    </div>
  </div>
  `, isInline: true, styles: [".ct-alert{padding:15px;margin-bottom:24px;border:1px solid transparent;border-radius:6px;position:relative;font-family:Interstate_Bold,sans-serif}.ct-alert:before{content:\"\";background-position:center center;position:absolute;top:20px;background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%20standalone%3D%22no%22%3F%3E%0A%3Csvg%20width%3D%2216px%22%20height%3D%2216px%22%20viewBox%3D%220%200%2016%2016%22%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%3E%0A%20%20%20%20%3C%21--%20Generator%3A%20Sketch%2040%20%2833762%29%20-%20http%3A//www.bohemiancoding.com/sketch%20--%3E%0A%20%20%20%20%3Ctitle%3EAlert%20Bubble%3C/title%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C/desc%3E%0A%20%20%20%20%3Cdefs%3E%3C/defs%3E%0A%20%20%20%20%3Cg%20id%3D%22P2.-DDL-1.1.5-Components%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%222.5_Components_Miscellaneous%22%20transform%3D%22translate%28-256.000000%2C%20-3998.000000%29%22%20fill%3D%22%23056DAE%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Tooltips-%26amp%3B-Helper-Text%22%20transform%3D%22translate%2819.000000%2C%203802.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Alert%22%20transform%3D%22translate%28235.000000%2C%2084.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%280.000000%2C%20105.000000%29%22%20id%3D%22Alert-Bubble%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%280.000000%2C%204.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icon%22%20transform%3D%22translate%282.000000%2C%203.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Sq%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2216%22%20height%3D%2211%22%3E%3C/rect%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpolygon%20id%3D%22Tri%22%20points%3D%224%2011%2011%2011%204%2016%22%3E%3C/polygon%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%3C/g%3E%0A%3C/svg%3E);background-repeat:no-repeat;background-size:auto;display:inline-block;text-indent:-9999em;background-size:100%;width:15px;height:15px}.ct-page-level-alert{display:none;margin-top:20px;margin-bottom:-10px}.ct-page-level-alert:before{top:16px;background-size:contain;background-position:center center;height:20px;width:20px;margin-left:-15px}.ct-page-level-alert span{margin-left:14px;display:block}.ct-page-level-alert div.ct-message{margin-left:0}.ct-alert-box{background-color:#eee;padding:40px 40px 40px 30px;border-left:2px solid #D60000;margin-top:40px}.theme-light .ct-alert-box{background-color:#eee}.ct-alert-box-critical:before{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%20standalone%3D%22no%22%3F%3E%0D%0A%3Csvg%20width%3D%2212px%22%20height%3D%229px%22%20viewBox%3D%220%200%2012%209%22%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20xmlns%3Asketch%3D%22http%3A//www.bohemiancoding.com/sketch/ns%22%3E%0D%0A%20%20%20%20%3C%21--%20Generator%3A%20Sketch%203.4.2%20%2815857%29%20-%20http%3A//www.bohemiancoding.com/sketch%20--%3E%0D%0A%20%20%20%20%3Ctitle%3ECheck01%3C/title%3E%0D%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C/desc%3E%0D%0A%20%20%20%20%3Cdefs%3E%3C/defs%3E%0D%0A%20%20%20%20%3Cg%20id%3D%22Toolkit/Grey-Background%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20sketch%3Atype%3D%22MSPage%22%3E%0D%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Buttons-Links-Lists%22%20sketch%3Atype%3D%22MSArtboardGroup%22%20transform%3D%22translate%28-204.000000%2C%20-1318.000000%29%22%20stroke%3D%22%23006E0A%22%20stroke-width%3D%222%22%3E%0D%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Check-List%22%20sketch%3Atype%3D%22MSLayerGroup%22%20transform%3D%22translate%28190.000000%2C%201313.000000%29%22%3E%0D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M15%2C8.72606345%20L18.5302555%2C12%20L25%2C6%22%20id%3D%22Check01%22%20sketch%3Atype%3D%22MSShapeGroup%22%3E%3C/path%3E%0D%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0D%0A%20%20%20%20%20%20%20%20%3C/g%3E%0D%0A%20%20%20%20%3C/g%3E%0D%0A%3C/svg%3E);background-repeat:no-repeat;width:20px;height:20px;top:42px}.ct-alert-box-success:before{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%20standalone%3D%22no%22%3F%3E%0D%0A%3Csvg%20width%3D%2212px%22%20height%3D%229px%22%20viewBox%3D%220%200%2012%209%22%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20xmlns%3Asketch%3D%22http%3A//www.bohemiancoding.com/sketch/ns%22%3E%0D%0A%20%20%20%20%3C%21--%20Generator%3A%20Sketch%203.4.2%20%2815857%29%20-%20http%3A//www.bohemiancoding.com/sketch%20--%3E%0D%0A%20%20%20%20%3Ctitle%3ECheck01%3C/title%3E%0D%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C/desc%3E%0D%0A%20%20%20%20%3Cdefs%3E%3C/defs%3E%0D%0A%20%20%20%20%3Cg%20id%3D%22Toolkit/Grey-Background%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20sketch%3Atype%3D%22MSPage%22%3E%0D%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Buttons-Links-Lists%22%20sketch%3Atype%3D%22MSArtboardGroup%22%20transform%3D%22translate%28-204.000000%2C%20-1318.000000%29%22%20stroke%3D%22%23006E0A%22%20stroke-width%3D%222%22%3E%0D%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Check-List%22%20sketch%3Atype%3D%22MSLayerGroup%22%20transform%3D%22translate%28190.000000%2C%201313.000000%29%22%3E%0D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M15%2C8.72606345%20L18.5302555%2C12%20L25%2C6%22%20id%3D%22Check01%22%20sketch%3Atype%3D%22MSShapeGroup%22%3E%3C/path%3E%0D%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0D%0A%20%20%20%20%20%20%20%20%3C/g%3E%0D%0A%20%20%20%20%3C/g%3E%0D%0A%3C/svg%3E);background-repeat:no-repeat;width:10px;height:10px;top:45px}.ct-theme-gray{background-color:#eee}.ct-critical:before{top:16px;background-size:contain;background-position:center center;height:20px;width:20px}.ct-critical .ct-message{margin-left:30px}.ct-critical:before,.ct-page-level-alert:before{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%20standalone%3D%22no%22%3F%3E%0A%3Csvg%20width%3D%2220px%22%20height%3D%2220px%22%20viewBox%3D%220%200%2020%2020%22%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%3E%0A%20%20%20%20%3C%21--%20Generator%3A%20Sketch%2040%20%2833762%29%20-%20http%3A//www.bohemiancoding.com/sketch%20--%3E%0A%20%20%20%20%3Ctitle%3EGroup%3C/title%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C/desc%3E%0A%20%20%20%20%3Cdefs%3E%3C/defs%3E%0A%20%20%20%20%3Cg%20id%3D%22P2.-DDL-1.1.5-Components%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%222.5_Components_Miscellaneous%22%20transform%3D%22translate%28-254.000000%2C%20-4247.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Tooltips-%26amp%3B-Helper-Text%22%20transform%3D%22translate%2819.000000%2C%203802.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Critical-Alert%22%20transform%3D%22translate%28235.000000%2C%20335.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%280.000000%2C%20107.000000%29%22%20id%3D%22Group%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%280.000000%2C%203.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22red-base%22%20fill%3D%22%23D60000%22%20cx%3D%2210%22%20cy%3D%2210%22%20r%3D%2210%22%3E%3C/circle%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M11.48%2C8.608%20L11.48%2C4%20L9.24%2C4%20L9.24%2C8.608%20L9.608%2C11.68%20L11.112%2C11.68%20L11.48%2C8.608%20Z%20M11.72%2C14.016%20C11.72%2C13.28%2011.096%2C12.656%2010.36%2C12.656%20C9.624%2C12.656%209%2C13.28%209%2C14.016%20C9%2C14.752%209.624%2C15.376%2010.36%2C15.376%20C11.096%2C15.376%2011.72%2C14.752%2011.72%2C14.016%20L11.72%2C14.016%20Z%22%20id%3D%22%21%22%20fill%3D%22%23FFFFFF%22%3E%3C/path%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%3C/g%3E%0A%3C/svg%3E);background-repeat:no-repeat}.ct-message{margin-left:22px}.ct-message .ct-strong{color:#d60000}.ct-no-left-border{border:none}.ct-alert-box-success,.ct-alert-box-critical{position:relative}.ct-alert-box-icon:before{content:\"\";background-repeat:no-repeat;background-position:center center;position:absolute}.ct-alert-box-success div.ct-message{margin-left:22px}.ct-alert-box-critical div.ct-message{margin-left:30px}.ct-sr-only{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: AlertComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-alert', standalone: false, template: `
  <div *ngIf="_isPageLevelAlert" [ngClass]="cssClass" [ngStyle]="{display: 'block'}">
    <div class="ct-message">
      <span *ngIf="notice" class="ct-strong">
        <span *ngIf="criticalAlertSRText" class="ct-sr-only">{{criticalAlertSRText}}</span>
        <span [innerHtml]="noticeText"></span>
      </span>
      <span [innerHtml]="alertText"></span>
    </div>
  </div>
  <div *ngIf="!_isPageLevelAlert" [ngClass]="cssClass">
    <span *ngIf="!notice && alertSRText" class="ct-sr-only">{{alertSRText}}</span>
    <div class="ct-message">
      <span *ngIf="notice" class="ct-strong">
        <span *ngIf="criticalAlertSRText" class="ct-sr-only">{{criticalAlertSRText}}</span>
        <span [innerHtml]="noticeText"></span>
      </span>
      <span [innerHtml]="alertText"></span>
    </div>
  </div>
  `, styles: [".ct-alert{padding:15px;margin-bottom:24px;border:1px solid transparent;border-radius:6px;position:relative;font-family:Interstate_Bold,sans-serif}.ct-alert:before{content:\"\";background-position:center center;position:absolute;top:20px;background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%20standalone%3D%22no%22%3F%3E%0A%3Csvg%20width%3D%2216px%22%20height%3D%2216px%22%20viewBox%3D%220%200%2016%2016%22%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%3E%0A%20%20%20%20%3C%21--%20Generator%3A%20Sketch%2040%20%2833762%29%20-%20http%3A//www.bohemiancoding.com/sketch%20--%3E%0A%20%20%20%20%3Ctitle%3EAlert%20Bubble%3C/title%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C/desc%3E%0A%20%20%20%20%3Cdefs%3E%3C/defs%3E%0A%20%20%20%20%3Cg%20id%3D%22P2.-DDL-1.1.5-Components%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%222.5_Components_Miscellaneous%22%20transform%3D%22translate%28-256.000000%2C%20-3998.000000%29%22%20fill%3D%22%23056DAE%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Tooltips-%26amp%3B-Helper-Text%22%20transform%3D%22translate%2819.000000%2C%203802.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Alert%22%20transform%3D%22translate%28235.000000%2C%2084.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%280.000000%2C%20105.000000%29%22%20id%3D%22Alert-Bubble%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%280.000000%2C%204.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icon%22%20transform%3D%22translate%282.000000%2C%203.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Sq%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2216%22%20height%3D%2211%22%3E%3C/rect%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpolygon%20id%3D%22Tri%22%20points%3D%224%2011%2011%2011%204%2016%22%3E%3C/polygon%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%3C/g%3E%0A%3C/svg%3E);background-repeat:no-repeat;background-size:auto;display:inline-block;text-indent:-9999em;background-size:100%;width:15px;height:15px}.ct-page-level-alert{display:none;margin-top:20px;margin-bottom:-10px}.ct-page-level-alert:before{top:16px;background-size:contain;background-position:center center;height:20px;width:20px;margin-left:-15px}.ct-page-level-alert span{margin-left:14px;display:block}.ct-page-level-alert div.ct-message{margin-left:0}.ct-alert-box{background-color:#eee;padding:40px 40px 40px 30px;border-left:2px solid #D60000;margin-top:40px}.theme-light .ct-alert-box{background-color:#eee}.ct-alert-box-critical:before{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%20standalone%3D%22no%22%3F%3E%0D%0A%3Csvg%20width%3D%2212px%22%20height%3D%229px%22%20viewBox%3D%220%200%2012%209%22%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20xmlns%3Asketch%3D%22http%3A//www.bohemiancoding.com/sketch/ns%22%3E%0D%0A%20%20%20%20%3C%21--%20Generator%3A%20Sketch%203.4.2%20%2815857%29%20-%20http%3A//www.bohemiancoding.com/sketch%20--%3E%0D%0A%20%20%20%20%3Ctitle%3ECheck01%3C/title%3E%0D%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C/desc%3E%0D%0A%20%20%20%20%3Cdefs%3E%3C/defs%3E%0D%0A%20%20%20%20%3Cg%20id%3D%22Toolkit/Grey-Background%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20sketch%3Atype%3D%22MSPage%22%3E%0D%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Buttons-Links-Lists%22%20sketch%3Atype%3D%22MSArtboardGroup%22%20transform%3D%22translate%28-204.000000%2C%20-1318.000000%29%22%20stroke%3D%22%23006E0A%22%20stroke-width%3D%222%22%3E%0D%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Check-List%22%20sketch%3Atype%3D%22MSLayerGroup%22%20transform%3D%22translate%28190.000000%2C%201313.000000%29%22%3E%0D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M15%2C8.72606345%20L18.5302555%2C12%20L25%2C6%22%20id%3D%22Check01%22%20sketch%3Atype%3D%22MSShapeGroup%22%3E%3C/path%3E%0D%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0D%0A%20%20%20%20%20%20%20%20%3C/g%3E%0D%0A%20%20%20%20%3C/g%3E%0D%0A%3C/svg%3E);background-repeat:no-repeat;width:20px;height:20px;top:42px}.ct-alert-box-success:before{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%20standalone%3D%22no%22%3F%3E%0D%0A%3Csvg%20width%3D%2212px%22%20height%3D%229px%22%20viewBox%3D%220%200%2012%209%22%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20xmlns%3Asketch%3D%22http%3A//www.bohemiancoding.com/sketch/ns%22%3E%0D%0A%20%20%20%20%3C%21--%20Generator%3A%20Sketch%203.4.2%20%2815857%29%20-%20http%3A//www.bohemiancoding.com/sketch%20--%3E%0D%0A%20%20%20%20%3Ctitle%3ECheck01%3C/title%3E%0D%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C/desc%3E%0D%0A%20%20%20%20%3Cdefs%3E%3C/defs%3E%0D%0A%20%20%20%20%3Cg%20id%3D%22Toolkit/Grey-Background%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20sketch%3Atype%3D%22MSPage%22%3E%0D%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Buttons-Links-Lists%22%20sketch%3Atype%3D%22MSArtboardGroup%22%20transform%3D%22translate%28-204.000000%2C%20-1318.000000%29%22%20stroke%3D%22%23006E0A%22%20stroke-width%3D%222%22%3E%0D%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Check-List%22%20sketch%3Atype%3D%22MSLayerGroup%22%20transform%3D%22translate%28190.000000%2C%201313.000000%29%22%3E%0D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M15%2C8.72606345%20L18.5302555%2C12%20L25%2C6%22%20id%3D%22Check01%22%20sketch%3Atype%3D%22MSShapeGroup%22%3E%3C/path%3E%0D%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0D%0A%20%20%20%20%20%20%20%20%3C/g%3E%0D%0A%20%20%20%20%3C/g%3E%0D%0A%3C/svg%3E);background-repeat:no-repeat;width:10px;height:10px;top:45px}.ct-theme-gray{background-color:#eee}.ct-critical:before{top:16px;background-size:contain;background-position:center center;height:20px;width:20px}.ct-critical .ct-message{margin-left:30px}.ct-critical:before,.ct-page-level-alert:before{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%20standalone%3D%22no%22%3F%3E%0A%3Csvg%20width%3D%2220px%22%20height%3D%2220px%22%20viewBox%3D%220%200%2020%2020%22%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%3E%0A%20%20%20%20%3C%21--%20Generator%3A%20Sketch%2040%20%2833762%29%20-%20http%3A//www.bohemiancoding.com/sketch%20--%3E%0A%20%20%20%20%3Ctitle%3EGroup%3C/title%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C/desc%3E%0A%20%20%20%20%3Cdefs%3E%3C/defs%3E%0A%20%20%20%20%3Cg%20id%3D%22P2.-DDL-1.1.5-Components%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%222.5_Components_Miscellaneous%22%20transform%3D%22translate%28-254.000000%2C%20-4247.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Tooltips-%26amp%3B-Helper-Text%22%20transform%3D%22translate%2819.000000%2C%203802.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Critical-Alert%22%20transform%3D%22translate%28235.000000%2C%20335.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%280.000000%2C%20107.000000%29%22%20id%3D%22Group%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%280.000000%2C%203.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22red-base%22%20fill%3D%22%23D60000%22%20cx%3D%2210%22%20cy%3D%2210%22%20r%3D%2210%22%3E%3C/circle%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M11.48%2C8.608%20L11.48%2C4%20L9.24%2C4%20L9.24%2C8.608%20L9.608%2C11.68%20L11.112%2C11.68%20L11.48%2C8.608%20Z%20M11.72%2C14.016%20C11.72%2C13.28%2011.096%2C12.656%2010.36%2C12.656%20C9.624%2C12.656%209%2C13.28%209%2C14.016%20C9%2C14.752%209.624%2C15.376%2010.36%2C15.376%20C11.096%2C15.376%2011.72%2C14.752%2011.72%2C14.016%20L11.72%2C14.016%20Z%22%20id%3D%22%21%22%20fill%3D%22%23FFFFFF%22%3E%3C/path%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%3C/g%3E%0A%3C/svg%3E);background-repeat:no-repeat}.ct-message{margin-left:22px}.ct-message .ct-strong{color:#d60000}.ct-no-left-border{border:none}.ct-alert-box-success,.ct-alert-box-critical{position:relative}.ct-alert-box-icon:before{content:\"\";background-repeat:no-repeat;background-position:center center;position:absolute}.ct-alert-box-success div.ct-message{margin-left:22px}.ct-alert-box-critical div.ct-message{margin-left:30px}.ct-sr-only{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0}\n"] }]
        }], ctorParameters: () => [], propDecorators: { criticalAlertSRText: [{
                type: Input$1
            }], alertSRText: [{
                type: Input$1
            }], type: [{
                type: Input$1
            }], enableAlertBackground: [{
                type: Input$1
            }], isPageLevelAlert: [{
                type: Input$1
            }], notice: [{
                type: Input$1
            }], noticeText: [{
                type: Input$1
            }], alertText: [{
                type: Input$1
            }], disabledBorder: [{
                type: Input$1
            }] } });

const COMPONENTS$R = [
    AlertComponent
];
const MODULES$S = [
    CommonModule
];
class Alert {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Alert, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: Alert, declarations: [AlertComponent], imports: [CommonModule], exports: [AlertComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Alert, imports: [MODULES$S] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Alert, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$S],
                    declarations: [...COMPONENTS$R],
                    exports: [AlertComponent]
                }]
        }] });

var Direction;
(function (Direction) {
    Direction[Direction["UNKNOWN"] = 0] = "UNKNOWN";
    Direction[Direction["NEXT"] = 1] = "NEXT";
    Direction[Direction["PREV"] = 2] = "PREV";
})(Direction || (Direction = {}));
class Carousel {
    constructor() {
        /**
        * @property ISSlideArrowReq
        * @description whether to display next slider arrow
        * @Type: boolean - by default false
        */
        this.ISSlideArrowReq = false;
        this.constants = {
            MESSAGE_PAUSED: 'carousel paused',
            MESSAGE_RESUMED: 'carousel resumed'
        };
        this.destroyed = false;
        this.hasFocus = false;
        this.isShowInstructions = false;
        this.isUserPaused = false;
        this.slides = [];
    }
    /**
     * @name interval
     * @description Gets the current transitioning interval
     * @return Number
     */
    get interval() {
        return this._interval;
    }
    /**
     * @name interval
     * @description To set the time interval to slide the carousel image
     * @param value new interval for changing the displayed image
     * @return void
     */
    set interval(value) {
        this._interval = value;
        this.restartTimer();
    }
    ngOnDestroy() {
        this.destroyed = true;
    }
    /**
     * @name select
     * @description this function will be triggered when next/prev will be clicked.
     * @param (CarouselSlide) - nextSlide - the next slide to be displayed
     * @param (direction) - Direction - the direction will be based on the next/prev
     * @return void
     */
    select(nextSlide, direction = Direction.UNKNOWN) {
        let nextIndex = nextSlide.index;
        if (direction === Direction.UNKNOWN) {
            direction = nextIndex > this.getCurrentIndex() ? Direction.NEXT : Direction.PREV;
        }
        // Prevent this user-triggered transition from occurring if there is already one in progress
        if (nextSlide && nextSlide !== this.currentSlide) {
            this.goNext(nextSlide, direction);
        }
    }
    goNext(slide, direction) {
        if (this.destroyed) {
            return;
        }
        slide.direction = direction;
        slide.active = true;
        if (this.currentSlide) {
            this.currentSlide.direction = direction;
            this.currentSlide.active = false;
        }
        this.currentSlide = slide;
        // every time you change slides, reset the timer
        this.restartTimer();
    }
    getSlideByIndex(index) {
        let len = this.slides.length;
        for (let i = 0; i < len; ++i) {
            if (this.slides[i].index === index) {
                return this.slides[i];
            }
        }
    }
    getCurrentIndex() {
        return !this.currentSlide ? 0 : this.currentSlide.index;
    }
    handleBlur() {
        this.hasFocus = false;
        this.isShowInstructions = false;
        this.setPauseStateMessage(this.isUserPaused);
        this.play();
    }
    handleFocus() {
        this.hasFocus = true;
        //if (this.isShowInstructions) {
        this.setPauseStateMessage(this.isUserPaused);
        this.pause();
        // }
    }
    handleKeyPress(event) {
        let keycode = event.which;
        switch (keycode) {
            case KEY_SPACEBAR:
                this.stopBubble(event);
                if (this.isUserPaused) {
                    this.isUserPaused = false;
                    this.setPauseStateMessage(this.isUserPaused);
                    this.play();
                }
                else {
                    this.isUserPaused = true;
                    this.setPauseStateMessage(this.isUserPaused);
                    this.pause();
                }
                break;
            case KEY_HOME:
            case KEY_PAGE_UP:
                this.stopBubble(event);
                this.select(this.getSlideByIndex(0), Direction.PREV);
                break;
            case KEY_END:
            case KEY_PAGE_DOWN:
                this.stopBubble(event);
                this.select(this.getSlideByIndex(this.slides.length - 1), Direction.NEXT);
                break;
            case KEY_ARROW_LEFT:
            case KEY_ARROW_UP:
                this.stopBubble(event);
                this.prev();
                break;
            case KEY_ARROW_RIGHT:
            case KEY_ARROW_DOWN:
                this.stopBubble(event);
                this.next();
                break;
            case KEY_1:
            case KEY_NUMPAD_1:
                if (this.slides[0]) {
                    this.stopBubble(event);
                    this.select(this.getSlideByIndex(0), Direction.UNKNOWN);
                }
                break;
            case KEY_2:
            case KEY_NUMPAD_2:
                if (this.slides[1]) {
                    this.stopBubble(event);
                    this.select(this.getSlideByIndex(1), Direction.UNKNOWN);
                }
                break;
            case KEY_3:
            case KEY_NUMPAD_3:
                if (this.slides[2]) {
                    this.stopBubble(event);
                    this.select(this.getSlideByIndex(2), Direction.UNKNOWN);
                }
                break;
            case KEY_4:
            case KEY_NUMPAD_4:
                if (this.slides[3]) {
                    this.stopBubble(event);
                    this.select(this.getSlideByIndex(3), Direction.UNKNOWN);
                }
                break;
            case KEY_5:
            case KEY_NUMPAD_5:
                if (this.slides[4]) {
                    this.stopBubble(event);
                    this.select(this.getSlideByIndex(4), Direction.UNKNOWN);
                }
                break;
            case KEY_6:
            case KEY_NUMPAD_6:
                if (this.slides[5]) {
                    this.stopBubble(event);
                    this.select(this.getSlideByIndex(5), Direction.UNKNOWN);
                }
                break;
            case KEY_7:
            case KEY_NUMPAD_7:
                if (this.slides[6]) {
                    this.stopBubble(event);
                    this.select(this.getSlideByIndex(6), Direction.UNKNOWN);
                }
                break;
            case KEY_8:
            case KEY_NUMPAD_8:
                if (this.slides[7]) {
                    this.stopBubble(event);
                    this.select(this.getSlideByIndex(7), Direction.UNKNOWN);
                }
                break;
            case KEY_9:
            case KEY_NUMPAD_9:
                if (this.slides[8]) {
                    this.stopBubble(event);
                    this.select(this.getSlideByIndex(8), Direction.UNKNOWN);
                }
                break;
            case KEY_0:
            case KEY_NUMPAD_0:
                if (this.slides[9]) {
                    this.stopBubble(event);
                    this.select(this.getSlideByIndex(9), Direction.UNKNOWN);
                }
                break;
        }
    }
    handleKeyUp(event) {
        if (event.which === KEY_TAB) {
            this.isShowInstructions = true;
        }
    }
    /* load next slide */
    next() {
        let newIndex = (this.getCurrentIndex() + 1) % this.slides.length;
        if (newIndex === 0 && this.noWrap) {
            this.pause();
            return;
        }
        return this.select(this.getSlideByIndex(newIndex), Direction.NEXT);
    }
    /* load previous slide */
    prev() {
        let newIndex = this.getCurrentIndex() - 1 < 0 ? this.slides.length - 1 : this.getCurrentIndex() - 1;
        if (this.noWrap && newIndex === this.slides.length - 1) {
            this.pause();
            return;
        }
        return this.select(this.getSlideByIndex(newIndex), Direction.PREV);
    }
    /* this function will be triggered to reset and initiate the interval */
    restartTimer() {
        this.resetTimer();
        let interval = +this.interval;
        if (!isNaN(interval) && interval > 0) {
            this.currentInterval = setInterval(() => {
                let nInterval = +this.interval;
                if (this.isPlaying && !isNaN(this.interval) && nInterval > 0 && this.slides.length) {
                    this.next();
                }
                else {
                    this.pause();
                }
            }, interval);
        }
    }
    /* this function will be triggered to reset the interval */
    resetTimer() {
        if (this.currentInterval) {
            clearInterval(this.currentInterval);
            this.currentInterval = null;
        }
    }
    /**
     * @name play
     * @description this function will be triggered when mouseleave. Starts/resumes the slide show.
     * @return void
     */
    play() {
        if (!this.isPlaying && !this.isUserPaused) {
            this.isPlaying = true;
            this.restartTimer();
        }
    }
    /**
     * @name pause
     * @description this function will be triggered when mouseenter. Pause the slide show.
     * @return void
     */
    pause() {
        if (!this.noPause || !this.isUserPaused) {
            this.isPlaying = false;
            this.resetTimer();
        }
    }
    setPauseStateMessage(state) {
        if (state) {
            this.pauseStateOutput = this.constants.MESSAGE_PAUSED;
        }
        else {
            this.pauseStateOutput = this.constants.MESSAGE_RESUMED;
        }
    }
    stopBubble(event) {
        event.preventDefault();
        event.stopPropagation();
    }
    /**
     * @name addSlide
     * @description addSlide will be triggered when each carousel image is getting added in slide component
     * @param (CarouselSlide) - slide - the next slide to be added to the list of images
     * @return void
     */
    addSlide(slide) {
        slide.index = this.slides.length;
        this.slides.push(slide);
        if (this.slides.length === 1 || slide.active) {
            this.select(this.slides[this.slides.length - 1]);
            if (this.slides.length === 1) {
                this.play();
            }
        }
        else {
            slide.active = false;
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Carousel, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: Carousel, isStandalone: false, selector: "carousel", inputs: { pauseStateOutput: "pauseStateOutput", idValue: "idValue", noWrap: "noWrap", noPause: "noPause", noTransition: "noTransition", ISSlideArrowReq: "ISSlideArrowReq", interval: "interval" }, ngImport: i0, template: `
  <div (blur)="handleBlur()"
    (focus)="handleFocus()"
    (keydown)="handleKeyPress($event)"
    (keyup)="handleKeyUp($event)"
    (mouseenter)="pause()"
    (mouseleave)="play()"
    [attr.aria-describedBy]="'carousel-instructions-'+ idValue"
    [attr.aria-label]="(!hasFocus ? 'Carousel. Use keyboard focus to activate content.' : null)"
    [attr.aria-live]="(hasFocus ? 'assertive' : null)"
    [attr.aria-relevant]="(hasFocus ? 'all' : null)"
    class="carousel slide"
    role="application"
    tabindex="0">

    <div #carouselInner class="carousel-inner">
        <ng-content></ng-content>
        <div class="carousel-indicator-inner">
            <ol class="carousel-indicators" [hidden]="slides.length <= 1">
                <li *ngFor="let slideItem of slides; let i = index;"
                [attr.aria-label]="'jump to slide ' + (i + 1)"
                [class.active]="slideItem.active === true"
                (click)="select(slideItem)"></li>
            </ol>
        </div>
    </div>
    <span *ngIf="ISSlideArrowReq" aria-label="previous slide" class="left carousel-control" (click)="prev()" [hidden]="!slides.length">
        <span class="glyphicon glyphicon-chevron-left"></span>
    </span>
    <span *ngIf="ISSlideArrowReq" aria-label="next slide" class="right carousel-control" (click)="next()" [hidden]="!slides.length">
        <span class="glyphicon glyphicon-chevron-right"></span>
    </span>
  </div>
  <div aria-hidden="true" class="instructions-block sr-only" [hidden]="!isShowInstructions" id="carousel-instructions-{{idValue}}" role="presentation">
      <p class="instructions-header">Carousel Instructions:</p>
      <ul class="instructions-list">
          <li class="instruction-item">Spacebar &mdash; Pause/Resume carousel rotation</li>
          <li class="instruction-item">Up/Left &mdash; Previous slide</li>
          <li class="instruction-item">Down/Right &mdash; Next slide</li>
          <li class="instruction-item">Home/Page Up &mdash; First slide</li>
          <li class="instruction-item">End/Page Down &mdash; Last slide</li>
          <li class="instruction-item">1 through 9 &mdash; Jumps to slide</li>
      </ul>
  </div>
  <div [innerHTML]="pauseStateOutput" aria-hidden="true" aria-live="assertive" aria-relevant="all" class="sr-only"></div>
  `, isInline: true, styles: [".carousel-caption{background-color:#000000a6}.carousel-slide-image img{width:100%}.carousel-slide-text,.carousel-slide-header,.carousel-slide-CTA{text-align:left;padding:0 20px 20px}.carousel-slide-header{margin-top:20px}.carousel-indicators li{display:inline-block;width:10px;height:10px;margin:4px!important;text-indent:-999px;border:1px solid #333!important;border-radius:47px;cursor:pointer}.carousel-indicators .active{margin:0;width:12px;height:12px;background-color:#056dae!important}.carousel-inner{position:relative;overflow:hidden!important;width:100%;height:auto;border:1px solid #999999}.carousel-indicators{bottom:0!important}.carousel-indicator-inner{padding-top:10px}.carousel-indicator-inner .carousel-indicators ol li:before{content:none!important}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Carousel, decorators: [{
            type: Component,
            args: [{ selector: 'carousel', standalone: false, template: `
  <div (blur)="handleBlur()"
    (focus)="handleFocus()"
    (keydown)="handleKeyPress($event)"
    (keyup)="handleKeyUp($event)"
    (mouseenter)="pause()"
    (mouseleave)="play()"
    [attr.aria-describedBy]="'carousel-instructions-'+ idValue"
    [attr.aria-label]="(!hasFocus ? 'Carousel. Use keyboard focus to activate content.' : null)"
    [attr.aria-live]="(hasFocus ? 'assertive' : null)"
    [attr.aria-relevant]="(hasFocus ? 'all' : null)"
    class="carousel slide"
    role="application"
    tabindex="0">

    <div #carouselInner class="carousel-inner">
        <ng-content></ng-content>
        <div class="carousel-indicator-inner">
            <ol class="carousel-indicators" [hidden]="slides.length <= 1">
                <li *ngFor="let slideItem of slides; let i = index;"
                [attr.aria-label]="'jump to slide ' + (i + 1)"
                [class.active]="slideItem.active === true"
                (click)="select(slideItem)"></li>
            </ol>
        </div>
    </div>
    <span *ngIf="ISSlideArrowReq" aria-label="previous slide" class="left carousel-control" (click)="prev()" [hidden]="!slides.length">
        <span class="glyphicon glyphicon-chevron-left"></span>
    </span>
    <span *ngIf="ISSlideArrowReq" aria-label="next slide" class="right carousel-control" (click)="next()" [hidden]="!slides.length">
        <span class="glyphicon glyphicon-chevron-right"></span>
    </span>
  </div>
  <div aria-hidden="true" class="instructions-block sr-only" [hidden]="!isShowInstructions" id="carousel-instructions-{{idValue}}" role="presentation">
      <p class="instructions-header">Carousel Instructions:</p>
      <ul class="instructions-list">
          <li class="instruction-item">Spacebar &mdash; Pause/Resume carousel rotation</li>
          <li class="instruction-item">Up/Left &mdash; Previous slide</li>
          <li class="instruction-item">Down/Right &mdash; Next slide</li>
          <li class="instruction-item">Home/Page Up &mdash; First slide</li>
          <li class="instruction-item">End/Page Down &mdash; Last slide</li>
          <li class="instruction-item">1 through 9 &mdash; Jumps to slide</li>
      </ul>
  </div>
  <div [innerHTML]="pauseStateOutput" aria-hidden="true" aria-live="assertive" aria-relevant="all" class="sr-only"></div>
  `, styles: [".carousel-caption{background-color:#000000a6}.carousel-slide-image img{width:100%}.carousel-slide-text,.carousel-slide-header,.carousel-slide-CTA{text-align:left;padding:0 20px 20px}.carousel-slide-header{margin-top:20px}.carousel-indicators li{display:inline-block;width:10px;height:10px;margin:4px!important;text-indent:-999px;border:1px solid #333!important;border-radius:47px;cursor:pointer}.carousel-indicators .active{margin:0;width:12px;height:12px;background-color:#056dae!important}.carousel-inner{position:relative;overflow:hidden!important;width:100%;height:auto;border:1px solid #999999}.carousel-indicators{bottom:0!important}.carousel-indicator-inner{padding-top:10px}.carousel-indicator-inner .carousel-indicators ol li:before{content:none!important}\n"] }]
        }], propDecorators: { pauseStateOutput: [{
                type: Input$1
            }], idValue: [{
                type: Input$1
            }], noWrap: [{
                type: Input$1
            }], noPause: [{
                type: Input$1
            }], noTransition: [{
                type: Input$1
            }], ISSlideArrowReq: [{
                type: Input$1
            }], interval: [{
                type: Input$1
            }] } });

class CarouselSlide {
    constructor(carousel) {
        this.carousel = carousel;
        this.addClass = true;
    }
    ngOnInit() {
        this.carousel.addSlide(this);
    }
    ngOnDestroy() {
        //this.carousel.removeSlide(this);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CarouselSlide, deps: [{ token: Carousel }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: CarouselSlide, isStandalone: false, selector: "slide", inputs: { index: "index", direction: "direction", active: "active" }, host: { properties: { "class.active": "this.active", "class.item": "this.addClass", "class.carousel-item": "this.addClass" } }, ngImport: i0, template: `
    <div [class.active]="active" class="item text-center">
      <ng-content></ng-content>
    </div>
  `, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CarouselSlide, decorators: [{
            type: Component,
            args: [{
                    selector: 'slide',
                    standalone: false,
                    template: `
    <div [class.active]="active" class="item text-center">
      <ng-content></ng-content>
    </div>
  `
                }]
        }], ctorParameters: () => [{ type: Carousel }], propDecorators: { index: [{
                type: Input$1
            }], direction: [{
                type: Input$1
            }], active: [{
                type: HostBinding,
                args: ['class.active']
            }, {
                type: Input$1
            }], addClass: [{
                type: HostBinding,
                args: ['class.item']
            }, {
                type: HostBinding,
                args: ['class.carousel-item']
            }] } });

/**
 * @Component: Carousel Control
 * @description This is the carousel component and is used to create carousel
 * from Bootstrap.
 */
class CarouselControlComponent {
    constructor() {
    }
    ngOnInit() {
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CarouselControlComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: CarouselControlComponent, isStandalone: false, selector: "citi-carousel-control", inputs: { idStr: "idStr", NextPhotoInterval: "NextPhotoInterval", noLoopSlides: "noLoopSlides", slides: "slides", arrowReq: "arrowReq", htmlContent: "htmlContent" }, ngImport: i0, template: `
  <div class="row">
    <div [attr.id]="idStr" class="col-md-12 carousel-container">
      <carousel [interval]="NextPhotoInterval" [noWrap]="noLoopSlides" [idValue]="idStr" [ISSlideArrowReq]="arrowReq">
        <slide *ngFor="let slideItem of slides; let index=index" [active]="slideItem.active">
            <!--<img [alt]="slideItem.alt" [src]="slideItem.imageURL" style="margin:auto;">
            <div class="carousel-caption">
                <p [innerHtml]='slideItem.text'></p>
            </div>-->
            <div *ngIf="slideItem.imageURL" class="carousel-slide-image">
                <img [alt]="slideItem.alt" [src]="slideItem.imageURL" style="margin:auto;">
            </div>
            <div class="carousel-slide-header">
                <strong [innerHtml]='slideItem.header'></strong>
            </div>
            <div class="carousel-slide-text">
                <p [innerHtml]='slideItem.text'></p>
            </div>
            <div class="carousel-slide-CTA">
                <p [innerHtml]='slideItem.link'></p>
            </div>
        </slide>
      </carousel>
    </div>
  </div>
  `, isInline: true, styles: [".carousel-caption{background-color:#000000a6}.carousel-slide-image img{width:100%}.carousel-slide-text,.carousel-slide-header,.carousel-slide-CTA{text-align:left;padding:0 20px 20px}.carousel-slide-header{margin-top:20px}.carousel-indicators li{display:inline-block;width:10px;height:10px;margin:4px!important;text-indent:-999px;border:1px solid #333!important;border-radius:47px;cursor:pointer}.carousel-indicators .active{margin:0;width:12px;height:12px;background-color:#056dae!important}.carousel-inner{position:relative;overflow:hidden!important;width:100%;height:auto;border:1px solid #999999}.carousel-indicators{bottom:0!important}.carousel-indicator-inner{padding-top:10px}.carousel-indicator-inner .carousel-indicators ol li:before{content:none!important}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: Carousel, selector: "carousel", inputs: ["pauseStateOutput", "idValue", "noWrap", "noPause", "noTransition", "ISSlideArrowReq", "interval"] }, { kind: "component", type: CarouselSlide, selector: "slide", inputs: ["index", "direction", "active"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CarouselControlComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-carousel-control', standalone: false, template: `
  <div class="row">
    <div [attr.id]="idStr" class="col-md-12 carousel-container">
      <carousel [interval]="NextPhotoInterval" [noWrap]="noLoopSlides" [idValue]="idStr" [ISSlideArrowReq]="arrowReq">
        <slide *ngFor="let slideItem of slides; let index=index" [active]="slideItem.active">
            <!--<img [alt]="slideItem.alt" [src]="slideItem.imageURL" style="margin:auto;">
            <div class="carousel-caption">
                <p [innerHtml]='slideItem.text'></p>
            </div>-->
            <div *ngIf="slideItem.imageURL" class="carousel-slide-image">
                <img [alt]="slideItem.alt" [src]="slideItem.imageURL" style="margin:auto;">
            </div>
            <div class="carousel-slide-header">
                <strong [innerHtml]='slideItem.header'></strong>
            </div>
            <div class="carousel-slide-text">
                <p [innerHtml]='slideItem.text'></p>
            </div>
            <div class="carousel-slide-CTA">
                <p [innerHtml]='slideItem.link'></p>
            </div>
        </slide>
      </carousel>
    </div>
  </div>
  `, styles: [".carousel-caption{background-color:#000000a6}.carousel-slide-image img{width:100%}.carousel-slide-text,.carousel-slide-header,.carousel-slide-CTA{text-align:left;padding:0 20px 20px}.carousel-slide-header{margin-top:20px}.carousel-indicators li{display:inline-block;width:10px;height:10px;margin:4px!important;text-indent:-999px;border:1px solid #333!important;border-radius:47px;cursor:pointer}.carousel-indicators .active{margin:0;width:12px;height:12px;background-color:#056dae!important}.carousel-inner{position:relative;overflow:hidden!important;width:100%;height:auto;border:1px solid #999999}.carousel-indicators{bottom:0!important}.carousel-indicator-inner{padding-top:10px}.carousel-indicator-inner .carousel-indicators ol li:before{content:none!important}\n"] }]
        }], ctorParameters: () => [], propDecorators: { idStr: [{
                type: Input$1
            }], NextPhotoInterval: [{
                type: Input$1
            }], noLoopSlides: [{
                type: Input$1
            }], slides: [{
                type: Input$1
            }], arrowReq: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }] } });

const COMPONENTS$Q = [
    Carousel,
    CarouselSlide,
    CarouselControlComponent
];
const MODULES$R = [
    CommonModule
];
class CarouselComp {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CarouselComp, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: CarouselComp, declarations: [Carousel,
            CarouselSlide,
            CarouselControlComponent], imports: [CommonModule], exports: [Carousel,
            CarouselSlide,
            CarouselControlComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CarouselComp, imports: [MODULES$R] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CarouselComp, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$R],
                    declarations: [...COMPONENTS$Q],
                    exports: [...COMPONENTS$Q]
                }]
        }] });

class DropdownService {
    constructor() {
        this.optionAdded = new EventEmitter();
        this.optionRemoved = new EventEmitter();
    }
    /**
     * @name addOption
     * @description Adds option to an input
     * @return void
     */
    addOption(option) {
        this.optionAdded.emit(option);
    }
    removeOption(option) {
        this.optionRemoved.emit(option);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: DropdownService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: DropdownService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: DropdownService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [] });

/**
 * @Component: Dropdown
 * @Section: Forms
 * @description This is the dropdown component and is used to create reusable dropdown field
 * from Bootstrap.
 */
class DropdownComponent {
    set error(isErrored) {
        this._error = isErrored;
        this.inputClasses['validation-input-danger'] = isErrored;
    }
    get error() {
        return this._error;
    }
    // #endregion
    // #region -------------      SETTERS / GETTERS       --------------//
    /*tslint:disable:triple-equals*/
    /**
     * @property hidden
     * @description whether the dropdown is hidden or not
     * @Type: boolean
     */
    set isHidden(hide) {
        if (hide === true || hide == 'true') {
            this.hidden = true;
        }
    }
    /**
     * @property autofocus
     * @description whether the dropdown should be focused automatically on page load
     * @Type: boolean
     */
    set autofocus(autofocus) {
        if (autofocus === true || autofocus == 'true') {
            this.hasAutoFocus = true;
        }
    }
    /**
     * @property hasTooltip
     * @description whether the dropdown has a tooltip or not
     * @Type: boolean
     */
    set hasTooltip(tooltip) {
        this.dropdownHasTooltip = tooltip === true || tooltip == 'true';
    }
    /**
     * @property selectedValue
     * @description Returns the selected value of the dropdown
     * @return string
     * @twoway false
     */
    get selectedValue() {
        if (this.selectEl && this.selectEl.nativeElement && this.selectEl.nativeElement.options) {
            const selectedOption = this.selectEl.nativeElement.options[this.selectEl.nativeElement.selectedIndex];
            if (selectedOption) {
                return selectedOption.value;
            }
        }
        return null;
    }
    /**
     * @property selectedText
     * @description Returns the text/label of the selected item
     * @return string
     * @twoway false
     */
    get selectedText() {
        if (this.selectEl && this.selectEl.nativeElement) {
            const selectedIndex = this.selectEl.nativeElement.selectedIndex;
            if (selectedIndex > 0)
                return this.selectEl.nativeElement.options[selectedIndex].text;
        }
        return null;
    }
    get hasGroup() {
        return this._optionsWithGroups.length > 0;
    }
    onHostFocus(event) {
        if (this.selectEl && this.selectEl.nativeElement) {
            this.selectEl.nativeElement.focus();
        }
    }
    // Sets the value when the select has focus
    set isFocused(value) {
        this._isFocused = value;
        this.updateDoShowLabel();
    }
    // #endregion
    // #region -------------      LIFE CYCLE       --------------//
    constructor(dropdownService, validationService, elRef, liveAnnouncer) {
        this.dropdownService = dropdownService;
        this.validationService = validationService;
        this.elRef = elRef;
        this.liveAnnouncer = liveAnnouncer;
        // #region -------------      PROPERTIES       --------------//
        this._isFocused = false;
        this.hidden = false;
        this.hasAutoFocus = false;
        // public isRequired: boolean = false;
        this.dropdownHasTooltip = false;
        this.labelId = null;
        this._hasGroup = false;
        this.doShowLabel = false;
        this.sizeClasses = {
            fullwidth: 'col-xs-12',
            large: 'col-md-8',
            medium: 'col-md-6 col-sm-9',
            small: 'col-md-4 col-sm-6',
            xsmall: 'col-md-2 col-sm-3 col-xs-6'
        };
        this.classes = {
            focus: '',
            size: '',
            hasValue: ''
        };
        this.inputClasses = {
            'validation-input-danger': false,
            'form-white-bg': false
        };
        this.subscriptions = [];
        this._optionsWithGroups = [];
        // Default messages for errors
        this.errors = {
            required: 'Input is required'
        };
        // #endregion
        // #region -------------      INPUT / OUTPUT       --------------//
        this.options = [];
        this.valueChange = new EventEmitter();
        /**
         * @property selectionChange
         * @description takes a function to be called when the value of the dropdown is changed.
         * @Type: Function
         */
        this.selectionChange = new EventEmitter();
        /**
         * @property idStr
         * @description id for the dropdown
         * @return string
         */
        this.idStr = null;
        /**
         * @property name
         * @description name for the dropdown
         * @return string
         */
        this.name = null;
        /**
         * @property size
         * @description size for the dropdown (fullwidth, large, medium, small, xsmall)
         * @return string
         */
        this.size = 'fullwidth';
        /**
         * @property errorMessage
         * @description error message to be displayed when no value is selected
         * @return string
         */
        this.errorMessage = 'Error';
        /**
         * @property error
         * @description This defines the error state on the input
         * @return string
         */
        this._error = false;
        /**
         * @Event: errorChange
         * @description The event is emitted when the error status changed
         * The event is returned.
         * @return Object
         */
        this.errorChange = new EventEmitter();
        /**
         * @property tooltipPosition
         * @description Position for the dropdown tooltip (top, bottom, left, right, auto)
         * @return string
         */
        this.tooltipPosition = 'auto';
        /**
         * @property disabled
         * @description The dropdown is not clickable
         * @return string
         */
        this.isDisabled = false;
    }
    ngOnInit() {
        this.validationService.addInput(this);
        if (this.idStr !== null)
            this.labelId = this.idStr + 'label';
        else
            this.labelId = null;
        // If no label is present, then use placeholder text as label
        if (!this.label && this.placeholder) {
            this.label = this.placeholder;
        }
        // Set the appropriate size class
        this.classes.size = this.sizeClasses[this.size];
        this.subscriptions.push(this.dropdownService.optionRemoved.subscribe(option => {
            setTimeout(_ => {
                this.options = this.options.filter(opt => opt !== option);
            }, 0);
        }));
        // Listen for options to be added
        this.subscriptions.push(this.dropdownService.optionAdded.subscribe(option => {
            setTimeout(_ => {
                this._hasGroup = option.group !== null;
                // Add the option to the options array
                this.options.push(option);
                // If the option should be selected
                if (option.isSelected) {
                    // Set the selected value to this options value
                    // Note that if multiple options are set as selected,
                    // the last set as selected will be selected
                    this.value = option.value;
                    // Call on change to update parent component
                    this.onDropdownChange(true);
                }
                if (this.dropdownDiv && this._hasGroup)
                    this.generateGroupOptions();
            }, 0);
        }));
        // Subscribe to the validation to validate the input on request of the service
        this.subscriptions.push(this.validationService.validateNow.subscribe(() => this.validate()));
        if (this.whiteBackground) {
            this.inputClasses['form-white-bg'] = true;
        }
    }
    ngAfterContentInit() {
        if (this._hasGroup)
            this.generateGroupOptions();
    }
    ngAfterViewInit() {
        if (this.dropdownDiv && this.dropdownDiv.nativeElement) {
            Array.prototype.slice.call(this.dropdownDiv.nativeElement.getElementsByTagName('option'))
                .forEach((option, index) => {
                if (this.options[index] && this.options[index].label) {
                    option.innerHTML = this.options[index].label;
                }
            });
        }
        // this.updateDomEl();
        if (!this.value && !!this.placeholder)
            this.value = '';
    }
    ngDoCheck() {
        this.updateDoShowLabel();
    }
    ngOnDestroy() {
        this.validationService.removeError(this);
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
    // #endregion
    // #region -------------      METHODS       --------------//
    focusInput() {
        if (this.selectEl && this.selectEl.nativeElement)
            this.selectEl.nativeElement.focus();
    }
    hasLabelId() {
        return typeof this.labelId !== 'undefined' && this.labelId !== null;
    }
    rebuildClassNamesForContainerDiv() {
        if (this.dropdownDiv && this.dropdownDiv.nativeElement) {
            this.dropdownDiv.nativeElement.className = 'form-group ' + this.classes.size + ' ' + this.classes.focus;
        }
    }
    updateDoShowLabel() {
        this.doShowLabel = this.label && (this._isFocused || !this.hasDisabledOptionSelected());
        this.hasValue();
    }
    // Returns true if value is set
    hasValue() {
        const hasVal = typeof this.value !== 'undefined' && this.value !== null && this.value.toString().length > 0;
        const noneSelected = !!this.selectEl && this.selectEl.nativeElement.selectedIndex === -1;
        this.classes.hasValue = hasVal || noneSelected ? 'has-value' : '';
        return hasVal;
    }
    // On Focus
    onFocus() {
        this.isFocused = true;
        // Add the is-focused class
        this.classes.focus = 'is-focused';
        if (this._error)
            this.liveAnnouncer.announce(this.errorMessage);
    }
    // On Blur
    onBlur() {
        this.isFocused = false;
        this.classes.focus = '';
        // If the dropdown is required and there is no selected value
        if (this.required && (!this.value || this.value == 'undefined')) {
            // Let the dropdown know there is an error
            this.error = true;
        }
        this.validate();
    }
    // On Change
    onDropdownChange(calledFromService = false) {
        for (const item of this.options) {
            item.isSelected = (item.value === this.value);
        }
        if (!calledFromService)
            this.validate();
        this.updateDoShowLabel();
        // Emit the change through value
        this.valueChange.emit(this.value);
        this.selectionChange.emit(this.value);
    }
    // Clears an error state on the input. Takes a type of error
    toggleError(errorType, isErrored) {
        // Clear the error state
        this.error = isErrored;
        // Set the error on the validation service
        if (isErrored) {
            // Add the error type
            this.errorType = errorType;
            // Add the error to the validation service
            this.validationService.addError(this);
        }
        else {
            // Remove the error type
            this.errorType = null;
            // Remove the error from the validation service
            this.validationService.removeError(this);
        }
        // Emit the change to the error
        this.errorChange.emit();
    }
    ;
    // validate input
    validate() {
        // Get the current value
        const value = this.value;
        // If we got a value
        if (value) {
            // If the input is required
            if (this.required) {
                // Clear the required error state
                this.toggleError('required', false);
            }
        }
        else {
            // Otherwise if there was no value and the input is required
            if (this.required && (!this.value || this.value === 'undefined')) {
                // Set the error message
                this.errorMessage = this.requiredError || this.errors['required'];
                // And set the required error state
                this.toggleError('required', true);
            }
        }
    }
    // updateDomEl() {
    //   if (this.selectEl) {
    //     this.DomEl = this.selectEl.nativeElement;
    //   }
    // }
    hasDisabledOptionSelected() {
        // In case of placeholder from property
        if (this.placeholder && this.value === '') {
            return true;
        }
        // In case of placeholder from options data
        let result = false;
        for (const option of this.options) {
            result = option.isDisabled && option.isSelected;
            if (result) {
                if (option.value == this.value) {
                    return true;
                }
                return false;
            }
        }
        return false;
    }
    generateGroupOptions() {
        if (this.options.length > 0) {
            const object = groupBy(this.options, 'group');
            const array = Object.keys(object).map(key => object[key]);
            this._optionsWithGroups = array.map(group => Object.assign({}, { options: group }, { name: group[0].group }));
        }
    }
    /**
     * @name clearOptions
     * @description Clears the dropdown options. Should be called when updating the dropdown options.
     * @Type: function
     */
    clearOptions() {
        this.options = [];
    }
    ;
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: DropdownComponent, deps: [{ token: DropdownService }, { token: ValidationService }, { token: i0.ElementRef }, { token: CitiLiveAnnouncer }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: DropdownComponent, isStandalone: false, selector: "citi-dropdown", inputs: { options: "options", whiteBackground: "whiteBackground", value: "value", idStr: "idStr", name: "name", size: "size", label: "label", placeholder: "placeholder", required: "required", additionalClasses: "additionalClasses", errorMessage: "errorMessage", error: "error", requiredError: "requiredError", tooltipTitle: "tooltipTitle", tooltipBody: "tooltipBody", tooltipPosition: "tooltipPosition", isDisabled: "isDisabled", dropdownTheme: "dropdownTheme", isHidden: "isHidden", autofocus: "autofocus", hasTooltip: "hasTooltip" }, outputs: { valueChange: "valueChange", selectionChange: "selectionChange", errorChange: "errorChange" }, host: { listeners: { "focus": "onHostFocus($event)" }, classAttribute: "citi-dropdown row" }, providers: [DropdownService], viewQueries: [{ propertyName: "dropdownDiv", first: true, predicate: ["dropdown"], descendants: true }, { propertyName: "selectEl", first: true, predicate: ["selectEl"], descendants: true }], ngImport: i0, template: `
  <div *ngIf="!hidden" class="dd-wrapper {{additionalClasses}}" [ngClass]="['form-group', classes.size, classes.focus, classes.hasValue]" #dropdown>

    <label class="select-box-label"
      [attr.id]="(hasLabelId() ? labelId : null)"
      [attr.for]="idStr"
      [innerHtml]="label"
      [ngClass]="[isDisabled ? 'disabled-label' : '']"
    ></label>

    <div [class.tooltip-input-group]="dropdownHasTooltip">

      <select #selectEl [attr.id]="idStr" [attr.name]="name" class="form-control {{dropdownTheme}}" (focus)="onFocus()" (blur)="onBlur()"
        (change)="onDropdownChange()"
        [ngClass]="([inputClasses['validation-input-danger'] ? 'validation-input-danger' : '', inputClasses['form-white-bg'] ? 'form-white-bg' : '', isDisabled ? 'disabled-select' : ''])"
        [(ngModel)]="value"
        [attr.ngDefaultControl]="(name ? true : null)"
        [attr.aria-labelledby]="labelId"
        [attr.disabled]="(isDisabled ? 'disabled' : null)"
        [attr.aria-disabled]="(isDisabled ? 'true' : null)"
        [attr.aria-required]="(required ? true : null)">
        <option *ngIf="placeholder" [value]="''" selected="true" disabled="disabled" [innerHTML]="placeholder"></option>

        <ng-template [ngIf]="hasGroup">

          <optgroup *ngFor="let group of _optionsWithGroups" [attr.label]="group.name">
            <option [value]="option.value" *ngFor="let option of group.options" [attr.disabled]="(option.isDisabled ? 'disabled' : null)"
              [attr.selected]="(option.isSelected ? true : null)" [innerHTML]="option.label">
            </option>
          </optgroup>
        </ng-template>

        <ng-template [ngIf]="!hasGroup">
          <option [value]="option.value" *ngFor="let option of options"
            [attr.disabled]="(option.isDisabled ? 'disabled' : null)"
            [attr.selected]="(option.isSelected ? true : null)"
            [innerHTML]="option.label">
          </option>
        </ng-template>

      </select>

      <citi-tooltip *ngIf="dropdownHasTooltip" [tooltipTitle]="tooltipTitle" [tooltipBody]="tooltipBody" [position]="tooltipPosition"></citi-tooltip>
    </div>
    <span *ngIf="_error" class="validation-message-danger" [id]="idStr + '-error'" [innerHtml]="errorMessage" role="alert"></span>
  </div>
  `, isInline: true, styles: [":host{display:block}.form-white-bg{background-color:#fff!important}.form-group{display:block}.dark{background-color:#eee!important}select.dark::-ms-value,select.dark:focus::-ms-value{background-color:#eee}.light{background-color:#fff!important}select.light::-ms-value,select.light:focus::-ms-value{background-color:#fff}.select-box-label{opacity:0}.is-focused .select-box-label,.has-value .select-box-label{opacity:1}.disabled-label{color:#333;font-size:12px;line-height:1.5;font-family:Interstate-Light}.disabled-select{color:#333;font-size:16px;font-family:Interstate-Light;line-height:1.5;border-width:1px;border-style:solid;border-color:#666!important;background-color:transparent!important;background-image:url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8' standalone='no'%3F%3E%3Csvg width='15px' height='8px' viewBox='0 0 15 8' version='1.1' xmlns='http://www.w3.org/2000/svg'%3E%3Cg transform='translate(-878, -122)' fill='%23666'%3E%3Cg transform='translate(570, 101)'%3E%3Cpath d='M312,32 L312,29.6917048 L316.989689,25.0246591 L312,20.3577556 L312,18 L318.461538,24.1555486 L318.461538,25.8443093 L312,32' transform='translate(315.230769, 25) rotate(-270) translate(-315.230769, -25) '%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")}.disabled-select:focus{border-width:1px;border-style:solid;border-color:#666!important}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i4.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i4.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i4.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { kind: "directive", type: i4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i4.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: TooltipComponent, selector: "citi-tooltip:not(.1Q21)", inputs: ["tooltipId", "tooltipBody", "tooltipTitle", "size", "buttonLabel", "hasCloseButton", "theme", "position", "secondaryPosition", "isContentAlerted", "show"], outputs: ["clickClose", "tooltipIdChange", "showChange"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: DropdownComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-dropdown', standalone: false, template: `
  <div *ngIf="!hidden" class="dd-wrapper {{additionalClasses}}" [ngClass]="['form-group', classes.size, classes.focus, classes.hasValue]" #dropdown>

    <label class="select-box-label"
      [attr.id]="(hasLabelId() ? labelId : null)"
      [attr.for]="idStr"
      [innerHtml]="label"
      [ngClass]="[isDisabled ? 'disabled-label' : '']"
    ></label>

    <div [class.tooltip-input-group]="dropdownHasTooltip">

      <select #selectEl [attr.id]="idStr" [attr.name]="name" class="form-control {{dropdownTheme}}" (focus)="onFocus()" (blur)="onBlur()"
        (change)="onDropdownChange()"
        [ngClass]="([inputClasses['validation-input-danger'] ? 'validation-input-danger' : '', inputClasses['form-white-bg'] ? 'form-white-bg' : '', isDisabled ? 'disabled-select' : ''])"
        [(ngModel)]="value"
        [attr.ngDefaultControl]="(name ? true : null)"
        [attr.aria-labelledby]="labelId"
        [attr.disabled]="(isDisabled ? 'disabled' : null)"
        [attr.aria-disabled]="(isDisabled ? 'true' : null)"
        [attr.aria-required]="(required ? true : null)">
        <option *ngIf="placeholder" [value]="''" selected="true" disabled="disabled" [innerHTML]="placeholder"></option>

        <ng-template [ngIf]="hasGroup">

          <optgroup *ngFor="let group of _optionsWithGroups" [attr.label]="group.name">
            <option [value]="option.value" *ngFor="let option of group.options" [attr.disabled]="(option.isDisabled ? 'disabled' : null)"
              [attr.selected]="(option.isSelected ? true : null)" [innerHTML]="option.label">
            </option>
          </optgroup>
        </ng-template>

        <ng-template [ngIf]="!hasGroup">
          <option [value]="option.value" *ngFor="let option of options"
            [attr.disabled]="(option.isDisabled ? 'disabled' : null)"
            [attr.selected]="(option.isSelected ? true : null)"
            [innerHTML]="option.label">
          </option>
        </ng-template>

      </select>

      <citi-tooltip *ngIf="dropdownHasTooltip" [tooltipTitle]="tooltipTitle" [tooltipBody]="tooltipBody" [position]="tooltipPosition"></citi-tooltip>
    </div>
    <span *ngIf="_error" class="validation-message-danger" [id]="idStr + '-error'" [innerHtml]="errorMessage" role="alert"></span>
  </div>
  `, providers: [DropdownService], host: { class: 'citi-dropdown row' }, styles: [":host{display:block}.form-white-bg{background-color:#fff!important}.form-group{display:block}.dark{background-color:#eee!important}select.dark::-ms-value,select.dark:focus::-ms-value{background-color:#eee}.light{background-color:#fff!important}select.light::-ms-value,select.light:focus::-ms-value{background-color:#fff}.select-box-label{opacity:0}.is-focused .select-box-label,.has-value .select-box-label{opacity:1}.disabled-label{color:#333;font-size:12px;line-height:1.5;font-family:Interstate-Light}.disabled-select{color:#333;font-size:16px;font-family:Interstate-Light;line-height:1.5;border-width:1px;border-style:solid;border-color:#666!important;background-color:transparent!important;background-image:url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8' standalone='no'%3F%3E%3Csvg width='15px' height='8px' viewBox='0 0 15 8' version='1.1' xmlns='http://www.w3.org/2000/svg'%3E%3Cg transform='translate(-878, -122)' fill='%23666'%3E%3Cg transform='translate(570, 101)'%3E%3Cpath d='M312,32 L312,29.6917048 L316.989689,25.0246591 L312,20.3577556 L312,18 L318.461538,24.1555486 L318.461538,25.8443093 L312,32' transform='translate(315.230769, 25) rotate(-270) translate(-315.230769, -25) '%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")}.disabled-select:focus{border-width:1px;border-style:solid;border-color:#666!important}\n"] }]
        }], ctorParameters: () => [{ type: DropdownService }, { type: ValidationService }, { type: i0.ElementRef }, { type: CitiLiveAnnouncer }], propDecorators: { dropdownDiv: [{
                type: ViewChild,
                args: ['dropdown']
            }], selectEl: [{
                type: ViewChild,
                args: ['selectEl']
            }], options: [{
                type: Input$1
            }], whiteBackground: [{
                type: Input$1
            }], value: [{
                type: Input$1
            }], valueChange: [{
                type: Output
            }], selectionChange: [{
                type: Output
            }], idStr: [{
                type: Input$1
            }], name: [{
                type: Input$1
            }], size: [{
                type: Input$1
            }], label: [{
                type: Input$1
            }], placeholder: [{
                type: Input$1
            }], required: [{
                type: Input$1
            }], additionalClasses: [{
                type: Input$1
            }], errorMessage: [{
                type: Input$1
            }], error: [{
                type: Input$1
            }], errorChange: [{
                type: Output
            }], requiredError: [{
                type: Input$1
            }], tooltipTitle: [{
                type: Input$1
            }], tooltipBody: [{
                type: Input$1
            }], tooltipPosition: [{
                type: Input$1
            }], isDisabled: [{
                type: Input$1
            }], dropdownTheme: [{
                type: Input$1
            }], isHidden: [{
                type: Input$1
            }], autofocus: [{
                type: Input$1
            }], hasTooltip: [{
                type: Input$1
            }], onHostFocus: [{
                type: HostListener,
                args: ['focus', ['$event']]
            }] } });

/**
 * @Component: Dropdown Option
 * @Section: Forms
 * @description used to create an option inside a citi-dropdown component
 * from Bootstrap.
 */
class DropdownOptionComponent {
    // Constructor
    constructor(dropdownService) {
        this.dropdownService = dropdownService;
        // Whether this option is disabled or not
        this.isDisabled = false;
        // Whether this option is selected or not
        this.isSelected = false;
        /**
         * @property value
         * @description value for the dropdown option
         * @return string
         */
        this.value = null;
        /**
         * @property label
         * @description label for the dropdown option
         * @return string
         */
        this.label = null;
        /**
         * @property group
         * @description Group to which the current option belongs to
         * @return string
         */
        this._group = null;
    }
    // On Init
    ngOnInit() {
        this.dropdownService.addOption(this);
    }
    ngOnDestroy() {
        this.dropdownService.removeOption(this);
    }
    /**
     * @property selected
     * @description whether the dropdown option is selected or not
     * @Type: boolean
     */
    set selected(selected) {
        if (selected === true || selected == 'true') {
            this.isSelected = true;
        }
    }
    /**
     * @property disabled
     * @description whether the dropdown option is disabled or not
     * @Type: boolean
     */
    set disabled(disabled) {
        if (disabled === true || disabled == 'true') {
            this.isDisabled = true;
        }
    }
    set group(value) {
        this._group = value;
    }
    get group() {
        return this._group;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: DropdownOptionComponent, deps: [{ token: DropdownService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: DropdownOptionComponent, isStandalone: false, selector: "citi-dropdown-option", inputs: { value: "value", label: "label", selected: "selected", disabled: "disabled", group: "group" }, ngImport: i0, template: '', isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: DropdownOptionComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'citi-dropdown-option',
                    standalone: false,
                    template: ''
                }]
        }], ctorParameters: () => [{ type: DropdownService }], propDecorators: { value: [{
                type: Input$1
            }], label: [{
                type: Input$1
            }], selected: [{
                type: Input$1
            }], disabled: [{
                type: Input$1
            }], group: [{
                type: Input$1
            }] } });

const COMPONENTS$P = [
    DropdownComponent,
    DropdownOptionComponent
];
const MODULES$Q = [
    CommonModule,
    FormsModule,
    CitiTooltip
];
class Dropdown {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Dropdown, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: Dropdown, declarations: [DropdownComponent,
            DropdownOptionComponent], imports: [CommonModule,
            FormsModule,
            CitiTooltip], exports: [DropdownComponent, DropdownOptionComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Dropdown, imports: [MODULES$Q] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Dropdown, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$Q],
                    declarations: [...COMPONENTS$P],
                    exports: [DropdownComponent, DropdownOptionComponent]
                }]
        }] });

// @dynamic
class IconTypeClassSettings {
    constructor() {
        this.iconType = '';
    }
}
// @dynamic
// tslint:disable-next-line:class-name
class iconTypeCSS {
    static get blueError() {
        return 'glyphicon-exclamation-sign';
    }
    static get redError() {
        return 'icon-RedAlert cbolui-icon-red';
    }
    static get blueAlert() {
        return 'icon-BlueSpeech cbolui-icon-blue';
    }
    static get redAlert() {
        return 'glyphicon-comment cbolui-icon-red';
    }
    static get blueStar() {
        return 'glyphicon-star cbolui-icon-blue';
    }
    static get closeIcon() {
        return 'glyphicon-remove';
    }
    static get redCloseIcon() {
        return 'glyphicon-remove cbolui-icon-red';
    }
    static get refreshIcon() {
        return 'glyphicon-refresh cbolui-icon-blue';
    }
    static get checkIcon() {
        return 'icon-GreenCheck cbolui-icon-green';
    }
    static get plusIcon() {
        return 'glyphicon-plus';
    }
    static get MinusIcon() {
        return 'glyphicon-minus';
    }
    static get profileIcon() {
        return 'glyphicon-user';
    }
    static get lockIcon() {
        return 'glyphicon-lock';
    }
    static get orangeLockIcon() {
        return 'glyphicon-lock cbolui-icon-orange';
    }
    static get searchIcon() {
        return 'glyphicon-search';
    }
    static get cameraIcon() {
        return 'glyphicon-camera';
    }
    static get redQuestionIcon() {
        return 'glyphicon-question-sign cbolui-icon-red';
    }
    static get greenTickMarkIcon() {
        return 'cbolui-icon-green-checkmark';
    }
    static get redIconXMark() {
        return 'cbolui-icon-red-icon_X';
    }
    static get upArrow() {
        return 'glyphicon-triangle-up';
    }
    static get downArrow() {
        return 'glyphicon-triangle-down';
    }
    static get learnMore() {
        return 'cbolui-icon-learn-more';
    }
    static get lgRedError() {
        return 'cbolui-icon-lg-red-error';
    }
    static get greenCheckMarkIcon() {
        return 'checkmark-icon svg-list-check-mark';
    }
    static get greenCheckMarkWithCircleIcon() {
        return 'cbolui-icon-green';
    }
    static get redExclamationWithCircleIcon() {
        return 'cbolui-icon-red';
    }
    static get blueMessageIcon() {
        return 'cbolui-icon-blue';
    }
    static get grayTechnicalIcon() {
        return 'cbolui-icon-technical-gray';
    }
    static get serviceIcon() {
        return 'cbolui-icon-service';
    }
    static get pointerIcon() {
        return 'cbolui-icon-pointer';
    }
    static get cardPinIcon() {
        return 'cbolui-icon-cardPin';
    }
    //------- Icons-Dark-theme-BG--------//
    static get trashCanCirclebIcon() {
        return 'cbolui-icon-trashb-circle';
    }
    static get fourArrowsCirclebIcon() {
        return 'cbolui-icon-four-arrowsb-circle';
    }
    static get arrowDownCirclebIcon() {
        return 'cbolui-icon-arrow-downb-circle';
    }
    static get arrowLefCirclebIcon() {
        return 'cbolui-icon-arrow-leftb-circle';
    }
    static get arrowRightCirclebIcon() {
        return 'cbolui-icon-arrow-rightb-circle';
    }
    static get arrowUpCirclebIcon() {
        return 'cbolui-icon-arrow-upb-circle';
    }
    static get branchCirclebIcon() {
        return 'cbolui-icon-branchb-circle';
    }
    static get bubbleCirclebIcon() {
        return 'cbolui-icon-bubbleb-circle';
    }
    static get calendarCirclebIcon() {
        return 'cbolui-icon-calendarb-circle';
    }
    static get chartCirclebIcon() {
        return 'cbolui-icon-chartb-circle';
    }
    static get checkmarkCirclebIcon() {
        return 'cbolui-icon-checkmarkb-circle';
    }
    static get circleArrowsbIcon() {
        return 'cbolui-icon-circleb-circle';
    }
    static get creditCardCirclebIcon() {
        return 'cbolui-icon-creditCardb-circle';
    }
    static get currencyBillCirclebIcon() {
        return 'cbolui-icon-currencyb-circle';
    }
    static get docuarrowCirclebIcon() {
        return 'cbolui-icon-docuarrowb-circle';
    }
    static get docucheckCirclebIcon() {
        return 'cbolui-icon-docucheckb-circle';
    }
    static get documentCirclebIcon() {
        return 'cbolui-icon-documentb-circle';
    }
    static get dollarCirclebIcon() {
        return 'cbolui-icon-dollarb-circle';
    }
    static get downloadCirclebIcon() {
        return 'cbolui-icon-downloadb-circle';
    }
    static get envelopCirclebIcon() {
        return 'cbolui-icon-envelopb-circle';
    }
    static get euroCirclebIcon() {
        return 'cbolui-icon-eurob-circle';
    }
    static get ensuranceCirclebIcon() {
        return 'cbolui-icon-ensurance-circle';
    }
    static get jbpCirclebIcon() {
        return 'cbolui-icon-jbpb-circle';
    }
    static get infoCirclebIcon() {
        return 'cbolui-icon-infob-circle';
    }
    static get laptopCirclebIcon() {
        return 'cbolui-icon-laptopb-circle';
    }
    static get lightbulbCirclebIcon() {
        return 'cbolui-icon-lightbulbb-circle';
    }
    static get listCirclebIcon() {
        return 'cbolui-icon-listb-circle';
    }
    static get lockCirclebIcon() {
        return 'cbolui-icon-lockb-circle';
    }
    static get mappingCirclebIcon() {
        return 'cbolui-icon-mappingb-circle';
    }
    static get menuCirclebIcon() {
        return 'cbolui-icon-menub-circle';
    }
    static get minusCirclebIcon() {
        return 'cbolui-icon-minusb-circle';
    }
    static get mobileCirclebIcon() {
        return 'cbolui-icon-mobileb-circle';
    }
    static get orgchartCirclebIcon() {
        return 'cbolui-icon-orgchartb-circle';
    }
    static get pencilCirclebIcon() {
        return 'cbolui-icon-pencilb-circle';
    }
    static get peopleCirclebIcon() {
        return 'cbolui-icon-peopleb-circle';
    }
    static get piggybankCirclebIcon() {
        return 'cbolui-icon-piggybankb-circle';
    }
    static get playButtonCirclebIcon() {
        return 'cbolui-icon-playbuttonb-circle';
    }
    static get plusCirclebIcon() {
        return 'cbolui-icon-plusb-circle';
    }
    static get printCirclebIcon() {
        return 'cbolui-icon-printb-circle';
    }
    static get profileCirclebIcon() {
        return 'cbolui-icon-profileb-circle';
    }
    static get searchCirclebIcon() {
        return 'cbolui-icon-searchb-circle';
    }
    static get shoppingCirclebIcon() {
        return 'cbolui-icon-shoppingb-circle';
    }
    static get talkCirclebIcon() {
        return 'cbolui-icon-talkb-circle';
    }
    static get telephoneCirclebIcon() {
        return 'cbolui-icon-telephoneb-circle';
    }
    static get tilesCirclebIcon() {
        return 'cbolui-icon-tilesb-circle';
    }
    static get unlockCirclebIcon() {
        return 'cbolui-icon-unlockb-circle';
    }
    static get uploadCirclebIcon() {
        return 'cbolui-icon-uploadb-circle';
    }
    static get wearCirclebIcon() {
        return 'cbolui-icon-wearb-circle';
    }
    static get websiteCirclebIcon() {
        return 'cbolui-icon-websiteb-circle';
    }
    static get xCirclebIcon() {
        return 'cbolui-icon-xb-circle';
    }
    static get yenCirclebIcon() {
        return 'cbolui-icon-yenb-circle';
    }
    static get locationCirclebIcon() {
        return 'cbolui-icon-locationb-circle';
    }
    static get serviceCirclebIcon() {
        return 'cbolui-icon-serviceb-circle';
    }
    static get pointerCirclebIcon() {
        return 'cbolui-icon-pointerb-circle';
    }
    static get cardPinCirclebIcon() {
        return 'cbolui-icon-cardPinb-circle';
    }
    //------- Icons-Light-theme-BG------//
    static get trashCanCircleIcon() {
        return 'cbolui-icon-trash-circle';
    }
    static get fourArrowsCircleIcon() {
        return 'cbolui-icon-four-arrows-circle';
    }
    static get arrowDownCircleIcon() {
        return 'cbolui-icon-arrow-down-circle';
    }
    static get arrowLefCircleIcon() {
        return 'cbolui-icon-arrow-left-circle';
    }
    static get arrowRightCircleIcon() {
        return 'cbolui-icon-arrow-right-circle';
    }
    static get arrowUpCircleIcon() {
        return 'cbolui-icon-arrow-up-circle';
    }
    static get branchCircleIcon() {
        return 'cbolui-icon-branch-circle';
    }
    static get bubbleCircleIcon() {
        return 'cbolui-icon-bubble-circle';
    }
    static get calendarCircleIcon() {
        return 'cbolui-icon-calendar-circle';
    }
    static get chartCircleIcon() {
        return 'cbolui-icon-chart-circle';
    }
    static get checkmarkCircleIcon() {
        return 'cbolui-icon-checkmark-circle';
    }
    static get circleArrowsIcon() {
        return 'cbolui-icon-circle-circle';
    }
    static get creditCardCircleIcon() {
        return 'cbolui-icon-creditCard-circle';
    }
    static get currencyBillCircleIcon() {
        return 'cbolui-icon-currency-circle';
    }
    static get docuarrowCircleIcon() {
        return 'cbolui-icon-docuarrow-circle';
    }
    static get docucheckCircleIcon() {
        return 'cbolui-icon-docucheck-circle';
    }
    static get documentCircleIcon() {
        return 'cbolui-icon-document-circle';
    }
    static get dollarCircleIcon() {
        return 'cbolui-icon-dollar-circle';
    }
    static get downloadCircleIcon() {
        return 'cbolui-icon-download-circle';
    }
    static get envelopCircleIcon() {
        return 'cbolui-icon-envelop-circle';
    }
    static get euroCircleIcon() {
        return 'cbolui-icon-euro-circle';
    }
    static get jbpCircleIcon() {
        return 'cbolui-icon-jbp-circle';
    }
    static get infoCircleIcon() {
        return 'cbolui-icon-info-circle';
    }
    static get laptopCircleIcon() {
        return 'cbolui-icon-laptop-circle';
    }
    static get lightbulbCircleIcon() {
        return 'cbolui-icon-lightbulb-circle';
    }
    static get listCircleIcon() {
        return 'cbolui-icon-list-circle';
    }
    static get lockCircleIcon() {
        return 'cbolui-icon-lock-circle';
    }
    static get mappingCircleIcon() {
        return 'cbolui-icon-mapping-circle';
    }
    static get menuCircleIcon() {
        return 'cbolui-icon-menu-circle';
    }
    static get minusCircleIcon() {
        return 'cbolui-icon-minus-circle';
    }
    static get mobileCircleIcon() {
        return 'cbolui-icon-mobile-circle';
    }
    static get orgchartCircleIcon() {
        return 'cbolui-icon-orgchart-circle';
    }
    static get pencilCircleIcon() {
        return 'cbolui-icon-pencil-circle';
    }
    static get peopleCircleIcon() {
        return 'cbolui-icon-people-circle';
    }
    static get piggybankCircleIcon() {
        return 'cbolui-icon-piggybank-circle';
    }
    static get playButtonCircleIcon() {
        return 'cbolui-icon-playbutton-circle';
    }
    static get plusCircleIcon() {
        return 'cbolui-icon-plus-circle';
    }
    static get printCircleIcon() {
        return 'cbolui-icon-print-circle';
    }
    static get profileCircleIcon() {
        return 'cbolui-icon-profile-circle';
    }
    static get searchCircleIcon() {
        return 'cbolui-icon-search-circle';
    }
    static get shoppingCircleIcon() {
        return 'cbolui-icon-shopping-circle';
    }
    static get talkCircleIcon() {
        return 'cbolui-icon-talk-circle';
    }
    static get telephoneCircleIcon() {
        return 'cbolui-icon-telephone-circle';
    }
    static get tilesCircleIcon() {
        return 'cbolui-icon-tiles-circle';
    }
    static get unlockCircleIcon() {
        return 'cbolui-icon-unlock-circle';
    }
    static get uploadCircleIcon() {
        return 'cbolui-icon-upload-circle';
    }
    static get wearCircleIcon() {
        return 'cbolui-icon-wear-circle';
    }
    static get websiteCircleIcon() {
        return 'cbolui-icon-website-circle';
    }
    static get xCircleIcon() {
        return 'cbolui-icon-x-circle';
    }
    static get yenCircleIcon() {
        return 'cbolui-icon-yen-circle';
    }
    static get locationCircleIcon() {
        return 'cbolui-icon-location-circle';
    }
    static get ensuranceCircleIcon() {
        return 'cbolui-icon-ensurance-circle';
    }
    static get serviceCircleIcon() {
        return 'cbolui-icon-service-circle';
    }
    static get pointerCircleIcon() {
        return 'cbolui-icon-pointer-circle';
    }
    static get cardPinCircleIcon() {
        return 'cbolui-icon-cardPin-circle';
    }
    //-------Icons-No-BG--------//
    static get trashCanIcon() {
        return 'cbolui-icon-trash';
    }
    static get fourArrowsIcon() {
        return 'cbolui-icon-four-arrows';
    }
    static get arrowDownIcon() {
        return 'cbolui-icon-arrow-down';
    }
    static get arrowLeftIcon() {
        return 'cbolui-icon-arrow-left';
    }
    static get arrowRightIcon() {
        return 'cbolui-icon-arrow-right';
    }
    static get arrowUpIcon() {
        return 'cbolui-icon-arrow-up';
    }
    static get branchIcon() {
        return 'cbolui-icon-branch';
    }
    static get bubbleIcon() {
        return 'cbolui-icon-bubble';
    }
    static get calendarIcon() {
        return 'cbolui-icon-calendar';
    }
    static get chartIcon() {
        return 'cbolui-icon-chart';
    }
    static get checkmarkIcon() {
        return 'cbolui-icon-checkmark';
    }
    static get roundArrowsIcon() {
        return 'cbolui-icon-round';
    }
    static get creditCardIcon() {
        return 'cbolui-icon-creditCard';
    }
    static get currencyBillIcon() {
        return 'cbolui-icon-currencybill';
    }
    static get docuarrowIcon() {
        return 'cbolui-icon-docuarrow';
    }
    static get docucheckIcon() {
        return 'cbolui-icon-docucheck';
    }
    static get documentIcon() {
        return 'cbolui-icon-document';
    }
    static get dollarIcon() {
        return 'cbolui-icon-dollar';
    }
    static get downloadIcon() {
        return 'cbolui-icon-download';
    }
    static get envelopIcon() {
        return 'cbolui-icon-envelop';
    }
    static get euroIcon() {
        return 'cbolui-icon-euro';
    }
    static get jbpIcon() {
        return 'cbolui-icon-jbp';
    }
    static get infoIcon() {
        return 'cbolui-icon-info';
    }
    static get laptopIcon() {
        return 'cbolui-icon-laptop';
    }
    static get lightbulbIcon() {
        return 'cbolui-icon-lightbulb';
    }
    static get listIcon() {
        return 'cbolui-icon-list';
    }
    static get lockIcon2() {
        return 'cbolui-icon-lock';
    }
    static get mappingIcon() {
        return 'cbolui-icon-mapping';
    }
    static get menuIcon() {
        return 'cbolui-icon-menu';
    }
    static get minusIcon() {
        return 'cbolui-icon-minus';
    }
    static get orgchartIcon() {
        return 'cbolui-icon-orgchart';
    }
    static get pencilIcon() {
        return 'cbolui-icon-pencil';
    }
    static get peopleIcon() {
        return 'cbolui-icon-people';
    }
    static get piggybankIcon() {
        return 'cbolui-icon-piggybank';
    }
    static get playButtonIcon() {
        return 'cbolui-icon-playbutton';
    }
    static get plusIcon2() {
        return 'cbolui-icon-plus';
    }
    static get printIcon() {
        return 'cbolui-icon-print';
    }
    static get profileIcon2() {
        return 'cbolui-icon-profile';
    }
    static get searchIcon2() {
        return 'cbolui-icon-search';
    }
    static get shoppingIcon() {
        return 'cbolui-icon-shopping';
    }
    static get talkIcon() {
        return 'cbolui-icon-talk';
    }
    static get telephoneIcon() {
        return 'cbolui-icon-telephone';
    }
    static get tilesIcon() {
        return 'cbolui-icon-tiles';
    }
    static get unlockIcon() {
        return 'cbolui-icon-unlock';
    }
    static get uploadIcon() {
        return 'cbolui-icon-upload';
    }
    static get wearIcon() {
        return 'cbolui-icon-wear';
    }
    static get websiteIcon() {
        return 'cbolui-icon-website';
    }
    static get xIcon() {
        return 'cbolui-icon-x';
    }
    static get yenIcon() {
        return 'cbolui-icon-yen';
    }
    static get locationIcon() {
        return 'cbolui-icon-location';
    }
    static get mobileIcon() {
        return 'cbolui-icon-mobile';
    }
    static get ensuranceIcon() {
        return 'cbolui-icon-ensurance';
    }
}

/**
 * @Component: Icon
 * @Section: Forms
 * @description This is the icon component and is used to create icon with message
 * from Bootstrap.
 */
class IconComponent {
    constructor() {
        // This property is used if the glyphicon class is needed / is a bootstrap font icon
        // glyphicon: boolean = true;
        this.settings = new IconTypeClassSettings;
        /**
         * @property title
         * @description This defines the title attribute of the icon component
         * @return string
         * @twoway true
         */
        this.title = '';
        // Classes to be applied to the label
        this.alertStatusColor = {
            'banner-alert-success': false,
            'banner-alert-danger': false
        };
    }
    ngOnInit() {
        this.iconTypeClass = `glyphicon cbolui-icon-${this.iconName}`;
        if (!!this.circle)
            this.iconTypeClass = `${this.iconTypeClass}-${this.circle}`;
        switch (this.iconType) {
            case 'blueError':
                this.iconTypeClass = `glyphicon ${iconTypeCSS.blueError}`;
                break;
            case 'redError':
                this.iconTypeClass = `glyphicon ${iconTypeCSS.redError}`;
                break;
            case 'blueAlert':
                this.iconTypeClass = `glyphicon ${iconTypeCSS.blueAlert}`;
                break;
            case 'upArrow':
                this.iconTypeClass = `glyphicon ${iconTypeCSS.upArrow}`;
                break;
            case 'downArrow':
                this.iconTypeClass = `glyphicon ${iconTypeCSS.downArrow}`;
                break;
            case 'checkIcon':
                this.iconTypeClass = `glyphicon ${iconTypeCSS.checkIcon}`;
                break;
            case 'closeIcon':
                this.iconTypeClass = `glyphicon ${iconTypeCSS.closeIcon}`;
                break;
            case 'greenTickMarkIcon':
                this.iconTypeClass = `glyphicon ${iconTypeCSS.greenTickMarkIcon}`;
                break;
            case 'lgRedError':
                this.iconTypeClass = `glyphicon ${iconTypeCSS.lgRedError}`;
                break;
            case 'redQuestionIcon':
                this.iconTypeClass = `glyphicon ${iconTypeCSS.redQuestionIcon}`;
                break;
            case 'learnMore':
                this.iconTypeClass = `glyphicon ${iconTypeCSS.learnMore}`;
                break;
            case 'greenCheckMarkIcon':
                this.iconTypeClass = `glyphicon ${iconTypeCSS.greenCheckMarkIcon}`;
                break;
        }
        //set the alert text color to green when its success.
        if (this.alertTextColor === 'success') {
            this.alertStatusColor['banner-alert-success'] = true;
            this.alertStatusColor['banner-alert-danger'] = false;
        }
        //set the alert text color to red when its critical/danger
        if (this.alertTextColor === 'danger') {
            this.alertStatusColor['banner-alert-danger'] = true;
            this.alertStatusColor['banner-alert-success'] = true;
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: IconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: IconComponent, isStandalone: false, selector: "citi-icon", inputs: { idStr: "idStr", title: "title", iconTextMessage: "iconTextMessage", isSROnly: "isSROnly", alertTextColor: "alertTextColor", iconType: "iconType", iconName: "iconName", circle: "circle" }, ngImport: i0, template: `
  <div class="cbolui-icon-wrapper" [attr.id]="idStr">

    <span class="iconClass"
      [ngClass]="[iconTypeClass]"
      [attr.id]="idStr + '-icon'"
      [title]="title"
    ></span>

    <span *ngIf="iconTextMessage"
      class="cbolui-icon-text {{isSROnly ? 'sr-only' : ''}}"
      [ngClass]="alertStatusColor"
      [attr.id]="idStr + '-iconText'"
      [innerHtml]="iconTextMessage"
    ></span>

    <span *ngIf="!iconTextMessage"
      class="cbolui-icon-text {{isSROnly ? 'sr-only' : ''}}"
      [ngClass]="alertStatusColor"
      [attr.id]="idStr + '-iconText'">
        <ng-content></ng-content>
    </span>

  </div>
  `, isInline: true, styles: [".cbolui-icon-globalSpriteBase{padding-right:7px;top:3px;font-size:20px;height:20px}.cbolui-icon-wrapper{padding:15px;margin-bottom:24px;border:1px solid transparent;border-radius:6px;display:flex;display:-webkit-flex}.cbolui-icon-wrapper .iconClass{margin-right:10px;padding-right:0!important;flex-shrink:0}.cbolui-icon-red{color:#d60000}.cbolui-icon-blue{color:#056dae;margin-top:5px}.cbolui-icon-orange{color:#cb6015}.cbolui-icon-green{color:#006e0a}.checkmark-icon{width:15px;height:10px;top:8px}.glyphicon-triangle-up,.glyphicon-triangle-down{margin-top:5px}.cbolui-icon-trash-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_trash%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M33%2C12H27a4%2C4%2C0%2C0%2C0-4-4H19a4%2C4%2C0%2C0%2C0-4%2C4H9v2h2V30a4%2C4%2C0%2C0%2C0%2C4%2C4H27a4%2C4%2C0%2C0%2C0%2C4-4V14h2ZM19%2C10h4a2%2C2%2C0%2C0%2C1%2C2%2C2H17A2%2C2%2C0%2C0%2C1%2C19%2C10ZM29%2C30a2%2C2%2C0%2C0%2C1-2%2C2H15a2%2C2%2C0%2C0%2C1-2-2V27.21L29%2C18.7Zm0-13.57L13%2C24.94V14H29Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-trash-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_trash%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M33%2C12H27a4%2C4%2C0%2C0%2C0-4-4H19a4%2C4%2C0%2C0%2C0-4%2C4H9v2h2V30a4%2C4%2C0%2C0%2C0%2C4%2C4H27a4%2C4%2C0%2C0%2C0%2C4-4V14h2ZM19%2C10h4a2%2C2%2C0%2C0%2C1%2C2%2C2H17A2%2C2%2C0%2C0%2C1%2C19%2C10ZM29%2C30a2%2C2%2C0%2C0%2C1-2%2C2H15a2%2C2%2C0%2C0%2C1-2-2V27.21L29%2C18.7Zm0-13.57L13%2C24.94V14H29Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-trash{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_trash%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M33%2C12H27a4%2C4%2C0%2C0%2C0-4-4H19a4%2C4%2C0%2C0%2C0-4%2C4H9v2h2V30a4%2C4%2C0%2C0%2C0%2C4%2C4H27a4%2C4%2C0%2C0%2C0%2C4-4V14h2ZM19%2C10h4a2%2C2%2C0%2C0%2C1%2C2%2C2H17A2%2C2%2C0%2C0%2C1%2C19%2C10ZM29%2C30a2%2C2%2C0%2C0%2C1-2%2C2H15a2%2C2%2C0%2C0%2C1-2-2V27.21L29%2C18.7Zm0-13.57L13%2C24.94V14H29Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-trash-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_trash%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M33%2C12H27a4%2C4%2C0%2C0%2C0-4-4H19a4%2C4%2C0%2C0%2C0-4%2C4H9v2h2V30a4%2C4%2C0%2C0%2C0%2C4%2C4H27a4%2C4%2C0%2C0%2C0%2C4-4V14h2ZM19%2C10h4a2%2C2%2C0%2C0%2C1%2C2%2C2H17A2%2C2%2C0%2C0%2C1%2C19%2C10ZM29%2C30a2%2C2%2C0%2C0%2C1-2%2C2H15a2%2C2%2C0%2C0%2C1-2-2V27.21L29%2C18.7Zm0-13.57L13%2C24.94V14H29Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-four-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2042%2042%22%20style%3D%22enable-background%3Anew%200%200%2042%2042%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text/css%22%3E%0A%09.st0%7Bfill%3A%23FFFFFF%3B%7D%0A%09.st1%7Bfill%3A%23002D72%3B%7D%0A%3C/style%3E%0A%3Cg%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M41%2C21c0%2C11-9%2C20-20%2C20C10%2C41%2C1%2C32%2C1%2C21S10%2C1%2C21%2C1C32%2C1%2C41%2C10%2C41%2C21%22/%3E%0A%09%3Cpolygon%20class%3D%22st1%22%20points%3D%2237%2C21%2029%2C16.4%2029%2C20%2022%2C20%2022%2C13%2025.6%2C13%2021%2C5%2016.4%2C13%2020%2C13%2020%2C20%2013%2C20%2013%2C16.4%205%2C21%2013%2C25.6%2013%2C22%20%0A%09%0920%2C22%2020%2C29%2016.4%2C29%2021%2C37%2025.6%2C29%2022%2C29%2022%2C22%2029%2C22%2029%2C25.6%20%09%22/%3E%0A%3C/g%3E%0A%3C/svg%3E%0A);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-arrowdown-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2042%2042%22%20style%3D%22enable-background%3Anew%200%200%2042%2042%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text/css%22%3E%0A%09.st0%7Bfill%3A%23FFFFFF%3B%7D%0A%09.st1%7Bfill%3A%23002D72%3B%7D%0A%3C/style%3E%0A%3Cg%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M41%2C21c0%2C11-9%2C20-20%2C20C10%2C41%2C1%2C32%2C1%2C21S10%2C1%2C21%2C1C32%2C1%2C41%2C10%2C41%2C21%22/%3E%0A%09%3Cpath%20class%3D%22st1%22%20d%3D%22M20%2C9v21.7c-0.2-0.1-0.4-0.3-0.6-0.5l-6.1-11.6l-1.8%2C0.9l5.7%2C10.8l0%2C0c0.6%2C1.5%2C2%2C2.6%2C3.7%2C2.6%0A%09%09c1.7%2C0%2C3.1-1%2C3.7-2.5l5.8-10.9l-1.8-0.9l-5.9%2C11c-0.2%2C0.4-0.5%2C0.8-0.9%2C1V9H20z%22/%3E%0A%3C/g%3E%0A%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-arrowleft-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_arrow_left%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C1%2C41%2C21%2C20%2C20%2C0%2C0%2C1%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M33%2C20H11.3a2%2C2%2C0%2C0%2C1%2C.5-.58l11.55-6.14-.94-1.77L11.64%2C17.24v0a4%2C4%2C0%2C0%2C0-.17%2C7.44l10.94%2C5.8.94-1.77-11-5.87a2%2C2%2C0%2C0%2C1-1-.86H33Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-arrowright-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_arrow_riwht%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C1A20%2C20%2C0%2C1%2C1%2C1%2C21%2C20%2C20%2C0%2C0%2C1%2C21%2C1%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M9%2C22H30.7a2%2C2%2C0%2C0%2C1-.5.58L18.65%2C28.72l.94%2C1.77%2C10.77-5.73v0a4%2C4%2C0%2C0%2C0%2C.16-7.44l-10.94-5.8-.94%2C1.77%2C11%2C5.87a2%2C2%2C0%2C0%2C1%2C1%2C.86H9Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-arrowup-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_arrow_up%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M1%2C21A20%2C20%2C0%2C1%2C1%2C21%2C41%2C20%2C20%2C0%2C0%2C1%2C1%2C21%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M22%2C33V11.3a2%2C2%2C0%2C0%2C1%2C.57.5l6.14%2C11.55%2C1.77-.94L24.77%2C11.64h0a4%2C4%2C0%2C0%2C0-7.44-.17l-5.8%2C10.94%2C1.77.94%2C5.87-11a2%2C2%2C0%2C0%2C1%2C.86-1V33Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-branch-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_branch%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C1A20%2C20%2C0%2C1%2C1%2C1%2C21%2C20%2C20%2C0%2C0%2C1%2C21%2C1%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M33%2C17V13h0a2%2C2%2C0%2C0%2C0-2-2H11a2%2C2%2C0%2C0%2C0-2%2C2H9v4h2V29H9v2H33V29H31V17Zm-2-4v2H11V13ZM21%2C21v8H17V21Zm8%2C8H23V19H15V29H13V17H29Zm-2-4H25V21h2v4Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-bubble-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_bubble%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M26.22%2C13.89C24.7%2C11%2C21.15%2C9%2C17%2C9%2C11.48%2C9%2C7%2C12.58%2C7%2C17c0%2C3%2C2%2C5.48%2C5%2C6.86v5.41l5.23-2.82a9%2C9%2C0%2C0%2C0%2C1.88%2C1.62l11.14%2C6V28.66c3-1.37%2C5-3.91%2C5-6.86C35.25%2C17.65%2C31.28%2C14.29%2C26.22%2C13.89ZM9%2C17c0-3.31%2C3.58-6%2C8-6s8%2C2.69%2C8%2C6a5.51%2C5.51%2C0%2C0%2C1-2.79%2C4.52L14%2C25.94V22.52C11.08%2C21.63%2C9%2C19.51%2C9%2C17ZM28.25%2C27.32v3.42L20%2C26.32a6.54%2C6.54%2C0%2C0%2C1-1-.83l4.13-2.22A7.51%2C7.51%2C0%2C0%2C0%2C27%2C17a6.44%2C6.44%2C0%2C0%2C0-.13-1c3.63.56%2C6.38%2C2.93%2C6.38%2C5.82C33.25%2C24.31%2C31.17%2C26.43%2C28.25%2C27.32Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-calendar-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_calendar%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M33%2C11H27V9H25v2H17V9H15v2H9V27a6%2C6%2C0%2C0%2C0%2C6%2C6H27a6%2C6%2C0%2C0%2C0%2C6-6h0ZM15%2C13v2h2V13h8v2h2V13h4v4H11V13ZM31%2C27a4%2C4%2C0%2C0%2C1-4%2C4H15a4%2C4%2C0%2C0%2C1-4-4V19H31Zm-4.74-6%2C.94%2C1.77-9.65%2C5.09-.94-1.77h0L15%2C22.93%2C16.77%2C22l1.65%2C3.16Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-chart-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_chart%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M17%2C29a4%2C4%2C0%2C0%2C1-4-3.81V23.09l4.94-2.63%2C1.81%2C3.4%2C11.61-6.18-.94-1.77-9.85%2C5.24-1.81-3.39L13%2C20.82V13H11V25.22A6%2C6%2C0%2C0%2C0%2C17%2C31H31V29Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-checkmark-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_checkmark%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpolygon%20class%3D%22cls-2%22%20points%3D%2231.9%2014.46%2015.3%2023.29%2011.77%2016.64%2010%2017.58%2014.46%2026%2032.84%2016.23%2031.9%2014.46%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-circle-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_circlearrows%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C1A20%2C20%2C0%2C1%2C1%2C1%2C21%2C20%2C20%2C0%2C0%2C1%2C21%2C1%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M31.45%2C26.81a12%2C12%2C0%2C0%2C1-21.16-.27l1.73-1a10%2C10%2C0%2C0%2C0%2C17.66.35l-3.21-1.7%2C7.84-4.9.32%2C9.23ZM26.59%2C10.41a12%2C12%2C0%2C0%2C0-16.16%2C4.85L7.37%2C13.62l.32%2C9.23L15.52%2C18l-3.32-1.77a10%2C10%2C0%2C0%2C1%2C17.67.32l1.73-1A11.94%2C11.94%2C0%2C0%2C0%2C26.59%2C10.41Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-creditCard-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_creditcard%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M21%2C23v2H11V23Zm14-8h0V27a4%2C4%2C0%2C0%2C1-4%2C4H11a4%2C4%2C0%2C0%2C1-4-4V15H7a4%2C4%2C0%2C0%2C1%2C4-4H31a4%2C4%2C0%2C0%2C1%2C4%2C4ZM11%2C29H21.44L33%2C22.85V19H9v8A2%2C2%2C0%2C0%2C0%2C11%2C29Zm22-2V25.12L25.7%2C29H31A2%2C2%2C0%2C0%2C0%2C33%2C27Zm0-12a2%2C2%2C0%2C0%2C0-2-2H11a2%2C2%2C0%2C0%2C0-2%2C2v2H33Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-currency-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_currency_bill%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M7%2C13V29H35V13Zm26%2C7.88L24.18%2C25.6A6.48%2C6.48%2C0%2C0%2C0%2C26%2C21c0-3.19-2.08-5.77-4.7-6v0H33ZM9%2C15h7.49L9%2C19Zm12%2C2c1.66%2C0%2C3%2C1.79%2C3%2C4s-1.34%2C4-3%2C4-3-1.79-3-4S19.34%2C17%2C21%2C17ZM9%2C21.22l8.5-4.5A6.61%2C6.61%2C0%2C0%2C0%2C16%2C21c0%2C3.24%2C2.14%2C5.86%2C4.82%2C6v0H9ZM25.84%2C27%2C33%2C23.18V27Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-docuarrow-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_docuarrow%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M11%2C9V33H24.13l5.09-2.67A4%2C4%2C0%2C0%2C0%2C31%2C27h0V9ZM27.73%2C28.85l-4%2C2.15H23V27h6A2%2C2%2C0%2C0%2C1%2C27.73%2C28.85ZM21%2C25v6H13V11H29v6H23V14l-7%2C4%2C7%2C4V19h6v6Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-docucheck-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_docucheck%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M11%2C9V33H24.14l5.08-2.7h0A4%2C4%2C0%2C0%2C0%2C31%2C27h0V9ZM29%2C27a2%2C2%2C0%2C0%2C1-1.27%2C1.85l-4%2C2.15H23V27Zm0-2H21v6H13V11H29ZM17.53%2C21.84%2C15%2C16.93%2C16.72%2C16l1.65%2C3.15L26.24%2C15l.94%2C1.77Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-document-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_document%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C1%2C41%2C21%2C20%2C20%2C0%2C0%2C1%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M11%2C9V33H24.13l5.08-2.7h0A4%2C4%2C0%2C0%2C0%2C31%2C27h0V9ZM29%2C27a2%2C2%2C0%2C0%2C1-1.27%2C1.85l-4%2C2.15H23V27Zm0-2H21v6H13V11H29ZM27%2C15H15V13H27ZM15%2C19V17h8v2Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-dollar-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_dollar%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M22.32%2C34.26H19.79v-3.8a9.09%2C9.09%2C0%2C0%2C1-5.15-2.56l-.18-.19%2C1.74-1.94.21.2a6.7%2C6.7%2C0%2C0%2C0%2C4.72%2C2.14c2.36%2C0%2C3.71-1%2C3.71-2.76%2C0-1.55-.95-2.34-4.23-3.52-3.74-1.34-5.51-2.5-5.51-5.51%2C0-2.6%2C1.75-4.37%2C4.7-4.78V7.74h2.53v3.76a8.53%2C8.53%2C0%2C0%2C1%2C4.62%2C2l.22.17-1.67%2C2-.21-.18A6.17%2C6.17%2C0%2C0%2C0%2C21%2C13.88c-2.14%2C0-3.31.82-3.31%2C2.31%2C0%2C1.27.4%2C2%2C4.2%2C3.33%2C4.25%2C1.53%2C5.54%2C2.87%2C5.54%2C5.72s-2%2C4.79-5.12%2C5.21Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-download-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_download%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M33%2C23v2a6%2C6%2C0%2C0%2C1-6%2C6H15a6%2C6%2C0%2C0%2C1-6-6V23h2v2a4%2C4%2C0%2C0%2C0%2C4%2C4H27a4%2C4%2C0%2C0%2C0%2C4-4V23ZM22%2C17V9H20v8H16.38L21%2C25l4.62-8Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-envelop-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_envelope%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M33%2C15h0V13H9V25a6%2C6%2C0%2C0%2C0%2C6%2C6H27a6%2C6%2C0%2C0%2C0%2C6-6V15ZM31%2C25a4%2C4%2C0%2C0%2C1-4%2C4H15a4%2C4%2C0%2C0%2C1-4-4h0V19.75l10%2C5.32%2C10-5.27Zm0-7.46L21%2C22.83%2C11%2C17.49V15H31Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-euro-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_euro%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M22%2C31c-3.13%2C0-5.75-3-6.64-7H21V22H15.07c0-.33-.07-.66-.07-1s0-.67.07-1H21V18H15.36c.89-4%2C3.52-7%2C6.64-7a6.26%2C6.26%2C0%2C0%2C1%2C5.09%2C3.16l1.73-.92C27.17%2C10.67%2C24.74%2C9%2C22%2C9c-4.2%2C0-7.71%2C3.83-8.71%2C9H11v2h2c0%2C.33%2C0%2C.66%2C0%2C1s0%2C.67%2C0%2C1H11v2h2.3c1%2C5.17%2C4.52%2C9%2C8.71%2C9%2C2.74%2C0%2C5.16-1.67%2C6.8-4.25l-1.71-.91A6.25%2C6.25%2C0%2C0%2C1%2C22%2C31Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-jbp-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_GBP%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M27.17%2C26.86a4%2C4%2C0%2C0%2C1-3.73%2C2.59%2C3.65%2C3.65%2C0%2C0%2C1-1.54-.37v0L19%2C27.56V21h6V19H19V15h0a4%2C4%2C0%2C0%2C1%2C4-4%2C3.94%2C3.94%2C0%2C0%2C1%2C2.56%2C1l1.88-1A6%2C6%2C0%2C0%2C0%2C17%2C15h0v4H15v2h2v6.29l-4%2C2.13.94%2C1.77%2C3.8-2%2C2.83%2C1.51a5.79%2C5.79%2C0%2C0%2C0%2C.52.28l.37.13a5.83%2C5.83%2C0%2C0%2C0%2C2%2C.38A6%2C6%2C0%2C0%2C0%2C29%2C27.8Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-info-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_info%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M23%2C13a2%2C2%2C0%2C1%2C1-2-2%2C2%2C2%2C0%2C0%2C1%2C2%2C2m12%2C8A14%2C14%2C0%2C1%2C0%2C21%2C35%2C14%2C14%2C0%2C0%2C0%2C35%2C21m2%2C0A16%2C16%2C0%2C1%2C1%2C21%2C5%2C16%2C16%2C0%2C0%2C1%2C37%2C21M23%2C17.09l-4.74%2C2.52.94%2C1.77%2C1.8-1V31h2Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-laptop-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_laptop%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M31%2C25V11H11V25H7a6%2C6%2C0%2C0%2C0%2C6%2C6H29a6%2C6%2C0%2C0%2C0%2C6-6ZM13%2C13h8.43L13%2C17.48Zm0%2C6.75L25.69%2C13H29V25H13ZM29%2C29H13a4%2C4%2C0%2C0%2C1-3.46-2H32.47A4%2C4%2C0%2C0%2C1%2C29%2C29Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-lightbulb-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_lightbulb%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C1%2C41%2C21%2C20%2C20%2C0%2C0%2C1%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M17%2C29h8v2H17Zm2%2C6h4V33H19Zm6.44-18.14-.94-1.77L21%2C17%2C17.5%2C15.1l-.94%2C1.77L21%2C19.22h0Zm-.44%2C7V27H17V23.87a8%2C8%2C0%2C1%2C1%2C8%2C0ZM27%2C17a6%2C6%2C0%2C1%2C0-8%2C5.63V25h4V22.63A6%2C6%2C0%2C0%2C0%2C27%2C17Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-list-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_list%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M15%2C11H31v2H15Zm0%2C14H31V23H15Zm0%2C6H31V29H15Zm0-12H31V17H15Zm-3-6a1%2C1%2C0%2C1%2C0-1-1%2C1%2C1%2C0%2C0%2C0%2C1%2C1m0%2C12a1%2C1%2C0%2C1%2C0-1-1%2C1%2C1%2C0%2C0%2C0%2C1%2C1m0-6a1%2C1%2C0%2C1%2C0-1-1%2C1%2C1%2C0%2C0%2C0%2C1%2C1m0%2C12a1%2C1%2C0%2C1%2C0-1-1%2C1%2C1%2C0%2C0%2C0%2C1%2C1%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-lock-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_lock%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M27%2C15V13h0a6%2C6%2C0%2C1%2C0-12%2C0v2H11v2h0v8a6%2C6%2C0%2C0%2C0%2C6%2C6h8a6%2C6%2C0%2C0%2C0%2C6-6V15ZM17%2C13a4%2C4%2C0%2C1%2C1%2C8%2C0h0v2H17ZM29%2C25a4%2C4%2C0%2C0%2C1-4%2C4H17a4%2C4%2C0%2C0%2C1-2.89-1.23L29%2C19.88Zm0-7.39L13.14%2C26A3.87%2C3.87%2C0%2C0%2C1%2C13%2C25V17H29Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-mapping-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_mappin%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M29%2C17c0%2C4.73-8%2C14.9-8%2C14.9S13%2C21.73%2C13%2C17a7.81%2C7.81%2C0%2C0%2C1%2C8-8%2C7.81%2C7.81%2C0%2C0%2C1%2C8%2C8m2%2C0a10%2C10%2C0%2C0%2C0-20%2C0c0%2C5.52%2C10%2C18%2C10%2C18S31%2C22.52%2C31%2C17m-6%2C0a4%2C4%2C0%2C1%2C1-4-4%2C4%2C4%2C0%2C0%2C1%2C4%2C4m2%2C0a6%2C6%2C0%2C1%2C0-6%2C6%2C6%2C6%2C0%2C0%2C0%2C6-6%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-menu-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_menu%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M11%2C15H31v2H11Zm0%2C12H31V25H11Zm0-5H31V20H11Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-minus-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_minus%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpolygon%20class%3D%22cls-2%22%20points%3D%2210%2021%2029%2021%2030%2021%2030%2019%2010%2019%2010%2021%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-mobile-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%0A%3Csvg%20width%3D%2240px%22%20height%3D%2240px%22%20viewBox%3D%220%200%2040%2040%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%0A%20%20%20%20%3C!--%20Generator%3A%20Sketch%2053.1%20%2872631%29%20-%20https%3A%2F%2Fsketchapp.com%20--%3E%0A%20%20%20%20%3Ctitle%3E055-mobile-white-circle%3C%2Ftitle%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%0A%20%20%20%20%3Cdefs%3E%0A%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22path-1%22%20cx%3D%2219%22%20cy%3D%2219%22%20r%3D%2219%22%3E%3C%2Fcircle%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M7%2C5%20L7%2C3.5%20C7%2C2.671%207.671%2C2%208.5%2C2%20L17.5%2C2%20C18.328%2C2%2019%2C2.671%2019%2C3.5%20L19%2C5%20L7%2C5%20Z%20M7%2C20%20L19%2C20%20L19%2C6%20L7%2C6%20L7%2C20%20Z%20M19%2C22.5%20C19%2C23.328%2018.328%2C24%2017.5%2C24%20L8.5%2C24%20C7.671%2C24%207%2C23.328%207%2C22.5%20L7%2C21%20L19%2C21%20L19%2C22.5%20Z%20M17.5%2C1%20L8.5%2C1%20C7.119%2C1%206%2C2.119%206%2C3.5%20L6%2C5%20L6%2C6%20L6%2C20%20L6%2C21%20L6%2C22.5%20C6%2C23.881%207.119%2C25%208.5%2C25%20L17.5%2C25%20C18.881%2C25%2020%2C23.881%2020%2C22.5%20L20%2C21%20L20%2C20%20L20%2C6%20L20%2C5%20L20%2C3.5%20C20%2C2.119%2018.881%2C1%2017.5%2C1%20L17.5%2C1%20Z%22%20id%3D%22path-3%22%3E%3C%2Fpath%3E%0A%20%20%20%20%3C%2Fdefs%3E%0A%20%20%20%20%3Cg%20id%3D%22Symbols%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%2299-icon-template%2F01-template%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%2299-icon-template%2F02-circle%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Circle%22%20transform%3D%22translate%281.000000%2C%201.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-2%22%20fill%3D%22white%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fmask%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Mask%22%20fill-rule%3D%22nonzero%22%3E%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22color%2Fwhite%22%20mask%3D%22url%28%23mask-2%29%22%20fill%3D%22%23FFFFFF%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%28-1.000000%2C%20-1.000000%29%22%20id%3D%22Color-%2F-White%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20x%3D%220%22%20y%3D%220%22%20width%3D%2240%22%20height%3D%2240%22%3E%3C%2Frect%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%2212-mobile%2F055-mobile%22%20transform%3D%22translate%287.000000%2C%207.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-4%22%20fill%3D%22white%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-3%22%3E%3C%2Fuse%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fmask%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20id%3D%22Mask%22%20fill%3D%22%23046EAE%22%20fill-rule%3D%22evenodd%22%20xlink%3Ahref%3D%22%23path-3%22%3E%3C%2Fuse%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22color%2Fb1%22%20mask%3D%22url%28%23mask-4%29%22%20fill%3D%22%23002A54%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Color-%2F-B1%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2226%22%20height%3D%2226%22%3E%3C%2Frect%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3C%2Fg%3E%0A%3C%2Fsvg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-pencil-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_pencil%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M27%2C25.89l2-1.06V29a4%2C4%2C0%2C0%2C1-4%2C4H13a4%2C4%2C0%2C0%2C1-4-4V13a4%2C4%2C0%2C0%2C1%2C4-4H25a4%2C4%2C0%2C0%2C1%2C3.86%2C3.31L27%2C13.3V13a2%2C2%2C0%2C0%2C0-2-2H13a2%2C2%2C0%2C0%2C0-2%2C2V29a2%2C2%2C0%2C0%2C0%2C2%2C2H25a2%2C2%2C0%2C0%2C0%2C2-2Zm11.14-8L20%2C27.51H14.1l-1-1.88%2C3.25-4.82%2C0-.06L34.55%2C11.1ZM19.91%2C21.14l1.72%2C3.24%2C9.25-4.92-1.72-3.24Zm-.4%2C4.37.36-.19-1.72-3.24-.36.19L15.6%2C25.51ZM35.44%2C17%2C33.72%2C13.8l-2.8%2C1.49%2C1.72%2C3.24Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-people-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_people%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M28%2C19a5%2C5%2C0%2C1%2C0-5-5A5%2C5%2C0%2C0%2C0%2C28%2C19Zm0-8a3%2C3%2C0%2C1%2C1-3%2C3A3%2C3%2C0%2C0%2C1%2C28%2C11ZM14%2C19a5%2C5%2C0%2C1%2C0-5-5A5%2C5%2C0%2C0%2C0%2C14%2C19Zm0-8a3%2C3%2C0%2C1%2C1-3%2C3A3%2C3%2C0%2C0%2C1%2C14%2C11Zm.77%2C10.43A3.9%2C3.9%2C0%2C0%2C0%2C13%2C21a4%2C4%2C0%2C0%2C0-4%2C4H9v8H21V24.72l-6.19-3.29ZM19%2C31H11V25h0a2%2C2%2C0%2C0%2C1%2C2-2%2C3.51%2C3.51%2C0%2C0%2C1%2C1%2C.27l5%2C2.66Zm14-6h0v8H23V31h8V25a2%2C2%2C0%2C0%2C0-2-2%2C2%2C2%2C0%2C0%2C0-1%2C.3v0l-5%2C2.66V23.66l4.19-2.23A7.37%2C7.37%2C0%2C0%2C1%2C29%2C21%2C4%2C4%2C0%2C0%2C1%2C33%2C25Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-piggybank-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_piggybank%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C1%2C41%2C21%2C20%2C20%2C0%2C0%2C1%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M25.74%2C18.37A5.55%2C5.55%2C0%2C0%2C0%2C22%2C17a5.62%2C5.62%2C0%2C0%2C0-3.62%2C1.25l-1.83-1a7.66%2C7.66%2C0%2C0%2C1%2C11%2C.12ZM32.36%2C17A7.5%2C7.5%2C0%2C0%2C1%2C33%2C20a8.38%2C8.38%2C0%2C0%2C1-4%2C6.87V31H15V26.87A9.22%2C9.22%2C0%2C0%2C1%2C11.7%2C23H9V17h2.72A8.41%2C8.41%2C0%2C0%2C1%2C13%2C15V9h2l4.36%2C2.28A12.69%2C12.69%2C0%2C0%2C1%2C22%2C11a11.68%2C11.68%2C0%2C0%2C1%2C9.36%2C4.28l1.4-.74.94%2C1.76ZM31%2C20c0-3.87-4-7-9-7a11.24%2C11.24%2C0%2C0%2C0-2.88.39L15%2C11.26v4.37A6.39%2C6.39%2C0%2C0%2C0%2C13.13%2C19H11v2h2.13A7.12%2C7.12%2C0%2C0%2C0%2C17%2C25.76V29h4V27h2v2h4V25.76C29.36%2C24.5%2C31%2C22.39%2C31%2C20Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-playbutton-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_play_button%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M29%2C11H13a6%2C6%2C0%2C0%2C0-6%2C6v8a6%2C6%2C0%2C0%2C0%2C6%2C6H29a6%2C6%2C0%2C0%2C0%2C6-6V17A6%2C6%2C0%2C0%2C0%2C29%2C11Zm4%2C14.19A4%2C4%2C0%2C0%2C1%2C29.2%2C29H12.81A4%2C4%2C0%2C0%2C1%2C9%2C25.19V16.81A4%2C4%2C0%2C0%2C1%2C12.81%2C13H29.2A4%2C4%2C0%2C0%2C1%2C33%2C16.81ZM18%2C26.34a1%2C1%2C0%2C0%2C1-1-1V16.66a1%2C1%2C0%2C0%2C1%2C.48-.86%2C1%2C1%2C0%2C0%2C1%2C1%2C0l8.17%2C4.33a1%2C1%2C0%2C0%2C1%2C0%2C1.77l-8.17%2C4.34A1%2C1%2C0%2C0%2C1%2C18%2C26.34Zm1-8v5.35L24%2C21Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-plus-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_plus%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpolygon%20class%3D%22cls-2%22%20points%3D%2230%2019%2021%2019%2021%2010%2019%2010%2019%2019%2010%2019%2010%2021%2019%2021%2019%2030%2021%2030%2021%2021%2030%2021%2030%2019%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-print-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_print%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M29%2C19h2v2H29Zm6%2C0v8H29v4H13V27H7V19a4%2C4%2C0%2C0%2C1%2C4-4h2V9H29v6h2A4%2C4%2C0%2C0%2C1%2C35%2C19ZM15%2C15H27V11H15Zm0%2C14H27V23H15Zm18-8V19a2%2C2%2C0%2C0%2C0-2-2H11a2%2C2%2C0%2C0%2C0-2%2C2v6h4V21H29v4h4Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-profile-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_profile%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M25%2C17a4%2C4%2C0%2C1%2C1-4-4%2C4%2C4%2C0%2C0%2C1%2C4%2C4m2%2C0a6%2C6%2C0%2C1%2C0-6%2C6%2C6%2C6%2C0%2C0%2C0%2C6-6m-6%2C7.39L9.36%2C30.58l.94%2C1.77L21%2C26.66l10.7%2C5.69.94-1.77Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-search-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_search%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M23%2C9a8%2C8%2C0%2C0%2C0-4.6%2C14.53L13%2C33.7l1.77.94%2C5.41-10.18A8%2C8%2C0%2C1%2C0%2C23%2C9Zm0%2C14a6%2C6%2C0%2C1%2C1%2C6-6A6%2C6%2C0%2C0%2C1%2C23%2C23Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-shopping-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_shopping_cart%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M41%2C21A20%2C20%2C0%2C1%2C1%2C21%2C1%2C20%2C20%2C0%2C0%2C1%2C41%2C21%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M29%2C33a2%2C2%2C0%2C1%2C1-2-2A2%2C2%2C0%2C0%2C1%2C29%2C33ZM17%2C31a2%2C2%2C0%2C1%2C0%2C2%2C2A2%2C2%2C0%2C0%2C0%2C17%2C31ZM31%2C15v6h0l-7.58%2C4v0H13a2%2C2%2C0%2C0%2C0%2C2%2C2H29v2H15a4%2C4%2C0%2C0%2C1-4-4V15H7V13h6v2Zm-2%2C2H13v6H23l6-3.2Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-talk-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_talk%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M31%2C19c0%2C3-2%2C5.51-5%2C6.89l-9%2C4.78V26.27c-3.52-1.24-6-4-6-7.27%2C0-4.42%2C4.48-8%2C10-8s10%2C3.58%2C10%2C8m2%2C0c0-5.52-5.37-10-12-10S9%2C13.48%2C9%2C19c0%2C3.69%2C2.42%2C6.88%2C6%2C8.6V34l12.94-6.88h0A9.54%2C9.54%2C0%2C0%2C0%2C33%2C19%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-telephone-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_telephone%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M31.11%2C31.49l-3.75-7.06-4.54%2C0-3.64-6.84%2C2.49-3.69L18%2C6.76h0L14.44%2C8.64h0A6%2C6%2C0%2C0%2C0%2C12%2C16.76h0l7.51%2C14.13h0a6%2C6%2C0%2C0%2C0%2C8.11%2C2.48h0l3.53-1.88Zm-4.47.11h0a4%2C4%2C0%2C0%2C1-5.41-1.65L13.72%2C15.82a4%2C4%2C0%2C0%2C1%2C1.65-5.41h0l1.77-.94%2C2.24%2C4.21-2.53%2C3.75h0l4.79%2C9h4.5l2.27%2C4.26-1.76.94Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-tiles-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_tiles%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M13%2C9a4%2C4%2C0%2C0%2C0-4%2C3.83H9V19H19V9Zm4%2C8H11V13a2%2C2%2C0%2C0%2C1%2C2-2h4Zm16-4a4%2C4%2C0%2C0%2C0-4-4H23V19H33V13Zm-2%2C4H25V11h4a2%2C2%2C0%2C0%2C1%2C2%2C2ZM9%2C23v6a4%2C4%2C0%2C0%2C0%2C4%2C4h6V23Zm8%2C8H13a2%2C2%2C0%2C0%2C1-2-2V25h6Zm6-8V33h6a4%2C4%2C0%2C0%2C0%2C4-4V23Zm6%2C8H25V25h6v4A2%2C2%2C0%2C0%2C1%2C29%2C31Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-upload-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_upload%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C1A20%2C20%2C0%2C1%2C0%2C41%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C1%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M9%2C19V17a6%2C6%2C0%2C0%2C1%2C6-6H27a6%2C6%2C0%2C0%2C1%2C6%2C6v2H31V17a4%2C4%2C0%2C0%2C0-4-4H15a4%2C4%2C0%2C0%2C0-4%2C4v2Zm11%2C6v8h2V25h3.62L21%2C17l-4.62%2C8Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-unlock-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_unlock%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M21%2C15V13h0A6%2C6%2C0%2C0%2C0%2C9%2C13H9v4h2V13a4%2C4%2C0%2C0%2C1%2C8%2C0v2H15V25a6%2C6%2C0%2C0%2C0%2C6%2C6h8a6%2C6%2C0%2C0%2C0%2C6-6V15ZM33%2C25a4%2C4%2C0%2C0%2C1-4%2C4H21a4%2C4%2C0%2C0%2C1-2.88-1.21L33%2C19.88V25Zm0-7.39L17.14%2C26A4%2C4%2C0%2C0%2C1%2C17%2C25h0V17H33Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-wear-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_wear%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M21%2C16a5%2C5%2C0%2C1%2C0%2C5%2C5A5%2C5%2C0%2C0%2C0%2C21%2C16Zm0%2C8a3%2C3%2C0%2C1%2C1%2C3-3A3%2C3%2C0%2C0%2C1%2C21%2C24Zm11-1.27a11.06%2C11.06%2C0%2C0%2C0%2C0-3.46l3.13-1.8-4-6.93L28%2C12.34a11.08%2C11.08%2C0%2C0%2C0-3-1.73V7H17v3.57a11%2C11%2C0%2C0%2C0-1.59.74%2C10.82%2C10.82%2C0%2C0%2C0-1.43%2C1l-3.1-1.79-4%2C6.93L10%2C19.27a11.28%2C11.28%2C0%2C0%2C0%2C0%2C3.46l-3.12%2C1.8h0l4%2C6.93L14%2C29.66a11.16%2C11.16%2C0%2C0%2C0%2C3%2C1.73V35h8V31.43a9.8%2C9.8%2C0%2C0%2C0%2C3-1.75l3.09%2C1.79%2C4-6.93Zm-1.6%2C6-2.57-1.48A8.72%2C8.72%2C0%2C0%2C1%2C23%2C30v3H19V30a9.23%2C9.23%2C0%2C0%2C1-4.84-2.77l-2.55%2C1.47-2-3.46%2C2.55-1.47a9.26%2C9.26%2C0%2C0%2C1%2C0-5.58L9.61%2C16.73l2-3.46%2C2.56%2C1.48A8.74%2C8.74%2C0%2C0%2C1%2C19%2C12V9h4v3a9.26%2C9.26%2C0%2C0%2C1%2C4.85%2C2.78l2.55-1.47%2C2%2C3.46L29.85%2C18.2a9.23%2C9.23%2C0%2C0%2C1%2C0%2C5.58l2.57%2C1.48Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-website-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_website%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M9%2C11V27a6%2C6%2C0%2C0%2C0%2C6%2C6H27a6%2C6%2C0%2C0%2C0%2C6-6V11Zm6%2C4V13h2v2Zm-2-2v2H11V13ZM31%2C27a4%2C4%2C0%2C0%2C1-4%2C4H15a4%2C4%2C0%2C0%2C1-4-4V17H31Zm0-12H19V13H31ZM18.61%2C21l8%2C.28-4.24%2C6.78L21%2C25.5l-5.3%2C2.82-.94-1.77%2C5.3-2.82Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-x-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_x%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpolygon%20class%3D%22cls-2%22%20points%3D%2227.78%2013.63%2026.36%2012.22%2020%2018.59%2013.64%2012.22%2012.22%2013.64%2018.59%2020%2012.22%2026.36%2013.64%2027.78%2020%2021.41%2026.36%2027.78%2027.78%2026.36%2021.41%2020%2027.78%2013.63%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-yen-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_yen%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpolygon%20class%3D%22cls-2%22%20points%3D%2221.01%2022%2025%2022%2025%2020%2021.01%2020%2021.01%2018.2%2030.57%2013.11%2029.63%2011.34%2019.98%2016.48%2010.33%2011.34%209.39%2013.11%2019.01%2018.23%2019.01%2020%2015%2020%2015%2022%2019.01%2022%2019.01%2024%2015%2024%2015%2026%2019.01%2026%2019.01%2032%2021.01%2032%2021.01%2026%2025%2026%2025%2024%2021.01%2024%2021.01%2022%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-location-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%0A%3Csvg%20width%3D%2240px%22%20height%3D%2240px%22%20viewBox%3D%220%200%2040%2040%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%0A%20%20%20%20%3C!--%20Generator%3A%20Sketch%2053.1%20%2872631%29%20-%20https%3A%2F%2Fsketchapp.com%20--%3E%0A%20%20%20%20%3Ctitle%3E050-location-white-circle%3C%2Ftitle%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%0A%20%20%20%20%3Cdefs%3E%0A%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22path-1%22%20cx%3D%2219%22%20cy%3D%2219%22%20r%3D%2219%22%3E%3C%2Fcircle%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M13.3858873%2C24.8179481%20C13.1858874%2C25.060684%2012.8141126%2C25.060684%2012.6141127%2C24.8179481%20C6.87428896%2C17.8516382%204%2C12.8371876%204%2C9.6710003%20C4%2C4.92164995%208.12532592%2C1%2013%2C1%20C17.8746741%2C1%2022%2C4.92164995%2022%2C9.6710003%20C22%2C12.8371876%2019.125711%2C17.8516382%2013.3858873%2C24.8179481%20Z%20M21%2C9.6710003%20C21%2C5.48557602%2017.3333961%2C2%2013%2C2%20C8.66660392%2C2%205%2C5.48557602%205%2C9.6710003%20C5%2C12.4554419%207.6639476%2C17.1677197%2013%2C23.7113019%20C18.3360524%2C17.1677197%2021%2C12.4554419%2021%2C9.6710003%20Z%20M13%2C15%20C10.2385763%2C15%208%2C12.7614237%208%2C10%20C8%2C7.23857625%2010.2385763%2C5%2013%2C5%20C15.7614237%2C5%2018%2C7.23857625%2018%2C10%20C18%2C12.7614237%2015.7614237%2C15%2013%2C15%20Z%20M13%2C14%20C15.209139%2C14%2017%2C12.209139%2017%2C10%20C17%2C7.790861%2015.209139%2C6%2013%2C6%20C10.790861%2C6%209%2C7.790861%209%2C10%20C9%2C12.209139%2010.790861%2C14%2013%2C14%20Z%22%20id%3D%22path-3%22%3E%3C%2Fpath%3E%0A%20%20%20%20%3C%2Fdefs%3E%0A%20%20%20%20%3Cg%20id%3D%22Symbols%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%2299-icon-template%2F01-template%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%2299-icon-template%2F02-circle%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Circle%22%20transform%3D%22translate%281.000000%2C%201.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-2%22%20fill%3D%22white%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fmask%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Mask%22%20fill-rule%3D%22nonzero%22%3E%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22color%2Fwhite%22%20mask%3D%22url%28%23mask-2%29%22%20fill%3D%22%23FFFFFF%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%28-1.000000%2C%20-1.000000%29%22%20id%3D%22Color-%2F-White%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20x%3D%220%22%20y%3D%220%22%20width%3D%2240%22%20height%3D%2240%22%3E%3C%2Frect%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%2201-direction%2F050-location%22%20transform%3D%22translate%287.000000%2C%207.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-4%22%20fill%3D%22white%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-3%22%3E%3C%2Fuse%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fmask%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20id%3D%22icon%22%20fill%3D%22%23056DAE%22%20fill-rule%3D%22evenodd%22%20xlink%3Ahref%3D%22%23path-3%22%3E%3C%2Fuse%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22color%2Fb1%22%20mask%3D%22url%28%23mask-4%29%22%20fill%3D%22%23002A54%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Color-%2F-B1%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2226%22%20height%3D%2226%22%3E%3C%2Frect%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3C%2Fg%3E%0A%3C%2Fsvg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-ensurance-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%0A%3Csvg%20width%3D%2240px%22%20height%3D%2240px%22%20viewBox%3D%220%200%2040%2040%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%0A%20%20%20%20%3C!--%20Generator%3A%20Sketch%2053.1%20%2872631%29%20-%20https%3A%2F%2Fsketchapp.com%20--%3E%0A%20%20%20%20%3Ctitle%3E247-insurance-check-white-circle%3C%2Ftitle%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%0A%20%20%20%20%3Cdefs%3E%0A%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22path-1%22%20cx%3D%2219%22%20cy%3D%2219%22%20r%3D%2219%22%3E%3C%2Fcircle%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M20.082%2C10.4475%20L20.082%2C5.1675%20C20.082%2C4.5575%2019.681%2C4.0145%2019.08%2C3.8115%20L11%2C1.0825%20C10.676%2C0.9725%2010.323%2C0.9725%209.999%2C1.0835%20L1.997%2C3.8105%20C1.399%2C4.0145%201%2C4.5565%201%2C5.1655%20L1%2C13.7835%20C1%2C16.6375%202.396%2C19.3265%204.773%2C21.0465%20L9.599%2C24.5415%20C10.132%2C24.9265%2010.867%2C24.9275%2011.402%2C24.5435%20C12.106%2C23.9685%2012.588%2C23.5795%2012.859%2C23.3665%20C14.137%2C24.3755%2015.746%2C24.9815%2017.5%2C24.9815%20C21.643%2C24.9815%2025%2C21.6245%2025%2C17.4815%20C25%2C14.2485%2022.95%2C11.5015%2020.082%2C10.4475%20L20.082%2C10.4475%20Z%20M17.5%2C23.9815%20C13.91%2C23.9815%2011%2C21.0715%2011%2C17.4815%20C11%2C13.8915%2013.91%2C10.9815%2017.5%2C10.9815%20C21.09%2C10.9815%2024%2C13.8915%2024%2C17.4815%20C24%2C21.0715%2021.09%2C23.9815%2017.5%2C23.9815%20L17.5%2C23.9815%20Z%20M10%2C17.4815%20C10%2C18.2455%2010.116%2C18.9815%2010.328%2C19.6745%20C10.225%2C19.6695%2010.123%2C19.6395%2010.039%2C19.5725%20L6.723%2C16.9065%20C5.703%2C16.0865%205.115%2C14.8775%205.115%2C13.6035%20L5.115%2C7.6415%20C5.115%2C7.4385%205.248%2C7.2575%205.448%2C7.1895%20L10.186%2C5.5825%20C10.291%2C5.5465%2010.406%2C5.5455%2010.512%2C5.5795%20L15.545%2C7.1995%20C15.748%2C7.2645%2015.886%2C7.4475%2015.886%2C7.6535%20L15.886%2C10.1605%20C12.52%2C10.8995%2010%2C13.8945%2010%2C17.4815%20L10%2C17.4815%20Z%20M10.803%2C23.7775%20C10.624%2C23.9055%2010.379%2C23.9045%2010.201%2C23.7765%20L5.376%2C20.2825%20C3.25%2C18.7435%202%2C16.3365%202%2C13.7835%20L2%2C5.1655%20C2%2C4.9615%202.133%2C4.7815%202.333%2C4.7135%20L10.334%2C1.9855%20C10.442%2C1.9495%2010.56%2C1.9495%2010.668%2C1.9855%20L18.748%2C4.7145%20C18.948%2C4.7825%2019.082%2C4.9635%2019.082%2C5.1675%20L19.082%2C10.1515%20C18.571%2C10.0425%2018.043%2C9.9815%2017.5%2C9.9815%20C17.293%2C9.9815%2017.089%2C9.9965%2016.886%2C10.0125%20L16.886%2C7.6535%20C16.886%2C7.0365%2016.474%2C6.4875%2015.863%2C6.2915%20L10.83%2C4.6715%20C10.512%2C4.5695%2010.167%2C4.5715%209.852%2C4.6795%20L5.114%2C6.2865%20C4.515%2C6.4905%204.115%2C7.0325%204.115%2C7.6415%20L4.115%2C13.6035%20C4.115%2C15.1615%204.834%2C16.6385%206.08%2C17.6405%20L9.396%2C20.3065%20C9.763%2C20.6015%2010.238%2C20.6855%2010.681%2C20.5915%20C11.042%2C21.3805%2011.532%2C22.0975%2012.129%2C22.7105%20L10.803%2C23.7775%20Z%20M20.5146%2C15.2745%20C20.7046%2C15.0755%2021.0226%2C15.0685%2021.2216%2C15.2595%20C21.4206%2C15.4515%2021.4266%2C15.7675%2021.2366%2C15.9665%20L17.7936%2C19.5535%20L17.7716%2C19.5765%20C17.1866%2C20.1625%2016.2366%2C20.1625%2015.6506%2C19.5765%20L14.6466%2C18.5715%20C14.4516%2C18.3765%2014.4516%2C18.0595%2014.6466%2C17.8645%20C14.8416%2C17.6695%2015.1586%2C17.6695%2015.3536%2C17.8645%20L16.3576%2C18.8695%20C16.5526%2C19.0645%2016.8686%2C19.0645%2017.0646%2C18.8695%20C17.0676%2C18.8665%2018.2166%2C17.6685%2020.5146%2C15.2745%20Z%22%20id%3D%22path-3%22%3E%3C%2Fpath%3E%0A%20%20%20%20%3C%2Fdefs%3E%0A%20%20%20%20%3Cg%20id%3D%22Symbols%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%2299-icon-template%2F01-template%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%2299-icon-template%2F02-circle%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Circle%22%20transform%3D%22translate%281.000000%2C%201.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-2%22%20fill%3D%22white%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fmask%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Mask%22%20fill-rule%3D%22nonzero%22%3E%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22color%2Fwhite%22%20mask%3D%22url%28%23mask-2%29%22%20fill%3D%22%23FFFFFF%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%28-1.000000%2C%20-1.000000%29%22%20id%3D%22Color-%2F-White%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20x%3D%220%22%20y%3D%220%22%20width%3D%2240%22%20height%3D%2240%22%3E%3C%2Frect%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%2210-service%2F247-insurance-check%22%20transform%3D%22translate%287.000000%2C%207.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-4%22%20fill%3D%22white%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-3%22%3E%3C%2Fuse%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fmask%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20id%3D%22Mask%22%20fill%3D%22%23046EAE%22%20fill-rule%3D%22evenodd%22%20xlink%3Ahref%3D%22%23path-3%22%3E%3C%2Fuse%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22color%2Fb1%22%20mask%3D%22url%28%23mask-4%29%22%20fill%3D%22%23002A54%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Color-%2F-B1%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2226%22%20height%3D%2226%22%3E%3C%2Frect%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3C%2Fg%3E%0A%3C%2Fsvg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-ensurance-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%0A%3Csvg%20width%3D%2240px%22%20height%3D%2240px%22%20viewBox%3D%220%200%2040%2040%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%0A%20%20%20%20%3C!--%20Generator%3A%20Sketch%2053.1%20%2872631%29%20-%20https%3A%2F%2Fsketchapp.com%20--%3E%0A%20%20%20%20%3Ctitle%3E247-insurance-check-white-circle%3C%2Ftitle%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%0A%20%20%20%20%3Cdefs%3E%0A%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22path-1%22%20cx%3D%2219%22%20cy%3D%2219%22%20r%3D%2219%22%3E%3C%2Fcircle%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M20.082%2C10.4475%20L20.082%2C5.1675%20C20.082%2C4.5575%2019.681%2C4.0145%2019.08%2C3.8115%20L11%2C1.0825%20C10.676%2C0.9725%2010.323%2C0.9725%209.999%2C1.0835%20L1.997%2C3.8105%20C1.399%2C4.0145%201%2C4.5565%201%2C5.1655%20L1%2C13.7835%20C1%2C16.6375%202.396%2C19.3265%204.773%2C21.0465%20L9.599%2C24.5415%20C10.132%2C24.9265%2010.867%2C24.9275%2011.402%2C24.5435%20C12.106%2C23.9685%2012.588%2C23.5795%2012.859%2C23.3665%20C14.137%2C24.3755%2015.746%2C24.9815%2017.5%2C24.9815%20C21.643%2C24.9815%2025%2C21.6245%2025%2C17.4815%20C25%2C14.2485%2022.95%2C11.5015%2020.082%2C10.4475%20L20.082%2C10.4475%20Z%20M17.5%2C23.9815%20C13.91%2C23.9815%2011%2C21.0715%2011%2C17.4815%20C11%2C13.8915%2013.91%2C10.9815%2017.5%2C10.9815%20C21.09%2C10.9815%2024%2C13.8915%2024%2C17.4815%20C24%2C21.0715%2021.09%2C23.9815%2017.5%2C23.9815%20L17.5%2C23.9815%20Z%20M10%2C17.4815%20C10%2C18.2455%2010.116%2C18.9815%2010.328%2C19.6745%20C10.225%2C19.6695%2010.123%2C19.6395%2010.039%2C19.5725%20L6.723%2C16.9065%20C5.703%2C16.0865%205.115%2C14.8775%205.115%2C13.6035%20L5.115%2C7.6415%20C5.115%2C7.4385%205.248%2C7.2575%205.448%2C7.1895%20L10.186%2C5.5825%20C10.291%2C5.5465%2010.406%2C5.5455%2010.512%2C5.5795%20L15.545%2C7.1995%20C15.748%2C7.2645%2015.886%2C7.4475%2015.886%2C7.6535%20L15.886%2C10.1605%20C12.52%2C10.8995%2010%2C13.8945%2010%2C17.4815%20L10%2C17.4815%20Z%20M10.803%2C23.7775%20C10.624%2C23.9055%2010.379%2C23.9045%2010.201%2C23.7765%20L5.376%2C20.2825%20C3.25%2C18.7435%202%2C16.3365%202%2C13.7835%20L2%2C5.1655%20C2%2C4.9615%202.133%2C4.7815%202.333%2C4.7135%20L10.334%2C1.9855%20C10.442%2C1.9495%2010.56%2C1.9495%2010.668%2C1.9855%20L18.748%2C4.7145%20C18.948%2C4.7825%2019.082%2C4.9635%2019.082%2C5.1675%20L19.082%2C10.1515%20C18.571%2C10.0425%2018.043%2C9.9815%2017.5%2C9.9815%20C17.293%2C9.9815%2017.089%2C9.9965%2016.886%2C10.0125%20L16.886%2C7.6535%20C16.886%2C7.0365%2016.474%2C6.4875%2015.863%2C6.2915%20L10.83%2C4.6715%20C10.512%2C4.5695%2010.167%2C4.5715%209.852%2C4.6795%20L5.114%2C6.2865%20C4.515%2C6.4905%204.115%2C7.0325%204.115%2C7.6415%20L4.115%2C13.6035%20C4.115%2C15.1615%204.834%2C16.6385%206.08%2C17.6405%20L9.396%2C20.3065%20C9.763%2C20.6015%2010.238%2C20.6855%2010.681%2C20.5915%20C11.042%2C21.3805%2011.532%2C22.0975%2012.129%2C22.7105%20L10.803%2C23.7775%20Z%20M20.5146%2C15.2745%20C20.7046%2C15.0755%2021.0226%2C15.0685%2021.2216%2C15.2595%20C21.4206%2C15.4515%2021.4266%2C15.7675%2021.2366%2C15.9665%20L17.7936%2C19.5535%20L17.7716%2C19.5765%20C17.1866%2C20.1625%2016.2366%2C20.1625%2015.6506%2C19.5765%20L14.6466%2C18.5715%20C14.4516%2C18.3765%2014.4516%2C18.0595%2014.6466%2C17.8645%20C14.8416%2C17.6695%2015.1586%2C17.6695%2015.3536%2C17.8645%20L16.3576%2C18.8695%20C16.5526%2C19.0645%2016.8686%2C19.0645%2017.0646%2C18.8695%20C17.0676%2C18.8665%2018.2166%2C17.6685%2020.5146%2C15.2745%20Z%22%20id%3D%22path-3%22%3E%3C%2Fpath%3E%0A%20%20%20%20%3C%2Fdefs%3E%0A%20%20%20%20%3Cg%20id%3D%22Symbols%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%2299-icon-template%2F01-template%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%2299-icon-template%2F02-circle%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Circle%22%20transform%3D%22translate%281.000000%2C%201.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-2%22%20fill%3D%22white%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fmask%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Mask%22%20fill-rule%3D%22nonzero%22%3E%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22color%2Fwhite%22%20mask%3D%22url%28%23mask-2%29%22%20fill%3D%22%23FFFFFF%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%28-1.000000%2C%20-1.000000%29%22%20id%3D%22Color-%2F-White%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20x%3D%220%22%20y%3D%220%22%20width%3D%2240%22%20height%3D%2240%22%3E%3C%2Frect%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%2210-service%2F247-insurance-check%22%20transform%3D%22translate%287.000000%2C%207.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-4%22%20fill%3D%22white%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-3%22%3E%3C%2Fuse%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fmask%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20id%3D%22Mask%22%20fill%3D%22%23046EAE%22%20fill-rule%3D%22evenodd%22%20xlink%3Ahref%3D%22%23path-3%22%3E%3C%2Fuse%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22color%2Fb1%22%20mask%3D%22url%28%23mask-4%29%22%20fill%3D%22%23002A54%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Color-%2F-B1%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2226%22%20height%3D%2226%22%3E%3C%2Frect%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3C%2Fg%3E%0A%3C%2Fsvg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-service-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20width%3D%2240px%22%20height%3D%2240px%22%20viewBox%3D%220%200%2040%2040%22%20version%3D%221.1%22%3E%0A%20%20%20%20%3C!--%20Generator%3A%20Sketch%2053.1%20%2872631%29%20-%20https%3A%2F%2Fsketchapp.com%20--%3E%0A%20%20%20%20%3Ctitle%3E125-customer-service-white-circle%3C%2Ftitle%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%0A%20%20%20%20%3Cdefs%3E%0A%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22path-1%22%20cx%3D%2219%22%20cy%3D%2219%22%20r%3D%2219%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M24%2C18%20C24%2C18.553%2023.553%2C19%2023%2C19%20L21%2C19%20L21%2C12%20L23%2C12%20C23.553%2C12%2024%2C12.448%2024%2C13%20L24%2C18%20Z%20M12%2C23%20L16%2C23%20L16%2C21%20L12%2C21%20L12%2C23%20Z%20M5%2C12%20L5%2C19%20L3%2C19%20C2.448%2C19%202%2C18.553%202%2C18%20L2%2C13%20C2%2C12.448%202.448%2C12%203%2C12%20L5%2C12%20Z%20M23%2C11%20C23%2C5.836%2018.729%2C2%2013.25%2C2%20C7.771%2C2%203.5%2C5.836%203.5%2C11%20L3%2C11%20C1.896%2C11%201%2C11.896%201%2C13%20L1%2C18%20C1%2C19.104%201.896%2C20%203%2C20%20L5%2C20%20C5.552%2C20%206%2C19.553%206%2C19%20L6%2C12%20C6%2C11.448%205.552%2C11%205%2C11%20L4.5%2C11%20C4.5%2C6.414%208.3%2C3%2013.25%2C3%20C18.2%2C3%2022%2C6.414%2022%2C11%20L21%2C11%20C20.447%2C11%2020%2C11.448%2020%2C12%20L20%2C19%20C20%2C19.516%2020.395%2C19.924%2020.896%2C19.979%20C20.264%2C20.599%2019.19%2C20.982%2017.189%2C21.418%20C17.146%2C21.428%2017.077%2C21.442%2017%2C21.459%20L17%2C21%20C17%2C20.447%2016.553%2C20%2016%2C20%20L12%2C20%20C11.448%2C20%2011%2C20.447%2011%2C21%20L11%2C23%20C11%2C23.553%2011.448%2C24%2012%2C24%20L16%2C24%20C16.553%2C24%2017%2C23.553%2017%2C23%20L17%2C22.482%20C17.169%2C22.445%2017.322%2C22.413%2017.402%2C22.396%20C20.15%2C21.796%2021.4%2C21.25%2022.135%2C20%20L23%2C20%20C24.104%2C20%2025%2C19.104%2025%2C18%20L25%2C13%20C25%2C11.896%2024.104%2C11%2023%2C11%20L23%2C11%20Z%22%20id%3D%22path-3%22%2F%3E%0A%20%20%20%20%3C%2Fdefs%3E%0A%20%20%20%20%3Cg%20id%3D%22Symbols%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%2299-icon-template%2F01-template%22%20transform%3D%22translate%28-1.000000%2C%200.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%2299-icon-template%2F02-circle%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Circle%22%20transform%3D%22translate%281.000000%2C%201.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-2%22%20fill%3D%22white%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-1%22%2F%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fmask%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Mask%22%20fill-rule%3D%22nonzero%22%2F%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22color%2Fwhite%22%20mask%3D%22url%28%23mask-2%29%22%20fill%3D%22%23FFFFFF%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%28-1.000000%2C%20-1.000000%29%22%20id%3D%22Color-%2F-White%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20x%3D%220%22%20y%3D%220%22%20width%3D%2240%22%20height%3D%2240%22%2F%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%2210-service%2F125-customer-service%22%20transform%3D%22translate%287.000000%2C%207.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-4%22%20fill%3D%22white%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-3%22%2F%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fmask%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20id%3D%22Mask%22%20fill%3D%22%23046EAE%22%20fill-rule%3D%22evenodd%22%20xlink%3Ahref%3D%22%23path-3%22%2F%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22color%2Fb1%22%20mask%3D%22url%28%23mask-4%29%22%20fill%3D%22%23002A54%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Color-%2F-B1%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2226%22%20height%3D%2226%22%2F%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3C%2Fg%3E%0A%3C%2Fsvg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-pointer-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20width%3D%2240px%22%20height%3D%2240px%22%20viewBox%3D%220%200%2040%2040%22%20version%3D%221.1%22%3E%0A%20%20%20%20%3C!--%20Generator%3A%20Sketch%2053.1%20%2872631%29%20-%20https%3A%2F%2Fsketchapp.com%20--%3E%0A%20%20%20%20%3Ctitle%3E053-arrow-pointer-white-circle%3C%2Ftitle%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%0A%20%20%20%20%3Cdefs%3E%0A%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22path-1%22%20cx%3D%2219%22%20cy%3D%2219%22%20r%3D%2219%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M19.6510105%2C1.575%20L6.15601046%2C9.95%20C5.83501046%2C10.149%205.84301046%2C10.618%206.17001046%2C10.807%20L6.17001046%2C10.807%20L10.0670105%2C13.057%20L5.31701046%2C21.285%20C5.17901046%2C21.524%205.26101046%2C21.83%205.50001046%2C21.968%20L5.50001046%2C21.968%20L9.87201046%2C24.493%20C10.1110105%2C24.631%2010.4170105%2C24.549%2010.5560105%2C24.309%20L10.5560105%2C24.309%20L15.3060105%2C16.081%20L19.1600105%2C18.308%20C19.4870105%2C18.497%2019.8980105%2C18.268%2019.9100105%2C17.89%20L19.9100105%2C17.89%20L20.4150105%2C2.016%20L20.4150105%2C1.983%20C20.4060105%2C1.7%2020.1700105%2C1.5%2019.9140105%2C1.5%20L19.9140105%2C1.5%20C19.8260105%2C1.5%2019.7350105%2C1.523%2019.6510105%2C1.575%20L19.6510105%2C1.575%20Z%20M6.43301046%2C21.352%20L11.1830105%2C13.125%20C11.3210105%2C12.885%2011.2390105%2C12.579%2011.0000105%2C12.442%20L11.0000105%2C12.442%20L7.39301046%2C10.359%20L19.3850105%2C2.917%20L18.9370105%2C17.024%20L15.3720105%2C14.966%20C15.1330105%2C14.828%2014.8270105%2C14.91%2014.6890105%2C15.149%20L14.6890105%2C15.149%20L9.93901046%2C23.377%20L6.43301046%2C21.352%20Z%22%20id%3D%22path-3%22%2F%3E%0A%20%20%20%20%3C%2Fdefs%3E%0A%20%20%20%20%3Cg%20id%3D%22Symbols%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%2299-icon-template%2F01-template%22%20transform%3D%22translate%28-1.000000%2C%200.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%2299-icon-template%2F02-circle%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Circle%22%20transform%3D%22translate%281.000000%2C%201.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-2%22%20fill%3D%22white%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-1%22%2F%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fmask%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Mask%22%20fill-rule%3D%22nonzero%22%2F%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22color%2Fwhite%22%20mask%3D%22url%28%23mask-2%29%22%20fill%3D%22%23FFFFFF%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%28-1.000000%2C%20-1.000000%29%22%20id%3D%22Color-%2F-White%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20x%3D%220%22%20y%3D%220%22%20width%3D%2240%22%20height%3D%2240%22%2F%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%2201-direction%2F053-arrow-pointer%22%20transform%3D%22translate%287.000000%2C%207.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-4%22%20fill%3D%22white%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-3%22%2F%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fmask%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22icon%22%2F%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22color%2Fb1%22%20mask%3D%22url%28%23mask-4%29%22%20fill%3D%22%23002A54%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Color-%2F-B1%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2226%22%20height%3D%2226%22%2F%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3C%2Fg%3E%0A%3C%2Fsvg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-cardPin-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20width%3D%2240px%22%20height%3D%2240px%22%20viewBox%3D%220%200%2040%2040%22%20version%3D%221.1%22%3E%0A%20%20%20%20%3C!--%20Generator%3A%20Sketch%2053.1%20%2872631%29%20-%20https%3A%2F%2Fsketchapp.com%20--%3E%0A%20%20%20%20%3Ctitle%3E185-card-pin-white-circle%3C%2Ftitle%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%0A%20%20%20%20%3Cdefs%3E%0A%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22path-1%22%20cx%3D%2219%22%20cy%3D%2219%22%20r%3D%2219%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M23.3496%2C4%20L2.6496%2C4%20C1.7356%2C4%200.9996%2C4.776%200.9996%2C5.714%20L0.9996%2C20.286%20C0.9996%2C21.224%201.7356%2C22%202.6496%2C22%20L23.3496%2C22%20C24.2656%2C22%2024.9996%2C21.224%2024.9996%2C20.286%20L24.9996%2C5.714%20C24.9996%2C4.776%2024.2656%2C4%2023.3496%2C4%20M23.3496%2C21%20L2.6496%2C21%20C2.2996%2C21%201.9996%2C20.684%201.9996%2C20.286%20L1.9996%2C9%20L23.9996%2C9%20L23.9996%2C20.286%20C23.9996%2C20.684%2023.7006%2C21%2023.3496%2C21%20M2.6496%2C5%20L23.3496%2C5%20C23.7006%2C5%2023.9996%2C5.316%2023.9996%2C5.714%20L23.9996%2C8%20L1.9996%2C8%20L1.9996%2C5.714%20C1.9996%2C5.316%202.2996%2C5%202.6496%2C5%20M9.5%2C14%20L11.5%2C14%20C12.167%2C14%2012.167%2C15%2011.5%2C15%20L9.5%2C15%20C8.833%2C15%208.833%2C14%209.5%2C14%20M4.5%2C14%20L6.5%2C14%20C7.167%2C14%207.167%2C15%206.5%2C15%20L4.5%2C15%20C3.833%2C15%203.833%2C14%204.5%2C14%20M19.5%2C14%20L21.5%2C14%20C22.167%2C14%2022.167%2C15%2021.5%2C15%20L19.5%2C15%20C18.833%2C15%2018.833%2C14%2019.5%2C14%20M14.5%2C14%20L16.5%2C14%20C17.167%2C14%2017.167%2C15%2016.5%2C15%20L14.5%2C15%20C13.833%2C15%2013.833%2C14%2014.5%2C14%22%20id%3D%22path-3%22%2F%3E%0A%20%20%20%20%3C%2Fdefs%3E%0A%20%20%20%20%3Cg%20id%3D%22Symbols%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%2299-icon-template%2F01-template%22%20transform%3D%22translate%28-1.000000%2C%200.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%2299-icon-template%2F02-circle%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Circle%22%20transform%3D%22translate%281.000000%2C%201.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-2%22%20fill%3D%22white%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-1%22%2F%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fmask%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Mask%22%20fill-rule%3D%22nonzero%22%2F%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22color%2Fwhite%22%20mask%3D%22url%28%23mask-2%29%22%20fill%3D%22%23FFFFFF%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%28-1.000000%2C%20-1.000000%29%22%20id%3D%22Color-%2F-White%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20x%3D%220%22%20y%3D%220%22%20width%3D%2240%22%20height%3D%2240%22%2F%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%2207-card%2F185-card-pin%22%20transform%3D%22translate%287.000000%2C%207.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-4%22%20fill%3D%22white%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-3%22%2F%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fmask%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20id%3D%22Mask%22%20fill%3D%22%23046EAE%22%20fill-rule%3D%22evenodd%22%20xlink%3Ahref%3D%22%23path-3%22%2F%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22color%2Fb1%22%20mask%3D%22url%28%23mask-4%29%22%20fill%3D%22%23002A54%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Color-%2F-B1%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2226%22%20height%3D%2226%22%2F%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3C%2Fg%3E%0A%3C%2Fsvg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-trash-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_trash%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M33%2C12H27a4%2C4%2C0%2C0%2C0-4-4H19a4%2C4%2C0%2C0%2C0-4%2C4H9v2h2V30a4%2C4%2C0%2C0%2C0%2C4%2C4H27a4%2C4%2C0%2C0%2C0%2C4-4V14h2ZM19%2C10h4a2%2C2%2C0%2C0%2C1%2C2%2C2H17A2%2C2%2C0%2C0%2C1%2C19%2C10ZM29%2C30a2%2C2%2C0%2C0%2C1-2%2C2H15a2%2C2%2C0%2C0%2C1-2-2V27.21L29%2C18.7Zm0-13.57L13%2C24.94V14H29Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-ensurance-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3C!--%20Generator%3A%20Adobe%20Illustrator%2022.0.1%2C%20SVG%20Export%20Plug-In%20.%20SVG%20Version%3A%206.00%20Build%200%29%20%20--%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22Layer%5f1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2040%2040%22%20style%3D%22enable-background%3Anew%200%200%2040%2040%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill%3A%23002A54%3B%7D%0A%3C%2Fstyle%3E%0A%3Cg%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M16.396%2C27.30609l-3.31598-2.66595c-1.24603-1.00201-1.96503-2.479-1.96503-4.03705v-5.96198%0A%09%09c0-0.60901%2C0.40002-1.151%2C0.99902-1.35498l4.73798-1.60699c0.315-0.10803%2C0.66003-0.11005%2C0.97803-0.00806l5.03296%2C1.62006%0A%09%09c0.61102%2C0.19598%2C1.02301%2C0.745%2C1.02301%2C1.362v2.35895c0.203-0.01599%2C0.40704-0.03101%2C0.61401-0.03101%0A%09%09c0.54303%2C0%2C1.07098%2C0.06104%2C1.58203%2C0.17004v-4.98401c0-0.20398-0.13403-0.38501-0.33405-0.453l-8.07996-2.729%0A%09%09c-0.10803-0.03601-0.22601-0.03601-0.33405%2C0l-8.00098%2C2.72803C9.133%2C11.78113%2C9%2C11.96112%2C9%2C12.1651v8.61798%0A%09%09c0%2C2.55304%2C1.25%2C4.96002%2C3.37598%2C6.49902l4.82501%2C3.49402c0.17804%2C0.12799%2C0.42303%2C0.12897%2C0.60199%2C0.00098l1.32605-1.06702%0A%09%09c-0.59705-0.61298-1.08704-1.32996-1.448-2.11896C17.23798%2C27.68512%2C16.763%2C27.60114%2C16.396%2C27.30609z%22%2F%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M22.88599%2C17.1601v-2.50696c0-0.20605-0.138-0.38904-0.341-0.45404l-5.03296-1.62%0A%09%09c-0.10602-0.034-0.22101-0.03302-0.32605%2C0.00299l-4.73798%2C1.607c-0.20001%2C0.06799-0.33301%2C0.24902-0.33301%2C0.45203v5.96198%0A%09%09c0%2C1.27405%2C0.58801%2C2.48303%2C1.60803%2C3.30304l3.31598%2C2.66595c0.08398%2C0.06702%2C0.18597%2C0.09705%2C0.289%2C0.10205%0A%09%09c-0.21197-0.693-0.328-1.42902-0.328-2.193C17%2C20.8941%2C19.52002%2C17.89911%2C22.88599%2C17.1601z%22%2F%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M20%2C0.99963c-10.49341%2C0-19%2C8.50659-19%2C19s8.50659%2C19%2C19%2C19s19-8.50659%2C19-19S30.49341%2C0.99963%2C20%2C0.99963z%0A%09%09%20M24.5%2C31.98114c-1.75403%2C0-3.36298-0.60602-4.64099-1.61505c-0.271%2C0.21301-0.75299%2C0.60205-1.45703%2C1.177%0A%09%09c-0.53497%2C0.38403-1.26996%2C0.383-1.80298-0.00195l-4.82599-3.49506C9.396%2C26.32611%2C8%2C23.63708%2C8%2C20.78308V12.1651%0A%09%09c0-0.60901%2C0.39899-1.151%2C0.99701-1.35498l8.00201-2.72699C17.323%2C7.97211%2C17.67603%2C7.97211%2C18%2C8.08209l8.08002%2C2.729%0A%09%09c0.60101%2C0.203%2C1.00201%2C0.74603%2C1.00201%2C1.35602v5.27997C29.95001%2C18.5011%2C32%2C21.24811%2C32%2C24.48114%0A%09%09C32%2C28.62408%2C28.64301%2C31.98114%2C24.5%2C31.98114z%22%2F%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M24.5%2C17.98108c-3.59003%2C0-6.5%2C2.91003-6.5%2C6.50006c0%2C3.58997%2C2.90997%2C6.5%2C6.5%2C6.5s6.5-2.91003%2C6.5-6.5%0A%09%09C31%2C20.89111%2C28.09003%2C17.98108%2C24.5%2C17.98108z%20M28.23657%2C22.96613l-3.44299%2C3.58698l-0.02197%2C0.02301%0A%09%09c-0.58502%2C0.586-1.53503%2C0.586-2.12103%2C0l-1.00397-1.005c-0.19501-0.19501-0.19501-0.51202%2C0-0.70697%0A%09%09c0.19501-0.19501%2C0.51202-0.19501%2C0.70697%2C0l1.00403%2C1.00494c0.19501%2C0.19501%2C0.51099%2C0.19501%2C0.70697%2C0%0A%09%09c0.00305-0.00299%2C1.15204-1.20099%2C3.45001-3.59497c0.19-0.19897%2C0.508-0.20599%2C0.70703-0.01501%0A%09%09C28.42059%2C22.45111%2C28.42657%2C22.76709%2C28.23657%2C22.96613z%22%2F%3E%0A%3C%2Fg%3E%0A%3C%2Fsvg%3E%0A);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-four-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_4_arrows%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M41%2C21A20%2C20%2C0%2C1%2C1%2C21%2C1%2C20%2C20%2C0%2C0%2C1%2C41%2C21%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpolygon%20class%3D%22cls-2%22%20points%3D%2236%2020%2028%2015.38%2028%2019%2021%2019%2021%2012%2024.62%2012%2020%204%2015.38%2012%2019%2012%2019%2019%2012%2019%2012%2015.38%204%2020%2012%2024.62%2012%2021%2019%2021%2019%2028%2015.38%2028%2020%2036%2024.62%2028%2021%2028%2021%2021%2028%2021%2028%2024.62%2036%2020%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-arrowdown-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_arrow_down%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M41%2C21A20%2C20%2C0%2C1%2C1%2C21%2C1%2C20%2C20%2C0%2C0%2C1%2C41%2C21%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M20%2C9V30.7a2%2C2%2C0%2C0%2C1-.58-.5L13.28%2C18.65l-1.77.94%2C5.73%2C10.77h0a4%2C4%2C0%2C0%2C0%2C7.44.17l5.8-10.94-1.77-.94-5.87%2C11a2%2C2%2C0%2C0%2C1-.86%2C1V9Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-arrowleft-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_arrow_left%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C1%2C41%2C21%2C20%2C20%2C0%2C0%2C1%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M33%2C20H11.3a2%2C2%2C0%2C0%2C1%2C.5-.58l11.55-6.14-.94-1.77L11.64%2C17.24v0a4%2C4%2C0%2C0%2C0-.17%2C7.44l10.94%2C5.8.94-1.77-11-5.87a2%2C2%2C0%2C0%2C1-1-.86H33Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-arrowright-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_arrow_right%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C1A20%2C20%2C0%2C1%2C1%2C1%2C21%2C20%2C20%2C0%2C0%2C1%2C21%2C1%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M9%2C22H30.7a2%2C2%2C0%2C0%2C1-.5.58L18.65%2C28.72l.94%2C1.77%2C10.77-5.73v0a4%2C4%2C0%2C0%2C0%2C.16-7.44l-10.94-5.8-.94%2C1.77%2C11%2C5.87a2%2C2%2C0%2C0%2C1%2C1%2C.86H9Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-arrowup-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_arrow_up%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M1%2C21A20%2C20%2C0%2C1%2C1%2C21%2C41%2C20%2C20%2C0%2C0%2C1%2C1%2C21%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M22%2C33V11.3a2%2C2%2C0%2C0%2C1%2C.57.5l6.14%2C11.55%2C1.77-.94L24.77%2C11.64h0a4%2C4%2C0%2C0%2C0-7.44-.17l-5.8%2C10.94%2C1.77.94%2C5.87-11a2%2C2%2C0%2C0%2C1%2C.86-1V33Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-calendar-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_calendar%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M33%2C11H27V9H25v2H17V9H15v2H9V27a6%2C6%2C0%2C0%2C0%2C6%2C6H27a6%2C6%2C0%2C0%2C0%2C6-6h0ZM15%2C13v2h2V13h8v2h2V13h4v4H11V13ZM31%2C27a4%2C4%2C0%2C0%2C1-4%2C4H15a4%2C4%2C0%2C0%2C1-4-4V19H31Zm-4.74-6%2C.94%2C1.77-9.65%2C5.09-.94-1.77h0L15%2C22.93%2C16.77%2C22l1.65%2C3.16Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-branch-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_branch%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C1A20%2C20%2C0%2C1%2C1%2C1%2C21%2C20%2C20%2C0%2C0%2C1%2C21%2C1%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M33%2C17V13h0a2%2C2%2C0%2C0%2C0-2-2H11a2%2C2%2C0%2C0%2C0-2%2C2H9v4h2V29H9v2H33V29H31V17Zm-2-4v2H11V13ZM21%2C21v8H17V21Zm8%2C8H23V19H15V29H13V17H29Zm-2-4H25V21h2Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-bubble-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_bubble%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M26.22%2C13.89C24.7%2C11%2C21.15%2C9%2C17%2C9%2C11.48%2C9%2C7%2C12.58%2C7%2C17c0%2C3%2C2%2C5.48%2C5%2C6.86v5.41l5.23-2.82a9%2C9%2C0%2C0%2C0%2C1.88%2C1.62l11.14%2C6V28.66c3-1.37%2C5-3.91%2C5-6.86C35.25%2C17.65%2C31.28%2C14.29%2C26.22%2C13.89ZM9%2C17c0-3.31%2C3.58-6%2C8-6s8%2C2.69%2C8%2C6a5.51%2C5.51%2C0%2C0%2C1-2.79%2C4.52L14%2C25.94V22.52C11.08%2C21.63%2C9%2C19.51%2C9%2C17ZM28.25%2C27.32v3.42L20%2C26.32a6.54%2C6.54%2C0%2C0%2C1-1-.83l4.13-2.22A7.51%2C7.51%2C0%2C0%2C0%2C27%2C17a6.44%2C6.44%2C0%2C0%2C0-.13-1c3.63.56%2C6.38%2C2.93%2C6.38%2C5.82C33.25%2C24.31%2C31.17%2C26.43%2C28.25%2C27.32Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-chart-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_chart%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M17%2C29a4%2C4%2C0%2C0%2C1-4-3.81V23.09l4.94-2.63%2C1.81%2C3.4%2C11.61-6.18-.94-1.77-9.85%2C5.24-1.81-3.39L13%2C20.82V13H11V25.22A6%2C6%2C0%2C0%2C0%2C17%2C31H31V29Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-checkmark-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_checkmark%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpolygon%20class%3D%22cls-2%22%20points%3D%2231.9%2014.46%2015.3%2023.29%2011.77%2016.64%2010%2017.58%2014.46%2026%2032.84%2016.23%2031.9%2014.46%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-circle-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_circlearrows%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C1A20%2C20%2C0%2C1%2C1%2C1%2C21%2C20%2C20%2C0%2C0%2C1%2C21%2C1%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M31.45%2C26.81a12%2C12%2C0%2C0%2C1-21.16-.27l1.73-1a10%2C10%2C0%2C0%2C0%2C17.66.35l-3.21-1.7%2C7.84-4.9.32%2C9.23ZM26.59%2C10.41a12%2C12%2C0%2C0%2C0-16.16%2C4.85L7.37%2C13.62l.32%2C9.23L15.52%2C18l-3.32-1.77a10%2C10%2C0%2C0%2C1%2C17.67.32l1.73-1A11.94%2C11.94%2C0%2C0%2C0%2C26.59%2C10.41Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-creditCard-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_creditcard%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M21%2C23v2H11V23Zm14-8h0V27a4%2C4%2C0%2C0%2C1-4%2C4H11a4%2C4%2C0%2C0%2C1-4-4V15H7a4%2C4%2C0%2C0%2C1%2C4-4H31a4%2C4%2C0%2C0%2C1%2C4%2C4ZM11%2C29H21.44L33%2C22.85V19H9v8A2%2C2%2C0%2C0%2C0%2C11%2C29Zm22-2V25.12L25.7%2C29H31A2%2C2%2C0%2C0%2C0%2C33%2C27Zm0-12a2%2C2%2C0%2C0%2C0-2-2H11a2%2C2%2C0%2C0%2C0-2%2C2v2H33Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-currency-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_currency_bill%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M7%2C13V29H35V13Zm26%2C7.88L24.18%2C25.6A6.48%2C6.48%2C0%2C0%2C0%2C26%2C21c0-3.19-2.08-5.77-4.7-6v0H33ZM9%2C15h7.49L9%2C19Zm12%2C2c1.66%2C0%2C3%2C1.79%2C3%2C4s-1.34%2C4-3%2C4-3-1.79-3-4S19.34%2C17%2C21%2C17ZM9%2C21.22l8.5-4.5A6.61%2C6.61%2C0%2C0%2C0%2C16%2C21c0%2C3.24%2C2.14%2C5.86%2C4.82%2C6v0H9ZM25.84%2C27%2C33%2C23.18V27Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-docuarrow-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_docuarrow%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M11%2C9V33H24.13l5.09-2.67A4%2C4%2C0%2C0%2C0%2C31%2C27h0V9ZM27.73%2C28.85l-4%2C2.15H23V27h6A2%2C2%2C0%2C0%2C1%2C27.73%2C28.85ZM21%2C25v6H13V11H29v6H23V14l-7%2C4%2C7%2C4V19h6v6Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-docucheck-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_docucheck%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M11%2C9V33H24.14l5.08-2.7h0A4%2C4%2C0%2C0%2C0%2C31%2C27h0V9ZM29%2C27a2%2C2%2C0%2C0%2C1-1.27%2C1.85l-4%2C2.15H23V27Zm0-2H21v6H13V11H29ZM17.53%2C21.84%2C15%2C16.93%2C16.72%2C16l1.65%2C3.15L26.24%2C15l.94%2C1.77Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-document-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_document%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C1%2C41%2C21%2C20%2C20%2C0%2C0%2C1%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M11%2C9V33H24.13l5.08-2.7h0A4%2C4%2C0%2C0%2C0%2C31%2C27h0V9ZM29%2C27a2%2C2%2C0%2C0%2C1-1.27%2C1.85l-4%2C2.15H23V27Zm0-2H21v6H13V11H29ZM27%2C15H15V13H27ZM15%2C19V17h8v2Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-dollar-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_dollar%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M22.32%2C34.26H19.79v-3.8a9.09%2C9.09%2C0%2C0%2C1-5.15-2.56l-.18-.19%2C1.74-1.94.21.2a6.7%2C6.7%2C0%2C0%2C0%2C4.72%2C2.14c2.36%2C0%2C3.71-1%2C3.71-2.76%2C0-1.55-.95-2.34-4.23-3.52-3.74-1.34-5.51-2.5-5.51-5.51%2C0-2.6%2C1.75-4.37%2C4.7-4.78V7.74h2.53v3.76a8.53%2C8.53%2C0%2C0%2C1%2C4.62%2C2l.22.17-1.67%2C2-.21-.18A6.17%2C6.17%2C0%2C0%2C0%2C21%2C13.88c-2.14%2C0-3.31.82-3.31%2C2.31%2C0%2C1.27.4%2C2%2C4.2%2C3.33%2C4.25%2C1.53%2C5.54%2C2.87%2C5.54%2C5.72s-2%2C4.79-5.12%2C5.21Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-download-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_download%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M33%2C23v2a6%2C6%2C0%2C0%2C1-6%2C6H15a6%2C6%2C0%2C0%2C1-6-6V23h2v2a4%2C4%2C0%2C0%2C0%2C4%2C4H27a4%2C4%2C0%2C0%2C0%2C4-4V23ZM22%2C17V9H20v8H16.38L21%2C25l4.62-8Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-envelop-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_envelope%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M33%2C15h0V13H9V25a6%2C6%2C0%2C0%2C0%2C6%2C6H27a6%2C6%2C0%2C0%2C0%2C6-6V15ZM31%2C25a4%2C4%2C0%2C0%2C1-4%2C4H15a4%2C4%2C0%2C0%2C1-4-4h0V19.75l10%2C5.32%2C10-5.27Zm0-7.46L21%2C22.83%2C11%2C17.49V15H31Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-euro-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_euro%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M22%2C31c-3.13%2C0-5.75-3-6.64-7H21V22H15.07c0-.33-.07-.66-.07-1s0-.67.07-1H21V18H15.36c.89-4%2C3.52-7%2C6.64-7a6.26%2C6.26%2C0%2C0%2C1%2C5.09%2C3.16l1.73-.92C27.17%2C10.67%2C24.74%2C9%2C22%2C9c-4.2%2C0-7.71%2C3.83-8.71%2C9H11v2h2c0%2C.33%2C0%2C.66%2C0%2C1s0%2C.67%2C0%2C1H11v2h2.3c1%2C5.17%2C4.52%2C9%2C8.71%2C9%2C2.74%2C0%2C5.16-1.67%2C6.8-4.25l-1.71-.91A6.25%2C6.25%2C0%2C0%2C1%2C22%2C31Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-jbp-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_GBP%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M27.17%2C26.86a4%2C4%2C0%2C0%2C1-3.73%2C2.59%2C3.65%2C3.65%2C0%2C0%2C1-1.54-.37v0L19%2C27.56V21h6V19H19V15h0a4%2C4%2C0%2C0%2C1%2C4-4%2C3.94%2C3.94%2C0%2C0%2C1%2C2.56%2C1l1.88-1A6%2C6%2C0%2C0%2C0%2C17%2C15h0v4H15v2h2v6.29l-4%2C2.13.94%2C1.77%2C3.8-2%2C2.83%2C1.51a5.79%2C5.79%2C0%2C0%2C0%2C.52.28l.37.13a5.83%2C5.83%2C0%2C0%2C0%2C2%2C.38A6%2C6%2C0%2C0%2C0%2C29%2C27.8Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-info-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_info%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M23%2C13a2%2C2%2C0%2C1%2C1-2-2%2C2%2C2%2C0%2C0%2C1%2C2%2C2m12%2C8A14%2C14%2C0%2C1%2C0%2C21%2C35%2C14%2C14%2C0%2C0%2C0%2C35%2C21m2%2C0A16%2C16%2C0%2C1%2C1%2C21%2C5%2C16%2C16%2C0%2C0%2C1%2C37%2C21M23%2C17.09l-4.74%2C2.52.94%2C1.77%2C1.8-1V31h2Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-laptop-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_laptop%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M31%2C25V11H11V25H7a6%2C6%2C0%2C0%2C0%2C6%2C6H29a6%2C6%2C0%2C0%2C0%2C6-6ZM13%2C13h8.43L13%2C17.48Zm0%2C6.75L25.69%2C13H29V25H13ZM29%2C29H13a4%2C4%2C0%2C0%2C1-3.46-2H32.47A4%2C4%2C0%2C0%2C1%2C29%2C29Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-lightbulb-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_lightbulb%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C1%2C41%2C21%2C20%2C20%2C0%2C0%2C1%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M17%2C29h8v2H17Zm2%2C6h4V33H19Zm6.44-18.14-.94-1.77L21%2C17%2C17.5%2C15.1l-.94%2C1.77L21%2C19.22h0Zm-.44%2C7V27H17V23.87a8%2C8%2C0%2C1%2C1%2C8%2C0ZM27%2C17a6%2C6%2C0%2C1%2C0-8%2C5.63V25h4V22.63A6%2C6%2C0%2C0%2C0%2C27%2C17Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-list-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_list%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M15%2C11H31v2H15Zm0%2C14H31V23H15Zm0%2C6H31V29H15Zm0-12H31V17H15Zm-3-6a1%2C1%2C0%2C1%2C0-1-1%2C1%2C1%2C0%2C0%2C0%2C1%2C1m0%2C12a1%2C1%2C0%2C1%2C0-1-1%2C1%2C1%2C0%2C0%2C0%2C1%2C1m0-6a1%2C1%2C0%2C1%2C0-1-1%2C1%2C1%2C0%2C0%2C0%2C1%2C1m0%2C12a1%2C1%2C0%2C1%2C0-1-1%2C1%2C1%2C0%2C0%2C0%2C1%2C1%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-lock-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_lock%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M27%2C15V13h0a6%2C6%2C0%2C1%2C0-12%2C0v2H11v2h0v8a6%2C6%2C0%2C0%2C0%2C6%2C6h8a6%2C6%2C0%2C0%2C0%2C6-6V15ZM17%2C13a4%2C4%2C0%2C1%2C1%2C8%2C0h0v2H17ZM29%2C25a4%2C4%2C0%2C0%2C1-4%2C4H17a4%2C4%2C0%2C0%2C1-2.89-1.23L29%2C19.88Zm0-7.39L13.14%2C26A3.87%2C3.87%2C0%2C0%2C1%2C13%2C25V17H29Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-mapping-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_mappin%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M29%2C17c0%2C4.73-8%2C14.9-8%2C14.9S13%2C21.73%2C13%2C17a7.81%2C7.81%2C0%2C0%2C1%2C8-8%2C7.81%2C7.81%2C0%2C0%2C1%2C8%2C8m2%2C0a10%2C10%2C0%2C0%2C0-20%2C0c0%2C5.52%2C10%2C18%2C10%2C18S31%2C22.52%2C31%2C17m-6%2C0a4%2C4%2C0%2C1%2C1-4-4%2C4%2C4%2C0%2C0%2C1%2C4%2C4m2%2C0a6%2C6%2C0%2C1%2C0-6%2C6%2C6%2C6%2C0%2C0%2C0%2C6-6%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-menu-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_menu%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M11%2C15H31v2H11Zm0%2C12H31V25H11Zm0-5H31V20H11Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-minus-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_minus%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Crect%20class%3D%22cls-2%22%20x%3D%2210%22%20y%3D%2219%22%20width%3D%2220%22%20height%3D%222%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-mobile-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3C!--%20Generator%3A%20Adobe%20Illustrator%2022.0.1%2C%20SVG%20Export%20Plug-In%20.%20SVG%20Version%3A%206.00%20Build%200%29%20%20--%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22Layer%5f1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2040%2040%22%20style%3D%22enable-background%3Anew%200%200%2040%2040%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill%3A%23002A54%3B%7D%0A%3C%2Fstyle%3E%0A%3Cg%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M24.5%2C9h-9C14.7%2C9%2C14%2C9.7%2C14%2C10.5V12h12v-1.5C26%2C9.7%2C25.3%2C9%2C24.5%2C9z%22%2F%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M14%2C29.5c0%2C0.8%2C0.7%2C1.5%2C1.5%2C1.5h9c0.8%2C0%2C1.5-0.7%2C1.5-1.5V28H14V29.5z%22%2F%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M20%2C1C9.5%2C1%2C1%2C9.5%2C1%2C20s8.5%2C19%2C19%2C19s19-8.5%2C19-19S30.5%2C1%2C20%2C1z%20M27%2C12v1v14v1v1.5c0%2C1.4-1.1%2C2.5-2.5%2C2.5h-9%0A%09%09c-1.4%2C0-2.5-1.1-2.5-2.5V28v-1V13v-1v-1.5C13%2C9.1%2C14.1%2C8%2C15.5%2C8h9c1.4%2C0%2C2.5%2C1.1%2C2.5%2C2.5V12z%22%2F%3E%0A%09%3Cpath%20id%3D%22path-3%5f1%5f%22%20class%3D%22st0%22%20d%3D%22M14%2C27h12V13H14V27z%22%2F%3E%0A%3C%2Fg%3E%0A%3C%2Fsvg%3E%0A);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-pencil-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_pencil%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M27%2C25.89l2-1.06V29a4%2C4%2C0%2C0%2C1-4%2C4H13a4%2C4%2C0%2C0%2C1-4-4V13a4%2C4%2C0%2C0%2C1%2C4-4H25a4%2C4%2C0%2C0%2C1%2C3.86%2C3.31L27%2C13.3V13a2%2C2%2C0%2C0%2C0-2-2H13a2%2C2%2C0%2C0%2C0-2%2C2V29a2%2C2%2C0%2C0%2C0%2C2%2C2H25a2%2C2%2C0%2C0%2C0%2C2-2Zm11.14-8L20%2C27.51H14.1l-1-1.88%2C3.25-4.82%2C0-.06L34.55%2C11.1ZM19.91%2C21.14l1.72%2C3.24%2C9.25-4.92-1.72-3.24Zm-.4%2C4.37.36-.19-1.72-3.24-.36.19L15.6%2C25.51ZM35.44%2C17%2C33.72%2C13.8l-2.8%2C1.49%2C1.72%2C3.24Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-people-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_people%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M28%2C19a5%2C5%2C0%2C1%2C0-5-5A5%2C5%2C0%2C0%2C0%2C28%2C19Zm0-8a3%2C3%2C0%2C1%2C1-3%2C3A3%2C3%2C0%2C0%2C1%2C28%2C11ZM14%2C19a5%2C5%2C0%2C1%2C0-5-5A5%2C5%2C0%2C0%2C0%2C14%2C19Zm0-8a3%2C3%2C0%2C1%2C1-3%2C3A3%2C3%2C0%2C0%2C1%2C14%2C11Zm.77%2C10.43A3.9%2C3.9%2C0%2C0%2C0%2C13%2C21a4%2C4%2C0%2C0%2C0-4%2C4H9v8H21V24.72l-6.19-3.29ZM19%2C31H11V25h0a2%2C2%2C0%2C0%2C1%2C2-2%2C3.51%2C3.51%2C0%2C0%2C1%2C1%2C.27l5%2C2.66Zm14-6h0v8H23V31h8V25a2%2C2%2C0%2C0%2C0-2-2%2C2%2C2%2C0%2C0%2C0-1%2C.3v0l-5%2C2.66V23.66l4.19-2.23A7.37%2C7.37%2C0%2C0%2C1%2C29%2C21%2C4%2C4%2C0%2C0%2C1%2C33%2C25Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-piggybank-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_piggybank%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C1%2C41%2C21%2C20%2C20%2C0%2C0%2C1%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M25.74%2C18.37A5.55%2C5.55%2C0%2C0%2C0%2C22%2C17a5.62%2C5.62%2C0%2C0%2C0-3.62%2C1.25l-1.83-1a7.66%2C7.66%2C0%2C0%2C1%2C11%2C.12ZM32.36%2C17A7.5%2C7.5%2C0%2C0%2C1%2C33%2C20a8.38%2C8.38%2C0%2C0%2C1-4%2C6.87V31H15V26.87A9.22%2C9.22%2C0%2C0%2C1%2C11.7%2C23H9V17h2.72A8.41%2C8.41%2C0%2C0%2C1%2C13%2C15V9h2l4.36%2C2.28A12.69%2C12.69%2C0%2C0%2C1%2C22%2C11a11.68%2C11.68%2C0%2C0%2C1%2C9.36%2C4.28l1.4-.74.94%2C1.76ZM31%2C20c0-3.87-4-7-9-7a11.24%2C11.24%2C0%2C0%2C0-2.88.39L15%2C11.26v4.37A6.39%2C6.39%2C0%2C0%2C0%2C13.13%2C19H11v2h2.13A7.12%2C7.12%2C0%2C0%2C0%2C17%2C25.76V29h4V27h2v2h4V25.76C29.36%2C24.5%2C31%2C22.39%2C31%2C20Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-wear-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_gear%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M21%2C16a5%2C5%2C0%2C1%2C0%2C5%2C5A5%2C5%2C0%2C0%2C0%2C21%2C16Zm0%2C8a3%2C3%2C0%2C1%2C1%2C3-3A3%2C3%2C0%2C0%2C1%2C21%2C24Zm11-1.27a11.06%2C11.06%2C0%2C0%2C0%2C0-3.46l3.13-1.8-4-6.93L28%2C12.34a11.08%2C11.08%2C0%2C0%2C0-3-1.73V7H17v3.57a11%2C11%2C0%2C0%2C0-1.59.74%2C10.82%2C10.82%2C0%2C0%2C0-1.43%2C1l-3.1-1.79-4%2C6.93L10%2C19.27a11.28%2C11.28%2C0%2C0%2C0%2C0%2C3.46l-3.12%2C1.8h0l4%2C6.93L14%2C29.66a11.16%2C11.16%2C0%2C0%2C0%2C3%2C1.73V35h8V31.43a9.8%2C9.8%2C0%2C0%2C0%2C3-1.75l3.09%2C1.79%2C4-6.93Zm-1.6%2C6-2.57-1.48A8.72%2C8.72%2C0%2C0%2C1%2C23%2C30v3H19V30a9.23%2C9.23%2C0%2C0%2C1-4.84-2.77l-2.55%2C1.47-2-3.46%2C2.55-1.47a9.26%2C9.26%2C0%2C0%2C1%2C0-5.58L9.61%2C16.73l2-3.46%2C2.56%2C1.48A8.74%2C8.74%2C0%2C0%2C1%2C19%2C12V9h4v3a9.26%2C9.26%2C0%2C0%2C1%2C4.85%2C2.78l2.55-1.47%2C2%2C3.46L29.85%2C18.2a9.23%2C9.23%2C0%2C0%2C1%2C0%2C5.58l2.57%2C1.48Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-playbutton-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_play_button%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M29%2C11H13a6%2C6%2C0%2C0%2C0-6%2C6v8a6%2C6%2C0%2C0%2C0%2C6%2C6H29a6%2C6%2C0%2C0%2C0%2C6-6V17A6%2C6%2C0%2C0%2C0%2C29%2C11Zm4%2C14.19A4%2C4%2C0%2C0%2C1%2C29.2%2C29H12.81A4%2C4%2C0%2C0%2C1%2C9%2C25.19V16.81A4%2C4%2C0%2C0%2C1%2C12.81%2C13H29.2A4%2C4%2C0%2C0%2C1%2C33%2C16.81ZM18%2C26.34a1%2C1%2C0%2C0%2C1-1-1V16.66a1%2C1%2C0%2C0%2C1%2C.48-.86%2C1%2C1%2C0%2C0%2C1%2C1%2C0l8.17%2C4.33a1%2C1%2C0%2C0%2C1%2C0%2C1.77l-8.17%2C4.34A1%2C1%2C0%2C0%2C1%2C18%2C26.34Zm1-8v5.35L24%2C21Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-plus-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_plus%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpolygon%20class%3D%22cls-2%22%20points%3D%2230%2019%2021%2019%2021%2010%2019%2010%2019%2019%2010%2019%2010%2021%2019%2021%2019%2030%2021%2030%2021%2021%2030%2021%2030%2019%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-print-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_print%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M29%2C19h2v2H29Zm6%2C0v8H29v4H13V27H7V19a4%2C4%2C0%2C0%2C1%2C4-4h2V9H29v6h2A4%2C4%2C0%2C0%2C1%2C35%2C19ZM15%2C15H27V11H15Zm0%2C14H27V23H15Zm18-8V19a2%2C2%2C0%2C0%2C0-2-2H11a2%2C2%2C0%2C0%2C0-2%2C2v6h4V21H29v4h4Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-profile-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_profile%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M25%2C17a4%2C4%2C0%2C1%2C1-4-4%2C4%2C4%2C0%2C0%2C1%2C4%2C4m2%2C0a6%2C6%2C0%2C1%2C0-6%2C6%2C6%2C6%2C0%2C0%2C0%2C6-6m-6%2C7.39L9.36%2C30.58l.94%2C1.77L21%2C26.66l10.7%2C5.69.94-1.77Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-search-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_search%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M23%2C9a8%2C8%2C0%2C0%2C0-4.6%2C14.53L13%2C33.7l1.77.94%2C5.41-10.18A8%2C8%2C0%2C1%2C0%2C23%2C9Zm0%2C14a6%2C6%2C0%2C1%2C1%2C6-6A6%2C6%2C0%2C0%2C1%2C23%2C23Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-shopping-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_shopping_cart%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M41%2C21A20%2C20%2C0%2C1%2C1%2C21%2C1%2C20%2C20%2C0%2C0%2C1%2C41%2C21%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M29%2C33a2%2C2%2C0%2C1%2C1-2-2A2%2C2%2C0%2C0%2C1%2C29%2C33ZM17%2C31a2%2C2%2C0%2C1%2C0%2C2%2C2A2%2C2%2C0%2C0%2C0%2C17%2C31ZM31%2C15v6h0l-7.58%2C4v0H13a2%2C2%2C0%2C0%2C0%2C2%2C2H29v2H15a4%2C4%2C0%2C0%2C1-4-4V15H7V13h6v2Zm-2%2C2H13v6H23l6-3.2Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-talk-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_talk%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M31%2C19c0%2C3-2%2C5.51-5%2C6.89l-9%2C4.78V26.27c-3.52-1.24-6-4-6-7.27%2C0-4.42%2C4.48-8%2C10-8s10%2C3.58%2C10%2C8m2%2C0c0-5.52-5.37-10-12-10S9%2C13.48%2C9%2C19c0%2C3.69%2C2.42%2C6.88%2C6%2C8.6V34l12.94-6.88h0A9.54%2C9.54%2C0%2C0%2C0%2C33%2C19%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-telephone-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_telephone%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M31.11%2C31.49l-3.75-7.06-4.54%2C0-3.64-6.84%2C2.49-3.69L18%2C6.76h0L14.44%2C8.64h0A6%2C6%2C0%2C0%2C0%2C12%2C16.76h0l7.51%2C14.13h0a6%2C6%2C0%2C0%2C0%2C8.11%2C2.48h0l3.53-1.88Zm-4.47.11h0a4%2C4%2C0%2C0%2C1-5.41-1.65L13.72%2C15.82a4%2C4%2C0%2C0%2C1%2C1.65-5.41h0l1.77-.94%2C2.24%2C4.21-2.53%2C3.75h0l4.79%2C9h4.5l2.27%2C4.26-1.76.94Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-tiles-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_tiles%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M13%2C9a4%2C4%2C0%2C0%2C0-4%2C3.83H9V19H19V9Zm4%2C8H11V13a2%2C2%2C0%2C0%2C1%2C2-2h4Zm16-4a4%2C4%2C0%2C0%2C0-4-4H23V19H33V13Zm-2%2C4H25V11h4a2%2C2%2C0%2C0%2C1%2C2%2C2ZM9%2C23v6a4%2C4%2C0%2C0%2C0%2C4%2C4h6V23Zm8%2C8H13a2%2C2%2C0%2C0%2C1-2-2V25h6Zm6-8V33h6a4%2C4%2C0%2C0%2C0%2C4-4V23Zm6%2C8H25V25h6v4A2%2C2%2C0%2C0%2C1%2C29%2C31Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-upload-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_upload%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C1A20%2C20%2C0%2C1%2C0%2C41%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C1%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M9%2C19V17a6%2C6%2C0%2C0%2C1%2C6-6H27a6%2C6%2C0%2C0%2C1%2C6%2C6v2H31V17a4%2C4%2C0%2C0%2C0-4-4H15a4%2C4%2C0%2C0%2C0-4%2C4v2Zm11%2C6v8h2V25h3.62L21%2C17l-4.62%2C8Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-unlock-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_unlock%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M21%2C15V13h0A6%2C6%2C0%2C0%2C0%2C9%2C13H9v4h2V13a4%2C4%2C0%2C0%2C1%2C8%2C0v2H15V25a6%2C6%2C0%2C0%2C0%2C6%2C6h8a6%2C6%2C0%2C0%2C0%2C6-6V15ZM33%2C25a4%2C4%2C0%2C0%2C1-4%2C4H21a4%2C4%2C0%2C0%2C1-2.88-1.21L33%2C19.88V25Zm0-7.39L17.14%2C26A4%2C4%2C0%2C0%2C1%2C17%2C25h0V17H33Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-website-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_website%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M9%2C11V27a6%2C6%2C0%2C0%2C0%2C6%2C6H27a6%2C6%2C0%2C0%2C0%2C6-6V11Zm6%2C4V13h2v2Zm-2-2v2H11V13ZM31%2C27a4%2C4%2C0%2C0%2C1-4%2C4H15a4%2C4%2C0%2C0%2C1-4-4V17H31Zm0-12H19V13H31ZM18.61%2C21l8%2C.28-4.24%2C6.78L21%2C25.5l-5.3%2C2.82-.94-1.77%2C5.3-2.82Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-x-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_x%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpolygon%20class%3D%22cls-2%22%20points%3D%2227.78%2013.63%2026.36%2012.22%2020%2018.59%2013.64%2012.22%2012.22%2013.64%2018.59%2020%2012.22%2026.36%2013.64%2027.78%2020%2021.41%2026.36%2027.78%2027.78%2026.36%2021.41%2020%2027.78%2013.63%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-yen-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_yen%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpolygon%20class%3D%22cls-2%22%20points%3D%2221.01%2022%2025%2022%2025%2020%2021.01%2020%2021.01%2018.2%2030.57%2013.11%2029.63%2011.34%2019.98%2016.48%2010.33%2011.34%209.39%2013.11%2019.01%2018.23%2019.01%2020%2015%2020%2015%2022%2019.01%2022%2019.01%2024%2015%2024%2015%2026%2019.01%2026%2019.01%2032%2021.01%2032%2021.01%2026%2025%2026%2025%2024%2021.01%2024%2021.01%2022%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-location-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3C!--%20Generator%3A%20Adobe%20Illustrator%2022.0.1%2C%20SVG%20Export%20Plug-In%20.%20SVG%20Version%3A%206.00%20Build%200%29%20%20--%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22Layer%5f1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2040%2040%22%20style%3D%22enable-background%3Anew%200%200%2040%2040%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill%3A%23002A54%3B%7D%0A%3C%2Fstyle%3E%0A%3Cg%3E%0A%09%3Ccircle%20class%3D%22st0%22%20cx%3D%2220%22%20cy%3D%2217%22%20r%3D%224%22%2F%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M20%2C9c-4.3%2C0-8%2C3.5-8%2C7.7c0%2C2.8%2C2.7%2C7.5%2C8%2C14c5.3-6.5%2C8-11.3%2C8-14C28%2C12.5%2C24.3%2C9%2C20%2C9z%20M20%2C22%0A%09%09c-2.8%2C0-5-2.2-5-5s2.2-5%2C5-5s5%2C2.2%2C5%2C5S22.8%2C22%2C20%2C22z%22%2F%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M20%2C1C9.5%2C1%2C1%2C9.5%2C1%2C20s8.5%2C19%2C19%2C19s19-8.5%2C19-19S30.5%2C1%2C20%2C1z%20M20.4%2C31.8c-0.2%2C0.2-0.6%2C0.2-0.8%2C0%0A%09%09c-5.7-7-8.6-12-8.6-15.1C11%2C12%2C15.1%2C8%2C20%2C8s9%2C3.9%2C9%2C8.7C29%2C19.8%2C26.1%2C24.9%2C20.4%2C31.8z%22%2F%3E%0A%3C%2Fg%3E%0A%3C%2Fsvg%3E%0A);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-service-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20version%3D%221.1%22%20id%3D%22Layer%5f1%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%2040%2040%22%20style%3D%22enable-background%3Anew%200%200%2040%2040%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill%3A%23002A54%3B%7D%0A%3C%2Fstyle%3E%0A%3Cg%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M30%2C18.99963h-2v7h2c0.55298%2C0%2C1-0.44702%2C1-1v-5C31%2C19.44763%2C30.55298%2C18.99963%2C30%2C18.99963z%22%2F%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M20%2C0.99963c-10.49341%2C0-19%2C8.50659-19%2C19s8.50659%2C19%2C19%2C19s19-8.50659%2C19-19S30.49341%2C0.99963%2C20%2C0.99963z%20%20%20%20M32%2C24.99963c0%2C1.104-0.896%2C2-2%2C2h-0.86499c-0.73499%2C1.25-1.98499%2C1.79596-4.73303%2C2.396%20%20%20c-0.07996%2C0.01697-0.23297%2C0.04895-0.40198%2C0.086v0.51801c0%2C0.55298-0.44702%2C1-1%2C1h-4c-0.552%2C0-1-0.44702-1-1v-2%20%20%20c0-0.55304%2C0.448-1%2C1-1h4c0.55298%2C0%2C1%2C0.44696%2C1%2C1v0.45898c0.07703-0.01703%2C0.146-0.03101%2C0.18903-0.04102%20%20%20c2.00098-0.43597%2C3.07495-0.81897%2C3.70697-1.43896C27.39502%2C26.92358%2C27%2C26.51562%2C27%2C25.99963v-7c0-0.552%2C0.44702-1%2C1-1h1%20%20%20c0-4.586-3.79999-8-8.75-8s-8.75%2C3.414-8.75%2C8H12c0.552%2C0%2C1%2C0.448%2C1%2C1v7c0%2C0.55298-0.448%2C1-1%2C1h-2c-1.104%2C0-2-0.896-2-2v-5%20%20%20c0-1.104%2C0.896-2%2C2-2h0.5c0-5.164%2C4.271-9%2C9.75-9s9.75%2C3.836%2C9.75%2C9c1.104%2C0%2C2%2C0.896%2C2%2C2V24.99963z%22%2F%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M22.75519%2C27.99963h-3.51038C19.10962%2C27.99963%2C19%2C28.10919%2C19%2C28.24445v1.51038%20%20%20c0%2C0.13519%2C0.10962%2C0.24481%2C0.24481%2C0.24481h3.51038c0.13519%2C0%2C0.24481-0.10962%2C0.24481-0.24481v-1.51038%20%20%20C23%2C28.10919%2C22.89038%2C27.99963%2C22.75519%2C27.99963z%22%2F%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M9%2C20.24445v4.51038c0%2C0.68744%2C0.55731%2C1.24481%2C1.24481%2C1.24481h1.51038%20%20%20c0.13519%2C0%2C0.24481-0.10962%2C0.24481-0.24481v-6.51038c0-0.13525-0.10962-0.24481-0.24481-0.24481h-1.51038%20%20%20C9.55731%2C18.99963%2C9%2C19.55695%2C9%2C20.24445z%22%2F%3E%0A%3C%2Fg%3E%0A%3C%2Fsvg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-pointer-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20version%3D%221.1%22%20id%3D%22Layer%5f1%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%2040%2040%22%20style%3D%22enable-background%3Anew%200%200%2040%2040%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill%3A%23002A54%3B%7D%0A%3C%2Fstyle%3E%0A%3Cg%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M20%2C1C9.5%2C1%2C1%2C9.5%2C1%2C20s8.5%2C19%2C19%2C19s19-8.5%2C19-19S30.5%2C1%2C20%2C1z%20M27.4%2C9l-0.5%2C15.9c0%2C0.4-0.4%2C0.6-0.8%2C0.4%20%20%20l-3.9-2.2l-4.8%2C8.2c-0.1%2C0.2-0.4%2C0.3-0.7%2C0.2L12.5%2C29c-0.2-0.1-0.3-0.4-0.2-0.7l4.8-8.2l-3.9-2.2c-0.3-0.2-0.3-0.7%2C0-0.9l13.5-8.4%20%20%20c0.1-0.1%2C0.2-0.1%2C0.3-0.1C27.2%2C8.5%2C27.4%2C8.7%2C27.4%2C9L27.4%2C9z%22%2F%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M18%2C19.4c0.2%2C0.1%2C0.3%2C0.4%2C0.2%2C0.7l-4.8%2C8.2l3.5%2C2l4.8-8.2c0.1-0.2%2C0.4-0.3%2C0.7-0.2L26%2C24l0.4-14.1l-12%2C7.4%20%20%20L18%2C19.4z%22%2F%3E%0A%3C%2Fg%3E%0A%3C%2Fsvg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-cardPin-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20version%3D%221.1%22%20id%3D%22Layer%5f1%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%2040%2040%22%20style%3D%22enable-background%3Anew%200%200%2040%2040%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill%3A%23002A54%3B%7D%0A%3C%2Fstyle%3E%0A%3Cg%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M8.99957%2C27.28558c0%2C0.39801%2C0.30005%2C0.71405%2C0.65002%2C0.71405H30.3496%20%20%20c0.35101%2C0%2C0.64996-0.31604%2C0.64996-0.71405V15.99963h-22v11.28595H8.99957z%20M26.5%2C20.99963h2c0.66699%2C0%2C0.66699%2C1%2C0%2C1h-2%20%20%20C25.83301%2C21.99963%2C25.83301%2C20.99963%2C26.5%2C20.99963z%20M21.5%2C20.99963h2c0.66699%2C0%2C0.66699%2C1%2C0%2C1h-2%20%20%20C20.83301%2C21.99963%2C20.83301%2C20.99963%2C21.5%2C20.99963z%20M16.5%2C20.99963h2c0.66699%2C0%2C0.66699%2C1%2C0%2C1h-2%20%20%20C15.83301%2C21.99963%2C15.83301%2C20.99963%2C16.5%2C20.99963z%20M11.5%2C20.99963h2c0.66699%2C0%2C0.66699%2C1%2C0%2C1h-2%20%20%20C10.83301%2C21.99963%2C10.83301%2C20.99963%2C11.5%2C20.99963z%22%2F%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M30.34961%2C11.99963H9.6496c-0.34998%2C0-0.65002%2C0.31598-0.65002%2C0.71399v2.28601h22v-2.28601%20%20%20C30.99957%2C12.31561%2C30.70062%2C11.99963%2C30.34961%2C11.99963z%22%2F%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M20%2C0.99963c-10.49341%2C0-19%2C8.50659-19%2C19s8.50659%2C19%2C19%2C19s19-8.50659%2C19-19S30.49341%2C0.99963%2C20%2C0.99963z%20%20%20%20M31.99957%2C27.28558c0%2C0.93805-0.73395%2C1.71405-1.64996%2C1.71405H9.6496c-0.914%2C0-1.65002-0.776-1.65002-1.71405V12.71362%20%20%20c0-0.93799%2C0.73602-1.71399%2C1.65002-1.71399h20.70001c0.91602%2C0%2C1.64996%2C0.776%2C1.64996%2C1.71399%20%20%20C31.99957%2C12.71362%2C31.99957%2C27.28558%2C31.99957%2C27.28558z%22%2F%3E%0A%3C%2Fg%3E%0A%3C%2Fsvg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-trash{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_trash%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M33%2C12H27a4%2C4%2C0%2C0%2C0-4-4H19a4%2C4%2C0%2C0%2C0-4%2C4H9v2h2V30a4%2C4%2C0%2C0%2C0%2C4%2C4H27a4%2C4%2C0%2C0%2C0%2C4-4V14h2ZM19%2C10h4a2%2C2%2C0%2C0%2C1%2C2%2C2H17A2%2C2%2C0%2C0%2C1%2C19%2C10ZM29%2C30a2%2C2%2C0%2C0%2C1-2%2C2H15a2%2C2%2C0%2C0%2C1-2-2V27.21L29%2C18.7Zm0-13.57L13%2C24.94V14H29Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-four{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_4_arrows%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M41%2C21A20%2C20%2C0%2C1%2C1%2C21%2C1%2C20%2C20%2C0%2C0%2C1%2C41%2C21%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpolygon%20class%3D%22cls-2%22%20points%3D%2236%2020%2028%2015.38%2028%2019%2021%2019%2021%2012%2024.62%2012%2020%204%2015.38%2012%2019%2012%2019%2019%2012%2019%2012%2015.38%204%2020%2012%2024.62%2012%2021%2019%2021%2019%2028%2015.38%2028%2020%2036%2024.62%2028%2021%2028%2021%2021%2028%2021%2028%2024.62%2036%2020%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-arrowdown{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_arrow_down%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M41%2C21A20%2C20%2C0%2C1%2C1%2C21%2C1%2C20%2C20%2C0%2C0%2C1%2C41%2C21%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M20%2C9V30.7a2%2C2%2C0%2C0%2C1-.58-.5L13.28%2C18.65l-1.77.94%2C5.73%2C10.77h0a4%2C4%2C0%2C0%2C0%2C7.44.17l5.8-10.94-1.77-.94-5.87%2C11a2%2C2%2C0%2C0%2C1-.86%2C1V9Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-arrowleft{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_arrow_left%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C1%2C41%2C21%2C20%2C20%2C0%2C0%2C1%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M33%2C20H11.3a2%2C2%2C0%2C0%2C1%2C.5-.58l11.55-6.14-.94-1.77L11.64%2C17.24v0a4%2C4%2C0%2C0%2C0-.17%2C7.44l10.94%2C5.8.94-1.77-11-5.87a2%2C2%2C0%2C0%2C1-1-.86H33Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-arrowright{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_arrow_riwht%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C1A20%2C20%2C0%2C1%2C1%2C1%2C21%2C20%2C20%2C0%2C0%2C1%2C21%2C1%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M9%2C22H30.7a2%2C2%2C0%2C0%2C1-.5.58L18.65%2C28.72l.94%2C1.77%2C10.77-5.73v0a4%2C4%2C0%2C0%2C0%2C.16-7.44l-10.94-5.8-.94%2C1.77%2C11%2C5.87a2%2C2%2C0%2C0%2C1%2C1%2C.86H9Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-arrowup{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_arrow_up%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M1%2C21A20%2C20%2C0%2C1%2C1%2C21%2C41%2C20%2C20%2C0%2C0%2C1%2C1%2C21%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M22%2C33V11.3a2%2C2%2C0%2C0%2C1%2C.57.5l6.14%2C11.55%2C1.77-.94L24.77%2C11.64h0a4%2C4%2C0%2C0%2C0-7.44-.17l-5.8%2C10.94%2C1.77.94%2C5.87-11a2%2C2%2C0%2C0%2C1%2C.86-1V33Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-calendar{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_calendar%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M33%2C11H27V9H25v2H17V9H15v2H9V27a6%2C6%2C0%2C0%2C0%2C6%2C6H27a6%2C6%2C0%2C0%2C0%2C6-6h0ZM15%2C13v2h2V13h8v2h2V13h4v4H11V13ZM31%2C27a4%2C4%2C0%2C0%2C1-4%2C4H15a4%2C4%2C0%2C0%2C1-4-4V19H31Zm-4.74-6%2C.94%2C1.77-9.65%2C5.09-.94-1.77h0L15%2C22.93%2C16.77%2C22l1.65%2C3.16Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-branch{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_branch%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C1A20%2C20%2C0%2C1%2C1%2C1%2C21%2C20%2C20%2C0%2C0%2C1%2C21%2C1%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M33%2C17V13h0a2%2C2%2C0%2C0%2C0-2-2H11a2%2C2%2C0%2C0%2C0-2%2C2H9v4h2V29H9v2H33V29H31V17Zm-2-4v2H11V13ZM21%2C21v8H17V21Zm8%2C8H23V19H15V29H13V17H29Zm-2-4H25V21h2v4Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-bubble{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_bubble%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M26.22%2C13.89C24.7%2C11%2C21.15%2C9%2C17%2C9%2C11.48%2C9%2C7%2C12.58%2C7%2C17c0%2C3%2C2%2C5.48%2C5%2C6.86v5.41l5.23-2.82a9%2C9%2C0%2C0%2C0%2C1.88%2C1.62l11.14%2C6V28.66c3-1.37%2C5-3.91%2C5-6.86C35.25%2C17.65%2C31.28%2C14.29%2C26.22%2C13.89ZM9%2C17c0-3.31%2C3.58-6%2C8-6s8%2C2.69%2C8%2C6a5.51%2C5.51%2C0%2C0%2C1-2.79%2C4.52L14%2C25.94V22.52C11.08%2C21.63%2C9%2C19.51%2C9%2C17ZM28.25%2C27.32v3.42L20%2C26.32a6.54%2C6.54%2C0%2C0%2C1-1-.83l4.13-2.22A7.51%2C7.51%2C0%2C0%2C0%2C27%2C17a6.44%2C6.44%2C0%2C0%2C0-.13-1c3.63.56%2C6.38%2C2.93%2C6.38%2C5.82C33.25%2C24.31%2C31.17%2C26.43%2C28.25%2C27.32Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-chart{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_chart%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M17%2C29a4%2C4%2C0%2C0%2C1-4-3.81V23.09l4.94-2.63%2C1.81%2C3.4%2C11.61-6.18-.94-1.77-9.85%2C5.24-1.81-3.39L13%2C20.82V13H11V25.22A6%2C6%2C0%2C0%2C0%2C17%2C31H31V29Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-checkmark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_checkmark%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpolygon%20class%3D%22cls-2%22%20points%3D%2231.9%2014.46%2015.3%2023.29%2011.77%2016.64%2010%2017.58%2014.46%2026%2032.84%2016.23%2031.9%2014.46%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-roundarrows{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_circlearrows%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C1A20%2C20%2C0%2C1%2C1%2C1%2C21%2C20%2C20%2C0%2C0%2C1%2C21%2C1%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M31.45%2C26.81a12%2C12%2C0%2C0%2C1-21.16-.27l1.73-1a10%2C10%2C0%2C0%2C0%2C17.66.35l-3.21-1.7%2C7.84-4.9.32%2C9.23ZM26.59%2C10.41a12%2C12%2C0%2C0%2C0-16.16%2C4.85L7.37%2C13.62l.32%2C9.23L15.52%2C18l-3.32-1.77a10%2C10%2C0%2C0%2C1%2C17.67.32l1.73-1A11.94%2C11.94%2C0%2C0%2C0%2C26.59%2C10.41Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-creditCard{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_creditcard%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M21%2C23v2H11V23Zm14-8h0V27a4%2C4%2C0%2C0%2C1-4%2C4H11a4%2C4%2C0%2C0%2C1-4-4V15H7a4%2C4%2C0%2C0%2C1%2C4-4H31a4%2C4%2C0%2C0%2C1%2C4%2C4ZM11%2C29H21.44L33%2C22.85V19H9v8A2%2C2%2C0%2C0%2C0%2C11%2C29Zm22-2V25.12L25.7%2C29H31A2%2C2%2C0%2C0%2C0%2C33%2C27Zm0-12a2%2C2%2C0%2C0%2C0-2-2H11a2%2C2%2C0%2C0%2C0-2%2C2v2H33Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-currency{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_currency_bill%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M7%2C13V29H35V13Zm26%2C7.88L24.18%2C25.6A6.48%2C6.48%2C0%2C0%2C0%2C26%2C21c0-3.19-2.08-5.77-4.7-6v0H33ZM9%2C15h7.49L9%2C19Zm12%2C2c1.66%2C0%2C3%2C1.79%2C3%2C4s-1.34%2C4-3%2C4-3-1.79-3-4S19.34%2C17%2C21%2C17ZM9%2C21.22l8.5-4.5A6.61%2C6.61%2C0%2C0%2C0%2C16%2C21c0%2C3.24%2C2.14%2C5.86%2C4.82%2C6v0H9ZM25.84%2C27%2C33%2C23.18V27Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-docuarrow{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_docuarrow%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M11%2C9V33H24.13l5.09-2.67A4%2C4%2C0%2C0%2C0%2C31%2C27h0V9ZM27.73%2C28.85l-4%2C2.15H23V27h6A2%2C2%2C0%2C0%2C1%2C27.73%2C28.85ZM21%2C25v6H13V11H29v6H23V14l-7%2C4%2C7%2C4V19h6v6Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-docucheck{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_docucheck%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M11%2C9V33H24.14l5.08-2.7h0A4%2C4%2C0%2C0%2C0%2C31%2C27h0V9ZM29%2C27a2%2C2%2C0%2C0%2C1-1.27%2C1.85l-4%2C2.15H23V27Zm0-2H21v6H13V11H29ZM17.53%2C21.84%2C15%2C16.93%2C16.72%2C16l1.65%2C3.15L26.24%2C15l.94%2C1.77Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-document{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_document%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C1%2C41%2C21%2C20%2C20%2C0%2C0%2C1%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M11%2C9V33H24.13l5.08-2.7h0A4%2C4%2C0%2C0%2C0%2C31%2C27h0V9ZM29%2C27a2%2C2%2C0%2C0%2C1-1.27%2C1.85l-4%2C2.15H23V27Zm0-2H21v6H13V11H29ZM27%2C15H15V13H27ZM15%2C19V17h8v2Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-dollar{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_dollar%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M22.32%2C34.26H19.79v-3.8a9.09%2C9.09%2C0%2C0%2C1-5.15-2.56l-.18-.19%2C1.74-1.94.21.2a6.7%2C6.7%2C0%2C0%2C0%2C4.72%2C2.14c2.36%2C0%2C3.71-1%2C3.71-2.76%2C0-1.55-.95-2.34-4.23-3.52-3.74-1.34-5.51-2.5-5.51-5.51%2C0-2.6%2C1.75-4.37%2C4.7-4.78V7.74h2.53v3.76a8.53%2C8.53%2C0%2C0%2C1%2C4.62%2C2l.22.17-1.67%2C2-.21-.18A6.17%2C6.17%2C0%2C0%2C0%2C21%2C13.88c-2.14%2C0-3.31.82-3.31%2C2.31%2C0%2C1.27.4%2C2%2C4.2%2C3.33%2C4.25%2C1.53%2C5.54%2C2.87%2C5.54%2C5.72s-2%2C4.79-5.12%2C5.21Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-download{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_download%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M33%2C23v2a6%2C6%2C0%2C0%2C1-6%2C6H15a6%2C6%2C0%2C0%2C1-6-6V23h2v2a4%2C4%2C0%2C0%2C0%2C4%2C4H27a4%2C4%2C0%2C0%2C0%2C4-4V23ZM22%2C17V9H20v8H16.38L21%2C25l4.62-8Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-envelop{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_envelope%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M33%2C15h0V13H9V25a6%2C6%2C0%2C0%2C0%2C6%2C6H27a6%2C6%2C0%2C0%2C0%2C6-6V15ZM31%2C25a4%2C4%2C0%2C0%2C1-4%2C4H15a4%2C4%2C0%2C0%2C1-4-4h0V19.75l10%2C5.32%2C10-5.27Zm0-7.46L21%2C22.83%2C11%2C17.49V15H31Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-euro{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_euro%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M22%2C31c-3.13%2C0-5.75-3-6.64-7H21V22H15.07c0-.33-.07-.66-.07-1s0-.67.07-1H21V18H15.36c.89-4%2C3.52-7%2C6.64-7a6.26%2C6.26%2C0%2C0%2C1%2C5.09%2C3.16l1.73-.92C27.17%2C10.67%2C24.74%2C9%2C22%2C9c-4.2%2C0-7.71%2C3.83-8.71%2C9H11v2h2c0%2C.33%2C0%2C.66%2C0%2C1s0%2C.67%2C0%2C1H11v2h2.3c1%2C5.17%2C4.52%2C9%2C8.71%2C9%2C2.74%2C0%2C5.16-1.67%2C6.8-4.25l-1.71-.91A6.25%2C6.25%2C0%2C0%2C1%2C22%2C31Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-jbp{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_GBP%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M27.17%2C26.86a4%2C4%2C0%2C0%2C1-3.73%2C2.59%2C3.65%2C3.65%2C0%2C0%2C1-1.54-.37v0L19%2C27.56V21h6V19H19V15h0a4%2C4%2C0%2C0%2C1%2C4-4%2C3.94%2C3.94%2C0%2C0%2C1%2C2.56%2C1l1.88-1A6%2C6%2C0%2C0%2C0%2C17%2C15h0v4H15v2h2v6.29l-4%2C2.13.94%2C1.77%2C3.8-2%2C2.83%2C1.51a5.79%2C5.79%2C0%2C0%2C0%2C.52.28l.37.13a5.83%2C5.83%2C0%2C0%2C0%2C2%2C.38A6%2C6%2C0%2C0%2C0%2C29%2C27.8Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-info{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_info%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M23%2C13a2%2C2%2C0%2C1%2C1-2-2%2C2%2C2%2C0%2C0%2C1%2C2%2C2m12%2C8A14%2C14%2C0%2C1%2C0%2C21%2C35%2C14%2C14%2C0%2C0%2C0%2C35%2C21m2%2C0A16%2C16%2C0%2C1%2C1%2C21%2C5%2C16%2C16%2C0%2C0%2C1%2C37%2C21M23%2C17.09l-4.74%2C2.52.94%2C1.77%2C1.8-1V31h2Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-laptop{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_laptop%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M31%2C25V11H11V25H7a6%2C6%2C0%2C0%2C0%2C6%2C6H29a6%2C6%2C0%2C0%2C0%2C6-6ZM13%2C13h8.43L13%2C17.48Zm0%2C6.75L25.69%2C13H29V25H13ZM29%2C29H13a4%2C4%2C0%2C0%2C1-3.46-2H32.47A4%2C4%2C0%2C0%2C1%2C29%2C29Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-lightbulb{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_lightbulb%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C1%2C41%2C21%2C20%2C20%2C0%2C0%2C1%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M17%2C29h8v2H17Zm2%2C6h4V33H19Zm6.44-18.14-.94-1.77L21%2C17%2C17.5%2C15.1l-.94%2C1.77L21%2C19.22h0Zm-.44%2C7V27H17V23.87a8%2C8%2C0%2C1%2C1%2C8%2C0ZM27%2C17a6%2C6%2C0%2C1%2C0-8%2C5.63V25h4V22.63A6%2C6%2C0%2C0%2C0%2C27%2C17Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-list{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_list%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M15%2C11H31v2H15Zm0%2C14H31V23H15Zm0%2C6H31V29H15Zm0-12H31V17H15Zm-3-6a1%2C1%2C0%2C1%2C0-1-1%2C1%2C1%2C0%2C0%2C0%2C1%2C1m0%2C12a1%2C1%2C0%2C1%2C0-1-1%2C1%2C1%2C0%2C0%2C0%2C1%2C1m0-6a1%2C1%2C0%2C1%2C0-1-1%2C1%2C1%2C0%2C0%2C0%2C1%2C1m0%2C12a1%2C1%2C0%2C1%2C0-1-1%2C1%2C1%2C0%2C0%2C0%2C1%2C1%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-lock{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_lock%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M27%2C15V13h0a6%2C6%2C0%2C1%2C0-12%2C0v2H11v2h0v8a6%2C6%2C0%2C0%2C0%2C6%2C6h8a6%2C6%2C0%2C0%2C0%2C6-6V15ZM17%2C13a4%2C4%2C0%2C1%2C1%2C8%2C0h0v2H17ZM29%2C25a4%2C4%2C0%2C0%2C1-4%2C4H17a4%2C4%2C0%2C0%2C1-2.89-1.23L29%2C19.88Zm0-7.39L13.14%2C26A3.87%2C3.87%2C0%2C0%2C1%2C13%2C25V17H29Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-mapping{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_mappin%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M29%2C17c0%2C4.73-8%2C14.9-8%2C14.9S13%2C21.73%2C13%2C17a7.81%2C7.81%2C0%2C0%2C1%2C8-8%2C7.81%2C7.81%2C0%2C0%2C1%2C8%2C8m2%2C0a10%2C10%2C0%2C0%2C0-20%2C0c0%2C5.52%2C10%2C18%2C10%2C18S31%2C22.52%2C31%2C17m-6%2C0a4%2C4%2C0%2C1%2C1-4-4%2C4%2C4%2C0%2C0%2C1%2C4%2C4m2%2C0a6%2C6%2C0%2C1%2C0-6%2C6%2C6%2C6%2C0%2C0%2C0%2C6-6%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-menu{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_menu%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M11%2C15H31v2H11Zm0%2C12H31V25H11Zm0-5H31V20H11Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-minus{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_minus%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpolygon%20class%3D%22cls-2%22%20points%3D%2210%2021%2029%2021%2030%2021%2030%2019%2010%2019%2010%2021%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-mobile{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3C!--%20Generator%3A%20Adobe%20Illustrator%2022.0.1%2C%20SVG%20Export%20Plug-In%20.%20SVG%20Version%3A%206.00%20Build%200%29%20%20--%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22Layer%5f1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2040%2040%22%20style%3D%22enable-background%3Anew%200%200%2040%2040%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill%3A%23002A54%3B%7D%0A%3C%2Fstyle%3E%0A%3Cpath%20class%3D%22st0%22%20d%3D%22M15.5%2C7.99963c-1.40002%2C0-2.5%2C1.09998-2.5%2C2.5v1.5v1v14v1v1.5c0%2C1.39996%2C1.09998%2C2.5%2C2.5%2C2.5h9%0A%09c1.40002%2C0%2C2.5-1.10004%2C2.5-2.5v-1.5v-1v-14v-1v-1.5c0-1.40002-1.09998-2.5-2.5-2.5H15.5z%20M26%2C29.49963%0A%09c0%2C0.79999-0.70001%2C1.5-1.5%2C1.5h-9c-0.79999%2C0-1.5-0.70001-1.5-1.5v-1.5h12V29.49963z%20M26%2C26.99963H14v-14h12V26.99963z%0A%09%20M26%2C10.49963v1.5H14v-1.5c0-0.80005%2C0.70001-1.5%2C1.5-1.5h9C25.29999%2C8.99963%2C26%2C9.69958%2C26%2C10.49963z%22%2F%3E%0A%3C%2Fsvg%3E%0A);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-pencil{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_pencil%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M27%2C25.89l2-1.06V29a4%2C4%2C0%2C0%2C1-4%2C4H13a4%2C4%2C0%2C0%2C1-4-4V13a4%2C4%2C0%2C0%2C1%2C4-4H25a4%2C4%2C0%2C0%2C1%2C3.86%2C3.31L27%2C13.3V13a2%2C2%2C0%2C0%2C0-2-2H13a2%2C2%2C0%2C0%2C0-2%2C2V29a2%2C2%2C0%2C0%2C0%2C2%2C2H25a2%2C2%2C0%2C0%2C0%2C2-2Zm11.14-8L20%2C27.51H14.1l-1-1.88%2C3.25-4.82%2C0-.06L34.55%2C11.1ZM19.91%2C21.14l1.72%2C3.24%2C9.25-4.92-1.72-3.24Zm-.4%2C4.37.36-.19-1.72-3.24-.36.19L15.6%2C25.51ZM35.44%2C17%2C33.72%2C13.8l-2.8%2C1.49%2C1.72%2C3.24Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-people{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_people%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M28%2C19a5%2C5%2C0%2C1%2C0-5-5A5%2C5%2C0%2C0%2C0%2C28%2C19Zm0-8a3%2C3%2C0%2C1%2C1-3%2C3A3%2C3%2C0%2C0%2C1%2C28%2C11ZM14%2C19a5%2C5%2C0%2C1%2C0-5-5A5%2C5%2C0%2C0%2C0%2C14%2C19Zm0-8a3%2C3%2C0%2C1%2C1-3%2C3A3%2C3%2C0%2C0%2C1%2C14%2C11Zm.77%2C10.43A3.9%2C3.9%2C0%2C0%2C0%2C13%2C21a4%2C4%2C0%2C0%2C0-4%2C4H9v8H21V24.72l-6.19-3.29ZM19%2C31H11V25h0a2%2C2%2C0%2C0%2C1%2C2-2%2C3.51%2C3.51%2C0%2C0%2C1%2C1%2C.27l5%2C2.66Zm14-6h0v8H23V31h8V25a2%2C2%2C0%2C0%2C0-2-2%2C2%2C2%2C0%2C0%2C0-1%2C.3v0l-5%2C2.66V23.66l4.19-2.23A7.37%2C7.37%2C0%2C0%2C1%2C29%2C21%2C4%2C4%2C0%2C0%2C1%2C33%2C25Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-piggybank{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_piwwybank%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C1%2C41%2C21%2C20%2C20%2C0%2C0%2C1%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M25.74%2C18.37A5.55%2C5.55%2C0%2C0%2C0%2C22%2C17a5.62%2C5.62%2C0%2C0%2C0-3.62%2C1.25l-1.83-1a7.66%2C7.66%2C0%2C0%2C1%2C11%2C.12ZM32.36%2C17A7.5%2C7.5%2C0%2C0%2C1%2C33%2C20a8.38%2C8.38%2C0%2C0%2C1-4%2C6.87V31H15V26.87A9.22%2C9.22%2C0%2C0%2C1%2C11.7%2C23H9V17h2.72A8.41%2C8.41%2C0%2C0%2C1%2C13%2C15V9h2l4.36%2C2.28A12.69%2C12.69%2C0%2C0%2C1%2C22%2C11a11.68%2C11.68%2C0%2C0%2C1%2C9.36%2C4.28l1.4-.74.94%2C1.76ZM31%2C20c0-3.87-4-7-9-7a11.24%2C11.24%2C0%2C0%2C0-2.88.39L15%2C11.26v4.37A6.39%2C6.39%2C0%2C0%2C0%2C13.13%2C19H11v2h2.13A7.12%2C7.12%2C0%2C0%2C0%2C17%2C25.76V29h4V27h2v2h4V25.76C29.36%2C24.5%2C31%2C22.39%2C31%2C20Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-playbutton{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_play_button%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M29%2C11H13a6%2C6%2C0%2C0%2C0-6%2C6v8a6%2C6%2C0%2C0%2C0%2C6%2C6H29a6%2C6%2C0%2C0%2C0%2C6-6V17A6%2C6%2C0%2C0%2C0%2C29%2C11Zm4%2C14.19A4%2C4%2C0%2C0%2C1%2C29.2%2C29H12.81A4%2C4%2C0%2C0%2C1%2C9%2C25.19V16.81A4%2C4%2C0%2C0%2C1%2C12.81%2C13H29.2A4%2C4%2C0%2C0%2C1%2C33%2C16.81ZM18%2C26.34a1%2C1%2C0%2C0%2C1-1-1V16.66a1%2C1%2C0%2C0%2C1%2C.48-.86%2C1%2C1%2C0%2C0%2C1%2C1%2C0l8.17%2C4.33a1%2C1%2C0%2C0%2C1%2C0%2C1.77l-8.17%2C4.34A1%2C1%2C0%2C0%2C1%2C18%2C26.34Zm1-8v5.35L24%2C21Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-plus{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_plus%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpolygon%20class%3D%22cls-2%22%20points%3D%2230%2019%2021%2019%2021%2010%2019%2010%2019%2019%2010%2019%2010%2021%2019%2021%2019%2030%2021%2030%2021%2021%2030%2021%2030%2019%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-print{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_print%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M29%2C19h2v2H29Zm6%2C0v8H29v4H13V27H7V19a4%2C4%2C0%2C0%2C1%2C4-4h2V9H29v6h2A4%2C4%2C0%2C0%2C1%2C35%2C19ZM15%2C15H27V11H15Zm0%2C14H27V23H15Zm18-8V19a2%2C2%2C0%2C0%2C0-2-2H11a2%2C2%2C0%2C0%2C0-2%2C2v6h4V21H29v4h4Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-profile{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_profile%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M25%2C17a4%2C4%2C0%2C1%2C1-4-4%2C4%2C4%2C0%2C0%2C1%2C4%2C4m2%2C0a6%2C6%2C0%2C1%2C0-6%2C6%2C6%2C6%2C0%2C0%2C0%2C6-6m-6%2C7.39L9.36%2C30.58l.94%2C1.77L21%2C26.66l10.7%2C5.69.94-1.77Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-search{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_search%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M23%2C9a8%2C8%2C0%2C0%2C0-4.6%2C14.53L13%2C33.7l1.77.94%2C5.41-10.18A8%2C8%2C0%2C1%2C0%2C23%2C9Zm0%2C14a6%2C6%2C0%2C1%2C1%2C6-6A6%2C6%2C0%2C0%2C1%2C23%2C23Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-shopping{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_shoppinw_cart%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M41%2C21A20%2C20%2C0%2C1%2C1%2C21%2C1%2C20%2C20%2C0%2C0%2C1%2C41%2C21%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M29%2C33a2%2C2%2C0%2C1%2C1-2-2A2%2C2%2C0%2C0%2C1%2C29%2C33ZM17%2C31a2%2C2%2C0%2C1%2C0%2C2%2C2A2%2C2%2C0%2C0%2C0%2C17%2C31ZM31%2C15v6h0l-7.58%2C4v0H13a2%2C2%2C0%2C0%2C0%2C2%2C2H29v2H15a4%2C4%2C0%2C0%2C1-4-4V15H7V13h6v2Zm-2%2C2H13v6H23l6-3.2Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-talk{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_talk%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M31%2C19c0%2C3-2%2C5.51-5%2C6.89l-9%2C4.78V26.27c-3.52-1.24-6-4-6-7.27%2C0-4.42%2C4.48-8%2C10-8s10%2C3.58%2C10%2C8m2%2C0c0-5.52-5.37-10-12-10S9%2C13.48%2C9%2C19c0%2C3.69%2C2.42%2C6.88%2C6%2C8.6V34l12.94-6.88h0A9.54%2C9.54%2C0%2C0%2C0%2C33%2C19%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-telephone{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_telephone%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M31.11%2C31.49l-3.75-7.06-4.54%2C0-3.64-6.84%2C2.49-3.69L18%2C6.76h0L14.44%2C8.64h0A6%2C6%2C0%2C0%2C0%2C12%2C16.76h0l7.51%2C14.13h0a6%2C6%2C0%2C0%2C0%2C8.11%2C2.48h0l3.53-1.88Zm-4.47.11h0a4%2C4%2C0%2C0%2C1-5.41-1.65L13.72%2C15.82a4%2C4%2C0%2C0%2C1%2C1.65-5.41h0l1.77-.94%2C2.24%2C4.21-2.53%2C3.75h0l4.79%2C9h4.5l2.27%2C4.26-1.76.94Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-tiles{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_tiles%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M13%2C9a4%2C4%2C0%2C0%2C0-4%2C3.83H9V19H19V9Zm4%2C8H11V13a2%2C2%2C0%2C0%2C1%2C2-2h4Zm16-4a4%2C4%2C0%2C0%2C0-4-4H23V19H33V13Zm-2%2C4H25V11h4a2%2C2%2C0%2C0%2C1%2C2%2C2ZM9%2C23v6a4%2C4%2C0%2C0%2C0%2C4%2C4h6V23Zm8%2C8H13a2%2C2%2C0%2C0%2C1-2-2V25h6Zm6-8V33h6a4%2C4%2C0%2C0%2C0%2C4-4V23Zm6%2C8H25V25h6v4A2%2C2%2C0%2C0%2C1%2C29%2C31Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-upload{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_upload%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C1A20%2C20%2C0%2C1%2C0%2C41%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C1%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M9%2C19V17a6%2C6%2C0%2C0%2C1%2C6-6H27a6%2C6%2C0%2C0%2C1%2C6%2C6v2H31V17a4%2C4%2C0%2C0%2C0-4-4H15a4%2C4%2C0%2C0%2C0-4%2C4v2Zm11%2C6v8h2V25h3.62L21%2C17l-4.62%2C8Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-unlock{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_unlock%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M21%2C15V13h0A6%2C6%2C0%2C0%2C0%2C9%2C13H9v4h2V13a4%2C4%2C0%2C0%2C1%2C8%2C0v2H15V25a6%2C6%2C0%2C0%2C0%2C6%2C6h8a6%2C6%2C0%2C0%2C0%2C6-6V15ZM33%2C25a4%2C4%2C0%2C0%2C1-4%2C4H21a4%2C4%2C0%2C0%2C1-2.88-1.21L33%2C19.88V25Zm0-7.39L17.14%2C26A4%2C4%2C0%2C0%2C1%2C17%2C25h0V17H33Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-wear{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_wear%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M21%2C16a5%2C5%2C0%2C1%2C0%2C5%2C5A5%2C5%2C0%2C0%2C0%2C21%2C16Zm0%2C8a3%2C3%2C0%2C1%2C1%2C3-3A3%2C3%2C0%2C0%2C1%2C21%2C24Zm11-1.27a11.06%2C11.06%2C0%2C0%2C0%2C0-3.46l3.13-1.8-4-6.93L28%2C12.34a11.08%2C11.08%2C0%2C0%2C0-3-1.73V7H17v3.57a11%2C11%2C0%2C0%2C0-1.59.74%2C10.82%2C10.82%2C0%2C0%2C0-1.43%2C1l-3.1-1.79-4%2C6.93L10%2C19.27a11.28%2C11.28%2C0%2C0%2C0%2C0%2C3.46l-3.12%2C1.8h0l4%2C6.93L14%2C29.66a11.16%2C11.16%2C0%2C0%2C0%2C3%2C1.73V35h8V31.43a9.8%2C9.8%2C0%2C0%2C0%2C3-1.75l3.09%2C1.79%2C4-6.93Zm-1.6%2C6-2.57-1.48A8.72%2C8.72%2C0%2C0%2C1%2C23%2C30v3H19V30a9.23%2C9.23%2C0%2C0%2C1-4.84-2.77l-2.55%2C1.47-2-3.46%2C2.55-1.47a9.26%2C9.26%2C0%2C0%2C1%2C0-5.58L9.61%2C16.73l2-3.46%2C2.56%2C1.48A8.74%2C8.74%2C0%2C0%2C1%2C19%2C12V9h4v3a9.26%2C9.26%2C0%2C0%2C1%2C4.85%2C2.78l2.55-1.47%2C2%2C3.46L29.85%2C18.2a9.23%2C9.23%2C0%2C0%2C1%2C0%2C5.58l2.57%2C1.48Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-website{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_website%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M9%2C11V27a6%2C6%2C0%2C0%2C0%2C6%2C6H27a6%2C6%2C0%2C0%2C0%2C6-6V11Zm6%2C4V13h2v2Zm-2-2v2H11V13ZM31%2C27a4%2C4%2C0%2C0%2C1-4%2C4H15a4%2C4%2C0%2C0%2C1-4-4V17H31Zm0-12H19V13H31ZM18.61%2C21l8%2C.28-4.24%2C6.78L21%2C25.5l-5.3%2C2.82-.94-1.77%2C5.3-2.82Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-x{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_x%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpolygon%20class%3D%22cls-2%22%20points%3D%2227.78%2013.63%2026.36%2012.22%2020%2018.59%2013.64%2012.22%2012.22%2013.64%2018.59%2020%2012.22%2026.36%2013.64%2027.78%2020%2021.41%2026.36%2027.78%2027.78%2026.36%2021.41%2020%2027.78%2013.63%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-ensurance{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3C!--%20Generator%3A%20Adobe%20Illustrator%2022.0.1%2C%20SVG%20Export%20Plug-In%20.%20SVG%20Version%3A%206.00%20Build%200%29%20%20--%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22Layer%5f1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2040%2040%22%20style%3D%22enable-background%3Anew%200%200%2040%2040%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill%3A%23002A54%3B%7D%0A%3C%2Fstyle%3E%0A%3Cg%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M23.3576%2C25.86871l-1.00403-1.00494c-0.19495-0.19501-0.51196-0.19501-0.70697%2C0%0A%09%09c-0.19501%2C0.19495-0.19501%2C0.51196%2C0%2C0.70697l1.00397%2C1.005c0.586%2C0.586%2C1.53601%2C0.586%2C2.12103%2C0l0.02197-0.02301l3.44299-3.58698%0A%09%09c0.19-0.19904%2C0.18402-0.51501-0.01495-0.70703c-0.19904-0.19098-0.51703-0.18396-0.70703%2C0.01501%0A%09%09c-2.29797%2C2.39398-3.44696%2C3.59198-3.45001%2C3.59497C23.86859%2C26.06372%2C23.55261%2C26.06372%2C23.3576%2C25.86871z%22%2F%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M26.08002%2C10.81073L18%2C8.08173c-0.32397-0.10999-0.677-0.10999-1.00098%2C0.00104l-8.00201%2C2.72699%0A%09%09C8.39899%2C11.01373%2C8%2C11.55573%2C8%2C12.16473v8.61798c0%2C2.854%2C1.396%2C5.54303%2C3.77301%2C7.263l4.82599%2C3.49506%0A%09%09c0.53302%2C0.38495%2C1.26801%2C0.38599%2C1.80298%2C0.00195c0.70404-0.57495%2C1.18604-0.96399%2C1.45703-1.177%0A%09%09c1.27802%2C1.00903%2C2.88696%2C1.61505%2C4.64099%2C1.61505c4.14301%2C0%2C7.5-3.35706%2C7.5-7.5c0-3.23303-2.04999-5.98004-4.91797-7.03406%0A%09%09v-5.27997C27.08203%2C11.5567%2C26.68103%2C11.01367%2C26.08002%2C10.81073z%20M17.80298%2C30.77673%0A%09%09c-0.17896%2C0.12799-0.42395%2C0.12701-0.60199-0.00098l-4.82501-3.49402C10.25%2C25.74274%2C9%2C23.33575%2C9%2C20.78271v-8.61798%0A%09%09c0-0.20398%2C0.133-0.38397%2C0.33301-0.45197l8.00098-2.72803c0.10803-0.03601%2C0.22601-0.03601%2C0.33405%2C0l8.07996%2C2.729%0A%09%09c0.20001%2C0.06799%2C0.33405%2C0.24896%2C0.33405%2C0.453v4.98401c-0.51105-0.10901-1.039-0.17004-1.58203-0.17004%0A%09%09c-0.20697%2C0-0.41101%2C0.01501-0.61401%2C0.03101v-2.35895c0-0.617-0.41199-1.16602-1.02301-1.362l-5.03296-1.62006%0A%09%09c-0.31799-0.10199-0.66302-0.09998-0.97803%2C0.00806l-4.73798%2C1.60699c-0.599%2C0.20398-0.99902%2C0.74597-0.99902%2C1.35498v5.96198%0A%09%09c0%2C1.55804%2C0.71899%2C3.03503%2C1.96503%2C4.03705l3.31598%2C2.66595c0.367%2C0.29504%2C0.84198%2C0.37903%2C1.28503%2C0.28503%0A%09%09c0.36096%2C0.789%2C0.85095%2C1.50598%2C1.448%2C2.11896L17.80298%2C30.77673z%20M17.328%2C26.67377c-0.10303-0.005-0.20502-0.03503-0.289-0.10205%0A%09%09l-3.31598-2.66595c-1.02002-0.82001-1.60803-2.02899-1.60803-3.30304v-5.96198c0-0.203%2C0.133-0.38403%2C0.33301-0.45203%0A%09%09l4.73798-1.60699c0.10504-0.03601%2C0.22003-0.03699%2C0.32605-0.00299l5.03296%2C1.62c0.203%2C0.065%2C0.341%2C0.24799%2C0.341%2C0.45404v2.50696%0A%09%09C19.52002%2C17.89874%2C17%2C20.89374%2C17%2C24.48077C17%2C25.24475%2C17.11603%2C25.98077%2C17.328%2C26.67377z%20M31%2C24.48077%0A%09%09c0%2C3.58997-2.90997%2C6.5-6.5%2C6.5s-6.5-2.91003-6.5-6.5c0-3.59003%2C2.90997-6.50006%2C6.5-6.50006S31%2C20.89075%2C31%2C24.48077z%22%2F%3E%0A%3C%2Fg%3E%0A%3C%2Fsvg%3E%0A);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-yen{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_yen%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpolygon%20class%3D%22cls-2%22%20points%3D%2221.01%2022%2025%2022%2025%2020%2021.01%2020%2021.01%2018.2%2030.57%2013.11%2029.63%2011.34%2019.98%2016.48%2010.33%2011.34%209.39%2013.11%2019.01%2018.23%2019.01%2020%2015%2020%2015%2022%2019.01%2022%2019.01%2024%2015%2024%2015%2026%2019.01%2026%2019.01%2032%2021.01%2032%2021.01%2026%2025%2026%2025%2024%2021.01%2024%2021.01%2022%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-location{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3C!--%20Generator%3A%20Adobe%20Illustrator%2022.0.1%2C%20SVG%20Export%20Plug-In%20.%20SVG%20Version%3A%206.00%20Build%200%29%20%20--%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22Layer%5f1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2040%2040%22%20style%3D%22enable-background%3Anew%200%200%2040%2040%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill%3A%23002A54%3B%7D%0A%3C%2Fstyle%3E%0A%3Cg%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M11%2C16.69958c0%2C3.10004%2C2.90002%2C8.10004%2C8.59998%2C15.10004c0.20001%2C0.20001%2C0.60004%2C0.20001%2C0.80005%2C0%0A%09%09C26.09998%2C24.8996%2C29%2C19.79962%2C29%2C16.69958c0-4.79999-4.09998-8.69995-9-8.69995S11%2C11.99963%2C11%2C16.69958z%20M28%2C16.69958%0A%09%09c0%2C2.70001-2.70001%2C7.5-8%2C14c-5.29999-6.5-8-11.19995-8-14c0-4.19995%2C3.70001-7.69995%2C8-7.69995S28%2C12.49963%2C28%2C16.69958z%22%2F%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M15%2C16.99963c0%2C2.79999%2C2.20001%2C5%2C5%2C5s5-2.20001%2C5-5c0-2.80005-2.20001-5-5-5S15%2C14.19958%2C15%2C16.99963z%0A%09%09%20M24%2C16.99963c0%2C2.20911-1.79083%2C4-4%2C4s-4-1.79089-4-4c0-2.20917%2C1.79083-4%2C4-4S24%2C14.79047%2C24%2C16.99963z%22%2F%3E%0A%3C%2Fg%3E%0A%3C%2Fsvg%3E%0A);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-service{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3C!--%20Generator%3A%20Adobe%20Illustrator%2022.0.1%2C%20SVG%20Export%20Plug-In%20.%20SVG%20Version%3A%206.00%20Build%200%29%20%20--%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22Layer%5f1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2040%2040%22%20style%3D%22enable-background%3Anew%200%200%2040%2040%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill%3A%23002A54%3B%7D%0A%3C%2Fstyle%3E%0A%3Cpath%20class%3D%22st0%22%20d%3D%22M23%2C26.99927h-4c-0.552%2C0-1%2C0.44696-1%2C1v2c0%2C0.55298%2C0.448%2C1%2C1%2C1h4c0.55298%2C0%2C1-0.44702%2C1-1v-0.51801%0A%09c0.16901-0.03705%2C0.32202-0.06903%2C0.40198-0.086c2.74805-0.60004%2C3.99805-1.146%2C4.73303-2.396H30c1.104%2C0%2C2-0.89606%2C2-2v-5%0A%09c0-1.104-0.896-2-2-2c0-5.164-4.271-9-9.75-9s-9.75%2C3.836-9.75%2C9H10c-1.104%2C0-2%2C0.896-2%2C2v5c0%2C1.10394%2C0.896%2C2%2C2%2C2h2%0A%09c0.552%2C0%2C1-0.44702%2C1-1v-7c0-0.552-0.448-1-1-1h-0.5c0-4.586%2C3.79999-8%2C8.75-8s8.75%2C3.414%2C8.75%2C8h-1c-0.55298%2C0-1%2C0.448-1%2C1v7%0A%09c0%2C0.51599%2C0.39502%2C0.92395%2C0.896%2C0.979c-0.63202%2C0.62-1.70599%2C1.00299-3.70697%2C1.43896%0A%09c-0.04303%2C0.01003-0.112%2C0.024-0.18903%2C0.04103v-0.45898C24%2C27.44623%2C23.55298%2C26.99927%2C23%2C26.99927z%20M23%2C29.75446%0A%09c0%2C0.13519-0.10962%2C0.24481-0.24481%2C0.24481h-3.51038C19.10962%2C29.99927%2C19%2C29.88965%2C19%2C29.75446v-1.51038%0A%09c0-0.13525%2C0.10962-0.24481%2C0.24481-0.24481h3.51038c0.13519%2C0%2C0.24481%2C0.10956%2C0.24481%2C0.24481V29.75446z%20M11.75519%2C18.99927%0A%09c0.13519%2C0%2C0.24481%2C0.10956%2C0.24481%2C0.24481v6.51038c0%2C0.13519-0.10962%2C0.24481-0.24481%2C0.24481h-1.51038%0A%09C9.55731%2C25.99927%2C9%2C25.44189%2C9%2C24.75446v-4.51038c0-0.6875%2C0.55731-1.24481%2C1.24481-1.24481H11.75519z%20M28%2C18.99927h2%0A%09c0.55298%2C0%2C1%2C0.448%2C1%2C1v5c0%2C0.55298-0.44702%2C1-1%2C1h-2V18.99927z%22%2F%3E%0A%3C%2Fsvg%3E%0A);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-pointer{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20version%3D%221.1%22%20id%3D%22Layer%5f1%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%2040%2040%22%20style%3D%22enable-background%3Anew%200%200%2040%2040%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill%3A%23002A54%3B%7D%0A%3C%2Fstyle%3E%0A%3Cpath%20class%3D%22st0%22%20d%3D%22M12.5%2C28.99963l4.20001%2C2.5c0.29999%2C0.09998%2C0.59998%2C0%2C0.70001-0.20001l4.79999-8.20001l3.89996%2C2.20001%20%20c0.40002%2C0.20001%2C0.80005%2C0%2C0.80005-0.40002l0.5-15.89996c0-0.30005-0.20001-0.5-0.40002-0.5c-0.09998%2C0-0.20001%2C0-0.29999%2C0.09998%20%20l-13.5%2C8.40002c-0.29999%2C0.19995-0.29999%2C0.69995%2C0%2C0.89996l3.89996%2C2.20001l-4.79999%2C8.20001%20%20C12.20001%2C28.59961%2C12.29999%2C28.8996%2C12.5%2C28.99963z%20M18.20001%2C20.09961c0.09998-0.29999%2C0-0.59998-0.20001-0.70001%20%20l-3.59998-2.09998l12-7.40002L26%2C23.99963l-3.59998-2.10004c-0.30005-0.09998-0.60004%2C0-0.70001%2C0.20001l-4.79999%2C8.20001l-3.5-2%20%20L18.20001%2C20.09961z%22%2F%3E%0A%3C%2Fsvg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-cardPin{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20version%3D%221.1%22%20id%3D%22Layer%5f1%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%2040%2040%22%20style%3D%22enable-background%3Anew%200%200%2040%2040%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill%3A%23002A54%3B%7D%0A%3C%2Fstyle%3E%0A%3Cg%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M11.5%2C21.99927h2c0.66699%2C0%2C0.66699-1%2C0-1h-2C10.83301%2C20.99927%2C10.83301%2C21.99927%2C11.5%2C21.99927z%22%2F%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M16.5%2C21.99927h2c0.66699%2C0%2C0.66699-1%2C0-1h-2C15.83301%2C20.99927%2C15.83301%2C21.99927%2C16.5%2C21.99927z%22%2F%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M26.5%2C21.99927h2c0.66699%2C0%2C0.66699-1%2C0-1h-2C25.83301%2C20.99927%2C25.83301%2C21.99927%2C26.5%2C21.99927z%22%2F%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M9.6496%2C10.99927c-0.914%2C0-1.65002%2C0.776-1.65002%2C1.71399v14.57196c0%2C0.93805%2C0.73602%2C1.71405%2C1.65002%2C1.71405%20%20%20h20.70001c0.91602%2C0%2C1.64996-0.776%2C1.64996-1.71405V12.71326c0-0.93799-0.73395-1.71399-1.64996-1.71399%20%20%20C30.34961%2C10.99927%2C9.6496%2C10.99927%2C9.6496%2C10.99927z%20M30.99957%2C27.28522c0%2C0.39801-0.29895%2C0.71405-0.64996%2C0.71405H9.6496%20%20%20c-0.34998%2C0-0.65002-0.31604-0.65002-0.71405V15.99927h22C30.99958%2C15.99927%2C30.99958%2C27.28522%2C30.99957%2C27.28522z%20%20%20%20M30.99957%2C12.71326v2.28601h-22v-2.28601c0-0.39801%2C0.30005-0.71399%2C0.65002-0.71399H30.3496%20%20%20C30.70062%2C11.99927%2C30.99957%2C12.31525%2C30.99957%2C12.71326z%22%2F%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M21.5%2C21.99927h2c0.66699%2C0%2C0.66699-1%2C0-1h-2C20.83301%2C20.99927%2C20.83301%2C21.99927%2C21.5%2C21.99927z%22%2F%3E%0A%3C%2Fg%3E%0A%3C%2Fsvg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-red-icon_X+.cbolui-icon-text,.cbolui-icon-green-checkmark+.cbolui-icon-text,.cbolui-icon-lg-red-error+.cbolui-icon-text{flex:1;-webkit-box-flex:1;-ms-flex:1;margin-top:20px}.icon-GreenCheck{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%0A%3Csvg%20width%3D%2220px%22%20height%3D%2220px%22%20viewBox%3D%220%200%2020%2020%22%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%3E%0A%20%20%20%20%3C%21--%20Generator%3A%20Sketch%2046.1%20%2844463%29%20-%20http%3A//www.bohemiancoding.com/sketch%20--%3E%0A%20%20%20%20%3Ctitle%3EIcon%3C/title%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C/desc%3E%0A%20%20%20%20%3Cdefs%3E%3C/defs%3E%0A%20%20%20%20%3Cg%20id%3D%22P1.-Banner-Alerts%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%221.1A_Desktop%22%20transform%3D%22translate%28-60.000000%2C%20-809.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Page-Level%22%20transform%3D%22translate%280.000000%2C%20213.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22White-Banner%22%20transform%3D%22translate%2820.000000%2C%20470.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Success-Banner%22%20transform%3D%22translate%280.000000%2C%20104.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icon%22%20transform%3D%22translate%2840.000000%2C%2022.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22Oval-5%22%20fill%3D%22%23006E0A%22%20cx%3D%2210%22%20cy%3D%2210%22%20r%3D%2210%22%3E%3C/circle%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpolygon%20id%3D%22Fill-4%22%20fill%3D%22%23FFFFFF%22%20points%3D%228.24403195%2012.0121714%205.68262639%209.50897143%204.28571429%2010.8737714%208.24403195%2014.7421714%2016.394286%206.79377143%2014.9969739%205.42857143%22%3E%3C/polygon%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%3C/g%3E%0A%3C/svg%3E);background-repeat:no-repeat;width:20px}.icon-RedAlert{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%0A%3Csvg%20width%3D%2220px%22%20height%3D%2220px%22%20viewBox%3D%220%200%2020%2020%22%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%3E%0A%20%20%20%20%3C%21--%20Generator%3A%20Sketch%2046.1%20%2844463%29%20-%20http%3A//www.bohemiancoding.com/sketch%20--%3E%0A%20%20%20%20%3Ctitle%3EIcon%3C/title%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C/desc%3E%0A%20%20%20%20%3Cdefs%3E%3C/defs%3E%0A%20%20%20%20%3Cg%20id%3D%22P1.-Banner-Alerts%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%221.1A_Desktop%22%20transform%3D%22translate%28-60.000000%2C%20-705.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Page-Level%22%20transform%3D%22translate%280.000000%2C%20213.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22White-Banner%22%20transform%3D%22translate%2820.000000%2C%20470.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Critical-Banner%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icon%22%20transform%3D%22translate%2840.000000%2C%2022.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22red-base%22%20fill%3D%22%23D60000%22%20cx%3D%2210%22%20cy%3D%2210%22%20r%3D%2210%22%3E%3C/circle%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M11.48%2C8.608%20L11.48%2C4%20L9.24%2C4%20L9.24%2C8.608%20L9.608%2C11.68%20L11.112%2C11.68%20L11.48%2C8.608%20Z%20M11.72%2C14.016%20C11.72%2C13.28%2011.096%2C12.656%2010.36%2C12.656%20C9.624%2C12.656%209%2C13.28%209%2C14.016%20C9%2C14.752%209.624%2C15.376%2010.36%2C15.376%20C11.096%2C15.376%2011.72%2C14.752%2011.72%2C14.016%20L11.72%2C14.016%20Z%22%20id%3D%22%21%22%20fill%3D%22%23FFFFFF%22%3E%3C/path%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%3C/g%3E%0A%3C/svg%3E);background-repeat:no-repeat;width:20px}.icon-BlueSpeech{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%0A%3Csvg%20width%3D%2216px%22%20height%3D%2216px%22%20viewBox%3D%220%200%2016%2016%22%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%3E%0A%20%20%20%20%3C%21--%20Generator%3A%20Sketch%2046.1%20%2844463%29%20-%20http%3A//www.bohemiancoding.com/sketch%20--%3E%0A%20%20%20%20%3Ctitle%3EIcon%3C/title%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C/desc%3E%0A%20%20%20%20%3Cdefs%3E%3C/defs%3E%0A%20%20%20%20%3Cg%20id%3D%22P1.-Banner-Alerts%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%221.1A_Desktop%22%20transform%3D%22translate%28-62.000000%2C%20-916.000000%29%22%20fill%3D%22%23056DAE%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Page-Level%22%20transform%3D%22translate%280.000000%2C%20213.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22White-Banner%22%20transform%3D%22translate%2820.000000%2C%20470.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Marketing-Banner%22%20transform%3D%22translate%280.000000%2C%20208.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icon%22%20transform%3D%22translate%2840.000000%2C%2022.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Alert-Bubble%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icon%22%20transform%3D%22translate%282.000000%2C%203.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Sq%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2216%22%20height%3D%2211%22%3E%3C/rect%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpolygon%20id%3D%22Tri%22%20points%3D%224%2011%2011%2011%204%2016%22%3E%3C/polygon%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%3C/g%3E%0A%3C/svg%3E);background-repeat:no-repeat;width:20px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: IconComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-icon', standalone: false, template: `
  <div class="cbolui-icon-wrapper" [attr.id]="idStr">

    <span class="iconClass"
      [ngClass]="[iconTypeClass]"
      [attr.id]="idStr + '-icon'"
      [title]="title"
    ></span>

    <span *ngIf="iconTextMessage"
      class="cbolui-icon-text {{isSROnly ? 'sr-only' : ''}}"
      [ngClass]="alertStatusColor"
      [attr.id]="idStr + '-iconText'"
      [innerHtml]="iconTextMessage"
    ></span>

    <span *ngIf="!iconTextMessage"
      class="cbolui-icon-text {{isSROnly ? 'sr-only' : ''}}"
      [ngClass]="alertStatusColor"
      [attr.id]="idStr + '-iconText'">
        <ng-content></ng-content>
    </span>

  </div>
  `, styles: [".cbolui-icon-globalSpriteBase{padding-right:7px;top:3px;font-size:20px;height:20px}.cbolui-icon-wrapper{padding:15px;margin-bottom:24px;border:1px solid transparent;border-radius:6px;display:flex;display:-webkit-flex}.cbolui-icon-wrapper .iconClass{margin-right:10px;padding-right:0!important;flex-shrink:0}.cbolui-icon-red{color:#d60000}.cbolui-icon-blue{color:#056dae;margin-top:5px}.cbolui-icon-orange{color:#cb6015}.cbolui-icon-green{color:#006e0a}.checkmark-icon{width:15px;height:10px;top:8px}.glyphicon-triangle-up,.glyphicon-triangle-down{margin-top:5px}.cbolui-icon-trash-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_trash%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M33%2C12H27a4%2C4%2C0%2C0%2C0-4-4H19a4%2C4%2C0%2C0%2C0-4%2C4H9v2h2V30a4%2C4%2C0%2C0%2C0%2C4%2C4H27a4%2C4%2C0%2C0%2C0%2C4-4V14h2ZM19%2C10h4a2%2C2%2C0%2C0%2C1%2C2%2C2H17A2%2C2%2C0%2C0%2C1%2C19%2C10ZM29%2C30a2%2C2%2C0%2C0%2C1-2%2C2H15a2%2C2%2C0%2C0%2C1-2-2V27.21L29%2C18.7Zm0-13.57L13%2C24.94V14H29Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-trash-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_trash%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M33%2C12H27a4%2C4%2C0%2C0%2C0-4-4H19a4%2C4%2C0%2C0%2C0-4%2C4H9v2h2V30a4%2C4%2C0%2C0%2C0%2C4%2C4H27a4%2C4%2C0%2C0%2C0%2C4-4V14h2ZM19%2C10h4a2%2C2%2C0%2C0%2C1%2C2%2C2H17A2%2C2%2C0%2C0%2C1%2C19%2C10ZM29%2C30a2%2C2%2C0%2C0%2C1-2%2C2H15a2%2C2%2C0%2C0%2C1-2-2V27.21L29%2C18.7Zm0-13.57L13%2C24.94V14H29Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-trash{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_trash%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M33%2C12H27a4%2C4%2C0%2C0%2C0-4-4H19a4%2C4%2C0%2C0%2C0-4%2C4H9v2h2V30a4%2C4%2C0%2C0%2C0%2C4%2C4H27a4%2C4%2C0%2C0%2C0%2C4-4V14h2ZM19%2C10h4a2%2C2%2C0%2C0%2C1%2C2%2C2H17A2%2C2%2C0%2C0%2C1%2C19%2C10ZM29%2C30a2%2C2%2C0%2C0%2C1-2%2C2H15a2%2C2%2C0%2C0%2C1-2-2V27.21L29%2C18.7Zm0-13.57L13%2C24.94V14H29Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-trash-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_trash%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M33%2C12H27a4%2C4%2C0%2C0%2C0-4-4H19a4%2C4%2C0%2C0%2C0-4%2C4H9v2h2V30a4%2C4%2C0%2C0%2C0%2C4%2C4H27a4%2C4%2C0%2C0%2C0%2C4-4V14h2ZM19%2C10h4a2%2C2%2C0%2C0%2C1%2C2%2C2H17A2%2C2%2C0%2C0%2C1%2C19%2C10ZM29%2C30a2%2C2%2C0%2C0%2C1-2%2C2H15a2%2C2%2C0%2C0%2C1-2-2V27.21L29%2C18.7Zm0-13.57L13%2C24.94V14H29Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-four-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2042%2042%22%20style%3D%22enable-background%3Anew%200%200%2042%2042%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text/css%22%3E%0A%09.st0%7Bfill%3A%23FFFFFF%3B%7D%0A%09.st1%7Bfill%3A%23002D72%3B%7D%0A%3C/style%3E%0A%3Cg%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M41%2C21c0%2C11-9%2C20-20%2C20C10%2C41%2C1%2C32%2C1%2C21S10%2C1%2C21%2C1C32%2C1%2C41%2C10%2C41%2C21%22/%3E%0A%09%3Cpolygon%20class%3D%22st1%22%20points%3D%2237%2C21%2029%2C16.4%2029%2C20%2022%2C20%2022%2C13%2025.6%2C13%2021%2C5%2016.4%2C13%2020%2C13%2020%2C20%2013%2C20%2013%2C16.4%205%2C21%2013%2C25.6%2013%2C22%20%0A%09%0920%2C22%2020%2C29%2016.4%2C29%2021%2C37%2025.6%2C29%2022%2C29%2022%2C22%2029%2C22%2029%2C25.6%20%09%22/%3E%0A%3C/g%3E%0A%3C/svg%3E%0A);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-arrowdown-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2042%2042%22%20style%3D%22enable-background%3Anew%200%200%2042%2042%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text/css%22%3E%0A%09.st0%7Bfill%3A%23FFFFFF%3B%7D%0A%09.st1%7Bfill%3A%23002D72%3B%7D%0A%3C/style%3E%0A%3Cg%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M41%2C21c0%2C11-9%2C20-20%2C20C10%2C41%2C1%2C32%2C1%2C21S10%2C1%2C21%2C1C32%2C1%2C41%2C10%2C41%2C21%22/%3E%0A%09%3Cpath%20class%3D%22st1%22%20d%3D%22M20%2C9v21.7c-0.2-0.1-0.4-0.3-0.6-0.5l-6.1-11.6l-1.8%2C0.9l5.7%2C10.8l0%2C0c0.6%2C1.5%2C2%2C2.6%2C3.7%2C2.6%0A%09%09c1.7%2C0%2C3.1-1%2C3.7-2.5l5.8-10.9l-1.8-0.9l-5.9%2C11c-0.2%2C0.4-0.5%2C0.8-0.9%2C1V9H20z%22/%3E%0A%3C/g%3E%0A%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-arrowleft-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_arrow_left%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C1%2C41%2C21%2C20%2C20%2C0%2C0%2C1%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M33%2C20H11.3a2%2C2%2C0%2C0%2C1%2C.5-.58l11.55-6.14-.94-1.77L11.64%2C17.24v0a4%2C4%2C0%2C0%2C0-.17%2C7.44l10.94%2C5.8.94-1.77-11-5.87a2%2C2%2C0%2C0%2C1-1-.86H33Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-arrowright-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_arrow_riwht%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C1A20%2C20%2C0%2C1%2C1%2C1%2C21%2C20%2C20%2C0%2C0%2C1%2C21%2C1%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M9%2C22H30.7a2%2C2%2C0%2C0%2C1-.5.58L18.65%2C28.72l.94%2C1.77%2C10.77-5.73v0a4%2C4%2C0%2C0%2C0%2C.16-7.44l-10.94-5.8-.94%2C1.77%2C11%2C5.87a2%2C2%2C0%2C0%2C1%2C1%2C.86H9Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-arrowup-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_arrow_up%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M1%2C21A20%2C20%2C0%2C1%2C1%2C21%2C41%2C20%2C20%2C0%2C0%2C1%2C1%2C21%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M22%2C33V11.3a2%2C2%2C0%2C0%2C1%2C.57.5l6.14%2C11.55%2C1.77-.94L24.77%2C11.64h0a4%2C4%2C0%2C0%2C0-7.44-.17l-5.8%2C10.94%2C1.77.94%2C5.87-11a2%2C2%2C0%2C0%2C1%2C.86-1V33Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-branch-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_branch%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C1A20%2C20%2C0%2C1%2C1%2C1%2C21%2C20%2C20%2C0%2C0%2C1%2C21%2C1%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M33%2C17V13h0a2%2C2%2C0%2C0%2C0-2-2H11a2%2C2%2C0%2C0%2C0-2%2C2H9v4h2V29H9v2H33V29H31V17Zm-2-4v2H11V13ZM21%2C21v8H17V21Zm8%2C8H23V19H15V29H13V17H29Zm-2-4H25V21h2v4Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-bubble-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_bubble%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M26.22%2C13.89C24.7%2C11%2C21.15%2C9%2C17%2C9%2C11.48%2C9%2C7%2C12.58%2C7%2C17c0%2C3%2C2%2C5.48%2C5%2C6.86v5.41l5.23-2.82a9%2C9%2C0%2C0%2C0%2C1.88%2C1.62l11.14%2C6V28.66c3-1.37%2C5-3.91%2C5-6.86C35.25%2C17.65%2C31.28%2C14.29%2C26.22%2C13.89ZM9%2C17c0-3.31%2C3.58-6%2C8-6s8%2C2.69%2C8%2C6a5.51%2C5.51%2C0%2C0%2C1-2.79%2C4.52L14%2C25.94V22.52C11.08%2C21.63%2C9%2C19.51%2C9%2C17ZM28.25%2C27.32v3.42L20%2C26.32a6.54%2C6.54%2C0%2C0%2C1-1-.83l4.13-2.22A7.51%2C7.51%2C0%2C0%2C0%2C27%2C17a6.44%2C6.44%2C0%2C0%2C0-.13-1c3.63.56%2C6.38%2C2.93%2C6.38%2C5.82C33.25%2C24.31%2C31.17%2C26.43%2C28.25%2C27.32Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-calendar-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_calendar%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M33%2C11H27V9H25v2H17V9H15v2H9V27a6%2C6%2C0%2C0%2C0%2C6%2C6H27a6%2C6%2C0%2C0%2C0%2C6-6h0ZM15%2C13v2h2V13h8v2h2V13h4v4H11V13ZM31%2C27a4%2C4%2C0%2C0%2C1-4%2C4H15a4%2C4%2C0%2C0%2C1-4-4V19H31Zm-4.74-6%2C.94%2C1.77-9.65%2C5.09-.94-1.77h0L15%2C22.93%2C16.77%2C22l1.65%2C3.16Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-chart-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_chart%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M17%2C29a4%2C4%2C0%2C0%2C1-4-3.81V23.09l4.94-2.63%2C1.81%2C3.4%2C11.61-6.18-.94-1.77-9.85%2C5.24-1.81-3.39L13%2C20.82V13H11V25.22A6%2C6%2C0%2C0%2C0%2C17%2C31H31V29Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-checkmark-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_checkmark%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpolygon%20class%3D%22cls-2%22%20points%3D%2231.9%2014.46%2015.3%2023.29%2011.77%2016.64%2010%2017.58%2014.46%2026%2032.84%2016.23%2031.9%2014.46%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-circle-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_circlearrows%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C1A20%2C20%2C0%2C1%2C1%2C1%2C21%2C20%2C20%2C0%2C0%2C1%2C21%2C1%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M31.45%2C26.81a12%2C12%2C0%2C0%2C1-21.16-.27l1.73-1a10%2C10%2C0%2C0%2C0%2C17.66.35l-3.21-1.7%2C7.84-4.9.32%2C9.23ZM26.59%2C10.41a12%2C12%2C0%2C0%2C0-16.16%2C4.85L7.37%2C13.62l.32%2C9.23L15.52%2C18l-3.32-1.77a10%2C10%2C0%2C0%2C1%2C17.67.32l1.73-1A11.94%2C11.94%2C0%2C0%2C0%2C26.59%2C10.41Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-creditCard-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_creditcard%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M21%2C23v2H11V23Zm14-8h0V27a4%2C4%2C0%2C0%2C1-4%2C4H11a4%2C4%2C0%2C0%2C1-4-4V15H7a4%2C4%2C0%2C0%2C1%2C4-4H31a4%2C4%2C0%2C0%2C1%2C4%2C4ZM11%2C29H21.44L33%2C22.85V19H9v8A2%2C2%2C0%2C0%2C0%2C11%2C29Zm22-2V25.12L25.7%2C29H31A2%2C2%2C0%2C0%2C0%2C33%2C27Zm0-12a2%2C2%2C0%2C0%2C0-2-2H11a2%2C2%2C0%2C0%2C0-2%2C2v2H33Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-currency-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_currency_bill%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M7%2C13V29H35V13Zm26%2C7.88L24.18%2C25.6A6.48%2C6.48%2C0%2C0%2C0%2C26%2C21c0-3.19-2.08-5.77-4.7-6v0H33ZM9%2C15h7.49L9%2C19Zm12%2C2c1.66%2C0%2C3%2C1.79%2C3%2C4s-1.34%2C4-3%2C4-3-1.79-3-4S19.34%2C17%2C21%2C17ZM9%2C21.22l8.5-4.5A6.61%2C6.61%2C0%2C0%2C0%2C16%2C21c0%2C3.24%2C2.14%2C5.86%2C4.82%2C6v0H9ZM25.84%2C27%2C33%2C23.18V27Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-docuarrow-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_docuarrow%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M11%2C9V33H24.13l5.09-2.67A4%2C4%2C0%2C0%2C0%2C31%2C27h0V9ZM27.73%2C28.85l-4%2C2.15H23V27h6A2%2C2%2C0%2C0%2C1%2C27.73%2C28.85ZM21%2C25v6H13V11H29v6H23V14l-7%2C4%2C7%2C4V19h6v6Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-docucheck-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_docucheck%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M11%2C9V33H24.14l5.08-2.7h0A4%2C4%2C0%2C0%2C0%2C31%2C27h0V9ZM29%2C27a2%2C2%2C0%2C0%2C1-1.27%2C1.85l-4%2C2.15H23V27Zm0-2H21v6H13V11H29ZM17.53%2C21.84%2C15%2C16.93%2C16.72%2C16l1.65%2C3.15L26.24%2C15l.94%2C1.77Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-document-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_document%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C1%2C41%2C21%2C20%2C20%2C0%2C0%2C1%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M11%2C9V33H24.13l5.08-2.7h0A4%2C4%2C0%2C0%2C0%2C31%2C27h0V9ZM29%2C27a2%2C2%2C0%2C0%2C1-1.27%2C1.85l-4%2C2.15H23V27Zm0-2H21v6H13V11H29ZM27%2C15H15V13H27ZM15%2C19V17h8v2Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-dollar-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_dollar%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M22.32%2C34.26H19.79v-3.8a9.09%2C9.09%2C0%2C0%2C1-5.15-2.56l-.18-.19%2C1.74-1.94.21.2a6.7%2C6.7%2C0%2C0%2C0%2C4.72%2C2.14c2.36%2C0%2C3.71-1%2C3.71-2.76%2C0-1.55-.95-2.34-4.23-3.52-3.74-1.34-5.51-2.5-5.51-5.51%2C0-2.6%2C1.75-4.37%2C4.7-4.78V7.74h2.53v3.76a8.53%2C8.53%2C0%2C0%2C1%2C4.62%2C2l.22.17-1.67%2C2-.21-.18A6.17%2C6.17%2C0%2C0%2C0%2C21%2C13.88c-2.14%2C0-3.31.82-3.31%2C2.31%2C0%2C1.27.4%2C2%2C4.2%2C3.33%2C4.25%2C1.53%2C5.54%2C2.87%2C5.54%2C5.72s-2%2C4.79-5.12%2C5.21Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-download-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_download%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M33%2C23v2a6%2C6%2C0%2C0%2C1-6%2C6H15a6%2C6%2C0%2C0%2C1-6-6V23h2v2a4%2C4%2C0%2C0%2C0%2C4%2C4H27a4%2C4%2C0%2C0%2C0%2C4-4V23ZM22%2C17V9H20v8H16.38L21%2C25l4.62-8Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-envelop-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_envelope%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M33%2C15h0V13H9V25a6%2C6%2C0%2C0%2C0%2C6%2C6H27a6%2C6%2C0%2C0%2C0%2C6-6V15ZM31%2C25a4%2C4%2C0%2C0%2C1-4%2C4H15a4%2C4%2C0%2C0%2C1-4-4h0V19.75l10%2C5.32%2C10-5.27Zm0-7.46L21%2C22.83%2C11%2C17.49V15H31Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-euro-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_euro%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M22%2C31c-3.13%2C0-5.75-3-6.64-7H21V22H15.07c0-.33-.07-.66-.07-1s0-.67.07-1H21V18H15.36c.89-4%2C3.52-7%2C6.64-7a6.26%2C6.26%2C0%2C0%2C1%2C5.09%2C3.16l1.73-.92C27.17%2C10.67%2C24.74%2C9%2C22%2C9c-4.2%2C0-7.71%2C3.83-8.71%2C9H11v2h2c0%2C.33%2C0%2C.66%2C0%2C1s0%2C.67%2C0%2C1H11v2h2.3c1%2C5.17%2C4.52%2C9%2C8.71%2C9%2C2.74%2C0%2C5.16-1.67%2C6.8-4.25l-1.71-.91A6.25%2C6.25%2C0%2C0%2C1%2C22%2C31Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-jbp-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_GBP%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M27.17%2C26.86a4%2C4%2C0%2C0%2C1-3.73%2C2.59%2C3.65%2C3.65%2C0%2C0%2C1-1.54-.37v0L19%2C27.56V21h6V19H19V15h0a4%2C4%2C0%2C0%2C1%2C4-4%2C3.94%2C3.94%2C0%2C0%2C1%2C2.56%2C1l1.88-1A6%2C6%2C0%2C0%2C0%2C17%2C15h0v4H15v2h2v6.29l-4%2C2.13.94%2C1.77%2C3.8-2%2C2.83%2C1.51a5.79%2C5.79%2C0%2C0%2C0%2C.52.28l.37.13a5.83%2C5.83%2C0%2C0%2C0%2C2%2C.38A6%2C6%2C0%2C0%2C0%2C29%2C27.8Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-info-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_info%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M23%2C13a2%2C2%2C0%2C1%2C1-2-2%2C2%2C2%2C0%2C0%2C1%2C2%2C2m12%2C8A14%2C14%2C0%2C1%2C0%2C21%2C35%2C14%2C14%2C0%2C0%2C0%2C35%2C21m2%2C0A16%2C16%2C0%2C1%2C1%2C21%2C5%2C16%2C16%2C0%2C0%2C1%2C37%2C21M23%2C17.09l-4.74%2C2.52.94%2C1.77%2C1.8-1V31h2Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-laptop-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_laptop%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M31%2C25V11H11V25H7a6%2C6%2C0%2C0%2C0%2C6%2C6H29a6%2C6%2C0%2C0%2C0%2C6-6ZM13%2C13h8.43L13%2C17.48Zm0%2C6.75L25.69%2C13H29V25H13ZM29%2C29H13a4%2C4%2C0%2C0%2C1-3.46-2H32.47A4%2C4%2C0%2C0%2C1%2C29%2C29Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-lightbulb-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_lightbulb%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C1%2C41%2C21%2C20%2C20%2C0%2C0%2C1%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M17%2C29h8v2H17Zm2%2C6h4V33H19Zm6.44-18.14-.94-1.77L21%2C17%2C17.5%2C15.1l-.94%2C1.77L21%2C19.22h0Zm-.44%2C7V27H17V23.87a8%2C8%2C0%2C1%2C1%2C8%2C0ZM27%2C17a6%2C6%2C0%2C1%2C0-8%2C5.63V25h4V22.63A6%2C6%2C0%2C0%2C0%2C27%2C17Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-list-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_list%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M15%2C11H31v2H15Zm0%2C14H31V23H15Zm0%2C6H31V29H15Zm0-12H31V17H15Zm-3-6a1%2C1%2C0%2C1%2C0-1-1%2C1%2C1%2C0%2C0%2C0%2C1%2C1m0%2C12a1%2C1%2C0%2C1%2C0-1-1%2C1%2C1%2C0%2C0%2C0%2C1%2C1m0-6a1%2C1%2C0%2C1%2C0-1-1%2C1%2C1%2C0%2C0%2C0%2C1%2C1m0%2C12a1%2C1%2C0%2C1%2C0-1-1%2C1%2C1%2C0%2C0%2C0%2C1%2C1%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-lock-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_lock%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M27%2C15V13h0a6%2C6%2C0%2C1%2C0-12%2C0v2H11v2h0v8a6%2C6%2C0%2C0%2C0%2C6%2C6h8a6%2C6%2C0%2C0%2C0%2C6-6V15ZM17%2C13a4%2C4%2C0%2C1%2C1%2C8%2C0h0v2H17ZM29%2C25a4%2C4%2C0%2C0%2C1-4%2C4H17a4%2C4%2C0%2C0%2C1-2.89-1.23L29%2C19.88Zm0-7.39L13.14%2C26A3.87%2C3.87%2C0%2C0%2C1%2C13%2C25V17H29Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-mapping-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_mappin%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M29%2C17c0%2C4.73-8%2C14.9-8%2C14.9S13%2C21.73%2C13%2C17a7.81%2C7.81%2C0%2C0%2C1%2C8-8%2C7.81%2C7.81%2C0%2C0%2C1%2C8%2C8m2%2C0a10%2C10%2C0%2C0%2C0-20%2C0c0%2C5.52%2C10%2C18%2C10%2C18S31%2C22.52%2C31%2C17m-6%2C0a4%2C4%2C0%2C1%2C1-4-4%2C4%2C4%2C0%2C0%2C1%2C4%2C4m2%2C0a6%2C6%2C0%2C1%2C0-6%2C6%2C6%2C6%2C0%2C0%2C0%2C6-6%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-menu-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_menu%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M11%2C15H31v2H11Zm0%2C12H31V25H11Zm0-5H31V20H11Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-minus-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_minus%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpolygon%20class%3D%22cls-2%22%20points%3D%2210%2021%2029%2021%2030%2021%2030%2019%2010%2019%2010%2021%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-mobile-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%0A%3Csvg%20width%3D%2240px%22%20height%3D%2240px%22%20viewBox%3D%220%200%2040%2040%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%0A%20%20%20%20%3C!--%20Generator%3A%20Sketch%2053.1%20%2872631%29%20-%20https%3A%2F%2Fsketchapp.com%20--%3E%0A%20%20%20%20%3Ctitle%3E055-mobile-white-circle%3C%2Ftitle%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%0A%20%20%20%20%3Cdefs%3E%0A%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22path-1%22%20cx%3D%2219%22%20cy%3D%2219%22%20r%3D%2219%22%3E%3C%2Fcircle%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M7%2C5%20L7%2C3.5%20C7%2C2.671%207.671%2C2%208.5%2C2%20L17.5%2C2%20C18.328%2C2%2019%2C2.671%2019%2C3.5%20L19%2C5%20L7%2C5%20Z%20M7%2C20%20L19%2C20%20L19%2C6%20L7%2C6%20L7%2C20%20Z%20M19%2C22.5%20C19%2C23.328%2018.328%2C24%2017.5%2C24%20L8.5%2C24%20C7.671%2C24%207%2C23.328%207%2C22.5%20L7%2C21%20L19%2C21%20L19%2C22.5%20Z%20M17.5%2C1%20L8.5%2C1%20C7.119%2C1%206%2C2.119%206%2C3.5%20L6%2C5%20L6%2C6%20L6%2C20%20L6%2C21%20L6%2C22.5%20C6%2C23.881%207.119%2C25%208.5%2C25%20L17.5%2C25%20C18.881%2C25%2020%2C23.881%2020%2C22.5%20L20%2C21%20L20%2C20%20L20%2C6%20L20%2C5%20L20%2C3.5%20C20%2C2.119%2018.881%2C1%2017.5%2C1%20L17.5%2C1%20Z%22%20id%3D%22path-3%22%3E%3C%2Fpath%3E%0A%20%20%20%20%3C%2Fdefs%3E%0A%20%20%20%20%3Cg%20id%3D%22Symbols%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%2299-icon-template%2F01-template%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%2299-icon-template%2F02-circle%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Circle%22%20transform%3D%22translate%281.000000%2C%201.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-2%22%20fill%3D%22white%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fmask%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Mask%22%20fill-rule%3D%22nonzero%22%3E%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22color%2Fwhite%22%20mask%3D%22url%28%23mask-2%29%22%20fill%3D%22%23FFFFFF%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%28-1.000000%2C%20-1.000000%29%22%20id%3D%22Color-%2F-White%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20x%3D%220%22%20y%3D%220%22%20width%3D%2240%22%20height%3D%2240%22%3E%3C%2Frect%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%2212-mobile%2F055-mobile%22%20transform%3D%22translate%287.000000%2C%207.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-4%22%20fill%3D%22white%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-3%22%3E%3C%2Fuse%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fmask%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20id%3D%22Mask%22%20fill%3D%22%23046EAE%22%20fill-rule%3D%22evenodd%22%20xlink%3Ahref%3D%22%23path-3%22%3E%3C%2Fuse%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22color%2Fb1%22%20mask%3D%22url%28%23mask-4%29%22%20fill%3D%22%23002A54%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Color-%2F-B1%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2226%22%20height%3D%2226%22%3E%3C%2Frect%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3C%2Fg%3E%0A%3C%2Fsvg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-pencil-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_pencil%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M27%2C25.89l2-1.06V29a4%2C4%2C0%2C0%2C1-4%2C4H13a4%2C4%2C0%2C0%2C1-4-4V13a4%2C4%2C0%2C0%2C1%2C4-4H25a4%2C4%2C0%2C0%2C1%2C3.86%2C3.31L27%2C13.3V13a2%2C2%2C0%2C0%2C0-2-2H13a2%2C2%2C0%2C0%2C0-2%2C2V29a2%2C2%2C0%2C0%2C0%2C2%2C2H25a2%2C2%2C0%2C0%2C0%2C2-2Zm11.14-8L20%2C27.51H14.1l-1-1.88%2C3.25-4.82%2C0-.06L34.55%2C11.1ZM19.91%2C21.14l1.72%2C3.24%2C9.25-4.92-1.72-3.24Zm-.4%2C4.37.36-.19-1.72-3.24-.36.19L15.6%2C25.51ZM35.44%2C17%2C33.72%2C13.8l-2.8%2C1.49%2C1.72%2C3.24Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-people-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_people%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M28%2C19a5%2C5%2C0%2C1%2C0-5-5A5%2C5%2C0%2C0%2C0%2C28%2C19Zm0-8a3%2C3%2C0%2C1%2C1-3%2C3A3%2C3%2C0%2C0%2C1%2C28%2C11ZM14%2C19a5%2C5%2C0%2C1%2C0-5-5A5%2C5%2C0%2C0%2C0%2C14%2C19Zm0-8a3%2C3%2C0%2C1%2C1-3%2C3A3%2C3%2C0%2C0%2C1%2C14%2C11Zm.77%2C10.43A3.9%2C3.9%2C0%2C0%2C0%2C13%2C21a4%2C4%2C0%2C0%2C0-4%2C4H9v8H21V24.72l-6.19-3.29ZM19%2C31H11V25h0a2%2C2%2C0%2C0%2C1%2C2-2%2C3.51%2C3.51%2C0%2C0%2C1%2C1%2C.27l5%2C2.66Zm14-6h0v8H23V31h8V25a2%2C2%2C0%2C0%2C0-2-2%2C2%2C2%2C0%2C0%2C0-1%2C.3v0l-5%2C2.66V23.66l4.19-2.23A7.37%2C7.37%2C0%2C0%2C1%2C29%2C21%2C4%2C4%2C0%2C0%2C1%2C33%2C25Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-piggybank-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_piggybank%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C1%2C41%2C21%2C20%2C20%2C0%2C0%2C1%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M25.74%2C18.37A5.55%2C5.55%2C0%2C0%2C0%2C22%2C17a5.62%2C5.62%2C0%2C0%2C0-3.62%2C1.25l-1.83-1a7.66%2C7.66%2C0%2C0%2C1%2C11%2C.12ZM32.36%2C17A7.5%2C7.5%2C0%2C0%2C1%2C33%2C20a8.38%2C8.38%2C0%2C0%2C1-4%2C6.87V31H15V26.87A9.22%2C9.22%2C0%2C0%2C1%2C11.7%2C23H9V17h2.72A8.41%2C8.41%2C0%2C0%2C1%2C13%2C15V9h2l4.36%2C2.28A12.69%2C12.69%2C0%2C0%2C1%2C22%2C11a11.68%2C11.68%2C0%2C0%2C1%2C9.36%2C4.28l1.4-.74.94%2C1.76ZM31%2C20c0-3.87-4-7-9-7a11.24%2C11.24%2C0%2C0%2C0-2.88.39L15%2C11.26v4.37A6.39%2C6.39%2C0%2C0%2C0%2C13.13%2C19H11v2h2.13A7.12%2C7.12%2C0%2C0%2C0%2C17%2C25.76V29h4V27h2v2h4V25.76C29.36%2C24.5%2C31%2C22.39%2C31%2C20Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-playbutton-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_play_button%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M29%2C11H13a6%2C6%2C0%2C0%2C0-6%2C6v8a6%2C6%2C0%2C0%2C0%2C6%2C6H29a6%2C6%2C0%2C0%2C0%2C6-6V17A6%2C6%2C0%2C0%2C0%2C29%2C11Zm4%2C14.19A4%2C4%2C0%2C0%2C1%2C29.2%2C29H12.81A4%2C4%2C0%2C0%2C1%2C9%2C25.19V16.81A4%2C4%2C0%2C0%2C1%2C12.81%2C13H29.2A4%2C4%2C0%2C0%2C1%2C33%2C16.81ZM18%2C26.34a1%2C1%2C0%2C0%2C1-1-1V16.66a1%2C1%2C0%2C0%2C1%2C.48-.86%2C1%2C1%2C0%2C0%2C1%2C1%2C0l8.17%2C4.33a1%2C1%2C0%2C0%2C1%2C0%2C1.77l-8.17%2C4.34A1%2C1%2C0%2C0%2C1%2C18%2C26.34Zm1-8v5.35L24%2C21Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-plus-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_plus%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpolygon%20class%3D%22cls-2%22%20points%3D%2230%2019%2021%2019%2021%2010%2019%2010%2019%2019%2010%2019%2010%2021%2019%2021%2019%2030%2021%2030%2021%2021%2030%2021%2030%2019%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-print-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_print%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M29%2C19h2v2H29Zm6%2C0v8H29v4H13V27H7V19a4%2C4%2C0%2C0%2C1%2C4-4h2V9H29v6h2A4%2C4%2C0%2C0%2C1%2C35%2C19ZM15%2C15H27V11H15Zm0%2C14H27V23H15Zm18-8V19a2%2C2%2C0%2C0%2C0-2-2H11a2%2C2%2C0%2C0%2C0-2%2C2v6h4V21H29v4h4Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-profile-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_profile%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M25%2C17a4%2C4%2C0%2C1%2C1-4-4%2C4%2C4%2C0%2C0%2C1%2C4%2C4m2%2C0a6%2C6%2C0%2C1%2C0-6%2C6%2C6%2C6%2C0%2C0%2C0%2C6-6m-6%2C7.39L9.36%2C30.58l.94%2C1.77L21%2C26.66l10.7%2C5.69.94-1.77Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-search-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_search%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M23%2C9a8%2C8%2C0%2C0%2C0-4.6%2C14.53L13%2C33.7l1.77.94%2C5.41-10.18A8%2C8%2C0%2C1%2C0%2C23%2C9Zm0%2C14a6%2C6%2C0%2C1%2C1%2C6-6A6%2C6%2C0%2C0%2C1%2C23%2C23Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-shopping-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_shopping_cart%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M41%2C21A20%2C20%2C0%2C1%2C1%2C21%2C1%2C20%2C20%2C0%2C0%2C1%2C41%2C21%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M29%2C33a2%2C2%2C0%2C1%2C1-2-2A2%2C2%2C0%2C0%2C1%2C29%2C33ZM17%2C31a2%2C2%2C0%2C1%2C0%2C2%2C2A2%2C2%2C0%2C0%2C0%2C17%2C31ZM31%2C15v6h0l-7.58%2C4v0H13a2%2C2%2C0%2C0%2C0%2C2%2C2H29v2H15a4%2C4%2C0%2C0%2C1-4-4V15H7V13h6v2Zm-2%2C2H13v6H23l6-3.2Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-talk-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_talk%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M31%2C19c0%2C3-2%2C5.51-5%2C6.89l-9%2C4.78V26.27c-3.52-1.24-6-4-6-7.27%2C0-4.42%2C4.48-8%2C10-8s10%2C3.58%2C10%2C8m2%2C0c0-5.52-5.37-10-12-10S9%2C13.48%2C9%2C19c0%2C3.69%2C2.42%2C6.88%2C6%2C8.6V34l12.94-6.88h0A9.54%2C9.54%2C0%2C0%2C0%2C33%2C19%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-telephone-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_telephone%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M31.11%2C31.49l-3.75-7.06-4.54%2C0-3.64-6.84%2C2.49-3.69L18%2C6.76h0L14.44%2C8.64h0A6%2C6%2C0%2C0%2C0%2C12%2C16.76h0l7.51%2C14.13h0a6%2C6%2C0%2C0%2C0%2C8.11%2C2.48h0l3.53-1.88Zm-4.47.11h0a4%2C4%2C0%2C0%2C1-5.41-1.65L13.72%2C15.82a4%2C4%2C0%2C0%2C1%2C1.65-5.41h0l1.77-.94%2C2.24%2C4.21-2.53%2C3.75h0l4.79%2C9h4.5l2.27%2C4.26-1.76.94Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-tiles-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_tiles%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M13%2C9a4%2C4%2C0%2C0%2C0-4%2C3.83H9V19H19V9Zm4%2C8H11V13a2%2C2%2C0%2C0%2C1%2C2-2h4Zm16-4a4%2C4%2C0%2C0%2C0-4-4H23V19H33V13Zm-2%2C4H25V11h4a2%2C2%2C0%2C0%2C1%2C2%2C2ZM9%2C23v6a4%2C4%2C0%2C0%2C0%2C4%2C4h6V23Zm8%2C8H13a2%2C2%2C0%2C0%2C1-2-2V25h6Zm6-8V33h6a4%2C4%2C0%2C0%2C0%2C4-4V23Zm6%2C8H25V25h6v4A2%2C2%2C0%2C0%2C1%2C29%2C31Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-upload-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_upload%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C1A20%2C20%2C0%2C1%2C0%2C41%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C1%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M9%2C19V17a6%2C6%2C0%2C0%2C1%2C6-6H27a6%2C6%2C0%2C0%2C1%2C6%2C6v2H31V17a4%2C4%2C0%2C0%2C0-4-4H15a4%2C4%2C0%2C0%2C0-4%2C4v2Zm11%2C6v8h2V25h3.62L21%2C17l-4.62%2C8Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-unlock-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_unlock%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M21%2C15V13h0A6%2C6%2C0%2C0%2C0%2C9%2C13H9v4h2V13a4%2C4%2C0%2C0%2C1%2C8%2C0v2H15V25a6%2C6%2C0%2C0%2C0%2C6%2C6h8a6%2C6%2C0%2C0%2C0%2C6-6V15ZM33%2C25a4%2C4%2C0%2C0%2C1-4%2C4H21a4%2C4%2C0%2C0%2C1-2.88-1.21L33%2C19.88V25Zm0-7.39L17.14%2C26A4%2C4%2C0%2C0%2C1%2C17%2C25h0V17H33Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-wear-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_wear%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M21%2C16a5%2C5%2C0%2C1%2C0%2C5%2C5A5%2C5%2C0%2C0%2C0%2C21%2C16Zm0%2C8a3%2C3%2C0%2C1%2C1%2C3-3A3%2C3%2C0%2C0%2C1%2C21%2C24Zm11-1.27a11.06%2C11.06%2C0%2C0%2C0%2C0-3.46l3.13-1.8-4-6.93L28%2C12.34a11.08%2C11.08%2C0%2C0%2C0-3-1.73V7H17v3.57a11%2C11%2C0%2C0%2C0-1.59.74%2C10.82%2C10.82%2C0%2C0%2C0-1.43%2C1l-3.1-1.79-4%2C6.93L10%2C19.27a11.28%2C11.28%2C0%2C0%2C0%2C0%2C3.46l-3.12%2C1.8h0l4%2C6.93L14%2C29.66a11.16%2C11.16%2C0%2C0%2C0%2C3%2C1.73V35h8V31.43a9.8%2C9.8%2C0%2C0%2C0%2C3-1.75l3.09%2C1.79%2C4-6.93Zm-1.6%2C6-2.57-1.48A8.72%2C8.72%2C0%2C0%2C1%2C23%2C30v3H19V30a9.23%2C9.23%2C0%2C0%2C1-4.84-2.77l-2.55%2C1.47-2-3.46%2C2.55-1.47a9.26%2C9.26%2C0%2C0%2C1%2C0-5.58L9.61%2C16.73l2-3.46%2C2.56%2C1.48A8.74%2C8.74%2C0%2C0%2C1%2C19%2C12V9h4v3a9.26%2C9.26%2C0%2C0%2C1%2C4.85%2C2.78l2.55-1.47%2C2%2C3.46L29.85%2C18.2a9.23%2C9.23%2C0%2C0%2C1%2C0%2C5.58l2.57%2C1.48Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-website-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_website%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M9%2C11V27a6%2C6%2C0%2C0%2C0%2C6%2C6H27a6%2C6%2C0%2C0%2C0%2C6-6V11Zm6%2C4V13h2v2Zm-2-2v2H11V13ZM31%2C27a4%2C4%2C0%2C0%2C1-4%2C4H15a4%2C4%2C0%2C0%2C1-4-4V17H31Zm0-12H19V13H31ZM18.61%2C21l8%2C.28-4.24%2C6.78L21%2C25.5l-5.3%2C2.82-.94-1.77%2C5.3-2.82Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-x-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_x%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpolygon%20class%3D%22cls-2%22%20points%3D%2227.78%2013.63%2026.36%2012.22%2020%2018.59%2013.64%2012.22%2012.22%2013.64%2018.59%2020%2012.22%2026.36%2013.64%2027.78%2020%2021.41%2026.36%2027.78%2027.78%2026.36%2021.41%2020%2027.78%2013.63%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-yen-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_w_rgb_yen%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpolygon%20class%3D%22cls-2%22%20points%3D%2221.01%2022%2025%2022%2025%2020%2021.01%2020%2021.01%2018.2%2030.57%2013.11%2029.63%2011.34%2019.98%2016.48%2010.33%2011.34%209.39%2013.11%2019.01%2018.23%2019.01%2020%2015%2020%2015%2022%2019.01%2022%2019.01%2024%2015%2024%2015%2026%2019.01%2026%2019.01%2032%2021.01%2032%2021.01%2026%2025%2026%2025%2024%2021.01%2024%2021.01%2022%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-location-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%0A%3Csvg%20width%3D%2240px%22%20height%3D%2240px%22%20viewBox%3D%220%200%2040%2040%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%0A%20%20%20%20%3C!--%20Generator%3A%20Sketch%2053.1%20%2872631%29%20-%20https%3A%2F%2Fsketchapp.com%20--%3E%0A%20%20%20%20%3Ctitle%3E050-location-white-circle%3C%2Ftitle%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%0A%20%20%20%20%3Cdefs%3E%0A%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22path-1%22%20cx%3D%2219%22%20cy%3D%2219%22%20r%3D%2219%22%3E%3C%2Fcircle%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M13.3858873%2C24.8179481%20C13.1858874%2C25.060684%2012.8141126%2C25.060684%2012.6141127%2C24.8179481%20C6.87428896%2C17.8516382%204%2C12.8371876%204%2C9.6710003%20C4%2C4.92164995%208.12532592%2C1%2013%2C1%20C17.8746741%2C1%2022%2C4.92164995%2022%2C9.6710003%20C22%2C12.8371876%2019.125711%2C17.8516382%2013.3858873%2C24.8179481%20Z%20M21%2C9.6710003%20C21%2C5.48557602%2017.3333961%2C2%2013%2C2%20C8.66660392%2C2%205%2C5.48557602%205%2C9.6710003%20C5%2C12.4554419%207.6639476%2C17.1677197%2013%2C23.7113019%20C18.3360524%2C17.1677197%2021%2C12.4554419%2021%2C9.6710003%20Z%20M13%2C15%20C10.2385763%2C15%208%2C12.7614237%208%2C10%20C8%2C7.23857625%2010.2385763%2C5%2013%2C5%20C15.7614237%2C5%2018%2C7.23857625%2018%2C10%20C18%2C12.7614237%2015.7614237%2C15%2013%2C15%20Z%20M13%2C14%20C15.209139%2C14%2017%2C12.209139%2017%2C10%20C17%2C7.790861%2015.209139%2C6%2013%2C6%20C10.790861%2C6%209%2C7.790861%209%2C10%20C9%2C12.209139%2010.790861%2C14%2013%2C14%20Z%22%20id%3D%22path-3%22%3E%3C%2Fpath%3E%0A%20%20%20%20%3C%2Fdefs%3E%0A%20%20%20%20%3Cg%20id%3D%22Symbols%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%2299-icon-template%2F01-template%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%2299-icon-template%2F02-circle%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Circle%22%20transform%3D%22translate%281.000000%2C%201.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-2%22%20fill%3D%22white%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fmask%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Mask%22%20fill-rule%3D%22nonzero%22%3E%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22color%2Fwhite%22%20mask%3D%22url%28%23mask-2%29%22%20fill%3D%22%23FFFFFF%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%28-1.000000%2C%20-1.000000%29%22%20id%3D%22Color-%2F-White%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20x%3D%220%22%20y%3D%220%22%20width%3D%2240%22%20height%3D%2240%22%3E%3C%2Frect%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%2201-direction%2F050-location%22%20transform%3D%22translate%287.000000%2C%207.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-4%22%20fill%3D%22white%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-3%22%3E%3C%2Fuse%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fmask%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20id%3D%22icon%22%20fill%3D%22%23056DAE%22%20fill-rule%3D%22evenodd%22%20xlink%3Ahref%3D%22%23path-3%22%3E%3C%2Fuse%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22color%2Fb1%22%20mask%3D%22url%28%23mask-4%29%22%20fill%3D%22%23002A54%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Color-%2F-B1%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2226%22%20height%3D%2226%22%3E%3C%2Frect%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3C%2Fg%3E%0A%3C%2Fsvg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-ensurance-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%0A%3Csvg%20width%3D%2240px%22%20height%3D%2240px%22%20viewBox%3D%220%200%2040%2040%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%0A%20%20%20%20%3C!--%20Generator%3A%20Sketch%2053.1%20%2872631%29%20-%20https%3A%2F%2Fsketchapp.com%20--%3E%0A%20%20%20%20%3Ctitle%3E247-insurance-check-white-circle%3C%2Ftitle%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%0A%20%20%20%20%3Cdefs%3E%0A%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22path-1%22%20cx%3D%2219%22%20cy%3D%2219%22%20r%3D%2219%22%3E%3C%2Fcircle%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M20.082%2C10.4475%20L20.082%2C5.1675%20C20.082%2C4.5575%2019.681%2C4.0145%2019.08%2C3.8115%20L11%2C1.0825%20C10.676%2C0.9725%2010.323%2C0.9725%209.999%2C1.0835%20L1.997%2C3.8105%20C1.399%2C4.0145%201%2C4.5565%201%2C5.1655%20L1%2C13.7835%20C1%2C16.6375%202.396%2C19.3265%204.773%2C21.0465%20L9.599%2C24.5415%20C10.132%2C24.9265%2010.867%2C24.9275%2011.402%2C24.5435%20C12.106%2C23.9685%2012.588%2C23.5795%2012.859%2C23.3665%20C14.137%2C24.3755%2015.746%2C24.9815%2017.5%2C24.9815%20C21.643%2C24.9815%2025%2C21.6245%2025%2C17.4815%20C25%2C14.2485%2022.95%2C11.5015%2020.082%2C10.4475%20L20.082%2C10.4475%20Z%20M17.5%2C23.9815%20C13.91%2C23.9815%2011%2C21.0715%2011%2C17.4815%20C11%2C13.8915%2013.91%2C10.9815%2017.5%2C10.9815%20C21.09%2C10.9815%2024%2C13.8915%2024%2C17.4815%20C24%2C21.0715%2021.09%2C23.9815%2017.5%2C23.9815%20L17.5%2C23.9815%20Z%20M10%2C17.4815%20C10%2C18.2455%2010.116%2C18.9815%2010.328%2C19.6745%20C10.225%2C19.6695%2010.123%2C19.6395%2010.039%2C19.5725%20L6.723%2C16.9065%20C5.703%2C16.0865%205.115%2C14.8775%205.115%2C13.6035%20L5.115%2C7.6415%20C5.115%2C7.4385%205.248%2C7.2575%205.448%2C7.1895%20L10.186%2C5.5825%20C10.291%2C5.5465%2010.406%2C5.5455%2010.512%2C5.5795%20L15.545%2C7.1995%20C15.748%2C7.2645%2015.886%2C7.4475%2015.886%2C7.6535%20L15.886%2C10.1605%20C12.52%2C10.8995%2010%2C13.8945%2010%2C17.4815%20L10%2C17.4815%20Z%20M10.803%2C23.7775%20C10.624%2C23.9055%2010.379%2C23.9045%2010.201%2C23.7765%20L5.376%2C20.2825%20C3.25%2C18.7435%202%2C16.3365%202%2C13.7835%20L2%2C5.1655%20C2%2C4.9615%202.133%2C4.7815%202.333%2C4.7135%20L10.334%2C1.9855%20C10.442%2C1.9495%2010.56%2C1.9495%2010.668%2C1.9855%20L18.748%2C4.7145%20C18.948%2C4.7825%2019.082%2C4.9635%2019.082%2C5.1675%20L19.082%2C10.1515%20C18.571%2C10.0425%2018.043%2C9.9815%2017.5%2C9.9815%20C17.293%2C9.9815%2017.089%2C9.9965%2016.886%2C10.0125%20L16.886%2C7.6535%20C16.886%2C7.0365%2016.474%2C6.4875%2015.863%2C6.2915%20L10.83%2C4.6715%20C10.512%2C4.5695%2010.167%2C4.5715%209.852%2C4.6795%20L5.114%2C6.2865%20C4.515%2C6.4905%204.115%2C7.0325%204.115%2C7.6415%20L4.115%2C13.6035%20C4.115%2C15.1615%204.834%2C16.6385%206.08%2C17.6405%20L9.396%2C20.3065%20C9.763%2C20.6015%2010.238%2C20.6855%2010.681%2C20.5915%20C11.042%2C21.3805%2011.532%2C22.0975%2012.129%2C22.7105%20L10.803%2C23.7775%20Z%20M20.5146%2C15.2745%20C20.7046%2C15.0755%2021.0226%2C15.0685%2021.2216%2C15.2595%20C21.4206%2C15.4515%2021.4266%2C15.7675%2021.2366%2C15.9665%20L17.7936%2C19.5535%20L17.7716%2C19.5765%20C17.1866%2C20.1625%2016.2366%2C20.1625%2015.6506%2C19.5765%20L14.6466%2C18.5715%20C14.4516%2C18.3765%2014.4516%2C18.0595%2014.6466%2C17.8645%20C14.8416%2C17.6695%2015.1586%2C17.6695%2015.3536%2C17.8645%20L16.3576%2C18.8695%20C16.5526%2C19.0645%2016.8686%2C19.0645%2017.0646%2C18.8695%20C17.0676%2C18.8665%2018.2166%2C17.6685%2020.5146%2C15.2745%20Z%22%20id%3D%22path-3%22%3E%3C%2Fpath%3E%0A%20%20%20%20%3C%2Fdefs%3E%0A%20%20%20%20%3Cg%20id%3D%22Symbols%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%2299-icon-template%2F01-template%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%2299-icon-template%2F02-circle%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Circle%22%20transform%3D%22translate%281.000000%2C%201.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-2%22%20fill%3D%22white%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fmask%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Mask%22%20fill-rule%3D%22nonzero%22%3E%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22color%2Fwhite%22%20mask%3D%22url%28%23mask-2%29%22%20fill%3D%22%23FFFFFF%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%28-1.000000%2C%20-1.000000%29%22%20id%3D%22Color-%2F-White%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20x%3D%220%22%20y%3D%220%22%20width%3D%2240%22%20height%3D%2240%22%3E%3C%2Frect%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%2210-service%2F247-insurance-check%22%20transform%3D%22translate%287.000000%2C%207.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-4%22%20fill%3D%22white%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-3%22%3E%3C%2Fuse%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fmask%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20id%3D%22Mask%22%20fill%3D%22%23046EAE%22%20fill-rule%3D%22evenodd%22%20xlink%3Ahref%3D%22%23path-3%22%3E%3C%2Fuse%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22color%2Fb1%22%20mask%3D%22url%28%23mask-4%29%22%20fill%3D%22%23002A54%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Color-%2F-B1%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2226%22%20height%3D%2226%22%3E%3C%2Frect%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3C%2Fg%3E%0A%3C%2Fsvg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-ensurance-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%0A%3Csvg%20width%3D%2240px%22%20height%3D%2240px%22%20viewBox%3D%220%200%2040%2040%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%0A%20%20%20%20%3C!--%20Generator%3A%20Sketch%2053.1%20%2872631%29%20-%20https%3A%2F%2Fsketchapp.com%20--%3E%0A%20%20%20%20%3Ctitle%3E247-insurance-check-white-circle%3C%2Ftitle%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%0A%20%20%20%20%3Cdefs%3E%0A%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22path-1%22%20cx%3D%2219%22%20cy%3D%2219%22%20r%3D%2219%22%3E%3C%2Fcircle%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M20.082%2C10.4475%20L20.082%2C5.1675%20C20.082%2C4.5575%2019.681%2C4.0145%2019.08%2C3.8115%20L11%2C1.0825%20C10.676%2C0.9725%2010.323%2C0.9725%209.999%2C1.0835%20L1.997%2C3.8105%20C1.399%2C4.0145%201%2C4.5565%201%2C5.1655%20L1%2C13.7835%20C1%2C16.6375%202.396%2C19.3265%204.773%2C21.0465%20L9.599%2C24.5415%20C10.132%2C24.9265%2010.867%2C24.9275%2011.402%2C24.5435%20C12.106%2C23.9685%2012.588%2C23.5795%2012.859%2C23.3665%20C14.137%2C24.3755%2015.746%2C24.9815%2017.5%2C24.9815%20C21.643%2C24.9815%2025%2C21.6245%2025%2C17.4815%20C25%2C14.2485%2022.95%2C11.5015%2020.082%2C10.4475%20L20.082%2C10.4475%20Z%20M17.5%2C23.9815%20C13.91%2C23.9815%2011%2C21.0715%2011%2C17.4815%20C11%2C13.8915%2013.91%2C10.9815%2017.5%2C10.9815%20C21.09%2C10.9815%2024%2C13.8915%2024%2C17.4815%20C24%2C21.0715%2021.09%2C23.9815%2017.5%2C23.9815%20L17.5%2C23.9815%20Z%20M10%2C17.4815%20C10%2C18.2455%2010.116%2C18.9815%2010.328%2C19.6745%20C10.225%2C19.6695%2010.123%2C19.6395%2010.039%2C19.5725%20L6.723%2C16.9065%20C5.703%2C16.0865%205.115%2C14.8775%205.115%2C13.6035%20L5.115%2C7.6415%20C5.115%2C7.4385%205.248%2C7.2575%205.448%2C7.1895%20L10.186%2C5.5825%20C10.291%2C5.5465%2010.406%2C5.5455%2010.512%2C5.5795%20L15.545%2C7.1995%20C15.748%2C7.2645%2015.886%2C7.4475%2015.886%2C7.6535%20L15.886%2C10.1605%20C12.52%2C10.8995%2010%2C13.8945%2010%2C17.4815%20L10%2C17.4815%20Z%20M10.803%2C23.7775%20C10.624%2C23.9055%2010.379%2C23.9045%2010.201%2C23.7765%20L5.376%2C20.2825%20C3.25%2C18.7435%202%2C16.3365%202%2C13.7835%20L2%2C5.1655%20C2%2C4.9615%202.133%2C4.7815%202.333%2C4.7135%20L10.334%2C1.9855%20C10.442%2C1.9495%2010.56%2C1.9495%2010.668%2C1.9855%20L18.748%2C4.7145%20C18.948%2C4.7825%2019.082%2C4.9635%2019.082%2C5.1675%20L19.082%2C10.1515%20C18.571%2C10.0425%2018.043%2C9.9815%2017.5%2C9.9815%20C17.293%2C9.9815%2017.089%2C9.9965%2016.886%2C10.0125%20L16.886%2C7.6535%20C16.886%2C7.0365%2016.474%2C6.4875%2015.863%2C6.2915%20L10.83%2C4.6715%20C10.512%2C4.5695%2010.167%2C4.5715%209.852%2C4.6795%20L5.114%2C6.2865%20C4.515%2C6.4905%204.115%2C7.0325%204.115%2C7.6415%20L4.115%2C13.6035%20C4.115%2C15.1615%204.834%2C16.6385%206.08%2C17.6405%20L9.396%2C20.3065%20C9.763%2C20.6015%2010.238%2C20.6855%2010.681%2C20.5915%20C11.042%2C21.3805%2011.532%2C22.0975%2012.129%2C22.7105%20L10.803%2C23.7775%20Z%20M20.5146%2C15.2745%20C20.7046%2C15.0755%2021.0226%2C15.0685%2021.2216%2C15.2595%20C21.4206%2C15.4515%2021.4266%2C15.7675%2021.2366%2C15.9665%20L17.7936%2C19.5535%20L17.7716%2C19.5765%20C17.1866%2C20.1625%2016.2366%2C20.1625%2015.6506%2C19.5765%20L14.6466%2C18.5715%20C14.4516%2C18.3765%2014.4516%2C18.0595%2014.6466%2C17.8645%20C14.8416%2C17.6695%2015.1586%2C17.6695%2015.3536%2C17.8645%20L16.3576%2C18.8695%20C16.5526%2C19.0645%2016.8686%2C19.0645%2017.0646%2C18.8695%20C17.0676%2C18.8665%2018.2166%2C17.6685%2020.5146%2C15.2745%20Z%22%20id%3D%22path-3%22%3E%3C%2Fpath%3E%0A%20%20%20%20%3C%2Fdefs%3E%0A%20%20%20%20%3Cg%20id%3D%22Symbols%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%2299-icon-template%2F01-template%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%2299-icon-template%2F02-circle%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Circle%22%20transform%3D%22translate%281.000000%2C%201.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-2%22%20fill%3D%22white%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fmask%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Mask%22%20fill-rule%3D%22nonzero%22%3E%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22color%2Fwhite%22%20mask%3D%22url%28%23mask-2%29%22%20fill%3D%22%23FFFFFF%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%28-1.000000%2C%20-1.000000%29%22%20id%3D%22Color-%2F-White%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20x%3D%220%22%20y%3D%220%22%20width%3D%2240%22%20height%3D%2240%22%3E%3C%2Frect%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%2210-service%2F247-insurance-check%22%20transform%3D%22translate%287.000000%2C%207.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-4%22%20fill%3D%22white%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-3%22%3E%3C%2Fuse%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fmask%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20id%3D%22Mask%22%20fill%3D%22%23046EAE%22%20fill-rule%3D%22evenodd%22%20xlink%3Ahref%3D%22%23path-3%22%3E%3C%2Fuse%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22color%2Fb1%22%20mask%3D%22url%28%23mask-4%29%22%20fill%3D%22%23002A54%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Color-%2F-B1%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2226%22%20height%3D%2226%22%3E%3C%2Frect%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3C%2Fg%3E%0A%3C%2Fsvg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-service-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20width%3D%2240px%22%20height%3D%2240px%22%20viewBox%3D%220%200%2040%2040%22%20version%3D%221.1%22%3E%0A%20%20%20%20%3C!--%20Generator%3A%20Sketch%2053.1%20%2872631%29%20-%20https%3A%2F%2Fsketchapp.com%20--%3E%0A%20%20%20%20%3Ctitle%3E125-customer-service-white-circle%3C%2Ftitle%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%0A%20%20%20%20%3Cdefs%3E%0A%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22path-1%22%20cx%3D%2219%22%20cy%3D%2219%22%20r%3D%2219%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M24%2C18%20C24%2C18.553%2023.553%2C19%2023%2C19%20L21%2C19%20L21%2C12%20L23%2C12%20C23.553%2C12%2024%2C12.448%2024%2C13%20L24%2C18%20Z%20M12%2C23%20L16%2C23%20L16%2C21%20L12%2C21%20L12%2C23%20Z%20M5%2C12%20L5%2C19%20L3%2C19%20C2.448%2C19%202%2C18.553%202%2C18%20L2%2C13%20C2%2C12.448%202.448%2C12%203%2C12%20L5%2C12%20Z%20M23%2C11%20C23%2C5.836%2018.729%2C2%2013.25%2C2%20C7.771%2C2%203.5%2C5.836%203.5%2C11%20L3%2C11%20C1.896%2C11%201%2C11.896%201%2C13%20L1%2C18%20C1%2C19.104%201.896%2C20%203%2C20%20L5%2C20%20C5.552%2C20%206%2C19.553%206%2C19%20L6%2C12%20C6%2C11.448%205.552%2C11%205%2C11%20L4.5%2C11%20C4.5%2C6.414%208.3%2C3%2013.25%2C3%20C18.2%2C3%2022%2C6.414%2022%2C11%20L21%2C11%20C20.447%2C11%2020%2C11.448%2020%2C12%20L20%2C19%20C20%2C19.516%2020.395%2C19.924%2020.896%2C19.979%20C20.264%2C20.599%2019.19%2C20.982%2017.189%2C21.418%20C17.146%2C21.428%2017.077%2C21.442%2017%2C21.459%20L17%2C21%20C17%2C20.447%2016.553%2C20%2016%2C20%20L12%2C20%20C11.448%2C20%2011%2C20.447%2011%2C21%20L11%2C23%20C11%2C23.553%2011.448%2C24%2012%2C24%20L16%2C24%20C16.553%2C24%2017%2C23.553%2017%2C23%20L17%2C22.482%20C17.169%2C22.445%2017.322%2C22.413%2017.402%2C22.396%20C20.15%2C21.796%2021.4%2C21.25%2022.135%2C20%20L23%2C20%20C24.104%2C20%2025%2C19.104%2025%2C18%20L25%2C13%20C25%2C11.896%2024.104%2C11%2023%2C11%20L23%2C11%20Z%22%20id%3D%22path-3%22%2F%3E%0A%20%20%20%20%3C%2Fdefs%3E%0A%20%20%20%20%3Cg%20id%3D%22Symbols%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%2299-icon-template%2F01-template%22%20transform%3D%22translate%28-1.000000%2C%200.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%2299-icon-template%2F02-circle%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Circle%22%20transform%3D%22translate%281.000000%2C%201.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-2%22%20fill%3D%22white%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-1%22%2F%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fmask%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Mask%22%20fill-rule%3D%22nonzero%22%2F%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22color%2Fwhite%22%20mask%3D%22url%28%23mask-2%29%22%20fill%3D%22%23FFFFFF%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%28-1.000000%2C%20-1.000000%29%22%20id%3D%22Color-%2F-White%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20x%3D%220%22%20y%3D%220%22%20width%3D%2240%22%20height%3D%2240%22%2F%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%2210-service%2F125-customer-service%22%20transform%3D%22translate%287.000000%2C%207.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-4%22%20fill%3D%22white%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-3%22%2F%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fmask%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20id%3D%22Mask%22%20fill%3D%22%23046EAE%22%20fill-rule%3D%22evenodd%22%20xlink%3Ahref%3D%22%23path-3%22%2F%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22color%2Fb1%22%20mask%3D%22url%28%23mask-4%29%22%20fill%3D%22%23002A54%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Color-%2F-B1%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2226%22%20height%3D%2226%22%2F%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3C%2Fg%3E%0A%3C%2Fsvg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-pointer-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20width%3D%2240px%22%20height%3D%2240px%22%20viewBox%3D%220%200%2040%2040%22%20version%3D%221.1%22%3E%0A%20%20%20%20%3C!--%20Generator%3A%20Sketch%2053.1%20%2872631%29%20-%20https%3A%2F%2Fsketchapp.com%20--%3E%0A%20%20%20%20%3Ctitle%3E053-arrow-pointer-white-circle%3C%2Ftitle%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%0A%20%20%20%20%3Cdefs%3E%0A%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22path-1%22%20cx%3D%2219%22%20cy%3D%2219%22%20r%3D%2219%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M19.6510105%2C1.575%20L6.15601046%2C9.95%20C5.83501046%2C10.149%205.84301046%2C10.618%206.17001046%2C10.807%20L6.17001046%2C10.807%20L10.0670105%2C13.057%20L5.31701046%2C21.285%20C5.17901046%2C21.524%205.26101046%2C21.83%205.50001046%2C21.968%20L5.50001046%2C21.968%20L9.87201046%2C24.493%20C10.1110105%2C24.631%2010.4170105%2C24.549%2010.5560105%2C24.309%20L10.5560105%2C24.309%20L15.3060105%2C16.081%20L19.1600105%2C18.308%20C19.4870105%2C18.497%2019.8980105%2C18.268%2019.9100105%2C17.89%20L19.9100105%2C17.89%20L20.4150105%2C2.016%20L20.4150105%2C1.983%20C20.4060105%2C1.7%2020.1700105%2C1.5%2019.9140105%2C1.5%20L19.9140105%2C1.5%20C19.8260105%2C1.5%2019.7350105%2C1.523%2019.6510105%2C1.575%20L19.6510105%2C1.575%20Z%20M6.43301046%2C21.352%20L11.1830105%2C13.125%20C11.3210105%2C12.885%2011.2390105%2C12.579%2011.0000105%2C12.442%20L11.0000105%2C12.442%20L7.39301046%2C10.359%20L19.3850105%2C2.917%20L18.9370105%2C17.024%20L15.3720105%2C14.966%20C15.1330105%2C14.828%2014.8270105%2C14.91%2014.6890105%2C15.149%20L14.6890105%2C15.149%20L9.93901046%2C23.377%20L6.43301046%2C21.352%20Z%22%20id%3D%22path-3%22%2F%3E%0A%20%20%20%20%3C%2Fdefs%3E%0A%20%20%20%20%3Cg%20id%3D%22Symbols%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%2299-icon-template%2F01-template%22%20transform%3D%22translate%28-1.000000%2C%200.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%2299-icon-template%2F02-circle%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Circle%22%20transform%3D%22translate%281.000000%2C%201.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-2%22%20fill%3D%22white%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-1%22%2F%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fmask%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Mask%22%20fill-rule%3D%22nonzero%22%2F%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22color%2Fwhite%22%20mask%3D%22url%28%23mask-2%29%22%20fill%3D%22%23FFFFFF%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%28-1.000000%2C%20-1.000000%29%22%20id%3D%22Color-%2F-White%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20x%3D%220%22%20y%3D%220%22%20width%3D%2240%22%20height%3D%2240%22%2F%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%2201-direction%2F053-arrow-pointer%22%20transform%3D%22translate%287.000000%2C%207.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-4%22%20fill%3D%22white%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-3%22%2F%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fmask%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22icon%22%2F%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22color%2Fb1%22%20mask%3D%22url%28%23mask-4%29%22%20fill%3D%22%23002A54%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Color-%2F-B1%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2226%22%20height%3D%2226%22%2F%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3C%2Fg%3E%0A%3C%2Fsvg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-cardPin-light{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20width%3D%2240px%22%20height%3D%2240px%22%20viewBox%3D%220%200%2040%2040%22%20version%3D%221.1%22%3E%0A%20%20%20%20%3C!--%20Generator%3A%20Sketch%2053.1%20%2872631%29%20-%20https%3A%2F%2Fsketchapp.com%20--%3E%0A%20%20%20%20%3Ctitle%3E185-card-pin-white-circle%3C%2Ftitle%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%0A%20%20%20%20%3Cdefs%3E%0A%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22path-1%22%20cx%3D%2219%22%20cy%3D%2219%22%20r%3D%2219%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M23.3496%2C4%20L2.6496%2C4%20C1.7356%2C4%200.9996%2C4.776%200.9996%2C5.714%20L0.9996%2C20.286%20C0.9996%2C21.224%201.7356%2C22%202.6496%2C22%20L23.3496%2C22%20C24.2656%2C22%2024.9996%2C21.224%2024.9996%2C20.286%20L24.9996%2C5.714%20C24.9996%2C4.776%2024.2656%2C4%2023.3496%2C4%20M23.3496%2C21%20L2.6496%2C21%20C2.2996%2C21%201.9996%2C20.684%201.9996%2C20.286%20L1.9996%2C9%20L23.9996%2C9%20L23.9996%2C20.286%20C23.9996%2C20.684%2023.7006%2C21%2023.3496%2C21%20M2.6496%2C5%20L23.3496%2C5%20C23.7006%2C5%2023.9996%2C5.316%2023.9996%2C5.714%20L23.9996%2C8%20L1.9996%2C8%20L1.9996%2C5.714%20C1.9996%2C5.316%202.2996%2C5%202.6496%2C5%20M9.5%2C14%20L11.5%2C14%20C12.167%2C14%2012.167%2C15%2011.5%2C15%20L9.5%2C15%20C8.833%2C15%208.833%2C14%209.5%2C14%20M4.5%2C14%20L6.5%2C14%20C7.167%2C14%207.167%2C15%206.5%2C15%20L4.5%2C15%20C3.833%2C15%203.833%2C14%204.5%2C14%20M19.5%2C14%20L21.5%2C14%20C22.167%2C14%2022.167%2C15%2021.5%2C15%20L19.5%2C15%20C18.833%2C15%2018.833%2C14%2019.5%2C14%20M14.5%2C14%20L16.5%2C14%20C17.167%2C14%2017.167%2C15%2016.5%2C15%20L14.5%2C15%20C13.833%2C15%2013.833%2C14%2014.5%2C14%22%20id%3D%22path-3%22%2F%3E%0A%20%20%20%20%3C%2Fdefs%3E%0A%20%20%20%20%3Cg%20id%3D%22Symbols%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%2299-icon-template%2F01-template%22%20transform%3D%22translate%28-1.000000%2C%200.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%2299-icon-template%2F02-circle%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Circle%22%20transform%3D%22translate%281.000000%2C%201.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-2%22%20fill%3D%22white%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-1%22%2F%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fmask%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Mask%22%20fill-rule%3D%22nonzero%22%2F%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22color%2Fwhite%22%20mask%3D%22url%28%23mask-2%29%22%20fill%3D%22%23FFFFFF%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%28-1.000000%2C%20-1.000000%29%22%20id%3D%22Color-%2F-White%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20x%3D%220%22%20y%3D%220%22%20width%3D%2240%22%20height%3D%2240%22%2F%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%2207-card%2F185-card-pin%22%20transform%3D%22translate%287.000000%2C%207.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-4%22%20fill%3D%22white%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-3%22%2F%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fmask%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20id%3D%22Mask%22%20fill%3D%22%23046EAE%22%20fill-rule%3D%22evenodd%22%20xlink%3Ahref%3D%22%23path-3%22%2F%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22color%2Fb1%22%20mask%3D%22url%28%23mask-4%29%22%20fill%3D%22%23002A54%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Color-%2F-B1%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2226%22%20height%3D%2226%22%2F%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3C%2Fg%3E%0A%3C%2Fsvg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-trash-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_trash%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M33%2C12H27a4%2C4%2C0%2C0%2C0-4-4H19a4%2C4%2C0%2C0%2C0-4%2C4H9v2h2V30a4%2C4%2C0%2C0%2C0%2C4%2C4H27a4%2C4%2C0%2C0%2C0%2C4-4V14h2ZM19%2C10h4a2%2C2%2C0%2C0%2C1%2C2%2C2H17A2%2C2%2C0%2C0%2C1%2C19%2C10ZM29%2C30a2%2C2%2C0%2C0%2C1-2%2C2H15a2%2C2%2C0%2C0%2C1-2-2V27.21L29%2C18.7Zm0-13.57L13%2C24.94V14H29Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-ensurance-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3C!--%20Generator%3A%20Adobe%20Illustrator%2022.0.1%2C%20SVG%20Export%20Plug-In%20.%20SVG%20Version%3A%206.00%20Build%200%29%20%20--%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22Layer%5f1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2040%2040%22%20style%3D%22enable-background%3Anew%200%200%2040%2040%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill%3A%23002A54%3B%7D%0A%3C%2Fstyle%3E%0A%3Cg%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M16.396%2C27.30609l-3.31598-2.66595c-1.24603-1.00201-1.96503-2.479-1.96503-4.03705v-5.96198%0A%09%09c0-0.60901%2C0.40002-1.151%2C0.99902-1.35498l4.73798-1.60699c0.315-0.10803%2C0.66003-0.11005%2C0.97803-0.00806l5.03296%2C1.62006%0A%09%09c0.61102%2C0.19598%2C1.02301%2C0.745%2C1.02301%2C1.362v2.35895c0.203-0.01599%2C0.40704-0.03101%2C0.61401-0.03101%0A%09%09c0.54303%2C0%2C1.07098%2C0.06104%2C1.58203%2C0.17004v-4.98401c0-0.20398-0.13403-0.38501-0.33405-0.453l-8.07996-2.729%0A%09%09c-0.10803-0.03601-0.22601-0.03601-0.33405%2C0l-8.00098%2C2.72803C9.133%2C11.78113%2C9%2C11.96112%2C9%2C12.1651v8.61798%0A%09%09c0%2C2.55304%2C1.25%2C4.96002%2C3.37598%2C6.49902l4.82501%2C3.49402c0.17804%2C0.12799%2C0.42303%2C0.12897%2C0.60199%2C0.00098l1.32605-1.06702%0A%09%09c-0.59705-0.61298-1.08704-1.32996-1.448-2.11896C17.23798%2C27.68512%2C16.763%2C27.60114%2C16.396%2C27.30609z%22%2F%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M22.88599%2C17.1601v-2.50696c0-0.20605-0.138-0.38904-0.341-0.45404l-5.03296-1.62%0A%09%09c-0.10602-0.034-0.22101-0.03302-0.32605%2C0.00299l-4.73798%2C1.607c-0.20001%2C0.06799-0.33301%2C0.24902-0.33301%2C0.45203v5.96198%0A%09%09c0%2C1.27405%2C0.58801%2C2.48303%2C1.60803%2C3.30304l3.31598%2C2.66595c0.08398%2C0.06702%2C0.18597%2C0.09705%2C0.289%2C0.10205%0A%09%09c-0.21197-0.693-0.328-1.42902-0.328-2.193C17%2C20.8941%2C19.52002%2C17.89911%2C22.88599%2C17.1601z%22%2F%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M20%2C0.99963c-10.49341%2C0-19%2C8.50659-19%2C19s8.50659%2C19%2C19%2C19s19-8.50659%2C19-19S30.49341%2C0.99963%2C20%2C0.99963z%0A%09%09%20M24.5%2C31.98114c-1.75403%2C0-3.36298-0.60602-4.64099-1.61505c-0.271%2C0.21301-0.75299%2C0.60205-1.45703%2C1.177%0A%09%09c-0.53497%2C0.38403-1.26996%2C0.383-1.80298-0.00195l-4.82599-3.49506C9.396%2C26.32611%2C8%2C23.63708%2C8%2C20.78308V12.1651%0A%09%09c0-0.60901%2C0.39899-1.151%2C0.99701-1.35498l8.00201-2.72699C17.323%2C7.97211%2C17.67603%2C7.97211%2C18%2C8.08209l8.08002%2C2.729%0A%09%09c0.60101%2C0.203%2C1.00201%2C0.74603%2C1.00201%2C1.35602v5.27997C29.95001%2C18.5011%2C32%2C21.24811%2C32%2C24.48114%0A%09%09C32%2C28.62408%2C28.64301%2C31.98114%2C24.5%2C31.98114z%22%2F%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M24.5%2C17.98108c-3.59003%2C0-6.5%2C2.91003-6.5%2C6.50006c0%2C3.58997%2C2.90997%2C6.5%2C6.5%2C6.5s6.5-2.91003%2C6.5-6.5%0A%09%09C31%2C20.89111%2C28.09003%2C17.98108%2C24.5%2C17.98108z%20M28.23657%2C22.96613l-3.44299%2C3.58698l-0.02197%2C0.02301%0A%09%09c-0.58502%2C0.586-1.53503%2C0.586-2.12103%2C0l-1.00397-1.005c-0.19501-0.19501-0.19501-0.51202%2C0-0.70697%0A%09%09c0.19501-0.19501%2C0.51202-0.19501%2C0.70697%2C0l1.00403%2C1.00494c0.19501%2C0.19501%2C0.51099%2C0.19501%2C0.70697%2C0%0A%09%09c0.00305-0.00299%2C1.15204-1.20099%2C3.45001-3.59497c0.19-0.19897%2C0.508-0.20599%2C0.70703-0.01501%0A%09%09C28.42059%2C22.45111%2C28.42657%2C22.76709%2C28.23657%2C22.96613z%22%2F%3E%0A%3C%2Fg%3E%0A%3C%2Fsvg%3E%0A);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-four-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_4_arrows%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M41%2C21A20%2C20%2C0%2C1%2C1%2C21%2C1%2C20%2C20%2C0%2C0%2C1%2C41%2C21%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpolygon%20class%3D%22cls-2%22%20points%3D%2236%2020%2028%2015.38%2028%2019%2021%2019%2021%2012%2024.62%2012%2020%204%2015.38%2012%2019%2012%2019%2019%2012%2019%2012%2015.38%204%2020%2012%2024.62%2012%2021%2019%2021%2019%2028%2015.38%2028%2020%2036%2024.62%2028%2021%2028%2021%2021%2028%2021%2028%2024.62%2036%2020%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-arrowdown-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_arrow_down%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M41%2C21A20%2C20%2C0%2C1%2C1%2C21%2C1%2C20%2C20%2C0%2C0%2C1%2C41%2C21%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M20%2C9V30.7a2%2C2%2C0%2C0%2C1-.58-.5L13.28%2C18.65l-1.77.94%2C5.73%2C10.77h0a4%2C4%2C0%2C0%2C0%2C7.44.17l5.8-10.94-1.77-.94-5.87%2C11a2%2C2%2C0%2C0%2C1-.86%2C1V9Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-arrowleft-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_arrow_left%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C1%2C41%2C21%2C20%2C20%2C0%2C0%2C1%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M33%2C20H11.3a2%2C2%2C0%2C0%2C1%2C.5-.58l11.55-6.14-.94-1.77L11.64%2C17.24v0a4%2C4%2C0%2C0%2C0-.17%2C7.44l10.94%2C5.8.94-1.77-11-5.87a2%2C2%2C0%2C0%2C1-1-.86H33Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-arrowright-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_arrow_right%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C1A20%2C20%2C0%2C1%2C1%2C1%2C21%2C20%2C20%2C0%2C0%2C1%2C21%2C1%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M9%2C22H30.7a2%2C2%2C0%2C0%2C1-.5.58L18.65%2C28.72l.94%2C1.77%2C10.77-5.73v0a4%2C4%2C0%2C0%2C0%2C.16-7.44l-10.94-5.8-.94%2C1.77%2C11%2C5.87a2%2C2%2C0%2C0%2C1%2C1%2C.86H9Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-arrowup-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_arrow_up%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M1%2C21A20%2C20%2C0%2C1%2C1%2C21%2C41%2C20%2C20%2C0%2C0%2C1%2C1%2C21%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M22%2C33V11.3a2%2C2%2C0%2C0%2C1%2C.57.5l6.14%2C11.55%2C1.77-.94L24.77%2C11.64h0a4%2C4%2C0%2C0%2C0-7.44-.17l-5.8%2C10.94%2C1.77.94%2C5.87-11a2%2C2%2C0%2C0%2C1%2C.86-1V33Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-calendar-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_calendar%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M33%2C11H27V9H25v2H17V9H15v2H9V27a6%2C6%2C0%2C0%2C0%2C6%2C6H27a6%2C6%2C0%2C0%2C0%2C6-6h0ZM15%2C13v2h2V13h8v2h2V13h4v4H11V13ZM31%2C27a4%2C4%2C0%2C0%2C1-4%2C4H15a4%2C4%2C0%2C0%2C1-4-4V19H31Zm-4.74-6%2C.94%2C1.77-9.65%2C5.09-.94-1.77h0L15%2C22.93%2C16.77%2C22l1.65%2C3.16Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-branch-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_branch%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C1A20%2C20%2C0%2C1%2C1%2C1%2C21%2C20%2C20%2C0%2C0%2C1%2C21%2C1%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M33%2C17V13h0a2%2C2%2C0%2C0%2C0-2-2H11a2%2C2%2C0%2C0%2C0-2%2C2H9v4h2V29H9v2H33V29H31V17Zm-2-4v2H11V13ZM21%2C21v8H17V21Zm8%2C8H23V19H15V29H13V17H29Zm-2-4H25V21h2Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-bubble-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_bubble%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M26.22%2C13.89C24.7%2C11%2C21.15%2C9%2C17%2C9%2C11.48%2C9%2C7%2C12.58%2C7%2C17c0%2C3%2C2%2C5.48%2C5%2C6.86v5.41l5.23-2.82a9%2C9%2C0%2C0%2C0%2C1.88%2C1.62l11.14%2C6V28.66c3-1.37%2C5-3.91%2C5-6.86C35.25%2C17.65%2C31.28%2C14.29%2C26.22%2C13.89ZM9%2C17c0-3.31%2C3.58-6%2C8-6s8%2C2.69%2C8%2C6a5.51%2C5.51%2C0%2C0%2C1-2.79%2C4.52L14%2C25.94V22.52C11.08%2C21.63%2C9%2C19.51%2C9%2C17ZM28.25%2C27.32v3.42L20%2C26.32a6.54%2C6.54%2C0%2C0%2C1-1-.83l4.13-2.22A7.51%2C7.51%2C0%2C0%2C0%2C27%2C17a6.44%2C6.44%2C0%2C0%2C0-.13-1c3.63.56%2C6.38%2C2.93%2C6.38%2C5.82C33.25%2C24.31%2C31.17%2C26.43%2C28.25%2C27.32Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-chart-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_chart%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M17%2C29a4%2C4%2C0%2C0%2C1-4-3.81V23.09l4.94-2.63%2C1.81%2C3.4%2C11.61-6.18-.94-1.77-9.85%2C5.24-1.81-3.39L13%2C20.82V13H11V25.22A6%2C6%2C0%2C0%2C0%2C17%2C31H31V29Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-checkmark-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_checkmark%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpolygon%20class%3D%22cls-2%22%20points%3D%2231.9%2014.46%2015.3%2023.29%2011.77%2016.64%2010%2017.58%2014.46%2026%2032.84%2016.23%2031.9%2014.46%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-circle-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_circlearrows%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C1A20%2C20%2C0%2C1%2C1%2C1%2C21%2C20%2C20%2C0%2C0%2C1%2C21%2C1%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M31.45%2C26.81a12%2C12%2C0%2C0%2C1-21.16-.27l1.73-1a10%2C10%2C0%2C0%2C0%2C17.66.35l-3.21-1.7%2C7.84-4.9.32%2C9.23ZM26.59%2C10.41a12%2C12%2C0%2C0%2C0-16.16%2C4.85L7.37%2C13.62l.32%2C9.23L15.52%2C18l-3.32-1.77a10%2C10%2C0%2C0%2C1%2C17.67.32l1.73-1A11.94%2C11.94%2C0%2C0%2C0%2C26.59%2C10.41Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-creditCard-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_creditcard%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M21%2C23v2H11V23Zm14-8h0V27a4%2C4%2C0%2C0%2C1-4%2C4H11a4%2C4%2C0%2C0%2C1-4-4V15H7a4%2C4%2C0%2C0%2C1%2C4-4H31a4%2C4%2C0%2C0%2C1%2C4%2C4ZM11%2C29H21.44L33%2C22.85V19H9v8A2%2C2%2C0%2C0%2C0%2C11%2C29Zm22-2V25.12L25.7%2C29H31A2%2C2%2C0%2C0%2C0%2C33%2C27Zm0-12a2%2C2%2C0%2C0%2C0-2-2H11a2%2C2%2C0%2C0%2C0-2%2C2v2H33Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-currency-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_currency_bill%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M7%2C13V29H35V13Zm26%2C7.88L24.18%2C25.6A6.48%2C6.48%2C0%2C0%2C0%2C26%2C21c0-3.19-2.08-5.77-4.7-6v0H33ZM9%2C15h7.49L9%2C19Zm12%2C2c1.66%2C0%2C3%2C1.79%2C3%2C4s-1.34%2C4-3%2C4-3-1.79-3-4S19.34%2C17%2C21%2C17ZM9%2C21.22l8.5-4.5A6.61%2C6.61%2C0%2C0%2C0%2C16%2C21c0%2C3.24%2C2.14%2C5.86%2C4.82%2C6v0H9ZM25.84%2C27%2C33%2C23.18V27Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-docuarrow-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_docuarrow%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M11%2C9V33H24.13l5.09-2.67A4%2C4%2C0%2C0%2C0%2C31%2C27h0V9ZM27.73%2C28.85l-4%2C2.15H23V27h6A2%2C2%2C0%2C0%2C1%2C27.73%2C28.85ZM21%2C25v6H13V11H29v6H23V14l-7%2C4%2C7%2C4V19h6v6Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-docucheck-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_docucheck%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M11%2C9V33H24.14l5.08-2.7h0A4%2C4%2C0%2C0%2C0%2C31%2C27h0V9ZM29%2C27a2%2C2%2C0%2C0%2C1-1.27%2C1.85l-4%2C2.15H23V27Zm0-2H21v6H13V11H29ZM17.53%2C21.84%2C15%2C16.93%2C16.72%2C16l1.65%2C3.15L26.24%2C15l.94%2C1.77Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-document-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_document%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C1%2C41%2C21%2C20%2C20%2C0%2C0%2C1%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M11%2C9V33H24.13l5.08-2.7h0A4%2C4%2C0%2C0%2C0%2C31%2C27h0V9ZM29%2C27a2%2C2%2C0%2C0%2C1-1.27%2C1.85l-4%2C2.15H23V27Zm0-2H21v6H13V11H29ZM27%2C15H15V13H27ZM15%2C19V17h8v2Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-dollar-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_dollar%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M22.32%2C34.26H19.79v-3.8a9.09%2C9.09%2C0%2C0%2C1-5.15-2.56l-.18-.19%2C1.74-1.94.21.2a6.7%2C6.7%2C0%2C0%2C0%2C4.72%2C2.14c2.36%2C0%2C3.71-1%2C3.71-2.76%2C0-1.55-.95-2.34-4.23-3.52-3.74-1.34-5.51-2.5-5.51-5.51%2C0-2.6%2C1.75-4.37%2C4.7-4.78V7.74h2.53v3.76a8.53%2C8.53%2C0%2C0%2C1%2C4.62%2C2l.22.17-1.67%2C2-.21-.18A6.17%2C6.17%2C0%2C0%2C0%2C21%2C13.88c-2.14%2C0-3.31.82-3.31%2C2.31%2C0%2C1.27.4%2C2%2C4.2%2C3.33%2C4.25%2C1.53%2C5.54%2C2.87%2C5.54%2C5.72s-2%2C4.79-5.12%2C5.21Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-download-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_download%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M33%2C23v2a6%2C6%2C0%2C0%2C1-6%2C6H15a6%2C6%2C0%2C0%2C1-6-6V23h2v2a4%2C4%2C0%2C0%2C0%2C4%2C4H27a4%2C4%2C0%2C0%2C0%2C4-4V23ZM22%2C17V9H20v8H16.38L21%2C25l4.62-8Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-envelop-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_envelope%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M33%2C15h0V13H9V25a6%2C6%2C0%2C0%2C0%2C6%2C6H27a6%2C6%2C0%2C0%2C0%2C6-6V15ZM31%2C25a4%2C4%2C0%2C0%2C1-4%2C4H15a4%2C4%2C0%2C0%2C1-4-4h0V19.75l10%2C5.32%2C10-5.27Zm0-7.46L21%2C22.83%2C11%2C17.49V15H31Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-euro-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_euro%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M22%2C31c-3.13%2C0-5.75-3-6.64-7H21V22H15.07c0-.33-.07-.66-.07-1s0-.67.07-1H21V18H15.36c.89-4%2C3.52-7%2C6.64-7a6.26%2C6.26%2C0%2C0%2C1%2C5.09%2C3.16l1.73-.92C27.17%2C10.67%2C24.74%2C9%2C22%2C9c-4.2%2C0-7.71%2C3.83-8.71%2C9H11v2h2c0%2C.33%2C0%2C.66%2C0%2C1s0%2C.67%2C0%2C1H11v2h2.3c1%2C5.17%2C4.52%2C9%2C8.71%2C9%2C2.74%2C0%2C5.16-1.67%2C6.8-4.25l-1.71-.91A6.25%2C6.25%2C0%2C0%2C1%2C22%2C31Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-jbp-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_GBP%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M27.17%2C26.86a4%2C4%2C0%2C0%2C1-3.73%2C2.59%2C3.65%2C3.65%2C0%2C0%2C1-1.54-.37v0L19%2C27.56V21h6V19H19V15h0a4%2C4%2C0%2C0%2C1%2C4-4%2C3.94%2C3.94%2C0%2C0%2C1%2C2.56%2C1l1.88-1A6%2C6%2C0%2C0%2C0%2C17%2C15h0v4H15v2h2v6.29l-4%2C2.13.94%2C1.77%2C3.8-2%2C2.83%2C1.51a5.79%2C5.79%2C0%2C0%2C0%2C.52.28l.37.13a5.83%2C5.83%2C0%2C0%2C0%2C2%2C.38A6%2C6%2C0%2C0%2C0%2C29%2C27.8Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-info-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_info%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M23%2C13a2%2C2%2C0%2C1%2C1-2-2%2C2%2C2%2C0%2C0%2C1%2C2%2C2m12%2C8A14%2C14%2C0%2C1%2C0%2C21%2C35%2C14%2C14%2C0%2C0%2C0%2C35%2C21m2%2C0A16%2C16%2C0%2C1%2C1%2C21%2C5%2C16%2C16%2C0%2C0%2C1%2C37%2C21M23%2C17.09l-4.74%2C2.52.94%2C1.77%2C1.8-1V31h2Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-laptop-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_laptop%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M31%2C25V11H11V25H7a6%2C6%2C0%2C0%2C0%2C6%2C6H29a6%2C6%2C0%2C0%2C0%2C6-6ZM13%2C13h8.43L13%2C17.48Zm0%2C6.75L25.69%2C13H29V25H13ZM29%2C29H13a4%2C4%2C0%2C0%2C1-3.46-2H32.47A4%2C4%2C0%2C0%2C1%2C29%2C29Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-lightbulb-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_lightbulb%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C1%2C41%2C21%2C20%2C20%2C0%2C0%2C1%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M17%2C29h8v2H17Zm2%2C6h4V33H19Zm6.44-18.14-.94-1.77L21%2C17%2C17.5%2C15.1l-.94%2C1.77L21%2C19.22h0Zm-.44%2C7V27H17V23.87a8%2C8%2C0%2C1%2C1%2C8%2C0ZM27%2C17a6%2C6%2C0%2C1%2C0-8%2C5.63V25h4V22.63A6%2C6%2C0%2C0%2C0%2C27%2C17Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-list-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_list%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M15%2C11H31v2H15Zm0%2C14H31V23H15Zm0%2C6H31V29H15Zm0-12H31V17H15Zm-3-6a1%2C1%2C0%2C1%2C0-1-1%2C1%2C1%2C0%2C0%2C0%2C1%2C1m0%2C12a1%2C1%2C0%2C1%2C0-1-1%2C1%2C1%2C0%2C0%2C0%2C1%2C1m0-6a1%2C1%2C0%2C1%2C0-1-1%2C1%2C1%2C0%2C0%2C0%2C1%2C1m0%2C12a1%2C1%2C0%2C1%2C0-1-1%2C1%2C1%2C0%2C0%2C0%2C1%2C1%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-lock-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_lock%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M27%2C15V13h0a6%2C6%2C0%2C1%2C0-12%2C0v2H11v2h0v8a6%2C6%2C0%2C0%2C0%2C6%2C6h8a6%2C6%2C0%2C0%2C0%2C6-6V15ZM17%2C13a4%2C4%2C0%2C1%2C1%2C8%2C0h0v2H17ZM29%2C25a4%2C4%2C0%2C0%2C1-4%2C4H17a4%2C4%2C0%2C0%2C1-2.89-1.23L29%2C19.88Zm0-7.39L13.14%2C26A3.87%2C3.87%2C0%2C0%2C1%2C13%2C25V17H29Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-mapping-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_mappin%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M29%2C17c0%2C4.73-8%2C14.9-8%2C14.9S13%2C21.73%2C13%2C17a7.81%2C7.81%2C0%2C0%2C1%2C8-8%2C7.81%2C7.81%2C0%2C0%2C1%2C8%2C8m2%2C0a10%2C10%2C0%2C0%2C0-20%2C0c0%2C5.52%2C10%2C18%2C10%2C18S31%2C22.52%2C31%2C17m-6%2C0a4%2C4%2C0%2C1%2C1-4-4%2C4%2C4%2C0%2C0%2C1%2C4%2C4m2%2C0a6%2C6%2C0%2C1%2C0-6%2C6%2C6%2C6%2C0%2C0%2C0%2C6-6%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-menu-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_menu%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M11%2C15H31v2H11Zm0%2C12H31V25H11Zm0-5H31V20H11Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-minus-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_minus%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Crect%20class%3D%22cls-2%22%20x%3D%2210%22%20y%3D%2219%22%20width%3D%2220%22%20height%3D%222%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-mobile-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3C!--%20Generator%3A%20Adobe%20Illustrator%2022.0.1%2C%20SVG%20Export%20Plug-In%20.%20SVG%20Version%3A%206.00%20Build%200%29%20%20--%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22Layer%5f1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2040%2040%22%20style%3D%22enable-background%3Anew%200%200%2040%2040%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill%3A%23002A54%3B%7D%0A%3C%2Fstyle%3E%0A%3Cg%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M24.5%2C9h-9C14.7%2C9%2C14%2C9.7%2C14%2C10.5V12h12v-1.5C26%2C9.7%2C25.3%2C9%2C24.5%2C9z%22%2F%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M14%2C29.5c0%2C0.8%2C0.7%2C1.5%2C1.5%2C1.5h9c0.8%2C0%2C1.5-0.7%2C1.5-1.5V28H14V29.5z%22%2F%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M20%2C1C9.5%2C1%2C1%2C9.5%2C1%2C20s8.5%2C19%2C19%2C19s19-8.5%2C19-19S30.5%2C1%2C20%2C1z%20M27%2C12v1v14v1v1.5c0%2C1.4-1.1%2C2.5-2.5%2C2.5h-9%0A%09%09c-1.4%2C0-2.5-1.1-2.5-2.5V28v-1V13v-1v-1.5C13%2C9.1%2C14.1%2C8%2C15.5%2C8h9c1.4%2C0%2C2.5%2C1.1%2C2.5%2C2.5V12z%22%2F%3E%0A%09%3Cpath%20id%3D%22path-3%5f1%5f%22%20class%3D%22st0%22%20d%3D%22M14%2C27h12V13H14V27z%22%2F%3E%0A%3C%2Fg%3E%0A%3C%2Fsvg%3E%0A);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-pencil-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_pencil%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M27%2C25.89l2-1.06V29a4%2C4%2C0%2C0%2C1-4%2C4H13a4%2C4%2C0%2C0%2C1-4-4V13a4%2C4%2C0%2C0%2C1%2C4-4H25a4%2C4%2C0%2C0%2C1%2C3.86%2C3.31L27%2C13.3V13a2%2C2%2C0%2C0%2C0-2-2H13a2%2C2%2C0%2C0%2C0-2%2C2V29a2%2C2%2C0%2C0%2C0%2C2%2C2H25a2%2C2%2C0%2C0%2C0%2C2-2Zm11.14-8L20%2C27.51H14.1l-1-1.88%2C3.25-4.82%2C0-.06L34.55%2C11.1ZM19.91%2C21.14l1.72%2C3.24%2C9.25-4.92-1.72-3.24Zm-.4%2C4.37.36-.19-1.72-3.24-.36.19L15.6%2C25.51ZM35.44%2C17%2C33.72%2C13.8l-2.8%2C1.49%2C1.72%2C3.24Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-people-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_people%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M28%2C19a5%2C5%2C0%2C1%2C0-5-5A5%2C5%2C0%2C0%2C0%2C28%2C19Zm0-8a3%2C3%2C0%2C1%2C1-3%2C3A3%2C3%2C0%2C0%2C1%2C28%2C11ZM14%2C19a5%2C5%2C0%2C1%2C0-5-5A5%2C5%2C0%2C0%2C0%2C14%2C19Zm0-8a3%2C3%2C0%2C1%2C1-3%2C3A3%2C3%2C0%2C0%2C1%2C14%2C11Zm.77%2C10.43A3.9%2C3.9%2C0%2C0%2C0%2C13%2C21a4%2C4%2C0%2C0%2C0-4%2C4H9v8H21V24.72l-6.19-3.29ZM19%2C31H11V25h0a2%2C2%2C0%2C0%2C1%2C2-2%2C3.51%2C3.51%2C0%2C0%2C1%2C1%2C.27l5%2C2.66Zm14-6h0v8H23V31h8V25a2%2C2%2C0%2C0%2C0-2-2%2C2%2C2%2C0%2C0%2C0-1%2C.3v0l-5%2C2.66V23.66l4.19-2.23A7.37%2C7.37%2C0%2C0%2C1%2C29%2C21%2C4%2C4%2C0%2C0%2C1%2C33%2C25Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-piggybank-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_piggybank%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C1%2C41%2C21%2C20%2C20%2C0%2C0%2C1%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M25.74%2C18.37A5.55%2C5.55%2C0%2C0%2C0%2C22%2C17a5.62%2C5.62%2C0%2C0%2C0-3.62%2C1.25l-1.83-1a7.66%2C7.66%2C0%2C0%2C1%2C11%2C.12ZM32.36%2C17A7.5%2C7.5%2C0%2C0%2C1%2C33%2C20a8.38%2C8.38%2C0%2C0%2C1-4%2C6.87V31H15V26.87A9.22%2C9.22%2C0%2C0%2C1%2C11.7%2C23H9V17h2.72A8.41%2C8.41%2C0%2C0%2C1%2C13%2C15V9h2l4.36%2C2.28A12.69%2C12.69%2C0%2C0%2C1%2C22%2C11a11.68%2C11.68%2C0%2C0%2C1%2C9.36%2C4.28l1.4-.74.94%2C1.76ZM31%2C20c0-3.87-4-7-9-7a11.24%2C11.24%2C0%2C0%2C0-2.88.39L15%2C11.26v4.37A6.39%2C6.39%2C0%2C0%2C0%2C13.13%2C19H11v2h2.13A7.12%2C7.12%2C0%2C0%2C0%2C17%2C25.76V29h4V27h2v2h4V25.76C29.36%2C24.5%2C31%2C22.39%2C31%2C20Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-wear-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_gear%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M21%2C16a5%2C5%2C0%2C1%2C0%2C5%2C5A5%2C5%2C0%2C0%2C0%2C21%2C16Zm0%2C8a3%2C3%2C0%2C1%2C1%2C3-3A3%2C3%2C0%2C0%2C1%2C21%2C24Zm11-1.27a11.06%2C11.06%2C0%2C0%2C0%2C0-3.46l3.13-1.8-4-6.93L28%2C12.34a11.08%2C11.08%2C0%2C0%2C0-3-1.73V7H17v3.57a11%2C11%2C0%2C0%2C0-1.59.74%2C10.82%2C10.82%2C0%2C0%2C0-1.43%2C1l-3.1-1.79-4%2C6.93L10%2C19.27a11.28%2C11.28%2C0%2C0%2C0%2C0%2C3.46l-3.12%2C1.8h0l4%2C6.93L14%2C29.66a11.16%2C11.16%2C0%2C0%2C0%2C3%2C1.73V35h8V31.43a9.8%2C9.8%2C0%2C0%2C0%2C3-1.75l3.09%2C1.79%2C4-6.93Zm-1.6%2C6-2.57-1.48A8.72%2C8.72%2C0%2C0%2C1%2C23%2C30v3H19V30a9.23%2C9.23%2C0%2C0%2C1-4.84-2.77l-2.55%2C1.47-2-3.46%2C2.55-1.47a9.26%2C9.26%2C0%2C0%2C1%2C0-5.58L9.61%2C16.73l2-3.46%2C2.56%2C1.48A8.74%2C8.74%2C0%2C0%2C1%2C19%2C12V9h4v3a9.26%2C9.26%2C0%2C0%2C1%2C4.85%2C2.78l2.55-1.47%2C2%2C3.46L29.85%2C18.2a9.23%2C9.23%2C0%2C0%2C1%2C0%2C5.58l2.57%2C1.48Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-playbutton-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_play_button%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M29%2C11H13a6%2C6%2C0%2C0%2C0-6%2C6v8a6%2C6%2C0%2C0%2C0%2C6%2C6H29a6%2C6%2C0%2C0%2C0%2C6-6V17A6%2C6%2C0%2C0%2C0%2C29%2C11Zm4%2C14.19A4%2C4%2C0%2C0%2C1%2C29.2%2C29H12.81A4%2C4%2C0%2C0%2C1%2C9%2C25.19V16.81A4%2C4%2C0%2C0%2C1%2C12.81%2C13H29.2A4%2C4%2C0%2C0%2C1%2C33%2C16.81ZM18%2C26.34a1%2C1%2C0%2C0%2C1-1-1V16.66a1%2C1%2C0%2C0%2C1%2C.48-.86%2C1%2C1%2C0%2C0%2C1%2C1%2C0l8.17%2C4.33a1%2C1%2C0%2C0%2C1%2C0%2C1.77l-8.17%2C4.34A1%2C1%2C0%2C0%2C1%2C18%2C26.34Zm1-8v5.35L24%2C21Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-plus-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_plus%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpolygon%20class%3D%22cls-2%22%20points%3D%2230%2019%2021%2019%2021%2010%2019%2010%2019%2019%2010%2019%2010%2021%2019%2021%2019%2030%2021%2030%2021%2021%2030%2021%2030%2019%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-print-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_print%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M29%2C19h2v2H29Zm6%2C0v8H29v4H13V27H7V19a4%2C4%2C0%2C0%2C1%2C4-4h2V9H29v6h2A4%2C4%2C0%2C0%2C1%2C35%2C19ZM15%2C15H27V11H15Zm0%2C14H27V23H15Zm18-8V19a2%2C2%2C0%2C0%2C0-2-2H11a2%2C2%2C0%2C0%2C0-2%2C2v6h4V21H29v4h4Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-profile-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_profile%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M25%2C17a4%2C4%2C0%2C1%2C1-4-4%2C4%2C4%2C0%2C0%2C1%2C4%2C4m2%2C0a6%2C6%2C0%2C1%2C0-6%2C6%2C6%2C6%2C0%2C0%2C0%2C6-6m-6%2C7.39L9.36%2C30.58l.94%2C1.77L21%2C26.66l10.7%2C5.69.94-1.77Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-search-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_search%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M23%2C9a8%2C8%2C0%2C0%2C0-4.6%2C14.53L13%2C33.7l1.77.94%2C5.41-10.18A8%2C8%2C0%2C1%2C0%2C23%2C9Zm0%2C14a6%2C6%2C0%2C1%2C1%2C6-6A6%2C6%2C0%2C0%2C1%2C23%2C23Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-shopping-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_shopping_cart%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M41%2C21A20%2C20%2C0%2C1%2C1%2C21%2C1%2C20%2C20%2C0%2C0%2C1%2C41%2C21%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M29%2C33a2%2C2%2C0%2C1%2C1-2-2A2%2C2%2C0%2C0%2C1%2C29%2C33ZM17%2C31a2%2C2%2C0%2C1%2C0%2C2%2C2A2%2C2%2C0%2C0%2C0%2C17%2C31ZM31%2C15v6h0l-7.58%2C4v0H13a2%2C2%2C0%2C0%2C0%2C2%2C2H29v2H15a4%2C4%2C0%2C0%2C1-4-4V15H7V13h6v2Zm-2%2C2H13v6H23l6-3.2Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-talk-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_talk%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M31%2C19c0%2C3-2%2C5.51-5%2C6.89l-9%2C4.78V26.27c-3.52-1.24-6-4-6-7.27%2C0-4.42%2C4.48-8%2C10-8s10%2C3.58%2C10%2C8m2%2C0c0-5.52-5.37-10-12-10S9%2C13.48%2C9%2C19c0%2C3.69%2C2.42%2C6.88%2C6%2C8.6V34l12.94-6.88h0A9.54%2C9.54%2C0%2C0%2C0%2C33%2C19%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-telephone-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_telephone%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M31.11%2C31.49l-3.75-7.06-4.54%2C0-3.64-6.84%2C2.49-3.69L18%2C6.76h0L14.44%2C8.64h0A6%2C6%2C0%2C0%2C0%2C12%2C16.76h0l7.51%2C14.13h0a6%2C6%2C0%2C0%2C0%2C8.11%2C2.48h0l3.53-1.88Zm-4.47.11h0a4%2C4%2C0%2C0%2C1-5.41-1.65L13.72%2C15.82a4%2C4%2C0%2C0%2C1%2C1.65-5.41h0l1.77-.94%2C2.24%2C4.21-2.53%2C3.75h0l4.79%2C9h4.5l2.27%2C4.26-1.76.94Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-tiles-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_tiles%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M13%2C9a4%2C4%2C0%2C0%2C0-4%2C3.83H9V19H19V9Zm4%2C8H11V13a2%2C2%2C0%2C0%2C1%2C2-2h4Zm16-4a4%2C4%2C0%2C0%2C0-4-4H23V19H33V13Zm-2%2C4H25V11h4a2%2C2%2C0%2C0%2C1%2C2%2C2ZM9%2C23v6a4%2C4%2C0%2C0%2C0%2C4%2C4h6V23Zm8%2C8H13a2%2C2%2C0%2C0%2C1-2-2V25h6Zm6-8V33h6a4%2C4%2C0%2C0%2C0%2C4-4V23Zm6%2C8H25V25h6v4A2%2C2%2C0%2C0%2C1%2C29%2C31Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-upload-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_upload%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C1A20%2C20%2C0%2C1%2C0%2C41%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C1%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M9%2C19V17a6%2C6%2C0%2C0%2C1%2C6-6H27a6%2C6%2C0%2C0%2C1%2C6%2C6v2H31V17a4%2C4%2C0%2C0%2C0-4-4H15a4%2C4%2C0%2C0%2C0-4%2C4v2Zm11%2C6v8h2V25h3.62L21%2C17l-4.62%2C8Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-unlock-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_unlock%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M21%2C15V13h0A6%2C6%2C0%2C0%2C0%2C9%2C13H9v4h2V13a4%2C4%2C0%2C0%2C1%2C8%2C0v2H15V25a6%2C6%2C0%2C0%2C0%2C6%2C6h8a6%2C6%2C0%2C0%2C0%2C6-6V15ZM33%2C25a4%2C4%2C0%2C0%2C1-4%2C4H21a4%2C4%2C0%2C0%2C1-2.88-1.21L33%2C19.88V25Zm0-7.39L17.14%2C26A4%2C4%2C0%2C0%2C1%2C17%2C25h0V17H33Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-website-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_website%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M9%2C11V27a6%2C6%2C0%2C0%2C0%2C6%2C6H27a6%2C6%2C0%2C0%2C0%2C6-6V11Zm6%2C4V13h2v2Zm-2-2v2H11V13ZM31%2C27a4%2C4%2C0%2C0%2C1-4%2C4H15a4%2C4%2C0%2C0%2C1-4-4V17H31Zm0-12H19V13H31ZM18.61%2C21l8%2C.28-4.24%2C6.78L21%2C25.5l-5.3%2C2.82-.94-1.77%2C5.3-2.82Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-x-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_x%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpolygon%20class%3D%22cls-2%22%20points%3D%2227.78%2013.63%2026.36%2012.22%2020%2018.59%2013.64%2012.22%2012.22%2013.64%2018.59%2020%2012.22%2026.36%2013.64%2027.78%2020%2021.41%2026.36%2027.78%2027.78%2026.36%2021.41%2020%2027.78%2013.63%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-yen-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23002d72%3B%7D.cls-2%7Bfill%3A%23fff%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_circle_b_rgb_yen%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpolygon%20class%3D%22cls-2%22%20points%3D%2221.01%2022%2025%2022%2025%2020%2021.01%2020%2021.01%2018.2%2030.57%2013.11%2029.63%2011.34%2019.98%2016.48%2010.33%2011.34%209.39%2013.11%2019.01%2018.23%2019.01%2020%2015%2020%2015%2022%2019.01%2022%2019.01%2024%2015%2024%2015%2026%2019.01%2026%2019.01%2032%2021.01%2032%2021.01%2026%2025%2026%2025%2024%2021.01%2024%2021.01%2022%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-location-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3C!--%20Generator%3A%20Adobe%20Illustrator%2022.0.1%2C%20SVG%20Export%20Plug-In%20.%20SVG%20Version%3A%206.00%20Build%200%29%20%20--%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22Layer%5f1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2040%2040%22%20style%3D%22enable-background%3Anew%200%200%2040%2040%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill%3A%23002A54%3B%7D%0A%3C%2Fstyle%3E%0A%3Cg%3E%0A%09%3Ccircle%20class%3D%22st0%22%20cx%3D%2220%22%20cy%3D%2217%22%20r%3D%224%22%2F%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M20%2C9c-4.3%2C0-8%2C3.5-8%2C7.7c0%2C2.8%2C2.7%2C7.5%2C8%2C14c5.3-6.5%2C8-11.3%2C8-14C28%2C12.5%2C24.3%2C9%2C20%2C9z%20M20%2C22%0A%09%09c-2.8%2C0-5-2.2-5-5s2.2-5%2C5-5s5%2C2.2%2C5%2C5S22.8%2C22%2C20%2C22z%22%2F%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M20%2C1C9.5%2C1%2C1%2C9.5%2C1%2C20s8.5%2C19%2C19%2C19s19-8.5%2C19-19S30.5%2C1%2C20%2C1z%20M20.4%2C31.8c-0.2%2C0.2-0.6%2C0.2-0.8%2C0%0A%09%09c-5.7-7-8.6-12-8.6-15.1C11%2C12%2C15.1%2C8%2C20%2C8s9%2C3.9%2C9%2C8.7C29%2C19.8%2C26.1%2C24.9%2C20.4%2C31.8z%22%2F%3E%0A%3C%2Fg%3E%0A%3C%2Fsvg%3E%0A);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-service-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20version%3D%221.1%22%20id%3D%22Layer%5f1%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%2040%2040%22%20style%3D%22enable-background%3Anew%200%200%2040%2040%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill%3A%23002A54%3B%7D%0A%3C%2Fstyle%3E%0A%3Cg%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M30%2C18.99963h-2v7h2c0.55298%2C0%2C1-0.44702%2C1-1v-5C31%2C19.44763%2C30.55298%2C18.99963%2C30%2C18.99963z%22%2F%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M20%2C0.99963c-10.49341%2C0-19%2C8.50659-19%2C19s8.50659%2C19%2C19%2C19s19-8.50659%2C19-19S30.49341%2C0.99963%2C20%2C0.99963z%20%20%20%20M32%2C24.99963c0%2C1.104-0.896%2C2-2%2C2h-0.86499c-0.73499%2C1.25-1.98499%2C1.79596-4.73303%2C2.396%20%20%20c-0.07996%2C0.01697-0.23297%2C0.04895-0.40198%2C0.086v0.51801c0%2C0.55298-0.44702%2C1-1%2C1h-4c-0.552%2C0-1-0.44702-1-1v-2%20%20%20c0-0.55304%2C0.448-1%2C1-1h4c0.55298%2C0%2C1%2C0.44696%2C1%2C1v0.45898c0.07703-0.01703%2C0.146-0.03101%2C0.18903-0.04102%20%20%20c2.00098-0.43597%2C3.07495-0.81897%2C3.70697-1.43896C27.39502%2C26.92358%2C27%2C26.51562%2C27%2C25.99963v-7c0-0.552%2C0.44702-1%2C1-1h1%20%20%20c0-4.586-3.79999-8-8.75-8s-8.75%2C3.414-8.75%2C8H12c0.552%2C0%2C1%2C0.448%2C1%2C1v7c0%2C0.55298-0.448%2C1-1%2C1h-2c-1.104%2C0-2-0.896-2-2v-5%20%20%20c0-1.104%2C0.896-2%2C2-2h0.5c0-5.164%2C4.271-9%2C9.75-9s9.75%2C3.836%2C9.75%2C9c1.104%2C0%2C2%2C0.896%2C2%2C2V24.99963z%22%2F%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M22.75519%2C27.99963h-3.51038C19.10962%2C27.99963%2C19%2C28.10919%2C19%2C28.24445v1.51038%20%20%20c0%2C0.13519%2C0.10962%2C0.24481%2C0.24481%2C0.24481h3.51038c0.13519%2C0%2C0.24481-0.10962%2C0.24481-0.24481v-1.51038%20%20%20C23%2C28.10919%2C22.89038%2C27.99963%2C22.75519%2C27.99963z%22%2F%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M9%2C20.24445v4.51038c0%2C0.68744%2C0.55731%2C1.24481%2C1.24481%2C1.24481h1.51038%20%20%20c0.13519%2C0%2C0.24481-0.10962%2C0.24481-0.24481v-6.51038c0-0.13525-0.10962-0.24481-0.24481-0.24481h-1.51038%20%20%20C9.55731%2C18.99963%2C9%2C19.55695%2C9%2C20.24445z%22%2F%3E%0A%3C%2Fg%3E%0A%3C%2Fsvg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-pointer-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20version%3D%221.1%22%20id%3D%22Layer%5f1%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%2040%2040%22%20style%3D%22enable-background%3Anew%200%200%2040%2040%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill%3A%23002A54%3B%7D%0A%3C%2Fstyle%3E%0A%3Cg%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M20%2C1C9.5%2C1%2C1%2C9.5%2C1%2C20s8.5%2C19%2C19%2C19s19-8.5%2C19-19S30.5%2C1%2C20%2C1z%20M27.4%2C9l-0.5%2C15.9c0%2C0.4-0.4%2C0.6-0.8%2C0.4%20%20%20l-3.9-2.2l-4.8%2C8.2c-0.1%2C0.2-0.4%2C0.3-0.7%2C0.2L12.5%2C29c-0.2-0.1-0.3-0.4-0.2-0.7l4.8-8.2l-3.9-2.2c-0.3-0.2-0.3-0.7%2C0-0.9l13.5-8.4%20%20%20c0.1-0.1%2C0.2-0.1%2C0.3-0.1C27.2%2C8.5%2C27.4%2C8.7%2C27.4%2C9L27.4%2C9z%22%2F%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M18%2C19.4c0.2%2C0.1%2C0.3%2C0.4%2C0.2%2C0.7l-4.8%2C8.2l3.5%2C2l4.8-8.2c0.1-0.2%2C0.4-0.3%2C0.7-0.2L26%2C24l0.4-14.1l-12%2C7.4%20%20%20L18%2C19.4z%22%2F%3E%0A%3C%2Fg%3E%0A%3C%2Fsvg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-cardPin-dark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20version%3D%221.1%22%20id%3D%22Layer%5f1%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%2040%2040%22%20style%3D%22enable-background%3Anew%200%200%2040%2040%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill%3A%23002A54%3B%7D%0A%3C%2Fstyle%3E%0A%3Cg%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M8.99957%2C27.28558c0%2C0.39801%2C0.30005%2C0.71405%2C0.65002%2C0.71405H30.3496%20%20%20c0.35101%2C0%2C0.64996-0.31604%2C0.64996-0.71405V15.99963h-22v11.28595H8.99957z%20M26.5%2C20.99963h2c0.66699%2C0%2C0.66699%2C1%2C0%2C1h-2%20%20%20C25.83301%2C21.99963%2C25.83301%2C20.99963%2C26.5%2C20.99963z%20M21.5%2C20.99963h2c0.66699%2C0%2C0.66699%2C1%2C0%2C1h-2%20%20%20C20.83301%2C21.99963%2C20.83301%2C20.99963%2C21.5%2C20.99963z%20M16.5%2C20.99963h2c0.66699%2C0%2C0.66699%2C1%2C0%2C1h-2%20%20%20C15.83301%2C21.99963%2C15.83301%2C20.99963%2C16.5%2C20.99963z%20M11.5%2C20.99963h2c0.66699%2C0%2C0.66699%2C1%2C0%2C1h-2%20%20%20C10.83301%2C21.99963%2C10.83301%2C20.99963%2C11.5%2C20.99963z%22%2F%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M30.34961%2C11.99963H9.6496c-0.34998%2C0-0.65002%2C0.31598-0.65002%2C0.71399v2.28601h22v-2.28601%20%20%20C30.99957%2C12.31561%2C30.70062%2C11.99963%2C30.34961%2C11.99963z%22%2F%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M20%2C0.99963c-10.49341%2C0-19%2C8.50659-19%2C19s8.50659%2C19%2C19%2C19s19-8.50659%2C19-19S30.49341%2C0.99963%2C20%2C0.99963z%20%20%20%20M31.99957%2C27.28558c0%2C0.93805-0.73395%2C1.71405-1.64996%2C1.71405H9.6496c-0.914%2C0-1.65002-0.776-1.65002-1.71405V12.71362%20%20%20c0-0.93799%2C0.73602-1.71399%2C1.65002-1.71399h20.70001c0.91602%2C0%2C1.64996%2C0.776%2C1.64996%2C1.71399%20%20%20C31.99957%2C12.71362%2C31.99957%2C27.28558%2C31.99957%2C27.28558z%22%2F%3E%0A%3C%2Fg%3E%0A%3C%2Fsvg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-trash{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_trash%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M33%2C12H27a4%2C4%2C0%2C0%2C0-4-4H19a4%2C4%2C0%2C0%2C0-4%2C4H9v2h2V30a4%2C4%2C0%2C0%2C0%2C4%2C4H27a4%2C4%2C0%2C0%2C0%2C4-4V14h2ZM19%2C10h4a2%2C2%2C0%2C0%2C1%2C2%2C2H17A2%2C2%2C0%2C0%2C1%2C19%2C10ZM29%2C30a2%2C2%2C0%2C0%2C1-2%2C2H15a2%2C2%2C0%2C0%2C1-2-2V27.21L29%2C18.7Zm0-13.57L13%2C24.94V14H29Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-four{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_4_arrows%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M41%2C21A20%2C20%2C0%2C1%2C1%2C21%2C1%2C20%2C20%2C0%2C0%2C1%2C41%2C21%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpolygon%20class%3D%22cls-2%22%20points%3D%2236%2020%2028%2015.38%2028%2019%2021%2019%2021%2012%2024.62%2012%2020%204%2015.38%2012%2019%2012%2019%2019%2012%2019%2012%2015.38%204%2020%2012%2024.62%2012%2021%2019%2021%2019%2028%2015.38%2028%2020%2036%2024.62%2028%2021%2028%2021%2021%2028%2021%2028%2024.62%2036%2020%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-arrowdown{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_arrow_down%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M41%2C21A20%2C20%2C0%2C1%2C1%2C21%2C1%2C20%2C20%2C0%2C0%2C1%2C41%2C21%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M20%2C9V30.7a2%2C2%2C0%2C0%2C1-.58-.5L13.28%2C18.65l-1.77.94%2C5.73%2C10.77h0a4%2C4%2C0%2C0%2C0%2C7.44.17l5.8-10.94-1.77-.94-5.87%2C11a2%2C2%2C0%2C0%2C1-.86%2C1V9Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-arrowleft{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_arrow_left%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C1%2C41%2C21%2C20%2C20%2C0%2C0%2C1%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M33%2C20H11.3a2%2C2%2C0%2C0%2C1%2C.5-.58l11.55-6.14-.94-1.77L11.64%2C17.24v0a4%2C4%2C0%2C0%2C0-.17%2C7.44l10.94%2C5.8.94-1.77-11-5.87a2%2C2%2C0%2C0%2C1-1-.86H33Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-arrowright{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_arrow_riwht%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C1A20%2C20%2C0%2C1%2C1%2C1%2C21%2C20%2C20%2C0%2C0%2C1%2C21%2C1%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M9%2C22H30.7a2%2C2%2C0%2C0%2C1-.5.58L18.65%2C28.72l.94%2C1.77%2C10.77-5.73v0a4%2C4%2C0%2C0%2C0%2C.16-7.44l-10.94-5.8-.94%2C1.77%2C11%2C5.87a2%2C2%2C0%2C0%2C1%2C1%2C.86H9Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-arrowup{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_arrow_up%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M1%2C21A20%2C20%2C0%2C1%2C1%2C21%2C41%2C20%2C20%2C0%2C0%2C1%2C1%2C21%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M22%2C33V11.3a2%2C2%2C0%2C0%2C1%2C.57.5l6.14%2C11.55%2C1.77-.94L24.77%2C11.64h0a4%2C4%2C0%2C0%2C0-7.44-.17l-5.8%2C10.94%2C1.77.94%2C5.87-11a2%2C2%2C0%2C0%2C1%2C.86-1V33Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-calendar{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_calendar%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M33%2C11H27V9H25v2H17V9H15v2H9V27a6%2C6%2C0%2C0%2C0%2C6%2C6H27a6%2C6%2C0%2C0%2C0%2C6-6h0ZM15%2C13v2h2V13h8v2h2V13h4v4H11V13ZM31%2C27a4%2C4%2C0%2C0%2C1-4%2C4H15a4%2C4%2C0%2C0%2C1-4-4V19H31Zm-4.74-6%2C.94%2C1.77-9.65%2C5.09-.94-1.77h0L15%2C22.93%2C16.77%2C22l1.65%2C3.16Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-branch{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_branch%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C1A20%2C20%2C0%2C1%2C1%2C1%2C21%2C20%2C20%2C0%2C0%2C1%2C21%2C1%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M33%2C17V13h0a2%2C2%2C0%2C0%2C0-2-2H11a2%2C2%2C0%2C0%2C0-2%2C2H9v4h2V29H9v2H33V29H31V17Zm-2-4v2H11V13ZM21%2C21v8H17V21Zm8%2C8H23V19H15V29H13V17H29Zm-2-4H25V21h2v4Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-bubble{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_bubble%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M26.22%2C13.89C24.7%2C11%2C21.15%2C9%2C17%2C9%2C11.48%2C9%2C7%2C12.58%2C7%2C17c0%2C3%2C2%2C5.48%2C5%2C6.86v5.41l5.23-2.82a9%2C9%2C0%2C0%2C0%2C1.88%2C1.62l11.14%2C6V28.66c3-1.37%2C5-3.91%2C5-6.86C35.25%2C17.65%2C31.28%2C14.29%2C26.22%2C13.89ZM9%2C17c0-3.31%2C3.58-6%2C8-6s8%2C2.69%2C8%2C6a5.51%2C5.51%2C0%2C0%2C1-2.79%2C4.52L14%2C25.94V22.52C11.08%2C21.63%2C9%2C19.51%2C9%2C17ZM28.25%2C27.32v3.42L20%2C26.32a6.54%2C6.54%2C0%2C0%2C1-1-.83l4.13-2.22A7.51%2C7.51%2C0%2C0%2C0%2C27%2C17a6.44%2C6.44%2C0%2C0%2C0-.13-1c3.63.56%2C6.38%2C2.93%2C6.38%2C5.82C33.25%2C24.31%2C31.17%2C26.43%2C28.25%2C27.32Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-chart{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_chart%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M17%2C29a4%2C4%2C0%2C0%2C1-4-3.81V23.09l4.94-2.63%2C1.81%2C3.4%2C11.61-6.18-.94-1.77-9.85%2C5.24-1.81-3.39L13%2C20.82V13H11V25.22A6%2C6%2C0%2C0%2C0%2C17%2C31H31V29Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-checkmark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_checkmark%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpolygon%20class%3D%22cls-2%22%20points%3D%2231.9%2014.46%2015.3%2023.29%2011.77%2016.64%2010%2017.58%2014.46%2026%2032.84%2016.23%2031.9%2014.46%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-roundarrows{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_circlearrows%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C1A20%2C20%2C0%2C1%2C1%2C1%2C21%2C20%2C20%2C0%2C0%2C1%2C21%2C1%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M31.45%2C26.81a12%2C12%2C0%2C0%2C1-21.16-.27l1.73-1a10%2C10%2C0%2C0%2C0%2C17.66.35l-3.21-1.7%2C7.84-4.9.32%2C9.23ZM26.59%2C10.41a12%2C12%2C0%2C0%2C0-16.16%2C4.85L7.37%2C13.62l.32%2C9.23L15.52%2C18l-3.32-1.77a10%2C10%2C0%2C0%2C1%2C17.67.32l1.73-1A11.94%2C11.94%2C0%2C0%2C0%2C26.59%2C10.41Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-creditCard{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_creditcard%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M21%2C23v2H11V23Zm14-8h0V27a4%2C4%2C0%2C0%2C1-4%2C4H11a4%2C4%2C0%2C0%2C1-4-4V15H7a4%2C4%2C0%2C0%2C1%2C4-4H31a4%2C4%2C0%2C0%2C1%2C4%2C4ZM11%2C29H21.44L33%2C22.85V19H9v8A2%2C2%2C0%2C0%2C0%2C11%2C29Zm22-2V25.12L25.7%2C29H31A2%2C2%2C0%2C0%2C0%2C33%2C27Zm0-12a2%2C2%2C0%2C0%2C0-2-2H11a2%2C2%2C0%2C0%2C0-2%2C2v2H33Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-currency{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_currency_bill%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M7%2C13V29H35V13Zm26%2C7.88L24.18%2C25.6A6.48%2C6.48%2C0%2C0%2C0%2C26%2C21c0-3.19-2.08-5.77-4.7-6v0H33ZM9%2C15h7.49L9%2C19Zm12%2C2c1.66%2C0%2C3%2C1.79%2C3%2C4s-1.34%2C4-3%2C4-3-1.79-3-4S19.34%2C17%2C21%2C17ZM9%2C21.22l8.5-4.5A6.61%2C6.61%2C0%2C0%2C0%2C16%2C21c0%2C3.24%2C2.14%2C5.86%2C4.82%2C6v0H9ZM25.84%2C27%2C33%2C23.18V27Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-docuarrow{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_docuarrow%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M11%2C9V33H24.13l5.09-2.67A4%2C4%2C0%2C0%2C0%2C31%2C27h0V9ZM27.73%2C28.85l-4%2C2.15H23V27h6A2%2C2%2C0%2C0%2C1%2C27.73%2C28.85ZM21%2C25v6H13V11H29v6H23V14l-7%2C4%2C7%2C4V19h6v6Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-docucheck{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_docucheck%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M11%2C9V33H24.14l5.08-2.7h0A4%2C4%2C0%2C0%2C0%2C31%2C27h0V9ZM29%2C27a2%2C2%2C0%2C0%2C1-1.27%2C1.85l-4%2C2.15H23V27Zm0-2H21v6H13V11H29ZM17.53%2C21.84%2C15%2C16.93%2C16.72%2C16l1.65%2C3.15L26.24%2C15l.94%2C1.77Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-document{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_document%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C1%2C41%2C21%2C20%2C20%2C0%2C0%2C1%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M11%2C9V33H24.13l5.08-2.7h0A4%2C4%2C0%2C0%2C0%2C31%2C27h0V9ZM29%2C27a2%2C2%2C0%2C0%2C1-1.27%2C1.85l-4%2C2.15H23V27Zm0-2H21v6H13V11H29ZM27%2C15H15V13H27ZM15%2C19V17h8v2Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-dollar{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_dollar%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M22.32%2C34.26H19.79v-3.8a9.09%2C9.09%2C0%2C0%2C1-5.15-2.56l-.18-.19%2C1.74-1.94.21.2a6.7%2C6.7%2C0%2C0%2C0%2C4.72%2C2.14c2.36%2C0%2C3.71-1%2C3.71-2.76%2C0-1.55-.95-2.34-4.23-3.52-3.74-1.34-5.51-2.5-5.51-5.51%2C0-2.6%2C1.75-4.37%2C4.7-4.78V7.74h2.53v3.76a8.53%2C8.53%2C0%2C0%2C1%2C4.62%2C2l.22.17-1.67%2C2-.21-.18A6.17%2C6.17%2C0%2C0%2C0%2C21%2C13.88c-2.14%2C0-3.31.82-3.31%2C2.31%2C0%2C1.27.4%2C2%2C4.2%2C3.33%2C4.25%2C1.53%2C5.54%2C2.87%2C5.54%2C5.72s-2%2C4.79-5.12%2C5.21Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-download{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_download%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M33%2C23v2a6%2C6%2C0%2C0%2C1-6%2C6H15a6%2C6%2C0%2C0%2C1-6-6V23h2v2a4%2C4%2C0%2C0%2C0%2C4%2C4H27a4%2C4%2C0%2C0%2C0%2C4-4V23ZM22%2C17V9H20v8H16.38L21%2C25l4.62-8Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-envelop{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_envelope%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M33%2C15h0V13H9V25a6%2C6%2C0%2C0%2C0%2C6%2C6H27a6%2C6%2C0%2C0%2C0%2C6-6V15ZM31%2C25a4%2C4%2C0%2C0%2C1-4%2C4H15a4%2C4%2C0%2C0%2C1-4-4h0V19.75l10%2C5.32%2C10-5.27Zm0-7.46L21%2C22.83%2C11%2C17.49V15H31Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-euro{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_euro%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M22%2C31c-3.13%2C0-5.75-3-6.64-7H21V22H15.07c0-.33-.07-.66-.07-1s0-.67.07-1H21V18H15.36c.89-4%2C3.52-7%2C6.64-7a6.26%2C6.26%2C0%2C0%2C1%2C5.09%2C3.16l1.73-.92C27.17%2C10.67%2C24.74%2C9%2C22%2C9c-4.2%2C0-7.71%2C3.83-8.71%2C9H11v2h2c0%2C.33%2C0%2C.66%2C0%2C1s0%2C.67%2C0%2C1H11v2h2.3c1%2C5.17%2C4.52%2C9%2C8.71%2C9%2C2.74%2C0%2C5.16-1.67%2C6.8-4.25l-1.71-.91A6.25%2C6.25%2C0%2C0%2C1%2C22%2C31Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-jbp{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_GBP%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M27.17%2C26.86a4%2C4%2C0%2C0%2C1-3.73%2C2.59%2C3.65%2C3.65%2C0%2C0%2C1-1.54-.37v0L19%2C27.56V21h6V19H19V15h0a4%2C4%2C0%2C0%2C1%2C4-4%2C3.94%2C3.94%2C0%2C0%2C1%2C2.56%2C1l1.88-1A6%2C6%2C0%2C0%2C0%2C17%2C15h0v4H15v2h2v6.29l-4%2C2.13.94%2C1.77%2C3.8-2%2C2.83%2C1.51a5.79%2C5.79%2C0%2C0%2C0%2C.52.28l.37.13a5.83%2C5.83%2C0%2C0%2C0%2C2%2C.38A6%2C6%2C0%2C0%2C0%2C29%2C27.8Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-info{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_info%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M23%2C13a2%2C2%2C0%2C1%2C1-2-2%2C2%2C2%2C0%2C0%2C1%2C2%2C2m12%2C8A14%2C14%2C0%2C1%2C0%2C21%2C35%2C14%2C14%2C0%2C0%2C0%2C35%2C21m2%2C0A16%2C16%2C0%2C1%2C1%2C21%2C5%2C16%2C16%2C0%2C0%2C1%2C37%2C21M23%2C17.09l-4.74%2C2.52.94%2C1.77%2C1.8-1V31h2Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-laptop{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_laptop%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M31%2C25V11H11V25H7a6%2C6%2C0%2C0%2C0%2C6%2C6H29a6%2C6%2C0%2C0%2C0%2C6-6ZM13%2C13h8.43L13%2C17.48Zm0%2C6.75L25.69%2C13H29V25H13ZM29%2C29H13a4%2C4%2C0%2C0%2C1-3.46-2H32.47A4%2C4%2C0%2C0%2C1%2C29%2C29Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-lightbulb{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_lightbulb%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C1%2C41%2C21%2C20%2C20%2C0%2C0%2C1%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M17%2C29h8v2H17Zm2%2C6h4V33H19Zm6.44-18.14-.94-1.77L21%2C17%2C17.5%2C15.1l-.94%2C1.77L21%2C19.22h0Zm-.44%2C7V27H17V23.87a8%2C8%2C0%2C1%2C1%2C8%2C0ZM27%2C17a6%2C6%2C0%2C1%2C0-8%2C5.63V25h4V22.63A6%2C6%2C0%2C0%2C0%2C27%2C17Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-list{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_list%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M15%2C11H31v2H15Zm0%2C14H31V23H15Zm0%2C6H31V29H15Zm0-12H31V17H15Zm-3-6a1%2C1%2C0%2C1%2C0-1-1%2C1%2C1%2C0%2C0%2C0%2C1%2C1m0%2C12a1%2C1%2C0%2C1%2C0-1-1%2C1%2C1%2C0%2C0%2C0%2C1%2C1m0-6a1%2C1%2C0%2C1%2C0-1-1%2C1%2C1%2C0%2C0%2C0%2C1%2C1m0%2C12a1%2C1%2C0%2C1%2C0-1-1%2C1%2C1%2C0%2C0%2C0%2C1%2C1%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-lock{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_lock%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M27%2C15V13h0a6%2C6%2C0%2C1%2C0-12%2C0v2H11v2h0v8a6%2C6%2C0%2C0%2C0%2C6%2C6h8a6%2C6%2C0%2C0%2C0%2C6-6V15ZM17%2C13a4%2C4%2C0%2C1%2C1%2C8%2C0h0v2H17ZM29%2C25a4%2C4%2C0%2C0%2C1-4%2C4H17a4%2C4%2C0%2C0%2C1-2.89-1.23L29%2C19.88Zm0-7.39L13.14%2C26A3.87%2C3.87%2C0%2C0%2C1%2C13%2C25V17H29Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-mapping{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_mappin%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M29%2C17c0%2C4.73-8%2C14.9-8%2C14.9S13%2C21.73%2C13%2C17a7.81%2C7.81%2C0%2C0%2C1%2C8-8%2C7.81%2C7.81%2C0%2C0%2C1%2C8%2C8m2%2C0a10%2C10%2C0%2C0%2C0-20%2C0c0%2C5.52%2C10%2C18%2C10%2C18S31%2C22.52%2C31%2C17m-6%2C0a4%2C4%2C0%2C1%2C1-4-4%2C4%2C4%2C0%2C0%2C1%2C4%2C4m2%2C0a6%2C6%2C0%2C1%2C0-6%2C6%2C6%2C6%2C0%2C0%2C0%2C6-6%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-menu{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_menu%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M11%2C15H31v2H11Zm0%2C12H31V25H11Zm0-5H31V20H11Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-minus{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_minus%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpolygon%20class%3D%22cls-2%22%20points%3D%2210%2021%2029%2021%2030%2021%2030%2019%2010%2019%2010%2021%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-mobile{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3C!--%20Generator%3A%20Adobe%20Illustrator%2022.0.1%2C%20SVG%20Export%20Plug-In%20.%20SVG%20Version%3A%206.00%20Build%200%29%20%20--%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22Layer%5f1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2040%2040%22%20style%3D%22enable-background%3Anew%200%200%2040%2040%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill%3A%23002A54%3B%7D%0A%3C%2Fstyle%3E%0A%3Cpath%20class%3D%22st0%22%20d%3D%22M15.5%2C7.99963c-1.40002%2C0-2.5%2C1.09998-2.5%2C2.5v1.5v1v14v1v1.5c0%2C1.39996%2C1.09998%2C2.5%2C2.5%2C2.5h9%0A%09c1.40002%2C0%2C2.5-1.10004%2C2.5-2.5v-1.5v-1v-14v-1v-1.5c0-1.40002-1.09998-2.5-2.5-2.5H15.5z%20M26%2C29.49963%0A%09c0%2C0.79999-0.70001%2C1.5-1.5%2C1.5h-9c-0.79999%2C0-1.5-0.70001-1.5-1.5v-1.5h12V29.49963z%20M26%2C26.99963H14v-14h12V26.99963z%0A%09%20M26%2C10.49963v1.5H14v-1.5c0-0.80005%2C0.70001-1.5%2C1.5-1.5h9C25.29999%2C8.99963%2C26%2C9.69958%2C26%2C10.49963z%22%2F%3E%0A%3C%2Fsvg%3E%0A);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-pencil{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_pencil%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M27%2C25.89l2-1.06V29a4%2C4%2C0%2C0%2C1-4%2C4H13a4%2C4%2C0%2C0%2C1-4-4V13a4%2C4%2C0%2C0%2C1%2C4-4H25a4%2C4%2C0%2C0%2C1%2C3.86%2C3.31L27%2C13.3V13a2%2C2%2C0%2C0%2C0-2-2H13a2%2C2%2C0%2C0%2C0-2%2C2V29a2%2C2%2C0%2C0%2C0%2C2%2C2H25a2%2C2%2C0%2C0%2C0%2C2-2Zm11.14-8L20%2C27.51H14.1l-1-1.88%2C3.25-4.82%2C0-.06L34.55%2C11.1ZM19.91%2C21.14l1.72%2C3.24%2C9.25-4.92-1.72-3.24Zm-.4%2C4.37.36-.19-1.72-3.24-.36.19L15.6%2C25.51ZM35.44%2C17%2C33.72%2C13.8l-2.8%2C1.49%2C1.72%2C3.24Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-people{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_people%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M28%2C19a5%2C5%2C0%2C1%2C0-5-5A5%2C5%2C0%2C0%2C0%2C28%2C19Zm0-8a3%2C3%2C0%2C1%2C1-3%2C3A3%2C3%2C0%2C0%2C1%2C28%2C11ZM14%2C19a5%2C5%2C0%2C1%2C0-5-5A5%2C5%2C0%2C0%2C0%2C14%2C19Zm0-8a3%2C3%2C0%2C1%2C1-3%2C3A3%2C3%2C0%2C0%2C1%2C14%2C11Zm.77%2C10.43A3.9%2C3.9%2C0%2C0%2C0%2C13%2C21a4%2C4%2C0%2C0%2C0-4%2C4H9v8H21V24.72l-6.19-3.29ZM19%2C31H11V25h0a2%2C2%2C0%2C0%2C1%2C2-2%2C3.51%2C3.51%2C0%2C0%2C1%2C1%2C.27l5%2C2.66Zm14-6h0v8H23V31h8V25a2%2C2%2C0%2C0%2C0-2-2%2C2%2C2%2C0%2C0%2C0-1%2C.3v0l-5%2C2.66V23.66l4.19-2.23A7.37%2C7.37%2C0%2C0%2C1%2C29%2C21%2C4%2C4%2C0%2C0%2C1%2C33%2C25Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-piggybank{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_piwwybank%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C1%2C41%2C21%2C20%2C20%2C0%2C0%2C1%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M25.74%2C18.37A5.55%2C5.55%2C0%2C0%2C0%2C22%2C17a5.62%2C5.62%2C0%2C0%2C0-3.62%2C1.25l-1.83-1a7.66%2C7.66%2C0%2C0%2C1%2C11%2C.12ZM32.36%2C17A7.5%2C7.5%2C0%2C0%2C1%2C33%2C20a8.38%2C8.38%2C0%2C0%2C1-4%2C6.87V31H15V26.87A9.22%2C9.22%2C0%2C0%2C1%2C11.7%2C23H9V17h2.72A8.41%2C8.41%2C0%2C0%2C1%2C13%2C15V9h2l4.36%2C2.28A12.69%2C12.69%2C0%2C0%2C1%2C22%2C11a11.68%2C11.68%2C0%2C0%2C1%2C9.36%2C4.28l1.4-.74.94%2C1.76ZM31%2C20c0-3.87-4-7-9-7a11.24%2C11.24%2C0%2C0%2C0-2.88.39L15%2C11.26v4.37A6.39%2C6.39%2C0%2C0%2C0%2C13.13%2C19H11v2h2.13A7.12%2C7.12%2C0%2C0%2C0%2C17%2C25.76V29h4V27h2v2h4V25.76C29.36%2C24.5%2C31%2C22.39%2C31%2C20Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-playbutton{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_play_button%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M29%2C11H13a6%2C6%2C0%2C0%2C0-6%2C6v8a6%2C6%2C0%2C0%2C0%2C6%2C6H29a6%2C6%2C0%2C0%2C0%2C6-6V17A6%2C6%2C0%2C0%2C0%2C29%2C11Zm4%2C14.19A4%2C4%2C0%2C0%2C1%2C29.2%2C29H12.81A4%2C4%2C0%2C0%2C1%2C9%2C25.19V16.81A4%2C4%2C0%2C0%2C1%2C12.81%2C13H29.2A4%2C4%2C0%2C0%2C1%2C33%2C16.81ZM18%2C26.34a1%2C1%2C0%2C0%2C1-1-1V16.66a1%2C1%2C0%2C0%2C1%2C.48-.86%2C1%2C1%2C0%2C0%2C1%2C1%2C0l8.17%2C4.33a1%2C1%2C0%2C0%2C1%2C0%2C1.77l-8.17%2C4.34A1%2C1%2C0%2C0%2C1%2C18%2C26.34Zm1-8v5.35L24%2C21Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-plus{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_plus%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpolygon%20class%3D%22cls-2%22%20points%3D%2230%2019%2021%2019%2021%2010%2019%2010%2019%2019%2010%2019%2010%2021%2019%2021%2019%2030%2021%2030%2021%2021%2030%2021%2030%2019%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-print{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_print%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M29%2C19h2v2H29Zm6%2C0v8H29v4H13V27H7V19a4%2C4%2C0%2C0%2C1%2C4-4h2V9H29v6h2A4%2C4%2C0%2C0%2C1%2C35%2C19ZM15%2C15H27V11H15Zm0%2C14H27V23H15Zm18-8V19a2%2C2%2C0%2C0%2C0-2-2H11a2%2C2%2C0%2C0%2C0-2%2C2v6h4V21H29v4h4Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-profile{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_profile%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M25%2C17a4%2C4%2C0%2C1%2C1-4-4%2C4%2C4%2C0%2C0%2C1%2C4%2C4m2%2C0a6%2C6%2C0%2C1%2C0-6%2C6%2C6%2C6%2C0%2C0%2C0%2C6-6m-6%2C7.39L9.36%2C30.58l.94%2C1.77L21%2C26.66l10.7%2C5.69.94-1.77Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-search{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_search%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M23%2C9a8%2C8%2C0%2C0%2C0-4.6%2C14.53L13%2C33.7l1.77.94%2C5.41-10.18A8%2C8%2C0%2C1%2C0%2C23%2C9Zm0%2C14a6%2C6%2C0%2C1%2C1%2C6-6A6%2C6%2C0%2C0%2C1%2C23%2C23Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-shopping{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_shoppinw_cart%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M41%2C21A20%2C20%2C0%2C1%2C1%2C21%2C1%2C20%2C20%2C0%2C0%2C1%2C41%2C21%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M29%2C33a2%2C2%2C0%2C1%2C1-2-2A2%2C2%2C0%2C0%2C1%2C29%2C33ZM17%2C31a2%2C2%2C0%2C1%2C0%2C2%2C2A2%2C2%2C0%2C0%2C0%2C17%2C31ZM31%2C15v6h0l-7.58%2C4v0H13a2%2C2%2C0%2C0%2C0%2C2%2C2H29v2H15a4%2C4%2C0%2C0%2C1-4-4V15H7V13h6v2Zm-2%2C2H13v6H23l6-3.2Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-talk{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_talk%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M31%2C19c0%2C3-2%2C5.51-5%2C6.89l-9%2C4.78V26.27c-3.52-1.24-6-4-6-7.27%2C0-4.42%2C4.48-8%2C10-8s10%2C3.58%2C10%2C8m2%2C0c0-5.52-5.37-10-12-10S9%2C13.48%2C9%2C19c0%2C3.69%2C2.42%2C6.88%2C6%2C8.6V34l12.94-6.88h0A9.54%2C9.54%2C0%2C0%2C0%2C33%2C19%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-telephone{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_telephone%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M31.11%2C31.49l-3.75-7.06-4.54%2C0-3.64-6.84%2C2.49-3.69L18%2C6.76h0L14.44%2C8.64h0A6%2C6%2C0%2C0%2C0%2C12%2C16.76h0l7.51%2C14.13h0a6%2C6%2C0%2C0%2C0%2C8.11%2C2.48h0l3.53-1.88Zm-4.47.11h0a4%2C4%2C0%2C0%2C1-5.41-1.65L13.72%2C15.82a4%2C4%2C0%2C0%2C1%2C1.65-5.41h0l1.77-.94%2C2.24%2C4.21-2.53%2C3.75h0l4.79%2C9h4.5l2.27%2C4.26-1.76.94Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-tiles{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_tiles%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M13%2C9a4%2C4%2C0%2C0%2C0-4%2C3.83H9V19H19V9Zm4%2C8H11V13a2%2C2%2C0%2C0%2C1%2C2-2h4Zm16-4a4%2C4%2C0%2C0%2C0-4-4H23V19H33V13Zm-2%2C4H25V11h4a2%2C2%2C0%2C0%2C1%2C2%2C2ZM9%2C23v6a4%2C4%2C0%2C0%2C0%2C4%2C4h6V23Zm8%2C8H13a2%2C2%2C0%2C0%2C1-2-2V25h6Zm6-8V33h6a4%2C4%2C0%2C0%2C0%2C4-4V23Zm6%2C8H25V25h6v4A2%2C2%2C0%2C0%2C1%2C29%2C31Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-upload{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_upload%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C1A20%2C20%2C0%2C1%2C0%2C41%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C1%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M9%2C19V17a6%2C6%2C0%2C0%2C1%2C6-6H27a6%2C6%2C0%2C0%2C1%2C6%2C6v2H31V17a4%2C4%2C0%2C0%2C0-4-4H15a4%2C4%2C0%2C0%2C0-4%2C4v2Zm11%2C6v8h2V25h3.62L21%2C17l-4.62%2C8Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-unlock{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_unlock%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M21%2C15V13h0A6%2C6%2C0%2C0%2C0%2C9%2C13H9v4h2V13a4%2C4%2C0%2C0%2C1%2C8%2C0v2H15V25a6%2C6%2C0%2C0%2C0%2C6%2C6h8a6%2C6%2C0%2C0%2C0%2C6-6V15ZM33%2C25a4%2C4%2C0%2C0%2C1-4%2C4H21a4%2C4%2C0%2C0%2C1-2.88-1.21L33%2C19.88V25Zm0-7.39L17.14%2C26A4%2C4%2C0%2C0%2C1%2C17%2C25h0V17H33Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-wear{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_wear%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M21%2C16a5%2C5%2C0%2C1%2C0%2C5%2C5A5%2C5%2C0%2C0%2C0%2C21%2C16Zm0%2C8a3%2C3%2C0%2C1%2C1%2C3-3A3%2C3%2C0%2C0%2C1%2C21%2C24Zm11-1.27a11.06%2C11.06%2C0%2C0%2C0%2C0-3.46l3.13-1.8-4-6.93L28%2C12.34a11.08%2C11.08%2C0%2C0%2C0-3-1.73V7H17v3.57a11%2C11%2C0%2C0%2C0-1.59.74%2C10.82%2C10.82%2C0%2C0%2C0-1.43%2C1l-3.1-1.79-4%2C6.93L10%2C19.27a11.28%2C11.28%2C0%2C0%2C0%2C0%2C3.46l-3.12%2C1.8h0l4%2C6.93L14%2C29.66a11.16%2C11.16%2C0%2C0%2C0%2C3%2C1.73V35h8V31.43a9.8%2C9.8%2C0%2C0%2C0%2C3-1.75l3.09%2C1.79%2C4-6.93Zm-1.6%2C6-2.57-1.48A8.72%2C8.72%2C0%2C0%2C1%2C23%2C30v3H19V30a9.23%2C9.23%2C0%2C0%2C1-4.84-2.77l-2.55%2C1.47-2-3.46%2C2.55-1.47a9.26%2C9.26%2C0%2C0%2C1%2C0-5.58L9.61%2C16.73l2-3.46%2C2.56%2C1.48A8.74%2C8.74%2C0%2C0%2C1%2C19%2C12V9h4v3a9.26%2C9.26%2C0%2C0%2C1%2C4.85%2C2.78l2.55-1.47%2C2%2C3.46L29.85%2C18.2a9.23%2C9.23%2C0%2C0%2C1%2C0%2C5.58l2.57%2C1.48Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-website{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_website%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M9%2C11V27a6%2C6%2C0%2C0%2C0%2C6%2C6H27a6%2C6%2C0%2C0%2C0%2C6-6V11Zm6%2C4V13h2v2Zm-2-2v2H11V13ZM31%2C27a4%2C4%2C0%2C0%2C1-4%2C4H15a4%2C4%2C0%2C0%2C1-4-4V17H31Zm0-12H19V13H31ZM18.61%2C21l8%2C.28-4.24%2C6.78L21%2C25.5l-5.3%2C2.82-.94-1.77%2C5.3-2.82Z%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-x{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_x%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpolygon%20class%3D%22cls-2%22%20points%3D%2227.78%2013.63%2026.36%2012.22%2020%2018.59%2013.64%2012.22%2012.22%2013.64%2018.59%2020%2012.22%2026.36%2013.64%2027.78%2020%2021.41%2026.36%2027.78%2027.78%2026.36%2021.41%2020%2027.78%2013.63%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-ensurance{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3C!--%20Generator%3A%20Adobe%20Illustrator%2022.0.1%2C%20SVG%20Export%20Plug-In%20.%20SVG%20Version%3A%206.00%20Build%200%29%20%20--%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22Layer%5f1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2040%2040%22%20style%3D%22enable-background%3Anew%200%200%2040%2040%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill%3A%23002A54%3B%7D%0A%3C%2Fstyle%3E%0A%3Cg%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M23.3576%2C25.86871l-1.00403-1.00494c-0.19495-0.19501-0.51196-0.19501-0.70697%2C0%0A%09%09c-0.19501%2C0.19495-0.19501%2C0.51196%2C0%2C0.70697l1.00397%2C1.005c0.586%2C0.586%2C1.53601%2C0.586%2C2.12103%2C0l0.02197-0.02301l3.44299-3.58698%0A%09%09c0.19-0.19904%2C0.18402-0.51501-0.01495-0.70703c-0.19904-0.19098-0.51703-0.18396-0.70703%2C0.01501%0A%09%09c-2.29797%2C2.39398-3.44696%2C3.59198-3.45001%2C3.59497C23.86859%2C26.06372%2C23.55261%2C26.06372%2C23.3576%2C25.86871z%22%2F%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M26.08002%2C10.81073L18%2C8.08173c-0.32397-0.10999-0.677-0.10999-1.00098%2C0.00104l-8.00201%2C2.72699%0A%09%09C8.39899%2C11.01373%2C8%2C11.55573%2C8%2C12.16473v8.61798c0%2C2.854%2C1.396%2C5.54303%2C3.77301%2C7.263l4.82599%2C3.49506%0A%09%09c0.53302%2C0.38495%2C1.26801%2C0.38599%2C1.80298%2C0.00195c0.70404-0.57495%2C1.18604-0.96399%2C1.45703-1.177%0A%09%09c1.27802%2C1.00903%2C2.88696%2C1.61505%2C4.64099%2C1.61505c4.14301%2C0%2C7.5-3.35706%2C7.5-7.5c0-3.23303-2.04999-5.98004-4.91797-7.03406%0A%09%09v-5.27997C27.08203%2C11.5567%2C26.68103%2C11.01367%2C26.08002%2C10.81073z%20M17.80298%2C30.77673%0A%09%09c-0.17896%2C0.12799-0.42395%2C0.12701-0.60199-0.00098l-4.82501-3.49402C10.25%2C25.74274%2C9%2C23.33575%2C9%2C20.78271v-8.61798%0A%09%09c0-0.20398%2C0.133-0.38397%2C0.33301-0.45197l8.00098-2.72803c0.10803-0.03601%2C0.22601-0.03601%2C0.33405%2C0l8.07996%2C2.729%0A%09%09c0.20001%2C0.06799%2C0.33405%2C0.24896%2C0.33405%2C0.453v4.98401c-0.51105-0.10901-1.039-0.17004-1.58203-0.17004%0A%09%09c-0.20697%2C0-0.41101%2C0.01501-0.61401%2C0.03101v-2.35895c0-0.617-0.41199-1.16602-1.02301-1.362l-5.03296-1.62006%0A%09%09c-0.31799-0.10199-0.66302-0.09998-0.97803%2C0.00806l-4.73798%2C1.60699c-0.599%2C0.20398-0.99902%2C0.74597-0.99902%2C1.35498v5.96198%0A%09%09c0%2C1.55804%2C0.71899%2C3.03503%2C1.96503%2C4.03705l3.31598%2C2.66595c0.367%2C0.29504%2C0.84198%2C0.37903%2C1.28503%2C0.28503%0A%09%09c0.36096%2C0.789%2C0.85095%2C1.50598%2C1.448%2C2.11896L17.80298%2C30.77673z%20M17.328%2C26.67377c-0.10303-0.005-0.20502-0.03503-0.289-0.10205%0A%09%09l-3.31598-2.66595c-1.02002-0.82001-1.60803-2.02899-1.60803-3.30304v-5.96198c0-0.203%2C0.133-0.38403%2C0.33301-0.45203%0A%09%09l4.73798-1.60699c0.10504-0.03601%2C0.22003-0.03699%2C0.32605-0.00299l5.03296%2C1.62c0.203%2C0.065%2C0.341%2C0.24799%2C0.341%2C0.45404v2.50696%0A%09%09C19.52002%2C17.89874%2C17%2C20.89374%2C17%2C24.48077C17%2C25.24475%2C17.11603%2C25.98077%2C17.328%2C26.67377z%20M31%2C24.48077%0A%09%09c0%2C3.58997-2.90997%2C6.5-6.5%2C6.5s-6.5-2.91003-6.5-6.5c0-3.59003%2C2.90997-6.50006%2C6.5-6.50006S31%2C20.89075%2C31%2C24.48077z%22%2F%3E%0A%3C%2Fg%3E%0A%3C%2Fsvg%3E%0A);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-yen{background-image:url(data:image/svg+xml;charset=US-ASCII,%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23002d72%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Ebf_primary_b_rgb_yen%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M21%2C41A20%2C20%2C0%2C1%2C0%2C1%2C21%2C20%2C20%2C0%2C0%2C0%2C21%2C41%22%20transform%3D%22translate%28-1%20-1%29%22/%3E%3Cpolygon%20class%3D%22cls-2%22%20points%3D%2221.01%2022%2025%2022%2025%2020%2021.01%2020%2021.01%2018.2%2030.57%2013.11%2029.63%2011.34%2019.98%2016.48%2010.33%2011.34%209.39%2013.11%2019.01%2018.23%2019.01%2020%2015%2020%2015%2022%2019.01%2022%2019.01%2024%2015%2024%2015%2026%2019.01%2026%2019.01%2032%2021.01%2032%2021.01%2026%2025%2026%2025%2024%2021.01%2024%2021.01%2022%22/%3E%3C/svg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-location{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3C!--%20Generator%3A%20Adobe%20Illustrator%2022.0.1%2C%20SVG%20Export%20Plug-In%20.%20SVG%20Version%3A%206.00%20Build%200%29%20%20--%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22Layer%5f1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2040%2040%22%20style%3D%22enable-background%3Anew%200%200%2040%2040%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill%3A%23002A54%3B%7D%0A%3C%2Fstyle%3E%0A%3Cg%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M11%2C16.69958c0%2C3.10004%2C2.90002%2C8.10004%2C8.59998%2C15.10004c0.20001%2C0.20001%2C0.60004%2C0.20001%2C0.80005%2C0%0A%09%09C26.09998%2C24.8996%2C29%2C19.79962%2C29%2C16.69958c0-4.79999-4.09998-8.69995-9-8.69995S11%2C11.99963%2C11%2C16.69958z%20M28%2C16.69958%0A%09%09c0%2C2.70001-2.70001%2C7.5-8%2C14c-5.29999-6.5-8-11.19995-8-14c0-4.19995%2C3.70001-7.69995%2C8-7.69995S28%2C12.49963%2C28%2C16.69958z%22%2F%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M15%2C16.99963c0%2C2.79999%2C2.20001%2C5%2C5%2C5s5-2.20001%2C5-5c0-2.80005-2.20001-5-5-5S15%2C14.19958%2C15%2C16.99963z%0A%09%09%20M24%2C16.99963c0%2C2.20911-1.79083%2C4-4%2C4s-4-1.79089-4-4c0-2.20917%2C1.79083-4%2C4-4S24%2C14.79047%2C24%2C16.99963z%22%2F%3E%0A%3C%2Fg%3E%0A%3C%2Fsvg%3E%0A);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-service{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3C!--%20Generator%3A%20Adobe%20Illustrator%2022.0.1%2C%20SVG%20Export%20Plug-In%20.%20SVG%20Version%3A%206.00%20Build%200%29%20%20--%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22Layer%5f1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%2040%2040%22%20style%3D%22enable-background%3Anew%200%200%2040%2040%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill%3A%23002A54%3B%7D%0A%3C%2Fstyle%3E%0A%3Cpath%20class%3D%22st0%22%20d%3D%22M23%2C26.99927h-4c-0.552%2C0-1%2C0.44696-1%2C1v2c0%2C0.55298%2C0.448%2C1%2C1%2C1h4c0.55298%2C0%2C1-0.44702%2C1-1v-0.51801%0A%09c0.16901-0.03705%2C0.32202-0.06903%2C0.40198-0.086c2.74805-0.60004%2C3.99805-1.146%2C4.73303-2.396H30c1.104%2C0%2C2-0.89606%2C2-2v-5%0A%09c0-1.104-0.896-2-2-2c0-5.164-4.271-9-9.75-9s-9.75%2C3.836-9.75%2C9H10c-1.104%2C0-2%2C0.896-2%2C2v5c0%2C1.10394%2C0.896%2C2%2C2%2C2h2%0A%09c0.552%2C0%2C1-0.44702%2C1-1v-7c0-0.552-0.448-1-1-1h-0.5c0-4.586%2C3.79999-8%2C8.75-8s8.75%2C3.414%2C8.75%2C8h-1c-0.55298%2C0-1%2C0.448-1%2C1v7%0A%09c0%2C0.51599%2C0.39502%2C0.92395%2C0.896%2C0.979c-0.63202%2C0.62-1.70599%2C1.00299-3.70697%2C1.43896%0A%09c-0.04303%2C0.01003-0.112%2C0.024-0.18903%2C0.04103v-0.45898C24%2C27.44623%2C23.55298%2C26.99927%2C23%2C26.99927z%20M23%2C29.75446%0A%09c0%2C0.13519-0.10962%2C0.24481-0.24481%2C0.24481h-3.51038C19.10962%2C29.99927%2C19%2C29.88965%2C19%2C29.75446v-1.51038%0A%09c0-0.13525%2C0.10962-0.24481%2C0.24481-0.24481h3.51038c0.13519%2C0%2C0.24481%2C0.10956%2C0.24481%2C0.24481V29.75446z%20M11.75519%2C18.99927%0A%09c0.13519%2C0%2C0.24481%2C0.10956%2C0.24481%2C0.24481v6.51038c0%2C0.13519-0.10962%2C0.24481-0.24481%2C0.24481h-1.51038%0A%09C9.55731%2C25.99927%2C9%2C25.44189%2C9%2C24.75446v-4.51038c0-0.6875%2C0.55731-1.24481%2C1.24481-1.24481H11.75519z%20M28%2C18.99927h2%0A%09c0.55298%2C0%2C1%2C0.448%2C1%2C1v5c0%2C0.55298-0.44702%2C1-1%2C1h-2V18.99927z%22%2F%3E%0A%3C%2Fsvg%3E%0A);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-pointer{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20version%3D%221.1%22%20id%3D%22Layer%5f1%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%2040%2040%22%20style%3D%22enable-background%3Anew%200%200%2040%2040%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill%3A%23002A54%3B%7D%0A%3C%2Fstyle%3E%0A%3Cpath%20class%3D%22st0%22%20d%3D%22M12.5%2C28.99963l4.20001%2C2.5c0.29999%2C0.09998%2C0.59998%2C0%2C0.70001-0.20001l4.79999-8.20001l3.89996%2C2.20001%20%20c0.40002%2C0.20001%2C0.80005%2C0%2C0.80005-0.40002l0.5-15.89996c0-0.30005-0.20001-0.5-0.40002-0.5c-0.09998%2C0-0.20001%2C0-0.29999%2C0.09998%20%20l-13.5%2C8.40002c-0.29999%2C0.19995-0.29999%2C0.69995%2C0%2C0.89996l3.89996%2C2.20001l-4.79999%2C8.20001%20%20C12.20001%2C28.59961%2C12.29999%2C28.8996%2C12.5%2C28.99963z%20M18.20001%2C20.09961c0.09998-0.29999%2C0-0.59998-0.20001-0.70001%20%20l-3.59998-2.09998l12-7.40002L26%2C23.99963l-3.59998-2.10004c-0.30005-0.09998-0.60004%2C0-0.70001%2C0.20001l-4.79999%2C8.20001l-3.5-2%20%20L18.20001%2C20.09961z%22%2F%3E%0A%3C%2Fsvg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-cardPin{background-image:url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20version%3D%221.1%22%20id%3D%22Layer%5f1%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%2040%2040%22%20style%3D%22enable-background%3Anew%200%200%2040%2040%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%09.st0%7Bfill%3A%23002A54%3B%7D%0A%3C%2Fstyle%3E%0A%3Cg%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M11.5%2C21.99927h2c0.66699%2C0%2C0.66699-1%2C0-1h-2C10.83301%2C20.99927%2C10.83301%2C21.99927%2C11.5%2C21.99927z%22%2F%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M16.5%2C21.99927h2c0.66699%2C0%2C0.66699-1%2C0-1h-2C15.83301%2C20.99927%2C15.83301%2C21.99927%2C16.5%2C21.99927z%22%2F%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M26.5%2C21.99927h2c0.66699%2C0%2C0.66699-1%2C0-1h-2C25.83301%2C20.99927%2C25.83301%2C21.99927%2C26.5%2C21.99927z%22%2F%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M9.6496%2C10.99927c-0.914%2C0-1.65002%2C0.776-1.65002%2C1.71399v14.57196c0%2C0.93805%2C0.73602%2C1.71405%2C1.65002%2C1.71405%20%20%20h20.70001c0.91602%2C0%2C1.64996-0.776%2C1.64996-1.71405V12.71326c0-0.93799-0.73395-1.71399-1.64996-1.71399%20%20%20C30.34961%2C10.99927%2C9.6496%2C10.99927%2C9.6496%2C10.99927z%20M30.99957%2C27.28522c0%2C0.39801-0.29895%2C0.71405-0.64996%2C0.71405H9.6496%20%20%20c-0.34998%2C0-0.65002-0.31604-0.65002-0.71405V15.99927h22C30.99958%2C15.99927%2C30.99958%2C27.28522%2C30.99957%2C27.28522z%20%20%20%20M30.99957%2C12.71326v2.28601h-22v-2.28601c0-0.39801%2C0.30005-0.71399%2C0.65002-0.71399H30.3496%20%20%20C30.70062%2C11.99927%2C30.99957%2C12.31525%2C30.99957%2C12.71326z%22%2F%3E%0A%09%3Cpath%20class%3D%22st0%22%20d%3D%22M21.5%2C21.99927h2c0.66699%2C0%2C0.66699-1%2C0-1h-2C20.83301%2C20.99927%2C20.83301%2C21.99927%2C21.5%2C21.99927z%22%2F%3E%0A%3C%2Fg%3E%0A%3C%2Fsvg%3E);background-repeat:no-repeat;width:20px;height:24px;background-size:20px 24px}.cbolui-icon-red-icon_X+.cbolui-icon-text,.cbolui-icon-green-checkmark+.cbolui-icon-text,.cbolui-icon-lg-red-error+.cbolui-icon-text{flex:1;-webkit-box-flex:1;-ms-flex:1;margin-top:20px}.icon-GreenCheck{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%0A%3Csvg%20width%3D%2220px%22%20height%3D%2220px%22%20viewBox%3D%220%200%2020%2020%22%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%3E%0A%20%20%20%20%3C%21--%20Generator%3A%20Sketch%2046.1%20%2844463%29%20-%20http%3A//www.bohemiancoding.com/sketch%20--%3E%0A%20%20%20%20%3Ctitle%3EIcon%3C/title%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C/desc%3E%0A%20%20%20%20%3Cdefs%3E%3C/defs%3E%0A%20%20%20%20%3Cg%20id%3D%22P1.-Banner-Alerts%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%221.1A_Desktop%22%20transform%3D%22translate%28-60.000000%2C%20-809.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Page-Level%22%20transform%3D%22translate%280.000000%2C%20213.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22White-Banner%22%20transform%3D%22translate%2820.000000%2C%20470.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Success-Banner%22%20transform%3D%22translate%280.000000%2C%20104.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icon%22%20transform%3D%22translate%2840.000000%2C%2022.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22Oval-5%22%20fill%3D%22%23006E0A%22%20cx%3D%2210%22%20cy%3D%2210%22%20r%3D%2210%22%3E%3C/circle%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpolygon%20id%3D%22Fill-4%22%20fill%3D%22%23FFFFFF%22%20points%3D%228.24403195%2012.0121714%205.68262639%209.50897143%204.28571429%2010.8737714%208.24403195%2014.7421714%2016.394286%206.79377143%2014.9969739%205.42857143%22%3E%3C/polygon%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%3C/g%3E%0A%3C/svg%3E);background-repeat:no-repeat;width:20px}.icon-RedAlert{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%0A%3Csvg%20width%3D%2220px%22%20height%3D%2220px%22%20viewBox%3D%220%200%2020%2020%22%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%3E%0A%20%20%20%20%3C%21--%20Generator%3A%20Sketch%2046.1%20%2844463%29%20-%20http%3A//www.bohemiancoding.com/sketch%20--%3E%0A%20%20%20%20%3Ctitle%3EIcon%3C/title%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C/desc%3E%0A%20%20%20%20%3Cdefs%3E%3C/defs%3E%0A%20%20%20%20%3Cg%20id%3D%22P1.-Banner-Alerts%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%221.1A_Desktop%22%20transform%3D%22translate%28-60.000000%2C%20-705.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Page-Level%22%20transform%3D%22translate%280.000000%2C%20213.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22White-Banner%22%20transform%3D%22translate%2820.000000%2C%20470.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Critical-Banner%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icon%22%20transform%3D%22translate%2840.000000%2C%2022.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22red-base%22%20fill%3D%22%23D60000%22%20cx%3D%2210%22%20cy%3D%2210%22%20r%3D%2210%22%3E%3C/circle%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M11.48%2C8.608%20L11.48%2C4%20L9.24%2C4%20L9.24%2C8.608%20L9.608%2C11.68%20L11.112%2C11.68%20L11.48%2C8.608%20Z%20M11.72%2C14.016%20C11.72%2C13.28%2011.096%2C12.656%2010.36%2C12.656%20C9.624%2C12.656%209%2C13.28%209%2C14.016%20C9%2C14.752%209.624%2C15.376%2010.36%2C15.376%20C11.096%2C15.376%2011.72%2C14.752%2011.72%2C14.016%20L11.72%2C14.016%20Z%22%20id%3D%22%21%22%20fill%3D%22%23FFFFFF%22%3E%3C/path%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%3C/g%3E%0A%3C/svg%3E);background-repeat:no-repeat;width:20px}.icon-BlueSpeech{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%0A%3Csvg%20width%3D%2216px%22%20height%3D%2216px%22%20viewBox%3D%220%200%2016%2016%22%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%3E%0A%20%20%20%20%3C%21--%20Generator%3A%20Sketch%2046.1%20%2844463%29%20-%20http%3A//www.bohemiancoding.com/sketch%20--%3E%0A%20%20%20%20%3Ctitle%3EIcon%3C/title%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C/desc%3E%0A%20%20%20%20%3Cdefs%3E%3C/defs%3E%0A%20%20%20%20%3Cg%20id%3D%22P1.-Banner-Alerts%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%221.1A_Desktop%22%20transform%3D%22translate%28-62.000000%2C%20-916.000000%29%22%20fill%3D%22%23056DAE%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Page-Level%22%20transform%3D%22translate%280.000000%2C%20213.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22White-Banner%22%20transform%3D%22translate%2820.000000%2C%20470.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Marketing-Banner%22%20transform%3D%22translate%280.000000%2C%20208.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icon%22%20transform%3D%22translate%2840.000000%2C%2022.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Alert-Bubble%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icon%22%20transform%3D%22translate%282.000000%2C%203.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Sq%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2216%22%20height%3D%2211%22%3E%3C/rect%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpolygon%20id%3D%22Tri%22%20points%3D%224%2011%2011%2011%204%2016%22%3E%3C/polygon%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%3C/g%3E%0A%3C/svg%3E);background-repeat:no-repeat;width:20px}\n"] }]
        }], ctorParameters: () => [], propDecorators: { idStr: [{
                type: Input$1
            }], title: [{
                type: Input$1
            }], iconTextMessage: [{
                type: Input$1
            }], isSROnly: [{
                type: Input$1
            }], alertTextColor: [{
                type: Input$1
            }], iconType: [{
                type: Input$1
            }], iconName: [{
                type: Input$1
            }], circle: [{
                type: Input$1
            }] } });

class Icons {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Icons, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: Icons, declarations: [IconComponent], imports: [CommonModule], exports: [IconComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Icons, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Icons, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [IconComponent],
                    exports: [IconComponent]
                }]
        }] });

/**
 * @Component: Nav Group
 * @Section: Navigation
 * @description This is in page navigation component to create
 * from Bootstrap.
*/
class NavGroupComponent {
    set activeTab(tabNum) {
        this._activeTab = tabNum;
        this.changeTab(tabNum);
    }
    addTab(tab) {
        if (this.tabContent) {
            if (this.tabContent.nativeElement.children.length === 0) {
                this.tabs = [];
            }
        }
        this.tabs.push(tab);
        return this.tabs.length - 1;
    }
    countTabs() {
        return this.tabs.length;
    }
    constructor(el) {
        this.el = el;
        /**
         * @property activeTab
         * @description This defines the active panel of in page navigation
         * @return number
        */
        this._activeTab = 0;
        this.activeTabChange = new EventEmitter();
        this.tabs = [];
        this.tabsFocused = false;
        this.shiftOn = false;
        /**
         * @Event: tabChanged
         * @description This event that is fired when a tab activates; returns the index of the active tab (first tab is 1)
         * @return Number
         */
        this.tabChanged = new EventEmitter();
    }
    ngOnInit() {
        this.tabLength = this.tabs.length;
    }
    ngAfterViewInit() {
        this.selectTab(this.tabs[this._activeTab]);
        // Attaches the trigger button to the tab pages
        if (this.tabs.length > 0) {
            const triggerButtons = this.el.nativeElement.querySelectorAll('ul.nav > li > a');
            this.tabs.forEach((tab, index) => {
                tab.triggerButton = triggerButtons[index];
                tab.tabFocusTrigger.subscribe(function (isActivated) {
                    if (isActivated) {
                        this.triggerButton.focus();
                    }
                }.bind(tab));
            });
        }
    }
    selectTab(tab) {
        if (!!tab) {
            this.tabs.forEach((tab2) => {
                tab2.isExpanded = false;
                tab2.tabIndexAttr = -1;
                tab2.tabFocusTrigger.emit(false);
            });
            tab.isExpanded = true;
            tab.tabIndexAttr = 0;
            tab.tabFocusTrigger.emit(true);
            // Event emitter
            this.tabChanged.emit(tab.tabIndex);
            this.activeTabChange.emit(tab.tabIndex);
        }
    }
    changeTab(tabNum) {
        if (!this.tabs[0])
            return;
        this.tabs.forEach((tab) => tab.isExpanded = false);
        this.tabs[tabNum].isExpanded = true;
        this.tabChanged.emit(tabNum);
        this.activeTabChange.emit(tabNum);
    }
    tablistFocus() {
        this.tabsFocused = true;
    }
    tabToContent() {
        this.tabsFocused = false;
        this.tabContent.nativeElement.focus();
    }
    currentTab() {
        return this.tabs.findIndex(tab => tab.isExpanded);
    }
    prevTab() {
        const curIndex = this.currentTab();
        const tab = (curIndex === 0)
            ? this.tabs[this.tabs.length]
            : this.tabs[curIndex - 1];
        this.selectTab(tab);
    }
    nextTab() {
        const curIndex = this.currentTab();
        let tab;
        if (curIndex === (this.tabs.length)) {
            tab = this.tabs[0];
        }
        else {
            tab = this.tabs[curIndex + 1];
        }
        this.selectTab(tab);
    }
    stopBubble(event) {
        event.preventDefault();
        event.stopPropagation();
    }
    handleKeyPress(event) {
        if (this.tabsFocused) {
            const keycode = event.which;
            switch (keycode) {
                case KEY_HOME:
                    this.stopBubble(event);
                    this.selectTab(this.tabs[0]);
                    break;
                case KEY_END:
                    this.stopBubble(event);
                    this.selectTab(this.tabs[this.tabs.length]);
                    break;
                case KEY_ARROW_LEFT:
                case KEY_ARROW_UP:
                    this.stopBubble(event);
                    this.prevTab();
                    break;
                case KEY_ARROW_RIGHT:
                case KEY_ARROW_DOWN:
                    this.stopBubble(event);
                    this.nextTab();
                    break;
            }
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: NavGroupComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: NavGroupComponent, isStandalone: false, selector: "citi-nav-group", inputs: { idStr: "idStr", activeTab: "activeTab", htmlContent: "htmlContent" }, outputs: { activeTabChange: "activeTabChange", tabChanged: "tabChanged" }, host: { listeners: { ":keydown": "handleKeyPress($event)" } }, viewQueries: [{ propertyName: "tabContent", first: true, predicate: ["tabContent"], descendants: true }], ngImport: i0, template: `
  <div class [attr.id]="idStr">
    <section [class]="'in-page-nav tabs-'+tabLength">

        <div class="container-fluid">
            <ul class="nav nav-pills nav-justified" role="tablist">
                <li *ngFor="let tab of tabs; let idx = index" role="presentation" [class]="(tab.isExpanded ? 'active' : '')" (click)="selectTab(tab); $event.preventDefault()">
                    <a href="#" id="{{idStr}}-{{idx}}-Tab" attr.aria-controls="{{idStr}}-panel-{{idx}}" role="tab" [attr.aria-selected]="(tab.isExpanded ? 'true' : 'false')" data-toggle="tab"
                        (focus)="tablistFocus()" [tabindex]="(tab.isExpanded ? 0 : -1)">
                        <span class="nav-pill-tab-content" [innerHtml]="tab.tabTitle"></span>
                    </a>
                </li>
            </ul>
          </div>

          <div class="tab-content noPadding" #tabContent [contentHtml]="htmlContent">
              <ng-content></ng-content>
          </div>

      </section>
  </div>

  `, isInline: true, styles: [".noPadding{padding:0}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: NavGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-nav-group', standalone: false, template: `
  <div class [attr.id]="idStr">
    <section [class]="'in-page-nav tabs-'+tabLength">

        <div class="container-fluid">
            <ul class="nav nav-pills nav-justified" role="tablist">
                <li *ngFor="let tab of tabs; let idx = index" role="presentation" [class]="(tab.isExpanded ? 'active' : '')" (click)="selectTab(tab); $event.preventDefault()">
                    <a href="#" id="{{idStr}}-{{idx}}-Tab" attr.aria-controls="{{idStr}}-panel-{{idx}}" role="tab" [attr.aria-selected]="(tab.isExpanded ? 'true' : 'false')" data-toggle="tab"
                        (focus)="tablistFocus()" [tabindex]="(tab.isExpanded ? 0 : -1)">
                        <span class="nav-pill-tab-content" [innerHtml]="tab.tabTitle"></span>
                    </a>
                </li>
            </ul>
          </div>

          <div class="tab-content noPadding" #tabContent [contentHtml]="htmlContent">
              <ng-content></ng-content>
          </div>

      </section>
  </div>

  `, host: { '(:keydown)': 'handleKeyPress($event)' }, styles: [".noPadding{padding:0}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { tabContent: [{
                type: ViewChild,
                args: ['tabContent']
            }], idStr: [{
                type: Input$1
            }], activeTab: [{
                type: Input$1
            }], activeTabChange: [{
                type: Output
            }], htmlContent: [{
                type: Input$1
            }], tabChanged: [{
                type: Output
            }] } });

/**
 * @Component: Nav Panel
 * @Section: Navigation
 * @description This is the nav panel component and is used to create panel in the nav group
 * from Bootstrap.
*/
class NavPanelComponent {
    constructor(parent, el) {
        this.parent = parent;
        this.el = el;
        // Set classes on host <citi-tab> tag
        this.classTabPane = true;
        this.classLevel1 = true;
        this.classParent = true;
        this.isExpanded = false;
        this.tabFocusTrigger = new EventEmitter();
        this.triggerButton = null;
        this.tabgroup = parent;
        this.tabIndex = this.tabgroup.addTab(this);
        this.tabIndexAttr = -1;
    }
    ngOnInit() {
        let totalTabs = this.tabgroup.countTabs();
        this.lastTab = this.tabIndex === totalTabs;
        this.isExpanded = this.tabIndex === this.tabgroup.defaultTab;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: NavPanelComponent, deps: [{ token: NavGroupComponent }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: NavPanelComponent, isStandalone: false, selector: "citi-nav-panel", inputs: { tabTitle: ["title", "tabTitle"], htmlContent: "htmlContent" }, host: { properties: { "class.tab-pane": "this.classTabPane", "class.level1": "this.classLevel1", "class.parent": "this.classParent", "class.active": "this.isExpanded" } }, ngImport: i0, template: `
  <div role="tabpanel"
    id="{{tabgroup.idStr}}-panel-{{tabIndex}}"
    attr.aria-labelledby="{{tabgroup.idStr}}-panel-{{tabIndex}}"
    class="tab-pane active transcript container-fluid"
    [contentHtml]="htmlContent">
    <ng-content></ng-content>
  </div>

  `, isInline: true, styles: [""], dependencies: [{ kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: NavPanelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-nav-panel', standalone: false, template: `
  <div role="tabpanel"
    id="{{tabgroup.idStr}}-panel-{{tabIndex}}"
    attr.aria-labelledby="{{tabgroup.idStr}}-panel-{{tabIndex}}"
    class="tab-pane active transcript container-fluid"
    [contentHtml]="htmlContent">
    <ng-content></ng-content>
  </div>

  ` }]
        }], ctorParameters: () => [{ type: NavGroupComponent }, { type: i0.ElementRef }], propDecorators: { classTabPane: [{
                type: HostBinding,
                args: ['class.tab-pane']
            }], classLevel1: [{
                type: HostBinding,
                args: ['class.level1']
            }], classParent: [{
                type: HostBinding,
                args: ['class.parent']
            }], isExpanded: [{
                type: HostBinding,
                args: ['class.active']
            }], tabTitle: [{
                type: Input$1,
                args: ['title']
            }], htmlContent: [{
                type: Input$1
            }] } });

const COMPONENTS$O = [
    NavGroupComponent,
    NavPanelComponent
];
const MODULES$P = [
    CommonModule,
    ContentHtml
];
class InPageNavigation {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: InPageNavigation, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: InPageNavigation, declarations: [NavGroupComponent,
            NavPanelComponent], imports: [CommonModule,
            ContentHtml], exports: [NavGroupComponent,
            NavPanelComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: InPageNavigation, imports: [MODULES$P] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: InPageNavigation, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$P],
                    declarations: [...COMPONENTS$O],
                    exports: [...COMPONENTS$O]
                }]
        }] });

class MaskingService {
    getMask(type) {
        switch (type) {
            case 'phone': return MaskTypes.phoneMask;
            case 'date': return MaskTypes.dateMask;
            case 'zipcode': return MaskTypes.zipcodeMask;
            case 'dollar': return MaskTypes.dollarMask;
            case 'email': return emailMask;
            case 'ssn': return MaskTypes.ssnMask;
            case 'fullSsnMasking': return MaskTypes.ssnFullMask;
            case 'fullDateMasking': return MaskTypes.dateFullMask;
            case 'fullZipcodeMasking': return MaskTypes.zipCodeFullMask;
            case 'fullPhoneMasking': return MaskTypes.phoneFullMask;
            case 'partialPhoneMasking': return MaskTypes.phonePartialMask;
            case 'partialEmailMasking': return MaskTypes.emailPartialMask;
            case 'fullTextMasking': return MaskTypes.textFullMask;
            case 'partialTextMasking': return MaskTypes.textPartialMask;
            default: return null;
        }
    }
    static getAvailableMaskNames() {
        return ['phone', 'date', 'zipcode', 'dollar', 'email', 'ssn', 'fullSsnMasking', 'fullDateMasking',
            'fullZipcodeMasking', 'fullPhoneMasking', 'partialPhoneMasking', 'partialEmailMasking', 'fullTextMasking',
            'partialTextMasking'];
    }
    static isValidMaskName(name) {
        return MaskingService.getAvailableMaskNames().indexOf(name) > -1;
    }
    getPhoneMask() {
        return MaskTypes.phoneMask;
    }
    getDateMask() {
        return MaskTypes.dateMask;
    }
    getZipcodeMask() {
        return MaskTypes.zipcodeMask;
    }
    getDollarMask() {
        return MaskTypes.dollarMask;
    }
    getEmailMask() {
        return emailMask;
    }
    getSSNPipe() {
        return createSSNPipe;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: MaskingService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: MaskingService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: MaskingService, decorators: [{
            type: Injectable
        }] });
function createSSNPipe(conformedValue, config) {
    let newString = '';
    for (let i = 0; i < conformedValue.length; i++) {
        if (i < 5) {
            newString += '*';
        }
        else {
            newString += conformedValue[i];
        }
    }
    return {
        newString
    };
}
// @dynamic
class MaskTypes {
    static get phoneMask() {
        return [
            '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/
        ];
    }
    static get dateMask() {
        return [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
    }
    static get zipcodeMask() {
        return [/[1-9]/, /\d/, /\d/, /\d/, /\d/];
    }
    static get ssnMask() {
        return [/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    }
    static get dollarMask() {
        const numMask = createNumberMask({ allowDecimal: true, requireDecimal: true, prefix: '' });
        return numMask;
    }
    static get fullNumberMask() {
        return function (number) {
            return number.replace(/\d/g, '*');
        };
    }
    static get ssnFullMask() {
        return function (ssn) {
            return ssn.replace(/^(\*{0,3}\d{0,3})\s?\-?\s?(\*{0,2}\d{0,2})\s?\-?\s?(\*{0,4}\d{0,4})$/, function (str) {
                return str.replace(/\d/g, '*');
            });
        };
    }
    static get dateFullMask() {
        return function (dateString) {
            return dateString.replace(/^(\*{0,3}\d{0,2})\s?\/?\s?(\*{0,2}\d{0,2})\s?\/?\s?(\*{0,4}\d{0,4})$/, function (str) {
                return str.replace(/[\d|\/]/g, '*');
            });
        };
    }
    static get zipCodeFullMask() {
        return function (zipCode) {
            return zipCode.replace(/^(\*{0,5}\d{0,5})\s?\-?\s?(\*{0,4}\d{0,4})\s?$/, function (str) {
                return str.replace(/\d/g, '*');
            });
        };
    }
    static get phoneFullMask() {
        return function (phone) {
            return phone.replace(/^(\*{0,3}\d{0,3})\s?\-?\s?(\*{0,3}\d{0,3})\s?\-?\s?(\*{0,4}\d{0,4})$/, function (str) {
                return str.replace(/\d/g, '*');
            });
        };
    }
    static get phonePartialMask() {
        return function (phone) {
            return phone.replace(/^\(?\*{0,3}\d{0,3}\)?\s?-?\s?\*{0,3}\d{0,3}\s?-?\s?\*{0,4}\d{0,4}$/, function (str) {
                if (str !== '') {
                    return str.replace(/^\(?\*{0,3}\d{0,3}\)?\s?-?\s?\*{0,3}\d{0,3}\s?-?\s?\*{0,4}(\d{0,4})$/, '(***)-***-$1');
                }
                return '';
            });
        };
    }
    static get emailPartialMask() {
        return function (email) {
            // ex. email: #-A0!#$%&'*+-/=?^_`{|}~08.q@ASaf0.com
            const emailRegex = /^([a-zA-Z0-9!#$%&'*+\/=?^_`{|}.~-]?)([a-zA-Z0-9!#$%&'*+\/=?^_`{|}.~-]*?)(\*?[a-zA-Z0-9!#$%&'*+\/=?^_`{|}.~-])@(.*?)$/;
            return email.replace(emailRegex, function (str) {
                const pattern = /^([a-zA-Z0-9!#$%&'*+\/=?^_`{|}.~-]?)([a-zA-Z0-9!#$%&'*+\/=?^_`{|}.~-]*?)(\*?[a-zA-Z0-9!#$%&'*+\/=?^_`{|}.~-])@(.*?)$/;
                // old: const pattern = /^(\*?\w?\.?)(.*?)(\*?\.?\w)@(.*?)$/;
                const matchObj = pattern.exec(str);
                const emailLength = matchObj['1'].length + matchObj['2'].length + matchObj['3'].length;
                if (emailLength == '3' || emailLength == '2') {
                    const replacedSecondGroup1 = matchObj['2'].replace(/[a-zA-Z0-9!#$%&'*+\/=?^_`{|}.~-]/g, '*') + matchObj['3'].replace(/[a-zA-Z0-9!#$%&'*+\/=?^_`{|}.~-]/g, '*');
                    return str.replace(pattern, '$1' + replacedSecondGroup1 + '@$4');
                }
                else if (emailLength == '1') {
                    return str;
                }
                else {
                    const replacedSecondGroup2 = matchObj['2'].replace(/[a-zA-Z0-9!#$%&'*+\/=?^_`{|}.~-]/g, '*');
                    return str.replace(pattern, '$1' + replacedSecondGroup2 + '$3@$4');
                }
            });
        };
    }
    static get textFullMask() {
        return function (value) {
            return Array(value.length + 1).join('*');
        };
    }
    static get textPartialMask() {
        return function (unmaskedLength, value) {
            function maskingFunction(val) {
                if (val !== '') {
                    const retrievingPattern = new RegExp('(\\w{0,' + unmaskedLength + '})$');
                    const matchObj = retrievingPattern.exec(val);
                    return Array(val.length - unmaskedLength + 1).join('*') + matchObj[0];
                }
                return '';
            }
            if (typeof value !== 'undefined' && value !== null && value !== '') {
                return maskingFunction(value);
            }
            return maskingFunction;
        };
    }
}

class InputMaskDirective {
    constructor(input) {
        this.input = input;
        this.maskedApplied = new EventEmitter();
        // Applies the mask
        this.applyMask = function () {
            // Make sure we have the latest mask
            this.getMask();
            // Get the value from the host component
            let value = this.input.nativeElement.value;
            // If there is a value that isn't blank, a valid mask to work with, and the mask is not a function
            if (value && value.length && this.mask && typeof this.mask !== 'function') {
                // loop over the mask array
                for (let i = 0, j = this.mask.length; i < j; i++) {
                    // Get the mask for this character
                    let character = value.charAt(i);
                    // Get the regex
                    let match = this.mask[i];
                    // Will hold the regex
                    let regex;
                    // Get the regex
                    if (typeof match === 'string' && match.length === 1) {
                        regex = new RegExp('\\' + match);
                    }
                    else if (typeof match === 'string' && match.length > 1) {
                        // If the match was an invalid string, ignore it
                        i++;
                        break;
                    }
                    else {
                        regex = match;
                    }
                    // If we got a valid character and a regex and the character doesn't match the regex
                    if (character && character.length && regex && !character.match(regex)) {
                        // If the match type was a string and the character didn't match the regex
                        if (typeof match === 'string' && !character.match(regex)) {
                            // Assume the string is required and add it to the value
                            value = [value.slice(0, i), match, value.slice(i)].join('');
                            // Increment j so the loop will complete
                            j++;
                        }
                        else {
                            // Otherwise remove the offending character from the string
                            let temp = value.split('');
                            temp.splice(i, 1);
                            value = temp.join('');
                            // And increment the loop values so the loop will complete
                            i--;
                            j--;
                        }
                    }
                }
                // Remove extra characters
                if (value.length > this.mask.length) {
                    value = value.substr(0, this.mask.length);
                }
                // Update the value accordingly
                this.input.nativeElement.value = value;
            }
            else {
                // This branch is used for masks which are function
                if (value && value !== null && value !== '') {
                    try {
                        this.input.nativeElement.value = this.mask(value);
                    }
                    catch (e) {
                        this.input.nativeElement.value = value;
                    }
                }
            }
            this.input.nativeElement.setAttribute('masked', true);
            this.maskedApplied.emit(value);
        };
        this.defaultEvents = ['oninput', 'onchange'];
        this.rawValue = null;
    }
    // Gets the mask
    getMask() {
        // Get type of mask passed
        let maskType = typeof this.inputMask;
        switch (maskType) {
            case 'function':
                // Get the value
                let value = this.input.nativeElement.value;
                // Check if we get a value from the passed function
                let mask = this.inputMask();
                // Check if the mask is a function and returns another function
                if (mask && typeof mask === 'function') {
                    try {
                        this.mask = typeof value !== 'undefined' && value !== null ? mask(value) : [];
                    }
                    catch (e) {
                        // Warn the developer that no mask was provided
                        console.warn('INPUTMASK: no array provided - masking disabled');
                        // This line disables the masking processing later on
                        this.mask = null;
                    }
                }
                const doesMaskFunctionReturnsMaskingArray = typeof mask === 'function' && typeof this.mask === 'object';
                if (doesMaskFunctionReturnsMaskingArray) {
                    // If the mask function returns an array
                    if (mask && typeof mask === 'object' && this.isValidMask(mask)) {
                        // If it is set the mask
                        this.mask = mask;
                    }
                    else if (!mask && isDevMode) {
                        // Warn the developer that no mask was provided
                        console.warn('INPUTMASK: no array provided - masking disabled');
                    }
                }
                else {
                    this.mask = mask;
                }
                break;
        }
    }
    // Validates a mask array
    isValidMask(mask) {
        // If the mask array is defined and has at least one object in it
        if (mask && mask.length) {
            // If the mask is valid or not
            let isValid = true;
            // Loop over the mask array
            for (let i = 0, j = mask.length; i < j; i++) {
                // Get the current value
                const value = mask[i];
                // Check if it is valid (either a string or regular expression)
                if ((
                // Is not a regular expression
                !(value instanceof RegExp)
                    // And is not a string
                    && !(typeof value === 'string'))
                    ||
                        (
                        // Is a string
                        typeof value === 'string'
                            // And is longer than one character
                            && value.length > 1)) {
                    // If it isn't invalidate the response
                    isValid = false;
                    let errorType = '';
                    if (isDevMode) {
                        if (
                        // Is not a regular expression
                        !(value instanceof RegExp)
                            // And is not a string
                            && !(typeof value === 'string')) {
                            errorType = 'invalid type in array';
                        }
                        else if (
                        // Is a string
                        typeof value === 'string'
                            // And is longer than one character
                            && value.length > 1) {
                            errorType = 'long string in array';
                        }
                        // Warn the developer of the problem
                        console.error('INPUTMASK: ' + errorType + ' - masking disabled');
                    }
                }
            }
            // If it is valid
            // return true
            // Otherwise return false
            return isValid;
        }
        else {
            // Otherwise return false
            return false;
        }
    }
    ngOnInit() {
        // Get initial mask
        setTimeout(() => {
            this.getMask();
            // If we got a valid mask and a valid list of event, registers the masking functionality
            if (this.mask) {
                let directive = this;
                if (this.defaultEvents.length > 0) {
                    // Registers any event for masking the raw data
                    this.defaultEvents.forEach(function (eventName) {
                        try {
                            this[eventName] = function () {
                                directive.applyMask();
                            };
                        }
                        catch (e) {
                        }
                    }.bind(this.input.nativeElement));
                }
                // Do the initial application of the mask
                setTimeout(() => {
                    this.applyMask();
                }, 0);
            }
        }, 0);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: InputMaskDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.5", type: InputMaskDirective, isStandalone: false, selector: "[inputMask]", inputs: { inputMask: "inputMask", defaultEvents: "defaultEvents", rawValue: "rawValue" }, outputs: { maskedApplied: "maskedApplied" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: InputMaskDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[inputMask]',
                    standalone: false
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { maskedApplied: [{
                type: Output
            }], inputMask: [{
                type: Input$1
            }], defaultEvents: [{
                type: Input$1
            }], rawValue: [{
                type: Input$1
            }] } });

class InputComponent {
    // #region // ------------------         Properties              -------------------- //
    static { this.DEFAULT_MAXLENGTH = 524288; }
    // #endregion
    // #region // ------------------         Input Setters                 -------------------- //
    /**
     * @property allowPositiveIntegerOnly
     * @description Enables/disables positive integer only validation
     * @return string
     */
    set allowPositiveIntegerOnly(value) {
        if (value === true) {
            this.allowIntegerOnly = true;
        }
        this._allowPositiveIntegerOnly = value;
    }
    /**
     * @property unmaskedLength
     * @description How many character should not be masked at the end of the string
     * @return number
     */
    set unmaskedLength(value) {
        if (typeof value !== 'undefined' && value !== null) {
            this._unmaskedLength = value;
            this.mask = this._maskingName;
        }
        else {
            this._unmaskedLength = 4;
        }
    }
    /**
     * @property allowDecimalDollarMask
     * @description Allows the decimal for the dollar mask
     * @Type: boolean
     * @twoway true
     */
    set allowDecimalDollarMask(val) {
        if (val === 'false' || val === false) {
            this._allowDecimalDollarMask = false;
        }
        else if (val === 'true' || val === true) {
            this._allowDecimalDollarMask = true;
        }
    }
    /**
     * @property hasCustomError
     * @description This defines the custom error state of the input. Takes precedence over other validation types.
     * @Type: boolean
     */
    set hasCustomError(err) {
        if (typeof err !== 'undefined') {
            this.toggleError('custom', err);
            if (err === true) {
                this.errorMessage = this.customErrorMessage;
            }
        }
    }
    /**
     * @property showZeroValue
     * @description Should the input show zero value when dollar mask is applied
     * @Type: boolean
     */
    set showZeroValue(value) {
        if (typeof value !== 'undefined' && value !== null) {
            this._showZeroValue = value;
        }
        else {
            this._showZeroValue = false;
        }
    }
    /**
     * @property mask
     * @description This defines the mask of the input, which changes the input text masking on character input.
     * @return string ('none', 'phone', 'zipcode', 'dollar', 'email', 'ssn', 'fullSsnMasking',
     * 'fullDateMasking', 'fullZipcodeMasking', 'fullPhoneMasking', 'partialEmailMasking', 'fullTextMasking'
     * 'partialTextMasking'), defaults to 'none'.
     */
    set mask(mask) {
        // If there is a mask and it is a valid mask
        this._maskingName = mask;
        const isValidMask = MaskingService.isValidMaskName(mask);
        if (mask && isValidMask) {
            this.dollaMaskIsActivated = mask === 'dollar';
            // If the mask type is not none (handled internally)
            if (mask !== 'none') {
                let maskingMethod;
                if (this.altPhoneMaskPattern != undefined) {
                    maskingMethod = this.altPhoneMaskPattern;
                }
                else {
                    maskingMethod = this.maskingService.getMask(mask);
                }
                // Set the mask array from the masking service
                if (mask !== 'partialTextMasking') {
                    this.inputMaskArray = maskingMethod;
                }
                else {
                    this.inputMaskArray = maskingMethod(this._unmaskedLength);
                }
            }
        }
        else if (mask && !isValidMask && isDevMode) {
            console.error('CITI-CTI - MASK: Caught \'' + mask + '\'. Valid values are: '
                + MaskingService.getAvailableMaskNames().join(', '));
        }
    }
    /**
     * @property type
     * @description This defines the type of the input, which changes which kind of input is displayed.
     * Mask must be set separately.
     * @return string ('text', 'password', 'email', 'url', 'phoneNumber', 'phoneCountry', 'phoneArea', 'readOnly', 'ssn'),
     * defaults to text.
     */
    set type(type) {
        // Define the valid types
        const validTypes = [
            'text', 'password', 'email', 'url', 'phoneNumber', 'phoneCountry', 'phoneArea', 'readOnly', 'ssn', 'number'
        ];
        // If there is a type and it is valid
        if (type && validTypes.indexOf(type) !== -1) {
            switch (type) {
                case 'phoneCountry':
                    this.phoneCountry = true;
                    break;
                case 'phoneArea':
                    this.phoneArea = true;
                    break;
                case 'readOnly':
                    this.readOnly = true;
                    break;
            }
            // Set the input type
            this.inputType = type;
        }
        else if (isDevMode) {
            console.error('CITI-INPUT - TYPE: Caught \'' + type + '\'. Valid types are: ' + validTypes);
        }
    }
    /**
     * @property size
     * @description This defines the size of the input, which changes the bootstrap classes.
     * @return string ('fullwidth', 'large', 'medium', 'small', 'xsmall', 'none'), defaults to 'large'.
     */
    set size(size) {
        if (this.isValidSizeValue(size)) {
            // Set the input size
            this.inputSize = size;
            this.classRow = size === 'none' ? false : true;
        }
        else if (isDevMode) {
            console.error('CITI-INPUT - SIZE: Caught \'' + size + '\'. Valid sizes are: ' + Object.keys(this.sizes));
        }
    }
    ;
    // #endregion
    // #region // ------------------         Setters                 -------------------- //
    get isDollarMaskApplied() {
        return this._maskingName === 'dollar';
    }
    /**
     * @property hasValue
     * @description If this input has any value
     * @return string
     * @twoway false
     */
    get hasValue() {
        return typeof this.value !== 'undefined' && this.value !== null && this.value.toString().length > 0;
    }
    get isNumberTypeInput() {
        return this.type === 'number';
    }
    get hasMaskingEnabled() {
        return this._maskingName !== null;
    }
    /**
     * @property unmaskedValue
     * @description Gets the raw value without any masking
     * @return string
     * @twoway false
     */
    get unmaskedValue() {
        return this._unmaskedValue;
    }
    get currentInputMaxLength() {
        return this.input.nativeElement.getAttribute('maxlength');
    }
    get formattingFunction() {
        switch (this._maskingName) {
            case 'partialPhoneMasking': return this.formatPhoneNumber;
            case 'fullSsnMasking': return this.formatSsnNumber;
            default: return null;
        }
    }
    get isValidValueLength() {
        if (this._maskingName !== null) {
            return this.doesUnmaskedValueHasValidLength;
        }
        return this.input.nativeElement.value.length <= this.maxlength;
    }
    get isValueMasked() {
        if (!this.input.nativeElement.hasAttribute('masked')) {
            return this._maskingName !== null && this.applyMaskOnEvents.length > 0;
        }
        return this.input.nativeElement.getAttribute('masked') === 'true';
    }
    get hasRevealingEvents() {
        return this._maskingName !== null && this.removeMaskOnEvents.length > 0;
    }
    get doesUnmaskedValueHasValidLength() {
        let length = 0;
        if (typeof this._unmaskedValue !== 'undefined' && this._unmaskedValue !== null) {
            length = this._unmaskedValue.length;
        }
        const effectMaxLength = (this.isDollarMaskApplied) ? this.maxlength - 2 : this.maxlength;
        if (this.isDollarMaskApplied)
            length = this.input.nativeElement.value.replace('$', '').replace(',', '').length;
        return length <= effectMaxLength;
    }
    // #endregion
    // #region // ------------------         Static Methods          -------------------- //
    static isCharacterKey(key) {
        return (key > 47 && key < 58) || // number keys
            key == 32 || key == 13 || // spacebar & return key(s) (if you want to allow carriage returns)
            (key > 64 && key < 91) || // letter keys
            (key > 95 && key < 112) || // numpad keys
            (key > 185 && key < 193) || // ;=,-./` (in order)
            (key > 218 && key < 223); // [\]' (in order)
    }
    // #endregion
    // #region // ------------------         Life Cycle              -------------------- //
    constructor(maskingService, validationService, elRef) {
        this.maskingService = maskingService;
        this.validationService = validationService;
        this.elRef = elRef;
        // The size of the input
        this.inputSize = 'fullwidth';
        // The type of the input
        this.inputType = 'text';
        // If the input is required
        this.isRequired = false;
        // Id for the label for aria
        this.labelId = null;
        // Phone area type toggle
        this.phoneArea = false;
        // Phone country type toggle
        this.phoneCountry = false;
        // Read only type toggle
        this.readOnly = false;
        // Show search icon
        this.isSearch = false;
        this._allowDecimalDollarMask = false;
        this.needToRaiseChangeEventForInput = false;
        this.newInputValue = null;
        this._maskingName = null;
        this.dollaMaskIsActivated = false;
        this._showZeroValue = false;
        this._unmaskedLength = 4;
        this._allowPositiveIntegerOnly = false;
        this.classRow = true;
        /**
         * @property autocomplete
         * @description Turns on/off the autocomplete feature of an input. Default value is 'off'.
         * @return string
         * @twoway false
         */
        this.autocomplete = 'off';
        /**
         * @property ariaLabel
         * @description Label for aria-label tag if special aria label is needed
         * @return string
         */
        this.ariaLabel = false;
        /**
         * @property allowIntegerOnly
         * @description The input only accepts alphabetical or numeric value
         * @return string
         */
        this.allowIntegerOnly = false;
        /**
         * @property name
         * @description This defines the name of the input
         * @return string
         */
        this.name = null;
        /**
         * @property currency
         * @description This defines the type of the currency being input
         * @return string
         */
        this.currency = 'dollar';
        /**
         * @property maxlength
         * @description This defines the maximum character length of the input
         * @return string
         */
        this.maxlength = InputComponent.DEFAULT_MAXLENGTH;
        /**
         * @property errorMessage
         * @description error message to be displayed when an error is triggered
         * @return string
         */
        this.errorMessage = 'Error';
        /**
         * @property customErrorMessage
         * @description Customized error message for custom error
         * @return string
         */
        this.customErrorMessage = null;
        /**
         * @property error
         * @description This defines the error state on the input
         * @return string
         */
        this.error = false;
        /**
         * @property messageOnlyIntegerError
         * @description Text to be displayed when the value fails only integer validation
         * @return string
         */
        this.messageOnlyIntegerError = 'Only integer value allowed';
        /**
         * @property allowNonZeroValueOnly
         * @description Enables/disables non zero validation
         * @return string
         */
        this.allowNonZeroValueOnly = false;
        /**
         * @property messageOnlyNonZeroError
         * @description Text to be displayed when the value fails non-zero validation
         * @return string
         */
        this.messageOnlyNonZeroError = 'Only negative or positive value allowed';
        /**
         * @property messageOnlyPositiveIntegerError
         * @description Text to be displayed when the value fails only positive integer validation
         * @return string
         */
        this.messageOnlyPositiveIntegerError = 'Only positive integer value allowed';
        /**
         * @property applyMaskOnEvents
         * @description A list of HTML event to activate the masking on the content
         * @return string[]
         */
        this.applyMaskOnEvents = ['oninput', 'onchange'];
        /**
         * @property removeMaskOnEvents
         * @description A list of HTML event to remove the mask from the value
         * @return string[]
         */
        this.removeMaskOnEvents = [];
        /**
       * @property validateOnBlur
       * @description Whether the input should valid on blur
       * @Type: boolean
       * @twoway true
       */
        this.validateOnBlur = true;
        // #endregion
        // #region // ------------------         Outputs                 -------------------- //
        /**
         * @property blur
         * @description Provides one-way binding to when the input is blurred.
         * Returns reference to input object. bind with (blur)="myBlurFunction($event)"
         * @Type: EventEmitter
         */
        this.blur = new EventEmitter;
        /**
         * @property focus
         * @description Provides one-way binding to when the input is focused.
         * Returns reference to the input object. bind with (focus)="myFocusFunction($event)"
         * @Type: EventEmitter
         */
        this.focus = new EventEmitter;
        /**
         * @Event: errorChange
         * @description The event is emitted when the error status changed
         * The event is returned.
         * @return Object
         */
        this.errorChange = new EventEmitter();
        this.valueChange = new EventEmitter();
        this.selectedPhoneCountryChange = new EventEmitter();
        /**
         * @Event: valueChanged
         * @description This event that is fired when the value of the input changes.
         * Can be bound to with (valueChange)='myFunction($event)'
         * @return Object
         */
        this.valueChanged = new EventEmitter();
        /**
         * @Event: unmaskValueChanged
         * @description This event that is fired when the raw value of the input is changed.
         * Can be bound to with (unmaskValueChanged)='myFunction($event)'
         * @return Object
         */
        this.unmaskValueChanged = new EventEmitter();
        // #endregion
        // #region // ------------------         NgClass Objects         -------------------- //
        // Classes to be applied to the wrapper
        this.wrapperClasses = {
            'is-focused': false,
            'addon-suffix': false,
            'addon-prefix': false
        };
        // Classes for the sizes of input, also applied to the wrapper
        this.sizes = {
            fullwidth: 'col-xs-12',
            large: 'col-md-8 col-lg-8',
            medium: 'col-md-6 col-sm-9',
            small: 'col-md-4 col-sm-6',
            xsmall: 'col-md-2 col-sm-3 col-xs-6',
            none: ''
        };
        // Class for the div wrapping the input but not the label
        this.inputGroupClasses = {
            'input-group': false,
            'focus-group': false,
            'validation-input-danger': false
        };
        // Classes to be applied to the input group
        this.groupClasses = {
            'tooltip-input-group': false,
            'input-group': false,
            'combo-group': false,
            'focus-group': false
        };
        // Classes to be applied to the input
        this.inputClasses = {
            'form-control': true,
            'formatted': false,
            'validation-input-danger': false,
            'read-only': false,
            'containsAddon': false
        };
        // Classes to be applied to the input
        this.addonClasses = {
            'border-focused-addon': false,
            'border-error-addon': false
        };
        // Classes to be applied to the label
        this.labelClasses = {
            'text-input-label': true,
            'select-box-label': false
        };
        this._unmaskedValue = '';
        this.cursorPosition = null;
        this.getMask = (value) => {
            return this.inputMaskArray;
        };
    }
    ngOnChanges(changes) {
        // Currently, I choose to detect change manually as the input element is applied 2-way binding with ngModel.
        // As a result, the onChange event of the element is not raised automatically and is not bubbled.
        if (this.isValueSetProgrammatically(changes)) {
            this.setTheOnChangeRaisingFlag(changes['value'] && !changes['value'].isFirstChange(), changes['value'].currentValue);
        }
    }
    ngOnInit() {
        this.validationService.addInput(this);
        if (typeof this.idStr !== 'undefined' && this.idStr !== null && this.idStr !== '') {
            this.labelId = this.idStr + 'label';
        }
        else {
            this.labelId = null;
        }
        // If the maxlength value is set to something weird, resets the max length value.
        if (typeof this.maxlength === 'undefined' || this.maxlength == null) {
            this.maxlength = InputComponent.DEFAULT_MAXLENGTH;
        }
        // Subscribe to the validation to validate the input on request of the service
        this.validateSub = this.validationService.validateNow.subscribe(() => {
            this.validate();
        });
        // Set the error messages
        this.errors = {
            required: 'Input is required',
            minLength: 'Input length must exceed ' + this.minlength + ' characters',
            maxLength: 'Input length must exceed ' + this.minlength + ' characters'
        };
        // set search icon class
        if (this.searchIcon) {
            this.wrapperClasses['addon-prefix'] = true;
            this.inputGroupClasses['input-group'] = true;
            this.inputGroupClasses['focus-group'] = true;
        }
        // set currency add-on class
        if (this.currencySignBefore || this.currencySignAfter) {
            this.wrapperClasses['addon-prefix'] = true;
            this.inputGroupClasses['input-group'] = true;
            this.inputGroupClasses['focus-group'] = true;
        }
        // set phonearea and phonecountry classes
        if (this.phoneArea || this.phoneCountry) {
            this.inputGroupClasses['input-group'] = true;
        }
        // set dark input theme
        if (this.themeDark) {
            this.inputClasses['theme-dark'] = true;
            this.addOnTheme = 'theme-dark';
        }
        // set light input theme
        if (this.themeLight) {
            this.inputClasses['theme-light'] = true;
            this.addOnTheme = 'theme-light';
        }
        if (this.focused) {
            if (this.phoneCountry || this.phoneArea) {
                this.wrapperClasses['is-focused'] = false;
                this.addonClasses['border-focused-addon'] = true;
            }
            else {
                this.wrapperClasses['is-focused'] = true;
            }
        }
        // set readonly classes
        if (this.readOnly) {
            this.labelClasses = {
                'text-input-label': false,
                'select-box-label': true
            };
            this.inputClasses = {
                'form-control': false,
                'formatted': false,
                'validation-input-danger': false,
                'read-only': true,
            };
        }
        if (this.phoneArea || this.phoneCountry) {
            this.inputClasses['containsAddon'] = true;
        }
        // Initializes the unmasked value with provided input value (if any)
        if (typeof this.value !== 'undefined' && this.value !== null && typeof this.value !== 'string') {
            this._unmaskedValue = this.value.toString();
        }
        else {
            this._unmaskedValue = this.value;
        }
        if (this.inputMaskArray instanceof Array) {
            this.maxlength = this.inputMaskArray.length;
        }
        this.updateMaxLength();
    }
    ngAfterViewInit() {
        if (this.removeMaskOnEvents.length > 0) {
            const component = this;
            this.removeMaskOnEvents.forEach((eventName) => {
                try {
                    component.input.nativeElement.addEventListener(eventName, component.revealRawValue.bind(component));
                }
                catch (e) {
                }
            });
        }
        // this.updateDomEl();
        // rerun validation if a custom error is removed
        this.errorChange.subscribe(error => {
            if (this.errorType == 'custom' && !this.error) {
                this.errorType = null;
                this.validate();
            }
        });
        setTimeout(() => {
            this.setSelectedPhoneCountry();
        }, 0);
    }
    ngAfterViewChecked() {
        // When a flag is set to manually raised the change event, we raise the change event and turn off the flag
        if (this.needToRaiseChangeEventForInput && this.input.nativeElement.value == this.newInputValue) {
            // Also, we only raise event when the value of the input is actually the new value. This prevents the event
            // from being raised multiple time
            if (this.input.nativeElement.fireEvent) {
                this.input.nativeElement.fireEvent('onchange');
            }
            else {
                const event = document.createEvent('HTMLEvents');
                event.initEvent('change', true, false);
                this.input.nativeElement.dispatchEvent(event);
            }
            this.needToRaiseChangeEventForInput = false;
        }
    }
    ngOnDestroy() {
        this.validationService.removeError(this);
        if (this.validateSub)
            this.validateSub.unsubscribe();
    }
    // #endregion
    // #region // ------------------         Private Methods         -------------------- //
    emitValueChangedEvent() {
        if (this.hasMaskingEnabled)
            this.valueChanged.emit(this._unmaskedValue);
        else
            this.valueChanged.emit(this.value);
    }
    updateValueProperty(newValue, doUpdateRawValue = false) {
        this.value = newValue;
        if (this.hasMaskingEnabled) {
            if (typeof newValue !== 'undefined' && newValue !== null) {
                if (this.isDollarMaskApplied && !this._allowDecimalDollarMask) {
                    this.value = newValue.replace(/[^0-9a-z]/gi, '');
                }
            }
        }
        if (doUpdateRawValue) {
            this._unmaskedValue = this.value;
        }
        this.valueChange.emit(this.value);
        this.emitValueChangedEvent();
    }
    onlyContainIntegerValue(value) {
        if (this.dollaMaskIsActivated) {
            return (/^[\-\$]?[\-\$]?(((\d{1,3})(,\d{3})*)|(\d+))?$/).test(value);
        }
        return (/^-?(((\d{1,3})(,\d{3})*)|(\d+))?$/).test(value);
    }
    onlyContainNumericValue(value) {
        if (this.dollaMaskIsActivated) {
            return (/^[\-\$]?[\-\$]?(((\d{1,3})(,\d{3})*)|(\d+))(.\d+)?$/).test(value);
        }
        return (/^-?(((\d{1,3})(,\d{3})*)|(\d+))(.\d+)?$/).test(value);
    }
    deleteCharacterInUnmaskedValue(position) {
        const filterFunction = function (deletedPos, item, index) {
            return function (item2, index2) {
                return deletedPos !== index2;
            };
        }.call(null, position);
        this._unmaskedValue = this._unmaskedValue.split('').filter(filterFunction).join('');
        this.unmaskValueChanged.emit(this._unmaskedValue);
        this.emitValueChangedEvent();
    }
    storeUnmaskedValue(event) {
        if (this.allowIntegerOnly || this.isDollarMaskApplied) {
            if (InputComponent.isCharacterKey(event.key)) {
                if (!/\d|-|,/.test(event.key)) {
                    return false;
                }
            }
        }
        if (this.isValidValueLength) {
            if (this.isValueMasked && InputComponent.isCharacterKey(event.keyCode)) {
                if (this._unmaskedValue) { // TODO: make ternary
                    this._unmaskedValue += event.key;
                }
                else {
                    this._unmaskedValue = event.key;
                }
            }
            else {
                return true;
            }
        }
    }
    updateCursorInInput(deletedPosition) {
        setTimeout(() => {
            if (this.input.nativeElement.setSelectionRange) {
                //Programatically added cursor position(works for iphone)
                this.input.nativeElement.setSelectionRange(deletedPosition + 1, deletedPosition + 1);
            }
        }, 0);
    }
    isValueSetProgrammatically(changes) {
        return Object.keys(changes).length === 1 && changes.hasOwnProperty('value');
    }
    setTheOnChangeRaisingFlag(flagValue, newValue) {
        this.needToRaiseChangeEventForInput = flagValue;
        if (newValue) {
            this.newInputValue = newValue;
        }
    }
    isValidSizeValue(value) {
        // Define the valid sizes
        const validSizes = Object.keys(this.sizes);
        // If there is a size and it is valid
        return value && validSizes.indexOf(value) !== -1;
    }
    updateMaxLength() {
        if (this.isDollarMaskApplied) {
            // When a dollar mask is applied, our input has to accommodate more character than just the max length.
            // Therefore, we have to re-calculate the max length to accommodate the currency symbol and comma.
            if (typeof this.maxlength === 'string') {
                this.maxlength = parseInt(this.maxlength, 10);
            }
            const oldMaxLength = this.maxlength;
            // Calculates the maximum number of comma for the length of the number
            let numberOfComma = oldMaxLength / 3;
            if (oldMaxLength % 3 === 0) {
                numberOfComma--;
            }
            // Calculates the new max length
            this.maxlength = oldMaxLength + numberOfComma + 1;
        }
    }
    /* This function is temporarily used for phone number case only. A better and generic approach should be
    * implemented to handle general cases.
    */
    formatPhoneNumber(value) {
        const checkPattern = /^\(?\*{0,3}\d{0,3}\)?\s?-?\s?\*{0,3}\d{0,3}\s?-?\s?\*{0,4}\d{0,4}$/;
        const retrievedPattern = /^\(?(\*{0,3}\d{0,3})\)?\s?-?\s?(\*{0,3}\d{0,3})\s?-?\s?(\*{0,4}\d{0,4})$/;
        return value.replace(checkPattern, function (str) {
            if (str !== '') {
                const paren = str.indexOf('(');
                const dash = str.indexOf('-');
                if (str.length < 4 && paren == -1) {
                    return str.replace(retrievedPattern, '($1');
                }
                else if (str.length < 5 && paren == 0) {
                    return str.replace(retrievedPattern, '($1');
                }
                else if ((str.length > 4 && str.length < 10 && paren == 0) || (str.length < 7 && paren == -1)) {
                    return str.replace(retrievedPattern, '($1)-$2');
                }
                else if (str.length > 9 || (str.length > 6 && dash == -1)) {
                    return str.replace(retrievedPattern, '($1)-$2-$3');
                }
            }
            return '';
        });
    }
    formatSsnNumber(value) {
        const checkPattern = /^\(?\*{0,3}\d{0,3}\)?\s?-?\s?\*{0,2}\d{0,2}\s?-?\s?\*{0,4}\d{0,4}$/;
        const retreivedPattern = /^(\*{0,3}\d{0,3})\s?-?\s?(\*{0,2}\d{0,2})\s?-?\s?(\*{0,4}\d{0,4})$/;
        return value.replace(checkPattern, function (str) {
            if (str !== '') {
                return str.replace(retreivedPattern, '$1$2$3');
            }
            return '';
        });
    }
    revealRawValue() {
        if (this.input.nativeElement && this._unmaskedValue) {
            let value = this._unmaskedValue;
            // If we have a masking, checks for a formatting function
            if (this._maskingName !== null) {
                // Applies the formatting function
                if (this.formattingFunction !== null) {
                    value = this.formattingFunction.call(this, this._unmaskedValue);
                }
            }
            this.input.nativeElement.value = value;
            // Updates the longest length to retain the appropriate length with formatted value
            const currentLargetLength = Math.max(this.currentInputMaxLength, value.length, this.maxlength);
            this.input.nativeElement.setAttribute('maxlength', currentLargetLength);
        }
        this.input.nativeElement.setAttribute('masked', false);
    }
    // #endregion
    // #region // ------------------         Public Methods          -------------------- //
    /**
     * @name setMaskedValue
     * @description Set the value on the input with the enabled mask.
     * Must be called after the application view has init
     * @return void
     */
    setMaskedValue(value) {
        this._unmaskedValue = value;
        if (this._maskingName !== null) {
            const maskConst = this.maskingService.getMask(this._maskingName);
            if (typeof maskConst == 'function' && this._maskingName != 'dollar') {
                this.value = this.maskingService.getMask(this._maskingName)(value);
            }
        }
        else {
            this.value = value;
        }
    }
    // Moves focus to the input
    focusInput() {
        this.input.nativeElement.focus();
    }
    ;
    // On focus
    onFocus() {
        // Set the focused class
        if (this.phoneCountry || this.phoneArea) {
            this.wrapperClasses['is-focused'] = false;
            this.addonClasses['border-focused-addon'] = true;
        }
        else {
            this.wrapperClasses['is-focused'] = true;
        }
        if (!this.isNumberTypeInput) {
            this.cursorPosition = this.input.nativeElement.selectionStart;
        }
        this.focus.emit(this);
    }
    ;
    // On Blur
    onBlur() {
        // Applies format function when such function is specified
        if (this.formattingFunction !== null) {
            this.input.nativeElement.value = this.formattingFunction.call(this, this.input.nativeElement.value);
        }
        this.updateValueProperty(this.input.nativeElement.value, this.isDollarMaskApplied);
        // Set the focused class
        this.wrapperClasses['is-focused'] = false;
        this.addonClasses['border-focused-addon'] = false;
        if (this.validateOnBlur)
            this.validate();
        this.blur.emit(this);
    }
    ;
    // Returns the value of the input on key up
    onInput() {
        // Check whether the value is masked with the below regex (last character is never masked at this point)
        if (this.input.nativeElement.value.match(/^[*]+[^*]{0,1}$/) == null) {
            // Commented out formatting function as this may not be required for all inputs
            // if(this._maskingName != null){
            //   this._unmaskedValue = this.input.nativeElement.value.replace(/[()-.\s]/g,'');
            // }
            // else{
            this._unmaskedValue = this.input.nativeElement.value;
            // }
        }
        // Checks if the length of new value is valid,
        if (this.isValidValueLength) {
            // If it is valid, updates the new value to the default value temporarily
            this.input.nativeElement.defaultValue = this.input.nativeElement.value;
        }
        else {
            // If not, reset to the old value.
            this.input.nativeElement.value = this.input.nativeElement.defaultValue;
        }
        if (this.isDollarMaskApplied) {
            // This is a temporarily fix for the weird comma problem: when users input 60000, the format does not
            // change properly. The format returns: 6,0000. Problem is currently reported when 'dollar' mask being used.
            let numericValue;
            /* Only go into this first block if they do not want the dollar masking to accept the decimal which is the
            default behaviour.  This was done this way to support backwards compatibility */
            if (!this._allowDecimalDollarMask) {
                numericValue = parseFloat(this.input.nativeElement.value.replace(/[^0-9\.]+/g, ''));
            }
            else {
                numericValue = this.input.nativeElement.value.replace(/[^0-9\.]+/g, '');
                /* Reset to 0 if they try to add something like 09, 08, etc... */
                numericValue = numericValue.replace(/^0[0-9]+/g, '0');
                /* Reset to '' if they enter . */
                numericValue = numericValue.replace(/^[\.]+/g, '');
                /* Reset to <digit>. if they enter <digit>.. */
                numericValue = numericValue.replace(/^([\d]+)[\.][\.]+/g, '$1.');
            }
            if (Number.isNaN(numericValue)) {
                if (this._showZeroValue) {
                    numericValue = 0;
                    this.input.nativeElement.value = numericValue.toLocaleString('en-US', {
                        style: 'currency', currency: 'USD',
                        minimumIntegerDigits: 1, minimumFractionDigits: 0, maximumFractionDigits: 2
                    });
                }
                else {
                    this.input.nativeElement.value = '';
                }
            }
            else {
                this.input.nativeElement.value = numericValue.toLocaleString('en-US', {
                    style: 'currency', currency: 'USD',
                    minimumIntegerDigits: 1, minimumFractionDigits: 0, maximumFractionDigits: 2
                });
            }
            /* Truncate to two decimal points */
            const val = this.input.nativeElement.value;
            const dotIndex = val.indexOf('.');
            const dotLength = val.length - dotIndex;
            if (dotIndex != -1 && dotLength > 2) {
                this.input.nativeElement.value = val.substring(0, dotIndex + 3);
            }
        }
        this.updateValueProperty(this.input.nativeElement.value);
        if (this._maskingName === 'partialPhoneMasking' || this._maskingName === 'partialEmailMasking') {
            this._unmaskedValue = this.input.nativeElement.value;
        }
        // If the new value is empty, we remove the unmasked value
        if (this.value === '' || this.value === null) {
            this._unmaskedValue = '';
            this.cursorPosition = null;
        }
        /* Only do this for non number inputs since the number input does not have this function. */
        /* This fixes a bug in android where the cursor is not properly updated after masking occurs. The masking occurs in the */
        /* text-directive which is the reason we put it in a timeout so it occurs after the directive has run */
        if (!this.isNumberTypeInput) {
            const ua = window.navigator.userAgent;
            const msie = (ua.indexOf('MSIE ') > 0);
            const trident = (ua.indexOf('Trident/') > 0);
            const edge = (ua.indexOf('Edge/') > 0);
            setTimeout(() => {
                if (this.input.nativeElement.setSelectionRange && !msie && !trident && !edge && this._maskingName == 'dollar') {
                    this.input.nativeElement.setSelectionRange(this.input.nativeElement.value.length, this.input.nativeElement.value.length);
                }
            }, 0);
        }
    }
    ;
    onKeyDown(event) {
        // Detects the backspace key
        const key = event.which || event.keyCode || event.charCode;
        if (!this.isValidValueLength) {
            if (InputComponent.isCharacterKey(key)) {
                return false;
            }
        }
        if (this.isValueMasked) {
            if (!this.isNumberTypeInput) {
                // Sets the default position of the character need to be deleted
                let deletedPosition = this.cursorPosition;
                switch (key) {
                    case 8:
                        // When a user clicks backspace key
                        if (this.cursorPosition < 1) {
                            break;
                        }
                        deletedPosition = this.cursorPosition - 1;
                    /* tslint:disable-next-line:no-switch-case-fall-through */
                    case 46:
                        // or when a user clicks delete key
                        // Checks if we have a valid position
                        if (this._unmaskedValue && deletedPosition !== null &&
                            (deletedPosition <= this._unmaskedValue.length || deletedPosition <= this.value.length)) {
                            // Removes the character as specified position
                            this.deleteCharacterInUnmaskedValue(deletedPosition);
                            // Puts the cursor in the proper position after a character is deleted
                            // If this is not in place then the cursor is put after the last character
                            this.updateCursorInInput(deletedPosition);
                        }
                        break;
                }
            }
        }
        this.storeUnmaskedValue(event);
    }
    onClick(event) {
        if (!this.isNumberTypeInput) {
            // Detects location of the cursor to see where to remove the character in the unmasked value.
            // Focus event does not work for this purpose because focus event is not fired when the input text is clicked.
            try {
                this.cursorPosition = event.target.selectionStart;
            }
            catch (e) {
                this.cursorPosition = null;
            }
        }
    }
    onKeyPress(event) {
        if (event.keyCode == 13)
            return false;
        if (!this.isNumberTypeInput) {
            // Detects location of the cursor to see where to remove the character in the unmasked value
            if (!this.isValidValueLength) {
                return false;
            }
            try {
                this.cursorPosition = event.target.selectionStart;
            }
            catch (e) {
                this.cursorPosition = null;
            }
        }
    }
    shouldApplyClass(ngClassObj, className, shouldApply) {
        ngClassObj[className] = shouldApply;
    }
    areThereNoAddOns() {
        return !this.currencySignAfter && !this.currencySignBefore;
    }
    // Clears an error state on the input. Takes a type of error
    toggleError(errorType, isErrored) {
        // Clear the error state
        this.error = isErrored;
        // Clear the error class
        if (this.phoneArea || this.phoneCountry) {
            this.addonClasses['border-error-addon'] = isErrored;
        }
        else {
            if (this.areThereNoAddOns()) {
                this.shouldApplyClass(this.inputClasses, 'validation-input-danger', isErrored);
            }
            else {
                this.shouldApplyClass(this.inputGroupClasses, 'validation-input-danger', isErrored);
            }
        }
        // Set the error on the validation service
        if (isErrored) {
            // Add the error type
            this.errorType = errorType;
            // Add the error to the validation service
            this.validationService.addError(this);
        }
        else {
            // Remove the error type
            if (this.errorType != 'custom') {
                this.errorType = null;
            }
            // Remove the error from the validation service
            this.validationService.removeError(this);
        }
        // Emit the change to the error
        this.errorChange.emit();
    }
    ;
    // validate input
    validate() {
        if (!this.errorType || this.errorType !== 'custom') {
            // Get the current value
            let value = this.input.nativeElement.value;
            if (this.hasMaskingEnabled) {
                value = this._unmaskedValue;
            }
            if (this._maskingName == 'phone') {
                let count = 0;
                for (const item in this.inputMaskArray) {
                    if (this.inputMaskArray[item] != '-' && this.inputMaskArray[item] != ' ' && this.inputMaskArray[item] != '(' && this.inputMaskArray[item] != ')' && this.inputMaskArray[item] != '.')
                        count++;
                }
                this.minlength = count;
                this.errors['minLength'] = 'Input length must exceed ' + this.minlength + ' characters';
                if (this._unmaskedValue != undefined) {
                    this._unmaskedValue = this._unmaskedValue.replace(/\D/g, '');
                }
            }
            // If we got a value
            // The placeholder check helps retain the error when the value is actually empty but IE takes the placeholder
            // as a value
            if (value && value !== this.placeholder) {
                // If the input is required
                if (this.required) {
                    // Clear the required error state
                    this.toggleError('required', false);
                }
                if (this.allowNonZeroValueOnly) {
                    let validationValue1 = value;
                    // This is a temporary value to handle the case that the value is not required and
                    // value is an empty string
                    if (!this.required && (!value || value === null || value === '')) {
                        validationValue1 = 1;
                    }
                    const isValidNumericValue = this.onlyContainNumericValue(validationValue1);
                    if (isValidNumericValue) {
                        try {
                            const isValueZero = parseFloat(this.value.replace(/[^0-9\.]/g, '')) === 0;
                            this.toggleError('only_non_zero_allowed', isValueZero);
                            if (isValueZero) {
                                this.errorMessage = this.messageOnlyNonZeroError;
                                return isValueZero;
                            }
                        }
                        catch (exception) {
                            this.toggleError('only_non_zero_allowed', true);
                            this.errorMessage = this.messageOnlyNonZeroError;
                            return false;
                        }
                    }
                    else {
                        this.toggleError('only_numeric_value_allowed', !isValidNumericValue);
                        this.errorMessage = 'Only numeric value allowed';
                        return isValidNumericValue;
                    }
                }
                if (this.allowIntegerOnly) {
                    let validationValue2 = value;
                    // This is a temporary value to handle the case that the value is not required and
                    // value is an empty string
                    if (!this.required && (!value || value === null || value === '')) {
                        validationValue2 = 1;
                    }
                    const validationResult = this.onlyContainIntegerValue(validationValue2);
                    this.toggleError('only_integer_allowed', !validationResult);
                    if (!validationResult) {
                        this.errorMessage = this.messageOnlyIntegerError;
                        return validationResult;
                    }
                }
                if (this._allowPositiveIntegerOnly) {
                    let validationValue3 = value;
                    // This is a temporary value to handle the case that the value is not required and
                    // value is an empty string
                    if (!this.required && (!value || value === null || value === '')) {
                        validationValue3 = 1;
                    }
                    try {
                        const isValueNonPositive = parseInt(validationValue3, 10) <= 0;
                        this.toggleError('only_positive_integer_allowed', isValueNonPositive);
                        if (isValueNonPositive) {
                            this.errorMessage = this.messageOnlyPositiveIntegerError;
                            return isValueNonPositive;
                        }
                    }
                    catch (exception) {
                        this.toggleError('only_positive_integer_allowed', true);
                        this.errorMessage = this.messageOnlyPositiveIntegerError;
                        return false;
                    }
                }
                // If there is a mininum input length
                if (this.minlength) {
                    // Get the length of the value of the input
                    const length = this._unmaskedValue.length;
                    // If the length is longer than the minimum length set on the input
                    const minLength = (typeof this.minlength === 'string') ? parseInt(this.minlength, 10) : this.minlength;
                    if (length >= minLength) {
                        // Clear the minlength error state
                        this.toggleError('minlength', false);
                    }
                    else {
                        // Otherwise set the error message
                        this.errorMessage = this.minLengthError || this.errors['minLength'];
                        // And set the minlength error state
                        this.toggleError('minlength', true);
                    }
                }
                // Max Length Validation
                // ** Max length validation not required because inputs don't allow more
                // characters when input attribute is present
            }
            else {
                // Otherwise if there was no value and the input is required
                if (this.required) {
                    const hasNoValidValue = (!value || value === 'undefined' || value === this.placeholder);
                    if (hasNoValidValue) {
                        // Set the error message
                        this.errorMessage = this.requiredError || this.errors['required'];
                    }
                    // And set the required error state
                    this.toggleError('required', hasNoValidValue);
                }
                else {
                    this.toggleError('required', false);
                }
            }
        }
        else {
            if (this.errorType === 'custom') {
                if (this.error === true) {
                    this.errorMessage = this.customErrorMessage;
                }
            }
        }
    }
    ;
    // updateDomEl() {
    //   if (this.input) {
    //     this.DomEl = this.input.nativeElement;
    //   }
    // }
    getLabelString() {
        const resultString = this.label || this.placeholder;
        return typeof resultString !== 'undefined' && resultString !== null && resultString !== 'null' ? resultString : '';
    }
    getAriaLabelString() {
        let resultString;
        if (this.ariaLabel) {
            resultString = this.ariaLabel;
        }
        else {
            resultString = this.label || this.placeholder;
        }
        return typeof resultString !== 'undefined' && resultString !== null && resultString !== 'null' ? resultString : '';
    }
    setSelectedPhoneCountry() {
        if (this.phoneCountrySelect && this.phoneCountrySelect.nativeElement) {
            const value = this.phoneCountrySelect.nativeElement.value;
            this.selectedPhoneCountry = value;
            this.selectedPhoneCountryChange.emit(value);
            /* This sets the masking pattern if international patterns are defined */
            const maskPattern = this.countryCodes[this.phoneCountrySelect.nativeElement.selectedIndex].maskingPattern;
            if (maskPattern != undefined) {
                this.inputMaskArray = maskPattern;
            }
            else {
                // Set the mask array from the masking service
                this.inputMaskArray = this.maskingService.getMask('phone');
            }
        }
    }
    /**
     * @name reset
     * @description Resets the apperance and state of the input to initial
     * @return void
     */
    reset() {
        this.updateValueProperty(null, true);
        this.toggleError(null, false);
    }
    formatValue(value) {
        return this.formatPhoneNumber(value);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: InputComponent, deps: [{ token: MaskingService }, { token: ValidationService }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: InputComponent, isStandalone: false, selector: "citi-input", inputs: { dataFormat: "dataFormat", autocomplete: "autocomplete", autocompleteType: "autocompleteType", ariaLabel: "ariaLabel", allowIntegerOnly: "allowIntegerOnly", idStr: "idStr", name: "name", label: "label", focused: "focused", value: "value", placeholder: "placeholder", tooltipTitle: "tooltipTitle", tooltipBody: "tooltipBody", tooltipPosition: "tooltipPosition", currency: "currency", searchIcon: "searchIcon", maxlength: "maxlength", minlength: "minlength", required: "required", errorMessage: "errorMessage", customErrorMessage: "customErrorMessage", error: "error", requiredError: "requiredError", themeDark: "themeDark", themeLight: "themeLight", addOnTheme: "addOnTheme", messageOnlyIntegerError: "messageOnlyIntegerError", allowNonZeroValueOnly: "allowNonZeroValueOnly", messageOnlyNonZeroError: "messageOnlyNonZeroError", messageOnlyPositiveIntegerError: "messageOnlyPositiveIntegerError", minLengthError: "minLengthError", describedby: "describedby", tabIndex: "tabIndex", countryCodes: "countryCodes", areaCodes: "areaCodes", altPhoneMaskPattern: "altPhoneMaskPattern", currencySignAfter: "currencySignAfter", currencySignBefore: "currencySignBefore", pattern: "pattern", applyMaskOnEvents: "applyMaskOnEvents", removeMaskOnEvents: "removeMaskOnEvents", selectedPhoneCountry: "selectedPhoneCountry", validateOnBlur: "validateOnBlur", allowPositiveIntegerOnly: "allowPositiveIntegerOnly", unmaskedLength: "unmaskedLength", allowDecimalDollarMask: "allowDecimalDollarMask", hasCustomError: "hasCustomError", showZeroValue: "showZeroValue", mask: "mask", type: "type", size: "size" }, outputs: { blur: "blur", focus: "focus", errorChange: "errorChange", valueChange: "valueChange", selectedPhoneCountryChange: "selectedPhoneCountryChange", valueChanged: "valueChanged", unmaskValueChanged: "unmaskValueChanged" }, host: { properties: { "class.row": "this.classRow" }, classAttribute: "citi-input" }, providers: [MaskingService], viewQueries: [{ propertyName: "input", first: true, predicate: ["input"], descendants: true }, { propertyName: "wrapper", first: true, predicate: ["wrapper"], descendants: true }, { propertyName: "phoneCountrySelect", first: true, predicate: ["phoneCountrySelect"], descendants: true }], usesOnChanges: true, ngImport: i0, template: `
  <div #wrapper [class.has-value]="hasValue || readOnly"
     [ngClass]="wrapperClasses"
     class="{{sizes[inputSize]}} form-group">

    <!-- Label -->
    <label [for]="idStr"
      [id]="labelId"
      [ngClass]="labelClasses"
      [innerHtml]="getLabelString()">
    </label>

    <!-- input wrapping classes -->
    <div [class]="phoneCountry || (phoneArea ? 'group-input-combo' : null)">

      <div [class]="phoneCountry || (phoneArea ? 'input-group combo-group input-fix' : null)" [ngClass]="addonClasses">

        <div [class]="phoneCountry || (phoneArea ? 'margin-fix' : null)" [ngClass]="inputGroupClasses">

          <!-- Phone Country Prefix Selector -->
          <div class="input-group-btn" *ngIf="countryCodes">
            <select
              #phoneCountrySelect
              [attr.name]="name"
              class="form-control input-add-on country-code {{addOnTheme}}"
              (change)="setSelectedPhoneCountry()"
            >
              <option *ngFor="let code of countryCodes"
                [value]="code.value"
                [innerHtml]="code.label"
                [attr.selected]="(code.selected === true ? true : null)"
              ></option>
            </select>
          </div>

          <!-- Phone Area Code Selector -->
          <div class="input-group-btn" *ngIf="areaCodes">
            <select [attr.name]="name" class="form-control input-add-on area-code {{addOnTheme}}" >
              <option *ngFor="let code of areaCodes" [value]="code.value" [innerHtml]="code.label"></option>
            </select>
          </div>

          <!-- Before Currency Sign -->
          <span *ngIf="currencySignBefore" class="input-group-addon before {{addOnTheme}}" [innerHtml]="currencySignBefore"></span>

          <!-- The Input -->
          <input
            (keypress)="onKeyPress($event)"
            [attr.aria-label]="((!hasValue || !readOnly) ? getAriaLabelString() : null)"
            [attr.aria-labelledby]="((!hasValue || !readOnly) ? labelId : null)"
            #input
            [isFocused]="focused"
            [attr.pattern]="pattern"
            [attr.type]="inputType"
            [attr.name]="name"
            [attr.id]="idStr"
            [attr.placeholder]="placeholder"
            [ngClass]="inputClasses"
            [(ngModel)]="value"
            [attr.maxlength]="maxlength"
            [attr.aria-required]="(required ? true : null)"
            [attr.required]="(isRequired ? true : null)"
            [readonly]="readOnly"
            [inputMask]="getMask"
            [defaultEvents]="applyMaskOnEvents"
            (valueUnmasked)="formatValue($event)"
            [rawValue]="_unmaskedValue"
            (focus)="onFocus()"
            (input)="onInput()"
            (keydown)="onKeyDown($event)"
            (click)="onClick($event)"
            (blur)="onBlur()"
            [attr.aria-invalid]="(error ? true : null)"
            [attr.autocomplete]="autocomplete"
            [attr.aria-autocomplete]="autocompleteType"
            [attr.aria-describedby]="(error ? idStr + '-error' : describedby ? describedby : null)"
            [attr.data-format]="dataFormat"
          />

          <!-- After Currency Sign -->
          <span *ngIf="currencySignAfter" class="input-group-addon after {{addOnTheme}}" [innerHtml]="currencySignAfter"></span>

          <!-- Search icon add-on -->
          <span *ngIf="searchIcon" class="input-group-addon search"><span class="search-icon"></span></span>

        </div>
      </div>

      <!-- Error Messsage -->
      <span *ngIf="error" class="validation-message-danger" [innerHtml]="errorMessage" role="alert"></span>
      <span aria-hidden="true" class="sr-only" [attr.id]="idStr + '-error'" [innerHtml]="errorMessage"></span>

    </div>
  </div>

  `, isInline: true, styles: [":host{display:block}.validation-input-danger{border-color:#d60000}.input-group-btn{vertical-align:top}.input-addon-border{border-left-color:#eee!important}.margin-fix{margin:0!important}.input-fix{border:1px solid #fff!important;transition:border-color ease-in-out 225ms}.border-focused-addon{border:1px solid #056DAE!important;border-radius:7px}.border-error-addon{border:1px solid #D60000!important;border-radius:10px 7px 7px}.border-focused-addon.border-error-addon{border-width:2px!important}.containsAddon{outline-color:#056dae!important;border:none!important;border-right:0px!important}.theme-dark{background-color:#eee!important}select.theme-dark::-ms-value{background-color:#eee}select.theme-dark:focus::-ms-value{background-color:#eee}.theme-light{background-color:#fff!important}select:focus{border:1px solid #056DAE!important}select.theme-light::-ms-value{background-color:#fff}select.theme-light:focus::-ms-value{background-color:#fff}.input-group-addon.before{border-radius:5px 0 0 5px!important}.input-group-addon.after{border-radius:0 5px 5px 0!important}label{opacity:0}.is-focused label,.has-value label{opacity:1}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i4.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i4.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i4.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i4.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: InputMaskDirective, selector: "[inputMask]", inputs: ["inputMask", "defaultEvents", "rawValue"], outputs: ["maskedApplied"] }, { kind: "directive", type: IsFocusedDirective, selector: "[isFocused]", inputs: ["isFocused"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: InputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-input', standalone: false, template: `
  <div #wrapper [class.has-value]="hasValue || readOnly"
     [ngClass]="wrapperClasses"
     class="{{sizes[inputSize]}} form-group">

    <!-- Label -->
    <label [for]="idStr"
      [id]="labelId"
      [ngClass]="labelClasses"
      [innerHtml]="getLabelString()">
    </label>

    <!-- input wrapping classes -->
    <div [class]="phoneCountry || (phoneArea ? 'group-input-combo' : null)">

      <div [class]="phoneCountry || (phoneArea ? 'input-group combo-group input-fix' : null)" [ngClass]="addonClasses">

        <div [class]="phoneCountry || (phoneArea ? 'margin-fix' : null)" [ngClass]="inputGroupClasses">

          <!-- Phone Country Prefix Selector -->
          <div class="input-group-btn" *ngIf="countryCodes">
            <select
              #phoneCountrySelect
              [attr.name]="name"
              class="form-control input-add-on country-code {{addOnTheme}}"
              (change)="setSelectedPhoneCountry()"
            >
              <option *ngFor="let code of countryCodes"
                [value]="code.value"
                [innerHtml]="code.label"
                [attr.selected]="(code.selected === true ? true : null)"
              ></option>
            </select>
          </div>

          <!-- Phone Area Code Selector -->
          <div class="input-group-btn" *ngIf="areaCodes">
            <select [attr.name]="name" class="form-control input-add-on area-code {{addOnTheme}}" >
              <option *ngFor="let code of areaCodes" [value]="code.value" [innerHtml]="code.label"></option>
            </select>
          </div>

          <!-- Before Currency Sign -->
          <span *ngIf="currencySignBefore" class="input-group-addon before {{addOnTheme}}" [innerHtml]="currencySignBefore"></span>

          <!-- The Input -->
          <input
            (keypress)="onKeyPress($event)"
            [attr.aria-label]="((!hasValue || !readOnly) ? getAriaLabelString() : null)"
            [attr.aria-labelledby]="((!hasValue || !readOnly) ? labelId : null)"
            #input
            [isFocused]="focused"
            [attr.pattern]="pattern"
            [attr.type]="inputType"
            [attr.name]="name"
            [attr.id]="idStr"
            [attr.placeholder]="placeholder"
            [ngClass]="inputClasses"
            [(ngModel)]="value"
            [attr.maxlength]="maxlength"
            [attr.aria-required]="(required ? true : null)"
            [attr.required]="(isRequired ? true : null)"
            [readonly]="readOnly"
            [inputMask]="getMask"
            [defaultEvents]="applyMaskOnEvents"
            (valueUnmasked)="formatValue($event)"
            [rawValue]="_unmaskedValue"
            (focus)="onFocus()"
            (input)="onInput()"
            (keydown)="onKeyDown($event)"
            (click)="onClick($event)"
            (blur)="onBlur()"
            [attr.aria-invalid]="(error ? true : null)"
            [attr.autocomplete]="autocomplete"
            [attr.aria-autocomplete]="autocompleteType"
            [attr.aria-describedby]="(error ? idStr + '-error' : describedby ? describedby : null)"
            [attr.data-format]="dataFormat"
          />

          <!-- After Currency Sign -->
          <span *ngIf="currencySignAfter" class="input-group-addon after {{addOnTheme}}" [innerHtml]="currencySignAfter"></span>

          <!-- Search icon add-on -->
          <span *ngIf="searchIcon" class="input-group-addon search"><span class="search-icon"></span></span>

        </div>
      </div>

      <!-- Error Messsage -->
      <span *ngIf="error" class="validation-message-danger" [innerHtml]="errorMessage" role="alert"></span>
      <span aria-hidden="true" class="sr-only" [attr.id]="idStr + '-error'" [innerHtml]="errorMessage"></span>

    </div>
  </div>

  `, providers: [MaskingService], host: { class: 'citi-input' }, styles: [":host{display:block}.validation-input-danger{border-color:#d60000}.input-group-btn{vertical-align:top}.input-addon-border{border-left-color:#eee!important}.margin-fix{margin:0!important}.input-fix{border:1px solid #fff!important;transition:border-color ease-in-out 225ms}.border-focused-addon{border:1px solid #056DAE!important;border-radius:7px}.border-error-addon{border:1px solid #D60000!important;border-radius:10px 7px 7px}.border-focused-addon.border-error-addon{border-width:2px!important}.containsAddon{outline-color:#056dae!important;border:none!important;border-right:0px!important}.theme-dark{background-color:#eee!important}select.theme-dark::-ms-value{background-color:#eee}select.theme-dark:focus::-ms-value{background-color:#eee}.theme-light{background-color:#fff!important}select:focus{border:1px solid #056DAE!important}select.theme-light::-ms-value{background-color:#fff}select.theme-light:focus::-ms-value{background-color:#fff}.input-group-addon.before{border-radius:5px 0 0 5px!important}.input-group-addon.after{border-radius:0 5px 5px 0!important}label{opacity:0}.is-focused label,.has-value label{opacity:1}\n"] }]
        }], ctorParameters: () => [{ type: MaskingService }, { type: ValidationService }, { type: i0.ElementRef }], propDecorators: { classRow: [{
                type: HostBinding,
                args: ['class.row']
            }], dataFormat: [{
                type: Input$1
            }], autocomplete: [{
                type: Input$1
            }], autocompleteType: [{
                type: Input$1
            }], ariaLabel: [{
                type: Input$1
            }], allowIntegerOnly: [{
                type: Input$1
            }], idStr: [{
                type: Input$1
            }], name: [{
                type: Input$1
            }], label: [{
                type: Input$1
            }], focused: [{
                type: Input$1
            }], value: [{
                type: Input$1
            }], placeholder: [{
                type: Input$1
            }], tooltipTitle: [{
                type: Input$1
            }], tooltipBody: [{
                type: Input$1
            }], tooltipPosition: [{
                type: Input$1
            }], currency: [{
                type: Input$1
            }], searchIcon: [{
                type: Input$1
            }], maxlength: [{
                type: Input$1
            }], minlength: [{
                type: Input$1
            }], required: [{
                type: Input$1
            }], errorMessage: [{
                type: Input$1
            }], customErrorMessage: [{
                type: Input$1
            }], error: [{
                type: Input$1
            }], requiredError: [{
                type: Input$1
            }], themeDark: [{
                type: Input$1
            }], themeLight: [{
                type: Input$1
            }], addOnTheme: [{
                type: Input$1
            }], messageOnlyIntegerError: [{
                type: Input$1
            }], allowNonZeroValueOnly: [{
                type: Input$1
            }], messageOnlyNonZeroError: [{
                type: Input$1
            }], messageOnlyPositiveIntegerError: [{
                type: Input$1
            }], minLengthError: [{
                type: Input$1
            }], describedby: [{
                type: Input$1
            }], tabIndex: [{
                type: Input$1
            }], countryCodes: [{
                type: Input$1
            }], areaCodes: [{
                type: Input$1
            }], altPhoneMaskPattern: [{
                type: Input$1
            }], currencySignAfter: [{
                type: Input$1
            }], currencySignBefore: [{
                type: Input$1
            }], pattern: [{
                type: Input$1
            }], applyMaskOnEvents: [{
                type: Input$1
            }], removeMaskOnEvents: [{
                type: Input$1
            }], selectedPhoneCountry: [{
                type: Input$1
            }], validateOnBlur: [{
                type: Input$1
            }], blur: [{
                type: Output
            }], focus: [{
                type: Output
            }], errorChange: [{
                type: Output
            }], valueChange: [{
                type: Output
            }], selectedPhoneCountryChange: [{
                type: Output
            }], valueChanged: [{
                type: Output
            }], unmaskValueChanged: [{
                type: Output
            }], allowPositiveIntegerOnly: [{
                type: Input$1
            }], unmaskedLength: [{
                type: Input$1
            }], allowDecimalDollarMask: [{
                type: Input$1
            }], hasCustomError: [{
                type: Input$1
            }], showZeroValue: [{
                type: Input$1
            }], mask: [{
                type: Input$1
            }], type: [{
                type: Input$1
            }], size: [{
                type: Input$1
            }], input: [{
                type: ViewChild,
                args: ['input']
            }], wrapper: [{
                type: ViewChild,
                args: ['wrapper']
            }], phoneCountrySelect: [{
                type: ViewChild,
                args: ['phoneCountrySelect']
            }] } });

class InputMask {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: InputMask, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: InputMask, declarations: [InputMaskDirective], imports: [CommonModule], exports: [InputMaskDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: InputMask, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: InputMask, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [InputMaskDirective],
                    exports: [InputMaskDirective]
                }]
        }] });

const COMPONENTS$N = [
    InputComponent,
];
const MODULES$O = [
    CommonModule,
    FormsModule,
    InputMask,
    IsFocused
];
class Input {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Input, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: Input, declarations: [InputComponent], imports: [CommonModule,
            FormsModule,
            InputMask,
            IsFocused], exports: [InputComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Input, imports: [MODULES$O] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Input, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$O],
                    declarations: [...COMPONENTS$N],
                    exports: [...COMPONENTS$N]
                }]
        }] });

class InputSettings {
    constructor() {
        this.type = 'text';
        this.size = 'large';
        this.mask = 'none';
        this.pipe = 'none';
    }
    get default() { return { type: 'text', size: 'large', mask: 'none', pipe: 'none' }; }
}
// @dynamic
class InputCss {
    static get Large() { return 'col-md-8 col-sm-12'; }
    static get Medium() { return 'col-md-6 col-sm-9'; }
    static get Small() { return 'col-md-4 col-sm-6'; }
    static get Success() { return 'validation-input-success'; }
    static get InputGroup() { return 'input-group'; }
    static get InputGroupFocus() { return 'focus-group'; }
    static get TextRight() { return 'text-right'; }
    static get ThemeDark() { return 'theme-dark'; }
    static get ThemeLight() { return 'theme-light'; }
}
// @dynamic
class InputSize {
    static get Large() { return 'large'; }
    static get Medium() { return 'medium'; }
    static get Small() { return 'small'; }
    static get XSmall() { return 'xsmall'; }
    static get FullBody() { return 'fullBody'; }
}
// @dynamic
class InputType {
    static get Standard() { return 'standard'; }
    static get Tooltip() { return 'tooltip'; }
    static get FinAddOn() { return 'finAddOn'; }
    static get Password() { return 'password'; }
    static get SimpleDate() { return 'simpleDate'; }
    static get Email() { return 'email'; }
    static get Url() { return 'url'; }
    static get PhoneNumber() { return 'phoneNumber'; }
    static get ReadOnly() { return 'readOnly'; }
    static get Error() { return 'error'; }
}
// @dynamic
class TooltipInput {
    static get InputCss() { return ''; }
    static get PlacementTop() { return 'auto top'; }
    static get PlacementBot() { return 'auto bottom'; }
    static get InputGroupCss() { return 'tooltip-input-group'; }
}
// @dynamic
class FinAddOnInput {
    static get Step() { return 1; }
    static get Min() { return 0; }
    static get TypeDollar() { return '$'; }
    static get TypeRUB() { return 'RUB'; }
    static get InputGroupCss() { return 'input-group focus-group'; }
}
// @dynamic
class PasswordInput {
    static get InputCss() { return 'text-input-container'; }
    static get MaxLength() { return 10; }
    static get Type() { return 'password'; }
    static get LargeRules() { return 'no-spaces min-max-8-10 has-letter has-number'; }
    static get MediumRules() { return 'hasspecialcharacter no-consecutive-3 no-spaces min-max-8-10 has-letter has-number'; }
    static get SmallRules() { return 'min-max-6-25'; }
    static get XSmallRules() { return 'no-consecutive no-special-characters has-letter has-number'; }
    static get PlacementTop() { return 'top auto'; }
    static get SuccessMsg() { return 'Your password meets all tested requirements'; }
    static get FailMsg() { return 'Your password doesn&#39;t meet the requirements below'; }
}
// @dynamic
class SimpleDateInput {
    static get RowCss() { return 'cbolui-input-box'; }
    static get Type() { return 'text'; }
    static get InputCss() { return 'dateinput-simple form-control formatted'; }
    static get Label1() { return 'Date (dd/mm/yyyy)'; }
    static get Placeholder1() { return 'Date dd/mm/yyyy'; }
    static get Format1() { return 'dd/mm/yyyy'; }
    static get AddFormat1() { return 'dd/mm/y|dd-mm-y|dd-mm-yy'; }
    static get Label2() { return 'Date (mm/dd/yy)'; }
    static get Placeholder2() { return 'Date mm/dd/yy'; }
    static get Format2() { return 'mm/dd/yy'; }
}
// @dynamic
class EmailInput {
    static get Type() { return 'email'; }
    static get InputCss() { return 'formatted'; }
    static get Label() { return 'Email Address (name@email.com)'; }
    static get Placeholder() { return 'Email Address'; }
    static get Format() { return 'name@email.com'; }
}
// @dynamic
class UrlInput {
    static get Type() { return 'url'; }
    static get InputCss() { return 'formatted'; }
    static get Label() { return 'URL (http://www.google.com)'; }
    static get Placeholder() { return 'URL'; }
    static get Format() { return 'http://www.google.com'; }
}
// @dynamic
class PhoneInput {
    static get Type() { return 'tel'; }
    static get InputCss() { return 'formatted'; }
    static get Label() { return 'Telephone Number'; }
    static get Placeholder() { return 'Telephone Number'; }
    static get Format() { return '416 673 5275'; }
    static get MaxLength() { return 16; }
    static get FormatEnforcement() { return '[\d ]'; }
}
// @dynamic
class ReadOnlyInput {
    static get InputCss() { return 'read-only'; }
}
// @dynamic
class ErrorInput {
    static get InputCss() { return 'validation-input-danger'; }
}
// @dynamic
class InputSizeCss {
    static get FullBody() {
        return 'col-lg-12 col-md-12 col-sm-12 col-xs-12 ';
    }
    static get Large() {
        return 'col-md-8 col-sm-12 ';
    }
    static get Medium() {
        return 'col-md-6 col-sm-9 col-xs-12 ';
    }
    static get Small() {
        return 'col-md-4 col-sm-6 col-xs-12 ';
    }
    static get Success() {
        return 'validation-input-success ';
    }
    static get InputGroup() {
        return 'input-group ';
    }
    static get InputGroupFocus() {
        return 'focus-group ';
    }
    static get TextRight() {
        return 'text-right ';
    }
}
// @dynamic
class InputOffsetCss {
    static get Large() {
        return 'col-lg-offset-';
    }
    static get Medium() {
        return 'col-md-offset-';
    }
    static get Small() {
        return 'col-sm-offset-';
    }
    static get XSmall() {
        return 'col-xs-offset-';
    }
}

/**
 * @Component: ProgressBarStepComponent
 * @description This is a progress bar step
 */
class ProgressBarStepComponent {
    constructor() {
        /// ------------- Host Bindings ----------- ///
        // Makes sure each step has the root class of "progress-indicator-step"
        this.rootClass = 'progress-indicator-step';
    }
    // Adds the class "progress-indicator-step-finished" for step based on the results of the isFinished() method
    get finishedClass() { return this.isFinished(); }
    // Adds the class "progress-indicator-step-active" for step based on the results of the isActive method
    get activeClass() { return this.isActive(); }
    /// ------------- Methods ----------------- ///
    // Determines if the finished class should be used
    isFinished() {
        return this.index < this.getCurrentStep - 1;
    }
    // Determines if the active class should be used
    isActive() {
        return this.index === this.getCurrentStep - 1;
    }
    /// ------------- Lifecycle Hooks --------- ///
    ngAfterViewInit() {
        // Force this update into the next lifecycle to avoid redundant settings of hostbinding properties
        setTimeout(() => {
            // Get and set the index of this step in relation to the other steps in the progress bar
            this.index = this.getSteps.indexOf(this);
        }, 0);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ProgressBarStepComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: ProgressBarStepComponent, isStandalone: false, selector: "[citi-progress-bar-step]", inputs: { label: "label", secondaryLabel: "secondaryLabel" }, host: { properties: { "class": "this.rootClass", "class.progress-indicator-step-finished": "this.finishedClass", "class.progress-indicator-step-active": "this.activeClass" } }, ngImport: i0, template: `
    <span class="primary-label" [innerHtml]="label" aria-hidden="true"></span>
    <span *ngIf="secondaryLabel" class="secondary-label" [innerHtml]="secondaryLabel" aria-hidden="true"></span>
    <span class="sr-only">
        Step {{(index + 1)}}, {{label}} {{secondaryLabel}}, {{isFinished() ? ' Complete' : isActive() ? " Current" : ' Incomplete'}}
    </span>
    `, isInline: true, styles: [":host{flex:1 1 .1px}:host:first-child,:host:last-child{flex:.5 1 .1px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ProgressBarStepComponent, decorators: [{
            type: Component,
            args: [{ selector: '[citi-progress-bar-step]', standalone: false, template: `
    <span class="primary-label" [innerHtml]="label" aria-hidden="true"></span>
    <span *ngIf="secondaryLabel" class="secondary-label" [innerHtml]="secondaryLabel" aria-hidden="true"></span>
    <span class="sr-only">
        Step {{(index + 1)}}, {{label}} {{secondaryLabel}}, {{isFinished() ? ' Complete' : isActive() ? " Current" : ' Incomplete'}}
    </span>
    `, styles: [":host{flex:1 1 .1px}:host:first-child,:host:last-child{flex:.5 1 .1px}\n"] }]
        }], propDecorators: { label: [{
                type: Input$1
            }], secondaryLabel: [{
                type: Input$1
            }], rootClass: [{
                type: HostBinding,
                args: ['class']
            }], finishedClass: [{
                type: HostBinding,
                args: ['class.progress-indicator-step-finished']
            }], activeClass: [{
                type: HostBinding,
                args: ['class.progress-indicator-step-active']
            }] } });

let nextUniqueId$9 = 0;
/**
 * @Component: ProgressBarParentComponent
 * @description This is a progress indicator component developed by adapting the DDL specification
 */
class ProgressBarParentComponent {
    constructor(el) {
        this.el = el;
        // Unique ID for this progress bar
        this.uid = 'progress-bar-' + nextUniqueId$9++;
        /// ------------- Inputs/Outputs --------- ///
        // language support
        this.stepText = 'Step';
        this.ofText = 'of';
        // The currently active step for the progress bar
        this.currentStep = 1;
        this.currentStepChange = new EventEmitter();
    }
    ;
    /// ------------- Methods ---------------- ///
    // Goes to the next step
    next() {
        this.currentStep = Math.min(this.currentStep + 1, this.steps.length);
        this.updateCurrentStep();
        this.currentStepChange.emit(this.currentStep);
    }
    // Goes to the previous step
    prev() {
        this.currentStep = Math.max(this.currentStep - 1, 1);
        this.updateCurrentStep();
        this.currentStepChange.emit(this.currentStep);
    }
    // Sets the current step to a new step index
    setCurrentStep(newStep) {
        // If the new step wouldn't be out of range make it the new step
        if (newStep >= 0 && newStep <= this.steps.length)
            this.currentStep = newStep;
        this.currentStepChange.emit(this.currentStep);
    }
    updateCurrentStep() {
        this._steps.forEach((step) => {
            step.getCurrentStep = this.currentStep;
        });
    }
    /// ------------- Lifecycle Hooks -------- ///
    ngAfterContentInit() {
        this.steps = this._steps.toArray();
        this._steps.forEach((step) => {
            step.getCurrentStep = this.currentStep;
            step.getSteps = this.steps;
        });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ProgressBarParentComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: ProgressBarParentComponent, isStandalone: false, selector: "citi-progress-bar", inputs: { stepText: "stepText", ofText: "ofText", currentStep: "currentStep" }, outputs: { currentStepChange: "currentStepChange" }, queries: [{ propertyName: "_steps", predicate: ProgressBarStepComponent }], ngImport: i0, template: `
    <div class="progress-indicator-wrapper clearfix col-xs-12">
        <span [id]="uid" class="sr-only">{{stepText}} {{this.currentStep}} {{ofText}} {{this.steps.length}}: {{this.steps[currentStep - 1].label}}</span>
        <ol class="progress-indicator col-xs-12">
            <ng-content></ng-content>
        </ol>
    </div>
    `, isInline: true, styles: [":host .progress-indicator{margin-left:0!important}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ProgressBarParentComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-progress-bar', standalone: false, template: `
    <div class="progress-indicator-wrapper clearfix col-xs-12">
        <span [id]="uid" class="sr-only">{{stepText}} {{this.currentStep}} {{ofText}} {{this.steps.length}}: {{this.steps[currentStep - 1].label}}</span>
        <ol class="progress-indicator col-xs-12">
            <ng-content></ng-content>
        </ol>
    </div>
    `, styles: [":host .progress-indicator{margin-left:0!important}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { _steps: [{
                type: ContentChildren,
                args: [ProgressBarStepComponent, { descendants: false }]
            }], stepText: [{
                type: Input$1
            }], ofText: [{
                type: Input$1
            }], currentStep: [{
                type: Input$1
            }], currentStepChange: [{
                type: Output
            }] } });

const COMPONENTS$M = [
    ProgressBarParentComponent,
    ProgressBarStepComponent
];
const MODULES$N = [
    CommonModule,
];
class ProgressBar {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ProgressBar, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: ProgressBar, declarations: [ProgressBarParentComponent,
            ProgressBarStepComponent], imports: [CommonModule], exports: [ProgressBarParentComponent,
            ProgressBarStepComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ProgressBar, imports: [MODULES$N] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ProgressBar, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$N],
                    declarations: [...COMPONENTS$M],
                    exports: [...COMPONENTS$M]
                }]
        }] });

/**
 * Created by ht08666 on 5/23/2017.
 */
class FormComponent {
    getOrderAppearance() {
        if (typeof this.DomEl !== 'undefined' && this.DomEl !== null) {
            const value = this.DomEl.getAttribute('data-order-appearance');
            if (value !== null) {
                return parseInt(value, 10);
            }
        }
        return -1;
    }
    updateDomEl() { }
}

class InputService {
    constructor() {
        this.errorAdded = new EventEmitter();
        this.errorRemoved = new EventEmitter();
        this.valueChanged = new EventEmitter();
        this.validateNow = new EventEmitter();
        this.errors = [];
        this.inputs = [];
        this.values = [];
    }
    addError(error) {
        if (this.errors.indexOf(error) === -1) {
            this.errors.push(error);
        }
        ;
    }
    ;
    removeError(error) {
        if (this.errors.indexOf(error) !== -1) {
            this.errors.splice(this.errors.indexOf(error), 1);
        }
    }
    ;
    addInput(input) {
        // protects against other types coming in later through content additions
        if (!this.type)
            this.type = input.type;
        if (this.type === input.type) {
            this.inputs.push(input);
            if (this.type === 'radio' && input.checked) {
                this.value = input.value;
                // avoids value changed after checked error
                setTimeout(_ => this.valueChanged.emit(this.value), 0);
            }
            else if (this.type === 'checkbox' && input.checked) {
                const alreadySelected = this.values.includes(input.value);
                if (!alreadySelected)
                    this.values.push(input.value);
                // avoids value changed after checked error
                setTimeout(_ => this.valueChanged.emit(this.values), 0);
            }
        }
    }
    removeInput(input) {
        // remove any selected values
        if (this.type === 'checkbox' && this.values.includes(input.value)) {
            this.values = this.values.filter(val => val !== input.value);
        }
        else if (this.type === 'radio' && this.value === input.value) {
            this.value = undefined;
        }
        // remove the input
        this.inputs = this.inputs.filter(inpt => inpt !== input);
    }
    validate() {
        this.validateNow.emit();
    }
    ;
    changeValue(value, checked = true) {
        if (this.type === 'radio') {
            if (value !== this.value) {
                this.value = value;
                this.valueChanged.emit(value);
            }
        }
        else if (this.type === 'checkbox') {
            const alreadySelected = this.values.includes(value);
            if (alreadySelected && !checked) {
                this.values = this.values.filter(val => val !== value);
                this.valueChanged.emit(this.values);
            }
            else if (!alreadySelected && checked) {
                this.values.push(value);
                this.valueChanged.emit(this.values);
            }
        }
    }
    hasBoxChecked() {
        if (this.type === 'radio')
            throw Error('This method should only be called on checkboxes');
        else {
            return this.inputs.map(comp => comp.checked).some(isChecked => isChecked === true);
        }
    }
    clearValue() {
        this.value = undefined;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: InputService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: InputService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: InputService, decorators: [{
            type: Injectable
        }] });

/*tslint:disable*/
// ----------- Imports ------------- //
// ---------- Component ------------ //
/**
 * @Component: CheckboxRadioRootComponent
 * @Section: Forms
 * @Description: This component is used to generate either a checkbox or a radio button.  It should not be used directly and is extended by the checkbox and radio button components to provide core functionality to both.
 */
class CheckboxRadioRootComponent extends FormComponent {
    /**
     * @Property: contentAddition
     * @Description: Where the checkbox is a content addition or not.
     * @Type: String
     */
    set contentAddition(value) {
        value = true;
        this.isContentAddition = value;
    }
    // -------- Lifecycle Hooks --------- //
    constructor(inputService, validationService, liveAnnouncer, cdr) {
        super();
        this.inputService = inputService;
        this.validationService = validationService;
        this.liveAnnouncer = liveAnnouncer;
        this.cdr = cdr;
        /**
         * @Property: checked
         * @Description: Whether the checkbox is checked or not
         * @Type: String
         */
        this.checked = false;
        /**
         * @Event: checkedChange
         * @Description: Emitted when the checked property of the radio is changed
         */
        this.checkedChange = new EventEmitter;
        /**
         * @Event: errorChange
         * @Description: Emitted when the validation error is updated
         */
        this.errorChange = new EventEmitter();
        /**
         * @Property: errorMessageRequired
         * @Description: Set custom error message displayed when the value is required and the check box is not checked
         * @Type: Boolean
         */
        this.errorMessageRequired = 'Required';
        /**
         * @Property: customValidator
         * @Description: Sets up a custom validator for a check box
         * @Type: Boolean
         */
        this.customValidator = null;
        /**
         * @Event: blur
         * @Description: Emitted when a checkbox button loses focus
         */
        this.blur = new EventEmitter();
        /**
         * @Event: keyup
         * @Description: Emitted when keyup is fired on the checkbox button
         */
        this.keyup = new EventEmitter();
        /**
         * @Event: keydown
         * @Description: Emitted when keydown is fired on the checkbox button
         */
        this.keydown = new EventEmitter();
        /**
         * @Event: keypress
         * @Description: Emitted when key press is fired on the checkbox button
         */
        this.keypress = new EventEmitter();
        /**
         * @Event: onClickEvent
         * @Description: Emitted when a radio button is clicked
         */
        this.onClickEvent = new EventEmitter();
        this.classes = [];
        this.isContentAddition = false;
        this.customErrorMessage = null;
        this.displayedErrorMessage = 'Error';
        this.isInitRun = true;
        // Constants for LiveAnnouncer
        this.expandedMessage = "Additional information expanded";
        this.collapsedMessage = "Additional information collapsed";
    }
    ;
    markForCheck() {
        this.cdr.markForCheck();
    }
    ngOnInit() {
        // Tell the input service that a checkbox was added
        this.inputService.addInput(this);
        this.update();
        // set inputs as checked initially
        if (this.value) {
            if (this.type === 'radio' && this.inputService.value === this.value) {
                this.checked = true;
            }
            else if (this.type === 'checkbox' && this.inputService.values.includes(this.value)) {
                this.checked = true;
            }
        }
        this.inputService.valueChanged.subscribe(value => {
            if (this.value === value && !this.checked && !this.check) {
                this.checked = true;
                this.update();
            }
            else if (this.value !== value && this.type === "radio" && (this.checked || this.check)) {
                this.checked = false;
                // Use Live Announcer to simulate announcements from aria-expanded for closing radio buttons
                this.announceExpandOrCollapse();
            }
        });
    }
    ngAfterViewInit() {
        if (this.value && this.inputService.value === this.value) {
            this.input.nativeElement.checked = true;
            this.inputService.changeValue(this.value);
        }
        // Listen for a change on the radio or checkbox
        // this.input.nativeElement.addEventListener("change", () => {
        //   // If there are any tooltips in the content addition
        //   if (this.input.nativeElement.checked && this.tooltips.length > 0) {
        //     // For each tooltip in the content addition
        //     this.tooltips.forEach(tooltip => {
        //       // Make sure the tooltip is positioned correctly
        //       this.contentAdditionEl.nativeElement.style.display = "block";
        //       tooltip.setRelativeOffsets();
        //       tooltip.positionTooltip(tooltip.initialPosition);
        //       this.contentAdditionEl.nativeElement.style.display = "";
        //     })
        //   }
        // })
        this.isInitRun = false;
    }
    ngOnDestroy() {
        this.inputService.removeInput(this);
        this.validationService.removeError(this);
    }
    // ------------ Methods ------------- //
    // On Focus
    onFocus() {
        if (this.inputService.inputGroupError)
            this.liveAnnouncer.announce(this.inputService.inputGroupErrorMsg);
        // If the input is first or last in the group and there is an error state, announce the error
        // if (this.shouldReadError()) this.liveAnnouncer.announce(this.inputService.inputGroupErrorMsg);
    }
    // shouldReadError(): boolean{
    //   return this.inputService.inputGroupError
    //      && ( this.label === this.inputService.inputs[0].label
    //        || this.label === this.inputService.inputs[this.inputService.inputs.length-1].label
    //     );
    // }
    onChange() {
        if (!this.isInitRun)
            this.validate();
        this.update();
    }
    update() {
        // If there is an input created already (check if this function is called before onViewInit)
        if (typeof this.input !== "undefined") {
            // Get the checked state of the input
            const isChecked = this.input.nativeElement.checked;
            setTimeout(_ => this.input.nativeElement.checked = isChecked, 0);
            // Make sure the checked input is in sync with the checked state of the input
            this.checked = isChecked;
            // Emit the checked state of the input
            this.checkedChange.emit(isChecked);
            // protects against contentaddition checkboxes
            const isPossibleValue = this.inputService.inputs
                .map(component => component.value)
                .some(opt => this.value === opt);
            // If the input is checked
            if (isPossibleValue) {
                // Emit the new value to the input service
                this.inputService.changeValue(this.value, isChecked);
            }
            // Use Live Announcer to simulate announcements from aria-expanded
            this.announceExpandOrCollapse();
            // Otherwise see if the checked or check inputs are available
        }
        else if (typeof this.checked === "boolean" || typeof this.check === "boolean") {
            // Emit the value of the inputs
            this.checkedChange.emit(this.checked || this.check);
            // If the value is true
            if ((this.checked || this.check) && this.type === "radio") {
                // Emit the new value to the input service
                this.inputService.changeValue(this.value);
            }
            // Use Live Announcer to simulate announcements from aria-expanded
            this.announceExpandOrCollapse();
        }
    }
    getAriaLabelledBy() {
        if (!!this.ariaLabelledById)
            return this.ariaLabelledById;
        else if (this.idStr && this.label)
            return this.idStr + '-label';
        else
            return null;
    }
    getAriaLabel() {
        if (this.ariaLabelledById || this.label) {
            return null;
        }
        else if (this.ariaLabel) {
            return this.ariaLabel;
        }
        else
            return null;
    }
    validate() {
        if (typeof this.input !== 'undefined' && this.input !== null) {
            this.toggleError("required", false);
            this.toggleError("required", this.required && !this.input.nativeElement.checked);
            // If the value pass all built-in validation,
            if (!this.hasError) {
                // and we still have custom validation to perform
                if (typeof this.customValidator === 'function' && this.customValidator !== null) {
                    // Performs the custom validation call
                    const errorMessage = this.customValidator.call(this, this.input.nativeElement.checked);
                    // Toggles error when it is needed
                    this.customErrorMessage = errorMessage;
                    this.toggleError('custom', typeof errorMessage !== 'undefined' && errorMessage !== null && errorMessage !== '');
                }
            }
        }
    }
    toggleChecked() {
        this.checked = !this.checked;
        this.checkedChange.emit(this.checked);
        this.inputService.valueChanged.emit();
    }
    toggleError(errorType, isErrored) {
        if (this.errorType && this.errorType !== errorType)
            this.errorChange.emit();
        // Clear the error state
        this.error = isErrored;
        if (isErrored) {
            switch (errorType) {
                case 'required':
                    this.displayedErrorMessage = this.errorMessageRequired;
                    break;
                case 'custom':
                    this.displayedErrorMessage = this.customErrorMessage;
                    break;
            }
        }
        // Set the error on the validation service
        if (isErrored) {
            // Add the error type
            this.errorType = errorType;
            // Add the error to the validation service
            this.validationService.addError(this);
            // Add the error to the group
            this.inputService.addError(this);
        }
        else {
            // Remove the error type
            this.errorType = null;
            // Remove the error from the validation service
            this.validationService.removeError(this);
            // Remove the error from the group
            this.inputService.removeError(this);
        }
        // Emit the change to the error
    }
    onClick(event) {
        this.propagateClickEvent(event);
    }
    propagateClickEvent(event) {
        event.radioObject = this;
        this.onClickEvent.emit(!this.checked);
    }
    get hasValue() {
        return typeof this.value !== 'undefined' && this.value !== null;
    }
    get hasError() {
        return this.error;
    }
    // Use Live Announcer to simulate announcements from aria-expanded
    announceExpandOrCollapse() {
        // If the checkbox or radio item has a content addition, announce collapse
        // or expansion message if checked or not checked
        if (this.ngContent && this.ngContent.nativeElement.children.length > 0) {
            if (this.checked) {
                this.liveAnnouncer.announce(this.expandedMessage);
            }
            else {
                this.liveAnnouncer.announce(this.collapsedMessage);
            }
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CheckboxRadioRootComponent, deps: [{ token: InputService }, { token: ValidationService }, { token: CitiLiveAnnouncer }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: CheckboxRadioRootComponent, isStandalone: false, selector: "citi-checkbox-radio-root", inputs: { required: "required", ariaLabelledById: "ariaLabelledById", ariaLabel: "ariaLabel", contentAddition: "contentAddition", idStr: "idStr", name: "name", value: "value", label: "label", disabled: "disabled", checked: "checked", check: "check", error: "error", htmlContent: "htmlContent", errorMessageRequired: "errorMessageRequired", customValidator: "customValidator" }, outputs: { checkedChange: "checkedChange", errorChange: "errorChange", blur: "blur", keyup: "keyup", keydown: "keydown", keypress: "keypress", onClickEvent: "onClickEvent" }, providers: [{ provide: FormComponent, useExisting: forwardRef((() => CheckboxRadioRootComponent)) }], viewQueries: [{ propertyName: "input", first: true, predicate: ["input"], descendants: true }, { propertyName: "contentAdditionEl", first: true, predicate: ["contentAdditionEl"], descendants: true }, { propertyName: "ngContent", first: true, predicate: ["ngContent"], descendants: true }], usesInheritance: true, ngImport: i0, template: `
  <div class="{{type}} col-xs-12 inline-addition" [class.validation-input-danger]="error ? true : null"
  [class.content-addition]="isContentAddition ? true : null" *ngIf="idStr && name && label && value">
  <input
    onkeypress="if (event.keyCode == 13) return false;"
    #input
    [attr.type]="type"
    [attr.id]="idStr"
    [attr.name]="name"
    [value]="value"
    [required]="required"
    (change)="onChange()"
    (blur)="blur.emit($event)"
    (keypress)="keypress.emit($event)"
    (keyup)="keyup.emit($event)"
    (keydown)="keydown.emit($event)"
    tabindex="0"
    [ngClass]="classes"
    [checked]="checked ? true : null"
    (click)="onClick($event)"
    [attr.disabled]="disabled ? true : null"
    [attr.aria-controls]="ngContent && ngContent.children.length ? idStr + '-addition' : null"
    (focus)="onFocus()"
    >
  <label
    [attr.for]="idStr"
    [attr.id]="idStr + '-label'"
    [innerHtml]="label"
    tabindex="-1"
  >
  </label>
  <!-- Error Messsage -->
  <span *ngIf="error" class="validation-message-danger" aria-live="assertive"
        [attr.id]="name !== null ? name + 'error' : null" [innerHtml]="displayedErrorMessage" role="alert">
  </span>
  <div [attr.id]="idStr + '-addition'" class="row" [hidden]="ngContent && !ngContent.children.length" #contentAdditionEl>
    <div class="col-xs-12">
      <div class="inline-content">
        <div #ngContent [contentHtml]="htmlContent">
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  </div>
</div>
`, isInline: true, styles: [".checkBoxAppear{appearance:checkbox!important}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CheckboxRadioRootComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-checkbox-radio-root', standalone: false, changeDetection: ChangeDetectionStrategy.OnPush, template: `
  <div class="{{type}} col-xs-12 inline-addition" [class.validation-input-danger]="error ? true : null"
  [class.content-addition]="isContentAddition ? true : null" *ngIf="idStr && name && label && value">
  <input
    onkeypress="if (event.keyCode == 13) return false;"
    #input
    [attr.type]="type"
    [attr.id]="idStr"
    [attr.name]="name"
    [value]="value"
    [required]="required"
    (change)="onChange()"
    (blur)="blur.emit($event)"
    (keypress)="keypress.emit($event)"
    (keyup)="keyup.emit($event)"
    (keydown)="keydown.emit($event)"
    tabindex="0"
    [ngClass]="classes"
    [checked]="checked ? true : null"
    (click)="onClick($event)"
    [attr.disabled]="disabled ? true : null"
    [attr.aria-controls]="ngContent && ngContent.children.length ? idStr + '-addition' : null"
    (focus)="onFocus()"
    >
  <label
    [attr.for]="idStr"
    [attr.id]="idStr + '-label'"
    [innerHtml]="label"
    tabindex="-1"
  >
  </label>
  <!-- Error Messsage -->
  <span *ngIf="error" class="validation-message-danger" aria-live="assertive"
        [attr.id]="name !== null ? name + 'error' : null" [innerHtml]="displayedErrorMessage" role="alert">
  </span>
  <div [attr.id]="idStr + '-addition'" class="row" [hidden]="ngContent && !ngContent.children.length" #contentAdditionEl>
    <div class="col-xs-12">
      <div class="inline-content">
        <div #ngContent [contentHtml]="htmlContent">
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  </div>
</div>
`, providers: [{ provide: FormComponent, useExisting: forwardRef((() => CheckboxRadioRootComponent)) }], styles: [".checkBoxAppear{appearance:checkbox!important}\n"] }]
        }], ctorParameters: () => [{ type: InputService }, { type: ValidationService }, { type: CitiLiveAnnouncer }, { type: i0.ChangeDetectorRef }], propDecorators: { required: [{
                type: Input$1
            }], ariaLabelledById: [{
                type: Input$1
            }], ariaLabel: [{
                type: Input$1
            }], contentAddition: [{
                type: Input$1
            }], idStr: [{
                type: Input$1
            }], name: [{
                type: Input$1
            }], value: [{
                type: Input$1
            }], label: [{
                type: Input$1
            }], disabled: [{
                type: Input$1
            }], checked: [{
                type: Input$1
            }], check: [{
                type: Input$1
            }], checkedChange: [{
                type: Output
            }], error: [{
                type: Input$1
            }], errorChange: [{
                type: Output
            }], htmlContent: [{
                type: Input$1
            }], errorMessageRequired: [{
                type: Input$1
            }], customValidator: [{
                type: Input$1
            }], blur: [{
                type: Output
            }], keyup: [{
                type: Output
            }], keydown: [{
                type: Output
            }], keypress: [{
                type: Output
            }], onClickEvent: [{
                type: Output
            }], input: [{
                type: ViewChild,
                args: ["input"]
            }], contentAdditionEl: [{
                type: ViewChild,
                args: ["contentAdditionEl"]
            }], ngContent: [{
                type: ViewChild,
                args: ["ngContent"]
            }] } });

/**
 * @Component: Checkbox
 * @Section: Forms
 * @Description: This component generates the checkbox
 */
class CheckboxComponent extends CheckboxRadioRootComponent {
    // ---------- Constructor ----------- //
    constructor(inputServiceCheckbox, validationService, liveAnnouncer, cdr) {
        super(inputServiceCheckbox, validationService, liveAnnouncer, cdr);
        this.inputServiceCheckbox = inputServiceCheckbox;
        if (isDevMode()) {
            console.error('%cThe Common UI DDL InputGroup <citi-checkbox> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
        this.type = 'checkbox';
        this.classes.push('checkboxAppear');
    }
    ;
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CheckboxComponent, deps: [{ token: InputService }, { token: ValidationService }, { token: CitiLiveAnnouncer }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: CheckboxComponent, isStandalone: false, selector: "citi-checkbox", usesInheritance: true, ngImport: i0, template: `
<div class="checkbox col-xs-12 inline-addition" [class.validation-input-danger]="error ? true : null"
  [class.content-addition]="isContentAddition ? true : null" *ngIf="idStr && name && label && value">
  <input
    onkeypress="if (event.keyCode == 13) return false;"
    #input
    type="checkbox"
    [attr.id]="idStr"
    [attr.name]="name"
    [value]="value"
    [required]="required"
    (change)="onChange()"
    (blur)="blur.emit($event)"
    (keypress)="keypress.emit($event)"
    (keyup)="keyup.emit($event)"
    (keydown)="keydown.emit($event)"
    class="checkBoxAppear"
    tabindex="0"
    [ngClass]="classes"
    [checked]="checked ? true : null"
    (click)="onClick($event)"
    (focus)="onFocus()"
    [attr.disabled]="disabled ? true : null"
    [attr.aria-controls]="ngContent && ngContent.children.length ? idStr + '-addition' : null"
    [attr.aria-expanded]="ngContent && checked && ngContent.children.length ? true : null"
    [attr.aria-labelledby]="getAriaLabelledBy()"
    [attr.aria-label]="getAriaLabel()"
    >
  <label
    *ngIf="!!label"
    [attr.for]="idStr"
    [attr.id]="idStr + '-label'"
    [innerHtml]="label"
    tabindex="-1"
  >
  </label>
  <!-- Error Messsage -->
  <span *ngIf="error" class="validation-message-danger" aria-live="assertive"
        [attr.id]="name !== null ? name + 'error' : null" [innerHtml]="displayedErrorMessage" role="alert">
  </span>
  <div [attr.id]="idStr + '-addition'" class="row" [hidden]="ngContent && !ngContent.children.length">
    <div class="col-xs-12">
      <div class="inline-content">
        <div #ngContent [contentHtml]="htmlContent">
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  </div>
</div>
`, isInline: true, dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CheckboxComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'citi-checkbox',
                    standalone: false,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: `
<div class="checkbox col-xs-12 inline-addition" [class.validation-input-danger]="error ? true : null"
  [class.content-addition]="isContentAddition ? true : null" *ngIf="idStr && name && label && value">
  <input
    onkeypress="if (event.keyCode == 13) return false;"
    #input
    type="checkbox"
    [attr.id]="idStr"
    [attr.name]="name"
    [value]="value"
    [required]="required"
    (change)="onChange()"
    (blur)="blur.emit($event)"
    (keypress)="keypress.emit($event)"
    (keyup)="keyup.emit($event)"
    (keydown)="keydown.emit($event)"
    class="checkBoxAppear"
    tabindex="0"
    [ngClass]="classes"
    [checked]="checked ? true : null"
    (click)="onClick($event)"
    (focus)="onFocus()"
    [attr.disabled]="disabled ? true : null"
    [attr.aria-controls]="ngContent && ngContent.children.length ? idStr + '-addition' : null"
    [attr.aria-expanded]="ngContent && checked && ngContent.children.length ? true : null"
    [attr.aria-labelledby]="getAriaLabelledBy()"
    [attr.aria-label]="getAriaLabel()"
    >
  <label
    *ngIf="!!label"
    [attr.for]="idStr"
    [attr.id]="idStr + '-label'"
    [innerHtml]="label"
    tabindex="-1"
  >
  </label>
  <!-- Error Messsage -->
  <span *ngIf="error" class="validation-message-danger" aria-live="assertive"
        [attr.id]="name !== null ? name + 'error' : null" [innerHtml]="displayedErrorMessage" role="alert">
  </span>
  <div [attr.id]="idStr + '-addition'" class="row" [hidden]="ngContent && !ngContent.children.length">
    <div class="col-xs-12">
      <div class="inline-content">
        <div #ngContent [contentHtml]="htmlContent">
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  </div>
</div>
`
                }]
        }], ctorParameters: () => [{ type: InputService }, { type: ValidationService }, { type: CitiLiveAnnouncer }, { type: i0.ChangeDetectorRef }] });

let nextId$6 = 0;
// #endregion
/**
 * @Component: Disclaimer
 * @Section: Forms
 * @description This is the disclaimer component and is used to create reusable disclaimer
 * from Bootstrap.
*/
class SignOnComponent {
    /**
     * @property unmaskedValue
     * @description Gets the raw value without any masking
     * @return string
     * @twoway false
     */
    get unmaskedValue() {
        return this._unmaskedValue;
    }
    // #endregion
    // #region // ---------------- Constructor ---------------- ///
    constructor() {
        //remember user id - by default false
        this.rememberUserID = false;
        this._unmaskedValue = '';
        // #endregion
        // #region // ---------------- Input/Output ---------------- ///
        // to focus input on load.
        this.focusInput = false;
        /**
          * @property user
          * @description This defines default user index for cookied.
          * @return string
         */
        this.user = undefined;
        /**
         * @Event: SubmitButtonClicked
         * @description This event that is fired when the submit button is clicked
         * Can be bound to with (SubmitButtonClicked)='myFunction($event)'
         * @return Object
         */
        this.SubmitButtonClicked = new EventEmitter();
        /**
         * @Event: onUserChange
         * @description This event that is fired when the user changes the drop down value
         * Can be bound to with (onUserChange)='myFunction($event)'
         * @return Object
         */
        this.onUserChange = new EventEmitter();
        /**
         * @property focus
         * @description Provides one-way binding to when the input is focused.
         * Returns reference to the input object. bind with (focus)="myFocusFunction($event)"
         * @Type: EventEmitter
         */
        this.focus = new EventEmitter;
        this.hostId = `signOn-${nextId$6++}`;
    }
    // #endregion
    // #region // ---------------- Life Cycles ---------------- ///
    // onValueChanged(target: HTMLSelectElement): void {
    //     this.user = target.value;
    // }
    ngOnInit() {
        this.signonConfig = this.data;
        // Set up config object to temporarily hold our calculated values
        const signonData = {};
        if (this.signonConfig) {
            //set the forgot user text and url to navigate
            if (this.signonConfig.forgotUser) {
                signonData.forgotUserText = this.signonConfig.forgotUser.text;
                signonData.forgotUserUrl = this.signonConfig.forgotUser.action;
            }
            //set the forgot password text and url to navigate
            if (this.signonConfig.forgotPassword) {
                signonData.forgotPasswordText = this.signonConfig.forgotPassword.text;
                signonData.forgotPasswordUrl = this.signonConfig.forgotPassword.action;
            }
            //set the activate the card text and url to navigate
            if (this.signonConfig.activateCard) {
                signonData.activateCardText = this.signonConfig.activateCard.text;
                signonData.activateCardUrl = this.signonConfig.activateCard.action;
            }
            //set the register online text and url to navigate
            if (this.signonConfig.registerOnline) {
                signonData.registerOnlineText = this.signonConfig.registerOnline.text;
                signonData.registerOnlineUrl = this.signonConfig.registerOnline.action;
            }
            //to show the user name drop down if existing user is present
            if (this.signonConfig.existingUsers && this.signonConfig.existingUsers.usernames && this.signonConfig.existingUsers.usernames.length) {
                // Set the component to use the user select dropdown
                signonData.useUserSelect = true;
                // Set the form to show the existing users dropdown
                signonData.showUserSelect = true;
                this.signonConfig.dropdownUsers = [];
                for (let i = 0, j = this.signonConfig.existingUsers.usernames.length; i < j; i++) {
                    this.signonConfig.dropdownUsers.push({
                        originalUser: this.signonConfig.existingUsers.usernames[i],
                        maskedUser: this.maskUsername(this.signonConfig.existingUsers.usernames[i])
                    });
                }
                // Provide the existing users dropdown's usernames
                signonData.existingUserNames = this.signonConfig.dropdownUsers;
                // Provide the existing users dropdown's add user text
                signonData.addUserText = this.signonConfig.existingUsers.addUserText;
                // Provide the existing users dropdown's delete user text
                signonData.deleteUserText = this.signonConfig.existingUsers.deleteUserText;
                // Provide the existing users dropdown's delete users url;
                signonData.deleteUserUrl = this.signonConfig.existingUsers.deleteUserUrl;
            }
        }
        // Set the config for use by the dom (DOM will not show until this is set);
        this.config = signonData;
    }
    ngAfterViewInit() {
        if (this.config.existingUserNames && this.config.existingUserNames.length) {
            this.user = this.userDropdown.value = this.config.existingUserNames[0].originalUser;
        }
    }
    // #endregion
    // #region // ---------------- Methods ---------------- ///
    //called when the remember check box is checked
    rememberCheckbox(event) {
        this.rememberUserID = event.target.checked;
    }
    ;
    // Called when the input is blurred
    onUsernameBlur(input) {
        if (this.usernameValue && this.usernameValue.length) {
            this.usernameValue = this.maskUsername(this.usernameValue);
        }
    }
    ;
    // On focus
    onFocus(input) {
        this.usernameValue = input._unmaskedValue;
        this.focus.emit(this);
    }
    ;
    //called when the submit button is clicked
    onSubmit(event, username, password, rememberuserid) {
        this.SubmitButtonClicked.emit({ event, username, password, rememberuserid });
    }
    // When the user select dropdown is changed
    onUserSelectChange(event) {
        this.user = event.target.value;
        // Get the value
        const value = event.target.value;
        // If the user selects the different user option
        if (value === 'differentUser') {
            // Set the user select not to show and the username input to show
            this.config.showUserSelect = false;
            this.focusInput = true;
        }
        else if (value === 'deleteUser') {
            // Take the user to the url specified
            window.location.href = this.config.deleteUserUrl;
        }
        this.onUserChange.emit(event);
    }
    ;
    // Masks the majority of characters in a username
    maskUsername(username) {
        // Define the long and short masks
        const short = /(^.)(.{1,})(.$)/;
        const long = /(^..)(.{1,})(..$)/;
        // Get the mask that should be used
        const mask = username.length >= 7 ? long : short;
        // Mask the username
        username = username.replace(mask, (a, b, c, d) => {
            // Get the first part of the string
            let maskedString = b;
            // Add an x for every character between the first and last sections
            for (let i = 0, j = c.length; i < j; i++) {
                maskedString += 'x';
            }
            // Add the last section
            maskedString += d;
            // Return the completed string
            return maskedString;
        });
        // Return the masked username
        return username;
    }
    ;
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: SignOnComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: SignOnComponent, isStandalone: false, selector: "citi-signon", inputs: { focusInput: "focusInput", idStr: "idStr", user: "user", htmlContent: "htmlContent", data: "data" }, outputs: { SubmitButtonClicked: "SubmitButtonClicked", onUserChange: "onUserChange", focus: "focus" }, host: { classAttribute: "citi-signon" }, viewQueries: [{ propertyName: "input", first: true, predicate: ["input"], descendants: true }, { propertyName: "userDropdown", first: true, predicate: ["userDropdown"], descendants: true }], ngImport: i0, template: `
    <div class="signonContainer " *ngIf="data">
      <section class="theme-light SampleErrorStates" [attr.id]="'section' + '-' + hostId">
        <h4>{{data.title}}</h4>
        <div class="username-input">
          <citi-input #input *ngIf="!config.showUserSelect" [idStr]="'userIdInput' + '-' + hostId" [focused]="focusInput"
            (input)="user = $event.target.value" (focus)="onFocus($event)" [label]="data.usernamePlaceholder"
            [placeholder]="data.usernamePlaceholder" type="text" [name]="data.usernameName" required="true"
            [requiredError]="data.userIdBlankError" [minLengthError]="data.userIdShortError"
            [minlength]="data.userIdMinChars" size="fullwidth" [(value)]="usernameValue" (blur)="onUsernameBlur($event)"
            [validateOnBlur]="false">
          </citi-input>
        </div>
        <div class="username-dropdown">
          <citi-dropdown #userDropdown [idStr]="'userSelect' + '-' + hostId" [label]="data.usernamePlaceholder" size="fullwidth"
            [name]="data.usernameName" (change)="onUserSelectChange($event)" *ngIf="config.showUserSelect">
            <citi-dropdown-option *ngFor="let user of config.existingUserNames" [value]="user.originalUser" [label]="user.maskedUser"></citi-dropdown-option>
            <citi-dropdown-option *ngFor="let user of ['1']" value="differentUser" [label]="config.addUserText"></citi-dropdown-option>
            <citi-dropdown-option *ngFor="let user of ['1']" value="deleteUser" [label]="config.deleteUserText"></citi-dropdown-option>
          </citi-dropdown>
        </div>
        <div class="password-input">
          <citi-input #pass [idStr]="'passwordInput' + '-' + hostId" [attr.name]="data.passwordName" [placeholder]="data.passwordPlaceholder"
            [requiredError]="data.passwordBlankError" [minLengthError]="data.passwordShortError"
            [minlength]="data.passwordMinChars" required="true" type="password" autocomplete="off" size="fullwidth" [validateOnBlur]="false">
          </citi-input>
        </div>
        <div class="row">
          <citi-checkbox *ngIf="!config.showUserSelect" [idStr]="'rememberIdCheck' + '-' + hostId" name="remember" value="true"
            [label]="data.rememberIdText" [checked]="rememberUserID" (change)="rememberCheckbox($event)">
          </citi-checkbox>
        </div>
        <div class="secInfo" *ngIf="rememberUserID" aria-live="polite">
          <div class="ui-tooltip-rmid" id="ui-tooltip-rmid"><small>{{data.rememberText}}</small></div>
        </div>

          <div class="row">
            <div class="col-xs-12 form-group signonButton">
              <input
                type="button"
                [attr.id]="'signOnBtn' + '-' + hostId"
                [value]="data.buttonText"
                (click)="onSubmit($event, user, pass.value, rememberUserID);"
                class="btn btn-primary">
            </div>
          </div>

        <div class="row linkBlock">
          <div class="col-xs-6">
            <div class=" no-mt firstSet" *ngIf="config.forgotUserText">
              <a [attr.id]="'RequestUserIDReminder' + '-' + hostId" class="btn btn-link removeMobilePadding requestUserIDReminder removeWhiteSpace"
                [href]="config.forgotUserUrl" target="_top">{{config.forgotUserText}}
              </a>
            </div>
          </div>
          <div class="col-xs-6">
            <div class=" no-mt secondset" *ngIf="config.activateCardText">
              <a [attr.id]="'activate_card' + '-' + hostId" class="btn btn-link removeMobilePadding top20" [href]="config.activateCardUrl" target="_top">
                {{config.activateCardText}}
              </a>
            </div>
          </div>
        </div>
        <div class="row linkBlock">
          <div class="col-xs-6">
            <div class=" firstSet" *ngIf="config.forgotPasswordText">
              <a [attr.id]="'RequestPassswordReminder' + '-' + hostId" class="btn btn-link removeMobilePadding requestUserIDReminder"
                [href]="config.forgotPasswordUrl" target="_top">
                {{config.forgotPasswordText}}
              </a>
            </div>
          </div>
          <div class="col-xs-6">
            <div class=" secondset" *ngIf="config.registerOnlineText">
              <a [attr.id]="'register_acc' + '-' + hostId" class="btn btn-link removeMobilePadding top20" [href]="config.registerOnlineUrl" target="_top">
                {{config.registerOnlineText}}
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  `, isInline: true, styles: [".signonContainer{width:344px;padding-left:10px;padding-right:10px}.signonContainer .SampleErrorStates ::ng-deep p{margin:2em 0}.signonContainer .SampleErrorStates ::ng-deep .checkbox{margin-top:0}.signonContainer .SampleErrorStates .linkBlock{margin-left:0;margin-right:0}.signonContainer .SampleErrorStates .linkBlock a{overflow-wrap:break-word!important;white-space:pre-line!important;text-align:left!important;font-size:12px!important;margin-right:0!important;vertical-align:top}.signonContainer .signonButton{margin-bottom:0}.signonContainer .username-dropdown ::ng-deep .form-group{padding:0!important}.signonContainer .secInfo{line-height:18px}@media (max-width: 768px){.signonContainer{width:320px}}input.btn{-webkit-appearance:button!important}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: InputComponent, selector: "citi-input", inputs: ["dataFormat", "autocomplete", "autocompleteType", "ariaLabel", "allowIntegerOnly", "idStr", "name", "label", "focused", "value", "placeholder", "tooltipTitle", "tooltipBody", "tooltipPosition", "currency", "searchIcon", "maxlength", "minlength", "required", "errorMessage", "customErrorMessage", "error", "requiredError", "themeDark", "themeLight", "addOnTheme", "messageOnlyIntegerError", "allowNonZeroValueOnly", "messageOnlyNonZeroError", "messageOnlyPositiveIntegerError", "minLengthError", "describedby", "tabIndex", "countryCodes", "areaCodes", "altPhoneMaskPattern", "currencySignAfter", "currencySignBefore", "pattern", "applyMaskOnEvents", "removeMaskOnEvents", "selectedPhoneCountry", "validateOnBlur", "allowPositiveIntegerOnly", "unmaskedLength", "allowDecimalDollarMask", "hasCustomError", "showZeroValue", "mask", "type", "size"], outputs: ["blur", "focus", "errorChange", "valueChange", "selectedPhoneCountryChange", "valueChanged", "unmaskValueChanged"] }, { kind: "component", type: DropdownComponent, selector: "citi-dropdown", inputs: ["options", "whiteBackground", "value", "idStr", "name", "size", "label", "placeholder", "required", "additionalClasses", "errorMessage", "error", "requiredError", "tooltipTitle", "tooltipBody", "tooltipPosition", "isDisabled", "dropdownTheme", "isHidden", "autofocus", "hasTooltip"], outputs: ["valueChange", "selectionChange", "errorChange"] }, { kind: "component", type: DropdownOptionComponent, selector: "citi-dropdown-option", inputs: ["value", "label", "selected", "disabled", "group"] }, { kind: "component", type: CheckboxComponent, selector: "citi-checkbox" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: SignOnComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-signon', standalone: false, host: { class: 'citi-signon' }, template: `
    <div class="signonContainer " *ngIf="data">
      <section class="theme-light SampleErrorStates" [attr.id]="'section' + '-' + hostId">
        <h4>{{data.title}}</h4>
        <div class="username-input">
          <citi-input #input *ngIf="!config.showUserSelect" [idStr]="'userIdInput' + '-' + hostId" [focused]="focusInput"
            (input)="user = $event.target.value" (focus)="onFocus($event)" [label]="data.usernamePlaceholder"
            [placeholder]="data.usernamePlaceholder" type="text" [name]="data.usernameName" required="true"
            [requiredError]="data.userIdBlankError" [minLengthError]="data.userIdShortError"
            [minlength]="data.userIdMinChars" size="fullwidth" [(value)]="usernameValue" (blur)="onUsernameBlur($event)"
            [validateOnBlur]="false">
          </citi-input>
        </div>
        <div class="username-dropdown">
          <citi-dropdown #userDropdown [idStr]="'userSelect' + '-' + hostId" [label]="data.usernamePlaceholder" size="fullwidth"
            [name]="data.usernameName" (change)="onUserSelectChange($event)" *ngIf="config.showUserSelect">
            <citi-dropdown-option *ngFor="let user of config.existingUserNames" [value]="user.originalUser" [label]="user.maskedUser"></citi-dropdown-option>
            <citi-dropdown-option *ngFor="let user of ['1']" value="differentUser" [label]="config.addUserText"></citi-dropdown-option>
            <citi-dropdown-option *ngFor="let user of ['1']" value="deleteUser" [label]="config.deleteUserText"></citi-dropdown-option>
          </citi-dropdown>
        </div>
        <div class="password-input">
          <citi-input #pass [idStr]="'passwordInput' + '-' + hostId" [attr.name]="data.passwordName" [placeholder]="data.passwordPlaceholder"
            [requiredError]="data.passwordBlankError" [minLengthError]="data.passwordShortError"
            [minlength]="data.passwordMinChars" required="true" type="password" autocomplete="off" size="fullwidth" [validateOnBlur]="false">
          </citi-input>
        </div>
        <div class="row">
          <citi-checkbox *ngIf="!config.showUserSelect" [idStr]="'rememberIdCheck' + '-' + hostId" name="remember" value="true"
            [label]="data.rememberIdText" [checked]="rememberUserID" (change)="rememberCheckbox($event)">
          </citi-checkbox>
        </div>
        <div class="secInfo" *ngIf="rememberUserID" aria-live="polite">
          <div class="ui-tooltip-rmid" id="ui-tooltip-rmid"><small>{{data.rememberText}}</small></div>
        </div>

          <div class="row">
            <div class="col-xs-12 form-group signonButton">
              <input
                type="button"
                [attr.id]="'signOnBtn' + '-' + hostId"
                [value]="data.buttonText"
                (click)="onSubmit($event, user, pass.value, rememberUserID);"
                class="btn btn-primary">
            </div>
          </div>

        <div class="row linkBlock">
          <div class="col-xs-6">
            <div class=" no-mt firstSet" *ngIf="config.forgotUserText">
              <a [attr.id]="'RequestUserIDReminder' + '-' + hostId" class="btn btn-link removeMobilePadding requestUserIDReminder removeWhiteSpace"
                [href]="config.forgotUserUrl" target="_top">{{config.forgotUserText}}
              </a>
            </div>
          </div>
          <div class="col-xs-6">
            <div class=" no-mt secondset" *ngIf="config.activateCardText">
              <a [attr.id]="'activate_card' + '-' + hostId" class="btn btn-link removeMobilePadding top20" [href]="config.activateCardUrl" target="_top">
                {{config.activateCardText}}
              </a>
            </div>
          </div>
        </div>
        <div class="row linkBlock">
          <div class="col-xs-6">
            <div class=" firstSet" *ngIf="config.forgotPasswordText">
              <a [attr.id]="'RequestPassswordReminder' + '-' + hostId" class="btn btn-link removeMobilePadding requestUserIDReminder"
                [href]="config.forgotPasswordUrl" target="_top">
                {{config.forgotPasswordText}}
              </a>
            </div>
          </div>
          <div class="col-xs-6">
            <div class=" secondset" *ngIf="config.registerOnlineText">
              <a [attr.id]="'register_acc' + '-' + hostId" class="btn btn-link removeMobilePadding top20" [href]="config.registerOnlineUrl" target="_top">
                {{config.registerOnlineText}}
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  `, styles: [".signonContainer{width:344px;padding-left:10px;padding-right:10px}.signonContainer .SampleErrorStates ::ng-deep p{margin:2em 0}.signonContainer .SampleErrorStates ::ng-deep .checkbox{margin-top:0}.signonContainer .SampleErrorStates .linkBlock{margin-left:0;margin-right:0}.signonContainer .SampleErrorStates .linkBlock a{overflow-wrap:break-word!important;white-space:pre-line!important;text-align:left!important;font-size:12px!important;margin-right:0!important;vertical-align:top}.signonContainer .signonButton{margin-bottom:0}.signonContainer .username-dropdown ::ng-deep .form-group{padding:0!important}.signonContainer .secInfo{line-height:18px}@media (max-width: 768px){.signonContainer{width:320px}}input.btn{-webkit-appearance:button!important}\n"] }]
        }], ctorParameters: () => [], propDecorators: { focusInput: [{
                type: Input$1
            }], idStr: [{
                type: Input$1
            }], user: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }], data: [{
                type: Input$1
            }], SubmitButtonClicked: [{
                type: Output
            }], onUserChange: [{
                type: Output
            }], focus: [{
                type: Output
            }], input: [{
                type: ViewChild,
                args: ['input']
            }], userDropdown: [{
                type: ViewChild,
                args: ['userDropdown']
            }] } });

/**
 * @Component: Checkbox
 * @Section: Forms
 * @Description: This componentt generates the checkbox
 */
class RadioComponent extends CheckboxRadioRootComponent {
    // ---------- Constructor ----------- //
    constructor(inputServiceRadio, validationService, liveAnnouncer, cdr) {
        super(inputServiceRadio, validationService, liveAnnouncer, cdr);
        this.inputServiceRadio = inputServiceRadio;
        if (isDevMode()) {
            console.error('%cThe Common UI DDL InputGroup <citi-radio> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
        this.type = 'radio';
    }
    ;
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: RadioComponent, deps: [{ token: InputService }, { token: ValidationService }, { token: CitiLiveAnnouncer }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: RadioComponent, isStandalone: false, selector: "citi-radio", usesInheritance: true, ngImport: i0, template: `
<div class="radio col-xs-12 inline-addition" [class.validation-input-danger]="error ? true : null"
  [class.content-addition]="isContentAddition ? true : null" *ngIf="idStr && name && label && value">
  <input
    onkeypress="if (event.keyCode == 13) return false;"
    #input
    type="radio"
    [attr.id]="idStr"
    [attr.name]="name"
    [value]="value"
    [required]="required"
    (change)="onChange()"
    (blur)="blur.emit($event)"
    (keypress)="keypress.emit($event)"
    (keyup)="keyup.emit($event)"
    (keydown)="keydown.emit($event)"
    tabindex="0"
    [ngClass]="classes"
    [checked]="checked ? true : null"
    (click)="onClick($event)"
    (focus)="onFocus()"
    [attr.disabled]="disabled ? true : null"
    [attr.aria-controls]="ngContent && ngContent.children.length ? idStr + '-addition' : null"
    [attr.aria-expanded]="ngContent && checked && ngContent.children.length ? true : null"
    [attr.aria-labelledby]="getAriaLabelledBy()"
    [attr.aria-label]="getAriaLabel()"
    >
  <label
    *ngIf="!!label"
    [attr.for]="idStr"
    [attr.id]="idStr + '-label'"
    [innerHtml]="label"
    tabindex="-1"
  >
  </label>
  <!-- Error Messsage -->
  <span *ngIf="error" class="validation-message-danger" aria-live="assertive"
        [attr.id]="name !== null ? name + 'error' : null" [innerHtml]="displayedErrorMessage" role="alert">
  </span>
  <div [attr.id]="idStr + '-addition'" class="row" [hidden]="ngContent && !ngContent.children.length">
    <div class="col-xs-12">
      <div class="inline-content">
        <div #ngContent [contentHtml]="htmlContent">
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  </div>
</div>
`, isInline: true, dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: RadioComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'citi-radio',
                    standalone: false,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: `
<div class="radio col-xs-12 inline-addition" [class.validation-input-danger]="error ? true : null"
  [class.content-addition]="isContentAddition ? true : null" *ngIf="idStr && name && label && value">
  <input
    onkeypress="if (event.keyCode == 13) return false;"
    #input
    type="radio"
    [attr.id]="idStr"
    [attr.name]="name"
    [value]="value"
    [required]="required"
    (change)="onChange()"
    (blur)="blur.emit($event)"
    (keypress)="keypress.emit($event)"
    (keyup)="keyup.emit($event)"
    (keydown)="keydown.emit($event)"
    tabindex="0"
    [ngClass]="classes"
    [checked]="checked ? true : null"
    (click)="onClick($event)"
    (focus)="onFocus()"
    [attr.disabled]="disabled ? true : null"
    [attr.aria-controls]="ngContent && ngContent.children.length ? idStr + '-addition' : null"
    [attr.aria-expanded]="ngContent && checked && ngContent.children.length ? true : null"
    [attr.aria-labelledby]="getAriaLabelledBy()"
    [attr.aria-label]="getAriaLabel()"
    >
  <label
    *ngIf="!!label"
    [attr.for]="idStr"
    [attr.id]="idStr + '-label'"
    [innerHtml]="label"
    tabindex="-1"
  >
  </label>
  <!-- Error Messsage -->
  <span *ngIf="error" class="validation-message-danger" aria-live="assertive"
        [attr.id]="name !== null ? name + 'error' : null" [innerHtml]="displayedErrorMessage" role="alert">
  </span>
  <div [attr.id]="idStr + '-addition'" class="row" [hidden]="ngContent && !ngContent.children.length">
    <div class="col-xs-12">
      <div class="inline-content">
        <div #ngContent [contentHtml]="htmlContent">
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  </div>
</div>
`
                }]
        }], ctorParameters: () => [{ type: InputService }, { type: ValidationService }, { type: CitiLiveAnnouncer }, { type: i0.ChangeDetectorRef }] });

/**
 * @Component: Input Group
 * @Section: Forms
 * @Description: This component generates a group of checkboxes or radio boxes
 */
class InputGroupComponent extends FormComponent {
    set errorMessage(errorMessage) {
        this.inputService.inputGroupErrorMsg = this._errorMessage = errorMessage;
    }
    set value(value) {
        // If the value is not the current value on the input service
        if (value !== this.inputService.value) {
            // If this is the initialization run of the group
            // this.inputService.changeValue(value);
            if (typeof value === 'string')
                this.inputService.value = value;
            else if (Array.isArray(value))
                this.inputService.values = value;
        }
    }
    constructor(inputService, validationService, host, cdr) {
        super();
        this.inputService = inputService;
        this.validationService = validationService;
        this.host = host;
        this.cdr = cdr;
        /**
         * @Property: title
         * @Description: The title for the input group
         * @Type: String
         */
        this.title = '';
        /**
         * @Property: required
         * @Description: If the input group is required
         * @Type: Boolean
         */
        this.required = false;
        /**
         * @Property: error
         * @Description: If the input group is in an error state
         * @Type: Boolean
         */
        this.error = false;
        this.errorChange = new EventEmitter();
        /**
         * @Property: errorMessage
         * @Description: Error message to display while the input group is in an error state
         * @Type: String
         */
        this._errorMessage = 'Error';
        this.valueChange = new EventEmitter();
        if (isDevMode()) {
            console.error('%cThe Common UI DDL InputGroup <citi-input-group> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    markForCheck() {
        this.cdr.markForCheck();
    }
    // Clears an error state on the input. Takes a type of error
    toggleError(errorType, isErrored) {
        // Clear the error state
        this.error = isErrored;
        // Set the error on the validation service
        if (isErrored) {
            // Add the error to the validation service
            this.validationService.addError(this);
        }
        else {
            // Remove the error from the validation service
            this.validationService.removeError(this);
        }
        // Emit the change to the error
        this.errorChange.emit(isErrored);
        this.inputService.inputGroupError = isErrored;
    }
    // Function to validate the input group
    validate() {
        // If this input group is required
        if (this.required) {
            // If the input group is valid or not
            let valid = false;
            // Loop over all the inputs that are a part of this input group
            for (let i = 0, j = this.inputService.inputs.length; i < j; i++) {
                // Get a  reference to the current input
                const input = this.inputService.inputs[i];
                if (input.checked) {
                    valid = input.checked;
                }
                if (input.isChecked) {
                    valid = input.isChecked;
                }
                // fix for first click on an required radio group
                if (!valid && this.inputService.value) {
                    valid = true;
                }
                if (valid) {
                    break;
                }
            }
            // Set the error type if needed
            this.toggleError('required', !valid);
        }
    }
    // On init
    ngOnInit() {
        this.validationService.addInput(this);
        // Subscribe to validateNow on the validation service
        this.validateSub = this.validationService.validateNow.subscribe(validate => {
            this.validate();
        });
        this.valueChangedSub = this.inputService.valueChanged.subscribe(value => {
            this.valueChange.emit(value);
            this.validate();
        });
        // Catch any initial errors in the error service and set the error state if needed
        setTimeout(() => {
            if (this.inputService.errors.length) {
                this.toggleError('input', true);
            }
        });
    }
    ngAfterViewInit() {
        this.updateDomEl();
    }
    ngOnDestroy() {
        this.validationService.removeError(this);
        if (this.validateSub)
            this.validateSub.unsubscribe();
    }
    updateDomEl() {
        this.DomEl = this.host.nativeElement.querySelectorAll('input')[0];
    }
    /**
     * @Function: clearSelection
     * @Description: Function that clears the group input's selections
     * @Return: void
     */
    clearSelection() {
        for (let i = 0; i < this.inputService.inputs.length; i++) {
            this.inputService.inputs[i].checked = false;
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: InputGroupComponent, deps: [{ token: InputService }, { token: ValidationService }, { token: i0.ElementRef }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: InputGroupComponent, isStandalone: false, selector: "citi-input-group", inputs: { title: "title", required: "required", error: "error", errorMessage: "errorMessage", htmlContent: "htmlContent", value: "value" }, outputs: { errorChange: "errorChange", valueChange: "valueChange" }, providers: [InputService], usesInheritance: true, ngImport: i0, template: `
  <fieldset>
  <legend *ngIf="title !== null && title !== ''">
      <span [innerHtml]="title"></span>
  </legend>
  <div class="validation-message-danger" *ngIf="error && _errorMessage" [innerHtml]="_errorMessage" role="alert"></div>
  <div class="row" [ngClass]= "error ? 'validation-fieldset-danger' : null">
      <ng-content></ng-content>
  </div>
</fieldset>
`, isInline: true, styles: [""], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: InputGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-input-group', standalone: false, changeDetection: ChangeDetectionStrategy.OnPush, template: `
  <fieldset>
  <legend *ngIf="title !== null && title !== ''">
      <span [innerHtml]="title"></span>
  </legend>
  <div class="validation-message-danger" *ngIf="error && _errorMessage" [innerHtml]="_errorMessage" role="alert"></div>
  <div class="row" [ngClass]= "error ? 'validation-fieldset-danger' : null">
      <ng-content></ng-content>
  </div>
</fieldset>
`, providers: [InputService] }]
        }], ctorParameters: () => [{ type: InputService }, { type: ValidationService }, { type: i0.ElementRef }, { type: i0.ChangeDetectorRef }], propDecorators: { title: [{
                type: Input$1
            }], required: [{
                type: Input$1
            }], error: [{
                type: Input$1
            }], errorChange: [{
                type: Output
            }], errorMessage: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }], value: [{
                type: Input$1
            }], valueChange: [{
                type: Output
            }] } });

const COMPONENTS$L = [
    CheckboxComponent,
    RadioComponent,
    InputGroupComponent,
    CheckboxRadioRootComponent
];
const MODULES$M = [
    CommonModule,
    ContentHtml
    // Directives,
    // CitiTooltip
];
const SERVICES = [
    InputService
];
class InputGroup {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: InputGroup, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: InputGroup, declarations: [CheckboxComponent,
            RadioComponent,
            InputGroupComponent,
            CheckboxRadioRootComponent], imports: [CommonModule,
            ContentHtml
            // Directives,
            // CitiTooltip
        ], exports: [CheckboxComponent,
            RadioComponent,
            InputGroupComponent,
            CheckboxRadioRootComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: InputGroup, providers: [InputService], imports: [MODULES$M] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: InputGroup, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$M],
                    declarations: [...COMPONENTS$L],
                    exports: [...COMPONENTS$L],
                    providers: [InputService]
                }]
        }] });

const COMPONENTS$K = [
    SignOnComponent
];
const MODULES$L = [
    CommonModule,
    Input,
    Dropdown,
    Grid,
    InputGroup
];
class SignOn {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: SignOn, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: SignOn, declarations: [SignOnComponent], imports: [CommonModule,
            Input,
            Dropdown,
            Grid,
            InputGroup], exports: [SignOnComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: SignOn, imports: [MODULES$L] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: SignOn, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$L],
                    declarations: [...COMPONENTS$K],
                    exports: [...COMPONENTS$K]
                }]
        }] });

/**
 * @Component: Tab-group
 * @description A wrapper for displaying individual tab panels
 */
class TabGroupComponent {
    addTab(tab) {
        if (this.tabContent) {
            if (this.tabContent.nativeElement.children.length == 0) {
                this.tabs = [];
            }
        }
        this.tabs.push(tab);
        return this.tabs.length;
    }
    countTabs() {
        return this.tabs.length;
    }
    constructor(el) {
        this.el = el;
        /**
         * @Event: tabChanged
         * @description This event that is fired when a tab activates; returns the index of the active tab (first tab is 1)
         * @return Number
         */
        this.tabChanged = new EventEmitter();
        this.tabs = [];
        this.tabsFocused = false;
        this.shiftOn = false;
    }
    ngOnInit() {
        this.defaultTab = this.activeTab ? Number.parseInt(this.activeTab, 10) : 1;
        this.selectTab(this.tabs[this.defaultTab - 1], null);
    }
    selectTab(tab, event) {
        if (event) {
            event.preventDefault();
        }
        // Update tab select tag with new tab index
        if (this.tabSelect) {
            this.tabSelect.nativeElement.value = tab.tabIndex;
        }
        if (this.tabs.length > 0) {
            this.tabs.forEach((tab) => {
                tab.isExpanded = false;
                tab.tabIndexAttr = -1;
                tab.tabFocusTrigger.emit(false);
            });
            tab.isExpanded = true;
            tab.tabIndexAttr = 0;
            tab.tabFocusTrigger.emit(true);
            // Event emitter
            this.tabChanged.emit(tab.tabIndex);
        }
    }
    // Dropdown select tag (change) method for mobile version D1.95 Action Module
    setSelectedTab() {
        if (this.tabs.length > 0) {
            let selectedTab;
            for (let tab of this.tabs) {
                // If TabComponent index matches select tag index
                if (this.tabSelect
                    && (Number(this.tabSelect.nativeElement.value) === tab.tabIndex)) {
                    selectedTab = tab;
                }
                // Look through each TabComponent and hide them all
                tab.isExpanded = false;
                tab.tabIndexAttr = -1;
                tab.tabFocusTrigger.emit(false);
            }
            ;
            // Update new TabComponent to currently viewed
            selectedTab.isExpanded = true;
            selectedTab.tabIndexAttr = 0;
            selectedTab.tabFocusTrigger.emit(true);
            // Event emitter
            this.tabChanged.emit(selectedTab.tabIndex);
        }
    }
    prevTab() {
        let curIndex = this.currentTab() - 1;
        let tab;
        if (curIndex == 0) {
            tab = this.tabs[this.tabs.length - 1];
        }
        else {
            tab = this.tabs[curIndex - 1];
        }
        this.selectTab(tab, null);
    }
    nextTab() {
        let curIndex = this.currentTab() - 1;
        let tab;
        if (curIndex == (this.tabs.length - 1)) {
            tab = this.tabs[0];
        }
        else {
            tab = this.tabs[curIndex + 1];
        }
        this.selectTab(tab, null);
    }
    currentTab() {
        let tIndex = -1;
        this.tabs.forEach((tab) => {
            if (tab.isExpanded) {
                tIndex = tab.tabIndex;
            }
        });
        return tIndex;
    }
    getExpanded(tab) {
        let width = window.innerWidth;
        if (width <= 768) {
            return tab.isExpanded;
        }
        else {
            return null;
        }
    }
    tablistFocus() {
        this.tabsFocused = true;
    }
    tabToContent() {
        this.tabsFocused = false;
        this.tabContent.nativeElement.focus();
    }
    stopBubble(event) {
        event.preventDefault();
        event.stopPropagation();
    }
    handleKeyPress(event) {
        if (this.tabsFocused) {
            let keycode = event.which;
            switch (keycode) {
                case KEY_HOME:
                    this.stopBubble(event);
                    this.selectTab(this.tabs[0], null);
                    break;
                case KEY_END:
                    this.stopBubble(event);
                    this.selectTab(this.tabs[this.tabs.length - 1], null);
                    break;
                case KEY_ARROW_LEFT:
                case KEY_ARROW_UP:
                    this.stopBubble(event);
                    this.prevTab();
                    break;
                case KEY_ARROW_RIGHT:
                case KEY_ARROW_DOWN:
                    this.stopBubble(event);
                    this.nextTab();
                    break;
            }
        }
    }
    ngAfterViewInit() {
        // Attaches the trigger button to the tab pages
        if (this.tabs.length > 0) {
            let triggerButtons = this.el.nativeElement.querySelectorAll('ul.accordion-control > li > a');
            this.tabs.forEach((tab, index) => {
                tab.triggerButton = triggerButtons[index];
                tab.tabFocusTrigger.subscribe(function (isActivated) {
                    if (isActivated) {
                        this.triggerButton.focus();
                    }
                }.bind(tab));
            });
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TabGroupComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: TabGroupComponent, isStandalone: false, selector: "citi-tab-group", inputs: { id: "id", activeTab: "activeTab", htmlContent: "htmlContent", alternateStyle: "alternateStyle", tabSelectLabel: "tabSelectLabel" }, outputs: { tabChanged: "tabChanged" }, host: { listeners: { ":keydown": "handleKeyPress($event)" } }, viewQueries: [{ propertyName: "tabContent", first: true, predicate: ["tabContent"], descendants: true }, { propertyName: "tabSelect", first: true, predicate: ["tabSelect"], descendants: true }], ngImport: i0, template: `
  <div class="{{ alternateStyle }}" id="{{id}}">

		<ul id="tgul" class="nav nav-tabs nav-justified hidden-xs accordion-control" role="tablist">
			<li *ngFor="let tab of tabs; let idx = index" role="presentation"
				[class]="(tab.twoLine ? 'two-line' : '') + (tab.isExpanded ? ' active' : '') + (tab.lastTab ? ' last' : '')"
				(click)="selectTab(tab, $event)" [isFocused]="tab.isExpanded">
				<a (focus)="tablistFocus()" [tabindex]="(tab.isExpanded ? 0 : -1)" role="tab" data-toggle="tab"
           href="#"
           [attr.title]="tab.tabTitle"
           [attr.aria-controls]="id + 'Panel-'+ idx"
           [attr.data-parent]="'#' + id + 'Panel-' + idx"
           [attr.id]="id + 'Header-' + idx + '-tab'"
           [attr.aria-selected]="tab.isExpanded.toString()"
           [attr.aria-expanded]="tab.isExpanded.toString()">
          <span class="category-title">
            {{tab.tabTitle}}
            <!--<span [innerHtml]=""></span>-->
            <br *ngIf="tab.twoLine">
            <!--<span [innerHtml]="tab.tabTitleSecond" *ngIf="tab.twoLine"></span>-->
            <span [innerHtml]="tab.tabTitleSecond" *ngIf="tab.twoLine"></span>
          </span>
        </a>
			</li>
    </ul>
    <div class="row hidden-sm hidden-md hidden-lg" *ngIf="alternateStyle">
      <div class="form-group col-md-4 col-sm-6">
        <label for="action-module-mobile-select" class="select-box-label" [innerHTML]="tabSelectLabel"></label>
        <select id="action-module-mobile-select" class="form-control action-module-mobile-select" #tabSelect (change)="setSelectedTab()">
          <option *ngFor="let tab of tabs; let idx = index" [value]="tab.tabIndex" [innerHTML]="tab.tabTitle"></option>
        </select>
      </div>
    </div>
		<div class="accordion menu tabbed-look" data-always-open-panel="true" role="navigation">
			<ul class="mainnav tab-content" #tabContent [contentHtml]="htmlContent">
				<ng-content></ng-content>
			</ul>
		</div>

</div>

  `, isInline: true, styles: [":host .nav-tabs a:focus{outline:1px dotted #212121;outline:5px auto -webkit-focus-ring-color}.accordion.tabbed-look{margin-top:0}.accordion.tabbed-look ul.mainnav.tab-content{border:none;margin-top:0;padding:40px}.accordion.tabbed-look[role=navigation] .tab-content>citi-tab>li.tab-pane{border:none}.accordion.tabbed-look[role=navigation] .tab-content>citi-tab>li.tab-pane>div.accordionSubMenu{padding:0;transition:none;-webkit-transition:none}@media (max-width: 768px){.accordion.tabbed-look[role=navigation] ul.mainnav.tab-content{padding:0;margin-top:20px}.accordion.tabbed-look[role=navigation] ul.mainnav.tab-content>citi-tab>li.tab-pane.is-expanded>div.accordionSubMenu{padding:0 20px 24px 70px}.accordion.tabbed-look[role=navigation] .tab-content>citi-tab>li.tab-pane{border-top:1px solid #999}}.action-d1-95-tab-group{margin-top:-20px}.action-d1-95-tab-group .nav-tabs>li{padding-right:.1px}.action-d1-95-tab-group .nav-tabs.nav-justified>li>a{border-bottom:1px solid rgba(0,0,0,.25)}.action-d1-95-tab-group .nav-tabs.nav-justified>.active>a{border-bottom:5px solid #056DAE;color:#056dae}.action-d1-95-tab-group .form-group .form-control.action-module-mobile-select{background-color:#fff}@media (min-width: 768px){.action-d1-95-tab-group .nav-tabs>li>a{padding:.1px 5px}}@media (max-width: 480px){.action-d1-95-tab-group{margin-top:0}}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: IsFocusedDirective, selector: "[isFocused]", inputs: ["isFocused"] }, { kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TabGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-tab-group', standalone: false, template: `
  <div class="{{ alternateStyle }}" id="{{id}}">

		<ul id="tgul" class="nav nav-tabs nav-justified hidden-xs accordion-control" role="tablist">
			<li *ngFor="let tab of tabs; let idx = index" role="presentation"
				[class]="(tab.twoLine ? 'two-line' : '') + (tab.isExpanded ? ' active' : '') + (tab.lastTab ? ' last' : '')"
				(click)="selectTab(tab, $event)" [isFocused]="tab.isExpanded">
				<a (focus)="tablistFocus()" [tabindex]="(tab.isExpanded ? 0 : -1)" role="tab" data-toggle="tab"
           href="#"
           [attr.title]="tab.tabTitle"
           [attr.aria-controls]="id + 'Panel-'+ idx"
           [attr.data-parent]="'#' + id + 'Panel-' + idx"
           [attr.id]="id + 'Header-' + idx + '-tab'"
           [attr.aria-selected]="tab.isExpanded.toString()"
           [attr.aria-expanded]="tab.isExpanded.toString()">
          <span class="category-title">
            {{tab.tabTitle}}
            <!--<span [innerHtml]=""></span>-->
            <br *ngIf="tab.twoLine">
            <!--<span [innerHtml]="tab.tabTitleSecond" *ngIf="tab.twoLine"></span>-->
            <span [innerHtml]="tab.tabTitleSecond" *ngIf="tab.twoLine"></span>
          </span>
        </a>
			</li>
    </ul>
    <div class="row hidden-sm hidden-md hidden-lg" *ngIf="alternateStyle">
      <div class="form-group col-md-4 col-sm-6">
        <label for="action-module-mobile-select" class="select-box-label" [innerHTML]="tabSelectLabel"></label>
        <select id="action-module-mobile-select" class="form-control action-module-mobile-select" #tabSelect (change)="setSelectedTab()">
          <option *ngFor="let tab of tabs; let idx = index" [value]="tab.tabIndex" [innerHTML]="tab.tabTitle"></option>
        </select>
      </div>
    </div>
		<div class="accordion menu tabbed-look" data-always-open-panel="true" role="navigation">
			<ul class="mainnav tab-content" #tabContent [contentHtml]="htmlContent">
				<ng-content></ng-content>
			</ul>
		</div>

</div>

  `, host: { '(:keydown)': 'handleKeyPress($event)' }, styles: [":host .nav-tabs a:focus{outline:1px dotted #212121;outline:5px auto -webkit-focus-ring-color}.accordion.tabbed-look{margin-top:0}.accordion.tabbed-look ul.mainnav.tab-content{border:none;margin-top:0;padding:40px}.accordion.tabbed-look[role=navigation] .tab-content>citi-tab>li.tab-pane{border:none}.accordion.tabbed-look[role=navigation] .tab-content>citi-tab>li.tab-pane>div.accordionSubMenu{padding:0;transition:none;-webkit-transition:none}@media (max-width: 768px){.accordion.tabbed-look[role=navigation] ul.mainnav.tab-content{padding:0;margin-top:20px}.accordion.tabbed-look[role=navigation] ul.mainnav.tab-content>citi-tab>li.tab-pane.is-expanded>div.accordionSubMenu{padding:0 20px 24px 70px}.accordion.tabbed-look[role=navigation] .tab-content>citi-tab>li.tab-pane{border-top:1px solid #999}}.action-d1-95-tab-group{margin-top:-20px}.action-d1-95-tab-group .nav-tabs>li{padding-right:.1px}.action-d1-95-tab-group .nav-tabs.nav-justified>li>a{border-bottom:1px solid rgba(0,0,0,.25)}.action-d1-95-tab-group .nav-tabs.nav-justified>.active>a{border-bottom:5px solid #056DAE;color:#056dae}.action-d1-95-tab-group .form-group .form-control.action-module-mobile-select{background-color:#fff}@media (min-width: 768px){.action-d1-95-tab-group .nav-tabs>li>a{padding:.1px 5px}}@media (max-width: 480px){.action-d1-95-tab-group{margin-top:0}}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { id: [{
                type: Input$1
            }], activeTab: [{
                type: Input$1
            }], tabChanged: [{
                type: Output
            }], htmlContent: [{
                type: Input$1
            }], alternateStyle: [{
                type: Input$1
            }], tabSelectLabel: [{
                type: Input$1
            }], tabContent: [{
                type: ViewChild,
                args: ['tabContent']
            }], tabSelect: [{
                type: ViewChild,
                args: ['tabSelect']
            }] } });

class TabComponent {
    constructor(parent, el) {
        this.parent = parent;
        this.el = el;
        /**
         * @property titleSecond
         * @description Text shown as the second line of tab title
         * @return string
         */
        this.tabTitleSecond = '';
        // Set classes on host <citi-tab> tag
        this.classTabPane = false;
        this.classLevel1 = false;
        this.classParent = false;
        // @HostBinding('class.is-expanded') isExpanded = false;
        this.isExpanded = false;
        this.twoLine = false;
        this.tabFocusTrigger = new EventEmitter();
        this.triggerButton = null;
        this.tabgroup = parent;
        this.tabIndex = this.tabgroup.addTab(this);
        this.tabIndexAttr = -1;
        this.zeroIndex = this.tabIndex - 1;
    }
    hasSecondLineTitle() {
        return typeof this.tabTitleSecond !== 'undefined' && this.tabTitleSecond != null && this.tabTitleSecond !== '';
    }
    ngOnInit() {
        this.twoLine = this.hasSecondLineTitle();
        let totalTabs = this.tabgroup.countTabs();
        this.lastTab = this.tabIndex === totalTabs;
        this.isExpanded = this.tabIndex === this.tabgroup.defaultTab;
    }
    selectTab(event) {
        this.tabgroup.selectTab(this, event);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TabComponent, deps: [{ token: TabGroupComponent }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: TabComponent, isStandalone: false, selector: "citi-tab", inputs: { tabTitle: ["title", "tabTitle"], tabTitleSecond: ["titleSecond", "tabTitleSecond"], htmlContent: "htmlContent" }, host: { properties: { "class.tab-pane": "this.classTabPane", "class.level1": "this.classLevel1", "class.parent": "this.classParent" } }, ngImport: i0, template: `
  <li class="tab-pane level1 parent" [class.is-expanded]="isExpanded" [ngClass]="(tabgroup.alternateStyle ? 'border-none' : '')">
    <span class="category hidden-md hidden-lg" (click)="selectTab($event)" *ngIf="!tabgroup.alternateStyle">
      <svg class="svg-arrow"></svg>
      <span tabindex="0" role="tab" id="{{tabgroup.id}}Header-{{zeroIndex}}"
            attr.aria-controls="{{tabgroup.id}}Panel-{{zeroIndex}}" data-title="Select to show/hide"
            class="category-title" [innerHtml]="tabTitle"
            [attr.aria-expanded]="isExpanded"
            [attr.aria-selected]="isExpanded"
      >
      </span>
    </span>
    <div class="accordionSubMenu" attr.aria-labelledby="{{tabgroup.id}}Header-{{zeroIndex}}-tab"
        [tabindex]="(isExpanded ? 0 : -1)" id="{{tabgroup.id}}Panel-{{zeroIndex}}" [contentHtml]="htmlContent"
        [attr.aria-hidden]="!isExpanded"
        role="tabpanel"
        [ngClass]="(tabgroup.alternateStyle ? 'padding-none' : '')">
      <ng-content></ng-content>
    </div>
  </li>
  `, isInline: true, styles: [".theme-light :host{background-color:#fff}:host{position:relative;margin-bottom:0;border-top:1px solid #999;background-color:#eee}:host.is-expanded .category{background-color:#fff}.theme-light :host.here,.theme-light :host.is-expanded .accordionSubMenu,.theme-light :host.is-expanded .category,.theme-light :host:hover{background-color:#eee}:host.is-expanded .category{color:#056dae}:host .category{font-family:Interstate_Light,sans-serif;color:#333;display:block;font-size:16px;font-size:1rem;line-height:22px;padding:19px 20px 19px 60px;transition:background-color .5s ease-in-out}:host .category .svg-arrow{position:absolute;height:8px;width:16px;left:22px;top:26px;transition:transform .4s ease-in-out;transform:rotate(0);transform-origin:50%;background-image:url(data:image/svg+xml;charset=utf-8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+DQo8c3ZnIHdpZHRoPSIxNXB4IiBoZWlnaHQ9IjhweCIgdmlld0JveD0iMCAwIDE1IDgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeG1sbnM6c2tldGNoPSJodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2gvbnMiPg0KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggMy40LjEgKDE1NjgxKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4NCiAgICA8dGl0bGU+Q2hldnJvbjwvdGl0bGU+DQogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+DQogICAgPGRlZnM+PC9kZWZzPg0KICAgIDxnIGlkPSJUb29sa2l0IiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBza2V0Y2g6dHlwZT0iTVNQYWdlIj4NCiAgICAgICAgPGcgaWQ9IkRyb3Bkb3ducyIgc2tldGNoOnR5cGU9Ik1TQXJ0Ym9hcmRHcm91cCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTg3OC4wMDAwMDAsIC0xMjIuMDAwMDAwKSIgZmlsbD0iIzA1NkRBRSI+DQogICAgICAgICAgICA8ZyBpZD0iRHJvcGRvd24tR3JleSIgc2tldGNoOnR5cGU9Ik1TTGF5ZXJHcm91cCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTcwLjAwMDAwMCwgMTAxLjAwMDAwMCkiPg0KICAgICAgICAgICAgICAgIDxnIGlkPSJEcm9wZG93bi1EZWZhdWx0IiBza2V0Y2g6dHlwZT0iTVNTaGFwZUdyb3VwIj4NCiAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTMxMiwzMiBMMzEyLDI5LjY5MTcwNDggTDMxNi45ODk2ODksMjUuMDI0NjU5MSBMMzEyLDIwLjM1Nzc1NTYgTDMxMiwxOCBMMzE4LjQ2MTUzOCwyNC4xNTU1NDg2IEwzMTguNDYxNTM4LDI1Ljg0NDMwOTMgTDMxMiwzMiIgaWQ9IkNoZXZyb24iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMxNS4yMzA3NjksIDI1LjAwMDAwMCkgcm90YXRlKC0yNzAuMDAwMDAwKSB0cmFuc2xhdGUoLTMxNS4yMzA3NjksIC0yNS4wMDAwMDApICI+PC9wYXRoPg0KICAgICAgICAgICAgICAgIDwvZz4NCiAgICAgICAgICAgIDwvZz4NCiAgICAgICAgPC9nPg0KICAgIDwvZz4NCjwvc3ZnPg==);background-repeat:no-repeat}:host.is-expanded .category .svg-arrow{left:22px;top:26px;transform:rotate(180deg)}:host .accordionSubMenu{display:block;overflow:hidden;width:100%;visibility:hidden;margin:auto;padding:0 20px 0 60px;max-height:0;transition:max-height .4s ease-out,background-color .5s ease-in-out,visibility 1ms ease .501s}:host.is-expanded .accordionSubMenu{background-color:#fff;display:block;max-height:300em;visibility:visible;transition:max-height 6s ease-out 2ms,background-color .5s ease-in-out 2ms,visibility 1ms ease}@media (max-width: 768px){.border-none{border:none!important}.padding-none{padding:0!important}}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TabComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-tab', standalone: false, template: `
  <li class="tab-pane level1 parent" [class.is-expanded]="isExpanded" [ngClass]="(tabgroup.alternateStyle ? 'border-none' : '')">
    <span class="category hidden-md hidden-lg" (click)="selectTab($event)" *ngIf="!tabgroup.alternateStyle">
      <svg class="svg-arrow"></svg>
      <span tabindex="0" role="tab" id="{{tabgroup.id}}Header-{{zeroIndex}}"
            attr.aria-controls="{{tabgroup.id}}Panel-{{zeroIndex}}" data-title="Select to show/hide"
            class="category-title" [innerHtml]="tabTitle"
            [attr.aria-expanded]="isExpanded"
            [attr.aria-selected]="isExpanded"
      >
      </span>
    </span>
    <div class="accordionSubMenu" attr.aria-labelledby="{{tabgroup.id}}Header-{{zeroIndex}}-tab"
        [tabindex]="(isExpanded ? 0 : -1)" id="{{tabgroup.id}}Panel-{{zeroIndex}}" [contentHtml]="htmlContent"
        [attr.aria-hidden]="!isExpanded"
        role="tabpanel"
        [ngClass]="(tabgroup.alternateStyle ? 'padding-none' : '')">
      <ng-content></ng-content>
    </div>
  </li>
  `, styles: [".theme-light :host{background-color:#fff}:host{position:relative;margin-bottom:0;border-top:1px solid #999;background-color:#eee}:host.is-expanded .category{background-color:#fff}.theme-light :host.here,.theme-light :host.is-expanded .accordionSubMenu,.theme-light :host.is-expanded .category,.theme-light :host:hover{background-color:#eee}:host.is-expanded .category{color:#056dae}:host .category{font-family:Interstate_Light,sans-serif;color:#333;display:block;font-size:16px;font-size:1rem;line-height:22px;padding:19px 20px 19px 60px;transition:background-color .5s ease-in-out}:host .category .svg-arrow{position:absolute;height:8px;width:16px;left:22px;top:26px;transition:transform .4s ease-in-out;transform:rotate(0);transform-origin:50%;background-image:url(data:image/svg+xml;charset=utf-8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+DQo8c3ZnIHdpZHRoPSIxNXB4IiBoZWlnaHQ9IjhweCIgdmlld0JveD0iMCAwIDE1IDgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeG1sbnM6c2tldGNoPSJodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2gvbnMiPg0KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggMy40LjEgKDE1NjgxKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4NCiAgICA8dGl0bGU+Q2hldnJvbjwvdGl0bGU+DQogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+DQogICAgPGRlZnM+PC9kZWZzPg0KICAgIDxnIGlkPSJUb29sa2l0IiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBza2V0Y2g6dHlwZT0iTVNQYWdlIj4NCiAgICAgICAgPGcgaWQ9IkRyb3Bkb3ducyIgc2tldGNoOnR5cGU9Ik1TQXJ0Ym9hcmRHcm91cCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTg3OC4wMDAwMDAsIC0xMjIuMDAwMDAwKSIgZmlsbD0iIzA1NkRBRSI+DQogICAgICAgICAgICA8ZyBpZD0iRHJvcGRvd24tR3JleSIgc2tldGNoOnR5cGU9Ik1TTGF5ZXJHcm91cCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTcwLjAwMDAwMCwgMTAxLjAwMDAwMCkiPg0KICAgICAgICAgICAgICAgIDxnIGlkPSJEcm9wZG93bi1EZWZhdWx0IiBza2V0Y2g6dHlwZT0iTVNTaGFwZUdyb3VwIj4NCiAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTMxMiwzMiBMMzEyLDI5LjY5MTcwNDggTDMxNi45ODk2ODksMjUuMDI0NjU5MSBMMzEyLDIwLjM1Nzc1NTYgTDMxMiwxOCBMMzE4LjQ2MTUzOCwyNC4xNTU1NDg2IEwzMTguNDYxNTM4LDI1Ljg0NDMwOTMgTDMxMiwzMiIgaWQ9IkNoZXZyb24iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMxNS4yMzA3NjksIDI1LjAwMDAwMCkgcm90YXRlKC0yNzAuMDAwMDAwKSB0cmFuc2xhdGUoLTMxNS4yMzA3NjksIC0yNS4wMDAwMDApICI+PC9wYXRoPg0KICAgICAgICAgICAgICAgIDwvZz4NCiAgICAgICAgICAgIDwvZz4NCiAgICAgICAgPC9nPg0KICAgIDwvZz4NCjwvc3ZnPg==);background-repeat:no-repeat}:host.is-expanded .category .svg-arrow{left:22px;top:26px;transform:rotate(180deg)}:host .accordionSubMenu{display:block;overflow:hidden;width:100%;visibility:hidden;margin:auto;padding:0 20px 0 60px;max-height:0;transition:max-height .4s ease-out,background-color .5s ease-in-out,visibility 1ms ease .501s}:host.is-expanded .accordionSubMenu{background-color:#fff;display:block;max-height:300em;visibility:visible;transition:max-height 6s ease-out 2ms,background-color .5s ease-in-out 2ms,visibility 1ms ease}@media (max-width: 768px){.border-none{border:none!important}.padding-none{padding:0!important}}\n"] }]
        }], ctorParameters: () => [{ type: TabGroupComponent }, { type: i0.ElementRef }], propDecorators: { tabTitle: [{
                type: Input$1,
                args: ['title']
            }], tabTitleSecond: [{
                type: Input$1,
                args: ['titleSecond']
            }], htmlContent: [{
                type: Input$1
            }], classTabPane: [{
                type: HostBinding,
                args: ['class.tab-pane']
            }], classLevel1: [{
                type: HostBinding,
                args: ['class.level1']
            }], classParent: [{
                type: HostBinding,
                args: ['class.parent']
            }] } });

const COMPONENTS$J = [
    TabGroupComponent,
    TabComponent
];
const MODULES$K = [
    CommonModule,
    IsFocused,
    ContentHtml
];
class TabGroup {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TabGroup, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: TabGroup, declarations: [TabGroupComponent,
            TabComponent], imports: [CommonModule,
            IsFocused,
            ContentHtml], exports: [TabGroupComponent,
            TabComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TabGroup, imports: [MODULES$K] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TabGroup, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$K],
                    declarations: [...COMPONENTS$J],
                    exports: [...COMPONENTS$J]
                }]
        }] });

let nextId$5 = 0;
/**
 * @Component: Nav Tab
 * @Section: Navigation
 * @description This is the nav tab component and is used to create tab in the nav group
 * from Bootstrap.
*/
class TabAltComponent {
    constructor() {
        this.isActive = false;
        this.isFocused = false;
        this.hostId = `nav-tab-${nextId$5++}`;
        this.keyboardFocused = false;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TabAltComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: TabAltComponent, isStandalone: false, selector: "citi-tab-alt, [citi-tab-alt]", inputs: { label: "label" }, host: { properties: { "class.nav-tab-panel-active": "this.isActive", "attr.id": "this.hostId" }, classAttribute: "citi-tab" }, ngImport: i0, template: `
  <div
    tabindex="0"
    role="tabpanel"
    [attr.aria-labelledby]="_tabGroupHostId + '-' + hostId"
    [ngClass]="{'nav-tab-panel-active': isActive }"
    class="nav-tab-panel">
    <ng-content></ng-content>
  </div>

  `, isInline: true, styles: [":host .nav-tab-panel{display:none;position:relative;visibility:hidden;z-index:2}:host .nav-tab-panel.nav-tab-panel-active{display:block;visibility:visible}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TabAltComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-tab-alt, [citi-tab-alt]', standalone: false, template: `
  <div
    tabindex="0"
    role="tabpanel"
    [attr.aria-labelledby]="_tabGroupHostId + '-' + hostId"
    [ngClass]="{'nav-tab-panel-active': isActive }"
    class="nav-tab-panel">
    <ng-content></ng-content>
  </div>

  `, host: {
                        'class': 'citi-tab'
                    }, styles: [":host .nav-tab-panel{display:none;position:relative;visibility:hidden;z-index:2}:host .nav-tab-panel.nav-tab-panel-active{display:block;visibility:visible}\n"] }]
        }], ctorParameters: () => [], propDecorators: { isActive: [{
                type: HostBinding,
                args: ['class.nav-tab-panel-active']
            }], hostId: [{
                type: HostBinding,
                args: ['attr.id']
            }], label: [{
                type: Input$1
            }] } });

let nextId$4 = 0;
/**
 * @Component: Nav Group
 * @Section: Navigation
 * @description This is in page navigation component to create
 * from Bootstrap.
*/
class TabGroupAltComponent {
    set activeTab(index) {
        this._activeTab = index;
        if (this.tabsArray.length)
            this.selectTab(index);
    }
    get activeTab() {
        return this._activeTab;
    }
    // ---------- Life Cycle ----------- //
    constructor(el, liveAnnouncer, _ngZone, navigatorRef) {
        this.el = el;
        this.liveAnnouncer = liveAnnouncer;
        this._ngZone = _ngZone;
        this.tabsArray = [];
        // -------- Inputs/Outputs ---------- //
        /**
         * @property activeTab
         * @description This defines the active tab of in page navigation
         * @return number
        */
        this._activeTab = 0;
        /**
         * @property focusedTab
         * @description This defines the focused tab of in page navigation
         * @return number
        */
        this.focusedTab = 0;
        /**
         * @Event: activeTabChanged
         * @description This event that is fired when a tab activates; returns the index of the active tab (first tab is 1)
         * @return Number
         */
        this.activeTabChange = new EventEmitter();
        /**
         * @property isThemeLight
         * @description Light theme default toggle
         * @return string
         */
        this.isThemeLight = true;
        this._navigator = navigatorRef;
        this.hostId = `nav-tab-group-${nextId$4++}`;
        this.iOS = this._navigator && (!!this._navigator.platform && /iPad|iPhone|iPod/.test(this._navigator.platform));
    }
    ngAfterContentInit() {
        this.tabs.forEach(t => {
            t._tabGroupHostId = this.hostId;
        });
        this.tabsArray = this.tabs.toArray();
        this.tabLength = this.tabsArray.length;
        this.setInitial(this.activeTab);
    }
    executeOnStable(func) {
        this._ngZone.runOutsideAngular(() => {
            this._ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => func());
        });
    }
    // ------------ Methods ------------- //
    setInitial(index) {
        this.focusedTab = index;
        const tab = this.tab(index);
        tab.isFocused = tab.isActive = true;
    }
    unSelectAll() {
        this.tabsArray.forEach(tab => this.setAll(tab, false));
    }
    tab(index) {
        return this.tabsArray[index];
    }
    setAll(tab, bool = true) {
        tab.isActive = tab.isFocused = tab.keyboardFocused = bool;
    }
    focusActive() {
        this.executeOnStable(() => this.el.nativeElement.querySelector('.tab-focused').focus());
    }
    currentTab() {
        return this.tabsArray.find(tab => tab.isActive);
    }
    currentTabIndex() {
        return this.tabsArray.indexOf(this.currentTab());
    }
    selectTab(index) {
        this.unSelectAll();
        this.setAll(this.tab(index), true);
        this.focusActive();
        this._activeTab = this.focusedTab = index;
        this.activeTabChange.emit(this.currentTabIndex());
        // TalkBack and VoiceOver announce
        if (this.iOS || androidPlatformCheck(this._navigator.platform)) {
            this.liveAnnouncer.announce(`${this.tab(index).label} selected ${index + 1} of ${this.tabLength}`);
        }
    }
    clearFocus() {
        this.tabsArray.forEach(tab => tab.isFocused = tab.keyboardFocused = false);
    }
    removeKeyboardFocus() {
        this.tabsArray.forEach(tab => tab.keyboardFocused = false);
        this.tabsArray.forEach(tab => tab.isFocused = false);
        this.focusedTab = this.activeTab;
    }
    moveFocus(dir) {
        this.setTabFocus((this.focusedTab + this.tabLength + dir) % this.tabLength);
    }
    setTabFocus(index) {
        this.clearFocus();
        this.tab(index).isFocused = true;
        this.focusActive();
        this.focusedTab = index;
        if ((!this.iOS)
            && (!androidPlatformCheck(this._navigator.platform))
            && (!this.tab(index).isActive)) {
            this.liveAnnouncer.announce('Use enter to select tab.');
        }
    }
    stopBubble(event) {
        event.preventDefault();
        event.stopPropagation();
    }
    handleKeyPress(event) {
        if (event.which !== KEY_TAB)
            this.stopBubble(event);
        switch (event.which) {
            case KEY_HOME:
                this.setTabFocus(0);
                break;
            case KEY_END:
                this.setTabFocus(this.tabLength - 1);
                break;
            case KEY_ARROW_LEFT:
            case KEY_ARROW_UP:
                this.moveFocus(-1);
                break;
            case KEY_ARROW_RIGHT:
            case KEY_ARROW_DOWN:
                this.moveFocus(1);
                break;
            case KEY_SPACEBAR:
            case KEY_ENTER:
                this.selectTab(this.focusedTab);
                break;
            case KEY_TAB: this.removeKeyboardFocus();
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TabGroupAltComponent, deps: [{ token: i0.ElementRef }, { token: CitiLiveAnnouncer }, { token: i0.NgZone }, { token: NAVIGATOR }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: TabGroupAltComponent, isStandalone: false, selector: "citi-tab-group-alt", inputs: { activeTab: "activeTab", alternateStyle: "alternateStyle", focusedTab: "focusedTab", isThemeLight: "isThemeLight" }, outputs: { activeTabChange: "activeTabChange" }, host: { properties: { "attr.id": "this.hostId" }, classAttribute: "citi-tab-group" }, queries: [{ propertyName: "tabs", predicate: TabAltComponent }], viewQueries: [{ propertyName: "tabContent", first: true, predicate: ["tabContent"], descendants: true }], ngImport: i0, template: `
  <div [class]="'nav-tab-list tabs-'+tabLength" [ngClass]="[alternateStyle ? alternateStyle : '']" role="tablist">
    <button
      *ngFor="let tab of tabsArray; let idx = index"
      role="tab"
      type="button"
      class="nav-tab-label"
      [ngClass]="[tab.isActive ? 'nav-tab-label-active' : '', tab.isFocused ? 'tab-focused' : '', tab.keyboardFocused ? 'tab-keyboard-focused': '']"
      [attr.id]="hostId + '-' + tab.hostId"
      [attr.aria-selected]="(tab.isActive ? 'true' : 'false')"
      [attr.aria-controls]="tab.hostId"
      [attr.tabindex]="(tab.isActive ? null : -1)"
      (click)="selectTab(idx)"
      (keydown)="handleKeyPress($event)">
      <span class="nav-tab-label-content" [innerHtml]="tab.label"></span>
    </button>
  </div>
  <div class="tab-content noPadding" #tabContent>
    <ng-content></ng-content>
  </div>
  `, isInline: true, styles: [":host .tab-content{background-color:transparent;padding:0}.nav-tab-list .nav-tab-label{background-color:#eee;border-left:none;border-bottom:5px solid #fff;border-top:5px solid #fff;border-right:none;height:70px;line-height:24px;min-height:70px;padding:10px;position:relative}.nav-tab-list .nav-tab-label.nav-tab-label-active{background-color:#fff!important;border-top-color:transparent;border-bottom:5px solid #056DAE;box-shadow:0 0 5px 1px #33333340}.nav-tab-list .nav-tab-label.nav-tab-label-active .nav-tab-label-content{color:#333;background-color:transparent}.nav-tab-list .nav-tab-label .nav-tab-label-content{color:#056dae;background-color:transparent}.nav-tab-list .nav-tab-label .nav-tab-label-content:hover{color:#333}@media (min-width: 992px){.nav-tab-list .nav-tab-label{font-size:21px;line-height:27px;min-height:90px;height:90px}}@media (max-width: 768px){.nav-tab-list .nav-tab-label{height:auto}}.tab-focused{outline:#7AACFE solid 2px!important;outline:auto 5px -webkit-focus-ring-color!important;z-index:2}.noPadding{padding:0}.citi-tab-selector{display:flex;border-bottom:1px solid rgba(0,0,0,.25)}.citi-tab-selector .nav-tab-label{flex:1 1 auto;background-color:#fff;border-bottom:none;padding:10px;font-size:1rem;height:auto;min-height:auto;border-top:none;box-shadow:none}.citi-tab-selector .nav-tab-label .nav-tab-label-content,.citi-tab-selector .nav-tab-label .nav-tab-label-content:hover{color:#056dae}.citi-tab-selector .nav-tab-label.nav-tab-label-active{border-bottom:5px solid #056DAE;padding-bottom:5px;box-shadow:none}.citi-tab-selector .nav-tab-label.nav-tab-label-active .nav-tab-label-content,.citi-tab-selector .nav-tab-label.nav-tab-label-active .nav-tab-label-content:hover{color:#056dae}.citi-tab-selector .tab-focused{outline:none!important}@media (min-width: 768px){.citi-tab-selector .nav-tab-label{text-align:left;padding-left:0;padding-right:0;flex:0 1 auto}.citi-tab-selector .nav-tab-label+.nav-tab-label{margin-left:40px}}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TabGroupAltComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-tab-group-alt', standalone: false, template: `
  <div [class]="'nav-tab-list tabs-'+tabLength" [ngClass]="[alternateStyle ? alternateStyle : '']" role="tablist">
    <button
      *ngFor="let tab of tabsArray; let idx = index"
      role="tab"
      type="button"
      class="nav-tab-label"
      [ngClass]="[tab.isActive ? 'nav-tab-label-active' : '', tab.isFocused ? 'tab-focused' : '', tab.keyboardFocused ? 'tab-keyboard-focused': '']"
      [attr.id]="hostId + '-' + tab.hostId"
      [attr.aria-selected]="(tab.isActive ? 'true' : 'false')"
      [attr.aria-controls]="tab.hostId"
      [attr.tabindex]="(tab.isActive ? null : -1)"
      (click)="selectTab(idx)"
      (keydown)="handleKeyPress($event)">
      <span class="nav-tab-label-content" [innerHtml]="tab.label"></span>
    </button>
  </div>
  <div class="tab-content noPadding" #tabContent>
    <ng-content></ng-content>
  </div>
  `, host: {
                        class: 'citi-tab-group'
                    }, styles: [":host .tab-content{background-color:transparent;padding:0}.nav-tab-list .nav-tab-label{background-color:#eee;border-left:none;border-bottom:5px solid #fff;border-top:5px solid #fff;border-right:none;height:70px;line-height:24px;min-height:70px;padding:10px;position:relative}.nav-tab-list .nav-tab-label.nav-tab-label-active{background-color:#fff!important;border-top-color:transparent;border-bottom:5px solid #056DAE;box-shadow:0 0 5px 1px #33333340}.nav-tab-list .nav-tab-label.nav-tab-label-active .nav-tab-label-content{color:#333;background-color:transparent}.nav-tab-list .nav-tab-label .nav-tab-label-content{color:#056dae;background-color:transparent}.nav-tab-list .nav-tab-label .nav-tab-label-content:hover{color:#333}@media (min-width: 992px){.nav-tab-list .nav-tab-label{font-size:21px;line-height:27px;min-height:90px;height:90px}}@media (max-width: 768px){.nav-tab-list .nav-tab-label{height:auto}}.tab-focused{outline:#7AACFE solid 2px!important;outline:auto 5px -webkit-focus-ring-color!important;z-index:2}.noPadding{padding:0}.citi-tab-selector{display:flex;border-bottom:1px solid rgba(0,0,0,.25)}.citi-tab-selector .nav-tab-label{flex:1 1 auto;background-color:#fff;border-bottom:none;padding:10px;font-size:1rem;height:auto;min-height:auto;border-top:none;box-shadow:none}.citi-tab-selector .nav-tab-label .nav-tab-label-content,.citi-tab-selector .nav-tab-label .nav-tab-label-content:hover{color:#056dae}.citi-tab-selector .nav-tab-label.nav-tab-label-active{border-bottom:5px solid #056DAE;padding-bottom:5px;box-shadow:none}.citi-tab-selector .nav-tab-label.nav-tab-label-active .nav-tab-label-content,.citi-tab-selector .nav-tab-label.nav-tab-label-active .nav-tab-label-content:hover{color:#056dae}.citi-tab-selector .tab-focused{outline:none!important}@media (min-width: 768px){.citi-tab-selector .nav-tab-label{text-align:left;padding-left:0;padding-right:0;flex:0 1 auto}.citi-tab-selector .nav-tab-label+.nav-tab-label{margin-left:40px}}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: CitiLiveAnnouncer }, { type: i0.NgZone }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [NAVIGATOR]
                }] }], propDecorators: { tabContent: [{
                type: ViewChild,
                args: ['tabContent']
            }], tabs: [{
                type: ContentChildren,
                args: [TabAltComponent, { descendants: false }]
            }], hostId: [{
                type: HostBinding,
                args: ['attr.id']
            }], activeTab: [{
                type: Input$1
            }], alternateStyle: [{
                type: Input$1
            }], focusedTab: [{
                type: Input$1
            }], activeTabChange: [{
                type: Output
            }], isThemeLight: [{
                type: Input$1
            }] } });

const COMPONENTS$I = [
    TabGroupAltComponent,
    TabAltComponent
];
class TabsAlt {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TabsAlt, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: TabsAlt, declarations: [TabGroupAltComponent,
            TabAltComponent], imports: [CommonModule], exports: [TabGroupAltComponent,
            TabAltComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TabsAlt, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TabsAlt, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [...COMPONENTS$I],
                    exports: [...COMPONENTS$I]
                }]
        }] });

/**
 * @Component: tileContainer Layout
 * @Section: GridLayouts
 * @description This is the tile layout component that includes panel wrappers based on the requirement.
*/
class TileContainerComponent {
    constructor() {
        /**
         * @property isRightPanelRequired
         * @description The isRightPanelRequired attribute will be set to enable/disable the right container.
         * @Type: boolean (true | false) -by default set to true.
         */
        this.isRightPanelRequired = true;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TileContainerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: TileContainerComponent, isStandalone: false, selector: "citi-tile-container", inputs: { tileContainer: "tileContainer", fullBodyContainer: "fullBodyContainer", isRightPanelRequired: "isRightPanelRequired" }, ngImport: i0, template: `
  <citi-row *ngIf="tileContainer" classes="tile-container">
    <citi-column md="9" xs="12" classes="left-container">
        <div class="left-content-body">
            <ng-content select="[leftcontent]"></ng-content>
        </div>
    </citi-column>
    <citi-column *ngIf="isRightPanelRequired" md="3" xs="12" classes="right-container">
        <div class="right-content-body">
            <ng-content select="[rightcontent]"></ng-content>
        </div>
    </citi-column>
  </citi-row>
  <citi-row *ngIf="fullBodyContainer" classes="full-container">
      <citi-column xs="12" classes="main-container">
          <div class="full-content-body">
              <ng-content select="[maincontent]"></ng-content>
          </div>
      </citi-column>
  </citi-row>
  `, isInline: true, styles: [":host-context(.theme-gray) ::ng-deep .tile-container .left-container .left-content-body,:host-context(.theme-gray) ::ng-deep .tile-container .right-container .right-content-body,:host-context(.theme-gray) ::ng-deep .full-container .main-container .full-content-body{background:#fff;padding:40px}:host-context(.theme-gray) ::ng-deep .tile-container .left-container .left-content-body .module-alert-box,:host-context(.theme-gray) ::ng-deep .tile-container .right-container .right-content-body .module-alert-box,:host-context(.theme-gray) ::ng-deep .full-container .main-container .full-content-body .module-alert-box{border:1px solid #eee}:host-context(.theme-light) ::ng-deep .tile-container .left-container .left-content-body,:host-context(.theme-light) ::ng-deep .tile-container .right-container .right-content-body,:host-context(.theme-light) ::ng-deep .full-container .main-container .full-content-body{background:#eee;padding:40px}:host-context(.theme-light) ::ng-deep .tile-container .left-container .left-content-body .module-alert-box,:host-context(.theme-light) ::ng-deep .tile-container .right-container .right-content-body .module-alert-box,:host-context(.theme-light) ::ng-deep .full-container .main-container .full-content-body .module-alert-box{border:1px solid #fff}:host-context(.cbolui-ddl.theme-gray) ::ng-deep .tile-container .left-container,:host-context(.cbolui-ddl.theme-gray) ::ng-deep .tile-container .right-container,:host-context(.cbolui-ddl.theme-gray) ::ng-deep .full-container .main-container{padding-top:20px;padding-bottom:20px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: ColumnComponent, selector: "citi-column, [citi-column]", inputs: ["xs", "sm", "md", "lg", "pullRight", "pullLeft", "offXs", "offSm", "offMd", "offLg", "classes", "htmlContent"] }, { kind: "component", type: RowComponent, selector: "citi-row, [citi-row]", inputs: ["classes", "htmlContent"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TileContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-tile-container', standalone: false, template: `
  <citi-row *ngIf="tileContainer" classes="tile-container">
    <citi-column md="9" xs="12" classes="left-container">
        <div class="left-content-body">
            <ng-content select="[leftcontent]"></ng-content>
        </div>
    </citi-column>
    <citi-column *ngIf="isRightPanelRequired" md="3" xs="12" classes="right-container">
        <div class="right-content-body">
            <ng-content select="[rightcontent]"></ng-content>
        </div>
    </citi-column>
  </citi-row>
  <citi-row *ngIf="fullBodyContainer" classes="full-container">
      <citi-column xs="12" classes="main-container">
          <div class="full-content-body">
              <ng-content select="[maincontent]"></ng-content>
          </div>
      </citi-column>
  </citi-row>
  `, styles: [":host-context(.theme-gray) ::ng-deep .tile-container .left-container .left-content-body,:host-context(.theme-gray) ::ng-deep .tile-container .right-container .right-content-body,:host-context(.theme-gray) ::ng-deep .full-container .main-container .full-content-body{background:#fff;padding:40px}:host-context(.theme-gray) ::ng-deep .tile-container .left-container .left-content-body .module-alert-box,:host-context(.theme-gray) ::ng-deep .tile-container .right-container .right-content-body .module-alert-box,:host-context(.theme-gray) ::ng-deep .full-container .main-container .full-content-body .module-alert-box{border:1px solid #eee}:host-context(.theme-light) ::ng-deep .tile-container .left-container .left-content-body,:host-context(.theme-light) ::ng-deep .tile-container .right-container .right-content-body,:host-context(.theme-light) ::ng-deep .full-container .main-container .full-content-body{background:#eee;padding:40px}:host-context(.theme-light) ::ng-deep .tile-container .left-container .left-content-body .module-alert-box,:host-context(.theme-light) ::ng-deep .tile-container .right-container .right-content-body .module-alert-box,:host-context(.theme-light) ::ng-deep .full-container .main-container .full-content-body .module-alert-box{border:1px solid #fff}:host-context(.cbolui-ddl.theme-gray) ::ng-deep .tile-container .left-container,:host-context(.cbolui-ddl.theme-gray) ::ng-deep .tile-container .right-container,:host-context(.cbolui-ddl.theme-gray) ::ng-deep .full-container .main-container{padding-top:20px;padding-bottom:20px}\n"] }]
        }], propDecorators: { tileContainer: [{
                type: Input$1
            }], fullBodyContainer: [{
                type: Input$1
            }], isRightPanelRequired: [{
                type: Input$1
            }] } });

const COMPONENTS$H = [
    TileContainerComponent
];
const MODULES$J = [
    CommonModule,
    Grid
];
class TileContainer {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TileContainer, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: TileContainer, declarations: [TileContainerComponent], imports: [CommonModule,
            Grid], exports: [TileContainerComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TileContainer, imports: [MODULES$J] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TileContainer, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$J],
                    declarations: [...COMPONENTS$H],
                    exports: [...COMPONENTS$H]
                }]
        }] });

class Dropdown3Service {
    register(select) {
        this.select = select;
    }
    getSelect() {
        return this.select;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Dropdown3Service, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Dropdown3Service }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Dropdown3Service, decorators: [{
            type: Injectable
        }] });

class Options3Component {
    get selected() {
        return this.select.selectedOption == this;
    }
    ;
    get disabledOption() {
        return this.disabled;
    }
    ;
    emitClick(e) {
        e.preventDefault();
        e.stopPropagation();
        if (!this.disabled) {
            this.select.selectOption(this);
        }
        return;
    }
    constructor(host, liveAnnouncer, ddService) {
        this.host = host;
        this.liveAnnouncer = liveAnnouncer;
        this.ddService = ddService;
        this.disabled = false;
        this.isSelected = false;
        this.click = new EventEmitter();
        this.ddValue = new EventEmitter();
        this.active = false;
        // @HostBinding('attr.aria-disabled') setAriaAttr = this.disabled;
        this.attrTabindex = 0;
        this.select = this.ddService.getSelect();
    }
    ngAfterContentInit() {
        setTimeout(() => {
            if (this.selected || this.isSelected) {
                const indexOfThisOption = this.select.options
                    .map((option) => option === this)
                    .indexOf(true);
                setTimeout(() => {
                    this.select._keyManager.setActiveItem(indexOfThisOption);
                }, 1);
            }
        }, 1);
    }
    ngOnInit() { }
    setValue() {
        this.click.emit(this.value);
        this.ddValue.emit(this.optionLabel);
    }
    setActiveStyles() {
        this.active = true;
        this.select.selected = this.value;
        this.select.inputRef.nativeElement.value = this.optionLabel;
        this.element.scrollIntoView();
        let optIndex = this.select._keyManager.activeItemIndex + 1;
        // setTimeout(() => {
        // }, 1);
        this.liveAnnouncer.announce(`${optIndex} out of ${this.select.optionsLength}`);
    }
    setInactiveStyles() {
        this.active = false;
    }
    get element() {
        return this.host.nativeElement;
    }
    getLabel() {
        return this.optionLabel;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Options3Component, deps: [{ token: i0.ElementRef }, { token: i1$3.LiveAnnouncer }, { token: Dropdown3Service }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: Options3Component, isStandalone: false, selector: "citi-options3", inputs: { value: "value", optionLabel: "optionLabel", disabled: "disabled", isSelected: "isSelected" }, outputs: { click: "click", ddValue: "ddValue" }, host: { listeners: { "mousedown": "emitClick($event)" }, properties: { "class.active": "this.active", "attr.tabindex": "this.attrTabindex", "class.selected": "this.selected", "class.ddl-dd3-disabled-option": "this.disabledOption" }, classAttribute: "ddl-dd3-option" }, ngImport: i0, template: `<span #option class="ddl-dd3-option">{{optionLabel}}</span>`, isInline: true, styles: [":host{display:block;cursor:pointer;font-size:16px;font-weight:300;letter-spacing:0;padding-top:10px;padding-bottom:10px;line-height:24px;padding-left:20px;color:#333}:host:hover,:host.selected,:host.active{color:#056dae;text-decoration:underline}:host.ddl-dd3-disabled-option{color:#666}:host.ddl-dd3-disabled-option:hover{text-decoration:none}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Options3Component, decorators: [{
            type: Component,
            args: [{ selector: 'citi-options3', standalone: false, template: `<span #option class="ddl-dd3-option">{{optionLabel}}</span>`, host: {
                        class: 'ddl-dd3-option'
                    }, styles: [":host{display:block;cursor:pointer;font-size:16px;font-weight:300;letter-spacing:0;padding-top:10px;padding-bottom:10px;line-height:24px;padding-left:20px;color:#333}:host:hover,:host.selected,:host.active{color:#056dae;text-decoration:underline}:host.ddl-dd3-disabled-option{color:#666}:host.ddl-dd3-disabled-option:hover{text-decoration:none}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i1$3.LiveAnnouncer }, { type: Dropdown3Service }], propDecorators: { value: [{
                type: Input$1
            }], optionLabel: [{
                type: Input$1
            }], disabled: [{
                type: Input$1
            }], isSelected: [{
                type: Input$1
            }], click: [{
                type: Output
            }], ddValue: [{
                type: Output
            }], active: [{
                type: HostBinding,
                args: ['class.active']
            }], attrTabindex: [{
                type: HostBinding,
                args: ['attr.tabindex']
            }], selected: [{
                type: HostBinding,
                args: ['class.selected']
            }], disabledOption: [{
                type: HostBinding,
                args: ['class.ddl-dd3-disabled-option']
            }], emitClick: [{
                type: HostListener,
                args: ['mousedown', ['$event']]
            }] } });

const DEFAULT_CONFIG = {
    hasBackdrop: false,
    panelClass: 'ddl-dropdown-panel'
};
class DdlOverlayPanel {
    constructor(host, vcr, overlay, viewContainerRef, announcer) {
        this.host = host;
        this.vcr = vcr;
        this.overlay = overlay;
        this.viewContainerRef = viewContainerRef;
        this.announcer = announcer;
        this.alive = true;
        this.showing = false;
        this.backdropClick = new EventEmitter();
    }
    getOverlayConfig(config) {
        return new OverlayConfig({
            width: this.origin.offsetWidth,
            backdropClass: config.backdropClass,
            positionStrategy: this.positionStrategy || this.getOverlayPosition(),
            scrollStrategy: this.scrollStrategy || this.getOverlayScroll(),
            maxHeight: config.maxHeight,
            panelClass: config.panelClass,
            hasBackdrop: config.hasBackdrop
        });
    }
    openDropdown(config = {}) {
        this.showing = true;
        this.syncWidth();
        const dialogConfig = { ...DEFAULT_CONFIG, ...config };
        this.overlayRef = this.createOverlay(dialogConfig);
        this.overlayRef.backdropClick().subscribe(() => this.close());
        const template = new TemplatePortal(this.templateRef, this.vcr);
        this.overlayRef.attach(template);
        this.overlayRef.hostElement.classList.add('custom-class-ddl-dd3');
    }
    createOverlay(config) {
        const overlayConfig = this.getOverlayConfig(config);
        return this.overlay.create(overlayConfig);
    }
    getOverlayPosition() {
        const positions = [
            new ConnectionPositionPair({ originX: 'start', originY: 'bottom' }, { overlayX: 'start', overlayY: 'top' }),
            new ConnectionPositionPair({ originX: 'end', originY: 'top' }, { overlayX: 'end', overlayY: 'bottom' })
        ];
        return this.overlay
            .position()
            .flexibleConnectedTo(this.origin)
            .withPositions(positions)
            .withFlexibleDimensions(false)
            .withPush(false);
    }
    getOverlayScroll() {
        return this.overlay.scrollStrategies.reposition();
    }
    onWinResize() {
        this.syncWidth();
    }
    syncWidth() {
        if (this.overlayRef) {
            const refRect = this.origin.getBoundingClientRect();
            this.overlayRef.updateSize({ width: refRect.width });
        }
        else
            return;
    }
    ngOnDestroy() {
        this.alive = false;
    }
    close() {
        if (this.overlayRef) {
            this.overlayRef.detach();
            this.overlayRef.dispose();
            this.overlayRef = null;
            this.showing = false;
            this.announcer.announce('Collapsed');
            this.backdropClick.emit(true); // emit backdropClick to control arrow rotate
        }
    }
    get origin() {
        return this.host.nativeElement;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: DdlOverlayPanel, deps: [{ token: i0.ElementRef }, { token: i0.ViewContainerRef }, { token: i1$4.Overlay }, { token: i0.ViewContainerRef }, { token: i1$3.LiveAnnouncer }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.5", type: DdlOverlayPanel, isStandalone: false, selector: "[ddlOverlayPanel]", inputs: { templateRef: "templateRef", positionStrategy: "positionStrategy", scrollStrategy: "scrollStrategy" }, outputs: { backdropClick: "backdropClick" }, host: { listeners: { "window:resize": "onWinResize()", "window:keydown.escape": "close()" } }, exportAs: ["ddlOverlayPanel"], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: DdlOverlayPanel, decorators: [{
            type: Directive,
            args: [{
                    selector: '[ddlOverlayPanel]',
                    standalone: false,
                    exportAs: 'ddlOverlayPanel'
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.ViewContainerRef }, { type: i1$4.Overlay }, { type: i0.ViewContainerRef }, { type: i1$3.LiveAnnouncer }], propDecorators: { templateRef: [{
                type: Input$1
            }], positionStrategy: [{
                type: Input$1
            }], scrollStrategy: [{
                type: Input$1
            }], backdropClick: [{
                type: Output
            }], onWinResize: [{
                type: HostListener,
                args: ['window:resize']
            }], close: [{
                type: HostListener,
                args: ['window:keydown.escape']
            }] } });

// import { ValidationService } from '../../core/services/validation.service';
class Dropdown3Component {
    set error(isErrored) {
        if (isErrored === this._error)
            return;
        if (isErrored)
            this._errorMessage = this.errorMessage;
        this._error = isErrored;
    }
    get error() {
        return this._error;
    }
    closeOnEsc() {
        this.closePanel();
    }
    constructor(overlay, 
    // , private validationService: ValidationService
    dropdownService, elementRef, host, liveAnnouncer, input) {
        this.overlay = overlay;
        this.dropdownService = dropdownService;
        this.elementRef = elementRef;
        this.host = host;
        this.liveAnnouncer = liveAnnouncer;
        this.input = input;
        this.required = false;
        this.disabled = false;
        this._error = false;
        this.errorMessage = 'Error';
        this.requiredError = 'Required error';
        this.selectionChange = new EventEmitter();
        this.blur = new EventEmitter();
        // #region // ----------------------- Form Binding Methods ----------------------- //
        /** `View -> model callback called when value changes` */
        this.onChangeFn = (_) => { };
        /** `View -> model callback called when select has been touched` */
        this.onTouchedFn = () => { };
        this.dropdownService.register(this);
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this._initKeyManager();
        });
    }
    ngOnInit() { }
    ngAfterContentInit() {
        this.options.forEach((option, index) => {
            if (option.value === this.value) {
                // this.ddValue = option.optionLabel;
                this.placeholder = option.optionLabel;
                this.selectedOption = option;
            }
        });
    }
    ngOnDestroy() { }
    selectOption(option) {
        this.selectActiveOption(option);
        this.closePanel();
        this.input.nativeElement.focus();
        this.onChange();
    }
    selectActiveOption(option) {
        if (option) {
            this._keyManager.setActiveItem(option);
            this.writeValue(option.value);
            this.selected = option.value;
            this.selectedOption = option;
            this.placeholder = this.selectedOption
                ? this.selectedOption.optionLabel
                : '';
        }
    }
    validate() {
        if (this.disabled)
            return;
        if (this.required && !this.selectedOption) {
            this._error = true;
            this._errorMessage = this.requiredError;
            this.liveAnnouncer.announce(this._errorMessage);
        }
        else if (this.required && this.selectedOption) {
            this._error = false;
        }
        else if (this.error && !this.required) {
            this._errorMessage = this.errorMessage;
            this.liveAnnouncer.announce(this._errorMessage);
        }
    }
    onBlur() {
        this.blur.emit();
        this.validate();
        this.closePanel();
    }
    onFocus() {
        if (this.disabled)
            return;
        if (this._error) {
            this.liveAnnouncer.announce(this._errorMessage);
        }
    }
    // find options length to be announce
    get optionsLength() {
        return this.options.length;
    }
    // find the index number of the active option to announce its position in the list
    get findActiveOption() {
        const activeOptionIndex = this.options.map(opt => opt.active).indexOf(true);
        return activeOptionIndex + 1;
    }
    get activeItem() {
        return this._keyManager.activeItem;
    }
    get select() {
        if (!this._keyManager.activeItem)
            return null;
        return this._keyManager.activeItem.value;
    }
    get optionLabel() {
        return this._keyManager.activeItem.optionLabel;
    }
    set optionLabel(value) {
        this._keyManager.activeItem.optionLabel = value;
    }
    _initKeyManager() {
        this._keyManager = new ActiveDescendantKeyManager(this.options)
            .withVerticalOrientation()
            .withWrap()
            .withTypeAhead()
            .withHomeAndEnd()
            .withAllowedModifierKeys(['shiftKey']);
        this._keyManager.change.subscribe({
            next: indx => {
                this.selectActiveOption(this._keyManager.activeItem);
            }
        });
    }
    onKeyDown(event) {
        const manager = this._keyManager;
        const keyCode = event.code;
        const endKey = keyCode === 'End';
        const homeKey = keyCode === 'Home';
        const arrowKey = keyCode === 'ArrowUp' || keyCode === 'ArrowDown';
        const isCloseKey = keyCode === 'Enter' || keyCode === 'Space';
        manager.onKeydown(event);
        if (!this.element.showing) {
            // Panel closed
            if (isCloseKey) {
                this.openPanel();
                event.preventDefault();
                if (this.select) {
                    // check if scrollTo() is hired on openPanel()
                    this.scrollTo();
                }
            }
            else if (arrowKey) {
                this.openPanel();
            }
        }
        else {
            // Panel open
            if (isCloseKey) {
                event.preventDefault();
                this.selectOption(manager.activeItem);
            }
        }
    }
    onPanelClose(e) {
    }
    toggleDropdown(event) {
        event.stopPropagation();
        !this.element.showing ? this.openPanel() : this.closePanel();
        this.inputRef.nativeElement.focus();
    }
    scrollTo() {
        const itemToScrollTo = this.activeItem.element;
        if (itemToScrollTo) {
            itemToScrollTo.scrollIntoView(true);
        }
    }
    openPanel() {
        if (this.disabled)
            return;
        this.element.openDropdown({
            panelClass: 'ddl-dropdown-overlay-panel',
            hasBackdrop: true,
            backdropClass: 'overlay-backdrop-class'
        });
        if (this.select) {
            this.scrollTo();
            setTimeout(() => {
                this.liveAnnouncer.announce(`Expanded ${this.optionLabel} ${this.findActiveOption} out of ${this.optionsLength}`);
            }, 1);
        }
        else {
            // setTimeout(() => {
            // }, 1);
            this.liveAnnouncer.announce(`Expanded ${this.optionsLength} total options`);
        }
    }
    closePanel() {
        if (this.element.showing) {
            this.element.close();
            this.selectionChange.emit(this.value);
            if (this.select) {
                this.liveAnnouncer.announce(`Collapsed ${this.optionLabel} selected`);
            }
            else {
                this.liveAnnouncer.announce(`Collapsed`);
            }
        }
    }
    // upon touching the element, this method gets triggered
    registerOnTouched(fn) {
        this.onTouchedFn = fn;
    }
    // upon UI element value changes, this method gets triggered
    registerOnChange(fn) {
        this.onChangeFn = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    /**
     * @description Allows Angular to update the model. The form will pass new values in here
     */
    writeValue(value) {
        this.value = value;
        this.selected = value;
        const opt = this.options?.find(o => o.value === value);
        if (opt) {
            this._keyManager.setActiveItem(opt);
        }
        this.onChange();
        this.selectionChange.emit(value);
        if (!!this.option)
            this.option.setValue();
    }
    onTouched() {
        this.onTouchedFn();
    }
    onChange() {
        this.onChangeFn(this.selected);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Dropdown3Component, deps: [{ token: i1$4.Overlay }, { token: Dropdown3Service }, { token: i0.ElementRef }, { token: i0.ElementRef }, { token: i1$3.LiveAnnouncer }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: Dropdown3Component, isStandalone: false, selector: "citi-dropdown3", inputs: { label: "label", placeholder: "placeholder", value: "value", selected: "selected", required: "required", disabled: "disabled", idStr: "idStr", error: "error", errorMessage: "errorMessage", requiredError: "requiredError" }, outputs: { selectionChange: "selectionChange", blur: "blur" }, host: { attributes: { "role": "presentation" }, listeners: { "keydown": "onKeyDown($event)", "keydown.escape": "closeOnEsc()" }, styleAttribute: "position: relative;", classAttribute: "ddl-dropdown" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef((() => Dropdown3Component)),
                multi: true
            },
            Dropdown3Service
        ], queries: [{ propertyName: "option", first: true, predicate: ["option"], descendants: true }, { propertyName: "options", predicate: Options3Component }], viewQueries: [{ propertyName: "element", first: true, predicate: ["panelPopup"], descendants: true }, { propertyName: "panel", first: true, predicate: ["panel"], descendants: true }, { propertyName: "inputRef", first: true, predicate: ["inputRef"], descendants: true }], ngImport: i0, template: `
    <label [for]="idStr" class="ddl-dd3-label-text">{{ label }}</label>
    <div>
      <input
        [id]="idStr"
        class="ddl-dd3-input"
        [ngClass]="{ 'ddl-dd3-error-state': _error }"
        #inputRef
        [attr.aria-required]="required"
        [attr.aria-expanded]="false"
        aria-autocomplete="none"
        role="combobox"
        [disabled]="disabled"
        [(ngModel)]="placeholder"
        placeholder="{{ placeholder }}"
        readonly
        ddlOverlayPanel
        #panelPopup="ddlOverlayPanel"
        [templateRef]="tmpl"
        (blur)="onBlur()"
        (focus)="onFocus()"
        (click)="toggleDropdown($event)"
        (backdropClick)="onPanelClose($event)"
      />

      <citi-icon2
        aria-hidden="true"
        class="arrowIcon ddl-dd3-arrow-icon"
        name="02-down"
        [shade]="disabled ? 'g1' : 'b2'"
        ariaLabel="icon"
      ></citi-icon2>
    </div>
    <!-- error message -->
    <div *ngIf="_error">
      <span class="ddl-dd3-error-message">{{ _errorMessage }}</span>
    </div>

    <!-- popup panel -->
    <ng-template #tmpl>
      <ng-content></ng-content>
    </ng-template>
  `, isInline: true, styles: ["label.ddl-dd3-label-text{font-size:.75rem;color:#666;width:100%;pointer-events:none}input.ddl-dd3-input{padding:.6875rem 1rem;border:1px solid #fff;background:#eee;font-size:1rem;line-height:1.5;border-radius:.5rem;outline:none;width:100%;color:#666}input.ddl-dd3-input:focus{border:1px solid #056DAE;outline:0}input.ddl-dd3-input:disabled{color:#333;background-color:transparent;border:1px solid #666}input.ddl-dd3-input.ddl-dd3-error-state{border:1px solid #D60000}input.ddl-dd3-input.ddl-dd3-error-state:focus{border:2px solid #D60000}.ddl-dd3-arrow-icon.ddl-dd3-arrow-icon{margin-top:17px;height:20px;position:absolute;right:30px;top:22px;display:inline-block;pointer-events:none}.ddl-dropdown-overlay-panel{display:block;border-radius:8px;overflow:auto;max-height:300px;flex-direction:column;background-color:#eee;border:1px solid #fff;box-shadow:0 1px 10px #0000001f}.ddl-dd3-error-message{color:#d60000;font-weight:700;line-height:1rem;font-size:12px;font-size:.75rem;font-family:interstate_Bold,sans-serif}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i4.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i4.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: Icon2Component, selector: "citi-icon2", inputs: ["role", "idStr", "ariaLabel", "ariaHidden", "size", "isHoverSfi", "includeCircle", "type", "svgStyle", "tabIndex", "shade", "name"] }, { kind: "directive", type: DdlOverlayPanel, selector: "[ddlOverlayPanel]", inputs: ["templateRef", "positionStrategy", "scrollStrategy"], outputs: ["backdropClick"], exportAs: ["ddlOverlayPanel"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Dropdown3Component, decorators: [{
            type: Component,
            args: [{ selector: 'citi-dropdown3', standalone: false, template: `
    <label [for]="idStr" class="ddl-dd3-label-text">{{ label }}</label>
    <div>
      <input
        [id]="idStr"
        class="ddl-dd3-input"
        [ngClass]="{ 'ddl-dd3-error-state': _error }"
        #inputRef
        [attr.aria-required]="required"
        [attr.aria-expanded]="false"
        aria-autocomplete="none"
        role="combobox"
        [disabled]="disabled"
        [(ngModel)]="placeholder"
        placeholder="{{ placeholder }}"
        readonly
        ddlOverlayPanel
        #panelPopup="ddlOverlayPanel"
        [templateRef]="tmpl"
        (blur)="onBlur()"
        (focus)="onFocus()"
        (click)="toggleDropdown($event)"
        (backdropClick)="onPanelClose($event)"
      />

      <citi-icon2
        aria-hidden="true"
        class="arrowIcon ddl-dd3-arrow-icon"
        name="02-down"
        [shade]="disabled ? 'g1' : 'b2'"
        ariaLabel="icon"
      ></citi-icon2>
    </div>
    <!-- error message -->
    <div *ngIf="_error">
      <span class="ddl-dd3-error-message">{{ _errorMessage }}</span>
    </div>

    <!-- popup panel -->
    <ng-template #tmpl>
      <ng-content></ng-content>
    </ng-template>
  `, providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef((() => Dropdown3Component)),
                            multi: true
                        },
                        Dropdown3Service
                    ], host: {
                        class: 'ddl-dropdown',
                        style: 'position: relative;',
                        role: 'presentation',
                        '(keydown)': 'onKeyDown($event)'
                    }, changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, styles: ["label.ddl-dd3-label-text{font-size:.75rem;color:#666;width:100%;pointer-events:none}input.ddl-dd3-input{padding:.6875rem 1rem;border:1px solid #fff;background:#eee;font-size:1rem;line-height:1.5;border-radius:.5rem;outline:none;width:100%;color:#666}input.ddl-dd3-input:focus{border:1px solid #056DAE;outline:0}input.ddl-dd3-input:disabled{color:#333;background-color:transparent;border:1px solid #666}input.ddl-dd3-input.ddl-dd3-error-state{border:1px solid #D60000}input.ddl-dd3-input.ddl-dd3-error-state:focus{border:2px solid #D60000}.ddl-dd3-arrow-icon.ddl-dd3-arrow-icon{margin-top:17px;height:20px;position:absolute;right:30px;top:22px;display:inline-block;pointer-events:none}.ddl-dropdown-overlay-panel{display:block;border-radius:8px;overflow:auto;max-height:300px;flex-direction:column;background-color:#eee;border:1px solid #fff;box-shadow:0 1px 10px #0000001f}.ddl-dd3-error-message{color:#d60000;font-weight:700;line-height:1rem;font-size:12px;font-size:.75rem;font-family:interstate_Bold,sans-serif}\n"] }]
        }], ctorParameters: () => [{ type: i1$4.Overlay }, { type: Dropdown3Service }, { type: i0.ElementRef }, { type: i0.ElementRef }, { type: i1$3.LiveAnnouncer }, { type: i0.ElementRef }], propDecorators: { label: [{
                type: Input$1
            }], placeholder: [{
                type: Input$1
            }], value: [{
                type: Input$1
            }], selected: [{
                type: Input$1
            }], required: [{
                type: Input$1
            }], disabled: [{
                type: Input$1
            }], idStr: [{
                type: Input$1
            }], error: [{
                type: Input$1
            }], errorMessage: [{
                type: Input$1
            }], requiredError: [{
                type: Input$1
            }], selectionChange: [{
                type: Output
            }], blur: [{
                type: Output
            }], element: [{
                type: ViewChild,
                args: ['panelPopup']
            }], panel: [{
                type: ViewChild,
                args: ['panel']
            }], inputRef: [{
                type: ViewChild,
                args: ['inputRef']
            }], options: [{
                type: ContentChildren,
                args: [Options3Component]
            }], option: [{
                type: ContentChild,
                args: ['option']
            }], closeOnEsc: [{
                type: HostListener,
                args: ['keydown.escape']
            }] } });

// Component Dependencies
const COMPONENTS$G = [Dropdown3Component, Options3Component, DdlOverlayPanel];
const MODULES$I = [CommonModule, FormsModule, OverlayModule, Icons2];
class Dropdown3 {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Dropdown3, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: Dropdown3, declarations: [Dropdown3Component, Options3Component, DdlOverlayPanel], imports: [CommonModule, FormsModule, OverlayModule, Icons2], exports: [Dropdown3Component, Options3Component, DdlOverlayPanel] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Dropdown3, imports: [MODULES$I] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Dropdown3, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$I],
                    declarations: [...COMPONENTS$G],
                    exports: [...COMPONENTS$G]
                }]
        }] });

/**
 * Gets scroll parents
 * @param node pass in the node to get it's parents that are scrollable
 * @returns array of elements that are scrollable
 */
function getScrollParents(node) {
    const scrollParents = [];
    let parent = node.parentElement;
    while (parent) {
        if (parent.nodeType === 1 && parent.scrollHeight > parent.clientHeight) {
            scrollParents.unshift(parent);
        }
        parent = parent.parentElement;
    }
    return scrollParents;
}

class Dropdown4Service {
    constructor() {
        this.currentDropdown4Value$ = new BehaviorSubject(null);
        this.optionClick$ = new Subject();
    }
    register(select) {
        this.select = select;
    }
    getSelect() {
        return this.select;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Dropdown4Service, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Dropdown4Service, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Dropdown4Service, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * Option IDs need to be unique across components, so this counter exists outside of
 * the component definition.
 */
let _optionUniqueIdCounter = 1;
class Option4Component {
    get element() {
        return this.host.nativeElement;
    }
    set label(lbl) {
        // Converts html entities (such as &reg; into text)
        const tempEl = this._document.createElement('span');
        tempEl.innerHTML = lbl || '';
        this._label = tempEl.textContent;
    }
    get label() {
        return this._label;
    }
    // Is the current dropdown value until a new option is selected
    get selected() {
        return this.select.selectedOption == this;
    }
    ;
    // #endregion
    // #region =========== Constructor / Life-cycle Hooks ========== //
    constructor(host, dropdownService, _doc) {
        this.host = host;
        this.dropdownService = dropdownService;
        this._doc = _doc;
        // #endregion
        // #region =========== @Input ========== //
        this.id = `option4-${_optionUniqueIdCounter++}`;
        this.isSelected = false;
        this._label = '';
        // #endregion
        // #region =========== @Output ========== //
        /**
         * Emits value
         * @deprecated
         */
        this.click = new EventEmitter();
        /**
         * Emits label
         * @deprecated
         */
        this.ddValue = new EventEmitter();
        this._document = _doc;
        this.select = this.dropdownService.getSelect();
    }
    ngOnInit() {
        this.dropdownService?.currentDropdown4Value$?.subscribe(val => {
            if (this.isSelected) {
                this._isSelected = this.isSelected;
            }
            else {
                this._isSelected = this._isActive = val === this.value ? true : null;
            }
        });
    }
    ngAfterContentInit() {
        setTimeout(() => {
            if (this.selected || this.isSelected) {
                const indexOfThisOption = this.select.options
                    .map((option) => option === this)
                    .indexOf(true);
                setTimeout(() => {
                    this.select._keyManager.setActiveItem(indexOfThisOption);
                }, 1);
            }
        }, 1);
    }
    // #endregion
    // #region =========== HostListeners ========== //
    optionClick(e) {
        e.preventDefault();
        e.stopPropagation();
        this.emitValues();
        // lets service know when option is clicked and passes value
        this.dropdownService.optionClick$.next(this.value);
    }
    // #endregion
    // #region =========== Methods ========== //
    /**
     * Previous functionality from original CDS Dropdown.
     * Should be deprecated.
     * They should use events emitted from dropdown instead.
     */
    emitValues() {
        this.select.selected = this.value;
        this.click.emit(this.value);
        this.ddValue.emit(this.label);
    }
    // #endregion
    // #region =========== Highlightable ========== //
    /**
     * This method sets display styles on the option to make it appear
     * active. This is used by the ActiveDescendantKeyManager so key
     * events will display the proper options as active on arrow key events.
     */
    setActiveStyles() {
        this._isActive = true;
        if (this.isSelected) {
            this.select.selected = this.value;
            this.select.writeValue(this.value);
        }
    }
    /**
     * This method removes display styles on the option that made it appear
     * active. This is used by the ActiveDescendantKeyManager so key
     * events will display the proper options as active on arrow key events.
     */
    setInactiveStyles() {
        this._isActive = null;
    }
    /** Gets the label to be used when determining whether the option should be focused. */
    getLabel() {
        return this.label;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Option4Component, deps: [{ token: i0.ElementRef }, { token: Dropdown4Service }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: Option4Component, isStandalone: false, selector: "li[option4]", inputs: { id: "id", value: "value", isSelected: "isSelected", label: "label" }, outputs: { click: "click", ddValue: "ddValue" }, host: { attributes: { "role": "option" }, listeners: { "mousedown": "optionClick($event)" }, properties: { "attr.id": "this.id", "class.dd4-option4-active": "this._isActive", "attr.aria-selected": "this._isActive", "class.dd4-option4-selected": "this.selected" }, classAttribute: "dd4-option4" }, ngImport: i0, template: `{{label}}`, isInline: true, styles: [":host{padding:0 16px;line-height:40px;cursor:default}:host.dd4-option4-active,:host:hover{color:#056dae;font-weight:400;text-decoration:underline;cursor:hand}:host.dd4-option4-selected{color:#056dae;font-weight:400;text-decoration:underline}:host-context(.ddl-dropdown4-sm){line-height:34px}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Option4Component, decorators: [{
            type: Component,
            args: [{ selector: 'li[option4]', standalone: false, template: `{{label}}`, host: {
                        class: 'dd4-option4',
                        role: 'option'
                    }, styles: [":host{padding:0 16px;line-height:40px;cursor:default}:host.dd4-option4-active,:host:hover{color:#056dae;font-weight:400;text-decoration:underline;cursor:hand}:host.dd4-option4-selected{color:#056dae;font-weight:400;text-decoration:underline}:host-context(.ddl-dropdown4-sm){line-height:34px}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: Dropdown4Service }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }], propDecorators: { id: [{
                type: HostBinding,
                args: ['attr.id']
            }, {
                type: Input$1
            }], value: [{
                type: Input$1
            }], isSelected: [{
                type: Input$1
            }], label: [{
                type: Input$1
            }], click: [{
                type: Output
            }], ddValue: [{
                type: Output
            }], _isActive: [{
                type: HostBinding,
                args: ['class.dd4-option4-active']
            }, {
                type: HostBinding,
                args: ['attr.aria-selected']
            }], selected: [{
                type: HostBinding,
                args: ['class.dd4-option4-selected']
            }], optionClick: [{
                type: HostListener,
                args: ['mousedown', ['$event']]
            }] } });

/**
 * @description this is an abstract class that the form field can query for
 * to manage form-level activities and sub component coordinatation
 */
class DdlFormBase {
    constructor() {
        /**
         * @description tells the form field whether or not the form element has focus
         */
        this.focusChange = new Subject();
        // /**
        //  * @description mechanism for casting focus in a standard way
        //  */
        // castFocus(): void {}
        /** Whether the control is required. */
        // readonly required: boolean;
        /** Whether the control is in an error state. */
        // readonly errorState: boolean;
    }
}

;
/**
 * Dropdown IDs need to be unique across components, so this counter exists outside of
 * the component definition.
 */
let _dropdown4UniqueIdCounter = 1;
class Dropdown4Component {
    set isInErrorState(isErr) {
        this._inErrorState = isErr;
        this.showErrorChange.emit(isErr);
        this._changeRef.markForCheck();
    }
    get isInErrorState() {
        return this._inErrorState;
    }
    set value(val) {
        // this value is updated by programmatic changes if( val !== undefined && this.val !== val){
        this._value = val;
        this._dropdown4Service?.currentDropdown4Value$?.next(val);
        this._updateDisplayText();
        this.onChange(val);
        this.hasValueChange.next(val);
        // Don't emit until after content is initialized
        if (this._isContentInitialized) {
            this.selectionChange.emit(val);
        }
        if (!val && this._keyManager?.activeItem) {
            this._keyManager.setActiveItem(null);
        }
    }
    get value() {
        return this._value;
    }
    // #endregion
    // #region =========== @Input ========== //
    set idStr(val) {
        this._id = val || this._uid;
        this.fieldId = this._id;
    }
    get idStr() {
        const id = this._id || this._uid;
        return id;
    }
    /**
     * Sets the error state.
     * This should only be used for Template based forms (not reactive forms)
     */
    set showError(isError) {
        this._inErrorState = isError;
    }
    get showError() {
        return this._inErrorState;
    }
    set error(isErrored) {
        if (isErrored === this._error)
            return;
        if (isErrored) {
            this._errorMessage = this.errorMessage;
        }
        this._error = isErrored;
        this._inErrorState = isErrored;
    }
    get error() {
        if (this._error)
            return this._error;
        if (this._inErrorState)
            return this._inErrorState;
        return false;
    }
    // #endregion
    // #region =========== Constructor / Life-cycle Hooks ========== //
    constructor(_el, _dropdown4Service, _changeRef, _validationService, _doc) {
        this._el = _el;
        this._dropdown4Service = _dropdown4Service;
        this._changeRef = _changeRef;
        this._validationService = _validationService;
        this._doc = _doc;
        this.fieldType = 'dropdown';
        this.focusChange = new Subject();
        this.hasValueChange = new Subject();
        this.disabledChange = new Subject();
        this._isOpen = false;
        this._isPastViewMiddle = false;
        this._wrapperPadding = 8;
        this._eventUnsub$ = new Subject();
        this._destroyUnsub$ = new Subject();
        this._inErrorState = false;
        this._uid = `Dropdown4_${_dropdown4UniqueIdCounter++}`;
        this._error = false;
        this.errorMessage = 'Error';
        this.requiredError = 'Required error';
        // #endregion
        // #region ========== @Outputs ========== //
        /**
         * The event is emitted when the value is changed
         * The event is returned.
         */
        this.selectionChange = new EventEmitter();
        /**
         * The event is emitted when the dropdown is closed
         */
        this.panelClose = new EventEmitter();
        /**
         * The event is emitted when the dropdown is blurred
         */
        this.blur = new EventEmitter();
        /**
         * The event is emitted when the error state changes
         */
        this.showErrorChange = new EventEmitter();
        // #endregion
        // #region =========== ControlValueAccessor =========== //
        this.onChange = (_) => { };
        this.onTouch = () => { };
        this._document = this._doc;
        this._window = this._document?.defaultView;
        this._dropdown4Service.register(this);
    }
    ngOnInit() {
        // Initialize fieldId
        this.fieldId = this.idStr;
        this._validateSub$ = this._validationService.validateNow.subscribe(() => {
            this.validate();
        });
    }
    ngAfterContentInit() {
        this._initKeyManager();
        this._updateDisplayText();
        this._isContentInitialized = true;
        this._dropdown4Service.optionClick$.subscribe(val => {
            this.value = val;
            this.close();
        });
    }
    ngAfterViewInit() {
        // set listbox max-height and change if window is resized
        this._setValidMaxHeight();
        fromEvent(this._window, 'resize')
            .pipe(takeUntil(this._destroyUnsub$), debounceTime(10))
            .subscribe(obv => {
            if (this.listMaxHeight) {
                this._setValidMaxHeight();
            }
        });
    }
    ngOnChanges(simpleChanges) {
        for (const propName in simpleChanges) {
            const change = simpleChanges[propName];
            switch (propName) {
                case 'placeholder':
                    this._updateDisplayText();
                    break;
                case 'listMaxHeight':
                    if (!change.isFirstChange()) {
                        this._setValidMaxHeight();
                    }
                    break;
            }
        }
    }
    ngOnDestroy() {
        this._validationService.removeError(this);
        if (this._validateSub$)
            this._validateSub$.unsubscribe();
        this._eventUnsub$.next();
        this._eventUnsub$.complete();
        this._destroyUnsub$.next();
        this._destroyUnsub$.complete();
    }
    // #endregion
    // #region =========== Methods =========== //
    /**
     * Toggles open the listbox
     */
    _toggleOpen(e) {
        e.preventDefault();
        if (this._isOpen) {
            this.close();
        }
        else {
            this.open();
        }
    }
    /**
     * Opens  dropdown4 component, scrolls to the active option, and focuses on listbox
     */
    open() {
        // Sets display to block, but still not visible.
        // This allows the code to get the dimensions of the listbox before making it visible.
        this._isOpen = true;
        // on open, sets the currently selected option to the "active" option
        const currentOptionInfo = this._getOptionInfoFromValue(this.value);
        if (currentOptionInfo) {
            this._keyManager.setActiveItem(currentOptionInfo.index);
        }
        else {
            this._keyManager.setFirstItemActive();
        }
        setTimeout(() => {
            // sets size and position of listbox
            this._repositionListbox();
            // when scroll or resize events happen, listbox is resized/repositioned
            const fromScroll$ = fromEvent(this._window, 'scroll');
            const fromResize$ = fromEvent(this._window, 'resize');
            const scrollParents$ = getScrollParents(this.listbox.nativeElement)
                .filter(el => el?.nodeName?.toLowerCase() !== 'html')
                .map(elem => fromEvent(elem, 'scroll'));
            merge$1(fromResize$, fromScroll$, ...scrollParents$)
                .pipe(takeUntil(this._eventUnsub$), debounceTime(10))
                .subscribe(obv => {
                this._repositionListbox();
            });
            // Scroll to active item after open
            const listboxEl = this.listbox.nativeElement;
            const activeEl = this._keyManager?.activeItem?.element;
            if (activeEl) {
                listboxEl.scrollTop = activeEl.offsetTop - this._wrapperPadding;
            }
            else {
                listboxEl.scrollTop = 0;
            }
            // Sets the listbox to visible after getting dimensions and setting the listbox in the correct position.
            this._isVisible = true;
            // focus on list after visible
            setTimeout(() => {
                this.listbox.nativeElement.focus();
            }, 0);
        }, 0);
    }
    /**
     * Closes  dropdown4 listbox
     * @param [isRefocusOnButtonSkipped] when the listbox is closed, this prevents it from focusing back on the button
     */
    close(isRefocusOnButtonSkipped) {
        // do nothing if already closed
        if (!this._isOpen) {
            return;
        }
        // No need to reposition while closed, unsubscribing from event observable
        this._eventUnsub$.next();
        setTimeout(() => {
            this._isOpen = false;
            this._isVisible = false;
            this.panelClose.emit(this.value);
            // focus back on button if needed
            if (!isRefocusOnButtonSkipped) {
                this.listboxButton.nativeElement.focus();
            }
            this._changeRef.markForCheck();
        }, 0);
    }
    validate() {
        if (this.disabled)
            return;
        if (this.required && !this.value) {
            this._error = true;
            this._inErrorState = true;
            this._errorMessage = this.requiredError;
            this._validationService.addError(this);
            this.resetErrorHidden();
        }
        else if (this.error && !this.required) {
            this._errorMessage = this.errorMessage;
            this._validationService.addError(this);
            this.resetErrorHidden();
        }
        else if (this.required && this.value) {
            this._error = false;
            this._inErrorState = false;
            this._validationService.removeError(this);
        }
    }
    resetErrorHidden() {
        this._isErrorHidden = true;
        this._changeRef.markForCheck();
        setTimeout(() => {
            this._isErrorHidden = false;
            this._changeRef.markForCheck();
        }, 10);
    }
    onBlur() {
        this.blur.emit();
    }
    /**
     * Finds the Option4 from the value
     * @param val value of option
     */
    _getOptionInfoFromValue(val) {
        const opt = this.options?.find(o => o.value === val);
        let optInfo = null;
        if (opt) {
            optInfo = {
                option: opt,
                label: opt.label,
                value: opt.value,
                index: this.options.toArray().indexOf(opt),
                isSelected: opt.isSelected
            };
        }
        return optInfo;
    }
    _updateDisplayText() {
        const currentOptionInfo = this._getOptionInfoFromValue(this.value);
        this._isPlaceholder = !this.value;
        this._displayText = currentOptionInfo?.label || this.placeholder || '';
        this._changeRef.markForCheck();
    }
    _blurList(e) {
        const isInDropdown = this._el.nativeElement.contains(e.relatedTarget);
        if (this._isOpen) {
            this.close(!isInDropdown);
        }
    }
    /**
     * Finds out if focus truly leaves the dropdown component.
     * @param e FocusEvent
     */
    _focusoutDropdown(e) {
        const isInDropdown = this._el.nativeElement.contains(e.relatedTarget);
        if (!isInDropdown) {
            this._isFocused = false;
            this.focusChange.next(this._isFocused);
            this.onTouch();
            this.blur.emit();
            this.validate();
        }
    }
    _focusinDropdown(e) {
        if (!this._isFocused) {
            this._isFocused = true;
            this.focusChange.next(this._isFocused);
        }
    }
    /**
     * Handles keyboard events when focus is on the button (mainly to open the listbox)
     * @param e KeyboardEvent
     */
    _keydownButtonHandler(e) {
        const keyCode = e.keyCode || e.which || 0;
        // if alt+arrowdown: open
        // deque opens dropdown with simple ArrowDown (even without alt key)
        if (keyCode === DOWN_ARROW || keyCode === ENTER) {
            e.preventDefault();
            this.open();
        }
    }
    /**
     * Handles keyboard events when the listbox is open and in focus
     * @param e KeyboardEvent
     */
    _keydownListHandler(e) {
        const keyCode = e.keyCode || e.which || 0;
        // passes event to keyManager
        this._keyManager.onKeydown(e);
        // functionality that the keyManager does not do
        switch (keyCode) {
            // escape closes without change
            case ESCAPE:
                e.preventDefault();
                e.stopPropagation();
                this.close();
                break;
            // enter/space selects the currently active item and closes
            case ENTER:
            //left blank based on CDS dropdown2 code structure
            case SPACE:
                e.preventDefault();
                e.stopPropagation();
                this.selected = this._keyManager?.activeItem?.value;
                this.value = this._keyManager?.activeItem?.value;
                this.close();
                break;
        }
    }
    /**
     * Initializes the ActiveDescendantKeyManager
     */
    _initKeyManager() {
        this._keyManager = new ActiveDescendantKeyManager(this.options)
            .withVerticalOrientation()
            .withAllowedModifierKeys(['shiftKey'])
            .withHomeAndEnd()
            .withTypeAhead();
        // subscribe to changes of active item
        this._keyManager.change.subscribe({
            next: indx => {
                // sets the aria-activedescendant id
                this._activeDescendantId = this._keyManager?.activeItem?.id;
                // scroll active item into view if needed
                const listboxEl = this.listbox.nativeElement;
                const activeEl = this._keyManager?.activeItem?.element;
                this._scrollToIfNeeded(listboxEl, activeEl);
                this._changeRef.markForCheck();
            }
        });
    }
    /**
     * Scrolls the item into view if needed.  Does not scroll if item already in view.
     * @param wrapperEl The wrapper element that contains the scrollable elements
     * @param itemEl The item that needs to scroll into view
     */
    _scrollToIfNeeded(wrapperEl, itemEl) {
        if (!itemEl) {
            if (!!wrapperEl) {
                wrapperEl.scrollTop = 0;
            }
            return;
        }
        const wrapTop = wrapperEl.scrollTop + this._wrapperPadding;
        const wrapBottom = wrapTop + wrapperEl.offsetHeight;
        const itemTop = itemEl.offsetTop;
        const itemBottom = itemTop + itemEl.offsetHeight;
        if (itemTop < wrapTop) {
            wrapperEl.scrollTop = itemTop - this._wrapperPadding;
        }
        else if (itemBottom > wrapBottom) {
            wrapperEl.scrollTop = itemBottom - wrapperEl.offsetHeight - this._wrapperPadding;
        }
    }
    /**
     * Repositions listbox - find out if dropdown is above/below middle of view, then add/remove class so dropdown can be repositioned.
     */
    _repositionListbox() {
        const viewportHeight = this._window?.innerHeight;
        const viewportMidpoint = Math.round(viewportHeight / 2);
        const buttonRect = this.listboxButton?.nativeElement?.getBoundingClientRect();
        const buttonMidpoint = Math.round(buttonRect.top + (buttonRect.height / 2));
        const listboxRect = this.listbox?.nativeElement?.getBoundingClientRect();
        this._isPastViewMiddle = buttonMidpoint > viewportMidpoint;
        this._isPlacedAbove = buttonRect.bottom + listboxRect.height - 8 > viewportHeight;
        // Set width of listbox
        this._listboxWidth = buttonRect?.width;
        // Set left position of listbox
        this._listboxLeft = buttonRect?.left;
        // Set top position of listbox
        if (this._isPlacedAbove) {
            this._listboxTop = buttonRect.top - listboxRect.height - (this._wrapperPadding * 2);
        }
        else {
            this._listboxTop = buttonRect.bottom;
        }
        /*   if (this._isPastViewMiddle) {
             this._listboxTop = buttonRect.top - listboxRect.height - (this._wrapperPadding * 2);
           } else {
             this._listboxTop = buttonRect.bottom;
           } */
        this._changeRef.markForCheck();
    }
    _getValidMaxHeight(maxHeight) {
        const viewportHeight = this._window?.innerHeight;
        const buttonRect = this.listboxButton?.nativeElement?.getBoundingClientRect();
        const buttonHeight = buttonRect.height;
        const maxAvailableViewportHeight = viewportHeight - buttonHeight;
        const buttonDistanceFromTop = Math.round(buttonRect.top + this._window.scrollY);
        const buttonDistanceFromBottom = this._document.body.clientHeight - buttonHeight - buttonDistanceFromTop;
        const buttonDistanceMax = Math.max(buttonDistanceFromTop, buttonDistanceFromBottom);
        const distanceVsViewportMin = Math.min(buttonDistanceMax, maxAvailableViewportHeight);
        if (maxHeight > distanceVsViewportMin) {
            return distanceVsViewportMin - 20;
        }
        return maxHeight;
    }
    _setValidMaxHeight() {
        if (this.listMaxHeight) {
            this._listMaxHeight = this._getValidMaxHeight(this.listMaxHeight);
        }
        else {
            this._listMaxHeight = null;
        }
        this._changeRef.detectChanges();
    }
    writeValue(value) {
        this.value = value;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
        this.disabledChange.next(isDisabled);
        this._changeRef.markForCheck();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Dropdown4Component, deps: [{ token: i0.ElementRef }, { token: Dropdown4Service }, { token: i0.ChangeDetectorRef }, { token: ValidationService }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: Dropdown4Component, isStandalone: false, selector: "citi-dropdown4", inputs: { idStr: "idStr", placeholder: "placeholder", disabled: "disabled", label: "label", selected: "selected", showError: "showError", error: "error", errorMessage: "errorMessage", requiredError: "requiredError", required: "required", listMaxHeight: "listMaxHeight" }, outputs: { selectionChange: "selectionChange", panelClose: "panelClose", blur: "blur", showErrorChange: "showErrorChange" }, host: { listeners: { "focusout": "_focusoutDropdown($event)", "focusin": "_focusinDropdown($event)" }, properties: { "class.cds-dd4-error": "this._inErrorState" }, classAttribute: "ddl-dropdown" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef((() => Dropdown4Component)),
                multi: true
            },
            { provide: DdlFormBase, useExisting: Dropdown4Component },
            Dropdown4Service
        ], queries: [{ propertyName: "options", predicate: Option4Component }], viewQueries: [{ propertyName: "listboxButton", first: true, predicate: ["listboxButton"], descendants: true }, { propertyName: "listbox", first: true, predicate: ["listbox"], descendants: true }], usesOnChanges: true, ngImport: i0, template: `
    <label [attr.id]="idStr + '-button-label'"  class="ddl-dd4-label-text">{{ label }}</label>
    <div><!-- wrapper div around button and listbox required, per https://github.com/dequelabs/pattern-library/wiki/selects -->
      <button
        #listboxButton
        [id]="idStr"
        type="button"
        class="dd4-button"
        [class.dd4-button-open]="_isOpen"
        [class.dd4-button-placeholder]="_isPlaceholder"
        [class.dd4-button-error]="_inErrorState"
        [class.dd4-button-focused]="_isFocused"
        role="combobox"
        aria-haspopup="listbox"
        [attr.aria-label]="disabled ? _displayText : null"
        [attr.aria-labelledby]="!disabled ? idStr + '-button-label' : null"
        [attr.aria-describedby]="_error ? idStr + '-error-message' : null"
        [attr.aria-expanded]="!!_isOpen"
        [attr.aria-controls]="idStr + '-listbox'"
        (click)="_toggleOpen($event)"
        (keydown)="_keydownButtonHandler($event)"
        [disabled]="disabled"
        [attr.required]="required ? '' : null"
        (blur)="onBlur()"
      >
        <div
          [id]="idStr + '-button-value'"
          class="dd4-pseudo-value"
        >
          {{ _displayText || '&nbsp;' }}
        </div>
      </button>
      <div
      class="ddl-dd4-options-container"
      [style.display]="_isOpen ? 'block' : 'none'"
      [style.visibility]="_isVisible ? 'visible' : 'hidden'"
      >
        <div
          class="ddl-dd4-options"
          [style.width.px]="_listboxWidth"
          [style.top.px]="_listboxTop"
          [style.left.px]="_listboxLeft"
        >
          <ul
            #listbox
            [id]="idStr + '-listbox'"
            class="ddl-dd4-listbox"
            role="listbox"
            tabindex="0"
            (keydown)="_keydownListHandler($event)"
            (blur)="_blurList($event)"
            [attr.aria-activedescendant]="_activeDescendantId"
            [style.maxHeight.px]="_listMaxHeight"
          >
            <ng-content></ng-content>
          </ul>
        </div>
      </div>
    </div>
    <div *ngIf="_error && !_isErrorHidden">
      <div [attr.id]="idStr + '-error-message'" role="alert" class="ddl-dd4-error-message">{{ _errorMessage }}</div>
    </div>
  `, isInline: true, styles: [":host{position:relative;width:100%;display:block}.ddl-dd4-error-message{color:#d60000;font-weight:700;line-height:1rem;font-size:12px;font-size:.75rem;font-family:interstate_Bold,sans-serif;margin:5px 0}label.ddl-dd4-label-text{font-size:.75rem;color:#666;width:100%;pointer-events:none}input.ddl-dd4-input{padding:.6875rem 1rem;border:1px solid #fff;background:#eee;font-size:1rem;line-height:1.5;border-radius:.5rem;outline:none;width:100%;color:#666}input.ddl-dd4-input:focus{border:1px solid #056DAE;outline:0}input.ddl-dd4-input:disabled{color:#333;background-color:transparent;border:1px solid #666}input.ddl-dd4-input.ddl-dd4-error-state{border:1px solid #D60000}input.ddl-dd4-input.ddl-dd4-error-state:focus{border:2px solid #D60000}.ddl-dd4-arrow-icon.ddl-dd4-arrow-icon{margin-top:17px;height:20px;position:absolute;right:30px;top:22px;display:inline-block;pointer-events:none}.ddl-dropdown-overlay-panel{display:block;border-radius:8px;overflow:auto;max-height:300px;flex-direction:column;background-color:#eee;border:1px solid #fff;box-shadow:0 1px 10px #0000001f}.dd4-button{color:#666;font-weight:400;border:1px solid #fff;border-radius:8px;padding:0 54px 0 16px;background-color:#eee;width:100%;text-align:left;line-height:46px;outline:none}.dd4-button:after{content:\"\";width:24px;height:48px;position:absolute;top:0;margin-top:22px;right:30px;background-repeat:no-repeat;background-position:right center;background-image:url(\"data:image/svg+xml,%3Csvg version=%221.1%22 viewBox=%220 0 24 24%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cg fill=%22none%22 fill-rule=%22evenodd%22%3E%3Cpath fill=%22%23056dae%22 d=%22m12 16.672c-0.531 0-1.046-0.227-1.413-0.62l-5.319-5.719c-0.376-0.404-0.353-1.037 0.051-1.413 0.406-0.375 1.037-0.352 1.413 0.052l5.268 5.662 5.268-5.662c0.378-0.404 1.009-0.426 1.413-0.052 0.405 0.376 0.427 1.009 0.051 1.413l-5.318 5.718c-0.368 0.394-0.883 0.621-1.414 0.621%22/%3E%3C/g%3E%3C/svg%3E\");transition:transform .2s}.dd4-button:disabled{pointer-events:none}.dd4-button.dd4-button-disabled{cursor:default;border-color:#666;background-color:#fff;color:#333}.dd4-button.dd4-button-disabled:after{background-image:url(\"data:image/svg+xml,%3Csvg version=%221.1%22 viewBox=%220 0 24 24%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cg fill=%22none%22 fill-rule=%22evenodd%22%3E%3Cpath fill=%22%23333%22 d=%22m12 16.672c-0.531 0-1.046-0.227-1.413-0.62l-5.319-5.719c-0.376-0.404-0.353-1.037 0.051-1.413 0.406-0.375 1.037-0.352 1.413 0.052l5.268 5.662 5.268-5.662c0.378-0.404 1.009-0.426 1.413-0.052 0.405 0.376 0.427 1.009 0.051 1.413l-5.318 5.718c-0.368 0.394-0.883 0.621-1.414 0.621%22/%3E%3C/g%3E%3C/svg%3E\")}.dd4-button:focus,.dd4-button:active,.dd4-button.dd4-button-focused{border-color:#056dae}.dd4-button.dd4-button-error{border-color:#d60000;color:#666}.dd4-button.dd4-button-error:focus,.dd4-button.dd4-button-error:active,.dd4-button.dd4-button-error.dd4-button-focused{border:2px solid #d60000}.dd4-button.dd4-button-error[disabled]{cursor:default;border-color:#666;background-color:#fff;color:#333}.dd4-button.dd4-button-error[disabled]:after{background-image:url(\"data:image/svg+xml,%3Csvg version=%221.1%22 viewBox=%220 0 24 24%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cg fill=%22none%22 fill-rule=%22evenodd%22%3E%3Cpath fill=%22%23333%22 d=%22m12 16.672c-0.531 0-1.046-0.227-1.413-0.62l-5.319-5.719c-0.376-0.404-0.353-1.037 0.051-1.413 0.406-0.375 1.037-0.352 1.413 0.052l5.268 5.662 5.268-5.662c0.378-0.404 1.009-0.426 1.413-0.052 0.405 0.376 0.427 1.009 0.051 1.413l-5.318 5.718c-0.368 0.394-0.883 0.621-1.414 0.621%22/%3E%3C/g%3E%3C/svg%3E\")}.dd4-button[disabled]{cursor:default;border-color:#666;background-color:#fff;color:#333}.dd4-button[disabled]:after{background-image:url(\"data:image/svg+xml,%3Csvg version=%221.1%22 viewBox=%220 0 24 24%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cg fill=%22none%22 fill-rule=%22evenodd%22%3E%3Cpath fill=%22%23333%22 d=%22m12 16.672c-0.531 0-1.046-0.227-1.413-0.62l-5.319-5.719c-0.376-0.404-0.353-1.037 0.051-1.413 0.406-0.375 1.037-0.352 1.413 0.052l5.268 5.662 5.268-5.662c0.378-0.404 1.009-0.426 1.413-0.052 0.405 0.376 0.427 1.009 0.051 1.413l-5.318 5.718c-0.368 0.394-0.883 0.621-1.414 0.621%22/%3E%3C/g%3E%3C/svg%3E\")}.dd4-button-open:after{transform:rotateX(-180deg)}.dd4-pseudo-value{text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.ddl-dd4-options-container{display:none;visibility:hidden;position:fixed;top:0;left:0;z-index:1000;pointer-events:none;width:100%;height:100%}.ddl-dd4-options{position:absolute;pointer-events:auto;padding:8px 0;background-color:#eee;border-radius:8px;box-shadow:0 1px 10px #0000001f}.ddl-dd4-listbox{list-style-type:none;overflow-y:auto;max-height:240px;margin:0;padding:0;outline:none}:host.ddl-dropdown4-sm .dd4-button{line-height:30px;padding-right:32px}:host.ddl-dropdown4-sm .dd4-button:after{height:32px;right:8px}:host.ddl-dropdown4-sm .ddl-dd4-listbox{max-height:238px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Dropdown4Component, decorators: [{
            type: Component,
            args: [{ selector: 'citi-dropdown4', standalone: false, template: `
    <label [attr.id]="idStr + '-button-label'"  class="ddl-dd4-label-text">{{ label }}</label>
    <div><!-- wrapper div around button and listbox required, per https://github.com/dequelabs/pattern-library/wiki/selects -->
      <button
        #listboxButton
        [id]="idStr"
        type="button"
        class="dd4-button"
        [class.dd4-button-open]="_isOpen"
        [class.dd4-button-placeholder]="_isPlaceholder"
        [class.dd4-button-error]="_inErrorState"
        [class.dd4-button-focused]="_isFocused"
        role="combobox"
        aria-haspopup="listbox"
        [attr.aria-label]="disabled ? _displayText : null"
        [attr.aria-labelledby]="!disabled ? idStr + '-button-label' : null"
        [attr.aria-describedby]="_error ? idStr + '-error-message' : null"
        [attr.aria-expanded]="!!_isOpen"
        [attr.aria-controls]="idStr + '-listbox'"
        (click)="_toggleOpen($event)"
        (keydown)="_keydownButtonHandler($event)"
        [disabled]="disabled"
        [attr.required]="required ? '' : null"
        (blur)="onBlur()"
      >
        <div
          [id]="idStr + '-button-value'"
          class="dd4-pseudo-value"
        >
          {{ _displayText || '&nbsp;' }}
        </div>
      </button>
      <div
      class="ddl-dd4-options-container"
      [style.display]="_isOpen ? 'block' : 'none'"
      [style.visibility]="_isVisible ? 'visible' : 'hidden'"
      >
        <div
          class="ddl-dd4-options"
          [style.width.px]="_listboxWidth"
          [style.top.px]="_listboxTop"
          [style.left.px]="_listboxLeft"
        >
          <ul
            #listbox
            [id]="idStr + '-listbox'"
            class="ddl-dd4-listbox"
            role="listbox"
            tabindex="0"
            (keydown)="_keydownListHandler($event)"
            (blur)="_blurList($event)"
            [attr.aria-activedescendant]="_activeDescendantId"
            [style.maxHeight.px]="_listMaxHeight"
          >
            <ng-content></ng-content>
          </ul>
        </div>
      </div>
    </div>
    <div *ngIf="_error && !_isErrorHidden">
      <div [attr.id]="idStr + '-error-message'" role="alert" class="ddl-dd4-error-message">{{ _errorMessage }}</div>
    </div>
  `, providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef((() => Dropdown4Component)),
                            multi: true
                        },
                        { provide: DdlFormBase, useExisting: Dropdown4Component },
                        Dropdown4Service
                    ], changeDetection: ChangeDetectionStrategy.OnPush, host: {
                        class: 'ddl-dropdown',
                        '(focusout)': '_focusoutDropdown($event)',
                        '(focusin)': '_focusinDropdown($event)'
                    }, styles: [":host{position:relative;width:100%;display:block}.ddl-dd4-error-message{color:#d60000;font-weight:700;line-height:1rem;font-size:12px;font-size:.75rem;font-family:interstate_Bold,sans-serif;margin:5px 0}label.ddl-dd4-label-text{font-size:.75rem;color:#666;width:100%;pointer-events:none}input.ddl-dd4-input{padding:.6875rem 1rem;border:1px solid #fff;background:#eee;font-size:1rem;line-height:1.5;border-radius:.5rem;outline:none;width:100%;color:#666}input.ddl-dd4-input:focus{border:1px solid #056DAE;outline:0}input.ddl-dd4-input:disabled{color:#333;background-color:transparent;border:1px solid #666}input.ddl-dd4-input.ddl-dd4-error-state{border:1px solid #D60000}input.ddl-dd4-input.ddl-dd4-error-state:focus{border:2px solid #D60000}.ddl-dd4-arrow-icon.ddl-dd4-arrow-icon{margin-top:17px;height:20px;position:absolute;right:30px;top:22px;display:inline-block;pointer-events:none}.ddl-dropdown-overlay-panel{display:block;border-radius:8px;overflow:auto;max-height:300px;flex-direction:column;background-color:#eee;border:1px solid #fff;box-shadow:0 1px 10px #0000001f}.dd4-button{color:#666;font-weight:400;border:1px solid #fff;border-radius:8px;padding:0 54px 0 16px;background-color:#eee;width:100%;text-align:left;line-height:46px;outline:none}.dd4-button:after{content:\"\";width:24px;height:48px;position:absolute;top:0;margin-top:22px;right:30px;background-repeat:no-repeat;background-position:right center;background-image:url(\"data:image/svg+xml,%3Csvg version=%221.1%22 viewBox=%220 0 24 24%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cg fill=%22none%22 fill-rule=%22evenodd%22%3E%3Cpath fill=%22%23056dae%22 d=%22m12 16.672c-0.531 0-1.046-0.227-1.413-0.62l-5.319-5.719c-0.376-0.404-0.353-1.037 0.051-1.413 0.406-0.375 1.037-0.352 1.413 0.052l5.268 5.662 5.268-5.662c0.378-0.404 1.009-0.426 1.413-0.052 0.405 0.376 0.427 1.009 0.051 1.413l-5.318 5.718c-0.368 0.394-0.883 0.621-1.414 0.621%22/%3E%3C/g%3E%3C/svg%3E\");transition:transform .2s}.dd4-button:disabled{pointer-events:none}.dd4-button.dd4-button-disabled{cursor:default;border-color:#666;background-color:#fff;color:#333}.dd4-button.dd4-button-disabled:after{background-image:url(\"data:image/svg+xml,%3Csvg version=%221.1%22 viewBox=%220 0 24 24%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cg fill=%22none%22 fill-rule=%22evenodd%22%3E%3Cpath fill=%22%23333%22 d=%22m12 16.672c-0.531 0-1.046-0.227-1.413-0.62l-5.319-5.719c-0.376-0.404-0.353-1.037 0.051-1.413 0.406-0.375 1.037-0.352 1.413 0.052l5.268 5.662 5.268-5.662c0.378-0.404 1.009-0.426 1.413-0.052 0.405 0.376 0.427 1.009 0.051 1.413l-5.318 5.718c-0.368 0.394-0.883 0.621-1.414 0.621%22/%3E%3C/g%3E%3C/svg%3E\")}.dd4-button:focus,.dd4-button:active,.dd4-button.dd4-button-focused{border-color:#056dae}.dd4-button.dd4-button-error{border-color:#d60000;color:#666}.dd4-button.dd4-button-error:focus,.dd4-button.dd4-button-error:active,.dd4-button.dd4-button-error.dd4-button-focused{border:2px solid #d60000}.dd4-button.dd4-button-error[disabled]{cursor:default;border-color:#666;background-color:#fff;color:#333}.dd4-button.dd4-button-error[disabled]:after{background-image:url(\"data:image/svg+xml,%3Csvg version=%221.1%22 viewBox=%220 0 24 24%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cg fill=%22none%22 fill-rule=%22evenodd%22%3E%3Cpath fill=%22%23333%22 d=%22m12 16.672c-0.531 0-1.046-0.227-1.413-0.62l-5.319-5.719c-0.376-0.404-0.353-1.037 0.051-1.413 0.406-0.375 1.037-0.352 1.413 0.052l5.268 5.662 5.268-5.662c0.378-0.404 1.009-0.426 1.413-0.052 0.405 0.376 0.427 1.009 0.051 1.413l-5.318 5.718c-0.368 0.394-0.883 0.621-1.414 0.621%22/%3E%3C/g%3E%3C/svg%3E\")}.dd4-button[disabled]{cursor:default;border-color:#666;background-color:#fff;color:#333}.dd4-button[disabled]:after{background-image:url(\"data:image/svg+xml,%3Csvg version=%221.1%22 viewBox=%220 0 24 24%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cg fill=%22none%22 fill-rule=%22evenodd%22%3E%3Cpath fill=%22%23333%22 d=%22m12 16.672c-0.531 0-1.046-0.227-1.413-0.62l-5.319-5.719c-0.376-0.404-0.353-1.037 0.051-1.413 0.406-0.375 1.037-0.352 1.413 0.052l5.268 5.662 5.268-5.662c0.378-0.404 1.009-0.426 1.413-0.052 0.405 0.376 0.427 1.009 0.051 1.413l-5.318 5.718c-0.368 0.394-0.883 0.621-1.414 0.621%22/%3E%3C/g%3E%3C/svg%3E\")}.dd4-button-open:after{transform:rotateX(-180deg)}.dd4-pseudo-value{text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.ddl-dd4-options-container{display:none;visibility:hidden;position:fixed;top:0;left:0;z-index:1000;pointer-events:none;width:100%;height:100%}.ddl-dd4-options{position:absolute;pointer-events:auto;padding:8px 0;background-color:#eee;border-radius:8px;box-shadow:0 1px 10px #0000001f}.ddl-dd4-listbox{list-style-type:none;overflow-y:auto;max-height:240px;margin:0;padding:0;outline:none}:host.ddl-dropdown4-sm .dd4-button{line-height:30px;padding-right:32px}:host.ddl-dropdown4-sm .dd4-button:after{height:32px;right:8px}:host.ddl-dropdown4-sm .ddl-dd4-listbox{max-height:238px}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: Dropdown4Service }, { type: i0.ChangeDetectorRef }, { type: ValidationService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }], propDecorators: { _inErrorState: [{
                type: HostBinding,
                args: ['class.cds-dd4-error']
            }], listboxButton: [{
                type: ViewChild,
                args: ['listboxButton']
            }], listbox: [{
                type: ViewChild,
                args: ['listbox']
            }], options: [{
                type: ContentChildren,
                args: [Option4Component]
            }], idStr: [{
                type: Input$1
            }], placeholder: [{
                type: Input$1
            }], disabled: [{
                type: Input$1
            }], label: [{
                type: Input$1
            }], selected: [{
                type: Input$1
            }], showError: [{
                type: Input$1
            }], error: [{
                type: Input$1
            }], errorMessage: [{
                type: Input$1
            }], requiredError: [{
                type: Input$1
            }], required: [{
                type: Input$1
            }], listMaxHeight: [{
                type: Input$1
            }], selectionChange: [{
                type: Output
            }], panelClose: [{
                type: Output
            }], blur: [{
                type: Output
            }], showErrorChange: [{
                type: Output
            }] } });

const COMPONENTS$F = [Dropdown4Component, Option4Component];
class Dropdown4 {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Dropdown4, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: Dropdown4, declarations: [Dropdown4Component, Option4Component], imports: [CommonModule], exports: [Dropdown4Component, Option4Component] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Dropdown4, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Dropdown4, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [...COMPONENTS$F],
                    imports: [
                        CommonModule
                    ],
                    exports: [...COMPONENTS$F]
                }]
        }] });

let nextId$3 = 0;
/**
 * @Component: Form Container
 * @Section: Forms
 * @description This is the container for forms and provides common funcionality for all DDL based forms.
 * To use the form container, create a reference to it in your markup: <citi-input-group #formContainer>
 * Then in your component, use ViewChild and ElementRef to get a reference to the actual form container component: @ViewChild("formContainer") formContainer: ElementRef
 * You can now call this.formContainer to gain access to all features of the form container.
 * Form container component reference returns:
 * form: This is a reference to the form element within the form container. Access via formContainer.form.nativeElement.
 * validationService: This is a reference to the validation service attached to the form container. Use this to interact with form validation.
 * submit(): Function that submits the form inside the form container.
 * validate(): Function to validate the form elements inside of the form container.
 */
class FormContainerComponent {
    /**
     ** @description Sets the id attribute of the form-container
    */
    get idStr() {
        return this._id || this._uid;
    }
    set idStr(value) {
        this._id = value || this._uid;
    }
    // #endregion
    // #region // ----------- Life Cycles ---------- //
    constructor(validationService, _document) {
        this.validationService = validationService;
        this._document = _document;
        /**
         * @property errors
         * @description Holds any errored elements in the form.
         * Each item in the array is a reference to the component for the element that has error,
         * giving you full access to its state. Empty until form is validated.
         * @Type: Array
         */
        this.errors = [];
        /**
         * @property hasErrors
         * @description Whether or not the form currently has errors
         * @Type: boolean
         */
        this.hasErrors = false;
        /**
         * @property formMethod
         * @description The method attribute for the form.
         * @return string
         */
        this.formMethod = 'GET';
        this.headingLevel = 1;
        this._uid = `citi-form-container-${nextId$3++}`;
        /**
         * @name submit
         * @description Submits the form element using the form action provided.
         * @return Void
         */
        this.submit = () => {
            this.form.nativeElement.submit();
        };
    }
    ngOnInit() {
        this.validationService.errorAdded.subscribe(() => {
            this.errors = this.validationService.errors;
            this.hasErrors = this.validationService.errors.length > 0;
        });
        this.validationService.errorRemoved.subscribe(() => {
            this.errors = this.validationService.errors;
            this.hasErrors = this.validationService.errors.length > 0;
        });
        if (typeof this.formHeader === 'string' && this.formHeader !== '' && this._document) {
            this.formHeader = decodeString(this.formHeader);
        }
    }
    ngAfterViewInit() {
        FormContainerComponent.traverseAndStore({ currentIndex: 0 }, this.form.nativeElement);
    }
    decodeString(string) {
        const el = this._document.createElement('textarea');
        el.innerHTML = string;
        return el.value;
    }
    // #endregion
    // #region // ----------- Methods ---------- //
    static traverseAndStore(index, node) {
        if (node == null) {
            return;
        }
        if (['INPUT', 'SELECT', 'TEXTAREA', 'CITI-INPUT-GROUP'].indexOf(node.tagName) > -1) {
            const nType = node.type;
            if (nType != 'checkbox' && nType != 'radio') {
                if (node.tagName == 'CITI-INPUT-GROUP') {
                    node.querySelectorAll('input')[0].setAttribute('data-order-appearance', index.currentIndex);
                }
                else {
                    node.setAttribute('data-order-appearance', index.currentIndex);
                }
                index.currentIndex++;
            }
        }
        for (let i = 0; i < node.childNodes.length; i++) {
            FormContainerComponent.traverseAndStore(index, node.childNodes[i]);
        }
    }
    /**
     * @property firstErrorElement
     * @description First element has error in the list. The element sorted by the order of appearance on the form
     * @return string
     * @twoway false
     */
    get firstErrorElement() {
        if (this.errors.length > 0) {
            const orderArray = this.errors.map((item, index) => ({ index: index, value: item.getOrderAppearance() }));
            orderArray.sort((element1, element2) => {
                return element1.value - element2.value;
            });
            return this.errors[orderArray[0].index];
        }
        return null;
    }
    /**
     * @name validate
     * @description Validates the entire form by calling the validate function of the validation service
     * connected to the form container.
     * Returns a promise that will resolve as true if no errors are found, and false if errors are found.
     * @return Void
     */
    validate() {
        this._isErrorHidden = true;
        setTimeout(() => {
            this._isErrorHidden = false;
        }, 1);
        // Validate the form
        this.validationService.validate();
        // Return a promise
        return new Promise((resolve, reject) => {
            // If there are no errors
            if (!this.validationService.errors.length) {
                // Resolve as valid
                resolve(true);
            }
            else {
                // Otherwise resolve as invalid
                resolve(false);
            }
        });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: FormContainerComponent, deps: [{ token: ValidationService }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: FormContainerComponent, isStandalone: false, selector: "citi-form-container", inputs: { requiredText: "requiredText", pageError: "pageError", formHeader: "formHeader", formName: "formName", formAction: "formAction", formMethod: "formMethod", autocomplete: "autocomplete", htmlContent: "htmlContent", ariaLabelledby: "ariaLabelledby", headingLevel: "headingLevel", idStr: "idStr" }, providers: [ValidationService], viewQueries: [{ propertyName: "form", first: true, predicate: ["form"], descendants: true }], ngImport: i0, template: `
    <form [name]="formName" [action]="formAction" [id]="idStr" [attr.aria-labelledby]="formHeader ? idStr+'-legend' :  ariaLabelledby ? ariaLabelledby : null" [method]="formMethod" #form [attr.autocomplete]="autocomplete">
      <div [id]="idStr+'-legend'" class="form-header" *ngIf="formHeader" role="heading" [attr.aria-level]="headingLevel" [innerHtml]="formHeader"></div>
      <p *ngIf="requiredText" [innerHtml]="requiredText"></p>
      <div class="alert page-level-alert" role="alert" *ngIf="pageError && !_isErrorHidden">
        <div class="strong" [innerHtml]="pageError"></div>
      </div>
      <div [contentHtml]="htmlContent">
        <ng-content></ng-content>
      </div>

    </form>
  `, isInline: true, styles: [".page-level-alert.page-level-alert{display:block}.page-level-alert div{margin-left:14px}fieldset{margin:0}.form-header{font-size:2rem;line-height:3rem;margin:0 0 1px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: FormContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-form-container', standalone: false, providers: [ValidationService], template: `
    <form [name]="formName" [action]="formAction" [id]="idStr" [attr.aria-labelledby]="formHeader ? idStr+'-legend' :  ariaLabelledby ? ariaLabelledby : null" [method]="formMethod" #form [attr.autocomplete]="autocomplete">
      <div [id]="idStr+'-legend'" class="form-header" *ngIf="formHeader" role="heading" [attr.aria-level]="headingLevel" [innerHtml]="formHeader"></div>
      <p *ngIf="requiredText" [innerHtml]="requiredText"></p>
      <div class="alert page-level-alert" role="alert" *ngIf="pageError && !_isErrorHidden">
        <div class="strong" [innerHtml]="pageError"></div>
      </div>
      <div [contentHtml]="htmlContent">
        <ng-content></ng-content>
      </div>

    </form>
  `, styles: [".page-level-alert.page-level-alert{display:block}.page-level-alert div{margin-left:14px}fieldset{margin:0}.form-header{font-size:2rem;line-height:3rem;margin:0 0 1px}\n"] }]
        }], ctorParameters: () => [{ type: ValidationService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }], propDecorators: { form: [{
                type: ViewChild,
                args: ['form']
            }], requiredText: [{
                type: Input$1
            }], pageError: [{
                type: Input$1
            }], formHeader: [{
                type: Input$1
            }], formName: [{
                type: Input$1
            }], formAction: [{
                type: Input$1
            }], formMethod: [{
                type: Input$1
            }], autocomplete: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }], ariaLabelledby: [{
                type: Input$1
            }], headingLevel: [{
                type: Input$1
            }], idStr: [{
                type: Input$1
            }] } });

const COMPONENTS$E = [
    FormContainerComponent
];
const MODULES$H = [
    CommonModule,
    ContentHtml
];
class FormContainer {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: FormContainer, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: FormContainer, declarations: [FormContainerComponent], imports: [CommonModule,
            ContentHtml], exports: [FormContainerComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: FormContainer, imports: [MODULES$H] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: FormContainer, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$H],
                    declarations: [...COMPONENTS$E],
                    exports: [FormContainerComponent]
                }]
        }] });

const numericValidator = char => /[0-9]{1}/.test(char);
const nonZeroNumericValidator = char => /[1-9]{1}/.test(char);
const lowerCaseValidator = char => /[a-z]{1}/.test(char);
const upperCaseValidator = char => /[A-Z]{1}/.test(char);
const anyValidator = char => true;
const numberRangeValidator = (maxValue, char) => numericValidator(char) && parseInt(char, 10) <= maxValue;
const neverValidator = char => false;
const MASK_DIGIT_VALIDATORS = {
    'a': lowerCaseValidator,
    'A': upperCaseValidator,
    '#': anyValidator,
    'Ü': nonZeroNumericValidator
    // numeric validators are added via the for loop below
};
for (let i = 0; i <= 9; i++) {
    MASK_DIGIT_VALIDATORS[i] = numberRangeValidator.bind(undefined, i);
}
const SPECIAL_CHARACTERS = [' ', '/', '(', ')', '+', '\/', '-'];
const INDENTIFIERS = ['Alt', 'Control', 'Shift', 'AltGraph', 'Meta', 'CapsLock', 'NumLock', 'Scroll'];
const hiddenModifier = '•';
function overWriteCharAtPosition(input, position, key) {
    const currentValue = input.value;
    input.value = currentValue.slice(0, position) + key + currentValue.slice(position + 1);
}
class MaskDigit {
    constructor(index, value, isPlaceholder, hidden, validator) {
        this.index = index;
        this.value = value;
        this.isPlaceholder = isPlaceholder;
        this.hidden = hidden;
        this.validator = validator;
    }
}

const NumpadMap = {
    Numpad1: 1,
    Numpad2: 2,
    Numpad3: 3,
    Numpad4: 4,
    Numpad5: 5,
    Numpad6: 6,
    Numpad7: 7,
    Numpad8: 8,
    Numpad9: 9,
    Numpad0: 0,
};
class CustomInputMaskDirective {
    // @Input() preventPaste: boolean = false;
    set hideCharacters(hideCharacters) {
        this._hideCharacters = hideCharacters;
        if (this._unmaskedValue)
            this.initiateValue(this._unmaskedValue, 0);
        setTimeout(() => {
            const cursor = this.input.value.indexOf('_');
            this.setSelection(cursor, cursor);
        });
    }
    set mask(mask) {
        let maskArray = mask.split('');
        for (let index = 0; index < maskArray.length; index++) {
            const maskCharacter = maskArray[index];
            const isHidden = maskCharacter === hiddenModifier || maskCharacter === '*';
            const validatorIndex = isHidden ? index + 1 : index;
            const isPlacholder = SPECIAL_CHARACTERS.includes(maskArray[validatorIndex]);
            this.maskDigitMap[index] = new MaskDigit(index, isPlacholder ? maskArray[validatorIndex] : '_', isPlacholder, isHidden, this.getValidator(validatorIndex));
            if (isHidden)
                maskArray = maskArray.filter((char, i) => index !== i);
        }
        this.effectiveMask = maskArray.join('');
        this.buildPlaceHolder();
    }
    set unmaskedValue(value) {
        if (this._unmaskedValue === value)
            return;
        if (!value || value.length === 0)
            this.buildPlaceHolder();
        this._unmaskedValue = value;
        if (this.effectiveMask) {
            this.clearMaskdigitMap();
            this.buildPlaceHolder();
            this.initiateValue(this._unmaskedValue, this.input.value.indexOf('_'));
            this.getUnMaskedValue();
        }
    }
    constructor(el, liveAnnouncer, _document) {
        this.liveAnnouncer = liveAnnouncer;
        this._document = _document;
        // object holding all relevant data for a position in a mask
        this.maskDigitMap = {};
        // mask with hidden character identifiers removed
        this.effectiveMask = '';
        this._hideCharacters = true;
        this.unmaskedValueChange = new EventEmitter();
        this.input = el.nativeElement;
        this.specials = SPECIAL_CHARACTERS.slice(0);
        this.validators = Object.assign({}, MASK_DIGIT_VALIDATORS);
    }
    ngAfterViewInit() {
        if (!this._unmaskedValue)
            this.buildPlaceHolder();
    }
    blockPaste(e) {
        e.preventDefault();
        if (this.input.readOnly) {
            return;
        }
        this.liveAnnouncer.announce('cut, copy and paste are disabled due to formatting');
    }
    onSlectionChange(event) {
        event.preventDefault();
        this.setSelections();
        if (!this.rangeSelected())
            this.ensureValidPlacement();
    }
    onFocus(event) {
        event.preventDefault();
        this.setSelection(0, 0);
        this.ensureValidPlacement();
    }
    /*tslint:disable:triple-equals*/
    onSelect() {
        this.setSelections();
    }
    getindexOfDifference(prev, next) {
        const prevArr = prev.split('');
        const nextArr = next.split('');
        for (let i = 0; i < nextArr.length; i++) {
            if (prevArr[i] !== nextArr[i])
                return i;
        }
    }
    onKeyDown(event, keyCode) {
        if (keyCode == KEY_TAB || this.input.readOnly)
            return;
        this.valuestart = this.input.value;
        // Numpad keys
        const isNumpad = event.code && event.code.indexOf('Numpad') > -1;
        const char = isNumpad ? NumpadMap[event.code] : (event.key || event['char']);
        if (keyCode !== KEY_TAB || SPECIAL_CHARACTERS.includes(char))
            event.preventDefault();
        if (!this.effectiveMask || event.metaKey || event.ctrlKey || [...SPECIAL_CHARACTERS, ...INDENTIFIERS].includes(char))
            return;
        this.setSelections();
        if (this.rangeSelected() && !event.code.includes('hift'))
            this.cutSelection();
        else if (!isNumpad)
            switch (keyCode) {
                case KEY_ARROW_LEFT:
                    this.handleLeftArrow(this.cursorStart);
                    event.preventDefault();
                    return;
                case KEY_ARROW_RIGHT:
                    this.handleRightArrow(this.cursorStart);
                    event.preventDefault();
                    return;
                case BACKSPACE:
                    this.handleBackspace(this.cursorStart);
                    event.preventDefault();
                    return;
                case DELETE:
                    this.handleDelete(this.cursorStart);
                    event.preventDefault();
                    return;
            }
        const digitValidator = this.getValidator(this.cursorStart);
        if (digitValidator(char)) {
            if (this.rangeSelected())
                this.cutSelection();
            this.storeAndWriteCharacter(this.cursorStart, char);
        }
        // return the underlying value
        this.getUnMaskedValue();
    }
    // runs the unmaked value through the masking to set the initial masked state
    initiateValue(value, cursorPos) {
        if (!value || !value.length || value.length <= 0)
            return;
        const digitValidator = this.getValidator(cursorPos);
        const nextChar = value.charAt(0);
        // if char is valid for the mask
        if (digitValidator(nextChar)) {
            this.storeAndWriteCharacter(cursorPos, nextChar);
            // call recusively by chooping off the first character
            this.initiateValue(value.substr(1), ++cursorPos);
        }
        else {
            // skip placeholder spots
            this.handleRightArrow(cursorPos);
            // call recursively
            if (++cursorPos <= this.effectiveMask.length)
                this.initiateValue(value, cursorPos);
        }
    }
    storeAndWriteCharacter(cursorPos, char) {
        // store the underlying value
        this.maskDigitMap[cursorPos].value = char;
        // hide character if specified
        const shouldWrite = (this.maskDigitMap[cursorPos].hidden && this._hideCharacters) ? hiddenModifier : char;
        // write to input
        overWriteCharAtPosition(this.input, cursorPos, shouldWrite);
        // move cursor
        this.handleRightArrow(cursorPos);
    }
    setSelections() {
        this.cursorStart = this.input.selectionStart;
        this.cursorEnd = this.input.selectionEnd;
    }
    // moves the cursor to the next
    ensureValidPlacement() {
        this.setSelections();
        const cursor = this.cursorStart == this.effectiveMask.length
            ? 0 : this.cursorStart;
        const substringIndex = this.input.value
            .substring(cursor)
            .indexOf('_');
        const newPosition = substringIndex === -1
            ? this.firstWritableIndex()
            : cursor + substringIndex;
        this.setSelection(newPosition, newPosition);
    }
    firstWritableIndex() {
        let position = this.cursorStart;
        while (position < this.effectiveMask.length) {
            const digitValidator = this.getValidator(position);
            if (digitValidator(this.input.value.charAt(position)))
                return position;
            position++;
        }
        return this.effectiveMask.length;
    }
    isTypable(char) {
        return char !== '_' && this.cursorStart < this.effectiveMask.length;
    }
    // returns the digit validator at the given position
    getValidator(cursorPos) {
        return this.validators[this.effectiveMask.charAt(cursorPos)] || neverValidator;
    }
    handleBackspace(cursorPos) {
        // cut if range is selected
        if (this.rangeSelected())
            this.cutSelection();
        // otherwise just remove the previous cursor poistion
        else {
            const previousPos = this.calculatePreviousCursorPos(cursorPos);
            if (previousPos >= 0) {
                this.maskDigitMap[previousPos].value = '_';
                overWriteCharAtPosition(this.input, previousPos, '_');
                this.setSelection(previousPos, previousPos);
            }
        }
        this.getUnMaskedValue();
    }
    handleDelete(cursorPos) {
        // cut if range is selected
        if (this.rangeSelected())
            this.cutSelection();
        // otherwise just remove at the current cursor poistion
        else {
            this.maskDigitMap[cursorPos].value = '_';
            overWriteCharAtPosition(this.input, cursorPos, '_');
            this.setSelection(cursorPos, cursorPos);
        }
        this.getUnMaskedValue();
    }
    handleLeftArrow(cursorPos) {
        const previousPos = this.calculatePreviousCursorPos(cursorPos);
        if (previousPos >= 0)
            this.setSelection(previousPos, previousPos);
    }
    handleRightArrow(cursorPos) {
        const valueAfterCursor = this.input.value.slice(cursorPos + 1);
        const nextPos = valueAfterCursor.split('').findIndex(char => !SPECIAL_CHARACTERS.includes(char));
        if (nextPos >= 0) {
            const newCursorPos = cursorPos + nextPos + 1;
            this.setSelection(newCursorPos, newCursorPos);
        }
        else
            this.setSelection(this.input.value.length, this.input.value.length);
    }
    calculatePreviousCursorPos(cursorPos) {
        const valueBeforeCursor = this.input.value.slice(0, cursorPos);
        return findLastIndex(valueBeforeCursor, char => !SPECIAL_CHARACTERS.includes(char));
    }
    // build the placeholder i.e. (___) ___-____ for phone number
    buildPlaceHolder() {
        if (this.input)
            this.input.value = this.effectiveMask
                .split('')
                .reduce((result, char) => result += SPECIAL_CHARACTERS.includes(char) ? char : '_', '');
    }
    getUnMaskedValue() {
        let unmasked = '';
        let currIndex = 0;
        while (this.maskDigitMap[currIndex]) {
            const digit = this.maskDigitMap[currIndex];
            if (!digit.isPlaceholder && digit.value !== '_')
                unmasked += digit.value;
            currIndex++;
        }
        this._unmaskedValue = unmasked;
        this.unmaskedValueChange.emit(unmasked);
    }
    rangeSelected() {
        return this.cursorStart !== this.cursorEnd;
    }
    cutSelection() {
        // split the input value
        const currentValue = this.input.value.split('');
        // replace cursor selected characters that are not placeholders
        currentValue.forEach((char, index) => {
            if (this.shouldCut(index)) {
                this.maskDigitMap[index].value = currentValue[index] = '_';
            }
        });
        // rebuild the string for the input
        this.input.value = currentValue.join('');
        // reset the cursor position
        this.setSelection(this.cursorStart, this.cursorStart);
        this.ensureValidPlacement();
    }
    // whether or not a character should be replaced is a cursor range is selected
    shouldCut(index) {
        const modifiable = !!this.maskDigitMap[index] && !this.maskDigitMap[index].isPlaceholder;
        return (index >= this.cursorStart) && (index < this.cursorEnd) && modifiable;
    }
    showHiddenValues() {
        const digits = values(this.maskDigitMap);
        const hiddenDigits = digits.filter(digit => digit.value === hiddenModifier);
        hiddenDigits.forEach(digit => overWriteCharAtPosition(this.input, digit.index, digit.value));
    }
    hideValues() {
        const digits = values(this.maskDigitMap);
        const hiddenDigits = digits.filter(digit => digit.hidden);
        hiddenDigits.forEach(digit => overWriteCharAtPosition(this.input, digit.index, hiddenModifier));
    }
    addSpecial(char) {
        this.specials.push(char);
    }
    removeSpecial(char) {
        this.specials = this.specials.filter(specChar => char != specChar);
    }
    addValidator(char, validator) {
        this.validators[char] = validator;
    }
    removeValidator(char) {
        delete this.validators[char];
    }
    rebuild() {
        this.buildPlaceHolder();
    }
    clearMaskdigitMap() {
        let i = 0;
        while (!!this.maskDigitMap[i]) {
            this.maskDigitMap[i].value = '_';
            i++;
        }
    }
    setSelection(start, end) {
        if (this._document.activeElement === this.input)
            this.input.setSelectionRange(start, end || start);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CustomInputMaskDirective, deps: [{ token: i0.ElementRef }, { token: CitiLiveAnnouncer }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.5", type: CustomInputMaskDirective, isStandalone: false, selector: "[custom-mask]", inputs: { hideCharacters: "hideCharacters", mask: ["custom-mask", "mask"], unmaskedValue: "unmaskedValue" }, outputs: { unmaskedValueChange: "unmaskedValueChange" }, host: { attributes: { "autocapitalize": "none" }, listeners: { "cut": "blockPaste($event)", "paste": "blockPaste($event)", "click": "onSlectionChange($event)", "focus": "onFocus($event)", "select": "onSelect()", "keydown": "onKeyDown($event,$event.keyCode)" } }, exportAs: ["custom"], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CustomInputMaskDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[custom-mask]',
                    standalone: false,
                    exportAs: 'custom',
                    host: { 'autocapitalize': 'none' }
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: CitiLiveAnnouncer }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }], propDecorators: { hideCharacters: [{
                type: Input$1
            }], mask: [{
                type: Input$1,
                args: ['custom-mask']
            }], unmaskedValue: [{
                type: Input$1
            }], unmaskedValueChange: [{
                type: Output
            }], blockPaste: [{
                type: HostListener,
                args: ['cut', ['$event']]
            }, {
                type: HostListener,
                args: ['paste', ['$event']]
            }], onSlectionChange: [{
                type: HostListener,
                args: ['click', ['$event']]
            }], onFocus: [{
                type: HostListener,
                args: ['focus', ['$event']]
            }], onSelect: [{
                type: HostListener,
                args: ['select']
            }], onKeyDown: [{
                type: HostListener,
                args: ['keydown', ['$event', '$event.keyCode']]
            }] } });

/*tslint:disable:triple-equals*/
/*tslint:disable:no-input-rename*/
/*tslint:disable:directive-selector*/
class CurrencyInputMaskDirective {
    set unmaskedValue(value) {
        value = parseFloat(value);
        if (Number.isNaN(value)) {
            this._unmaskedValue = undefined;
            this.input.value = null;
            this.unmaskedValueChange.emit(this._unmaskedValue);
        }
        else if (this._unmaskedValue !== value)
            this.reCalculate(value.toString());
    }
    // #region - Life Cycle
    constructor(el, announcer, ngZone) {
        this.el = el;
        this.announcer = announcer;
        this.ngZone = ngZone;
        this.unmaskedValueChange = new EventEmitter();
        this.thousandsSeparator = ',';
        this.decimalSeparator = '.';
        // number of decimal places
        this.precision = 2;
        this.preventPaste = false;
        this.input = this.el.nativeElement;
    }
    ngOnInit() {
        this.allThousands = new RegExp(`${this.thousandsSeparator}`, 'g');
    }
    ngAfterViewInit() {
        // provide the initial value
        if (!this.input.value && !this._unmaskedValue)
            return;
        else if (this._unmaskedValue !== undefined)
            this.reCalculate(this._unmaskedValue.toString());
    }
    // #region - Host Listeners
    onPaste(e) {
        e.preventDefault();
        if (this.input.readOnly) {
            return;
        }
        if (this.preventPaste) {
            this.announcer.announce('paste is disabled');
            return;
        }
        // upfront work for storing the cursor positoin
        this.storeCountOfDigitsBeforeCursor();
        // chop it up
        const beforePaste = this.input.value.slice(0, this.input.selectionStart);
        const afterPaste = this.input.value.slice(this.input.selectionStart + Math.abs(this.input.selectionStart - this.input.selectionEnd));
        const pastedText = (beforePaste + afterPaste).indexOf(this.decimalSeparator) === -1
            ? e.clipboardData.getData('Text').replace(/[^0-9.]/g, '')
            : e.clipboardData.getData('Text').replace(/\D/g, '');
        this.digitsBefore += pastedText.length;
        // slice it together
        const newVal = `${beforePaste}${pastedText}${afterPaste}`;
        // update the value
        this.reCalculate(this.getUnMaskedValue(newVal).toString());
        // fix cursor
        this.reCalcCursor();
    }
    onCut() {
        if (this.input.readOnly) {
            return;
        }
        this.storeCountOfDigitsBeforeCursor();
        setTimeout(() => {
            const unmaksked = this.getUnMaskedValue(this.input.value).toString();
            this.reCalculate(unmaksked);
            const offset = this.wholeIsZeroish(unmaksked) ? 1 : 0;
            this.reCalcCursor(offset);
        });
    }
    onSelectionChange(event) {
        this.storeCountOfDigitsBeforeCursor();
        if (!this.rangeSelected())
            this.reCalcCursor();
    }
    onSelect(event) {
        this.storeCountOfDigitsBeforeCursor();
    }
    onKeyDown(event, keyCode) {
        if (this.input.readOnly) {
            return;
        }
        this.storeCountOfDigitsBeforeCursor();
        if (event.shiftKey) {
            if (keyCode !== KEY_TAB)
                event.preventDefault();
            switch (keyCode) {
                case KEY_ARROW_LEFT:
                    this.handleShiftSelectLeft(event);
                    return;
                case KEY_ARROW_RIGHT:
                    this.handleShiftSelectRight(event);
                    return;
            }
        }
        switch (keyCode) {
            case KEY_ARROW_LEFT:
                this.handleLeftArrow(this.input.selectionStart);
                event.preventDefault();
                return;
            case KEY_ARROW_RIGHT:
                this.handleRightArrow(this.input.selectionEnd);
                event.preventDefault();
                return;
            case BACKSPACE:
                this.handleBackspaceDelete(this.input.selectionStart);
                event.preventDefault();
                return;
            case DELETE:
                this.handleBackspaceDelete(this.input.selectionStart, true);
                event.preventDefault();
                return;
        }
    }
    onKeyPress(event, keyCode) {
        if (this.input.readOnly) {
            return;
        }
        if (event.metaKey || event.ctrlKey || keyCode == KEY_TAB)
            return;
        event.preventDefault();
        const cursorPosition = this.input.selectionStart;
        const char = event.key || event['char'];
        if (cursorPosition == 0 && char == '0') {
            this.input.value = '0';
            this.unmaskedValueChange.emit(0);
            this.input.setSelectionRange(1, 1);
            return;
        }
        ;
        this.storeCountOfDigitsBeforeCursor(); // upfront work for new cursor position
        if (this.rangeSelected())
            this.cutSelection(false, char);
        else if (char === this.decimalSeparator && this.precision > 0)
            this.addDecimal();
        else if (numericValidator(char))
            this.handleNumericCharacter(char, cursorPosition);
    }
    // #region - Helper Methods
    // https://www.w3schools.com/tags/tryit.asp?filename=tryhtml_input_maxlength
    // max length still announces the digit, but doesn't inform of maxlength
    shouldEnforceMaxFactor(charAdded) {
        if (!this.maxFactor)
            return false; // efficiency exit
        const whole = charAdded.split(this.decimalSeparator)[0].split('').filter(char => char !== this.thousandsSeparator);
        if (whole.length > this.maxFactor) {
            this.announcer.announce(this.maxFactorExceededMessage);
            return true;
        }
        else
            return false;
    }
    // whether or not the cursor selection is a range of characters
    rangeSelected() {
        return this.input.selectionStart !== this.input.selectionEnd;
    }
    // does the string have a decimal
    hasDecimal(value) {
        return value.indexOf(this.decimalSeparator) > -1;
    }
    // breaks a numeric string into its whole and decimal parts
    getParts(value) {
        const decimalSplit = value.split(this.decimalSeparator);
        return {
            whole: decimalSplit[0],
            decimal: decimalSplit[1]
        };
    }
    wholeIsZeroish(value) {
        const whole = this.getParts(value).whole;
        return whole === '0' || whole == '';
    }
    // whether or not a decimal should be added
    shouldAddDecimalSeperator() {
        return this.input.value.indexOf(this.decimalSeparator) !== -1
            && this.precision > 0;
    }
    // #region - Input Value Methods
    handleNumericCharacter(key, cursorPosition) {
        const charAdded = insertCharAt(this.input.value, key, cursorPosition);
        const offset = (this.input.value.charAt(0) === '0' && cursorPosition < 2) ? 0 : 1;
        if (this.shouldEnforceMaxFactor(charAdded))
            return;
        this.reCalculate(charAdded);
        // protects against infinite while loop while calculating the cursor position
        this.reCalcCursor(offset);
    }
    // applies the mask to the string
    reCalculate(value) {
        this.hasDecimal(value) ? this.addDigitWithDecimal(value) : this.addDigitNoDecimal(value);
    }
    // handle the undefined value state
    clear() {
        this.input.value = '';
        this.unmaskedValueChange.emit(undefined);
        this._unmaskedValue = undefined;
    }
    // adds a digit when no decimal is present
    addDigitNoDecimal(charAdded) {
        if (charAdded !== '') {
            this.input.value = this.maskWholeNumber(charAdded);
            this._unmaskedValue = this.getUnMaskedValue(this.input.value);
            this.unmaskedValueChange.emit(this._unmaskedValue);
        }
        else
            this.clear();
    }
    // adds a digit when a decial is present
    addDigitWithDecimal(value) {
        const parts = this.getParts(value);
        const decimal = this.maskDecimal(parts.decimal);
        // update the input
        this.input.value = `${this.maskWholeNumber(parts.whole)}${this.decimalSeparator}${decimal}`;
        // catch values less than 0
        const whole = parts.whole ? this.getUnMaskedValue(parts.whole) : '0';
        // get the new value
        this._unmaskedValue = parseFloat(`${whole}.${decimal}`);
        this.unmaskedValueChange.emit(this._unmaskedValue);
    }
    // adds the decimal character
    addDecimal() {
        // ignore duplicate decimals
        if (this.shouldAddDecimalSeperator())
            return;
        let newCursorPostion = 1;
        if (this.input.value.length === 0) {
            this.input.value = '0';
            newCursorPostion++;
        }
        // add the decimal seperator
        const newValue = insertCharAt(this.input.value, this.decimalSeparator, this.input.selectionStart).replace(this.allThousands, '');
        this.addDigitWithDecimal(newValue);
        newCursorPostion += this.input.value.indexOf(this.decimalSeparator);
        this.input.setSelectionRange(newCursorPostion, newCursorPostion);
    }
    handleBackspaceDelete(cursorPos, isDelete = false) {
        if (this.rangeSelected())
            this.cutSelection();
        else {
            const position = isDelete ? cursorPos : this.calculatePreviousCursorPos(cursorPos);
            if (position >= 0 && position < this.input.value.length) {
                const newValue = removeCharAt(this.input.value, position);
                if (newValue === '')
                    this.clear();
                this.reCalculate(newValue);
                this.reCalcCursor(isDelete ? 0 : -1); // backspace = -1
            }
        }
    }
    cutSelection(moveCursorToEnd = false, replaceWith = '') {
        // cut out the unwanted digits
        const spliceLength = Math.abs(this.input.selectionStart - this.input.selectionEnd);
        const beforePaste = this.input.value.slice(0, this.input.selectionStart);
        const afterPaste = this.input.value.slice(this.input.selectionStart + spliceLength);
        if (!numericValidator(replaceWith) && replaceWith !== this.decimalSeparator) {
            replaceWith = '';
            this.digitsBefore--;
        }
        // strip masking
        const newValue = `${beforePaste}${replaceWith}${afterPaste}`.replace(this.allThousands, '');
        let offset = (beforePaste.indexOf('.') > -1) ? 2 : 1;
        if (this.wholeIsZeroish(newValue))
            offset++;
        this.reCalculate(newValue);
        this.reCalcCursor(offset);
    }
    // #region - String Manipulation Methods
    // ruturns the dollar masked value of the whole number part of a value
    maskWholeNumber(wholeNumber) {
        if (!wholeNumber || wholeNumber === '0')
            return '0';
        // remove zeros at the beginnin if not right before the decimal.. only if length of whole number is greater then 1
        while (wholeNumber.charAt(0) === '0' && wholeNumber.length > 1)
            wholeNumber = wholeNumber.substr(1);
        // convert to string and remove thousands seperators
        wholeNumber = (wholeNumber + '').replace(this.allThousands, '');
        // add thousands separators in the correct positions
        return wholeNumber.length > 3 ? reverseString(reverseString(wholeNumber).match(/.{1,3}/g).join(this.thousandsSeparator)) : wholeNumber;
    }
    // only allow decimals up to the specified precision
    maskDecimal(decimal) {
        return (decimal + '').substring(0, this.precision);
    }
    getUnMaskedValue(value) {
        const newVal = parseFloat(value.split('').filter(char => char !== this.thousandsSeparator).join(''));
        return Number.isNaN(newVal) ? 0 : newVal;
    }
    // #region - Cursor Methods
    // handles range selection via shift key
    handleShiftSelectRight(event) {
        const end = event.ctrlKey
            ? this.input.value.length + 1
            : Math.min(this.input.selectionEnd + 1, this.input.value.length);
        executeOnStable(this.ngZone, () => this.input.setSelectionRange(this.input.selectionStart, end));
    }
    handleShiftSelectLeft(event) {
        const start = event.ctrlKey ? 0 : Math.max(this.input.selectionStart - 1, 0);
        executeOnStable(this.ngZone, () => this.input.setSelectionRange(start, this.input.selectionEnd));
    }
    // determines the next appropriate spot for the currsor - offset = -1 for backspace
    // at event start call storeCountOfDigitsBeforeCursor() to prepare for this method
    reCalcCursor(offSet = 0) {
        let newPosition = 0;
        // iterate through the string to find the next spot
        while (this.digitsBefore + offSet > 0) {
            const char = this.input.value.charAt(newPosition);
            if (numericValidator(char) || char === this.decimalSeparator)
                this.digitsBefore--;
            newPosition++;
            if (newPosition > this.input.value.length)
                break;
        }
        //skip it if it's a thousands seperator
        const nextChar = this.input.value.charAt(newPosition);
        newPosition = (nextChar === this.thousandsSeparator)
            ? newPosition + 1
            : newPosition;
        // never put the cursor pefore a leading 0
        if (newPosition == 0 && this.input.value.charAt(newPosition) === '0')
            newPosition++;
        // set the cursoposition
        this.input.setSelectionRange(newPosition, newPosition);
    }
    // stores the current indexes of the cursor selection
    // at the end of the input update call reCalcCursor()
    storeCountOfDigitsBeforeCursor() {
        // returns the number of numbers ( plus decimal ) to aid in recalculating the next cursor position
        const subString = this.input.value.substr(0, this.input.selectionStart);
        this.digitsBefore = subString.replace(/\D/g, '').length;
        if (subString.indexOf('.') !== -1)
            this.digitsBefore++;
    }
    handleLeftArrow(cursorPos) {
        if (!this.rangeSelected()) {
            let previousPos = this.calculatePreviousCursorPos(cursorPos);
            // never put the cursor pefore a leading 0
            if (previousPos == 0 && this.input.value.charAt(previousPos) === '0')
                previousPos++;
            // never go out of range
            if (previousPos >= 0)
                this.input.setSelectionRange(previousPos, previousPos);
        }
        else
            this.input.setSelectionRange(this.input.selectionStart, this.input.selectionStart);
    }
    calculatePreviousCursorPos(cursorPos) {
        const valueBeforeCursor = this.input.value.slice(0, cursorPos);
        return findLastIndex(valueBeforeCursor, char => numericValidator(char) || char === this.decimalSeparator);
    }
    handleRightArrow(cursorPos) {
        if (!this.rangeSelected()) {
            const valueAfterCursor = this.input.value.slice(cursorPos);
            const nextPos = valueAfterCursor.split('').findIndex(char => numericValidator(char) || char === this.decimalSeparator);
            if (nextPos >= 0) {
                const newCursorPos = cursorPos + nextPos + 1;
                this.input.setSelectionRange(newCursorPos, newCursorPos);
            }
        }
        else
            this.input.setSelectionRange(this.input.selectionEnd, this.input.selectionEnd);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CurrencyInputMaskDirective, deps: [{ token: i0.ElementRef }, { token: CitiLiveAnnouncer }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.5", type: CurrencyInputMaskDirective, isStandalone: false, selector: "[currency-mask]", inputs: { unmaskedValue: "unmaskedValue", thousandsSeparator: "thousandsSeparator", decimalSeparator: "decimalSeparator", precision: "precision", maxFactor: "maxFactor", maxFactorExceededMessage: "maxFactorExceededMessage", preventPaste: "preventPaste" }, outputs: { unmaskedValueChange: "unmaskedValueChange" }, host: { attributes: { "autocapitalize": "none" }, listeners: { "onpaste": "onPaste($event)", "paste": "onPaste($event)", "cut": "onCut()", "click": "onSelectionChange($event)", "select": "onSelect($event)", "keydown": "onKeyDown($event,$event.keyCode)", "keypress": "onKeyPress($event,$event.keyCode)" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CurrencyInputMaskDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[currency-mask]',
                    standalone: false,
                    host: { 'autocapitalize': 'none' }
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: CitiLiveAnnouncer }, { type: i0.NgZone }], propDecorators: { unmaskedValue: [{
                type: Input$1
            }], unmaskedValueChange: [{
                type: Output
            }], thousandsSeparator: [{
                type: Input$1
            }], decimalSeparator: [{
                type: Input$1
            }], precision: [{
                type: Input$1
            }], maxFactor: [{
                type: Input$1
            }], maxFactorExceededMessage: [{
                type: Input$1
            }], preventPaste: [{
                type: Input$1
            }], onPaste: [{
                type: HostListener,
                args: ['onpaste', ['$event']]
            }, {
                type: HostListener,
                args: ['paste', ['$event']]
            }], onCut: [{
                type: HostListener,
                args: ['cut']
            }], onSelectionChange: [{
                type: HostListener,
                args: ['click', ['$event']]
            }], onSelect: [{
                type: HostListener,
                args: ['select', ['$event']]
            }], onKeyDown: [{
                type: HostListener,
                args: ['keydown', ['$event', '$event.keyCode']]
            }], onKeyPress: [{
                type: HostListener,
                args: ['keypress', ['$event', '$event.keyCode']]
            }] } });

class PartialInputMaskDirective {
    set hideCharacters(hideCharacters) {
        this._hideCharacters = hideCharacters;
        if (!!this._unmaskedValue && !!this._unmaskedValue.length && this._unmaskedValue.length > 0)
            this.applyMask(this._unmaskedValue);
    }
    set mask(mask) {
        switch (mask) {
            case 'partialEmailMasking':
                this.setPartialEmailMasking();
                break;
            case 'fullTextMasking':
                this.setFullTextMasking();
                break;
            case 'partialTextMasking':
                this.setPartialTextMasking();
                break;
        }
    }
    set unmaskedValue(value) {
        if (this._unmaskedValue !== value) {
            this._unmaskedValue = value;
            this.initiateValue(this._unmaskedValue);
        }
    }
    // #region - Life Cycle
    constructor(el, announcer) {
        this.announcer = announcer;
        // whether or not the whole field is selected
        this.fullFieldSelected = false;
        this.selectAdjustment = false;
        this.unmaskedLength = 4;
        this.numbersOnly = false;
        this.preventPaste = false;
        this._hideCharacters = true;
        this.unmaskedValueChange = new EventEmitter();
        this.input = el.nativeElement;
    }
    ngOnInit() {
        // this.initiateValue(this._unmaskedValue);
    }
    ngAfterViewInit() {
        // provide the initial value
        this.initiateValue(this._unmaskedValue);
    }
    // #region - Host Listeners
    onSlectionChange(event) {
        event.preventDefault();
    }
    handlePaste(e) {
        e.preventDefault();
        if (this.input.readOnly) {
            return;
        }
        if (this.preventPaste) {
            this.announcer.announce('paste is disabled');
            return;
        }
        this.setSelections();
        if (this.rangeSelected())
            this.cutSelection();
        const clip = e.clipboardData.getData('Text');
        const newValue = insertCharAt(this._unmaskedValue, clip, this.input.selectionStart);
        this.applyMask(newValue);
        const newPos = this.cursorStart + clip.length;
        this.input.setSelectionRange(newPos, newPos);
    }
    handleCut(e) {
        e.preventDefault();
        if (this.input.readOnly) {
            return;
        }
        this.setSelections();
        if (this.rangeSelected()) {
            const clipboard = this.cutSelection();
            e.clipboardData.setData('text/plain', clipboard);
        }
    }
    onKeyDown(event, keyCode) {
        if (this.input.readOnly) {
            return;
        }
        this.setSelections();
        if (event.metaKey || event.ctrlKey)
            return;
        switch (keyCode) {
            case BACKSPACE:
                this.handleBackspace(this.cursorStart);
                event.preventDefault();
                return;
            case DELETE:
                this.handleDelete(this.cursorStart);
                event.preventDefault();
                return;
        }
    }
    onKeyPress(event, keyCode) {
        if (event.metaKey || event.ctrlKey
            || this.input.readOnly
            || keyCode == KEY_TAB
            || [0, 8, 13, 27, 20].includes(event.which))
            return;
        event.preventDefault();
        if (this.rangeSelected())
            this.cutSelection();
        if ((this.numbersOnly && (event.which > 57 || event.which < 48))
            || this.input.value.length >= this.maxLength)
            return;
        this.addCharacter(String.fromCharCode(event.charCode));
    }
    addCharacter(char) {
        const cursorPos = this.input.selectionStart;
        this._unmaskedValue = insertCharAt(this._unmaskedValue, char, cursorPos);
        this.applyMask(this._unmaskedValue);
        this.input.setSelectionRange(cursorPos + 1, cursorPos + 1);
    }
    // #region - Methods
    // runs the unmaked value through the masking to set the initial masked state
    initiateValue(value) {
        if (!!value && !!value.length && value.length > 0) {
            this._unmaskedValue = value;
            this.applyMask(this._unmaskedValue);
        }
        else {
            this.input.value = '';
            this.unmaskedValueChange.emit('');
        }
        ;
    }
    rangeSelected() {
        return this.cursorStart !== this.cursorEnd;
    }
    setSelections() {
        this.cursorStart = this.input.selectionStart;
        this.cursorEnd = this.input.selectionEnd;
    }
    applyMask(value) {
        this._unmaskedValue = value;
        this.unmaskedValueChange.emit(value);
        // calculate when the hidden characters stop
        if (this._hideCharacters && value) {
            const stopMasking = (!!this.maskEndChartacter) ? value.indexOf(this.maskEndChartacter) - 1 : value.length - this.unmaskedLength;
            // apply to input
            this.input.value = value.split('').map((char, index) => (index >= this.maskStartPosition && index < stopMasking) ? '•' : char).join('');
        }
        else
            this.input.value = this._unmaskedValue;
    }
    handleBackspace(cursorPos) {
        if (this.rangeSelected()) {
            this.cutSelection();
            return;
        }
        if (cursorPos < 0)
            return;
        const newValue = removeCharAt(this._unmaskedValue, cursorPos - 1);
        this.applyMask(newValue);
        const newPostion = Math.max(cursorPos - 1, 0);
        this.input.setSelectionRange(newPostion, newPostion);
    }
    handleDelete(cursorPos) {
        if (this.rangeSelected()) {
            this.cutSelection();
            return;
        }
        if (cursorPos >= this._unmaskedValue.length)
            return;
        const newValue = removeCharAt(this._unmaskedValue, cursorPos);
        this.applyMask(newValue);
        const newPostion = Math.min(cursorPos, newValue.length);
        this.input.setSelectionRange(cursorPos, cursorPos);
    }
    cutSelection() {
        // split the input value
        const arrayString = this._unmaskedValue.split('');
        const clipboard = arrayString.splice(this.cursorStart, Math.abs(this.cursorStart - this.cursorEnd));
        this.applyMask(arrayString.join(''));
        this.input.setSelectionRange(this.cursorStart, this.cursorStart);
        return clipboard.join('');
    }
    setPartialEmailMasking() {
        this.maskStartPosition = 1;
        this.maskEndChartacter = '@';
        this.unmaskedLength = undefined;
    }
    setFullTextMasking() {
        this.maskStartPosition = 0;
        this.unmaskedLength = 0;
    }
    setPartialTextMasking() {
        this.maskStartPosition = 0;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: PartialInputMaskDirective, deps: [{ token: i0.ElementRef }, { token: CitiLiveAnnouncer }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.5", type: PartialInputMaskDirective, isStandalone: false, selector: "[partial-mask]", inputs: { maxLength: "maxLength", unmaskedLength: "unmaskedLength", numbersOnly: "numbersOnly", preventPaste: "preventPaste", hideCharacters: "hideCharacters", mask: ["partial-mask", "mask"], unmaskedValue: "unmaskedValue" }, outputs: { unmaskedValueChange: "unmaskedValueChange" }, host: { attributes: { "autocapitalize": "none" }, listeners: { "click": "onSlectionChange($event)", "paste": "handlePaste($event)", "cut": "handleCut($event)", "keydown": "onKeyDown($event,$event.keyCode)", "keypress": "onKeyPress($event,$event.keyCode)" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: PartialInputMaskDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[partial-mask]',
                    standalone: false,
                    host: { 'autocapitalize': 'none' }
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: CitiLiveAnnouncer }], propDecorators: { maxLength: [{
                type: Input$1
            }], unmaskedLength: [{
                type: Input$1
            }], numbersOnly: [{
                type: Input$1
            }], preventPaste: [{
                type: Input$1
            }], hideCharacters: [{
                type: Input$1
            }], mask: [{
                type: Input$1,
                args: ['partial-mask']
            }], unmaskedValue: [{
                type: Input$1
            }], unmaskedValueChange: [{
                type: Output
            }], onSlectionChange: [{
                type: HostListener,
                args: ['click', ['$event']]
            }], handlePaste: [{
                type: HostListener,
                args: ['paste', ['$event']]
            }], handleCut: [{
                type: HostListener,
                args: ['cut', ['$event']]
            }], onKeyDown: [{
                type: HostListener,
                args: ['keydown', ['$event', '$event.keyCode']]
            }], onKeyPress: [{
                type: HostListener,
                args: ['keypress', ['$event', '$event.keyCode']]
            }] } });

// @dynamic
let nextUniqueId$8 = 0;
const DEFAULT_ERRORS$1 = {
    required: 'Input is required',
    positive: 'Value must be positive',
    integer: 'Value must be an integer',
    phone: 'Invalid phone number',
    nonZero: 'value cannot be zero',
    email: 'Invalid email',
    zip: 'Invalid Zip Code',
    ssn: 'Invalid social security number',
    areaCode: 'Please select an area code',
    countryCode: 'Please select a country code'
};
const INPUT2_VALUE_ACCESSOR$1 = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => Input2Component),
    multi: true
};
// @dynamic
class Input2Component {
    // #region - Properties: Static
    static { this.DEFAULT_MAXLENGTH = 524288; }
    static { this.VALIDATORS = {
        isEmail: (val) => /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(val),
        isNumber: (val) => !isNaN(val),
        isPositive: (val) => !isNaN(val) && parseFloat(val) > 0,
        isValue: (val) => !!val && val !== ''
    }; }
    static { this.VALID_TYPES = [
        'text',
        'password',
        'email',
        'number',
        'tel',
        'phone',
        'ssn',
        'zip'
    ]; }
    static { this.DEFAULT_MASKS = {
        phone: '(999) 999-9999',
        zipcode: '99999',
        ssn: '999-99-9999',
        partialSsnMasking: '*9*9*9-*9*9-9999',
        fullSsnMasking: '*9*9*9-*9*9-*9*9*9*9',
        partialPhoneMasking: '(*9*9*9)-*9*9*9-9999',
        fullZipcodeMasking: '*9*9*9*9*9',
        fullPhoneMasking: '(*9*9*9) *9*9*9-*9*9*9*9',
        creditCard: '9999 9999 9999 9999'
    }; }
    // Classes for the sizes of input, also applied to the wrapper
    static { this.SIZE_CLASSES = {
        fullwidth: 'col-xs-12',
        large: 'col-md-8 col-lg-8',
        medium: 'col-md-6 col-sm-9',
        small: 'col-md-4 col-sm-6',
        xsmall: 'col-md-2 col-sm-3 col-xs-6',
        none: ''
    }; }
    get idStr() { return this._id; }
    set idStr(value) { this._id = value || this._uid; }
    // #endregion
    // #region - Two-way Bound values
    get hideMask() {
        return this.hideCharacters;
    }
    set hideMask(value) {
        this.hideCharacters = value;
    }
    /**
     * This focuses the input if set to true
     */
    set focus(isFocused) {
        isFocused ? this.onFocus() : this.onBlur();
    }
    ;
    // #endregion
    // #region - Setters
    /**
     * Text to be displayed when the input doesn't meet the required length
     */
    set minLengthError(message) {
        if (message)
            this.errors.minLength = message;
    }
    /**
     * Text to be displayed when the value exceed the provided maximum
     */
    set maxValueError(message) {
        if (message)
            this.errors.maxValue = message;
    }
    /**
     * Text to be displayed when the value exceed the provided maximum
     */
    set minValueError(message) {
        if (message)
            this.errors.minValue = message;
    }
    /**
     * Text to be displayed when the input exceed the maximum length
     */
    set maxLengthError(message) {
        if (message)
            this.errors.maxLength = message;
    }
    /**
     * Text to be displayed when the input is required and no value was entered
     */
    set requiredError(message) {
        this.errors.required = (!!message) ? message : DEFAULT_ERRORS$1.required;
    }
    /**
     * Text to be displayed when the value fails non-zero validation
     */
    set messageOnlyNonZeroError(message) {
        this.errors.nonZero = (!!message) ? message : DEFAULT_ERRORS$1.nonZero;
    }
    /**
     * Text to be displayed when the value fails only integer validation
     */
    set messageOnlyIntegerError(message) {
        this.errors.integer = (!!message) ? message : DEFAULT_ERRORS$1.integer;
    }
    /**
     * Text to be displayed when the value fails only positive integer validation
     */
    set messageOnlyPositiveIntegerError(message) {
        this.errors.positive = (!!message) ? message : DEFAULT_ERRORS$1.positive;
    }
    /**
     * Text to be displayed when no phone is provided
     */
    set messageOnlyPhoneError(message) {
        this.errors.phone = (!!message) ? message : DEFAULT_ERRORS$1.phone;
    }
    /**
     * Text to be displayed when no zipcode is provided
     */
    set messageOnlyZipcodeError(message) {
        this.errors.zipcode = (!!message) ? message : DEFAULT_ERRORS$1.zip;
    }
    /**
     * Text to be displayed when no email is provided
     */
    set messageOnlyEmailError(message) {
        this.errors.email = (!!message) ? message : DEFAULT_ERRORS$1.email;
    }
    /**
     * Text to be displayed when no zip is provided
     */
    set messageOnlyZipError(message) {
        this.errors.zip = (!!message) ? message : DEFAULT_ERRORS$1.zip;
    }
    /**
     * Text to be displayed when no SSN is provided
     */
    set messageOnlySsnError(message) {
        this.errors.ssn = (!!message) ? message : DEFAULT_ERRORS$1.ssn;
    }
    /**
     * Text to be displayed when no areaCode is provided
     */
    set messageOnlyAreaCodeError(message) {
        this.errors.areaCode = (!!message) ? message : DEFAULT_ERRORS$1.areaCode;
    }
    /**
     * Text to be displayed when no countryCode is provided
     */
    set messageOnlyCountryCodeError(message) {
        this.errors.countryCode = (!!message) ? message : DEFAULT_ERRORS$1.countryCode;
    }
    /**
     * allows users to customize any of the error messages
     */
    set changeMessage([errorType, msg]) {
        if (errorType && msg)
            this.errors[errorType] = msg;
    }
    set hasCustomError(useCustom) {
        this._hasCustomError = coerceBool(useCustom);
        if (this.error) {
            if (this._hasCustomError)
                this.errorMessage = this.errors.custom;
            else
                this.validate();
        }
    }
    /**
     * Customized error message for custom error
     * @Note: *this field need to be above the error setter to trigger initial error correctly
     */
    set customErrorMessage(message) {
        this.errors.custom = (!!message) ? message : 'Your Custom Error Message';
        if (this.error && this._hasCustomError)
            this.errorMessage = this.errors.custom;
    }
    set error(err) {
        if (err === this._error)
            return;
        if (err) {
            this.validationService.addError(this);
            this.errorMessage = this.errors['custom'] || 'Default Error. You should provide your own customErrorMessage';
            this.announcer.announce(this.errorMessage);
        }
        this._error = err;
    }
    get error() {
        return this._error;
    }
    /**
     * Masking does not work on Android. This setting will set the input type to password on Android.
     */
    set usePasswordOnAndroid(usePass) {
        this._usePassOnAndroid = usePass;
        if (this.isAndroidDevice && usePass) {
            this.inputType = 'password';
        }
        else {
            this.inputType = this._inputType;
        }
    }
    ;
    get usePasswordOnAndroid() {
        return this._usePassOnAndroid;
    }
    /**
     * This defines the mask of the input, which changes the input text masking on character input.
     *  - 'fullZipcodeMasking'
     *  - 'fullPhoneMasking'
     *  - 'partialEmailMasking'
     *  - 'fullTextMasking'
     *  - 'partialTextMasking'
     * @defaults 'none'
     */
    set mask(mask) {
        this._storedMask = Input2Component.DEFAULT_MASKS[mask] || mask;
        // TODO: once Android 7 (Nougat) is no longer supported, we can fix this
        if (this.isAndroidDevice) {
            this.displayedInput = 'none';
            if (mask === 'dollar')
                this.inputType = 'number';
        }
        // selects the correct input and applied masking directive or lack there of
        else if (!mask || mask === 'none')
            this.displayedInput = 'none';
        else if (mask === 'dollar')
            this.displayedInput = 'dollar';
        else if (['partialEmailMasking', 'fullTextMasking', 'partialTextMasking'].includes(mask)) {
            this.displayedInput = 'partial';
            if (mask === 'fullTextMasking')
                this.unmaskedLength = 0;
        }
        else
            this.displayedInput = 'custom';
        if (this.isPhantom)
            this.displayedInput = 'none';
        // look up the stroed masks if available
        this._appliedMask = Input2Component.DEFAULT_MASKS[mask] || mask;
    }
    get showHideMaskText() {
        return this.hideCharacters ? this.showText : this.hideText;
    }
    /**
     * This defines the type of the input, which changes which kind of input is displayed.
     * Mask must be set separately.
     * defaults to text.
     */
    set type(type) {
        if (type && Input2Component.VALID_TYPES.includes(type)) {
            this.inputType = type.includes('hone') ? 'tel' : type;
            this._inputType = this.inputType;
            if (this.isAndroidDevice && this.usePasswordOnAndroid) {
                this.inputType = 'password';
            }
        }
        else if (isDevMode)
            console.error('CITI-INPUT - TYPE: Caught \'' + type + '\'. Valid types are: ' + Input2Component.VALID_TYPES);
    }
    get type() {
        return this._inputType;
    }
    /**
     * This defines the size of the input, which changes the bootstrap classes.
     */
    set size(size) {
        if (!!size && Input2Component.SIZE_CLASSES[size] !== undefined) {
            this.inputSize = size;
            this.classRow = size === 'none' ? false : true;
        }
        else if (isDevMode) {
            console.error('CITI-INPUT - SIZE: Caught \'' + size + '\'. Valid sizes are: ' + Object.keys(Input2Component.SIZE_CLASSES));
        }
    }
    ;
    // #endregion
    // #region - Getters
    get hasValue() {
        return Input2Component.VALIDATORS.isValue(this.value);
    }
    get size() {
        return Input2Component.SIZE_CLASSES[this.inputSize];
    }
    get isCountryCodes() {
        return !!this.countryCodes && this.countryCodes.length > 0;
    }
    get isAreaCodes() {
        return !!this.areaCodes && this.areaCodes.length > 0;
    }
    get hasCurrencySignBefore() {
        return !!this.currencySignBefore && this.currencySignBefore !== '';
    }
    get labelOpacity() {
        return this.visibleLabel ? 1 : (this.value || this.isFocused || this.isSelectFocused || this.displayedInput === 'custom') ? 1 : 0;
    }
    get isAndroidDevice() {
        if (!this._navigator || !this._navigator.userAgent)
            return false;
        else
            return /(android)/i.test(this._navigator.userAgent);
    }
    get isMobile() {
        return !!this._isMobile;
    }
    get isPhantom() {
        if (!this._navigator || !this._navigator.userAgent)
            return false;
        else
            return /(PhantomJS)/i.test(this._navigator.userAgent);
    }
    // #endregion
    // #region - Life Cycle
    constructor(validationService, announcer, el, // added for Duracell
    _navigator) {
        this.validationService = validationService;
        this.announcer = announcer;
        this.el = el;
        this._navigator = _navigator;
        // #endregion
        // #region - Properties: Public
        // Default errors for the different validation error states
        this.errors = {
            required: DEFAULT_ERRORS$1.required,
            positive: DEFAULT_ERRORS$1.positive,
            integer: DEFAULT_ERRORS$1.integer,
            phone: DEFAULT_ERRORS$1.phone,
            zipcode: DEFAULT_ERRORS$1.zip,
            nonZero: DEFAULT_ERRORS$1.nonZero,
            email: DEFAULT_ERRORS$1.email,
            zip: DEFAULT_ERRORS$1.zip,
            ssn: DEFAULT_ERRORS$1.ssn,
            areaCode: DEFAULT_ERRORS$1.areaCode,
            countryCode: DEFAULT_ERRORS$1.countryCode,
        };
        this.shouldValidate = {
            number: () => this.inputType === 'number' || this._appliedMask === 'dollar',
            url: () => this.inputType === 'url',
            zip: () => this.inputType === 'zip',
            ssn: () => this.inputType === 'ssn' || this._appliedMask.toLowerCase().includes('ssn'),
            phone: () => this.inputType === 'tel' || this._appliedMask.toLowerCase().includes('phone'),
            email: () => this.inputType === 'email' || this._appliedMask.toLowerCase().includes('email'),
            minLength: () => !!this.minLength && ['text', 'email', 'password', 'none'].includes(this.inputType)
        };
        // Id for the label for aria
        this.labelId = null;
        // applys class to remove excess padding if there is a pre addon
        this.hasPreAddon = false;
        // error message to be displayed when an error is triggered
        this.errorMessage = 'Error';
        // whether the input is focused
        this.isFocused = false;
        // whether the select of the input is focused
        this.isSelectFocused = false;
        this._calledFromSubmit = false;
        // #endregion
        // #region - Inputs: Error Related
        /**
         * Whether the input should valid on 'blur' and 'change' events (always validates on submit)
         */
        this.validateOn = [];
        /**
         * The input only accepts alphabetical or numeric value
         */
        this.allowIntegerOnly = false;
        /**
         * This defines the maximum character length of the input
         */
        this.maxLength = Input2Component.DEFAULT_MAXLENGTH;
        /**
         * readonly field, displays its value and focusable
         */
        this.readOnly = false;
        /**
         * disables the field and not focusable
         */
        this.disabled = false;
        /**
         * non-masked text fields this limits characters to numbers
         */
        this.typeNumbersOnly = false;
        /**
         * Enables/disables non zero validation
         */
        this.allowNonZeroValueOnly = false;
        // #endregion
        /**
         * Turns on/off the autocomplete feature of an input. Default value is 'off'.
         * @Two-way: false
         */
        this.autocomplete = 'off';
        /**
         * prevents all paste events
         */
        this.preventPaste = false;
        // #region - Inputs: Dollar mask
        /**
         * string to seperate the thousands position
         */
        this.thousandsSeparator = ',';
        /**
         * string to seperate the decimal position
         */
        this.decimalSeparator = '.';
        /**
         * number of digits allowed after the decimal
         */
        this.precision = 2;
        /**
         * max value allowed without throughing an error
         */
        this.maxValue = Number.MAX_SAFE_INTEGER;
        /**
         * Message to inform ADA users that the typed character surpassed the maxFactor and was not added to the input value
         */
        this.maxFactorExceededMessage = 'Maximum Factor Exceeded. Last number was not added';
        // #endregion
        // #region - Inputs: Global Properties
        /**
         * Label for aria-label tag if special aria label is needed
         */
        this.ariaLabel = false;
        this._uid = `citi-input2-${nextUniqueId$8++}`;
        /**
         * This defines the name of the input
         */
        this.name = null;
        /**
         * Show a search icon add-on in the input.
         */
        this.searchIcon = false;
        /**
         * Sets the tabindex attribute
         */
        this.tabIndex = 0;
        /**
         * Sets the isCbolPassword attribute
         */
        this.isCbolPassword = false;
        this.countryCodeChange = new EventEmitter();
        this.countryCodes = [];
        this.areaCodeChange = new EventEmitter();
        this.areaCodes = [];
        /**
         * How many character should not be masked at the end of the string, only applies to text masking
         */
        this.unmaskedLength = 4;
        // #endregion
        // #region - Inputs: Masking / Unmasking events
        /**
         * A list of HTML event to activate the masking on the content
         */
        this.applyMaskOnEvents = [];
        /**
         * A list of HTML event to remove the mask from the value
         */
        this.removeMaskOnEvents = [];
        // #endregion
        // #region - Inputs: Success related
        /**
         * This defines the success state on the input
         */
        this.isSuccess = false;
        /**
         * Customized success message for valid password input
         */
        this.successMessage = '';
        /**
        * Input for visibleLabel for the label
        */
        this.visibleLabel = false;
        /**
         * This defines the value of the input. Can be two-way bound through [(value)]='myValueVar'
         */
        this.value = undefined;
        this.valueChange = new EventEmitter();
        this.hideToggle = new EventEmitter();
        this.focusChange = new EventEmitter();
        // #endregion
        // #region - Outputs
        /**
         * emits when the focus is blured
         */
        this.blur = new EventEmitter();
        /*
        * This defines the custom error state of the input. Takes precedence over other validation types.
        */
        this._hasCustomError = false;
        /**
         * This defines the error state on the input
         */
        this._error = false;
        this.errorChange = new EventEmitter();
        this._appliedMask = 'none';
        this._storedMask = 'none';
        this.displayedInput = 'none';
        this.hideCharacters = true;
        /**
         * text of the show (unmask) button
         */
        this.showText = 'Show';
        /**
         * text of the hide (mask) button
         */
        this.hideText = 'Hide';
        this.inputType = 'text';
        this.inputSize = 'fullwidth';
        this.classRow = true;
        // #endregion
        // #region - FORM BINDING METHODS
        // All methods below are required for the Value Control Accessor interface to work with [(ngModel)]
        this.onChange = (value) => { };
        this.onTouched = () => { };
    }
    ngOnInit() {
        // Detects mobile device
        if (this._navigator)
            this._isMobile = this._navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i);
        // ensures that an id is assigned
        this.idStr = this.idStr;
        // register and subscribe to validation service
        this.validationService.addInput(this);
        this.validateSub = this.validationService.validateNow.subscribe(() => {
            this._calledFromSubmit = true;
            this.validate();
        });
        this.labelId = Input2Component.VALIDATORS.isValue(this._id) ? this._id + '-label' : null;
        if (this.hasCurrencySignBefore || this.isCountryCodes || this.isAreaCodes)
            this.hasPreAddon = true;
        this.setDynamicMessages();
        if (this.countryCode) {
            const codeOption = this.countryCodes.find(code => code.value === this.countryCode);
            if (codeOption)
                this.mask = codeOption.mask || this._storedMask;
        }
    }
    ngOnDestroy() {
        this.validationService.removeError(this);
        if (this.validateSub)
            this.validateSub.unsubscribe();
    }
    // #endregion
    // #region - Event Listeners and handlers
    /**
     * Updates the ui to responsd to a focus event
     * This does not cast focus. Use "focusInput()" for that
     */
    onFocus() {
        if (this.isFocused)
            return;
        if (this.safeIncludes(this.removeMaskOnEvents, 'focus'))
            this.hideCharacters = false;
        this.isFocused = true;
        this.isSelectFocused = false;
        this.focusChange.emit(true);
    }
    /**
     * Casts focus to the native <input> element
     */
    focusInput() {
        this.input.nativeElement.focus();
    }
    ;
    onBlur() {
        if (!this.isFocused)
            return;
        if (this.safeIncludes(this.applyMaskOnEvents, 'blur'))
            this.hideCharacters = true;
        if (this.safeIncludes(this.validateOn, 'blur'))
            this.validate();
        this.isFocused = false;
        this.blur.emit();
        this.focusChange.emit(false);
        this.onTouched(); // registers
    }
    onPaste(e) {
        if (this.preventPaste)
            e.preventDefault();
    }
    onInputChange() {
        if (this.safeIncludes(this.validateOn, 'change'))
            this.validate();
    }
    onInput() {
        if (this.safeIncludes(this.validateOn, 'input'))
            this.validate();
    }
    onSelectFocus() {
        if (this.isSelectFocused === true)
            return;
        this.isSelectFocused = true;
    }
    preventCharacters(e) {
        if (!this.typeNumbersOnly)
            return;
        if (e.key === 'TAB' || e.code === 'TAB')
            return;
        if (e.shiftKey && e.keyCode === 9)
            return;
        if (e.shiftKey || e.which > 57 || ['.', ',', '/', '\'', '-'].includes(e.key))
            e.preventDefault();
    }
    // #endregion
    // #region - Methods: Masking
    // updates the mask from the template when the area or coutry code changes and requires a new mask
    updateMask(selected) {
        if (this.isAreaCodes)
            this.areaCodeChange.emit(selected);
        if (this.isCountryCodes)
            this.countryCodeChange.emit(selected);
        const options = this.countryCodes.length > 0 ? this.countryCodes : this.areaCodes;
        const mask = options.find(option => option.value === selected).mask;
        if (!!mask)
            this.mask = mask;
    }
    writeValueAndValidate(value) {
        this.writeValue(value);
        if (this.safeIncludes(this.validateOn, 'input'))
            this.validate();
    }
    // #endregion
    // #region - Methods: Validation
    setDynamicMessages() {
        const dynamicMessage = {
            minLength: this.minLengthError || `Input length must exceed ${this.minLength - 1} characters`,
            maxLength: this.maxLengthError || `Input length may not exceed ${this.maxLength} characters`,
            maxFactor: this.maxFactorExceededMessage || `Input value cannot exceed ${this.maxFactor} digits before the decimal`,
            custom: this.customErrorMessage
        };
        if (this.maxValue)
            dynamicMessage.maxValue = 'Value cannot exceed ' + this.formatDollar(this.maxValue);
        if (this.minValue)
            dynamicMessage.minValue = 'Value cannot subceed ' + this.formatDollar(this.minValue);
        this.errors = Object.assign(dynamicMessage, this.errors);
    }
    // only used for error messages, not for formatting the input field
    formatDollar(number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    // Clears an error state on the input. Takes a type of error
    toggleError(errorType, error) {
        // Clear the error state
        this._error = error;
        this.errorType = errorType;
        this.errorChange.emit(error);
        if (error) {
            // override message for customer errors
            if (this._hasCustomError)
                errorType = 'custom';
            // set the error message
            this.errorMessage = (!!errorType) ? this.errors[errorType] : '';
            this.validationService.addError(this);
        }
        else
            this.validationService.removeError(this);
    }
    validate() {
        if (this.required && !Input2Component.VALIDATORS.isValue(this.value) && this.value !== 0) {
            this.toggleError('required', true);
            return;
        }
        if (this.isCbolPassword) {
            this.toggleError('custom', this.error);
            return;
        }
        if (this.shouldValidate.minLength() && (!this.value || this.minLength > this.value.length)) {
            this.toggleError('minLength', true);
            return;
        }
        if (this.shouldValidate.number())
            this.validateNumber(); // and dollar & currency
        else if (this.shouldValidate.zip())
            this.validateZip();
        else if (this.shouldValidate.email())
            this.validateEmail();
        else if (this.shouldValidate.ssn())
            this.validateSSN();
        else if (this.shouldValidate.phone())
            this.validatePhone();
        else
            this.toggleError(null, false);
    }
    // and dollar-currency
    validateNumber() {
        const newValue = parseFloat(this.value);
        if (this.allowIntegerOnly && !Number.isInteger(newValue))
            this.toggleError('integer', true);
        else if (this.allowNonZeroValueOnly && newValue === 0)
            this.toggleError('nonZero', true);
        else if (this.allowPositiveIntegerOnly && (!Number.isInteger(newValue) || newValue <= 0))
            this.toggleError('positive', true);
        else if (!!this.maxValue && newValue > this.maxValue)
            this.toggleError('maxValue', true);
        else if (!!this.minValue && newValue < this.minValue)
            this.toggleError('minValue', true);
        else if (!!this.maxFactor && this.value > Math.pow(10, this.maxFactor + 1))
            this.toggleError('maxFactor', true);
        else
            this.toggleError(null, false);
    }
    validateEmail() {
        if (!Input2Component.VALIDATORS.isEmail(this.value))
            this.toggleError('email', true);
        else
            this.toggleError(null, false);
    }
    validateSSN() {
        const newValue = parseFloat(this.value);
        if (this.value.length !== 9 || !Number.isInteger(newValue))
            this.toggleError('ssn', true);
        else
            this.toggleError(null, false);
    }
    validateZip() {
        // strip off all non-numeric values from the mask to determine the number of characters
        const requiredLength = this._appliedMask.replace(/[^0-9]/g, '').length;
        if (!this.value || requiredLength !== this.value.length)
            this.toggleError('zip', true);
        else
            this.toggleError(null, false);
    }
    validatePhone() {
        // strip off all non-numeric values from the mask to determine the number of characters
        const hasBlanks = this._appliedMask.replace(/[^0-9]/g, '').length !== this.value.length;
        const isNull = !this.value || this.value.length === 0;
        if (this._appliedMask !== 'none' && (hasBlanks && this.required || !isNull && hasBlanks))
            this.toggleError('phone', true);
        else if (this.selectAddonIsValid(this.countryCodes, this.countryCode))
            this.toggleError('countryCode', true);
        else if (this.selectAddonIsValid(this.areaCodes, this.areaCode))
            this.toggleError('areaCode', true);
        else
            this.toggleError(null, false);
    }
    selectAddonIsValid(options, value) {
        return this.required && !value && options && options.length > 0;
    }
    safeIncludes(array, value) {
        return array && array.length && array.includes(value);
    }
    /**
     * @Function: reset
     * Resets the apperance and state of the input to initial
     * @Return: void
     */
    reset() {
        this.toggleError(null, false);
        this.value = null;
    }
    // #endregion
    // #region - Methods: Accessibility
    get describedByID() {
        if (this.describedby)
            return this.describedby;
        else if (this.error)
            return `${this._id}-error`;
        else if (this.isSuccess)
            return `${this._id}-success`;
    }
    getAriaLabelString() {
        if (this.hasValue && this.readOnly)
            return null;
        const resultString = this.label || this.placeholder;
        if (!this.ariaLabel || !Input2Component.VALIDATORS.isValue(resultString))
            return '';
        else
            return resultString;
    }
    getAriaLabelledBy() {
        if (!!this.ariaLabelledById)
            return this.ariaLabelledById;
        else if (!this.hasValue || !this.readOnly)
            return this.labelId;
        else
            return null;
    }
    get labeltext() {
        return this.label || this.placeholder;
    }
    get selectLabeltext() {
        return this.selectLabel || this.label || this.placeholder;
    }
    showhideMaskcheck(e) {
        this.hideCharacters = !this.hideCharacters;
        this.hideToggle.emit(this.hideCharacters);
    }
    /**
     * @Method: showhideMaskcheckKeyboard
     * This method gets called when enter key is pressed on the hide/show button
     */
    showhideMaskcheckKeyboard(e) {
        if (e.keyCode === 13)
            this.showhideMaskcheck(e);
    }
    // Allows Angular to update the model.
    // Update the model and changes needed for the view here.
    writeValue(value) {
        this.value = value;
        this.valueChange.emit(value);
        //      !!!!    WARNING: DO NOT REMOVE    !!!!
        // this is actually necessary for ngModel to update
        this.onChange(this.value);
    }
    // Allows Angular to register a function to call when the model changes.
    // Save the function as a property to call later here.
    registerOnChange(fn) {
        this.onChange = fn;
    }
    // Allows Angular to register a function to call when the input has been touched.
    // Save the function as a property to call later here.
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    // Allows Angular to disable the input.
    setDisabledState(isDisabled) {
        this.readOnly = isDisabled;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Input2Component, deps: [{ token: ValidationService }, { token: CitiLiveAnnouncer }, { token: i0.ElementRef }, { token: NAVIGATOR }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: Input2Component, isStandalone: false, selector: "citi-input2:not(.4Q21)", inputs: { validateOn: "validateOn", allowIntegerOnly: "allowIntegerOnly", maxLength: "maxLength", allowPositiveIntegerOnly: "allowPositiveIntegerOnly", minLength: "minLength", readOnly: "readOnly", disabled: "disabled", typeNumbersOnly: "typeNumbersOnly", allowNonZeroValueOnly: "allowNonZeroValueOnly", autocomplete: "autocomplete", ariaAutocomplete: "ariaAutocomplete", preventPaste: "preventPaste", thousandsSeparator: "thousandsSeparator", decimalSeparator: "decimalSeparator", precision: "precision", step: "step", maxValue: "maxValue", minValue: "minValue", maxFactor: "maxFactor", maxFactorExceededMessage: "maxFactorExceededMessage", currencySignAfter: "currencySignAfter", currencySignBefore: "currencySignBefore", ariaLabel: "ariaLabel", ariaLabelledById: "ariaLabelledById", idStr: "idStr", name: "name", label: "label", selectLabel: "selectLabel", placeholder: "placeholder", searchIcon: "searchIcon", required: "required", describedby: "describedby", tabIndex: "tabIndex", isCbolPassword: "isCbolPassword", countryCode: "countryCode", countryCodes: "countryCodes", areaCode: "areaCode", areaCodes: "areaCodes", unmaskedLength: "unmaskedLength", theme: "theme", applyMaskOnEvents: "applyMaskOnEvents", removeMaskOnEvents: "removeMaskOnEvents", isSuccess: "isSuccess", successMessage: "successMessage", visibleLabel: "visibleLabel", hideMask: "hideMask", value: "value", focus: "focus", minLengthError: "minLengthError", maxValueError: "maxValueError", minValueError: "minValueError", maxLengthError: "maxLengthError", requiredError: "requiredError", messageOnlyNonZeroError: "messageOnlyNonZeroError", messageOnlyIntegerError: "messageOnlyIntegerError", messageOnlyPositiveIntegerError: "messageOnlyPositiveIntegerError", messageOnlyPhoneError: "messageOnlyPhoneError", messageOnlyZipcodeError: "messageOnlyZipcodeError", messageOnlyEmailError: "messageOnlyEmailError", messageOnlyZipError: "messageOnlyZipError", messageOnlySsnError: "messageOnlySsnError", messageOnlyAreaCodeError: "messageOnlyAreaCodeError", messageOnlyCountryCodeError: "messageOnlyCountryCodeError", changeMessage: "changeMessage", hasCustomError: "hasCustomError", customErrorMessage: "customErrorMessage", error: "error", usePasswordOnAndroid: "usePasswordOnAndroid", mask: "mask", hideShowButtonWhenMasked: "hideShowButtonWhenMasked", showText: "showText", hideText: "hideText", type: "type", size: "size" }, outputs: { countryCodeChange: "countryCodeChange", areaCodeChange: "areaCodeChange", valueChange: "valueChange", hideToggle: "hideToggle", focusChange: "focusChange", blur: "blur", errorChange: "errorChange" }, host: { properties: { "class.row": "this.classRow" }, classAttribute: "citi-input2" }, providers: [INPUT2_VALUE_ACCESSOR$1], viewQueries: [{ propertyName: "input", first: true, predicate: ["input"], descendants: true }, { propertyName: "custom", first: true, predicate: CustomInputMaskDirective, descendants: true }], ngImport: i0, template: `

    <div class="form-control-container {{theme}}" [ngClass]="size">
      <!-- label for the input, will switch text to select element's label when that element is focused -->
      <label [for]="_id" [id]="labelId" tabIndex="-1" [ngStyle]="{'opacity': labelOpacity}" [innerHtml]="(isSelectFocused ? selectLabeltext : labeltext)"></label>
      <!-- input wapper (all borders) -->
      <div class="input-container"
        [ngClass]="{
          'focused': isFocused,
          'errored': _error,
          'has-pre-addon': hasPreAddon,
          'readOnly': readOnly,
          'disabled': disabled,
          'success': isSuccess
        }">
        <!-- Add-ons Pre -->
        <div class="add-on-pre">
          <!-- Phone Area Code Selector -->
          <select *ngIf="isAreaCodes"
            [attr.name]="name"
            class="form-control"
            (change)="updateMask($event.target.value)"
            [attr.aria-label]="selectLabeltext"
            (focus)="onSelectFocus()">
            <option *ngFor="let code of areaCodes" [value]="code.value" [innerHtml]="code.label" [attr.selected]="(code.selected === true ? true : null)"></option>
          </select>
          <!-- Phone Country Prefix Selector -->
          <select *ngIf="isCountryCodes"
            [attr.name]="name"
            (change)="updateMask($event.target.value)"
            class="form-control"
            [attr.aria-label]="selectLabeltext"
            (focus)="onSelectFocus()">
            <option *ngFor="let code of countryCodes" [value]="code.value" [innerHtml]="code.label" [attr.selected]="(code.selected === true ? true : null)"></option>
          </select>
          <span *ngIf="currencySignBefore" (click)="focusInput()" class="input-group-addon before">{{currencySignBefore}}</span>
        </div>
        <!-- The Inputs managed by a switch statement -->
        <div [ngSwitch]="displayedInput" class="input-switch-wrapper">
          <!-- Custom Mask -->
          <input
            *ngSwitchCase="'custom'"
            #input
            #custom="custom"
            [attr.type]="(inputType == 'tel' ? 'tel' : 'text')"
            [custom-mask]="_appliedMask"
            [hideCharacters]="hideCharacters"
            [unmaskedValue]="value"
            (unmaskedValueChange)="writeValue($event)"
            [attr.id]="_id"
            [attr.name]="name"
            [readonly]="readOnly"
            [disabled]="disabled"
            [ngClass]="{
              'disabled': disabled,
              'readOnly': readOnly
            }"
            [attr.tabindex]="tabIndex"
            (focus)="onFocus()"
            (blur)="onBlur()"
            (change)="onInputChange()"
            (input)="onInput()"
            [attr.aria-autocomplete]="ariaAutocomplete"
            [attr.autocomplete]="autocomplete"
            [attr.aria-label]="getAriaLabelString()"
            [attr.aria-labelledby]="getAriaLabelledBy()"
            [attr.placeholder]="placeholder"
            [attr.aria-required]="(required ? true : null)"
            [attr.aria-invalid]="(_error ? true : null)"
            [attr.aria-describedby]="(isMobile ? describedByID : null)"
          />
          <!-- Dollar Mask -->
          <input
            *ngSwitchCase="'dollar'"
            #input
            type="text"
            currency-mask
            [unmaskedValue]="value"
            (unmaskedValueChange)="writeValueAndValidate($event)"
            [thousandsSeparator]="thousandsSeparator"
            [decimalSeparator]="decimalSeparator"
            [maxFactor]="maxFactor"
            [precision]="precision"
            [preventPaste]="preventPaste"
            [maxFactorExceededMessage]="maxFactorExceededMessage"
            [attr.id]="_id"
            [attr.name]="name"
            [attr.tabindex]="tabIndex"
            [attr.placeholder]="placeholder"
            [readonly]="readOnly"
            [disabled]="disabled"
            [ngClass]="{
              'disabled': disabled,
              'readOnly': readOnly
            }"
            (focus)="onFocus()"
            (blur)="onBlur()"
            (change)="onInputChange()"
            (input)="onInput()"
            [attr.aria-autocomplete]="ariaAutocomplete"
            [attr.autocomplete]="autocomplete"
            [attr.aria-invalid]="(_error ? true : null)"
            [attr.aria-label]="getAriaLabelString()"
            [attr.aria-labelledby]="getAriaLabelledBy()"
            [attr.aria-required]="(required ? true : null)"
            [attr.aria-describedby]="(isMobile ? describedByID : null)"
          />
          <!-- Partial Mask -->
          <input
            *ngSwitchCase="'partial'"
            #input
            type="text"
            [partial-mask]="_appliedMask"
            [hideCharacters]="hideCharacters"
            [unmaskedValue]="value"
            (unmaskedValueChange)="writeValue($event)"
            [unmaskedLength]="unmaskedLength"
            [maxLength]="maxLength"
            [preventPaste]="preventPaste"
            [numbersOnly]="typeNumbersOnly"
            [attr.id]="_id"
            [attr.name]="name"
            [readonly]="readOnly"
            [disabled]="disabled"
            [ngClass]="{
              'disabled': disabled,
              'readOnly': readOnly
            }"
            [attr.tabindex]="tabIndex"
            [attr.placeholder]="placeholder"
            (focus)="onFocus()"
            (blur)="onBlur()"
            (change)="onInputChange()"
            (input)="onInput()"
            [attr.aria-autocomplete]="(ariaAutocomplete ? ariaAutocomplete : null)"
            [attr.autocomplete]="(autocomplete ? autocomplete : null)"
            [attr.aria-required]="(required ? true : null)"
            [attr.aria-label]="getAriaLabelString()"
            [attr.aria-labelledby]="getAriaLabelledBy()"
            [attr.aria-invalid]="(_error ? true : null)"
            [attr.aria-describedby]="(isMobile ? describedByID : null)"
          />
          <!-- No Mask -->
          <input
            *ngSwitchCase="'none'"
            #input
            [ngModel]="value"
            [attr.type]="inputType"
            (ngModelChange)="writeValue($event)"
            [attr.id]="_id"
            [attr.name]="name"
            [attr.step]="step"
            [attr.tabindex]="tabIndex"
            [attr.placeholder]="placeholder"
            [attr.maxlength]="maxLength"
            autocapitalize="none"
            [readonly]="readOnly"
            [disabled]="disabled"
            [ngClass]="{
              'disabled': disabled,
              'readOnly': readOnly
            }"
            (keypress)="preventCharacters($event)"
            (focus)="onFocus()"
            (blur)="onBlur()"
            (change)="onInputChange()"
            (input)="onInput()"
            (paste)="onPaste($event)"
            [attr.aria-autocomplete]="ariaAutocomplete"
            [attr.autocomplete]="autocomplete"
            [attr.aria-required]="(required ? true : null)"
            [attr.aria-invalid]="(_error ? true : null)"
            [attr.aria-labelledby]="getAriaLabelledBy()"
            [attr.aria-label]="getAriaLabelString()"
            [attr.aria-describedby]="(isMobile ? describedByID : null)"
          />

        </div>
        <div class="add-on-post">
         <button
            #button1
            type=button
            *ngIf="hideShowButtonWhenMasked && value"
            class="input-group-addon showHideMask"
            (click)="showhideMaskcheck($event)"
            (keydown)="showhideMaskcheckKeyboard($event)"
            >
            {{showHideMaskText}}
      </button>
          <citi-icon2
            *ngIf="searchIcon"
            name="006-search"
            ariaLabel="icon"
            [idStr]="_id ? _id + '-search-icon' : null"
            shade="dark"
            [svgStyle]="{'width.px': 50, 'height.px': 50}">
          </citi-icon2>
          <span *ngIf="currencySignAfter" (click)="focusInput()" class="input-group-addon after">{{currencySignAfter}}</span>
        </div>
      </div>

      <div class="input-error" *ngIf="_error">
        <span [attr.id]="describedByID" class="validation-message-danger">{{errorMessage}}</span>
      </div>
      <div class="input-success" *ngIf="!_error && isSuccess">
        <span [attr.id]="describedByID" class="validation-message-success">{{successMessage}}</span>
      </div>
    </div>
  `, isInline: true, styles: [":host{display:block}label{font-size:.75rem;color:#666;width:100%;pointer-events:none;transition:opacity ease-in-out 225ms}.input-container{width:100%;margin:3px 0 5px;box-sizing:border-box;-moz-box-sizing:border-box;float:left;display:-moz-inline-flex;display:inline-flex;-moz-flex-direction:row;flex-direction:row;flex-wrap:nowrap;justify-content:flex-start;align-content:stretch;align-items:flex-start;border-radius:8px;background:#eee;border:1px solid transparent;border:.9px solid transparent}.input-container.focused{border-color:#056dae}.input-container.focused input::placeholder{opacity:0}.input-container.errored{border-color:#d60000}.input-container.errored.focused{width:calc(100% + 2px);border-width:1.99px;margin:2px 0 4px -1px}.input-container.success{border-color:#006e0a}.input-container.success.focused{width:calc(100% + 2px);border-width:1.99px;margin:2px 0 4px -1px}.input-container.readOnly{background:#fff;border:1px solid #666}.input-container.readOnly input.readOnly:read-only,.input-container.readOnly select,.input-container.readOnly span{background-color:#fff}.input-container.disabled{background:#fff;border:1px solid #666}.input-container.disabled input.disabled:disabled,.input-container.disabled select,.input-container.disabled span{background-color:#fff}.input-container.has-pre-addon input{padding-left:0!important}.input-container .input-group-addon.before{border-top-left-radius:8px;border-bottom-left-radius:8px}.input-container .input-group-addon.before,.input-container .input-group-addon.after{width:48px;height:48px}.input-container .input-group-addon.after{border-top-right-radius:8px;border-bottom-right-radius:8px}.input-container .add-on-pre{order:0;flex:0 1 auto;align-self:auto;box-sizing:border-box;-moz-box-sizing:border-box}.input-container .add-on-pre select{margin:0;width:105px;border:1px solid transparent;border-top-right-radius:0;border-bottom-right-radius:0}.input-container .add-on-pre select:focus{border-color:#056dae;outline:none}.input-container .input-switch-wrapper{flex:1 1 0%;box-sizing:border-box;-moz-box-sizing:border-box;margin:0 2px;border-radius:8px}.input-container .input-switch-wrapper input{width:100%;box-sizing:border-box;-moz-box-sizing:border-box;letter-spacing:.5px;height:48px;padding:10px 20px;background:#eee;border:none!important;box-shadow:none;border-radius:8px}.input-container .input-switch-wrapper input::-ms-clear{display:none}.input-container .input-switch-wrapper input:focus{outline:none}.input-container .add-on-post{flex:0 1 auto;box-sizing:border-box;-moz-box-sizing:border-box}.input-container .add-on-post .search{width:50px;padding-top:12px;border-radius:8px}.input-container .add-on-post .showHideMask{width:50px;border-radius:8px;padding:17px 20px 17px 10px;color:#056dae;font-family:Interstate_Bold,sans-serif;line-height:14px;cursor:pointer;font-size:12px}.input-error,.input-success{height:16px;width:100%;float:left}.input-success .validation-message-success{font-size:12px;font-family:Interstate_Bold,sans-serif;margin:0;color:#006e0a;font-weight:700;position:relative;display:block;line-height:1rem;font-size:.75rem}:host .light .input-container{background:#fff}:host .light .input-container input,:host .light .input-container select,:host .light .input-container span{background-color:#fff}:host .light .input-container.readOnly{background:#eee}:host .light .input-container.readOnly input,:host .light .input-container.readOnly select,:host .light .input-container.readOnly span{background-color:#eee}::ng-deep #inputSearchIconId path{fill:#056dae}::-webkit-input-placeholder{color:#6b6b6b}::-moz-placeholder{color:#6b6b6b}:-ms-input-placeholder{color:#6b6b6b}:-moz-placeholder{color:#6b6b6b}input::-ms-reveal,input::-ms-clear{display:none}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: i1$1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1$1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i4.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i4.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i4.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i4.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: Icon2Component, selector: "citi-icon2", inputs: ["role", "idStr", "ariaLabel", "ariaHidden", "size", "isHoverSfi", "includeCircle", "type", "svgStyle", "tabIndex", "shade", "name"] }, { kind: "directive", type: CustomInputMaskDirective, selector: "[custom-mask]", inputs: ["hideCharacters", "custom-mask", "unmaskedValue"], outputs: ["unmaskedValueChange"], exportAs: ["custom"] }, { kind: "directive", type: CurrencyInputMaskDirective, selector: "[currency-mask]", inputs: ["unmaskedValue", "thousandsSeparator", "decimalSeparator", "precision", "maxFactor", "maxFactorExceededMessage", "preventPaste"], outputs: ["unmaskedValueChange"] }, { kind: "directive", type: PartialInputMaskDirective, selector: "[partial-mask]", inputs: ["maxLength", "unmaskedLength", "numbersOnly", "preventPaste", "hideCharacters", "partial-mask", "unmaskedValue"], outputs: ["unmaskedValueChange"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Input2Component, decorators: [{
            type: Component,
            args: [{ selector: 'citi-input2:not(.4Q21)', standalone: false, providers: [INPUT2_VALUE_ACCESSOR$1], host: { class: 'citi-input2' }, template: `

    <div class="form-control-container {{theme}}" [ngClass]="size">
      <!-- label for the input, will switch text to select element's label when that element is focused -->
      <label [for]="_id" [id]="labelId" tabIndex="-1" [ngStyle]="{'opacity': labelOpacity}" [innerHtml]="(isSelectFocused ? selectLabeltext : labeltext)"></label>
      <!-- input wapper (all borders) -->
      <div class="input-container"
        [ngClass]="{
          'focused': isFocused,
          'errored': _error,
          'has-pre-addon': hasPreAddon,
          'readOnly': readOnly,
          'disabled': disabled,
          'success': isSuccess
        }">
        <!-- Add-ons Pre -->
        <div class="add-on-pre">
          <!-- Phone Area Code Selector -->
          <select *ngIf="isAreaCodes"
            [attr.name]="name"
            class="form-control"
            (change)="updateMask($event.target.value)"
            [attr.aria-label]="selectLabeltext"
            (focus)="onSelectFocus()">
            <option *ngFor="let code of areaCodes" [value]="code.value" [innerHtml]="code.label" [attr.selected]="(code.selected === true ? true : null)"></option>
          </select>
          <!-- Phone Country Prefix Selector -->
          <select *ngIf="isCountryCodes"
            [attr.name]="name"
            (change)="updateMask($event.target.value)"
            class="form-control"
            [attr.aria-label]="selectLabeltext"
            (focus)="onSelectFocus()">
            <option *ngFor="let code of countryCodes" [value]="code.value" [innerHtml]="code.label" [attr.selected]="(code.selected === true ? true : null)"></option>
          </select>
          <span *ngIf="currencySignBefore" (click)="focusInput()" class="input-group-addon before">{{currencySignBefore}}</span>
        </div>
        <!-- The Inputs managed by a switch statement -->
        <div [ngSwitch]="displayedInput" class="input-switch-wrapper">
          <!-- Custom Mask -->
          <input
            *ngSwitchCase="'custom'"
            #input
            #custom="custom"
            [attr.type]="(inputType == 'tel' ? 'tel' : 'text')"
            [custom-mask]="_appliedMask"
            [hideCharacters]="hideCharacters"
            [unmaskedValue]="value"
            (unmaskedValueChange)="writeValue($event)"
            [attr.id]="_id"
            [attr.name]="name"
            [readonly]="readOnly"
            [disabled]="disabled"
            [ngClass]="{
              'disabled': disabled,
              'readOnly': readOnly
            }"
            [attr.tabindex]="tabIndex"
            (focus)="onFocus()"
            (blur)="onBlur()"
            (change)="onInputChange()"
            (input)="onInput()"
            [attr.aria-autocomplete]="ariaAutocomplete"
            [attr.autocomplete]="autocomplete"
            [attr.aria-label]="getAriaLabelString()"
            [attr.aria-labelledby]="getAriaLabelledBy()"
            [attr.placeholder]="placeholder"
            [attr.aria-required]="(required ? true : null)"
            [attr.aria-invalid]="(_error ? true : null)"
            [attr.aria-describedby]="(isMobile ? describedByID : null)"
          />
          <!-- Dollar Mask -->
          <input
            *ngSwitchCase="'dollar'"
            #input
            type="text"
            currency-mask
            [unmaskedValue]="value"
            (unmaskedValueChange)="writeValueAndValidate($event)"
            [thousandsSeparator]="thousandsSeparator"
            [decimalSeparator]="decimalSeparator"
            [maxFactor]="maxFactor"
            [precision]="precision"
            [preventPaste]="preventPaste"
            [maxFactorExceededMessage]="maxFactorExceededMessage"
            [attr.id]="_id"
            [attr.name]="name"
            [attr.tabindex]="tabIndex"
            [attr.placeholder]="placeholder"
            [readonly]="readOnly"
            [disabled]="disabled"
            [ngClass]="{
              'disabled': disabled,
              'readOnly': readOnly
            }"
            (focus)="onFocus()"
            (blur)="onBlur()"
            (change)="onInputChange()"
            (input)="onInput()"
            [attr.aria-autocomplete]="ariaAutocomplete"
            [attr.autocomplete]="autocomplete"
            [attr.aria-invalid]="(_error ? true : null)"
            [attr.aria-label]="getAriaLabelString()"
            [attr.aria-labelledby]="getAriaLabelledBy()"
            [attr.aria-required]="(required ? true : null)"
            [attr.aria-describedby]="(isMobile ? describedByID : null)"
          />
          <!-- Partial Mask -->
          <input
            *ngSwitchCase="'partial'"
            #input
            type="text"
            [partial-mask]="_appliedMask"
            [hideCharacters]="hideCharacters"
            [unmaskedValue]="value"
            (unmaskedValueChange)="writeValue($event)"
            [unmaskedLength]="unmaskedLength"
            [maxLength]="maxLength"
            [preventPaste]="preventPaste"
            [numbersOnly]="typeNumbersOnly"
            [attr.id]="_id"
            [attr.name]="name"
            [readonly]="readOnly"
            [disabled]="disabled"
            [ngClass]="{
              'disabled': disabled,
              'readOnly': readOnly
            }"
            [attr.tabindex]="tabIndex"
            [attr.placeholder]="placeholder"
            (focus)="onFocus()"
            (blur)="onBlur()"
            (change)="onInputChange()"
            (input)="onInput()"
            [attr.aria-autocomplete]="(ariaAutocomplete ? ariaAutocomplete : null)"
            [attr.autocomplete]="(autocomplete ? autocomplete : null)"
            [attr.aria-required]="(required ? true : null)"
            [attr.aria-label]="getAriaLabelString()"
            [attr.aria-labelledby]="getAriaLabelledBy()"
            [attr.aria-invalid]="(_error ? true : null)"
            [attr.aria-describedby]="(isMobile ? describedByID : null)"
          />
          <!-- No Mask -->
          <input
            *ngSwitchCase="'none'"
            #input
            [ngModel]="value"
            [attr.type]="inputType"
            (ngModelChange)="writeValue($event)"
            [attr.id]="_id"
            [attr.name]="name"
            [attr.step]="step"
            [attr.tabindex]="tabIndex"
            [attr.placeholder]="placeholder"
            [attr.maxlength]="maxLength"
            autocapitalize="none"
            [readonly]="readOnly"
            [disabled]="disabled"
            [ngClass]="{
              'disabled': disabled,
              'readOnly': readOnly
            }"
            (keypress)="preventCharacters($event)"
            (focus)="onFocus()"
            (blur)="onBlur()"
            (change)="onInputChange()"
            (input)="onInput()"
            (paste)="onPaste($event)"
            [attr.aria-autocomplete]="ariaAutocomplete"
            [attr.autocomplete]="autocomplete"
            [attr.aria-required]="(required ? true : null)"
            [attr.aria-invalid]="(_error ? true : null)"
            [attr.aria-labelledby]="getAriaLabelledBy()"
            [attr.aria-label]="getAriaLabelString()"
            [attr.aria-describedby]="(isMobile ? describedByID : null)"
          />

        </div>
        <div class="add-on-post">
         <button
            #button1
            type=button
            *ngIf="hideShowButtonWhenMasked && value"
            class="input-group-addon showHideMask"
            (click)="showhideMaskcheck($event)"
            (keydown)="showhideMaskcheckKeyboard($event)"
            >
            {{showHideMaskText}}
      </button>
          <citi-icon2
            *ngIf="searchIcon"
            name="006-search"
            ariaLabel="icon"
            [idStr]="_id ? _id + '-search-icon' : null"
            shade="dark"
            [svgStyle]="{'width.px': 50, 'height.px': 50}">
          </citi-icon2>
          <span *ngIf="currencySignAfter" (click)="focusInput()" class="input-group-addon after">{{currencySignAfter}}</span>
        </div>
      </div>

      <div class="input-error" *ngIf="_error">
        <span [attr.id]="describedByID" class="validation-message-danger">{{errorMessage}}</span>
      </div>
      <div class="input-success" *ngIf="!_error && isSuccess">
        <span [attr.id]="describedByID" class="validation-message-success">{{successMessage}}</span>
      </div>
    </div>
  `, styles: [":host{display:block}label{font-size:.75rem;color:#666;width:100%;pointer-events:none;transition:opacity ease-in-out 225ms}.input-container{width:100%;margin:3px 0 5px;box-sizing:border-box;-moz-box-sizing:border-box;float:left;display:-moz-inline-flex;display:inline-flex;-moz-flex-direction:row;flex-direction:row;flex-wrap:nowrap;justify-content:flex-start;align-content:stretch;align-items:flex-start;border-radius:8px;background:#eee;border:1px solid transparent;border:.9px solid transparent}.input-container.focused{border-color:#056dae}.input-container.focused input::placeholder{opacity:0}.input-container.errored{border-color:#d60000}.input-container.errored.focused{width:calc(100% + 2px);border-width:1.99px;margin:2px 0 4px -1px}.input-container.success{border-color:#006e0a}.input-container.success.focused{width:calc(100% + 2px);border-width:1.99px;margin:2px 0 4px -1px}.input-container.readOnly{background:#fff;border:1px solid #666}.input-container.readOnly input.readOnly:read-only,.input-container.readOnly select,.input-container.readOnly span{background-color:#fff}.input-container.disabled{background:#fff;border:1px solid #666}.input-container.disabled input.disabled:disabled,.input-container.disabled select,.input-container.disabled span{background-color:#fff}.input-container.has-pre-addon input{padding-left:0!important}.input-container .input-group-addon.before{border-top-left-radius:8px;border-bottom-left-radius:8px}.input-container .input-group-addon.before,.input-container .input-group-addon.after{width:48px;height:48px}.input-container .input-group-addon.after{border-top-right-radius:8px;border-bottom-right-radius:8px}.input-container .add-on-pre{order:0;flex:0 1 auto;align-self:auto;box-sizing:border-box;-moz-box-sizing:border-box}.input-container .add-on-pre select{margin:0;width:105px;border:1px solid transparent;border-top-right-radius:0;border-bottom-right-radius:0}.input-container .add-on-pre select:focus{border-color:#056dae;outline:none}.input-container .input-switch-wrapper{flex:1 1 0%;box-sizing:border-box;-moz-box-sizing:border-box;margin:0 2px;border-radius:8px}.input-container .input-switch-wrapper input{width:100%;box-sizing:border-box;-moz-box-sizing:border-box;letter-spacing:.5px;height:48px;padding:10px 20px;background:#eee;border:none!important;box-shadow:none;border-radius:8px}.input-container .input-switch-wrapper input::-ms-clear{display:none}.input-container .input-switch-wrapper input:focus{outline:none}.input-container .add-on-post{flex:0 1 auto;box-sizing:border-box;-moz-box-sizing:border-box}.input-container .add-on-post .search{width:50px;padding-top:12px;border-radius:8px}.input-container .add-on-post .showHideMask{width:50px;border-radius:8px;padding:17px 20px 17px 10px;color:#056dae;font-family:Interstate_Bold,sans-serif;line-height:14px;cursor:pointer;font-size:12px}.input-error,.input-success{height:16px;width:100%;float:left}.input-success .validation-message-success{font-size:12px;font-family:Interstate_Bold,sans-serif;margin:0;color:#006e0a;font-weight:700;position:relative;display:block;line-height:1rem;font-size:.75rem}:host .light .input-container{background:#fff}:host .light .input-container input,:host .light .input-container select,:host .light .input-container span{background-color:#fff}:host .light .input-container.readOnly{background:#eee}:host .light .input-container.readOnly input,:host .light .input-container.readOnly select,:host .light .input-container.readOnly span{background-color:#eee}::ng-deep #inputSearchIconId path{fill:#056dae}::-webkit-input-placeholder{color:#6b6b6b}::-moz-placeholder{color:#6b6b6b}:-ms-input-placeholder{color:#6b6b6b}:-moz-placeholder{color:#6b6b6b}input::-ms-reveal,input::-ms-clear{display:none}\n"] }]
        }], ctorParameters: () => [{ type: ValidationService }, { type: CitiLiveAnnouncer }, { type: i0.ElementRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [NAVIGATOR]
                }] }], propDecorators: { validateOn: [{
                type: Input$1
            }], allowIntegerOnly: [{
                type: Input$1
            }], maxLength: [{
                type: Input$1
            }], allowPositiveIntegerOnly: [{
                type: Input$1
            }], minLength: [{
                type: Input$1
            }], readOnly: [{
                type: Input$1
            }], disabled: [{
                type: Input$1
            }], typeNumbersOnly: [{
                type: Input$1
            }], allowNonZeroValueOnly: [{
                type: Input$1
            }], autocomplete: [{
                type: Input$1
            }], ariaAutocomplete: [{
                type: Input$1
            }], preventPaste: [{
                type: Input$1
            }], thousandsSeparator: [{
                type: Input$1
            }], decimalSeparator: [{
                type: Input$1
            }], precision: [{
                type: Input$1
            }], step: [{
                type: Input$1
            }], maxValue: [{
                type: Input$1
            }], minValue: [{
                type: Input$1
            }], maxFactor: [{
                type: Input$1
            }], maxFactorExceededMessage: [{
                type: Input$1
            }], currencySignAfter: [{
                type: Input$1
            }], currencySignBefore: [{
                type: Input$1
            }], ariaLabel: [{
                type: Input$1
            }], ariaLabelledById: [{
                type: Input$1
            }], idStr: [{
                type: Input$1
            }], name: [{
                type: Input$1
            }], label: [{
                type: Input$1
            }], selectLabel: [{
                type: Input$1
            }], placeholder: [{
                type: Input$1
            }], searchIcon: [{
                type: Input$1
            }], required: [{
                type: Input$1
            }], describedby: [{
                type: Input$1
            }], tabIndex: [{
                type: Input$1
            }], isCbolPassword: [{
                type: Input$1
            }], countryCode: [{
                type: Input$1
            }], countryCodeChange: [{
                type: Output
            }], countryCodes: [{
                type: Input$1
            }], areaCode: [{
                type: Input$1
            }], areaCodeChange: [{
                type: Output
            }], areaCodes: [{
                type: Input$1
            }], unmaskedLength: [{
                type: Input$1
            }], theme: [{
                type: Input$1
            }], applyMaskOnEvents: [{
                type: Input$1
            }], removeMaskOnEvents: [{
                type: Input$1
            }], isSuccess: [{
                type: Input$1
            }], successMessage: [{
                type: Input$1
            }], visibleLabel: [{
                type: Input$1
            }], hideMask: [{
                type: Input$1
            }], value: [{
                type: Input$1
            }], valueChange: [{
                type: Output
            }], hideToggle: [{
                type: Output
            }], focus: [{
                type: Input$1
            }], focusChange: [{
                type: Output
            }], blur: [{
                type: Output
            }], minLengthError: [{
                type: Input$1
            }], maxValueError: [{
                type: Input$1
            }], minValueError: [{
                type: Input$1
            }], maxLengthError: [{
                type: Input$1
            }], requiredError: [{
                type: Input$1
            }], messageOnlyNonZeroError: [{
                type: Input$1
            }], messageOnlyIntegerError: [{
                type: Input$1
            }], messageOnlyPositiveIntegerError: [{
                type: Input$1
            }], messageOnlyPhoneError: [{
                type: Input$1
            }], messageOnlyZipcodeError: [{
                type: Input$1
            }], messageOnlyEmailError: [{
                type: Input$1
            }], messageOnlyZipError: [{
                type: Input$1
            }], messageOnlySsnError: [{
                type: Input$1
            }], messageOnlyAreaCodeError: [{
                type: Input$1
            }], messageOnlyCountryCodeError: [{
                type: Input$1
            }], changeMessage: [{
                type: Input$1
            }], hasCustomError: [{
                type: Input$1
            }], customErrorMessage: [{
                type: Input$1
            }], error: [{
                type: Input$1
            }], errorChange: [{
                type: Output
            }], usePasswordOnAndroid: [{
                type: Input$1
            }], mask: [{
                type: Input$1
            }], hideShowButtonWhenMasked: [{
                type: Input$1
            }], showText: [{
                type: Input$1
            }], hideText: [{
                type: Input$1
            }], type: [{
                type: Input$1
            }], size: [{
                type: Input$1
            }], input: [{
                type: ViewChild,
                args: ['input']
            }], custom: [{
                type: ViewChild,
                args: [CustomInputMaskDirective]
            }], classRow: [{
                type: HostBinding,
                args: ['class.row']
            }] } });

// @dynamic
let nextUniqueId$7 = 0;
const DEFAULT_ERRORS = {
    required: 'Input is required',
    positive: 'Value must be positive',
    integer: 'Value must be an integer',
    phone: 'Invalid phone number',
    nonZero: 'value cannot be zero',
    email: 'Invalid email',
    zip: 'Invalid Zip Code',
    ssn: 'Invalid social security number',
    areaCode: 'Please select an area code',
    countryCode: 'Please select a country code'
};
const INPUT2_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => Input2Component4Q21),
    multi: true
};
// @dynamic
class Input2Component4Q21 {
    // #region - Properties: Static
    static { this.DEFAULT_MAXLENGTH = 524288; }
    static { this.VALIDATORS = {
        isEmail: (val) => /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(val),
        isNumber: (val) => !isNaN(val),
        isPositive: (val) => !isNaN(val) && parseFloat(val) > 0,
        isValue: (val) => !!val && val !== ''
    }; }
    static { this.VALID_TYPES = [
        'text',
        'password',
        'email',
        'number',
        'tel',
        'phone',
        'ssn',
        'zip'
    ]; }
    static { this.DEFAULT_MASKS = {
        phone: '(999) 999-9999',
        zipcode: '99999',
        ssn: '999-99-9999',
        partialSsnMasking: '*9*9*9-*9*9-9999',
        fullSsnMasking: '*9*9*9-*9*9-*9*9*9*9',
        partialPhoneMasking: '(*9*9*9)-*9*9*9-9999',
        fullZipcodeMasking: '*9*9*9*9*9',
        fullPhoneMasking: '(*9*9*9) *9*9*9-*9*9*9*9',
        creditCard: '9999 9999 9999 9999'
    }; }
    // Classes for the sizes of input, also applied to the wrapper
    static { this.SIZE_CLASSES = {
        fullwidth: 'col-xs-12',
        large: 'col-md-8 col-lg-8',
        medium: 'col-md-6 col-sm-9',
        small: 'col-md-4 col-sm-6',
        xsmall: 'col-md-2 col-sm-3 col-xs-6',
        none: ''
    }; }
    get idStr() { return this._id; }
    set idStr(value) { this._id = value || this._uid; }
    /**
     * How many character should not be masked at the end of the string, only applies to text masking
     */
    set unmaskedLength(value) {
        this._unmaskedLength = this._unmaskedViewLength = value;
    }
    get unmaskedLength() {
        return this._unmaskedViewLength;
    }
    // #endregion
    // #region - Two-way Bound values
    get hideMask() {
        return this.hideCharacters;
    }
    set hideMask(value) {
        this.hideCharacters = value;
    }
    /**
     * This focuses the input if set to true
     */
    set focus(isFocused) {
        isFocused ? this.onFocus() : this.onBlur();
    }
    ;
    // #endregion
    // #region - Setters
    /**
     * Text to be displayed when the input doesn't meet the required length
     */
    set minLengthError(message) {
        if (message)
            this.errors.minLength = message;
    }
    /**
     * Text to be displayed when the value exceed the provided maximum
     */
    set maxValueError(message) {
        if (message)
            this.errors.maxValue = message;
    }
    /**
     * Text to be displayed when the value exceed the provided maximum
     */
    set minValueError(message) {
        if (message)
            this.errors.minValue = message;
    }
    /**
     * Text to be displayed when the input exceed the maximum length
     */
    set maxLengthError(message) {
        if (message)
            this.errors.maxLength = message;
    }
    /**
     * Text to be displayed when the input is required and no value was entered
     */
    set requiredError(message) {
        this.errors.required = (!!message) ? message : DEFAULT_ERRORS.required;
    }
    /**
     * Text to be displayed when the value fails non-zero validation
     */
    set messageOnlyNonZeroError(message) {
        this.errors.nonZero = (!!message) ? message : DEFAULT_ERRORS.nonZero;
    }
    /**
     * Text to be displayed when the value fails only integer validation
     */
    set messageOnlyIntegerError(message) {
        this.errors.integer = (!!message) ? message : DEFAULT_ERRORS.integer;
    }
    /**
     * Text to be displayed when the value fails only positive integer validation
     */
    set messageOnlyPositiveIntegerError(message) {
        this.errors.positive = (!!message) ? message : DEFAULT_ERRORS.positive;
    }
    /**
     * Text to be displayed when no phone is provided
     */
    set messageOnlyPhoneError(message) {
        this.errors.phone = (!!message) ? message : DEFAULT_ERRORS.phone;
    }
    /**
     * Text to be displayed when no zipcode is provided
     */
    set messageOnlyZipcodeError(message) {
        this.errors.zipcode = (!!message) ? message : DEFAULT_ERRORS.zip;
    }
    /**
     * Text to be displayed when no email is provided
     */
    set messageOnlyEmailError(message) {
        this.errors.email = (!!message) ? message : DEFAULT_ERRORS.email;
    }
    /**
     * Text to be displayed when no zip is provided
     */
    set messageOnlyZipError(message) {
        this.errors.zip = (!!message) ? message : DEFAULT_ERRORS.zip;
    }
    /**
     * Text to be displayed when no SSN is provided
     */
    set messageOnlySsnError(message) {
        this.errors.ssn = (!!message) ? message : DEFAULT_ERRORS.ssn;
    }
    /**
     * Text to be displayed when no areaCode is provided
     */
    set messageOnlyAreaCodeError(message) {
        this.errors.areaCode = (!!message) ? message : DEFAULT_ERRORS.areaCode;
    }
    /**
     * Text to be displayed when no countryCode is provided
     */
    set messageOnlyCountryCodeError(message) {
        this.errors.countryCode = (!!message) ? message : DEFAULT_ERRORS.countryCode;
    }
    /**
     * allows users to customize any of the error messages
     */
    set changeMessage([errorType, msg]) {
        if (errorType && msg)
            this.errors[errorType] = msg;
    }
    set hasCustomError(useCustom) {
        this._hasCustomError = coerceBool(useCustom);
        if (this.error) {
            if (this._hasCustomError)
                this.errorMessage = this.errors.custom;
            else
                this.validate();
        }
    }
    /**
     * Customized error message for custom error
     * @Note: *this field need to be above the error setter to trigger initial error correctly
     */
    set customErrorMessage(message) {
        this.errors.custom = (!!message) ? message : 'Your Custom Error Message';
        if (this.error && this._hasCustomError)
            this.errorMessage = this.errors.custom;
    }
    set error(err) {
        if (err === this._error)
            return;
        if (err) {
            this.validationService.addError(this);
            this.errorMessage = this.errors['custom'] || 'Default Error. You should provide your own customErrorMessage';
        }
        this._error = err;
    }
    get error() {
        return this._error;
    }
    /**
     * Masking does not work on Android. This setting will set the input type to password on Android.
     */
    set usePasswordOnAndroid(usePass) {
        this._usePassOnAndroid = usePass;
        if (this.isAndroidDevice && usePass) {
            this.inputType = 'password';
        }
        else {
            this.inputType = this._inputType;
        }
    }
    ;
    get usePasswordOnAndroid() {
        return this._usePassOnAndroid;
    }
    /**
     * This defines the mask of the input, which changes the input text masking on character input.
     *  - 'fullZipcodeMasking'
     *  - 'fullPhoneMasking'
     *  - 'partialEmailMasking'
     *  - 'fullTextMasking'
     *  - 'partialTextMasking'
     * @defaults 'none'
     */
    set mask(mask) {
        this._storedMask = Input2Component4Q21.DEFAULT_MASKS[mask] || mask;
        // TODO: once Android 7 (Nougat) is no longer supported, we can fix this
        if (this.isAndroidDevice) {
            this.displayedInput = 'none';
            if (mask === 'dollar')
                this.inputType = 'number';
        }
        // selects the correct input and applied masking directive or lack there of
        else if (!mask || mask === 'none')
            this.displayedInput = 'none';
        else if (mask === 'dollar')
            this.displayedInput = 'dollar';
        else if (['partialEmailMasking', 'fullTextMasking', 'partialTextMasking'].includes(mask)) {
            this.displayedInput = 'partial';
            this._unmaskedViewLength = mask === 'fullTextMasking' ? 0 : this._unmaskedLength;
        }
        else
            this.displayedInput = 'custom';
        if (this.isPhantom)
            this.displayedInput = 'none';
        // look up the stroed masks if available
        this._appliedMask = Input2Component4Q21.DEFAULT_MASKS[mask] || mask;
    }
    get showHideMaskText() {
        return this.hideCharacters ? this.showText : this.hideText;
    }
    /**
     * This defines the type of the input, which changes which kind of input is displayed.
     * Mask must be set separately.
     * defaults to text.
     */
    set type(type) {
        if (type && Input2Component4Q21.VALID_TYPES.includes(type)) {
            this.inputType = type.includes('hone') ? 'tel' : type;
            this._inputType = this.inputType;
            if (this.isAndroidDevice && this.usePasswordOnAndroid) {
                this.inputType = 'password';
            }
        }
        else if (isDevMode)
            console.error('CITI-INPUT - TYPE: Caught \'' + type + '\'. Valid types are: ' + Input2Component4Q21.VALID_TYPES);
    }
    get type() {
        return this._inputType;
    }
    /**
     * This defines the size of the input, which changes the bootstrap classes.
     */
    set size(size) {
        if (!!size && Input2Component4Q21.SIZE_CLASSES[size] !== undefined) {
            this.inputSize = size;
            this.classRow = size === 'none' ? false : true;
        }
        else if (isDevMode) {
            console.error('CITI-INPUT - SIZE: Caught \'' + size + '\'. Valid sizes are: ' + Object.keys(Input2Component4Q21.SIZE_CLASSES));
        }
    }
    ;
    // #endregion
    // #region - Getters
    get hasValue() {
        return Input2Component4Q21.VALIDATORS.isValue(this.value);
    }
    get size() {
        return Input2Component4Q21.SIZE_CLASSES[this.inputSize];
    }
    get isCountryCodes() {
        return !!this.countryCodes && this.countryCodes.length > 0;
    }
    get isAreaCodes() {
        return !!this.areaCodes && this.areaCodes.length > 0;
    }
    get hasCurrencySignBefore() {
        return !!this.currencySignBefore && this.currencySignBefore !== '';
    }
    get labelOpacity() {
        return this.visibleLabel ? 1 : (this.value || this.isFocused || this.isSelectFocused || this.displayedInput === 'custom') ? 1 : 0;
    }
    get isAndroidDevice() {
        if (!this._navigator || !this._navigator.userAgent)
            return false;
        else
            return /(android)/i.test(this._navigator.userAgent);
    }
    get isMobile() {
        return !!this._isMobile;
    }
    get isPhantom() {
        if (!this._navigator || !this._navigator.userAgent)
            return false;
        else
            return /(PhantomJS)/i.test(this._navigator.userAgent);
    }
    // #endregion
    // #region - Life Cycle
    constructor(validationService, announcer, el, // added for Duracell
    _navigator) {
        this.validationService = validationService;
        this.announcer = announcer;
        this.el = el;
        this._navigator = _navigator;
        // #endregion
        // #region - Properties: Public
        // Default errors for the different validation error states
        this.errors = {
            required: DEFAULT_ERRORS.required,
            positive: DEFAULT_ERRORS.positive,
            integer: DEFAULT_ERRORS.integer,
            phone: DEFAULT_ERRORS.phone,
            zipcode: DEFAULT_ERRORS.zip,
            nonZero: DEFAULT_ERRORS.nonZero,
            email: DEFAULT_ERRORS.email,
            zip: DEFAULT_ERRORS.zip,
            ssn: DEFAULT_ERRORS.ssn,
            areaCode: DEFAULT_ERRORS.areaCode,
            countryCode: DEFAULT_ERRORS.countryCode,
        };
        this.shouldValidate = {
            number: () => this.inputType === 'number' || this._appliedMask === 'dollar',
            url: () => this.inputType === 'url',
            zip: () => this.inputType === 'zip',
            ssn: () => this.inputType === 'ssn' || this._appliedMask.toLowerCase().includes('ssn'),
            phone: () => this.inputType === 'tel' || this._appliedMask.toLowerCase().includes('phone'),
            email: () => this.inputType === 'email' || this._appliedMask.toLowerCase().includes('email'),
            minLength: () => !!this.minLength && ['text', 'email', 'password', 'none'].includes(this.inputType)
        };
        // Id for the label for aria
        this.labelId = null;
        // applys class to remove excess padding if there is a pre addon
        this.hasPreAddon = false;
        // error message to be displayed when an error is triggered
        this.errorMessage = 'Error';
        // whether the input is focused
        this.isFocused = false;
        // whether the select of the input is focused
        this.isSelectFocused = false;
        this._calledFromSubmit = false;
        // #endregion
        // #region - Inputs: Error Related
        /**
         * Whether the input should valid on 'blur' and 'change' events (always validates on submit)
         */
        this.validateOn = [];
        /**
         * The input only accepts alphabetical or numeric value
         */
        this.allowIntegerOnly = false;
        /**
         * This defines the maximum character length of the input
         */
        this.maxLength = Input2Component4Q21.DEFAULT_MAXLENGTH;
        /**
         * readonly field, displays its value and focusable
         */
        this.readOnly = false;
        /**
         * disables the field and not focusable
         */
        this.disabled = false;
        /**
         * non-masked text fields this limits characters to numbers
         */
        this.typeNumbersOnly = false;
        /**
         * Enables/disables non zero validation
         */
        this.allowNonZeroValueOnly = false;
        // #endregion
        /**
         * Turns on/off the autocomplete feature of an input. Default value is 'off'.
         * @Two-way: false
         */
        this.autocomplete = 'off';
        /**
         * prevents all paste events
         */
        this.preventPaste = false;
        // #region - Inputs: Dollar mask
        /**
         * string to seperate the thousands position
         */
        this.thousandsSeparator = ',';
        /**
         * string to seperate the decimal position
         */
        this.decimalSeparator = '.';
        /**
         * number of digits allowed after the decimal
         */
        this.precision = 2;
        /**
         * max value allowed without throughing an error
         */
        this.maxValue = Number.MAX_SAFE_INTEGER;
        /**
         * Message to inform ADA users that the typed character surpassed the maxFactor and was not added to the input value
         */
        this.maxFactorExceededMessage = 'Maximum Factor Exceeded. Last number was not added';
        // #endregion
        // #region - Inputs: Global Properties
        /**
         * Label for aria-label tag if special aria label is needed
         */
        this.ariaLabel = false;
        this._uid = `citi-input2-${nextUniqueId$7++}`;
        /**
         * This defines the name of the input
         */
        this.name = null;
        /**
         * Show a search icon add-on in the input.
         */
        this.searchIcon = false;
        /**
         * Sets the tabindex attribute
         */
        this.tabIndex = 0;
        /**
         * Sets the isCbolPassword attribute
         */
        this.isCbolPassword = false;
        this.countryCodeChange = new EventEmitter();
        this.countryCodes = [];
        this.areaCodeChange = new EventEmitter();
        this.areaCodes = [];
        this._unmaskedLength = 4;
        this._unmaskedViewLength = 4;
        // #endregion
        // #region - Inputs: Masking / Unmasking events
        /**
         * A list of HTML event to activate the masking on the content
         */
        this.applyMaskOnEvents = [];
        /**
         * A list of HTML event to remove the mask from the value
         */
        this.removeMaskOnEvents = [];
        // #endregion
        // #region - Inputs: Success related
        /**
         * This defines the success state on the input
         */
        this.isSuccess = false;
        /**
         * Customized success message for valid password input
         */
        this.successMessage = '';
        /**
        * Input for visibleLabel for the label
        */
        this.visibleLabel = false;
        /**
         * This defines the value of the input. Can be two-way bound through [(value)]='myValueVar'
         */
        this.value = undefined;
        this.valueChange = new EventEmitter();
        this.hideToggle = new EventEmitter();
        this.focusChange = new EventEmitter();
        // #endregion
        // #region - Outputs
        /**
         * emits when the focus is blured
         */
        this.blur = new EventEmitter();
        /*
        * This defines the custom error state of the input. Takes precedence over other validation types.
        */
        this._hasCustomError = false;
        /**
         * This defines the error state on the input
         */
        this._error = false;
        this.errorChange = new EventEmitter();
        this._appliedMask = 'none';
        this._storedMask = 'none';
        this.displayedInput = 'none';
        this.hideCharacters = true;
        /**
         * text of the show (unmask) button
         */
        this.showText = 'Show';
        /**
         * text of the hide (mask) button
         */
        this.hideText = 'Hide';
        this.inputType = 'text';
        this.inputSize = 'fullwidth';
        this.classRow = true;
        // #endregion
        // #region - FORM BINDING METHODS
        // All methods below are required for the Value Control Accessor interface to work with [(ngModel)]
        this.onChange = (value) => { };
        this.onTouched = () => { };
    }
    ngOnInit() {
        // Detects mobile device
        if (this._navigator)
            this._isMobile = this._navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i);
        // ensures that an id is assigned
        this.idStr = this.idStr;
        // register and subscribe to validation service
        this.validationService.addInput(this);
        this.validateSub = this.validationService.validateNow.subscribe(() => {
            this._calledFromSubmit = true;
            this.validate();
        });
        this.labelId = Input2Component4Q21.VALIDATORS.isValue(this._id) ? this._id + '-label' : null;
        if (this.hasCurrencySignBefore || this.isCountryCodes || this.isAreaCodes)
            this.hasPreAddon = true;
        this.setDynamicMessages();
        if (this.countryCode) {
            const codeOption = this.countryCodes.find(code => code.value === this.countryCode);
            if (codeOption)
                this.mask = codeOption.mask || this._storedMask;
        }
    }
    ngOnDestroy() {
        this.validationService.removeError(this);
        if (this.validateSub)
            this.validateSub.unsubscribe();
    }
    // #endregion
    // #region - Event Listeners and handlers
    /**
     * Updates the ui to responsd to a focus event
     * This does not cast focus. Use "focusInput()" for that
     */
    onFocus() {
        if (this.isFocused)
            return;
        if (this.safeIncludes(this.removeMaskOnEvents, 'focus'))
            this.hideCharacters = false;
        this.isFocused = true;
        this.isSelectFocused = false;
        this.focusChange.emit(true);
    }
    /**
     * Casts focus to the native <input> element
     */
    focusInput() {
        this.input.nativeElement.focus();
    }
    ;
    onBlur() {
        if (!this.isFocused)
            return;
        if (this.safeIncludes(this.applyMaskOnEvents, 'blur'))
            this.hideCharacters = true;
        if (this.safeIncludes(this.validateOn, 'blur'))
            this.validate();
        this.isFocused = false;
        this.blur.emit();
        this.focusChange.emit(false);
        this.onTouched(); // registers
    }
    onPaste(e) {
        if (this.preventPaste)
            e.preventDefault();
    }
    onInputChange() {
        if (this.safeIncludes(this.validateOn, 'change'))
            this.validate();
    }
    onInput() {
        if (this.safeIncludes(this.validateOn, 'input'))
            this.validate();
    }
    onSelectFocus() {
        if (this.readOnly)
            this.announcer.announce(`${this.selectLabel} combo box read only`);
        if (this.isSelectFocused === true)
            return;
        this.isSelectFocused = true;
    }
    preventCharacters(e) {
        if (!this.typeNumbersOnly)
            return;
        if (e.key === 'TAB' || e.code === 'TAB')
            return;
        if (e.shiftKey && e.keyCode === 9)
            return;
        if (e.shiftKey || e.which > 57 || ['.', ',', '/', '\'', '-'].includes(e.key))
            e.preventDefault();
    }
    // #endregion
    // #region - Methods: Masking
    // updates the mask from the template when the area or coutry code changes and requires a new mask
    updateMask(selected) {
        if (this.isAreaCodes)
            this.areaCodeChange.emit(selected);
        if (this.isCountryCodes)
            this.countryCodeChange.emit(selected);
        const options = this.countryCodes.length > 0 ? this.countryCodes : this.areaCodes;
        const mask = options.find(option => option.value === selected).mask;
        if (!!mask)
            this.mask = mask;
    }
    writeValueAndValidate(value) {
        this.writeValue(value);
        if (this.safeIncludes(this.validateOn, 'input'))
            this.validate();
    }
    // #endregion
    // #region - Methods: Validation
    setDynamicMessages() {
        const dynamicMessage = {
            minLength: this.minLengthError || `Input length must exceed ${this.minLength - 1} characters`,
            maxLength: this.maxLengthError || `Input length may not exceed ${this.maxLength} characters`,
            maxFactor: this.maxFactorExceededMessage || `Input value cannot exceed ${this.maxFactor} digits before the decimal`,
            custom: this.customErrorMessage
        };
        if (this.maxValue)
            dynamicMessage.maxValue = 'Value cannot exceed ' + this.formatDollar(this.maxValue);
        if (this.minValue)
            dynamicMessage.minValue = 'Value cannot subceed ' + this.formatDollar(this.minValue);
        this.errors = Object.assign(dynamicMessage, this.errors);
    }
    // only used for error messages, not for formatting the input field
    formatDollar(number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    // Clears an error state on the input. Takes a type of error
    toggleError(errorType, error) {
        // Clear the error state
        this._error = error;
        this.errorType = errorType;
        this.errorChange.emit(error);
        if (error) {
            // override message for customer errors
            if (this._hasCustomError)
                errorType = 'custom';
            // set the error message
            this.errorMessage = (!!errorType) ? this.errors[errorType] : '';
            this.validationService.addError(this);
        }
        else
            this.validationService.removeError(this);
    }
    validate() {
        this._isErrorHidden = true;
        setTimeout(() => {
            this._isErrorHidden = false;
        }, 200);
        if (this.required && !Input2Component4Q21.VALIDATORS.isValue(this.value) && this.value !== 0) {
            this.toggleError('required', true);
            return;
        }
        if (this.isCbolPassword) {
            this.toggleError('custom', this.error);
            return;
        }
        if (this.shouldValidate.minLength() && (!this.value || this.minLength > this.value.length)) {
            this.toggleError('minLength', true);
            return;
        }
        if (this.shouldValidate.number())
            this.validateNumber(); // and dollar & currency
        else if (this.shouldValidate.zip())
            this.validateZip();
        else if (this.shouldValidate.email())
            this.validateEmail();
        else if (this.shouldValidate.ssn())
            this.validateSSN();
        else if (this.shouldValidate.phone())
            this.validatePhone();
        else
            this.toggleError(null, false);
    }
    // and dollar-currency
    validateNumber() {
        const newValue = parseFloat(this.value);
        if (this.allowIntegerOnly && !Number.isInteger(newValue))
            this.toggleError('integer', true);
        else if (this.allowNonZeroValueOnly && newValue === 0)
            this.toggleError('nonZero', true);
        else if (this.allowPositiveIntegerOnly && (!Number.isInteger(newValue) || newValue <= 0))
            this.toggleError('positive', true);
        else if (!!this.maxValue && newValue > this.maxValue)
            this.toggleError('maxValue', true);
        else if (!!this.minValue && newValue < this.minValue)
            this.toggleError('minValue', true);
        else if (!!this.maxFactor && this.value > Math.pow(10, this.maxFactor + 1))
            this.toggleError('maxFactor', true);
        else
            this.toggleError(null, false);
    }
    validateEmail() {
        if (this.value && this.value.length > 0 && !Input2Component4Q21.VALIDATORS.isEmail(this.value))
            this.toggleError('email', true);
        else
            this.toggleError(null, false);
    }
    validateSSN() {
        const newValue = parseFloat(this.value);
        if (this.value && this.value.length > 0 && (this.value.length !== 9 || !Number.isInteger(newValue)))
            this.toggleError('ssn', true);
        else
            this.toggleError(null, false);
    }
    validateZip() {
        // strip off all non-numeric values from the mask to determine the number of characters
        const requiredLength = this._appliedMask.replace(/[^0-9]/g, '').length;
        if (this.value && this.value.length > 0 && (!this.value || requiredLength !== this.value.length))
            this.toggleError('zip', true);
        else
            this.toggleError(null, false);
    }
    validatePhone() {
        // strip off all non-numeric values from the mask to determine the number of characters
        const hasBlanks = this._appliedMask.replace(/[^0-9]/g, '').length !== this.value.length;
        const isNull = !this.value || this.value.length === 0;
        if (this._appliedMask !== 'none' && (hasBlanks && this.required || !isNull && hasBlanks))
            this.toggleError('phone', true);
        else if (this.selectAddonIsValid(this.countryCodes, this.countryCode))
            this.toggleError('countryCode', true);
        else if (this.selectAddonIsValid(this.areaCodes, this.areaCode))
            this.toggleError('areaCode', true);
        else
            this.toggleError(null, false);
    }
    selectAddonIsValid(options, value) {
        return this.required && !value && options && options.length > 0;
    }
    safeIncludes(array, value) {
        return array && array.length && array.includes(value);
    }
    /**
     * @Function: reset
     * Resets the apperance and state of the input to initial
     * @Return: void
     */
    reset() {
        this.toggleError(null, false);
        this.value = null;
    }
    // #endregion
    // #region - Methods:
    get describedByID() {
        let describedBy = '';
        if (this.describedby) {
            describedBy = this.describedby;
        }
        if (this.error) {
            describedBy += ` ${this._id}-error`;
        }
        if (this.isSuccess) {
            describedBy += ` ${this._id}-success`;
        }
        return describedBy;
    }
    getAriaLabelString() {
        if (this.hasValue && this.readOnly)
            return null;
        const resultString = this.label || this.placeholder;
        if (!this.ariaLabel || !Input2Component4Q21.VALIDATORS.isValue(resultString))
            return '';
        else
            return resultString;
    }
    getAriaLabelledBy() {
        if (!!this.ariaLabelledById)
            return this.ariaLabelledById;
        else if ((!this.hasValue || !this.readOnly) && !(this.isAreaCodes || this.isCountryCodes))
            return this.labelId;
        else
            return null;
    }
    get labeltext() {
        return this.label || this.placeholder;
    }
    get selectLabeltext() {
        return this.selectLabel || this.label || this.placeholder;
    }
    showhideMaskcheck(e) {
        this.hideCharacters = !this.hideCharacters;
        this.announcer.announce(`${this.hideCharacters ? `${this.showText} Button` : `${this.hideText} Button`}`);
    }
    /**
     * @Method: showhideMaskcheckKeyboard
     * This method gets called when enter key is pressed on the hide/show button
     */
    showhideMaskcheckKeyboard(e) {
        if (e.keyCode === 13)
            this.showhideMaskcheck(e);
    }
    // Allows Angular to update the model.
    // Update the model and changes needed for the view here.
    writeValue(value) {
        this.value = value;
        this.valueChange.emit(value);
        //      !!!!    WARNING: DO NOT REMOVE    !!!!
        // this is actually necessary for ngModel to update
        this.onChange(this.value);
    }
    // Allows Angular to register a function to call when the model changes.
    // Save the function as a property to call later here.
    registerOnChange(fn) {
        this.onChange = fn;
    }
    // Allows Angular to register a function to call when the input has been touched.
    // Save the function as a property to call later here.
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    // Allows Angular to disable the input.
    setDisabledState(isDisabled) {
        this.readOnly = isDisabled;
    }
    // Disable keyboard click for select when readonly is true
    onSelectKeyDown(event) {
        if (!this.readOnly)
            return;
        let index = -1;
        const keyCodes = [32, 13, 33, 34, 38, 40, 37, 39];
        index = keyCodes.findIndex(item => item === event.keyCode);
        return (index !== -1 ? false : null);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Input2Component4Q21, deps: [{ token: ValidationService }, { token: CitiLiveAnnouncer }, { token: i0.ElementRef }, { token: NAVIGATOR }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: Input2Component4Q21, isStandalone: false, selector: "citi-input2.4Q21", inputs: { validateOn: "validateOn", allowIntegerOnly: "allowIntegerOnly", maxLength: "maxLength", allowPositiveIntegerOnly: "allowPositiveIntegerOnly", minLength: "minLength", readOnly: "readOnly", disabled: "disabled", typeNumbersOnly: "typeNumbersOnly", allowNonZeroValueOnly: "allowNonZeroValueOnly", autocomplete: "autocomplete", ariaAutocomplete: "ariaAutocomplete", preventPaste: "preventPaste", thousandsSeparator: "thousandsSeparator", decimalSeparator: "decimalSeparator", precision: "precision", step: "step", maxValue: "maxValue", minValue: "minValue", maxFactor: "maxFactor", maxFactorExceededMessage: "maxFactorExceededMessage", currencySignAfter: "currencySignAfter", currencySignBefore: "currencySignBefore", ariaLabel: "ariaLabel", ariaLabelledById: "ariaLabelledById", ariaGroupLabel: "ariaGroupLabel", idStr: "idStr", name: "name", label: "label", selectLabel: "selectLabel", placeholder: "placeholder", searchIcon: "searchIcon", required: "required", describedby: "describedby", tabIndex: "tabIndex", isCbolPassword: "isCbolPassword", countryCode: "countryCode", countryCodes: "countryCodes", areaCode: "areaCode", areaCodes: "areaCodes", unmaskedLength: "unmaskedLength", theme: "theme", applyMaskOnEvents: "applyMaskOnEvents", removeMaskOnEvents: "removeMaskOnEvents", isSuccess: "isSuccess", successMessage: "successMessage", visibleLabel: "visibleLabel", hideMask: "hideMask", value: "value", focus: "focus", minLengthError: "minLengthError", maxValueError: "maxValueError", minValueError: "minValueError", maxLengthError: "maxLengthError", requiredError: "requiredError", messageOnlyNonZeroError: "messageOnlyNonZeroError", messageOnlyIntegerError: "messageOnlyIntegerError", messageOnlyPositiveIntegerError: "messageOnlyPositiveIntegerError", messageOnlyPhoneError: "messageOnlyPhoneError", messageOnlyZipcodeError: "messageOnlyZipcodeError", messageOnlyEmailError: "messageOnlyEmailError", messageOnlyZipError: "messageOnlyZipError", messageOnlySsnError: "messageOnlySsnError", messageOnlyAreaCodeError: "messageOnlyAreaCodeError", messageOnlyCountryCodeError: "messageOnlyCountryCodeError", changeMessage: "changeMessage", hasCustomError: "hasCustomError", customErrorMessage: "customErrorMessage", error: "error", usePasswordOnAndroid: "usePasswordOnAndroid", mask: "mask", hideShowButtonWhenMasked: "hideShowButtonWhenMasked", showText: "showText", hideText: "hideText", type: "type", size: "size" }, outputs: { countryCodeChange: "countryCodeChange", areaCodeChange: "areaCodeChange", valueChange: "valueChange", hideToggle: "hideToggle", focusChange: "focusChange", blur: "blur", errorChange: "errorChange" }, host: { properties: { "class.row": "this.classRow" }, classAttribute: "citi-input2" }, providers: [INPUT2_VALUE_ACCESSOR], viewQueries: [{ propertyName: "input", first: true, predicate: ["input"], descendants: true }, { propertyName: "custom", first: true, predicate: CustomInputMaskDirective, descendants: true }], ngImport: i0, template: `
    <div class="form-control-container {{theme}}" [ngClass]="size" [attr.role]="(isAreaCodes || isCountryCodes) ? 'group' : null"
      [attr.aria-labelledby]="((isAreaCodes || isCountryCodes) ? labelId : null)"  >
      <!-- label for the input with group -->
      <label *ngIf="(isAreaCodes || isCountryCodes)" [id]="labelId" tabIndex="-1"
        [ngStyle]="{'opacity': labelOpacity}"
          [innerHtml]="ariaGroupLabel"></label>
      <!-- label for the input, will switch text to select element's label when that element is focused -->
      <label *ngIf="!(isAreaCodes || isCountryCodes)" [for]="_id" [id]="labelId" tabIndex="-1"
        [ngStyle]="{'opacity': labelOpacity}"
          [innerHtml]="(isSelectFocused ? selectLabeltext : labeltext)"></label>
      <!-- input wapper (all borders) -->
      <div class="input-container"
        [ngClass]="{
          'focused': isFocused,
          'errored': _error,
          'has-pre-addon': hasPreAddon,
          'readOnly': readOnly,
          'disabled': disabled,
          'success': isSuccess
        }">
        <!-- Add-ons Pre -->
        <div class="add-on-pre">
          <!-- Phone Area Code Selector -->
          <select *ngIf="isAreaCodes"
            [attr.name]="name"
            class="form-control"
            (change)="updateMask($event.target.value)"
            [attr.aria-label]="selectLabeltext"
            (focus)="onSelectFocus()"
            [disabled]="disabled"
            (keydown)="onSelectKeyDown($event)"
            [ngClass]="{
              'disabled': disabled,
              'readOnly': readOnly
            }">
            <option *ngFor="let code of areaCodes" [value]="code.value" [innerHtml]="code.label" [attr.selected]="(code.selected === true ? true : null)"></option>
          </select>
          <!-- Phone Country Prefix Selector -->
          <select *ngIf="isCountryCodes"
            [attr.name]="name"
            (change)="updateMask($event.target.value)"
            class="form-control"
            [attr.aria-label]="selectLabeltext"
            (focus)="onSelectFocus()"
            [disabled]="disabled"
            (keydown)="onSelectKeyDown($event)"
            [ngClass]="{
              'disabled': disabled,
              'readOnly': readOnly
            }">
            <option *ngFor="let code of countryCodes" [value]="code.value" [innerHtml]="code.label" [attr.selected]="(code.selected === true ? true : null)"></option>
          </select>
          <span *ngIf="currencySignBefore" class="input-group-addon before">{{currencySignBefore}}</span>
        </div>
        <!-- The Inputs managed by a switch statement -->
        <div [ngSwitch]="displayedInput" class="input-switch-wrapper">
          <!-- Custom Mask -->
          <input
            *ngSwitchCase="'custom'"
            #input
            #custom="custom"
            [attr.type]="(inputType == 'tel' ? 'tel' : 'text')"
            [custom-mask]="_appliedMask"
            [hideCharacters]="hideCharacters"
            [unmaskedValue]="value"
            (unmaskedValueChange)="writeValue($event)"
            [attr.id]="_id"
            [attr.name]="name"
            [readonly]="readOnly"
            [disabled]="disabled"
            [ngClass]="{
              'disabled': disabled,
              'readOnly': readOnly
            }"
            [attr.tabindex]="tabIndex"
            (focus)="onFocus()"
            (blur)="onBlur()"
            (change)="onInputChange()"
            (input)="onInput()"
            [attr.aria-autocomplete]="ariaAutocomplete"
            [attr.autocomplete]="autocomplete"
            [attr.aria-label]="getAriaLabelString()"
            [attr.aria-labelledby]="getAriaLabelledBy()"
            [attr.placeholder]="placeholder"
            [attr.aria-required]="(required ? true : null)"
            [attr.aria-invalid]="(_error ? true : null)"
            [attr.aria-describedby]="describedByID"
          />
          <!-- Dollar Mask -->
          <input
            *ngSwitchCase="'dollar'"
            #input
            type="text"
            currency-mask
            [unmaskedValue]="value"
            (unmaskedValueChange)="writeValueAndValidate($event)"
            [thousandsSeparator]="thousandsSeparator"
            [decimalSeparator]="decimalSeparator"
            [maxFactor]="maxFactor"
            [precision]="precision"
            [preventPaste]="preventPaste"
            [maxFactorExceededMessage]="maxFactorExceededMessage"
            [attr.id]="_id"
            [attr.name]="name"
            [attr.tabindex]="tabIndex"
            [attr.placeholder]="placeholder"
            [readonly]="readOnly"
            [disabled]="disabled"
            [ngClass]="{
              'disabled': disabled,
              'readOnly': readOnly
            }"
            (focus)="onFocus()"
            (blur)="onBlur()"
            (change)="onInputChange()"
            (input)="onInput()"
            [attr.aria-autocomplete]="ariaAutocomplete"
            [attr.autocomplete]="autocomplete"
            [attr.aria-invalid]="(_error ? true : null)"
            [attr.aria-label]="getAriaLabelString()"
            [attr.aria-labelledby]="getAriaLabelledBy()"
            [attr.aria-required]="(required ? true : null)"
            [attr.aria-describedby]="describedByID"
          />
          <!-- Partial Mask -->
          <input
            *ngSwitchCase="'partial'"
            #input
            type="text"
            [partial-mask]="_appliedMask"
            [hideCharacters]="hideCharacters"
            [unmaskedValue]="value"
            (unmaskedValueChange)="writeValue($event)"
            [unmaskedLength]="_unmaskedViewLength"
            [maxLength]="maxLength"
            [preventPaste]="preventPaste"
            [numbersOnly]="typeNumbersOnly"
            [attr.id]="_id"
            [attr.name]="name"
            [readonly]="readOnly"
            [disabled]="disabled"
            [ngClass]="{
              'disabled': disabled,
              'readOnly': readOnly
            }"
            [attr.tabindex]="tabIndex"
            [attr.placeholder]="placeholder"
            (focus)="onFocus()"
            (blur)="onBlur()"
            (change)="onInputChange()"
            (input)="onInput()"
            [attr.aria-autocomplete]="(ariaAutocomplete ? ariaAutocomplete : null)"
            [attr.autocomplete]="(autocomplete ? autocomplete : null)"
            [attr.aria-required]="(required ? true : null)"
            [attr.aria-label]="getAriaLabelString()"
            [attr.aria-labelledby]="getAriaLabelledBy()"
            [attr.aria-invalid]="(_error ? true : null)"
            [attr.aria-describedby]="describedByID"
          />
          <!-- No Mask -->
          <input
            *ngSwitchCase="'none'"
            #input
            [ngModel]="value"
            [attr.type]="inputType"
            (ngModelChange)="writeValue($event)"
            [attr.id]="_id"
            [attr.name]="name"
            [attr.step]="step"
            [attr.tabindex]="tabIndex"
            [attr.placeholder]="placeholder"
            [attr.maxlength]="maxLength"
            autocapitalize="none"
            [readonly]="readOnly"
            [disabled]="disabled"
            [ngClass]="{
              'disabled': disabled,
              'readOnly': readOnly
            }"
            (keypress)="preventCharacters($event)"
            (focus)="onFocus()"
            (blur)="onBlur()"
            (change)="onInputChange()"
            (input)="onInput()"
            (paste)="onPaste($event)"
            [attr.aria-autocomplete]="ariaAutocomplete"
            [attr.autocomplete]="autocomplete"
            [attr.aria-required]="(required ? true : null)"
            [attr.aria-invalid]="(_error ? true : null)"
            [attr.aria-labelledby]="getAriaLabelledBy()"
            [attr.aria-label]="getAriaLabelString()"
            [attr.aria-describedby]="describedByID"
          />

        </div>
        <div class="add-on-post">
         <button
            #button1
            type=button
            *ngIf="hideShowButtonWhenMasked && value"
            class="input-group-addon showHideMask"
            (click)="showhideMaskcheck($event)"
            [disabled]="disabled"
            [ngClass]="{'disabled': disabled}"
            >
            {{showHideMaskText}}
      </button>
          <citi-icon2
            *ngIf="searchIcon"
            name="006-search"
            idStr="inputSearchIconId"
            shade="dark"
            [svgStyle]="{'width.px': 50, 'height.px': 50}"
            ariaLabel="icon">
          </citi-icon2>
          <span *ngIf="currencySignAfter" class="input-group-addon after">{{currencySignAfter}}</span>
        </div>
      </div>

      <div
        [attr.id]="_id+'-error'"
        class="validation-message-danger"
        *ngIf="_error && !_isErrorHidden"
        [innerHtml]="errorMessage"
        role="alert"
      ></div>
      <div class="input-success" *ngIf="!_error && isSuccess">
        <span [attr.id]="_id+'-success'" class="validation-message-success">{{successMessage}}</span>
      </div>
    </div>
  `, isInline: true, styles: [":host{display:block}label{font-size:.75rem;color:#666;width:100%;pointer-events:none;transition:opacity ease-in-out 225ms}.input-container{width:100%;margin:3px 0 5px;box-sizing:border-box;-moz-box-sizing:border-box;display:flex;-moz-flex-direction:row;flex-direction:row;flex-wrap:nowrap;justify-content:flex-start;align-content:stretch;align-items:flex-start;border-radius:8px;background:#eee;border:1px solid transparent;border:.9px solid transparent}.input-container.focused{border-color:#056dae}.input-container.focused input::placeholder{opacity:0}.input-container.errored{border-color:#d60000}.input-container.errored.focused{width:calc(100% + 2px);border-width:1.99px;margin:2px 0 4px -1px}.input-container.success{border-color:#006e0a}.input-container.success.focused{width:calc(100% + 2px);border-width:1.99px;margin:2px 0 4px -1px}.input-container.readOnly{background:#fff;border:1px solid #666}.input-container.readOnly input.readOnly:read-only,.input-container.readOnly select,.input-container.readOnly span{background-color:#fff}.input-container.readOnly button.input-group-addon{background-color:#eee}.input-container.readOnly.focused:not(.has-pre-addon){outline:1px solid #056DAE}.input-container.disabled{background-color:#ccc;border:1px solid #CCC}.input-container.disabled input.disabled:disabled,.input-container.disabled select,.input-container.disabled span{background-color:#ccc}.input-container.has-pre-addon .input-switch-wrapper{margin:0}.input-container.has-pre-addon.focused:not(.readOnly){border-color:transparent}.input-container.has-pre-addon.focused .input-switch-wrapper{border-radius:0 8px 8px 0;outline:1px solid #056DAE}.input-container.has-pre-addon input{padding-left:0!important}.input-container .input-group-addon{width:auto;background-color:#fff}.input-container .input-group-addon.before{border-top-left-radius:8px;border-bottom-left-radius:8px;border-right:1px solid #6B6B6B}.input-container .input-group-addon.before,.input-container .input-group-addon.after{width:48px;height:48px}.input-container .input-group-addon.after{border-top-right-radius:8px;border-bottom-right-radius:8px;border-left:1px solid #6B6B6B}.input-container .add-on-pre{order:0;flex:0 1 auto;align-self:auto;box-sizing:border-box;-moz-box-sizing:border-box}.input-container .add-on-pre select{margin:0 2px 0 0;height:48px;width:105px;border:1px solid transparent;border-top-right-radius:0;border-bottom-right-radius:0}.input-container .add-on-pre select:focus{outline:1px solid #056DAE}.input-container .input-switch-wrapper{flex:1 1 0%;box-sizing:border-box;-moz-box-sizing:border-box;margin:0 2px;border-radius:8px}.input-container .input-switch-wrapper input{width:100%;box-sizing:border-box;-moz-box-sizing:border-box;letter-spacing:.5px;height:48px;padding:10px 20px;background:#eee;border:none!important;box-shadow:none;border-radius:8px}.input-container .input-switch-wrapper input::-ms-clear{display:none}.input-container .input-switch-wrapper input:focus{outline:none}.input-container .add-on-post{flex:0 1 auto;box-sizing:border-box;-moz-box-sizing:border-box}.input-container .add-on-post .search{width:50px;padding-top:12px;border-radius:8px}.input-container .add-on-post .showHideMask{min-width:50px;border-radius:8px;padding:17px 10px;color:#056dae;font-family:Interstate_Bold,sans-serif;line-height:14px;cursor:pointer;font-size:12px;margin-left:2px}.input-container .add-on-post .showHideMask.disabled{background-color:#ccc;border:1px solid #CCC;color:#333;cursor:context-menu}.input-container .add-on-post .showHideMask.disabled button.disabled:disabled{background-color:#ccc}.input-error,.input-success{height:16px;width:100%;float:left}.input-success .validation-message-success{font-size:12px;font-family:Interstate_Bold,sans-serif;margin:0;color:#006e0a;font-weight:700;position:relative;display:block;line-height:1rem;font-size:.75rem}:host .light .input-container{background:#fff}:host .light .input-container input,:host .light .input-container select,:host .light .input-container span{background-color:#fff}:host .light .input-container.readOnly{background:#eee}:host .light .input-container.readOnly input,:host .light .input-container.readOnly select,:host .light .input-container.readOnly span{background-color:#eee}:host .light .input-container.readOnly button.input-group-addon{background-color:#fff}:host .light .input-container .input-group-addon{background-color:#eee}:host ::ng-deep #inputSearchIconId path{fill:#056dae}.form-control.disabled{background-color:#ccc;border:1px solid #CCC;color:#333;cursor:context-menu}.form-control.disabled button.disabled:disabled{background-color:#ccc}select.form-control{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%20standalone%3D%22no%22%3F%3E%0A%3Csvg%20width%3D%2215px%22%20height%3D%228px%22%20viewBox%3D%220%200%2015%208%22%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20xmlns%3Asketch%3D%22http%3A//www.bohemiancoding.com/sketch/ns%22%3E%0A%20%20%20%20%3C%21--%20Generator%3A%20Sketch%203.4.1%20%2815681%29%20-%20http%3A//www.bohemiancoding.com/sketch%20--%3E%0A%20%20%20%20%3Ctitle%3EChevron%3C/title%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C/desc%3E%0A%20%20%20%20%3Cdefs%3E%3C/defs%3E%0A%20%20%20%20%3Cg%20id%3D%22Toolkit%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20sketch%3Atype%3D%22MSPage%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Dropdowns%22%20sketch%3Atype%3D%22MSArtboardGroup%22%20transform%3D%22translate%28-878.000000%2C%20-122.000000%29%22%20fill%3D%22%23056DAE%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Dropdown-Grey%22%20sketch%3Atype%3D%22MSLayerGroup%22%20transform%3D%22translate%28570.000000%2C%20101.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Dropdown-Default%22%20sketch%3Atype%3D%22MSShapeGroup%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M312%2C32%20L312%2C29.6917048%20L316.989689%2C25.0246591%20L312%2C20.3577556%20L312%2C18%20L318.461538%2C24.1555486%20L318.461538%2C25.8443093%20L312%2C32%22%20id%3D%22Chevron%22%20transform%3D%22translate%28315.230769%2C%2025.000000%29%20rotate%28-270.000000%29%20translate%28-315.230769%2C%20-25.000000%29%20%22%3E%3C/path%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%3C/g%3E%0A%3C/svg%3E);background-repeat:no-repeat}select.form-control.disabled{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%20standalone%3D%22no%22%3F%3E%0A%3Csvg%20width%3D%2215px%22%20height%3D%228px%22%20viewBox%3D%220%200%2015%208%22%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20xmlns%3Asketch%3D%22http%3A//www.bohemiancoding.com/sketch/ns%22%3E%0A%20%20%20%20%3C%21--%20Generator%3A%20Sketch%203.4.1%20%2815681%29%20-%20http%3A//www.bohemiancoding.com/sketch%20--%3E%0A%20%20%20%20%3Ctitle%3EChevron%3C/title%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C/desc%3E%0A%20%20%20%20%3Cdefs%3E%3C/defs%3E%0A%20%20%20%20%3Cg%20id%3D%22Toolkit%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20sketch%3Atype%3D%22MSPage%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Dropdowns%22%20sketch%3Atype%3D%22MSArtboardGroup%22%20transform%3D%22translate%28-878.000000%2C%20-122.000000%29%22%20fill%3D%22%23333333%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Dropdown-Grey%22%20sketch%3Atype%3D%22MSLayerGroup%22%20transform%3D%22translate%28570.000000%2C%20101.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Dropdown-Default%22%20sketch%3Atype%3D%22MSShapeGroup%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M312%2C32%20L312%2C29.6917048%20L316.989689%2C25.0246591%20L312%2C20.3577556%20L312%2C18%20L318.461538%2C24.1555486%20L318.461538%2C25.8443093%20L312%2C32%22%20id%3D%22Chevron%22%20transform%3D%22translate%28315.230769%2C%2025.000000%29%20rotate%28-270.000000%29%20translate%28-315.230769%2C%20-25.000000%29%20%22%3E%3C/path%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%3C/g%3E%0A%3C/svg%3E);background-repeat:no-repeat}select.form-control.readOnly{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%20standalone%3D%22no%22%3F%3E%0A%3Csvg%20width%3D%2215px%22%20height%3D%228px%22%20viewBox%3D%220%200%2015%208%22%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20xmlns%3Asketch%3D%22http%3A//www.bohemiancoding.com/sketch/ns%22%3E%0A%20%20%20%20%3C%21--%20Generator%3A%20Sketch%203.4.1%20%2815681%29%20-%20http%3A//www.bohemiancoding.com/sketch%20--%3E%0A%20%20%20%20%3Ctitle%3EChevron%3C/title%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C/desc%3E%0A%20%20%20%20%3Cdefs%3E%3C/defs%3E%0A%20%20%20%20%3Cg%20id%3D%22Toolkit%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20sketch%3Atype%3D%22MSPage%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Dropdowns%22%20sketch%3Atype%3D%22MSArtboardGroup%22%20transform%3D%22translate%28-878.000000%2C%20-122.000000%29%22%20fill%3D%22%23CCC%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Dropdown-Grey%22%20sketch%3Atype%3D%22MSLayerGroup%22%20transform%3D%22translate%28570.000000%2C%20101.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Dropdown-Default%22%20sketch%3Atype%3D%22MSShapeGroup%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M312%2C32%20L312%2C29.6917048%20L316.989689%2C25.0246591%20L312%2C20.3577556%20L312%2C18%20L318.461538%2C24.1555486%20L318.461538%2C25.8443093%20L312%2C32%22%20id%3D%22Chevron%22%20transform%3D%22translate%28315.230769%2C%2025.000000%29%20rotate%28-270.000000%29%20translate%28-315.230769%2C%20-25.000000%29%20%22%3E%3C/path%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%3C/g%3E%0A%3C/svg%3E);background-repeat:no-repeat}select.readOnly{pointer-events:none}::-webkit-input-placeholder{color:#6b6b6b}::-moz-placeholder{color:#6b6b6b}:-ms-input-placeholder{color:#6b6b6b}:-moz-placeholder{color:#6b6b6b}input::-ms-reveal,input::-ms-clear{display:none}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: i1$1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1$1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i4.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i4.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i4.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i4.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: Icon2Component, selector: "citi-icon2", inputs: ["role", "idStr", "ariaLabel", "ariaHidden", "size", "isHoverSfi", "includeCircle", "type", "svgStyle", "tabIndex", "shade", "name"] }, { kind: "directive", type: CustomInputMaskDirective, selector: "[custom-mask]", inputs: ["hideCharacters", "custom-mask", "unmaskedValue"], outputs: ["unmaskedValueChange"], exportAs: ["custom"] }, { kind: "directive", type: CurrencyInputMaskDirective, selector: "[currency-mask]", inputs: ["unmaskedValue", "thousandsSeparator", "decimalSeparator", "precision", "maxFactor", "maxFactorExceededMessage", "preventPaste"], outputs: ["unmaskedValueChange"] }, { kind: "directive", type: PartialInputMaskDirective, selector: "[partial-mask]", inputs: ["maxLength", "unmaskedLength", "numbersOnly", "preventPaste", "hideCharacters", "partial-mask", "unmaskedValue"], outputs: ["unmaskedValueChange"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Input2Component4Q21, decorators: [{
            type: Component,
            args: [{ selector: 'citi-input2.4Q21', standalone: false, providers: [INPUT2_VALUE_ACCESSOR], host: { class: 'citi-input2' }, template: `
    <div class="form-control-container {{theme}}" [ngClass]="size" [attr.role]="(isAreaCodes || isCountryCodes) ? 'group' : null"
      [attr.aria-labelledby]="((isAreaCodes || isCountryCodes) ? labelId : null)"  >
      <!-- label for the input with group -->
      <label *ngIf="(isAreaCodes || isCountryCodes)" [id]="labelId" tabIndex="-1"
        [ngStyle]="{'opacity': labelOpacity}"
          [innerHtml]="ariaGroupLabel"></label>
      <!-- label for the input, will switch text to select element's label when that element is focused -->
      <label *ngIf="!(isAreaCodes || isCountryCodes)" [for]="_id" [id]="labelId" tabIndex="-1"
        [ngStyle]="{'opacity': labelOpacity}"
          [innerHtml]="(isSelectFocused ? selectLabeltext : labeltext)"></label>
      <!-- input wapper (all borders) -->
      <div class="input-container"
        [ngClass]="{
          'focused': isFocused,
          'errored': _error,
          'has-pre-addon': hasPreAddon,
          'readOnly': readOnly,
          'disabled': disabled,
          'success': isSuccess
        }">
        <!-- Add-ons Pre -->
        <div class="add-on-pre">
          <!-- Phone Area Code Selector -->
          <select *ngIf="isAreaCodes"
            [attr.name]="name"
            class="form-control"
            (change)="updateMask($event.target.value)"
            [attr.aria-label]="selectLabeltext"
            (focus)="onSelectFocus()"
            [disabled]="disabled"
            (keydown)="onSelectKeyDown($event)"
            [ngClass]="{
              'disabled': disabled,
              'readOnly': readOnly
            }">
            <option *ngFor="let code of areaCodes" [value]="code.value" [innerHtml]="code.label" [attr.selected]="(code.selected === true ? true : null)"></option>
          </select>
          <!-- Phone Country Prefix Selector -->
          <select *ngIf="isCountryCodes"
            [attr.name]="name"
            (change)="updateMask($event.target.value)"
            class="form-control"
            [attr.aria-label]="selectLabeltext"
            (focus)="onSelectFocus()"
            [disabled]="disabled"
            (keydown)="onSelectKeyDown($event)"
            [ngClass]="{
              'disabled': disabled,
              'readOnly': readOnly
            }">
            <option *ngFor="let code of countryCodes" [value]="code.value" [innerHtml]="code.label" [attr.selected]="(code.selected === true ? true : null)"></option>
          </select>
          <span *ngIf="currencySignBefore" class="input-group-addon before">{{currencySignBefore}}</span>
        </div>
        <!-- The Inputs managed by a switch statement -->
        <div [ngSwitch]="displayedInput" class="input-switch-wrapper">
          <!-- Custom Mask -->
          <input
            *ngSwitchCase="'custom'"
            #input
            #custom="custom"
            [attr.type]="(inputType == 'tel' ? 'tel' : 'text')"
            [custom-mask]="_appliedMask"
            [hideCharacters]="hideCharacters"
            [unmaskedValue]="value"
            (unmaskedValueChange)="writeValue($event)"
            [attr.id]="_id"
            [attr.name]="name"
            [readonly]="readOnly"
            [disabled]="disabled"
            [ngClass]="{
              'disabled': disabled,
              'readOnly': readOnly
            }"
            [attr.tabindex]="tabIndex"
            (focus)="onFocus()"
            (blur)="onBlur()"
            (change)="onInputChange()"
            (input)="onInput()"
            [attr.aria-autocomplete]="ariaAutocomplete"
            [attr.autocomplete]="autocomplete"
            [attr.aria-label]="getAriaLabelString()"
            [attr.aria-labelledby]="getAriaLabelledBy()"
            [attr.placeholder]="placeholder"
            [attr.aria-required]="(required ? true : null)"
            [attr.aria-invalid]="(_error ? true : null)"
            [attr.aria-describedby]="describedByID"
          />
          <!-- Dollar Mask -->
          <input
            *ngSwitchCase="'dollar'"
            #input
            type="text"
            currency-mask
            [unmaskedValue]="value"
            (unmaskedValueChange)="writeValueAndValidate($event)"
            [thousandsSeparator]="thousandsSeparator"
            [decimalSeparator]="decimalSeparator"
            [maxFactor]="maxFactor"
            [precision]="precision"
            [preventPaste]="preventPaste"
            [maxFactorExceededMessage]="maxFactorExceededMessage"
            [attr.id]="_id"
            [attr.name]="name"
            [attr.tabindex]="tabIndex"
            [attr.placeholder]="placeholder"
            [readonly]="readOnly"
            [disabled]="disabled"
            [ngClass]="{
              'disabled': disabled,
              'readOnly': readOnly
            }"
            (focus)="onFocus()"
            (blur)="onBlur()"
            (change)="onInputChange()"
            (input)="onInput()"
            [attr.aria-autocomplete]="ariaAutocomplete"
            [attr.autocomplete]="autocomplete"
            [attr.aria-invalid]="(_error ? true : null)"
            [attr.aria-label]="getAriaLabelString()"
            [attr.aria-labelledby]="getAriaLabelledBy()"
            [attr.aria-required]="(required ? true : null)"
            [attr.aria-describedby]="describedByID"
          />
          <!-- Partial Mask -->
          <input
            *ngSwitchCase="'partial'"
            #input
            type="text"
            [partial-mask]="_appliedMask"
            [hideCharacters]="hideCharacters"
            [unmaskedValue]="value"
            (unmaskedValueChange)="writeValue($event)"
            [unmaskedLength]="_unmaskedViewLength"
            [maxLength]="maxLength"
            [preventPaste]="preventPaste"
            [numbersOnly]="typeNumbersOnly"
            [attr.id]="_id"
            [attr.name]="name"
            [readonly]="readOnly"
            [disabled]="disabled"
            [ngClass]="{
              'disabled': disabled,
              'readOnly': readOnly
            }"
            [attr.tabindex]="tabIndex"
            [attr.placeholder]="placeholder"
            (focus)="onFocus()"
            (blur)="onBlur()"
            (change)="onInputChange()"
            (input)="onInput()"
            [attr.aria-autocomplete]="(ariaAutocomplete ? ariaAutocomplete : null)"
            [attr.autocomplete]="(autocomplete ? autocomplete : null)"
            [attr.aria-required]="(required ? true : null)"
            [attr.aria-label]="getAriaLabelString()"
            [attr.aria-labelledby]="getAriaLabelledBy()"
            [attr.aria-invalid]="(_error ? true : null)"
            [attr.aria-describedby]="describedByID"
          />
          <!-- No Mask -->
          <input
            *ngSwitchCase="'none'"
            #input
            [ngModel]="value"
            [attr.type]="inputType"
            (ngModelChange)="writeValue($event)"
            [attr.id]="_id"
            [attr.name]="name"
            [attr.step]="step"
            [attr.tabindex]="tabIndex"
            [attr.placeholder]="placeholder"
            [attr.maxlength]="maxLength"
            autocapitalize="none"
            [readonly]="readOnly"
            [disabled]="disabled"
            [ngClass]="{
              'disabled': disabled,
              'readOnly': readOnly
            }"
            (keypress)="preventCharacters($event)"
            (focus)="onFocus()"
            (blur)="onBlur()"
            (change)="onInputChange()"
            (input)="onInput()"
            (paste)="onPaste($event)"
            [attr.aria-autocomplete]="ariaAutocomplete"
            [attr.autocomplete]="autocomplete"
            [attr.aria-required]="(required ? true : null)"
            [attr.aria-invalid]="(_error ? true : null)"
            [attr.aria-labelledby]="getAriaLabelledBy()"
            [attr.aria-label]="getAriaLabelString()"
            [attr.aria-describedby]="describedByID"
          />

        </div>
        <div class="add-on-post">
         <button
            #button1
            type=button
            *ngIf="hideShowButtonWhenMasked && value"
            class="input-group-addon showHideMask"
            (click)="showhideMaskcheck($event)"
            [disabled]="disabled"
            [ngClass]="{'disabled': disabled}"
            >
            {{showHideMaskText}}
      </button>
          <citi-icon2
            *ngIf="searchIcon"
            name="006-search"
            idStr="inputSearchIconId"
            shade="dark"
            [svgStyle]="{'width.px': 50, 'height.px': 50}"
            ariaLabel="icon">
          </citi-icon2>
          <span *ngIf="currencySignAfter" class="input-group-addon after">{{currencySignAfter}}</span>
        </div>
      </div>

      <div
        [attr.id]="_id+'-error'"
        class="validation-message-danger"
        *ngIf="_error && !_isErrorHidden"
        [innerHtml]="errorMessage"
        role="alert"
      ></div>
      <div class="input-success" *ngIf="!_error && isSuccess">
        <span [attr.id]="_id+'-success'" class="validation-message-success">{{successMessage}}</span>
      </div>
    </div>
  `, styles: [":host{display:block}label{font-size:.75rem;color:#666;width:100%;pointer-events:none;transition:opacity ease-in-out 225ms}.input-container{width:100%;margin:3px 0 5px;box-sizing:border-box;-moz-box-sizing:border-box;display:flex;-moz-flex-direction:row;flex-direction:row;flex-wrap:nowrap;justify-content:flex-start;align-content:stretch;align-items:flex-start;border-radius:8px;background:#eee;border:1px solid transparent;border:.9px solid transparent}.input-container.focused{border-color:#056dae}.input-container.focused input::placeholder{opacity:0}.input-container.errored{border-color:#d60000}.input-container.errored.focused{width:calc(100% + 2px);border-width:1.99px;margin:2px 0 4px -1px}.input-container.success{border-color:#006e0a}.input-container.success.focused{width:calc(100% + 2px);border-width:1.99px;margin:2px 0 4px -1px}.input-container.readOnly{background:#fff;border:1px solid #666}.input-container.readOnly input.readOnly:read-only,.input-container.readOnly select,.input-container.readOnly span{background-color:#fff}.input-container.readOnly button.input-group-addon{background-color:#eee}.input-container.readOnly.focused:not(.has-pre-addon){outline:1px solid #056DAE}.input-container.disabled{background-color:#ccc;border:1px solid #CCC}.input-container.disabled input.disabled:disabled,.input-container.disabled select,.input-container.disabled span{background-color:#ccc}.input-container.has-pre-addon .input-switch-wrapper{margin:0}.input-container.has-pre-addon.focused:not(.readOnly){border-color:transparent}.input-container.has-pre-addon.focused .input-switch-wrapper{border-radius:0 8px 8px 0;outline:1px solid #056DAE}.input-container.has-pre-addon input{padding-left:0!important}.input-container .input-group-addon{width:auto;background-color:#fff}.input-container .input-group-addon.before{border-top-left-radius:8px;border-bottom-left-radius:8px;border-right:1px solid #6B6B6B}.input-container .input-group-addon.before,.input-container .input-group-addon.after{width:48px;height:48px}.input-container .input-group-addon.after{border-top-right-radius:8px;border-bottom-right-radius:8px;border-left:1px solid #6B6B6B}.input-container .add-on-pre{order:0;flex:0 1 auto;align-self:auto;box-sizing:border-box;-moz-box-sizing:border-box}.input-container .add-on-pre select{margin:0 2px 0 0;height:48px;width:105px;border:1px solid transparent;border-top-right-radius:0;border-bottom-right-radius:0}.input-container .add-on-pre select:focus{outline:1px solid #056DAE}.input-container .input-switch-wrapper{flex:1 1 0%;box-sizing:border-box;-moz-box-sizing:border-box;margin:0 2px;border-radius:8px}.input-container .input-switch-wrapper input{width:100%;box-sizing:border-box;-moz-box-sizing:border-box;letter-spacing:.5px;height:48px;padding:10px 20px;background:#eee;border:none!important;box-shadow:none;border-radius:8px}.input-container .input-switch-wrapper input::-ms-clear{display:none}.input-container .input-switch-wrapper input:focus{outline:none}.input-container .add-on-post{flex:0 1 auto;box-sizing:border-box;-moz-box-sizing:border-box}.input-container .add-on-post .search{width:50px;padding-top:12px;border-radius:8px}.input-container .add-on-post .showHideMask{min-width:50px;border-radius:8px;padding:17px 10px;color:#056dae;font-family:Interstate_Bold,sans-serif;line-height:14px;cursor:pointer;font-size:12px;margin-left:2px}.input-container .add-on-post .showHideMask.disabled{background-color:#ccc;border:1px solid #CCC;color:#333;cursor:context-menu}.input-container .add-on-post .showHideMask.disabled button.disabled:disabled{background-color:#ccc}.input-error,.input-success{height:16px;width:100%;float:left}.input-success .validation-message-success{font-size:12px;font-family:Interstate_Bold,sans-serif;margin:0;color:#006e0a;font-weight:700;position:relative;display:block;line-height:1rem;font-size:.75rem}:host .light .input-container{background:#fff}:host .light .input-container input,:host .light .input-container select,:host .light .input-container span{background-color:#fff}:host .light .input-container.readOnly{background:#eee}:host .light .input-container.readOnly input,:host .light .input-container.readOnly select,:host .light .input-container.readOnly span{background-color:#eee}:host .light .input-container.readOnly button.input-group-addon{background-color:#fff}:host .light .input-container .input-group-addon{background-color:#eee}:host ::ng-deep #inputSearchIconId path{fill:#056dae}.form-control.disabled{background-color:#ccc;border:1px solid #CCC;color:#333;cursor:context-menu}.form-control.disabled button.disabled:disabled{background-color:#ccc}select.form-control{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%20standalone%3D%22no%22%3F%3E%0A%3Csvg%20width%3D%2215px%22%20height%3D%228px%22%20viewBox%3D%220%200%2015%208%22%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20xmlns%3Asketch%3D%22http%3A//www.bohemiancoding.com/sketch/ns%22%3E%0A%20%20%20%20%3C%21--%20Generator%3A%20Sketch%203.4.1%20%2815681%29%20-%20http%3A//www.bohemiancoding.com/sketch%20--%3E%0A%20%20%20%20%3Ctitle%3EChevron%3C/title%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C/desc%3E%0A%20%20%20%20%3Cdefs%3E%3C/defs%3E%0A%20%20%20%20%3Cg%20id%3D%22Toolkit%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20sketch%3Atype%3D%22MSPage%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Dropdowns%22%20sketch%3Atype%3D%22MSArtboardGroup%22%20transform%3D%22translate%28-878.000000%2C%20-122.000000%29%22%20fill%3D%22%23056DAE%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Dropdown-Grey%22%20sketch%3Atype%3D%22MSLayerGroup%22%20transform%3D%22translate%28570.000000%2C%20101.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Dropdown-Default%22%20sketch%3Atype%3D%22MSShapeGroup%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M312%2C32%20L312%2C29.6917048%20L316.989689%2C25.0246591%20L312%2C20.3577556%20L312%2C18%20L318.461538%2C24.1555486%20L318.461538%2C25.8443093%20L312%2C32%22%20id%3D%22Chevron%22%20transform%3D%22translate%28315.230769%2C%2025.000000%29%20rotate%28-270.000000%29%20translate%28-315.230769%2C%20-25.000000%29%20%22%3E%3C/path%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%3C/g%3E%0A%3C/svg%3E);background-repeat:no-repeat}select.form-control.disabled{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%20standalone%3D%22no%22%3F%3E%0A%3Csvg%20width%3D%2215px%22%20height%3D%228px%22%20viewBox%3D%220%200%2015%208%22%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20xmlns%3Asketch%3D%22http%3A//www.bohemiancoding.com/sketch/ns%22%3E%0A%20%20%20%20%3C%21--%20Generator%3A%20Sketch%203.4.1%20%2815681%29%20-%20http%3A//www.bohemiancoding.com/sketch%20--%3E%0A%20%20%20%20%3Ctitle%3EChevron%3C/title%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C/desc%3E%0A%20%20%20%20%3Cdefs%3E%3C/defs%3E%0A%20%20%20%20%3Cg%20id%3D%22Toolkit%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20sketch%3Atype%3D%22MSPage%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Dropdowns%22%20sketch%3Atype%3D%22MSArtboardGroup%22%20transform%3D%22translate%28-878.000000%2C%20-122.000000%29%22%20fill%3D%22%23333333%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Dropdown-Grey%22%20sketch%3Atype%3D%22MSLayerGroup%22%20transform%3D%22translate%28570.000000%2C%20101.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Dropdown-Default%22%20sketch%3Atype%3D%22MSShapeGroup%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M312%2C32%20L312%2C29.6917048%20L316.989689%2C25.0246591%20L312%2C20.3577556%20L312%2C18%20L318.461538%2C24.1555486%20L318.461538%2C25.8443093%20L312%2C32%22%20id%3D%22Chevron%22%20transform%3D%22translate%28315.230769%2C%2025.000000%29%20rotate%28-270.000000%29%20translate%28-315.230769%2C%20-25.000000%29%20%22%3E%3C/path%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%3C/g%3E%0A%3C/svg%3E);background-repeat:no-repeat}select.form-control.readOnly{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%20standalone%3D%22no%22%3F%3E%0A%3Csvg%20width%3D%2215px%22%20height%3D%228px%22%20viewBox%3D%220%200%2015%208%22%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20xmlns%3Asketch%3D%22http%3A//www.bohemiancoding.com/sketch/ns%22%3E%0A%20%20%20%20%3C%21--%20Generator%3A%20Sketch%203.4.1%20%2815681%29%20-%20http%3A//www.bohemiancoding.com/sketch%20--%3E%0A%20%20%20%20%3Ctitle%3EChevron%3C/title%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C/desc%3E%0A%20%20%20%20%3Cdefs%3E%3C/defs%3E%0A%20%20%20%20%3Cg%20id%3D%22Toolkit%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20sketch%3Atype%3D%22MSPage%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Dropdowns%22%20sketch%3Atype%3D%22MSArtboardGroup%22%20transform%3D%22translate%28-878.000000%2C%20-122.000000%29%22%20fill%3D%22%23CCC%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Dropdown-Grey%22%20sketch%3Atype%3D%22MSLayerGroup%22%20transform%3D%22translate%28570.000000%2C%20101.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Dropdown-Default%22%20sketch%3Atype%3D%22MSShapeGroup%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M312%2C32%20L312%2C29.6917048%20L316.989689%2C25.0246591%20L312%2C20.3577556%20L312%2C18%20L318.461538%2C24.1555486%20L318.461538%2C25.8443093%20L312%2C32%22%20id%3D%22Chevron%22%20transform%3D%22translate%28315.230769%2C%2025.000000%29%20rotate%28-270.000000%29%20translate%28-315.230769%2C%20-25.000000%29%20%22%3E%3C/path%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%3C/g%3E%0A%3C/svg%3E);background-repeat:no-repeat}select.readOnly{pointer-events:none}::-webkit-input-placeholder{color:#6b6b6b}::-moz-placeholder{color:#6b6b6b}:-ms-input-placeholder{color:#6b6b6b}:-moz-placeholder{color:#6b6b6b}input::-ms-reveal,input::-ms-clear{display:none}\n"] }]
        }], ctorParameters: () => [{ type: ValidationService }, { type: CitiLiveAnnouncer }, { type: i0.ElementRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [NAVIGATOR]
                }] }], propDecorators: { validateOn: [{
                type: Input$1
            }], allowIntegerOnly: [{
                type: Input$1
            }], maxLength: [{
                type: Input$1
            }], allowPositiveIntegerOnly: [{
                type: Input$1
            }], minLength: [{
                type: Input$1
            }], readOnly: [{
                type: Input$1
            }], disabled: [{
                type: Input$1
            }], typeNumbersOnly: [{
                type: Input$1
            }], allowNonZeroValueOnly: [{
                type: Input$1
            }], autocomplete: [{
                type: Input$1
            }], ariaAutocomplete: [{
                type: Input$1
            }], preventPaste: [{
                type: Input$1
            }], thousandsSeparator: [{
                type: Input$1
            }], decimalSeparator: [{
                type: Input$1
            }], precision: [{
                type: Input$1
            }], step: [{
                type: Input$1
            }], maxValue: [{
                type: Input$1
            }], minValue: [{
                type: Input$1
            }], maxFactor: [{
                type: Input$1
            }], maxFactorExceededMessage: [{
                type: Input$1
            }], currencySignAfter: [{
                type: Input$1
            }], currencySignBefore: [{
                type: Input$1
            }], ariaLabel: [{
                type: Input$1
            }], ariaLabelledById: [{
                type: Input$1
            }], ariaGroupLabel: [{
                type: Input$1
            }], idStr: [{
                type: Input$1
            }], name: [{
                type: Input$1
            }], label: [{
                type: Input$1
            }], selectLabel: [{
                type: Input$1
            }], placeholder: [{
                type: Input$1
            }], searchIcon: [{
                type: Input$1
            }], required: [{
                type: Input$1
            }], describedby: [{
                type: Input$1
            }], tabIndex: [{
                type: Input$1
            }], isCbolPassword: [{
                type: Input$1
            }], countryCode: [{
                type: Input$1
            }], countryCodeChange: [{
                type: Output
            }], countryCodes: [{
                type: Input$1
            }], areaCode: [{
                type: Input$1
            }], areaCodeChange: [{
                type: Output
            }], areaCodes: [{
                type: Input$1
            }], unmaskedLength: [{
                type: Input$1
            }], theme: [{
                type: Input$1
            }], applyMaskOnEvents: [{
                type: Input$1
            }], removeMaskOnEvents: [{
                type: Input$1
            }], isSuccess: [{
                type: Input$1
            }], successMessage: [{
                type: Input$1
            }], visibleLabel: [{
                type: Input$1
            }], hideMask: [{
                type: Input$1
            }], value: [{
                type: Input$1
            }], valueChange: [{
                type: Output
            }], hideToggle: [{
                type: Output
            }], focus: [{
                type: Input$1
            }], focusChange: [{
                type: Output
            }], blur: [{
                type: Output
            }], minLengthError: [{
                type: Input$1
            }], maxValueError: [{
                type: Input$1
            }], minValueError: [{
                type: Input$1
            }], maxLengthError: [{
                type: Input$1
            }], requiredError: [{
                type: Input$1
            }], messageOnlyNonZeroError: [{
                type: Input$1
            }], messageOnlyIntegerError: [{
                type: Input$1
            }], messageOnlyPositiveIntegerError: [{
                type: Input$1
            }], messageOnlyPhoneError: [{
                type: Input$1
            }], messageOnlyZipcodeError: [{
                type: Input$1
            }], messageOnlyEmailError: [{
                type: Input$1
            }], messageOnlyZipError: [{
                type: Input$1
            }], messageOnlySsnError: [{
                type: Input$1
            }], messageOnlyAreaCodeError: [{
                type: Input$1
            }], messageOnlyCountryCodeError: [{
                type: Input$1
            }], changeMessage: [{
                type: Input$1
            }], hasCustomError: [{
                type: Input$1
            }], customErrorMessage: [{
                type: Input$1
            }], error: [{
                type: Input$1
            }], errorChange: [{
                type: Output
            }], usePasswordOnAndroid: [{
                type: Input$1
            }], mask: [{
                type: Input$1
            }], hideShowButtonWhenMasked: [{
                type: Input$1
            }], showText: [{
                type: Input$1
            }], hideText: [{
                type: Input$1
            }], type: [{
                type: Input$1
            }], size: [{
                type: Input$1
            }], input: [{
                type: ViewChild,
                args: ['input']
            }], custom: [{
                type: ViewChild,
                args: [CustomInputMaskDirective]
            }], classRow: [{
                type: HostBinding,
                args: ['class.row']
            }] } });

const COMPONENTS$D = [
    Input2Component,
    CustomInputMaskDirective,
    CurrencyInputMaskDirective,
    PartialInputMaskDirective,
    Input2Component4Q21
];
const MODULES$G = [CommonModule, FormsModule, Icons2];
class Input2 {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Input2, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: Input2, declarations: [Input2Component,
            CustomInputMaskDirective,
            CurrencyInputMaskDirective,
            PartialInputMaskDirective,
            Input2Component4Q21], imports: [CommonModule, FormsModule, Icons2], exports: [Input2Component,
            CustomInputMaskDirective,
            CurrencyInputMaskDirective,
            PartialInputMaskDirective,
            Input2Component4Q21] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Input2, imports: [MODULES$G] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Input2, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$G],
                    declarations: [...COMPONENTS$D],
                    exports: [...COMPONENTS$D]
                }]
        }] });

class PasswordStrengthIndicatorComponent {
    set strength(strength) {
        this._strength = strength;
    }
    set strengthLevelText(strengthText) {
        this._strengthLevelText = strengthText;
        this.announcer.announce(`${this.strengthLabelText}: ${this._strengthLevelText}`, 'assertive');
    }
    get strengthLevelText() {
        return this._strengthLevelText;
    }
    // #endregion
    // #region ------------- Lifecycle Hooks ------------- //
    constructor(announcer) {
        this.announcer = announcer;
        // #region -------- Inputs/Outputs ---------- //
        /**
         * @property strength
         * @description Defines which strength should be displayed.
         * @return string ('invalid', 'weak', 'average', 'strong'), defaults to 'invalid'
         */
        // private _strength: string = "invalid";
        this._strength = 'invalid';
        /**
         * @property strengthLabelText
         * @description Defines which text should be used as a label for the strength level.
         * @return string
         */
        this.strengthLabelText = 'Password Strength';
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: PasswordStrengthIndicatorComponent, deps: [{ token: CitiLiveAnnouncer }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: PasswordStrengthIndicatorComponent, isStandalone: false, selector: "citi-password-strength-indicator", inputs: { strength: "strength", strengthLevelText: "strengthLevelText", strengthLabelText: "strengthLabelText" }, host: { classAttribute: "citi-password-strength-indicator" }, ngImport: i0, template: `
    <div class="message">
      <span class="message-label">{{strengthLabelText}}:</span>
      <span class="level-label">{{strengthLevelText}}</span>
    </div>
    <div class="container-bar">
      <div class="color-bar {{_strength}}"></div>
    </div>
  `, isInline: true, styles: [":host{display:block}.level-label{text-transform:capitalize}.message{margin-bottom:15px}.message .level-label{font-family:Interstate_Bold,sans-serif;font-weight:700}.container-bar{height:15px;background-color:#eee}.container-bar .color-bar{height:15px;width:10%}.container-bar .color-bar.invalid{width:100%;background-color:#da0000}.container-bar .color-bar.weak{width:25%;background-color:#da0000}.container-bar .color-bar.average{width:50%;background-color:#ffca00}.container-bar .color-bar.strong{width:100%;background-color:#007100}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: PasswordStrengthIndicatorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-password-strength-indicator', standalone: false, host: {
                        'class': 'citi-password-strength-indicator'
                    }, template: `
    <div class="message">
      <span class="message-label">{{strengthLabelText}}:</span>
      <span class="level-label">{{strengthLevelText}}</span>
    </div>
    <div class="container-bar">
      <div class="color-bar {{_strength}}"></div>
    </div>
  `, styles: [":host{display:block}.level-label{text-transform:capitalize}.message{margin-bottom:15px}.message .level-label{font-family:Interstate_Bold,sans-serif;font-weight:700}.container-bar{height:15px;background-color:#eee}.container-bar .color-bar{height:15px;width:10%}.container-bar .color-bar.invalid{width:100%;background-color:#da0000}.container-bar .color-bar.weak{width:25%;background-color:#da0000}.container-bar .color-bar.average{width:50%;background-color:#ffca00}.container-bar .color-bar.strong{width:100%;background-color:#007100}\n"] }]
        }], ctorParameters: () => [{ type: CitiLiveAnnouncer }], propDecorators: { strength: [{
                type: Input$1
            }], strengthLevelText: [{
                type: Input$1
            }], strengthLabelText: [{
                type: Input$1
            }] } });

;
let nextUniqueId$6 = 0;
class PasswordComponent {
    set name(value) {
        this._name = value || this._uniqueName;
        this._passwordName = `${this._name}-password`;
        this._confirmName = `${this._name}-confirm`;
    }
    get name() { return this._name; }
    get idStr() { return this._id; }
    set idStr(value) { this._id = value || this._uid; }
    // #endregion
    // #region ------------- Lifecycle Hooks ------------- //
    constructor(announcer, validationService) {
        this.announcer = announcer;
        this.validationService = validationService;
        // #region - Properties
        this.PASSWORD_VALIDATORS = {
            noSpaces: (val) => /^\s*\S+\s*$/.test(val), // contains no spaces
            hasNumber: (val) => /\d/.test(val), // includes number
            hasSmallLetter: (val) => /[a-z]/.test(val), // includes small letter
            hasCapsLetter: (val) => /[A-Z]/.test(val), // includes caps letter
            hasLength: (val) => /^.{8,64}$/.test(val), // between 8 - 64 characters
            hasAllowedSymbol: (val) => /[~\`!@#$%^&*()_\-\/\\|]/.test(val), // includes allowed character
            onlyAllowedSpecialChars: (val) => /^([\w~\`!@#$%^&*()_\-\/\\|]*)$/.test(val), // contains only allowed characters
            noRepeatingCharacters: (val) => !(/(.)\1{2,}/i.test(val)) // cannot repeat a character more than twice in a row
        };
        this.unsub$ = new Subject();
        /**
         * @property requirementsHeading
         * @description Header for password requirements list
         * @return string
         */
        this.requirementsHeading = 'Password Guidelines';
        this.ariaLevel = 2;
        /**
         * @property requirementsStrings
         * @description Text for each password requirement or guideline
         * @return string[]
         */
        this.requirementsStrings = [
            'Must be different from your User ID',
            'Must contain no spaces',
            'Cannot have an empty field',
            'Must include at least 1 upper case',
            'Must include at least 1 lower case',
            'Must include at least 1 number',
            'Must include between 8-64 characters',
            'Cannot repeat a character more than twice in a row',
            'Must include at least 1 Approved special characters: ~ ` ! @ # $ % ^ & * ( ) _ - \\ \/ |',
        ];
        this._uniqueName = `citi-password-${nextUniqueId$6++}`;
        this._uid = `citi-password-${nextUniqueId$6++}`;
        // #endregion
        // #region - Inputs: Password Input Related
        /**
         * @property placeholder
         * @description This defines the place holder text of the input.
         * @return string
         */
        this.placeholder = 'Password';
        /**
         * @property label
         * @description This defines the label text of the input
         * @return string
         */
        this.label = 'Password';
        /**
         * @property customErrorMessage
         * @description Customized error message for custom error state on password input
         * @return string
         */
        this.customErrorMessage = 'Your password does not meet our requirements';
        /**
         * @property successMessage
         * @description Customized success message for valid password input
         * @return string
         */
        this.successMessage = 'Your password meets our requirements';
        // #endregion
        // #region - Inputs: Strength Indicator Related
        /**
         * @property hasStrengthIndicator
         * @description Determines whether or not the Password Strength Indicator should be displayed.
         * @Type: boolean, defaults to 'true'
         */
        this.hasStrengthIndicator = true;
        /**
       * @property strengthLabelText
       * @description Defines which text should be used as a label for the strength level.
       * @return string
       */
        this.strengthLabelText = 'Password Strength';
        // #endregion
        // #region ------------- INPUT / OUTPUT --------------//
        /**
         * @property hasConfirmingInput
         * @description Determines whether or not the Confirm Password Input should be displayed.
         * @Type: boolean, defaults to 'false'
         */
        this.hasConfirmingInput = false;
        /**
         * @property placeholderConfirming
         * @description This defines the place holder text of the second input.
         * @return string
         */
        this.placeholderConfirming = 'Confirm Password';
        /**
         * @property labelConfirming
         * @description This defines the label text of the second input
         * @return string
         */
        this.labelConfirming = 'Confirm Password';
        /**
         * @property confirmErrorMessage
         * @description Customized error message for custom error state on confirm input
         * @return string
         */
        this.confirmErrorMessage = "Your passwords don't match";
        /**
         * @property passwordBlur
         * @description Emits when the focus of the password input is blurred
         * @Type: EventEmitter
         */
        this.passwordBlur = new EventEmitter();
        /**
         * @property passwordFocus
         * @description emits when the password input is focused
         * @Type: EventEmitter
         */
        this.passwordFocus = new EventEmitter();
        /**
         * @property confirmBlur
         * @description emits when the focus of the password input is blurred
         * @Type: EventEmitter
         */
        this.confirmBlur = new EventEmitter();
        /**
         * @property confirmFocus
         * @description emits when the confirm input is focused
         * @Type: EventEmitter
         */
        this.confirmFocus = new EventEmitter();
        /**
         * @property mismatchError
         * @description This determines whether the passwords do not match error state should be triggered.
         * @Type: boolean
         * @twoway false
         */
        this.mismatchError = false;
        this.mismatchErrorChange = new EventEmitter();
        /**
         * @property matchSuccess
         * @description This determines whether the valid matching password state should be triggered.
         * @Type: boolean
         * @twoway false
         */
        this.matchSuccess = false;
        this.matchSuccessChange = new EventEmitter();
        this.passwordValueChange = new EventEmitter();
        this.confirmValueChange = new EventEmitter();
        /**
         * @property invalidError
         * @description This determines whether the invalid password error state should be triggered. Can be two-way bound through [(invalidError)]='myValueVar'
         * @Type: boolean
         * @twoway true
         */
        this.invalidError = false;
        this.invalidErrorChange = new EventEmitter();
        /**
       * @property validSuccess
       * @description This determines whether the valid password success state should be triggered. Can be two-way bound through [(validSuccess)]='myValueVar'
       * @Type: boolean
       * @twoway true
       */
        this.validSuccess = false;
        this.validSuccessChange = new EventEmitter();
    }
    // ensures that a name is assigned
    ngOnInit() {
        this.name = this.name;
        // register and subscribe to validation service
        this.validationService.addInput(this);
        this.validationService.validateNow.pipe(takeUntil(this.unsub$)).subscribe(() => {
            this.validatePassword(this.passwordValue);
            if (this.hasConfirmingInput) {
                this.confirmPasswordMatch();
            }
            this.manageValidationServiceErrors();
        });
    }
    ngOnDestroy() {
        this.validationService.removeError(this);
        this.unsub$.next();
        this.unsub$.complete();
    }
    // #endregion
    // #region - Event Listeners and handlers
    // Method called when the password input focus is changed
    onFocusChange(isFocused) {
        // When a user focuses the password field, error and success states should be reset until blurred again
        if (isFocused) {
            if (this.invalidError)
                this.invalidErrorChange.emit(false);
            if (this.validSuccess)
                this.validSuccessChange.emit(false);
            this.passwordFocus.emit();
            this.manageValidationServiceErrors();
        }
    }
    // Method called on password input blur. Constructs a blur message to avoid messages colliding and ensure all announce
    onBlur() {
        let blurMessage = this.validatePassword(this.passwordInput.value);
        let blurMessageConfirm = "";
        blurMessage = !this.invalidError ? blurMessage : '';
        // If password strength is enabled, announce the strength on blur because strength announcement is often interrupted by the user inputs while typing
        if (this.hasStrengthIndicator) {
            if (this.strengthLevelText !== undefined) {
                blurMessage += ` ${this.strengthLabelText}: ${this.strengthLevelText}`;
            }
        }
        if (this.hasConfirmingInput) {
            if (this.confirmInput.value != undefined) {
                blurMessageConfirm = `${this.confirmPasswordMatch()}`;
            }
        }
        if (blurMessage !== '') {
            if (blurMessageConfirm !== '') {
                blurMessage += blurMessageConfirm;
            }
        }
        this.passwordBlur.emit();
    }
    // Method called on password input value change
    onValueChange(value) {
        this.passwordValueChange.emit(value);
    }
    // Method called when the confirm input focus is changed
    onConfirmFocusChange(isFocused) {
        // When a user focuses the password field, error should be reset until blurred again
        if (isFocused) {
            if (this.mismatchError)
                this.mismatchErrorChange.emit(false);
            this.confirmFocus.emit();
            this.manageValidationServiceErrors();
        }
    }
    // Method called on confirm input blur
    onConfirmBlur() {
        setTimeout(() => {
            this.confirmPasswordMatch();
        }, 0);
        this.confirmBlur.emit();
    }
    // Method called on confirm input value change
    onConfirmValueChange(value) {
        this.confirmValueChange.emit(value);
    }
    // #endregion
    // #region - Methods: Validation
    // Method called to validate password input on change. Determines if requirements are met, triggers success
    // Returns message for the live announcer
    validatePassword(value) {
        if (this.isPasswordValid(value, this.userId)) {
            this.invalidError = false;
            this.validSuccess = true;
            this.validSuccessChange.emit(true);
            this.passwordInput.toggleError(null, false);
            this.manageValidationServiceErrors();
            return this.successMessage;
        }
        // Requirements not met
        else {
            this.invalidError = true;
            this.validSuccess = false;
            this.invalidErrorChange.emit(true);
            this.manageValidationServiceErrors();
            return this.customErrorMessage;
        }
    }
    isPasswordValid(value, username) {
        let isValid = this.PASSWORD_VALIDATORS.hasNumber(value)
            && this.PASSWORD_VALIDATORS.hasSmallLetter(value)
            && this.PASSWORD_VALIDATORS.hasCapsLetter(value)
            && this.PASSWORD_VALIDATORS.hasLength(value)
            && this.PASSWORD_VALIDATORS.hasAllowedSymbol(value)
            && this.PASSWORD_VALIDATORS.onlyAllowedSpecialChars(value)
            && this.PASSWORD_VALIDATORS.noRepeatingCharacters(value);
        // Validate against username
        if (username && value === username) {
            isValid = false;
        }
        return isValid;
    }
    matches() {
        this.matchSuccess = this.passwordValue === this.confirmValue;
        this.matchSuccessChange.emit(this.matchSuccess);
        return this.matchSuccess;
    }
    // Method called to check if password input value and confirm input value match and trigger error if mismatched
    // Returns message for the live announcer
    confirmPasswordMatch() {
        // If both inputs have no value, make no determination about matching
        if (!this.passwordInput.value && !this.confirmInput.value)
            return '';
        if (this.passwordInput.value && !this.confirmInput.value)
            return '';
        // If the values match do not trigger the mismatch error
        if (this.matches()) {
            this.confirmInput.toggleError(null, false);
        }
        if (this.mismatchError && this.matches()) {
            this.mismatchError = false;
            this.mismatchErrorChange.emit(false);
            this.manageValidationServiceErrors();
        }
        // Else the values do not match, trigger the mismatch error and return the error message to be announced
        if (!this.mismatchError && !this.matches()) {
            this.mismatchError = true;
            this.mismatchErrorChange.emit(true);
            this.manageValidationServiceErrors();
            return this.confirmErrorMessage;
        }
        return '';
    }
    manageValidationServiceErrors() {
        if (this.invalidError || this.mismatchError) {
            this.validationService.addError(this);
        }
        else {
            this.validationService.removeError(this);
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: PasswordComponent, deps: [{ token: CitiLiveAnnouncer }, { token: ValidationService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: PasswordComponent, isStandalone: false, selector: "citi-password", inputs: { required: "required", requirementsHeading: "requirementsHeading", ariaLevel: "ariaLevel", requirementsStrings: "requirementsStrings", userId: "userId", name: "name", idStr: "idStr", ariaLabel: "ariaLabel", ariaLabelledby: "ariaLabelledby", ariaDescribedby: "ariaDescribedby", placeholder: "placeholder", label: "label", customErrorMessage: "customErrorMessage", successMessage: "successMessage", hasStrengthIndicator: "hasStrengthIndicator", strength: "strength", strengthLevelText: "strengthLevelText", strengthLabelText: "strengthLabelText", hasConfirmingInput: "hasConfirmingInput", placeholderConfirming: "placeholderConfirming", labelConfirming: "labelConfirming", confirmErrorMessage: "confirmErrorMessage", passwordValue: "passwordValue", confirmValue: "confirmValue", invalidError: "invalidError", validSuccess: "validSuccess" }, outputs: { passwordBlur: "passwordBlur", passwordFocus: "passwordFocus", confirmBlur: "confirmBlur", confirmFocus: "confirmFocus", mismatchErrorChange: "mismatchErrorChange", matchSuccessChange: "matchSuccessChange", passwordValueChange: "passwordValueChange", confirmValueChange: "confirmValueChange", invalidErrorChange: "invalidErrorChange", validSuccessChange: "validSuccessChange" }, host: { classAttribute: "citi-password" }, viewQueries: [{ propertyName: "passwordInput", first: true, predicate: ["passwordInput"], descendants: true }, { propertyName: "confirmInput", first: true, predicate: ["confirmInput"], descendants: true }], ngImport: i0, template: `
    <div class="passwordReqsHeader" role="heading" [attr.aria-level]="ariaLevel">{{requirementsHeading}}</div>
    <ul>
      <li *ngFor="let req of requirementsStrings" class="passwordReqs">{{ req }}</li>
    </ul>
    <citi-input2
      class="passwordInput 4Q21"
      #passwordInput
      type="password"
      size="fullwidth"
      [idStr]="idStr"
      [describedby]="ariaDescribedby"
      [ariaLabel]="ariaLabel"
      [ariaLabelledById]="ariaLabelledby"
      [name]="_passwordName"
      [required]="true"
      [label]="label"
      [validateOn]="['blur']"
      [placeholder]="placeholder"
      [successMessage]="successMessage"
      [hasCustomError]="true"
      [customErrorMessage]="customErrorMessage"
      [(error)]="invalidError"
      [isSuccess]="validSuccess"
      (blur)="onBlur()"
      (focusChange)="onFocusChange($event)"
      (valueChange)="onValueChange($event)"
      [(value)]="passwordValue"
      [isCbolPassword]="true"
      [visibleLabel]="true"
    ></citi-input2>
    <citi-password-strength-indicator
      *ngIf="hasStrengthIndicator"
      [strength]="strength"
      [strengthLevelText]="strengthLevelText"
      [strengthLabelText]="strengthLabelText"
    ></citi-password-strength-indicator>
    <citi-input2
      class="4Q21"
      #confirmInput
      *ngIf="hasConfirmingInput"
      type="password"
      size="fullwidth"
      [idStr]="idStr+'confirm'"
      [describedby]="ariaDescribedby"
      [ariaLabel]="ariaLabel"
      [ariaLabelledById]="ariaLabelledby"
      [name]="_confirmName"
      [required]="true"
      [label]="labelConfirming"
      [validateOn]="['blur']"
      [placeholder]="placeholderConfirming"
      [customErrorMessage]="confirmErrorMessage"
      [hasCustomError]="true"
      [(error)]="mismatchError"
      (blur)="onConfirmBlur()"
      (focusChange)="onConfirmFocusChange($event)"
      (valueChange)="onConfirmValueChange($event)"
      [(value)]="confirmValue"
      [isCbolPassword]="true"
      [visibleLabel]="true"
    ></citi-input2>
  `, isInline: true, styles: [":host{display:flex;flex-direction:column}.passwordReqs{font-size:12px}.passwordReqsHeader{font-size:12px;font-family:Interstate_Bold,sans-serif;margin:8px 0}.passwordReqsList{margin-bottom:-5px}citi-input2 ::ng-deep .validation-message-danger{line-height:18px!important}citi-input2 ::ng-deep .input-success .validation-message-success{line-height:18px!important}citi-unordered-list ::ng-deep .b-copy-modules{margin-bottom:18px;margin-left:-10px}.citi-password-strength-indicator{margin-top:20px;margin-bottom:20px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: Input2Component4Q21, selector: "citi-input2.4Q21", inputs: ["validateOn", "allowIntegerOnly", "maxLength", "allowPositiveIntegerOnly", "minLength", "readOnly", "disabled", "typeNumbersOnly", "allowNonZeroValueOnly", "autocomplete", "ariaAutocomplete", "preventPaste", "thousandsSeparator", "decimalSeparator", "precision", "step", "maxValue", "minValue", "maxFactor", "maxFactorExceededMessage", "currencySignAfter", "currencySignBefore", "ariaLabel", "ariaLabelledById", "ariaGroupLabel", "idStr", "name", "label", "selectLabel", "placeholder", "searchIcon", "required", "describedby", "tabIndex", "isCbolPassword", "countryCode", "countryCodes", "areaCode", "areaCodes", "unmaskedLength", "theme", "applyMaskOnEvents", "removeMaskOnEvents", "isSuccess", "successMessage", "visibleLabel", "hideMask", "value", "focus", "minLengthError", "maxValueError", "minValueError", "maxLengthError", "requiredError", "messageOnlyNonZeroError", "messageOnlyIntegerError", "messageOnlyPositiveIntegerError", "messageOnlyPhoneError", "messageOnlyZipcodeError", "messageOnlyEmailError", "messageOnlyZipError", "messageOnlySsnError", "messageOnlyAreaCodeError", "messageOnlyCountryCodeError", "changeMessage", "hasCustomError", "customErrorMessage", "error", "usePasswordOnAndroid", "mask", "hideShowButtonWhenMasked", "showText", "hideText", "type", "size"], outputs: ["countryCodeChange", "areaCodeChange", "valueChange", "hideToggle", "focusChange", "blur", "errorChange"] }, { kind: "component", type: PasswordStrengthIndicatorComponent, selector: "citi-password-strength-indicator", inputs: ["strength", "strengthLevelText", "strengthLabelText"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: PasswordComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-password', standalone: false, host: {
                        'class': 'citi-password'
                    }, template: `
    <div class="passwordReqsHeader" role="heading" [attr.aria-level]="ariaLevel">{{requirementsHeading}}</div>
    <ul>
      <li *ngFor="let req of requirementsStrings" class="passwordReqs">{{ req }}</li>
    </ul>
    <citi-input2
      class="passwordInput 4Q21"
      #passwordInput
      type="password"
      size="fullwidth"
      [idStr]="idStr"
      [describedby]="ariaDescribedby"
      [ariaLabel]="ariaLabel"
      [ariaLabelledById]="ariaLabelledby"
      [name]="_passwordName"
      [required]="true"
      [label]="label"
      [validateOn]="['blur']"
      [placeholder]="placeholder"
      [successMessage]="successMessage"
      [hasCustomError]="true"
      [customErrorMessage]="customErrorMessage"
      [(error)]="invalidError"
      [isSuccess]="validSuccess"
      (blur)="onBlur()"
      (focusChange)="onFocusChange($event)"
      (valueChange)="onValueChange($event)"
      [(value)]="passwordValue"
      [isCbolPassword]="true"
      [visibleLabel]="true"
    ></citi-input2>
    <citi-password-strength-indicator
      *ngIf="hasStrengthIndicator"
      [strength]="strength"
      [strengthLevelText]="strengthLevelText"
      [strengthLabelText]="strengthLabelText"
    ></citi-password-strength-indicator>
    <citi-input2
      class="4Q21"
      #confirmInput
      *ngIf="hasConfirmingInput"
      type="password"
      size="fullwidth"
      [idStr]="idStr+'confirm'"
      [describedby]="ariaDescribedby"
      [ariaLabel]="ariaLabel"
      [ariaLabelledById]="ariaLabelledby"
      [name]="_confirmName"
      [required]="true"
      [label]="labelConfirming"
      [validateOn]="['blur']"
      [placeholder]="placeholderConfirming"
      [customErrorMessage]="confirmErrorMessage"
      [hasCustomError]="true"
      [(error)]="mismatchError"
      (blur)="onConfirmBlur()"
      (focusChange)="onConfirmFocusChange($event)"
      (valueChange)="onConfirmValueChange($event)"
      [(value)]="confirmValue"
      [isCbolPassword]="true"
      [visibleLabel]="true"
    ></citi-input2>
  `, styles: [":host{display:flex;flex-direction:column}.passwordReqs{font-size:12px}.passwordReqsHeader{font-size:12px;font-family:Interstate_Bold,sans-serif;margin:8px 0}.passwordReqsList{margin-bottom:-5px}citi-input2 ::ng-deep .validation-message-danger{line-height:18px!important}citi-input2 ::ng-deep .input-success .validation-message-success{line-height:18px!important}citi-unordered-list ::ng-deep .b-copy-modules{margin-bottom:18px;margin-left:-10px}.citi-password-strength-indicator{margin-top:20px;margin-bottom:20px}\n"] }]
        }], ctorParameters: () => [{ type: CitiLiveAnnouncer }, { type: ValidationService }], propDecorators: { required: [{
                type: Input$1
            }], requirementsHeading: [{
                type: Input$1
            }], ariaLevel: [{
                type: Input$1
            }], requirementsStrings: [{
                type: Input$1
            }], userId: [{
                type: Input$1
            }], name: [{
                type: Input$1
            }], idStr: [{
                type: Input$1
            }], ariaLabel: [{
                type: Input$1
            }], ariaLabelledby: [{
                type: Input$1
            }], ariaDescribedby: [{
                type: Input$1
            }], placeholder: [{
                type: Input$1
            }], label: [{
                type: Input$1
            }], customErrorMessage: [{
                type: Input$1
            }], successMessage: [{
                type: Input$1
            }], hasStrengthIndicator: [{
                type: Input$1
            }], strength: [{
                type: Input$1
            }], strengthLevelText: [{
                type: Input$1
            }], strengthLabelText: [{
                type: Input$1
            }], hasConfirmingInput: [{
                type: Input$1
            }], placeholderConfirming: [{
                type: Input$1
            }], labelConfirming: [{
                type: Input$1
            }], confirmErrorMessage: [{
                type: Input$1
            }], passwordBlur: [{
                type: Output
            }], passwordFocus: [{
                type: Output
            }], confirmBlur: [{
                type: Output
            }], confirmFocus: [{
                type: Output
            }], mismatchErrorChange: [{
                type: Output
            }], matchSuccessChange: [{
                type: Output
            }], passwordValue: [{
                type: Input$1
            }], passwordValueChange: [{
                type: Output
            }], confirmValue: [{
                type: Input$1
            }], confirmValueChange: [{
                type: Output
            }], invalidError: [{
                type: Input$1
            }], invalidErrorChange: [{
                type: Output
            }], validSuccess: [{
                type: Input$1
            }], validSuccessChange: [{
                type: Output
            }], passwordInput: [{
                type: ViewChild,
                args: ['passwordInput']
            }], confirmInput: [{
                type: ViewChild,
                args: ['confirmInput']
            }] } });

const COMPONENTS$C = [
    PasswordStrengthIndicatorComponent,
    PasswordComponent
];
const MODULES$F = [
    CommonModule,
    FormsModule,
    Grid,
    Input2,
];
class Password {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Password, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: Password, declarations: [PasswordStrengthIndicatorComponent,
            PasswordComponent], imports: [CommonModule,
            FormsModule,
            Grid,
            Input2], exports: [PasswordStrengthIndicatorComponent,
            PasswordComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Password, imports: [MODULES$F] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Password, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$F],
                    declarations: [...COMPONENTS$C],
                    exports: [...COMPONENTS$C]
                }]
        }] });

let nextUniqueId$5 = 0;
const TEXT_AREA_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => TextareaComponent),
    multi: true
};
class TextareaComponent {
    get isFocused() {
        return this._isFocused;
    }
    get hostClasses() {
        return `citi-textarea row ${this.textareavalue || !this.placeHolder ? 'has-value' : ''} ${this._isFocused ? 'is-focused' : ''}`;
    }
    /**
     * Reference to the bound FormControl
     */
    get control() {
        return this.reactiveMode ? this._control : null;
    }
    /**
     * Whether or not the component was set up with a form control
     */
    get reactiveMode() {
        return !!this._control;
    }
    get errorMessage() {
        return this._errorMessage;
    }
    set error(isError) {
        if (isError === this._error)
            return;
        this._error = isError;
        !this.reactiveMode && isError
            ? this.toggleError(true, 'custom')
            : this.toggleError(false);
    }
    get error() {
        return this._error;
    }
    /**
     * This defines the custom error state of the input. Takes precedence over other validation types.
     * @default false
     */
    set hasCustomError(useCustom) {
        if (isDevMode)
            console.warn('Deprecated: please trigger the error state using the [(error)] binding');
    }
    get idStr() {
        return this._id;
    }
    set idStr(value) {
        this._id = value || this._uid;
    }
    get sizeClass() {
        return ({
            fullwidth: 'col-xs-12',
            large: 'col-xs-10 col-md-8 col-lg-8',
            medium: 'col-xs-8 col-sm-9 col-md-6',
            small: 'col-xs-7 col-sm-6 col-md-4',
            xsmall: 'col-xs-6 col-sm-3 col-md-2',
            none: ''
        }[this.size] || 'col-xs-12');
    }
    // #endregion
    // #region // ---------- Lifecycle Hooks
    constructor(validationService, liveAnnouncer, inj) {
        this.validationService = validationService;
        this.liveAnnouncer = liveAnnouncer;
        this.inj = inj;
        // #region // ---------- Properties
        this.unsub$ = new Subject();
        this._errorMessage = null;
        // #endregion
        // #region // ---------- Input/Output
        this.textareavalue = null;
        this.textareavalueChange = new EventEmitter();
        this.customErrorMessage = 'Please provide a "customErrorMessage"';
        this._error = false;
        this.errorChange = new EventEmitter();
        this.readOnly = false;
        this.disabled = false;
        this.blur = new EventEmitter();
        this.focus = new EventEmitter();
        this.isRequired = false;
        this.maxLength = null;
        this.requiredError = 'This is a required field';
        this.validateOnBlur = true;
        this._hasCustomError = false;
        this._uid = `citi-textarea-${nextUniqueId$5++}`;
        this.name = null;
        this.size = 'fullwidth';
        // #endregion
        // #region - FORM BINDING METHODS
        // All methods below are required for the Value Control Accessor interface to work with [(ngModel)]
        this.onChange = (value) => { };
        this.onTouched = () => { };
        this.idStr = this.idStr;
    }
    ngOnInit() {
        /**
         * Will create a reference to the FormControl if a reactive form is setup, otherwise
         * it will assume that the consumer is using the FomContainer / Validation Service
         */
        try {
            this._control = this.inj.get(NgControl);
        }
        catch {
            this.validationService.validateNow
                .pipe(takeUntil(this.unsub$), tap(() => this.validate()))
                .subscribe();
        }
        // Double announcing on desktop so removing.
        // TODO: Check to see if this is required to annouce on mobile only.
        // this.errorChange
        //   .pipe(
        //     takeUntil(this.unsub$),
        //     debounceTime(1250),
        //     tap(error => this.announceError(error))
        //   )
        //   .subscribe();
    }
    ngOnDestroy() {
        this.validationService.removeError(this);
        this.unsub$.next();
        this.unsub$.complete();
    }
    // #endregion
    // #region // ---------- Methods
    get errorsInSpan() {
        return this.errorSpan.nativeElement.textContent;
    }
    /**
     * Manually triggers an error state
     * @param isErrorer - whether to turn the error on or off
     * @param errorType the nature of the error, which determines the error message
     * @example
     *  <citi-textarea #templateVar></citi-textarea>
     *
     *  @ViewChild('templateVar') textarea: ReactiveTextareaComponent;
     *
     *  textarea.toggleError(true, 'custom')
     */
    toggleError(isErrored, errorType = 'custom') {
        this._error = isErrored;
        this.errorChange.emit(isErrored);
        isErrored
            ? this.validationService.addError(this)
            : this.validationService.removeError(this);
        this._errorMessage = errorType.includes('required')
            ? this.requiredError
            : this.customErrorMessage;
    }
    announceError(error) {
        if (this.error)
            this.liveAnnouncer.announce(this.errorsInSpan);
    }
    /**
     * Triggers the baked-in, non-reactive validation
     */
    validate() {
        if (this.reactiveMode)
            return;
        if (this.isRequired && !this.textareavalue)
            this.toggleError(true, 'required');
        // TODO: evaluate when this is called and if it is needed
        else if (this.error && !Boolean(this.textareavalue))
            this.toggleError(true, 'custom');
        else
            this.toggleError(false);
        // TODO: Check if this call actually works and
        // see if this is required to annouce on mobile only.
        // this.announceError();
    }
    /**
     * Resets the apperance and state of the input to initial
     */
    reset() {
        this.toggleError(false);
        this.textareavalue = null;
        if (this.reactiveMode)
            this.control.reset();
    }
    castFocus() {
        this.textarea.nativeElement.focus();
    }
    onFocus(e) {
        this._isFocused = true;
        this.focus.emit(e);
    }
    onBlur(e) {
        this.onTouched();
        this._isFocused = false;
        this.blur.emit(e);
        this.reactiveValidate();
        if (this.validateOnBlur)
            this.validate();
    }
    onKeyup() {
        this.reactiveValidate();
    }
    textChange(value) {
        this.writeValue(value);
    }
    // #endregion
    // #region // ---------- Reactive Forms Methods
    /**
     * Helper method to determine if the bound FormControl's errors object contains an error
     * @param errorName key of the FormControl error object
     * @category reactive
    */
    hasError(errorName) {
        return this.reactiveMode ? this.control.hasError(errorName) : false;
    }
    /**
     * Whether the textarea has been blured. Only works when bound to a FormControl
     * @Type boolean
     * @category reactive
    */
    get touched() {
        return this.reactiveMode ? this.control.touched : false;
    }
    /**
     * Triggers the reactive validation
     * @category reactive
    */
    reactiveValidate() {
        if (!this.reactiveMode)
            return;
        const isError = (!this.validateOnBlur || this.touched) && this.control.invalid;
        if (this._error != isError || this.reactiveMode)
            this.errorChange.emit(isError);
        this._error = isError;
    }
    // Allows Angular to update the model.
    // Update the model and changes needed for the view here.
    writeValue(value) {
        this.textareavalue = value;
        this.textareavalueChange.emit(value);
        //      !!!!    WARNING: DO NOT REMOVE    !!!!
        // this is actually necessary for the (reactive) control to update
        this.onChange(value);
    }
    // Allows Angular to register a function to call when the model changes.
    // Save the function as a property to call later here.
    registerOnChange(fn) {
        this.onChange = fn;
    }
    // Allows Angular to register a function to call when the input has been touched.
    // Save the function as a property to call later here.
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    // Allows Angular to disable the input.
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TextareaComponent, deps: [{ token: ValidationService }, { token: CitiLiveAnnouncer }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: TextareaComponent, isStandalone: false, selector: "citi-textarea", inputs: { textareavalue: "textareavalue", customErrorMessage: "customErrorMessage", error: "error", placeHolder: "placeHolder", labelText: "labelText", describedby: "describedby", readOnly: "readOnly", disabled: "disabled", isRequired: "isRequired", maxLength: "maxLength", requiredError: "requiredError", validateOnBlur: "validateOnBlur", hasCustomError: "hasCustomError", idStr: "idStr", name: "name", size: "size" }, outputs: { textareavalueChange: "textareavalueChange", errorChange: "errorChange", blur: "blur", focus: "focus" }, host: { properties: { "class": "this.hostClasses" } }, providers: [TEXT_AREA_VALUE_ACCESSOR], viewQueries: [{ propertyName: "textarea", first: true, predicate: ["textarea"], descendants: true }, { propertyName: "errorSpan", first: true, predicate: ["errorSpan"], descendants: true }], ngImport: i0, template: `
    <div [attr.class]="sizeClass + ' form-group'">
      <label
        class="text-input-label"
        [attr.for]="idStr"
        [innerHtml]="labelText"
      ></label>

      <textarea
        #textarea
        class="form-control"
        [ngModel]="textareavalue"
        (ngModelChange)="textChange($event)"
        [ngClass]="{ 'validation-input-danger': error, 'readOnly': readOnly, 'disabled': disabled }"
        [attr.id]="idStr"
        [attr.name]="name || idStr"
        [readonly]="readOnly"
        [disabled]="disabled"
        [attr.maxlength]="maxLength"
        [attr.required]="isRequired ? true : null"
        [attr.aria-describedby]="
          error ? idStr + '-error' : describedby ? describedby : null
        "
        [attr.aria-invalid]="error ? true : null"
        [attr.placeholder]="placeHolder"
        (keyup)="onKeyup()"
        (focus)="onFocus($event)"
        (blur)="onBlur($event)"
      >
      </textarea>

      <span
        #errorSpan
        class="validation-message-danger"
        [attr.id]="idStr + '-error'"
      >
        <span *ngIf="error && errorMessage" [innerHtml]="errorMessage"></span>
        <ng-content></ng-content>
      </span>
    </div>
  `, isInline: true, styles: [":host{display:block}label{opacity:0}.is-focused label,.has-value label{opacity:1}.form-control.readOnly,.form-control.disabled{background:#fff!important;border:1px solid #666}:host .light .form-control{background:#fff}:host .light .form-control.readOnly{background-color:#eee!important}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i4.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i4.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TextareaComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-textarea', standalone: false, providers: [TEXT_AREA_VALUE_ACCESSOR], template: `
    <div [attr.class]="sizeClass + ' form-group'">
      <label
        class="text-input-label"
        [attr.for]="idStr"
        [innerHtml]="labelText"
      ></label>

      <textarea
        #textarea
        class="form-control"
        [ngModel]="textareavalue"
        (ngModelChange)="textChange($event)"
        [ngClass]="{ 'validation-input-danger': error, 'readOnly': readOnly, 'disabled': disabled }"
        [attr.id]="idStr"
        [attr.name]="name || idStr"
        [readonly]="readOnly"
        [disabled]="disabled"
        [attr.maxlength]="maxLength"
        [attr.required]="isRequired ? true : null"
        [attr.aria-describedby]="
          error ? idStr + '-error' : describedby ? describedby : null
        "
        [attr.aria-invalid]="error ? true : null"
        [attr.placeholder]="placeHolder"
        (keyup)="onKeyup()"
        (focus)="onFocus($event)"
        (blur)="onBlur($event)"
      >
      </textarea>

      <span
        #errorSpan
        class="validation-message-danger"
        [attr.id]="idStr + '-error'"
      >
        <span *ngIf="error && errorMessage" [innerHtml]="errorMessage"></span>
        <ng-content></ng-content>
      </span>
    </div>
  `, styles: [":host{display:block}label{opacity:0}.is-focused label,.has-value label{opacity:1}.form-control.readOnly,.form-control.disabled{background:#fff!important;border:1px solid #666}:host .light .form-control{background:#fff}:host .light .form-control.readOnly{background-color:#eee!important}\n"] }]
        }], ctorParameters: () => [{ type: ValidationService }, { type: CitiLiveAnnouncer }, { type: i0.Injector }], propDecorators: { hostClasses: [{
                type: HostBinding,
                args: ['class']
            }], textarea: [{
                type: ViewChild,
                args: ['textarea']
            }], errorSpan: [{
                type: ViewChild,
                args: ['errorSpan']
            }], textareavalue: [{
                type: Input$1
            }], textareavalueChange: [{
                type: Output
            }], customErrorMessage: [{
                type: Input$1
            }], error: [{
                type: Input$1
            }], errorChange: [{
                type: Output
            }], placeHolder: [{
                type: Input$1
            }], labelText: [{
                type: Input$1
            }], describedby: [{
                type: Input$1
            }], readOnly: [{
                type: Input$1
            }], disabled: [{
                type: Input$1
            }], blur: [{
                type: Output
            }], focus: [{
                type: Output
            }], isRequired: [{
                type: Input$1
            }], maxLength: [{
                type: Input$1
            }], requiredError: [{
                type: Input$1
            }], validateOnBlur: [{
                type: Input$1
            }], hasCustomError: [{
                type: Input$1
            }], idStr: [{
                type: Input$1
            }], name: [{
                type: Input$1
            }], size: [{
                type: Input$1
            }] } });

class TextArea {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TextArea, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: TextArea, declarations: [TextareaComponent], imports: [CommonModule, FormsModule], exports: [TextareaComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TextArea, imports: [CommonModule, FormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TextArea, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FormsModule],
                    declarations: [TextareaComponent],
                    exports: [TextareaComponent]
                }]
        }] });

function coerceBoolean(val) {
    if (val === 'true' || val === true)
        return true;
    if (val === 'false' || val === false)
        return false;
}
let nextUniqueId$4 = 0;
const CHECKBOX_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => Checkbox2),
    multi: true
};
class Checkbox2 {
    /**
     * allows for a custom id on the input element.
     * @default: a caluculated unique id
     */
    set idStr(value) {
        this._id = value || this._uid;
    }
    get idStr() {
        return this._id;
    }
    /** Whether the checkbox is disabled. */
    set disabled(value) {
        const newDisabledState = coerceBoolean(value);
        if (this._disabled !== newDisabledState) {
            this._disabled = newDisabledState;
        }
    }
    get disabled() {
        return this._disabled;
    }
    /**
     * @property contentAddition
     * @description Where the checkbox is a content addition or not.
     * @return string
     */
    set contentAddition(value) {
        this.isContentAddition = value;
    }
    /** The value of this individual checkbox. */
    get value() {
        return this._value;
    }
    set value(value) {
        if (this._value !== value) {
            this._value = value;
        }
    }
    /** Whether this checkbox is checked. */
    get checked() {
        return this._checked;
    }
    set checked(value) {
        const newCheckedState = coerceBoolean(value);
        if (this._checked !== newCheckedState) {
            this._checked = newCheckedState;
        }
    }
    // #endregion
    // #region // ---------- Constructor/Lifecycle Hooks ---------- //
    constructor(liveAnnouncer) {
        this.liveAnnouncer = liveAnnouncer;
        /** Whether this checkbox is checked. */
        this._checked = false;
        this.isContentAddition = false;
        this.required = false;
        this.expandedMessage = 'Additional information expanded';
        this.collapsedMessage = 'Additional information collapsed';
        this._uid = `citi-checkbox2-${nextUniqueId$4++}`;
        // #endregion
        // #region // ---------- Outputs ---------- //
        this.getCheckbox = new EventEmitter();
        /**
         * @Event: blur
         * @description Emitted when a checkbox loses focus
         */
        this.blur = new EventEmitter();
        /**
         * @Event: keyup
         * @description Emitted when keyup is fired on the checkbox
         */
        this.keyup = new EventEmitter();
        /**
         * @Event: keydown
         * @description Emitted when keydown is fired on the checkbox
         */
        this.keydown = new EventEmitter();
        /**
         * @Event: keypress
         * @description Emitted when key press is fired on the checkbox
         */
        this.keypress = new EventEmitter();
        /**
         * @Event: checkChange
         * @Description: Emitted when checkChange is fired on the checkbox
         */
        this.checkChange = new EventEmitter();
        // #endregion
        // #region // ---------- Reative Forms Stuffs ---------- //
        /** The method to be called in order to update ngModel */
        this.onChange = (value) => { };
        /** onTouch function registered via registerOnTouch (ControlValueAccessor) */
        this.onTouched = () => { };
    }
    ngOnInit() {
        // Force setter to be called in case id was not specified.
        this.idStr = this.idStr;
        if (!this.name)
            this.name = this.idStr;
    }
    ngOnChanges(changes) {
        for (const propName in changes) {
            const change = changes[propName];
            if (propName === 'contentAddition' || propName === 'ariaDescribedby') {
                this._inputDescribedby =
                    this.ariaDescribedby && this.isContentAddition
                        ? this.ariaDescribedby + ' ' + this.idStr + 'descby'
                        : this.ariaDescribedby
                            ? this.ariaDescribedby
                            : this.isContentAddition
                                ? this.idStr + 'descby'
                                : null;
            }
        }
    }
    // #endregion
    // #region // ---------- Methods ---------- //
    onBlur(event) {
        this.blur.emit(event);
        this.onTouched();
    }
    get announcerMessage() {
        if (this.checked && this.contentEl.nativeElement.children.length)
            return this.expandedMessage;
        else if (!this.checked) {
            if (this.groupError && !this.contentEl.nativeElement.children.length)
                return this.groupErrorMessage;
            else if (!this.groupError && this.contentEl.nativeElement.children.length)
                return this.collapsedMessage;
            else if (!this.groupError &&
                !this.contentEl.nativeElement.children.length)
                return '';
            else if (this.groupError && this.contentEl.nativeElement.children.length)
                return this.collapsedMessage + this.groupErrorMessage;
        }
    }
    /**
     * Triggered when the checkbox received a click or the input recognized any change.
     * Clicking on a label element, will trigger a change event on the associated input.
     */
    _onInputChange(event) {
        event.stopPropagation();
        if (this.checked === true)
            this.checked = false;
        else
            this.checked = true;
        /** Dispatch change event with current checkbox. */
        this.getCheckbox.emit(this);
        this.checkChange.emit(this.checked);
        this.writeValue(this.checked);
    }
    /**
     * Sets the model value. Implemented as part of ControlValueAccessor.
     * @param cheecked
     */
    writeValue(cheecked) {
        this.onChange(cheecked);
    }
    /**
     * Registers a callback to be triggered when the model value changes.
     * Implemented as part of ControlValueAccessor.
     * @param fn Callback to be registered.
     */
    registerOnChange(fn) {
        this.onChange = fn;
    }
    /**
     * Registers a callback to be triggered when the control is touched.
     * Implemented as part of ControlValueAccessor.
     * @param fn Callback to be registered.
     */
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    /**
     * Sets the disabled state of the control. Implemented as a part of ControlValueAccessor.
     * @param isDisabled Whether the control should be disabled.
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Checkbox2, deps: [{ token: CitiLiveAnnouncer }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: Checkbox2, isStandalone: false, selector: "citi-checkbox2", inputs: { name: "name", required: "required", label: "label", expandedMessage: "expandedMessage", collapsedMessage: "collapsedMessage", idStr: "idStr", tabIndex: "tabIndex", htmlContent: "htmlContent", ariaLabel: ["aria-label", "ariaLabel"], ariaLabelledby: ["aria-labelledby", "ariaLabelledby"], ariaDescribedby: ["aria-describedby", "ariaDescribedby"], disabled: "disabled", contentAddition: "contentAddition", value: "value", checked: "checked" }, outputs: { getCheckbox: "getCheckbox", blur: "blur", keyup: "keyup", keydown: "keydown", keypress: "keypress", checkChange: "checkChange" }, host: { classAttribute: "citi-checkbox2" }, providers: [CHECKBOX_CONTROL_VALUE_ACCESSOR], viewQueries: [{ propertyName: "contentEl", first: true, predicate: ["contentEl"], descendants: true }], usesOnChanges: true, ngImport: i0, template: `
    <div
      class="checkbox2 col-xs-12"
      [class.content-addition]="isContentAddition ? true : null"
      *ngIf="name && label && value"
      [attr.id]="idStr + '-wrapper'"
    >
      <input
        #inputEl
        type="checkbox"
        class="checkbox2-input"
        [attr.id]="idStr"
        [value]="value"
        [attr.name]="name"
        [checked]="checked"
        [disabled]="disabled"
        [attr.aria-required]="required"
        [tabIndex]="tabIndex"
        [attr.aria-label]="ariaLabel"
        [attr.aria-labelledby]="ariaLabelledby"
        [attr.aria-describedby]="_inputDescribedby"
        (change)="_onInputChange($event)"
        (blur)="onBlur($event)"
        (keyup)="keyup.emit($event)"
        (keydown)="keydown.emit($event)"
        (keypress)="keypress.emit($event)"
      />
      <label
        class="checkbox2-label"
        [attr.for]="idStr"
        [attr.id]="idStr + '-label'"
        [innerHtml]="label"
      ></label>
      <div *ngIf="isContentAddition" [id]="idStr + 'descby'" class="sr-only" aria-atomic="true" aria-hidden="true">{{this.checked ? this.expandedMessage : this.collapsedMessage}}</div>

      <!-- This is the projected content when the checkbox is checked and has any content -->
      <div
        [attr.id]="idStr + 'content-addition'"
        *ngIf="isContentAddition"
        class="row"
        [class.hidden]="contentEl && !contentEl.children.length"
      >
        <div class="col-xs-12">
          <div class="inline-content2">
            <div #contentEl [contentHtml]="htmlContent">
              <ng-content></ng-content>
            </div>
          </div>
        </div>
      </div>
    </div>
  `, isInline: true, styles: [".groupTitle{margin:42px 0 30px;font-size:22px;font-size:1.375rem;line-height:1.5rem;font-family:Interstate_Light,sans-serif;color:#333;border-bottom:0}.validation-fieldset-danger{border-left:2px solid #D60000;padding-left:10px;margin-left:-1px}.validation-message-danger{font-weight:700;line-height:1rem;font-size:12px;font-size:.75rem;font-family:interstate_Bold,sans-serif;color:#d60000}.radio2,.checkbox2{position:relative;margin:12px 0}.radio2 input,.checkbox2 input{display:inline-block;opacity:.01}.radio2 label,.checkbox2 label{display:inline-block;width:98%;cursor:pointer;min-height:26px}.radio2 input:disabled+label:before,.checkbox2 input:disabled+label:before{border:1px solid #999}.radio2 label:focus,.radio2 label:hover,.checkbox2 label:focus,.checkbox2 label:hover{text-decoration:underline;color:#002a54}.radio2 input:checked+label,.checkbox2 input:checked+label{color:#056dae}.radio2 input:disabled+label,.checkbox2 input:disabled+label{cursor:default;color:#999;text-decoration:none}.radio2 .row,.checkbox2 .row{display:none;margin-bottom:0}.radio2 .row>.col-xs-12,.checkbox2 .row>.col-xs-12{padding-left:0}.radio2 .inline-content2,.checkbox2 .inline-content2{display:block;max-height:300em;padding:20px 20px 20px 40px;margin:10px 0 10px 10px;background-color:#eee}.radio2 [type=checkbox],.radio2 [type=radio],.checkbox2 [type=checkbox],.checkbox2 [type=radio]{margin-bottom:0}.radio2 [type=checkbox]~.row,.radio2 [type=radio]~.row,.checkbox2 [type=checkbox]~.row,.checkbox2 [type=radio]~.row{display:none}.radio2 [type=checkbox]:checked~.row,.radio2 [type=radio]:checked~.row,.checkbox2 [type=checkbox]:checked~.row,.checkbox2 [type=radio]:checked~.row{display:block}input{vertical-align:middle;margin-top:1px;margin-right:15px;display:inline-block;position:absolute;top:0;opacity:.01}input:focus+label{color:#002a54;text-decoration:underline}.checkbox2 label:before{content:\"\";position:relative;top:4px;display:inline-block;width:20px;height:20px;margin-right:10px;border:1px solid black;border-radius:6px;background-color:transparent}.checkbox2 input:checked+label:before{background-image:url(data:image/svg+xml,%3Csvg%20width%3D%2211%22%20height%3D%228%22%20viewBox%3D%220%200%2011%208%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22m5.242%207.026-.597.632a.26.26%200%200%201-.381.006L.82%204.013a.297.297%200%200%201%20.006-.404l.735-.778a.26.26%200%200%201%20.38-.006l2.528%202.68L9.558.335a.256.256%200%200%201%20.377.006l.728.77a.295.295%200%200%201%20.005.4L5.24%207.026z%22%20fill%3D%22%23fff%22%20fill-rule%3D%22evenodd%22%2F%3E%3C%2Fsvg%3E);background-repeat:no-repeat;background-position:center;background-color:#056dae;border:none}.checkbox2 input:checked:disabled+label:before{background-color:#999}.checkbox2 input:focus-visible+label:before{outline:1px solid #000}[role=list]{margin:0;padding:0}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Checkbox2, decorators: [{
            type: Component,
            args: [{ selector: 'citi-checkbox2', standalone: false, providers: [CHECKBOX_CONTROL_VALUE_ACCESSOR], changeDetection: ChangeDetectionStrategy.OnPush, host: { class: 'citi-checkbox2' }, template: `
    <div
      class="checkbox2 col-xs-12"
      [class.content-addition]="isContentAddition ? true : null"
      *ngIf="name && label && value"
      [attr.id]="idStr + '-wrapper'"
    >
      <input
        #inputEl
        type="checkbox"
        class="checkbox2-input"
        [attr.id]="idStr"
        [value]="value"
        [attr.name]="name"
        [checked]="checked"
        [disabled]="disabled"
        [attr.aria-required]="required"
        [tabIndex]="tabIndex"
        [attr.aria-label]="ariaLabel"
        [attr.aria-labelledby]="ariaLabelledby"
        [attr.aria-describedby]="_inputDescribedby"
        (change)="_onInputChange($event)"
        (blur)="onBlur($event)"
        (keyup)="keyup.emit($event)"
        (keydown)="keydown.emit($event)"
        (keypress)="keypress.emit($event)"
      />
      <label
        class="checkbox2-label"
        [attr.for]="idStr"
        [attr.id]="idStr + '-label'"
        [innerHtml]="label"
      ></label>
      <div *ngIf="isContentAddition" [id]="idStr + 'descby'" class="sr-only" aria-atomic="true" aria-hidden="true">{{this.checked ? this.expandedMessage : this.collapsedMessage}}</div>

      <!-- This is the projected content when the checkbox is checked and has any content -->
      <div
        [attr.id]="idStr + 'content-addition'"
        *ngIf="isContentAddition"
        class="row"
        [class.hidden]="contentEl && !contentEl.children.length"
      >
        <div class="col-xs-12">
          <div class="inline-content2">
            <div #contentEl [contentHtml]="htmlContent">
              <ng-content></ng-content>
            </div>
          </div>
        </div>
      </div>
    </div>
  `, styles: [".groupTitle{margin:42px 0 30px;font-size:22px;font-size:1.375rem;line-height:1.5rem;font-family:Interstate_Light,sans-serif;color:#333;border-bottom:0}.validation-fieldset-danger{border-left:2px solid #D60000;padding-left:10px;margin-left:-1px}.validation-message-danger{font-weight:700;line-height:1rem;font-size:12px;font-size:.75rem;font-family:interstate_Bold,sans-serif;color:#d60000}.radio2,.checkbox2{position:relative;margin:12px 0}.radio2 input,.checkbox2 input{display:inline-block;opacity:.01}.radio2 label,.checkbox2 label{display:inline-block;width:98%;cursor:pointer;min-height:26px}.radio2 input:disabled+label:before,.checkbox2 input:disabled+label:before{border:1px solid #999}.radio2 label:focus,.radio2 label:hover,.checkbox2 label:focus,.checkbox2 label:hover{text-decoration:underline;color:#002a54}.radio2 input:checked+label,.checkbox2 input:checked+label{color:#056dae}.radio2 input:disabled+label,.checkbox2 input:disabled+label{cursor:default;color:#999;text-decoration:none}.radio2 .row,.checkbox2 .row{display:none;margin-bottom:0}.radio2 .row>.col-xs-12,.checkbox2 .row>.col-xs-12{padding-left:0}.radio2 .inline-content2,.checkbox2 .inline-content2{display:block;max-height:300em;padding:20px 20px 20px 40px;margin:10px 0 10px 10px;background-color:#eee}.radio2 [type=checkbox],.radio2 [type=radio],.checkbox2 [type=checkbox],.checkbox2 [type=radio]{margin-bottom:0}.radio2 [type=checkbox]~.row,.radio2 [type=radio]~.row,.checkbox2 [type=checkbox]~.row,.checkbox2 [type=radio]~.row{display:none}.radio2 [type=checkbox]:checked~.row,.radio2 [type=radio]:checked~.row,.checkbox2 [type=checkbox]:checked~.row,.checkbox2 [type=radio]:checked~.row{display:block}input{vertical-align:middle;margin-top:1px;margin-right:15px;display:inline-block;position:absolute;top:0;opacity:.01}input:focus+label{color:#002a54;text-decoration:underline}.checkbox2 label:before{content:\"\";position:relative;top:4px;display:inline-block;width:20px;height:20px;margin-right:10px;border:1px solid black;border-radius:6px;background-color:transparent}.checkbox2 input:checked+label:before{background-image:url(data:image/svg+xml,%3Csvg%20width%3D%2211%22%20height%3D%228%22%20viewBox%3D%220%200%2011%208%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22m5.242%207.026-.597.632a.26.26%200%200%201-.381.006L.82%204.013a.297.297%200%200%201%20.006-.404l.735-.778a.26.26%200%200%201%20.38-.006l2.528%202.68L9.558.335a.256.256%200%200%201%20.377.006l.728.77a.295.295%200%200%201%20.005.4L5.24%207.026z%22%20fill%3D%22%23fff%22%20fill-rule%3D%22evenodd%22%2F%3E%3C%2Fsvg%3E);background-repeat:no-repeat;background-position:center;background-color:#056dae;border:none}.checkbox2 input:checked:disabled+label:before{background-color:#999}.checkbox2 input:focus-visible+label:before{outline:1px solid #000}[role=list]{margin:0;padding:0}\n"] }]
        }], ctorParameters: () => [{ type: CitiLiveAnnouncer }], propDecorators: { contentEl: [{
                type: ViewChild,
                args: ['contentEl']
            }], name: [{
                type: Input$1
            }], required: [{
                type: Input$1
            }], label: [{
                type: Input$1
            }], expandedMessage: [{
                type: Input$1
            }], collapsedMessage: [{
                type: Input$1
            }], idStr: [{
                type: Input$1
            }], tabIndex: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }], ariaLabel: [{
                type: Input$1,
                args: ['aria-label']
            }], ariaLabelledby: [{
                type: Input$1,
                args: ['aria-labelledby']
            }], ariaDescribedby: [{
                type: Input$1,
                args: ['aria-describedby']
            }], disabled: [{
                type: Input$1
            }], contentAddition: [{
                type: Input$1
            }], value: [{
                type: Input$1
            }], checked: [{
                type: Input$1
            }], getCheckbox: [{
                type: Output
            }], blur: [{
                type: Output
            }], keyup: [{
                type: Output
            }], keydown: [{
                type: Output
            }], keypress: [{
                type: Output
            }], checkChange: [{
                type: Output
            }] } });

/**
 * Provider Expression that allows checkbox-group to register as a ControlValueAccessor. This
 * allows it to support [(ngModel)] and ngControl.
 */
const CHECKBOX_GROUP_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CheckboxGroup),
    multi: true
};
class CheckboxGroup {
    get value() {
        return this._value;
    }
    set value(val) {
        if (this.value !== val) {
            this._value = val;
            if (this._checkboxes) {
                let filterCheckboxes = this._checkboxes.filter(x => val.includes(x.value));
                filterCheckboxes.forEach(checkbox => {
                    checkbox.checked = true;
                    this.error = false;
                });
            }
        }
    }
    // #endregion
    // #region // ---------- Constructor/Lifecycle Hooks ---------- //
    constructor(_el, validationService) {
        this._el = _el;
        this.validationService = validationService;
        this.unsub$ = new Subject();
        /** Whether the `value` has been set to its initial value. */
        this._isInitialized = false;
        // #endregion
        // #region // ----------  Inputs ---------- //
        /** Whether the checkbox group is disabled. */
        this.disabled = false;
        /** Selected value for the checkbox group. */
        this._value = [];
        /** Whether the checkbox group is required. */
        this.required = false;
        this.error = false;
        this.errorMessage = 'Input is required';
        this.groupRequiredAriaLabel = 'At least one checkbox should be checked.';
        /**
         * @property titleText
         * @description The titleText for the input group
         * @return string
         */
        this.titleText = '';
        // #endregion
        // #region // ---------- Outputs ---------- //
        this.errorChange = new EventEmitter();
        this.valueChange = new EventEmitter();
        this.change = new EventEmitter();
        this.blur = new EventEmitter();
        // #endregion
        // #region // ---------- Reative Forms Stuffs --------------- //
        /** The method to be called in order to update ngModel */
        this.onChange = (value) => { };
        /** onTouch function registered via registerOnTouch (ControlValueAccessor) */
        this.onTouched = () => { };
    }
    ngOnInit() {
        this._validateSub = this.validationService.validateNow.subscribe(_ => {
            this.validate();
        });
    }
    ngAfterContentInit() {
        this._isInitialized = true;
        this._checkboxes.forEach(checkbox => {
            if (this.disabled)
                checkbox.disabled = true;
            if (this.error) {
                checkbox.groupError = this.error;
                checkbox.groupErrorMessage = this.errorMessage;
            }
        });
        this._checkboxes.forEach(checkbox => {
            checkbox.checkChange
                .pipe(tap(() => {
                this.onChange(checkbox.value);
                checkbox.checked
                    ? this.pushValue(checkbox.value)
                    : this.removeValue(checkbox.value);
                this._emitChangeEvent();
                // checkbox group validation
                this.validate();
            }), takeUntil(this.unsub$))
                .subscribe();
        });
    }
    ngOnDestroy() {
        this.validationService.removeError(this);
        this._validateSub.unsubscribe();
        this.unsub$.next();
        this.unsub$.complete();
    }
    /** Dispatch change event with current selection and group value. */
    _emitChangeEvent() {
        if (this._isInitialized) {
            this.change.emit(this._value);
        }
    }
    // #endregion
    // #region // ---------- Methods ---------- //
    pushValue(newValue) {
        this._value = [...this._value, newValue];
        this.valueChange.emit(this._value);
        this.onTouched();
        this.writeValue(this._value);
    }
    removeValue(newValue) {
        this._value = this._value.filter(str => str !== newValue);
        this.valueChange.emit(this._value);
        this.onTouched();
        this.writeValue(this._value);
    }
    // #endregion
    // #region // ---------- Validation Methods --------------- //
    toggleError(isErrored) {
        this.error = isErrored;
        if (isErrored)
            this.validationService.addError(this);
        else
            this.validationService.removeError(this);
        this.errorChange.emit(isErrored);
    }
    validate() {
        if (this.required) {
            this.toggleError(!this._checkboxes.map(checkbox => checkbox.checked).includes(true));
            this._isErrorHidden = true;
            setTimeout(() => {
                this._isErrorHidden = false;
            }, 1);
        }
    }
    _focusoutCheckboxGroup(focusEvent) {
        const isInGroup = this._el.nativeElement.contains(focusEvent.relatedTarget);
        if (!isInGroup) {
            this.onTouched();
            this.blur.emit();
        }
    }
    /**
     * Sets the model value. Implemented as part of ControlValueAccessor.
     * @param value
     */
    writeValue(value) {
        this.value = value;
        this.onChange(value);
    }
    /**
     * Registers a callback to be triggered when the model value changes.
     * Implemented as part of ControlValueAccessor.
     * @param fn Callback to be registered.
     */
    registerOnChange(fn) {
        this.onChange = fn;
    }
    /**
     * Registers a callback to be triggered when the control is touched.
     * Implemented as part of ControlValueAccessor.
     * @param fn Callback to be registered.
     */
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    /**
     * Sets the disabled state of the control. Implemented as a part of ControlValueAccessor.
     * @param isDisabled Whether the control should be disabled.
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CheckboxGroup, deps: [{ token: i0.ElementRef }, { token: ValidationService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: CheckboxGroup, isStandalone: false, selector: "citi-checkbox-group", inputs: { disabled: "disabled", value: "value", required: "required", error: "error", errorMessage: "errorMessage", groupRequiredAriaLabel: "groupRequiredAriaLabel", groupRequiredAriaLabelledby: "groupRequiredAriaLabelledby", titleText: "titleText" }, outputs: { errorChange: "errorChange", valueChange: "valueChange", change: "change", blur: "blur" }, host: { listeners: { "focusout": "_focusoutCheckboxGroup($event)" }, classAttribute: "citi-checkbox-group" }, providers: [CHECKBOX_GROUP_CONTROL_VALUE_ACCESSOR], queries: [{ propertyName: "_checkboxes", predicate: Checkbox2 }], ngImport: i0, template: `
    <fieldset>
      <legend *ngIf="titleText !== null && titleText !== ''" class="groupTitle">
        <span [innerHtml]="titleText"></span>
      </legend>
      <div aria-live="polite">
        <div
          class="validation-message-danger"
          *ngIf="error && !_isErrorHidden"
          [innerHtml]="errorMessage"
          role="alert"
        ></div>
      </div>
      <div class="row" [ngClass]="error ? 'validation-fieldset-danger' : null">
        <div
          role="list"
          [attr.aria-label]="required && groupRequiredAriaLabel && !(value?.length > 0) ? groupRequiredAriaLabel : null"
          [attr.aria-labelledby]="required && groupRequiredAriaLabelledby ? groupRequiredAriaLabelledby : null"
        >
          <ng-content></ng-content>
        </div>
      </div>
    </fieldset>
  `, isInline: true, styles: [".groupTitle{margin:42px 0 30px;font-size:22px;font-size:1.375rem;line-height:1.5rem;font-family:Interstate_Light,sans-serif;color:#333;border-bottom:0}.validation-fieldset-danger{border-left:2px solid #D60000;padding-left:10px;margin-left:-1px}.validation-message-danger{font-weight:700;line-height:1rem;font-size:12px;font-size:.75rem;font-family:interstate_Bold,sans-serif;color:#d60000}.radio2,.checkbox2{position:relative;margin:12px 0}.radio2 input,.checkbox2 input{display:inline-block;opacity:.01}.radio2 label,.checkbox2 label{display:inline-block;width:98%;cursor:pointer;min-height:26px}.radio2 input:disabled+label:before,.checkbox2 input:disabled+label:before{border:1px solid #999}.radio2 label:focus,.radio2 label:hover,.checkbox2 label:focus,.checkbox2 label:hover{text-decoration:underline;color:#002a54}.radio2 input:checked+label,.checkbox2 input:checked+label{color:#056dae}.radio2 input:disabled+label,.checkbox2 input:disabled+label{cursor:default;color:#999;text-decoration:none}.radio2 .row,.checkbox2 .row{display:none;margin-bottom:0}.radio2 .row>.col-xs-12,.checkbox2 .row>.col-xs-12{padding-left:0}.radio2 .inline-content2,.checkbox2 .inline-content2{display:block;max-height:300em;padding:20px 20px 20px 40px;margin:10px 0 10px 10px;background-color:#eee}.radio2 [type=checkbox],.radio2 [type=radio],.checkbox2 [type=checkbox],.checkbox2 [type=radio]{margin-bottom:0}.radio2 [type=checkbox]~.row,.radio2 [type=radio]~.row,.checkbox2 [type=checkbox]~.row,.checkbox2 [type=radio]~.row{display:none}.radio2 [type=checkbox]:checked~.row,.radio2 [type=radio]:checked~.row,.checkbox2 [type=checkbox]:checked~.row,.checkbox2 [type=radio]:checked~.row{display:block}input{vertical-align:middle;margin-top:1px;margin-right:15px;display:inline-block;position:absolute;top:0;opacity:.01}input:focus+label{color:#002a54;text-decoration:underline}.checkbox2 label:before{content:\"\";position:relative;top:4px;display:inline-block;width:20px;height:20px;margin-right:10px;border:1px solid black;border-radius:6px;background-color:transparent}.checkbox2 input:checked+label:before{background-image:url(data:image/svg+xml,%3Csvg%20width%3D%2211%22%20height%3D%228%22%20viewBox%3D%220%200%2011%208%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22m5.242%207.026-.597.632a.26.26%200%200%201-.381.006L.82%204.013a.297.297%200%200%201%20.006-.404l.735-.778a.26.26%200%200%201%20.38-.006l2.528%202.68L9.558.335a.256.256%200%200%201%20.377.006l.728.77a.295.295%200%200%201%20.005.4L5.24%207.026z%22%20fill%3D%22%23fff%22%20fill-rule%3D%22evenodd%22%2F%3E%3C%2Fsvg%3E);background-repeat:no-repeat;background-position:center;background-color:#056dae;border:none}.checkbox2 input:checked:disabled+label:before{background-color:#999}.checkbox2 input:focus-visible+label:before{outline:1px solid #000}[role=list]{margin:0;padding:0}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
__decorate([
    Boolish,
    __metadata("design:type", Boolean)
], CheckboxGroup.prototype, "disabled", void 0);
__decorate([
    Boolish,
    __metadata("design:type", Boolean)
], CheckboxGroup.prototype, "required", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CheckboxGroup, decorators: [{
            type: Component,
            args: [{ selector: 'citi-checkbox-group', standalone: false, providers: [CHECKBOX_GROUP_CONTROL_VALUE_ACCESSOR], host: {
                        class: 'citi-checkbox-group',
                        '(focusout)': '_focusoutCheckboxGroup($event)'
                    }, template: `
    <fieldset>
      <legend *ngIf="titleText !== null && titleText !== ''" class="groupTitle">
        <span [innerHtml]="titleText"></span>
      </legend>
      <div aria-live="polite">
        <div
          class="validation-message-danger"
          *ngIf="error && !_isErrorHidden"
          [innerHtml]="errorMessage"
          role="alert"
        ></div>
      </div>
      <div class="row" [ngClass]="error ? 'validation-fieldset-danger' : null">
        <div
          role="list"
          [attr.aria-label]="required && groupRequiredAriaLabel && !(value?.length > 0) ? groupRequiredAriaLabel : null"
          [attr.aria-labelledby]="required && groupRequiredAriaLabelledby ? groupRequiredAriaLabelledby : null"
        >
          <ng-content></ng-content>
        </div>
      </div>
    </fieldset>
  `, styles: [".groupTitle{margin:42px 0 30px;font-size:22px;font-size:1.375rem;line-height:1.5rem;font-family:Interstate_Light,sans-serif;color:#333;border-bottom:0}.validation-fieldset-danger{border-left:2px solid #D60000;padding-left:10px;margin-left:-1px}.validation-message-danger{font-weight:700;line-height:1rem;font-size:12px;font-size:.75rem;font-family:interstate_Bold,sans-serif;color:#d60000}.radio2,.checkbox2{position:relative;margin:12px 0}.radio2 input,.checkbox2 input{display:inline-block;opacity:.01}.radio2 label,.checkbox2 label{display:inline-block;width:98%;cursor:pointer;min-height:26px}.radio2 input:disabled+label:before,.checkbox2 input:disabled+label:before{border:1px solid #999}.radio2 label:focus,.radio2 label:hover,.checkbox2 label:focus,.checkbox2 label:hover{text-decoration:underline;color:#002a54}.radio2 input:checked+label,.checkbox2 input:checked+label{color:#056dae}.radio2 input:disabled+label,.checkbox2 input:disabled+label{cursor:default;color:#999;text-decoration:none}.radio2 .row,.checkbox2 .row{display:none;margin-bottom:0}.radio2 .row>.col-xs-12,.checkbox2 .row>.col-xs-12{padding-left:0}.radio2 .inline-content2,.checkbox2 .inline-content2{display:block;max-height:300em;padding:20px 20px 20px 40px;margin:10px 0 10px 10px;background-color:#eee}.radio2 [type=checkbox],.radio2 [type=radio],.checkbox2 [type=checkbox],.checkbox2 [type=radio]{margin-bottom:0}.radio2 [type=checkbox]~.row,.radio2 [type=radio]~.row,.checkbox2 [type=checkbox]~.row,.checkbox2 [type=radio]~.row{display:none}.radio2 [type=checkbox]:checked~.row,.radio2 [type=radio]:checked~.row,.checkbox2 [type=checkbox]:checked~.row,.checkbox2 [type=radio]:checked~.row{display:block}input{vertical-align:middle;margin-top:1px;margin-right:15px;display:inline-block;position:absolute;top:0;opacity:.01}input:focus+label{color:#002a54;text-decoration:underline}.checkbox2 label:before{content:\"\";position:relative;top:4px;display:inline-block;width:20px;height:20px;margin-right:10px;border:1px solid black;border-radius:6px;background-color:transparent}.checkbox2 input:checked+label:before{background-image:url(data:image/svg+xml,%3Csvg%20width%3D%2211%22%20height%3D%228%22%20viewBox%3D%220%200%2011%208%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22m5.242%207.026-.597.632a.26.26%200%200%201-.381.006L.82%204.013a.297.297%200%200%201%20.006-.404l.735-.778a.26.26%200%200%201%20.38-.006l2.528%202.68L9.558.335a.256.256%200%200%201%20.377.006l.728.77a.295.295%200%200%201%20.005.4L5.24%207.026z%22%20fill%3D%22%23fff%22%20fill-rule%3D%22evenodd%22%2F%3E%3C%2Fsvg%3E);background-repeat:no-repeat;background-position:center;background-color:#056dae;border:none}.checkbox2 input:checked:disabled+label:before{background-color:#999}.checkbox2 input:focus-visible+label:before{outline:1px solid #000}[role=list]{margin:0;padding:0}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: ValidationService }], propDecorators: { _checkboxes: [{
                type: ContentChildren,
                args: [Checkbox2, { descendants: false }]
            }], disabled: [{
                type: Input$1
            }], value: [{
                type: Input$1
            }], required: [{
                type: Input$1
            }], error: [{
                type: Input$1
            }], errorMessage: [{
                type: Input$1
            }], groupRequiredAriaLabel: [{
                type: Input$1
            }], groupRequiredAriaLabelledby: [{
                type: Input$1
            }], titleText: [{
                type: Input$1
            }], errorChange: [{
                type: Output
            }], valueChange: [{
                type: Output
            }], change: [{
                type: Output
            }], blur: [{
                type: Output
            }] } });

const COMPONENTS$B = [Checkbox2, CheckboxGroup];
const MODULES$E = [CommonModule, ContentHtml];
class Checkbox2Module {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Checkbox2Module, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: Checkbox2Module, declarations: [Checkbox2, CheckboxGroup], imports: [CommonModule, ContentHtml], exports: [Checkbox2, CheckboxGroup] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Checkbox2Module, imports: [MODULES$E] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Checkbox2Module, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$E],
                    declarations: [...COMPONENTS$B],
                    exports: [...COMPONENTS$B]
                }]
        }] });

class Radio2Service {
    constructor() {
        this.errorIdValue$ = new BehaviorSubject(null);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Radio2Service, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Radio2Service, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Radio2Service, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [] });

let nextUniqueId$3 = 0;
class Radio2 {
    /** ID of the native input element inside `<citi-radio2>` */
    get inputId() {
        return `${this.idStr || this._uniqueId}-input`;
    }
    /** The value of this radio button. */
    get value() { return this._value; }
    set value(value) {
        if (this._value !== value) {
            this._value = value;
        }
    }
    /** Whether this radio button is checked. */
    get checked() { return this._checked; }
    set checked(value) {
        const newCheckedState = coerceBool(value);
        if (this._checked !== newCheckedState) {
            this._checked = newCheckedState;
        }
    }
    /** Whether the radio button is disabled. */
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        const newDisabledState = coerceBool(value);
        if (this._disabled !== newDisabledState) {
            this._disabled = newDisabledState;
        }
    }
    /** Whether the radio button is required. */
    get required() { return this._required; }
    set required(value) { this._required = coerceBool(value); }
    /**
     * Where the radio has a content addition or not.
     */
    set contentAddition(value) {
        this.isContentAddition = value;
    }
    // #endregion
    // #region // ----------  Constructor / Lifecycle Hooks ---------- //
    constructor(_changeDetector, radio2Service) {
        this._changeDetector = _changeDetector;
        this.radio2Service = radio2Service;
        this._uniqueId = `radio2-${++nextUniqueId$3}`;
        /** Whether this radio is checked. */
        this._checked = false;
        /** Value assigned to this radio. */
        this._value = null;
        this.isContentAddition = false;
        // #endregion
        // #region // ----------  Inputs/Outputs ---------- //
        // Constants for LiveAnnouncer
        this.expandedMessage = 'Additional information expanded';
        this.collapsedMessage = 'Additional information collapsed';
        /** The unique ID for the radio button. */
        this.idStr = this._uniqueId;
        this.change = new EventEmitter();
        /**
         * Emitted when a checkbox button loses focus
         */
        this.blur = new EventEmitter();
        /**
         * Emitted when keyup is fired on the checkbox button
         */
        this.keyup = new EventEmitter();
        /**
         * Emitted when keydown is fired on the checkbox button
         */
        this.keydown = new EventEmitter();
        /**
         * Emitted when key press is fired on the checkbox button
         */
        this.keypress = new EventEmitter();
        /**
         * Emitted when checkChange is fired on the radio button
         */
        this.checkChange = new EventEmitter();
    }
    ngOnInit() {
        this.radio2Service?.errorIdValue$?.subscribe(val => {
            this._errorDescribedby = val;
            this.changeDescribedby();
        });
    }
    ngOnChanges(changes) {
        for (const propName in changes) {
            const change = changes[propName];
            if (propName === 'contentAddition' || propName === 'ariaDescribedby') {
                this.changeDescribedby();
            }
        }
    }
    // #endregion
    // #region // ----------  Methods ---------- //
    _markForCheck() {
        // When group value changes, the button will not be notified. Use `markForCheck` to explicit
        // update radio button's status
        this._changeDetector.markForCheck();
    }
    /** Dispatch change event with current value. */
    _emitChangeEvent() {
        this.change.emit(new RadioChange(this, this._value));
    }
    /**
     * Triggered when the radio button received a click or the input recognized any change.
     * Clicking on a label element, will trigger a change event on the associated input.
     */
    _onInputChange(event) {
        // We always have to stop propagation on the change event.
        // Otherwise the change event, from the input element, will bubble up and
        // emit its event object to the `change` output.
        event.stopPropagation();
        this.checked = true;
        this.checkChange.emit(this.checked);
        this._emitChangeEvent();
    }
    changeDescribedby() {
        this._inputDescribedby =
            this.ariaDescribedby && this.isContentAddition
                ? this.ariaDescribedby + ' ' + this.idStr + 'descby'
                : this.ariaDescribedby
                    ? this.ariaDescribedby
                    : this.isContentAddition
                        ? this.idStr + 'descby'
                        : null;
        if (this._errorDescribedby && this._inputDescribedby) {
            this._inputDescribedby += ' ' + this._errorDescribedby;
        }
        else if (this._errorDescribedby) {
            this._inputDescribedby = this._errorDescribedby;
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Radio2, deps: [{ token: i0.ChangeDetectorRef }, { token: Radio2Service }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: Radio2, isStandalone: false, selector: "citi-radio2", inputs: { expandedMessage: "expandedMessage", collapsedMessage: "collapsedMessage", idStr: "idStr", name: "name", label: "label", tabIndex: "tabIndex", htmlContent: "htmlContent", ariaLabel: ["aria-label", "ariaLabel"], ariaLabelledby: ["aria-labelledby", "ariaLabelledby"], ariaDescribedby: ["aria-describedby", "ariaDescribedby"], value: "value", checked: "checked", disabled: "disabled", required: "required", contentAddition: "contentAddition" }, outputs: { change: "change", blur: "blur", keyup: "keyup", keydown: "keydown", keypress: "keypress", checkChange: "checkChange" }, host: { classAttribute: "citi-radio2" }, viewQueries: [{ propertyName: "ngContent", first: true, predicate: ["ngContent"], descendants: true }], usesOnChanges: true, ngImport: i0, template: `
    <div [ngClass]="(radioGroup?.isTimeSelector ? 'time-selector' : 'radio2')"
      [class.content-addition]="(isContentAddition ? true : null)"
      *ngIf="name && label && value"
    >

      <input #inputEl
        type="radio"
        [attr.id]="inputId"
        [value]="value"
        [attr.name]="name"
        [checked]="checked"
        [disabled]="(disabled? true: null)"
        [attr.aria-label]="ariaLabel"
        [attr.aria-labelledby]="ariaLabelledby"
        [attr.aria-describedby]="_inputDescribedby"
        [required]="required ? 'true' : null"
        (change)="_onInputChange($event)"
        (blur)="blur.emit($event)"
        (keyup)="keyup.emit($event)"
        (keydown)="keydown.emit($event)"
        (keypress)="keypress.emit($event)"
      >
      <label
        [attr.for]="inputId"
        [attr.id]="inputId + '-label'"
        [innerHtml]="label"
      ></label>
      <span *ngIf="isContentAddition" [id]="idStr + 'descby'" class="sr-only" aria-hidden="true">{{this.checked ? this.expandedMessage : this.collapsedMessage}}</span>

      <!-- This is the projected conted when the radio button is checked and has any content -->
      <div
        [attr.id]="'content-addition' + inputId"
        *ngIf="isContentAddition"
        [hidden]="ngContent && !ngContent.children.length"
      >
        <div class="inline-content2">
          <div #ngContent [contentHtml]="htmlContent">
            <ng-content></ng-content>
          </div>
        </div>
      </div>

    </div>
    `, isInline: true, styles: [".groupTitle{margin:42px 0 30px;font-size:22px;font-size:1.375rem;line-height:1.5rem;font-family:Interstate_Light,sans-serif;color:#333;border-bottom:0}.validation-fieldset-danger{border-left:2px solid #D60000;padding-left:10px;margin-left:-1px}.validation-message-danger{font-weight:700;line-height:1rem;font-size:12px;font-size:.75rem;font-family:interstate_Bold,sans-serif;color:#d60000}.radio2,.checkbox2{position:relative;margin:12px 0}.radio2 input,.checkbox2 input{display:inline-block;opacity:.01}.radio2 label,.checkbox2 label{display:inline-block;width:98%;cursor:pointer;min-height:26px}.radio2 input:disabled+label:before,.checkbox2 input:disabled+label:before{border:1px solid #999}.radio2 label:focus,.radio2 label:hover,.checkbox2 label:focus,.checkbox2 label:hover{text-decoration:underline;color:#002a54}.radio2 input:checked+label,.checkbox2 input:checked+label{color:#056dae}.radio2 input:disabled+label,.checkbox2 input:disabled+label{cursor:default;color:#999;text-decoration:none}.radio2 .row,.checkbox2 .row{display:none;margin-bottom:0}.radio2 .row>.col-xs-12,.checkbox2 .row>.col-xs-12{padding-left:0}.radio2 .inline-content2,.checkbox2 .inline-content2{display:block;max-height:300em;padding:20px 20px 20px 40px;margin:10px 0 10px 10px;background-color:#eee}.radio2 [type=checkbox],.radio2 [type=radio],.checkbox2 [type=checkbox],.checkbox2 [type=radio]{margin-bottom:0}.radio2 [type=checkbox]~.row,.radio2 [type=radio]~.row,.checkbox2 [type=checkbox]~.row,.checkbox2 [type=radio]~.row{display:none}.radio2 [type=checkbox]:checked~.row,.radio2 [type=radio]:checked~.row,.checkbox2 [type=checkbox]:checked~.row,.checkbox2 [type=radio]:checked~.row{display:block}input{vertical-align:middle;margin-top:1px;margin-right:15px;display:inline-block;position:absolute;top:0;opacity:.01}input:focus+label{color:#002a54;text-decoration:underline}.radio2 label:before{content:\"\";position:relative;top:4px;display:inline-block;width:20px;height:20px;margin-right:10px;border:1px solid black;border-radius:100%;background-color:transparent}.radio2 input:checked+label:before{box-shadow:inset 0 0 0 3px #fff;background-color:#056dae}.time-selector{position:relative;display:inline-block}.time-selector input{display:inline-block;opacity:.01;position:absolute;top:4px}.time-selector label{display:inline-block;margin:0 10px 20px;line-height:30px;font-size:12px;min-width:90px;outline:0;color:#056dae;background:#fff;border-radius:6px;font-weight:700;border:2px solid #056dae;padding:0;text-align:center}.time-selector label:focus,.time-selector label:hover{cursor:pointer;background:#056dae;color:#fff}.time-selector input:disabled+label{cursor:default;color:#999;border-color:#999;text-decoration:none;background:#fff}.time-selector input:checked+label{color:#fff;background-color:#002a54;border-color:#002a54}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Radio2, decorators: [{
            type: Component,
            args: [{ selector: 'citi-radio2', standalone: false, template: `
    <div [ngClass]="(radioGroup?.isTimeSelector ? 'time-selector' : 'radio2')"
      [class.content-addition]="(isContentAddition ? true : null)"
      *ngIf="name && label && value"
    >

      <input #inputEl
        type="radio"
        [attr.id]="inputId"
        [value]="value"
        [attr.name]="name"
        [checked]="checked"
        [disabled]="(disabled? true: null)"
        [attr.aria-label]="ariaLabel"
        [attr.aria-labelledby]="ariaLabelledby"
        [attr.aria-describedby]="_inputDescribedby"
        [required]="required ? 'true' : null"
        (change)="_onInputChange($event)"
        (blur)="blur.emit($event)"
        (keyup)="keyup.emit($event)"
        (keydown)="keydown.emit($event)"
        (keypress)="keypress.emit($event)"
      >
      <label
        [attr.for]="inputId"
        [attr.id]="inputId + '-label'"
        [innerHtml]="label"
      ></label>
      <span *ngIf="isContentAddition" [id]="idStr + 'descby'" class="sr-only" aria-hidden="true">{{this.checked ? this.expandedMessage : this.collapsedMessage}}</span>

      <!-- This is the projected conted when the radio button is checked and has any content -->
      <div
        [attr.id]="'content-addition' + inputId"
        *ngIf="isContentAddition"
        [hidden]="ngContent && !ngContent.children.length"
      >
        <div class="inline-content2">
          <div #ngContent [contentHtml]="htmlContent">
            <ng-content></ng-content>
          </div>
        </div>
      </div>

    </div>
    `, host: { 'class': 'citi-radio2' }, styles: [".groupTitle{margin:42px 0 30px;font-size:22px;font-size:1.375rem;line-height:1.5rem;font-family:Interstate_Light,sans-serif;color:#333;border-bottom:0}.validation-fieldset-danger{border-left:2px solid #D60000;padding-left:10px;margin-left:-1px}.validation-message-danger{font-weight:700;line-height:1rem;font-size:12px;font-size:.75rem;font-family:interstate_Bold,sans-serif;color:#d60000}.radio2,.checkbox2{position:relative;margin:12px 0}.radio2 input,.checkbox2 input{display:inline-block;opacity:.01}.radio2 label,.checkbox2 label{display:inline-block;width:98%;cursor:pointer;min-height:26px}.radio2 input:disabled+label:before,.checkbox2 input:disabled+label:before{border:1px solid #999}.radio2 label:focus,.radio2 label:hover,.checkbox2 label:focus,.checkbox2 label:hover{text-decoration:underline;color:#002a54}.radio2 input:checked+label,.checkbox2 input:checked+label{color:#056dae}.radio2 input:disabled+label,.checkbox2 input:disabled+label{cursor:default;color:#999;text-decoration:none}.radio2 .row,.checkbox2 .row{display:none;margin-bottom:0}.radio2 .row>.col-xs-12,.checkbox2 .row>.col-xs-12{padding-left:0}.radio2 .inline-content2,.checkbox2 .inline-content2{display:block;max-height:300em;padding:20px 20px 20px 40px;margin:10px 0 10px 10px;background-color:#eee}.radio2 [type=checkbox],.radio2 [type=radio],.checkbox2 [type=checkbox],.checkbox2 [type=radio]{margin-bottom:0}.radio2 [type=checkbox]~.row,.radio2 [type=radio]~.row,.checkbox2 [type=checkbox]~.row,.checkbox2 [type=radio]~.row{display:none}.radio2 [type=checkbox]:checked~.row,.radio2 [type=radio]:checked~.row,.checkbox2 [type=checkbox]:checked~.row,.checkbox2 [type=radio]:checked~.row{display:block}input{vertical-align:middle;margin-top:1px;margin-right:15px;display:inline-block;position:absolute;top:0;opacity:.01}input:focus+label{color:#002a54;text-decoration:underline}.radio2 label:before{content:\"\";position:relative;top:4px;display:inline-block;width:20px;height:20px;margin-right:10px;border:1px solid black;border-radius:100%;background-color:transparent}.radio2 input:checked+label:before{box-shadow:inset 0 0 0 3px #fff;background-color:#056dae}.time-selector{position:relative;display:inline-block}.time-selector input{display:inline-block;opacity:.01;position:absolute;top:4px}.time-selector label{display:inline-block;margin:0 10px 20px;line-height:30px;font-size:12px;min-width:90px;outline:0;color:#056dae;background:#fff;border-radius:6px;font-weight:700;border:2px solid #056dae;padding:0;text-align:center}.time-selector label:focus,.time-selector label:hover{cursor:pointer;background:#056dae;color:#fff}.time-selector input:disabled+label{cursor:default;color:#999;border-color:#999;text-decoration:none;background:#fff}.time-selector input:checked+label{color:#fff;background-color:#002a54;border-color:#002a54}\n"] }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }, { type: Radio2Service }], propDecorators: { expandedMessage: [{
                type: Input$1
            }], collapsedMessage: [{
                type: Input$1
            }], idStr: [{
                type: Input$1
            }], name: [{
                type: Input$1
            }], label: [{
                type: Input$1
            }], tabIndex: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }], ariaLabel: [{
                type: Input$1,
                args: ['aria-label']
            }], ariaLabelledby: [{
                type: Input$1,
                args: ['aria-labelledby']
            }], ariaDescribedby: [{
                type: Input$1,
                args: ['aria-describedby']
            }], value: [{
                type: Input$1
            }], checked: [{
                type: Input$1
            }], disabled: [{
                type: Input$1
            }], required: [{
                type: Input$1
            }], contentAddition: [{
                type: Input$1
            }], change: [{
                type: Output
            }], blur: [{
                type: Output
            }], keyup: [{
                type: Output
            }], keydown: [{
                type: Output
            }], keypress: [{
                type: Output
            }], checkChange: [{
                type: Output
            }], ngContent: [{
                type: ViewChild,
                args: ['ngContent']
            }] } });
/** Change event object emitted by Radio2 and RadioGroup. */
class RadioChange {
    constructor(
    /** The RadioButtonNew that emits the change event. */
    source, 
    /** The value of the RadioButtonNew. */
    value) {
        this.source = source;
        this.value = value;
    }
}

// Increasing integer for generating unique name for radio components.
let nextUniqueId$2 = 0;
/**
 * Provider Expression that allows radio-group-new to register as a ControlValueAccessor. This
 * allows it to support [(ngModel)] and ngControl.
 */
const RADIO_GROUP_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => RadioGroup),
    multi: true
};
class RadioGroup {
    /** Name of the radio button group. All radio buttons inside this group will use this name. */
    get name() {
        return this._name;
    }
    set name(name) {
        this._name = name;
        this._updateRadioButtonNames();
    }
    /** Whether the radio group is disabled */
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = coerceBool(value);
        this._markRadiosForCheck();
    }
    /**
     * Value for the radio-group. Should equal the value of the selected radio button if there is
     * a corresponding radio button with a matching value. If there is not such a corresponding
     * radio button, this value persists to be applied in case a new radio button is added with a
     * matching value.
     */
    get value() {
        return this._value;
    }
    set value(newValue) {
        if (this._value !== newValue) {
            // Set this before proceeding to ensure no circular loop occurs with selection.
            this._value = newValue;
            this._updateSelectedRadioFromValue();
            this._checkSelectedRadioButton();
        }
    }
    /**
     * The currently selected radio button. If set to a new radio button, the radio group value
     * will be updated to match the new selected button.
     */
    get selected() {
        return this._selected;
    }
    set selected(selected) {
        this._selected = selected;
        this.value = selected ? selected.value : null;
        this._checkSelectedRadioButton();
    }
    /** Whether the radio group is required */
    get required() {
        return this._required;
    }
    set required(value) {
        this._required = coerceBool(value);
        this._markRadiosForCheck();
    }
    // #endregion
    // #region // ----------  Constructor / Lifecycle Hooks ---------- //
    constructor(_el, _changeDetector, validationService, _radio2Service) {
        this._el = _el;
        this._changeDetector = _changeDetector;
        this.validationService = validationService;
        this._radio2Service = _radio2Service;
        // #region // ----------  Properties ---------- //
        this.unsub$ = new Subject();
        /** The HTML name attribute applied to radio buttons in this group. */
        this._name = `radio-group-${nextUniqueId$2++}`;
        this.headingId = `radio-group-heading-${nextUniqueId$2++}`;
        this.errorId = `radio-group-error${nextUniqueId$2++}`;
        /** Whether the radio group is disabled. */
        this._disabled = false;
        /** Selected value for the radio group. */
        this._value = null;
        /** The currently selected radio button. Should match value. */
        this._selected = null;
        /** Whether the `value` has been set to its initial value. */
        this._isInitialized = false;
        /** Whether the radio group is required. */
        this._required = false;
        // #endregion
        // #region // ----------  Inputs/Outputs ---------- //
        this.error = false;
        this.errorChange = new EventEmitter();
        this.errorMessage = 'Input is required';
        /**
         * @property title
         * @description The title for the input group
         * @return string
         */
        this.title = '';
        this.isTimeSelector = false;
        this.change = new EventEmitter();
        this.blur = new EventEmitter();
        // #endregion
        // #region // ----------  ControlValueAccessor ---------- //
        /** The method to be called in order to update ngModel */
        this._controlValueAccessorChangeFn = () => { };
        /** onTouch function registered via registerOnTouch (ControlValueAccessor) */
        this.onTouched = () => { };
    }
    ngOnInit() {
        this.validateSub = this.validationService.validateNow.subscribe(_ => {
            this.validate();
        });
    }
    ngAfterContentInit() {
        this._isInitialized = true;
        setTimeout(() => {
            this._updateRadioButtonNames();
        }, 0);
        this.subscribeAll();
        this._radios.forEach(radio => {
            // If the radio is inside a radio group, determine if it should be checked
            // disable all radio buttons if radio group is set to true
            if (this._disabled)
                radio._disabled = true;
            // Update checked when the value changed to match the radio group's value
            if (this._value) {
                radio.checked = this._value === radio._value;
                radio.tabIndex = radio.checked ? 0 : -1;
                this._selected = radio;
            }
            // assigning Classes for value emitting purpose
            radio.radioGroup = RadioGroup;
            radio.radioChange = RadioChange;
        });
        if (!this._radios.map(radio => radio.tabIndex).includes(0))
            this._radios.first.tabIndex = 0;
    }
    ngOnDestroy() {
        this.validationService.removeError(this);
        if (this.validateSub)
            this.validateSub.unsubscribe();
        this.unsub$.next();
        this.unsub$.complete();
    }
    // #endregion
    // #region ----- Start Validation Methods ----- //
    subscribeAll() {
        this._radios.forEach(radio => {
            radio.checkChange
                .pipe(tap(() => {
                const groupValueChanged = radio._value !== this._value;
                this._controlValueAccessorChangeFn(radio._value);
                if (groupValueChanged) {
                    this._value = radio._value;
                    this._emitChangeEvent(radio, radio._value);
                    this._uncheckOtherRadios(radio.value);
                    this.validate();
                }
            }), takeUntil(this.unsub$))
                .subscribe();
        });
    }
    _uncheckOtherRadios(value) {
        this._radios.forEach(radio => {
            if (value !== radio.value) {
                radio.checked = false;
            }
        });
    }
    toggleError(isErrored) {
        this.error = isErrored;
        if (isErrored)
            this.validationService.addError(this);
        else
            this.validationService.removeError(this);
        this.errorChange.emit(isErrored);
    }
    validate() {
        if (this.required) {
            let error = !this._radios.map(x => x.checked).includes(true);
            this.toggleError(error);
            this._radio2Service?.errorIdValue$?.next(error ? this.errorId : null);
            this._isErrorHidden = true;
            setTimeout(() => {
                this._isErrorHidden = false;
            }, 1);
        }
    }
    // #endregion ----- End Validation Methods ----- //
    // #region // ----------  Methods ---------- //
    _focusoutRadioGroup(focusEvent) {
        const isInGroup = this._el.nativeElement.contains(focusEvent.relatedTarget);
        if (!isInGroup) {
            this.onTouched();
            this.blur.emit(focusEvent);
        }
    }
    _updateRadioButtonNames() {
        if (this._radios && this.name) {
            this._radios.forEach(radio => {
                radio.name = this.name;
                radio._markForCheck();
            });
        }
    }
    _markRadiosForCheck() {
        if (this._radios) {
            this._radios.forEach(radio => radio._markForCheck());
        }
    }
    /** Updates the `selected` radio button from the internal _value state. */
    _updateSelectedRadioFromValue() {
        // If the value already matches the selected radio, do nothing.
        const isAlreadySelected = this._selected !== null && this._selected.value === this._value;
        if (this._radios && !isAlreadySelected) {
            this._selected = null;
            this._radios.forEach(radio => {
                radio.checked = this.value === radio.value;
                if (radio.checked) {
                    this._selected = radio;
                }
            });
        }
    }
    _checkSelectedRadioButton() {
        if (this._selected && !this._selected.checked) {
            this._selected.checked = true;
        }
    }
    /** Dispatch change event with current selection and group value. */
    _emitChangeEvent(source, value) {
        if (this._isInitialized) {
            this.change.emit(new RadioChange(source, value));
        }
    }
    /**
     * Sets the model value. Implemented as part of ControlValueAccessor.
     * @param value
     */
    writeValue(value) {
        this.value = value;
        this._changeDetector.markForCheck();
    }
    /**
     * Registers a callback to be triggered when the model value changes.
     * Implemented as part of ControlValueAccessor.
     * @param fn Callback to be registered.
     */
    registerOnChange(fn) {
        this._controlValueAccessorChangeFn = fn;
    }
    /**
     * Registers a callback to be triggered when the control is touched.
     * Implemented as part of ControlValueAccessor.
     * @param fn Callback to be registered.
     */
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    /**
     * Sets the disabled state of the control. Implemented as a part of ControlValueAccessor.
     * @param isDisabled Whether the control should be disabled.
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
        this._changeDetector.markForCheck();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: RadioGroup, deps: [{ token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: ValidationService }, { token: Radio2Service }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: RadioGroup, isStandalone: false, selector: "citi-radio-group", inputs: { error: "error", errorMessage: "errorMessage", title: "title", isTimeSelector: "isTimeSelector", name: "name", disabled: "disabled", value: "value", selected: "selected", required: "required" }, outputs: { errorChange: "errorChange", change: "change", blur: "blur" }, host: { listeners: { "focusout": "_focusoutRadioGroup($event)" }, classAttribute: "citi-radio-group" }, providers: [RADIO_GROUP_CONTROL_VALUE_ACCESSOR, Radio2Service], queries: [{ propertyName: "_radios", predicate: Radio2 }], ngImport: i0, template: `
    <fieldset role="radiogroup" [attr.aria-required]="required ? 'true': null">
      <legend *ngIf="title !== null && title !== ''" class="groupTitle">
        <span [id]="headingId" [innerHtml]="title"></span>
      </legend>
      <span
        class="validation-message-danger"
        [id]="errorId"
        *ngIf="error && !_isErrorHidden"
        [innerHtml]="errorMessage"
        role="alert"
      ></span>
      <div [ngClass]="error ? 'validation-fieldset-danger' : null">
        <ng-content></ng-content>
      </div>
    </fieldset>
  `, isInline: true, styles: [".groupTitle{margin:42px 0 30px;font-size:22px;font-size:1.375rem;line-height:1.5rem;font-family:Interstate_Light,sans-serif;color:#333;border-bottom:0}.validation-fieldset-danger{border-left:2px solid #D60000;padding-left:10px;margin-left:-1px}.validation-message-danger{font-weight:700;line-height:1rem;font-size:12px;font-size:.75rem;font-family:interstate_Bold,sans-serif;color:#d60000}.radio2,.checkbox2{position:relative;margin:12px 0}.radio2 input,.checkbox2 input{display:inline-block;opacity:.01}.radio2 label,.checkbox2 label{display:inline-block;width:98%;cursor:pointer;min-height:26px}.radio2 input:disabled+label:before,.checkbox2 input:disabled+label:before{border:1px solid #999}.radio2 label:focus,.radio2 label:hover,.checkbox2 label:focus,.checkbox2 label:hover{text-decoration:underline;color:#002a54}.radio2 input:checked+label,.checkbox2 input:checked+label{color:#056dae}.radio2 input:disabled+label,.checkbox2 input:disabled+label{cursor:default;color:#999;text-decoration:none}.radio2 .row,.checkbox2 .row{display:none;margin-bottom:0}.radio2 .row>.col-xs-12,.checkbox2 .row>.col-xs-12{padding-left:0}.radio2 .inline-content2,.checkbox2 .inline-content2{display:block;max-height:300em;padding:20px 20px 20px 40px;margin:10px 0 10px 10px;background-color:#eee}.radio2 [type=checkbox],.radio2 [type=radio],.checkbox2 [type=checkbox],.checkbox2 [type=radio]{margin-bottom:0}.radio2 [type=checkbox]~.row,.radio2 [type=radio]~.row,.checkbox2 [type=checkbox]~.row,.checkbox2 [type=radio]~.row{display:none}.radio2 [type=checkbox]:checked~.row,.radio2 [type=radio]:checked~.row,.checkbox2 [type=checkbox]:checked~.row,.checkbox2 [type=radio]:checked~.row{display:block}input{vertical-align:middle;margin-top:1px;margin-right:15px;display:inline-block;position:absolute;top:0;opacity:.01}input:focus+label{color:#002a54;text-decoration:underline}.radio2 label:before{content:\"\";position:relative;top:4px;display:inline-block;width:20px;height:20px;margin-right:10px;border:1px solid black;border-radius:100%;background-color:transparent}.radio2 input:checked+label:before{box-shadow:inset 0 0 0 3px #fff;background-color:#056dae}.time-selector{position:relative;display:inline-block}.time-selector input{display:inline-block;opacity:.01;position:absolute;top:4px}.time-selector label{display:inline-block;margin:0 10px 20px;line-height:30px;font-size:12px;min-width:90px;outline:0;color:#056dae;background:#fff;border-radius:6px;font-weight:700;border:2px solid #056dae;padding:0;text-align:center}.time-selector label:focus,.time-selector label:hover{cursor:pointer;background:#056dae;color:#fff}.time-selector input:disabled+label{cursor:default;color:#999;border-color:#999;text-decoration:none;background:#fff}.time-selector input:checked+label{color:#fff;background-color:#002a54;border-color:#002a54}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: RadioGroup, decorators: [{
            type: Component,
            args: [{ selector: 'citi-radio-group', standalone: false, providers: [RADIO_GROUP_CONTROL_VALUE_ACCESSOR, Radio2Service], host: {
                        class: 'citi-radio-group',
                        '(focusout)': '_focusoutRadioGroup($event)'
                    }, template: `
    <fieldset role="radiogroup" [attr.aria-required]="required ? 'true': null">
      <legend *ngIf="title !== null && title !== ''" class="groupTitle">
        <span [id]="headingId" [innerHtml]="title"></span>
      </legend>
      <span
        class="validation-message-danger"
        [id]="errorId"
        *ngIf="error && !_isErrorHidden"
        [innerHtml]="errorMessage"
        role="alert"
      ></span>
      <div [ngClass]="error ? 'validation-fieldset-danger' : null">
        <ng-content></ng-content>
      </div>
    </fieldset>
  `, styles: [".groupTitle{margin:42px 0 30px;font-size:22px;font-size:1.375rem;line-height:1.5rem;font-family:Interstate_Light,sans-serif;color:#333;border-bottom:0}.validation-fieldset-danger{border-left:2px solid #D60000;padding-left:10px;margin-left:-1px}.validation-message-danger{font-weight:700;line-height:1rem;font-size:12px;font-size:.75rem;font-family:interstate_Bold,sans-serif;color:#d60000}.radio2,.checkbox2{position:relative;margin:12px 0}.radio2 input,.checkbox2 input{display:inline-block;opacity:.01}.radio2 label,.checkbox2 label{display:inline-block;width:98%;cursor:pointer;min-height:26px}.radio2 input:disabled+label:before,.checkbox2 input:disabled+label:before{border:1px solid #999}.radio2 label:focus,.radio2 label:hover,.checkbox2 label:focus,.checkbox2 label:hover{text-decoration:underline;color:#002a54}.radio2 input:checked+label,.checkbox2 input:checked+label{color:#056dae}.radio2 input:disabled+label,.checkbox2 input:disabled+label{cursor:default;color:#999;text-decoration:none}.radio2 .row,.checkbox2 .row{display:none;margin-bottom:0}.radio2 .row>.col-xs-12,.checkbox2 .row>.col-xs-12{padding-left:0}.radio2 .inline-content2,.checkbox2 .inline-content2{display:block;max-height:300em;padding:20px 20px 20px 40px;margin:10px 0 10px 10px;background-color:#eee}.radio2 [type=checkbox],.radio2 [type=radio],.checkbox2 [type=checkbox],.checkbox2 [type=radio]{margin-bottom:0}.radio2 [type=checkbox]~.row,.radio2 [type=radio]~.row,.checkbox2 [type=checkbox]~.row,.checkbox2 [type=radio]~.row{display:none}.radio2 [type=checkbox]:checked~.row,.radio2 [type=radio]:checked~.row,.checkbox2 [type=checkbox]:checked~.row,.checkbox2 [type=radio]:checked~.row{display:block}input{vertical-align:middle;margin-top:1px;margin-right:15px;display:inline-block;position:absolute;top:0;opacity:.01}input:focus+label{color:#002a54;text-decoration:underline}.radio2 label:before{content:\"\";position:relative;top:4px;display:inline-block;width:20px;height:20px;margin-right:10px;border:1px solid black;border-radius:100%;background-color:transparent}.radio2 input:checked+label:before{box-shadow:inset 0 0 0 3px #fff;background-color:#056dae}.time-selector{position:relative;display:inline-block}.time-selector input{display:inline-block;opacity:.01;position:absolute;top:4px}.time-selector label{display:inline-block;margin:0 10px 20px;line-height:30px;font-size:12px;min-width:90px;outline:0;color:#056dae;background:#fff;border-radius:6px;font-weight:700;border:2px solid #056dae;padding:0;text-align:center}.time-selector label:focus,.time-selector label:hover{cursor:pointer;background:#056dae;color:#fff}.time-selector input:disabled+label{cursor:default;color:#999;border-color:#999;text-decoration:none;background:#fff}.time-selector input:checked+label{color:#fff;background-color:#002a54;border-color:#002a54}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: ValidationService }, { type: Radio2Service }], propDecorators: { error: [{
                type: Input$1
            }], errorChange: [{
                type: Output
            }], errorMessage: [{
                type: Input$1
            }], title: [{
                type: Input$1
            }], isTimeSelector: [{
                type: Input$1
            }], name: [{
                type: Input$1
            }], disabled: [{
                type: Input$1
            }], value: [{
                type: Input$1
            }], selected: [{
                type: Input$1
            }], required: [{
                type: Input$1
            }], change: [{
                type: Output
            }], blur: [{
                type: Output
            }], _radios: [{
                type: ContentChildren,
                args: [Radio2, { descendants: false }]
            }] } });

const COMPONENTS$A = [
    Radio2,
    RadioGroup
];
const MODULES$D = [
    CommonModule,
    ContentHtml
];
class Radio2Module {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Radio2Module, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: Radio2Module, declarations: [Radio2,
            RadioGroup], imports: [CommonModule,
            ContentHtml], exports: [Radio2,
            RadioGroup] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Radio2Module, imports: [MODULES$D] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Radio2Module, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$D],
                    declarations: [...COMPONENTS$A],
                    exports: [...COMPONENTS$A]
                }]
        }] });

// Reference: https://scotch.io/tutorials/how-to-implement-a-custom-validator-directive-confirm-password-in-angular-2
class ConfrmPasswordDir {
    constructor(confirmPassword) {
        this.confirmPassword = confirmPassword;
    }
    validate(confirm) {
        const password = confirm.root.get(this.confirmPassword);
        const noMatch = confirm.value != password.value;
        if (!password || noMatch)
            return { noMatch: true };
        else
            return null;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ConfrmPasswordDir, deps: [{ token: 'confirmPassword', attribute: true }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.5", type: ConfrmPasswordDir, isStandalone: false, selector: "[confirmPassword][formControlName],[confirmPassword][formControl],[confirmPassword][ngModel]", providers: [{
                provide: NG_VALIDATORS,
                useExisting: forwardRef((() => ConfrmPasswordDir)),
                multi: true
            }], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ConfrmPasswordDir, decorators: [{
            type: Directive,
            args: [{
                    selector: '[confirmPassword][formControlName],[confirmPassword][formControl],[confirmPassword][ngModel]',
                    standalone: false,
                    providers: [{
                            provide: NG_VALIDATORS,
                            useExisting: forwardRef((() => ConfrmPasswordDir)),
                            multi: true
                        }]
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Attribute,
                    args: ['confirmPassword']
                }] }] });

class PasswordValidatorDir {
    validate(control) {
        return passwordVal(control);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: PasswordValidatorDir, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.5", type: PasswordValidatorDir, isStandalone: false, selector: "[password][formControlName],[password][formControl],[password][ngModel]", providers: [{
                provide: NG_VALIDATORS,
                useExisting: PasswordValidatorDir,
                multi: true
            }], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: PasswordValidatorDir, decorators: [{
            type: Directive,
            args: [{
                    selector: '[password][formControlName],[password][formControl],[password][ngModel]',
                    standalone: false,
                    providers: [{
                            provide: NG_VALIDATORS,
                            useExisting: PasswordValidatorDir,
                            multi: true
                        }]
                }]
        }] });
const passwordVal = (control) => {
    if (isPresent(Validators.required(control)))
        return null;
    const v = control.value;
    const hasCap = !!v && /[A-Z]/.test(v);
    const hasNum = !!v && /[0-9]/.test(v);
    const atLeast6 = !!v && v.length >= 6;
    const atMost20 = !!v && v.length <= 20;
    return (hasCap && hasNum && atLeast6 && atMost20) ? null : {
        'noCap': !hasCap,
        'noNum': !hasNum,
        'lessThan6': !atLeast6,
        'moreThan20': !atMost20
    };
};
function isPresent(obj) {
    return obj !== undefined && obj !== null;
}

class FocusFirstErrorDir {
    constructor(el) {
        this.el = el;
    }
    onFormSubmit() {
        const invalidElements = this.el.nativeElement.querySelectorAll('.ng-invalid');
        if (invalidElements.length > 0)
            invalidElements[0].focus();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: FocusFirstErrorDir, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.5", type: FocusFirstErrorDir, isStandalone: false, selector: "[focusFirstError]", host: { listeners: { "submit": "onFormSubmit()" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: FocusFirstErrorDir, decorators: [{
            type: Directive,
            args: [{
                    selector: '[focusFirstError]',
                    standalone: false
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { onFormSubmit: [{
                type: HostListener,
                args: ['submit']
            }] } });

const PHONE_PATTERN = '^(\([0-9]{3}\)\s*|[0-9]{3}\-)[0-9]{3}-[0-9]{4}$';
const EMAIL_PATTERN = '^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$';
const ZIPCODE_PATTERN = '(^\d{5}$)|(^\d{5}-\d{4}$)';
const SSN_PATTERN = '(\d{0,3})(\d{0,2})(\d{0,4})';
const URL_PATTERN = '[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)';

function validateEmail(c) {
    return new RegExp(EMAIL_PATTERN).test(c.value)
        ? null
        : { 'email': true }; // becomes the errors object on a control
}
class EmailValidatorDir {
    validate(control) {
        return validateEmail(control);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: EmailValidatorDir, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.5", type: EmailValidatorDir, isStandalone: false, selector: "[formControlName][email],[formControl][email],[ngModel][email]", providers: [
            {
                provide: NG_VALIDATORS,
                useValue: validateEmail,
                multi: true
            }
        ], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: EmailValidatorDir, decorators: [{
            type: Directive,
            args: [{
                    selector: '[formControlName][email],[formControl][email],[ngModel][email]',
                    standalone: false,
                    providers: [
                        {
                            provide: NG_VALIDATORS,
                            useValue: validateEmail,
                            multi: true
                        }
                    ]
                }]
        }] });

const DIRECTIVES = [
    ConfrmPasswordDir,
    EmailValidatorDir,
    PasswordValidatorDir,
    FocusFirstErrorDir
];
class CitiReactiveFormsModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CitiReactiveFormsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: CitiReactiveFormsModule, declarations: [ConfrmPasswordDir,
            EmailValidatorDir,
            PasswordValidatorDir,
            FocusFirstErrorDir], imports: [FormsModule,
            ReactiveFormsModule], exports: [FormsModule,
            ReactiveFormsModule, ConfrmPasswordDir,
            EmailValidatorDir,
            PasswordValidatorDir,
            FocusFirstErrorDir] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CitiReactiveFormsModule, imports: [FormsModule,
            ReactiveFormsModule, FormsModule,
            ReactiveFormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CitiReactiveFormsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        FormsModule,
                        ReactiveFormsModule
                    ],
                    declarations: [
                        ...DIRECTIVES
                    ],
                    exports: [
                        FormsModule,
                        ReactiveFormsModule,
                        ...DIRECTIVES
                    ]
                }]
        }] });

function noNumberVal(control) {
    const hasNum = /^([^0-9]*)$/.test(control.value);
    return (hasNum) ? null : { 'containsNumber': true };
}
;

class CitiValidators extends Validators {
    static validateEmail(c) {
        return validateEmail(c);
    }
    static passwordVal(c) {
        return passwordVal(c);
    }
    static noNumberVal(c) {
        return noNumberVal(c);
    }
    constructor() {
        super();
    }
}

let nextId$2 = 0;
/**
 * @Component: Disclaimer
 * @Section: Forms
 * @Description: This is the disclaimer component and is used to create reusable disclaimer
 * from Bootstrap.
 */
class SignOn2Component {
    set isRememberUsernameChecked(checked) {
        this._isRememberUsernameChecked = checked;
        if (!this.userDD && checked)
            this.announcer.announce(this.rememberText);
    }
    get isRememberUsernameChecked() {
        return this._isRememberUsernameChecked;
    }
    get usernameInput() {
        const firstInput = this.inputs ? this.inputs.first : null;
        return this.usesDD ? null : firstInput;
    }
    get usesDD() {
        return !!this.userDD;
    }
    get passwordInput() {
        return this.usesDD ? this.inputs.first : this.inputs.last;
    }
    // #endregion
    // #region // ---------------- Constructor / Lifecycle Hooks ---------------- ///
    constructor(announcer) {
        this.announcer = announcer;
        this.idStr = `signOn-${nextId$2++}`;
        // to focus input on load.
        this.focusInput = false;
        this._isRememberUsernameChecked = false;
        /**
         * @Event: SubmitButtonClicked
         * @Description: This event that is fired when the submit button is clicked
         * Can be bound to with (SubmitButtonClicked)='myFunction($event)'
         * @Return: Object
         */
        this.SubmitButtonClicked = new EventEmitter();
    }
    ngAfterContentInit() {
        this.userInputSetup();
        if (this.passwordInput) {
            this.passwordInput.size = 'fullwidth';
            this.passwordInput.required = true;
        }
    }
    // #region // ---------------- Methods ---------------- ///
    onSubmit(remember, event) {
        this.SubmitButtonClicked.emit({ remember, event });
    }
    userInputSetup() {
        if (!this.usesDD && this.usernameInput) {
            this.usernameInput.size = 'fullwidth';
            this.usernameInput.required = true;
            this.usernameInput.removeMaskOnEvents = ['focus'];
            this.usernameInput.applyMaskOnEvents = ['blur'];
            this.usernameInput.focus = this.focusInput;
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: SignOn2Component, deps: [{ token: CitiLiveAnnouncer }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: SignOn2Component, isStandalone: false, selector: "citi-signon2", inputs: { title: "title", buttonText: "buttonText", rememberIdText: "rememberIdText", rememberText: "rememberText", idStr: "idStr", focusInput: "focusInput", isRememberUsernameChecked: "isRememberUsernameChecked" }, outputs: { SubmitButtonClicked: "SubmitButtonClicked" }, host: { classAttribute: "citi-signon2" }, queries: [{ propertyName: "userDD", first: true, predicate: Dropdown3Component, descendants: true }, { propertyName: "inputs", predicate: Input2Component }], ngImport: i0, template: `
    <div class="qr"><ng-content select="[mobileCode]"></ng-content></div>
    <section class="theme-light SampleErrorStates">
      <h4>{{ title }}</h4>
      <div><ng-content select="[alertmessage]"></ng-content></div>
      <div class="row">
        <div class="username-input col-xs-6">
          <ng-content select="[username]"></ng-content>
          <!--username input end-->
        </div>

        <!--password input-->
        <div class="password-input col-xs-6">
          <ng-content select="[password]"></ng-content>
          <!--password input end-->
        </div>
      </div>

      <!--  checkbox -->
      <div *ngIf="!usesDD">
        <ng-content select="[remember]"></ng-content>
      </div>

      <div class="secInfo" *ngIf="!usesDD && isRememberUsernameChecked">
        <div class="ui-tooltip-rmid" id="ui-tooltip-rmid">
          <small>{{ rememberText }}</small>
        </div>
      </div>

      <!--  signon button -->
      <div class="row">
        <div class="form-group signonButton col-xs-12">
          <button
            type="button"
            class="btn btn-primary btn-block"
            [attr.id]="idStr"
            (click)="onSubmit(isRememberUsernameChecked, $event)"
          >
            {{ buttonText }}
          </button>
        </div>
      </div>
      <!-- signon button end -->

      <!--  links -->
      <div class="row">
        <ng-content select="[links]"></ng-content>
      </div>
      <!--  link ends -->
    </section>
  `, isInline: true, styles: [":host{display:block}a{overflow-wrap:break-word!important;white-space:pre-line!important;text-align:left!important;font-size:12px!important;margin-right:0!important;vertical-align:top}:host ::ng-deep .input-error{height:auto}.qr{float:right;position:relative}:host ::ng-deep citi-dropdown3 .ddl-dd3-input{margin-top:3px;padding-top:12px;padding-bottom:12px}:host ::ng-deep citi-dropdown3 .ddl-dd3-arrow-icon{top:24px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: SignOn2Component, decorators: [{
            type: Component,
            args: [{ selector: 'citi-signon2', standalone: false, host: { class: 'citi-signon2' }, template: `
    <div class="qr"><ng-content select="[mobileCode]"></ng-content></div>
    <section class="theme-light SampleErrorStates">
      <h4>{{ title }}</h4>
      <div><ng-content select="[alertmessage]"></ng-content></div>
      <div class="row">
        <div class="username-input col-xs-6">
          <ng-content select="[username]"></ng-content>
          <!--username input end-->
        </div>

        <!--password input-->
        <div class="password-input col-xs-6">
          <ng-content select="[password]"></ng-content>
          <!--password input end-->
        </div>
      </div>

      <!--  checkbox -->
      <div *ngIf="!usesDD">
        <ng-content select="[remember]"></ng-content>
      </div>

      <div class="secInfo" *ngIf="!usesDD && isRememberUsernameChecked">
        <div class="ui-tooltip-rmid" id="ui-tooltip-rmid">
          <small>{{ rememberText }}</small>
        </div>
      </div>

      <!--  signon button -->
      <div class="row">
        <div class="form-group signonButton col-xs-12">
          <button
            type="button"
            class="btn btn-primary btn-block"
            [attr.id]="idStr"
            (click)="onSubmit(isRememberUsernameChecked, $event)"
          >
            {{ buttonText }}
          </button>
        </div>
      </div>
      <!-- signon button end -->

      <!--  links -->
      <div class="row">
        <ng-content select="[links]"></ng-content>
      </div>
      <!--  link ends -->
    </section>
  `, styles: [":host{display:block}a{overflow-wrap:break-word!important;white-space:pre-line!important;text-align:left!important;font-size:12px!important;margin-right:0!important;vertical-align:top}:host ::ng-deep .input-error{height:auto}.qr{float:right;position:relative}:host ::ng-deep citi-dropdown3 .ddl-dd3-input{margin-top:3px;padding-top:12px;padding-bottom:12px}:host ::ng-deep citi-dropdown3 .ddl-dd3-arrow-icon{top:24px}\n"] }]
        }], ctorParameters: () => [{ type: CitiLiveAnnouncer }], propDecorators: { title: [{
                type: Input$1
            }], buttonText: [{
                type: Input$1
            }], rememberIdText: [{
                type: Input$1
            }], rememberText: [{
                type: Input$1
            }], idStr: [{
                type: Input$1
            }], focusInput: [{
                type: Input$1
            }], isRememberUsernameChecked: [{
                type: Input$1
            }], SubmitButtonClicked: [{
                type: Output
            }], inputs: [{
                type: ContentChildren,
                args: [Input2Component]
            }], userDD: [{
                type: ContentChild,
                args: [Dropdown3Component]
            }] } });

const COMPONENTS$z = [SignOn2Component];
const MODULES$C = [
    CommonModule,
    IsFocused,
    Input2,
    Dropdown3,
    Grid,
    CTA,
    InputGroup,
];
class SignOn2 {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: SignOn2, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: SignOn2, declarations: [SignOn2Component], imports: [CommonModule,
            IsFocused,
            Input2,
            Dropdown3,
            Grid,
            CTA,
            InputGroup], exports: [SignOn2Component] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: SignOn2, imports: [MODULES$C] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: SignOn2, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$C],
                    declarations: [...COMPONENTS$z],
                    exports: [...COMPONENTS$z]
                }]
        }] });

function SliderRangeValidator(minValue, maxValue) {
    return function validateRange(c) {
        let isInvalid = false;
        const err = {
            rangeError: {
                given: c.value,
                min: minValue,
                max: maxValue
            }
        };
        if (c.value !== null && c.value !== undefined && typeof c.value.min === 'number' && typeof c.value.max === 'number') {
            isInvalid = c.value.min < +minValue || c.value.min > +maxValue || c.value.max < +minValue || c.value.max > +maxValue;
        }
        else {
            isInvalid = c.value < +minValue || c.value > +maxValue;
        }
        return isInvalid ? err : null;
    };
}

var SliderEnum;
(function (SliderEnum) {
    SliderEnum["currentValue"] = "currentValue";
    SliderEnum["currentMinValue"] = "currentMinValue";
    SliderEnum["currentMaxValue"] = "currentMaxValue";
    SliderEnum["handleValueChange"] = "handleValueChange";
    SliderEnum["handleMinValueChange"] = "handleMinValueChange";
    SliderEnum["handleMaxValueChange"] = "handleMaxValueChange";
})(SliderEnum || (SliderEnum = {}));
class ValueSliderComponent {
    /**
     * Whether or not the hash marks for each step on the slider should show
     * Do not use on sliders where there would be more than ~20 hash marks!
     * @Type: boolean
     */
    set showHashMarks(show) {
        show = show === 'true' || show === true;
        this._showHashMarks = show === true;
        this.setHashMarks(show);
    }
    set value(value) {
        this._value = value;
        // Update the given value
        this.updateValue(value, SliderEnum.currentValue, SliderEnum.handleValueChange);
    }
    /**
     * reference/setter for the current minimum value of the slider if it is a range slider
     */
    set minValue(value) {
        // Update the given value
        this.updateValue(value, SliderEnum.currentMinValue, SliderEnum.handleMinValueChange);
    }
    /**
     * reference/setter for the current maximum value of the slider if it is a range slider
     */
    set maxValue(value) {
        // Update the given value
        this.updateValue(value, SliderEnum.currentMaxValue, SliderEnum.handleMaxValueChange);
    }
    // #endregion
    // #region /// -------------------- Host Listeners -------------------- ///
    // Document mouseup host listener
    onMouseUp(event) {
        this.handleDragEnd();
    }
    onTouchEnd(event) {
        this.handleDragEnd();
    }
    // Window resize host listener
    onWindowResize(event) {
        // Let the slider know what its new width is
        this.setSliderWidth();
    }
    // #endregion
    // #region /// -------------------- Constructor / Lifecycle Hooks -------------------- ///
    constructor() {
        // #region /// -------------------- Properties -------------------- ///
        this.showRightHandle = false;
        this.showLeftHandle = false;
        this.leftHandleOffset = 0;
        this.rightHandleOffset = 100;
        this.inputTimeoutLength = 250;
        this.mouseUp = new EventEmitter();
        this.interacting = false;
        this.isStartup = true;
        // #endregion
        // #region /// -------------------- Inputs/Outputs -------------------- ///
        /**
         * Sets the id attribute
         */
        this.idStr = null;
        /**
         * name associated with the hidden input which will binf to the <form>
         */
        this.name = 'dropdown';
        /**
         * Sets whether the range is a true range selector (two handles) or a fixed min/max slider
         */
        this.range = 'min';
        /**
         * sets the minimum value of the range slider
         */
        this.min = 1;
        /**
         * sets the maximum value of the range slider
         */
        this.max = 5;
        /**
         * The increment between values. Number will be rounded to the nearest *step*
         */
        this.step = 1;
        /**
         * sets whether the min/max labels should be shown or not
         * @Type: boolean
         */
        this.showLabels = true;
        /**
         * aria and alt label for the handle of the slider
         */
        this.handleLabel = 'value';
        /**
         * aria and alt label for the minimum handle of the slider
         */
        this.minHandleLabel = 'minimum value';
        /**
         * aria and alt label for the minimum handle of the slider
         */
        this.maxHandleLabel = 'maximum value';
        /**
         * defines the word to be read by screen readers after the current value such as 12 >months< or 2500 >dollars<
         */
        this.unitOfValue = 'dollars';
        this.valueChange = new EventEmitter();
        this.minValueChange = new EventEmitter();
        this.maxValueChange = new EventEmitter();
        // #region /// --- ControlValueAccessor --- ///
        this.propagateChange = (_) => { };
        this.propagateTouched = () => { };
    }
    ngOnInit() {
        // Set up the slider on init
        this.setUpSlider(this.range);
    }
    // TODO: trigger this from a setter
    ngOnChanges(changes) {
        if (changes.min || changes.max) {
            this.validateFn = SliderRangeValidator(this.min, this.max);
        }
    }
    ngAfterViewInit() {
        // We are no longer in startup now that this cycle has passed.
        this.isStartup = false;
    }
    // #endregion - Lifecycle Hooks
    // #region /// -------------------- Methods -------------------- ///
    // Gets a slider value based on a given offset (% from left of slider)
    getValueFromOffset(offset) {
        const min = parseInt(String(this.min), 10);
        const max = parseInt(String(this.max), 10);
        return (max - min) * (offset / 100) + min;
    }
    // Accounts for the steps input if there is one
    accountForSteps(value) {
        return !this.step ? value : Math.round(value / +this.step) * +this.step;
    }
    // Calculates a valid value and returns it
    calculateValidValue(value, handleSide) {
        // Account for any steps
        let calculatedValue = this.accountForSteps(value);
        // Account for the number being above or below the min or max
        calculatedValue =
            calculatedValue < +this.min
                ? +this.min
                : calculatedValue > +this.max
                    ? +this.max
                    : calculatedValue;
        // If this is a double handle range slider
        if (this.rangeType === 'double') {
            // Makes sure one handle doesn't equal or surpass the other
            if (handleSide === 'left') {
                calculatedValue = calculatedValue > this.currentMaxValue - +this.step ? this.currentMaxValue - +this.step : calculatedValue;
            }
            else {
                calculatedValue = calculatedValue < this.currentMinValue + +this.step ? this.currentMinValue + +this.step : calculatedValue;
            }
        }
        // Return the calculated value
        return calculatedValue;
    }
    setNewValue(value, property, emitter, handleSide) {
        // Get the new value by making sure we calculate a valid value based on the given value
        const validValue = this.calculateValidValue(value, handleSide);
        // Detect if the validValue has changed
        if (this[property] !== validValue) {
            // Update the property to reflect the new value
            this[property] = validValue;
            // Emit the new value through the emitter
            this[emitter].emit(validValue);
            if (property === SliderEnum.currentMinValue ||
                property === SliderEnum.currentMaxValue) {
                this.propagateChange({
                    min: this.currentMinValue,
                    max: this.currentMaxValue
                });
            }
            else {
                this.propagateChange(validValue);
            }
        }
    }
    // Updates a value by performing any necessary steps and then calling the correct handler with the new value
    updateValue(newValue, valueProperty, handlerName) {
        const isMinMaxValue = !!(valueProperty === SliderEnum.currentValue &&
            newValue &&
            !isNaN(+newValue.min) &&
            !isNaN(+newValue.max));
        // If this is the startup lifecycle, just set the value to current value and do nothing else since the mechanisms aren't ready
        if (this.isStartup) {
            this[valueProperty] = newValue;
            if (isMinMaxValue) {
                this.currentMinValue = +newValue.min;
                this.currentMaxValue = +newValue.max;
            }
            return;
        }
        // We need to wait for the users input to finish, clear any existing timeouts set
        if (this.inputTimeout)
            clearTimeout(this.inputTimeout);
        // Set a new timeout to wait for the users input to finish
        this.inputTimeout = setTimeout(() => {
            // Otherwise if the user is not interacting with the mouse
            if (!this.interacting) {
                // Handle the value change
                this[handlerName](newValue);
                if (isMinMaxValue) {
                    this.handleMinValueChange(+newValue.min);
                    this.handleMaxValueChange(+newValue.max);
                }
            }
        }, this.inputTimeoutLength);
    }
    writeValue(value) {
        if (value !== undefined) {
            // Make sure min value is not outside of slider min
            if (value && value.min < this.min) {
                value.min = this.min;
            }
            // Make sure max value is not outside of slider max
            if (value && value.max > this.max) {
                value.max = this.max;
            }
            this.value = value;
        }
    }
    validate(c) {
        return this.validateFn(c);
    }
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    registerOnTouched(fn) {
        this.propagateTouched = fn;
    }
    // #endregion - ControlValueAccessor
    // #region /// --- Getters --- ///
    // Gets an offset from a handle value
    getOffsetFromValue(value) {
        return ((value - this.min) / (this.max - this.min)) * 100;
    }
    // Determines the left handles offset from the left
    getLeftHandleOffset() {
        return this.getOffsetFromValue(this.rangeType === 'single' ? this.currentValue : this.currentMinValue);
    }
    // Determines the right handles offset from the left
    getRightHandleOffset() {
        return this.getOffsetFromValue(this.rangeType === 'single' ? this.currentValue : this.currentMaxValue);
    }
    // Gets the tracks offset from the left
    getTrackLeft() {
        return this.range === 'max' ? '0' : this.getLeftHandleOffset();
    }
    // Gets the width of the track
    getTrackWidth() {
        if (this.range === 'max')
            return this.getLeftHandleOffset();
        else if (this.range === 'min')
            return 100 - this.getLeftHandleOffset();
        else if (this.rangeType === 'double')
            return this.getRightHandleOffset() - this.getLeftHandleOffset();
    }
    // Gets whether a hash is highlight or not
    getHashHighlighted(index) {
        // what percent each step is across the slider
        const stepPercent = (100 / this.hashMarkArray.length) * (index + 1);
        // Return if the hash is highlighted based on if the left handle offset is greater than the offset of the given hash
        if (this.range === 'max')
            return this.getLeftHandleOffset() >= stepPercent ? 'highlighted' : null;
        else if (this.range === 'min')
            return this.getLeftHandleOffset() <= stepPercent ? 'highlighted' : null;
        else if (this.rangeType === 'double')
            return this.getLeftHandleOffset() <= stepPercent &&
                this.getRightHandleOffset() >= stepPercent
                ? 'highlighted'
                : null;
    }
    _getAriaValueText(isMax) {
        let currentVal = this.rangeType === 'single'
            ? this.currentValue
            : isMax
                ? this.currentMaxValue
                : this.currentMinValue;
        let ariaValueText = currentVal + ' ' + this.unitOfValue;
        if (this.labels?.length > 1 && this.showLabels) {
            const minToMaxCount = this.max - this.min;
            const labelSectionCount = minToMaxCount / (this.labels.length - 1);
            this.labels.forEach((lbl, i) => {
                const valueAtLabel = this.min + (labelSectionCount * i);
                if (valueAtLabel === currentVal) {
                    ariaValueText += ' ' + lbl;
                }
            });
        }
        return ariaValueText;
    }
    // #endregion - Getters
    // #region /// --- Setters --- ///
    // Sets the width of the slider
    setSliderWidth() {
        // I hate you set timeout
        setTimeout(() => {
            // Determine the width of the slider in the document
            this.sliderWidth = this.slider.nativeElement.offsetWidth;
            if (this.sliderWidth === 0) {
                this.setSliderWidth();
            }
        }, 50);
    }
    // Sets the initial slider state on first load of the slider component
    setSliderState(rangeType) {
        // If we are showing a true range slider
        if (rangeType === 'true' || rangeType === true) {
            // Set the left handle to show
            this.showLeftHandle = true;
            // Set the right handle to show
            this.showRightHandle = true;
            // Set the track to be 100% width to start since the range handles start at opposite ends of the slider
            this.trackWidth = 100;
            // Set the range type for reference
            this.rangeType = 'double';
            // Ensure that the current min value is set correctly
            this.handleMinValueChange(this.currentMinValue || this.min);
            // Ensure that the current max value is set correctly
            this.handleMaxValueChange(this.currentMaxValue || this.max);
            // Otherwise if the range type is 'max' (slider locked to max, slides toward left)
        }
        else if (rangeType === 'max') {
            // Set the left handle to hide
            this.showLeftHandle = false;
            // Set the right handle to show
            this.showRightHandle = true;
            // Set the track to be stuck to the left of the slider
            this.trackLeft = 0;
            // Set the range type for reference
            this.rangeType = 'single';
            // Ensure that the current value is set to the minimum value
            this.handleValueChange(this.currentValue || this.min);
            // Otherwise if the range type is 'min' (slider locked to min, slides toward right)
        }
        else if (rangeType === 'min') {
            // Set the left handle to show
            this.showLeftHandle = true;
            // Set the right handle to hide
            this.showRightHandle = false;
            // Set the track to be stuck to the right of the slider
            this.trackRight = 0;
            // Set the range type for reference
            this.rangeType = 'single';
            // Ensure that the current value is set to the minimum value
            this.handleValueChange(this.currentValue || this.max);
        }
    }
    setHashMarks(showHashMarks) {
        // If we should show hash marks
        if (showHashMarks) {
            // Get the number of hash marks there would be
            const numHashes = (this.max - this.min) / +this.step;
            // Only if we get a whole number
            const isWholeNumber = parseInt(String(numHashes), 10) === parseFloat(String(numHashes));
            // Only if we get a reasonable number of hashes to make
            const isReasonableNumHashes = numHashes < 25;
            // Create the hash marks array
            if (isWholeNumber && isReasonableNumHashes)
                this.hashMarkArray = new Array(numHashes);
            else if (isDevMode && !isWholeNumber)
                console.warn('Not a whole number of hash marks. Provide different values');
            else if (isDevMode && !isReasonableNumHashes)
                console.warn('Maximum Number of hashes (25) exceeded. Not showing hash marks.');
        }
    }
    // Calls all functions required to set up the slider
    setUpSlider(rangeType) {
        // Set the initial slider width
        this.setSliderWidth();
        // These updates need to wait for the DOM to be rendered, and thus are wrapped in a setTimeout to wait for the browser to render the DOM
        setTimeout(() => {
            this.setSliderState(rangeType);
        }, 50);
    }
    // #endregion - Setters
    // #region /// --- Handlers --- ///
    handleMousedown(event, handleEl) {
        this.handleSliderMousedown(event, handleEl);
    }
    handleKeydown(event, handleEl) {
        this.handlePositionChange(event, handleEl);
    }
    // Handles mouse down events on range slider handles
    handleSliderMousedown(event, handle) {
        // Prevent browser behavior -- !! DO NOT REMOVE !!
        event.preventDefault();
        event.stopPropagation();
        // Let the component know what the current handle is
        this.currentHandle = handle;
        // Let everyone know the slider is being interacted with
        this.interacting = true;
        // Set the initial handle position so we can reference it as the mouse is moving
        const initialHandlePosition = event.target.offsetLeft;
        // Set the initial mouse position so we can use it as a reference as the mouse is moving
        const initialMouseX = event.type === 'touchstart'
            ? event.changedTouches[0].clientX
            : event.clientX;
        // Subscribe to mouse move observable until a mouseup is detected and use the handlePositionChange method to handle the move
        // Add the observable for the mouse move event on the document
        if (event.type === 'mousedown') {
            this.mouseMoveListener = fromEvent(document, 'mousemove');
        }
        else if (event.type === 'touchstart') {
            this.mouseMoveListener = fromEvent(document, 'touchmove');
        }
        this.mouseMoveListener.pipe(takeUntil(this.mouseUp)).subscribe(e2 => this.handlePositionChange(e2, handle, initialHandlePosition, initialMouseX));
    }
    // Handles anytime the dragging stuff should end
    handleDragEnd() {
        // Let the slider know the mouse was released
        this.mouseUp.next();
        // Release the interacting boolean
        this.interacting = false;
    }
    ////// root handlers above
    // Handles any change in the sliders value from the outside and updates the sliders position
    handleInputValue(value, property, emitter, handleSide) {
        // If the value is in range
        if (value >= this.min && value <= this.max) {
            // If this is a single handle slider
            if (this.rangeType === 'single') {
                // Set the new value
                this.setNewValue(value, property, emitter, handleSide);
                // Otherwise make sure there is no handle interferance to prevent false checks
            }
            else if (
            // Otherwise if this is a double handle slider and this is for the left handle
            handleSide === 'left' ||
                // Or this is for the right handle and the the value is above the min
                (handleSide === 'right' &&
                    value >= this.currentMinValue)) {
                // Set the new value
                this.setNewValue(value, property, emitter, handleSide);
            }
        }
    }
    // Handles mousemove events
    handleMouseMove(event, property, emitter, handleSide, initialMouseX, initialHandlePosition) {
        const clientX = event.type === 'touchmove'
            ? event.changedTouches[0].clientX
            : event.clientX;
        // Get the new position of the handle on the slider
        const newPosition = initialHandlePosition + (clientX - initialMouseX);
        // Get the percent of the value we should get
        const offset = (newPosition / this.sliderWidth) * 100;
        // Get the value using the previously calculated percent
        const value = this.getValueFromOffset(offset);
        // Set the new value on the slider
        this.setNewValue(value, property, emitter, handleSide);
    }
    // Handles all keydown events
    handleKeyDown(event, property, emitter, handleSide) {
        // Switch on the event's key code
        switch (event.which) {
            // Page Up
            case 33:
                // Prevent default browser actions
                event.preventDefault();
                event.stopPropagation();
                // Set the new value
                this.setNewValue(this[property] + (this.max - this.min) * 0.1, property, emitter, handleSide);
                break;
            // Page Down
            case 34:
                // Prevent default browser actions
                event.preventDefault();
                event.stopPropagation();
                // Set the new value
                this.setNewValue(this[property] - (this.max - this.min) * 0.1, property, emitter, handleSide);
                break;
            // End Button
            case 35:
                // Prevent default browser actions
                event.preventDefault();
                event.stopPropagation();
                // Set the new value
                this.setNewValue(this.max, property, emitter, handleSide);
                break;
            // Home button
            case 36:
                // Prevent default browser actions
                event.preventDefault();
                event.stopPropagation();
                // Set the new value
                this.setNewValue(this.min, property, emitter, handleSide);
                break;
            // Left/Down arrows
            case 37:
            case 40:
                // Prevent default browser actions
                event.preventDefault();
                event.stopPropagation();
                // Set the new value
                this.setNewValue(this[property] - +this.step, property, emitter, handleSide);
                break;
            // Up/Right arrows
            case 38:
            case 39:
                // Prevent default browser actions
                event.preventDefault();
                event.stopPropagation();
                // Set the new value
                this.setNewValue(this[property] + +this.step, property, emitter, handleSide);
                break;
        }
    }
    // Handles events that cause the slider handle(s) to move
    handlePositionChange(event, handle, initialHandlePosition, initialMouseX) {
        // Determine the side of the handle
        const handleSide = handle.className.match('left')
            ? 'left'
            : 'right';
        // Get the property we should change based on the slider state and handle side
        const property = this.rangeType === 'single'
            ? SliderEnum.currentValue
            : handleSide === 'left'
                ? SliderEnum.currentMinValue
                : SliderEnum.currentMaxValue;
        // Get the emitter we should use based on the slider state and handle side
        const emitter = this.rangeType === 'single'
            ? 'valueChange'
            : handleSide === 'left'
                ? 'minValueChange'
                : 'maxValueChange';
        // If this is a mousemove event
        if (event.type === 'mousemove' ||
            event.type === 'touchmove') {
            // Handle the mouse move
            this.handleMouseMove(event, property, emitter, handleSide, initialMouseX, initialHandlePosition);
            // Otherwise if this is a keydown event
        }
        else if (event.type === 'keydown') {
            // Handle the keydown event
            this.handleKeyDown(event, property, emitter, handleSide);
        }
    }
    // Handles value changes
    handleValueChange(value) {
        // Update the handle position
        this.handleInputValue(value, SliderEnum.currentValue, 'valueChange', 'left');
    }
    // Handles minimum value changes
    handleMinValueChange(value) {
        // Update the handle position
        this.handleInputValue(value, SliderEnum.currentMinValue, 'minValueChange', 'left');
    }
    // Handles maximum value changes
    handleMaxValueChange(value) {
        // Update the handle position
        this.handleInputValue(value, SliderEnum.currentMaxValue, 'maxValueChange', 'right');
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ValueSliderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: ValueSliderComponent, isStandalone: false, selector: "citi-value-slider", inputs: { idStr: "idStr", name: "name", range: "range", min: "min", max: "max", step: "step", minLabel: "minLabel", maxLabel: "maxLabel", labels: "labels", showLabels: "showLabels", handleLabel: "handleLabel", minHandleLabel: "minHandleLabel", maxHandleLabel: "maxHandleLabel", unitOfValue: "unitOfValue", showHashMarks: "showHashMarks", value: "value", minValue: "minValue", maxValue: "maxValue" }, outputs: { valueChange: "valueChange", minValueChange: "minValueChange", maxValueChange: "maxValueChange" }, host: { listeners: { "document:mouseup": "onMouseUp($event)", "document:touchend": "onTouchEnd($event)", "window:resize": "onWindowResize($event)" } }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef((() => ValueSliderComponent)),
                multi: true
            },
            {
                provide: NG_VALIDATORS,
                useExisting: forwardRef((() => ValueSliderComponent)),
                multi: true
            }
        ], viewQueries: [{ propertyName: "viewInput", first: true, predicate: ["viewInput"], descendants: true }, { propertyName: "slider", first: true, predicate: ["slider"], descendants: true }, { propertyName: "track", first: true, predicate: ["track"], descendants: true }, { propertyName: "leftHandle", first: true, predicate: ["leftHandle"], descendants: true, static: true }, { propertyName: "rightHandle", first: true, predicate: ["rightHandle"], descendants: true, static: true }, { propertyName: "line", first: true, predicate: ["line"], descendants: true, static: true }, { propertyName: "labelContainer", first: true, predicate: ["labelContainer"], descendants: true }, { propertyName: "hashTrack", first: true, predicate: ["hashTrack"], descendants: true }], usesOnChanges: true, ngImport: i0, template: `
    <div #slider [attr.id]="idStr ? idStr : null" class="slider {{ range }}">
      <div *ngIf="_showHashMarks" class="hashTrack">
        <div
          class="hash"
          *ngFor="let hash of hashMarkArray; let i = index"
          [style.width]="100 / this.hashMarkArray.length + '%'"
          [ngClass]="getHashHighlighted(i)"
        >
        </div>
      </div>
      <div
        #track
        class="track"
        [style.left]="getTrackLeft() + '%'"
        [style.right]="trackRight + '%'"
        [style.width]="getTrackWidth() + '%'"
      ></div>
      <div #line class="line"></div>
      <div
        #leftHandle
        *ngIf="showLeftHandle"
        class="handle left"
        [style.left]="getLeftHandleOffset() + '%'"
        [style.z-index]="currentHandle == (leftHandle ? '99' : 1)"
        role="slider"
        tabindex="0"
        aria-orientation="horizontal"
        [attr.aria-valuemax]="max"
        [attr.aria-valuemin]="min"
        [attr.aria-valuenow]="
          rangeType === 'single' ? currentValue : currentMinValue
        "
        [attr.aria-valuetext]="_getAriaValueText()"
        [attr.aria-label]="
          rangeType === 'single' ? handleLabel : minHandleLabel
        "
        (mousedown)="handleMousedown($event, leftHandle)"
        (touchstart)="handleMousedown($event, leftHandle)"
        (keydown)="handleKeydown($event, leftHandle)"
      >
      </div>
      <div
        #rightHandle
        *ngIf="showRightHandle"
        class="handle right"
        [style.left]="getRightHandleOffset() + '%'"
        [style.z-index]="currentHandle == (rightHandle ? '99' : 1)"
        role="slider"
        tabindex="0"
        [attr.aria-valuemax]="max"
        [attr.aria-valuemin]="min"
        [attr.aria-valuenow]="
          rangeType === 'single' ? currentValue : currentMinValue
        "
        [attr.aria-valuetext]="_getAriaValueText(true)"
        [attr.aria-label]="
          rangeType === 'single' ? handleLabel : maxHandleLabel
        "
        (mousedown)="handleMousedown($event, rightHandle)"
        (touchstart)="handleMousedown($event, rightHandle)"
        (keydown)="handleKeydown($event, rightHandle)"
      >
      </div>
      <input
        [attr.id]="idStr ? idStr + '_hidden' : null"
        [attr.name]="name"
        [(ngModel)]="_value"
        hidden
      />
    </div>
    <div
      class="labels"
      *ngIf="showLabels && (minLabel || maxLabel)"
    >
      <div #minLabelElement class="min-label" *ngIf="!labels && minLabel">
        {{minLabel}}
      </div>
      <div #maxLabelElement class="max-label" *ngIf="!labels && maxLabel">
        {{maxLabel}}
      </div>
    </div>
    <div
      #hashLabels
      class="value-labels"
      *ngIf="showLabels && labels"
    >
      <div class="value-label" *ngFor="let label of labels">
        <p>{{ label }}</p>
      </div>
    </div>
  `, isInline: true, styles: [".ui-slider{position:relative;text-align:left}.ui-slider .ui-slider-handle{position:absolute;z-index:2;width:1.2em;height:1.2em;cursor:default;touch-action:none}.ui-slider .ui-slider-range{position:absolute;z-index:1;font-size:.7em;display:block;border:0;background-position:0 0}.ui-slider.ui-state-disabled .ui-slider-handle,.ui-slider.ui-state-disabled .ui-slider-range{filter:inherit}.ui-slider-horizontal{height:.8em}.ui-slider-horizontal .ui-slider-handle{top:-.3em;margin-left:-.6em}.ui-slider-horizontal .ui-slider-range{top:0;height:100%}.ui-slider-horizontal .ui-slider-range-min{left:0}.ui-slider-horizontal .ui-slider-range-max{right:0}.ui-slider-vertical{width:.8em;height:100px}.ui-slider-vertical .ui-slider-handle{left:-.3em;margin-left:0;margin-bottom:-.6em}.ui-slider-vertical .ui-slider-range{left:0;width:100%}.ui-slider-vertical .ui-slider-range-min{bottom:0}:host ::ng-deep .slider{height:2px;background-color:#999;display:flex;align-items:center;position:relative}:host ::ng-deep .slider:before,:host ::ng-deep .slider:after{content:\"\";width:2px;height:14px;background-color:#999;position:absolute;top:-6px}:host ::ng-deep .slider:before{left:0}:host ::ng-deep .slider:after{right:0}:host ::ng-deep .slider.min:after{background-color:#056dae}:host ::ng-deep .slider.max:before{background-color:#056dae}:host ::ng-deep .slider .line{display:block;width:100%;height:20px}:host ::ng-deep .slider .track{height:6px;width:0;display:block;position:absolute;top:-2px;background-color:#056dae}:host ::ng-deep .slider .handle{width:20px;height:20px;border:none;padding:0;margin-left:-11px;margin-top:2px;position:absolute;z-index:99}:host ::ng-deep .slider .handle:after{content:\"\";width:25px;height:25px;display:block;cursor:pointer;position:absolute;top:-2px;left:-2px;background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%20standalone%3D%22no%22%3F%3E%0A%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%22-1%20-1%2026%2026%22%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20xmlns%3Asketch%3D%22http%3A//www.bohemiancoding.com/sketch/ns%22%3E%0A%20%20%20%20%3C%21--%20Generator%3A%20Sketch%203.4.1%20%2815681%29%20-%20http%3A//www.bohemiancoding.com/sketch%20--%3E%0A%20%20%20%20%3Ctitle%3EHandle%3C/title%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C/desc%3E%0A%20%20%20%20%3Cdefs%3E%3C/defs%3E%0A%20%20%20%20%3Cg%20id%3D%22Toolkit%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20sketch%3Atype%3D%22MSPage%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Smaller-Elements%22%20sketch%3Atype%3D%22MSArtboardGroup%22%20transform%3D%22translate%28-1249.000000%2C%20-720.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Slider%22%20sketch%3Atype%3D%22MSLayerGroup%22%20transform%3D%22translate%28560.000000%2C%20650.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Knob-Slider-Range-Hover%22%20transform%3D%22translate%28610.000000%2C%200.000000%29%22%20sketch%3Atype%3D%22MSShapeGroup%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Slider%22%20transform%3D%22translate%280.000000%2C%2070.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Handle%22%20transform%3D%22translate%2879.000000%2C%200.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22Active-Area%22%20fill%3D%22%230076C0%22%20cx%3D%2212%22%20cy%3D%2212%22%20r%3D%2212%22%3E%3C/circle%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M8%2C7.5%20L8%2C16.5%20L8%2C17%20L9%2C17%20L9%2C16.5%20L9%2C7.5%20L9%2C7%20L8%2C7%20L8%2C7.5%20Z%20M12%2C7.5%20L12%2C16.5%20L12%2C17%20L13%2C17%20L13%2C16.5%20L13%2C7.5%20L13%2C7%20L12%2C7%20L12%2C7.5%20Z%20M16%2C7.5%20L16%2C16.5%20L16%2C17%20L17%2C17%20L17%2C16.5%20L17%2C7.5%20L17%2C7%20L16%2C7%20L16%2C7.5%20Z%22%20id%3D%22Scrubber-Lines-Left%22%20fill%3D%22%23FFFFFF%22%3E%3C/path%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%3C/g%3E%0A%3C/svg%3E);background-repeat:no-repeat}:host ::ng-deep .slider .handle:focus:after,:host ::ng-deep .slider .handle:hover:after{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%20standalone%3D%22no%22%3F%3E%0A%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%22-1%20-1%2026%2026%22%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20xmlns%3Asketch%3D%22http%3A//www.bohemiancoding.com/sketch/ns%22%3E%0A%20%20%20%20%3C%21--%20Generator%3A%20Sketch%203.4.1%20%2815681%29%20-%20http%3A//www.bohemiancoding.com/sketch%20--%3E%0A%20%20%20%20%3Ctitle%3EFocused%20Handle%3C/title%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C/desc%3E%0A%20%20%20%20%3Cdefs%3E%3C/defs%3E%0A%20%20%20%20%3Cg%20id%3D%22Toolkit%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20sketch%3Atype%3D%22MSPage%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Smaller-Elements%22%20sketch%3Atype%3D%22MSArtboardGroup%22%20transform%3D%22translate%28-1449.000000%2C%20-720.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Slider%22%20sketch%3Atype%3D%22MSLayerGroup%22%20transform%3D%22translate%28560.000000%2C%20650.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Knob-Slider-Range-Hover%22%20transform%3D%22translate%28610.000000%2C%200.000000%29%22%20sketch%3Atype%3D%22MSShapeGroup%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Slider%22%20transform%3D%22translate%280.000000%2C%2070.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Focused-Handle%22%20transform%3D%22translate%28279.000000%2C%200.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22Oval-10%22%20stroke%3D%22%230076C0%22%20stroke-width%3D%222%22%20fill%3D%22%23FFFFFF%22%20cx%3D%2212%22%20cy%3D%2212%22%20r%3D%2212%22%3E%3C/circle%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M8%2C7.5%20L8%2C16.5%20L8%2C17%20L9%2C17%20L9%2C16.5%20L9%2C7.5%20L9%2C7%20L8%2C7%20L8%2C7.5%20Z%20M12%2C7.5%20L12%2C16.5%20L12%2C17%20L13%2C17%20L13%2C16.5%20L13%2C7.5%20L13%2C7%20L12%2C7%20L12%2C7.5%20Z%20M16%2C7.5%20L16%2C16.5%20L16%2C17%20L17%2C17%20L17%2C16.5%20L17%2C7.5%20L17%2C7%20L16%2C7%20L16%2C7.5%20Z%22%20id%3D%22Scrubber-Lines-RIght%22%20fill%3D%22%230076C0%22%3E%3C/path%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%3C/g%3E%0A%3C/svg%3E)}:host ::ng-deep .slider .handle.right{right:0}:host ::ng-deep .slider .handle.left{left:0}:host ::ng-deep .slider .handle.hidden{display:none}:host ::ng-deep .slider .hashTrack{display:flex;justify-content:space-between;position:absolute;left:0;top:0;width:100%}:host ::ng-deep .slider .hashTrack .hash{display:inline-block;height:12px;position:relative}:host ::ng-deep .slider .hashTrack .hash:after{content:\"\";display:block;width:1px;background-color:#999;height:100%;position:absolute;right:0}:host ::ng-deep .slider .hashTrack .hash.highlighted:after{background-color:#056dae}:host ::ng-deep .slider .hashTrack .hash:last-child:after{display:none}:host ::ng-deep .labels{display:flex;justify-content:space-between;margin-top:20px}:host ::ng-deep .value-labels{display:flex;margin-top:15px}:host ::ng-deep .value-labels .value-label{flex:1 1 100%;text-align:center}:host ::ng-deep .value-labels .value-label:first-child,:host ::ng-deep .value-labels .value-label:last-child{flex:1 1 50%}:host ::ng-deep .value-labels .value-label:first-child{text-align:left}:host ::ng-deep .value-labels .value-label:last-child{text-align:right}:host ::ng-deep .value-labels .value-label span{position:absolute;transform:translate(-50%)}:host ::ng-deep .value-labels .value-label:first-child span{transform:none}:host ::ng-deep .value-labels .value-label:last-child span{transform:translate(-100%)}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i4.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i4.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ValueSliderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-value-slider', standalone: false, providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef((() => ValueSliderComponent)),
                            multi: true
                        },
                        {
                            provide: NG_VALIDATORS,
                            useExisting: forwardRef((() => ValueSliderComponent)),
                            multi: true
                        }
                    ], template: `
    <div #slider [attr.id]="idStr ? idStr : null" class="slider {{ range }}">
      <div *ngIf="_showHashMarks" class="hashTrack">
        <div
          class="hash"
          *ngFor="let hash of hashMarkArray; let i = index"
          [style.width]="100 / this.hashMarkArray.length + '%'"
          [ngClass]="getHashHighlighted(i)"
        >
        </div>
      </div>
      <div
        #track
        class="track"
        [style.left]="getTrackLeft() + '%'"
        [style.right]="trackRight + '%'"
        [style.width]="getTrackWidth() + '%'"
      ></div>
      <div #line class="line"></div>
      <div
        #leftHandle
        *ngIf="showLeftHandle"
        class="handle left"
        [style.left]="getLeftHandleOffset() + '%'"
        [style.z-index]="currentHandle == (leftHandle ? '99' : 1)"
        role="slider"
        tabindex="0"
        aria-orientation="horizontal"
        [attr.aria-valuemax]="max"
        [attr.aria-valuemin]="min"
        [attr.aria-valuenow]="
          rangeType === 'single' ? currentValue : currentMinValue
        "
        [attr.aria-valuetext]="_getAriaValueText()"
        [attr.aria-label]="
          rangeType === 'single' ? handleLabel : minHandleLabel
        "
        (mousedown)="handleMousedown($event, leftHandle)"
        (touchstart)="handleMousedown($event, leftHandle)"
        (keydown)="handleKeydown($event, leftHandle)"
      >
      </div>
      <div
        #rightHandle
        *ngIf="showRightHandle"
        class="handle right"
        [style.left]="getRightHandleOffset() + '%'"
        [style.z-index]="currentHandle == (rightHandle ? '99' : 1)"
        role="slider"
        tabindex="0"
        [attr.aria-valuemax]="max"
        [attr.aria-valuemin]="min"
        [attr.aria-valuenow]="
          rangeType === 'single' ? currentValue : currentMinValue
        "
        [attr.aria-valuetext]="_getAriaValueText(true)"
        [attr.aria-label]="
          rangeType === 'single' ? handleLabel : maxHandleLabel
        "
        (mousedown)="handleMousedown($event, rightHandle)"
        (touchstart)="handleMousedown($event, rightHandle)"
        (keydown)="handleKeydown($event, rightHandle)"
      >
      </div>
      <input
        [attr.id]="idStr ? idStr + '_hidden' : null"
        [attr.name]="name"
        [(ngModel)]="_value"
        hidden
      />
    </div>
    <div
      class="labels"
      *ngIf="showLabels && (minLabel || maxLabel)"
    >
      <div #minLabelElement class="min-label" *ngIf="!labels && minLabel">
        {{minLabel}}
      </div>
      <div #maxLabelElement class="max-label" *ngIf="!labels && maxLabel">
        {{maxLabel}}
      </div>
    </div>
    <div
      #hashLabels
      class="value-labels"
      *ngIf="showLabels && labels"
    >
      <div class="value-label" *ngFor="let label of labels">
        <p>{{ label }}</p>
      </div>
    </div>
  `, styles: [".ui-slider{position:relative;text-align:left}.ui-slider .ui-slider-handle{position:absolute;z-index:2;width:1.2em;height:1.2em;cursor:default;touch-action:none}.ui-slider .ui-slider-range{position:absolute;z-index:1;font-size:.7em;display:block;border:0;background-position:0 0}.ui-slider.ui-state-disabled .ui-slider-handle,.ui-slider.ui-state-disabled .ui-slider-range{filter:inherit}.ui-slider-horizontal{height:.8em}.ui-slider-horizontal .ui-slider-handle{top:-.3em;margin-left:-.6em}.ui-slider-horizontal .ui-slider-range{top:0;height:100%}.ui-slider-horizontal .ui-slider-range-min{left:0}.ui-slider-horizontal .ui-slider-range-max{right:0}.ui-slider-vertical{width:.8em;height:100px}.ui-slider-vertical .ui-slider-handle{left:-.3em;margin-left:0;margin-bottom:-.6em}.ui-slider-vertical .ui-slider-range{left:0;width:100%}.ui-slider-vertical .ui-slider-range-min{bottom:0}:host ::ng-deep .slider{height:2px;background-color:#999;display:flex;align-items:center;position:relative}:host ::ng-deep .slider:before,:host ::ng-deep .slider:after{content:\"\";width:2px;height:14px;background-color:#999;position:absolute;top:-6px}:host ::ng-deep .slider:before{left:0}:host ::ng-deep .slider:after{right:0}:host ::ng-deep .slider.min:after{background-color:#056dae}:host ::ng-deep .slider.max:before{background-color:#056dae}:host ::ng-deep .slider .line{display:block;width:100%;height:20px}:host ::ng-deep .slider .track{height:6px;width:0;display:block;position:absolute;top:-2px;background-color:#056dae}:host ::ng-deep .slider .handle{width:20px;height:20px;border:none;padding:0;margin-left:-11px;margin-top:2px;position:absolute;z-index:99}:host ::ng-deep .slider .handle:after{content:\"\";width:25px;height:25px;display:block;cursor:pointer;position:absolute;top:-2px;left:-2px;background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%20standalone%3D%22no%22%3F%3E%0A%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%22-1%20-1%2026%2026%22%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20xmlns%3Asketch%3D%22http%3A//www.bohemiancoding.com/sketch/ns%22%3E%0A%20%20%20%20%3C%21--%20Generator%3A%20Sketch%203.4.1%20%2815681%29%20-%20http%3A//www.bohemiancoding.com/sketch%20--%3E%0A%20%20%20%20%3Ctitle%3EHandle%3C/title%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C/desc%3E%0A%20%20%20%20%3Cdefs%3E%3C/defs%3E%0A%20%20%20%20%3Cg%20id%3D%22Toolkit%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20sketch%3Atype%3D%22MSPage%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Smaller-Elements%22%20sketch%3Atype%3D%22MSArtboardGroup%22%20transform%3D%22translate%28-1249.000000%2C%20-720.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Slider%22%20sketch%3Atype%3D%22MSLayerGroup%22%20transform%3D%22translate%28560.000000%2C%20650.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Knob-Slider-Range-Hover%22%20transform%3D%22translate%28610.000000%2C%200.000000%29%22%20sketch%3Atype%3D%22MSShapeGroup%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Slider%22%20transform%3D%22translate%280.000000%2C%2070.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Handle%22%20transform%3D%22translate%2879.000000%2C%200.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22Active-Area%22%20fill%3D%22%230076C0%22%20cx%3D%2212%22%20cy%3D%2212%22%20r%3D%2212%22%3E%3C/circle%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M8%2C7.5%20L8%2C16.5%20L8%2C17%20L9%2C17%20L9%2C16.5%20L9%2C7.5%20L9%2C7%20L8%2C7%20L8%2C7.5%20Z%20M12%2C7.5%20L12%2C16.5%20L12%2C17%20L13%2C17%20L13%2C16.5%20L13%2C7.5%20L13%2C7%20L12%2C7%20L12%2C7.5%20Z%20M16%2C7.5%20L16%2C16.5%20L16%2C17%20L17%2C17%20L17%2C16.5%20L17%2C7.5%20L17%2C7%20L16%2C7%20L16%2C7.5%20Z%22%20id%3D%22Scrubber-Lines-Left%22%20fill%3D%22%23FFFFFF%22%3E%3C/path%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%3C/g%3E%0A%3C/svg%3E);background-repeat:no-repeat}:host ::ng-deep .slider .handle:focus:after,:host ::ng-deep .slider .handle:hover:after{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%20standalone%3D%22no%22%3F%3E%0A%3Csvg%20width%3D%2224px%22%20height%3D%2224px%22%20viewBox%3D%22-1%20-1%2026%2026%22%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20xmlns%3Asketch%3D%22http%3A//www.bohemiancoding.com/sketch/ns%22%3E%0A%20%20%20%20%3C%21--%20Generator%3A%20Sketch%203.4.1%20%2815681%29%20-%20http%3A//www.bohemiancoding.com/sketch%20--%3E%0A%20%20%20%20%3Ctitle%3EFocused%20Handle%3C/title%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C/desc%3E%0A%20%20%20%20%3Cdefs%3E%3C/defs%3E%0A%20%20%20%20%3Cg%20id%3D%22Toolkit%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20sketch%3Atype%3D%22MSPage%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Smaller-Elements%22%20sketch%3Atype%3D%22MSArtboardGroup%22%20transform%3D%22translate%28-1449.000000%2C%20-720.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Slider%22%20sketch%3Atype%3D%22MSLayerGroup%22%20transform%3D%22translate%28560.000000%2C%20650.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Knob-Slider-Range-Hover%22%20transform%3D%22translate%28610.000000%2C%200.000000%29%22%20sketch%3Atype%3D%22MSShapeGroup%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Slider%22%20transform%3D%22translate%280.000000%2C%2070.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Focused-Handle%22%20transform%3D%22translate%28279.000000%2C%200.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22Oval-10%22%20stroke%3D%22%230076C0%22%20stroke-width%3D%222%22%20fill%3D%22%23FFFFFF%22%20cx%3D%2212%22%20cy%3D%2212%22%20r%3D%2212%22%3E%3C/circle%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M8%2C7.5%20L8%2C16.5%20L8%2C17%20L9%2C17%20L9%2C16.5%20L9%2C7.5%20L9%2C7%20L8%2C7%20L8%2C7.5%20Z%20M12%2C7.5%20L12%2C16.5%20L12%2C17%20L13%2C17%20L13%2C16.5%20L13%2C7.5%20L13%2C7%20L12%2C7%20L12%2C7.5%20Z%20M16%2C7.5%20L16%2C16.5%20L16%2C17%20L17%2C17%20L17%2C16.5%20L17%2C7.5%20L17%2C7%20L16%2C7%20L16%2C7.5%20Z%22%20id%3D%22Scrubber-Lines-RIght%22%20fill%3D%22%230076C0%22%3E%3C/path%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%3C/g%3E%0A%3C/svg%3E)}:host ::ng-deep .slider .handle.right{right:0}:host ::ng-deep .slider .handle.left{left:0}:host ::ng-deep .slider .handle.hidden{display:none}:host ::ng-deep .slider .hashTrack{display:flex;justify-content:space-between;position:absolute;left:0;top:0;width:100%}:host ::ng-deep .slider .hashTrack .hash{display:inline-block;height:12px;position:relative}:host ::ng-deep .slider .hashTrack .hash:after{content:\"\";display:block;width:1px;background-color:#999;height:100%;position:absolute;right:0}:host ::ng-deep .slider .hashTrack .hash.highlighted:after{background-color:#056dae}:host ::ng-deep .slider .hashTrack .hash:last-child:after{display:none}:host ::ng-deep .labels{display:flex;justify-content:space-between;margin-top:20px}:host ::ng-deep .value-labels{display:flex;margin-top:15px}:host ::ng-deep .value-labels .value-label{flex:1 1 100%;text-align:center}:host ::ng-deep .value-labels .value-label:first-child,:host ::ng-deep .value-labels .value-label:last-child{flex:1 1 50%}:host ::ng-deep .value-labels .value-label:first-child{text-align:left}:host ::ng-deep .value-labels .value-label:last-child{text-align:right}:host ::ng-deep .value-labels .value-label span{position:absolute;transform:translate(-50%)}:host ::ng-deep .value-labels .value-label:first-child span{transform:none}:host ::ng-deep .value-labels .value-label:last-child span{transform:translate(-100%)}\n"] }]
        }], ctorParameters: () => [], propDecorators: { viewInput: [{
                type: ViewChild,
                args: ['viewInput', { static: false }]
            }], slider: [{
                type: ViewChild,
                args: ['slider', { static: false }]
            }], track: [{
                type: ViewChild,
                args: ['track', { static: false }]
            }], leftHandle: [{
                type: ViewChild,
                args: ['leftHandle', { static: true }]
            }], rightHandle: [{
                type: ViewChild,
                args: ['rightHandle', { static: true }]
            }], line: [{
                type: ViewChild,
                args: ['line', { static: true }]
            }], labelContainer: [{
                type: ViewChild,
                args: ['labelContainer', { static: false }]
            }], hashTrack: [{
                type: ViewChild,
                args: ['hashTrack', { static: false }]
            }], idStr: [{
                type: Input$1
            }], name: [{
                type: Input$1
            }], range: [{
                type: Input$1
            }], min: [{
                type: Input$1
            }], max: [{
                type: Input$1
            }], step: [{
                type: Input$1
            }], minLabel: [{
                type: Input$1
            }], maxLabel: [{
                type: Input$1
            }], labels: [{
                type: Input$1
            }], showLabels: [{
                type: Input$1
            }], handleLabel: [{
                type: Input$1
            }], minHandleLabel: [{
                type: Input$1
            }], maxHandleLabel: [{
                type: Input$1
            }], unitOfValue: [{
                type: Input$1
            }], showHashMarks: [{
                type: Input$1
            }], value: [{
                type: Input$1
            }], valueChange: [{
                type: Output
            }], minValue: [{
                type: Input$1
            }], minValueChange: [{
                type: Output
            }], maxValue: [{
                type: Input$1
            }], maxValueChange: [{
                type: Output
            }], onMouseUp: [{
                type: HostListener,
                args: ['document:mouseup', ['$event']]
            }], onTouchEnd: [{
                type: HostListener,
                args: ['document:touchend', ['$event']]
            }], onWindowResize: [{
                type: HostListener,
                args: ['window:resize', ['$event']]
            }] } });

const COMPONENTS$y = [
    ValueSliderComponent
];
const MODULES$B = [
    CommonModule,
    FormsModule
];
class ValueSlider {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ValueSlider, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: ValueSlider, declarations: [ValueSliderComponent], imports: [CommonModule,
            FormsModule], exports: [ValueSliderComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ValueSlider, imports: [MODULES$B] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ValueSlider, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$B],
                    declarations: [...COMPONENTS$y],
                    exports: [...COMPONENTS$y]
                }]
        }] });

/**
 * @Component: Card Info
 * @Section: Modules
 * @description The card info module.
 */
class CardComponent {
    set isIE(isIE) {
        this._isIE = isIE;
    }
    get isIE() {
        return this._isIE;
    }
    // #endregion
    // #region ------------- Lifecycle Hooks ------------- //
    constructor(liveAnnouncer, _navigator) {
        this.liveAnnouncer = liveAnnouncer;
        /**
         * @property readonly
         * @description Whether component only shows one card instead of offering a dropdown menu
         * @Type: boolean
         */
        this.readonly = false;
        /**
         * @Event: cardChanged
         * @description This event that is fired when a card is selected; returns the index of the card (first card is 0)
         * @return Number
         */
        this.cardChanged = new EventEmitter();
        if (isDevMode()) {
            console.error('%cThe Common UI DDL Card <citi-card> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
        this.isIE = isIE(_navigator);
    }
    initSelectedCard() {
        this.startCardIndex = this.selectedIndex ? Number.parseInt(this.selectedIndex, 10) : 0;
        this.selectCard(this.startCardIndex);
    }
    ngOnInit() {
        this.initSelectedCard();
    }
    // TODO: move to a setter
    ngOnChanges(changes) {
        if (changes.cardList.currentValue != changes.cardList.previousValue) {
            this.initSelectedCard();
        }
    }
    // #endregion
    /**
     * @name selectCard
     * @description Selects a card in a list of card by index
     * @param (Number) - cardIndex - Index of the target card
     * @return void
     */
    selectCard(cardIndex) {
        if (this.cardList && this.cardList.length > 0) {
            this.currentCard = this.cardList[cardIndex];
            // Event emitter
            this.cardChanged.emit(this.currentCard);
            // If there is only one card
            if (this.cardList && this.cardList.length === 1) {
                this.readonly = true;
            }
            this.liveAnnouncer.announce(this.currentCard.cardNameFormatted + ' ' + 'selected');
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CardComponent, deps: [{ token: CitiLiveAnnouncer }, { token: NAVIGATOR }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: CardComponent, isStandalone: false, selector: "citi-card", inputs: { displayMemberSince: "displayMemberSince", displayCardholderName: "displayCardholderName", isIE: "isIE", id: "id", cardList: "cardList", selectedIndex: "selectedIndex", readonly: "readonly", showDetails: "showDetails", selectCardLabel: "selectCardLabel", cardTheme: "cardTheme" }, outputs: { cardChanged: "cardChanged" }, usesOnChanges: true, ngImport: i0, template: `
    <div class="container-fluid">
      <div class="row" *ngIf="cardList" [ngClass]="{'forIE':isIE, 'forOther': !isIE}">
        <div class="leftItem">
          <img [attr.src]="currentCard.cardArtUrl" [attr.alt]="currentCard.cardArtAltText" width="100%"/>
          <div class="mobileView" *ngIf="displayCardholderName">{{currentCard.cardHolderName}}</div>
          <div class="mobileView" *ngIf="displayMemberSince">{{currentCard.memberSince}}</div>
        </div>
        <div *ngIf="!readonly" class="form-group rightItem">
          <label class="select-box-label" [attr.for]="id+'-select'" [innerHtml]="selectCardLabel"></label>
          <select [id]="id+'-select'" class="form-control {{cardTheme}}" (change)="selectCard($event.target.selectedIndex);">
            <option *ngFor="let card of cardList; let idx = index;" [attr.value]="card.cardInstanceID"
              [selected]="idx === startCardIndex" [innerHtml]="card.cardNameFormatted">
            </option>
          </select>
        </div>
        <div *ngIf="readonly" class="rightItem">
          <p [innerHTML]="currentCard.cardName + ' ' + currentCard.cardNumber"></p>
        </div>
      </div>
      <div class="desktopView" *ngIf="displayCardholderName">{{currentCard.cardHolderName}}</div>
      <div class="desktopView" *ngIf="displayMemberSince">{{currentCard.memberSince}}</div>
    </div>
  `, isInline: true, styles: ["img{max-width:100%}.cbolui-ddl :host ::ng-deep .select-box-label{visibility:visible;opacity:1}.dark{background-color:#eee!important}select.dark::-ms-value{background-color:#eee}select.dark:focus::-ms-value{background-color:#eee}.light{background-color:#fff!important}select.light::-ms-value{background-color:#fff}select.light:focus::-ms-value{background-color:#fff}.forOther{display:flex;flex-direction:row;align-items:center;position:relative}.forIE{display:flex;flex-direction:row;align-items:center}.leftItem{width:27%}.rightItem{padding:0 20px;width:63%}.mobileView{display:none}.desktopView{display:block;width:24%;text-align:center;margin-top:10px}@media only screen and (max-width: 767px){.forOther{display:flex;flex-direction:column;align-items:center}.forIE{display:inline;align-items:center}}@media only screen and (max-width: 767px){.leftItem{width:70%;margin:0 auto}.rightItem{width:100%;text-align:center;margin:0 auto;padding:20px}.desktopView{display:none}.mobileView{display:block;text-align:center;margin-top:10px}}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i4.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i4.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-card', standalone: false, template: `
    <div class="container-fluid">
      <div class="row" *ngIf="cardList" [ngClass]="{'forIE':isIE, 'forOther': !isIE}">
        <div class="leftItem">
          <img [attr.src]="currentCard.cardArtUrl" [attr.alt]="currentCard.cardArtAltText" width="100%"/>
          <div class="mobileView" *ngIf="displayCardholderName">{{currentCard.cardHolderName}}</div>
          <div class="mobileView" *ngIf="displayMemberSince">{{currentCard.memberSince}}</div>
        </div>
        <div *ngIf="!readonly" class="form-group rightItem">
          <label class="select-box-label" [attr.for]="id+'-select'" [innerHtml]="selectCardLabel"></label>
          <select [id]="id+'-select'" class="form-control {{cardTheme}}" (change)="selectCard($event.target.selectedIndex);">
            <option *ngFor="let card of cardList; let idx = index;" [attr.value]="card.cardInstanceID"
              [selected]="idx === startCardIndex" [innerHtml]="card.cardNameFormatted">
            </option>
          </select>
        </div>
        <div *ngIf="readonly" class="rightItem">
          <p [innerHTML]="currentCard.cardName + ' ' + currentCard.cardNumber"></p>
        </div>
      </div>
      <div class="desktopView" *ngIf="displayCardholderName">{{currentCard.cardHolderName}}</div>
      <div class="desktopView" *ngIf="displayMemberSince">{{currentCard.memberSince}}</div>
    </div>
  `, styles: ["img{max-width:100%}.cbolui-ddl :host ::ng-deep .select-box-label{visibility:visible;opacity:1}.dark{background-color:#eee!important}select.dark::-ms-value{background-color:#eee}select.dark:focus::-ms-value{background-color:#eee}.light{background-color:#fff!important}select.light::-ms-value{background-color:#fff}select.light:focus::-ms-value{background-color:#fff}.forOther{display:flex;flex-direction:row;align-items:center;position:relative}.forIE{display:flex;flex-direction:row;align-items:center}.leftItem{width:27%}.rightItem{padding:0 20px;width:63%}.mobileView{display:none}.desktopView{display:block;width:24%;text-align:center;margin-top:10px}@media only screen and (max-width: 767px){.forOther{display:flex;flex-direction:column;align-items:center}.forIE{display:inline;align-items:center}}@media only screen and (max-width: 767px){.leftItem{width:70%;margin:0 auto}.rightItem{width:100%;text-align:center;margin:0 auto;padding:20px}.desktopView{display:none}.mobileView{display:block;text-align:center;margin-top:10px}}\n"] }]
        }], ctorParameters: () => [{ type: CitiLiveAnnouncer }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [NAVIGATOR]
                }] }], propDecorators: { displayMemberSince: [{
                type: Input$1
            }], displayCardholderName: [{
                type: Input$1
            }], isIE: [{
                type: Input$1
            }], id: [{
                type: Input$1
            }], cardList: [{
                type: Input$1
            }], selectedIndex: [{
                type: Input$1
            }], readonly: [{
                type: Input$1
            }], showDetails: [{
                type: Input$1
            }], selectCardLabel: [{
                type: Input$1
            }], cardTheme: [{
                type: Input$1
            }], cardChanged: [{
                type: Output
            }] } });
/**
 * isIE() returns if browser is Internet Explorer
 */
function isIE(getNavigator) {
    if (getNavigator == null || !getNavigator)
        return false;
    if (!getNavigator.userAgent || getNavigator.userAgent == null)
        return false;
    let ua = getNavigator.userAgent;
    // IE 10 or older => return true
    let msie = ua.indexOf('MSIE ');
    if (msie > 0)
        return true;
    // IE 11 => return true
    let trident = ua.indexOf('Trident/');
    if (trident > 0)
        return true;
    // Edge (IE 12+) => return true
    let edge = ua.indexOf('Edge/');
    if (edge > 0)
        return true;
    // other browser
    return false;
}

const COMPONENTS$x = [
    CardComponent
];
const MODULES$A = [
    CommonModule,
    FormsModule
];
class Card {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Card, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: Card, declarations: [CardComponent], imports: [CommonModule,
            FormsModule], exports: [CardComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Card, imports: [MODULES$A] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Card, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$A],
                    declarations: [...COMPONENTS$x],
                    exports: [CardComponent]
                }]
        }] });

/**
 * @Component: Card Info
 * @Section: Modules
 * @description The card info module.
 */
class CardInfoComponent {
    /**
     * @property selectedIndex
     * @description Which card is initially visible (default is the first card, 0)
     * @return number
     */
    set selectedIndex(val) {
        this._selectedIndex = val;
    }
    get selectedIndex() {
        return this._selectedIndex;
    }
    set cardList(cardList) {
        this._cardList = cardList;
        setTimeout(() => {
            this.selectCard(this.cardList[this.selectedIndex].cardInstanceID);
        }, 10);
    }
    get cardList() {
        return this._cardList;
    }
    constructor() {
        this._selectedIndex = 0;
        /**
         * @property readonly
         * @description Whether component only shows one card instead of offering a dropdown menu
         * @Type: boolean
         */
        this.readonly = false;
        /**
         * @property showDetails
         * @description Whether component shows the selected card's details (balance, etc)
         * @Type: boolean
         */
        this.showDetails = false;
        /**
         * @property selectCardLabel
         * @description Label of card dropdown
         * @return string
         */
        this.selectCardLabel = 'Please select one';
        /**
         * @property cardTheme
         * @description optional 'dark' or 'light' theme for select tag
         * @return string
         */
        this.cardTheme = 'dark';
        /**
         * @Event: cardChanged
         * @description This event that is fired when a card is selected; returns the index of the card (first card is 0)
         * @return Number
         */
        this.cardChanged = new EventEmitter();
        if (isDevMode()) {
            console.error('%cThe Common UI DDL CardInfo <citi-card-info> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    /**
     * @name selectCard
     * @description Selects a card in a list of card by index
     * @param (Number) - cardIndex - Index of the target card
     * @return void
     */
    selectCard(selectedID) {
        if (!this.cardList.length || this.selectedDDValue === selectedID)
            return;
        this.selectedDDValue = selectedID;
        this.selectedIndex = this.cardList.findIndex(card => card.cardInstanceID === selectedID);
        this.currentCard = this.cardList.find(card => card.cardInstanceID === selectedID);
        // Extract iteratable list of details: [{label:"", value:""}]
        this.currentCardDetails = values(this.cardList[this.selectedIndex].details);
        this.cardChanged.emit(this.currentCard);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CardInfoComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: CardInfoComponent, isStandalone: false, selector: "citi-card-info", inputs: { idStr: "idStr", selectedIndex: "selectedIndex", cardList: "cardList", readonly: "readonly", showDetails: "showDetails", selectCardLabel: "selectCardLabel", cardTheme: "cardTheme" }, outputs: { cardChanged: "cardChanged" }, ngImport: i0, template: `
    <div *ngIf="showDetails" [attr.id]="idStr" class="container-fluid">
      <div class="row" *ngIf="cardList && cardList.length > 1">
        <div *ngIf="!readonly" class="form-group col-md-8 col-sm-12">
          <citi-dropdown2
            [idStr]="idStr + '-select'"
            [dropdownTheme]="cardTheme"
            [label]="selectCardLabel"
            [value]="selectedDDValue"
            (valueChange)="selectCard($event)"
            placeholder="Please select one"
          >
            <citi-options2
              *ngFor="let card of cardList; let i = index"
              [value]="card.cardInstanceID"
              [label]="card.cardNameFormatted"
            ></citi-options2>
          </citi-dropdown2>
        </div>
        <div *ngIf="readonly" class="form-group col-md-8 col-sm-12">
          <p [innerHTML]="currentCard.cardName"></p>
          <p class="small" [innerHtml]="currentCard.cardHolderName"></p>
        </div>
      </div>
      <div class="row" *ngIf="cardList && cardList.length === 1">
        <div class="form-group col-md-8 col-sm-12">
          <p [innerHTML]="currentCard.cardName"></p>
          <p
            *ngIf="readonly"
            class="small"
            [innerHtml]="currentCard.cardHolderName"
          ></p>
        </div>
      </div>
      <div *ngIf="currentCard" class="row">
        <div *ngIf="currentCard.cardArtUrl" class="col-sm-4 col-sm-push-8">
          <!-- Deque has instructed that no alt text be provided -->
          <img [attr.src]="currentCard.cardArtUrl" alt="" />
        </div>
        <div *ngIf="currentCard.details" class=" col-sm-8 col-sm-pull-4">
          <div *ngFor="let detail of currentCardDetails" class="row">
            <div class="col-sm-8">
              <b innerHtml="{{ detail.label + ':' }}"></b>
            </div>
            <div class="col-sm-4" [innerHtml]="detail.value"></div>
          </div>
        </div>
      </div>
    </div>
    <div
      *ngIf="!showDetails && currentCard"
      [attr.id]="idStr"
      class="container-fluid"
    >
      <div class="row" *ngIf="cardList && cardList.length > 1">
        <div class="col-xs-2">
          <!-- Deque has instructed that no alt text be provided -->
          <img [attr.src]="currentCard.cardArtUrl" alt="" />
        </div>
        <div *ngIf="!readonly" class="form-group col-xs-10">
          <citi-dropdown2
            [idStr]="idStr + '-select'"
            [dropdownTheme]="cardTheme"
            [label]="selectCardLabel"
            [value]="selectedDDValue"
            (valueChange)="selectCard($event)"
            placeholder="Please select one"
          >
            <citi-options2
              *ngFor="let card of cardList; let i = index"
              [value]="card.cardInstanceID"
              [label]="card.cardNameFormatted"
            ></citi-options2>
          </citi-dropdown2>
        </div>
        <div *ngIf="readonly" class="form-group col-xs-10">
          <p
            *ngIf="currentCard.cardName"
            [innerHTML]="currentCard.cardName"
          ></p>
          <p
            *ngIf="currentCard.cardHolderName"
            class="small"
            [innerHtml]="currentCard.cardHolderName"
          ></p>
        </div>
      </div>
      <div class="row" *ngIf="cardList && cardList.length === 1">
        <div class="col-xs-2">
          <!-- Deque has instructed that no alt text be provided -->
          <img [attr.src]="currentCard.cardArtUrl" alt="" />
        </div>
        <div class="form-group col-xs-10">
          <p
            *ngIf="currentCard.cardName"
            [innerHTML]="currentCard.cardName"
          ></p>
          <p
            *ngIf="readonly && currentCard.cardHolderName"
            class="small"
            [innerHtml]="currentCard.cardHolderName"
          ></p>
        </div>
      </div>
    </div>
  `, isInline: true, styles: [":host ::ng-deep img{max-width:100%}.cbolui-ddl :host ::ng-deep .select-box-label{visibility:visible;opacity:1}.dark{background-color:#eee!important}select.dark::-ms-value{background-color:#eee}select.dark:focus::-ms-value{background-color:#eee}.light{background-color:#fff!important}select.light::-ms-value{background-color:#fff}select.light:focus::-ms-value{background-color:#fff}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: Dropdown2Component, selector: "citi-dropdown2", inputs: ["CustomMasking", "mask", "placeholder", "label", "idStr", "labelId", "ariaLabelledById", "name", "size", "customErrorMessage", "error", "requiredError", "required", "predictiveSearch", "isDisabled", "dropdownTheme", "additionalClasses", "visibleLabel", "value", "getScrollableMenuAriaLabelledby"], outputs: ["errorChange", "valueChange", "searchValueChange", "displayedValueChange"] }, { kind: "component", type: OptionsComponent, selector: "citi-options2", inputs: ["isSelected", "value", "label", "disabled"], outputs: ["ddResetStyles", "ddClose", "ddDisplayText", "ddValueName", "ddValue", "ddHasOptionSelected", "ddAnnounce"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CardInfoComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-card-info', standalone: false, template: `
    <div *ngIf="showDetails" [attr.id]="idStr" class="container-fluid">
      <div class="row" *ngIf="cardList && cardList.length > 1">
        <div *ngIf="!readonly" class="form-group col-md-8 col-sm-12">
          <citi-dropdown2
            [idStr]="idStr + '-select'"
            [dropdownTheme]="cardTheme"
            [label]="selectCardLabel"
            [value]="selectedDDValue"
            (valueChange)="selectCard($event)"
            placeholder="Please select one"
          >
            <citi-options2
              *ngFor="let card of cardList; let i = index"
              [value]="card.cardInstanceID"
              [label]="card.cardNameFormatted"
            ></citi-options2>
          </citi-dropdown2>
        </div>
        <div *ngIf="readonly" class="form-group col-md-8 col-sm-12">
          <p [innerHTML]="currentCard.cardName"></p>
          <p class="small" [innerHtml]="currentCard.cardHolderName"></p>
        </div>
      </div>
      <div class="row" *ngIf="cardList && cardList.length === 1">
        <div class="form-group col-md-8 col-sm-12">
          <p [innerHTML]="currentCard.cardName"></p>
          <p
            *ngIf="readonly"
            class="small"
            [innerHtml]="currentCard.cardHolderName"
          ></p>
        </div>
      </div>
      <div *ngIf="currentCard" class="row">
        <div *ngIf="currentCard.cardArtUrl" class="col-sm-4 col-sm-push-8">
          <!-- Deque has instructed that no alt text be provided -->
          <img [attr.src]="currentCard.cardArtUrl" alt="" />
        </div>
        <div *ngIf="currentCard.details" class=" col-sm-8 col-sm-pull-4">
          <div *ngFor="let detail of currentCardDetails" class="row">
            <div class="col-sm-8">
              <b innerHtml="{{ detail.label + ':' }}"></b>
            </div>
            <div class="col-sm-4" [innerHtml]="detail.value"></div>
          </div>
        </div>
      </div>
    </div>
    <div
      *ngIf="!showDetails && currentCard"
      [attr.id]="idStr"
      class="container-fluid"
    >
      <div class="row" *ngIf="cardList && cardList.length > 1">
        <div class="col-xs-2">
          <!-- Deque has instructed that no alt text be provided -->
          <img [attr.src]="currentCard.cardArtUrl" alt="" />
        </div>
        <div *ngIf="!readonly" class="form-group col-xs-10">
          <citi-dropdown2
            [idStr]="idStr + '-select'"
            [dropdownTheme]="cardTheme"
            [label]="selectCardLabel"
            [value]="selectedDDValue"
            (valueChange)="selectCard($event)"
            placeholder="Please select one"
          >
            <citi-options2
              *ngFor="let card of cardList; let i = index"
              [value]="card.cardInstanceID"
              [label]="card.cardNameFormatted"
            ></citi-options2>
          </citi-dropdown2>
        </div>
        <div *ngIf="readonly" class="form-group col-xs-10">
          <p
            *ngIf="currentCard.cardName"
            [innerHTML]="currentCard.cardName"
          ></p>
          <p
            *ngIf="currentCard.cardHolderName"
            class="small"
            [innerHtml]="currentCard.cardHolderName"
          ></p>
        </div>
      </div>
      <div class="row" *ngIf="cardList && cardList.length === 1">
        <div class="col-xs-2">
          <!-- Deque has instructed that no alt text be provided -->
          <img [attr.src]="currentCard.cardArtUrl" alt="" />
        </div>
        <div class="form-group col-xs-10">
          <p
            *ngIf="currentCard.cardName"
            [innerHTML]="currentCard.cardName"
          ></p>
          <p
            *ngIf="readonly && currentCard.cardHolderName"
            class="small"
            [innerHtml]="currentCard.cardHolderName"
          ></p>
        </div>
      </div>
    </div>
  `, styles: [":host ::ng-deep img{max-width:100%}.cbolui-ddl :host ::ng-deep .select-box-label{visibility:visible;opacity:1}.dark{background-color:#eee!important}select.dark::-ms-value{background-color:#eee}select.dark:focus::-ms-value{background-color:#eee}.light{background-color:#fff!important}select.light::-ms-value{background-color:#fff}select.light:focus::-ms-value{background-color:#fff}\n"] }]
        }], ctorParameters: () => [], propDecorators: { idStr: [{
                type: Input$1
            }], selectedIndex: [{
                type: Input$1
            }], cardList: [{
                type: Input$1
            }], readonly: [{
                type: Input$1
            }], showDetails: [{
                type: Input$1
            }], selectCardLabel: [{
                type: Input$1
            }], cardTheme: [{
                type: Input$1
            }], cardChanged: [{
                type: Output
            }] } });

const COMPONENTS$w = [
    CardInfoComponent
];
const MODULES$z = [
    CommonModule,
    FormsModule,
    Dropdown2
];
class CardInfo {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CardInfo, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: CardInfo, declarations: [CardInfoComponent], imports: [CommonModule,
            FormsModule,
            Dropdown2], exports: [CardInfoComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CardInfo, imports: [MODULES$z] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CardInfo, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$z],
                    declarations: [...COMPONENTS$w],
                    exports: [CardInfoComponent]
                }]
        }] });

/**
 * @Component: Terms and Conditions
 * @Section: Forms
 * @description This component generates a terms and conditions section
 */
class TermsAndConditionsComponent {
    set show(show) {
        this._show = show;
        this.showChange.emit(show);
    }
    get show() {
        return this._show;
    }
    constructor(_ngZone) {
        this._ngZone = _ngZone;
        /**
       * @property checkboxLabel
       * @description text of the Checkbox Label
       * @return string
       * @twoway false
       */
        this.checkboxLabel = 'I agree to the Terms & Conditions';
        /**
       * @property modalButtonLabel
       * @description text on the button for the modal terms configuration
       * @return string
       * @twoway false
       */
        this.modalButtonLabel = 'Terms & Conditions';
        /**
         * @property show
         * @description binds to the term's <citi-modal> show property (only useful when type="modal")
         * @Type: boolean
         * @twoway true
         */
        this._show = false;
        this.showChange = new EventEmitter();
        if (isDevMode()) {
            console.error('%cThe Common UI DDL TermsAndConditions <citi-terms-and-conditions> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    // Once all of the content is available
    ngAfterContentChecked() {
        this.executeOnStable(() => this.contentCheck());
    }
    contentCheck() {
        const innerHtml = this.content.nativeElement.innerHTML.toString();
        // If we got anything back Set the content HTML string
        if (innerHtml.length)
            this.htmlContent = innerHtml;
    }
    executeOnStable(func) {
        this._ngZone.runOutsideAngular(() => {
            this._ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => func());
        });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TermsAndConditionsComponent, deps: [{ token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: TermsAndConditionsComponent, isStandalone: false, selector: "citi-terms-and-conditions", inputs: { type: "type", htmlContent: "htmlContent", checkboxLabel: "checkboxLabel", modalButtonLabel: "modalButtonLabel", show: "show" }, outputs: { showChange: "showChange" }, viewQueries: [{ propertyName: "content", first: true, predicate: ["content"], descendants: true }], ngImport: i0, template: `
    <div #content class="hidden" [contentHtml]="htmlContent">
      <ng-content></ng-content>
    </div>
    <fieldset *ngIf="!type || type === 'standalone' || type === 'scrollbox'">
      <div class="row">
        <div class="col-sm-10">
          <div [attr.class]="type === 'scrollbox' ? 'scrollbox' : null">
            <small class="terms-and-conditons">
              <div [innerHtml]="htmlContent"></div>
            </small>
          </div>
          <citi-input-group>
            <citi-checkbox idStr="tandc" value="true" [label]="checkboxLabel" name="tandc"></citi-checkbox>
          </citi-input-group>
        </div>
      </div>
    </fieldset>
    <fieldset *ngIf="type === 'modal'">
      <div class="row">
        <div class="col-sm-10">
          <div class="checkbox">
            <input type="checkbox" id="tandc" name="tandc" value="true">
            <label for="tandc">
              {{checkboxLabel}}
              <citi-cta bold type="secondary" [value]="modalButtonLabel" (ctaClick)="show = !show"></citi-cta>
            </label>
          </div>
        </div>
      </div>
      <citi-modal title="Terms &amp; Conditions" [(show)]="show">
        <div [innerHtml]="htmlContent"></div>
      </citi-modal>
    </fieldset>
    <section *ngIf="type === 'terms'" class="b-5-copy">
      <div class="container-fluid">

          <div [innerHtml]="htmlContent"></div>

      </div>
    </section>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }, { kind: "component", type: CheckboxComponent, selector: "citi-checkbox" }, { kind: "component", type: InputGroupComponent, selector: "citi-input-group", inputs: ["title", "required", "error", "errorMessage", "htmlContent", "value"], outputs: ["errorChange", "valueChange"] }, { kind: "component", type: CTAComponent, selector: "citi-cta", inputs: ["textAlign", "bold", "noMargin", "tabIndex", "ariaDescription", "ariaLabeledBy", "ariaHasPopup", "ariaRole", "ariaLabel", "ariaControls", "ariaExpanded", "router", "queryParams", "idStr", "dataTarget", "addJFPToken", "doNotAddJFPToken", "buttonType", "target", "href", "value", "disabled", "type", "size", "arrow", "leftArrow"], outputs: ["ctaClick", "disabledChange", "ctaFocus", "ctaBlur"] }, { kind: "component", type: ModalComponent, selector: "citi-modal", inputs: ["scrollable", "htmlContent", "ariaRole", "footerContent", "idStr", "title", "primaryButtonUrl", "primaryButtonTarget", "primaryButtonText", "showCancelButton", "footerProjection", "disablePrimaryButton", "disableCloseButton", "closeOnBgClick", "cancelButtonText", "openerSelector", "show", "closeButtonIdStr"], outputs: ["primaryButtonClick", "secondaryButtonClick", "closeButtonClick", "showChange", "onHide"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TermsAndConditionsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'citi-terms-and-conditions',
                    standalone: false,
                    template: `
    <div #content class="hidden" [contentHtml]="htmlContent">
      <ng-content></ng-content>
    </div>
    <fieldset *ngIf="!type || type === 'standalone' || type === 'scrollbox'">
      <div class="row">
        <div class="col-sm-10">
          <div [attr.class]="type === 'scrollbox' ? 'scrollbox' : null">
            <small class="terms-and-conditons">
              <div [innerHtml]="htmlContent"></div>
            </small>
          </div>
          <citi-input-group>
            <citi-checkbox idStr="tandc" value="true" [label]="checkboxLabel" name="tandc"></citi-checkbox>
          </citi-input-group>
        </div>
      </div>
    </fieldset>
    <fieldset *ngIf="type === 'modal'">
      <div class="row">
        <div class="col-sm-10">
          <div class="checkbox">
            <input type="checkbox" id="tandc" name="tandc" value="true">
            <label for="tandc">
              {{checkboxLabel}}
              <citi-cta bold type="secondary" [value]="modalButtonLabel" (ctaClick)="show = !show"></citi-cta>
            </label>
          </div>
        </div>
      </div>
      <citi-modal title="Terms &amp; Conditions" [(show)]="show">
        <div [innerHtml]="htmlContent"></div>
      </citi-modal>
    </fieldset>
    <section *ngIf="type === 'terms'" class="b-5-copy">
      <div class="container-fluid">

          <div [innerHtml]="htmlContent"></div>

      </div>
    </section>
  `
                }]
        }], ctorParameters: () => [{ type: i0.NgZone }], propDecorators: { type: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }], checkboxLabel: [{
                type: Input$1
            }], modalButtonLabel: [{
                type: Input$1
            }], show: [{
                type: Input$1
            }], showChange: [{
                type: Output
            }], content: [{
                type: ViewChild,
                args: ['content']
            }] } });

const COMPONENTS$v = [TermsAndConditionsComponent];
const MODULES$y = [CommonModule, ContentHtml, InputGroup, CTA, TextHeader, Modal];
class TermsAndConditions {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TermsAndConditions, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: TermsAndConditions, declarations: [TermsAndConditionsComponent], imports: [CommonModule, ContentHtml, InputGroup, CTA, TextHeader, Modal], exports: [TermsAndConditionsComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TermsAndConditions, imports: [MODULES$y] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TermsAndConditions, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$y],
                    declarations: [...COMPONENTS$v],
                    exports: [...COMPONENTS$v]
                }]
        }] });

class TimeSelectorGroupComponent {
    constructor() {
        /**
         * @property groupLabel
         * @description Label for the radio button group legend text
        */
        this.groupLabel = 'Group label';
        /**
         * @property groupNum
         * @description A unique number for the group when there are multiple groups on the same view
        */
        this.groupNum = 1;
        this.onClickChange = new EventEmitter();
        this.onArrowPressed = new EventEmitter();
        if (isDevMode()) {
            console.error('%cThe Common UI DDL TimeSelector <citi-time-selector-group> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    handleValueChange(event, inputElement) {
        this.onClickChange.emit(inputElement.nativeElement);
    }
    onkeyupevent(event) {
        if (event.keyCode === 37 || event.keyCode === 38 || event.keyCode === 39 || event.keyCode === 40) {
            this.onArrowPressed.emit(event.target);
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TimeSelectorGroupComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: TimeSelectorGroupComponent, isStandalone: false, selector: "citi-time-selector-group", inputs: { groupLabel: "groupLabel", groupNum: "groupNum" }, outputs: { onClickChange: "onClickChange", onArrowPressed: "onArrowPressed" }, host: { classAttribute: "citi-time-selector-group" }, ngImport: i0, template: `
    <div class="component-container">
      <citi-row>
        <citi-column xs="12" sm="12" md="8">
          <fieldset>
          <legend id="rgrouplabel-{{groupNum}}" class="sr-only">{{groupLabel}}</legend>
          <ng-content></ng-content>
          </fieldset>
        </citi-column>
      </citi-row>
    </div>
  `, isInline: true, styles: [""], dependencies: [{ kind: "component", type: ColumnComponent, selector: "citi-column, [citi-column]", inputs: ["xs", "sm", "md", "lg", "pullRight", "pullLeft", "offXs", "offSm", "offMd", "offLg", "classes", "htmlContent"] }, { kind: "component", type: RowComponent, selector: "citi-row, [citi-row]", inputs: ["classes", "htmlContent"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TimeSelectorGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-time-selector-group', standalone: false, host: { class: 'citi-time-selector-group' }, template: `
    <div class="component-container">
      <citi-row>
        <citi-column xs="12" sm="12" md="8">
          <fieldset>
          <legend id="rgrouplabel-{{groupNum}}" class="sr-only">{{groupLabel}}</legend>
          <ng-content></ng-content>
          </fieldset>
        </citi-column>
      </citi-row>
    </div>
  ` }]
        }], ctorParameters: () => [], propDecorators: { groupLabel: [{
                type: Input$1
            }], groupNum: [{
                type: Input$1
            }], onClickChange: [{
                type: Output
            }], onArrowPressed: [{
                type: Output
            }] } });

/**
 * @Component: TimeSelectorComponent
 * @Section: Modules
 * @description This component generates...
 */
class TimeSelectorComponent {
    // #endregion
    // #region // ---------- Constructor / LifeCycle Hooks ----------- //
    constructor(timeSelectorGroup) {
        this.timeSelectorGroup = timeSelectorGroup;
        /**
         * @property checked
         * @description check if the radio button is checked or not
         */
        this.checked = false;
    }
    ;
    // #endregion
    // #region // ------------ Methods ------------- //
    /**
     * @Method: onClick
     * @description click handler method
     */
    onClick(event) {
        this.timeSelectorGroup.handleValueChange(event, this.viewInput);
    }
    /**
     * @Method: onkeyupeventMethod
     * @description keyup handler method
     */
    onkeyupevent(e) {
        this.timeSelectorGroup.onkeyupevent(e);
    }
    /**
     * @description method to check if button is checked, and if checked append class name
     */
    isState(st) {
        return st;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TimeSelectorComponent, deps: [{ token: forwardRef(() => TimeSelectorGroupComponent) }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: TimeSelectorComponent, isStandalone: false, selector: "citi-time-selector-option", inputs: { label: "label", checked: "checked", value: "value", name: "name" }, host: { classAttribute: "citi-time-selector-option" }, viewQueries: [{ propertyName: "viewInput", first: true, predicate: ["viewInput"], descendants: true }], ngImport: i0, template: `
      <span class="radio-temp">
        <label
          id="{{label}}-Id"
          for="time-{{label}}"
          class="btn timeSelector small"
          (click) = "onClick($event)"
          [ngClass]="{'active focus': isState(viewInput.checked) }">
          {{value}}
        </label>
        <input
          #viewInput
          type="radio"
          id="time-{{label}}"
          attr.aria-labelledby="{{label}}-Id"
          autocomplete="off"
          [name]="name"
          [value]="value"
          (keyup) = "onkeyupevent($event)"
          [checked]="(checked ? checked : null)">
      </span>
    `, isInline: true, styles: [".radio-temp{position:relative}.radio-temp>label{position:relative;margin-top:3px;z-index:1}.radio-temp>input{position:absolute;margin-left:-78px;margin-top:13px}input{appearance:none}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TimeSelectorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-time-selector-option', standalone: false, host: { class: 'citi-time-selector-option' }, template: `
      <span class="radio-temp">
        <label
          id="{{label}}-Id"
          for="time-{{label}}"
          class="btn timeSelector small"
          (click) = "onClick($event)"
          [ngClass]="{'active focus': isState(viewInput.checked) }">
          {{value}}
        </label>
        <input
          #viewInput
          type="radio"
          id="time-{{label}}"
          attr.aria-labelledby="{{label}}-Id"
          autocomplete="off"
          [name]="name"
          [value]="value"
          (keyup) = "onkeyupevent($event)"
          [checked]="(checked ? checked : null)">
      </span>
    `, styles: [".radio-temp{position:relative}.radio-temp>label{position:relative;margin-top:3px;z-index:1}.radio-temp>input{position:absolute;margin-left:-78px;margin-top:13px}input{appearance:none}\n"] }]
        }], ctorParameters: () => [{ type: TimeSelectorGroupComponent, decorators: [{
                    type: Inject,
                    args: [forwardRef(() => TimeSelectorGroupComponent)]
                }] }], propDecorators: { viewInput: [{
                type: ViewChild,
                args: ['viewInput']
            }], label: [{
                type: Input$1
            }], checked: [{
                type: Input$1
            }], value: [{
                type: Input$1
            }], name: [{
                type: Input$1
            }] } });

const COMPONENTS$u = [
    TimeSelectorComponent,
    TimeSelectorGroupComponent
];
const MODULES$x = [
    CommonModule,
    Grid
];
class TimeSelector {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TimeSelector, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: TimeSelector, declarations: [TimeSelectorComponent,
            TimeSelectorGroupComponent], imports: [CommonModule,
            Grid], exports: [TimeSelectorComponent,
            TimeSelectorGroupComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TimeSelector, imports: [MODULES$x] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TimeSelector, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$x],
                    declarations: [...COMPONENTS$u],
                    exports: [...COMPONENTS$u]
                }]
        }] });

let nextUniqueId$1 = 0;
class FileUploadComponent {
    get idStr() { return this._id; }
    set idStr(value) { this._id = value || this._uid; }
    // This is used to upload the file.
    uploadFile(fileList) {
        if (fileList[0].type === "") {
            this.announcer.announce('file not supported');
            this.message = 'Oops! We can’t attach this file type. Accepted file types include PDF, JPG, PNG, TIF or BMP.';
            return;
        }
        this.message = '';
        let combinedFileCount = this.files.length;
        if (this.fileToReplace === 12345) {
            combinedFileCount += fileList.length;
            this.announcer.announce('fileuploaded');
        }
        else {
            combinedFileCount += fileList.length - 1;
        }
        if (combinedFileCount == 3) {
            this.message =
                'You have successfully attached the maximum number of documents';
        }
        //To check the maximum file limit
        if (combinedFileCount > 3) {
            this.showMaxFileCount = true;
        }
        else {
            for (let i = 0; i < fileList.length; i++) {
                if (fileList[i].type == '') {
                    // alert('File type not supported');
                    // this.announcer.announce('file not supported');
                    return;
                }
                const fileinfo = {
                    file: fileList[i],
                    newName: fileList[i].name.replace(/\s/g, ''),
                    display: false,
                    imageUrl: ''
                };
                //to check the size of the file
                if (this.isTooLarge(fileList[i]))
                    alert(fileList[i].name + ' is over the limit');
                else {
                    if (this.fileToReplace == 12345) {
                        this.files.push(fileinfo);
                    }
                    else {
                        this.files[this.fileToReplace] = fileinfo;
                        this.titlename.nativeElement.focus();
                        this.announcer.announce('Replaced the File');
                        this.fileToReplace = 12345;
                    }
                }
            }
        }
        //To enable the submit and exit button when file are uploaded
        if (this.files.length > 0) {
            this.isSubmitOrExitEnabled = true;
        }
    }
    // To check the size of the file
    isTooLarge(file) {
        return file.size > 1048576;
    }
    //To preview the file
    preview(file) {
        if (!file) {
            return;
        }
        if (file.file.type.includes('image')) {
            file.display = !file.display;
            let reader = new FileReader();
            this.imagePath = file.file;
            reader.readAsDataURL(file.file);
            reader.onload = (_event) => {
                file.imageUrl = reader.result;
            };
            if (file.display) {
                this.announcer.announce('expanded preview ' + file.newName);
            }
            else {
                this.announcer.announce('collapsed preview ' + file.newName);
            }
        }
        else {
            this.announcer.announce('Preview not supported for this type of file');
            // TODO show message to user if file is not supported
            // alert('Preview not supported for this type of file');
        }
    }
    // To delete the file
    remove(index) {
        this.files.splice(index, 1);
    }
    //To display the delete modal
    confirmModal(i) {
        this.index = i;
        this.deleteModalId = 'deleteModalId' + i;
        this.showConfirmModal = true;
    }
    confirm() {
        this.remove(this.index);
        this.message = '';
        this.showConfirmModal = false;
        this.announcer.announce('filedeleted');
        timer(100).pipe(takeUntil(this.unsub$)).subscribe(() => {
            this.titlename.nativeElement.focus();
        });
    }
    // To focus the input when modal is closed
    onDeleteModalHide() {
        this.titlename.nativeElement.focus();
    }
    //To display the max file modal
    confirmMaxFile() {
        this.showMaxFileCount = true;
    }
    //To display the submit modal
    confirmSubmit() {
        this.showSubmitModal = true;
    }
    onSubmit() {
        this.SubmitButtonClicked.emit(this.files);
        this.files = [];
        this.isSubmitOrExitEnabled = false;
        this.message = '';
        this.showSubmitModal = false;
    }
    //To display the exit file modal
    confirmExit() {
        this.showExitModal = true;
    }
    exit() {
        this.ExitButtonClicked.emit(this.files);
        this.files = [];
        this.isSubmitOrExitEnabled = false;
        this.message = '';
        this.showExitModal = false;
    }
    //Lifecycle Hooks
    constructor(announcer) {
        this.announcer = announcer;
        // #region // ------------------         Properties              -------------------- //
        this.files = [];
        // This is always set to a random number
        // when a file is clicked for replacement, that is stored here
        // and the upload method checks for this variable and replaces it.
        this.fileToReplace = 12345;
        //To disable the submit and exit button
        this.isSubmitOrExitEnabled = false;
        // modal id
        this.deleteModalId = 'deleteModalId';
        // focus on title
        this.unsub$ = new Subject();
        /**
        * @property title
        * @description To define the title
        * @return string
       */
        this.title = 'Drag and Drop Files here';
        this._uid = `citi-fileupload-${nextUniqueId$1++}`;
        // #endregion
        // #region // ------------------         Outputs                 -------------------- //
        /**
        * @property SubmitButtonClicked
        * @description Emits when the submitbutton is clicked
        * @type: EventEmitter
        */
        this.SubmitButtonClicked = new EventEmitter();
        /**
        * @property ExitButtonClicked
        * @description Emits when the exitbutton is clicked
        * @type: EventEmitter
        */
        this.ExitButtonClicked = new EventEmitter();
    }
    announce(txt) {
        if (isDevMode()) {
            console.error('%cThe Common UI DDL FileUpload <citi-file-upload> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
        this.announcer.announce(txt);
    }
    ngOnDestroy() {
        this.unsub$.next();
        this.unsub$.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: FileUploadComponent, deps: [{ token: CitiLiveAnnouncer }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: FileUploadComponent, isStandalone: false, selector: "citi-file-upload", inputs: { accept: "accept", title: "title", idStr: "idStr" }, outputs: { SubmitButtonClicked: "SubmitButtonClicked", ExitButtonClicked: "ExitButtonClicked" }, viewQueries: [{ propertyName: "titlename", first: true, predicate: ["titlename"], descendants: true }], ngImport: i0, template: `
   <div
     class="uploadfilecontainer"
     (click)="fileInput.click()"
     fileDragDrop
     (onFileDropped)="uploadFile($event)"
  >
    <input
    hidden
    type="file"
    #fileInput
    (change)="uploadFile($event.target.files)"
    multiple="multiple"
    accept="{{accept}}"
    >

    <div class="title">
    <span #titlename (keydown.enter)="fileInput.click()" tabindex="0">{{title}}</span>
    </div>
  </div>

  <div class="files-list" *ngFor="let file of files; index as i">
    <img class="previewImg" [src]="file.imageUrl" height="300" *ngIf="file.display">
    <div class="test">
      <div class="filename">
        <span aria-describedby="fileInput"> {{ file.newName }} </span>
      </div>
      <div class="button">
        <button class="preview-file" (click)="preview(file)">
          <citi-icon2 shade="dark" name="006-search" size="large"></citi-icon2>
          Preview <span class="sr-only"> {{ file.newName }}</span>
        </button>

        <button
          class="replace-file"
          (click)="fileInput.click(); fileToReplace = i"
          >
          <citi-icon2 shade="dark" name="131-refresh" size="large"></citi-icon2>
          Replace <span class="sr-only"> {{ file.newName }}</span>
        </button>

        <button class="delete-file" (click)="confirmModal(i)" [attr.data-target]="'#deleteModalId'+i">
          <citi-icon2 shade="dark" name="156-trash" size="large"></citi-icon2>
          Delete <span class="sr-only"> {{ file.newName }}</span>
        </button>
      </div>
    </div>
  </div>

  <citi-modal
    cancelButtonText="Cancel"
    disablePrimaryButton="false"
    [idStr]="deleteModalId"
    primaryButtonText="Delete"
    showCancelButton="true"
    [title]="'Are you sure you want to delete the file?'"
    (primaryButtonClick)="confirm()"
    [(show)]="showConfirmModal">
    </citi-modal>

  <div class = message >{{message}}</div>

      <citi-modal
        [title]="'can upload only 3 files'"
        [(show)]="showMaxFileCount">
      </citi-modal>

      <!--
  <div class="notes">
    <p> Please note: Make sure you have attached the relevant information. </p>
  </div>
  -->

  <div>
    <citi-cta
      value="Submit form"
      type="primary"
      [disabled]="!isSubmitOrExitEnabled"
      (click)="confirmSubmit()"
      dataTarget="#submitModalId"
    >
    </citi-cta>

    <citi-modal
      cancelButtonText="Goback"
      disablePrimaryButton="false"
      [idStr]="'submitModalId'"
      primaryButtonText="Submit"
      showCancelButton="true"
      [title]="'Are you ready to Submit?'"
      (primaryButtonClick)="onSubmit()"
      [(show)]="showSubmitModal"
    >
    </citi-modal>

    <button
      class="btn btn-link"
      type="button"
      [disabled]="!isSubmitOrExitEnabled"
      (click)="confirmExit()"
      data-target="#exitModalId"
    >
    Exit
    </button>

    <citi-modal
      cancelButtonText="Go back"
      disablePrimaryButton="false"
      [idStr]="'exitModalId'"
      [title]="' Are you sure you want to Exit' "
      primaryButtonText="Exit"
      showCancelButton="true"
      (primaryButtonClick)="exit()"
      [(show)]="showExitModal"
    >
    </citi-modal>
  </div>
`, isInline: true, styles: [".uploadfilecontainer{height:200px;width:80%;margin:20px auto;border:2px dashed #1c8adb;border-radius:10px}.files-list{width:80%;margin:10px auto;background:#fff;border:1px solid;border-radius:12px;padding:5px;color:#1c8adb}.title{display:flex;align-items:center;justify-content:center;padding-top:80px;cursor:pointer}.title:hover{text-decoration:underline;color:#1c8adb}.filename{flex-grow:0;padding-top:20px;flex-basis:auto;overflow:hidden;white-space:nowrap}.filename p{overflow:hidden;text-overflow:ellipsis}.message{width:80%;margin:10px auto;background:#fff;padding:5px}.button{flex-grow:0;padding-top:10px;margin-bottom:10px;display:flex;flex-direction:row;align-items:center}.button button{margin-left:10px;white-space:nowrap;text-decoration:underline}.test{display:flex;justify-content:space-between}img.previewImg{display:block;margin-left:auto;margin-right:auto}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: CTAComponent, selector: "citi-cta", inputs: ["textAlign", "bold", "noMargin", "tabIndex", "ariaDescription", "ariaLabeledBy", "ariaHasPopup", "ariaRole", "ariaLabel", "ariaControls", "ariaExpanded", "router", "queryParams", "idStr", "dataTarget", "addJFPToken", "doNotAddJFPToken", "buttonType", "target", "href", "value", "disabled", "type", "size", "arrow", "leftArrow"], outputs: ["ctaClick", "disabledChange", "ctaFocus", "ctaBlur"] }, { kind: "component", type: ModalComponent, selector: "citi-modal", inputs: ["scrollable", "htmlContent", "ariaRole", "footerContent", "idStr", "title", "primaryButtonUrl", "primaryButtonTarget", "primaryButtonText", "showCancelButton", "footerProjection", "disablePrimaryButton", "disableCloseButton", "closeOnBgClick", "cancelButtonText", "openerSelector", "show", "closeButtonIdStr"], outputs: ["primaryButtonClick", "secondaryButtonClick", "closeButtonClick", "showChange", "onHide"] }, { kind: "component", type: Icon2Component, selector: "citi-icon2", inputs: ["role", "idStr", "ariaLabel", "ariaHidden", "size", "isHoverSfi", "includeCircle", "type", "svgStyle", "tabIndex", "shade", "name"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: FileUploadComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-file-upload', standalone: false, template: `
   <div
     class="uploadfilecontainer"
     (click)="fileInput.click()"
     fileDragDrop
     (onFileDropped)="uploadFile($event)"
  >
    <input
    hidden
    type="file"
    #fileInput
    (change)="uploadFile($event.target.files)"
    multiple="multiple"
    accept="{{accept}}"
    >

    <div class="title">
    <span #titlename (keydown.enter)="fileInput.click()" tabindex="0">{{title}}</span>
    </div>
  </div>

  <div class="files-list" *ngFor="let file of files; index as i">
    <img class="previewImg" [src]="file.imageUrl" height="300" *ngIf="file.display">
    <div class="test">
      <div class="filename">
        <span aria-describedby="fileInput"> {{ file.newName }} </span>
      </div>
      <div class="button">
        <button class="preview-file" (click)="preview(file)">
          <citi-icon2 shade="dark" name="006-search" size="large"></citi-icon2>
          Preview <span class="sr-only"> {{ file.newName }}</span>
        </button>

        <button
          class="replace-file"
          (click)="fileInput.click(); fileToReplace = i"
          >
          <citi-icon2 shade="dark" name="131-refresh" size="large"></citi-icon2>
          Replace <span class="sr-only"> {{ file.newName }}</span>
        </button>

        <button class="delete-file" (click)="confirmModal(i)" [attr.data-target]="'#deleteModalId'+i">
          <citi-icon2 shade="dark" name="156-trash" size="large"></citi-icon2>
          Delete <span class="sr-only"> {{ file.newName }}</span>
        </button>
      </div>
    </div>
  </div>

  <citi-modal
    cancelButtonText="Cancel"
    disablePrimaryButton="false"
    [idStr]="deleteModalId"
    primaryButtonText="Delete"
    showCancelButton="true"
    [title]="'Are you sure you want to delete the file?'"
    (primaryButtonClick)="confirm()"
    [(show)]="showConfirmModal">
    </citi-modal>

  <div class = message >{{message}}</div>

      <citi-modal
        [title]="'can upload only 3 files'"
        [(show)]="showMaxFileCount">
      </citi-modal>

      <!--
  <div class="notes">
    <p> Please note: Make sure you have attached the relevant information. </p>
  </div>
  -->

  <div>
    <citi-cta
      value="Submit form"
      type="primary"
      [disabled]="!isSubmitOrExitEnabled"
      (click)="confirmSubmit()"
      dataTarget="#submitModalId"
    >
    </citi-cta>

    <citi-modal
      cancelButtonText="Goback"
      disablePrimaryButton="false"
      [idStr]="'submitModalId'"
      primaryButtonText="Submit"
      showCancelButton="true"
      [title]="'Are you ready to Submit?'"
      (primaryButtonClick)="onSubmit()"
      [(show)]="showSubmitModal"
    >
    </citi-modal>

    <button
      class="btn btn-link"
      type="button"
      [disabled]="!isSubmitOrExitEnabled"
      (click)="confirmExit()"
      data-target="#exitModalId"
    >
    Exit
    </button>

    <citi-modal
      cancelButtonText="Go back"
      disablePrimaryButton="false"
      [idStr]="'exitModalId'"
      [title]="' Are you sure you want to Exit' "
      primaryButtonText="Exit"
      showCancelButton="true"
      (primaryButtonClick)="exit()"
      [(show)]="showExitModal"
    >
    </citi-modal>
  </div>
`, styles: [".uploadfilecontainer{height:200px;width:80%;margin:20px auto;border:2px dashed #1c8adb;border-radius:10px}.files-list{width:80%;margin:10px auto;background:#fff;border:1px solid;border-radius:12px;padding:5px;color:#1c8adb}.title{display:flex;align-items:center;justify-content:center;padding-top:80px;cursor:pointer}.title:hover{text-decoration:underline;color:#1c8adb}.filename{flex-grow:0;padding-top:20px;flex-basis:auto;overflow:hidden;white-space:nowrap}.filename p{overflow:hidden;text-overflow:ellipsis}.message{width:80%;margin:10px auto;background:#fff;padding:5px}.button{flex-grow:0;padding-top:10px;margin-bottom:10px;display:flex;flex-direction:row;align-items:center}.button button{margin-left:10px;white-space:nowrap;text-decoration:underline}.test{display:flex;justify-content:space-between}img.previewImg{display:block;margin-left:auto;margin-right:auto}\n"] }]
        }], ctorParameters: () => [{ type: CitiLiveAnnouncer }], propDecorators: { accept: [{
                type: Input$1
            }], title: [{
                type: Input$1
            }], idStr: [{
                type: Input$1
            }], SubmitButtonClicked: [{
                type: Output
            }], ExitButtonClicked: [{
                type: Output
            }], titlename: [{
                type: ViewChild,
                args: ['titlename']
            }] } });

const MODULES$w = [CommonModule, ContentHtml, CTA, Modal];
class FileUpload {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: FileUpload, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: FileUpload, declarations: [FileUploadComponent], imports: [CommonModule, ContentHtml, CTA, Modal, Icons2], exports: [FileUploadComponent, FileUploadComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: FileUpload, imports: [MODULES$w, Icons2] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: FileUpload, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$w, Icons2],
                    declarations: [
                        FileUploadComponent,
                        // DragDropDirective,
                    ],
                    exports: [FileUploadComponent, FileUploadComponent]
                }]
        }] });

class CitiPillarComponent {
    constructor(liveAnnouncer) {
        this.liveAnnouncer = liveAnnouncer;
        this.isSelected = false;
        /**
         * @property: onPillerClicked
         * @description emits when a pillar is clicked
         * @type: new EventEmitter<void>
         */
        this.onPillerClicked = new EventEmitter();
    }
    onclick() {
        this.onPillerClicked.emit();
    }
    /**
      * @property: onFocus
      * @description announces the selected pillar and it's selected state
      * @type: number
      */
    onFocus(isSelected, pillarName) {
        isSelected ?
            this.liveAnnouncer.announce(pillarName + ' selected.' + ' ' + this.getMessageToAnnounce) :
            this.liveAnnouncer.announce(pillarName);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CitiPillarComponent, deps: [{ token: CitiLiveAnnouncer }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: CitiPillarComponent, isStandalone: false, selector: "citi-pillar", inputs: { height: "height", pillarName: "pillarName", getMessageToAnnounce: "getMessageToAnnounce", getCustomStyles: "getCustomStyles", setBackgroundColor: "setBackgroundColor" }, outputs: { onPillerClicked: "onPillerClicked" }, host: { listeners: { "click": "onclick()" }, classAttribute: "citi-pillar" }, ngImport: i0, template: `
  <ng-content select=".topOfTheBar"></ng-content>
    <div
      class="bar"
      [ngStyle] = "getCustomStyles"
      [style.background-color] = "setBackgroundColor"
      [tabindex]= "isSelected ? 0 : -1"
      role="listitem"
      [attr.name]="pillarName"
      [attr.isSelected]= "isSelected"
      [class.active]="isSelected"
      [attr.aria-label]= "isSelected == true ? 'selected' : 'not selected'"
      [style.height.px] ="height"
      (focus)="onFocus(isSelected, pillarName)">
      <ng-content></ng-content>
    </div>
    <ng-content select=".bottomOfTheBar"></ng-content>
  `, isInline: true, styles: [":host{font-family:Interstate_Light,sans-serif;color:#fff;font-size:12px;letter-spacing:0px 14px}.bar{width:100%;order:0;flex:0 1 auto;text-align:center;position:relative;border:none;color:#333;background-color:#eee;border-radius:20px 0 0}.bar.active{background-color:#014c79}.bar.active .percentageNumber,.bar.active .percentageSymbol,.bar.active .apyText,.bar.active .amountRange{color:#fff}\n"], dependencies: [{ kind: "directive", type: i1$1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CitiPillarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-pillar', standalone: false, host: { class: 'citi-pillar' }, template: `
  <ng-content select=".topOfTheBar"></ng-content>
    <div
      class="bar"
      [ngStyle] = "getCustomStyles"
      [style.background-color] = "setBackgroundColor"
      [tabindex]= "isSelected ? 0 : -1"
      role="listitem"
      [attr.name]="pillarName"
      [attr.isSelected]= "isSelected"
      [class.active]="isSelected"
      [attr.aria-label]= "isSelected == true ? 'selected' : 'not selected'"
      [style.height.px] ="height"
      (focus)="onFocus(isSelected, pillarName)">
      <ng-content></ng-content>
    </div>
    <ng-content select=".bottomOfTheBar"></ng-content>
  `, styles: [":host{font-family:Interstate_Light,sans-serif;color:#fff;font-size:12px;letter-spacing:0px 14px}.bar{width:100%;order:0;flex:0 1 auto;text-align:center;position:relative;border:none;color:#333;background-color:#eee;border-radius:20px 0 0}.bar.active{background-color:#014c79}.bar.active .percentageNumber,.bar.active .percentageSymbol,.bar.active .apyText,.bar.active .amountRange{color:#fff}\n"] }]
        }], ctorParameters: () => [{ type: CitiLiveAnnouncer }], propDecorators: { height: [{
                type: Input$1
            }], pillarName: [{
                type: Input$1
            }], getMessageToAnnounce: [{
                type: Input$1
            }], getCustomStyles: [{
                type: Input$1
            }], setBackgroundColor: [{
                type: Input$1
            }], onPillerClicked: [{
                type: Output
            }], onclick: [{
                type: HostListener,
                args: ['click']
            }] } });

class CitiPillarsComponent {
    /**
     * @property: activePillar
     * @description binds to the index of the selected pillar
     * @type: number
     * @two-way: true
     */
    set activePillar(newIndex) {
        if (this._activePillar === newIndex)
            return;
        if (this.pillars)
            this.setActivePillar(newIndex);
        this._activePillar = newIndex;
    }
    get activePillar() {
        return this._activePillar;
    }
    constructor() {
        this.unsub$ = new Subject();
        this._activePillar = 0;
        this.activePillarChange = new EventEmitter();
        /**
         * @property: enableClickSelected
         * @description selects the pillar when it is clicked
         * @type: boolean
         * @two-way: false
         */
        this.enableClickSelected = false;
        if (isDevMode()) {
            console.error('%cThe Common UI DDL CitiPillars <citi-pillars> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    ngAfterContentInit() {
        setTimeout(() => {
            this.setActivePillar(this.activePillar);
            this.pillars.forEach((pillar, index) => pillar.onPillerClicked.pipe(takeUntil(this.unsub$), tap(() => {
                if (this.enableClickSelected)
                    this.activePillar = index;
            })).subscribe());
        }, 0);
    }
    ngOnDestroy() {
        this.unsub$.next();
        this.unsub$.complete();
    }
    setActivePillar(newIndex) {
        const pillars = this.pillars.toArray();
        pillars[this.activePillar].isSelected = false;
        pillars[newIndex].isSelected = true;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CitiPillarsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: CitiPillarsComponent, isStandalone: false, selector: "citi-pillars", inputs: { activePillar: "activePillar", enableClickSelected: "enableClickSelected" }, outputs: { activePillarChange: "activePillarChange" }, host: { classAttribute: "citi-pillars" }, queries: [{ propertyName: "pillars", predicate: CitiPillarComponent }], ngImport: i0, template: `
    <div class="pillarsWrapper" role="list">
      <ng-content></ng-content>
    </div>
    <ng-content select=".bottomContent"></ng-content>
    `, isInline: true, styles: [":host{display:block}.pillarsWrapper{height:auto;width:auto;display:inline-flex;flex-direction:row;flex-wrap:nowrap;justify-content:flex-start;align-content:center;align-items:flex-end}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CitiPillarsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-pillars', standalone: false, host: { class: 'citi-pillars' }, template: `
    <div class="pillarsWrapper" role="list">
      <ng-content></ng-content>
    </div>
    <ng-content select=".bottomContent"></ng-content>
    `, styles: [":host{display:block}.pillarsWrapper{height:auto;width:auto;display:inline-flex;flex-direction:row;flex-wrap:nowrap;justify-content:flex-start;align-content:center;align-items:flex-end}\n"] }]
        }], ctorParameters: () => [], propDecorators: { activePillar: [{
                type: Input$1
            }], activePillarChange: [{
                type: Output
            }], enableClickSelected: [{
                type: Input$1
            }], pillars: [{
                type: ContentChildren,
                args: [CitiPillarComponent, { descendants: false }]
            }] } });

const COMPONENTS$t = [
    CitiPillarsComponent,
    CitiPillarComponent
];
const MODULES$v = [
    CommonModule,
];
class CitiPillars {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CitiPillars, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: CitiPillars, declarations: [CitiPillarsComponent,
            CitiPillarComponent], imports: [CommonModule], exports: [CitiPillarsComponent,
            CitiPillarComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CitiPillars, imports: [MODULES$v] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CitiPillars, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [...COMPONENTS$t],
                    imports: [...MODULES$v],
                    exports: [CitiPillarsComponent,
                        CitiPillarComponent]
                }]
        }] });

let nextId$1 = 0;
/**
 * @Component: Tab
 * @Section: Navigation
 * @Description: This is the tab component and is used to create a tap panel in
 * a tab group.
 */
class TabComponent3 {
    constructor() {
        this.isActive = false;
        this.isFocused = false;
        this.isSelected = false;
        /**
         * emits when the mobile layout label is clicked
         */
        this.selectTabCall = new EventEmitter();
        this.selectTabFocusCall = new EventEmitter();
        this.tabIdNumber = nextId$1++;
        this.tabId = `tab-${this.tabIdNumber}`;
        this.keyboardFocused = false;
    }
    /**
     * Accordion Mobile Style Profile: emit index to parent TabGroup
     */
    selectTab(index) {
        this.selectTabCall.emit(index);
    }
    selectTabFocus(index) {
        this.selectTabFocusCall.emit(index);
    }
    stopBubble(event) {
        event.preventDefault();
        event.stopPropagation();
    }
    arrowNavigate(index) {
        if (this.manualActivation) {
            if (index == this.tabsLength) {
                this.selectTabFocus(0);
            }
            else if (index < 0) {
                this.selectTabFocus(this.tabsLength - 1);
            }
            else {
                this.selectTabFocus(index);
            }
        }
        else {
            if (index == this.tabsLength) {
                this.selectTab(0);
            }
            else if (index < 0) {
                this.selectTab(this.tabsLength - 1);
            }
            else {
                this.selectTab(index);
            }
        }
    }
    handleKeyPress(event) {
        if (event.key !== "Tab")
            this.stopBubble(event);
        let previousTabIdx = this.tabIdx - 1;
        let nextTabIdx = this.tabIdx + 1;
        switch (event.key) {
            case "ArrowUp":
                window.scrollBy(0, -50);
                break;
            case "ArrowDown":
                window.scrollBy(0, 50);
                break;
            case "ArrowLeft":
                this.arrowNavigate(previousTabIdx);
                break;
            case "ArrowRight":
                this.arrowNavigate(nextTabIdx);
                break;
            case " ":
            case "Enter":
                if (this.manualActivation)
                    this.selectTab(this.tabIdx);
                break;
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TabComponent3, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: TabComponent3, isStandalone: false, selector: "citi-tab3, [citi-tab3]", inputs: { label: "label" }, outputs: { selectTabCall: "selectTabCall", selectTabFocusCall: "selectTabFocusCall" }, host: { properties: { "class.tab-panel-active": "this.isActive" }, classAttribute: "citi-tab3" }, ngImport: i0, template: `
    <!-- tabs/tabs-dark style profile mobile layout -->
    <button
      *ngIf="
        ((styleProfile == 'tabs' || styleProfile == 'tabs-dark') ||
        (styleProfile == 'in-page-navigation' && tabsLength > 2) ||
        styleProfile == 'tabs-action-d1-95')
        && !mobileLayoutDisabled
        && mobileViewport
      "
      type="button"
      role="tab"
      [attr.id]="hostId + '-label-mobile-' + tabId"
      (click)="selectTab(this.tabIdx)"
      (keydown)="handleKeyPress($event)"
      class="hidden-sm hidden-md hidden-lg tabs-label-mobile"
      [ngClass]="{
        'tabs-dark': styleProfile == 'tabs-dark',
        'tab-label-mobile-active': isActive,
        'tab-mobile-focused': isFocused
      }"
      [attr.aria-selected]="isSelected"
      [attr.tabindex]="isSelected ? null : -1"
    >
      <citi-icon2
        [ngClass]="{ 'is-expanded': isSelected }"
        name="02-down"
        shade="b2"
        ariaLabel="icon"
        [ariaHidden]="true"
      >
      </citi-icon2>
      <span class="tab-label-content-mobile" [innerHtml]="label"></span>
    </button>
    <!-- End tabs/tabs-dark style profile mobile layout -->

    <!-- tabpanel content area for all style profiles -->
    <div
      role="tabpanel"
      [attr.id]="tabId"
      [attr.aria-labelledby]="hostId + '-' + tabId"
      [ngClass]="{
        tabs: styleProfile == 'tabs',
        'tabs-dark': styleProfile == 'tabs-dark',
        'in-page-navigation': styleProfile == 'in-page-navigation',
        'tabs-alt': styleProfile == 'tabs-alt',
        'tabs-action-d1-95': styleProfile == 'tabs-action-d1-95',
        'tab-panel-active': isActive
      }"
      class="tab-panel"
    >
      <ng-content></ng-content>
    </div>
  `, isInline: true, styles: [":host .tab-panel{background-color:#fff;display:none;position:relative;visibility:hidden;z-index:2}:host .tab-panel.tab-panel-active{display:block;visibility:visible}:host button{border:none;padding:0}:host .tabs-label-mobile{background-color:#eee;border-bottom:1px solid #999;color:#333;cursor:pointer;display:block;font-family:Interstate_Light,sans-serif;font-size:16px;font-size:1rem;line-height:22px;padding:19px 20px 19px 60px;text-align:left;transition:background-color .5s ease-in-out;width:100%}:host .tabs-label-mobile.tab-label-mobile-active{background-color:#fff;border:none;color:#056dae}:host citi-icon2.is-expanded ::ng-deep .sfi.b2-02-down{transform:rotate(180deg)}:host citi-icon2 ::ng-deep .sfi.b2-02-down{display:inline-block;position:absolute;transition:transform .4s ease-in-out;transform:rotate(0);transform-origin:50%}:host citi-icon2 ::ng-deep .sfi.medium{left:42px;height:8px;margin-top:7px}:host .tabs-dark.tab-panel{background-color:#eee}:host .tabs-label-mobile.tabs-dark{background-color:#fff}:host .tabs-label-mobile.tabs-dark.tab-label-mobile-active{color:#056dae;background-color:#eee}:host .tabs-action-d1-95.tab-panel{background-color:#eee}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: Icon2Component, selector: "citi-icon2", inputs: ["role", "idStr", "ariaLabel", "ariaHidden", "size", "isHoverSfi", "includeCircle", "type", "svgStyle", "tabIndex", "shade", "name"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TabComponent3, decorators: [{
            type: Component,
            args: [{ selector: 'citi-tab3, [citi-tab3]', standalone: false, template: `
    <!-- tabs/tabs-dark style profile mobile layout -->
    <button
      *ngIf="
        ((styleProfile == 'tabs' || styleProfile == 'tabs-dark') ||
        (styleProfile == 'in-page-navigation' && tabsLength > 2) ||
        styleProfile == 'tabs-action-d1-95')
        && !mobileLayoutDisabled
        && mobileViewport
      "
      type="button"
      role="tab"
      [attr.id]="hostId + '-label-mobile-' + tabId"
      (click)="selectTab(this.tabIdx)"
      (keydown)="handleKeyPress($event)"
      class="hidden-sm hidden-md hidden-lg tabs-label-mobile"
      [ngClass]="{
        'tabs-dark': styleProfile == 'tabs-dark',
        'tab-label-mobile-active': isActive,
        'tab-mobile-focused': isFocused
      }"
      [attr.aria-selected]="isSelected"
      [attr.tabindex]="isSelected ? null : -1"
    >
      <citi-icon2
        [ngClass]="{ 'is-expanded': isSelected }"
        name="02-down"
        shade="b2"
        ariaLabel="icon"
        [ariaHidden]="true"
      >
      </citi-icon2>
      <span class="tab-label-content-mobile" [innerHtml]="label"></span>
    </button>
    <!-- End tabs/tabs-dark style profile mobile layout -->

    <!-- tabpanel content area for all style profiles -->
    <div
      role="tabpanel"
      [attr.id]="tabId"
      [attr.aria-labelledby]="hostId + '-' + tabId"
      [ngClass]="{
        tabs: styleProfile == 'tabs',
        'tabs-dark': styleProfile == 'tabs-dark',
        'in-page-navigation': styleProfile == 'in-page-navigation',
        'tabs-alt': styleProfile == 'tabs-alt',
        'tabs-action-d1-95': styleProfile == 'tabs-action-d1-95',
        'tab-panel-active': isActive
      }"
      class="tab-panel"
    >
      <ng-content></ng-content>
    </div>
  `, host: {
                        class: 'citi-tab3'
                    }, styles: [":host .tab-panel{background-color:#fff;display:none;position:relative;visibility:hidden;z-index:2}:host .tab-panel.tab-panel-active{display:block;visibility:visible}:host button{border:none;padding:0}:host .tabs-label-mobile{background-color:#eee;border-bottom:1px solid #999;color:#333;cursor:pointer;display:block;font-family:Interstate_Light,sans-serif;font-size:16px;font-size:1rem;line-height:22px;padding:19px 20px 19px 60px;text-align:left;transition:background-color .5s ease-in-out;width:100%}:host .tabs-label-mobile.tab-label-mobile-active{background-color:#fff;border:none;color:#056dae}:host citi-icon2.is-expanded ::ng-deep .sfi.b2-02-down{transform:rotate(180deg)}:host citi-icon2 ::ng-deep .sfi.b2-02-down{display:inline-block;position:absolute;transition:transform .4s ease-in-out;transform:rotate(0);transform-origin:50%}:host citi-icon2 ::ng-deep .sfi.medium{left:42px;height:8px;margin-top:7px}:host .tabs-dark.tab-panel{background-color:#eee}:host .tabs-label-mobile.tabs-dark{background-color:#fff}:host .tabs-label-mobile.tabs-dark.tab-label-mobile-active{color:#056dae;background-color:#eee}:host .tabs-action-d1-95.tab-panel{background-color:#eee}\n"] }]
        }], ctorParameters: () => [], propDecorators: { isActive: [{
                type: HostBinding,
                args: ['class.tab-panel-active']
            }], label: [{
                type: Input$1
            }], selectTabCall: [{
                type: Output
            }], selectTabFocusCall: [{
                type: Output
            }] } });

let nextId = 0;
/**
 * @Component: Tab Group
 * @Section: Navigation
 * @Description: This tab group component creates a group
 * of selectable tabs with tab-label content sections.
 */
class TabGroupComponent3 {
    set activeTab(index) {
        if (Number(index) === this.activeTab)
            return;
        this._activeTab = Number(index);
        if (this.tabs && this.tabs.length)
            this.selectTab(this._activeTab);
    }
    get activeTab() {
        return this._activeTab;
    }
    /**
     * @Property: ariaLabel
     * @Description: Supplies the aria-label value for tablist
     * @Type: String
     */
    set ariaLabel(label) {
        if (typeof label !== 'undefined') {
            this._ariaLabel = label;
        }
    }
    /**
     * @Property: ariaLabelledby
     * @Description: Supplies the aria-labelledby value for tablist
     * @Type: String
     */
    set ariaLabelledby(label) {
        if (typeof label !== 'undefined') {
            this._ariaLabelledby = label;
        }
    }
    // #endregion
    // #region // ------- Constructor/Lifecycle Hooks -------- //
    constructor(el) {
        this.el = el;
        // #endregion
        // #region // -------- Inputs/Outputs ---------- //
        /**
         * @Property: activeTab
         * @Description: This defines the active tab of in page navigation
         * @Type: number
         */
        this._activeTab = 0;
        /**
         * @Property: focusedTab
         * @Description: This defines the focused tab of in page navigation
         * @Type: number
         */
        this.focusedTab = 0;
        /**
         * @Event: activeTabChanged
         * @Description: This event that is fired when a tab activates; returns the index of the active tab (first tab is 1)
         * @Return: Number
         */
        this.activeTabChange = new EventEmitter();
        /**
         * @Property: manualActivation
         * @Description: Enables manual activation of tabs with Space or Enter key when navigating with arrow keys.
         * @Type: String
         */
        this.manualActivation = false;
        this.hostId = `tabs-${nextId++}`;
    }
    ngAfterContentInit() {
        this.setInitial(this.activeTab);
        this.updateViewport();
        // Set Tab child(ren) component properties based on TabGroup @Inputs and properties
        this.tabs.forEach((tab, index) => {
            tab.tabIdx = index;
            tab.hostId = this.hostId;
            tab.styleProfile = this.styleProfile;
            tab.tabsLength = this.tabs.length;
            tab.mobileLayoutDisabled = this.mobileLayoutDisabled;
            tab.mobileViewport = this.mobileViewport;
            tab.manualActivation = this.manualActivation;
            // Subscribe to Tab child(ren) selectTabCall EventEmitter for Tabs mobile style profile tab select
            tab.selectTabCall.subscribe(tabIdx => {
                this.selectTabMobile(tabIdx);
            });
            tab.selectTabFocusCall.subscribe(tabIdx => {
                this.setTabFocusMobile(tabIdx);
            });
        });
    }
    onWindowResize() {
        this.updateViewport();
    }
    updateViewport() {
        this.screenWidth = window.innerWidth;
        if (this.screenWidth < 992) {
            this.mobileViewport = true;
            this.updateTabViewport(this.mobileViewport);
        }
        else {
            this.mobileViewport = false;
            this.updateTabViewport(this.mobileViewport);
        }
    }
    updateTabViewport(mobileV) {
        this.tabs.forEach(tab => tab.mobileViewport = mobileV);
    }
    // #endregion
    // #region // ------------ Methods ------------- //
    setInitial(index) {
        this.focusedTab = index;
        const tab = this.tab(index);
        tab.isFocused = tab.isActive = tab.isSelected = true;
    }
    unSelectAll() {
        this.tabs.forEach(tab => this.setActiveTab(tab, false));
    }
    tab(index) {
        return this.tabs.find((tab, i) => i === index);
    }
    setActiveTab(tab, bool = true) {
        tab.isActive = tab.isFocused = tab.isSelected = tab.keyboardFocused = bool;
    }
    focusActive() {
        setTimeout(() => this.el.nativeElement.querySelector('.tab-focused').focus(), 100);
    }
    currentTab() {
        return this.tabs.find(tab => tab.isActive);
    }
    selectTab(index) {
        this.unSelectAll();
        this.setActiveTab(this.tab(index));
        this.focusActive();
        this._activeTab = this.focusedTab = index;
        this.activeTabChange.emit(index);
    }
    clearFocus() {
        this.tabs.forEach(tab => (tab.isFocused = tab.keyboardFocused = false));
    }
    removeKeyboardFocus() {
        this.tabs.forEach(tab => (tab.keyboardFocused = false));
        this.tabs.forEach(tab => (tab.isFocused = false));
        this.focusedTab = this.activeTab;
    }
    moveFocus(dir) {
        this.setTabFocus((this.focusedTab + this.tabs.length + dir) % this.tabs.length);
    }
    setTabFocus(index) {
        this.clearFocus();
        this.tab(index).isFocused = true;
        this.focusActive();
        this.focusedTab = index;
    }
    stopBubble(event) {
        event.preventDefault();
        event.stopPropagation();
    }
    arrowNavigate(index, dir) {
        if (this.manualActivation) {
            this.moveFocus(dir);
        }
        else {
            if (index == this.tabs.length) {
                this.selectTab(0);
            }
            else if (index < 0) {
                this.selectTab(this.tabs.length - 1);
            }
            else {
                this.selectTab(index);
            }
        }
    }
    handleKeyPress(index, event) {
        if (event.key !== "Tab")
            this.stopBubble(event);
        let previousTabIdx = index - 1;
        let nextTabIdx = index + 1;
        switch (event.key) {
            case "Home":
                this.setTabFocus(0);
                break;
            case "End":
                this.setTabFocus(this.tabs.length - 1);
                break;
            case "ArrowLeft":
                this.arrowNavigate(previousTabIdx, -1);
                break;
            case "ArrowRight":
                this.arrowNavigate(nextTabIdx, 1);
                break;
            case " ":
            case "Enter":
                this.selectTab(this.focusedTab);
                break;
            case "Tab":
                this.removeKeyboardFocus();
        }
    }
    // #endregion
    // #region // ------------ Mobile Accordion Layout Methods ------------- //
    focusActiveMobile() {
        setTimeout(() => this.el.nativeElement.querySelector('.tab-mobile-focused').focus(), 100);
    }
    selectTabMobile(index) {
        this.unSelectAll();
        this.setActiveTab(this.tab(index));
        this._activeTab = this.focusedTab = index;
        this.activeTabChange.emit(index);
        setTimeout(() => this.el.nativeElement.querySelector('.tab-label-mobile-active').focus(), 100);
    }
    setTabFocusMobile(index) {
        this.clearFocus();
        this.tab(index).isFocused = true;
        this.focusActiveMobile();
        this.focusedTab = index;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TabGroupComponent3, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: TabGroupComponent3, isStandalone: false, selector: "citi-tab-group3", inputs: { activeTab: "activeTab", focusedTab: "focusedTab", ariaLabel: "ariaLabel", ariaLabelledby: "ariaLabelledby", tabSelectLabel: "tabSelectLabel", manualActivation: "manualActivation", styleProfile: "styleProfile", mobileLayoutDisabled: "mobileLayoutDisabled" }, outputs: { activeTabChange: "activeTabChange" }, host: { listeners: { "window:resize": "onWindowResize($event)" }, classAttribute: "citi-tab-group3" }, queries: [{ propertyName: "tabs", predicate: i0.forwardRef(() => TabComponent3) }], ngImport: i0, template: `
    <div [attr.id]="hostId">
      <div
        class="tab-header"
        [ngClass]="{
          tabs: styleProfile == 'tabs' || styleProfile == 'tabs-dark',
          'tabs-dark': styleProfile == 'tabs-dark',
          'in-page-navigation': styleProfile == 'in-page-navigation',
          'tabs-alt': styleProfile == 'tabs-alt',
          'tabs-action-d1-95': styleProfile == 'tabs-action-d1-95'
        }"
      >
        <div
          role="tablist"
          [class]="'tab-list tabs-' + tabs.length"
          [ngClass]="{
            'hidden-xs':
              !mobileLayoutDisabled &&
              ((styleProfile == 'in-page-navigation' && tabs.length > 2) ||
                styleProfile == 'tabs' ||
                styleProfile == 'tabs-dark' ||
                styleProfile == 'tabs-action-d1-95')
          }"
          [attr.aria-label]="_ariaLabel ? _ariaLabel : null"
          [attr.aria-labelledby]="_ariaLabelledby ? _ariaLabelledby : null"
        >
          <button
            *ngFor="let tab of tabs.toArray(); let idx = index"
            role="tab"
            type="button"
            [attr.id]="hostId + '-' + tab.tabId"
            [attr.tabindex]="tab.isActive ? 0 : -1"
            class="tab-label"
            [ngClass]="{
              'tab-label-active': tab.isActive,
              'tab-label-inactive':
                (styleProfile == 'tabs' || styleProfile == 'tabs-dark') &&
                !tab.isActive,
              'tab-focused': tab.isFocused,
              'tab-keyboard-focused': tab.keyboardFocused
            }"
            (click)="selectTab(idx)"
            (keydown)="handleKeyPress(idx, $event)"
            [attr.aria-selected]="tab.isSelected"
            [attr.aria-controls]="tab.tabId"
          >
            <span class="tab-label-content" [innerHtml]="tab.label"></span>
          </button>
        </div>
      </div>
      <!-- End tab header -->

      <!-- Tab content area for all style profiles -->
      <div
        [ngClass]="{ 'tabs-dark': styleProfile == 'tabs-dark' }"
        class="tab-content-wrapper"
        [attr.role]="mobileViewport && styleProfile != 'tabs-alt' ? 'tablist' : null"
        [attr.aria-labelledby]="_ariaLabelledby && mobileViewport && styleProfile != 'tabs-alt' ? _ariaLabelledby : null"
      >
        <ng-content></ng-content>
      </div>
    </div>
  `, isInline: true, styles: [":host .tab-content-wrapper{background-color:transparent;padding:0}.noPadding{padding:0}.tabs .tab-list{border-bottom:0}.tabs .tab-list button{border:none;padding:0}.tabs .tab-list .tab-label{background-color:#fff;border-radius:0;border-top:none;border-bottom:1px solid #999999;border-left:none;box-sizing:border-box;height:50px;line-height:normal;outline:none;position:relative;width:50%}.tabs .tab-list .tab-label .tab-label-content{color:#056dae;background-color:transparent;font-family:Interstate_Light,sans-serif,Arial,sans-serif;font-size:1rem;text-align:center}.tabs .tab-list .tab-label.tab-label-active{background-color:#fff;border-bottom:3px solid #056DAE}.tabs .tab-list .tab-label.tab-label-active .tab-label-content{color:#333}.tabs .tab-list .tab-label:focus{border-top:1px solid #333333;border-right:2px solid #333333;border-bottom:3px solid #056DAE;border-left:2px solid #333333}.tabs .tab-list .tab-label:focus .tab-label-content{border:2px solid rgb(36,116,214);border-radius:3px;padding:2px 4px}.tabs .tab-list .tab-label:hover .tab-label-content{padding:2px 4px;border:2px solid rgb(36,116,214);border-radius:3px}.tabs .tab-list .tab-label:not(:last-child):after{content:\"\";background-color:#eee;height:calc(100% + 3px);right:0;padding-right:10px;position:absolute;top:0;width:10px;z-index:3}.tabs .tab-list .tab-label:focus:not(:last-child):after{height:calc(100% - 1px)}.tabs .tab-list button:last-child{padding-right:0}.tabs .tab-list.tabs-3 .tab-label{width:33.33%}.tabs .tab-list.tabs-4 .tab-label{width:25%}.tabs .tab-list.tabs-5 .tab-label{width:20%}.tabs .tab-list.tabs-6 .tab-label{width:16.66%}.tabs .tab-list.tabs-6 .tab-label:not(:last-child):after{padding-right:5px;width:5px}.tabs .tab-list.tabs-7 .tab-label{width:14.27%}.tabs .tab-list.tabs-7 .tab-label:not(:last-child):after{padding-right:4px;width:4px}.tabs.tabs-dark .tab-list .tab-label{background-color:#eee}.tabs.tabs-dark .tab-list .tab-label.tab-label-active{border-bottom:3px solid #056DAE}.tabs.tabs-dark .tab-list .tab-label:focus{border-bottom:3px solid #056DAE}.tabs.tabs-dark .tab-list .tab-label:not(:last-child):after{background-color:#fff}.tabs-dark.tab-content-wrapper{background-color:#eee}.in-page-navigation .tab-list .tab-label{background-color:#eee;border-left:none;border-bottom:5px solid #FFFFFF;border-top:5px solid #FFFFFF;border-right:none;height:70px;line-height:24px;min-height:70px;outline:none;padding:10px;position:relative;width:50%}.in-page-navigation .tab-list .tab-label .tab-label-content{color:#056dae;background-color:transparent}.in-page-navigation .tab-list .tab-label .tab-label-content:hover{color:#333}.in-page-navigation .tab-list .tab-label.tab-label-active{background-color:#fff!important;border-top-color:transparent;border-bottom:5px solid #056DAE;box-shadow:0 0 5px 1px #33333340}.in-page-navigation .tab-list .tab-label.tab-label-active .tab-label-content{color:#333;background-color:transparent}.in-page-navigation .tab-list .tab-label:focus{border-top:5px solid #FFFFFF;border-right:2px solid #333333;border-bottom:5px solid #056DAE;border-left:2px solid #333333}.in-page-navigation .tab-list .tab-label:focus .tab-label-content{border:2px solid rgb(36,116,214);border-radius:3px;padding:2px 4px}.in-page-navigation .tab-list .tab-label:hover .tab-label-content{border:2px solid rgb(36,116,214);border-radius:3px;padding:2px 4px}@media (min-width: 992px){.in-page-navigation .tab-list .tab-label{font-size:21px;line-height:27px;min-height:90px;height:90px}}@media (max-width: 768px){.in-page-navigation .tab-list .tab-label{height:auto}}.in-page-navigation .tab-list .tab-label:not(:first-child):before{content:\"\";background-color:#767676;height:calc(100% - 20px);left:0;position:absolute;top:10%;width:1px;z-index:3}.in-page-navigation .tab-list .tab-label.tab-label-active+button:before,.in-page-navigation .tab-list .tab-label.tab-label-active:before{background-color:transparent}.in-page-navigation .tab-list.tabs-3 .tab-label{width:33.33%}.in-page-navigation .tab-list.tabs-4 .tab-label{width:25%}.in-page-navigation .tab-list.tabs-5 .tab-label{width:20%}.in-page-navigation .tab-list.tabs-6 .tab-label{width:16.66%}.in-page-navigation .tab-list.tabs-6 .tab-label:not(:last-child):after{padding-right:5px;width:5px}.in-page-navigation .tab-list.tabs-7 .tab-label{width:14.27%}.in-page-navigation .tab-list.tabs-7 .tab-label:not(:last-child):after{padding-right:4px;width:4px}.tabs-alt .tab-list{display:flex;border-bottom:1px solid rgba(0,0,0,.25)}.tabs-alt .tab-list .tab-label{flex:1 1 auto;background-color:#fff;border:none;padding:10px;font-size:1rem;height:auto;outline:none;min-height:auto;box-shadow:none}.tabs-alt .tab-list .tab-label .tab-label-content{color:#056dae;padding:6px}.tabs-alt .tab-list .tab-label .tab-label-content:hover{color:#056dae}.tabs-alt .tab-list .tab-label.tab-label-active{border-bottom:5px solid #056DAE;padding-bottom:5px;box-shadow:none}.tabs-alt .tab-list .tab-label.tab-label-active .tab-label-content,.tabs-alt .tab-list .tab-label.tab-label-active .tab-label-content:hover{color:#056dae}.tabs-alt .tab-list .tab-label:focus .tab-label-content{border:2px solid rgb(36,116,214);border-radius:3px;padding:2px 4px}.tabs-alt .tab-list .tab-label:hover .tab-label-content{padding:2px 4px;border:2px solid rgb(36,116,214);border-radius:3px}@media (min-width: 768px){.tabs-alt .tab-list .tab-label{padding-left:0;padding-right:0;flex:0 1 auto}.tabs-alt .tab-list .tab-label+.tab-label{margin-left:40px}}.tabs-action-d1-95 .tab-list{border-bottom:0}.tabs-action-d1-95 .tab-list button{border:none;padding:0}.tabs-action-d1-95 .tab-list .tab-label{background-color:#eee;border-bottom:1px solid rgba(0,0,0,.25);box-sizing:border-box;height:50px;outline:none;position:relative;line-height:normal;width:50%}.tabs-action-d1-95 .tab-list .tab-label .tab-label-content{color:#056dae;background-color:transparent;font-family:Interstate_Light,sans-serif,Arial,sans-serif;font-size:1rem;text-align:center}.tabs-action-d1-95 .tab-list .tab-label.tab-label-active{border-bottom:5px solid #056DAE}.tabs-action-d1-95 .tab-list .tab-label:focus{border-top:1px solid #333333;border-right:2px solid #333333;border-bottom:5px solid #056DAE;border-left:2px solid #333333}.tabs-action-d1-95 .tab-list .tab-label:focus .tab-label-content{border:2px solid rgb(36,116,214);border-radius:3px;padding:2px 4px}.tabs-action-d1-95 .tab-list .tab-label:hover .tab-label-content{padding:2px 4px;border:2px solid rgb(36,116,214);border-radius:3px}.tabs-action-d1-95 .tab-list.tabs-3 .tab-label{width:33.33%}.tabs-action-d1-95 .tab-list.tabs-4 .tab-label{width:25%}.tabs-action-d1-95 .tab-list.tabs-5 .tab-label{width:20%}.tabs-action-d1-95 .tab-list.tabs-6 .tab-label{width:16%}.tabs-action-d1-95 .tab-list.tabs-7 .tab-label{width:14%}.mobile-select-wrapper{background:#eee}.select-box-label{text-align:left}.action-module-mobile-select{background-color:#fff!important}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TabGroupComponent3, decorators: [{
            type: Component,
            args: [{ selector: 'citi-tab-group3', standalone: false, template: `
    <div [attr.id]="hostId">
      <div
        class="tab-header"
        [ngClass]="{
          tabs: styleProfile == 'tabs' || styleProfile == 'tabs-dark',
          'tabs-dark': styleProfile == 'tabs-dark',
          'in-page-navigation': styleProfile == 'in-page-navigation',
          'tabs-alt': styleProfile == 'tabs-alt',
          'tabs-action-d1-95': styleProfile == 'tabs-action-d1-95'
        }"
      >
        <div
          role="tablist"
          [class]="'tab-list tabs-' + tabs.length"
          [ngClass]="{
            'hidden-xs':
              !mobileLayoutDisabled &&
              ((styleProfile == 'in-page-navigation' && tabs.length > 2) ||
                styleProfile == 'tabs' ||
                styleProfile == 'tabs-dark' ||
                styleProfile == 'tabs-action-d1-95')
          }"
          [attr.aria-label]="_ariaLabel ? _ariaLabel : null"
          [attr.aria-labelledby]="_ariaLabelledby ? _ariaLabelledby : null"
        >
          <button
            *ngFor="let tab of tabs.toArray(); let idx = index"
            role="tab"
            type="button"
            [attr.id]="hostId + '-' + tab.tabId"
            [attr.tabindex]="tab.isActive ? 0 : -1"
            class="tab-label"
            [ngClass]="{
              'tab-label-active': tab.isActive,
              'tab-label-inactive':
                (styleProfile == 'tabs' || styleProfile == 'tabs-dark') &&
                !tab.isActive,
              'tab-focused': tab.isFocused,
              'tab-keyboard-focused': tab.keyboardFocused
            }"
            (click)="selectTab(idx)"
            (keydown)="handleKeyPress(idx, $event)"
            [attr.aria-selected]="tab.isSelected"
            [attr.aria-controls]="tab.tabId"
          >
            <span class="tab-label-content" [innerHtml]="tab.label"></span>
          </button>
        </div>
      </div>
      <!-- End tab header -->

      <!-- Tab content area for all style profiles -->
      <div
        [ngClass]="{ 'tabs-dark': styleProfile == 'tabs-dark' }"
        class="tab-content-wrapper"
        [attr.role]="mobileViewport && styleProfile != 'tabs-alt' ? 'tablist' : null"
        [attr.aria-labelledby]="_ariaLabelledby && mobileViewport && styleProfile != 'tabs-alt' ? _ariaLabelledby : null"
      >
        <ng-content></ng-content>
      </div>
    </div>
  `, host: {
                        class: 'citi-tab-group3'
                    }, styles: [":host .tab-content-wrapper{background-color:transparent;padding:0}.noPadding{padding:0}.tabs .tab-list{border-bottom:0}.tabs .tab-list button{border:none;padding:0}.tabs .tab-list .tab-label{background-color:#fff;border-radius:0;border-top:none;border-bottom:1px solid #999999;border-left:none;box-sizing:border-box;height:50px;line-height:normal;outline:none;position:relative;width:50%}.tabs .tab-list .tab-label .tab-label-content{color:#056dae;background-color:transparent;font-family:Interstate_Light,sans-serif,Arial,sans-serif;font-size:1rem;text-align:center}.tabs .tab-list .tab-label.tab-label-active{background-color:#fff;border-bottom:3px solid #056DAE}.tabs .tab-list .tab-label.tab-label-active .tab-label-content{color:#333}.tabs .tab-list .tab-label:focus{border-top:1px solid #333333;border-right:2px solid #333333;border-bottom:3px solid #056DAE;border-left:2px solid #333333}.tabs .tab-list .tab-label:focus .tab-label-content{border:2px solid rgb(36,116,214);border-radius:3px;padding:2px 4px}.tabs .tab-list .tab-label:hover .tab-label-content{padding:2px 4px;border:2px solid rgb(36,116,214);border-radius:3px}.tabs .tab-list .tab-label:not(:last-child):after{content:\"\";background-color:#eee;height:calc(100% + 3px);right:0;padding-right:10px;position:absolute;top:0;width:10px;z-index:3}.tabs .tab-list .tab-label:focus:not(:last-child):after{height:calc(100% - 1px)}.tabs .tab-list button:last-child{padding-right:0}.tabs .tab-list.tabs-3 .tab-label{width:33.33%}.tabs .tab-list.tabs-4 .tab-label{width:25%}.tabs .tab-list.tabs-5 .tab-label{width:20%}.tabs .tab-list.tabs-6 .tab-label{width:16.66%}.tabs .tab-list.tabs-6 .tab-label:not(:last-child):after{padding-right:5px;width:5px}.tabs .tab-list.tabs-7 .tab-label{width:14.27%}.tabs .tab-list.tabs-7 .tab-label:not(:last-child):after{padding-right:4px;width:4px}.tabs.tabs-dark .tab-list .tab-label{background-color:#eee}.tabs.tabs-dark .tab-list .tab-label.tab-label-active{border-bottom:3px solid #056DAE}.tabs.tabs-dark .tab-list .tab-label:focus{border-bottom:3px solid #056DAE}.tabs.tabs-dark .tab-list .tab-label:not(:last-child):after{background-color:#fff}.tabs-dark.tab-content-wrapper{background-color:#eee}.in-page-navigation .tab-list .tab-label{background-color:#eee;border-left:none;border-bottom:5px solid #FFFFFF;border-top:5px solid #FFFFFF;border-right:none;height:70px;line-height:24px;min-height:70px;outline:none;padding:10px;position:relative;width:50%}.in-page-navigation .tab-list .tab-label .tab-label-content{color:#056dae;background-color:transparent}.in-page-navigation .tab-list .tab-label .tab-label-content:hover{color:#333}.in-page-navigation .tab-list .tab-label.tab-label-active{background-color:#fff!important;border-top-color:transparent;border-bottom:5px solid #056DAE;box-shadow:0 0 5px 1px #33333340}.in-page-navigation .tab-list .tab-label.tab-label-active .tab-label-content{color:#333;background-color:transparent}.in-page-navigation .tab-list .tab-label:focus{border-top:5px solid #FFFFFF;border-right:2px solid #333333;border-bottom:5px solid #056DAE;border-left:2px solid #333333}.in-page-navigation .tab-list .tab-label:focus .tab-label-content{border:2px solid rgb(36,116,214);border-radius:3px;padding:2px 4px}.in-page-navigation .tab-list .tab-label:hover .tab-label-content{border:2px solid rgb(36,116,214);border-radius:3px;padding:2px 4px}@media (min-width: 992px){.in-page-navigation .tab-list .tab-label{font-size:21px;line-height:27px;min-height:90px;height:90px}}@media (max-width: 768px){.in-page-navigation .tab-list .tab-label{height:auto}}.in-page-navigation .tab-list .tab-label:not(:first-child):before{content:\"\";background-color:#767676;height:calc(100% - 20px);left:0;position:absolute;top:10%;width:1px;z-index:3}.in-page-navigation .tab-list .tab-label.tab-label-active+button:before,.in-page-navigation .tab-list .tab-label.tab-label-active:before{background-color:transparent}.in-page-navigation .tab-list.tabs-3 .tab-label{width:33.33%}.in-page-navigation .tab-list.tabs-4 .tab-label{width:25%}.in-page-navigation .tab-list.tabs-5 .tab-label{width:20%}.in-page-navigation .tab-list.tabs-6 .tab-label{width:16.66%}.in-page-navigation .tab-list.tabs-6 .tab-label:not(:last-child):after{padding-right:5px;width:5px}.in-page-navigation .tab-list.tabs-7 .tab-label{width:14.27%}.in-page-navigation .tab-list.tabs-7 .tab-label:not(:last-child):after{padding-right:4px;width:4px}.tabs-alt .tab-list{display:flex;border-bottom:1px solid rgba(0,0,0,.25)}.tabs-alt .tab-list .tab-label{flex:1 1 auto;background-color:#fff;border:none;padding:10px;font-size:1rem;height:auto;outline:none;min-height:auto;box-shadow:none}.tabs-alt .tab-list .tab-label .tab-label-content{color:#056dae;padding:6px}.tabs-alt .tab-list .tab-label .tab-label-content:hover{color:#056dae}.tabs-alt .tab-list .tab-label.tab-label-active{border-bottom:5px solid #056DAE;padding-bottom:5px;box-shadow:none}.tabs-alt .tab-list .tab-label.tab-label-active .tab-label-content,.tabs-alt .tab-list .tab-label.tab-label-active .tab-label-content:hover{color:#056dae}.tabs-alt .tab-list .tab-label:focus .tab-label-content{border:2px solid rgb(36,116,214);border-radius:3px;padding:2px 4px}.tabs-alt .tab-list .tab-label:hover .tab-label-content{padding:2px 4px;border:2px solid rgb(36,116,214);border-radius:3px}@media (min-width: 768px){.tabs-alt .tab-list .tab-label{padding-left:0;padding-right:0;flex:0 1 auto}.tabs-alt .tab-list .tab-label+.tab-label{margin-left:40px}}.tabs-action-d1-95 .tab-list{border-bottom:0}.tabs-action-d1-95 .tab-list button{border:none;padding:0}.tabs-action-d1-95 .tab-list .tab-label{background-color:#eee;border-bottom:1px solid rgba(0,0,0,.25);box-sizing:border-box;height:50px;outline:none;position:relative;line-height:normal;width:50%}.tabs-action-d1-95 .tab-list .tab-label .tab-label-content{color:#056dae;background-color:transparent;font-family:Interstate_Light,sans-serif,Arial,sans-serif;font-size:1rem;text-align:center}.tabs-action-d1-95 .tab-list .tab-label.tab-label-active{border-bottom:5px solid #056DAE}.tabs-action-d1-95 .tab-list .tab-label:focus{border-top:1px solid #333333;border-right:2px solid #333333;border-bottom:5px solid #056DAE;border-left:2px solid #333333}.tabs-action-d1-95 .tab-list .tab-label:focus .tab-label-content{border:2px solid rgb(36,116,214);border-radius:3px;padding:2px 4px}.tabs-action-d1-95 .tab-list .tab-label:hover .tab-label-content{padding:2px 4px;border:2px solid rgb(36,116,214);border-radius:3px}.tabs-action-d1-95 .tab-list.tabs-3 .tab-label{width:33.33%}.tabs-action-d1-95 .tab-list.tabs-4 .tab-label{width:25%}.tabs-action-d1-95 .tab-list.tabs-5 .tab-label{width:20%}.tabs-action-d1-95 .tab-list.tabs-6 .tab-label{width:16%}.tabs-action-d1-95 .tab-list.tabs-7 .tab-label{width:14%}.mobile-select-wrapper{background:#eee}.select-box-label{text-align:left}.action-module-mobile-select{background-color:#fff!important}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { tabs: [{
                type: ContentChildren,
                args: [forwardRef(() => TabComponent3), { descendants: false }]
            }], activeTab: [{
                type: Input$1
            }], focusedTab: [{
                type: Input$1
            }], activeTabChange: [{
                type: Output
            }], ariaLabel: [{
                type: Input$1
            }], ariaLabelledby: [{
                type: Input$1
            }], tabSelectLabel: [{
                type: Input$1
            }], manualActivation: [{
                type: Input$1
            }], styleProfile: [{
                type: Input$1
            }], mobileLayoutDisabled: [{
                type: Input$1
            }], onWindowResize: [{
                type: HostListener,
                args: ['window:resize', ['$event']]
            }] } });

const COMPONENTS$s = [TabGroupComponent3, TabComponent3];
const MODULES$u = [CommonModule, Icons2];
class Tab3 {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Tab3, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: Tab3, declarations: [TabGroupComponent3, TabComponent3], imports: [CommonModule, Icons2], exports: [TabGroupComponent3, TabComponent3] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Tab3, providers: [NAVIGATOR_PROVIDER], imports: [MODULES$u] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Tab3, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$u],
                    declarations: [...COMPONENTS$s],
                    providers: [NAVIGATOR_PROVIDER],
                    exports: [...COMPONENTS$s]
                }]
        }] });

class HeroComponent {
    /**
     * @property promoImageSrc
     * @description Sets the url string for the hero image source.
     * @return string
     */
    set promoImageSrc(promoImage) {
        this.promoImage = promoImage;
    }
    /**
     * @property legendText
     * @description Sets the text string to be displayed as the hero legend.
     * @return string
     */
    set legendText(legendText) {
        this.legend = legendText;
    }
    /**
     * @property heroType
     * @description Sets the hero type as defined in the DDL modules. Use only one of the available types.
     * The available types include the following: 'a-1-0', 'a-1-1', 'a-2-0', 'a-2-1', 'a-2-2', 'a-2-3', 'a-2-4',
     * 'a-2-5', 'a-2-6', 'a-3-0', 'a-3-1', 'a-4-0', 'a-4-1', 'a-4-2', 'a-4-3', 'a-4-4', 'a-4-5', 'a-4-6', 'a-4-7',
     * 'a-7-0', 'a-7-1'
     * @return string
     * @twoway false
     */
    set heroType(type) {
        this.type = type;
    }
    /**
     * @property eyebrowText
     * @description Sets the text string to be displayed as the hero eyebrow.
     * @return string
     */
    set eyebrowText(eyebrowText) {
        this.eyebrow = eyebrowText;
    }
    /**
     * @property subtitleText
     * @description Sets the text string to be displayed as the hero subtitle.
     * @return string
     */
    set subtitleText(subtitleText) {
        this.subtitle = subtitleText;
    }
    constructor(element, _sanitizer, zone, _document) {
        this.element = element;
        this._sanitizer = _sanitizer;
        this.zone = zone;
        this._document = _document;
        this.type = '';
        this.promoImage = '';
        this.shows = true;
        this.subtitle = '';
        this.eyebrowLevel = 2;
        this.eyebrowAriaLevel = 2;
        this.eyebrowStyle = 3;
        this.legendLevel = 2;
        this.legendAriaLevel = 2;
        this.legendStyle = 3;
    }
    getHHClass() {
        if (this.type === 'a-4-0' ||
            this.type === 'a-4-1' ||
            this.type === 'a-4-3' ||
            this.type === 'a-4-6' ||
            this.type === 'a-4-7' ||
            this.type === 'a-5-0') {
            return 'common-module-header';
        }
        else if (this.type === 'a-4-2' ||
            this.type === 'a-4-4' ||
            this.type === 'a-4-5') {
            return 'common-module-header-2';
        }
    }
    getStyles() {
        return this._sanitizer.bypassSecurityTrustStyle('left:' +
            -this.element.nativeElement.offsetLeft +
            'px; width:' +
            this._document.body.clientWidth +
            'px');
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: HeroComponent, deps: [{ token: i0.ElementRef }, { token: i1$2.DomSanitizer }, { token: i0.NgZone }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: HeroComponent, isStandalone: false, selector: "citi-hero:not(.4Q20)", inputs: { eyebrowLevel: "eyebrowLevel", eyebrowAriaLevel: "eyebrowAriaLevel", eyebrowStyle: "eyebrowStyle", legendLevel: "legendLevel", legendAriaLevel: "legendAriaLevel", legendStyle: "legendStyle", promoImageSrc: "promoImageSrc", legendText: "legendText", heroType: "heroType", eyebrowText: "eyebrowText", subtitleText: "subtitleText", htmlContent: "htmlContent", imageAltText: "imageAltText" }, host: { classAttribute: "citi-hero" }, ngImport: i0, template: `
    <section
      class="hero-a-1 sectionBleed"
      *ngIf="type == 'a-1-0' || type == 'a-1-1'"
      [attr.style]="getStyles()"
    >
      <div class="container-fluid">
        <div class="content-module">
          <div class="row">
            <div class="col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
              <div class="row">
                <div class="col-md-10 col-md-offset-1 text-center">
                  <h1
                    class="hero-title__a-1 header-1"
                    [innerHtml]="eyebrow"
                  ></h1>
                  <p *ngIf="legend" [innerHtml]="legend"></p>
                  <p></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section
      class="hero-a-1-2"
      *ngIf="type == 'a-1-2'"
      [attr.style]="getStyles()"
    >
      <div class="container-fluid">
        <div class="content-module_1_2">
          <div class="row">
            <div class="col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
              <div class="row">
                <div class="col-md-10 col-md-offset-1">
                  <h1
                    class="hero-title_a-1-2 header-1"
                    [innerHtml]="eyebrow"
                  ></h1>
                  <p
                    class="hero_a-1-2_text"
                    *ngIf="legend"
                    [innerHtml]="legend"
                  ></p>
                  <p></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section
      class="hero-a-2 sectionBleed"
      [attr.style]="getStyles()"
      *ngIf="
        type == 'a-2-0' ||
        type == 'a-2-1' ||
        type == 'a-2-2' ||
        type == 'a-2-3' ||
        type == 'a-2-4' ||
        type == 'a-2-7'
      "
    >
      <div class="hero-module-adjusted">
        <div
          role="presentation"
          class="hero-adjusted-image-wrapper promo-img-bg"
          *ngIf="!!promoImage"
          [attr.aria-label]="imageAltText"
          role="img"
          [style.background-image]="'url(' + promoImage + ')'"
        >
          <!-- <img src='{{promoImage}}' alt="{{imageAltText}}" class="adjusted-intro-image focal-sm-bottom" /> -->
        </div>
        <div class="hero-module-adjusted-floating-content">
          <div class="container-fluid">
            <div class="row">
              <div
                class="hero-adjusted-content-wrapper col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2"
              >
                <ng-content select="[content]"></ng-content>
                <ng-content select="[content2]"></ng-content>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ng-content select="[footer]"></ng-content>
    </section>
    <section
      class="hero-module-adjusted hero-a-2-card sectionBleed"
      [attr.style]="getStyles()"
      *ngIf="type == 'a-2-5' || type == 'a-2-6'"
    >
      <div
        role="presentation"
        class="hero-adjusted-image-wrapper promo-img-bg"
        [attr.aria-label]="imageAltText"
        role="img"
        [style.background-image]="'url(' + promoImage + ')'"
      >
        <!-- <img src='{{promoImage}}' alt="{{imageAltText}}" class="adjusted-intro-image focal-sm-bottom" /> -->
      </div>
      <div class="hero-module-adjusted-floating-content">
        <div class="container-fluid">
          <div class="row">
            <div
              class="hero-adjusted-content-wrapper col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2"
            >
              <ng-content select="[content3]"></ng-content>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section
      class="introduction introduction-top-level"
      [attr.style]="getStyles()"
      *ngIf="type == 'a-3-0' || type == 'a-3-1' || type == 'a-3-2'"
    >
      <div
        class="background-image-wrapper promo-img-bg"
        role="presentation"
        *ngIf="!!promoImage"
        [attr.aria-label]="imageAltText"
        role="img"
        [style.background-image]="'url(' + promoImage + ')'"
      ></div>
      <div [contentHtml]="htmlContent">
        <ng-content select="[content4]"></ng-content>
      </div>
    </section>
    <section
      class="hero-4 sectionBleed"
      [attr.style]="getStyles()"
      *ngIf="
        type == 'a-4-0' ||
        type == 'a-4-1' ||
        type == 'a-4-2' ||
        type == 'a-4-3' ||
        type == 'a-4-4' ||
        type == 'a-4-5' ||
        type == 'a-4-6' ||
        type == 'a-4-7'
      "
    >
      <header
        [ngClass]="getHHClass()"
        class="cross-link-header hero-4-header citi-brand"
      >
        <div class="container-fluid">
          <citi-text-header
            [level]="eyebrowLevel"
            [ariaLevel]="eyebrowAriaLevel"
            [style]="eyebrowStyle"
            class="hero-4-eyebrow"
            *ngIf="!!eyebrow"
            [htmlContent]="eyebrow"
          ></citi-text-header>
          <citi-text-header
            [level]="legendLevel"
            [ariaLevel]="legendAriaLevel"
            [style]="legendStyle"
            class="cross-link-heading"
            *ngIf="!!legend"
            [htmlContent]="legend"
          ></citi-text-header>
          <p *ngIf="!!subtitle" [innerHtml]="subtitle"></p>
        </div>
      </header>
      <div class="common-module-body container-fluid">
        <div class="cross-link-cards">
          <div class="hero-4-content" [contentHtml]="htmlContent">
            <ng-content select="[content5]"></ng-content>
          </div>
        </div>
      </div>
    </section>
    <section
      class="hero-a-2 sectionBleed"
      [attr.style]="getStyles()"
      *ngIf="type == 'a-2-8'"
    >
      <div class="hero-module-adjusted">
        <div
          role="presentation"
          class="hero-adjusted-image-wrapper promo-img-bg"
          [attr.aria-label]="imageAltText"
          role="img"
          [style.background-image]="'url(' + promoImage + ')'"
        >
          <!-- <img src="{{promoImage}}" alt="{{imageAlitText}}" class="adjusted-intro-image focal-sm-bottom" /> -->
        </div>
        <div class="hero-module-adjusted-floating-content">
          <div class="container-fluid">
            <div class="row">
              <div
                class="hero-adjusted-content-wrapper col-sm-6 col-sm-offset-6 col-md-5 col-md-offset-6 col-lg-4 col-lg-offset-7 col-xl-4"
              >
                <div class="row hero-adjusted-content">
                  <div class="col-md-10 col-md-offset-1 text-center">
                    <div class="hero-2-8-copy">
                      <ng-content select="[content6]"></ng-content>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section
      class="hero-5 sectionBleed"
      [attr.style]="getStyles()"
      *ngIf="type == 'a-5-0'"
    >
      <header
        [ngClass]="getHHClass()"
        class="common-module-header cross-link-header hero-5-header citi-brand"
      >
        <div class="container-fluid">
          <h1
            class="header-3 cross-link-heading"
            *ngIf="!!legend"
            [innerHTML]="legend"
          ></h1>
          <p *ngIf="!!subtitle" [innerHtml]="subtitle"></p>
        </div>
      </header>
    </section>
    <section class="hero-a-7-0" *ngIf="type == 'a-7-0'">
      <div class="container-fluid">
        <div class="content-module_7_0">
          <div class="row">
            <div class="col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
              <div class="row">
                <div class="col-md-5 col-md-offset-1 image-container">
                  <img
                    src="{{ promoImage }}"
                    class="img-responsive"
                    alt="{{ imageAltText }}"
                  />
                </div>
                <div class="col-md-5">
                  <h2
                    class="hero-title_a-7-0 header-2"
                    [innerHTML]="legend"
                  ></h2>
                </div>
              </div>
              <div class="row">
                <div class="col-md-10 col-md-offset-1">
                  <div class="a-7-border"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="hero-a-7-1" *ngIf="type == 'a-7-1'">
      <div class="container-fluid">
        <div class="content-module_7_1">
          <div class="row">
            <div class="col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
              <div class="row">
                <div class="col-md-5 col-md-offset-1 image-container">
                  <img
                    src="{{ promoImage }}"
                    class="img-responsive"
                    alt="{{ imageAltText }}"
                  />
                </div>
                <div class="col-md-5">
                  <h2
                    class="hero-title_a-7-1 header-2"
                    [innerHTML]="legend"
                  ></h2>
                  <div class="attribution-line-content">
                    <p class="attribution-line" [innerHtml]="subtitle"></p>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-10 col-md-offset-1">
                  <div class="a-7-border"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  `, isInline: true, styles: [".sectionBleed{position:relative}@media (min-width: 768px) and (max-width: 991px){.hero-2-8-copy ::ng-deep h2{font-size:42px}}.promo-img-bg{background-repeat:no-repeat;background-position:center center;background-size:cover}.hero-module-adjusted-floating-content{z-index:1}.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h1,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h2,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h3,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h4,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h5,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h6{color:#fff;font-size:1.625rem;line-height:2rem;-webkit-font-smoothing:antialiased;margin-bottom:10px;margin-top:40px}.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h1 sup,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h1 .super-script,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h2 sup,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h2 .super-script,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h3 sup,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h3 .super-script,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h4 sup,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h4 .super-script,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h5 sup,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h5 .super-script,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h6 sup,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h6 .super-script{font-size:1.625rem}.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h1,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h2,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h3,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h4,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h5,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h6{color:#fff;-webkit-font-smoothing:antialiased;margin-bottom:25px;font-size:4.25rem;line-height:4.75rem;font-weight:400}.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h1 sup,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h1 .super-script,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h2 sup,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h2 .super-script,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h3 sup,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h3 .super-script,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h4 sup,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h4 .super-script,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h5 sup,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h5 .super-script,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h6 sup,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h6 .super-script{font-size:4.25rem}:host .introduction ::ng-deep .a-3-introduction-content,:host .introduction ::ng-deep .hero-3-2-introduction-content{margin:280px 0 10px}@media (min-width: 991px){:host .introduction ::ng-deep .a-3-introduction-content,:host .introduction ::ng-deep .hero-3-2-introduction-content{margin-bottom:40px}}.a-3-img-wrapper img{max-height:320px;width:100%;object-fit:cover}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }, { kind: "component", type: TextHeaderComponent, selector: "citi-text-header", inputs: ["ariaLevel", "level", "style", "bold", "class", "html", "ariaRole", "htmlContent"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: HeroComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-hero:not(.4Q20)', standalone: false, host: { class: 'citi-hero' }, template: `
    <section
      class="hero-a-1 sectionBleed"
      *ngIf="type == 'a-1-0' || type == 'a-1-1'"
      [attr.style]="getStyles()"
    >
      <div class="container-fluid">
        <div class="content-module">
          <div class="row">
            <div class="col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
              <div class="row">
                <div class="col-md-10 col-md-offset-1 text-center">
                  <h1
                    class="hero-title__a-1 header-1"
                    [innerHtml]="eyebrow"
                  ></h1>
                  <p *ngIf="legend" [innerHtml]="legend"></p>
                  <p></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section
      class="hero-a-1-2"
      *ngIf="type == 'a-1-2'"
      [attr.style]="getStyles()"
    >
      <div class="container-fluid">
        <div class="content-module_1_2">
          <div class="row">
            <div class="col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
              <div class="row">
                <div class="col-md-10 col-md-offset-1">
                  <h1
                    class="hero-title_a-1-2 header-1"
                    [innerHtml]="eyebrow"
                  ></h1>
                  <p
                    class="hero_a-1-2_text"
                    *ngIf="legend"
                    [innerHtml]="legend"
                  ></p>
                  <p></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section
      class="hero-a-2 sectionBleed"
      [attr.style]="getStyles()"
      *ngIf="
        type == 'a-2-0' ||
        type == 'a-2-1' ||
        type == 'a-2-2' ||
        type == 'a-2-3' ||
        type == 'a-2-4' ||
        type == 'a-2-7'
      "
    >
      <div class="hero-module-adjusted">
        <div
          role="presentation"
          class="hero-adjusted-image-wrapper promo-img-bg"
          *ngIf="!!promoImage"
          [attr.aria-label]="imageAltText"
          role="img"
          [style.background-image]="'url(' + promoImage + ')'"
        >
          <!-- <img src='{{promoImage}}' alt="{{imageAltText}}" class="adjusted-intro-image focal-sm-bottom" /> -->
        </div>
        <div class="hero-module-adjusted-floating-content">
          <div class="container-fluid">
            <div class="row">
              <div
                class="hero-adjusted-content-wrapper col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2"
              >
                <ng-content select="[content]"></ng-content>
                <ng-content select="[content2]"></ng-content>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ng-content select="[footer]"></ng-content>
    </section>
    <section
      class="hero-module-adjusted hero-a-2-card sectionBleed"
      [attr.style]="getStyles()"
      *ngIf="type == 'a-2-5' || type == 'a-2-6'"
    >
      <div
        role="presentation"
        class="hero-adjusted-image-wrapper promo-img-bg"
        [attr.aria-label]="imageAltText"
        role="img"
        [style.background-image]="'url(' + promoImage + ')'"
      >
        <!-- <img src='{{promoImage}}' alt="{{imageAltText}}" class="adjusted-intro-image focal-sm-bottom" /> -->
      </div>
      <div class="hero-module-adjusted-floating-content">
        <div class="container-fluid">
          <div class="row">
            <div
              class="hero-adjusted-content-wrapper col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2"
            >
              <ng-content select="[content3]"></ng-content>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section
      class="introduction introduction-top-level"
      [attr.style]="getStyles()"
      *ngIf="type == 'a-3-0' || type == 'a-3-1' || type == 'a-3-2'"
    >
      <div
        class="background-image-wrapper promo-img-bg"
        role="presentation"
        *ngIf="!!promoImage"
        [attr.aria-label]="imageAltText"
        role="img"
        [style.background-image]="'url(' + promoImage + ')'"
      ></div>
      <div [contentHtml]="htmlContent">
        <ng-content select="[content4]"></ng-content>
      </div>
    </section>
    <section
      class="hero-4 sectionBleed"
      [attr.style]="getStyles()"
      *ngIf="
        type == 'a-4-0' ||
        type == 'a-4-1' ||
        type == 'a-4-2' ||
        type == 'a-4-3' ||
        type == 'a-4-4' ||
        type == 'a-4-5' ||
        type == 'a-4-6' ||
        type == 'a-4-7'
      "
    >
      <header
        [ngClass]="getHHClass()"
        class="cross-link-header hero-4-header citi-brand"
      >
        <div class="container-fluid">
          <citi-text-header
            [level]="eyebrowLevel"
            [ariaLevel]="eyebrowAriaLevel"
            [style]="eyebrowStyle"
            class="hero-4-eyebrow"
            *ngIf="!!eyebrow"
            [htmlContent]="eyebrow"
          ></citi-text-header>
          <citi-text-header
            [level]="legendLevel"
            [ariaLevel]="legendAriaLevel"
            [style]="legendStyle"
            class="cross-link-heading"
            *ngIf="!!legend"
            [htmlContent]="legend"
          ></citi-text-header>
          <p *ngIf="!!subtitle" [innerHtml]="subtitle"></p>
        </div>
      </header>
      <div class="common-module-body container-fluid">
        <div class="cross-link-cards">
          <div class="hero-4-content" [contentHtml]="htmlContent">
            <ng-content select="[content5]"></ng-content>
          </div>
        </div>
      </div>
    </section>
    <section
      class="hero-a-2 sectionBleed"
      [attr.style]="getStyles()"
      *ngIf="type == 'a-2-8'"
    >
      <div class="hero-module-adjusted">
        <div
          role="presentation"
          class="hero-adjusted-image-wrapper promo-img-bg"
          [attr.aria-label]="imageAltText"
          role="img"
          [style.background-image]="'url(' + promoImage + ')'"
        >
          <!-- <img src="{{promoImage}}" alt="{{imageAlitText}}" class="adjusted-intro-image focal-sm-bottom" /> -->
        </div>
        <div class="hero-module-adjusted-floating-content">
          <div class="container-fluid">
            <div class="row">
              <div
                class="hero-adjusted-content-wrapper col-sm-6 col-sm-offset-6 col-md-5 col-md-offset-6 col-lg-4 col-lg-offset-7 col-xl-4"
              >
                <div class="row hero-adjusted-content">
                  <div class="col-md-10 col-md-offset-1 text-center">
                    <div class="hero-2-8-copy">
                      <ng-content select="[content6]"></ng-content>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section
      class="hero-5 sectionBleed"
      [attr.style]="getStyles()"
      *ngIf="type == 'a-5-0'"
    >
      <header
        [ngClass]="getHHClass()"
        class="common-module-header cross-link-header hero-5-header citi-brand"
      >
        <div class="container-fluid">
          <h1
            class="header-3 cross-link-heading"
            *ngIf="!!legend"
            [innerHTML]="legend"
          ></h1>
          <p *ngIf="!!subtitle" [innerHtml]="subtitle"></p>
        </div>
      </header>
    </section>
    <section class="hero-a-7-0" *ngIf="type == 'a-7-0'">
      <div class="container-fluid">
        <div class="content-module_7_0">
          <div class="row">
            <div class="col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
              <div class="row">
                <div class="col-md-5 col-md-offset-1 image-container">
                  <img
                    src="{{ promoImage }}"
                    class="img-responsive"
                    alt="{{ imageAltText }}"
                  />
                </div>
                <div class="col-md-5">
                  <h2
                    class="hero-title_a-7-0 header-2"
                    [innerHTML]="legend"
                  ></h2>
                </div>
              </div>
              <div class="row">
                <div class="col-md-10 col-md-offset-1">
                  <div class="a-7-border"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="hero-a-7-1" *ngIf="type == 'a-7-1'">
      <div class="container-fluid">
        <div class="content-module_7_1">
          <div class="row">
            <div class="col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
              <div class="row">
                <div class="col-md-5 col-md-offset-1 image-container">
                  <img
                    src="{{ promoImage }}"
                    class="img-responsive"
                    alt="{{ imageAltText }}"
                  />
                </div>
                <div class="col-md-5">
                  <h2
                    class="hero-title_a-7-1 header-2"
                    [innerHTML]="legend"
                  ></h2>
                  <div class="attribution-line-content">
                    <p class="attribution-line" [innerHtml]="subtitle"></p>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-10 col-md-offset-1">
                  <div class="a-7-border"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  `, styles: [".sectionBleed{position:relative}@media (min-width: 768px) and (max-width: 991px){.hero-2-8-copy ::ng-deep h2{font-size:42px}}.promo-img-bg{background-repeat:no-repeat;background-position:center center;background-size:cover}.hero-module-adjusted-floating-content{z-index:1}.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h1,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h2,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h3,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h4,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h5,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h6{color:#fff;font-size:1.625rem;line-height:2rem;-webkit-font-smoothing:antialiased;margin-bottom:10px;margin-top:40px}.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h1 sup,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h1 .super-script,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h2 sup,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h2 .super-script,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h3 sup,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h3 .super-script,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h4 sup,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h4 .super-script,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h5 sup,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h5 .super-script,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h6 sup,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h6 .super-script{font-size:1.625rem}.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h1,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h2,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h3,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h4,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h5,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h6{color:#fff;-webkit-font-smoothing:antialiased;margin-bottom:25px;font-size:4.25rem;line-height:4.75rem;font-weight:400}.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h1 sup,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h1 .super-script,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h2 sup,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h2 .super-script,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h3 sup,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h3 .super-script,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h4 sup,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h4 .super-script,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h5 sup,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h5 .super-script,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h6 sup,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h6 .super-script{font-size:4.25rem}:host .introduction ::ng-deep .a-3-introduction-content,:host .introduction ::ng-deep .hero-3-2-introduction-content{margin:280px 0 10px}@media (min-width: 991px){:host .introduction ::ng-deep .a-3-introduction-content,:host .introduction ::ng-deep .hero-3-2-introduction-content{margin-bottom:40px}}.a-3-img-wrapper img{max-height:320px;width:100%;object-fit:cover}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i1$2.DomSanitizer }, { type: i0.NgZone }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }], propDecorators: { eyebrowLevel: [{
                type: Input$1
            }], eyebrowAriaLevel: [{
                type: Input$1
            }], eyebrowStyle: [{
                type: Input$1
            }], legendLevel: [{
                type: Input$1
            }], legendAriaLevel: [{
                type: Input$1
            }], legendStyle: [{
                type: Input$1
            }], promoImageSrc: [{
                type: Input$1
            }], legendText: [{
                type: Input$1
            }], heroType: [{
                type: Input$1
            }], eyebrowText: [{
                type: Input$1
            }], subtitleText: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }], imageAltText: [{
                type: Input$1
            }] } });

class HeroComponent4Q20 {
    set roleInput(role) {
        this.role = role;
    }
    /**
     * @property promoImageSrc
     * @description Sets the url string for the hero image source.
     * @return string
     */
    set promoImageSrc(promoImage) {
        this.promoImage = promoImage;
    }
    /**
     * @property legendText
     * @description Sets the text string to be displayed as the hero legend.
     * @return string
     */
    set legendText(legendText) {
        this.legend = legendText;
    }
    /**
     * @property heroType
     * @description Sets the hero type as defined in the DDL modules. Use only one of the available types.
     * The available types include the following: 'a-1-0', 'a-1-1', 'a-2-0', 'a-2-1', 'a-2-2', 'a-2-3', 'a-2-4',
     * 'a-2-5', 'a-2-6', 'a-3-0', 'a-3-1', 'a-4-0', 'a-4-1', 'a-4-2', 'a-4-3', 'a-4-4', 'a-4-5', 'a-4-6', 'a-4-7',
     * 'a-7-0', 'a-7-1'
     * @return string
     * @twoway false
     */
    set heroType(type) {
        this.type = type;
    }
    /**
     * @property eyebrowText
     * @description Sets the text string to be displayed as the hero eyebrow.
     * @return string
     */
    set eyebrowText(eyebrowText) {
        this.eyebrow = eyebrowText;
    }
    /**
     * @property subtitleText
     * @description Sets the text string to be displayed as the hero subtitle.
     * @return string
     */
    set subtitleText(subtitleText) {
        this.subtitle = subtitleText;
    }
    // #endregion
    // #region ---------- Constructor / Lifecycle Hooks ---------- //
    constructor(element, _doc) {
        this.element = element;
        this._doc = _doc;
        // #region ---------- Properties ---------- //
        this.type = '';
        this.promoImage = '';
        this.shows = true;
        this.subtitle = '';
        this._destroyUnsub$ = new Subject();
        // #endregion
        // #region ---------- @Inputs ---------- //
        this.eyebrowLevel = 2;
        this.eyebrowAriaLevel = 2;
        this.eyebrowStyle = 3;
        this.legendLevel = 2;
        this.legendAriaLevel = 2;
        this.legendStyle = 3;
        //roleInput can be img or presentation
        this.role = 'img';
        this._document = this._doc;
        this._window = this._document?.defaultView;
    }
    ngAfterViewInit() {
        this._heroStyles = this.getHeroStyles();
        // will update hero styles upon window resize
        fromEvent(this._window, 'resize')
            .pipe(takeUntil$1(this._destroyUnsub$), debounceTime$1(200))
            .subscribe(e => {
            this._heroStyles = this.getHeroStyles();
        });
    }
    ngOnDestroy() {
        this._destroyUnsub$.next();
        this._destroyUnsub$.complete();
    }
    // #endregion
    // #region ---------- Methods ---------- //
    getHHClass() {
        if (this.type === 'a-4-0' ||
            this.type === 'a-4-1' ||
            this.type === 'a-4-3' ||
            this.type === 'a-4-6' ||
            this.type === 'a-4-7' ||
            this.type === 'a-5-0') {
            return 'common-module-header';
        }
        else if (this.type === 'a-4-2' ||
            this.type === 'a-4-4' ||
            this.type === 'a-4-5') {
            return 'common-module-header-2';
        }
    }
    getHeroStyles() {
        return {
            'left.px': -this.element.nativeElement.offsetLeft,
            'width.px': this._document.body.clientWidth
        };
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: HeroComponent4Q20, deps: [{ token: i0.ElementRef }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: HeroComponent4Q20, isStandalone: false, selector: "citi-hero.4Q20", inputs: { eyebrowLevel: "eyebrowLevel", eyebrowAriaLevel: "eyebrowAriaLevel", eyebrowStyle: "eyebrowStyle", legendLevel: "legendLevel", legendAriaLevel: "legendAriaLevel", legendStyle: "legendStyle", roleInput: "roleInput", promoImageSrc: "promoImageSrc", legendText: "legendText", heroType: "heroType", eyebrowText: "eyebrowText", subtitleText: "subtitleText", htmlContent: "htmlContent", imageAltText: "imageAltText" }, host: { classAttribute: "citi-hero" }, ngImport: i0, template: `
    <section
      class="hero-a-1 sectionBleed"
      *ngIf="type == 'a-1-0' || type == 'a-1-1'"
      [ngStyle]="_heroStyles"
    >
      <div class="container-fluid">
        <div class="content-module">
          <div class="row">
            <div class="col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
              <div class="row">
                <div class="col-md-10 col-md-offset-1 text-center">
                  <h1
                    class="hero-title__a-1 header-1"
                    [innerHtml]="eyebrow"
                  ></h1>
                  <p *ngIf="legend" [innerHtml]="legend"></p>
                  <p></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section
      class="hero-a-1-2"
      *ngIf="type == 'a-1-2'"
      [ngStyle]="_heroStyles"
    >
      <div class="container-fluid">
        <div class="content-module_1_2">
          <div class="row">
            <div class="col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
              <div class="row">
                <div class="col-md-10 col-md-offset-1">
                  <h1
                    class="hero-title_a-1-2 header-1"
                    [innerHtml]="eyebrow"
                  ></h1>
                  <p
                    class="hero_a-1-2_text"
                    *ngIf="legend"
                    [innerHtml]="legend"
                  ></p>
                  <p></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section
      class="hero-a-2 sectionBleed"
      [ngStyle]="_heroStyles"
      *ngIf="
        type == 'a-2-0' ||
        type == 'a-2-1' ||
        type == 'a-2-2' ||
        type == 'a-2-3' ||
        type == 'a-2-4' ||
        type == 'a-2-7'
      "
    >
      <div class="hero-module-adjusted">
        <div
          class="hero-adjusted-image-wrapper promo-img-bg"
          role="presentation"
          *ngIf="role == 'presentation'"
        ></div>
        <div
          class="hero-adjusted-image-wrapper promo-img-bg"
          *ngIf="!!promoImage && role == 'img'"
        >
          <img src="{{ promoImage }}" alt="" role="img" />
        </div>
        <div class="hero-module-adjusted-floating-content">
          <div class="container-fluid">
            <div class="row">
              <div
                class="hero-adjusted-content-wrapper col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2"
              >
                <ng-content select="[content]"></ng-content>
                <ng-content select="[content2]"></ng-content>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ng-content select="[footer]"></ng-content>
    </section>
    <section
      class="hero-module-adjusted hero-a-2-card sectionBleed"
      [ngStyle]="_heroStyles"
      *ngIf="type == 'a-2-5' || type == 'a-2-6'"
    >
      <div
        class="hero-adjusted-image-wrapper promo-img-bg"
        role="presentation"
        *ngIf="role == 'presentation'"
      ></div>
      <div
        class="hero-adjusted-image-wrapper promo-img-bg"
        *ngIf="!!promoImage && role == 'img'"
      >
        <img src="{{ promoImage }}" alt="" role="img" />
      </div>
      <div class="hero-module-adjusted-floating-content">
        <div class="container-fluid">
          <div class="row">
            <div
              class="hero-adjusted-content-wrapper col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2"
            >
              <ng-content select="[content3]"></ng-content>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section
      class="introduction introduction-top-level"
      [ngStyle]="_heroStyles"
      *ngIf="type == 'a-3-0' || type == 'a-3-1' || type == 'a-3-2'"
    >
      <div
        class="hero-adjusted-image-wrapper promo-img-bg"
        role="presentation"
        *ngIf="role == 'presentation'"
      ></div>
      <div
        class="hero-adjusted-image-wrapper promo-img-bg a-3-img-wrapper"
        *ngIf="!!promoImage && role == 'img'"
      >
        <img src="{{ promoImage }}" alt="" role="img" />
      </div>
      <div [contentHtml]="htmlContent">
        <ng-content select="[content4]"></ng-content>
      </div>
    </section>
    <section
      class="hero-4 sectionBleed"
      [ngStyle]="_heroStyles"
      *ngIf="
        type == 'a-4-0' ||
        type == 'a-4-1' ||
        type == 'a-4-2' ||
        type == 'a-4-3' ||
        type == 'a-4-4' ||
        type == 'a-4-5' ||
        type == 'a-4-6' ||
        type == 'a-4-7'
      "
    >
      <header
        [ngClass]="getHHClass()"
        class="cross-link-header hero-4-header citi-brand"
      >
        <div class="container-fluid">
          <div  *ngIf="!!eyebrow" [ngClass]="eyebrowLevel ? 'header-'+eyebrowLevel : null" [style]="eyebrowStyle"  class="hero-4-eyebrow" [innerHTML]="eyebrow"> </div>
          <citi-text-header
            [level]="1"
            [ariaLevel]="1"
            [style]="legendStyle"
            class="cross-link-heading header-2"
            *ngIf="!!legend"
            [htmlContent]="legend"
          ></citi-text-header>
          <p *ngIf="!!subtitle" [innerHtml]="subtitle"></p>
        </div>
      </header>
      <div class="common-module-body container-fluid">
        <div class="cross-link-cards">
          <div class="hero-4-content" [contentHtml]="htmlContent">
            <ng-content select="[content5]"></ng-content>
          </div>
        </div>
      </div>
    </section>
    <section
      class="hero-a-2 sectionBleed"
      [ngStyle]="_heroStyles"
      *ngIf="type == 'a-2-8'"
    >
      <div class="hero-module-adjusted">
        <div
          class="hero-adjusted-image-wrapper promo-img-bg"
          role="presentation"
          *ngIf="role == 'presentation'"
        ></div>
        <div
          class="hero-adjusted-image-wrapper promo-img-bg"
          *ngIf="!!promoImage && role == 'img'"
        >
          <img src="{{ promoImage }}" alt="" role="img" />
        </div>
        <div class="hero-module-adjusted-floating-content">
          <div class="container-fluid">
            <div class="row">
              <div
                class="hero-adjusted-content-wrapper col-sm-6 col-sm-offset-6 col-md-5 col-md-offset-6 col-lg-4 col-lg-offset-7 col-xl-4"
              >
                <div class="row hero-adjusted-content">
                  <div class="col-md-10 col-md-offset-1 text-center">
                    <div class="hero-2-8-copy">
                      <ng-content select="[content6]"></ng-content>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section
      class="hero-5 sectionBleed"
      [ngStyle]="_heroStyles"
      *ngIf="type == 'a-5-0'"
    >
      <header
        [ngClass]="getHHClass()"
        class="common-module-header cross-link-header hero-5-header citi-brand"
      >
        <div class="container-fluid">
          <h1
            class="header-3 cross-link-heading"
            *ngIf="!!legend"
            [innerHTML]="legend"
          ></h1>
          <p *ngIf="!!subtitle" [innerHtml]="subtitle"></p>
        </div>
      </header>
    </section>
    <section class="hero-a-7-0" *ngIf="type == 'a-7-0'">
      <div class="container-fluid">
        <div class="content-module_7_0">
          <div class="row">
            <div class="col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
              <div class="row">
                <div class="col-md-5 col-md-offset-1 image-container">
                  <img
                    src="{{ promoImage }}"
                    class="img-responsive"
                    alt=""
                  />
                </div>
                <div class="col-md-5">
                  <h1
                    class="hero-title_a-7-0 header-2"
                    [innerHTML]="legend"
                  ></h1>
                </div>
              </div>
              <div class="row">
                <div class="col-md-10 col-md-offset-1">
                  <div class="a-7-border"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="hero-a-7-1" *ngIf="type == 'a-7-1'">
      <div class="container-fluid">
        <div class="content-module_7_1">
          <div class="row">
            <div class="col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
              <div class="row">
                <div class="col-md-5 col-md-offset-1 image-container">
                  <img
                    src="{{ promoImage }}"
                    class="img-responsive"
                    alt=""
                  />
                </div>
                <div class="col-md-5">
                  <h1
                    class="hero-title_a-7-1 header-2"
                    [innerHTML]="legend"
                  ></h1>
                  <div class="attribution-line-content">
                    <p class="attribution-line" [innerHtml]="subtitle"></p>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-10 col-md-offset-1">
                  <div class="a-7-border"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  `, isInline: true, styles: [".sectionBleed{position:relative}@media (min-width: 768px) and (max-width: 991px){.hero-2-8-copy ::ng-deep h2{font-size:42px}}.promo-img-bg{background-repeat:no-repeat;background-position:center center;background-size:cover}.hero-module-adjusted-floating-content{z-index:1}.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h1,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h2,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h3,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h4,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h5,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h6{color:#fff;font-size:1.625rem;line-height:2rem;-webkit-font-smoothing:antialiased;margin-bottom:10px;margin-top:40px}.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h1 sup,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h1 .super-script,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h2 sup,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h2 .super-script,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h3 sup,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h3 .super-script,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h4 sup,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h4 .super-script,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h5 sup,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h5 .super-script,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h6 sup,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h6 .super-script{font-size:1.625rem}.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h1,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h2,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h3,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h4,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h5,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h6{color:#fff;-webkit-font-smoothing:antialiased;margin-bottom:25px;font-size:4.25rem;line-height:4.75rem;font-weight:400}.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h1 sup,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h1 .super-script,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h2 sup,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h2 .super-script,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h3 sup,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h3 .super-script,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h4 sup,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h4 .super-script,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h5 sup,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h5 .super-script,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h6 sup,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h6 .super-script{font-size:4.25rem}:host .introduction ::ng-deep .a-3-introduction-content,:host .introduction ::ng-deep .hero-3-2-introduction-content{margin:-40px 0 10px}@media (min-width: 991px){:host .introduction ::ng-deep .a-3-introduction-content,:host .introduction ::ng-deep .hero-3-2-introduction-content{margin-bottom:40px}}.a-3-img-wrapper img{max-height:320px;width:100%;object-fit:cover}.hero-a-2-card ::ng-deep .right-col-inner__a-2 citi-cta a{color:#056dae}.hero-module-adjusted ::ng-deep .form-group{margin-bottom:15px!important}.hero-module-adjusted ::ng-deep .form-group .btn-primary{margin-top:0}@media only screen and (min-width: 480px) and (max-width: 1190px){.hero-module-adjusted ::ng-deep .btn-primary{min-width:170px;margin-right:0}}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }, { kind: "component", type: TextHeaderComponent, selector: "citi-text-header", inputs: ["ariaLevel", "level", "style", "bold", "class", "html", "ariaRole", "htmlContent"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: HeroComponent4Q20, decorators: [{
            type: Component,
            args: [{ selector: 'citi-hero.4Q20', standalone: false, host: { class: 'citi-hero' }, template: `
    <section
      class="hero-a-1 sectionBleed"
      *ngIf="type == 'a-1-0' || type == 'a-1-1'"
      [ngStyle]="_heroStyles"
    >
      <div class="container-fluid">
        <div class="content-module">
          <div class="row">
            <div class="col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
              <div class="row">
                <div class="col-md-10 col-md-offset-1 text-center">
                  <h1
                    class="hero-title__a-1 header-1"
                    [innerHtml]="eyebrow"
                  ></h1>
                  <p *ngIf="legend" [innerHtml]="legend"></p>
                  <p></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section
      class="hero-a-1-2"
      *ngIf="type == 'a-1-2'"
      [ngStyle]="_heroStyles"
    >
      <div class="container-fluid">
        <div class="content-module_1_2">
          <div class="row">
            <div class="col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
              <div class="row">
                <div class="col-md-10 col-md-offset-1">
                  <h1
                    class="hero-title_a-1-2 header-1"
                    [innerHtml]="eyebrow"
                  ></h1>
                  <p
                    class="hero_a-1-2_text"
                    *ngIf="legend"
                    [innerHtml]="legend"
                  ></p>
                  <p></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section
      class="hero-a-2 sectionBleed"
      [ngStyle]="_heroStyles"
      *ngIf="
        type == 'a-2-0' ||
        type == 'a-2-1' ||
        type == 'a-2-2' ||
        type == 'a-2-3' ||
        type == 'a-2-4' ||
        type == 'a-2-7'
      "
    >
      <div class="hero-module-adjusted">
        <div
          class="hero-adjusted-image-wrapper promo-img-bg"
          role="presentation"
          *ngIf="role == 'presentation'"
        ></div>
        <div
          class="hero-adjusted-image-wrapper promo-img-bg"
          *ngIf="!!promoImage && role == 'img'"
        >
          <img src="{{ promoImage }}" alt="" role="img" />
        </div>
        <div class="hero-module-adjusted-floating-content">
          <div class="container-fluid">
            <div class="row">
              <div
                class="hero-adjusted-content-wrapper col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2"
              >
                <ng-content select="[content]"></ng-content>
                <ng-content select="[content2]"></ng-content>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ng-content select="[footer]"></ng-content>
    </section>
    <section
      class="hero-module-adjusted hero-a-2-card sectionBleed"
      [ngStyle]="_heroStyles"
      *ngIf="type == 'a-2-5' || type == 'a-2-6'"
    >
      <div
        class="hero-adjusted-image-wrapper promo-img-bg"
        role="presentation"
        *ngIf="role == 'presentation'"
      ></div>
      <div
        class="hero-adjusted-image-wrapper promo-img-bg"
        *ngIf="!!promoImage && role == 'img'"
      >
        <img src="{{ promoImage }}" alt="" role="img" />
      </div>
      <div class="hero-module-adjusted-floating-content">
        <div class="container-fluid">
          <div class="row">
            <div
              class="hero-adjusted-content-wrapper col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2"
            >
              <ng-content select="[content3]"></ng-content>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section
      class="introduction introduction-top-level"
      [ngStyle]="_heroStyles"
      *ngIf="type == 'a-3-0' || type == 'a-3-1' || type == 'a-3-2'"
    >
      <div
        class="hero-adjusted-image-wrapper promo-img-bg"
        role="presentation"
        *ngIf="role == 'presentation'"
      ></div>
      <div
        class="hero-adjusted-image-wrapper promo-img-bg a-3-img-wrapper"
        *ngIf="!!promoImage && role == 'img'"
      >
        <img src="{{ promoImage }}" alt="" role="img" />
      </div>
      <div [contentHtml]="htmlContent">
        <ng-content select="[content4]"></ng-content>
      </div>
    </section>
    <section
      class="hero-4 sectionBleed"
      [ngStyle]="_heroStyles"
      *ngIf="
        type == 'a-4-0' ||
        type == 'a-4-1' ||
        type == 'a-4-2' ||
        type == 'a-4-3' ||
        type == 'a-4-4' ||
        type == 'a-4-5' ||
        type == 'a-4-6' ||
        type == 'a-4-7'
      "
    >
      <header
        [ngClass]="getHHClass()"
        class="cross-link-header hero-4-header citi-brand"
      >
        <div class="container-fluid">
          <div  *ngIf="!!eyebrow" [ngClass]="eyebrowLevel ? 'header-'+eyebrowLevel : null" [style]="eyebrowStyle"  class="hero-4-eyebrow" [innerHTML]="eyebrow"> </div>
          <citi-text-header
            [level]="1"
            [ariaLevel]="1"
            [style]="legendStyle"
            class="cross-link-heading header-2"
            *ngIf="!!legend"
            [htmlContent]="legend"
          ></citi-text-header>
          <p *ngIf="!!subtitle" [innerHtml]="subtitle"></p>
        </div>
      </header>
      <div class="common-module-body container-fluid">
        <div class="cross-link-cards">
          <div class="hero-4-content" [contentHtml]="htmlContent">
            <ng-content select="[content5]"></ng-content>
          </div>
        </div>
      </div>
    </section>
    <section
      class="hero-a-2 sectionBleed"
      [ngStyle]="_heroStyles"
      *ngIf="type == 'a-2-8'"
    >
      <div class="hero-module-adjusted">
        <div
          class="hero-adjusted-image-wrapper promo-img-bg"
          role="presentation"
          *ngIf="role == 'presentation'"
        ></div>
        <div
          class="hero-adjusted-image-wrapper promo-img-bg"
          *ngIf="!!promoImage && role == 'img'"
        >
          <img src="{{ promoImage }}" alt="" role="img" />
        </div>
        <div class="hero-module-adjusted-floating-content">
          <div class="container-fluid">
            <div class="row">
              <div
                class="hero-adjusted-content-wrapper col-sm-6 col-sm-offset-6 col-md-5 col-md-offset-6 col-lg-4 col-lg-offset-7 col-xl-4"
              >
                <div class="row hero-adjusted-content">
                  <div class="col-md-10 col-md-offset-1 text-center">
                    <div class="hero-2-8-copy">
                      <ng-content select="[content6]"></ng-content>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section
      class="hero-5 sectionBleed"
      [ngStyle]="_heroStyles"
      *ngIf="type == 'a-5-0'"
    >
      <header
        [ngClass]="getHHClass()"
        class="common-module-header cross-link-header hero-5-header citi-brand"
      >
        <div class="container-fluid">
          <h1
            class="header-3 cross-link-heading"
            *ngIf="!!legend"
            [innerHTML]="legend"
          ></h1>
          <p *ngIf="!!subtitle" [innerHtml]="subtitle"></p>
        </div>
      </header>
    </section>
    <section class="hero-a-7-0" *ngIf="type == 'a-7-0'">
      <div class="container-fluid">
        <div class="content-module_7_0">
          <div class="row">
            <div class="col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
              <div class="row">
                <div class="col-md-5 col-md-offset-1 image-container">
                  <img
                    src="{{ promoImage }}"
                    class="img-responsive"
                    alt=""
                  />
                </div>
                <div class="col-md-5">
                  <h1
                    class="hero-title_a-7-0 header-2"
                    [innerHTML]="legend"
                  ></h1>
                </div>
              </div>
              <div class="row">
                <div class="col-md-10 col-md-offset-1">
                  <div class="a-7-border"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="hero-a-7-1" *ngIf="type == 'a-7-1'">
      <div class="container-fluid">
        <div class="content-module_7_1">
          <div class="row">
            <div class="col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
              <div class="row">
                <div class="col-md-5 col-md-offset-1 image-container">
                  <img
                    src="{{ promoImage }}"
                    class="img-responsive"
                    alt=""
                  />
                </div>
                <div class="col-md-5">
                  <h1
                    class="hero-title_a-7-1 header-2"
                    [innerHTML]="legend"
                  ></h1>
                  <div class="attribution-line-content">
                    <p class="attribution-line" [innerHtml]="subtitle"></p>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-10 col-md-offset-1">
                  <div class="a-7-border"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  `, styles: [".sectionBleed{position:relative}@media (min-width: 768px) and (max-width: 991px){.hero-2-8-copy ::ng-deep h2{font-size:42px}}.promo-img-bg{background-repeat:no-repeat;background-position:center center;background-size:cover}.hero-module-adjusted-floating-content{z-index:1}.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h1,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h2,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h3,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h4,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h5,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h6{color:#fff;font-size:1.625rem;line-height:2rem;-webkit-font-smoothing:antialiased;margin-bottom:10px;margin-top:40px}.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h1 sup,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h1 .super-script,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h2 sup,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h2 .super-script,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h3 sup,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h3 .super-script,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h4 sup,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h4 .super-script,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h5 sup,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h5 .super-script,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h6 sup,.hero-4 .common-module-header-2 .hero-4-eyebrow ::ng-deep h6 .super-script{font-size:1.625rem}.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h1,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h2,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h3,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h4,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h5,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h6{color:#fff;-webkit-font-smoothing:antialiased;margin-bottom:25px;font-size:4.25rem;line-height:4.75rem;font-weight:400}.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h1 sup,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h1 .super-script,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h2 sup,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h2 .super-script,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h3 sup,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h3 .super-script,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h4 sup,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h4 .super-script,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h5 sup,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h5 .super-script,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h6 sup,.hero-4 .common-module-header-2 .cross-link-heading ::ng-deep h6 .super-script{font-size:4.25rem}:host .introduction ::ng-deep .a-3-introduction-content,:host .introduction ::ng-deep .hero-3-2-introduction-content{margin:-40px 0 10px}@media (min-width: 991px){:host .introduction ::ng-deep .a-3-introduction-content,:host .introduction ::ng-deep .hero-3-2-introduction-content{margin-bottom:40px}}.a-3-img-wrapper img{max-height:320px;width:100%;object-fit:cover}.hero-a-2-card ::ng-deep .right-col-inner__a-2 citi-cta a{color:#056dae}.hero-module-adjusted ::ng-deep .form-group{margin-bottom:15px!important}.hero-module-adjusted ::ng-deep .form-group .btn-primary{margin-top:0}@media only screen and (min-width: 480px) and (max-width: 1190px){.hero-module-adjusted ::ng-deep .btn-primary{min-width:170px;margin-right:0}}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }], propDecorators: { eyebrowLevel: [{
                type: Input$1
            }], eyebrowAriaLevel: [{
                type: Input$1
            }], eyebrowStyle: [{
                type: Input$1
            }], legendLevel: [{
                type: Input$1
            }], legendAriaLevel: [{
                type: Input$1
            }], legendStyle: [{
                type: Input$1
            }], roleInput: [{
                type: Input$1
            }], promoImageSrc: [{
                type: Input$1
            }], legendText: [{
                type: Input$1
            }], heroType: [{
                type: Input$1
            }], eyebrowText: [{
                type: Input$1
            }], subtitleText: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }], imageAltText: [{
                type: Input$1
            }] } });

const COMPONENTS$r = [HeroComponent, HeroComponent4Q20];
const MODULES$t = [CommonModule, ContentHtml, TextHeader];
class Hero {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Hero, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: Hero, declarations: [HeroComponent, HeroComponent4Q20], imports: [CommonModule, ContentHtml, TextHeader], exports: [HeroComponent, HeroComponent4Q20] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Hero, imports: [MODULES$t] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Hero, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$t],
                    declarations: [...COMPONENTS$r],
                    exports: [...COMPONENTS$r]
                }]
        }] });

/**
 * @Component: Terms and Conditions
 * @Section: Forms
 * @description This component generates a terms and conditions section
 */
class ShowcaseChildComponent {
    ngOnInit() { }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ShowcaseChildComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: ShowcaseChildComponent, isStandalone: false, selector: "citi-showcase-child", inputs: { headerText: "headerText", bodyText: "bodyText", imageUrl: "imageUrl", ctaText: "ctaText", href: "href" }, ngImport: i0, template: `
    <div class="col-sm-4 tile">
        <img src="{{imageUrl}}" alt="">
        <h2 class="header-5 normal-case"><strong [innerHtml]="headerText"></strong></h2>
        <p [innerHtml]='bodyText'></p>
        <a href="{{href}}" class="chevron-link bold" *ngIf="ctaText"><strong [innerHtml]="ctaText"></strong></a>
    </div>
`, isInline: true, dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ShowcaseChildComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'citi-showcase-child',
                    standalone: false,
                    template: `
    <div class="col-sm-4 tile">
        <img src="{{imageUrl}}" alt="">
        <h2 class="header-5 normal-case"><strong [innerHtml]="headerText"></strong></h2>
        <p [innerHtml]='bodyText'></p>
        <a href="{{href}}" class="chevron-link bold" *ngIf="ctaText"><strong [innerHtml]="ctaText"></strong></a>
    </div>
`
                }]
        }], propDecorators: { headerText: [{
                type: Input$1
            }], bodyText: [{
                type: Input$1
            }], imageUrl: [{
                type: Input$1
            }], ctaText: [{
                type: Input$1
            }], href: [{
                type: Input$1
            }] } });

/**
 * @Component: Showcase
 * @Section: Modules
 * @Description: This component generates the showcase module (Module G)
 */
class ShowcaseComponent {
    constructor() {
        /**
         * @Property: headerLevel
         * @Description: Header level for the showcase
         * @Type: string
         */
        this.headerLevel = 1;
        /**
         * @Property: type
         * @Description: Specifies the type of showcase you would like.  Type numbers match the DDL Style Guide.
         * @Type: string ('g-1-0', 'g-1-1', 'g-1-2', 'g-1-3', 'g-1-4', 'g-2-0', 'g-2-1', 'g-2-2', 'g-3-0', 'g-3-1', 'g-3-2' (default), etc...)
         */
        this.type = 'g-1-4';
        /**
         * @Property: imageSide
         * @Description: Specifies the side you would like the image displayed on for the g-3 module
         * If the type is g-3-2 this defines the first image side and the second will be the opposite
         * @Type: string ('left' (default) or 'right')
         */
        this.imageSide = 'left';
        /**
         * @Property: iconUrl
         * @Description: Specifies the src for the icon image in the  g-1-1 module
         * @Type: string (url)
         */
        this.iconUrl = '';
        /**
         * @Property: htmlContent
         * @Description: Adds the given string as the content and supports simple HTML.
         * Do not pass anything within the component tags using ng-content. Do not use citi-* components in the String.
         * This works with expressions for asynchronously loaded content that will get
         * picked up by the Angular 2 change detection.
         * @Type: string
         * @Two-way: false
         */
        this.htmlContent = null;
        /**
         * @Property: htmlContent2
         * @Description: Adds the given string as the content and supports simple HTML.
         * Do not pass anything within the component tags using ng-content. Do not use citi-* components in the String.
         * This works with expressions for asynchronously loaded content that will get
         * picked up by the Angular 2 change detection.
         * @Type: string
         * @Two-way: false
         */
        this.htmlContent2 = null;
        /**
         * @Property: imageAlternativeText
         * @Description: Alternative text for image in the showcase content
         * @Type: string
         */
        this.imageAlternativeText = '';
        /**
         * @Property: imageAlternativeText2
         * @Description: Alternative text for secondary showcase content
         * @Type: string
         */
        this.imageAlternativeText2 = '';
        /**
         * adds anchor tag around image
         */
        this.imageLink = null;
        /**
         * adds anchor tag with routerLink around image
         */
        this.imageRouterLink = null;
        /**
         * adds target attribute to anchor tag around image
         */
        this.imageTarget = null;
        /**
         * @Event: buttonClick
         * @Description: This event that is fired when the button of the promo changes.
         * G-4-0 Showcase
         * Can be bound to with (ButtonClick)='myFunction($event)'
         * @Return: Object
         */
        this.buttonClick = new EventEmitter();
        /**
         * @Event: buttonClick2
         * @Description: This event that is fired when the button of the promo changes.
         * G-4-0 Showcase
         * Can be bound to with (button2Click)='myFunction($event)'
         * @Return: Object
         */
        this.button2Click = new EventEmitter();
    }
    // ------------ Methods ------------- //
    /** This function is being called from button in Promo, fires the event to to eventEmitter object,
      and passing parameter 'e' for the use on consuming side
    */
    buttonClicked(e) {
        this.buttonClick.emit(e);
    }
    /** This function is being called from button in Promo, fires the event to to eventEmitter object,
      and passing parameter 'e' for the use on consuming side
    */
    button2Clicked(e) {
        this.button2Click.emit(e);
    }
    ngOnChanges(simpleChanges) {
        const imageUrlChange = simpleChanges?.imageUrl;
        if (imageUrlChange && !imageUrlChange.isFirstChange()) {
            this._isLazyloadImageHidden = true;
            setTimeout(() => {
                this._isLazyloadImageHidden = false;
            }, 0);
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ShowcaseComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: ShowcaseComponent, isStandalone: false, selector: "citi-showcase", inputs: { ariaLevel: "ariaLevel", headerLevel: "headerLevel", headerText: "headerText", legendText: "legendText", imageUrl: "imageUrl", type: "type", isLazyload: "isLazyload", imageSide: "imageSide", iconUrl: "iconUrl", imageUrl2: "imageUrl2", headerText2: "headerText2", legendText2: "legendText2", htmlContent: "htmlContent", htmlContent2: "htmlContent2", imageAlternativeText: "imageAlternativeText", imageAlternativeText2: "imageAlternativeText2", imageLink: "imageLink", imageRouterLink: "imageRouterLink", imageTarget: "imageTarget", buttonText: "buttonText", buttonUrl: "buttonUrl", buttonTarget: "buttonTarget", buttonText2: "buttonText2", buttonUrl2: "buttonUrl2", buttonTarget2: "buttonTarget2" }, outputs: { buttonClick: "buttonClick", button2Click: "button2Click" }, viewQueries: [{ propertyName: "content", first: true, predicate: ["content"], descendants: true }], usesOnChanges: true, ngImport: i0, template: `
    <section
      class="showcase"
      *ngIf="type == 'g-1-0' || type == 'g-1-2' || type == 'g-1-3'"
    >
      <div class="container-fluid">
        <div class=" text-center">
          <citi-text-header
            [style]="2"
            [level]="headerLevel"
            [htmlContent]="headerText"
            [ariaLevel]="ariaLevel"
          ></citi-text-header>
        </div>

        <div class="row" [contentHtml]="htmlContent">
          <ng-content select="[content-1-0]"></ng-content>
          <ng-content select="[content-1-2]"></ng-content>
          <ng-content select="[content-1-3]"></ng-content>
        </div>
        <footer class="text-center">
          <ng-content select="[footer-1-3]"></ng-content>
          <ng-content select="[footer-1-2]"></ng-content>
          <ng-content select="[footer-1-0]"></ng-content>
        </footer>
      </div>
    </section>
    <section class="showcase" *ngIf="type == 'g-1-1'">
      <div class="container-fluid showcase-1-1">
        <div class="text-center">
          <img
            src="{{ iconUrl }}"
            class="img-responsive showcase-header-icon"
            alt=""
          />
          <citi-text-header
            [style]="2"
            [level]="headerLevel"
            [htmlContent]="headerText"
            [ariaLevel]="ariaLevel"
          ></citi-text-header>
        </div>

        <div class="row row-spacing" [contentHtml]="htmlContent">
          <ng-content select="[content-1-1]"></ng-content>
        </div>
      </div>
    </section>
    <section class="showcase" *ngIf="type == 'g-1-4'">
      <div class="container-fluid showcase-1-4">
        <div class="row row-spacing">
          <citi-text-header
            [style]="2"
            [level]="headerLevel"
            [htmlContent]="headerText"
            [ariaLevel]="ariaLevel"
          ></citi-text-header>
          <ng-content></ng-content>
        </div>
      </div>
    </section>
    <section class="showcase" *ngIf="type == 'g-2-0'">
      <div class="container-fluid showcase-2-0">
        <div class="showcase-header-image sixteen-by-nine">
          <img [attr.src]="imageUrl" [attr.alt]="imageAlternativeText" />
        </div>

        <div class="text-center">
          <citi-text-header
            [style]="2"
            [level]="headerLevel"
            [htmlContent]="headerText"
            [ariaLevel]="ariaLevel"
          ></citi-text-header>
          <p class="showcase-subheader" [innerHtml]="legendText"></p>
        </div>

        <div class="row" [contentHtml]="htmlContent">
          <ng-content select="[content-2-0]"></ng-content>
        </div>
        <footer class="text-center">
          <ng-content select="[footer-2-0]"></ng-content>
        </footer>
      </div>
    </section>
    <section class="showcase" *ngIf="type == 'g-2-1'">
      <div class="container-fluid showcase-2-1">
        <div class="showcase-header-image sixteen-by-nine">
          <img [attr.src]="imageUrl" [attr.alt]="imageAlternativeText" />
        </div>

        <div class="text-center">
          <img
            src="{{ iconUrl }}"
            class="img-responsive showcase-header-icon"
            [attr.alt]="imageAlternativeText2"
          />
          <citi-text-header
            [style]="2"
            [level]="headerLevel"
            [htmlContent]="headerText"
            [ariaLevel]="ariaLevel"
          ></citi-text-header>
          <p class="showcase-subheader" [innerHtml]="legendText"></p>
        </div>

        <div class="row" [contentHtml]="htmlContent"></div>
        <ng-content select="[content-2-1]"></ng-content>
        <footer class="text-center">
          <ng-content select="[footer-2-1]"></ng-content>
        </footer>
      </div>
    </section>
    <section class="showcase" *ngIf="type == 'g-2-2'">
      <div class="container-fluid showcase-2-2">
        <div class="showcase-header-image sixteen-by-nine">
          <img [attr.src]="imageUrl" [attr.alt]="imageAlternativeText" />
        </div>

        <div class="text-center">
          <citi-text-header
            [style]="2"
            [level]="headerLevel"
            [htmlContent]="headerText"
            [ariaLevel]="ariaLevel"
          ></citi-text-header>
        </div>

        <div class="row text-center" [contentHtml]="htmlContent">
          <ng-content select="[content-2-2]"></ng-content>
        </div>
      </div>
    </section>
    <section class="showcase" *ngIf="type == 'g-3-0' || type == 'g-3-1'">
      <div class="container-fluid showcase-3">
          <div class="g-3-container d-flex" [class.flex-reverse]="imageSide === 'right'">
            <div class="flex-50 image-container-cover">
              <ng-container
                *ngIf="!!imageLink || !!imageRouterLink; else g3Image"
              >
                <ng-container *ngIf="!!imageRouterLink; else g3HrefAnchor">
                  <a [routerLink]="imageRouterLink">
                    <ng-container *ngTemplateOutlet="g3Image"></ng-container>
                  </a>
                </ng-container>
                <ng-template #g3HrefAnchor>
                  <a [attr.href]="imageLink" [attr.target]="imageTarget">
                    <ng-container *ngTemplateOutlet="g3Image"></ng-container>
                  </a>
                </ng-template>
              </ng-container>
              <ng-template #g3Image>
                <ng-container *ngIf="!isLazyload; else g3LazyLoad">
                  <img
                    [attr.src]="imageUrl"
                    class="img-responsive img-cover"
                    [attr.alt]="imageAlternativeText"
                  />
                </ng-container>
                <ng-template #g3LazyLoad>
                  <img
                    *ngIf="!_isLazyloadImageHidden"
                    [lazyloadUrl]="imageUrl"
                    class="img-responsive img-cover"
                    [attr.alt]="imageAlternativeText"
                  />
                </ng-template>
              </ng-template>
            </div>
            <div class="flex-50 module-content">
              <citi-text-header
                [style]="2"
                [level]="headerLevel"
                [htmlContent]="headerText"
                [ariaLevel]="ariaLevel"
              ></citi-text-header>
              <p [innerHtml]="legendText"></p>
              <div [contentHtml]="htmlContent">
                <ng-content select="[content-3-0]"></ng-content>
                <ng-content select="[content-3-1]"></ng-content>
              </div>
            </div>
          </div>
      </div>
    </section>
    <section class="showcase" *ngIf="type == 'g-3-2'">
      <div class="container-fluid showcase-3-2">
        <div class="row">
          <div class="g-3-container">
            <div
              class="col-sm-6 image-container {{
                imageSide == 'right' ? 'col-sm-push-6' : ''
              }}"
            >
              <img
                [attr.src]="imageUrl"
                class="img-responsive"
                [attr.alt]="imageAlternativeText"
              />
            </div>
            <div
              class="col-sm-6 {{
                imageSide == 'right' ? '' : 'col-sm-push-6'
              }} module-content"
            >
              <citi-text-header
                [style]="2"
                [level]="headerLevel"
                [htmlContent]="headerText"
                [ariaLevel]="ariaLevel"
              ></citi-text-header>
              <p [innerHtml]="legendText"></p>
              <div class="row" [contentHtml]="htmlContent">
                <ng-content select="[content-3-2-1]"></ng-content>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="g-3-container">
              <div
                class="col-sm-6 image-container {{
                  imageSide == 'right' ? '' : 'col-sm-push-6'
                }}"
              >
                <img
                  src="{{ imageUrl2 }}"
                  class="img-responsive"
                  [attr.alt]="imageAlternativeText2"
                />
              </div>
              <div
                class="col-sm-6 {{
                  imageSide == 'right' ? 'col-sm-push-6' : ''
                }} module-content"
              >
                <citi-text-header
                  [style]="2"
                  [level]="headerLevel"
                  [htmlContent]="headerText2"
                  [ariaLevel]="ariaLevel"
                ></citi-text-header>
                <p [innerHtml]="legendText2"></p>
                <div class="row" [contentHtml]="htmlContent2">
                  <ng-content select="[content-3-2-2]"></ng-content>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="showcase" *ngIf="type == 'g-4-0'">
      <div class="wrapper__g-4-0">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6 col-md-6">
              <div class="module-container">
                <div class="image-container">
                  <img
                    [attr.src]="imageUrl"
                    class="img-responsive"
                    [attr.alt]="imageAlternativeText"
                  />
                </div>
                <div class="body-module">
                  <div class="showcase-4-content">
                    <citi-text-header
                      [style]="2"
                      [level]="headerLevel"
                      [htmlContent]="headerText"
                      [ariaLevel]="ariaLevel"
                    ></citi-text-header>
                    <p class="showcase-text" [innerHtml]="legendText"></p>
                    <citi-cta
                      type="secondary"
                      [value]="buttonText"
                      [href]="buttonUrl"
                      [target]="buttonTarget"
                      (ctaClick)="buttonClicked($event)"
                      bold
                    ></citi-cta>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-md-6">
              <div class="module-container">
                <div class="image-container">
                  <img
                    [attr.src]="imageUrl2"
                    class="img-responsive"
                    [attr.alt]="imageAlternativeText2"
                  />
                </div>
                <div class="body-module">
                  <div class="showcase-4-content">
                    <citi-text-header
                      [style]="2"
                      [level]="headerLevel"
                      [htmlContent]="headerText2"
                      [ariaLevel]="ariaLevel"
                    ></citi-text-header>
                    <p class="showcase-text" [innerHtml]="legendText2"></p>
                    <citi-cta
                      type="secondary"
                      [value]="buttonText2"
                      [href]="buttonUrl2"
                      [target]="buttonTarget2"
                      (ctaClick)="button2Clicked($event)"
                      bold
                    ></citi-cta>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="showcase" *ngIf="type == 'g-5-0'">
      <div class="wrapper__g-5-0">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-3">
              <div class="module-container">
                <div class="img-responsive">
                  <img
                    [attr.src]="imageUrl"
                    class="img-responsive"
                    [attr.alt]="imageAlternativeText"
                  />
                </div>
              </div>
            </div>
            <div class="col-sm-8">
              <div class="module-container">
                <div class="body-module">
                  <div class="showcase-section-header header-4">
                    <citi-text-header
                      [style]="4"
                      [level]="headerLevel"
                      [htmlContent]="headerText"
                      [ariaLevel]="ariaLevel"
                      bold
                    ></citi-text-header>
                    <p class="showcase-text" [innerHtml]="legendText"></p>
                    <citi-cta
                      type="secondary"
                      [value]="buttonText"
                      [href]="buttonUrl"
                      [target]="buttonTarget"
                      (ctaClick)="buttonClicked($event)"
                      bold
                    ></citi-cta>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="showcase" *ngIf="type == 'g-5-1'">
      <div class="wrapper__g-5-1">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-3">
              <div class="module-container">
                <div class="img-responsive">
                  <img
                    [attr.src]="imageUrl"
                    class="img-responsive"
                    [attr.alt]="imageAlternativeText"
                  />
                </div>
              </div>
            </div>
            <div class="col-sm-8">
              <div class="module-container">
                <div class="body-module">
                  <div class="chevron-link link bold cta-anchor">
                    <citi-cta
                      type="secondary"
                      [value]="buttonText"
                      [href]="buttonUrl"
                      [target]="buttonTarget"
                      (ctaClick)="buttonClicked($event)"
                      bold
                    ></citi-cta>
                    <p class="showcase-text" [innerHtml]="legendText"></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  `, isInline: true, styles: [".sixteen-by-nine img{width:100%;height:auto;left:0;top:50%;transform:translateY(-50%)}.top-buffer{margin-bottom:40px}.cta-anchor ::ng-deep citi-cta a{background-size:10px;font-size:1.625rem;line-height:2rem;font-family:Interstate_bold,sans-serif;font-weight:400;color:#056dae;text-transform:none;letter-spacing:normal;padding:0 20px 0 0;margin-bottom:20px}.cta-anchor ::ng-deep .chevron-link:after{font-weight:100;background-size:10px;padding-right:5px}.showcase .g-3-container{overflow:visible}.d-flex{display:flex}.flex-reverse{flex-direction:row-reverse}.flex-50{flex:1 1 50%}.img-cover{object-fit:cover;height:100%}.image-container-cover a:focus{outline:none}.image-container-cover a:focus-visible{outline:-webkit-focus-ring-color auto 1px;outline-offset:3px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }, { kind: "component", type: CTAComponent, selector: "citi-cta", inputs: ["textAlign", "bold", "noMargin", "tabIndex", "ariaDescription", "ariaLabeledBy", "ariaHasPopup", "ariaRole", "ariaLabel", "ariaControls", "ariaExpanded", "router", "queryParams", "idStr", "dataTarget", "addJFPToken", "doNotAddJFPToken", "buttonType", "target", "href", "value", "disabled", "type", "size", "arrow", "leftArrow"], outputs: ["ctaClick", "disabledChange", "ctaFocus", "ctaBlur"] }, { kind: "component", type: TextHeaderComponent, selector: "citi-text-header", inputs: ["ariaLevel", "level", "style", "bold", "class", "html", "ariaRole", "htmlContent"] }, { kind: "directive", type: i2.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "info", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "directive", type: LazyLoadImageDirective, selector: "[lazyloadUrl]", inputs: ["lazyloadUrl"], exportAs: ["lazyloadUrl"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ShowcaseComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-showcase', standalone: false, template: `
    <section
      class="showcase"
      *ngIf="type == 'g-1-0' || type == 'g-1-2' || type == 'g-1-3'"
    >
      <div class="container-fluid">
        <div class=" text-center">
          <citi-text-header
            [style]="2"
            [level]="headerLevel"
            [htmlContent]="headerText"
            [ariaLevel]="ariaLevel"
          ></citi-text-header>
        </div>

        <div class="row" [contentHtml]="htmlContent">
          <ng-content select="[content-1-0]"></ng-content>
          <ng-content select="[content-1-2]"></ng-content>
          <ng-content select="[content-1-3]"></ng-content>
        </div>
        <footer class="text-center">
          <ng-content select="[footer-1-3]"></ng-content>
          <ng-content select="[footer-1-2]"></ng-content>
          <ng-content select="[footer-1-0]"></ng-content>
        </footer>
      </div>
    </section>
    <section class="showcase" *ngIf="type == 'g-1-1'">
      <div class="container-fluid showcase-1-1">
        <div class="text-center">
          <img
            src="{{ iconUrl }}"
            class="img-responsive showcase-header-icon"
            alt=""
          />
          <citi-text-header
            [style]="2"
            [level]="headerLevel"
            [htmlContent]="headerText"
            [ariaLevel]="ariaLevel"
          ></citi-text-header>
        </div>

        <div class="row row-spacing" [contentHtml]="htmlContent">
          <ng-content select="[content-1-1]"></ng-content>
        </div>
      </div>
    </section>
    <section class="showcase" *ngIf="type == 'g-1-4'">
      <div class="container-fluid showcase-1-4">
        <div class="row row-spacing">
          <citi-text-header
            [style]="2"
            [level]="headerLevel"
            [htmlContent]="headerText"
            [ariaLevel]="ariaLevel"
          ></citi-text-header>
          <ng-content></ng-content>
        </div>
      </div>
    </section>
    <section class="showcase" *ngIf="type == 'g-2-0'">
      <div class="container-fluid showcase-2-0">
        <div class="showcase-header-image sixteen-by-nine">
          <img [attr.src]="imageUrl" [attr.alt]="imageAlternativeText" />
        </div>

        <div class="text-center">
          <citi-text-header
            [style]="2"
            [level]="headerLevel"
            [htmlContent]="headerText"
            [ariaLevel]="ariaLevel"
          ></citi-text-header>
          <p class="showcase-subheader" [innerHtml]="legendText"></p>
        </div>

        <div class="row" [contentHtml]="htmlContent">
          <ng-content select="[content-2-0]"></ng-content>
        </div>
        <footer class="text-center">
          <ng-content select="[footer-2-0]"></ng-content>
        </footer>
      </div>
    </section>
    <section class="showcase" *ngIf="type == 'g-2-1'">
      <div class="container-fluid showcase-2-1">
        <div class="showcase-header-image sixteen-by-nine">
          <img [attr.src]="imageUrl" [attr.alt]="imageAlternativeText" />
        </div>

        <div class="text-center">
          <img
            src="{{ iconUrl }}"
            class="img-responsive showcase-header-icon"
            [attr.alt]="imageAlternativeText2"
          />
          <citi-text-header
            [style]="2"
            [level]="headerLevel"
            [htmlContent]="headerText"
            [ariaLevel]="ariaLevel"
          ></citi-text-header>
          <p class="showcase-subheader" [innerHtml]="legendText"></p>
        </div>

        <div class="row" [contentHtml]="htmlContent"></div>
        <ng-content select="[content-2-1]"></ng-content>
        <footer class="text-center">
          <ng-content select="[footer-2-1]"></ng-content>
        </footer>
      </div>
    </section>
    <section class="showcase" *ngIf="type == 'g-2-2'">
      <div class="container-fluid showcase-2-2">
        <div class="showcase-header-image sixteen-by-nine">
          <img [attr.src]="imageUrl" [attr.alt]="imageAlternativeText" />
        </div>

        <div class="text-center">
          <citi-text-header
            [style]="2"
            [level]="headerLevel"
            [htmlContent]="headerText"
            [ariaLevel]="ariaLevel"
          ></citi-text-header>
        </div>

        <div class="row text-center" [contentHtml]="htmlContent">
          <ng-content select="[content-2-2]"></ng-content>
        </div>
      </div>
    </section>
    <section class="showcase" *ngIf="type == 'g-3-0' || type == 'g-3-1'">
      <div class="container-fluid showcase-3">
          <div class="g-3-container d-flex" [class.flex-reverse]="imageSide === 'right'">
            <div class="flex-50 image-container-cover">
              <ng-container
                *ngIf="!!imageLink || !!imageRouterLink; else g3Image"
              >
                <ng-container *ngIf="!!imageRouterLink; else g3HrefAnchor">
                  <a [routerLink]="imageRouterLink">
                    <ng-container *ngTemplateOutlet="g3Image"></ng-container>
                  </a>
                </ng-container>
                <ng-template #g3HrefAnchor>
                  <a [attr.href]="imageLink" [attr.target]="imageTarget">
                    <ng-container *ngTemplateOutlet="g3Image"></ng-container>
                  </a>
                </ng-template>
              </ng-container>
              <ng-template #g3Image>
                <ng-container *ngIf="!isLazyload; else g3LazyLoad">
                  <img
                    [attr.src]="imageUrl"
                    class="img-responsive img-cover"
                    [attr.alt]="imageAlternativeText"
                  />
                </ng-container>
                <ng-template #g3LazyLoad>
                  <img
                    *ngIf="!_isLazyloadImageHidden"
                    [lazyloadUrl]="imageUrl"
                    class="img-responsive img-cover"
                    [attr.alt]="imageAlternativeText"
                  />
                </ng-template>
              </ng-template>
            </div>
            <div class="flex-50 module-content">
              <citi-text-header
                [style]="2"
                [level]="headerLevel"
                [htmlContent]="headerText"
                [ariaLevel]="ariaLevel"
              ></citi-text-header>
              <p [innerHtml]="legendText"></p>
              <div [contentHtml]="htmlContent">
                <ng-content select="[content-3-0]"></ng-content>
                <ng-content select="[content-3-1]"></ng-content>
              </div>
            </div>
          </div>
      </div>
    </section>
    <section class="showcase" *ngIf="type == 'g-3-2'">
      <div class="container-fluid showcase-3-2">
        <div class="row">
          <div class="g-3-container">
            <div
              class="col-sm-6 image-container {{
                imageSide == 'right' ? 'col-sm-push-6' : ''
              }}"
            >
              <img
                [attr.src]="imageUrl"
                class="img-responsive"
                [attr.alt]="imageAlternativeText"
              />
            </div>
            <div
              class="col-sm-6 {{
                imageSide == 'right' ? '' : 'col-sm-push-6'
              }} module-content"
            >
              <citi-text-header
                [style]="2"
                [level]="headerLevel"
                [htmlContent]="headerText"
                [ariaLevel]="ariaLevel"
              ></citi-text-header>
              <p [innerHtml]="legendText"></p>
              <div class="row" [contentHtml]="htmlContent">
                <ng-content select="[content-3-2-1]"></ng-content>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="g-3-container">
              <div
                class="col-sm-6 image-container {{
                  imageSide == 'right' ? '' : 'col-sm-push-6'
                }}"
              >
                <img
                  src="{{ imageUrl2 }}"
                  class="img-responsive"
                  [attr.alt]="imageAlternativeText2"
                />
              </div>
              <div
                class="col-sm-6 {{
                  imageSide == 'right' ? 'col-sm-push-6' : ''
                }} module-content"
              >
                <citi-text-header
                  [style]="2"
                  [level]="headerLevel"
                  [htmlContent]="headerText2"
                  [ariaLevel]="ariaLevel"
                ></citi-text-header>
                <p [innerHtml]="legendText2"></p>
                <div class="row" [contentHtml]="htmlContent2">
                  <ng-content select="[content-3-2-2]"></ng-content>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="showcase" *ngIf="type == 'g-4-0'">
      <div class="wrapper__g-4-0">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6 col-md-6">
              <div class="module-container">
                <div class="image-container">
                  <img
                    [attr.src]="imageUrl"
                    class="img-responsive"
                    [attr.alt]="imageAlternativeText"
                  />
                </div>
                <div class="body-module">
                  <div class="showcase-4-content">
                    <citi-text-header
                      [style]="2"
                      [level]="headerLevel"
                      [htmlContent]="headerText"
                      [ariaLevel]="ariaLevel"
                    ></citi-text-header>
                    <p class="showcase-text" [innerHtml]="legendText"></p>
                    <citi-cta
                      type="secondary"
                      [value]="buttonText"
                      [href]="buttonUrl"
                      [target]="buttonTarget"
                      (ctaClick)="buttonClicked($event)"
                      bold
                    ></citi-cta>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-md-6">
              <div class="module-container">
                <div class="image-container">
                  <img
                    [attr.src]="imageUrl2"
                    class="img-responsive"
                    [attr.alt]="imageAlternativeText2"
                  />
                </div>
                <div class="body-module">
                  <div class="showcase-4-content">
                    <citi-text-header
                      [style]="2"
                      [level]="headerLevel"
                      [htmlContent]="headerText2"
                      [ariaLevel]="ariaLevel"
                    ></citi-text-header>
                    <p class="showcase-text" [innerHtml]="legendText2"></p>
                    <citi-cta
                      type="secondary"
                      [value]="buttonText2"
                      [href]="buttonUrl2"
                      [target]="buttonTarget2"
                      (ctaClick)="button2Clicked($event)"
                      bold
                    ></citi-cta>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="showcase" *ngIf="type == 'g-5-0'">
      <div class="wrapper__g-5-0">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-3">
              <div class="module-container">
                <div class="img-responsive">
                  <img
                    [attr.src]="imageUrl"
                    class="img-responsive"
                    [attr.alt]="imageAlternativeText"
                  />
                </div>
              </div>
            </div>
            <div class="col-sm-8">
              <div class="module-container">
                <div class="body-module">
                  <div class="showcase-section-header header-4">
                    <citi-text-header
                      [style]="4"
                      [level]="headerLevel"
                      [htmlContent]="headerText"
                      [ariaLevel]="ariaLevel"
                      bold
                    ></citi-text-header>
                    <p class="showcase-text" [innerHtml]="legendText"></p>
                    <citi-cta
                      type="secondary"
                      [value]="buttonText"
                      [href]="buttonUrl"
                      [target]="buttonTarget"
                      (ctaClick)="buttonClicked($event)"
                      bold
                    ></citi-cta>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="showcase" *ngIf="type == 'g-5-1'">
      <div class="wrapper__g-5-1">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-3">
              <div class="module-container">
                <div class="img-responsive">
                  <img
                    [attr.src]="imageUrl"
                    class="img-responsive"
                    [attr.alt]="imageAlternativeText"
                  />
                </div>
              </div>
            </div>
            <div class="col-sm-8">
              <div class="module-container">
                <div class="body-module">
                  <div class="chevron-link link bold cta-anchor">
                    <citi-cta
                      type="secondary"
                      [value]="buttonText"
                      [href]="buttonUrl"
                      [target]="buttonTarget"
                      (ctaClick)="buttonClicked($event)"
                      bold
                    ></citi-cta>
                    <p class="showcase-text" [innerHtml]="legendText"></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  `, styles: [".sixteen-by-nine img{width:100%;height:auto;left:0;top:50%;transform:translateY(-50%)}.top-buffer{margin-bottom:40px}.cta-anchor ::ng-deep citi-cta a{background-size:10px;font-size:1.625rem;line-height:2rem;font-family:Interstate_bold,sans-serif;font-weight:400;color:#056dae;text-transform:none;letter-spacing:normal;padding:0 20px 0 0;margin-bottom:20px}.cta-anchor ::ng-deep .chevron-link:after{font-weight:100;background-size:10px;padding-right:5px}.showcase .g-3-container{overflow:visible}.d-flex{display:flex}.flex-reverse{flex-direction:row-reverse}.flex-50{flex:1 1 50%}.img-cover{object-fit:cover;height:100%}.image-container-cover a:focus{outline:none}.image-container-cover a:focus-visible{outline:-webkit-focus-ring-color auto 1px;outline-offset:3px}\n"] }]
        }], propDecorators: { content: [{
                type: ViewChild,
                args: ['content']
            }], ariaLevel: [{
                type: Input$1
            }], headerLevel: [{
                type: Input$1
            }], headerText: [{
                type: Input$1
            }], legendText: [{
                type: Input$1
            }], imageUrl: [{
                type: Input$1
            }], type: [{
                type: Input$1
            }], isLazyload: [{
                type: Input$1
            }], imageSide: [{
                type: Input$1
            }], iconUrl: [{
                type: Input$1
            }], imageUrl2: [{
                type: Input$1
            }], headerText2: [{
                type: Input$1
            }], legendText2: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }], htmlContent2: [{
                type: Input$1
            }], imageAlternativeText: [{
                type: Input$1
            }], imageAlternativeText2: [{
                type: Input$1
            }], imageLink: [{
                type: Input$1
            }], imageRouterLink: [{
                type: Input$1
            }], imageTarget: [{
                type: Input$1
            }], buttonText: [{
                type: Input$1
            }], buttonUrl: [{
                type: Input$1
            }], buttonTarget: [{
                type: Input$1
            }], buttonClick: [{
                type: Output
            }], buttonText2: [{
                type: Input$1
            }], buttonUrl2: [{
                type: Input$1
            }], buttonTarget2: [{
                type: Input$1
            }], button2Click: [{
                type: Output
            }] } });

/**
 * @Component: Terms and Conditions
 * @Section: Forms
 * @description This component generates a terms and conditions section
 */
class ShowcaseSectionComponent {
    ngOnInit() {
        this.sectionParent = this.injector.get(ShowcaseComponent);
    }
    constructor(injector) {
        this.injector = injector;
        this.classes = {
            'g-5-0': 'section',
            'g-5-1': 'section',
            'g-1-4': 'col-sm-4 tile gray'
        };
    }
    ;
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ShowcaseSectionComponent, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: ShowcaseSectionComponent, isStandalone: false, selector: "citi-showcase-section", inputs: { headerText: "headerText", bodyText: "bodyText", imageUrl: "imageUrl", ctaText: "ctaText", href: "href" }, ngImport: i0, template: `
    <div *ngIf="sectionParent.type === 'g-1-4'" class="col-sm-4 tile gray">
        <div class="showcase-section-container">
            <div class="showcase-section-image">
                <img [src]="imageUrl" alt="">
            </div>
            <div class="showcase-section-content">
                <h2 class="showcase-section-header header-3" [innerHtml]="headerText"></h2>
                <div class="showcase-section-text" [innerHtml]="bodyText"></div>
                <a [href]="href" class="chevron-link bold showcase-section-cta"><strong [innerHtml]="ctaText"></strong></a>
            </div>
        </div>
    </div>
    <div *ngIf="sectionParent.type === 'g-5-0' || sectionParent.type === 'g-5-1'" class="section">
        <div class="col-sm-3 showcase-section-image">
            <img [src]="imageUrl" class="img-responsive" alt=""/>
        </div>
        <div class="col-sm-8 showcase-section-content">
            <div class="showcase-section-header">
                <h2 class="header-3" *ngIf="sectionParent.type === 'g-5-1'">
                    <a href="#" class="chevron-link link bold" [innerHtml]="headerText"></a>
                </h2>
                <h2 class="header-4" *ngIf="sectionParent.type === 'g-5-0'" [innerHtml]="headerText"></h2>
            </div>
            <div class="showcase-section-text" [innerHtml]="bodyText"></div>
            <a *ngIf="href && ctaText" [href]="href" class="chevron-link bold showcase-section-cta"><strong [innerHtml]="ctaText"></strong></a>
        </div>
    </div>
`, isInline: true, dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ShowcaseSectionComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'citi-showcase-section',
                    standalone: false,
                    template: `
    <div *ngIf="sectionParent.type === 'g-1-4'" class="col-sm-4 tile gray">
        <div class="showcase-section-container">
            <div class="showcase-section-image">
                <img [src]="imageUrl" alt="">
            </div>
            <div class="showcase-section-content">
                <h2 class="showcase-section-header header-3" [innerHtml]="headerText"></h2>
                <div class="showcase-section-text" [innerHtml]="bodyText"></div>
                <a [href]="href" class="chevron-link bold showcase-section-cta"><strong [innerHtml]="ctaText"></strong></a>
            </div>
        </div>
    </div>
    <div *ngIf="sectionParent.type === 'g-5-0' || sectionParent.type === 'g-5-1'" class="section">
        <div class="col-sm-3 showcase-section-image">
            <img [src]="imageUrl" class="img-responsive" alt=""/>
        </div>
        <div class="col-sm-8 showcase-section-content">
            <div class="showcase-section-header">
                <h2 class="header-3" *ngIf="sectionParent.type === 'g-5-1'">
                    <a href="#" class="chevron-link link bold" [innerHtml]="headerText"></a>
                </h2>
                <h2 class="header-4" *ngIf="sectionParent.type === 'g-5-0'" [innerHtml]="headerText"></h2>
            </div>
            <div class="showcase-section-text" [innerHtml]="bodyText"></div>
            <a *ngIf="href && ctaText" [href]="href" class="chevron-link bold showcase-section-cta"><strong [innerHtml]="ctaText"></strong></a>
        </div>
    </div>
`
                }]
        }], ctorParameters: () => [{ type: i0.Injector }], propDecorators: { headerText: [{
                type: Input$1
            }], bodyText: [{
                type: Input$1
            }], imageUrl: [{
                type: Input$1
            }], ctaText: [{
                type: Input$1
            }], href: [{
                type: Input$1
            }] } });

const COMPONENTS$q = [
    ShowcaseComponent,
    ShowcaseChildComponent,
    ShowcaseSectionComponent
];
const MODULES$s = [CommonModule, ContentHtml, CTA, TextHeader, RouterModule, LazyLoadImage];
class Showcase {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Showcase, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: Showcase, declarations: [ShowcaseComponent,
            ShowcaseChildComponent,
            ShowcaseSectionComponent], imports: [CommonModule, ContentHtml, CTA, TextHeader, RouterModule, LazyLoadImage], exports: [ShowcaseComponent,
            ShowcaseChildComponent,
            ShowcaseSectionComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Showcase, imports: [MODULES$s] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Showcase, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$s],
                    declarations: [...COMPONENTS$q],
                    exports: [...COMPONENTS$q]
                }]
        }] });

/**
 * @Component: Action Module Section
 * @Section: Modules
 * @description This component generates a basic Action section (D8.0)
 */
class ActionContactUsComponent {
    constructor() {
        /**
         * @property actionContactStyle
         * @description This will specify the class name
         * @return string
         */
        this.actionContactStyle = 'header-3 d8-contact-us-text';
        /**
         * @property headerLevel
         * @description This will create the requested HTML header tag <h1> - <h6>
         * @return number
         */
        this.headerLevel = 1;
        if (isDevMode()) {
            console.error('%cThe Common UI DDL ActionContactUs <citi-action-contact-us> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ActionContactUsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: ActionContactUsComponent, isStandalone: false, selector: "citi-action-contact-us", inputs: { headerLevel: "headerLevel", headerText: "headerText", ariaLevel: "ariaLevel", imageAlt: "imageAlt", imageSrc: "imageSrc", linkText: "linkText", url: "url", htmlContent: "htmlContent" }, ngImport: i0, template: `
  <section class="theme-gray">
    <div class="container-fluid">
        <div class="d8-contact-us">
            <span *ngIf="imageSrc" class="d8-contact-us-icon"><img [alt]="imageAlt" [src]="imageSrc"></span>
            <citi-text-header [class]="actionContactStyle"  [level]="headerLevel" [ariaLevel]="ariaLevel" >
              <span [innerHtml]="headerText"></span>
              <a *ngIf="linkText" class="chevron-link bold" [href]="url"><strong [innerHtml]="linkText"></strong></a>
            </citi-text-header>
            <!-- <h1 class="header-3 d8-contact-us-text">
                <span [innerHtml]="headerText"></span>
                <a *ngIf="linkText" class="chevron-link bold" [href]="url"><strong [innerHtml]="linkText"></strong></a>
            </h1> -->
        </div>
    </div>

</section>

  `, isInline: true, styles: [".d8-contact-us-text ::ng-deep a.chevron-link.bold{background-size:12px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: TextHeaderComponent, selector: "citi-text-header", inputs: ["ariaLevel", "level", "style", "bold", "class", "html", "ariaRole", "htmlContent"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ActionContactUsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-action-contact-us', standalone: false, template: `
  <section class="theme-gray">
    <div class="container-fluid">
        <div class="d8-contact-us">
            <span *ngIf="imageSrc" class="d8-contact-us-icon"><img [alt]="imageAlt" [src]="imageSrc"></span>
            <citi-text-header [class]="actionContactStyle"  [level]="headerLevel" [ariaLevel]="ariaLevel" >
              <span [innerHtml]="headerText"></span>
              <a *ngIf="linkText" class="chevron-link bold" [href]="url"><strong [innerHtml]="linkText"></strong></a>
            </citi-text-header>
            <!-- <h1 class="header-3 d8-contact-us-text">
                <span [innerHtml]="headerText"></span>
                <a *ngIf="linkText" class="chevron-link bold" [href]="url"><strong [innerHtml]="linkText"></strong></a>
            </h1> -->
        </div>
    </div>

</section>

  `, styles: [".d8-contact-us-text ::ng-deep a.chevron-link.bold{background-size:12px}\n"] }]
        }], ctorParameters: () => [], propDecorators: { headerLevel: [{
                type: Input$1
            }], headerText: [{
                type: Input$1
            }], ariaLevel: [{
                type: Input$1
            }], imageAlt: [{
                type: Input$1
            }], imageSrc: [{
                type: Input$1
            }], linkText: [{
                type: Input$1
            }], url: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }] } });

class MatchHeightDirective {
    constructor(el) {
        this.el = el;
    }
    // TODO: find a more efficient way of doing this
    ngAfterViewChecked() {
        // call our matchHeight function here later
        this.matchHeight(this.el.nativeElement, this.actionMatchHeight);
    }
    onResize() {
        // call our matchHeight function here later
        this.matchHeight(this.el.nativeElement, this.actionMatchHeight);
    }
    matchHeight(parent, className) {
        // match height logic here
        if (!parent)
            return;
        const children = parent.getElementsByClassName(className);
        if (!children)
            return;
        // reset all children height
        Array.from(children).forEach((x) => {
            x.style.height = 'initial';
        });
        // gather all height
        const itemHeights = Array.from(children)
            .map(x => x.getBoundingClientRect().height);
        // find max height
        const maxHeight = itemHeights.reduce((prev, curr) => {
            return curr > prev ? curr : prev;
        }, 0);
        // apply max height
        Array.from(children)
            .forEach((x) => x.style.height = `${maxHeight}px`);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: MatchHeightDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.0.5", type: MatchHeightDirective, isStandalone: false, selector: "[actionMatchHeight]", inputs: { actionMatchHeight: "actionMatchHeight" }, host: { listeners: { "window:resize": "onResize()" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: MatchHeightDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[actionMatchHeight]',
                    standalone: false
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { actionMatchHeight: [{
                type: Input$1
            }], onResize: [{
                type: HostListener,
                args: ['window:resize']
            }] } });

class ActionMatchHeight {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ActionMatchHeight, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: ActionMatchHeight, declarations: [MatchHeightDirective], imports: [CommonModule], exports: [MatchHeightDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ActionMatchHeight, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ActionMatchHeight, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [MatchHeightDirective],
                    exports: [MatchHeightDirective]
                }]
        }] });

// This Component
const COMPONENTS$p = [
    ActionContactUsComponent
];
const MODULES$r = [
    CommonModule,
    ActionMatchHeight,
    TextHeader
];
class ActionContactUs {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ActionContactUs, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: ActionContactUs, declarations: [ActionContactUsComponent], imports: [CommonModule,
            ActionMatchHeight,
            TextHeader], exports: [ActionContactUsComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ActionContactUs, imports: [MODULES$r] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ActionContactUs, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$r],
                    declarations: [...COMPONENTS$p],
                    exports: [ActionContactUsComponent]
                }]
        }] });

/**
 * @Component: Action Module Section
 * @Section: Modules
 * @description This component generates a basic Action section (D1.0, D1.1, D1.3, D1.4, D1.8,D1.9)
 */
class ActionD1Component {
    /**
    * @property actionType
    * @description Sets the action type as defined in the DDL modules. Use only one of the available types.
    * The available types include the following: 'd-1-0'
    * @return string
    * @twoway false
    */
    set actionType(type) {
        this.type = type;
    }
    constructor() {
        this.type = 'd-1-0';
        /**
        * @property headerLevel
        * @description Header level for the component header tag
        * @return number
        */
        this.headerLevel = 1;
        /**
        * @property isBottomContentRequired
        * @description isBottomContentRequired to add the bottom line to separate the body content.
        * @Type: boolean  true | false, default false
        */
        this.isBottomContentRequired = false;
        if (isDevMode()) {
            console.error('%cThe Common UI DDL ActionD1Series <citi-action-d1> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ActionD1Component, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: ActionD1Component, isStandalone: false, selector: "citi-action-d1", inputs: { actionType: "actionType", headerText: "headerText", headerLevel: "headerLevel", ariaLevel: "ariaLevel", isWhiteBG: "isWhiteBG", introText: "introText", isBottomContentRequired: "isBottomContentRequired", htmlContent: "htmlContent" }, ngImport: i0, template: `
  <section class="{{isWhiteBG ? '' : 'theme-gray'}}">
    <div class="ways-to-apply common-module container-fluid">
        <div class="row">
            <div class="col-md-8 col-md-offset-2">
                <div class="text-center standard-header" *ngIf="headerText">
                    <!-- <h1 class="header-2">{{headerText}}</h1> -->
                    <citi-text-header [style]="2" [level]="headerLevel" [htmlContent]="headerText" [ariaLevel]="ariaLevel"></citi-text-header>
                    <ng-content select="[paragraphtext]"></ng-content>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-8 col-md-offset-2">
                <div class=" text-center" [ngClass]="{'no-buttons-body-d-1-4': type=='d-1-4'}" *ngIf="introText">
                    <p [innerHtml]="introText"></p>
                    <ng-content select="[actioncontent]"></ng-content>
                </div>
            </div>
        </div>
        <div class="common-module-body text-center">
            <ng-content select="[actioncontent1]"></ng-content>
        </div>
        <div class="row bottom-half">
            <ng-content select="[actioncontent2]"></ng-content>
        </div>

        <div class="common-module-body text-center no-buttons-body" *ngIf="isBottomContentRequired"></div>

        <div class="row bottom-half">
            <div class="col-md-8 col-md-offset-2">
                <div class="common-module-col text-center">
                    <ng-content select="[actioncontent3]"></ng-content>
                </div>
            </div>
        </div>
    </div>
</section>

  `, isInline: true, styles: [".theme-gray .ways-to-apply.common-module ::ng-deep select{background-color:#fff!important}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: TextHeaderComponent, selector: "citi-text-header", inputs: ["ariaLevel", "level", "style", "bold", "class", "html", "ariaRole", "htmlContent"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ActionD1Component, decorators: [{
            type: Component,
            args: [{ selector: 'citi-action-d1', standalone: false, template: `
  <section class="{{isWhiteBG ? '' : 'theme-gray'}}">
    <div class="ways-to-apply common-module container-fluid">
        <div class="row">
            <div class="col-md-8 col-md-offset-2">
                <div class="text-center standard-header" *ngIf="headerText">
                    <!-- <h1 class="header-2">{{headerText}}</h1> -->
                    <citi-text-header [style]="2" [level]="headerLevel" [htmlContent]="headerText" [ariaLevel]="ariaLevel"></citi-text-header>
                    <ng-content select="[paragraphtext]"></ng-content>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-8 col-md-offset-2">
                <div class=" text-center" [ngClass]="{'no-buttons-body-d-1-4': type=='d-1-4'}" *ngIf="introText">
                    <p [innerHtml]="introText"></p>
                    <ng-content select="[actioncontent]"></ng-content>
                </div>
            </div>
        </div>
        <div class="common-module-body text-center">
            <ng-content select="[actioncontent1]"></ng-content>
        </div>
        <div class="row bottom-half">
            <ng-content select="[actioncontent2]"></ng-content>
        </div>

        <div class="common-module-body text-center no-buttons-body" *ngIf="isBottomContentRequired"></div>

        <div class="row bottom-half">
            <div class="col-md-8 col-md-offset-2">
                <div class="common-module-col text-center">
                    <ng-content select="[actioncontent3]"></ng-content>
                </div>
            </div>
        </div>
    </div>
</section>

  `, styles: [".theme-gray .ways-to-apply.common-module ::ng-deep select{background-color:#fff!important}\n"] }]
        }], ctorParameters: () => [], propDecorators: { actionType: [{
                type: Input$1
            }], headerText: [{
                type: Input$1
            }], headerLevel: [{
                type: Input$1
            }], ariaLevel: [{
                type: Input$1
            }], isWhiteBG: [{
                type: Input$1
            }], introText: [{
                type: Input$1
            }], isBottomContentRequired: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }] } });

class ActionSubContentComponent {
    constructor() { }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ActionSubContentComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: ActionSubContentComponent, isStandalone: false, selector: "citi-action-sub-content", inputs: { headerText: "headerText", introText: "introText", linkUrl: "linkUrl", htmlContent: "htmlContent" }, ngImport: i0, template: `
  <div class="col-sm-4">
    <div class="common-module-col text-center">
        <ng-content></ng-content>
    </div>
  </div>
  `, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ActionSubContentComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'citi-action-sub-content',
                    standalone: false,
                    template: `
  <div class="col-sm-4">
    <div class="common-module-col text-center">
        <ng-content></ng-content>
    </div>
  </div>
  `
                }]
        }], ctorParameters: () => [], propDecorators: { headerText: [{
                type: Input$1
            }], introText: [{
                type: Input$1
            }], linkUrl: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }] } });

class ActionTwoColumnComponent {
    constructor() { }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ActionTwoColumnComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: ActionTwoColumnComponent, isStandalone: false, selector: "citi-action-two-column", inputs: { headerText: "headerText", introText: "introText", linkUrl: "linkUrl", htmlContent: "htmlContent" }, ngImport: i0, template: `
  <div class="row d-1-1-no-hr">
    <div class="col-sm-6 contact-info">
        <ng-content select="[actioncolumn1]"></ng-content>
    </div>
    <div class="col-sm-6 contact-info">
        <div class="common-module-col text-center">
            <ng-content select="[actioncolumn2]"></ng-content>
        </div>
    </div>
  </div>
  `, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ActionTwoColumnComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'citi-action-two-column',
                    standalone: false,
                    template: `
  <div class="row d-1-1-no-hr">
    <div class="col-sm-6 contact-info">
        <ng-content select="[actioncolumn1]"></ng-content>
    </div>
    <div class="col-sm-6 contact-info">
        <div class="common-module-col text-center">
            <ng-content select="[actioncolumn2]"></ng-content>
        </div>
    </div>
  </div>
  `
                }]
        }], ctorParameters: () => [], propDecorators: { headerText: [{
                type: Input$1
            }], introText: [{
                type: Input$1
            }], linkUrl: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }] } });

const COMPONENTS$o = [
    ActionD1Component,
    ActionSubContentComponent,
    ActionTwoColumnComponent
];
const MODULES$q = [
    CommonModule,
    ActionMatchHeight,
    TextHeader
];
class ActionD1Series {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ActionD1Series, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: ActionD1Series, declarations: [ActionD1Component,
            ActionSubContentComponent,
            ActionTwoColumnComponent], imports: [CommonModule,
            ActionMatchHeight,
            TextHeader], exports: [ActionD1Component,
            ActionSubContentComponent,
            ActionTwoColumnComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ActionD1Series, imports: [MODULES$q] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ActionD1Series, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$q],
                    declarations: [...COMPONENTS$o],
                    exports: [...COMPONENTS$o]
                }]
        }] });

/**
 * @Component: Action Module Section
 * @Section: Modules
 * @description This component generates a basic Action section (D3.0, D3.1, D3.2, D3.3)
 */
class ActionD3Component {
    constructor() {
        /*
        * @property headerLevel
        * @description Alternate text header levels. Defaults to one.
        * @return number
        */
        this.headerLevel = 1;
        if (isDevMode()) {
            console.error('%cThe Common UI DDL ActionD3 <citi-action-d3> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ActionD3Component, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: ActionD3Component, isStandalone: false, selector: "citi-action-d3", inputs: { headerText: "headerText", headerLevel: "headerLevel", htmlContent: "htmlContent" }, ngImport: i0, template: `
    <section class="container-fluid">
      <div class="contact-us">
          <div class="contact-us-content">
              <div class="contact-us-header" *ngIf="headerText">
                <citi-text-header *ngIf="headerText" [level]="headerLevel" [htmlContent]="headerText" [style]="2"></citi-text-header>
              </div>
              <ng-content select="[actioncontent1]"></ng-content>
          </div>
      </div>
  </section>
`, isInline: true, styles: [""], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: TextHeaderComponent, selector: "citi-text-header", inputs: ["ariaLevel", "level", "style", "bold", "class", "html", "ariaRole", "htmlContent"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ActionD3Component, decorators: [{
            type: Component,
            args: [{ selector: 'citi-action-d3', standalone: false, template: `
    <section class="container-fluid">
      <div class="contact-us">
          <div class="contact-us-content">
              <div class="contact-us-header" *ngIf="headerText">
                <citi-text-header *ngIf="headerText" [level]="headerLevel" [htmlContent]="headerText" [style]="2"></citi-text-header>
              </div>
              <ng-content select="[actioncontent1]"></ng-content>
          </div>
      </div>
  </section>
` }]
        }], ctorParameters: () => [], propDecorators: { headerText: [{
                type: Input$1
            }], headerLevel: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }] } });

const COMPONENTS$n = [
    ActionD3Component
];
const MODULES$p = [
    CommonModule,
    ActionMatchHeight,
    TextHeader
];
class ActionD3 {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ActionD3, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: ActionD3, declarations: [ActionD3Component], imports: [CommonModule,
            ActionMatchHeight,
            TextHeader], exports: [ActionD3Component] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ActionD3, imports: [MODULES$p] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ActionD3, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$p],
                    declarations: [...COMPONENTS$n],
                    exports: [ActionD3Component]
                }]
        }] });

/**
 * @Component: NewComponent
 * @Section: Modules
 * @description This component generates...
 */
class ActionD34Component {
    // ---------- Constructor ----------- //
    constructor() {
        /*
        * @property headerLevel
        * @description Alternate text header levels. Defaults to one.
        * @return number
        */
        this.headerLevel = 1;
        if (isDevMode()) {
            console.error('%cThe Common UI DDL ActionD3_4 <citi-action-d3-4> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    ;
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ActionD34Component, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: ActionD34Component, isStandalone: false, selector: "citi-action-d3-4", inputs: { headerText: "headerText", headerLevel: "headerLevel", ariaLevel: "ariaLevel", htmlContent: "htmlContent" }, ngImport: i0, template: `
  <section class="container-fluid mainSection_3_4_Action">
    <div class="contact-us">
        <div class="contact-us-content">
            <div class="contact-us-header" *ngIf="headerText">
                <!-- <h1 class="header-2">{{headerText}}</h1> -->
                <citi-text-header [style]="2" [level]="headerLevel" [htmlContent]="headerText" [ariaLevel]="ariaLevel"></citi-text-header>
            </div>
            <ng-content select="[actioncontent2]"></ng-content>
        </div>
    </div>
</section>
`, isInline: true, dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: TextHeaderComponent, selector: "citi-text-header", inputs: ["ariaLevel", "level", "style", "bold", "class", "html", "ariaRole", "htmlContent"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ActionD34Component, decorators: [{
            type: Component,
            args: [{
                    selector: 'citi-action-d3-4',
                    standalone: false,
                    template: `
  <section class="container-fluid mainSection_3_4_Action">
    <div class="contact-us">
        <div class="contact-us-content">
            <div class="contact-us-header" *ngIf="headerText">
                <!-- <h1 class="header-2">{{headerText}}</h1> -->
                <citi-text-header [style]="2" [level]="headerLevel" [htmlContent]="headerText" [ariaLevel]="ariaLevel"></citi-text-header>
            </div>
            <ng-content select="[actioncontent2]"></ng-content>
        </div>
    </div>
</section>
`
                }]
        }], ctorParameters: () => [], propDecorators: { headerText: [{
                type: Input$1
            }], headerLevel: [{
                type: Input$1
            }], ariaLevel: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }] } });

// This Component
const COMPONENTS$m = [
    ActionD34Component
];
const MODULES$o = [
    CommonModule,
    ActionMatchHeight,
    Grid,
    TextHeader
];
// tslint:disable-next-line:class-name
class ActionD3_4 {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ActionD3_4, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: ActionD3_4, declarations: [ActionD34Component], imports: [CommonModule,
            ActionMatchHeight,
            Grid,
            TextHeader], exports: [ActionD34Component] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ActionD3_4, imports: [MODULES$o] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ActionD3_4, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$o],
                    declarations: [...COMPONENTS$m],
                    exports: [ActionD34Component]
                }]
        }] });

class ActionD9ColumnComponent {
    /**
     * @property type
     * @description type of the D9 action component be default d-9-0
     * @return string (either d-9-0 or d-9-1)
     */
    set actionType(type) {
        this.type = type;
    }
    constructor(renderer, el) {
        this.renderer = renderer;
        this.el = el;
        /**
         * @property xs
         * @description This defines the grid behavior for the xs grid resolution
         * @return number (1-12)
        */
        this.xs = 12;
        /**
         * @property md
         * @description This defines the grid behavior for the md grid resolution
         * @return number (1-12)
        */
        this.md = 2;
        this.type = 'd-9-0';
    }
    ngOnInit() { }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ActionD9ColumnComponent, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: ActionD9ColumnComponent, isStandalone: false, selector: "citi-action-d9-column", inputs: { xs: "xs", sm: "sm", md: "md", lg: "lg", offMd: "offMd", actionType: "actionType" }, ngImport: i0, template: `
  <citi-column [xs]="xs" [md]="md" [offMd]="offMd">
    <div class="full-width visible-xs visible-sm">
        <hr/>
    </div>
    <div class="five-col hRow" [ngClass]="{'priority': type=='d-9-1'}">
        <div class="hCol">
            <div class="equalHeightHeader">
                <ng-content select="[content1_0]"></ng-content>
            </div>
        </div>

        <hr class="thick" />
        <div class="hCol">
            <div class="equalHeightContent">
                <ng-content select="[content1_1]"></ng-content>
                <ng-content select="[content1_2]"></ng-content>
            </div>
        </div>
        <hr/>
        <div class="hCol">
            <div class="equalHeightParaGraph">
                <p class="fineprint">
                    <small>
                     <ng-content select="[content1_3]"></ng-content>
                </small>
                </p>
            </div>
        </div>
        <div class="common-module-body text-center">
            <ng-content select="[content1_4]"></ng-content>
        </div>
        <div class="common-module-body text-center">
            <ng-content select="[content1_5]"></ng-content>
        </div>
    </div>
  </citi-column>
`, isInline: true, styles: [""], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: ColumnComponent, selector: "citi-column, [citi-column]", inputs: ["xs", "sm", "md", "lg", "pullRight", "pullLeft", "offXs", "offSm", "offMd", "offLg", "classes", "htmlContent"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ActionD9ColumnComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-action-d9-column', standalone: false, template: `
  <citi-column [xs]="xs" [md]="md" [offMd]="offMd">
    <div class="full-width visible-xs visible-sm">
        <hr/>
    </div>
    <div class="five-col hRow" [ngClass]="{'priority': type=='d-9-1'}">
        <div class="hCol">
            <div class="equalHeightHeader">
                <ng-content select="[content1_0]"></ng-content>
            </div>
        </div>

        <hr class="thick" />
        <div class="hCol">
            <div class="equalHeightContent">
                <ng-content select="[content1_1]"></ng-content>
                <ng-content select="[content1_2]"></ng-content>
            </div>
        </div>
        <hr/>
        <div class="hCol">
            <div class="equalHeightParaGraph">
                <p class="fineprint">
                    <small>
                     <ng-content select="[content1_3]"></ng-content>
                </small>
                </p>
            </div>
        </div>
        <div class="common-module-body text-center">
            <ng-content select="[content1_4]"></ng-content>
        </div>
        <div class="common-module-body text-center">
            <ng-content select="[content1_5]"></ng-content>
        </div>
    </div>
  </citi-column>
` }]
        }], ctorParameters: () => [{ type: i0.Renderer2 }, { type: i0.ElementRef }], propDecorators: { xs: [{
                type: Input$1
            }], sm: [{
                type: Input$1
            }], md: [{
                type: Input$1
            }], lg: [{
                type: Input$1
            }], offMd: [{
                type: Input$1
            }], actionType: [{
                type: Input$1
            }] } });

/**
 * @Component: Action Module Section
 * @Section: Modules
 * @description This component generates a basic Action section (D9.0, D9.1)
 */
class ActionD9Component {
    /**
     * @property type
     * @description type of the D9 action component be default d-9-0
     * @return string (either d-9-0 or d-9-1)
     */
    set actionType(type) {
        this.type = type;
    }
    constructor() {
        this.type = 'd-9-0';
        /**
        * @property headerLevel
        * @description Header level for the component header
        * @return number
        */
        this.headerLevel = 1;
        if (isDevMode()) {
            console.error('%cThe Common UI DDL ActionD9 <citi-action-d9> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ActionD9Component, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: ActionD9Component, isStandalone: false, selector: "citi-action-d9", inputs: { headerText: "headerText", headerLevel: "headerLevel", ariaLevel: "ariaLevel", actionType: "actionType", htmlContent: "htmlContent" }, ngImport: i0, template: `
  <section class="action-module-d-9-0">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-offset-1 col-md-10">
                <div class="standard-header">
                    <citi-text-header [level]="headerLevel" [style]="2" [ariaLevel]="ariaLevel"> {{headerText}}</citi-text-header>
                </div>
                <div class="common-module-body">
                    <ng-content select="[content1]"></ng-content>
                </div>
            </div>
        </div>
        <div class="row hidden-xs">
            <div class="col-md-12">
                <div class="spacer_md-sm"></div>
            </div>
        </div>
        <div class="row hTable standard" [ngClass]="{'highlight': type=='d-9-1'}">
            <ng-content select="[content2]"></ng-content>
            <ng-content select="[content3]"></ng-content>
        </div>
        <div class="row hidden-xs hidden-sm">
            <div class="col-md-12">
                <div class="spacer_md-sm"></div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="full-width visible-xs visible-sm">
                    <hr/>
                </div>
                <div class="common-module-body text-center">
                    <ng-content select="[content4]"></ng-content>
                </div>
            </div>
        </div>
    </div>
  </section>
`, isInline: true, styles: [".action-module-d-9-0 ::ng-deep .list-check-mark li:first-child:last-child,.action-module-d-9-0 ::ng-deep .list-x-mark li:first-child:last-child{margin-bottom:9px}.action-module-d-9-0 ::ng-deep .modal .modal-header .header-level-6.modal-title,.action-module-d-9-0 ::ng-deep h2.header-level-6,:host-context(.modal .modal-header) .action-module-d-9-0 ::ng-deep .header-level-6.modal-title{margin-bottom:12px}.action-module-d-9-0 ::ng-deep .hTable.highlight .five-col.priority .large .popover-title,.action-module-d-9-0 ::ng-deep .hTable.highlight .five-col.priority h3,:host-context(.large) .action-module-d-9-0 ::ng-deep .hTable.highlight .five-col.priority .popover-title{padding-top:0!important}.action-module-d-9-0 ::ng-deep .hTable.highlight .five-col.priority .modal .modal-header .header-level-6.modal-title,.action-module-d-9-0 ::ng-deep .hTable.highlight .five-col.priority h2.header-level-6,:host-context(.modal .modal-header) .action-module-d-9-0 ::ng-deep .hTable.highlight .five-col.priority .header-level-6.modal-title{display:block}.action-module-d-9-0 ::ng-deep .hTable.highlight .five-col .modal .modal-header .header-level-6.modal-title,.action-module-d-9-0 ::ng-deep .hTable.highlight .five-col h2.header-level-6,:host-context(.modal .modal-header) .action-module-d-9-0 ::ng-deep .hTable.highlight .five-col .header-level-6.modal-title{display:none}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: TextHeaderComponent, selector: "citi-text-header", inputs: ["ariaLevel", "level", "style", "bold", "class", "html", "ariaRole", "htmlContent"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ActionD9Component, decorators: [{
            type: Component,
            args: [{ selector: 'citi-action-d9', standalone: false, template: `
  <section class="action-module-d-9-0">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-offset-1 col-md-10">
                <div class="standard-header">
                    <citi-text-header [level]="headerLevel" [style]="2" [ariaLevel]="ariaLevel"> {{headerText}}</citi-text-header>
                </div>
                <div class="common-module-body">
                    <ng-content select="[content1]"></ng-content>
                </div>
            </div>
        </div>
        <div class="row hidden-xs">
            <div class="col-md-12">
                <div class="spacer_md-sm"></div>
            </div>
        </div>
        <div class="row hTable standard" [ngClass]="{'highlight': type=='d-9-1'}">
            <ng-content select="[content2]"></ng-content>
            <ng-content select="[content3]"></ng-content>
        </div>
        <div class="row hidden-xs hidden-sm">
            <div class="col-md-12">
                <div class="spacer_md-sm"></div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="full-width visible-xs visible-sm">
                    <hr/>
                </div>
                <div class="common-module-body text-center">
                    <ng-content select="[content4]"></ng-content>
                </div>
            </div>
        </div>
    </div>
  </section>
`, styles: [".action-module-d-9-0 ::ng-deep .list-check-mark li:first-child:last-child,.action-module-d-9-0 ::ng-deep .list-x-mark li:first-child:last-child{margin-bottom:9px}.action-module-d-9-0 ::ng-deep .modal .modal-header .header-level-6.modal-title,.action-module-d-9-0 ::ng-deep h2.header-level-6,:host-context(.modal .modal-header) .action-module-d-9-0 ::ng-deep .header-level-6.modal-title{margin-bottom:12px}.action-module-d-9-0 ::ng-deep .hTable.highlight .five-col.priority .large .popover-title,.action-module-d-9-0 ::ng-deep .hTable.highlight .five-col.priority h3,:host-context(.large) .action-module-d-9-0 ::ng-deep .hTable.highlight .five-col.priority .popover-title{padding-top:0!important}.action-module-d-9-0 ::ng-deep .hTable.highlight .five-col.priority .modal .modal-header .header-level-6.modal-title,.action-module-d-9-0 ::ng-deep .hTable.highlight .five-col.priority h2.header-level-6,:host-context(.modal .modal-header) .action-module-d-9-0 ::ng-deep .hTable.highlight .five-col.priority .header-level-6.modal-title{display:block}.action-module-d-9-0 ::ng-deep .hTable.highlight .five-col .modal .modal-header .header-level-6.modal-title,.action-module-d-9-0 ::ng-deep .hTable.highlight .five-col h2.header-level-6,:host-context(.modal .modal-header) .action-module-d-9-0 ::ng-deep .hTable.highlight .five-col .header-level-6.modal-title{display:none}\n"] }]
        }], ctorParameters: () => [], propDecorators: { headerText: [{
                type: Input$1
            }], headerLevel: [{
                type: Input$1
            }], ariaLevel: [{
                type: Input$1
            }], actionType: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }] } });

const COMPONENTS$l = [
    ActionD9Component,
    ActionD9ColumnComponent
];
const MODULES$n = [
    CommonModule,
    ActionMatchHeight,
    TextHeader,
    Grid
];
class ActionD9 {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ActionD9, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: ActionD9, declarations: [ActionD9Component,
            ActionD9ColumnComponent], imports: [CommonModule,
            ActionMatchHeight,
            TextHeader,
            Grid], exports: [ActionD9Component, ActionD9ColumnComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ActionD9, imports: [MODULES$n] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ActionD9, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$n],
                    declarations: [...COMPONENTS$l],
                    exports: [ActionD9Component, ActionD9ColumnComponent]
                }]
        }] });

//export * from './action-faq-modal/public-api';

class ContentBlockComponent {
    constructor() {
        if (isDevMode()) {
            console.error('%cThe Common UI DDL ContentBlock <citi-content-block> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ContentBlockComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: ContentBlockComponent, isStandalone: false, selector: "citi-content-block", inputs: { blockHeader: "blockHeader", blockHeaderLevel: "blockHeaderLevel", blockMarkup: "blockMarkup" }, ngImport: i0, template: `
  <div *ngIf="blockMarkup" class="col-md-4 content-spacer">
    <div class="d-6-0-item content-block-content">
        <citi-text-header *ngIf="blockHeader"
          [level]="blockHeaderLevel"
          [style]="4"
          bold
          class="content-block-header"
          html="{{ blockHeader }}"
        ></citi-text-header>
        <div [innerHTML]="blockMarkup"></div>
    </div>
  </div>
  `, isInline: true, styles: [":host ::ng-deep .d-6-0-item.content-block-content{margin-bottom:36px}:host ::ng-deep .content-block-header{font-size:1rem;line-height:1.5rem;margin-bottom:1.1rem}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: TextHeaderComponent, selector: "citi-text-header", inputs: ["ariaLevel", "level", "style", "bold", "class", "html", "ariaRole", "htmlContent"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ContentBlockComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-content-block', standalone: false, template: `
  <div *ngIf="blockMarkup" class="col-md-4 content-spacer">
    <div class="d-6-0-item content-block-content">
        <citi-text-header *ngIf="blockHeader"
          [level]="blockHeaderLevel"
          [style]="4"
          bold
          class="content-block-header"
          html="{{ blockHeader }}"
        ></citi-text-header>
        <div [innerHTML]="blockMarkup"></div>
    </div>
  </div>
  `, styles: [":host ::ng-deep .d-6-0-item.content-block-content{margin-bottom:36px}:host ::ng-deep .content-block-header{font-size:1rem;line-height:1.5rem;margin-bottom:1.1rem}\n"] }]
        }], ctorParameters: () => [], propDecorators: { blockHeader: [{
                type: Input$1
            }], blockHeaderLevel: [{
                type: Input$1
            }], blockMarkup: [{
                type: Input$1
            }] } });

class ContentBlockStackComponent {
    constructor() {
        if (isDevMode()) {
            console.error('%cThe Common UI DDL ContentBlock <citi-content-block-stack> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ContentBlockStackComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: ContentBlockStackComponent, isStandalone: false, selector: "citi-content-block-stack", inputs: { headerLevel: "headerLevel", headerText: "headerText", htmlContent: "htmlContent" }, ngImport: i0, template: `
  <section class="action-module-d-6-0 container-fluid">
    <div class="d-6-content">
        <div class="row">
            <citi-text-header
              [level]="headerLevel"
              class="content-block-stack-header"
              [html]="headerText"
            ></citi-text-header>
            <div [contentHtml]="htmlContent">
                <ng-content></ng-content>
            </div>
        </div>
    </div>
  </section>
  `, isInline: true, styles: [":host ::ng-deep .content-block-stack-header{text-align:center}\n"], dependencies: [{ kind: "component", type: TextHeaderComponent, selector: "citi-text-header", inputs: ["ariaLevel", "level", "style", "bold", "class", "html", "ariaRole", "htmlContent"] }, { kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ContentBlockStackComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-content-block-stack', standalone: false, template: `
  <section class="action-module-d-6-0 container-fluid">
    <div class="d-6-content">
        <div class="row">
            <citi-text-header
              [level]="headerLevel"
              class="content-block-stack-header"
              [html]="headerText"
            ></citi-text-header>
            <div [contentHtml]="htmlContent">
                <ng-content></ng-content>
            </div>
        </div>
    </div>
  </section>
  `, styles: [":host ::ng-deep .content-block-stack-header{text-align:center}\n"] }]
        }], ctorParameters: () => [], propDecorators: { headerLevel: [{
                type: Input$1
            }], headerText: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }] } });

const COMPONENTS$k = [
    ContentBlockComponent,
    ContentBlockStackComponent
];
const MODULES$m = [
    CommonModule,
    TextHeader,
    ContentHtml
];
class ContentBlock {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ContentBlock, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: ContentBlock, declarations: [ContentBlockComponent,
            ContentBlockStackComponent], imports: [CommonModule,
            TextHeader,
            ContentHtml], exports: [ContentBlockComponent,
            ContentBlockStackComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ContentBlock, imports: [MODULES$m] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ContentBlock, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$m],
                    declarations: [...COMPONENTS$k],
                    exports: [...COMPONENTS$k]
                }]
        }] });

/**
 * @Component: Copy Section
 * @Section: Forms
 * @description This component generates a basic copy section (B1.0)
 */
class CopyComponent {
    constructor() {
        if (isDevMode()) {
            console.error('%cThe Common UI DDL PlainCopy <citi-copy-section> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CopyComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: CopyComponent, isStandalone: false, selector: "citi-copy-section", inputs: { title: "title", htmlContent: "htmlContent" }, ngImport: i0, template: `
    <section class="b-copy-modules">
        <div class="container-fluid">
            <div class="content-module">
                <div class="double-col-content">
                    <div class="row">
                        <div class="col-sm-10 col-md-9">
                            <h1 class="header-2">{{title}}</h1>
                            <p [contentHtml]="htmlContent">
                                <ng-content></ng-content>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
`, isInline: true, dependencies: [{ kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CopyComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'citi-copy-section',
                    standalone: false,
                    template: `
    <section class="b-copy-modules">
        <div class="container-fluid">
            <div class="content-module">
                <div class="double-col-content">
                    <div class="row">
                        <div class="col-sm-10 col-md-9">
                            <h1 class="header-2">{{title}}</h1>
                            <p [contentHtml]="htmlContent">
                                <ng-content></ng-content>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
`
                }]
        }], ctorParameters: () => [], propDecorators: { title: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }] } });

const COMPONENTS$j = [
    CopyComponent
];
const MODULES$l = [
    CommonModule,
    TextHeader,
    ContentHtml
];
class PlainCopy {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: PlainCopy, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: PlainCopy, declarations: [CopyComponent], imports: [CommonModule,
            TextHeader,
            ContentHtml], exports: [CopyComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: PlainCopy, imports: [MODULES$l] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: PlainCopy, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$l],
                    declarations: [...COMPONENTS$j],
                    exports: [CopyComponent]
                }]
        }] });

class CopyAccordionComponent {
    constructor() {
        if (isDevMode()) {
            console.error('%cThe Common UI DDL CopyAccordion <citi-copy-accordion> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CopyAccordionComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: CopyAccordionComponent, isStandalone: false, selector: "citi-copy-accordion", inputs: { htmlContent: "htmlContent" }, ngImport: i0, template: `
    <div class="copy-Accordion" [contentHtml]="htmlContent">
        <ng-content></ng-content>
    </div>
`, isInline: true, dependencies: [{ kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CopyAccordionComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'citi-copy-accordion',
                    standalone: false,
                    template: `
    <div class="copy-Accordion" [contentHtml]="htmlContent">
        <ng-content></ng-content>
    </div>
`
                }]
        }], ctorParameters: () => [], propDecorators: { htmlContent: [{
                type: Input$1
            }] } });

const COMPONENTS$i = [
    CopyAccordionComponent
];
const MODULES$k = [
    CommonModule,
    ContentHtml
];
class CopyAccordion {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CopyAccordion, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: CopyAccordion, declarations: [CopyAccordionComponent], imports: [CommonModule,
            ContentHtml], exports: [CopyAccordionComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CopyAccordion, imports: [MODULES$k] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CopyAccordion, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$k],
                    declarations: [...COMPONENTS$i],
                    exports: [CopyAccordionComponent]
                }]
        }] });

/**
 * @Component: Copy Section
 * @Section: Forms
 * @description This component generates a basic copy section (B5.5)
 */
class CopywarningLogoComponent {
    constructor() {
        if (isDevMode()) {
            console.error('%cThe Common UI DDL CopyWarningLogo <citi-copy-warning-logo> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CopywarningLogoComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: CopywarningLogoComponent, isStandalone: false, selector: "citi-copy-warning-logo", inputs: { altText: "altText", imageURL: "imageURL", htmlContent: "htmlContent" }, ngImport: i0, template: `
    <section class="b-5-5-copy">
        <div class="container-fluid">
            <div class="row row-eq-height">
                <div class="col-sm-1">
                    <div class="b-5-5-img-wrap">
                        <img [attr.alt]="altText" [attr.src]="imageURL" />
                    </div>
                </div>
                <div class="col-sm-11">
                    <div class="b-5-5-text-wrap" [contentHtml]="htmlContent">
                        <ng-content></ng-content>
                    </div>
                </div>
            </div>
        </div>
    </section>
    `, isInline: true, dependencies: [{ kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CopywarningLogoComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'citi-copy-warning-logo',
                    standalone: false,
                    template: `
    <section class="b-5-5-copy">
        <div class="container-fluid">
            <div class="row row-eq-height">
                <div class="col-sm-1">
                    <div class="b-5-5-img-wrap">
                        <img [attr.alt]="altText" [attr.src]="imageURL" />
                    </div>
                </div>
                <div class="col-sm-11">
                    <div class="b-5-5-text-wrap" [contentHtml]="htmlContent">
                        <ng-content></ng-content>
                    </div>
                </div>
            </div>
        </div>
    </section>
    `
                }]
        }], ctorParameters: () => [], propDecorators: { altText: [{
                type: Input$1
            }], imageURL: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }] } });

const MODULES$j = [CommonModule, ContentHtml];
class CopyWarningLogo {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CopyWarningLogo, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: CopyWarningLogo, declarations: [CopywarningLogoComponent], imports: [CommonModule, ContentHtml], exports: [CopywarningLogoComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CopyWarningLogo, imports: [MODULES$j] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CopyWarningLogo, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$j],
                    declarations: [CopywarningLogoComponent],
                    exports: [CopywarningLogoComponent]
                }]
        }] });

/**
 * @Component: Copy Section
 * @Section: Forms
 * @description This component generates a basic copy section (B5.0, B5.1, B5.2, B5.3, B5.4, B5.6)
 */
class CopywarningComponent {
    constructor() {
        if (isDevMode()) {
            console.error('%cThe Common UI DDL CopyWarning <citi-copy-warning> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CopywarningComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: CopywarningComponent, isStandalone: false, selector: "citi-copy-warning", inputs: { title: "title", altText: "altText", imageURL: "imageURL", htmlContent: "htmlContent" }, ngImport: i0, template: `
    <section class="b-5-copy">
        <div class="container-fluid">

                <div [contentHtml]="htmlContent">
                    <ng-content></ng-content>
                </div>

        </div>
    </section>
`, isInline: true, dependencies: [{ kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CopywarningComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'citi-copy-warning',
                    standalone: false,
                    template: `
    <section class="b-5-copy">
        <div class="container-fluid">

                <div [contentHtml]="htmlContent">
                    <ng-content></ng-content>
                </div>

        </div>
    </section>
`
                }]
        }], ctorParameters: () => [], propDecorators: { title: [{
                type: Input$1
            }], altText: [{
                type: Input$1
            }], imageURL: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }] } });

const COMPONENTS$h = [CopywarningComponent];
const MODULES$i = [CommonModule, ContentHtml];
class CopyWarning {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CopyWarning, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: CopyWarning, declarations: [CopywarningComponent], imports: [CommonModule, ContentHtml], exports: [CopywarningComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CopyWarning, imports: [MODULES$i] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CopyWarning, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$i],
                    declarations: [...COMPONENTS$h],
                    exports: [CopywarningComponent]
                }]
        }] });

/**
 * @Component: List Section
 * @Section: ButtonsLinksLists
 * @description This component generates a list section (B1.1, B1.2, B1.3, B1.4, and B1.5)
 */
class ListComponent {
    constructor() {
        if (isDevMode()) {
            console.error('%cThe Common UI DDL CopyContentList <citi-copy-list-section> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: ListComponent, isStandalone: false, selector: "citi-copy-list-section", inputs: { title: "title", htmlContent: "htmlContent" }, ngImport: i0, template: `
    <section class="b-copy-modules">
        <div class="container-fluid">
            <div class="content-module">
                <div class="row">
                    <div class="col-sm-10 col-md-9">
                        <citi-text-header level="2">
                            {{title}}
                        </citi-text-header>
                        <div [contentHtml]="htmlContent">
                            <ng-content></ng-content>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
`, isInline: true, dependencies: [{ kind: "component", type: TextHeaderComponent, selector: "citi-text-header", inputs: ["ariaLevel", "level", "style", "bold", "class", "html", "ariaRole", "htmlContent"] }, { kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ListComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'citi-copy-list-section',
                    standalone: false,
                    template: `
    <section class="b-copy-modules">
        <div class="container-fluid">
            <div class="content-module">
                <div class="row">
                    <div class="col-sm-10 col-md-9">
                        <citi-text-header level="2">
                            {{title}}
                        </citi-text-header>
                        <div [contentHtml]="htmlContent">
                            <ng-content></ng-content>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
`
                }]
        }], ctorParameters: () => [], propDecorators: { title: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }] } });

const COMPONENTS$g = [
    ListComponent
];
const MODULES$h = [
    CommonModule,
    TextHeader,
    ContentHtml
];
class CopyContentList {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CopyContentList, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: CopyContentList, declarations: [ListComponent], imports: [CommonModule,
            TextHeader,
            ContentHtml], exports: [ListComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CopyContentList, imports: [MODULES$h] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CopyContentList, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$h],
                    declarations: [...COMPONENTS$g],
                    exports: [ListComponent]
                }]
        }] });

/**
 * @Component: Sub Content Section
 * @Section: Modules
 * @description This component generates a sub-content section (B3.0, B3.1, B3.2, B3.3)
 */
class SubContentSectionComponent {
    constructor() {
        if (isDevMode()) {
            console.error('%cThe Common UI DDL CopySubContent <citi-sub-content-section> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: SubContentSectionComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: SubContentSectionComponent, isStandalone: false, selector: "citi-sub-content-section", inputs: { title: "title", htmlContent: "htmlContent" }, ngImport: i0, template: `
    <div class="col-sm-6 copy-module-card">
        <h2 class="header-3" [innerHtml]="title">
        </h2>
        <div [contentHtml]="htmlContent">
            <ng-content></ng-content>
        </div>
    </div>
`, isInline: true, styles: [":host:nth-child(n+3) .copy-module-card{border-top:1px solid rgba(0,0,0,.25)!important}:host:nth-child(2n-1) .copy-module-card{position:relative}:host:nth-child(2n-1) .copy-module-card:before{content:\"\";width:1px;position:absolute;right:0;top:35px;bottom:35px;background:#00000040}\n"], dependencies: [{ kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: SubContentSectionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-sub-content-section', standalone: false, template: `
    <div class="col-sm-6 copy-module-card">
        <h2 class="header-3" [innerHtml]="title">
        </h2>
        <div [contentHtml]="htmlContent">
            <ng-content></ng-content>
        </div>
    </div>
`, styles: [":host:nth-child(n+3) .copy-module-card{border-top:1px solid rgba(0,0,0,.25)!important}:host:nth-child(2n-1) .copy-module-card{position:relative}:host:nth-child(2n-1) .copy-module-card:before{content:\"\";width:1px;position:absolute;right:0;top:35px;bottom:35px;background:#00000040}\n"] }]
        }], ctorParameters: () => [], propDecorators: { title: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }] } });

/**
 * @Component: Sub Content Block
 * @Section: Modules
 * @description This component generates a sub-content block (B3.0, B3.1, B3.2, B3.3)
 */
class SubContentComponent {
    constructor() {
        if (isDevMode()) {
            console.error('%cThe Common UI DDL CopySubContent <citi-sub-content-block> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: SubContentComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: SubContentComponent, isStandalone: false, selector: "citi-sub-content-block", inputs: { title: "title", description: "description", color: "color", htmlContent: "htmlContent" }, ngImport: i0, template: `
    <div class="copy-module-tiles">
        <header [attr.class]="(color === 'gray' ? 'header-gray-bg' : null)">
            <div class="row">
                <div class="col-md-9">
                    <citi-text-header level="2">
                        {{title}}
                    </citi-text-header>
                    <p [innerHtml]="description">
                    </p>
                </div>
            </div>
        </header>
        <div class="copy-module-body">
            <div class="row copy-module-cards" [contentHtml]="htmlContent">
                <ng-content></ng-content>
            </div>
        </div>
    </div>
`, isInline: true, styles: [".copy-module-cards:before{background:transparent!important}citi-text-header ::ng-deep h2{color:#fff}.header-gray-bg citi-text-header ::ng-deep h2{color:#000}\n"], dependencies: [{ kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }, { kind: "component", type: TextHeaderComponent, selector: "citi-text-header", inputs: ["ariaLevel", "level", "style", "bold", "class", "html", "ariaRole", "htmlContent"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: SubContentComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-sub-content-block', standalone: false, template: `
    <div class="copy-module-tiles">
        <header [attr.class]="(color === 'gray' ? 'header-gray-bg' : null)">
            <div class="row">
                <div class="col-md-9">
                    <citi-text-header level="2">
                        {{title}}
                    </citi-text-header>
                    <p [innerHtml]="description">
                    </p>
                </div>
            </div>
        </header>
        <div class="copy-module-body">
            <div class="row copy-module-cards" [contentHtml]="htmlContent">
                <ng-content></ng-content>
            </div>
        </div>
    </div>
`, styles: [".copy-module-cards:before{background:transparent!important}citi-text-header ::ng-deep h2{color:#fff}.header-gray-bg citi-text-header ::ng-deep h2{color:#000}\n"] }]
        }], ctorParameters: () => [], propDecorators: { title: [{
                type: Input$1
            }], description: [{
                type: Input$1
            }], color: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }] } });

const COMPONENTS$f = [
    SubContentComponent,
    SubContentSectionComponent
];
const MODULES$g = [
    CommonModule,
    ContentHtml,
    TextHeader
];
class CopySubContent {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CopySubContent, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: CopySubContent, declarations: [SubContentComponent,
            SubContentSectionComponent], imports: [CommonModule,
            ContentHtml,
            TextHeader], exports: [SubContentComponent,
            SubContentSectionComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CopySubContent, imports: [MODULES$g] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CopySubContent, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$g],
                    declarations: [...COMPONENTS$f],
                    exports: [...COMPONENTS$f]
                }]
        }] });

/**
 * @Component: Two Column List Section
 * @Section: Modules
 * @description This component generates a two column list Section (B2.0)
 */
class TwoColumnListSectionComponent {
    constructor() {
        if (isDevMode()) {
            console.error('%cThe Common UI DDL CopyTwoColumnList <citi-two-column-list-section> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TwoColumnListSectionComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: TwoColumnListSectionComponent, isStandalone: false, selector: "citi-two-column-list-section", inputs: { htmlContent: "htmlContent" }, ngImport: i0, template: `
    <div class="col-sm-6 content-spacer" [contentHtml]="htmlContent">
        <ng-content></ng-content>
    </div>
`, isInline: true, dependencies: [{ kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TwoColumnListSectionComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'citi-two-column-list-section',
                    standalone: false,
                    template: `
    <div class="col-sm-6 content-spacer" [contentHtml]="htmlContent">
        <ng-content></ng-content>
    </div>
`
                }]
        }], ctorParameters: () => [], propDecorators: { htmlContent: [{
                type: Input$1
            }] } });

/**
 * @Component: Two Column List Block
 * @Section: Modules
 * @description This component generates a two column list block (B2.0)
 */
class TwoColumnListComponent {
    constructor() {
        if (isDevMode()) {
            console.error('%cThe Common UI DDL CopyTwoColumnList <citi-two-column-list> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TwoColumnListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: TwoColumnListComponent, isStandalone: false, selector: "citi-two-column-list", inputs: { title: "title", htmlContent: "htmlContent" }, ngImport: i0, template: `
    <section class="b-copy-modules">
        <div class="container-fluid">
            <div class="double-col-content">

                                <h1 class="header-2 b-2-headline" [innerHtml]="title"></h1>

                            <div class="row" [contentHtml]="htmlContent">
                                <ng-content></ng-content>
                            </div>

            </div>
        </div>
    </section>
`, isInline: true, dependencies: [{ kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TwoColumnListComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'citi-two-column-list',
                    standalone: false,
                    template: `
    <section class="b-copy-modules">
        <div class="container-fluid">
            <div class="double-col-content">

                                <h1 class="header-2 b-2-headline" [innerHtml]="title"></h1>

                            <div class="row" [contentHtml]="htmlContent">
                                <ng-content></ng-content>
                            </div>

            </div>
        </div>
    </section>
`
                }]
        }], ctorParameters: () => [], propDecorators: { title: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }] } });

const COMPONENTS$e = [
    TwoColumnListComponent,
    TwoColumnListSectionComponent
];
const MODULES$f = [
    CommonModule,
    ContentHtml
];
class CopyTwoColumnList {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CopyTwoColumnList, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: CopyTwoColumnList, declarations: [TwoColumnListComponent,
            TwoColumnListSectionComponent], imports: [CommonModule,
            ContentHtml], exports: [TwoColumnListComponent, TwoColumnListSectionComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CopyTwoColumnList, imports: [MODULES$f] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CopyTwoColumnList, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$f],
                    declarations: [...COMPONENTS$e],
                    exports: [TwoColumnListComponent, TwoColumnListSectionComponent]
                }]
        }] });

/**
 * @Component: Two Column Title Grid Section
 * @Section: Modules
 * @description This component generates a two column title grid section (B1.6)
 */
class TitleGridSectionComponent {
    constructor() {
        if (isDevMode()) {
            console.error('%cThe Common UI DDL CopyTwoColumnTitleGrid <citi-title-grid-section> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TitleGridSectionComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: TitleGridSectionComponent, isStandalone: false, selector: "citi-title-grid-section", inputs: { title: "title", htmlContent: "htmlContent" }, ngImport: i0, template: `
    <div class="col-sm-6 content-spacer">
        <citi-text-header level="3" bold="true" class="content-subheading">
            {{title}}
        </citi-text-header>
        <p [contentHtml]="htmlContent">
            <ng-content></ng-content>
        </p>
    </div>
`, isInline: true, dependencies: [{ kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }, { kind: "component", type: TextHeaderComponent, selector: "citi-text-header", inputs: ["ariaLevel", "level", "style", "bold", "class", "html", "ariaRole", "htmlContent"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TitleGridSectionComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'citi-title-grid-section',
                    standalone: false,
                    template: `
    <div class="col-sm-6 content-spacer">
        <citi-text-header level="3" bold="true" class="content-subheading">
            {{title}}
        </citi-text-header>
        <p [contentHtml]="htmlContent">
            <ng-content></ng-content>
        </p>
    </div>
`
                }]
        }], ctorParameters: () => [], propDecorators: { title: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }] } });

/**
 * @Component: Two Column Title Grid Block
 * @Section: Modules
 * @description This component generates a two column list block (B1.6)
 */
class TwoColumnTitleGridComponent {
    constructor() {
        if (isDevMode()) {
            console.error('%cThe Common UI DDL CopyTwoColumnTitleGrid <citi-two-column-title-grid> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TwoColumnTitleGridComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: TwoColumnTitleGridComponent, isStandalone: false, selector: "citi-two-column-title-grid", inputs: { htmlContent: "htmlContent", title: "title" }, ngImport: i0, template: `
    <section class="b-copy-modules">
        <div class="container-fluid">
            <div class="content-module">
                <div class="double-col-content">

                                    <citi-text-header level="2" class="header-2 b-1-6_header">
                                        {{title}}
                                    </citi-text-header>
                            <div class="row" [contentHtml]="htmlContent">
                                <ng-content></ng-content>
                            </div>


                </div>
            </div>
        </div>
    </section>
`, isInline: true, styles: [":host ::ng-deep citi-title-grid-section ::ng-deep .content-spacer{padding-bottom:20px!important}:host ::ng-deep citi-title-grid-section:nth-last-child(-n+2) ::ng-deep .content-spacer{padding-bottom:0!important}\n"], dependencies: [{ kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }, { kind: "component", type: TextHeaderComponent, selector: "citi-text-header", inputs: ["ariaLevel", "level", "style", "bold", "class", "html", "ariaRole", "htmlContent"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TwoColumnTitleGridComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-two-column-title-grid', standalone: false, template: `
    <section class="b-copy-modules">
        <div class="container-fluid">
            <div class="content-module">
                <div class="double-col-content">

                                    <citi-text-header level="2" class="header-2 b-1-6_header">
                                        {{title}}
                                    </citi-text-header>
                            <div class="row" [contentHtml]="htmlContent">
                                <ng-content></ng-content>
                            </div>


                </div>
            </div>
        </div>
    </section>
`, styles: [":host ::ng-deep citi-title-grid-section ::ng-deep .content-spacer{padding-bottom:20px!important}:host ::ng-deep citi-title-grid-section:nth-last-child(-n+2) ::ng-deep .content-spacer{padding-bottom:0!important}\n"] }]
        }], ctorParameters: () => [], propDecorators: { htmlContent: [{
                type: Input$1
            }], title: [{
                type: Input$1
            }] } });

const COMPONENTS$d = [
    TwoColumnTitleGridComponent,
    TitleGridSectionComponent
];
const MODULES$e = [
    CommonModule,
    ContentHtml,
    TextHeader
];
class CopyTwoColumnTitleGrid {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CopyTwoColumnTitleGrid, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: CopyTwoColumnTitleGrid, declarations: [TwoColumnTitleGridComponent,
            TitleGridSectionComponent], imports: [CommonModule,
            ContentHtml,
            TextHeader], exports: [TwoColumnTitleGridComponent, TitleGridSectionComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CopyTwoColumnTitleGrid, imports: [MODULES$e] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CopyTwoColumnTitleGrid, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$e],
                    declarations: [...COMPONENTS$d],
                    exports: [TwoColumnTitleGridComponent, TitleGridSectionComponent]
                }]
        }] });

/**
 * @Component: Photo Content
 * @Section: Modules
 * @description This is the photo component and
 * is used display an image with a quote
 */
class PhotoComponent {
    /**
     * @name setUrl
     * @description This function is to set the URL for the image.
     * @return Void
     */
    setUrl() {
        if (this.imgUrl) {
            this.pic.url = this.imgUrl;
        }
    }
    /**
     * @name setQuote
     * @description This function is to set the Quote for the image.
     * @return Void
     */
    setQuote() {
        if (this.imgQuote) {
            this.pic.quote = this.imgQuote;
        }
    }
    /**
     * @name setPosition
     * @description This function is to set the Position for the image.
     * @return Void
     */
    setPosition() {
        if (this.imgPosition === 'left') {
            this.pic.position = 'pull-out-quote pull-quote-content-p-1';
        }
        else if (this.imgPosition === 'right') {
            this.pic.position = 'pull-out-quote pull-quote-content-p-2';
        }
        else if (this.imgPosition === 'centre') {
            this.pic.position = 'pull-out-quote-3 pull-out-quote-p-3';
        }
    }
    constructor() {
        this.pic = {
            position: 'left',
            url: 'https://citi-ddl-ui.criticalmass.com/images/pull-out-quote-v2.png',
            quote: 'F1.0 Photo Content, lorem ipsum dolor sit amet, eu mel altera mandamus.\
            Legimus definiebas deterruisset id sea, ut nostro mel ipsum dolor'
        };
        if (isDevMode()) {
            console.error('%cThe Common UI DDL Photo <citi-photo> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    ngOnInit() {
        this.setPosition();
        this.setQuote();
        this.setUrl();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: PhotoComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: PhotoComponent, isStandalone: false, selector: "citi-photo", inputs: { imgUrl: "imgUrl", imgQuote: "imgQuote", imgPosition: "imgPosition" }, ngImport: i0, template: `
  <section class="f-1-photo">
    <div class="{{pic.position}}">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <blockquote class="pull-quote-content">
                        <p class="pull-quote-copy" [innerHtml]="pic.quote"></p>
                    </blockquote>
                    <div class="pull-quote-banner" [style.backgroundImage]=" 'url(' + pic.url + ')' "></div>
                </div>
            </div>
        </div>
    </div>
  </section>
`, isInline: true, styles: [".pull-quote-banner{background-size:cover}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: PhotoComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-photo', standalone: false, template: `
  <section class="f-1-photo">
    <div class="{{pic.position}}">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <blockquote class="pull-quote-content">
                        <p class="pull-quote-copy" [innerHtml]="pic.quote"></p>
                    </blockquote>
                    <div class="pull-quote-banner" [style.backgroundImage]=" 'url(' + pic.url + ')' "></div>
                </div>
            </div>
        </div>
    </div>
  </section>
`, styles: [".pull-quote-banner{background-size:cover}\n"] }]
        }], ctorParameters: () => [], propDecorators: { imgUrl: [{
                type: Input$1
            }], imgQuote: [{
                type: Input$1
            }], imgPosition: [{
                type: Input$1
            }] } });

const COMPONENTS$c = [
    PhotoComponent
];
const MODULES$d = [
    CommonModule,
];
class Photo {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Photo, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: Photo, declarations: [PhotoComponent], imports: [CommonModule], exports: [PhotoComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Photo, imports: [MODULES$d] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Photo, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$d],
                    declarations: [...COMPONENTS$c],
                    exports: [PhotoComponent]
                }]
        }] });

class PromoH1Component {
    constructor() {
        if (isDevMode()) {
            console.error('%cThe Common UI DDL PromoH1 <citi-promo-h1> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    ngOnInit() {
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: PromoH1Component, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: PromoH1Component, isStandalone: false, selector: "citi-promo-h1", inputs: { promoCopyText: "promoCopyText", linkText: "linkText", url: "url" }, ngImport: i0, template: `
  <section class="promo-modules">
    <div class="container-fluid">
        <div class="wrapper__h-1-0">
            <div class="row">
                <div class="col-md-12">
                    <p class="text-center"><span [innerHtml]="promoCopyText"></span> <a *ngIf="linkText" [href]="url" class="cta__h-1-0 chevron-link-white bold"><strong [innerHtml]="linkText"></strong></a></p>
                </div>
            </div>
        </div>
    </div>
  </section>
`, isInline: true, styles: [""], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: PromoH1Component, decorators: [{
            type: Component,
            args: [{ selector: 'citi-promo-h1', standalone: false, template: `
  <section class="promo-modules">
    <div class="container-fluid">
        <div class="wrapper__h-1-0">
            <div class="row">
                <div class="col-md-12">
                    <p class="text-center"><span [innerHtml]="promoCopyText"></span> <a *ngIf="linkText" [href]="url" class="cta__h-1-0 chevron-link-white bold"><strong [innerHtml]="linkText"></strong></a></p>
                </div>
            </div>
        </div>
    </div>
  </section>
` }]
        }], ctorParameters: () => [], propDecorators: { promoCopyText: [{
                type: Input$1
            }], linkText: [{
                type: Input$1
            }], url: [{
                type: Input$1
            }] } });

const COMPONENTS$b = [
    PromoH1Component
];
const MODULES$c = [
    CommonModule,
    // Directives    
];
class PromoH1 {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: PromoH1, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: PromoH1, declarations: [PromoH1Component], imports: [CommonModule], exports: [PromoH1Component] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: PromoH1, imports: [MODULES$c] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: PromoH1, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$c],
                    declarations: [...COMPONENTS$b],
                    exports: [PromoH1Component]
                }]
        }] });

class PromoH2Component {
    constructor() {
        // Classes to be applied to the input
        this.styleClasses = {
            'chevron-link-white': false,
            'chevron-link': true
        };
        // Classes to be applied to the input
        this.promoTheme = {
            'blue-promo': false,
            'gray-promo': false
        };
        this.CTAButtonClicked = new EventEmitter();
        if (isDevMode()) {
            console.error('%cThe Common UI DDL PromoH2 <citi-promo-h2> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    clickCTA() {
        this.CTAButtonClicked.emit(this);
    }
    ngOnInit() {
        if (this.isBluePromo) {
            this.styleClasses['chevron-link-white'] = true;
            this.styleClasses['chevron-link'] = false;
            this.promoTheme['blue-promo'] = true;
        }
        if (this.isGreyPromo) {
            this.promoTheme['gray-promo'] = true;
            this.promoTheme['blue-promo'] = false;
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: PromoH2Component, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: PromoH2Component, isStandalone: false, selector: "citi-promo-h2", inputs: { promoCopyText: "promoCopyText", promoSubText: "promoSubText", linkText: "linkText", url: "url", isBluePromo: "isBluePromo", htmlContent: "htmlContent", isGreyPromo: "isGreyPromo" }, outputs: { CTAButtonClicked: "CTAButtonClicked" }, ngImport: i0, template: `
  <section class="promo-modules">
    <div class="container-fluid">
        <div class="wrapper__h-2-0" [ngClass]="promoTheme">
            <div class="row">
                <div class="col-md-12">
                    <p *ngIf="promoSubText" class="text-center"><strong [innerHtml]="promoSubText"></strong></p>
                    <h1 class="header-3 text-center"><span [innerHtml]="promoCopyText"></span> <a *ngIf="linkText" [href]="url" (click)="clickCTA()" [ngClass]="styleClasses" class="chevron-lg bold"><strong [innerHtml]="linkText"></strong></a>
                    </h1>
                    <div [contentHtml]="htmlContent">
                        <ng-content></ng-content>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </section>
`, isInline: true, styles: [""], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: PromoH2Component, decorators: [{
            type: Component,
            args: [{ selector: 'citi-promo-h2', standalone: false, template: `
  <section class="promo-modules">
    <div class="container-fluid">
        <div class="wrapper__h-2-0" [ngClass]="promoTheme">
            <div class="row">
                <div class="col-md-12">
                    <p *ngIf="promoSubText" class="text-center"><strong [innerHtml]="promoSubText"></strong></p>
                    <h1 class="header-3 text-center"><span [innerHtml]="promoCopyText"></span> <a *ngIf="linkText" [href]="url" (click)="clickCTA()" [ngClass]="styleClasses" class="chevron-lg bold"><strong [innerHtml]="linkText"></strong></a>
                    </h1>
                    <div [contentHtml]="htmlContent">
                        <ng-content></ng-content>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </section>
` }]
        }], ctorParameters: () => [], propDecorators: { promoCopyText: [{
                type: Input$1
            }], promoSubText: [{
                type: Input$1
            }], linkText: [{
                type: Input$1
            }], url: [{
                type: Input$1
            }], isBluePromo: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }], isGreyPromo: [{
                type: Input$1
            }], CTAButtonClicked: [{
                type: Output
            }] } });

const COMPONENTS$a = [PromoH2Component];
const MODULES$b = [CommonModule, ContentHtml];
class PromoH2 {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: PromoH2, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: PromoH2, declarations: [PromoH2Component], imports: [CommonModule, ContentHtml], exports: [PromoH2Component] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: PromoH2, imports: [MODULES$b] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: PromoH2, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$b],
                    declarations: [...COMPONENTS$a],
                    exports: [PromoH2Component]
                }]
        }] });

// ----------- Imports ------------- //
// ---------- Component ------------ //
/**
 * @Component: PromoH4Component
 * @Section: Modules
 * @description This component generates a H4 Promo
 */
class PromoH4Component {
    // ---------- Constructor ----------- //
    constructor() {
        /**
        * @property imageAlternativeText
        * @description Alternative text for image in the promo
        * @return string
        */
        this.imageAlternativeText = null;
        /**
        * @Event: primaryButtonClick
        * @description This event that is fired when the primary button of the promo changes.
        * Can be bound to with (primaryButtonClick)='myFunction($event)'
        * @return Object
        */
        this.primaryButtonClick = new EventEmitter();
        if (isDevMode()) {
            console.error('%cThe Common UI DDL PromoH4 <citi-promo-h4> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    ;
    /** This function is being called from primary button in Promo, fires the event to to eventEmitter object,
  and passing parameter 'e' for the use on consuming side
  */
    primaryButtonClicked(e) {
        this.primaryButtonClick.emit(e);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: PromoH4Component, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: PromoH4Component, isStandalone: false, selector: "citi-promo-h4", inputs: { headerText: "headerText", promoCopyText: "promoCopyText", imageUrl: "imageUrl", imageAlternativeText: "imageAlternativeText", primaryButtonText: "primaryButtonText", primaryButtonUrl: "primaryButtonUrl", primaryButtonTarget: "primaryButtonTarget" }, outputs: { primaryButtonClick: "primaryButtonClick" }, ngImport: i0, template: `
    <section class="promo-modules">
      <div class="container-fluid">
        <div class="wrapper__h-4-0">
          <citi-row>
            <citi-column sm="5" offSm="1" md="5" offMd="1">
              <div class="image-container">
                <img [attr.src]="imageUrl" class="img-responsive" [attr.alt]="imageAlternativeText"/>
              </div>
            </citi-column>
            <citi-column sm="5" md="5">
              <div class="promo-content">
                <h1 class="header-2 promo-header"><span [innerHtml]="headerText"></span></h1>
                <p class="promo-text" [innerHtml]="promoCopyText"></p>
                <citi-cta type="primary" [value]="primaryButtonText" [href]="primaryButtonUrl" [target]="primaryButtonTarget" (ctaClick)="primaryButtonClicked($event)"></citi-cta>
              </div>
            </citi-column>
          </citi-row>
        </div>
      </div>
    </section>

  `, isInline: true, dependencies: [{ kind: "component", type: ColumnComponent, selector: "citi-column, [citi-column]", inputs: ["xs", "sm", "md", "lg", "pullRight", "pullLeft", "offXs", "offSm", "offMd", "offLg", "classes", "htmlContent"] }, { kind: "component", type: RowComponent, selector: "citi-row, [citi-row]", inputs: ["classes", "htmlContent"] }, { kind: "component", type: CTAComponent, selector: "citi-cta", inputs: ["textAlign", "bold", "noMargin", "tabIndex", "ariaDescription", "ariaLabeledBy", "ariaHasPopup", "ariaRole", "ariaLabel", "ariaControls", "ariaExpanded", "router", "queryParams", "idStr", "dataTarget", "addJFPToken", "doNotAddJFPToken", "buttonType", "target", "href", "value", "disabled", "type", "size", "arrow", "leftArrow"], outputs: ["ctaClick", "disabledChange", "ctaFocus", "ctaBlur"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: PromoH4Component, decorators: [{
            type: Component,
            args: [{
                    selector: 'citi-promo-h4',
                    standalone: false,
                    template: `
    <section class="promo-modules">
      <div class="container-fluid">
        <div class="wrapper__h-4-0">
          <citi-row>
            <citi-column sm="5" offSm="1" md="5" offMd="1">
              <div class="image-container">
                <img [attr.src]="imageUrl" class="img-responsive" [attr.alt]="imageAlternativeText"/>
              </div>
            </citi-column>
            <citi-column sm="5" md="5">
              <div class="promo-content">
                <h1 class="header-2 promo-header"><span [innerHtml]="headerText"></span></h1>
                <p class="promo-text" [innerHtml]="promoCopyText"></p>
                <citi-cta type="primary" [value]="primaryButtonText" [href]="primaryButtonUrl" [target]="primaryButtonTarget" (ctaClick)="primaryButtonClicked($event)"></citi-cta>
              </div>
            </citi-column>
          </citi-row>
        </div>
      </div>
    </section>

  `
                }]
        }], ctorParameters: () => [], propDecorators: { headerText: [{
                type: Input$1
            }], promoCopyText: [{
                type: Input$1
            }], imageUrl: [{
                type: Input$1
            }], imageAlternativeText: [{
                type: Input$1
            }], primaryButtonText: [{
                type: Input$1
            }], primaryButtonUrl: [{
                type: Input$1
            }], primaryButtonTarget: [{
                type: Input$1
            }], primaryButtonClick: [{
                type: Output
            }] } });

const COMPONENTS$9 = [PromoH4Component];
const MODULES$a = [CommonModule, Grid, CTA];
class PromoH4 {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: PromoH4, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: PromoH4, declarations: [PromoH4Component], imports: [CommonModule, Grid, CTA], exports: [PromoH4Component] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: PromoH4, imports: [MODULES$a] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: PromoH4, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$a],
                    declarations: [...COMPONENTS$9],
                    exports: [PromoH4Component]
                }]
        }] });

class ToolsE1Component {
    constructor() {
        this._isExpanded = false;
        if (isDevMode()) {
            console.error('%cThe Common UI DDL E1Tool <citi-tools-e1> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    get isExpanded() {
        return this._isExpanded;
    }
    /*
      * @property isExpanded
      * @description This defines whether isExpanded needs to be expanded by default tools module
      * @return string
      */
    set isExpanded(value) {
        this._isExpanded = value;
    }
    onClickBtn1(event) {
        this.isExpanded = !this.isExpanded;
    }
    ngOnInit() {
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ToolsE1Component, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: ToolsE1Component, isStandalone: false, selector: "citi-tools-e1", inputs: { headerText: "headerText", buttonText: "buttonText", htmlContent: "htmlContent", isExpanded: "isExpanded" }, host: { listeners: { "onClickBtn1": "onClickBtn1($event)" } }, ngImport: i0, template: `
  <section class="e-1-tool container-fluid">

            <div class="e-1-tool-container">
                <div class="row">
                    <div class="col-md-12 text-center">
                        <div class="e-1-inner-wrap">
                            <h1 class="header-3">
                              <span [innerHtml]="headerText"></span>
                              <button class="e-1-header btn-secondary btn"
                              (click)="onClickBtn1($event)"
                              aria-controls="e-1-0-tool-a"
                              [attr.aria-expanded]="(isExpanded ? 'true' : 'false')">
                                <strong [innerHtml]="buttonText"></strong>
                                <span class="down-arrow"></span>
                              </button>
                            </h1>
                        </div>
                    </div>
                </div>
                <div class="e-1-dropdown-wrap text-center expand-collapse-wrap expandable-panel {{isExpanded ? 'is-expanded' : 'is-collapsed'}}" aria-hidden="true" id="e-1-0-tool-a">
                    <div [contentHtml]="htmlContent">
                        <ng-content></ng-content>
                    </div>
                </div>
            </div>


</section>
  `, isInline: true, styles: [".expanded-content.is-expanded{height:100%;visibility:visible;overflow-y:visible}.expanded-content.is-collapsed{height:0;visibility:hidden;overflow-y:hidden}\n"], dependencies: [{ kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ToolsE1Component, decorators: [{
            type: Component,
            args: [{ selector: 'citi-tools-e1', standalone: false, template: `
  <section class="e-1-tool container-fluid">

            <div class="e-1-tool-container">
                <div class="row">
                    <div class="col-md-12 text-center">
                        <div class="e-1-inner-wrap">
                            <h1 class="header-3">
                              <span [innerHtml]="headerText"></span>
                              <button class="e-1-header btn-secondary btn"
                              (click)="onClickBtn1($event)"
                              aria-controls="e-1-0-tool-a"
                              [attr.aria-expanded]="(isExpanded ? 'true' : 'false')">
                                <strong [innerHtml]="buttonText"></strong>
                                <span class="down-arrow"></span>
                              </button>
                            </h1>
                        </div>
                    </div>
                </div>
                <div class="e-1-dropdown-wrap text-center expand-collapse-wrap expandable-panel {{isExpanded ? 'is-expanded' : 'is-collapsed'}}" aria-hidden="true" id="e-1-0-tool-a">
                    <div [contentHtml]="htmlContent">
                        <ng-content></ng-content>
                    </div>
                </div>
            </div>


</section>
  `, styles: [".expanded-content.is-expanded{height:100%;visibility:visible;overflow-y:visible}.expanded-content.is-collapsed{height:0;visibility:hidden;overflow-y:hidden}\n"] }]
        }], ctorParameters: () => [], propDecorators: { headerText: [{
                type: Input$1
            }], buttonText: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }], isExpanded: [{
                type: Input$1
            }], onClickBtn1: [{
                type: HostListener,
                args: ['onClickBtn1', ['$event']]
            }] } });

const MODULES$9 = [
    CommonModule,
    ContentHtml
];
class E1Tool {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: E1Tool, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: E1Tool, declarations: [ToolsE1Component], imports: [CommonModule,
            ContentHtml], exports: [ToolsE1Component] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: E1Tool, imports: [MODULES$9] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: E1Tool, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$9],
                    declarations: [ToolsE1Component],
                    exports: [ToolsE1Component]
                }]
        }] });

/**
 * @Component: tools Section
 * @Section: module
 * @description This component generates a basic tools section (E2.0)
 */
class ToolsE2Component {
    constructor() {
        if (isDevMode()) {
            console.error('%cThe Common UI DDL E2Tool <citi-tools-e2> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    ngOnInit() {
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ToolsE2Component, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: ToolsE2Component, isStandalone: false, selector: "citi-tools-e2", inputs: { htmlContent: "htmlContent" }, ngImport: i0, template: `
  <section class="theme-gray e-2-tool text-center sectionBleed">
    <div class="container-fluid">
        <span class="header__e-2">
            <ng-content select="[content1]"></ng-content>
        </span>
    </div>
  </section>
  `, isInline: true, styles: [".e-2-tool .btn.modal-btn-reset{text-decoration:underline;color:#056dae;border:none;background:0 0;box-shadow:none;font-weight:400;font-size:12px;font-size:.75rem;font-family:Interstate_Light,sans-serif;line-height:40px;margin-right:0;padding:1px 6px}.sectionBleed{position:relative}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ToolsE2Component, decorators: [{
            type: Component,
            args: [{ selector: 'citi-tools-e2', standalone: false, template: `
  <section class="theme-gray e-2-tool text-center sectionBleed">
    <div class="container-fluid">
        <span class="header__e-2">
            <ng-content select="[content1]"></ng-content>
        </span>
    </div>
  </section>
  `, styles: [".e-2-tool .btn.modal-btn-reset{text-decoration:underline;color:#056dae;border:none;background:0 0;box-shadow:none;font-weight:400;font-size:12px;font-size:.75rem;font-family:Interstate_Light,sans-serif;line-height:40px;margin-right:0;padding:1px 6px}.sectionBleed{position:relative}\n"] }]
        }], ctorParameters: () => [], propDecorators: { htmlContent: [{
                type: Input$1
            }] } });

class E2Tool {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: E2Tool, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: E2Tool, declarations: [ToolsE2Component], imports: [CommonModule], exports: [ToolsE2Component] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: E2Tool, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: E2Tool, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [ToolsE2Component],
                    exports: [ToolsE2Component]
                }]
        }] });

class ToolsE3Component {
    constructor(element, _sanitizer, _document) {
        this.element = element;
        this._sanitizer = _sanitizer;
        this._document = _document;
        /*
        * @property headerLevel
        * @description Alternate text header levels. Defaults to one.
        * @return string
        */
        this.headerLevel = 1;
        /**
         * @property isThemeGray
         * @description Gray theme is E3.0 defaut so a boolean was added to toggle it
         * @return string
         */
        this.isThemeGray = true;
        if (isDevMode()) {
            console.error('%cThe Common UI DDL E3Tool <citi-tools-e3> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    ngOnInit() {
    }
    getStyles() {
        return this._sanitizer.bypassSecurityTrustStyle('left:' + -this.element.nativeElement.offsetLeft + 'px; width:' + this._document.body.clientWidth + 'px');
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ToolsE3Component, deps: [{ token: i0.ElementRef }, { token: i1$2.DomSanitizer }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: ToolsE3Component, isStandalone: false, selector: "citi-tools-e3", inputs: { headerText: "headerText", headerLevel: "headerLevel", isThemeGray: "isThemeGray", toolType: "toolType" }, ngImport: i0, template: `
  <section class="e-3-tool e-3-0-tool sectionBleed {{isThemeGray ? 'theme-gray' : '' }} {{toolType == 'e-3-1' ? 'e-3-1-tool' : '' }}" [attr.style]="getStyles()">
    <div class="container-fluid">

        <div class="text-center">
          <ng-content select="[icon]"></ng-content>
          <citi-text-header
            [level]="headerLevel"
            [htmlContent]="headerText"
            [style]="2"
          ></citi-text-header>
        </div>

      <div class="row">
        <ng-content></ng-content>
      </div>
    </div>
  </section>
  `, isInline: true, styles: [".cbolui-ddl .btn-primary{margin:0!important}.sectionBleed{position:relative}.e-3-1-tool ::ng-deep .in-page-nav .nav-pills.nav-justified>li.active{box-shadow:0 0}.e-3-1-tool ::ng-deep .in-page-nav .tab-content .controlsGroup{margin-top:15px!important}@media (min-width: 768px){.e-3-1-tool .header-2.e-3-tool-header{margin-bottom:20px!important}}@media (max-width: 480px){.e-3-1-tool .header-2.e-3-tool-header{margin-bottom:40px!important}}::ng-deep .e-3-1-tool-result{border-left:1px solid #b3b3b3!important}::ng-deep .e-3-1-tool-result-v2{border-left:1px solid #b3b3b3!important}@media (max-width: 480px){::ng-deep .e-3-1-tool-result{border-left:.1px!important;border-top:1px solid #b3b3b3!important}::ng-deep .e-3-1-tool-result-v2{border-left:0px!important}}\n"], dependencies: [{ kind: "component", type: TextHeaderComponent, selector: "citi-text-header", inputs: ["ariaLevel", "level", "style", "bold", "class", "html", "ariaRole", "htmlContent"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ToolsE3Component, decorators: [{
            type: Component,
            args: [{ selector: 'citi-tools-e3', standalone: false, template: `
  <section class="e-3-tool e-3-0-tool sectionBleed {{isThemeGray ? 'theme-gray' : '' }} {{toolType == 'e-3-1' ? 'e-3-1-tool' : '' }}" [attr.style]="getStyles()">
    <div class="container-fluid">

        <div class="text-center">
          <ng-content select="[icon]"></ng-content>
          <citi-text-header
            [level]="headerLevel"
            [htmlContent]="headerText"
            [style]="2"
          ></citi-text-header>
        </div>

      <div class="row">
        <ng-content></ng-content>
      </div>
    </div>
  </section>
  `, styles: [".cbolui-ddl .btn-primary{margin:0!important}.sectionBleed{position:relative}.e-3-1-tool ::ng-deep .in-page-nav .nav-pills.nav-justified>li.active{box-shadow:0 0}.e-3-1-tool ::ng-deep .in-page-nav .tab-content .controlsGroup{margin-top:15px!important}@media (min-width: 768px){.e-3-1-tool .header-2.e-3-tool-header{margin-bottom:20px!important}}@media (max-width: 480px){.e-3-1-tool .header-2.e-3-tool-header{margin-bottom:40px!important}}::ng-deep .e-3-1-tool-result{border-left:1px solid #b3b3b3!important}::ng-deep .e-3-1-tool-result-v2{border-left:1px solid #b3b3b3!important}@media (max-width: 480px){::ng-deep .e-3-1-tool-result{border-left:.1px!important;border-top:1px solid #b3b3b3!important}::ng-deep .e-3-1-tool-result-v2{border-left:0px!important}}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i1$2.DomSanitizer }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }], propDecorators: { headerText: [{
                type: Input$1
            }], headerLevel: [{
                type: Input$1
            }], isThemeGray: [{
                type: Input$1
            }], toolType: [{
                type: Input$1
            }] } });

const COMPONENTS$8 = [
    ToolsE3Component
];
const MODULES$8 = [
    CommonModule,
    ContentHtml,
    TextHeader
];
class E3Tool {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: E3Tool, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: E3Tool, declarations: [ToolsE3Component], imports: [CommonModule,
            ContentHtml,
            TextHeader], exports: [ToolsE3Component] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: E3Tool, imports: [MODULES$8] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: E3Tool, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$8],
                    declarations: [...COMPONENTS$8],
                    exports: [ToolsE3Component]
                }]
        }] });

/**
 * @Component: Two Column Title Grid Section
 * @Section: Modules
 * @description This component generates a two column title grid section (for Video Module section. )
 */
class VideoGridSectionComponent {
    constructor() {
        if (isDevMode()) {
            console.error('%cThe Common UI DDL VideoComponent <citi-video-grid-section> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: VideoGridSectionComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: VideoGridSectionComponent, isStandalone: false, selector: "citi-video-grid-section", inputs: { isGrayBG: "isGrayBG", isVideoCardOverlay: "isVideoCardOverlay", htmlContent: "htmlContent" }, ngImport: i0, template: `
    <div *ngIf="!isVideoCardOverlay" class="col-sm-4 video-thumb tile">
        <ng-content select="[content]"></ng-content>
        <div class="thumb-blurb {{isGrayBG ? 'theme-gray' : ''}}">
            <ng-content select="[content1] "></ng-content>
        </div>
    </div>

    <div class="g-3-container" *ngIf="isVideoCardOverlay">
        <div class="col-sm-8 col-md-6 image-container">
            <ng-content select="[content2]"></ng-content>
        </div>

        <div class="col-sm-4 col-md-6 module-content">
            <ng-content select="[content3] "></ng-content>
        </div>
    </div>
    `, isInline: true, dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: VideoGridSectionComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'citi-video-grid-section',
                    standalone: false,
                    template: `
    <div *ngIf="!isVideoCardOverlay" class="col-sm-4 video-thumb tile">
        <ng-content select="[content]"></ng-content>
        <div class="thumb-blurb {{isGrayBG ? 'theme-gray' : ''}}">
            <ng-content select="[content1] "></ng-content>
        </div>
    </div>

    <div class="g-3-container" *ngIf="isVideoCardOverlay">
        <div class="col-sm-8 col-md-6 image-container">
            <ng-content select="[content2]"></ng-content>
        </div>

        <div class="col-sm-4 col-md-6 module-content">
            <ng-content select="[content3] "></ng-content>
        </div>
    </div>
    `
                }]
        }], ctorParameters: () => [], propDecorators: { isGrayBG: [{
                type: Input$1
            }], isVideoCardOverlay: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }] } });

/**
 * @Component: Video Module Section
 * @Section: Modules
 * @description This component generates a basic Action section (K1.0, K1.1 and K1.2)
 */
class VideoK1Component {
    constructor() {
        if (isDevMode()) {
            console.error('%cThe Common UI DDL VideoComponent <citi-video-k1_0> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    ngOnInit() {
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: VideoK1Component, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: VideoK1Component, isStandalone: false, selector: "citi-video-k1_0", inputs: { title: "title", isVideoCardOverlay: "isVideoCardOverlay", htmlContent: "htmlContent" }, ngImport: i0, template: `
  <div class="container-fluid showcase video-module {{isVideoCardOverlay ? 'video-module-1-1' : 'video-module-1-0'}}">

        <div class="text-center">
            <h1 *ngIf="title" class="header-2">{{title}}</h1>
        </div>

    <div class="row" [contentHtml]="htmlContent">
        <ng-content></ng-content>
    </div>
  </div>
  `, isInline: true, styles: [""], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: VideoK1Component, decorators: [{
            type: Component,
            args: [{ selector: 'citi-video-k1_0', standalone: false, template: `
  <div class="container-fluid showcase video-module {{isVideoCardOverlay ? 'video-module-1-1' : 'video-module-1-0'}}">

        <div class="text-center">
            <h1 *ngIf="title" class="header-2">{{title}}</h1>
        </div>

    <div class="row" [contentHtml]="htmlContent">
        <ng-content></ng-content>
    </div>
  </div>
  ` }]
        }], ctorParameters: () => [], propDecorators: { title: [{
                type: Input$1
            }], isVideoCardOverlay: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }] } });

class ModalSettings {
    constructor() {
        this.hideModal = true;
        this.primaryButtonDisabled = false;
        this.show = false;
        this.showCancelButton = false;
        this.showModal = false;
    }
}

/**
 * @Component: Modal
 * @description This component generates a Video Modal. can be used along with video section
 */
class VideoModalComponent {
    constructor(_document) {
        this._document = _document;
        // This variable is initialized with false so that it can prevent the initial showChange as there actually
        // is no change at the initializing phase
        this.isDisplayed = false;
        // Settings Object
        this.settings = new ModalSettings;
        // Function to open/close modal
        this.toggleModal = function (show) {
            // If the modal should be shown
            if (show === true) {
                // Create a reference to the button that opened the modal
                // this.openButton = document.activeElement;
                // Take display:none off the modal
                this.settings.hideModal = false;
                if (this.isDisplayed === false && !this.settings.hideModal) {
                    // We have to add the 'modal-open' class to disable the scrolling capability for the body element
                    this._document.getElementsByTagName('body')[0].className += ' modal-open';
                }
                // Wait for hideModal to be set
                setTimeout(() => {
                    // Fade in the modal
                    this.settings.showModal = true;
                    // Sets the isDisplayed to true to signal the event emitter to emit event in case the modal is displayed
                    this.isDisplayed = true;
                    // Focus modal container
                    this.modal.nativeElement.focus();
                    // Let the parent component know the module is open
                    // This is technically redundant since only the parent can
                    // set this in the first place, but you know, semantics
                    this.showChange.emit(true);
                }, 0);
            }
            else {
                // Otherwise fade out the modal
                this.settings.showModal = false;
                // We have to remove the 'modal-open' class to reactivate the scrolling capability for the body element
                this._document.getElementsByTagName('body')[0].className =
                    this._document.getElementsByTagName('body')[0].className.replace('modal-open', '');
                // Wait for the modal to fade out
                // The delay should match the CSS transition speed
                setTimeout(() => {
                    // Set display: none on the modal
                    this.settings.hideModal = true;
                    if (this.isDisplayed === true) {
                        // Let the parent know the modal is closed
                        this.showChange.emit(false);
                        // Sets the isDisplayed to false to prevent any event emitting not by showing the modal
                        this.isDisplayed = false;
                    }
                    // Focus the button that originally opened the modal
                    if (this.openButton && this.openButton !== null) {
                        this.openButton.focus();
                    }
                }, 150);
            }
        };
        /**
         * @property idStr
         * @description Sets the id attribute of the modal
         * @return string
         */
        this.idStr = null;
        /**
         * @Event: primaryButtonClick
         * @description This event that is fired when the primary button of the modal changes.
         * Can be bound to with (primaryButtonClick)='myFunction($event)'
         * @return Object
         */
        this.primaryButtonClick = new EventEmitter();
        /**
         * @Event: secondaryButtonClick
         * @description This event that is fired when the secondary button of the modal changes.
         * Can be bound to with (secondaryButtonClick)='myFunction($event)'
         * @return Object
         */
        this.secondaryButtonClick = new EventEmitter();
        /**
         * @Event: closeButtonClick
         * @description This event that is fired when the close button of the modal changes.
         * Can be bound to with (closeButtonClick)='myFunction($event)'
         * @return Object
         */
        this.closeButtonClick = new EventEmitter();
        /**
         * @Event: showChange
         * @description This event that is fired when the modal is hidden/displayed.
         * Can be bound to with (showChange)='myFunction($event)'.
         * Value 'true' in the parameter means the modal is displayed
         * Value 'false' in the parameter means the modal is hidden
         * @return Object
         */
        this.showChange = new EventEmitter();
        if (isDevMode()) {
            console.error('%cThe Common UI DDL VideoComponent <citi-video-modal> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    // The OnInit function handles capturing tab order
    ngOnInit() {
        // Wait for the lifecycle to finish
        setTimeout(() => {
            // Get DOM node list of all tabbable elements
            let tabbableElements = this.modal.nativeElement.querySelectorAll('\
                a[href],\
                area[href],\
                button:enabled,\
                iframe,\
                input:enabled,\
                textarea:enabled,\
                [tabindex]:not([tabindex=\'-1\'])\
            ');
            // convert tabbleElements into and array
            let tabbables = [
                ...Array.prototype.slice.call(tabbableElements)
            ];
            let lastItem = tabbables[tabbables.length - 1];
            // Listen for keydown events on the modal
            this.modal.nativeElement.addEventListener('keydown', (e) => {
                // If the key pressed was the tab button
                if (e.keyCode === 9 && !e.shiftKey) {
                    // If the currently active element is the last button
                    if (lastItem && this._document.activeElement === lastItem
                        ||
                            !lastItem && this._document.activeElement === this.primaryButton.button.nativeElement) {
                        // Prevent default action
                        e.preventDefault();
                        // Put focus on the close button
                        this.closeButton.nativeElement.focus();
                    }
                }
                else if (e.keyCode === 9 && e.shiftKey === true) {
                    // If the key pressed was shift+tab
                    // And the currently active button is the close button
                    if (this._document.activeElement === this.closeButton.nativeElement) {
                        // Prevent Default
                        e.preventDefault();
                        // Focus the last button
                        if (lastItem) {
                            lastItem.focus();
                        }
                    }
                }
            });
            if (this.primaryButton) {
                this.primaryButton.button.nativeElement.addEventListener('click', (e) => {
                    this.primaryButtonClick.emit(e);
                });
            }
            if (this.closeButton) {
                this.closeButton.nativeElement.addEventListener('click', (e) => {
                    this.closeButtonClick.emit(e);
                });
            }
            if (this.secondaryButton) {
                this.secondaryButton.button.nativeElement.addEventListener('click', (e) => {
                    this.secondaryButtonClick.emit(e);
                });
            }
        }, 0);
    }
    /**
     * @property show
     * @description Whether the modal should be open or not
     * @Type: boolean
     */
    set show(_show) {
        // If _show is defined
        if (typeof _show !== 'undefined') {
            if (_show === true) {
                // This query creates a more cross-browser solution to target the element as compared to document.activeElement
                // since the document.activeElement is not compatible with Safari
                let items = this._document.querySelectorAll('[data-target="#' + this.idStr + '"]');
                // Create a reference to the button that opened the modal
                this.openButton = items.length > 0 ? items[0] : null;
            }
            // Use the value to toggle the modal
            this.toggleModal(_show);
        }
    }
    /**
     * @property title
     * @description the title text for the modal
     * @return string
     */
    set title(title) {
        if (typeof title === 'string') {
            this.settings.title = title;
        }
        else {
            console.error('The value passed to title should be a string');
        }
    }
    /**
     * @property primaryButtonUrl
     * @description The url for the primary button
     * @return string
     */
    set primaryButtonUrl(url) {
        if (typeof url === 'string') {
            this.settings.primaryButtonUrl = url;
        }
        else {
            console.error('The value passed to primaryButtonUrl should be a string');
        }
    }
    /**
     * @property primaryButtonTarget
     * @description The target for the primary button
     * @return string
     */
    set primaryButtonTarget(target) {
        if (target === '_blank' || target === '_self') {
            this.settings.primaryButtonTarget = target;
        }
        else {
            console.error('The value passed to primaryButtonTarget should be either \'_blank\' or \'_self\'');
        }
    }
    /**
     * @property primaryButtonText
     * @description The value (display text) of the primary button
     * @return string
     */
    set primaryButtonText(text) {
        if (typeof text === 'string') {
            this.settings.primaryButtonText = text;
        }
        else {
            console.error('The value passed to primaryButtonText should be a string');
        }
    }
    /**
     * @property showCancelButton
     * @description Whether or not the cancel button should be shown
     * @Type: boolean
     */
    set showCancelButton(show) {
        if (show === 'true') {
            this.settings.showCancelButton = true;
        }
        else if (show === 'false') {
            this.settings.showCancelButton = false;
        }
        else if (typeof show === 'boolean') {
            this.settings.showCancelButton = show;
        }
        else {
            console.error('The value passed to showCancelButton should be a boolean');
        }
    }
    /**
     * @property disablePrimaryButton
     * @description Whether or not the primary button should be disabled
     * @Type: boolean
     */
    set disablePrimaryButton(disabled) {
        if (disabled === 'true') {
            this.settings.primaryButtonDisabled = true;
        }
        else if (disabled === 'false') {
            this.settings.primaryButtonDisabled = false;
        }
        else if (typeof disabled === 'boolean') {
            this.settings.primaryButtonDisabled = disabled;
        }
        else {
            console.error('The value passed to disablePrimaryButton should be a boolean');
        }
    }
    /**
     * @property cancelButtonText
     * @description The value (display text) for the cancel button
     * @return string
     */
    set cancelButtonText(text) {
        if (typeof text === 'string') {
            this.settings.cancelButtonText = text;
        }
        else {
            console.error('the value passsed to cancelButtonText should be a string');
        }
    }
    onEscape(event) {
        if (this.settings.showModal && event.key === 'Escape') {
            this.toggleModal(false);
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: VideoModalComponent, deps: [{ token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: VideoModalComponent, isStandalone: false, selector: "citi-video-modal", inputs: { videoURL: "videoURL", videoLabelReader: "videoLabelReader", show: "show", title: "title", primaryButtonUrl: "primaryButtonUrl", primaryButtonTarget: "primaryButtonTarget", primaryButtonText: "primaryButtonText", showCancelButton: "showCancelButton", disablePrimaryButton: "disablePrimaryButton", cancelButtonText: "cancelButtonText", scrollable: "scrollable", htmlContent: "htmlContent", idStr: "idStr" }, outputs: { primaryButtonClick: "primaryButtonClick", secondaryButtonClick: "secondaryButtonClick", closeButtonClick: "closeButtonClick", showChange: "showChange" }, host: { listeners: { "window:keydown": "onEscape($event)" } }, viewQueries: [{ propertyName: "modal", first: true, predicate: ["modal"], descendants: true }, { propertyName: "closeButton", first: true, predicate: ["closeButton"], descendants: true }, { propertyName: "primaryButton", first: true, predicate: ["primaryButton"], descendants: true }, { propertyName: "secondaryButton", first: true, predicate: ["secondaryButton"], descendants: true }, { propertyName: "wrapDiv", first: true, predicate: ["wrapDiv"], descendants: true }], ngImport: i0, template: `
  <div #wrapDiv tabindex="0" role="dialog" class="citi-modal citi-video-modal-container video-modal {{settings.showModal ? 'open' : ''}} {{settings.hideModal ? 'hide' : ''}}" [attr.id]="idStr">

    <!-- the black layer that overlays the page -->
    <div class="citi-modal-overlay" (click)="toggleModal(false)"></div>

    <!-- the actual content box -->
    <div #modal class="citi-modal-box" role="document" tabindex="-1">

        <!-- the close button -->
        <div class="citi-modal-close">
            <button #closeButton class="close" (click)="toggleModal(false)" aria-label="Close Popup"> ×</button>
        </div>

        <!-- the modal content -->
        <div class="citi-modal-content">
            <citi-text-header *ngIf="settings.title" level="2" [style]="2">{{settings.title}}</citi-text-header>
            <ng-content select="[content]"></ng-content>

        </div>
        <!-- the modal footer -->
        <div class="modal-footer">
            <section class="in-page-nav in-page-nav-lite tabs-2" [contentHtml]="htmlContent">
                <ng-content select="[content1]"></ng-content>
            </section>
        </div>
        <!-- the modal CTA placement -->
        <div class="citi-modal-controls" [hidden]="!settings.primaryButtonText && !settings.showCancelButton">
            <citi-cta #primaryButton [target]="settings.primaryButtonTarget" [href]="settings.primaryButtonUrl" [value]="settings.primaryButtonText" *ngIf="settings.primaryButtonText" [disabled]="settings.primaryButtonDisabled"></citi-cta>
            <citi-cta #secondaryButton type="tertiary" [value]="settings.cancelButtonText" (click)="toggleModal(false)" *ngIf="settings.showCancelButton && settings.cancelButtonText"></citi-cta>
        </div>

    </div>
  </div>
  `, isInline: true, styles: [".citi-modal{position:fixed;top:0;left:0;z-index:9999;width:100%;height:100%;overflow-y:auto;opacity:0;transition:opacity .15s linear}.citi-modal::-webkit-scrollbar{display:none}.citi-modal.hidden{display:none}.citi-modal.open{opacity:1;transition:opacity .15s linear}.citi-modal.open .citi-modal-box{top:30px;margin-bottom:30px;transition:top .25s linear}@media (max-width: 480px){.citi-modal.open .citi-modal-box{top:0}}.citi-modal .citi-modal-overlay{position:fixed;top:0;left:0;width:100%;height:100%;background-color:#0009}.citi-modal .citi-modal-box{position:relative;margin:0 auto;background:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.2);outline:none;width:55%;max-width:1200px;top:-30px;transition:top .25s linear}@media (max-width: 480px){.citi-modal .citi-modal-box{width:100%;max-height:100%;overflow:auto}}@media (min-width: 480px){.citi-modal .citi-modal-box{width:100%}}@media (min-width: 768px){.citi-modal .citi-modal-box{width:65%}}@media (min-width: 1200px){.citi-modal .citi-modal-box{width:60%}}@media (min-width: 1440px){.citi-modal .citi-modal-box{width:55%}}.citi-modal .citi-modal-box .citi-modal-close{text-align:right;display:flex;justify-content:flex-end;align-items:center;height:60px}@media (max-width: 480px){.citi-modal .citi-modal-box .citi-modal-close{height:45px}}.citi-modal .citi-modal-box .citi-modal-close button{text-indent:-9999px;margin:-5px 10px 0 0;border:none;padding:0;width:30px;height:30px}.citi-modal .citi-modal-box .citi-modal-content{margin:0 20px;padding:0 20px;overflow:auto}.citi-modal .citi-modal-box .citi-modal-content citi-text-header ::ng-deep h1{line-height:.8}@media (max-width: 480px){.citi-modal .citi-modal-box .citi-modal-content{max-height:260px}}.citi-modal .citi-modal-box .citi-modal-content.scrollable{max-height:360px;border-bottom:1px solid #000}.citi-modal .citi-modal-box .citi-modal-controls{display:flex;justify-content:flex-end;align-items:center;padding:20px}@media (max-width: 480px){.citi-modal .citi-modal-box .citi-modal-controls{display:block;padding:20px}}.citi-modal .citi-modal-box .citi-modal-controls>citi-cta{margin-right:20px}.citi-modal .citi-modal-box .citi-modal-controls>citi-cta:last-child{margin-right:0}@media (max-width: 480px){.citi-modal .citi-modal-box .citi-modal-controls>citi-cta{display:block;margin:0 0 20px;text-align:center}.citi-modal .citi-modal-box .citi-modal-controls>citi-cta:last-child{margin-bottom:0}}.citi-modal .citi-modal-close{padding:15px;border-bottom:1px solid #e5e5e5;min-height:16.5px}.citi-modal .citi-modal-close,.citi-modal .citi-modal-content{padding-left:20px;padding-right:20px}.citi-modal .citi-modal-content{border:none}:host-context(.e-2-tool) .citi-modal-content ::ng-deep p{font-size:1rem;line-height:1.5rem;font-family:Interstate_Light,sans-serif;text-align:left}.citi-modal-content ::ng-deep ul.lineDivided li{padding:20px 0;margin:0;list-style:none;background:0 0;border-top:1px solid rgba(0,0,0,.25);font-size:1rem;-webkit-font-smoothing:antialiased}.citi-modal-content ::ng-deep ul.lineDivided{padding:20px 0 0;margin:0}.citi-modal-content ::ng-deep .rowspan-table-module.grey{background-color:#fff}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: TextHeaderComponent, selector: "citi-text-header", inputs: ["ariaLevel", "level", "style", "bold", "class", "html", "ariaRole", "htmlContent"] }, { kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }, { kind: "component", type: CTAComponent, selector: "citi-cta", inputs: ["textAlign", "bold", "noMargin", "tabIndex", "ariaDescription", "ariaLabeledBy", "ariaHasPopup", "ariaRole", "ariaLabel", "ariaControls", "ariaExpanded", "router", "queryParams", "idStr", "dataTarget", "addJFPToken", "doNotAddJFPToken", "buttonType", "target", "href", "value", "disabled", "type", "size", "arrow", "leftArrow"], outputs: ["ctaClick", "disabledChange", "ctaFocus", "ctaBlur"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: VideoModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-video-modal', standalone: false, template: `
  <div #wrapDiv tabindex="0" role="dialog" class="citi-modal citi-video-modal-container video-modal {{settings.showModal ? 'open' : ''}} {{settings.hideModal ? 'hide' : ''}}" [attr.id]="idStr">

    <!-- the black layer that overlays the page -->
    <div class="citi-modal-overlay" (click)="toggleModal(false)"></div>

    <!-- the actual content box -->
    <div #modal class="citi-modal-box" role="document" tabindex="-1">

        <!-- the close button -->
        <div class="citi-modal-close">
            <button #closeButton class="close" (click)="toggleModal(false)" aria-label="Close Popup"> ×</button>
        </div>

        <!-- the modal content -->
        <div class="citi-modal-content">
            <citi-text-header *ngIf="settings.title" level="2" [style]="2">{{settings.title}}</citi-text-header>
            <ng-content select="[content]"></ng-content>

        </div>
        <!-- the modal footer -->
        <div class="modal-footer">
            <section class="in-page-nav in-page-nav-lite tabs-2" [contentHtml]="htmlContent">
                <ng-content select="[content1]"></ng-content>
            </section>
        </div>
        <!-- the modal CTA placement -->
        <div class="citi-modal-controls" [hidden]="!settings.primaryButtonText && !settings.showCancelButton">
            <citi-cta #primaryButton [target]="settings.primaryButtonTarget" [href]="settings.primaryButtonUrl" [value]="settings.primaryButtonText" *ngIf="settings.primaryButtonText" [disabled]="settings.primaryButtonDisabled"></citi-cta>
            <citi-cta #secondaryButton type="tertiary" [value]="settings.cancelButtonText" (click)="toggleModal(false)" *ngIf="settings.showCancelButton && settings.cancelButtonText"></citi-cta>
        </div>

    </div>
  </div>
  `, styles: [".citi-modal{position:fixed;top:0;left:0;z-index:9999;width:100%;height:100%;overflow-y:auto;opacity:0;transition:opacity .15s linear}.citi-modal::-webkit-scrollbar{display:none}.citi-modal.hidden{display:none}.citi-modal.open{opacity:1;transition:opacity .15s linear}.citi-modal.open .citi-modal-box{top:30px;margin-bottom:30px;transition:top .25s linear}@media (max-width: 480px){.citi-modal.open .citi-modal-box{top:0}}.citi-modal .citi-modal-overlay{position:fixed;top:0;left:0;width:100%;height:100%;background-color:#0009}.citi-modal .citi-modal-box{position:relative;margin:0 auto;background:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.2);outline:none;width:55%;max-width:1200px;top:-30px;transition:top .25s linear}@media (max-width: 480px){.citi-modal .citi-modal-box{width:100%;max-height:100%;overflow:auto}}@media (min-width: 480px){.citi-modal .citi-modal-box{width:100%}}@media (min-width: 768px){.citi-modal .citi-modal-box{width:65%}}@media (min-width: 1200px){.citi-modal .citi-modal-box{width:60%}}@media (min-width: 1440px){.citi-modal .citi-modal-box{width:55%}}.citi-modal .citi-modal-box .citi-modal-close{text-align:right;display:flex;justify-content:flex-end;align-items:center;height:60px}@media (max-width: 480px){.citi-modal .citi-modal-box .citi-modal-close{height:45px}}.citi-modal .citi-modal-box .citi-modal-close button{text-indent:-9999px;margin:-5px 10px 0 0;border:none;padding:0;width:30px;height:30px}.citi-modal .citi-modal-box .citi-modal-content{margin:0 20px;padding:0 20px;overflow:auto}.citi-modal .citi-modal-box .citi-modal-content citi-text-header ::ng-deep h1{line-height:.8}@media (max-width: 480px){.citi-modal .citi-modal-box .citi-modal-content{max-height:260px}}.citi-modal .citi-modal-box .citi-modal-content.scrollable{max-height:360px;border-bottom:1px solid #000}.citi-modal .citi-modal-box .citi-modal-controls{display:flex;justify-content:flex-end;align-items:center;padding:20px}@media (max-width: 480px){.citi-modal .citi-modal-box .citi-modal-controls{display:block;padding:20px}}.citi-modal .citi-modal-box .citi-modal-controls>citi-cta{margin-right:20px}.citi-modal .citi-modal-box .citi-modal-controls>citi-cta:last-child{margin-right:0}@media (max-width: 480px){.citi-modal .citi-modal-box .citi-modal-controls>citi-cta{display:block;margin:0 0 20px;text-align:center}.citi-modal .citi-modal-box .citi-modal-controls>citi-cta:last-child{margin-bottom:0}}.citi-modal .citi-modal-close{padding:15px;border-bottom:1px solid #e5e5e5;min-height:16.5px}.citi-modal .citi-modal-close,.citi-modal .citi-modal-content{padding-left:20px;padding-right:20px}.citi-modal .citi-modal-content{border:none}:host-context(.e-2-tool) .citi-modal-content ::ng-deep p{font-size:1rem;line-height:1.5rem;font-family:Interstate_Light,sans-serif;text-align:left}.citi-modal-content ::ng-deep ul.lineDivided li{padding:20px 0;margin:0;list-style:none;background:0 0;border-top:1px solid rgba(0,0,0,.25);font-size:1rem;-webkit-font-smoothing:antialiased}.citi-modal-content ::ng-deep ul.lineDivided{padding:20px 0 0;margin:0}.citi-modal-content ::ng-deep .rowspan-table-module.grey{background-color:#fff}\n"] }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }], propDecorators: { modal: [{
                type: ViewChild,
                args: ['modal']
            }], closeButton: [{
                type: ViewChild,
                args: ['closeButton']
            }], primaryButton: [{
                type: ViewChild,
                args: ['primaryButton']
            }], secondaryButton: [{
                type: ViewChild,
                args: ['secondaryButton']
            }], wrapDiv: [{
                type: ViewChild,
                args: ['wrapDiv']
            }], videoURL: [{
                type: Input$1
            }], videoLabelReader: [{
                type: Input$1
            }], show: [{
                type: Input$1
            }], title: [{
                type: Input$1
            }], primaryButtonUrl: [{
                type: Input$1
            }], primaryButtonTarget: [{
                type: Input$1
            }], primaryButtonText: [{
                type: Input$1
            }], showCancelButton: [{
                type: Input$1
            }], disablePrimaryButton: [{
                type: Input$1
            }], cancelButtonText: [{
                type: Input$1
            }], scrollable: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }], idStr: [{
                type: Input$1
            }], primaryButtonClick: [{
                type: Output
            }], secondaryButtonClick: [{
                type: Output
            }], closeButtonClick: [{
                type: Output
            }], showChange: [{
                type: Output
            }], onEscape: [{
                type: HostListener,
                args: ['window:keydown', ['$event']]
            }] } });

const COMPONENTS$7 = [
    VideoK1Component,
    VideoModalComponent,
    VideoGridSectionComponent
];
const MODULES$7 = [CommonModule, TextHeader, ContentHtml, CTA];
class VideoComponent {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: VideoComponent, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: VideoComponent, declarations: [VideoK1Component,
            VideoModalComponent,
            VideoGridSectionComponent], imports: [CommonModule, TextHeader, ContentHtml, CTA], exports: [VideoK1Component,
            VideoModalComponent,
            VideoGridSectionComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: VideoComponent, imports: [MODULES$7] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: VideoComponent, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$7],
                    declarations: [...COMPONENTS$7],
                    exports: [...COMPONENTS$7]
                }]
        }] });

/**
 * @Component: Static Control Element
 * @description This component generates the static control element.
 */
class StaticControlElementComponent {
    constructor() {
        /**
         * @property labelText
         * @description Defines the label of static row element
         * @return string
         */
        this.labelText = null;
        /**
         * @property valueText
         * @description Defines the value of static row element
         * @return string
         */
        this.valueText = null;
        /**
         * @property valueText
         * @description Enables the right alignment of value/text in static row element
         * @return string
         */
        this.isRightAligned = false;
        /**
         * @property isNoWrapContent
         * @description Enables text wrapping onto the next line in static row element
         * @return string
         */
        this.isNoWrapContent = false;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: StaticControlElementComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: StaticControlElementComponent, isStandalone: false, selector: "[citi-static-control-element]", inputs: { idStr: "idStr", labelText: "labelText", valueText: "valueText", isRightAligned: "isRightAligned", isNoWrapContent: "isNoWrapContent" }, ngImport: i0, template: `
    <td class="cbolui-table-boldFont" [innerHtml]="(labelText === null ? '' : labelText)"></td>
    <td [class.nowrap-content]="(isNoWrapContent ? true : null)"
      [ngClass]="{'cbolui-table-rightAlign':isRightAligned}"
      [innerHtml]="(valueText === null ? '' : valueText)">
    </td>
  `, isInline: true, styles: [".cbolui-table-rightAlign{text-align:right}.cbolui-table-boldFont{font-weight:700}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: StaticControlElementComponent, decorators: [{
            type: Component,
            args: [{ selector: '[citi-static-control-element]', standalone: false, template: `
    <td class="cbolui-table-boldFont" [innerHtml]="(labelText === null ? '' : labelText)"></td>
    <td [class.nowrap-content]="(isNoWrapContent ? true : null)"
      [ngClass]="{'cbolui-table-rightAlign':isRightAligned}"
      [innerHtml]="(valueText === null ? '' : valueText)">
    </td>
  `, styles: [".cbolui-table-rightAlign{text-align:right}.cbolui-table-boldFont{font-weight:700}\n"] }]
        }], propDecorators: { idStr: [{
                type: Input$1
            }], labelText: [{
                type: Input$1
            }], valueText: [{
                type: Input$1
            }], isRightAligned: [{
                type: Input$1
            }], isNoWrapContent: [{
                type: Input$1
            }] } });

/**
 * @Component: Static Control Group
 * @description This component generates the Static Control Group component
 */
class StaticControlGroupComponent {
    constructor() {
        /**
         * @property caption
         * @description Defines the title of static element
         * @return string
        */
        this.caption = null;
        /**
         * @property subCaption
         * @description Defines the sub title text of static element
         * @return string
        */
        this.subCaption = null;
        /**
       * @property tableName
       * @description Used to define the name of table for NVDA users
       * @return string
      */
        this.tableName = null;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: StaticControlGroupComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: StaticControlGroupComponent, isStandalone: false, selector: "citi-static-control-group", inputs: { idStr: "idStr", caption: "caption", subCaption: "subCaption", isZebraTable: "isZebraTable", isLabelValuePair: "isLabelValuePair", tableName: "tableName" }, ngImport: i0, template: `
    <div [attr.id]="idStr" class="component-container"
      [ngClass]= "{'table-responsive':isLabelValuePair}">
      <h2 class="static-control-caption"
      [innerHtml]="(caption === null ? '' : caption)">
      </h2>
      <span class="sub-caption"
        [innerHtml]="(subCaption === null ? '' : subCaption)">
      </span>
      <table class="table table-simple"
        [ngClass]= "{'table-striped':isZebraTable}"
        role="table">
      <caption class="sr-only">{{tableName}}</caption>
        <ng-content></ng-content>
      </table>
    </div>
  `, isInline: true, styles: [".static-control-caption{font-size:2.625rem!important;border-bottom:0;padding-top:18px;padding-bottom:12px;color:#333;text-align:left;font-size:26px;font-family:Interstate_Light,sans-serif;line-height:1.5}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: StaticControlGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-static-control-group', standalone: false, template: `
    <div [attr.id]="idStr" class="component-container"
      [ngClass]= "{'table-responsive':isLabelValuePair}">
      <h2 class="static-control-caption"
      [innerHtml]="(caption === null ? '' : caption)">
      </h2>
      <span class="sub-caption"
        [innerHtml]="(subCaption === null ? '' : subCaption)">
      </span>
      <table class="table table-simple"
        [ngClass]= "{'table-striped':isZebraTable}"
        role="table">
      <caption class="sr-only">{{tableName}}</caption>
        <ng-content></ng-content>
      </table>
    </div>
  `, styles: [".static-control-caption{font-size:2.625rem!important;border-bottom:0;padding-top:18px;padding-bottom:12px;color:#333;text-align:left;font-size:26px;font-family:Interstate_Light,sans-serif;line-height:1.5}\n"] }]
        }], propDecorators: { idStr: [{
                type: Input$1
            }], caption: [{
                type: Input$1
            }], subCaption: [{
                type: Input$1
            }], isZebraTable: [{
                type: Input$1
            }], isLabelValuePair: [{
                type: Input$1
            }], tableName: [{
                type: Input$1
            }] } });

const COMPONENTS$6 = [
    StaticControlGroupComponent,
    StaticControlElementComponent,
];
const MODULES$6 = [
    CommonModule
];
class StaticControl {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: StaticControl, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: StaticControl, declarations: [StaticControlGroupComponent,
            StaticControlElementComponent], imports: [CommonModule], exports: [StaticControlGroupComponent,
            StaticControlElementComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: StaticControl, imports: [MODULES$6] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: StaticControl, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$6],
                    declarations: [...COMPONENTS$6],
                    exports: [...COMPONENTS$6]
                }]
        }] });

class TableService {
    constructor() {
        this.previousHeader = null;
        this.columnSorted = new EventEmitter();
    }
    /**
     * @name addOption
     * @description Adds option to an input
     * @return void
     */
    sortColumn(columnHeader) {
        this.columnSorted.emit({ 'columnHeader': columnHeader, 'previousHeader': this.previousHeader });
        this.previousHeader = columnHeader;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TableService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TableService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TableService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class ExpandComponent {
    constructor(announcer) {
        this.announcer = announcer;
        this._isExpanded = false;
        this.iconShade = 'b2';
        this.expandChange = new EventEmitter();
        /**
         * @property htmlContent
         * @description Adds the given string as the content and supports simple HTML.
         * Do not pass anything within the component tags using ng-content. Do not use citi-* components in the String.
         * This works with expressions for asynchronously loaded content that will get picked up by the Angular 2 change detection.
         * @return string
         * @twoway false
         */
        this.htmlContent = null;
    }
    get textOpen() {
        return this._textOpen;
    }
    set textOpen(value) {
        this._textOpen = value;
    }
    get textCollapse() {
        return this._textCollapse;
    }
    set textCollapse(value) {
        this._textCollapse = value;
    }
    get isExpanded() {
        return this._isExpanded;
    }
    set isExpanded(value) {
        this._isExpanded = value;
    }
    getExpandText() {
        return this.isExpanded ? this.textOpen : this.textCollapse;
    }
    /**
     * Checks if a show detail button of a row is clicked
     *
     * @param element
     * @returns boolean
     */
    isShowDetailButtonClicked(element) {
        let targetClassName = ' no class';
        switch (element.tagName) {
            case 'BUTTON':
                targetClassName = ' details-button ';
                break;
            case 'SPAN':
                targetClassName = ' btn-link ';
                break;
        }
        return (' ' + element.className + ' ').indexOf(targetClassName) > -1;
    }
    onClickBtn(event) {
        let target = event.target;
        while (target !== event.currentTarget) {
            if (target.tagName == 'BUTTON')
                return;
            target = target.parentNode;
        }
        if (this.isShowDetailButtonClicked(event.target)) {
            this.isExpanded = !this.isExpanded;
            this.expandChange.emit(this.isExpanded);
        }
    }
    darkShade() {
        this.iconShade = 'b1';
    }
    lightShade() {
        this.iconShade = 'b2';
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ExpandComponent, deps: [{ token: CitiLiveAnnouncer }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: ExpandComponent, isStandalone: false, selector: "citi-expand", inputs: { textOpen: "textOpen", textCollapse: "textCollapse", isExpanded: "isExpanded", htmlContent: "htmlContent" }, outputs: { expandChange: "expandChange" }, host: { listeners: { "click": "onClickBtn($event)" } }, ngImport: i0, template: `
    <div class="internal-expand">
      <button
        class="details-button"
        [attr.aria-expanded]="isExpanded"
        role="button"
        (click)="onClickBtn($event)"
        (focus)="darkShade()"
        (focusout)="lightShade()"
        (mouseenter)="darkShade()"
        (mouseleave)="lightShade()"
      >
        <citi-icon2
          [name]="isExpanded ? '01-up' : '02-down'"
          [shade]="iconShade"
          size="small"
          aria-hidden="true"
        >
        </citi-icon2>
        <span class="btn-text btn-link"> {{ getExpandText() }}</span>
      </button>
    </div>
    <div class="expanded-content" [contentHtml]="htmlContent">
      <ng-content></ng-content>
    </div>
  `, isInline: true, styles: [".cbolui-ddl-post .cbolui-table .details-button .btn-text,.cbolui-ddl-post .transaction-journal-table .details-button .btn-text{float:none!important}citi-icon2.expandIcon ::ng-deep .sfi.small{height:8px;margin-right:8px}\n"], dependencies: [{ kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }, { kind: "component", type: Icon2Component, selector: "citi-icon2", inputs: ["role", "idStr", "ariaLabel", "ariaHidden", "size", "isHoverSfi", "includeCircle", "type", "svgStyle", "tabIndex", "shade", "name"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ExpandComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-expand', standalone: false, template: `
    <div class="internal-expand">
      <button
        class="details-button"
        [attr.aria-expanded]="isExpanded"
        role="button"
        (click)="onClickBtn($event)"
        (focus)="darkShade()"
        (focusout)="lightShade()"
        (mouseenter)="darkShade()"
        (mouseleave)="lightShade()"
      >
        <citi-icon2
          [name]="isExpanded ? '01-up' : '02-down'"
          [shade]="iconShade"
          size="small"
          aria-hidden="true"
        >
        </citi-icon2>
        <span class="btn-text btn-link"> {{ getExpandText() }}</span>
      </button>
    </div>
    <div class="expanded-content" [contentHtml]="htmlContent">
      <ng-content></ng-content>
    </div>
  `, styles: [".cbolui-ddl-post .cbolui-table .details-button .btn-text,.cbolui-ddl-post .transaction-journal-table .details-button .btn-text{float:none!important}citi-icon2.expandIcon ::ng-deep .sfi.small{height:8px;margin-right:8px}\n"] }]
        }], ctorParameters: () => [{ type: CitiLiveAnnouncer }], propDecorators: { expandChange: [{
                type: Output
            }], textOpen: [{
                type: Input$1
            }], textCollapse: [{
                type: Input$1
            }], isExpanded: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }], onClickBtn: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

let TdProperties$1 = class TdProperties {
    constructor() {
        this.id = '';
        this.text = '';
        this.additionalClasses = '';
        this.isRightAligned = false;
        this.isChoiceColumn = false;
        this.isNoWrap = false;
        this.colspan = '1';
    }
};

// TODO: convert this into a binding action
function hasClass(el, className) {
    return el.classList ? el.classList.contains(className) :
        !!el.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'));
}
function addClass(el, className) {
    return el.classList ? el.classList.add(className) :
        el.className += ' ' + className;
}

class TdComponent {
    constructor(_parentElement) {
        this._props = new TdProperties$1();
        /**
         * @property htmlContent
         * @description Adds the given string as the content and supports simple HTML.
         * Do not pass anything within the component tags using ng-content. Do not use citi-* components in the String.
         * This works with expressions for asynchronously loaded content that will get picked up by the Angular 2 change detection.
         * @return string
         * @twoway false
         */
        this.htmlContent = null;
        this._parentElement = _parentElement;
    }
    ngAfterViewInit() {
        this.generateClass();
    }
    // TODO: trigger this from setters
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('isRightAligned') || changes.hasOwnProperty('isChoiceColumn')
            || changes.hasOwnProperty('additionalClasses') || changes.hasOwnProperty('isNoWrap')
            || changes.hasOwnProperty('statusAlert')) {
            this.generateClass();
        }
    }
    set type(props) {
        this._props = props;
    }
    set text(text) {
        this._props.text = text;
    }
    set additionalClasses(additionalClasses) {
        this._props.additionalClasses = additionalClasses;
    }
    set isRightAligned(isRightAligned) {
        this._props.isRightAligned = isRightAligned;
    }
    set isChoiceColumn(isChoiceColumn) {
        this._props.isChoiceColumn = isChoiceColumn;
    }
    set isNoWrap(isNoWrap) {
        this._props.isNoWrap = isNoWrap;
    }
    set colspan(colspan) {
        this._props.colspan = colspan;
    }
    set statusAlert(statusAlert) {
        this._props.statusAlert = statusAlert;
    }
    generateClass() {
        let classArray = [];
        this._parentElement.nativeElement.className = '';
        classArray.push('cbolui-table-tablebody-col');
        if (this._props.isRightAligned)
            classArray.push(' cbolui-table-rightAlign', 'text-right');
        if (this._props.isChoiceColumn)
            classArray.push(' cbolui-table-tablebody-col-choice');
        if (this._props.isNoWrap)
            classArray.push('cbolui-nowrap', 'nowrap-content');
        if (this._props.statusAlert === 'success')
            classArray.push('cbolui-success');
        if (this._props.statusAlert === 'error')
            classArray.push('cbolui-error');
        if (this._props.additionalClasses && this._props.additionalClasses !== null) {
            const classes = this._props.additionalClasses.split(' ');
            classArray = classArray.concat(classes);
        }
        classArray.forEach((cla) => {
            if (cla !== '')
                addClass(this._parentElement.nativeElement, cla.trim());
        });
        this._parentElement.nativeElement.setAttribute('colspan', this._props.colspan);
        if (this._props.id)
            this._parentElement.nativeElement.id = this._props.id;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TdComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: TdComponent, isStandalone: false, selector: "[citi-td]", inputs: { type: "type", text: "text", additionalClasses: "additionalClasses", isRightAligned: "isRightAligned", isChoiceColumn: "isChoiceColumn", isNoWrap: "isNoWrap", colspan: "colspan", statusAlert: "statusAlert", htmlContent: "htmlContent" }, viewQueries: [{ propertyName: "wrapper", first: true, predicate: ["wrapperTd"], descendants: true }], usesOnChanges: true, ngImport: i0, template: `
    <div *ngIf="htmlContent !== null" [contentHtml]="htmlContent">
    </div>
    <ng-content></ng-content>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TdComponent, decorators: [{
            type: Component,
            args: [{
                    selector: '[citi-td]',
                    standalone: false,
                    template: `
    <div *ngIf="htmlContent !== null" [contentHtml]="htmlContent">
    </div>
    <ng-content></ng-content>
  `
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { wrapper: [{
                type: ViewChild,
                args: ['wrapperTd']
            }], type: [{
                type: Input$1
            }], text: [{
                type: Input$1
            }], additionalClasses: [{
                type: Input$1
            }], isRightAligned: [{
                type: Input$1
            }], isChoiceColumn: [{
                type: Input$1
            }], isNoWrap: [{
                type: Input$1
            }], colspan: [{
                type: Input$1
            }], statusAlert: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }] } });

let ThProperties$1 = class ThProperties {
    constructor() {
        this.id = '';
        this.text = '';
        this.additionalClasses = '';
        this.isRightAligned = false;
        this.isChoiceColumn = false;
        this.isSorterFalse = false;
        this.dataSortType = '';
        this.isSortable = false;
    }
};

class ThComponent {
    constructor(parentElment, tableService, announcer) {
        this.tableService = tableService;
        this.announcer = announcer;
        this.props = new ThProperties$1();
        this.iconClassName = '04-right';
        this.sortClasses = {
            sortedButton: false,
            sortedButtonLast: false
        };
        this.sortAnnounce = '';
        this.isSorted = false;
        this.iconShade = 'b2';
        this._descending = true;
        // tslint:disable-next-line:no-output-rename
        this.cardChanged = new EventEmitter();
        /**
         * @Event: sorted
         * @description The event is emitted when the header is clicked on
         * The descending boolean is returned.
         * @return Object
         */
        this.sorted = new EventEmitter();
        this.iconRole = null;
        this.parentElment = parentElment;
    }
    get text() {
        return this.props.text;
    }
    get isSortable() {
        return this.props.isSortable;
    }
    set type(props) {
        this.props = props;
    }
    set text(text) {
        this.props.text = text;
    }
    set additionalClasses(additionalClasses) {
        this.props.additionalClasses = additionalClasses;
    }
    set isRightAligned(isRightAligned) {
        this.props.isRightAligned = isRightAligned;
    }
    set isChoiceColumn(isChoiceColumn) {
        this.props.isChoiceColumn = isChoiceColumn;
    }
    set isSorterFalse(isSorterFalse) {
        this.props.isSorterFalse = isSorterFalse;
    }
    set dataSortType(dataSortType) {
        this.props.dataSortType = dataSortType;
    }
    set isSortable(isSortable) {
        this.props.isSortable = isSortable;
    }
    ngOnInit() {
        this.tableService.columnSorted.subscribe(headers => {
            if (headers.columnHeader !== this.parentElment) {
                this.sortClasses['sortedButton'] = false;
                this.iconClassName = '04-right';
                this.isSorted = false;
            }
        });
    }
    ngAfterViewInit() {
        this.generateClass();
    }
    // TODO: move to setters
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('isRightAligned') ||
            changes.hasOwnProperty('isChoiceColumn') ||
            changes.hasOwnProperty('additionalClasses') ||
            changes.hasOwnProperty('isSortable') ||
            changes.hasOwnProperty('isSorterFalse') ||
            changes.hasOwnProperty('isChoiceColumn') ||
            changes.hasOwnProperty('dataSortType')) {
            this.generateClass();
        }
    }
    onclick() {
        this.cardChanged.emit();
    }
    generateClass() {
        this.parentElment.nativeElement.className = '';
        let cls = '';
        cls += this.props.isRightAligned
            ? ' cbolui-table-rightAlign text-right'
            : '';
        cls += this.isSortable ? ' sortable cM-extend' : ' sorter-false';
        cls += this.props.isChoiceColumn
            ? ' cbolui-table-tableheader-col-choice'
            : '';
        cls += this.props.additionalClasses
            ? ' ' + this.props.additionalClasses
            : '';
        cls
            .trim()
            .split(' ')
            .forEach(cla => {
            addClass(this.parentElment.nativeElement, cla);
        });
        this.parentElment.nativeElement.setAttribute('scope', 'col');
        this.parentElment.nativeElement.setAttribute('aria-sort', 'none');
        this.parentElment.nativeElement.setAttribute('data-sort', this.props.dataSortType);
        if (this.props.id) {
            this.parentElment.nativeElement.id = this.props.id;
        }
    }
    toggleHeader(event) {
        this.sortClasses['sortedButton'] = true;
        this.isSorted = true;
        this._descending = !this._descending;
        if (this._descending === true) {
            this.iconClassName = '02-down';
            this.ariaSort = 'descending';
            this.announcer.announce(`Sorted by ${this.props.text}, descending`);
        }
        else {
            this.iconClassName = '01-up';
            this.ariaSort = 'ascending';
            this.announcer.announce(`Sorted by ${this.props.text}, ascending`);
        }
        this.sorted.emit(this.parentElment);
        this.tableService.sortColumn(this.parentElment);
    }
    onFocus() {
        this.darkShade();
    }
    darkShade() {
        this.iconShade = 'b1';
    }
    lightShade() {
        this.iconShade = 'b2';
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ThComponent, deps: [{ token: i0.ElementRef }, { token: TableService }, { token: CitiLiveAnnouncer }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: ThComponent, isStandalone: false, selector: "[citi-th]", inputs: { iconRole: "iconRole", type: "type", text: "text", additionalClasses: "additionalClasses", isRightAligned: "isRightAligned", isChoiceColumn: "isChoiceColumn", isSorterFalse: "isSorterFalse", dataSortType: "dataSortType", isSortable: "isSortable" }, outputs: { cardChanged: "click", sorted: "sorted" }, host: { properties: { "attr.aria-sort": "isSorted ? ariaSort : null" } }, viewQueries: [{ propertyName: "wrapper", first: true, predicate: ["wrapperTh"], descendants: true }], usesOnChanges: true, ngImport: i0, template: `
    <div *ngIf="isSortable" class="sortable" [class.sorted]="isSorted" (click)="toggleHeader($event)">
      <div
        *ngIf="isSortable === true"
        [ngClass]="sortClasses"
        class="th-body sortableDiv"
      >
        <button
          type="button"
          class="sortableCopy"
          (focus)="onFocus()"
          (focusout)="lightShade()"
          (mouseenter)="darkShade()"
          (mouseleave)="lightShade()"
        >
          {{ text }}
          <citi-icon2
            [name]="iconClassName"
            [role]="iconRole"
            ariaLabel="{{ sortAnnounce }}"
            [shade]="iconShade"
            size="small"
          >
          </citi-icon2>
        </button>
      </div>
    </div>
    <div *ngIf="!isSortable" class="sortable" [class.sorted]="isSorted">
      <ng-container *ngIf="isSortable !== true">
        <div>{{ text }} <ng-content select="[headercontent]"></ng-content></div>
      </ng-container>
    </div>
  `, isInline: true, styles: [".svg-arrow-btn-next-blue,.glyphicon-triangle-right,.glyphicon{background-image:url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8' standalone='no'%3F%3E%3Csvg width='7px' height='14px' viewBox='0 0 7 14' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:sketch='http://www.bohemiancoding.com/sketch/ns'%3E%3C!-- Generator: Sketch 3.4.1 (15681) - http://www.bohemiancoding.com/sketch --%3E%3Ctitle%3EChevron Copy 4%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cdefs%3E%3C/defs%3E%3Cg id='Toolkit' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' sketch:type='MSPage'%3E%3Cg id='Buttons' sketch:type='MSArtboardGroup' fill='%23056dae'%3E%3Cpath d='M0,14 L0,11.6917048 L4.9896888,7.0246591 L0,2.3577556 L0,0 L6.4615385,6.1555486 L6.4615385,7.8443093 L0,14' id='Chevron-Copy-4'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/svg%3E\");background-repeat:no-repeat}.svg-arrow-dropdown-up,.glyphicon-triangle-top{background-image:url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8' standalone='no'%3F%3E%3Csvg width='15px' height='8px' viewBox='0 0 15 8' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:sketch='http://www.bohemiancoding.com/sketch/ns'%3E%3C!-- Generator: Sketch 3.4.1 (15681) - http://www.bohemiancoding.com/sketch --%3E%3Ctitle%3EChevron%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cdefs%3E%3C/defs%3E%3Cg id='Dropdowns' sketch:type='MSArtboardGroup' fill='%23056dae'%3E%3Cpath d='M-7,14 L-7,11.6917048 L-2.010311,7.0246591 L-7,2.3577556 L-7,0 L-0.538462,6.1555486 L-0.538462,7.8443093 L-7,14' id='Chevron' transform='rotate(-90)'%3E%3C/path%3E%3C/g%3E%3C/svg%3E\");background-repeat:no-repeat}.svg-arrow-dropdown-down,.glyphicon-triangle-bottom{background-image:url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8' standalone='no'%3F%3E%3Csvg width='15px' height='8px' viewBox='0 0 15 8' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:sketch='http://www.bohemiancoding.com/sketch/ns'%3E%3C!-- Generator: Sketch 3.4.1 (15681) - http://www.bohemiancoding.com/sketch --%3E%3Ctitle%3EChevron%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cdefs%3E%3C/defs%3E%3Cg id='Dropdowns' sketch:type='MSArtboardGroup' fill='%23056dae'%3E%3Cpath d='M-7,14 L-7,11.6917048 L-2.010311,7.0246591 L-7,2.3577556 L-7,0 L-0.538462,6.1555486 L-0.538462,7.8443093 L-7,14' id='Chevron' transform='rotate(90) translate(7, -14) '%3E%3C/path%3E%3C/g%3E%3C/svg%3E\");background-repeat:no-repeat}.svg-arrow-btn-next-blue-hover,.glyphicon-triangle-right:hover,.glyphicon-triangle-right:focus,.glyphicon:hover,.glyphicon:focus{background-image:url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8' standalone='no'%3F%3E%3Csvg width='7px' height='14px' viewBox='0 0 7 14' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:sketch='http://www.bohemiancoding.com/sketch/ns'%3E%3C!-- Generator: Sketch 3.4.1 (15681) - http://www.bohemiancoding.com/sketch --%3E%3Ctitle%3EChevron Copy 4%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cdefs%3E%3C/defs%3E%3Cg id='Toolkit' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' sketch:type='MSPage'%3E%3Cg id='Buttons' sketch:type='MSArtboardGroup' fill='%23002a54'%3E%3Cpath d='M0,14 L0,11.6917048 L4.9896888,7.0246591 L0,2.3577556 L0,0 L6.4615385,6.1555486 L6.4615385,7.8443093 L0,14' id='Chevron-Copy-4'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")}.svg-arrow-dropdown-up-hover,.glyphicon-triangle-top:hover,.glyphicon-triangle-top:focus{background-image:url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8' standalone='no'%3F%3E%3Csvg width='15px' height='8px' viewBox='0 0 15 8' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:sketch='http://www.bohemiancoding.com/sketch/ns'%3E%3C!-- Generator: Sketch 3.4.1 (15681) - http://www.bohemiancoding.com/sketch --%3E%3Ctitle%3EChevron%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cdefs%3E%3C/defs%3E%3Cg id='Dropdowns' sketch:type='MSArtboardGroup' fill='%23002a54'%3E%3Cpath d='M-7,14 L-7,11.6917048 L-2.010311,7.0246591 L-7,2.3577556 L-7,0 L-0.538462,6.1555486 L-0.538462,7.8443093 L-7,14' id='Chevron' transform='rotate(-90)'%3E%3C/path%3E%3C/g%3E%3C/svg%3E\")}.svg-arrow-dropdown-down-hover,.glyphicon-triangle-bottom:hover,.glyphicon-triangle-bottom:focus{background-image:url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8' standalone='no'%3F%3E%3Csvg width='15px' height='8px' viewBox='0 0 15 8' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:sketch='http://www.bohemiancoding.com/sketch/ns'%3E%3C!-- Generator: Sketch 3.4.1 (15681) - http://www.bohemiancoding.com/sketch --%3E%3Ctitle%3EChevron%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cdefs%3E%3C/defs%3E%3Cg id='Dropdowns' sketch:type='MSArtboardGroup' fill='%23002a54'%3E%3Cpath d='M-7,14 L-7,11.6917048 L-2.010311,7.0246591 L-7,2.3577556 L-7,0 L-0.538462,6.1555486 L-0.538462,7.8443093 L-7,14' id='Chevron' transform='rotate(90) translate(7, -14) '%3E%3C/path%3E%3C/g%3E%3C/svg%3E\")}.parentDivOfIcons{position:relative}.glyphicon{left:initial;right:-1px;font-size:.65em;text-indent:-9999em;width:10px;height:10px;background-size:10px auto;background-repeat:no-repeat;background-position:center;position:absolute!important;top:50%;transform:translateY(-50%)}.glyphicon:before{content:\"\"}.glyphicon-triangle-right{margin-right:0!important;background-size:auto 9px}.sortedButton{border-bottom-color:#056dae!important}:host.text-right{text-align:right}.sortable{padding-top:0;padding-bottom:0;display:block}.sortable button,.sortable [role=button],.sortable a{padding-top:16px;padding-bottom:12px;color:#056dae;position:relative;display:inline-block}.sortable button:first-child,.sortable [role=button]:first-child,.sortable a:first-child{padding-right:16px;border-bottom:3px solid transparent;color:#056dae}.sortable button.sr-only,.sortable [role=button].sr-only,.sortable a.sr-only{position:absolute}.sortable button:hover,.sortable [role=button]:hover,.sortable a:hover{color:#002a54;text-decoration:underline}.sortable.sorted button:first-child,.sortable.sorted [role=button]:first-child,.sortable.sorted a:first-child{border-bottom-color:#056dae}.sortableDiv{position:relative}.sortableCopy{border-top:3px solid transparent;padding-left:0}citi-icon2 ::ng-deep .sfi.small{margin:0 3px;height:8px}citi-icon2 ::ng-deep .b1-04-right.sfi.small,citi-icon2 ::ng-deep .b2-04-right.sfi.small{height:12px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: Icon2Component, selector: "citi-icon2", inputs: ["role", "idStr", "ariaLabel", "ariaHidden", "size", "isHoverSfi", "includeCircle", "type", "svgStyle", "tabIndex", "shade", "name"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ThComponent, decorators: [{
            type: Component,
            args: [{ selector: '[citi-th]', standalone: false, host: { '[attr.aria-sort]': 'isSorted ? ariaSort : null' }, template: `
    <div *ngIf="isSortable" class="sortable" [class.sorted]="isSorted" (click)="toggleHeader($event)">
      <div
        *ngIf="isSortable === true"
        [ngClass]="sortClasses"
        class="th-body sortableDiv"
      >
        <button
          type="button"
          class="sortableCopy"
          (focus)="onFocus()"
          (focusout)="lightShade()"
          (mouseenter)="darkShade()"
          (mouseleave)="lightShade()"
        >
          {{ text }}
          <citi-icon2
            [name]="iconClassName"
            [role]="iconRole"
            ariaLabel="{{ sortAnnounce }}"
            [shade]="iconShade"
            size="small"
          >
          </citi-icon2>
        </button>
      </div>
    </div>
    <div *ngIf="!isSortable" class="sortable" [class.sorted]="isSorted">
      <ng-container *ngIf="isSortable !== true">
        <div>{{ text }} <ng-content select="[headercontent]"></ng-content></div>
      </ng-container>
    </div>
  `, styles: [".svg-arrow-btn-next-blue,.glyphicon-triangle-right,.glyphicon{background-image:url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8' standalone='no'%3F%3E%3Csvg width='7px' height='14px' viewBox='0 0 7 14' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:sketch='http://www.bohemiancoding.com/sketch/ns'%3E%3C!-- Generator: Sketch 3.4.1 (15681) - http://www.bohemiancoding.com/sketch --%3E%3Ctitle%3EChevron Copy 4%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cdefs%3E%3C/defs%3E%3Cg id='Toolkit' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' sketch:type='MSPage'%3E%3Cg id='Buttons' sketch:type='MSArtboardGroup' fill='%23056dae'%3E%3Cpath d='M0,14 L0,11.6917048 L4.9896888,7.0246591 L0,2.3577556 L0,0 L6.4615385,6.1555486 L6.4615385,7.8443093 L0,14' id='Chevron-Copy-4'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/svg%3E\");background-repeat:no-repeat}.svg-arrow-dropdown-up,.glyphicon-triangle-top{background-image:url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8' standalone='no'%3F%3E%3Csvg width='15px' height='8px' viewBox='0 0 15 8' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:sketch='http://www.bohemiancoding.com/sketch/ns'%3E%3C!-- Generator: Sketch 3.4.1 (15681) - http://www.bohemiancoding.com/sketch --%3E%3Ctitle%3EChevron%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cdefs%3E%3C/defs%3E%3Cg id='Dropdowns' sketch:type='MSArtboardGroup' fill='%23056dae'%3E%3Cpath d='M-7,14 L-7,11.6917048 L-2.010311,7.0246591 L-7,2.3577556 L-7,0 L-0.538462,6.1555486 L-0.538462,7.8443093 L-7,14' id='Chevron' transform='rotate(-90)'%3E%3C/path%3E%3C/g%3E%3C/svg%3E\");background-repeat:no-repeat}.svg-arrow-dropdown-down,.glyphicon-triangle-bottom{background-image:url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8' standalone='no'%3F%3E%3Csvg width='15px' height='8px' viewBox='0 0 15 8' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:sketch='http://www.bohemiancoding.com/sketch/ns'%3E%3C!-- Generator: Sketch 3.4.1 (15681) - http://www.bohemiancoding.com/sketch --%3E%3Ctitle%3EChevron%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cdefs%3E%3C/defs%3E%3Cg id='Dropdowns' sketch:type='MSArtboardGroup' fill='%23056dae'%3E%3Cpath d='M-7,14 L-7,11.6917048 L-2.010311,7.0246591 L-7,2.3577556 L-7,0 L-0.538462,6.1555486 L-0.538462,7.8443093 L-7,14' id='Chevron' transform='rotate(90) translate(7, -14) '%3E%3C/path%3E%3C/g%3E%3C/svg%3E\");background-repeat:no-repeat}.svg-arrow-btn-next-blue-hover,.glyphicon-triangle-right:hover,.glyphicon-triangle-right:focus,.glyphicon:hover,.glyphicon:focus{background-image:url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8' standalone='no'%3F%3E%3Csvg width='7px' height='14px' viewBox='0 0 7 14' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:sketch='http://www.bohemiancoding.com/sketch/ns'%3E%3C!-- Generator: Sketch 3.4.1 (15681) - http://www.bohemiancoding.com/sketch --%3E%3Ctitle%3EChevron Copy 4%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cdefs%3E%3C/defs%3E%3Cg id='Toolkit' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' sketch:type='MSPage'%3E%3Cg id='Buttons' sketch:type='MSArtboardGroup' fill='%23002a54'%3E%3Cpath d='M0,14 L0,11.6917048 L4.9896888,7.0246591 L0,2.3577556 L0,0 L6.4615385,6.1555486 L6.4615385,7.8443093 L0,14' id='Chevron-Copy-4'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")}.svg-arrow-dropdown-up-hover,.glyphicon-triangle-top:hover,.glyphicon-triangle-top:focus{background-image:url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8' standalone='no'%3F%3E%3Csvg width='15px' height='8px' viewBox='0 0 15 8' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:sketch='http://www.bohemiancoding.com/sketch/ns'%3E%3C!-- Generator: Sketch 3.4.1 (15681) - http://www.bohemiancoding.com/sketch --%3E%3Ctitle%3EChevron%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cdefs%3E%3C/defs%3E%3Cg id='Dropdowns' sketch:type='MSArtboardGroup' fill='%23002a54'%3E%3Cpath d='M-7,14 L-7,11.6917048 L-2.010311,7.0246591 L-7,2.3577556 L-7,0 L-0.538462,6.1555486 L-0.538462,7.8443093 L-7,14' id='Chevron' transform='rotate(-90)'%3E%3C/path%3E%3C/g%3E%3C/svg%3E\")}.svg-arrow-dropdown-down-hover,.glyphicon-triangle-bottom:hover,.glyphicon-triangle-bottom:focus{background-image:url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8' standalone='no'%3F%3E%3Csvg width='15px' height='8px' viewBox='0 0 15 8' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:sketch='http://www.bohemiancoding.com/sketch/ns'%3E%3C!-- Generator: Sketch 3.4.1 (15681) - http://www.bohemiancoding.com/sketch --%3E%3Ctitle%3EChevron%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cdefs%3E%3C/defs%3E%3Cg id='Dropdowns' sketch:type='MSArtboardGroup' fill='%23002a54'%3E%3Cpath d='M-7,14 L-7,11.6917048 L-2.010311,7.0246591 L-7,2.3577556 L-7,0 L-0.538462,6.1555486 L-0.538462,7.8443093 L-7,14' id='Chevron' transform='rotate(90) translate(7, -14) '%3E%3C/path%3E%3C/g%3E%3C/svg%3E\")}.parentDivOfIcons{position:relative}.glyphicon{left:initial;right:-1px;font-size:.65em;text-indent:-9999em;width:10px;height:10px;background-size:10px auto;background-repeat:no-repeat;background-position:center;position:absolute!important;top:50%;transform:translateY(-50%)}.glyphicon:before{content:\"\"}.glyphicon-triangle-right{margin-right:0!important;background-size:auto 9px}.sortedButton{border-bottom-color:#056dae!important}:host.text-right{text-align:right}.sortable{padding-top:0;padding-bottom:0;display:block}.sortable button,.sortable [role=button],.sortable a{padding-top:16px;padding-bottom:12px;color:#056dae;position:relative;display:inline-block}.sortable button:first-child,.sortable [role=button]:first-child,.sortable a:first-child{padding-right:16px;border-bottom:3px solid transparent;color:#056dae}.sortable button.sr-only,.sortable [role=button].sr-only,.sortable a.sr-only{position:absolute}.sortable button:hover,.sortable [role=button]:hover,.sortable a:hover{color:#002a54;text-decoration:underline}.sortable.sorted button:first-child,.sortable.sorted [role=button]:first-child,.sortable.sorted a:first-child{border-bottom-color:#056dae}.sortableDiv{position:relative}.sortableCopy{border-top:3px solid transparent;padding-left:0}citi-icon2 ::ng-deep .sfi.small{margin:0 3px;height:8px}citi-icon2 ::ng-deep .b1-04-right.sfi.small,citi-icon2 ::ng-deep .b2-04-right.sfi.small{height:12px}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: TableService }, { type: CitiLiveAnnouncer }], propDecorators: { wrapper: [{
                type: ViewChild,
                args: ['wrapperTh']
            }], cardChanged: [{
                type: Output,
                args: ['click']
            }], sorted: [{
                type: Output,
                args: ['sorted']
            }], iconRole: [{
                type: Input$1
            }], type: [{
                type: Input$1
            }], text: [{
                type: Input$1
            }], additionalClasses: [{
                type: Input$1
            }], isRightAligned: [{
                type: Input$1
            }], isChoiceColumn: [{
                type: Input$1
            }], isSorterFalse: [{
                type: Input$1
            }], dataSortType: [{
                type: Input$1
            }], isSortable: [{
                type: Input$1
            }] } });

let TrProperties$1 = class TrProperties {
    constructor() {
        this.id = '';
        this.additionalClasses = '';
        this.isTableHeaderRow = false;
        this.isSubRow = false;
        this.isDetailRow = false;
        this.additionalAttributes = '';
        this.isExpanded = false;
    }
};

class TrComponent {
    set isExpanded(value) {
        this.props.isExpanded = value;
    }
    set type(properties) {
        this.props = properties;
    }
    set additionalClasses(additionalClasses) {
        this.props.additionalClasses = additionalClasses;
    }
    set isTableHeaderRow(isTableHeaderRow) {
        this.props.isTableHeaderRow = isTableHeaderRow;
        if (isTableHeaderRow === true) {
            this.rowType = 'tableheader';
        }
    }
    set isSubRow(isSubRow) {
        this.props.isSubRow = isSubRow;
    }
    set isDetailRow(isDetailRow) {
        this.props.isDetailRow = isDetailRow;
    }
    set additionalAttributes(additionalAttributes) {
        this.props.additionalAttributes = additionalAttributes;
    }
    get isExpanded() {
        return this.props.isExpanded;
    }
    constructor(elm) {
        this.props = new TrProperties$1();
        this.rowType = 'tablebody';
        /**
         * @property htmlContent
         * @description Adds the given string as the content and supports simple HTML.
         * Do not pass anything within the component tags using ng-content. Do not use citi-* components in the String.
         * This works with expressions for asynchronously loaded content that will get picked up by the Angular 2 change detection.
         * @return string
         * @twoway false
         */
        this.htmlContent = null;
        this.parentElment = elm;
    }
    ngAfterViewInit() {
        this.generateClass();
        if (this.props.id) {
            this.parentElment.nativeElement.id = this.props.id;
        }
        this.expandComponent?.expandChange.subscribe(isExpand => {
            this.props.isExpanded = isExpand;
        });
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('isSubRow') || changes.hasOwnProperty('rowType')
            || changes.hasOwnProperty('isExpanded') || changes.hasOwnProperty('additionalClasses')
            || changes.hasOwnProperty('isDetailRow')) {
            this.generateClass();
        }
    }
    // TODO: find a more efficient way of doing this
    ngAfterContentChecked() {
        this.generateClass();
    }
    generateClass() {
        this.parentElment.nativeElement.className = '';
        let cl = [];
        cl.push('cbolui-table-' + this.rowType + '-row');
        if (this.props.isSubRow !== null && this.props.isSubRow !== false) {
            cl.push('cbolui-table-' + this.rowType + '-row-subrow');
            cl.push('tablesorter-childRow');
        }
        if (this.props.additionalClasses && this.props.additionalClasses !== null) {
            const classes = this.props.additionalClasses.split(' ');
            cl = cl.concat(classes);
        }
        if (this.props.isDetailRow) {
            cl.push('expandable-row');
        }
        if (this.props.isDetailRow && this.isExpanded) {
            cl.push('is-expanded');
        }
        else {
            if (this.props.isDetailRow) {
                cl.push('is-collapsed');
            }
        }
        cl.forEach((cla) => { addClass(this.parentElment.nativeElement, cla); });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TrComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: TrComponent, isStandalone: false, selector: "[citi-tr]", inputs: { isExpanded: "isExpanded", type: "type", additionalClasses: "additionalClasses", isTableHeaderRow: "isTableHeaderRow", isSubRow: "isSubRow", isDetailRow: "isDetailRow", additionalAttributes: "additionalAttributes", htmlContent: "htmlContent" }, queries: [{ propertyName: "expandComponent", first: true, predicate: ExpandComponent, descendants: true }], viewQueries: [{ propertyName: "wrapper", first: true, predicate: ["wrapper"], descendants: true }], usesOnChanges: true, ngImport: i0, template: `
    <div *ngIf="htmlContent !== null" [contentHtml]="htmlContent">
    </div>
    <ng-content></ng-content>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TrComponent, decorators: [{
            type: Component,
            args: [{
                    selector: '[citi-tr]',
                    standalone: false,
                    template: `
    <div *ngIf="htmlContent !== null" [contentHtml]="htmlContent">
    </div>
    <ng-content></ng-content>
  `
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { wrapper: [{
                type: ViewChild,
                args: ['wrapper']
            }], isExpanded: [{
                type: Input$1
            }], type: [{
                type: Input$1
            }], additionalClasses: [{
                type: Input$1
            }], isTableHeaderRow: [{
                type: Input$1
            }], isSubRow: [{
                type: Input$1
            }], isDetailRow: [{
                type: Input$1
            }], additionalAttributes: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }], expandComponent: [{
                type: ContentChild,
                args: [ExpandComponent]
            }] } });

let TableProperties$1 = class TableProperties {
    constructor() {
        this.id = '';
        this.caption = '';
        this.hideCaption = false;
        this.summary = '';
        this.tableTooltip = false;
        this.isSortable = false;
        this.isAutoInitTableSorter = false;
        this.beforeTableSorterInitialization = false;
        this.sorterConfig = '';
        this.filterContent = '';
        this.filterAligned = false;
        this.viewMore = '';
        this.isExpandable = false;
        this.isExpanded = false;
        this.hasMasterDetailsRows = false;
        this.noTopMargin = false;
        this.isFixedLayout = true;
        this.ctaText = '';
        this.ctaTooltipTitle = '';
        this.ctaTooltipBody = '';
        this.isExpandableRow = false;
        this.expandDetailsHeader = false;
        this.collapseDetailsHeader = false;
        this.tableType = false;
        this.isFixedColumnTable = false;
        this.bodyText = '';
        this.data = [];
        this.displayedHeaders = [];
        this.isInfiniteScrollEnabled = false;
        this.loadButtonText = 'Load %d more records';
        this.defaultNumberOfVisibleRecords = 10;
        this.defaultAdditionalRecords = 10;
        this.currentNumberOfVisibleRecords = 0;
        this.loadingText = 'Just a moment please.';
        this.isLoadingMoreData = false;
        this.visibleRows = [];
        this.canLoadMoreData = false;
        this.expandButtonTextClose = 'More Details';
        this.expandButtonTextOpen = 'Less Details';
        this.itemDetailCollapses = [];
        this.isZebraTable = false;
        this.isLayoutTable = false;
    }
};

let nextUniqueId = 0;
class TableComponent {
    constructor() {
        this.props = new TableProperties$1();
        this.isExpandedValue = false;
        this.showMoreButtonClicked = new EventEmitter();
        this._uid = `citi-table-${nextUniqueId++}`;
    }
    set isZebraTable(value) {
        this.props.isZebraTable = value;
    }
    set loadButtonText(value) {
        this.props.loadButtonText = value;
    }
    set itemDetailCollapses(newValues) {
        this.props.itemDetailCollapses = newValues.slice(0);
    }
    set defaultNumberOfVisibleRecords(value) {
        this.props.defaultNumberOfVisibleRecords = value;
    }
    set isInfiniteScrollEnabled(value) {
        this.props.isInfiniteScrollEnabled = value;
    }
    set displayedHeaders(headerList) {
        this.props.displayedHeaders = headerList.slice(0);
    }
    set data(source) {
        this.props.data = source.slice(0);
    }
    set type(properties) {
        this.props = properties;
    }
    get idStr() { return this.props.id; }
    set idStr(value) { this.props.id = value || this._uid; }
    set caption(caption) {
        this.props.caption = caption;
    }
    set hideCaption(hideCaption) {
        this.props.hideCaption = hideCaption;
    }
    set summary(summary) {
        this.props.summary = summary;
    }
    set tableTooltip(tableTooltip) {
        this.props.tableTooltip = tableTooltip;
    }
    set isSortable(isSortable) {
        this.props.isSortable = isSortable;
    }
    set isAutoInitTableSorter(isAutoInitTableSorter) {
        this.props.isAutoInitTableSorter = isAutoInitTableSorter;
    }
    set beforeTableSorterInitialization(beforeTableSorterInitialization) {
        this.props.beforeTableSorterInitialization = beforeTableSorterInitialization;
    }
    set sorterConfig(sorterConfig) {
        this.props.sorterConfig = sorterConfig;
    }
    set filterContent(filterContent) {
        this.props.filterContent = filterContent;
    }
    set filterAligned(filterAligned) {
        this.props.filterAligned = filterAligned;
    }
    set viewMore(viewMore) {
        this.props.viewMore = viewMore;
    }
    set isExpandable(isExpandable) {
        this.props.isExpandable = isExpandable;
    }
    set isExpanded(isExpanded) {
        this.props.isExpanded = isExpanded;
    }
    set hasMasterDetailsRows(hasMasterDetailsRows) {
        this.props.hasMasterDetailsRows = hasMasterDetailsRows;
    }
    set noTopMargin(noTopMargin) {
        this.props.noTopMargin = noTopMargin;
    }
    set isFixedLayout(isFixedLayout) {
        this.props.isFixedLayout = isFixedLayout;
    }
    set ctaText(ctaText) {
        this.props.ctaText = ctaText;
    }
    set ctaTooltipTitle(ctaTooltipTitle) {
        this.props.ctaTooltipTitle = ctaTooltipTitle;
    }
    set ctaTooltipBody(ctaTooltipBody) {
        this.props.ctaTooltipBody = ctaTooltipBody;
    }
    set isExpandableRow(isExpandableRow) {
        this.props.isExpandableRow = isExpandableRow;
    }
    set expandDetailsHeader(expandDetailsHeader) {
        this.props.expandDetailsHeader = expandDetailsHeader;
    }
    set collapseDetailsHeader(collapseDetailsHeader) {
        this.props.collapseDetailsHeader = collapseDetailsHeader;
    }
    set tableType(tableType) {
        this.props.tableType = tableType;
    }
    set isFixedColumnTable(isFixedColumnTable) {
        this.props.isFixedColumnTable = isFixedColumnTable;
    }
    set bodyText(bodyText) {
        this.props.bodyText = bodyText;
    }
    set loadingText(newText) {
        this.props.loadingText = newText;
    }
    set isLoadingMoreData(value) {
        this.props.isLoadingMoreData = value;
    }
    set visibleRows(rows) {
        this.props.visibleRows = rows.slice(0);
    }
    set defaultAdditionalRecords(numberOfRecords) {
        this.props.defaultAdditionalRecords = numberOfRecords;
    }
    set currentNumberOfVisibleRecords(numberOfRecords) {
        this.props.currentNumberOfVisibleRecords = numberOfRecords;
    }
    set expandButtonTextClose(newText) {
        this.props.expandButtonTextClose = newText;
    }
    set isLayoutTable(value) {
        if (typeof value === 'string') {
            value = value === 'true';
        }
        this.props.isLayoutTable = value;
    }
    set expandButtonTextOpen(newText) {
        this.props.expandButtonTextOpen = newText;
    }
    get isZebraTable() {
        return this.props.isZebraTable;
    }
    get expandButtonTextClose() {
        return this.props.expandButtonTextClose;
    }
    get expandButtonTextOpen() {
        return this.props.expandButtonTextOpen;
    }
    get defaultNumberOfVisibleRecords() {
        return this.props.defaultNumberOfVisibleRecords;
    }
    get data() {
        return this.props.data;
    }
    get isExpandable() {
        return this.props.isExpandable;
    }
    get displayedHeaders() {
        return this.props.displayedHeaders;
    }
    get isInfiniteScrollEnabled() {
        return this.props.isInfiniteScrollEnabled;
    }
    get loadButtonText() {
        return this.props.loadButtonText;
    }
    get loadingText() {
        return this.props.loadingText;
    }
    get isLoadingMoreData() {
        return this.props.isLoadingMoreData;
    }
    get visibleRows() {
        return this.props.visibleRows;
    }
    get defaultAdditionalRecords() {
        return this.props.defaultAdditionalRecords;
    }
    get currentNumberOfVisibleRecords() {
        return this.props.currentNumberOfVisibleRecords;
    }
    get canLoadMoreData() {
        return this.isInfiniteScrollEnabled && (this.data.length - this.currentNumberOfVisibleRecords > 0);
    }
    get isSortable() {
        return this.props.isSortable;
    }
    get itemDetailCollapses() {
        return this.props.itemDetailCollapses;
    }
    ngOnInit() {
        this.updateNumberOfVisibleRecords();
        this.itemDetailCollapses = Array.apply(null, Array(this.data.length)).map(function () { return true; });
    }
    updateNumberOfVisibleRecords() {
        if (this.isInfiniteScrollEnabled && this.canLoadMoreData) {
            this.currentNumberOfVisibleRecords = (this.currentNumberOfVisibleRecords > 0) ?
                this.currentNumberOfVisibleRecords + this.defaultAdditionalRecords :
                this.defaultNumberOfVisibleRecords;
            this.visibleRows = this.data.slice(0, this.currentNumberOfVisibleRecords);
        }
        else {
            this.visibleRows = this.data.slice(0, this.data.length);
        }
    }
    isCurrentVisible(currentIndex) {
        return this.isInfiniteScrollEnabled ? (this.defaultNumberOfVisibleRecords > currentIndex) : true;
    }
    loadMoreButtonClicked(event) {
        this.showMoreButtonClicked.emit(this);
    }
    detailButtonClicked(index) {
        const newFlagValues = this.itemDetailCollapses.slice(0);
        newFlagValues[index] = !newFlagValues[index];
        this.itemDetailCollapses = newFlagValues;
    }
    replaceLoadButtonText() {
        return this.loadButtonText.replace('%d', `${this.defaultNumberOfVisibleRecords}`);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TableComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: TableComponent, isStandalone: false, selector: "citi-table", inputs: { isZebraTable: "isZebraTable", loadButtonText: "loadButtonText", itemDetailCollapses: "itemDetailCollapses", defaultNumberOfVisibleRecords: "defaultNumberOfVisibleRecords", isInfiniteScrollEnabled: "isInfiniteScrollEnabled", displayedHeaders: "displayedHeaders", data: "data", type: "type", idStr: "idStr", caption: "caption", hideCaption: "hideCaption", summary: "summary", tableTooltip: "tableTooltip", isSortable: "isSortable", isAutoInitTableSorter: "isAutoInitTableSorter", beforeTableSorterInitialization: "beforeTableSorterInitialization", sorterConfig: "sorterConfig", filterContent: "filterContent", filterAligned: "filterAligned", viewMore: "viewMore", isExpandable: "isExpandable", isExpanded: "isExpanded", hasMasterDetailsRows: "hasMasterDetailsRows", noTopMargin: "noTopMargin", isFixedLayout: "isFixedLayout", ctaText: "ctaText", ctaTooltipTitle: "ctaTooltipTitle", ctaTooltipBody: "ctaTooltipBody", isExpandableRow: "isExpandableRow", expandDetailsHeader: "expandDetailsHeader", collapseDetailsHeader: "collapseDetailsHeader", tableType: "tableType", isFixedColumnTable: "isFixedColumnTable", bodyText: "bodyText", loadingText: "loadingText", isLoadingMoreData: "isLoadingMoreData", visibleRows: "visibleRows", defaultAdditionalRecords: "defaultAdditionalRecords", currentNumberOfVisibleRecords: "currentNumberOfVisibleRecords", expandButtonTextClose: "expandButtonTextClose", isLayoutTable: "isLayoutTable", expandButtonTextOpen: "expandButtonTextOpen" }, outputs: { showMoreButtonClicked: "showMoreButtonClicked" }, ngImport: i0, template: `
    <div
    class="cbolui-table-wrapper
          cbolui-clearfix
          table-responsive
          {{props.filterContent != null ? ' cbolui-table-wrapper-hasFilter': ''}}
          {{props.filterAligned == true ? ' cbolui-table-wrapper-filterAligned': ''}}
          {{props.hideCaption == true ? ' cbolui-table-wrapper-hiddenCaption': ''}}
          {{props.isExpandable == true ? ' cbolui-table-wrapper-expandable': ''}}
          {{props.noTopMargin == true ? ' cbolui-table-wrapper-no-top-margin': ''}}"
    [attr.id]= "props.id ? props.id + '-wrapper' : null"
    [attr.data-cbolui-table-wrapper-expandable-minimized]= "props.isExpandable == true ? props.isExpanded == true ? true: false: null"
    >

    <div
        *ngIf="props.filterContent != null"
        class="cbolui-tables-tableFilterWrapper cbolui-table-relatedTo-{{props.id}}"
        [attr.role]="'search'"
        [innerHtml]="props.filterContent">
    </div>
    <table
        [attr.id]= "props.id ? props.id : null"
        [attr.role]= "props.isLayoutTable ? 'presentation' : null"
        [title]="props.summary"
        [ngClass]= "{'cbolui-table': true, 'table': true,
                    'table-fixed': props.isFixedColumnTable,
                    'sortable-table': props.isSortable,
                    'cbolui-table-master-details': props.hasMasterDetailsRows,
                    'cbolui-table-normal-layout': !props.isFixedLayout,
                    'internal-expand-table': isExpandable,
                    'table-inf-scroll': props.isInfiniteScrollEnabled,
                    'table-striped': isZebraTable}">
        <caption
            *ngIf="props.caption !== null && !props.isLayoutTable">
            <div [ngClass]="{'flex-container': true}">
              <div
                  *ngIf="props.isExpandable === true"
                  class="glyphicon {{props.isExpanded == true ? ' glyphicon-minus': ' glyphicon-plus'}} cbolui-icon-maximize"
                  aria-hidden="true"
                  data-sort="descending">
              </div>
              <div class="cbolui-sr-only {{props.hideCaption == true ? 'sr-only' : ''}}" [innerHtml]= "props.caption"></div>
              <div
                  *ngIf="props.tableTooltip == true"
                  tabindex="0"
                  [ngClass]="{
                    'hidden-caption': props.hideCaption,
                    'ddl-tableTooltip': true
                  }">
                    <ng-content select="citi-tooltip"></ng-content>
            </div>
          </div>
        </caption>
        <ng-content select=".table-header"></ng-content>
        <ng-content select=".table-body"></ng-content>
      </table>
    </div>
    <citi-row *ngIf="isInfiniteScrollEnabled">
      <citi-column xs="12" class="btn-inf-scoll-wrap">
          <div class="btn-inf-scoll-wrap">
              <button *ngIf="!isLoadingMoreData" class="btn btn-primary btn-inf-scroll" (click)="loadMoreButtonClicked($event)">
                  {{replaceLoadButtonText()}}
              </button>
              <div [ngClass]= "{jamp: true, hidden: !isLoadingMoreData}" [attr.aria-hidden]= "!isLoadingMoreData" role="alert">
                  <span class="img"></span> <span class="message" [innerHtml]="loadingText"></span>
              </div>
          </div>
      </citi-column>
    </citi-row>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: ColumnComponent, selector: "citi-column, [citi-column]", inputs: ["xs", "sm", "md", "lg", "pullRight", "pullLeft", "offXs", "offSm", "offMd", "offLg", "classes", "htmlContent"] }, { kind: "component", type: RowComponent, selector: "citi-row, [citi-row]", inputs: ["classes", "htmlContent"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TableComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'citi-table',
                    standalone: false,
                    template: `
    <div
    class="cbolui-table-wrapper
          cbolui-clearfix
          table-responsive
          {{props.filterContent != null ? ' cbolui-table-wrapper-hasFilter': ''}}
          {{props.filterAligned == true ? ' cbolui-table-wrapper-filterAligned': ''}}
          {{props.hideCaption == true ? ' cbolui-table-wrapper-hiddenCaption': ''}}
          {{props.isExpandable == true ? ' cbolui-table-wrapper-expandable': ''}}
          {{props.noTopMargin == true ? ' cbolui-table-wrapper-no-top-margin': ''}}"
    [attr.id]= "props.id ? props.id + '-wrapper' : null"
    [attr.data-cbolui-table-wrapper-expandable-minimized]= "props.isExpandable == true ? props.isExpanded == true ? true: false: null"
    >

    <div
        *ngIf="props.filterContent != null"
        class="cbolui-tables-tableFilterWrapper cbolui-table-relatedTo-{{props.id}}"
        [attr.role]="'search'"
        [innerHtml]="props.filterContent">
    </div>
    <table
        [attr.id]= "props.id ? props.id : null"
        [attr.role]= "props.isLayoutTable ? 'presentation' : null"
        [title]="props.summary"
        [ngClass]= "{'cbolui-table': true, 'table': true,
                    'table-fixed': props.isFixedColumnTable,
                    'sortable-table': props.isSortable,
                    'cbolui-table-master-details': props.hasMasterDetailsRows,
                    'cbolui-table-normal-layout': !props.isFixedLayout,
                    'internal-expand-table': isExpandable,
                    'table-inf-scroll': props.isInfiniteScrollEnabled,
                    'table-striped': isZebraTable}">
        <caption
            *ngIf="props.caption !== null && !props.isLayoutTable">
            <div [ngClass]="{'flex-container': true}">
              <div
                  *ngIf="props.isExpandable === true"
                  class="glyphicon {{props.isExpanded == true ? ' glyphicon-minus': ' glyphicon-plus'}} cbolui-icon-maximize"
                  aria-hidden="true"
                  data-sort="descending">
              </div>
              <div class="cbolui-sr-only {{props.hideCaption == true ? 'sr-only' : ''}}" [innerHtml]= "props.caption"></div>
              <div
                  *ngIf="props.tableTooltip == true"
                  tabindex="0"
                  [ngClass]="{
                    'hidden-caption': props.hideCaption,
                    'ddl-tableTooltip': true
                  }">
                    <ng-content select="citi-tooltip"></ng-content>
            </div>
          </div>
        </caption>
        <ng-content select=".table-header"></ng-content>
        <ng-content select=".table-body"></ng-content>
      </table>
    </div>
    <citi-row *ngIf="isInfiniteScrollEnabled">
      <citi-column xs="12" class="btn-inf-scoll-wrap">
          <div class="btn-inf-scoll-wrap">
              <button *ngIf="!isLoadingMoreData" class="btn btn-primary btn-inf-scroll" (click)="loadMoreButtonClicked($event)">
                  {{replaceLoadButtonText()}}
              </button>
              <div [ngClass]= "{jamp: true, hidden: !isLoadingMoreData}" [attr.aria-hidden]= "!isLoadingMoreData" role="alert">
                  <span class="img"></span> <span class="message" [innerHtml]="loadingText"></span>
              </div>
          </div>
      </citi-column>
    </citi-row>
  `
                }]
        }], propDecorators: { showMoreButtonClicked: [{
                type: Output
            }], isZebraTable: [{
                type: Input$1
            }], loadButtonText: [{
                type: Input$1
            }], itemDetailCollapses: [{
                type: Input$1
            }], defaultNumberOfVisibleRecords: [{
                type: Input$1
            }], isInfiniteScrollEnabled: [{
                type: Input$1
            }], displayedHeaders: [{
                type: Input$1
            }], data: [{
                type: Input$1
            }], type: [{
                type: Input$1
            }], idStr: [{
                type: Input$1
            }], caption: [{
                type: Input$1
            }], hideCaption: [{
                type: Input$1
            }], summary: [{
                type: Input$1
            }], tableTooltip: [{
                type: Input$1
            }], isSortable: [{
                type: Input$1
            }], isAutoInitTableSorter: [{
                type: Input$1
            }], beforeTableSorterInitialization: [{
                type: Input$1
            }], sorterConfig: [{
                type: Input$1
            }], filterContent: [{
                type: Input$1
            }], filterAligned: [{
                type: Input$1
            }], viewMore: [{
                type: Input$1
            }], isExpandable: [{
                type: Input$1
            }], isExpanded: [{
                type: Input$1
            }], hasMasterDetailsRows: [{
                type: Input$1
            }], noTopMargin: [{
                type: Input$1
            }], isFixedLayout: [{
                type: Input$1
            }], ctaText: [{
                type: Input$1
            }], ctaTooltipTitle: [{
                type: Input$1
            }], ctaTooltipBody: [{
                type: Input$1
            }], isExpandableRow: [{
                type: Input$1
            }], expandDetailsHeader: [{
                type: Input$1
            }], collapseDetailsHeader: [{
                type: Input$1
            }], tableType: [{
                type: Input$1
            }], isFixedColumnTable: [{
                type: Input$1
            }], bodyText: [{
                type: Input$1
            }], loadingText: [{
                type: Input$1
            }], isLoadingMoreData: [{
                type: Input$1
            }], visibleRows: [{
                type: Input$1
            }], defaultAdditionalRecords: [{
                type: Input$1
            }], currentNumberOfVisibleRecords: [{
                type: Input$1
            }], expandButtonTextClose: [{
                type: Input$1
            }], isLayoutTable: [{
                type: Input$1
            }], expandButtonTextOpen: [{
                type: Input$1
            }] } });

const COMPONENTS$5 = [
    TableComponent,
    TrComponent,
    ThComponent,
    TdComponent,
    ExpandComponent,
];
const MODULES$5 = [
    CommonModule,
    CitiOrderBy,
    Grid,
    ContentHtml,
    Icons2
];
class Table {
    static forRoot() {
        return {
            ngModule: Table,
            providers: [TableService]
        };
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Table, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: Table, declarations: [TableComponent,
            TrComponent,
            ThComponent,
            TdComponent,
            ExpandComponent], imports: [CommonModule,
            CitiOrderBy,
            Grid,
            ContentHtml,
            Icons2], exports: [TableComponent,
            TrComponent,
            ThComponent,
            TdComponent,
            ExpandComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Table, imports: [MODULES$5] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: Table, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$5],
                    declarations: [...COMPONENTS$5],
                    exports: [...COMPONENTS$5],
                }]
        }] });

/**
 * @Component: ComparisonTableComponent
 * @Section: Modules
 * @description Component for rendering a comparison table of a list of items
 * with various features or characteristics
 */
class ComparisonTableComponent {
    /**
     * @property emptyMessage
     * @description Sets the message when there is no data in the table
     * @return string
     */
    set emptyMessage(newMessage) {
        this._emptyMessage = newMessage;
    }
    /**
      * @name emptyMessage
      * @description Gets the message when there is no data in the table
      * @return Void
    */
    get emptyMessage() {
        if (this._emptyMessage !== undefined && this._emptyMessage !== '') {
            return this._emptyMessage;
        }
        return 'No data provided';
    }
    /**
     * @property isDesktopWidth
     * @description Sets the flag indicating the table is rendered in a viewport whose width is greater 768 pixels
     * @Type: boolean
     */
    set isDesktopWidth(value) {
        this._isDesktopWidth = value;
    }
    /**
     * @property isDesktopWidth
     * @description Gets the flag indicating the table is rendered in a viewport whose width is greater 768 pixels
     * @Type: boolean
     */
    get isDesktopWidth() {
        return this._isDesktopWidth;
    }
    set options(newOptions) {
        if (newOptions !== undefined) {
            this._options = JSON.parse(JSON.stringify(newOptions));
            if (this.options.hasOwnProperty('list')) {
                this.data = this.options.list.items;
            }
        }
    }
    /**
     * @property options
     * @description Gets the current options of the table
     * @Type: Object
     */
    get options() {
        return this._options;
    }
    /**
     * @property caption
     * @description Sets caption for the table
     * @return string
     */
    set caption(newCaption) {
        this._options.caption = newCaption;
    }
    /**
     * @property secondaryCaption
     * @description Sets secondary caption for the table
     * @return string
     */
    set secondaryCaption(newCaption) {
        this._options.secondaryCaption = newCaption;
    }
    /**
     * @property caption
     * @description Gets the current options of the table
     * @return string
     */
    get caption() {
        return this._options.caption;
    }
    /**
     * @property caption
     * @description Gets the current options of the table
     * @return string
     */
    get secondaryCaption() {
        return this._options.secondaryCaption;
    }
    /**
     * @property data
     * @description Sets new list of items. Pass in the list of items into this property by checking against the
     * dataset.list property. For example: [data]=" dataset !== undefined && dataset.hasOwnProperty('list') ? dataset.list.items : []"
     * where dataset is a controller property you've created in your application. The items array should be of objects
     * that match the columns in the comparison table. Each object should have a header property, an href property for the header
     * as well as a property that matches each row in the first column to a row key. For example:
     * {
     *       "header": "Citigold",
     *       "href": "#link"
     *       "waivedAnnualFeeOnCitiPersonalWealthManagement": {
     *         "type": "boolean",
     *         "value": true
     *       },
     *       ...
     * }
     * The key "waivedAnnualFeeOnCitiPersonalWealthManagement" must match the "key" property of a "displayedKeys"
     * object in the parent dataset property in your application controller.
     * There are different data object types available for each column in the comparison table. The types include:
     * "boolean", "string", and "template". Examples of each type:
     * Boolean:
     * "unlimitedRefundsOfNonCitiATMFees": {
     *         "type": "boolean",
     *         "value": true
     * }
     * String:
     * "monthlyServiceFee": {
     *         "type": "string",
     *         "value": "N/A"
     * }
     * Template:
     * "minimumOpeningDeposit": {
     *         "type": "template",
     *         "value": "<strong>Regular or Interest Checking</strong>: $0 <br/><br/>
     * <strong>Citibank Saving Plus Account:</strong> $100 <br/><br/> <strong>Citi Savings</strong>: $100"
     * }
     *
     * @Type: Object
     */
    set data(newData) {
        if (isArray(newData)) {
            this._data = newData.slice(0);
        }
        else {
            console.warn('Provided data is not an array');
        }
    }
    /**
     * @property data
     * @description Gets the list of items
     * @Type: Array
     */
    get data() {
        return this._data.slice(0);
    }
    /**
     * @property hasData
     * @description Checks if the table has some data
     * @Type: boolean
     */
    get hasData() {
        return isArray(this._data) && this._data.length > 0;
    }
    /**
     * @property isProcessing
     * @description Checks if the table is loading data
     * @Type: boolean
     */
    get isProcessing() {
        return this._isProcessing;
    }
    /**
     * @property AllItemExpanded
     * @description Checks if all items in the table is being expanded
     * @Type: boolean
     */
    get allItemExpanded() {
        for (let listItem of this._options.displayedKeys) {
            if (listItem.expanded !== true) {
                return false;
            }
        }
        return true;
    }
    /**
     * @property loadingMessage
     * @description Sets the message being displayed when the table is loading data
     * @Type: boolean
     */
    set loadingMessage(message) {
        if (message !== '') {
            this._loadingMessage = message;
        }
    }
    /**
     * @property loadingMessage
     * @description Gets the message being displayed when the table is loading data
     * @Type: boolean
     */
    get loadingMessage() {
        if (this._loadingMessage !== undefined && this._loadingMessage !== '') {
            return this._loadingMessage;
        }
        return 'Loading data ...';
    }
    constructor(platformId, _window) {
        this.platformId = platformId;
        this._window = _window;
        this._isProcessing = false;
        this._loadingMessage = '';
        this._emptyMessage = '';
        /**
         * @Event: onListItemClick
         * @description Emitted when an row header is clicked
         * @return Object
         */
        this.onListItemClick = new EventEmitter();
        /**
         * @Event: onAllItemClick
         * @description This event that is fired when the menu is clicked. The event is returned.
         * @return Array
         */
        this.onAllItemClick = new EventEmitter();
        /**
         * @property options
         * @description Sets options for the table. This takes an object that requires a "displayedKeys" and "list" property.
         * The displayedKeys property should be an array of objects with "key" and "text" properties. An example below:
         * "displayedKeys": [
         *   {
         *     "key": "minimumOpeningDeposit",
         *     "text": "Minimum opening deposit"
         *   },
         *   ...
         * ]
         * The key values are used to match the rows and columns for different products. The list property should include
         * "listHeader" and "list" properties. The listHeader is the header for the row title column and the list
         * property is an Array of Objects for each column of products in the table. An example of the list property is as follows:
         * "items": [
         * {
         *       "header": "Citigold",
         *       "waivedAnnualFeeOnCitiPersonalWealthManagement": {
         *         "type": "boolean",
         *         "value": true
         *        },
         *        ...
         * },
         * ...
         * ]
         *
         * @Type: Object
         */
        this._options = {};
        if (isDevMode()) {
            console.error('%cThe Common UI DDL ComparisonTable <citi-comparison-table> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    ngOnInit() {
        this.onResize(null);
        if (this._window != undefined) {
            fromEvent(this._window, 'resize').pipe(debounceTime(500))
                .subscribe(e => {
                this.onResize(e);
            });
        }
    }
    onResize(event) {
        if (isPlatformBrowser(this.platformId))
            this.isDesktopWidth = document.body.clientWidth > 768;
    }
    /**
     * @name onItemClick
     * @description Handles the item click event
     * @param (Object) - item - Clicked item.
     * @return void
     */
    onItemClick(item) {
        let selectedItem = null;
        for (let listItem of this._options.displayedKeys) {
            if (listItem.key === item.key) {
                listItem.expanded = !listItem.expanded;
                selectedItem = JSON.parse(JSON.stringify(listItem));
                break;
            }
        }
        this.onListItemClick.emit(selectedItem);
    }
    /**
     * @name onAllItemButtonClick
     * @description Handles all item expanding/collapsing button clicked
     * @return void
     */
    onAllItemButtonClick(event) {
        let isExpanded = !this.allItemExpanded;
        for (let listItem of this._options.displayedKeys) {
            listItem.expanded = isExpanded;
        }
        this.onAllItemClick.emit(this.data);
    }
    /**
     * @name showProcessingIndicator
     * @description The function displays the processing indicator with 'loadingMessage'
     * @return void
     */
    showProcessingIndicator() {
        this._isProcessing = true;
    }
    /**
     * @name hideProcessingIndicator
     * @description The function hides the processing indicator
     * @return void
     */
    hideProcessingIndicator() {
        this._isProcessing = false;
    }
    /**
     * @name removeSpaces
     * @description The function removes the spaces of the string argument
     * @return string
     */
    removeSpaces(str) {
        return str.replace(/\s+/g, '');
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ComparisonTableComponent, deps: [{ token: PLATFORM_ID }, { token: WINDOW }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: ComparisonTableComponent, isStandalone: false, selector: "citi-comparison-table", inputs: { emptyMessage: "emptyMessage", isDesktopWidth: "isDesktopWidth", options: "options", caption: "caption", secondaryCaption: "secondaryCaption", data: "data", loadingMessage: "loadingMessage" }, outputs: { onListItemClick: "onListItemClick", onAllItemClick: "onAllItemClick" }, ngImport: i0, template: `
      <section class="comparison-table-module">
      <div *ngIf="isProcessing" class="jamp jamp-css">
          <span class="img loading">
          </span>
          <span class="message" [innerHtml]="loadingMessage">
          </span>
      </div>
      <div *ngIf="!isProcessing && !hasData" class="jamp">
          <h4 style="color: #D60000">
              <strong [innerHtml]="emptyMessage">
              </strong>
          </h4>
      </div>
      <div *ngIf="!isProcessing && hasData" class="container-fluid">

                  <table [ngClass]="{table: true, 'comparison-table': true, 'mode-desktop': isDesktopWidth, 'mode-mobile': !isDesktopWidth}">
                      <caption *ngIf="caption !== undefined" [attr.aria-live]="'polite'" [attr.aria-atomic]="false">
                          <div class="row">
                              <div class="col-md-9">
                                  <h1 class="header-3" [innerHtml]="caption">
                                  </h1>
                                  <p *ngIf="secondaryCaption !== undefined" [innerHTML]="secondaryCaption">
                                  </p>
                              </div>
                          </div>
                          <ng-content>
                          </ng-content>
                          <div class="visible-xs">
                              <button data-id="0" class="toggle-accordion-table btn-link" (click)="onAllItemButtonClick($event)" type="button">
                                  <span innerHtml="{{allItemExpanded ? 'Collapse All Sections' : 'Expand All Sections'}}">
                                  </span>
                              </button>
                              <!-- data-accordion-state="collapse" data-toggled-copy="Collapse All Sections"-->
                          </div>
                      </caption>
                      <thead [attr.aria-hidden]="isDesktopWidth ? false: true">
                          <tr>
                              <th [innerHtml]="options.list.listHeader" scope="col">
                              </th>
                              <th *ngFor="let header of options.list.items" scope="col" id="comparisonTableTH-{{removeSpaces(header.header)}}">
                                  <ng-container *ngIf="isDesktopWidth; headerTemplate">
                                  <a *ngIf="header.hasOwnProperty('header')" href="{{header.href}}" class="chevron-link bold">
                                  <strong [innerHtml]="header.header"></strong>
                                  </a>
                                  </ng-container>
                                  <ng-template #headerTemplate>
                                  <strong [innerHtml]="header.header"></strong>
                                  </ng-template>
                              </th>
                          </tr>
                      </thead>
                      <tbody role="table">
                          <ng-container *ngFor="let item of options.displayedKeys">
                              <tr [ngClass]="{'for-mobile': true, 'is-expanded': item.expanded === true}"
                              [attr.data-toggle]="item.expanded === true ? 'expanded' : 'collapse'" (click)="onItemClick(item)">
                                  <td attr.colspan="{{options.list.items.length + 1}}" class="mobileHeader">
                                  <button scope="col" id="comparisonTableButton-{{item.key}}" class="buttonHeader" role="list" aria-label= 'button' type="button"
                                      [attr.aria-expanded]="item.expanded" attr.aria-controls="comparisonTableTR-{{item.key}}">
                                          <div class="icon-svg svg-arrow-dropdown-down comparison-table-arrow-down"
                                          [ngClass]="{'arrowDown': true}">
                                          </div>
                                          <span id="comparisonTableHeader-{{item.key}}" class="category-title" tabindex="0"
                                          role="listitem" aria-posinset="1" aria-setsize="5"
                                          data-title="Select to hide" [innerHtml]="item.text">
                                          </span>
                                      </button>
                                  </td>
                              </tr>
                              <tr class="table-row" [attr.aria-labelledby]="'comparisonTableHeader-' + item.key"
                              [attr.aria-hidden]="!isDesktopWidth && item.expanded === false"
                              id="comparisonTableTR-{{item.key}}">
                                  <th scope="row">
                                      <strong [innerHtml]="item.text">
                                      </strong>
                                      <p *ngIf="item.additionalDescription && item.additionalDescription !== null"
                                      class="fingerprint">
                                      </p>
                                  </th>
                                  <td *ngFor="let listItem of options.list.items" [attr.headers]="'comparisonTableTH-' + removeSpaces(listItem.header)">
                                      <a *ngIf="isDesktopWidth !== true" href="{{listItem.href}}" class="chevron-link bold">{{listItem.header}}</a>
                                      <span *ngIf="listItem[item.key] !== undefined" [ngSwitch]="listItem[item.key].type"
                                      class="row-content-container">
                                          <ng-container *ngSwitchCase="'number'">
                                              {{listItem[item.key].value}}
                                          </ng-container>
                                          <ng-container *ngSwitchCase="'boolean'">
                                              <ng-container *ngIf="listItem[item.key].value === true">
                                                  <span class="svg-icon table-check-mark">
                                                      ✓
                                                      <span class="sr-only">
                                                          {{listItem[item.key].value}}
                                                      </span>
                                                  </span>
                                              </ng-container>
                                              <ng-container *ngIf="listItem[item.key].value !== true">
                                                  X
                                                  <span class="sr-only">
                                                      {{listItem[item.key].value}}
                                                  </span>
                                              </ng-container>
                                          </ng-container>
                                          <ng-container *ngSwitchCase="'template'">
                                              <span [innerHtml]="listItem[item.key].value">
                                              </span>
                                          </ng-container>
                                          <ng-container *ngSwitchDefault>
                                              {{listItem[item.key].value}}
                                          </ng-container>
                                      </span>
                                      <ng-container *ngIf="listItem[item.key] !== undefined && listItem[item.key].hasOwnProperty('secondaryDescription')">
                                          <br/>
                                          {{listItem[item.key].secondaryDescription}}
                                      </ng-container>
                                  </td>
                              </tr>
                          </ng-container>
                      </tbody>
                  </table>

      </div>
    </section>
  `, isInline: true, styles: [".mobileHeader{padding:0!important;margin:0!important}.buttonHeader{background:none;border:none;position:relative;line-height:1.5;vertical-align:top;border-top:1px solid #d8d8d8;font-size:16px;font-size:1rem;font-family:Interstate_light,sans-serif;padding:16px 18px 12px 55px!important}.arrowDown{position:absolute;top:25px;left:20px;height:8px;transition:transform .4s ease-in-out;transform:rotate(0);transform-origin:50%}.comparison-table-module{padding:20px 0 40px;background-color:#eee}@media (max-width: 992px){.comparison-table-module{padding:0 0 20px}.comparison-table-module caption{padding-top:40px}}@media (max-width: 991px){.comparison-table-module caption{padding-top:20px}}.comparison-table .header-3{margin-bottom:0}.comparison-table .header-3+p{margin-top:10px}@media (min-width: 992px){.comparison-table .header-3+p{margin-top:18px}}.comparison-table .toggle-accordion-table{text-decoration:underline;font-size:16px}.comparison-table thead{position:absolute;overflow:hidden;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);width:1px;height:1px;padding:0}@media (min-width: 992px){.comparison-table thead{position:relative;overflow:auto;clip:auto;width:auto;height:auto}}.comparison-table thead tr th,.modal-table thead tr th{vertical-align:top}.comparison-table tbody,.comparison-table td,.comparison-table th,.comparison-table tr{display:block}.comparison-table tr.for-mobile{display:none}.comparison-table tr.for-mobile:first-child th{border-top:0}@media (min-width: 992px){.comparison-table tr{display:table-row!important}.comparison-table tr.for-mobile{display:none!important}}@media (max-width: 991px){.comparison-table tr.for-mobile{display:block;transition:background-color .5s ease-in-out}.comparison-table tr.for-mobile+tr{visibility:hidden;overflow:hidden;max-height:0;transition:max-height .4s ease-out,background-color .5s ease-in-out,visibility .01s ease .501s}.comparison-table tr.for-mobile+tr th:first-child{display:none}.comparison-table tr.is-expanded{background-color:#fff}.comparison-table tr.is-expanded+tr{visibility:visible;max-height:300em;transition:max-height 6s ease-out 2ms,background-color .5s ease-in-out,visibility 1ms ease;background-color:#fff}}.comparison-table tr>th p{margin-bottom:0}.comparison-table tr>th:last-child a,.comparison-table tr>th:last-child p{margin-right:18px}.comparison-table td,.comparison-table th{font-weight:500!important;-webkit-font-smoothing:antialiased}@media (min-width: 992px){.comparison-table td,.comparison-table th{display:table-cell;width:16.6666666667%}}@media (min-width: 992px){.comparison-table tbody{display:table-row-group}}@media (max-width: 991px){.comparison-table tbody tr td,.comparison-table tbody tr th{padding-right:0;padding-left:0}.comparison-table tbody tr td{margin-right:20px;margin-left:55px}.comparison-table tbody tr th{position:relative}.comparison-table tbody tr th:first-child{padding-left:55px}.comparison-table tbody tr th .comparison-table-arrow-down{position:absolute;top:25px;left:20px;height:8px;transition:transform .4s ease-in-out;transform:rotate(0);transform-origin:50%}.comparison-table tbody tr.is-expanded .comparison-table-arrow-down{transform:rotate(180deg)}.comparison-table tbody .comparison-table-sub-header{display:none!important}}@media (min-width: 992px){.comparison-table tbody tr{display:table-row}}.comparison-table tbody td .row-content-container{display:block}.comparison-table tbody td .row-content-container .svg-icon{display:block;text-indent:-99999em;background-repeat:no-repeat}.comparison-table tbody td .row-content-container .svg-icon.table-x-mark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%20standalone%3D%22no%22%3F%3E%0A%3Csvg%20width%3D%2210px%22%20height%3D%2210px%22%20viewBox%3D%22-1%20-1%2012%2012%22%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20xmlns%3Asketch%3D%22http%3A//www.bohemiancoding.com/sketch/ns%22%3E%0A%20%20%20%20%3C%21--%20Generator%3A%20Sketch%203.4.1%20%2815681%29%20-%20http%3A//www.bohemiancoding.com/sketch%20--%3E%0A%20%20%20%20%3Ctitle%3EX%3C/title%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C/desc%3E%0A%20%20%20%20%3Cdefs%3E%3C/defs%3E%0A%20%20%20%20%3Cg%20id%3D%22Toolkit/White-Background%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20sketch%3Atype%3D%22MSPage%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Inputs%22%20sketch%3Atype%3D%22MSArtboardGroup%22%20transform%3D%22translate%28-1208.000000%2C%20-815.000000%29%22%20fill%3D%22%23D60000%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20sketch%3Atype%3D%22MSLayerGroup%22%20transform%3D%22translate%28178.000000%2C%20200.000000%29%22%20id%3D%22Input-Password-Error%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%28720.000000%2C%20490.000000%29%22%20sketch%3Atype%3D%22MSShapeGroup%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Tooltip-Cel%22%20transform%3D%22translate%280.000000%2C%2090.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Close-Default-Copy%22%20transform%3D%22translate%28300.000000%2C%2025.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M14%2C14%20L14%2C10%20L14%2C9%20L16%2C9%20L16%2C10%20L16%2C14%20L20%2C14%20L21%2C14%20L21%2C16%20L20%2C16%20L16%2C16%20L16%2C20%20L16%2C21%20L14%2C21%20L14%2C20%20L14%2C16%20L10%2C16%20L9%2C16%20L9%2C14%20L10%2C14%20L14%2C14%20Z%22%20id%3D%22X%22%20transform%3D%22translate%2815.000000%2C%2015.000000%29%20rotate%28-315.000000%29%20translate%28-15.000000%2C%20-15.000000%29%20%22%3E%3C/path%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%3C/g%3E%0A%3C/svg%3E);background-repeat:no-repeat}.comparison-table tbody td .row-content-container .svg-icon.table-check-mark{width:12px;height:auto;background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%20standalone%3D%22no%22%3F%3E%0A%3Csvg%20width%3D%2212px%22%20height%3D%229px%22%20viewBox%3D%220%200%2012%209%22%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20xmlns%3Asketch%3D%22http%3A//www.bohemiancoding.com/sketch/ns%22%3E%0A%20%20%20%20%3C%21--%20Generator%3A%20Sketch%203.4.2%20%2815857%29%20-%20http%3A//www.bohemiancoding.com/sketch%20--%3E%0A%20%20%20%20%3Ctitle%3ECheck01%3C/title%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C/desc%3E%0A%20%20%20%20%3Cdefs%3E%3C/defs%3E%0A%20%20%20%20%3Cg%20id%3D%22Toolkit/Grey-Background%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20sketch%3Atype%3D%22MSPage%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Buttons-Links-Lists%22%20sketch%3Atype%3D%22MSArtboardGroup%22%20transform%3D%22translate%28-204.000000%2C%20-1318.000000%29%22%20stroke%3D%22%23006E0A%22%20stroke-width%3D%222%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Check-List%22%20sketch%3Atype%3D%22MSLayerGroup%22%20transform%3D%22translate%28190.000000%2C%201313.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M15%2C8.72606345%20L18.5302555%2C12%20L25%2C6%22%20id%3D%22Check01%22%20sketch%3Atype%3D%22MSShapeGroup%22%3E%3C/path%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%3C/g%3E%0A%3C/svg%3E);background-repeat:no-repeat;background-position:center center}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1$1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1$1.NgSwitchDefault, selector: "[ngSwitchDefault]" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ComparisonTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-comparison-table', standalone: false, template: `
      <section class="comparison-table-module">
      <div *ngIf="isProcessing" class="jamp jamp-css">
          <span class="img loading">
          </span>
          <span class="message" [innerHtml]="loadingMessage">
          </span>
      </div>
      <div *ngIf="!isProcessing && !hasData" class="jamp">
          <h4 style="color: #D60000">
              <strong [innerHtml]="emptyMessage">
              </strong>
          </h4>
      </div>
      <div *ngIf="!isProcessing && hasData" class="container-fluid">

                  <table [ngClass]="{table: true, 'comparison-table': true, 'mode-desktop': isDesktopWidth, 'mode-mobile': !isDesktopWidth}">
                      <caption *ngIf="caption !== undefined" [attr.aria-live]="'polite'" [attr.aria-atomic]="false">
                          <div class="row">
                              <div class="col-md-9">
                                  <h1 class="header-3" [innerHtml]="caption">
                                  </h1>
                                  <p *ngIf="secondaryCaption !== undefined" [innerHTML]="secondaryCaption">
                                  </p>
                              </div>
                          </div>
                          <ng-content>
                          </ng-content>
                          <div class="visible-xs">
                              <button data-id="0" class="toggle-accordion-table btn-link" (click)="onAllItemButtonClick($event)" type="button">
                                  <span innerHtml="{{allItemExpanded ? 'Collapse All Sections' : 'Expand All Sections'}}">
                                  </span>
                              </button>
                              <!-- data-accordion-state="collapse" data-toggled-copy="Collapse All Sections"-->
                          </div>
                      </caption>
                      <thead [attr.aria-hidden]="isDesktopWidth ? false: true">
                          <tr>
                              <th [innerHtml]="options.list.listHeader" scope="col">
                              </th>
                              <th *ngFor="let header of options.list.items" scope="col" id="comparisonTableTH-{{removeSpaces(header.header)}}">
                                  <ng-container *ngIf="isDesktopWidth; headerTemplate">
                                  <a *ngIf="header.hasOwnProperty('header')" href="{{header.href}}" class="chevron-link bold">
                                  <strong [innerHtml]="header.header"></strong>
                                  </a>
                                  </ng-container>
                                  <ng-template #headerTemplate>
                                  <strong [innerHtml]="header.header"></strong>
                                  </ng-template>
                              </th>
                          </tr>
                      </thead>
                      <tbody role="table">
                          <ng-container *ngFor="let item of options.displayedKeys">
                              <tr [ngClass]="{'for-mobile': true, 'is-expanded': item.expanded === true}"
                              [attr.data-toggle]="item.expanded === true ? 'expanded' : 'collapse'" (click)="onItemClick(item)">
                                  <td attr.colspan="{{options.list.items.length + 1}}" class="mobileHeader">
                                  <button scope="col" id="comparisonTableButton-{{item.key}}" class="buttonHeader" role="list" aria-label= 'button' type="button"
                                      [attr.aria-expanded]="item.expanded" attr.aria-controls="comparisonTableTR-{{item.key}}">
                                          <div class="icon-svg svg-arrow-dropdown-down comparison-table-arrow-down"
                                          [ngClass]="{'arrowDown': true}">
                                          </div>
                                          <span id="comparisonTableHeader-{{item.key}}" class="category-title" tabindex="0"
                                          role="listitem" aria-posinset="1" aria-setsize="5"
                                          data-title="Select to hide" [innerHtml]="item.text">
                                          </span>
                                      </button>
                                  </td>
                              </tr>
                              <tr class="table-row" [attr.aria-labelledby]="'comparisonTableHeader-' + item.key"
                              [attr.aria-hidden]="!isDesktopWidth && item.expanded === false"
                              id="comparisonTableTR-{{item.key}}">
                                  <th scope="row">
                                      <strong [innerHtml]="item.text">
                                      </strong>
                                      <p *ngIf="item.additionalDescription && item.additionalDescription !== null"
                                      class="fingerprint">
                                      </p>
                                  </th>
                                  <td *ngFor="let listItem of options.list.items" [attr.headers]="'comparisonTableTH-' + removeSpaces(listItem.header)">
                                      <a *ngIf="isDesktopWidth !== true" href="{{listItem.href}}" class="chevron-link bold">{{listItem.header}}</a>
                                      <span *ngIf="listItem[item.key] !== undefined" [ngSwitch]="listItem[item.key].type"
                                      class="row-content-container">
                                          <ng-container *ngSwitchCase="'number'">
                                              {{listItem[item.key].value}}
                                          </ng-container>
                                          <ng-container *ngSwitchCase="'boolean'">
                                              <ng-container *ngIf="listItem[item.key].value === true">
                                                  <span class="svg-icon table-check-mark">
                                                      ✓
                                                      <span class="sr-only">
                                                          {{listItem[item.key].value}}
                                                      </span>
                                                  </span>
                                              </ng-container>
                                              <ng-container *ngIf="listItem[item.key].value !== true">
                                                  X
                                                  <span class="sr-only">
                                                      {{listItem[item.key].value}}
                                                  </span>
                                              </ng-container>
                                          </ng-container>
                                          <ng-container *ngSwitchCase="'template'">
                                              <span [innerHtml]="listItem[item.key].value">
                                              </span>
                                          </ng-container>
                                          <ng-container *ngSwitchDefault>
                                              {{listItem[item.key].value}}
                                          </ng-container>
                                      </span>
                                      <ng-container *ngIf="listItem[item.key] !== undefined && listItem[item.key].hasOwnProperty('secondaryDescription')">
                                          <br/>
                                          {{listItem[item.key].secondaryDescription}}
                                      </ng-container>
                                  </td>
                              </tr>
                          </ng-container>
                      </tbody>
                  </table>

      </div>
    </section>
  `, styles: [".mobileHeader{padding:0!important;margin:0!important}.buttonHeader{background:none;border:none;position:relative;line-height:1.5;vertical-align:top;border-top:1px solid #d8d8d8;font-size:16px;font-size:1rem;font-family:Interstate_light,sans-serif;padding:16px 18px 12px 55px!important}.arrowDown{position:absolute;top:25px;left:20px;height:8px;transition:transform .4s ease-in-out;transform:rotate(0);transform-origin:50%}.comparison-table-module{padding:20px 0 40px;background-color:#eee}@media (max-width: 992px){.comparison-table-module{padding:0 0 20px}.comparison-table-module caption{padding-top:40px}}@media (max-width: 991px){.comparison-table-module caption{padding-top:20px}}.comparison-table .header-3{margin-bottom:0}.comparison-table .header-3+p{margin-top:10px}@media (min-width: 992px){.comparison-table .header-3+p{margin-top:18px}}.comparison-table .toggle-accordion-table{text-decoration:underline;font-size:16px}.comparison-table thead{position:absolute;overflow:hidden;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);width:1px;height:1px;padding:0}@media (min-width: 992px){.comparison-table thead{position:relative;overflow:auto;clip:auto;width:auto;height:auto}}.comparison-table thead tr th,.modal-table thead tr th{vertical-align:top}.comparison-table tbody,.comparison-table td,.comparison-table th,.comparison-table tr{display:block}.comparison-table tr.for-mobile{display:none}.comparison-table tr.for-mobile:first-child th{border-top:0}@media (min-width: 992px){.comparison-table tr{display:table-row!important}.comparison-table tr.for-mobile{display:none!important}}@media (max-width: 991px){.comparison-table tr.for-mobile{display:block;transition:background-color .5s ease-in-out}.comparison-table tr.for-mobile+tr{visibility:hidden;overflow:hidden;max-height:0;transition:max-height .4s ease-out,background-color .5s ease-in-out,visibility .01s ease .501s}.comparison-table tr.for-mobile+tr th:first-child{display:none}.comparison-table tr.is-expanded{background-color:#fff}.comparison-table tr.is-expanded+tr{visibility:visible;max-height:300em;transition:max-height 6s ease-out 2ms,background-color .5s ease-in-out,visibility 1ms ease;background-color:#fff}}.comparison-table tr>th p{margin-bottom:0}.comparison-table tr>th:last-child a,.comparison-table tr>th:last-child p{margin-right:18px}.comparison-table td,.comparison-table th{font-weight:500!important;-webkit-font-smoothing:antialiased}@media (min-width: 992px){.comparison-table td,.comparison-table th{display:table-cell;width:16.6666666667%}}@media (min-width: 992px){.comparison-table tbody{display:table-row-group}}@media (max-width: 991px){.comparison-table tbody tr td,.comparison-table tbody tr th{padding-right:0;padding-left:0}.comparison-table tbody tr td{margin-right:20px;margin-left:55px}.comparison-table tbody tr th{position:relative}.comparison-table tbody tr th:first-child{padding-left:55px}.comparison-table tbody tr th .comparison-table-arrow-down{position:absolute;top:25px;left:20px;height:8px;transition:transform .4s ease-in-out;transform:rotate(0);transform-origin:50%}.comparison-table tbody tr.is-expanded .comparison-table-arrow-down{transform:rotate(180deg)}.comparison-table tbody .comparison-table-sub-header{display:none!important}}@media (min-width: 992px){.comparison-table tbody tr{display:table-row}}.comparison-table tbody td .row-content-container{display:block}.comparison-table tbody td .row-content-container .svg-icon{display:block;text-indent:-99999em;background-repeat:no-repeat}.comparison-table tbody td .row-content-container .svg-icon.table-x-mark{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%20standalone%3D%22no%22%3F%3E%0A%3Csvg%20width%3D%2210px%22%20height%3D%2210px%22%20viewBox%3D%22-1%20-1%2012%2012%22%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20xmlns%3Asketch%3D%22http%3A//www.bohemiancoding.com/sketch/ns%22%3E%0A%20%20%20%20%3C%21--%20Generator%3A%20Sketch%203.4.1%20%2815681%29%20-%20http%3A//www.bohemiancoding.com/sketch%20--%3E%0A%20%20%20%20%3Ctitle%3EX%3C/title%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C/desc%3E%0A%20%20%20%20%3Cdefs%3E%3C/defs%3E%0A%20%20%20%20%3Cg%20id%3D%22Toolkit/White-Background%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20sketch%3Atype%3D%22MSPage%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Inputs%22%20sketch%3Atype%3D%22MSArtboardGroup%22%20transform%3D%22translate%28-1208.000000%2C%20-815.000000%29%22%20fill%3D%22%23D60000%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20sketch%3Atype%3D%22MSLayerGroup%22%20transform%3D%22translate%28178.000000%2C%20200.000000%29%22%20id%3D%22Input-Password-Error%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%28720.000000%2C%20490.000000%29%22%20sketch%3Atype%3D%22MSShapeGroup%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Tooltip-Cel%22%20transform%3D%22translate%280.000000%2C%2090.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Close-Default-Copy%22%20transform%3D%22translate%28300.000000%2C%2025.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M14%2C14%20L14%2C10%20L14%2C9%20L16%2C9%20L16%2C10%20L16%2C14%20L20%2C14%20L21%2C14%20L21%2C16%20L20%2C16%20L16%2C16%20L16%2C20%20L16%2C21%20L14%2C21%20L14%2C20%20L14%2C16%20L10%2C16%20L9%2C16%20L9%2C14%20L10%2C14%20L14%2C14%20Z%22%20id%3D%22X%22%20transform%3D%22translate%2815.000000%2C%2015.000000%29%20rotate%28-315.000000%29%20translate%28-15.000000%2C%20-15.000000%29%20%22%3E%3C/path%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%3C/g%3E%0A%3C/svg%3E);background-repeat:no-repeat}.comparison-table tbody td .row-content-container .svg-icon.table-check-mark{width:12px;height:auto;background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%20standalone%3D%22no%22%3F%3E%0A%3Csvg%20width%3D%2212px%22%20height%3D%229px%22%20viewBox%3D%220%200%2012%209%22%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20xmlns%3Asketch%3D%22http%3A//www.bohemiancoding.com/sketch/ns%22%3E%0A%20%20%20%20%3C%21--%20Generator%3A%20Sketch%203.4.2%20%2815857%29%20-%20http%3A//www.bohemiancoding.com/sketch%20--%3E%0A%20%20%20%20%3Ctitle%3ECheck01%3C/title%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C/desc%3E%0A%20%20%20%20%3Cdefs%3E%3C/defs%3E%0A%20%20%20%20%3Cg%20id%3D%22Toolkit/Grey-Background%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20sketch%3Atype%3D%22MSPage%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Buttons-Links-Lists%22%20sketch%3Atype%3D%22MSArtboardGroup%22%20transform%3D%22translate%28-204.000000%2C%20-1318.000000%29%22%20stroke%3D%22%23006E0A%22%20stroke-width%3D%222%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Check-List%22%20sketch%3Atype%3D%22MSLayerGroup%22%20transform%3D%22translate%28190.000000%2C%201313.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M15%2C8.72606345%20L18.5302555%2C12%20L25%2C6%22%20id%3D%22Check01%22%20sketch%3Atype%3D%22MSShapeGroup%22%3E%3C/path%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%3C/g%3E%0A%3C/svg%3E);background-repeat:no-repeat;background-position:center center}\n"] }]
        }], ctorParameters: () => [{ type: Object, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }], propDecorators: { onListItemClick: [{
                type: Output
            }], onAllItemClick: [{
                type: Output
            }], emptyMessage: [{
                type: Input$1
            }], isDesktopWidth: [{
                type: Input$1
            }], options: [{
                type: Input$1
            }], caption: [{
                type: Input$1
            }], secondaryCaption: [{
                type: Input$1
            }], data: [{
                type: Input$1
            }], loadingMessage: [{
                type: Input$1
            }] } });

class ComparisonTable {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ComparisonTable, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: ComparisonTable, declarations: [ComparisonTableComponent], imports: [CommonModule], exports: [ComparisonTableComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ComparisonTable, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ComparisonTable, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [ComparisonTableComponent],
                    exports: [ComparisonTableComponent]
                }]
        }] });

/**
 * @Component: ComplexTableComponent
 * @Section: Modules
 * @description Component for rendering a complex table of a list of items
 * with various features or characteristics
 */
class ComplexTableComponent {
    /**
     * @property emptyMessage
     * @description Sets the message when there is no data in the table
     * @return string
     */
    set emptyMessage(newMessage) {
        this._emptyMessage = newMessage;
    }
    /**
      * @name emptyMessage
      * @description Gets the message when there is no data in the table
      * @return Void
    */
    get emptyMessage() {
        if (this._emptyMessage !== undefined && this._emptyMessage !== '') {
            return this._emptyMessage;
        }
        return 'No data provided';
    }
    /**
     * @property isDesktopWidth
     * @description Sets the flag indicating the table is rendered in a viewport whose width is greater 768 pixels
     * @Type: boolean
     */
    set isDesktopWidth(value) {
        this._isDesktopWidth = value;
    }
    /**
     * @property isDesktopWidth
     * @description Gets the flag indicating the table is rendered in a viewport whose width is greater 768 pixels
     * @Type: boolean
     */
    get isDesktopWidth() {
        return this._isDesktopWidth;
    }
    set options(newOptions) {
        if (newOptions !== undefined) {
            this._options = JSON.parse(JSON.stringify(newOptions));
            if (this.options.hasOwnProperty('list')) {
                this.data = this.options.list.items;
            }
        }
    }
    /**
     * @property options
     * @description Gets the current options of the table
     * @Type: Object
     */
    get options() {
        return JSON.parse(JSON.stringify(this._options));
    }
    /**
     * @property caption
     * @description Sets caption for the table
     * @return string
     */
    set caption(newCaption) {
        this._options.caption = newCaption;
    }
    /**
     * @property secondaryCaption
     * @description Sets secondary caption for the table
     * @return string
     */
    set secondaryCaption(newCaption) {
        this._options.secondaryCaption = newCaption;
    }
    /**
     * @property caption
     * @description Gets the current options of the table
     * @return string
     */
    get caption() {
        return this._options.caption;
    }
    /**
     * @property caption
     * @description Gets the current options of the table
     * @return string
     */
    get secondaryCaption() {
        return this._options.secondaryCaption;
    }
    set data(newData) {
        if (isArray(newData)) {
            this._data = newData.slice(0);
        }
        else {
            console.warn('Provided data is not an array');
        }
    }
    /**
     * @property data
     * @description Gets the list of items
     * @Type: Array
     */
    get data() {
        return this._data.slice(0);
    }
    /**
     * @property hasData
     * @description Checks if the table has some data
     * @Type: boolean
     */
    get hasData() {
        return isArray(this._data) && this._data.length > 0;
    }
    /**
     * @property isProcessing
     * @description Checks if the table is loading data
     * @Type: boolean
     */
    get isProcessing() {
        return this._isProcessing;
    }
    /**
     * @property AllItemExpanded
     * @description Checks if all items in the table is being expanded
     * @Type: boolean
     */
    get allItemExpanded() {
        for (let listItem of this._options.list.items) {
            if (listItem.expanded !== true) {
                return false;
            }
        }
        return true;
    }
    /**
     * @property loadingMessage
     * @description Sets the message being displayed when the table is loading data
     * @Type: boolean
     */
    set loadingMessage(message) {
        if (message !== '') {
            this._loadingMessage = message;
        }
    }
    /**
     * @property loadingMessage
     * @description Gets the message being displayed when the table is loading data
     * @Type: boolean
     */
    get loadingMessage() {
        if (this._loadingMessage !== undefined && this._loadingMessage !== '') {
            return this._loadingMessage;
        }
        return 'Loading data ...';
    }
    constructor(platformId, _window) {
        this.platformId = platformId;
        this._window = _window;
        this._isProcessing = false;
        this._loadingMessage = '';
        this._emptyMessage = '';
        /**
         * @Event: onListItemClick
         * @description Emitted when an row header is clicked
         * @return Object
         */
        this.onListItemClick = new EventEmitter();
        /**
         * @Event: onAllItemClick
         * @description This event that is fired when the menu is clicked. The event is returned.
         * @return Array
         */
        this.onAllItemClick = new EventEmitter();
        if (isDevMode()) {
            console.error('%cThe Common UI DDL ComplexTable <citi-complex-table> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    ngOnInit() {
        this.onResize(null);
        if (this._window != undefined) {
            fromEvent(window, 'resize').pipe(debounceTime(500))
                .subscribe(e => {
                this.onResize(e);
            });
        }
    }
    onResize(event) {
        if (isPlatformBrowser(this.platformId))
            this.isDesktopWidth = document.body.clientWidth > 768;
    }
    /**
     * @name onItemClick
     * @description Handles the item click event
     * @param (Object) - item - Clicked item.
     * @return void
     */
    onItemClick(item) {
        let selectedItem = null;
        for (let listItem of this._options.list.items) {
            if (listItem.key === item.key) {
                listItem.expanded = !listItem.expanded;
                selectedItem = JSON.parse(JSON.stringify(listItem));
                break;
            }
        }
        this.onListItemClick.emit(selectedItem);
    }
    /**
     * @name onAllItemButtonClick
     * @description Handles all item expanding/collapsing button clicked
     * @return void
     */
    onAllItemButtonClick(event) {
        let isExpanded = !this.allItemExpanded;
        for (let listItem of this._options.list.items) {
            listItem.expanded = isExpanded;
        }
        this.onAllItemClick.emit(this.data);
    }
    /**
     * @name showProcessingIndicator
     * @description The function displays the processing indicator with 'loadingMessage'
     * @return void
     */
    showProcessingIndicator() {
        this._isProcessing = true;
    }
    /**
     * @name hideProcessingIndicator
     * @description The function hides the processing indicator
     * @return void
     */
    hideProcessingIndicator() {
        this._isProcessing = false;
    }
    /**
     * @name removeSpaces
     * @description The function removes the spaces of the string argument
     * @return string
     */
    removeSpaces(str) {
        return str.replace(/\s+/g, '');
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ComplexTableComponent, deps: [{ token: PLATFORM_ID }, { token: WINDOW }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: ComplexTableComponent, isStandalone: false, selector: "citi-complex-table", inputs: { emptyMessage: "emptyMessage", isDesktopWidth: "isDesktopWidth", options: "options", subCaption: "subCaption", footnote: "footnote", caption: "caption", secondaryCaption: "secondaryCaption", data: "data", loadingMessage: "loadingMessage" }, outputs: { onListItemClick: "onListItemClick", onAllItemClick: "onAllItemClick" }, ngImport: i0, template: `
    <section class="rowspan-table-module grey">
      <div *ngIf="isProcessing" class="jamp jamp-css">
          <span class="img loading"></span>
          <span class="message" [innerHtml]="loadingMessage"></span>
      </div>
      <div *ngIf="!isProcessing && !hasData" class="jamp">
          <h4 style="color: #D60000"><strong [innerHtml]="emptyMessage"></strong></h4>
      </div>
      <div *ngIf="!isProcessing && hasData" class="container-fluid">
          <div class="row">
              <div class="col-md-12">
                  <table [ngClass]="{table: true, 'rowspan-table': true, 'mode-desktop': isDesktopWidth, 'mode-mobile': !isDesktopWidth}">
                      <caption [attr.aria-live]="'polite'" [attr.aria-atomic]="false">

                          <h2 *ngIf="caption !== undefined" [innerHtml]="caption"></h2>
                          <h3 *ngIf="subCaption" class="header-3" [innerHtml]="subCaption"></h3>
                          <p *ngIf="secondaryCaption !== undefined" [innerHTML]="secondaryCaption">
                          </p>

                          <ng-content></ng-content>
                          <div class="visible-xs">
                              <button data-id="0" class="toggle-accordion-table btn-link" (click)="onAllItemButtonClick($event)">
                  <span innerHtml="{{allItemExpanded ? 'Collapse All Sections' : 'Expand All Sections'}}"></span>
                </button>
                              <!-- data-accordion-state="collapse" data-toggled-copy="Collapse All Sections"-->
                          </div>
                      </caption>
                      <thead [attr.aria-hidden]="isDesktopWidth ? false: true">
                          <tr>
                              <th *ngFor="let item of options.displayedKeys" scope="col" id="complexTableTH-{{removeSpaces(item.key)}}">
                                  <strong [innerHtml]="item.text"></strong>
                              </th>
                          </tr>
                      </thead>
                      <ng-container *ngFor=" let item of options.list.items, let i = index ">
                          <tbody role="list">

                              <tr [ngClass]="{'for-mobile': true, 'is-expanded': item.expanded === true}" [attr.data-toggle]="item.expanded === true ? 'expanded' : 'collapse'" (click)="onItemClick(item)">
                                  <th attr.colspan="{{options.list.items.length + 2}}" class="mobileHeader">
                                      <button scope="col" id="complexTableButton-{{item.key}}" class="buttonHeader" [attr.aria-expanded]="item.expanded" attr.aria-controls="complexTableHeader-{{item.key}}">
                                          <div class="icon-svg svg-arrow-dropdown-down comparision-table-arrow-down" [ngClass]="{'arrowDown': true}"></div>
                                          <span id="complexTableHeader-{{item.key}}" class="category-title" role="listitem" [attr.aria-posinset]="i + 1" [attr.aria-setsize]="options.list.items.length" data-title="Select to hide" [innerHtml]="item.header"></span>
                                      </button>
                                  </th>
                              </tr>

                              <tr class="table-row collapse in" *ngFor="let subitem of item.item; let idx = index; " [attr.aria-labelledby]="'complexTableHeader-' + item.key"
                                  [ngClass]="(item.expanded==true)?'expandRow':'collapseRow'" [attr.aria-hidden]="!isDesktopWidth && item.expanded === false">

                                  <th *ngIf="idx == 0" attr.rowspan=" {{item.item.length}}" scope="row">
                                      {{item.header}}
                                  </th>

                                  <td *ngFor="let columnValue of subitem">
                                      <span class="row-content-container">{{columnValue}}</span>
                                  </td>
                              </tr>

                          </tbody>
                      </ng-container>
                  </table>
              </div>
          </div>

          <div *ngIf="footnote" class="row">
              <div class="col-md-12">

                  <div class="table-footnote">
                      <p><small>
                          {{footnote}}
                          <ng-content select="[content]"></ng-content>
                      </small></p>
                  </div>

              </div>
          </div>
      </div>
    </section>
  `, isInline: true, styles: [".buttonHeader{background:none;border:none;position:relative;line-height:1.5;vertical-align:top;border-top:1px solid #d8d8d8;font-size:16px;font-size:1rem;font-family:Interstate_light,sans-serif;padding:16px 18px 12px 55px!important}.mobileHeader{padding:0!important;margin:0!important}.arrowDown{position:absolute;top:25px;left:20px;height:8px;transition:transform .4s ease-in-out;transform:rotate(0);transform-origin:50%}.rowspan-table-module.grey{background-color:#eee}.rowspan-table .header-3{margin-bottom:0}.rowspan-table .header-3+p{margin-top:10px}@media (min-width: 992px){.rowspan-table .header-3+p{margin-top:18px}}.rowspan-table .toggle-accordion-table{text-decoration:underline;font-size:16px}.rowspan-table.table{margin-top:-1px}.rowspan-table.table>tbody+tbody{border:none}.rowspan-table.table caption{padding-top:20px;padding-bottom:20px;display:table-caption}.rowspan-table.table caption h2{margin-top:40px;margin-bottom:20px;padding-bottom:20px}.rowspan-table.table caption h3{margin-top:0;margin-bottom:0}@media (max-width: 991px){.rowspan-table.table caption{display:block}.rowspan-table.table caption h2{margin-top:20px;margin-bottom:0;padding-bottom:20px}.rowspan-table.table caption h3{margin-top:20px}.rowspan-table.table tr td{border:none}.rowspan-table.table tr td:last-child{border-bottom:1px solid #d8d8d8}.rowspan-table.table tr:last-child td:last-child{border-bottom:none}}.rowspan-table .table>thead>tr>th{border-top:1px solid #999;border-bottom:1px solid #999}.rowspan-table thead{position:absolute;overflow:hidden;width:1px;height:1px;padding:0}@media (min-width: 992px){.rowspan-table thead{position:relative;overflow:auto;width:auto;height:auto}}.rowspan-table thead tr th{vertical-align:top}.rowspan-table tbody,.rowspan-table td,.rowspan-table th,.rowspan-table tr{display:block}.rowspan-table tr.for-mobile{display:none}.rowspan-table tr.for-mobile :first-child th{border-top:0}@media (min-width: 992px){.rowspan-table tr{display:table-row!important}.rowspan-table tr.for-mobile{display:none!important}}@media (max-width: 991px){.rowspan-table tr.for-mobile{display:block}.rowspan-table tr.for-mobile+tr{visibility:hidden;overflow:hidden;max-height:0}.rowspan-table tr.for-mobile+tr td.complex-table-sub-header,.rowspan-table tr.for-mobile+tr th:first-child{display:none}.rowspan-table tr.is-expanded{background-color:#fff}.rowspan-table tr.is-expanded+tr{visibility:visible;max-height:300em}}.rowspan-table tr>th p{margin-bottom:0}.rowspan-table tr>th:last-child a,.rowspan-table tr>th:last-child p{margin-right:18px}.rowspan-table td,.rowspan-table th{font-weight:500!important;-webkit-font-smoothing:antialiased}@media (min-width: 992px){.rowspan-table td,.rowspan-table th{display:table-cell;width:5%}.rowspan-table tbody{display:table-row-group}}@media (max-width: 991px){.rowspan-table tbody tr td,.rowspan-table tbody tr th{padding-right:0;padding-left:0}.rowspan-table tbody tr td{margin-right:20px;margin-left:55px}.rowspan-table tbody tr th{position:relative}.rowspan-table tbody tr th:first-child{padding-left:55px}}@media (min-width: 992px){.rowspan-table tbody tr{display:table-row}}.rowspan-table tbody{width:100%}.rowspan-table tbody td .row-content-container{display:block}.rowspan-table tbody tr.for-mobile{background-color:#eee;transition:background-color .5s ease-in-out}.rowspan-table tbody tr.for-mobile.is-expanded{background-color:#fff;transition:background-color .5s ease-in-out}.rowspan-table tr{width:100%;overflow:hidden}.rowspan-table tr.table-row.collapse{height:0;width:100%;display:block}.rowspan-table tr.table-row.collapse.in{height:auto;width:100%;display:block}@media (max-width: 991px){.rowspan-table.mode-mobile tbody tr.table-row.collapse.in,.rowspan-table.mode-mobile tbody tr.table-row.collapsing{background-color:#fff}.rowspan-table.mode-mobile tbody tr.table-row.collapse.in th,.rowspan-table.mode-mobile tbody tr.table-row.collapse.in th:first-child,.rowspan-table.mode-mobile tbody tr.table-row.collapsing th,.rowspan-table.mode-mobile tbody tr.table-row.collapsing th:first-child{display:none}}.rowspan-table.mode-mobile tbody.theaders-visible tr.table-row.collapse.in th,.rowspan-table.mode-mobile tbody.theaders-visible tr.table-row.collapse.in th:first-child,.rowspan-table.mode-mobile tbody.theaders-visible tr.table-row.collapsing th,.rowspan-table.mode-mobile tbody.theaders-visible tr.table-row.collapsing th:first-child{display:block}.rowspan-table.mode-mobile tbody tr td{padding-left:0}@media (min-width: 991px){.rowspan-table.mode-mobile tbody tr td{padding-left:18px}}.rowspan-table.mode-desktop tbody tr td{padding-left:18px}.rowspan-table tr.expandRow{visibility:visible;max-height:auto}.rowspan-table tr.collapseRow{visibility:none;max-height:0}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ComplexTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-complex-table', standalone: false, template: `
    <section class="rowspan-table-module grey">
      <div *ngIf="isProcessing" class="jamp jamp-css">
          <span class="img loading"></span>
          <span class="message" [innerHtml]="loadingMessage"></span>
      </div>
      <div *ngIf="!isProcessing && !hasData" class="jamp">
          <h4 style="color: #D60000"><strong [innerHtml]="emptyMessage"></strong></h4>
      </div>
      <div *ngIf="!isProcessing && hasData" class="container-fluid">
          <div class="row">
              <div class="col-md-12">
                  <table [ngClass]="{table: true, 'rowspan-table': true, 'mode-desktop': isDesktopWidth, 'mode-mobile': !isDesktopWidth}">
                      <caption [attr.aria-live]="'polite'" [attr.aria-atomic]="false">

                          <h2 *ngIf="caption !== undefined" [innerHtml]="caption"></h2>
                          <h3 *ngIf="subCaption" class="header-3" [innerHtml]="subCaption"></h3>
                          <p *ngIf="secondaryCaption !== undefined" [innerHTML]="secondaryCaption">
                          </p>

                          <ng-content></ng-content>
                          <div class="visible-xs">
                              <button data-id="0" class="toggle-accordion-table btn-link" (click)="onAllItemButtonClick($event)">
                  <span innerHtml="{{allItemExpanded ? 'Collapse All Sections' : 'Expand All Sections'}}"></span>
                </button>
                              <!-- data-accordion-state="collapse" data-toggled-copy="Collapse All Sections"-->
                          </div>
                      </caption>
                      <thead [attr.aria-hidden]="isDesktopWidth ? false: true">
                          <tr>
                              <th *ngFor="let item of options.displayedKeys" scope="col" id="complexTableTH-{{removeSpaces(item.key)}}">
                                  <strong [innerHtml]="item.text"></strong>
                              </th>
                          </tr>
                      </thead>
                      <ng-container *ngFor=" let item of options.list.items, let i = index ">
                          <tbody role="list">

                              <tr [ngClass]="{'for-mobile': true, 'is-expanded': item.expanded === true}" [attr.data-toggle]="item.expanded === true ? 'expanded' : 'collapse'" (click)="onItemClick(item)">
                                  <th attr.colspan="{{options.list.items.length + 2}}" class="mobileHeader">
                                      <button scope="col" id="complexTableButton-{{item.key}}" class="buttonHeader" [attr.aria-expanded]="item.expanded" attr.aria-controls="complexTableHeader-{{item.key}}">
                                          <div class="icon-svg svg-arrow-dropdown-down comparision-table-arrow-down" [ngClass]="{'arrowDown': true}"></div>
                                          <span id="complexTableHeader-{{item.key}}" class="category-title" role="listitem" [attr.aria-posinset]="i + 1" [attr.aria-setsize]="options.list.items.length" data-title="Select to hide" [innerHtml]="item.header"></span>
                                      </button>
                                  </th>
                              </tr>

                              <tr class="table-row collapse in" *ngFor="let subitem of item.item; let idx = index; " [attr.aria-labelledby]="'complexTableHeader-' + item.key"
                                  [ngClass]="(item.expanded==true)?'expandRow':'collapseRow'" [attr.aria-hidden]="!isDesktopWidth && item.expanded === false">

                                  <th *ngIf="idx == 0" attr.rowspan=" {{item.item.length}}" scope="row">
                                      {{item.header}}
                                  </th>

                                  <td *ngFor="let columnValue of subitem">
                                      <span class="row-content-container">{{columnValue}}</span>
                                  </td>
                              </tr>

                          </tbody>
                      </ng-container>
                  </table>
              </div>
          </div>

          <div *ngIf="footnote" class="row">
              <div class="col-md-12">

                  <div class="table-footnote">
                      <p><small>
                          {{footnote}}
                          <ng-content select="[content]"></ng-content>
                      </small></p>
                  </div>

              </div>
          </div>
      </div>
    </section>
  `, styles: [".buttonHeader{background:none;border:none;position:relative;line-height:1.5;vertical-align:top;border-top:1px solid #d8d8d8;font-size:16px;font-size:1rem;font-family:Interstate_light,sans-serif;padding:16px 18px 12px 55px!important}.mobileHeader{padding:0!important;margin:0!important}.arrowDown{position:absolute;top:25px;left:20px;height:8px;transition:transform .4s ease-in-out;transform:rotate(0);transform-origin:50%}.rowspan-table-module.grey{background-color:#eee}.rowspan-table .header-3{margin-bottom:0}.rowspan-table .header-3+p{margin-top:10px}@media (min-width: 992px){.rowspan-table .header-3+p{margin-top:18px}}.rowspan-table .toggle-accordion-table{text-decoration:underline;font-size:16px}.rowspan-table.table{margin-top:-1px}.rowspan-table.table>tbody+tbody{border:none}.rowspan-table.table caption{padding-top:20px;padding-bottom:20px;display:table-caption}.rowspan-table.table caption h2{margin-top:40px;margin-bottom:20px;padding-bottom:20px}.rowspan-table.table caption h3{margin-top:0;margin-bottom:0}@media (max-width: 991px){.rowspan-table.table caption{display:block}.rowspan-table.table caption h2{margin-top:20px;margin-bottom:0;padding-bottom:20px}.rowspan-table.table caption h3{margin-top:20px}.rowspan-table.table tr td{border:none}.rowspan-table.table tr td:last-child{border-bottom:1px solid #d8d8d8}.rowspan-table.table tr:last-child td:last-child{border-bottom:none}}.rowspan-table .table>thead>tr>th{border-top:1px solid #999;border-bottom:1px solid #999}.rowspan-table thead{position:absolute;overflow:hidden;width:1px;height:1px;padding:0}@media (min-width: 992px){.rowspan-table thead{position:relative;overflow:auto;width:auto;height:auto}}.rowspan-table thead tr th{vertical-align:top}.rowspan-table tbody,.rowspan-table td,.rowspan-table th,.rowspan-table tr{display:block}.rowspan-table tr.for-mobile{display:none}.rowspan-table tr.for-mobile :first-child th{border-top:0}@media (min-width: 992px){.rowspan-table tr{display:table-row!important}.rowspan-table tr.for-mobile{display:none!important}}@media (max-width: 991px){.rowspan-table tr.for-mobile{display:block}.rowspan-table tr.for-mobile+tr{visibility:hidden;overflow:hidden;max-height:0}.rowspan-table tr.for-mobile+tr td.complex-table-sub-header,.rowspan-table tr.for-mobile+tr th:first-child{display:none}.rowspan-table tr.is-expanded{background-color:#fff}.rowspan-table tr.is-expanded+tr{visibility:visible;max-height:300em}}.rowspan-table tr>th p{margin-bottom:0}.rowspan-table tr>th:last-child a,.rowspan-table tr>th:last-child p{margin-right:18px}.rowspan-table td,.rowspan-table th{font-weight:500!important;-webkit-font-smoothing:antialiased}@media (min-width: 992px){.rowspan-table td,.rowspan-table th{display:table-cell;width:5%}.rowspan-table tbody{display:table-row-group}}@media (max-width: 991px){.rowspan-table tbody tr td,.rowspan-table tbody tr th{padding-right:0;padding-left:0}.rowspan-table tbody tr td{margin-right:20px;margin-left:55px}.rowspan-table tbody tr th{position:relative}.rowspan-table tbody tr th:first-child{padding-left:55px}}@media (min-width: 992px){.rowspan-table tbody tr{display:table-row}}.rowspan-table tbody{width:100%}.rowspan-table tbody td .row-content-container{display:block}.rowspan-table tbody tr.for-mobile{background-color:#eee;transition:background-color .5s ease-in-out}.rowspan-table tbody tr.for-mobile.is-expanded{background-color:#fff;transition:background-color .5s ease-in-out}.rowspan-table tr{width:100%;overflow:hidden}.rowspan-table tr.table-row.collapse{height:0;width:100%;display:block}.rowspan-table tr.table-row.collapse.in{height:auto;width:100%;display:block}@media (max-width: 991px){.rowspan-table.mode-mobile tbody tr.table-row.collapse.in,.rowspan-table.mode-mobile tbody tr.table-row.collapsing{background-color:#fff}.rowspan-table.mode-mobile tbody tr.table-row.collapse.in th,.rowspan-table.mode-mobile tbody tr.table-row.collapse.in th:first-child,.rowspan-table.mode-mobile tbody tr.table-row.collapsing th,.rowspan-table.mode-mobile tbody tr.table-row.collapsing th:first-child{display:none}}.rowspan-table.mode-mobile tbody.theaders-visible tr.table-row.collapse.in th,.rowspan-table.mode-mobile tbody.theaders-visible tr.table-row.collapse.in th:first-child,.rowspan-table.mode-mobile tbody.theaders-visible tr.table-row.collapsing th,.rowspan-table.mode-mobile tbody.theaders-visible tr.table-row.collapsing th:first-child{display:block}.rowspan-table.mode-mobile tbody tr td{padding-left:0}@media (min-width: 991px){.rowspan-table.mode-mobile tbody tr td{padding-left:18px}}.rowspan-table.mode-desktop tbody tr td{padding-left:18px}.rowspan-table tr.expandRow{visibility:visible;max-height:auto}.rowspan-table tr.collapseRow{visibility:none;max-height:0}\n"] }]
        }], ctorParameters: () => [{ type: Object, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }], propDecorators: { onListItemClick: [{
                type: Output
            }], onAllItemClick: [{
                type: Output
            }], emptyMessage: [{
                type: Input$1
            }], isDesktopWidth: [{
                type: Input$1
            }], options: [{
                type: Input$1
            }], subCaption: [{
                type: Input$1
            }], footnote: [{
                type: Input$1
            }], caption: [{
                type: Input$1
            }], secondaryCaption: [{
                type: Input$1
            }], data: [{
                type: Input$1
            }], loadingMessage: [{
                type: Input$1
            }] } });

const COMPONENTS$4 = [
    ComplexTableComponent
];
const MODULES$4 = [
    CommonModule,
];
class ComplexTable {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ComplexTable, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: ComplexTable, declarations: [ComplexTableComponent], imports: [CommonModule], exports: [ComplexTableComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ComplexTable, imports: [MODULES$4] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ComplexTable, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$4],
                    declarations: [...COMPONENTS$4],
                    exports: [...COMPONENTS$4]
                }]
        }] });

class ETSubRowDataMobileComponent {
    constructor() {
        if (isDevMode()) {
            console.error('%cThe Common UI DDL ExpandablesTable <citi-et-subRowData-mobile> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ETSubRowDataMobileComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: ETSubRowDataMobileComponent, isStandalone: false, selector: "citi-et-subRowData-mobile", inputs: { mobileDataObj: "mobileDataObj" }, ngImport: i0, template: `
    <div class="totalRowContainer bgColorWhenExpanded">
      <div class="HiddencolumnItemContainer">
          <ng-content></ng-content>
      </div>
    </div>
  `, isInline: true, styles: [".totalRowContainer{padding-left:20px}.HiddencolumnItemContainer{display:flex;flex-direction:column;flex-wrap:nowrap;justify-content:flex-start;align-content:flex-start;align-items:flex-start;padding:0 0 20px 28px}.bgColorWhenExpanded{background-color:#eee}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ETSubRowDataMobileComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-et-subRowData-mobile', standalone: false, template: `
    <div class="totalRowContainer bgColorWhenExpanded">
      <div class="HiddencolumnItemContainer">
          <ng-content></ng-content>
      </div>
    </div>
  `, styles: [".totalRowContainer{padding-left:20px}.HiddencolumnItemContainer{display:flex;flex-direction:column;flex-wrap:nowrap;justify-content:flex-start;align-content:flex-start;align-items:flex-start;padding:0 0 20px 28px}.bgColorWhenExpanded{background-color:#eee}\n"] }]
        }], ctorParameters: () => [], propDecorators: { mobileDataObj: [{
                type: Input$1
            }] } });

class ETSubRowMobileComponent {
    constructor(liveAnnouncer) {
        this.liveAnnouncer = liveAnnouncer;
        this.isCollapsed = true;
        this.toggleButtonEvent = new EventEmitter();
        if (isDevMode()) {
            console.error('%cThe Common UI DDL ExpandablesTable <citi-et-subRow-mobile> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    expandSubData(e) {
        this.isCollapsed = !this.isCollapsed;
        this.liveAnnouncer.announce(`button is ${this.isCollapsed ? 'collapsed' : 'expanded'}`);
        this.toggleButtonEvent.emit(e);
    }
    SRannounceWhenFocus() {
        this.liveAnnouncer.announce(`button is ${this.isCollapsed ? 'collapsed' : 'expanded'}`);
    }
    expandableSubData(e) {
        if (e.keyCode === 32 || e.keyCode === 13) {
            e.preventDefault();
            this.expandSubData(e);
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ETSubRowMobileComponent, deps: [{ token: CitiLiveAnnouncer }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: ETSubRowMobileComponent, isStandalone: false, selector: "citi-et-subRow-mobile", inputs: { tableRows: "tableRows", columns: "columns", mobileDataObj: "mobileDataObj" }, outputs: { toggleButtonEvent: "toggleButtonEvent" }, viewQueries: [{ propertyName: "arrowSpan", first: true, predicate: ["arrowSpan"], descendants: true }], ngImport: i0, template: `
    <div class="expandableRow">
      <div
          class="rowExpand"
          [ngClass]="{'grayBackground': !isCollapsed}"
          tabindex="0"
          role="presentation"
          (click)="expandSubData($event)"
          (focus)="SRannounceWhenFocus()"
          (keypress)="expandableSubData($event)">

          <span #arrowSpan
              class="icon-svg svg-arrow-dropdown-down arrow-expandable-table"
              [ngClass]="(!isCollapsed ? 'upArrow-expandable-table':'arrow-expandable-table')">
          </span>
          <ng-content></ng-content>
      </div>
    </div>

    <ng-container  *ngIf="!isCollapsed">
        <citi-et-subRowData-mobile
            *ngFor="let subData of mobileDataObj.rows; let i= index"
            [mobileDataObj]="mobileDataObj[i]">
                <div><strong [innerHtml]="subData.label"></strong></div>
                <div [innerHtml]="subData.value"></div>
        </citi-et-subRowData-mobile>
    </ng-container>
  `, isInline: true, styles: [".rowExpand{padding:20px 0 20px 20px;cursor:pointer;border-top:1px solid black!important}.arrow-expandable-table{position:relative;top:3px;margin-right:5px;transition:transform .4s ease-in-out;transform-origin:50%}.upArrow-expandable-table{transform:rotate(180deg);position:relative;top:-3px;margin-right:5px;transition:transform .4s ease-in-out;transform-origin:50%}.grayBackground{background-color:#eee}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: ETSubRowDataMobileComponent, selector: "citi-et-subRowData-mobile", inputs: ["mobileDataObj"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ETSubRowMobileComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-et-subRow-mobile', standalone: false, template: `
    <div class="expandableRow">
      <div
          class="rowExpand"
          [ngClass]="{'grayBackground': !isCollapsed}"
          tabindex="0"
          role="presentation"
          (click)="expandSubData($event)"
          (focus)="SRannounceWhenFocus()"
          (keypress)="expandableSubData($event)">

          <span #arrowSpan
              class="icon-svg svg-arrow-dropdown-down arrow-expandable-table"
              [ngClass]="(!isCollapsed ? 'upArrow-expandable-table':'arrow-expandable-table')">
          </span>
          <ng-content></ng-content>
      </div>
    </div>

    <ng-container  *ngIf="!isCollapsed">
        <citi-et-subRowData-mobile
            *ngFor="let subData of mobileDataObj.rows; let i= index"
            [mobileDataObj]="mobileDataObj[i]">
                <div><strong [innerHtml]="subData.label"></strong></div>
                <div [innerHtml]="subData.value"></div>
        </citi-et-subRowData-mobile>
    </ng-container>
  `, styles: [".rowExpand{padding:20px 0 20px 20px;cursor:pointer;border-top:1px solid black!important}.arrow-expandable-table{position:relative;top:3px;margin-right:5px;transition:transform .4s ease-in-out;transform-origin:50%}.upArrow-expandable-table{transform:rotate(180deg);position:relative;top:-3px;margin-right:5px;transition:transform .4s ease-in-out;transform-origin:50%}.grayBackground{background-color:#eee}\n"] }]
        }], ctorParameters: () => [{ type: CitiLiveAnnouncer }], propDecorators: { tableRows: [{
                type: Input$1
            }], columns: [{
                type: Input$1
            }], mobileDataObj: [{
                type: Input$1
            }], arrowSpan: [{
                type: ViewChild,
                args: ['arrowSpan']
            }], toggleButtonEvent: [{
                type: Output
            }] } });

class ETRowMobileComponent {
    constructor(liveAnnouncer) {
        this.liveAnnouncer = liveAnnouncer;
        // PROPERTIES, Inputs and Outputs //
        this.isCollapsed = true;
        /**
         * @property _shouldCloseRow
         * @description When in expandOneOnly mode, determine whether or not we are in a row to be closed
         */
        this._shouldCloseRow = false;
        /**
           * @property closeOtherSections
           * @description Event Emitter for expandOnlyOne mode, when we need to close other sections
           */
        this.closeOtherSections = new EventEmitter();
        /**
         * @property toggleButtonEvent
         * @description Event Emitter for the expand more rows button
         */
        this.toggleButtonEvent = new EventEmitter();
        if (isDevMode()) {
            console.error('%cThe Common UI DDL ExpandablesTable <citi-et-row-mobile> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    set shouldCloseRow(close) {
        this._shouldCloseRow = close;
        if (this.expandOneOnly && !this.isCollapsed && this._shouldCloseRow) {
            this.isCollapsed = !this.isCollapsed;
            setTimeout(() => this.liveAnnouncer.announce('button is expanded ' + this.expandOneOnlyCollapseMessage), 500);
        }
    }
    // EXPAND AND COLLAPSED FUNCTIONALITY
    expandSubData(e) {
        this.isCollapsed = !this.isCollapsed;
        this.liveAnnouncer.announce(`button is ${this.isCollapsed ? 'collapsed' : 'expanded'}`);
        this.toggleButtonEvent.emit(e);
        // When in expandOneOnly mode, emit when we need to close the other sections
        if (this.expandOneOnly && !this.isCollapsed)
            this.closeOtherSections.emit(this.rowId);
    }
    // FOR SCREEN READER
    SRannounceWhenFocus() {
        this.liveAnnouncer.announce(`button is ${this.isCollapsed ? 'collapsed' : 'expanded'}`);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ETRowMobileComponent, deps: [{ token: CitiLiveAnnouncer }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: ETRowMobileComponent, isStandalone: false, selector: "citi-et-row-mobile", inputs: { tableRow: "tableRow", rowId: "rowId", expandOneOnly: "expandOneOnly", expandOneOnlyCollapseMessage: "expandOneOnlyCollapseMessage", label: "label", expandText: "expandText", collapseText: "collapseText", mobileDataMainLabel: "mobileDataMainLabel", mobileDataObj: "mobileDataObj", shouldCloseRow: "shouldCloseRow" }, outputs: { closeOtherSections: "closeOtherSections", toggleButtonEvent: "toggleButtonEvent" }, ngImport: i0, template: `
 <div [ngClass]="tableRow.highlightclass">
    <div class="firstMainRow">
      <div class="columnItemContainer noBorderTop">
          <div class="colItem">
              <strong [innerHtml]="mobileDataMainLabel.label"  role="heading" aria-level="3"></strong>
          </div>
      </div>
  </div>

  <div role = "list">
      <div role = "presentation">
          <div class="columnItemContainer" *ngFor="let column of mobileDataMainLabel.rows" role="listitem">
              <div class="colItem" [attr.aria-label]="column.label + column.primaryVal">
                  <span class=" colItem colItem-1" aria-hidden="true" [innerHtml]="column.label">
                      <span *ngIf="column.hasTertiary" [innerHtml]="label"></span>
                  </span>
                  <span class=" colItem colItem-2" aria-hidden="true" [innerHtml]="column.primaryVal || '&mdash;'" ></span>
              </div>
          </div>
      </div>
  </div>

      <div class="columnItemContainer">
          <div class="colItem">
              <button type="button" class="btn btn-link" (click)="expandSubData($event)" (focus)="SRannounceWhenFocus()" role="button">
                  <span *ngIf="isCollapsed" class="btn btn-link">{{expandText}}</span>
                  <span *ngIf="!isCollapsed" class="btn btn-link buttonCopyStyleWhenExpanded">{{collapseText}}</span>
              </button>
          </div>
      </div>
      <ng-container *ngIf="!isCollapsed" >
          <citi-et-subRow-mobile
              (toggleButtonEvent)="toggleButtonEvent.emit($event)"
              *ngFor="let eachRow of mobileDataMainLabel.collapsedSections; let i =index"
              [mobileDataObj]="mobileDataMainLabel.collapsedSections[i]">
                <span class="lowerExpandableSection" [innerHtml]="eachRow.label"></span>
          </citi-et-subRow-mobile>
      </ng-container>
</div>
  `, isInline: true, styles: [".columnItemContainer{display:flex;flex-direction:row;flex-wrap:nowrap;border-top:1px solid #7f7474;width:100%}.colItem{order:0;flex:1 1 auto;align-self:auto;padding:20px;width:auto}.colItem-1,.colItem-2{width:50%}.noBorderTop{border-top:none}.buttonCopyStyleWhenExpanded{color:#002a54}.lowerExpandableSection{margin-left:3px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: ETSubRowMobileComponent, selector: "citi-et-subRow-mobile", inputs: ["tableRows", "columns", "mobileDataObj"], outputs: ["toggleButtonEvent"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ETRowMobileComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-et-row-mobile', standalone: false, template: `
 <div [ngClass]="tableRow.highlightclass">
    <div class="firstMainRow">
      <div class="columnItemContainer noBorderTop">
          <div class="colItem">
              <strong [innerHtml]="mobileDataMainLabel.label"  role="heading" aria-level="3"></strong>
          </div>
      </div>
  </div>

  <div role = "list">
      <div role = "presentation">
          <div class="columnItemContainer" *ngFor="let column of mobileDataMainLabel.rows" role="listitem">
              <div class="colItem" [attr.aria-label]="column.label + column.primaryVal">
                  <span class=" colItem colItem-1" aria-hidden="true" [innerHtml]="column.label">
                      <span *ngIf="column.hasTertiary" [innerHtml]="label"></span>
                  </span>
                  <span class=" colItem colItem-2" aria-hidden="true" [innerHtml]="column.primaryVal || '&mdash;'" ></span>
              </div>
          </div>
      </div>
  </div>

      <div class="columnItemContainer">
          <div class="colItem">
              <button type="button" class="btn btn-link" (click)="expandSubData($event)" (focus)="SRannounceWhenFocus()" role="button">
                  <span *ngIf="isCollapsed" class="btn btn-link">{{expandText}}</span>
                  <span *ngIf="!isCollapsed" class="btn btn-link buttonCopyStyleWhenExpanded">{{collapseText}}</span>
              </button>
          </div>
      </div>
      <ng-container *ngIf="!isCollapsed" >
          <citi-et-subRow-mobile
              (toggleButtonEvent)="toggleButtonEvent.emit($event)"
              *ngFor="let eachRow of mobileDataMainLabel.collapsedSections; let i =index"
              [mobileDataObj]="mobileDataMainLabel.collapsedSections[i]">
                <span class="lowerExpandableSection" [innerHtml]="eachRow.label"></span>
          </citi-et-subRow-mobile>
      </ng-container>
</div>
  `, styles: [".columnItemContainer{display:flex;flex-direction:row;flex-wrap:nowrap;border-top:1px solid #7f7474;width:100%}.colItem{order:0;flex:1 1 auto;align-self:auto;padding:20px;width:auto}.colItem-1,.colItem-2{width:50%}.noBorderTop{border-top:none}.buttonCopyStyleWhenExpanded{color:#002a54}.lowerExpandableSection{margin-left:3px}\n"] }]
        }], ctorParameters: () => [{ type: CitiLiveAnnouncer }], propDecorators: { tableRow: [{
                type: Input$1
            }], rowId: [{
                type: Input$1
            }], expandOneOnly: [{
                type: Input$1
            }], expandOneOnlyCollapseMessage: [{
                type: Input$1
            }], label: [{
                type: Input$1
            }], expandText: [{
                type: Input$1
            }], collapseText: [{
                type: Input$1
            }], mobileDataMainLabel: [{
                type: Input$1
            }], mobileDataObj: [{
                type: Input$1
            }], shouldCloseRow: [{
                type: Input$1
            }], closeOtherSections: [{
                type: Output
            }], toggleButtonEvent: [{
                type: Output
            }] } });

class ExpandablesTableThComponent {
    constructor(parentElment, announcer) {
        this.announcer = announcer;
        this.thClick = new EventEmitter();
        this.iconShade = 'b2';
        this._descending = true;
        this.sortAnnounce = 'sort by ascending';
        this.ariaSort = 'none';
        if (isDevMode()) {
            console.error('%cThe Common UI DDL ExpandablesTable <th citi-et-th> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
        this.parentElment = parentElment;
    }
    getAriaSort(index) {
        return index === this.currentIndex ? (this._descending ? 'descending' : 'ascending') : null;
    }
    getSortAnnounce(index) {
        return index === this.currentIndex ? (this._descending ? 'sort by descending' : 'sort by ascending') : null;
    }
    thSort(column, index) {
        // do nothing if not sortable
        if (!column.isSortable)
            return;
        // was th clicked again
        if (index === this.currentIndex) {
            this._descending = !this._descending;
            if (this._descending) {
                this.sortAnnounce = 'descending';
                this.ariaSort = 'descending';
            }
            else {
                this.sortAnnounce = 'ascending';
                this.ariaSort = 'ascending';
            }
        }
        else {
            this.currentIndex = index;
        }
        this.thClick.emit({ headerIndex: index, dataIndex: index - 1, isAscending: !this._descending, title: column.title });
    }
    getIconClass(index) {
        return index === this.currentIndex ? this._descending ? '02-down' : '01-up' : '04-right';
    }
    onFocus() {
        this.announcer.announce(this.sortAnnounce);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ExpandablesTableThComponent, deps: [{ token: i0.ElementRef }, { token: CitiLiveAnnouncer }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: ExpandablesTableThComponent, isStandalone: false, selector: "[citi-et-th]", inputs: { columns: "columns", label: "label" }, outputs: { thClick: "thClick" }, ngImport: i0, template: `
  <th *ngFor="let column of columns;
  index as i" scope="col"
  [class.sortable]="column.isSortable"
  [attr.aria-sort]="getAriaSort(i)"
  [attr.aria-label]="getSortAnnounce(i)"
  aria-live="polite" >
  <button type="button" class="sortableCopy" *ngIf="column.isSortable else nonSortableTemplate"
          (focus)="onFocus()" (click)="thSort(column, i)"
          >
    <span [innerHtml]="column.title"></span>
    <citi-icon2 ariaLabel='icon' [name]="getIconClass(i)" [shade]="iconShade" size="small"></citi-icon2>
    </button>
    <ng-template #nonSortableTemplate>
    <span [innerHtml]="column.title"></span>
    </ng-template>
    <span *ngIf="column.showButton" [innerHtml]="label"></span>
  </th>
  `, isInline: true, styles: ["th{padding:20px!important;border:none!important;font-family:Interstate_Bold,sans-serif!important;font-size:16px}.sortableCopy:hover{color:#002a54;text-decoration:underline;cursor:pointer}.sortable{color:#056dae}citi-icon2 ::ng-deep .sfi.small{margin:0 3px;height:8px}citi-icon2 ::ng-deep .b1-04-right.sfi.small,citi-icon2 ::ng-deep .b2-04-right.sfi.small{height:12px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: Icon2Component, selector: "citi-icon2", inputs: ["role", "idStr", "ariaLabel", "ariaHidden", "size", "isHoverSfi", "includeCircle", "type", "svgStyle", "tabIndex", "shade", "name"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ExpandablesTableThComponent, decorators: [{
            type: Component,
            args: [{ selector: '[citi-et-th]', standalone: false, template: `
  <th *ngFor="let column of columns;
  index as i" scope="col"
  [class.sortable]="column.isSortable"
  [attr.aria-sort]="getAriaSort(i)"
  [attr.aria-label]="getSortAnnounce(i)"
  aria-live="polite" >
  <button type="button" class="sortableCopy" *ngIf="column.isSortable else nonSortableTemplate"
          (focus)="onFocus()" (click)="thSort(column, i)"
          >
    <span [innerHtml]="column.title"></span>
    <citi-icon2 ariaLabel='icon' [name]="getIconClass(i)" [shade]="iconShade" size="small"></citi-icon2>
    </button>
    <ng-template #nonSortableTemplate>
    <span [innerHtml]="column.title"></span>
    </ng-template>
    <span *ngIf="column.showButton" [innerHtml]="label"></span>
  </th>
  `, styles: ["th{padding:20px!important;border:none!important;font-family:Interstate_Bold,sans-serif!important;font-size:16px}.sortableCopy:hover{color:#002a54;text-decoration:underline;cursor:pointer}.sortable{color:#056dae}citi-icon2 ::ng-deep .sfi.small{margin:0 3px;height:8px}citi-icon2 ::ng-deep .b1-04-right.sfi.small,citi-icon2 ::ng-deep .b2-04-right.sfi.small{height:12px}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: CitiLiveAnnouncer }], propDecorators: { columns: [{
                type: Input$1
            }], label: [{
                type: Input$1
            }], thClick: [{
                type: Output
            }] } });

class ExpandablesTableTrComponent {
    set shouldCloseRow(close) {
        this._shouldCloseRow = close;
        if (this.expandOneOnly && !this.isCollapsed && this._shouldCloseRow) {
            this.isCollapsed = !this.isCollapsed;
            setTimeout(() => this.liveAnnouncer.announce(`button is expanded ${this.expandOneOnlyCollapseMessage}`), 500);
        }
    }
    constructor(liveAnnouncer) {
        this.liveAnnouncer = liveAnnouncer;
        this.isCollapsed = true;
        /**
         * @property _shouldCloseRow
         * @description When in expandOneOnly mode, determine whether or not we are in a row to be closed
         */ this._shouldCloseRow = false;
        /**
         * @property toggleButtonEvent
         * @description Event Emitter for the expand more rows button
         */
        this.toggleButtonEvent = new EventEmitter();
        /**
        * @property closeOtherSections
        * @description Event Emitter for expandOnlyOne mode, when we need to close other sections
        */
        this.closeOtherSections = new EventEmitter();
        if (isDevMode()) {
            console.error('%cThe Common UI DDL ExpandablesTable <tr citi-et-tr> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    expandSubData(e) {
        this.isCollapsed = !this.isCollapsed;
        this.liveAnnouncer.announce(`button is ${this.isCollapsed ? 'collapsed' : 'expanded'}`);
        e.tableRow = this.tableRow;
        this.toggleButtonEvent.emit(e);
        // When in expandOneOnly mode, emit when we need to close the other sections
        if (this.expandOneOnly && !this.isCollapsed)
            this.closeOtherSections.emit(this.rowId);
    }
    SRannounceWhenFocus() {
        this.liveAnnouncer.announce(`button is ${this.isCollapsed ? 'collapsed' : 'expanded'}`);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ExpandablesTableTrComponent, deps: [{ token: CitiLiveAnnouncer }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: ExpandablesTableTrComponent, isStandalone: false, selector: "[citi-et-tr]", inputs: { tableRow: "tableRow", expandText: "expandText", collapseText: "collapseText", rowId: "rowId", expandOneOnly: "expandOneOnly", expandOneOnlyCollapseMessage: "expandOneOnlyCollapseMessage", shouldCloseRow: "shouldCloseRow" }, outputs: { toggleButtonEvent: "toggleButtonEvent", closeOtherSections: "closeOtherSections" }, ngImport: i0, template: `
    <tr class="expandableTable-row"
      [class.bgcolorWhenExpanded]="!isCollapsed"
      [class.lastHasBottomBorder]="isCollapsed"
      [ngClass]="[tableRow?.highlightclass || '']"
    >
      <td class="firstColumnFont">
          <span [innerHtml]="tableRow.rowHeader"></span>
          <div>
              <button type="button" class="btn btn-link" (click)="expandSubData($event)" (focus)="SRannounceWhenFocus()">
                  <span *ngIf="isCollapsed" class="btn btn-link">{{expandText}}</span>
                  <span *ngIf="!isCollapsed" class="btn btn-link buttonCopyStyleWhenExpanded">{{collapseText}}</span>
              </button>
          </div>
      </td>
      <td *ngFor="let item of tableRow.rowData; let i=index;" [innerHtml]="item || '&mdash;'"></td>
    </tr>
    <ng-container *ngIf="!isCollapsed">
    <tr *ngFor="let subData of tableRow.subRowData" class="hidden-row bgcolorWhenExpanded">
        <td *ngFor="let subItem of subData" [innerHtml]="subItem"></td>
    </tr>
    </ng-container>
  `, isInline: true, styles: [".firstColumnFont{font-family:Interstate_Bold,sans-serif!important}.btn{margin-right:0}.buttonCopyStyleWhenExpanded{color:#002a54}.bgcolorWhenExpanded{background-color:#eee}td{padding:20px!important;border:none!important}tr{border:none!important}.hidden-row:after{content:\"\";width:calc(100% - 40px);height:1px;background:#b2b2b2;position:absolute;left:20px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ExpandablesTableTrComponent, decorators: [{
            type: Component,
            args: [{ selector: '[citi-et-tr]', standalone: false, template: `
    <tr class="expandableTable-row"
      [class.bgcolorWhenExpanded]="!isCollapsed"
      [class.lastHasBottomBorder]="isCollapsed"
      [ngClass]="[tableRow?.highlightclass || '']"
    >
      <td class="firstColumnFont">
          <span [innerHtml]="tableRow.rowHeader"></span>
          <div>
              <button type="button" class="btn btn-link" (click)="expandSubData($event)" (focus)="SRannounceWhenFocus()">
                  <span *ngIf="isCollapsed" class="btn btn-link">{{expandText}}</span>
                  <span *ngIf="!isCollapsed" class="btn btn-link buttonCopyStyleWhenExpanded">{{collapseText}}</span>
              </button>
          </div>
      </td>
      <td *ngFor="let item of tableRow.rowData; let i=index;" [innerHtml]="item || '&mdash;'"></td>
    </tr>
    <ng-container *ngIf="!isCollapsed">
    <tr *ngFor="let subData of tableRow.subRowData" class="hidden-row bgcolorWhenExpanded">
        <td *ngFor="let subItem of subData" [innerHtml]="subItem"></td>
    </tr>
    </ng-container>
  `, styles: [".firstColumnFont{font-family:Interstate_Bold,sans-serif!important}.btn{margin-right:0}.buttonCopyStyleWhenExpanded{color:#002a54}.bgcolorWhenExpanded{background-color:#eee}td{padding:20px!important;border:none!important}tr{border:none!important}.hidden-row:after{content:\"\";width:calc(100% - 40px);height:1px;background:#b2b2b2;position:absolute;left:20px}\n"] }]
        }], ctorParameters: () => [{ type: CitiLiveAnnouncer }], propDecorators: { tableRow: [{
                type: Input$1
            }], expandText: [{
                type: Input$1
            }], collapseText: [{
                type: Input$1
            }], rowId: [{
                type: Input$1
            }], expandOneOnly: [{
                type: Input$1
            }], expandOneOnlyCollapseMessage: [{
                type: Input$1
            }], shouldCloseRow: [{
                type: Input$1
            }], toggleButtonEvent: [{
                type: Output
            }], closeOtherSections: [{
                type: Output
            }] } });

class EtMobileDataSection {
    constructor(columnData, tableData, index) {
        this.label = tableData.rowHeader;
        this.index = index;
        this.highlightclass = tableData.highlightclass;
        const newColumnData = columnData.filter((item, index) => index !== 0);
        this.rows = newColumnData.map((column, index) => new EtMobileDataPrimaryRow(column, tableData, index));
        this.collapsedSections = tableData.subRowData.map(subRowData => new EtMobileDataCollapsable(subRowData, newColumnData));
    }
}
class EtMobileDataPrimaryRow {
    constructor(column, tableData, index) {
        this.label = column.title;
        this.primaryVal = tableData.rowData[index];
        this.hasTertiary = column.showButton;
    }
}
class EtMobileDataCollapsable {
    constructor(subRowData, columnData) {
        this.label = subRowData[0];
        const newSubRowData = subRowData.filter((item, index) => index !== 0);
        this.rows = columnData.map((columnData, index) => new EtMobileDataCollapsedData(columnData, newSubRowData, index));
    }
}
class EtMobileDataCollapsedData {
    constructor(column, subRowData, index) {
        this.label = column.title;
        this.value = subRowData[index];
    }
}

/**
 * @Component: ExpandablesTableComponent
 * @Section: Modules
 * @description This component generates...
 */
class ExpandablesTableComponent {
    get tableDataObj() {
        return this._tableDataObj;
    }
    set tableDataObj(object) {
        if (!object.tableData)
            return;
        this._tableDataObj = object;
        this.mobileDataObj = this._tableDataObj.tableData.map((tabledata, index) => new EtMobileDataSection(this._tableDataObj.columnData, tabledata, index));
    }
    constructor() {
        /**
        * @property tableDataObj
        * @description sets table datas
        * @return string
        */
        this._tableDataObj = {
            columnData: [],
            tableData: []
        };
        /**
       * @property expandOneOnly
       * @description only allow one section to be expanded at a time
       * @Type: boolean
       */
        this.expandOneOnly = false;
        /**
         * @property expandOneOnlyCollapseMessage
         * @description message for screen reader to announce for closing of previously open section
         *  while only allowing one section to be expanded at a time (ie. expandOneOnly is true)
         * @return string
         */
        this.expandOneOnlyCollapseMessage = 'other sections collapsed';
        /**
         * @property toggleButtonEvent
         * @description Event Emitter for the expand more rows button
         */
        this.toggleButtonEvent = new EventEmitter();
        /**
         * @property allheader
         * @description Event Emitter for the allheader rows
         */
        this.headerClick = new EventEmitter();
        // Close all sections that are not the one we just opened
        this.openRow = -1;
        if (isDevMode()) {
            console.error('%cThe Common UI DDL ExpandablesTable <citi-Expandables-table> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    clickAllHeader(e) {
        this.headerClick.emit(e);
    }
    /**
     * @Method: doSomethingOnToggle
     * @description Method to emit toggleOpenCloseDesktop event
     */
    doSomethingOnToggle(e) {
        this.toggleButtonEvent.emit(e);
    }
    onCloseOtherSections(rowId) {
        // Store ID of the section asking to open in variable on table
        this.openRow = rowId;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ExpandablesTableComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: ExpandablesTableComponent, isStandalone: false, selector: "citi-Expandables-table", inputs: { tableDataObj: "tableDataObj", expandText: "expandText", collapseText: "collapseText", expandablesTableTitle: "expandablesTableTitle", expandablesTableSubtitle: "expandablesTableSubtitle", addLabel: "addLabel", expandOneOnly: "expandOneOnly", expandOneOnlyCollapseMessage: "expandOneOnlyCollapseMessage" }, outputs: { toggleButtonEvent: "toggleButtonEvent", headerClick: "headerClick" }, ngImport: i0, template: `
      <section class="expandableModule browserVersion">
      <div class="pos-relative">
          <div class="titleWrapper">
          <h2 class="expandableTableTitle" [innerHtml]= "expandablesTableTitle"></h2>
          <h3 [innerHtml]= "expandablesTableSubtitle"></h3>
          </div>

          <table class="table expandableTable">
              <tbody class='addTopBorder'>
                  <tr citi-et-th class="expandableTable-row "
                  [label]="addLabel"
                  [columns]="tableDataObj.columnData"
                  (thClick)="clickAllHeader($event)"></tr>
              </tbody>

              <ng-container *ngFor="let item of tableDataObj.tableData; let i = index">
                  <tbody citi-et-tr
                      [expandOneOnly]= "expandOneOnly"
                      [expandOneOnlyCollapseMessage]= "expandOneOnlyCollapseMessage"
                      [tableRow]= "item"
                      [expandText]= "expandText"
                      [rowId] = "i"
                      [collapseText]= "collapseText"
                      class='addTopBorder'
                      (toggleButtonEvent)="doSomethingOnToggle($event)"
                      (closeOtherSections)="onCloseOtherSections($event)"
                      [shouldCloseRow] = "(i == openRow ? false : true)"
                  ></tbody>
              </ng-container>

          </table>
      </div>
    </section>
  <!-- ________________________________Above part is browser version (Table has been used for browser version)___________________________________________ -->

    <section class="expandable-table-mobile">
        <div class="titleWrapper">
            <h2
                class="expandableTableTitle"
                [innerHtml]= "expandablesTableTitle">
            </h2>
        </div>
        <citi-et-row-mobile  *ngFor= "let individualRow of mobileDataObj; let i=index"
            [expandOneOnly]="expandOneOnly"
            [expandOneOnlyCollapseMessage]="expandOneOnlyCollapseMessage"
            [tableRow]="individualRow"
            [rowId] = "i"
            [label]="addLabel"
            [expandText]="expandText"
            [collapseText]="collapseText"
            [mobileDataMainLabel]="mobileDataObj[i]"
            [mobileDataObj]="mobileDataObj"
            (toggleButtonEvent)="doSomethingOnToggle($event)"
            (closeOtherSections)="onCloseOtherSections($event)"
            [shouldCloseRow] = "i == openRow ? false : true"
        ></citi-et-row-mobile>
    </section>
  `, isInline: true, styles: [".addTopBorder{border-top:1px solid #7f7474!important}@media (min-width: 768px){.expandable-table-mobile{display:none}}.pos-relative{position:relative}.expandableTable-row:after{display:none}.expandableTableTitle{margin-bottom:40px}.titleWrapper{margin-left:20px;margin-top:80px}.expandableTable{margin-bottom:50px;border:none!important}.expandableTable tr,.expandableTable td,.expandableTable th{border:none!important}.expandableTable ::ng-deep tbody:last-child tr.lastHasBottomBorder{border-bottom:1px solid #7f7474!important}@media screen and (max-width: 767px){.browserVersion{display:none}.expandable-table-mobile{margin-bottom:40px}.expandableTableTitle{margin-bottom:0}.titleWrapper{margin-left:20px;margin-top:40px}.firstMainRow{order:0;flex:0 1 auto;align-self:stretch}.firstMainRow :first-child{border-top:none}.columnItemContainer{display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:flex-start;align-content:flex-start;align-items:flex-start;order:0;flex:0 1 auto;align-self:stretch;border-top:1px solid #7f7474;width:100%}.colItem{order:0;flex:1 1 auto;align-self:auto;padding:20px;width:auto}}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: ExpandablesTableTrComponent, selector: "[citi-et-tr]", inputs: ["tableRow", "expandText", "collapseText", "rowId", "expandOneOnly", "expandOneOnlyCollapseMessage", "shouldCloseRow"], outputs: ["toggleButtonEvent", "closeOtherSections"] }, { kind: "component", type: ExpandablesTableThComponent, selector: "[citi-et-th]", inputs: ["columns", "label"], outputs: ["thClick"] }, { kind: "component", type: ETRowMobileComponent, selector: "citi-et-row-mobile", inputs: ["tableRow", "rowId", "expandOneOnly", "expandOneOnlyCollapseMessage", "label", "expandText", "collapseText", "mobileDataMainLabel", "mobileDataObj", "shouldCloseRow"], outputs: ["closeOtherSections", "toggleButtonEvent"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ExpandablesTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-Expandables-table', standalone: false, template: `
      <section class="expandableModule browserVersion">
      <div class="pos-relative">
          <div class="titleWrapper">
          <h2 class="expandableTableTitle" [innerHtml]= "expandablesTableTitle"></h2>
          <h3 [innerHtml]= "expandablesTableSubtitle"></h3>
          </div>

          <table class="table expandableTable">
              <tbody class='addTopBorder'>
                  <tr citi-et-th class="expandableTable-row "
                  [label]="addLabel"
                  [columns]="tableDataObj.columnData"
                  (thClick)="clickAllHeader($event)"></tr>
              </tbody>

              <ng-container *ngFor="let item of tableDataObj.tableData; let i = index">
                  <tbody citi-et-tr
                      [expandOneOnly]= "expandOneOnly"
                      [expandOneOnlyCollapseMessage]= "expandOneOnlyCollapseMessage"
                      [tableRow]= "item"
                      [expandText]= "expandText"
                      [rowId] = "i"
                      [collapseText]= "collapseText"
                      class='addTopBorder'
                      (toggleButtonEvent)="doSomethingOnToggle($event)"
                      (closeOtherSections)="onCloseOtherSections($event)"
                      [shouldCloseRow] = "(i == openRow ? false : true)"
                  ></tbody>
              </ng-container>

          </table>
      </div>
    </section>
  <!-- ________________________________Above part is browser version (Table has been used for browser version)___________________________________________ -->

    <section class="expandable-table-mobile">
        <div class="titleWrapper">
            <h2
                class="expandableTableTitle"
                [innerHtml]= "expandablesTableTitle">
            </h2>
        </div>
        <citi-et-row-mobile  *ngFor= "let individualRow of mobileDataObj; let i=index"
            [expandOneOnly]="expandOneOnly"
            [expandOneOnlyCollapseMessage]="expandOneOnlyCollapseMessage"
            [tableRow]="individualRow"
            [rowId] = "i"
            [label]="addLabel"
            [expandText]="expandText"
            [collapseText]="collapseText"
            [mobileDataMainLabel]="mobileDataObj[i]"
            [mobileDataObj]="mobileDataObj"
            (toggleButtonEvent)="doSomethingOnToggle($event)"
            (closeOtherSections)="onCloseOtherSections($event)"
            [shouldCloseRow] = "i == openRow ? false : true"
        ></citi-et-row-mobile>
    </section>
  `, styles: [".addTopBorder{border-top:1px solid #7f7474!important}@media (min-width: 768px){.expandable-table-mobile{display:none}}.pos-relative{position:relative}.expandableTable-row:after{display:none}.expandableTableTitle{margin-bottom:40px}.titleWrapper{margin-left:20px;margin-top:80px}.expandableTable{margin-bottom:50px;border:none!important}.expandableTable tr,.expandableTable td,.expandableTable th{border:none!important}.expandableTable ::ng-deep tbody:last-child tr.lastHasBottomBorder{border-bottom:1px solid #7f7474!important}@media screen and (max-width: 767px){.browserVersion{display:none}.expandable-table-mobile{margin-bottom:40px}.expandableTableTitle{margin-bottom:0}.titleWrapper{margin-left:20px;margin-top:40px}.firstMainRow{order:0;flex:0 1 auto;align-self:stretch}.firstMainRow :first-child{border-top:none}.columnItemContainer{display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:flex-start;align-content:flex-start;align-items:flex-start;order:0;flex:0 1 auto;align-self:stretch;border-top:1px solid #7f7474;width:100%}.colItem{order:0;flex:1 1 auto;align-self:auto;padding:20px;width:auto}}\n"] }]
        }], ctorParameters: () => [], propDecorators: { tableDataObj: [{
                type: Input$1
            }], expandText: [{
                type: Input$1
            }], collapseText: [{
                type: Input$1
            }], expandablesTableTitle: [{
                type: Input$1
            }], expandablesTableSubtitle: [{
                type: Input$1
            }], addLabel: [{
                type: Input$1
            }], expandOneOnly: [{
                type: Input$1
            }], expandOneOnlyCollapseMessage: [{
                type: Input$1
            }], toggleButtonEvent: [{
                type: Output
            }], headerClick: [{
                type: Output
            }] } });

const COMPONENTS$3 = [
    ExpandablesTableComponent,
    ExpandablesTableTrComponent,
    ExpandablesTableThComponent,
    ETRowMobileComponent,
    ETSubRowMobileComponent,
    ETSubRowDataMobileComponent
];
const MODULES$3 = [CommonModule, Grid, Icons2];
class ExpandablesTable {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ExpandablesTable, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: ExpandablesTable, declarations: [ExpandablesTableComponent,
            ExpandablesTableTrComponent,
            ExpandablesTableThComponent,
            ETRowMobileComponent,
            ETSubRowMobileComponent,
            ETSubRowDataMobileComponent], imports: [CommonModule, Grid, Icons2], exports: [ExpandablesTableComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ExpandablesTable, imports: [MODULES$3] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: ExpandablesTable, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$3],
                    declarations: [...COMPONENTS$3],
                    exports: [ExpandablesTableComponent]
                }]
        }] });

/**
 * @Component: NtSectionComponent
 * @Section: Modules
 * @description This component generates a nested table
 */
class NtSectionComponent {
    onTitleCTAClick() {
        this.headerCtaClick.emit(this);
    }
    applyNowClicked(event) {
        this.ClickEventApplyNow.emit(this);
    }
    /* This function adds the no wrap class to columns that should not wrap.
    * Use the nowrapColumns property on the sections object
    * which is an array of numbers that correspond to the column that should not wrap
    */
    isNoWrap(index) {
        if (this.section.nowrapColumns) {
            return this.section.nowrapColumns.indexOf(index) < 0;
        }
    }
    constructor() {
        /**
        * @Event: headerCtaClick
        * @description CTA click event to emit the click
        */
        this.headerCtaClick = new EventEmitter();
        /**
        * @Event: ClickEventApplyNow
        * @description Emit event when Apply Now button is clicked
        */
        this.ClickEventApplyNow = new EventEmitter();
        if (isDevMode()) {
            console.error('%cThe Common UI DDL NestedTable <citi-nt-section> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: NtSectionComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: NtSectionComponent, isStandalone: false, selector: "citi-nt-section", inputs: { section: "section" }, outputs: { headerCtaClick: "headerCtaClick", ClickEventApplyNow: "ClickEventApplyNow" }, ngImport: i0, template: `
    <div class="stacked-tables">
      <div class="stacked-tables-content">
        <div class="row">
          <div class="col-md-3 stackedTablesTitle">
            <citi-cta type="tertiary" value="{{section.productTitle.title}}" href="{{section.productTitle.url}}" *ngIf="section.productTitle.title && section.productTitle.title !== null && section.productTitle.url && section.productTitle.url !== null">
            </citi-cta>
            <div *ngIf="section.productTitle.title
    && section.productTitle.title !== null
    && (section.productTitle.url === null || !section.productTitle.url)" class="{{section.productTitle.bold? 'bold':''}}">
                {{ section.productTitle.title }}
            </div>
          </div>
          <div class="col-md-9">
              <div class="row">
                <div class="col-md-9">
                  <div class="stacked-table-desc" [innerHTML]="section?.description">

                  </div>
                </div>
                <div class="col-md-3 sectionPrimary">
                  <citi-cta
                    class="sectionPrimaryCTA"
                    type="primary"
                    size="small"
                    value="{{section.primaryButton.title}}"
                    href="{{section.primaryButton.url}}"
                    *ngIf="section.primaryButton.url && section.primaryButton.url !== null">
                  </citi-cta>
                  <citi-cta
                    *ngIf="(section.primaryButton.title && section.primaryButton.title !== null) &&
                      (!section.primaryButton.url || section.primaryButton.url === null)"
                    class="sectionPrimaryCTA"
                    type="primary"
                    (click)="applyNowClicked($event)"
                    size="small"
                    value="{{section.primaryButton.title}}">
                  </citi-cta>
                </div>
              </div>
              <div class="table-responsive nt-padding" *ngIf="section.rows && section.rows.length > 0" [attr.aria-hidden]="!section.rows && section.rows.length < 0">
                  <table class="table table-striped nt-table" [ngClass]="{'collapse': section.expanded === false}" [attr.aria-expanded]="section.expanded" [attr.aria-hidden]="section.expanded === false">
                    <thead>
                      <tr class="nt-tr">
                        <th scope="col" *ngFor="let head of section.displayedKeys">
                          <span [innerHtml]="head.text"></span>
                          <p *ngIf="head.link && head.link !== null" class="fingerprint">
                            <a *ngIf="head.link.url && head.url !== null" href="{{head.link.url}}">
                              <small [innerHTML]="head.link.title"></small>
                            </a>
                            <a *ngIf="!head.link.url" href="javascript:void(0)" (click)="onTitleCTAClick()"> <small [innerHTML]="head.link.title"></small></a>
                          </p>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let row of section.rows">
                        <td *ngFor="let item of row.cells; let i = index" class="{{isNoWrap(i) ? 'no-wrap' : ''}}">
                          {{item}}
                        </td>
                      </tr>
                    </tbody>
                  </table>
              </div>
          </div>
        </div>
      </div>
    </div>
  `, isInline: true, styles: [".nt-padding{padding-right:20px}.nt-table{margin-bottom:20px}.nt-tr{border-top:1px solid rgba(0,0,0,.5)!important;border-bottom:1px solid rgba(0,0,0,.5)!important;font-size:1rem;font-family:Interstate_light,sans-serif;padding:16px 18px 12px 16px}.sectionPrimary{text-align:right;padding-right:30px;margin-bottom:20px}.cbolui-ddl-post .stacked-tables{border-top:2px solid #ccc;padding:20px 0}.stacked-tables{border-top:1px solid rgba(0,0,0,.25);padding:20px 0 0}.stacked-tables th{font-weight:700!important;vertical-align:top!important}.stacked-tables th a{display:inline-block;font-size:11px;font-weight:400;line-height:16px;text-decoration:underline}.stacked-tables th p{font-weight:700;margin-bottom:0}.stacked-tables .stacked-table-desc{margin-bottom:15px}@media (max-width: 991px){.stacked-tables{margin-left:20px}.stacked-tables-content{margin-left:10px;margin-right:10px}}citi-cta.sectionPrimaryCTA ::ng-deep a{margin:0!important}citi-cta.sectionPrimaryCTA ::ng-deep button{margin:0!important}.stackedTablesTitle{padding-bottom:20px}.stacked-table-desc{padding-right:20px}.no-wrap{white-space:nowrap}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: CTAComponent, selector: "citi-cta", inputs: ["textAlign", "bold", "noMargin", "tabIndex", "ariaDescription", "ariaLabeledBy", "ariaHasPopup", "ariaRole", "ariaLabel", "ariaControls", "ariaExpanded", "router", "queryParams", "idStr", "dataTarget", "addJFPToken", "doNotAddJFPToken", "buttonType", "target", "href", "value", "disabled", "type", "size", "arrow", "leftArrow"], outputs: ["ctaClick", "disabledChange", "ctaFocus", "ctaBlur"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: NtSectionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-nt-section', standalone: false, template: `
    <div class="stacked-tables">
      <div class="stacked-tables-content">
        <div class="row">
          <div class="col-md-3 stackedTablesTitle">
            <citi-cta type="tertiary" value="{{section.productTitle.title}}" href="{{section.productTitle.url}}" *ngIf="section.productTitle.title && section.productTitle.title !== null && section.productTitle.url && section.productTitle.url !== null">
            </citi-cta>
            <div *ngIf="section.productTitle.title
    && section.productTitle.title !== null
    && (section.productTitle.url === null || !section.productTitle.url)" class="{{section.productTitle.bold? 'bold':''}}">
                {{ section.productTitle.title }}
            </div>
          </div>
          <div class="col-md-9">
              <div class="row">
                <div class="col-md-9">
                  <div class="stacked-table-desc" [innerHTML]="section?.description">

                  </div>
                </div>
                <div class="col-md-3 sectionPrimary">
                  <citi-cta
                    class="sectionPrimaryCTA"
                    type="primary"
                    size="small"
                    value="{{section.primaryButton.title}}"
                    href="{{section.primaryButton.url}}"
                    *ngIf="section.primaryButton.url && section.primaryButton.url !== null">
                  </citi-cta>
                  <citi-cta
                    *ngIf="(section.primaryButton.title && section.primaryButton.title !== null) &&
                      (!section.primaryButton.url || section.primaryButton.url === null)"
                    class="sectionPrimaryCTA"
                    type="primary"
                    (click)="applyNowClicked($event)"
                    size="small"
                    value="{{section.primaryButton.title}}">
                  </citi-cta>
                </div>
              </div>
              <div class="table-responsive nt-padding" *ngIf="section.rows && section.rows.length > 0" [attr.aria-hidden]="!section.rows && section.rows.length < 0">
                  <table class="table table-striped nt-table" [ngClass]="{'collapse': section.expanded === false}" [attr.aria-expanded]="section.expanded" [attr.aria-hidden]="section.expanded === false">
                    <thead>
                      <tr class="nt-tr">
                        <th scope="col" *ngFor="let head of section.displayedKeys">
                          <span [innerHtml]="head.text"></span>
                          <p *ngIf="head.link && head.link !== null" class="fingerprint">
                            <a *ngIf="head.link.url && head.url !== null" href="{{head.link.url}}">
                              <small [innerHTML]="head.link.title"></small>
                            </a>
                            <a *ngIf="!head.link.url" href="javascript:void(0)" (click)="onTitleCTAClick()"> <small [innerHTML]="head.link.title"></small></a>
                          </p>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let row of section.rows">
                        <td *ngFor="let item of row.cells; let i = index" class="{{isNoWrap(i) ? 'no-wrap' : ''}}">
                          {{item}}
                        </td>
                      </tr>
                    </tbody>
                  </table>
              </div>
          </div>
        </div>
      </div>
    </div>
  `, styles: [".nt-padding{padding-right:20px}.nt-table{margin-bottom:20px}.nt-tr{border-top:1px solid rgba(0,0,0,.5)!important;border-bottom:1px solid rgba(0,0,0,.5)!important;font-size:1rem;font-family:Interstate_light,sans-serif;padding:16px 18px 12px 16px}.sectionPrimary{text-align:right;padding-right:30px;margin-bottom:20px}.cbolui-ddl-post .stacked-tables{border-top:2px solid #ccc;padding:20px 0}.stacked-tables{border-top:1px solid rgba(0,0,0,.25);padding:20px 0 0}.stacked-tables th{font-weight:700!important;vertical-align:top!important}.stacked-tables th a{display:inline-block;font-size:11px;font-weight:400;line-height:16px;text-decoration:underline}.stacked-tables th p{font-weight:700;margin-bottom:0}.stacked-tables .stacked-table-desc{margin-bottom:15px}@media (max-width: 991px){.stacked-tables{margin-left:20px}.stacked-tables-content{margin-left:10px;margin-right:10px}}citi-cta.sectionPrimaryCTA ::ng-deep a{margin:0!important}citi-cta.sectionPrimaryCTA ::ng-deep button{margin:0!important}.stackedTablesTitle{padding-bottom:20px}.stacked-table-desc{padding-right:20px}.no-wrap{white-space:nowrap}\n"] }]
        }], ctorParameters: () => [], propDecorators: { section: [{
                type: Input$1
            }], headerCtaClick: [{
                type: Output
            }], ClickEventApplyNow: [{
                type: Output
            }] } });

function isValidArray(array) {
    return isArray(array) && array.length > 0;
}
/**
 * @Component: NestedTableComponent
 * @Section: Modules
 * @description This component generates a nested table
 */
class NestedTableComponent {
    ngOnInit() {
        this.toggleAllSections(this._allSectionsExpanded);
    }
    openModal(event) {
        this.ClickEventCTA.emit(event);
    }
    clickApplyNow(event) {
        this.ApplyNowCTA.emit(event);
    }
    /**
     * @name onAllItemButtonClick
     * @description Handles all item expanding/collapsing button clicked
     * @return void
     */
    onAllItemButtonClick(event) {
        this.toggleAllSections(!this._allSectionsExpanded);
        if (this._allSectionsExpanded) {
            this.announcer.announce('expanded');
        }
        else {
            this.announcer.announce('collapsed');
        }
    }
    /**
     * @name toggleAllSections
     * @description Iterates through data values and updates expanded values
     * @return void
     */
    toggleAllSections(expanded) {
        this._allSectionsExpanded = expanded;
        if (this._data && this._data.length) {
            this.allSectionsExpandedChanged.emit(expanded);
            this._data.forEach(item => item.expanded = expanded);
        }
    }
    set allSectionsExpanded(expanded) {
        this.toggleAllSections(expanded);
    }
    get allSectionsExpanded() {
        return this._allSectionsExpanded;
    }
    set bottomLinkUrl(newMessage) {
        this._bottomLinkUrl = newMessage;
    }
    /**
      * @name bottomLinkUrl
      * @description Gets the URL to be set for optional bottom button
      * @return string
    */
    get bottomLinkUrl() {
        return this._bottomLinkUrl;
    }
    set bottomLinkText(newMessage) {
        this._bottomLinkText = newMessage;
    }
    /**
      * @name bottomLinkText
      * @description Gets the text for the optional bottom link button
      * @return string
    */
    get bottomLinkText() {
        return this._bottomLinkText;
    }
    set collapseTextHide(newMessage) {
        this._collapseTextHide = newMessage;
    }
    /**
      * @name collapseTextHide
      * @description Gets the text for the collapse button
      * @return string
    */
    get collapseTextHide() {
        return this._collapseTextHide;
    }
    set collapseTextShow(newMessage) {
        this._collapseTextShow = newMessage;
    }
    /**
      * @name collapseTextShow
      * @description Gets the text for the collapse button
      * @return Void
    */
    get collapseTextShow() {
        return this._collapseTextShow;
    }
    /**
     * @property data
     * @description sets the list of sections
     * @Type: Array
     */
    set data(newData) {
        if (isValidArray(newData)) {
            // this._data = newData.slice(0);
            this._data = JSON.parse(JSON.stringify(newData));
        }
        else if (isDevMode) {
            console.warn('Provided data is not an array');
        }
    }
    get data() {
        return this._data.slice(0);
    }
    /**
     * @property hasData
     * @description Checks if the component has some data
     * @Type: boolean
     */
    get hasData() {
        return isValidArray(this._data);
    }
    constructor(announcer) {
        this.announcer = announcer;
        this._bottomLinkText = '';
        this._bottomLinkUrl = '';
        this._collapseTextHide = '';
        this._collapseTextShow = '';
        this.allSectionsExpandedChanged = new EventEmitter();
        /**
         * @Event: ClickEventCTA
         * @description Emit event when CTA tertiary button is clicked
         */
        this.ClickEventCTA = new EventEmitter();
        /**
         * @Event: ApplyNowCTA
         * @description Emit event when Apply Now button is clicked
         */
        this.ApplyNowCTA = new EventEmitter();
        if (isDevMode()) {
            console.error('%cThe Common UI DDL NestedTable <citi-nested-table> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: NestedTableComponent, deps: [{ token: CitiLiveAnnouncer }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: NestedTableComponent, isStandalone: false, selector: "citi-nested-table", inputs: { allSectionsExpanded: "allSectionsExpanded", bottomLinkUrl: "bottomLinkUrl", bottomLinkText: "bottomLinkText", collapseTextHide: "collapseTextHide", collapseTextShow: "collapseTextShow", data: "data" }, outputs: { allSectionsExpandedChanged: "allSectionsExpandedChanged", ClickEventCTA: "ClickEventCTA", ApplyNowCTA: "ApplyNowCTA" }, ngImport: i0, template: `
    <div class="row" *ngIf="collapseTextHide || collapseTextShow">
      <div class="col-md-12">
          <button class="btn btn-link top-link hide-tables" (click)="onAllItemButtonClick($event)">
        <span *ngIf="allSectionsExpanded">{{collapseTextHide}}</span>
        <span *ngIf="!allSectionsExpanded">{{collapseTextShow}}</span>
      </button>
      </div>
    </div>
    <citi-nt-section *ngFor="let section of _data;" [section]="section"
      (headerCtaClick)= "openModal($event)"
      (ClickEventApplyNow)= "clickApplyNow($event)">
    </citi-nt-section>

    <div class="row nested-table-bottom-link">
        <div class="col-md-12 nav-link-container"
        *ngIf="bottomLinkText && bottomLinkText !== null
        && bottomLinkUrl && bottomLinkUrl !== null">
            <a class="chevron-link bold nav-link" href="{{bottomLinkUrl}}">
                <strong>{{bottomLinkText}}</strong>
            </a>
        </div>
    </div>
  `, isInline: true, styles: [".collapse{visibility:hidden;overflow:hidden;max-height:0}.nested-table-bottom-link{border-top:1px solid rgba(0,0,0,.25)}:host{font-size:1rem;font-family:Interstate_light,sans-serif}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: NtSectionComponent, selector: "citi-nt-section", inputs: ["section"], outputs: ["headerCtaClick", "ClickEventApplyNow"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: NestedTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-nested-table', standalone: false, template: `
    <div class="row" *ngIf="collapseTextHide || collapseTextShow">
      <div class="col-md-12">
          <button class="btn btn-link top-link hide-tables" (click)="onAllItemButtonClick($event)">
        <span *ngIf="allSectionsExpanded">{{collapseTextHide}}</span>
        <span *ngIf="!allSectionsExpanded">{{collapseTextShow}}</span>
      </button>
      </div>
    </div>
    <citi-nt-section *ngFor="let section of _data;" [section]="section"
      (headerCtaClick)= "openModal($event)"
      (ClickEventApplyNow)= "clickApplyNow($event)">
    </citi-nt-section>

    <div class="row nested-table-bottom-link">
        <div class="col-md-12 nav-link-container"
        *ngIf="bottomLinkText && bottomLinkText !== null
        && bottomLinkUrl && bottomLinkUrl !== null">
            <a class="chevron-link bold nav-link" href="{{bottomLinkUrl}}">
                <strong>{{bottomLinkText}}</strong>
            </a>
        </div>
    </div>
  `, styles: [".collapse{visibility:hidden;overflow:hidden;max-height:0}.nested-table-bottom-link{border-top:1px solid rgba(0,0,0,.25)}:host{font-size:1rem;font-family:Interstate_light,sans-serif}\n"] }]
        }], ctorParameters: () => [{ type: CitiLiveAnnouncer }], propDecorators: { allSectionsExpanded: [{
                type: Input$1
            }], allSectionsExpandedChanged: [{
                type: Output
            }], bottomLinkUrl: [{
                type: Input$1
            }], bottomLinkText: [{
                type: Input$1
            }], collapseTextHide: [{
                type: Input$1
            }], collapseTextShow: [{
                type: Input$1
            }], data: [{
                type: Input$1
            }], ClickEventCTA: [{
                type: Output
            }], ApplyNowCTA: [{
                type: Output
            }] } });

const COMPONENTS$2 = [NestedTableComponent, NtSectionComponent];
const MODULES$2 = [CommonModule, Grid, CTA];
class NestedTable {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: NestedTable, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: NestedTable, declarations: [NestedTableComponent, NtSectionComponent], imports: [CommonModule, Grid, CTA], exports: [NestedTableComponent, NtSectionComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: NestedTable, imports: [MODULES$2] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: NestedTable, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$2],
                    declarations: [...COMPONENTS$2],
                    exports: [...COMPONENTS$2]
                }]
        }] });

class expandProperties {
    constructor() {
        this.id = '';
        this.text = '';
        this.additionalClasses = '';
        this.isRightAligned = false;
        this.isChoiceColumn = false;
        this.isNoWrap = false;
        this.colspan = '1';
        this.statusAlert = '';
    }
}

class TransactionTableExpandComponent {
    get isExpanded() {
        return this._isExpanded;
    }
    set isExpanded(value) {
        this._isExpanded = value;
    }
    set isRightAligned(isRightAligned) {
        this.props.isRightAligned = isRightAligned;
    }
    set isChoiceColumn(isChoiceColumn) {
        this.props.isChoiceColumn = isChoiceColumn;
    }
    set isNoWrap(isNoWrap) {
        this.props.isNoWrap = isNoWrap;
    }
    set colspan(colspan) {
        this.props.colspan = colspan;
    }
    set statusAlert(statusAlert) {
        this.props.statusAlert = statusAlert;
    }
    constructor(parentElment) {
        this._isExpanded = false;
        this.props = new expandProperties();
        /**
         * @Event: expandEmitter
         * @description This event that is fired when the expand/collapse clicked
         * Can be bound to with (expandEmitter)='myFunction($event)'
         * @return Object
         */
        this.expandEmitter = new EventEmitter();
        this.isExpandedChange = new EventEmitter();
        /**
         * @property htmlContent
         * @description Adds the given string as the content and supports simple HTML.
         * Do not pass anything within the component tags using ng-content. Do not use citi-* components in the String.
         * This works with expressions for asynchronously loaded content that will get picked up by the Angular 2 change detection.
         * @return string
         * @twoway false
         */
        this.htmlContent = null;
        if (isDevMode()) {
            console.error('%cThe Common UI DDL TJTable <citi-tj-expand> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
        this.parentElment = parentElment;
    }
    //constructor(private announcer: CitiLiveAnnouncer) { }
    onClickBtn() {
        this.isExpanded = !this.isExpanded;
        // this.announcer.announce(this.isExpanded ? 'expanded' : 'collapsed');
        this.isExpandedChange.emit(this.isExpanded);
        this.expandEmitter.emit(this.isExpanded);
    }
    generateClass() {
        let classArray = [];
        this.parentElment.nativeElement.className = '';
        classArray.push('cbolui-table-tablebody-col');
        if (this.props.isRightAligned === true) {
            // classArray.push(' cbolui-table-rightAlign', 'text-right');
        }
        if (this.props.isChoiceColumn) {
            classArray.push(' cbolui-table-tablebody-col-choice');
        }
        if (this.props.isNoWrap) {
            classArray.push('cbolui-nowrap', 'nowrap-content');
        }
        if (this.props.statusAlert === 'success') {
            classArray.push('cbolui-success');
        }
        if (this.props.statusAlert === 'error') {
            classArray.push('cbolui-error');
        }
        if (this.props.additionalClasses && this.props.additionalClasses !== null) {
            const classes = this.props.additionalClasses.split(' ');
            classArray = classArray.concat(classes);
        }
        classArray.forEach((cla) => {
            if (cla !== '') {
                addClass(this.parentElment.nativeElement, cla.trim());
            }
        });
        this.parentElment.nativeElement.setAttribute('colspan', this.props.colspan);
        if (this.props.id) {
            this.parentElment.nativeElement.id = this.props.id;
        }
    }
    ngAfterViewInit() {
        this.generateClass();
    }
    // TODO: move to a setter
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('isRightAligned') || changes.hasOwnProperty('isChoiceColumn')
            || changes.hasOwnProperty('additionalClasses') || changes.hasOwnProperty('isNoWrap')
            || changes.hasOwnProperty('statusAlert')) {
            this.generateClass();
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TransactionTableExpandComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: TransactionTableExpandComponent, isStandalone: false, selector: "citi-tj-expand", inputs: { internalExpandText: "internalExpandText", isExpanded: "isExpanded", htmlContent: "htmlContent", isRightAligned: "isRightAligned", isChoiceColumn: "isChoiceColumn", isNoWrap: "isNoWrap", colspan: "colspan", statusAlert: "statusAlert" }, outputs: { expandEmitter: "expandEmitter", isExpandedChange: "isExpandedChange" }, usesOnChanges: true, ngImport: i0, template: `
    <div class="internal-expand">
      <button *ngIf="this.props.isRightAligned === false" class="details-button"
          [attr.aria-expanded]="isExpanded"
          role="button"
          (click)="onClickBtn()">


          <span class="glyphicon"
              [ngClass]="{
                  'glyphicon-triangle-top': isExpanded,
                  'glyphicon-triangle-bottom': !isExpanded

              }"
              aria-hidden="true"
          ></span>
          <span class="btn-text btn-link">
            {{internalExpandText}}
          </span>
      </button>
      <button *ngIf="this.props.isRightAligned === true" class="details-button description-right-aligned"
          [attr.aria-expanded]="isExpanded"
          role="button"
          (click)="onClickBtn()">


          <span class="glyphicon"
              [ngClass]="{
                  'glyphicon-triangle-top': isExpanded,
                  'glyphicon-triangle-bottom': !isExpanded

              }"
              aria-hidden="true"
          ></span>
          <span class="btn-text btn-link">
            {{internalExpandText}}
          </span>
      </button>
    </div>





    <div class="expanded-content" [contentHtml]="htmlContent">
        <ng-content></ng-content>
    </div>
  `, isInline: true, styles: [".btn-text{float:none!important}.details-button{text-align:left;width:100%!important}.description-right-aligned{color:#333;font-size:1rem;line-height:22px;text-decoration:none;text-align:right!important;width:calc(100% - 30px)}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TransactionTableExpandComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-tj-expand', standalone: false, template: `
    <div class="internal-expand">
      <button *ngIf="this.props.isRightAligned === false" class="details-button"
          [attr.aria-expanded]="isExpanded"
          role="button"
          (click)="onClickBtn()">


          <span class="glyphicon"
              [ngClass]="{
                  'glyphicon-triangle-top': isExpanded,
                  'glyphicon-triangle-bottom': !isExpanded

              }"
              aria-hidden="true"
          ></span>
          <span class="btn-text btn-link">
            {{internalExpandText}}
          </span>
      </button>
      <button *ngIf="this.props.isRightAligned === true" class="details-button description-right-aligned"
          [attr.aria-expanded]="isExpanded"
          role="button"
          (click)="onClickBtn()">


          <span class="glyphicon"
              [ngClass]="{
                  'glyphicon-triangle-top': isExpanded,
                  'glyphicon-triangle-bottom': !isExpanded

              }"
              aria-hidden="true"
          ></span>
          <span class="btn-text btn-link">
            {{internalExpandText}}
          </span>
      </button>
    </div>





    <div class="expanded-content" [contentHtml]="htmlContent">
        <ng-content></ng-content>
    </div>
  `, styles: [".btn-text{float:none!important}.details-button{text-align:left;width:100%!important}.description-right-aligned{color:#333;font-size:1rem;line-height:22px;text-decoration:none;text-align:right!important;width:calc(100% - 30px)}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { internalExpandText: [{
                type: Input$1
            }], expandEmitter: [{
                type: Output
            }], isExpandedChange: [{
                type: Output
            }], isExpanded: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }], isRightAligned: [{
                type: Input$1
            }], isChoiceColumn: [{
                type: Input$1
            }], isNoWrap: [{
                type: Input$1
            }], colspan: [{
                type: Input$1
            }], statusAlert: [{
                type: Input$1
            }] } });

class TdProperties {
    constructor() {
        this.id = '';
        this.text = '';
        this.additionalClasses = '';
        this.isRightAligned = false;
        this.isChoiceColumn = false;
        this.isNoWrap = false;
        this.colspan = '1';
        this.statusAlert = '';
    }
}

class TransactionTableTdComponent {
    set type(props) {
        this.props = props;
    }
    set id(id) {
        this.props.id = id;
    }
    set text(text) {
        this.props.text = text;
    }
    set additionalClasses(additionalClasses) {
        this.props.additionalClasses = additionalClasses;
    }
    set isRightAligned(isRightAligned) {
        this.props.isRightAligned = isRightAligned;
    }
    set isChoiceColumn(isChoiceColumn) {
        this.props.isChoiceColumn = isChoiceColumn;
    }
    set isNoWrap(isNoWrap) {
        this.props.isNoWrap = isNoWrap;
    }
    set colspan(colspan) {
        this.props.colspan = colspan;
    }
    set statusAlert(statusAlert) {
        this.props.statusAlert = statusAlert;
    }
    constructor(parentElment) {
        this.props = new TdProperties();
        /**
         * @property htmlContent
         * @description Adds the given string as the content and supports simple HTML.
         * Do not pass anything within the component tags using ng-content. Do not use citi-* components in the String.
         * This works with expressions for asynchronously loaded content that will get picked up by the Angular 2 change detection.
         * @return string
         * @twoway false
         */
        this.htmlContent = null;
        if (isDevMode()) {
            console.error('%cThe Common UI DDL TJTable <td citi-tj-td> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
        this.parentElment = parentElment;
    }
    generateClass() {
        let classArray = [];
        this.parentElment.nativeElement.className = '';
        classArray.push('cbolui-table-tablebody-col');
        if (this.props.isRightAligned) {
            classArray.push(' cbolui-table-rightAlign', 'text-right');
        }
        if (this.props.isChoiceColumn) {
            classArray.push(' cbolui-table-tablebody-col-choice');
        }
        if (this.props.isNoWrap) {
            classArray.push('cbolui-nowrap', 'nowrap-content');
        }
        if (this.props.statusAlert === 'success') {
            classArray.push('cbolui-success');
        }
        if (this.props.statusAlert === 'error') {
            classArray.push('cbolui-error');
        }
        if (this.props.additionalClasses && this.props.additionalClasses !== null) {
            const classes = this.props.additionalClasses.split(' ');
            classArray = classArray.concat(classes);
        }
        classArray.forEach((cla) => {
            if (cla !== '') {
                addClass(this.parentElment.nativeElement, cla.trim());
            }
        });
        this.parentElment.nativeElement.setAttribute('colspan', this.props.colspan);
        if (this.props.id) {
            this.parentElment.nativeElement.id = this.props.id;
        }
    }
    ngAfterViewInit() {
        this.generateClass();
    }
    // TODO: move to a setter
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('isRightAligned') || changes.hasOwnProperty('isChoiceColumn')
            || changes.hasOwnProperty('additionalClasses') || changes.hasOwnProperty('isNoWrap')
            || changes.hasOwnProperty('statusAlert')) {
            this.generateClass();
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TransactionTableTdComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: TransactionTableTdComponent, isStandalone: false, selector: "[citi-tj-td]", inputs: { type: "type", id: "id", text: "text", additionalClasses: "additionalClasses", isRightAligned: "isRightAligned", isChoiceColumn: "isChoiceColumn", isNoWrap: "isNoWrap", colspan: "colspan", statusAlert: "statusAlert", htmlContent: "htmlContent" }, viewQueries: [{ propertyName: "wrapper", first: true, predicate: ["wrapperTd"], descendants: true }], usesOnChanges: true, ngImport: i0, template: `
    <div  *ngIf="htmlContent !== null" [contentHtml]= "htmlContent"></div>
    <ng-container>
    <span tabindex="0">
    <ng-content ></ng-content>
    </span>
    </ng-container>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TransactionTableTdComponent, decorators: [{
            type: Component,
            args: [{
                    selector: '[citi-tj-td]',
                    standalone: false,
                    template: `
    <div  *ngIf="htmlContent !== null" [contentHtml]= "htmlContent"></div>
    <ng-container>
    <span tabindex="0">
    <ng-content ></ng-content>
    </span>
    </ng-container>
  `
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { wrapper: [{
                type: ViewChild,
                args: ['wrapperTd']
            }], type: [{
                type: Input$1
            }], id: [{
                type: Input$1
            }], text: [{
                type: Input$1
            }], additionalClasses: [{
                type: Input$1
            }], isRightAligned: [{
                type: Input$1
            }], isChoiceColumn: [{
                type: Input$1
            }], isNoWrap: [{
                type: Input$1
            }], colspan: [{
                type: Input$1
            }], statusAlert: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }] } });

class ThProperties {
    constructor() {
        this.id = '';
        this.text = '';
        this.additionalClasses = '';
        this.isRightAligned = false;
        this.isChoiceColumn = false;
        this.isSorterFalse = false;
        this.dataSortType = '';
        this.isSortable = false;
    }
}

class TransactionTableThComponent {
    set type(props) {
        this.props = props;
    }
    set id(id) {
        this.props.id = id;
    }
    set text(text) {
        this.props.text = text;
    }
    set additionalClasses(additionalClasses) {
        this.props.additionalClasses = additionalClasses;
    }
    set isRightAligned(isRightAligned) {
        this.props.isRightAligned = isRightAligned;
    }
    set isChoiceColumn(isChoiceColumn) {
        this.props.isChoiceColumn = isChoiceColumn;
    }
    set isSorterFalse(isSorterFalse) {
        this.props.isSorterFalse = isSorterFalse;
    }
    set dataSortType(dataSortType) {
        this.props.dataSortType = dataSortType;
    }
    set isSortable(isSortable) {
        this.props.isSortable = isSortable;
    }
    get text() {
        return this.props.text;
    }
    get isSortable() {
        return this.props.isSortable;
    }
    generateClass() {
        this.parentElment.nativeElement.className = '';
        let cls = '';
        cls += this.props.isRightAligned ? ' cbolui-table-rightAlign text-right' : '';
        cls += (this.isSortable) ? ' sortable cM-extend' : ' sorter-false';
        cls += this.props.isChoiceColumn ? ' cbolui-table-tableheader-col-choice' : '';
        cls += this.props.additionalClasses ? ' ' + this.props.additionalClasses : '';
        cls.trim().split(' ').forEach((cla) => {
            addClass(this.parentElment.nativeElement, cla);
        });
        this.parentElment.nativeElement.setAttribute('aria-sort', 'none');
        this.parentElment.nativeElement.setAttribute('tabindex', this.props.isSortable && this.props.isSorterFalse ? '0' : '-1');
        this.parentElment.nativeElement.setAttribute('data-sort', this.props.dataSortType);
        if (this.props.id) {
            this.parentElment.nativeElement.id = this.props.id;
        }
    }
    constructor(parentElment, tableService, announcer) {
        this.tableService = tableService;
        this.announcer = announcer;
        this.props = new ThProperties();
        this.sortedcaptionUpdate = '';
        this.iconClasses = {
            'glyphicon': true,
            'glyphicon-triangle-right': true,
            'glyphicon-triangle-top': false,
            'glyphicon-triangle-bottom': false
        };
        this.sortClasses = {
            'sortedButton': false,
            'sortedButtonLast': false
        };
        this.descending = false;
        this.cardChanged = new EventEmitter();
        /**
         * @Event: sorted
         * @description The event is emitted when the header is clicked on
         * The descending boolean is returned.
         * @return Object
         */
        this.sorted = new EventEmitter();
        if (isDevMode()) {
            console.error('%cThe Common UI DDL TJTable <th citi-tj-th> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
        this.parentElment = parentElment;
    }
    ngOnInit() {
        this.parentElment.nativeElement.setAttribute('aria-sort', 'none');
        this.tableService.columnSorted.subscribe(headers => {
            if (headers.previousHeader == this.parentElment && headers.columnHeader != this.parentElment) {
                this.sortClasses['sortedButton'] = false;
                this.iconClasses['glyphicon-triangle-right'] = true;
                this.iconClasses['glyphicon-triangle-top'] = false;
                this.iconClasses['glyphicon-triangle-bottom'] = false;
            }
            else if (headers.previousHeader != this.parentElment && headers.columnHeader != this.parentElment) {
                this.sortClasses['sortedButton'] = false;
                this.iconClasses['glyphicon-triangle-right'] = true;
                this.iconClasses['glyphicon-triangle-top'] = false;
                this.iconClasses['glyphicon-triangle-bottom'] = false;
            }
            if (headers.columnHeader !== this.parentElment.nativeElement) {
                this.parentElment.nativeElement.setAttribute('aria-sort', 'none');
            }
        });
    }
    ngAfterViewInit() {
        this.generateClass();
    }
    onclick() {
        this.cardChanged.emit();
    }
    announceSortable() {
        this.announcer.announce(this.text + ' is sortable');
    }
    // TODO: move to a setter
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('isRightAligned') || changes.hasOwnProperty('isChoiceColumn')
            || changes.hasOwnProperty('additionalClasses') || changes.hasOwnProperty('isSortable')
            || changes.hasOwnProperty('isSorterFalse') || changes.hasOwnProperty('isChoiceColumn')) {
            this.generateClass();
        }
    }
    toggleHeader(event) {
        if (!this.isSortable) {
            this.parentElment.nativeElement.setAttribute('aria-sort', 'none');
        }
        this.sortClasses['sortedButton'] = true;
        this.parentElment.nativeElement.descending = !this.parentElment.nativeElement.descending;
        if (this.parentElment.nativeElement.descending === true) {
            this.iconClasses['glyphicon-triangle-right'] = false;
            this.iconClasses['glyphicon-triangle-top'] = false;
            this.iconClasses['glyphicon-triangle-bottom'] = true;
            this.parentElment.nativeElement.setAttribute('aria-sort', 'descending');
            this.announcer.announce(this.text + ' is sorted by descending');
        }
        else {
            this.iconClasses['glyphicon-triangle-right'] = false;
            this.iconClasses['glyphicon-triangle-bottom'] = false;
            this.iconClasses['glyphicon-triangle-top'] = true;
            this.parentElment.nativeElement.setAttribute('aria-sort', 'ascending');
            this.announcer.announce(this.text + ' is sorted by ascending');
        }
        this.sorted.emit(this.descending);
        this.tableService.sortColumn(this.parentElment.nativeElement);
    }
    keyPressHandler(e) {
        if (e.keyCode == '13' || e.keyCode == '27') {
            this.toggleHeader(e);
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TransactionTableThComponent, deps: [{ token: i0.ElementRef }, { token: TableService }, { token: CitiLiveAnnouncer }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: TransactionTableThComponent, isStandalone: false, selector: "[citi-tj-th]", inputs: { type: "type", id: "id", text: "text", additionalClasses: "additionalClasses", isRightAligned: "isRightAligned", isChoiceColumn: "isChoiceColumn", isSorterFalse: "isSorterFalse", dataSortType: "dataSortType", isSortable: "isSortable" }, outputs: { cardChanged: "click", sorted: "sorted" }, host: { attributes: { "role": "columnheader" } }, viewQueries: [{ propertyName: "wrapper", first: true, predicate: ["wrapperTh"], descendants: true }], usesOnChanges: true, ngImport: i0, template: `
    <span class="sortable">
      <div (click)="toggleHeader($event)" class="sortableDivWrapper" (keypress)="keyPressHandler($event)">
        <div *ngIf="isSortable === true" tabindex="0" (focus)="announceSortable()"
         role="button"  [ngClass]="sortClasses" class="th-body sortableDiv">
          <span  [innerHtml]="text" class="sortableCopy"></span>
          <span aria-hidden="false">
            <span [ngClass]="iconClasses" aria-hidden="false"></span>
          </span>
        </div>
      </div>
      <ng-container *ngIf="isSortable !== true">
        <span  tabindex="0">
          {{text}} <ng-content select="[headercontent]"></ng-content>
        </span>
      </ng-container>
    </span>
  `, isInline: true, styles: ["@charset \"UTF-8\";.sortedButton{border-bottom-color:#056dae!important}.svg-arrow-btn-next-blue,.glyphicon-triangle-right,.glyphicon{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%20standalone%3D%22no%22%3F%3E%0A%3Csvg%20width%3D%227px%22%20height%3D%2214px%22%20viewBox%3D%220%200%207%2014%22%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20xmlns%3Asketch%3D%22http%3A//www.bohemiancoding.com/sketch/ns%22%3E%0A%20%20%20%20%3C%21--%20Generator%3A%20Sketch%203.4.1%20%2815681%29%20-%20http%3A//www.bohemiancoding.com/sketch%20--%3E%0A%20%20%20%20%3Ctitle%3EChevron%20Copy%204%3C/title%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C/desc%3E%0A%20%20%20%20%3Cdefs%3E%3C/defs%3E%0A%20%20%20%20%3Cg%20id%3D%22Toolkit%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20sketch%3Atype%3D%22MSPage%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Buttons%22%20sketch%3Atype%3D%22MSArtboardGroup%22%20transform%3D%22translate%28-1121.000000%2C%20-223.000000%29%22%20fill%3D%22%23056DAE%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Buttons-01%22%20sketch%3Atype%3D%22MSLayerGroup%22%20transform%3D%22translate%28689.000000%2C%20205.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Default-Icon%22%20transform%3D%22translate%28240.000000%2C%200.000000%29%22%20sketch%3Atype%3D%22MSShapeGroup%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icon%22%20transform%3D%22translate%28170.000000%2C%200.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M22%2C32%20L22%2C29.6917048%20L26.9896888%2C25.0246591%20L22%2C20.3577556%20L22%2C18%20L28.4615385%2C24.1555486%20L28.4615385%2C25.8443093%20L22%2C32%22%20id%3D%22Chevron-Copy-4%22%3E%3C/path%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%3C/g%3E%0A%3C/svg%3E);background-repeat:no-repeat}.svg-arrow-dropdown-up,.glyphicon-triangle-top{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%20standalone%3D%22no%22%3F%3E%0A%3Csvg%20width%3D%2215px%22%20height%3D%228px%22%20viewBox%3D%220%200%2015%208%22%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20xmlns%3Asketch%3D%22http%3A//www.bohemiancoding.com/sketch/ns%22%3E%0A%20%20%20%20%3C%21--%20Generator%3A%20Sketch%203.4.1%20%2815681%29%20-%20http%3A//www.bohemiancoding.com/sketch%20--%3E%0A%20%20%20%20%3Ctitle%3EChevron%3C/title%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C/desc%3E%0A%20%20%20%20%3Cdefs%3E%3C/defs%3E%0A%20%20%20%20%3Cg%20id%3D%22Toolkit%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20sketch%3Atype%3D%22MSPage%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Dropdowns%22%20sketch%3Atype%3D%22MSArtboardGroup%22%20transform%3D%22translate%28-878.000000%2C%20-862.000000%29%22%20fill%3D%22%23056DAE%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Dropdown-Grey%22%20sketch%3Atype%3D%22MSLayerGroup%22%20transform%3D%22translate%28570.000000%2C%20101.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Dropdown-Input%22%20transform%3D%22translate%280.000000%2C%20740.000000%29%22%20sketch%3Atype%3D%22MSShapeGroup%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M312%2C32%20L312%2C29.6917048%20L316.989689%2C25.0246591%20L312%2C20.3577556%20L312%2C18%20L318.461538%2C24.1555486%20L318.461538%2C25.8443093%20L312%2C32%22%20id%3D%22Chevron%22%20transform%3D%22translate%28315.230769%2C%2025.000000%29%20scale%281%2C%20-1%29%20rotate%28-270.000000%29%20translate%28-315.230769%2C%20-25.000000%29%20%22%3E%3C/path%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%3C/g%3E%0A%3C/svg%3E);background-repeat:no-repeat}.svg-arrow-dropdown-down,.glyphicon-triangle-bottom{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%20standalone%3D%22no%22%3F%3E%0A%3Csvg%20width%3D%2215px%22%20height%3D%228px%22%20viewBox%3D%220%200%2015%208%22%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20xmlns%3Asketch%3D%22http%3A//www.bohemiancoding.com/sketch/ns%22%3E%0A%20%20%20%20%3C%21--%20Generator%3A%20Sketch%203.4.1%20%2815681%29%20-%20http%3A//www.bohemiancoding.com/sketch%20--%3E%0A%20%20%20%20%3Ctitle%3EChevron%3C/title%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C/desc%3E%0A%20%20%20%20%3Cdefs%3E%3C/defs%3E%0A%20%20%20%20%3Cg%20id%3D%22Toolkit%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20sketch%3Atype%3D%22MSPage%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Dropdowns%22%20sketch%3Atype%3D%22MSArtboardGroup%22%20transform%3D%22translate%28-878.000000%2C%20-122.000000%29%22%20fill%3D%22%23056DAE%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Dropdown-Grey%22%20sketch%3Atype%3D%22MSLayerGroup%22%20transform%3D%22translate%28570.000000%2C%20101.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Dropdown-Default%22%20sketch%3Atype%3D%22MSShapeGroup%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M312%2C32%20L312%2C29.6917048%20L316.989689%2C25.0246591%20L312%2C20.3577556%20L312%2C18%20L318.461538%2C24.1555486%20L318.461538%2C25.8443093%20L312%2C32%22%20id%3D%22Chevron%22%20transform%3D%22translate%28315.230769%2C%2025.000000%29%20rotate%28-270.000000%29%20translate%28-315.230769%2C%20-25.000000%29%20%22%3E%3C/path%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%3C/g%3E%0A%3C/svg%3E);background-repeat:no-repeat}:host.text-right{text-align:right}.glyphicon{right:-1px;font-size:.65em;text-indent:-9999em;width:10px;height:10px;background-size:10px auto;background-repeat:no-repeat;background-position:center;position:absolute;top:50%;transform:translateY(-50%)}.glyphicon:before{text-indent:-9999em}.glyphicon-triangle-right{margin-right:\\a0 0px!important;background-size:auto 9px}.sortable{padding-top:0;padding-bottom:0;display:block}.sortable button,.sortable [role=button],.sortable a{padding-top:16px;padding-bottom:12px;color:#056dae;position:relative;display:inline-block}.sortable button:first-child,.sortable [role=button]:first-child,.sortable a:first-child{padding-right:16px;border-bottom:3px solid transparent}.sortable button.sr-only,.sortable [role=button].sr-only,.sortable a.sr-only{position:absolute}.sortable.sorted [role=button]:first-child,.sortable.sorted a:first-child{border-bottom-color:#056dae}.sortable:focus [role=button]:first-child,.sortable:hover [role=button]:first-child{color:#002a54;text-decoration:underline}.sortable [role=button]:first-child:focus,.sortable [role=button]:first-child:hover{color:#002a54;text-decoration:underline}.sortableCopy{line-height:46px}.sortableDiv{line-height:\\a0 46px!important;border-top:3px solid transparent}.sortableDivWrapper{width:100%}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TransactionTableThComponent, decorators: [{
            type: Component,
            args: [{ selector: '[citi-tj-th]', standalone: false, template: `
    <span class="sortable">
      <div (click)="toggleHeader($event)" class="sortableDivWrapper" (keypress)="keyPressHandler($event)">
        <div *ngIf="isSortable === true" tabindex="0" (focus)="announceSortable()"
         role="button"  [ngClass]="sortClasses" class="th-body sortableDiv">
          <span  [innerHtml]="text" class="sortableCopy"></span>
          <span aria-hidden="false">
            <span [ngClass]="iconClasses" aria-hidden="false"></span>
          </span>
        </div>
      </div>
      <ng-container *ngIf="isSortable !== true">
        <span  tabindex="0">
          {{text}} <ng-content select="[headercontent]"></ng-content>
        </span>
      </ng-container>
    </span>
  `, host: { role: 'columnheader' }, styles: ["@charset \"UTF-8\";.sortedButton{border-bottom-color:#056dae!important}.svg-arrow-btn-next-blue,.glyphicon-triangle-right,.glyphicon{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%20standalone%3D%22no%22%3F%3E%0A%3Csvg%20width%3D%227px%22%20height%3D%2214px%22%20viewBox%3D%220%200%207%2014%22%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20xmlns%3Asketch%3D%22http%3A//www.bohemiancoding.com/sketch/ns%22%3E%0A%20%20%20%20%3C%21--%20Generator%3A%20Sketch%203.4.1%20%2815681%29%20-%20http%3A//www.bohemiancoding.com/sketch%20--%3E%0A%20%20%20%20%3Ctitle%3EChevron%20Copy%204%3C/title%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C/desc%3E%0A%20%20%20%20%3Cdefs%3E%3C/defs%3E%0A%20%20%20%20%3Cg%20id%3D%22Toolkit%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20sketch%3Atype%3D%22MSPage%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Buttons%22%20sketch%3Atype%3D%22MSArtboardGroup%22%20transform%3D%22translate%28-1121.000000%2C%20-223.000000%29%22%20fill%3D%22%23056DAE%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Buttons-01%22%20sketch%3Atype%3D%22MSLayerGroup%22%20transform%3D%22translate%28689.000000%2C%20205.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Default-Icon%22%20transform%3D%22translate%28240.000000%2C%200.000000%29%22%20sketch%3Atype%3D%22MSShapeGroup%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icon%22%20transform%3D%22translate%28170.000000%2C%200.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M22%2C32%20L22%2C29.6917048%20L26.9896888%2C25.0246591%20L22%2C20.3577556%20L22%2C18%20L28.4615385%2C24.1555486%20L28.4615385%2C25.8443093%20L22%2C32%22%20id%3D%22Chevron-Copy-4%22%3E%3C/path%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%3C/g%3E%0A%3C/svg%3E);background-repeat:no-repeat}.svg-arrow-dropdown-up,.glyphicon-triangle-top{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%20standalone%3D%22no%22%3F%3E%0A%3Csvg%20width%3D%2215px%22%20height%3D%228px%22%20viewBox%3D%220%200%2015%208%22%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20xmlns%3Asketch%3D%22http%3A//www.bohemiancoding.com/sketch/ns%22%3E%0A%20%20%20%20%3C%21--%20Generator%3A%20Sketch%203.4.1%20%2815681%29%20-%20http%3A//www.bohemiancoding.com/sketch%20--%3E%0A%20%20%20%20%3Ctitle%3EChevron%3C/title%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C/desc%3E%0A%20%20%20%20%3Cdefs%3E%3C/defs%3E%0A%20%20%20%20%3Cg%20id%3D%22Toolkit%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20sketch%3Atype%3D%22MSPage%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Dropdowns%22%20sketch%3Atype%3D%22MSArtboardGroup%22%20transform%3D%22translate%28-878.000000%2C%20-862.000000%29%22%20fill%3D%22%23056DAE%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Dropdown-Grey%22%20sketch%3Atype%3D%22MSLayerGroup%22%20transform%3D%22translate%28570.000000%2C%20101.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Dropdown-Input%22%20transform%3D%22translate%280.000000%2C%20740.000000%29%22%20sketch%3Atype%3D%22MSShapeGroup%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M312%2C32%20L312%2C29.6917048%20L316.989689%2C25.0246591%20L312%2C20.3577556%20L312%2C18%20L318.461538%2C24.1555486%20L318.461538%2C25.8443093%20L312%2C32%22%20id%3D%22Chevron%22%20transform%3D%22translate%28315.230769%2C%2025.000000%29%20scale%281%2C%20-1%29%20rotate%28-270.000000%29%20translate%28-315.230769%2C%20-25.000000%29%20%22%3E%3C/path%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%3C/g%3E%0A%3C/svg%3E);background-repeat:no-repeat}.svg-arrow-dropdown-down,.glyphicon-triangle-bottom{background-image:url(data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%20standalone%3D%22no%22%3F%3E%0A%3Csvg%20width%3D%2215px%22%20height%3D%228px%22%20viewBox%3D%220%200%2015%208%22%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20xmlns%3Asketch%3D%22http%3A//www.bohemiancoding.com/sketch/ns%22%3E%0A%20%20%20%20%3C%21--%20Generator%3A%20Sketch%203.4.1%20%2815681%29%20-%20http%3A//www.bohemiancoding.com/sketch%20--%3E%0A%20%20%20%20%3Ctitle%3EChevron%3C/title%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C/desc%3E%0A%20%20%20%20%3Cdefs%3E%3C/defs%3E%0A%20%20%20%20%3Cg%20id%3D%22Toolkit%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20sketch%3Atype%3D%22MSPage%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Dropdowns%22%20sketch%3Atype%3D%22MSArtboardGroup%22%20transform%3D%22translate%28-878.000000%2C%20-122.000000%29%22%20fill%3D%22%23056DAE%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Dropdown-Grey%22%20sketch%3Atype%3D%22MSLayerGroup%22%20transform%3D%22translate%28570.000000%2C%20101.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Dropdown-Default%22%20sketch%3Atype%3D%22MSShapeGroup%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M312%2C32%20L312%2C29.6917048%20L316.989689%2C25.0246591%20L312%2C20.3577556%20L312%2C18%20L318.461538%2C24.1555486%20L318.461538%2C25.8443093%20L312%2C32%22%20id%3D%22Chevron%22%20transform%3D%22translate%28315.230769%2C%2025.000000%29%20rotate%28-270.000000%29%20translate%28-315.230769%2C%20-25.000000%29%20%22%3E%3C/path%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%3C/g%3E%0A%3C/svg%3E);background-repeat:no-repeat}:host.text-right{text-align:right}.glyphicon{right:-1px;font-size:.65em;text-indent:-9999em;width:10px;height:10px;background-size:10px auto;background-repeat:no-repeat;background-position:center;position:absolute;top:50%;transform:translateY(-50%)}.glyphicon:before{text-indent:-9999em}.glyphicon-triangle-right{margin-right:\\a0 0px!important;background-size:auto 9px}.sortable{padding-top:0;padding-bottom:0;display:block}.sortable button,.sortable [role=button],.sortable a{padding-top:16px;padding-bottom:12px;color:#056dae;position:relative;display:inline-block}.sortable button:first-child,.sortable [role=button]:first-child,.sortable a:first-child{padding-right:16px;border-bottom:3px solid transparent}.sortable button.sr-only,.sortable [role=button].sr-only,.sortable a.sr-only{position:absolute}.sortable.sorted [role=button]:first-child,.sortable.sorted a:first-child{border-bottom-color:#056dae}.sortable:focus [role=button]:first-child,.sortable:hover [role=button]:first-child{color:#002a54;text-decoration:underline}.sortable [role=button]:first-child:focus,.sortable [role=button]:first-child:hover{color:#002a54;text-decoration:underline}.sortableCopy{line-height:46px}.sortableDiv{line-height:\\a0 46px!important;border-top:3px solid transparent}.sortableDivWrapper{width:100%}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: TableService }, { type: CitiLiveAnnouncer }], propDecorators: { wrapper: [{
                type: ViewChild,
                args: ['wrapperTh']
            }], cardChanged: [{
                type: Output,
                args: ['click']
            }], sorted: [{
                type: Output,
                args: ['sorted']
            }], type: [{
                type: Input$1
            }], id: [{
                type: Input$1
            }], text: [{
                type: Input$1
            }], additionalClasses: [{
                type: Input$1
            }], isRightAligned: [{
                type: Input$1
            }], isChoiceColumn: [{
                type: Input$1
            }], isSorterFalse: [{
                type: Input$1
            }], dataSortType: [{
                type: Input$1
            }], isSortable: [{
                type: Input$1
            }] } });

class TrProperties {
    constructor() {
        this.id = '';
        this.additionalClasses = '';
        this.isTableHeaderRow = false;
        this.isSubRow = false;
        this.isDetailRow = false;
        this.additionalAttributes = '';
        this.isExpanded = false;
    }
}

class TransactionTableTrComponent {
    set isExpanded(value) {
        this.props.isExpanded = value;
        this.generateClass();
    }
    get isExpanded() {
        return this.props.isExpanded;
    }
    set type(properties) {
        this.props = properties;
    }
    set id(id) {
        this.props.id = id;
    }
    set additionalClasses(additionalClasses) {
        this.props.additionalClasses = additionalClasses || '';
        this.generateClass();
    }
    set isTableHeaderRow(isTableHeaderRow) {
        this.props.isTableHeaderRow = isTableHeaderRow;
        if (isTableHeaderRow === true) {
            this.rowType = 'tableheader';
        }
    }
    set isSubRow(isSubRow) {
        this.props.isSubRow = isSubRow;
        this.generateClass();
    }
    set isDetailRow(isDetailRow) {
        this.props.isDetailRow = isDetailRow;
        this.generateClass();
    }
    set additionalAttributes(additionalAttributes) {
        this.props.additionalAttributes = additionalAttributes;
    }
    constructor(el) {
        this.el = el;
        this.props = new TrProperties();
        this.rowType = 'tablebody';
        this.classes = 'is-collapsed';
        /**
         * @property htmlContent
         * @description Adds the given string as the content and supports simple HTML.
         * Do not pass anything within the component tags using ng-content. Do not use citi-* components in the String.
         * This works with expressions for asynchronously loaded content that will get picked up by the Angular 2 change detection.
         * @return string
         * @twoway false
         */
        this.htmlContent = null;
        if (isDevMode()) {
            console.error('%cThe Common UI DDL ABC <tr citi-tj-tr> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    ngAfterContentInit() {
        // listen for clicks on the expand component's button
        this.expandables.forEach(expandComp => {
            expandComp.expandEmitter.subscribe(shouldExpand => this.isExpanded = shouldExpand);
            expandComp.isExpandedChange.subscribe(shouldExpand => this.isExpanded = shouldExpand);
        });
    }
    ngAfterViewInit() {
        this.generateClass();
        if (this.props.id)
            this.el.nativeElement.id = this.props.id;
    }
    get rowTypeClass() {
        return `cbolui-table-${this.rowType}-row`;
    }
    get subRowTypeClass() {
        return !!this.props.isSubRow ? `cbolui-table-${this.rowType}-row-subrow tablesorter-childRow` : '';
    }
    get isDetailRowClass() {
        return this.props.isDetailRow ? 'expandable-row' : '';
    }
    get exapandedClass() {
        return this.props.isExpanded ? 'is-expanded' : 'is-collapsed';
    }
    get additionalClass() {
        return this.props.additionalClasses && !!this.props.additionalClasses ? this.props.additionalClasses : '';
    }
    generateClass() {
        this.classes = `${this.rowTypeClass} ${this.subRowTypeClass} ${this.isDetailRowClass} ${this.exapandedClass} ${this.additionalClass}`;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TransactionTableTrComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: TransactionTableTrComponent, isStandalone: false, selector: "[citi-tj-tr]", inputs: { isExpanded: "isExpanded", type: "type", id: "id", additionalClasses: "additionalClasses", isTableHeaderRow: "isTableHeaderRow", isSubRow: "isSubRow", isDetailRow: "isDetailRow", additionalAttributes: "additionalAttributes", htmlContent: "htmlContent" }, host: { attributes: { "role": "row" }, properties: { "class": "this.classes" } }, queries: [{ propertyName: "expandables", predicate: i0.forwardRef(() => TransactionTableExpandComponent), descendants: true }], viewQueries: [{ propertyName: "wrapper", first: true, predicate: ["wrapper"], descendants: true }], ngImport: i0, template: `<div *ngIf="htmlContent !== null" [contentHtml]="htmlContent"></div>
     <ng-content></ng-content>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: ContentHtmlDirective, selector: "[contentHtml]", inputs: ["contentHtml"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TransactionTableTrComponent, decorators: [{
            type: Component,
            args: [{
                    selector: '[citi-tj-tr]',
                    standalone: false,
                    template: `<div *ngIf="htmlContent !== null" [contentHtml]="htmlContent"></div>
     <ng-content></ng-content>
  `,
                    host: { role: 'row' }
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { wrapper: [{
                type: ViewChild,
                args: ['wrapper']
            }], classes: [{
                type: HostBinding,
                args: ['class']
            }], expandables: [{
                type: ContentChildren,
                args: [forwardRef(() => TransactionTableExpandComponent), { descendants: true }]
            }], isExpanded: [{
                type: Input$1
            }], type: [{
                type: Input$1
            }], id: [{
                type: Input$1
            }], additionalClasses: [{
                type: Input$1
            }], isTableHeaderRow: [{
                type: Input$1
            }], isSubRow: [{
                type: Input$1
            }], isDetailRow: [{
                type: Input$1
            }], additionalAttributes: [{
                type: Input$1
            }], htmlContent: [{
                type: Input$1
            }] } });

class TableProperties {
    constructor() {
        this.id = '';
        this.caption = '';
        this.hideCaption = false;
        this.summary = '';
        this.tableTooltip = false;
        this.isSortable = false;
        this.isAutoInitTableSorter = false;
        this.beforeTableSorterInitialization = false;
        this.sorterConfig = '';
        this.filterContent = '';
        this.filterAligned = false;
        this.viewMore = '';
        this.isExpandable = false;
        this.isExpanded = false;
        this.hasMasterDetailsRows = false;
        this.noTopMargin = false;
        this.isFixedLayout = true;
        this.ctaText = '';
        this.ctaTooltipTitle = '';
        this.ctaTooltipBody = '';
        this.isExpandableRow = false;
        this.expandDetailsHeader = false;
        this.collapseDetailsHeader = false;
        this.tableType = false;
        this.isFixedColumnTable = false;
        this.bodyText = '';
        this.data = [];
        this.displayedHeaders = [];
        this.isInfiniteScrollEnabled = false;
        this.loadButtonText = 'Load %d more records';
        this.defaultNumberOfVisibleRecords = 10;
        this.defaultAdditionalRecords = 10;
        this.currentNumberOfVisibleRecords = 0;
        this.loadingText = 'Just a moment please.';
        this.isLoadingMoreData = false;
        this.visibleRows = [];
        this.canLoadMoreData = false;
        this.expandButtonTextClose = 'More Details';
        this.expandButtonTextOpen = 'Less Details';
        this.itemDetailCollapses = [];
        this.isZebraTable = false;
        this.isLayoutTable = false;
    }
}

class TJComponent {
    set isZebraTable(value) {
        this.props.isZebraTable = value;
    }
    set loadButtonText(value) {
        this.props.loadButtonText = value;
    }
    set itemDetailCollapses(newValues) {
        this.props.itemDetailCollapses = newValues.slice(0);
    }
    set defaultNumberOfVisibleRecords(value) {
        this.props.defaultNumberOfVisibleRecords = value;
    }
    set isInfiniteScrollEnabled(value) {
        this.props.isInfiniteScrollEnabled = value;
    }
    set displayedHeaders(headerList) {
        this.props.displayedHeaders = headerList.slice(0);
    }
    set data(source) {
        this.props.data = source.slice(0);
    }
    set type(properties) {
        this.props = properties;
    }
    set id(id) {
        this.props.id = id;
    }
    set caption(caption) {
        this.props.caption = caption;
    }
    set hideCaption(hideCaption) {
        this.props.hideCaption = hideCaption;
    }
    set summary(summary) {
        this.props.summary = summary;
    }
    set tableTooltip(tableTooltip) {
        this.props.tableTooltip = tableTooltip;
    }
    set isSortable(isSortable) {
        this.props.isSortable = isSortable;
    }
    set isAutoInitTableSorter(isAutoInitTableSorter) {
        this.props.isAutoInitTableSorter = isAutoInitTableSorter;
    }
    set beforeTableSorterInitialization(beforeTableSorterInitialization) {
        this.props.beforeTableSorterInitialization = beforeTableSorterInitialization;
    }
    set sorterConfig(sorterConfig) {
        this.props.sorterConfig = sorterConfig;
    }
    set filterContent(filterContent) {
        this.props.filterContent = filterContent;
    }
    set filterAligned(filterAligned) {
        this.props.filterAligned = filterAligned;
    }
    set viewMore(viewMore) {
        this.props.viewMore = viewMore;
    }
    set isExpandable(isExpandable) {
        this.props.isExpandable = isExpandable;
    }
    set isExpanded(isExpanded) {
        this.props.isExpanded = isExpanded;
    }
    set hasMasterDetailsRows(hasMasterDetailsRows) {
        this.props.hasMasterDetailsRows = hasMasterDetailsRows;
    }
    set noTopMargin(noTopMargin) {
        this.props.noTopMargin = noTopMargin;
    }
    set isFixedLayout(isFixedLayout) {
        this.props.isFixedLayout = isFixedLayout;
    }
    set ctaText(ctaText) {
        this.props.ctaText = ctaText;
    }
    set ctaTooltipTitle(ctaTooltipTitle) {
        this.props.ctaTooltipTitle = ctaTooltipTitle;
    }
    set ctaTooltipBody(ctaTooltipBody) {
        this.props.ctaTooltipBody = ctaTooltipBody;
    }
    set isExpandableRow(isExpandableRow) {
        this.props.isExpandableRow = isExpandableRow;
    }
    set expandDetailsHeader(expandDetailsHeader) {
        this.props.expandDetailsHeader = expandDetailsHeader;
    }
    set collapseDetailsHeader(collapseDetailsHeader) {
        this.props.collapseDetailsHeader = collapseDetailsHeader;
    }
    set tableType(tableType) {
        this.props.tableType = tableType;
    }
    set isFixedColumnTable(isFixedColumnTable) {
        this.props.isFixedColumnTable = isFixedColumnTable;
    }
    set bodyText(bodyText) {
        this.props.bodyText = bodyText;
    }
    set loadingText(newText) {
        this.props.loadingText = newText;
    }
    set isLoadingMoreData(value) {
        this.props.isLoadingMoreData = value;
    }
    set visibleRows(rows) {
        this.props.visibleRows = rows.slice(0);
    }
    set defaultAdditionalRecords(numberOfRecords) {
        this.props.defaultAdditionalRecords = numberOfRecords;
    }
    set currentNumberOfVisibleRecords(numberOfRecords) {
        this.props.currentNumberOfVisibleRecords = numberOfRecords;
    }
    set expandButtonTextClose(newText) {
        this.props.expandButtonTextClose = newText;
    }
    set isLayoutTable(value) {
        if (typeof value === 'string') {
            value = value === 'true';
        }
        this.props.isLayoutTable = value;
    }
    get isZebraTable() {
        return this.props.isZebraTable;
    }
    get expandButtonTextClose() {
        return this.props.expandButtonTextClose;
    }
    set expandButtonTextOpen(newText) {
        this.props.expandButtonTextOpen = newText;
    }
    get expandButtonTextOpen() {
        return this.props.expandButtonTextOpen;
    }
    get defaultNumberOfVisibleRecords() {
        return this.props.defaultNumberOfVisibleRecords;
    }
    get data() {
        return this.props.data;
    }
    get isExpandable() {
        return this.props.isExpandable;
    }
    get displayedHeaders() {
        return this.props.displayedHeaders;
    }
    get isInfiniteScrollEnabled() {
        return this.props.isInfiniteScrollEnabled;
    }
    get loadButtonText() {
        return this.props.loadButtonText;
    }
    get loadingText() {
        return this.props.loadingText;
    }
    get isLoadingMoreData() {
        return this.props.isLoadingMoreData;
    }
    get visibleRows() {
        return this.props.visibleRows;
    }
    get defaultAdditionalRecords() {
        return this.props.defaultAdditionalRecords;
    }
    get currentNumberOfVisibleRecords() {
        return this.props.currentNumberOfVisibleRecords;
    }
    get canLoadMoreData() {
        return this.isInfiniteScrollEnabled && (this.data.length - this.currentNumberOfVisibleRecords > 0);
    }
    get isSortable() {
        return this.props.isSortable;
    }
    get itemDetailCollapses() {
        return this.props.itemDetailCollapses;
    }
    constructor() {
        this.props = new TableProperties();
        this.isExpandedValue = false;
        this.expandEmitter = new EventEmitter();
        this.isExpandableChange = new EventEmitter();
        this.showMoreButtonClicked = new EventEmitter();
        if (isDevMode()) {
            console.error('%cThe Common UI DDL TJTable <citi-tj-table> is deprecated. Please discontinue using.', 'background-color: #f00; color: #fff;');
        }
    }
    ngOnInit() {
        this.updateNumberOfVisibleRecords();
        this.itemDetailCollapses = Array.apply(null, Array(this.data.length)).map(function () { return true; });
    }
    updateNumberOfVisibleRecords() {
        if (this.isInfiniteScrollEnabled && this.canLoadMoreData) {
            this.currentNumberOfVisibleRecords = this.currentNumberOfVisibleRecords > 0 ?
                this.currentNumberOfVisibleRecords + this.defaultAdditionalRecords :
                this.defaultNumberOfVisibleRecords;
            this.visibleRows = this.data.slice(0, this.currentNumberOfVisibleRecords);
        }
        else {
            this.visibleRows = this.data.slice(0, this.data.length);
        }
    }
    isCurrentVisible(currentIndex) {
        return this.isInfiniteScrollEnabled ?
            (this.defaultNumberOfVisibleRecords > currentIndex) :
            true;
    }
    loadMoreButtonClicked(event) {
        this.showMoreButtonClicked.emit(this);
    }
    detailButtonClicked(index) {
        let newFlagValues = this.itemDetailCollapses.slice(0);
        newFlagValues[index] = !newFlagValues[index];
        this.itemDetailCollapses = newFlagValues;
    }
    replaceLoadButtonText() {
        return this.loadButtonText.replace('%d', `${this.defaultNumberOfVisibleRecords}`);
    }
    expandOnClick() {
        this.isExpandable = !this.isExpandable;
        this.isExpandableChange.emit(this.isExpandable);
        this.expandEmitter.emit(this.isExpandable);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TJComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: TJComponent, isStandalone: false, selector: "citi-tj-table", inputs: { isZebraTable: "isZebraTable", loadButtonText: "loadButtonText", itemDetailCollapses: "itemDetailCollapses", defaultNumberOfVisibleRecords: "defaultNumberOfVisibleRecords", isInfiniteScrollEnabled: "isInfiniteScrollEnabled", displayedHeaders: "displayedHeaders", data: "data", type: "type", id: "id", caption: "caption", hideCaption: "hideCaption", summary: "summary", tableTooltip: "tableTooltip", isSortable: "isSortable", isAutoInitTableSorter: "isAutoInitTableSorter", beforeTableSorterInitialization: "beforeTableSorterInitialization", sorterConfig: "sorterConfig", filterContent: "filterContent", filterAligned: "filterAligned", viewMore: "viewMore", isExpandable: "isExpandable", isExpanded: "isExpanded", hasMasterDetailsRows: "hasMasterDetailsRows", noTopMargin: "noTopMargin", isFixedLayout: "isFixedLayout", ctaText: "ctaText", ctaTooltipTitle: "ctaTooltipTitle", ctaTooltipBody: "ctaTooltipBody", isExpandableRow: "isExpandableRow", expandDetailsHeader: "expandDetailsHeader", collapseDetailsHeader: "collapseDetailsHeader", tableType: "tableType", isFixedColumnTable: "isFixedColumnTable", bodyText: "bodyText", loadingText: "loadingText", isLoadingMoreData: "isLoadingMoreData", visibleRows: "visibleRows", defaultAdditionalRecords: "defaultAdditionalRecords", currentNumberOfVisibleRecords: "currentNumberOfVisibleRecords", expandButtonTextClose: "expandButtonTextClose", isLayoutTable: "isLayoutTable", expandButtonTextOpen: "expandButtonTextOpen" }, outputs: { expandEmitter: "expandEmitter", isExpandableChange: "isExpandableChange", showMoreButtonClicked: "showMoreButtonClicked" }, ngImport: i0, template: `
    <div class="cbolui-table-wrapper cbolui-clearfix table-responsive table-responsive-transaction {{props.filterContent != null ? ' cbolui-table-wrapper-hasFilter': ''}}{{props.filterAligned == true ? ' cbolui-table-wrapper-filterAligned': ''}}{{props.hideCaption == true ? ' cbolui-table-wrapper-hiddenCaption': ''}}{{props.isExpandable == true ? ' cbolui-table-wrapper-expandable': ''}}{{props.noTopMargin == true ? ' cbolui-table-wrapper-no-top-margin': ''}}"
      id="{{props.id}}-wrapper" [attr.data-cbolui-table-wrapper-expandable-minimized]= "props.isExpandable == true ? props.isExpanded == true ? true: false: null" [attr.aria-expanded]= "props.isExpandable == true ? props.isExpanded == true ? true: false: null">

      <div *ngIf="props.filterContent != null" class="cbolui-tables-tableFilterWrapper cbolui-table-relatedTo-{{props.id}}" role="search" [innerHtml]="props.filterContent">
      </div>

      <table
          id="{{props.id}}"
          [attr.role]= "props.isLayoutTable ? 'presentation' : 'grid'"
          class="transaction-journal-table table cbolui-table"
          [ngClass]= "{
              'table-fixed': props.isFixedColumnTable,
              'sortable-table': props.isSortable,
              'cbolui-table-master-details': props.hasMasterDetailsRows,
              'cbolui-table-normal-layout': !props.isFixedLayout,
              'internal-expand-table': isExpandable,
              'table-inf-scroll': props.isInfiniteScrollEnabled,
              'table-striped': isZebraTable
          }">
          <caption *ngIf="props.caption !== null && !props.isLayoutTable">
              <span [ngClass]= "{'sr-only': props.hideCaption}" [attr.aria-hidden]="props.hideCaption">
                  <span *ngIf="props.isExpandable === true" (click)="expandOnClick()" class="glyphicon cbolui-icon-maximize" [ngClass]="{'glyphicon-minus': props.isExpanded,'glyphicon-plus': !props.isExpanded}" aria-hidden="true" data-sort="descending"></span>
                  <span [innerHtml]="props.caption"></span>
                  <span *ngIf="props.tableTooltip == true" class="ddl-tableTooltip"><span [innerHtml]="props.ctaText"></span>
                  <i aria-label="Social Insurance Number Help" role="button" tabindex="0" [attr.data-original-title]="props.ctaTooltipTitle" class="tooltip-toggle icon-svg svg-question" data-close="button" data-toggle="popover" [attr.data-content]="props.ctaTooltipBody"></i>
                  </span>
                  <span class="cbolui-float-right"> <ng-content select="[rightsidecontent]"></ng-content></span>
              </span>
          </caption>
          <ng-content select=".table-header"></ng-content>
          <ng-content select=".table-body"></ng-content>
      </table>
    </div>
    <citi-row *ngIf="isInfiniteScrollEnabled">
        <citi-column [xs]="12" class="btn-inf-scoll-wrap">
            <div class="btn-inf-scoll-wrap">
                <button *ngIf="!isLoadingMoreData" class="btn btn-primary btn-inf-scroll" (click)="loadMoreButtonClicked($event)">
            {{replaceLoadButtonText()}}
          </button>
                <div [ngClass]= "{jamp: true, hidden: !isLoadingMoreData}" [attr.aria-hidden]= "!isLoadingMoreData" role="alert">
                    <span class="img"></span> <span class="message" [innerHtml]="loadingText"></span>
                </div>
            </div>
        </citi-column>
    </citi-row>
  `, isInline: true, styles: [".transaction-journal-table ::ng-deep th .sortableDiv{padding-right:16px;border-bottom:3px solid transparent;position:relative;display:inline-block;line-height:20px;color:#056dae}.transaction-journal-table ::ng-deep .btn-carat-down-svg:before,.transaction-journal-table ::ng-deep .btn-carat-down:before,.transaction-journal-table ::ng-deep .glyphicon-triangle-bottom:before,.transaction-journal-table ::ng-deep .btn-carat-up:before,.transaction-journal-table ::ng-deep .glyphicon-triangle-top:before,.transaction-journal-table ::ng-deep .btn-carat-unsorted:before,.transaction-journal-table ::ng-deep .btn-default-light:before,.transaction-journal-table ::ng-deep .btn-default:before,.transaction-journal-table ::ng-deep .glyphicon-triangle-right:before,.transaction-journal-table ::ng-deep .list-unstyled li:before{content:none}@media print{.transaction-journal-table ::ng-deep th .sortableDiv{position:unset;border-bottom-color:#fff!important}}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: ColumnComponent, selector: "citi-column, [citi-column]", inputs: ["xs", "sm", "md", "lg", "pullRight", "pullLeft", "offXs", "offSm", "offMd", "offLg", "classes", "htmlContent"] }, { kind: "component", type: RowComponent, selector: "citi-row, [citi-row]", inputs: ["classes", "htmlContent"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TJComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-tj-table', standalone: false, template: `
    <div class="cbolui-table-wrapper cbolui-clearfix table-responsive table-responsive-transaction {{props.filterContent != null ? ' cbolui-table-wrapper-hasFilter': ''}}{{props.filterAligned == true ? ' cbolui-table-wrapper-filterAligned': ''}}{{props.hideCaption == true ? ' cbolui-table-wrapper-hiddenCaption': ''}}{{props.isExpandable == true ? ' cbolui-table-wrapper-expandable': ''}}{{props.noTopMargin == true ? ' cbolui-table-wrapper-no-top-margin': ''}}"
      id="{{props.id}}-wrapper" [attr.data-cbolui-table-wrapper-expandable-minimized]= "props.isExpandable == true ? props.isExpanded == true ? true: false: null" [attr.aria-expanded]= "props.isExpandable == true ? props.isExpanded == true ? true: false: null">

      <div *ngIf="props.filterContent != null" class="cbolui-tables-tableFilterWrapper cbolui-table-relatedTo-{{props.id}}" role="search" [innerHtml]="props.filterContent">
      </div>

      <table
          id="{{props.id}}"
          [attr.role]= "props.isLayoutTable ? 'presentation' : 'grid'"
          class="transaction-journal-table table cbolui-table"
          [ngClass]= "{
              'table-fixed': props.isFixedColumnTable,
              'sortable-table': props.isSortable,
              'cbolui-table-master-details': props.hasMasterDetailsRows,
              'cbolui-table-normal-layout': !props.isFixedLayout,
              'internal-expand-table': isExpandable,
              'table-inf-scroll': props.isInfiniteScrollEnabled,
              'table-striped': isZebraTable
          }">
          <caption *ngIf="props.caption !== null && !props.isLayoutTable">
              <span [ngClass]= "{'sr-only': props.hideCaption}" [attr.aria-hidden]="props.hideCaption">
                  <span *ngIf="props.isExpandable === true" (click)="expandOnClick()" class="glyphicon cbolui-icon-maximize" [ngClass]="{'glyphicon-minus': props.isExpanded,'glyphicon-plus': !props.isExpanded}" aria-hidden="true" data-sort="descending"></span>
                  <span [innerHtml]="props.caption"></span>
                  <span *ngIf="props.tableTooltip == true" class="ddl-tableTooltip"><span [innerHtml]="props.ctaText"></span>
                  <i aria-label="Social Insurance Number Help" role="button" tabindex="0" [attr.data-original-title]="props.ctaTooltipTitle" class="tooltip-toggle icon-svg svg-question" data-close="button" data-toggle="popover" [attr.data-content]="props.ctaTooltipBody"></i>
                  </span>
                  <span class="cbolui-float-right"> <ng-content select="[rightsidecontent]"></ng-content></span>
              </span>
          </caption>
          <ng-content select=".table-header"></ng-content>
          <ng-content select=".table-body"></ng-content>
      </table>
    </div>
    <citi-row *ngIf="isInfiniteScrollEnabled">
        <citi-column [xs]="12" class="btn-inf-scoll-wrap">
            <div class="btn-inf-scoll-wrap">
                <button *ngIf="!isLoadingMoreData" class="btn btn-primary btn-inf-scroll" (click)="loadMoreButtonClicked($event)">
            {{replaceLoadButtonText()}}
          </button>
                <div [ngClass]= "{jamp: true, hidden: !isLoadingMoreData}" [attr.aria-hidden]= "!isLoadingMoreData" role="alert">
                    <span class="img"></span> <span class="message" [innerHtml]="loadingText"></span>
                </div>
            </div>
        </citi-column>
    </citi-row>
  `, styles: [".transaction-journal-table ::ng-deep th .sortableDiv{padding-right:16px;border-bottom:3px solid transparent;position:relative;display:inline-block;line-height:20px;color:#056dae}.transaction-journal-table ::ng-deep .btn-carat-down-svg:before,.transaction-journal-table ::ng-deep .btn-carat-down:before,.transaction-journal-table ::ng-deep .glyphicon-triangle-bottom:before,.transaction-journal-table ::ng-deep .btn-carat-up:before,.transaction-journal-table ::ng-deep .glyphicon-triangle-top:before,.transaction-journal-table ::ng-deep .btn-carat-unsorted:before,.transaction-journal-table ::ng-deep .btn-default-light:before,.transaction-journal-table ::ng-deep .btn-default:before,.transaction-journal-table ::ng-deep .glyphicon-triangle-right:before,.transaction-journal-table ::ng-deep .list-unstyled li:before{content:none}@media print{.transaction-journal-table ::ng-deep th .sortableDiv{position:unset;border-bottom-color:#fff!important}}\n"] }]
        }], ctorParameters: () => [], propDecorators: { expandEmitter: [{
                type: Output
            }], isExpandableChange: [{
                type: Output
            }], showMoreButtonClicked: [{
                type: Output
            }], isZebraTable: [{
                type: Input$1
            }], loadButtonText: [{
                type: Input$1
            }], itemDetailCollapses: [{
                type: Input$1
            }], defaultNumberOfVisibleRecords: [{
                type: Input$1
            }], isInfiniteScrollEnabled: [{
                type: Input$1
            }], displayedHeaders: [{
                type: Input$1
            }], data: [{
                type: Input$1
            }], type: [{
                type: Input$1
            }], id: [{
                type: Input$1
            }], caption: [{
                type: Input$1
            }], hideCaption: [{
                type: Input$1
            }], summary: [{
                type: Input$1
            }], tableTooltip: [{
                type: Input$1
            }], isSortable: [{
                type: Input$1
            }], isAutoInitTableSorter: [{
                type: Input$1
            }], beforeTableSorterInitialization: [{
                type: Input$1
            }], sorterConfig: [{
                type: Input$1
            }], filterContent: [{
                type: Input$1
            }], filterAligned: [{
                type: Input$1
            }], viewMore: [{
                type: Input$1
            }], isExpandable: [{
                type: Input$1
            }], isExpanded: [{
                type: Input$1
            }], hasMasterDetailsRows: [{
                type: Input$1
            }], noTopMargin: [{
                type: Input$1
            }], isFixedLayout: [{
                type: Input$1
            }], ctaText: [{
                type: Input$1
            }], ctaTooltipTitle: [{
                type: Input$1
            }], ctaTooltipBody: [{
                type: Input$1
            }], isExpandableRow: [{
                type: Input$1
            }], expandDetailsHeader: [{
                type: Input$1
            }], collapseDetailsHeader: [{
                type: Input$1
            }], tableType: [{
                type: Input$1
            }], isFixedColumnTable: [{
                type: Input$1
            }], bodyText: [{
                type: Input$1
            }], loadingText: [{
                type: Input$1
            }], isLoadingMoreData: [{
                type: Input$1
            }], visibleRows: [{
                type: Input$1
            }], defaultAdditionalRecords: [{
                type: Input$1
            }], currentNumberOfVisibleRecords: [{
                type: Input$1
            }], expandButtonTextClose: [{
                type: Input$1
            }], isLayoutTable: [{
                type: Input$1
            }], expandButtonTextOpen: [{
                type: Input$1
            }] } });

const COMPONENTS$1 = [
    TJComponent,
    TransactionTableTrComponent,
    TransactionTableThComponent,
    TransactionTableTdComponent,
    TransactionTableExpandComponent
];
const MODULES$1 = [
    CommonModule,
    Grid,
    ContentHtml
];
class TJTable {
    static forRoot() {
        return {
            ngModule: TJTable,
            providers: [TableService]
        };
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TJTable, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: TJTable, declarations: [TJComponent,
            TransactionTableTrComponent,
            TransactionTableThComponent,
            TransactionTableTdComponent,
            TransactionTableExpandComponent], imports: [CommonModule,
            Grid,
            ContentHtml], exports: [TJComponent,
            TransactionTableTrComponent,
            TransactionTableThComponent,
            TransactionTableTdComponent,
            TransactionTableExpandComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TJTable, imports: [MODULES$1] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TJTable, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES$1],
                    declarations: [...COMPONENTS$1],
                    exports: [...COMPONENTS$1],
                }]
        }] });

class TableServiceModule {
    static forRoot() {
        return {
            ngModule: TableServiceModule,
            providers: [
                TableService
            ]
        };
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TableServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: TableServiceModule }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TableServiceModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: TableServiceModule, decorators: [{
            type: NgModule,
            args: [{}]
        }] });

class CommonUI {
    static forRoot() {
        return {
            ngModule: CommonUI,
            providers: [
                CitiLiveAnnouncer,
                ValidationService,
                WINDOW_PROVIDER,
                NAVIGATOR_PROVIDER,
                LOCATION_PROVIDER
            ]
        };
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CommonUI, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: CommonUI, imports: [Icons2, TableServiceModule, CitiMap] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CommonUI, imports: [Icons2.forRoot(),
            TableServiceModule.forRoot(),
            CitiMap.forRoot()] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: CommonUI, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        Icons2.forRoot(),
                        TableServiceModule.forRoot(),
                        CitiMap.forRoot()
                    ]
                }]
        }] });

class SelectOptionComponent {
    constructor(host) {
        this.host = host;
        this._isActive = false;
        this.click = new EventEmitter();
    }
    get element() {
        return this.host.nativeElement;
    }
    get isActive() {
        return this._isActive;
    }
    ;
    emitClick(e) {
        this.click.emit(e);
    }
    setActiveStyles() {
        this.element.scrollIntoView(false);
        this._isActive = true;
    }
    ;
    setInactiveStyles() {
        this._isActive = false;
    }
    getLabel() {
        return this.data;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: SelectOptionComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: SelectOptionComponent, isStandalone: false, selector: "citi-select-option", inputs: { data: "data", id: "id" }, outputs: { click: "click" }, host: { listeners: { "mousedown": "emitClick($event)" }, properties: { "class.active": "this.isActive" }, classAttribute: "citi-select-option" }, ngImport: i0, template: `
    <ng-content></ng-content>
  `, isInline: true, styles: [":host{display:block;cursor:pointer;font-size:14px;padding:10px}:host:hover{background-color:#056dae;border-color:#056dae;color:#fff}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: SelectOptionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-select-option', standalone: false, host: { class: 'citi-select-option' }, template: `
    <ng-content></ng-content>
  `, changeDetection: ChangeDetectionStrategy.OnPush, styles: [":host{display:block;cursor:pointer;font-size:14px;padding:10px}:host:hover{background-color:#056dae;border-color:#056dae;color:#fff}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { data: [{
                type: Input$1
            }], id: [{
                type: Input$1
            }], click: [{
                type: Output
            }], isActive: [{
                type: HostBinding,
                args: ['class.active']
            }], emitClick: [{
                type: HostListener,
                args: ['mousedown', ['$event']]
            }] } });

class SelectComponent {
    constructor(announcer) {
        this.announcer = announcer;
        this.unsub$ = new Subject();
        this.activeOptionChanges = Subscription.EMPTY;
        this.selectionChange = new EventEmitter();
    }
    ngAfterViewInit() {
        this.keyManager = new ActiveDescendantKeyManager(this.options)
            .withVerticalOrientation()
            .withWrap()
            .withTypeAhead();
        this.options.forEach((option, index) => {
            option.click.pipe(takeUntil(this.unsub$), tap(event => this.selectOption(index))).subscribe();
        });
    }
    ngOnDestroy() {
        this.unsub$.next();
        this.unsub$.complete();
    }
    onKeyDown(event) {
        this.keyManager.onKeydown(event);
        if (event.keyCode === ENTER)
            this.keyManager.setActiveItem(this.keyManager.activeItemIndex);
        if (event.keyCode === END) {
            this.keyManager.setLastItemActive();
            this.announceActive();
        }
        if (event.keyCode === HOME) {
            this.keyManager.setFirstItemActive();
            this.announceActive();
        }
    }
    get selected() {
        if (!this.keyManager.activeItem)
            return null;
        return this.keyManager.activeItem.data;
    }
    selectOption(index) {
        this.keyManager.setActiveItem(index || this.keyManager.activeItemIndex);
        if (this.keyManager.activeItem)
            this.selectionChange.emit(this.keyManager.activeItem);
    }
    announceActive() {
        this.announcer.announce(`${this.selected}`);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: SelectComponent, deps: [{ token: CitiLiveAnnouncer }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.5", type: SelectComponent, isStandalone: false, selector: "citi-select", outputs: { selectionChange: "selectionChange" }, host: { classAttribute: "citi-select" }, queries: [{ propertyName: "options", predicate: SelectOptionComponent }], viewQueries: [{ propertyName: "element", first: true, predicate: OverlayPanelDirective, descendants: true }], ngImport: i0, template: `
    <ng-content></ng-content>
  `, isInline: true, styles: [":host{width:100%;box-shadow:0 2px 14px #0003;display:block;overflow:auto}@media all and (-ms-high-contrast: active),(-ms-high-contrast: none){:host{height:250px}}@media only screen and (max-width: 768px){:host{margin-left:15px;margin-right:7px}}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: SelectComponent, decorators: [{
            type: Component,
            args: [{ selector: 'citi-select', standalone: false, host: { class: 'citi-select' }, template: `
    <ng-content></ng-content>
  `, styles: [":host{width:100%;box-shadow:0 2px 14px #0003;display:block;overflow:auto}@media all and (-ms-high-contrast: active),(-ms-high-contrast: none){:host{height:250px}}@media only screen and (max-width: 768px){:host{margin-left:15px;margin-right:7px}}\n"] }]
        }], ctorParameters: () => [{ type: CitiLiveAnnouncer }], propDecorators: { options: [{
                type: ContentChildren,
                args: [SelectOptionComponent]
            }], element: [{
                type: ViewChild,
                args: [OverlayPanelDirective]
            }], selectionChange: [{
                type: Output
            }] } });

const COMPONENTS = [
    SelectComponent,
    SelectOptionComponent
];
const MODULES = [
    CommonModule,
];
class SelectModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: SelectModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.0.5", ngImport: i0, type: SelectModule, declarations: [SelectComponent,
            SelectOptionComponent], imports: [CommonModule], exports: [SelectComponent,
            SelectOptionComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: SelectModule, imports: [MODULES] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.5", ngImport: i0, type: SelectModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...MODULES],
                    declarations: [...COMPONENTS],
                    exports: [...COMPONENTS]
                }]
        }] });

// export * from './lib/legacy-forms/date-picker-3Q20/public-api';
// export * from './lib/date';

/**
 * Generated bundle index. Do not edit.
 */

export { Accordion, Accordion2Q23, AccordionComponent, AccordionComponent2Q23, AccordionSectionComponent, AccordionSectionComponent2Q23, ActionContactUs, ActionContactUsComponent, ActionD1Component, ActionD1Series, ActionD3, ActionD34Component, ActionD3Component, ActionD3_4, ActionD9, ActionD9ColumnComponent, ActionD9Component, ActionMatchHeight, ActionSubContentComponent, ActionTwoColumnComponent, Alert, AlertComponent, Animation, BACKSPACE, BANNER_ALERT_ICON2_MEDIUM_STYLES, BANNER_ALERT_ICON2_SMALL_STYLES, BannerAlert, BannerAlertComponent, Boolish, Breadcrumb, BreadcrumbComponent, BrowserWindowRef, ButtonBar, ButtonBarComponent, CHECKBOX_CONTROL_VALUE_ACCESSOR, CHECKBOX_GROUP_CONTROL_VALUE_ACCESSOR, CSSLoaderService, CTA, CTAComponent, CTA_CLASSES, Card, CardComponent, CardInfo, CardInfoComponent, Carousel, Carousel2, Carousel2Component, Carousel3, Carousel3Component, CarouselComp, CarouselControlComponent, CarouselItemDirective, CarouselSlide, CarouselSlideDirective, Checkbox2, Checkbox2Module, CheckboxComponent, CheckboxGroup, CheckboxRadioRootComponent, CheckmarkList, CheckmarkListComponent, CitiLiveAnnouncer, CitiMap, CitiOrderBy, CitiPillarComponent, CitiPillars, CitiPillarsComponent, CitiReactiveFormsModule, CitiTooltip, CitiTooltip1Q21, CitiValidators, ColumnComponent, CommonUI, ComparisonTable, ComparisonTableComponent, ComplexTable, ComplexTableComponent, ConfrmPasswordDir, ContentBlock, ContentBlockComponent, ContentBlockStackComponent, ContentDirective, ContentHtml, ContentHtmlDirective, ContentObj, CopyAccordion, CopyAccordionComponent, CopyComponent, CopyContentList, CopySubContent, CopyTwoColumnList, CopyTwoColumnTitleGrid, CopyWarning, CopyWarningLogo, CopywarningComponent, CopywarningLogoComponent, CurrencyInputMaskDirective, CustomInputMaskDirective, CustomPipe, DD2_VALUE_ACCESSOR, DELETE, DdlAriaHideOuterDomDirective, DdlAriaHideOuterDomModule, DdlFocusTrap, DdlOverlayPanel, Direction, DisclaimerComponent, Drawer, DrawerComponent, Dropdown, Dropdown2, Dropdown2Component, Dropdown3, Dropdown3Component, Dropdown4, Dropdown4Component, DropdownComponent, DropdownOptionComponent, DropdownService, E1Tool, E2Tool, E3Tool, ETRowMobileComponent, ETSubRowDataMobileComponent, ETSubRowMobileComponent, Ellipses, EmailInput, EmailValidatorDir, ErrorInput, ErrorsComponent, EtMobileDataCollapsable, EtMobileDataCollapsedData, EtMobileDataPrimaryRow, EtMobileDataSection, ExpandComponent, ExpandablesTable, ExpandablesTableComponent, ExpandablesTableThComponent, ExpandablesTableTrComponent, FileUpload, FileUploadComponent, FinAddOnInput, FocusFirstErrorDir, FormContainer, FormContainerComponent, FormErrors, FormsDisclaimer, Grid, Hero, HeroComponent, HeroComponent4Q20, ICON2_REGISTRY_PROVIDER, ICON2_REGISTRY_PROVIDER_FACTORY, INPUT2_VALUE_ACCESSOR$1 as INPUT2_VALUE_ACCESSOR, Icon2Component, Icon2RegistryService, Icon2WrapperComponent, IconComponent, Icons, Icons2, Image, ImageComponent, InPageNavigation, InPageNavigation2, Input, Input2, Input2Component, Input2Component4Q21, InputComponent, InputCss, InputGroup, InputGroupComponent, InputMask, InputMaskDirective, InputOffsetCss, InputService, InputSettings, InputSize, InputSizeCss, InputType, IsFocused, IsFocusedDirective, JAMP, JSLoaderService, JampComponent, KEY_0, KEY_1, KEY_2, KEY_3, KEY_4, KEY_5, KEY_6, KEY_7, KEY_8, KEY_9, KEY_ARROW_DOWN, KEY_ARROW_LEFT, KEY_ARROW_RIGHT, KEY_ARROW_UP, KEY_END, KEY_ENTER, KEY_ESC, KEY_HOME, KEY_NUMPAD_0, KEY_NUMPAD_1, KEY_NUMPAD_2, KEY_NUMPAD_3, KEY_NUMPAD_4, KEY_NUMPAD_5, KEY_NUMPAD_6, KEY_NUMPAD_7, KEY_NUMPAD_8, KEY_NUMPAD_9, KEY_PAGE_DOWN, KEY_PAGE_UP, KEY_SHIFT, KEY_SPACEBAR, KEY_TAB, LIVE_ANNOUNCER_ELEMENT_TOKEN, LIVE_ANNOUNCER_PROVIDER, LIVE_ANNOUNCER_PROVIDER_FACTORY, LOCATION, LOCATION_PROVIDER, LazyLoadImage, LazyLoadImageDirective, ListComponent, ListItem, ListItemComponent, MapComponent, MapMarkerDataService, MaskTypes, MaskingPipe, MaskingService, MatchHeightDirective, Modal, ModalComponent, NAVIGATOR, NAVIGATOR_PROVIDER, NavGroup2Component, NavGroupComponent, NavPanelComponent, NavTab2Component, NestedTable, NestedTableComponent, NtSectionComponent, Option4Component, Options3Component, OptionsComponent, OptionsGroupComponent, OrderBy, OrderedList, OrderedListComponent, OverlayPanel, OverlayPanelDirective, PERIOD, Pagination, PaginationComponent, PaginationItem, PartialInputMaskDirective, Password, PasswordComponent, PasswordInput, PasswordStrengthIndicatorComponent, PasswordValidatorDir, PhoneInput, Photo, PhotoComponent, PlainCopy, ProgressBar, ProgressBar2, ProgressBar2Component, ProgressBarParentComponent, ProgressBarStepComponent, PromoH1, PromoH1Component, PromoH2, PromoH2Component, PromoH4, PromoH4Component, RADIO_GROUP_CONTROL_VALUE_ACCESSOR, RadialProgressBar, RadialProgressBarComponent, Radio2, Radio2Module, RadioChange, RadioComponent, RadioGroup, ReadOnlyInput, RowComponent, SERVER_URL, SectionComponent, SelectComponent, SelectModule, SelectOptionComponent, Showcase, ShowcaseChildComponent, ShowcaseComponent, ShowcaseSectionComponent, SignOn, SignOn2, SignOn2Component, SignOnComponent, SimpleDateInput, SiteCatService, SmartSearchGroupPipe, SmartSearchModule, SmartSearchOrdinaryPipe, StaticControl, StaticControlElementComponent, StaticControlGroupComponent, StripHtml, StripHtmlPipe, SubContentComponent, SubContentSectionComponent, TEXT_AREA_VALUE_ACCESSOR, TJComponent, TJTable, Tab2Component, Tab3, TabAltComponent, TabComponent, TabComponent3, TabGroup, TabGroup2, TabGroup2Component, TabGroupAltComponent, TabGroupComponent, TabGroupComponent3, Table, TableComponent, TableService, TabsAlt, TaggingDataLayerService, TdComponent, TermsAndConditions, TermsAndConditionsComponent, TextArea, TextHeader, TextHeaderComponent, TextareaComponent, ThComponent, TileContainer, TileContainerComponent, TimeSelector, TimeSelectorComponent, TimeSelectorGroupComponent, TitleGridSectionComponent, ToolsE1Component, ToolsE2Component, ToolsE3Component, TooltipComponent, TooltipComponent1Q21, TooltipInput, TooltipPopupComponent, TooltipPopupComponent1Q21, TrComponent, TransactionTableExpandComponent, TransactionTableTdComponent, TransactionTableThComponent, TransactionTableTrComponent, Transition, TwoColumnListComponent, TwoColumnListSectionComponent, TwoColumnTitleGridComponent, UnorderedList, UnorderedListComponent, UrlInput, ValidationService, ValueSlider, ValueSliderComponent, VideoComponent, VideoGridSectionComponent, VideoK1Component, VideoModalComponent, WINDOW, WINDOW_PROVIDER, WindowRef, XmarkList, XmarkListComponent, addClass$1 as addClass, addJfpToken, addStyle, androidPlatformCheck, boolCheck, changePageTitleAndSetFocus, closestByClass, coerceBool, coerceBoolean, createSSNPipe, decodeString, executeOnStable, findLastIndex, findUpTag, flatMap$1 as flatMap, getFocableAbleElements, groupBy, hasClass$1 as hasClass, insertCharAt, isArray, isBoolish, isDefined, isEmptyObject, isPresent, keyBy, locationFactory, merge, mergeObjects, navigatorFactory, passwordVal, removeCharAt, removeClass, reverseString, validateEmail, values, windowFactory };
